(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired248"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired248"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eNJDH", function(module, exports) {

$parcel$export(module.exports, "ModalController", function () { return (parcelRequire("ib7WC")).ModalController; });
$parcel$export(module.exports, "RouterController", function () { return (parcelRequire("6mRzS")).RouterController; });
$parcel$export(module.exports, "AccountController", function () { return (parcelRequire("f7IXw")).AccountController; });
$parcel$export(module.exports, "ChainController", function () { return (parcelRequire("d94Xg")).ChainController; });
$parcel$export(module.exports, "NetworkController", function () { return (parcelRequire("jbD0z")).NetworkController; });
$parcel$export(module.exports, "OnRampController", function () { return (parcelRequire("jM3Wq")).OnRampController; });
$parcel$export(module.exports, "ConnectionController", function () { return (parcelRequire("hlVrM")).ConnectionController; });
$parcel$export(module.exports, "ConnectorController", function () { return (parcelRequire("7Xn6F")).ConnectorController; });
$parcel$export(module.exports, "SnackController", function () { return (parcelRequire("br7WV")).SnackController; });
$parcel$export(module.exports, "ApiController", function () { return (parcelRequire("g4s8N")).ApiController; });
$parcel$export(module.exports, "AssetController", function () { return (parcelRequire("zKxbI")).AssetController; });
$parcel$export(module.exports, "ThemeController", function () { return (parcelRequire("3Sg6l")).ThemeController; });
$parcel$export(module.exports, "OptionsController", function () { return (parcelRequire("8BVTM")).OptionsController; });
$parcel$export(module.exports, "BlockchainApiController", function () { return (parcelRequire("hxXs8")).BlockchainApiController; });
$parcel$export(module.exports, "PublicStateController", function () { return (parcelRequire("1DdOF")).PublicStateController; });
$parcel$export(module.exports, "EventsController", function () { return (parcelRequire("6m17w")).EventsController; });
$parcel$export(module.exports, "TransactionsController", function () { return (parcelRequire("i2wHx")).TransactionsController; });
$parcel$export(module.exports, "SwapController", function () { return (parcelRequire("89gde")).SwapController; });
$parcel$export(module.exports, "SendController", function () { return (parcelRequire("3BhS7")).SendController; });
$parcel$export(module.exports, "TooltipController", function () { return (parcelRequire("vBowO")).TooltipController; });
$parcel$export(module.exports, "EnsController", function () { return (parcelRequire("4DSpJ")).EnsController; });
$parcel$export(module.exports, "AssetUtil", function () { return (parcelRequire("eOULk")).AssetUtil; });
$parcel$export(module.exports, "ConstantsUtil", function () { return (parcelRequire("6AwK8")).ConstantsUtil; });
$parcel$export(module.exports, "CoreHelperUtil", function () { return (parcelRequire("c4rfq")).CoreHelperUtil; });
$parcel$export(module.exports, "StorageUtil", function () { return (parcelRequire("hdC6E")).StorageUtil; });
$parcel$export(module.exports, "RouterUtil", function () { return (parcelRequire("bmR1U")).RouterUtil; });
// -- Controllers -------------------------------------------------------------

var $ib7WC = parcelRequire("ib7WC");

var $6mRzS = parcelRequire("6mRzS");

var $f7IXw = parcelRequire("f7IXw");

var $d94Xg = parcelRequire("d94Xg");

var $jbD0z = parcelRequire("jbD0z");

var $jM3Wq = parcelRequire("jM3Wq");

var $hlVrM = parcelRequire("hlVrM");

var $7Xn6F = parcelRequire("7Xn6F");

var $br7WV = parcelRequire("br7WV");

var $g4s8N = parcelRequire("g4s8N");

var $zKxbI = parcelRequire("zKxbI");

var $3Sg6l = parcelRequire("3Sg6l");

var $8BVTM = parcelRequire("8BVTM");

var $hxXs8 = parcelRequire("hxXs8");

var $1DdOF = parcelRequire("1DdOF");

var $6m17w = parcelRequire("6m17w");

var $i2wHx = parcelRequire("i2wHx");

var $89gde = parcelRequire("89gde");

var $3BhS7 = parcelRequire("3BhS7");

var $vBowO = parcelRequire("vBowO");

var $4DSpJ = parcelRequire("4DSpJ");

var $eOULk = parcelRequire("eOULk");

var $6AwK8 = parcelRequire("6AwK8");

var $c4rfq = parcelRequire("c4rfq");

var $hdC6E = parcelRequire("hdC6E");

var $bmR1U = parcelRequire("bmR1U");

});
parcelRegister("ib7WC", function(module, exports) {

$parcel$export(module.exports, "ModalController", function () { return $d3bf6aa7e044a299$export$d507f25e63650365; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $f7IXw = parcelRequire("f7IXw");

var $g4s8N = parcelRequire("g4s8N");

var $6m17w = parcelRequire("6m17w");

var $1DdOF = parcelRequire("1DdOF");

var $6mRzS = parcelRequire("6mRzS");
// -- State --------------------------------------------- //
const $d3bf6aa7e044a299$var$state = (0, $eAQzZ.proxy)({
    loading: false,
    open: false,
    shake: false
});
const $d3bf6aa7e044a299$export$d507f25e63650365 = {
    state: $d3bf6aa7e044a299$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($d3bf6aa7e044a299$var$state, ()=>callback($d3bf6aa7e044a299$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($d3bf6aa7e044a299$var$state, key, callback);
    },
    async open (options) {
        await (0, $g4s8N.ApiController).state.prefetchPromise;
        const connected = (0, $f7IXw.AccountController).state.isConnected;
        if (options?.view) (0, $6mRzS.RouterController).reset(options.view);
        else if (connected) (0, $6mRzS.RouterController).reset("Account");
        else (0, $6mRzS.RouterController).reset("Connect");
        $d3bf6aa7e044a299$var$state.open = true;
        (0, $1DdOF.PublicStateController).set({
            open: true
        });
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "MODAL_OPEN",
            properties: {
                connected: connected
            }
        });
    },
    close () {
        const connected = (0, $f7IXw.AccountController).state.isConnected || false;
        $d3bf6aa7e044a299$var$state.open = false;
        (0, $1DdOF.PublicStateController).set({
            open: false
        });
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "MODAL_CLOSE",
            properties: {
                connected: connected
            }
        });
    },
    setLoading (loading) {
        $d3bf6aa7e044a299$var$state.loading = loading;
        (0, $1DdOF.PublicStateController).set({
            loading: loading
        });
    },
    shake () {
        if ($d3bf6aa7e044a299$var$state.shake) return;
        $d3bf6aa7e044a299$var$state.shake = true;
        setTimeout(()=>{
            $d3bf6aa7e044a299$var$state.shake = false;
        }, 500);
    }
};

});
parcelRegister("dNrTM", function(module, exports) {

$parcel$export(module.exports, "subscribeKey", function () { return $6c8034423c804e1d$export$7faad7f6b3708314; });
$parcel$export(module.exports, "proxyMap", function () { return $6c8034423c804e1d$export$17aaac2670e0d2b9; });

var $eAQzZ = parcelRequire("eAQzZ");
var $6c8034423c804e1d$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla/utils.mjs"
});
function $6c8034423c804e1d$export$7faad7f6b3708314(proxyObject, key, callback, notifyInSync) {
    let prevValue = proxyObject[key];
    return (0, $eAQzZ.subscribe)(proxyObject, ()=>{
        const nextValue = proxyObject[key];
        if (!Object.is(prevValue, nextValue)) callback(prevValue = nextValue);
    }, notifyInSync);
}
let $6c8034423c804e1d$var$currentCleanups;
function $6c8034423c804e1d$export$3db5d71bdb2d5499(callback, options) {
    let alive = true;
    const cleanups = /* @__PURE__ */ new Set();
    const subscriptions = /* @__PURE__ */ new Map();
    const cleanup = ()=>{
        if (alive) {
            alive = false;
            cleanups.forEach((clean)=>clean());
            cleanups.clear();
            subscriptions.forEach((unsubscribe)=>unsubscribe());
            subscriptions.clear();
        }
    };
    const revalidate = ()=>{
        if (!alive) return;
        cleanups.forEach((clean)=>clean());
        cleanups.clear();
        const proxiesToSubscribe = /* @__PURE__ */ new Set();
        const parent = $6c8034423c804e1d$var$currentCleanups;
        $6c8034423c804e1d$var$currentCleanups = cleanups;
        try {
            const cleanupReturn = callback((proxyObject)=>{
                proxiesToSubscribe.add(proxyObject);
                return proxyObject;
            });
            if (cleanupReturn) cleanups.add(cleanupReturn);
        } finally{
            $6c8034423c804e1d$var$currentCleanups = parent;
        }
        subscriptions.forEach((unsubscribe, proxyObject)=>{
            if (proxiesToSubscribe.has(proxyObject)) proxiesToSubscribe.delete(proxyObject);
            else {
                subscriptions.delete(proxyObject);
                unsubscribe();
            }
        });
        proxiesToSubscribe.forEach((proxyObject)=>{
            const unsubscribe = (0, $eAQzZ.subscribe)(proxyObject, revalidate, options == null ? void 0 : options.sync);
            subscriptions.set(proxyObject, unsubscribe);
        });
    };
    if ($6c8034423c804e1d$var$currentCleanups) $6c8034423c804e1d$var$currentCleanups.add(cleanup);
    revalidate();
    return cleanup;
}
const $6c8034423c804e1d$var$DEVTOOLS = Symbol();
function $6c8034423c804e1d$export$6922d3b3a607469e(proxyObject, options) {
    if (typeof options === "string") {
        console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400");
        options = {
            name: options
        };
    }
    const { enabled: enabled, name: name = "", ...rest } = options || {};
    let extension;
    try {
        extension = (enabled != null ? enabled : ($6c8034423c804e1d$import_meta.env ? $6c8034423c804e1d$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
    } catch  {}
    if (!extension) {
        if (($6c8034423c804e1d$import_meta.env ? $6c8034423c804e1d$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[Warning] Please install/enable Redux devtools extension");
        return;
    }
    let isTimeTraveling = false;
    const devtools2 = extension.connect({
        name: name,
        ...rest
    });
    const unsub1 = (0, $eAQzZ.subscribe)(proxyObject, (ops)=>{
        const action = ops.filter(([_, path])=>path[0] !== $6c8034423c804e1d$var$DEVTOOLS).map(([op, path])=>`${op}:${path.map(String).join(".")}`).join(", ");
        if (!action) return;
        if (isTimeTraveling) isTimeTraveling = false;
        else {
            const snapWithoutDevtools = Object.assign({}, (0, $eAQzZ.snapshot)(proxyObject));
            delete snapWithoutDevtools[$6c8034423c804e1d$var$DEVTOOLS];
            devtools2.send({
                type: action,
                updatedAt: /* @__PURE__ */ new Date().toLocaleString()
            }, snapWithoutDevtools);
        }
    });
    const unsub2 = devtools2.subscribe((message)=>{
        var _a, _b, _c, _d, _e, _f;
        if (message.type === "ACTION" && message.payload) try {
            Object.assign(proxyObject, JSON.parse(message.payload));
        } catch (e) {
            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
        }
        if (message.type === "DISPATCH" && message.state) {
            if (((_a = message.payload) == null ? void 0 : _a.type) === "JUMP_TO_ACTION" || ((_b = message.payload) == null ? void 0 : _b.type) === "JUMP_TO_STATE") {
                isTimeTraveling = true;
                const state = JSON.parse(message.state);
                Object.assign(proxyObject, state);
            }
            proxyObject[$6c8034423c804e1d$var$DEVTOOLS] = message;
        } else if (message.type === "DISPATCH" && ((_c = message.payload) == null ? void 0 : _c.type) === "COMMIT") devtools2.init((0, $eAQzZ.snapshot)(proxyObject));
        else if (message.type === "DISPATCH" && ((_d = message.payload) == null ? void 0 : _d.type) === "IMPORT_STATE") {
            const actions = (_e = message.payload.nextLiftedState) == null ? void 0 : _e.actionsById;
            const computedStates = ((_f = message.payload.nextLiftedState) == null ? void 0 : _f.computedStates) || [];
            isTimeTraveling = true;
            computedStates.forEach(({ state: state }, index)=>{
                const action = actions[index] || "No action found";
                Object.assign(proxyObject, state);
                if (index === 0) devtools2.init((0, $eAQzZ.snapshot)(proxyObject));
                else devtools2.send(action, (0, $eAQzZ.snapshot)(proxyObject));
            });
        }
    });
    devtools2.init((0, $eAQzZ.snapshot)(proxyObject));
    return ()=>{
        unsub1();
        unsub2 == null || unsub2();
    };
}
const $6c8034423c804e1d$var$sourceObjectMap = /* @__PURE__ */ new WeakMap();
const $6c8034423c804e1d$var$derivedObjectMap = /* @__PURE__ */ new WeakMap();
const $6c8034423c804e1d$var$markPending = (sourceObject, callback)=>{
    const sourceObjectEntry = $6c8034423c804e1d$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        sourceObjectEntry[0].forEach((subscription)=>{
            const { d: derivedObject } = subscription;
            if (sourceObject !== derivedObject) $6c8034423c804e1d$var$markPending(derivedObject);
        });
        ++sourceObjectEntry[2];
        if (callback) sourceObjectEntry[3].add(callback);
    }
};
const $6c8034423c804e1d$var$checkPending = (sourceObject, callback)=>{
    const sourceObjectEntry = $6c8034423c804e1d$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry == null ? void 0 : sourceObjectEntry[2]) {
        sourceObjectEntry[3].add(callback);
        return true;
    }
    return false;
};
const $6c8034423c804e1d$var$unmarkPending = (sourceObject)=>{
    const sourceObjectEntry = $6c8034423c804e1d$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        --sourceObjectEntry[2];
        if (!sourceObjectEntry[2]) {
            sourceObjectEntry[3].forEach((callback)=>callback());
            sourceObjectEntry[3].clear();
        }
        sourceObjectEntry[0].forEach((subscription)=>{
            const { d: derivedObject } = subscription;
            if (sourceObject !== derivedObject) $6c8034423c804e1d$var$unmarkPending(derivedObject);
        });
    }
};
const $6c8034423c804e1d$var$addSubscription = (subscription)=>{
    const { s: sourceObject, d: derivedObject } = subscription;
    let derivedObjectEntry = $6c8034423c804e1d$var$derivedObjectMap.get(derivedObject);
    if (!derivedObjectEntry) {
        derivedObjectEntry = [
            /* @__PURE__ */ new Set()
        ];
        $6c8034423c804e1d$var$derivedObjectMap.set(subscription.d, derivedObjectEntry);
    }
    derivedObjectEntry[0].add(subscription);
    let sourceObjectEntry = $6c8034423c804e1d$var$sourceObjectMap.get(sourceObject);
    if (!sourceObjectEntry) {
        const subscriptions = /* @__PURE__ */ new Set();
        const unsubscribe = (0, $eAQzZ.subscribe)(sourceObject, (ops)=>{
            subscriptions.forEach((subscription2)=>{
                const { d: derivedObject2, c: callback, n: notifyInSync, i: ignoreKeys } = subscription2;
                if (sourceObject === derivedObject2 && ops.every((op)=>op[1].length === 1 && ignoreKeys.includes(op[1][0]))) return;
                if (subscription2.p) return;
                $6c8034423c804e1d$var$markPending(sourceObject, callback);
                if (notifyInSync) $6c8034423c804e1d$var$unmarkPending(sourceObject);
                else subscription2.p = Promise.resolve().then(()=>{
                    delete subscription2.p;
                    $6c8034423c804e1d$var$unmarkPending(sourceObject);
                });
            });
        }, true);
        sourceObjectEntry = [
            subscriptions,
            unsubscribe,
            0,
            /* @__PURE__ */ new Set()
        ];
        $6c8034423c804e1d$var$sourceObjectMap.set(sourceObject, sourceObjectEntry);
    }
    sourceObjectEntry[0].add(subscription);
};
const $6c8034423c804e1d$var$removeSubscription = (subscription)=>{
    const { s: sourceObject, d: derivedObject } = subscription;
    const derivedObjectEntry = $6c8034423c804e1d$var$derivedObjectMap.get(derivedObject);
    derivedObjectEntry == null || derivedObjectEntry[0].delete(subscription);
    if ((derivedObjectEntry == null ? void 0 : derivedObjectEntry[0].size) === 0) $6c8034423c804e1d$var$derivedObjectMap.delete(derivedObject);
    const sourceObjectEntry = $6c8034423c804e1d$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        const [subscriptions, unsubscribe] = sourceObjectEntry;
        subscriptions.delete(subscription);
        if (!subscriptions.size) {
            unsubscribe();
            $6c8034423c804e1d$var$sourceObjectMap.delete(sourceObject);
        }
    }
};
const $6c8034423c804e1d$var$listSubscriptions = (derivedObject)=>{
    const derivedObjectEntry = $6c8034423c804e1d$var$derivedObjectMap.get(derivedObject);
    if (derivedObjectEntry) return Array.from(derivedObjectEntry[0]);
    return [];
};
const $6c8034423c804e1d$export$5bb85a5dcd872eb9 = {
    add: $6c8034423c804e1d$var$addSubscription,
    remove: $6c8034423c804e1d$var$removeSubscription,
    list: $6c8034423c804e1d$var$listSubscriptions
};
function $6c8034423c804e1d$export$78ed5b3305815fc7(derivedFns, options) {
    const proxyObject = (options == null ? void 0 : options.proxy) || (0, $eAQzZ.proxy)({});
    const notifyInSync = !!(options == null ? void 0 : options.sync);
    const derivedKeys = Object.keys(derivedFns);
    derivedKeys.forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(proxyObject, key)) throw new Error("object property already defined");
        const fn = derivedFns[key];
        let lastDependencies = null;
        const evaluate = ()=>{
            if (lastDependencies) {
                if (Array.from(lastDependencies).map(([p])=>$6c8034423c804e1d$var$checkPending(p, evaluate)).some((isPending)=>isPending)) return;
                if (Array.from(lastDependencies).every(([p, entry])=>(0, $eAQzZ.getVersion)(p) === entry.v)) return;
            }
            const dependencies = /* @__PURE__ */ new Map();
            const get = (p)=>{
                dependencies.set(p, {
                    v: (0, $eAQzZ.getVersion)(p)
                });
                return p;
            };
            const value = fn(get);
            const subscribeToDependencies = ()=>{
                dependencies.forEach((entry, p)=>{
                    var _a;
                    const lastSubscription = (_a = lastDependencies == null ? void 0 : lastDependencies.get(p)) == null ? void 0 : _a.s;
                    if (lastSubscription) entry.s = lastSubscription;
                    else {
                        const subscription = {
                            s: p,
                            // sourceObject
                            d: proxyObject,
                            // derivedObject
                            k: key,
                            // derived key
                            c: evaluate,
                            // callback
                            n: notifyInSync,
                            i: derivedKeys
                        };
                        $6c8034423c804e1d$var$addSubscription(subscription);
                        entry.s = subscription;
                    }
                });
                lastDependencies == null || lastDependencies.forEach((entry, p)=>{
                    if (!dependencies.has(p) && entry.s) $6c8034423c804e1d$var$removeSubscription(entry.s);
                });
                lastDependencies = dependencies;
            };
            if (value instanceof Promise) value.finally(subscribeToDependencies);
            else subscribeToDependencies();
            proxyObject[key] = value;
        };
        evaluate();
    });
    return proxyObject;
}
function $6c8034423c804e1d$export$992ed2abb18cb90(proxyObject, options) {
    const keysToDelete = (options == null ? void 0 : options.delete) ? /* @__PURE__ */ new Set() : null;
    $6c8034423c804e1d$var$listSubscriptions(proxyObject).forEach((subscription)=>{
        const { k: key } = subscription;
        if (!(options == null ? void 0 : options.keys) || options.keys.includes(key)) {
            $6c8034423c804e1d$var$removeSubscription(subscription);
            if (keysToDelete) keysToDelete.add(key);
        }
    });
    if (keysToDelete) keysToDelete.forEach((key)=>{
        delete proxyObject[key];
    });
}
function $6c8034423c804e1d$export$b84fff6f79a56fa3(proxyObject, computedFns_FAKE, targetObject = proxyObject) {
    if (($6c8034423c804e1d$import_meta.env ? $6c8034423c804e1d$import_meta.env.MODE : void 0) !== "production") console.warn("addComputed is deprecated. Please consider using `derive`. Falling back to emulation with derive. https://github.com/pmndrs/valtio/pull/201");
    const derivedFns = {};
    Object.keys(computedFns_FAKE).forEach((key)=>{
        derivedFns[key] = (get)=>computedFns_FAKE[key](get(proxyObject));
    });
    return $6c8034423c804e1d$export$78ed5b3305815fc7(derivedFns, {
        proxy: targetObject
    });
}
function $6c8034423c804e1d$export$64a33e9109220e08(initialObject, computedFns) {
    if (($6c8034423c804e1d$import_meta.env ? $6c8034423c804e1d$import_meta.env.MODE : void 0) !== "production") console.warn('proxyWithComputed is deprecated. Please follow "Computed Properties" guide in docs.');
    Object.keys(computedFns).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        const computedFn = computedFns[key];
        const { get: get, set: set } = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn;
        const desc = {};
        desc.get = ()=>get((0, $eAQzZ.snapshot)(proxyObject));
        if (set) desc.set = (newValue)=>set(proxyObject, newValue);
        Object.defineProperty(initialObject, key, desc);
    });
    const proxyObject = (0, $eAQzZ.proxy)(initialObject);
    return proxyObject;
}
const $6c8034423c804e1d$var$isObject = (x)=>typeof x === "object" && x !== null;
let $6c8034423c804e1d$var$refSet;
const $6c8034423c804e1d$var$deepClone = (obj)=>{
    if (!$6c8034423c804e1d$var$refSet) $6c8034423c804e1d$var$refSet = (0, $eAQzZ.unstable_buildProxyFunction)()[2];
    if (!$6c8034423c804e1d$var$isObject(obj) || $6c8034423c804e1d$var$refSet.has(obj)) return obj;
    const baseObject = Array.isArray(obj) ? [] : Object.create(Object.getPrototypeOf(obj));
    Reflect.ownKeys(obj).forEach((key)=>{
        baseObject[key] = $6c8034423c804e1d$var$deepClone(obj[key]);
    });
    return baseObject;
};
function $6c8034423c804e1d$export$32f3091caa3ecf1e(initialValue, skipSubscribe = false) {
    const proxyObject = (0, $eAQzZ.proxy)({
        value: initialValue,
        history: (0, $eAQzZ.ref)({
            wip: void 0,
            // to avoid infinite loop
            snapshots: [],
            index: -1
        }),
        clone: $6c8034423c804e1d$var$deepClone,
        canUndo: ()=>proxyObject.history.index > 0,
        undo: ()=>{
            if (proxyObject.canUndo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[--proxyObject.history.index]);
        },
        canRedo: ()=>proxyObject.history.index < proxyObject.history.snapshots.length - 1,
        redo: ()=>{
            if (proxyObject.canRedo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[++proxyObject.history.index]);
        },
        saveHistory: ()=>{
            proxyObject.history.snapshots.splice(proxyObject.history.index + 1);
            proxyObject.history.snapshots.push((0, $eAQzZ.snapshot)(proxyObject).value);
            ++proxyObject.history.index;
        },
        subscribe: ()=>(0, $eAQzZ.subscribe)(proxyObject, (ops)=>{
                if (ops.every((op)=>op[1][0] === "value" && (op[0] !== "set" || op[2] !== proxyObject.history.wip))) proxyObject.saveHistory();
            })
    });
    proxyObject.saveHistory();
    if (!skipSubscribe) proxyObject.subscribe();
    return proxyObject;
}
function $6c8034423c804e1d$export$339ebc24fb22ad80(initialValues) {
    const set = (0, $eAQzZ.proxy)({
        data: Array.from(new Set(initialValues)),
        has (value) {
            return this.data.indexOf(value) !== -1;
        },
        add (value) {
            let hasProxy = false;
            if (typeof value === "object" && value !== null) hasProxy = this.data.indexOf((0, $eAQzZ.proxy)(value)) !== -1;
            if (this.data.indexOf(value) === -1 && !hasProxy) this.data.push(value);
            return this;
        },
        delete (value) {
            const index = this.data.indexOf(value);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear () {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        forEach (cb) {
            this.data.forEach((value)=>{
                cb(value, value, this);
            });
        },
        get [Symbol.toStringTag] () {
            return "Set";
        },
        toJSON () {
            return new Set(this.data);
        },
        [Symbol.iterator] () {
            return this.data[Symbol.iterator]();
        },
        values () {
            return this.data.values();
        },
        keys () {
            return this.data.values();
        },
        entries () {
            return new Set(this.data).entries();
        }
    });
    Object.defineProperties(set, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(set);
    return set;
}
function $6c8034423c804e1d$export$17aaac2670e0d2b9(entries) {
    const map = (0, $eAQzZ.proxy)({
        data: Array.from(entries || []),
        has (key) {
            return this.data.some((p)=>p[0] === key);
        },
        set (key, value) {
            const record = this.data.find((p)=>p[0] === key);
            if (record) record[1] = value;
            else this.data.push([
                key,
                value
            ]);
            return this;
        },
        get (key) {
            var _a;
            return (_a = this.data.find((p)=>p[0] === key)) == null ? void 0 : _a[1];
        },
        delete (key) {
            const index = this.data.findIndex((p)=>p[0] === key);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear () {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        toJSON () {
            return new Map(this.data);
        },
        forEach (cb) {
            this.data.forEach((p)=>{
                cb(p[1], p[0], this);
            });
        },
        keys () {
            return this.data.map((p)=>p[0]).values();
        },
        values () {
            return this.data.map((p)=>p[1]).values();
        },
        entries () {
            return new Map(this.data).entries();
        },
        get [Symbol.toStringTag] () {
            return "Map";
        },
        [Symbol.iterator] () {
            return this.entries();
        }
    });
    Object.defineProperties(map, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(map);
    return map;
}

});
parcelRegister("eAQzZ", function(module, exports) {

$parcel$export(module.exports, "proxy", function () { return $542dcc0c6157ad40$export$923f96dd5afa9ce6; });
$parcel$export(module.exports, "getVersion", function () { return $542dcc0c6157ad40$export$c506eb22e615ba4a; });
$parcel$export(module.exports, "subscribe", function () { return $542dcc0c6157ad40$export$ec068583843480e7; });
$parcel$export(module.exports, "snapshot", function () { return $542dcc0c6157ad40$export$b8801ea43165ed7d; });
$parcel$export(module.exports, "ref", function () { return $542dcc0c6157ad40$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "unstable_buildProxyFunction", function () { return $542dcc0c6157ad40$export$e7b04d37d9502758; });

var $cbzom = parcelRequire("cbzom");
var $542dcc0c6157ad40$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla.mjs"
});
const $542dcc0c6157ad40$var$isObject = (x)=>typeof x === "object" && x !== null;
const $542dcc0c6157ad40$var$proxyStateMap = /* @__PURE__ */ new WeakMap();
const $542dcc0c6157ad40$var$refSet = /* @__PURE__ */ new WeakSet();
const $542dcc0c6157ad40$var$buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler)=>new Proxy(target, handler), canProxy = (x)=>$542dcc0c6157ad40$var$isObject(x) && !$542dcc0c6157ad40$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise)=>{
    switch(promise.status){
        case "fulfilled":
            return promise.value;
        case "rejected":
            throw promise.reason;
        default:
            throw promise;
    }
}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise)=>{
    const cache = snapCache.get(target);
    if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
    const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
    (0, $cbzom.markToTrack)(snap, true);
    snapCache.set(target, [
        version,
        snap
    ]);
    Reflect.ownKeys(target).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(snap, key)) return;
        const value = Reflect.get(target, key);
        const desc = {
            value: value,
            enumerable: true,
            // This is intentional to avoid copying with proxy-compare.
            // It's still non-writable, so it avoids assigning a value.
            configurable: true
        };
        if ($542dcc0c6157ad40$var$refSet.has(value)) (0, $cbzom.markToTrack)(value, false);
        else if (value instanceof Promise) {
            delete desc.value;
            desc.get = ()=>handlePromise(value);
        } else if ($542dcc0c6157ad40$var$proxyStateMap.has(value)) {
            const [target2, ensureVersion] = $542dcc0c6157ad40$var$proxyStateMap.get(value);
            desc.value = createSnapshot(target2, ensureVersion(), handlePromise);
        }
        Object.defineProperty(snap, key, desc);
    });
    return Object.preventExtensions(snap);
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [
    1,
    1
], proxyFunction = (initialObject)=>{
    if (!$542dcc0c6157ad40$var$isObject(initialObject)) throw new Error("object required");
    const found = proxyCache.get(initialObject);
    if (found) return found;
    let version = versionHolder[0];
    const listeners = /* @__PURE__ */ new Set();
    const notifyUpdate = (op, nextVersion = ++versionHolder[0])=>{
        if (version !== nextVersion) {
            version = nextVersion;
            listeners.forEach((listener)=>listener(op, nextVersion));
        }
    };
    let checkVersion = versionHolder[1];
    const ensureVersion = (nextCheckVersion = ++versionHolder[1])=>{
        if (checkVersion !== nextCheckVersion && !listeners.size) {
            checkVersion = nextCheckVersion;
            propProxyStates.forEach(([propProxyState])=>{
                const propVersion = propProxyState[1](nextCheckVersion);
                if (propVersion > version) version = propVersion;
            });
        }
        return version;
    };
    const createPropListener = (prop)=>(op, nextVersion)=>{
            const newOp = [
                ...op
            ];
            newOp[1] = [
                prop,
                ...newOp[1]
            ];
            notifyUpdate(newOp, nextVersion);
        };
    const propProxyStates = /* @__PURE__ */ new Map();
    const addPropListener = (prop, propProxyState)=>{
        if (($542dcc0c6157ad40$import_meta.env ? $542dcc0c6157ad40$import_meta.env.MODE : void 0) !== "production" && propProxyStates.has(prop)) throw new Error("prop listener already exists");
        if (listeners.size) {
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        } else propProxyStates.set(prop, [
            propProxyState
        ]);
    };
    const removePropListener = (prop)=>{
        var _a;
        const entry = propProxyStates.get(prop);
        if (entry) {
            propProxyStates.delete(prop);
            (_a = entry[1]) == null || _a.call(entry);
        }
    };
    const addListener = (listener)=>{
        listeners.add(listener);
        if (listeners.size === 1) propProxyStates.forEach(([propProxyState, prevRemove], prop)=>{
            if (($542dcc0c6157ad40$import_meta.env ? $542dcc0c6157ad40$import_meta.env.MODE : void 0) !== "production" && prevRemove) throw new Error("remove already exists");
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        });
        const removeListener = ()=>{
            listeners.delete(listener);
            if (listeners.size === 0) propProxyStates.forEach(([propProxyState, remove], prop)=>{
                if (remove) {
                    remove();
                    propProxyStates.set(prop, [
                        propProxyState
                    ]);
                }
            });
        };
        return removeListener;
    };
    const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
    const handler = {
        deleteProperty (target, prop) {
            const prevValue = Reflect.get(target, prop);
            removePropListener(prop);
            const deleted = Reflect.deleteProperty(target, prop);
            if (deleted) notifyUpdate([
                "delete",
                [
                    prop
                ],
                prevValue
            ]);
            return deleted;
        },
        set (target, prop, value, receiver) {
            const hasPrevValue = Reflect.has(target, prop);
            const prevValue = Reflect.get(target, prop, receiver);
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
            removePropListener(prop);
            if ($542dcc0c6157ad40$var$isObject(value)) value = (0, $cbzom.getUntracked)(value) || value;
            let nextValue = value;
            if (value instanceof Promise) value.then((v)=>{
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch((e)=>{
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$542dcc0c6157ad40$var$proxyStateMap.has(value) && canProxy(value)) nextValue = proxyFunction(value);
                const childProxyState = !$542dcc0c6157ad40$var$refSet.has(nextValue) && $542dcc0c6157ad40$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            Reflect.set(target, prop, nextValue, receiver);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
            return true;
        }
    };
    const proxyObject = newProxy(baseObject, handler);
    proxyCache.set(initialObject, proxyObject);
    const proxyState = [
        baseObject,
        ensureVersion,
        createSnapshot,
        addListener
    ];
    $542dcc0c6157ad40$var$proxyStateMap.set(proxyObject, proxyState);
    Reflect.ownKeys(initialObject).forEach((key)=>{
        const desc = Object.getOwnPropertyDescriptor(initialObject, key);
        if ("value" in desc) {
            proxyObject[key] = initialObject[key];
            delete desc.value;
            delete desc.writable;
        }
        Object.defineProperty(baseObject, key, desc);
    });
    return proxyObject;
})=>[
        // public functions
        proxyFunction,
        // shared state
        $542dcc0c6157ad40$var$proxyStateMap,
        $542dcc0c6157ad40$var$refSet,
        // internal things
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
const [$542dcc0c6157ad40$var$defaultProxyFunction] = $542dcc0c6157ad40$var$buildProxyFunction();
function $542dcc0c6157ad40$export$923f96dd5afa9ce6(initialObject = {}) {
    return $542dcc0c6157ad40$var$defaultProxyFunction(initialObject);
}
function $542dcc0c6157ad40$export$c506eb22e615ba4a(proxyObject) {
    const proxyState = $542dcc0c6157ad40$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $542dcc0c6157ad40$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    const proxyState = $542dcc0c6157ad40$var$proxyStateMap.get(proxyObject);
    if (($542dcc0c6157ad40$import_meta.env ? $542dcc0c6157ad40$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    let promise;
    const ops = [];
    const addListener = proxyState[3];
    let isListenerActive = false;
    const listener = (op)=>{
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(()=>{
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    const removeListener = addListener(listener);
    isListenerActive = true;
    return ()=>{
        isListenerActive = false;
        removeListener();
    };
}
function $542dcc0c6157ad40$export$b8801ea43165ed7d(proxyObject, handlePromise) {
    const proxyState = $542dcc0c6157ad40$var$proxyStateMap.get(proxyObject);
    if (($542dcc0c6157ad40$import_meta.env ? $542dcc0c6157ad40$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    const [target, ensureVersion, createSnapshot] = proxyState;
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $542dcc0c6157ad40$export$eff4d24c3ff7876e(obj) {
    $542dcc0c6157ad40$var$refSet.add(obj);
    return obj;
}
const $542dcc0c6157ad40$export$e7b04d37d9502758 = $542dcc0c6157ad40$var$buildProxyFunction;

});
parcelRegister("cbzom", function(module, exports) {

$parcel$export(module.exports, "getUntracked", function () { return $8df1f7376b8e2728$export$80d2cee7ee556e99; });
$parcel$export(module.exports, "markToTrack", function () { return $8df1f7376b8e2728$export$2c8383c890e26a1c; });
const $8df1f7376b8e2728$var$e = Symbol(), $8df1f7376b8e2728$var$t = Symbol(), $8df1f7376b8e2728$var$r = "a", $8df1f7376b8e2728$var$n = "w";
let $8df1f7376b8e2728$var$o = (e, t)=>new Proxy(e, t);
const $8df1f7376b8e2728$var$s = Object.getPrototypeOf, $8df1f7376b8e2728$var$c = new WeakMap, $8df1f7376b8e2728$var$l = (e)=>e && ($8df1f7376b8e2728$var$c.has(e) ? $8df1f7376b8e2728$var$c.get(e) : $8df1f7376b8e2728$var$s(e) === Object.prototype || $8df1f7376b8e2728$var$s(e) === Array.prototype), $8df1f7376b8e2728$var$f = (e)=>"object" == typeof e && null !== e, $8df1f7376b8e2728$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($8df1f7376b8e2728$var$s(e), t);
}, $8df1f7376b8e2728$var$u = (e)=>e[$8df1f7376b8e2728$var$t] || e, $8df1f7376b8e2728$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$8df1f7376b8e2728$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $8df1f7376b8e2728$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $8df1f7376b8e2728$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$8df1f7376b8e2728$var$r].get(o);
                if (s || (s = {}, c[$8df1f7376b8e2728$var$r].set(o, s)), e === $8df1f7376b8e2728$var$n) s[$8df1f7376b8e2728$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $8df1f7376b8e2728$var$t ? o : (f("k", n), $8df1f7376b8e2728$export$7865d0c7f908de6b(Reflect.get(e, n), c[$8df1f7376b8e2728$var$r], c.c, c.t)),
            has: (t, n)=>n === $8df1f7376b8e2728$var$e ? (l = !0, c[$8df1f7376b8e2728$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($8df1f7376b8e2728$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $8df1f7376b8e2728$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$8df1f7376b8e2728$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $8df1f7376b8e2728$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$8df1f7376b8e2728$var$f(e) || !$8df1f7376b8e2728$var$f(t)) return !0;
    const s = r.get($8df1f7376b8e2728$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$8df1f7376b8e2728$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $8df1f7376b8e2728$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $8df1f7376b8e2728$export$badc26589cf7bb38 = (t)=>!!$8df1f7376b8e2728$var$l(t) && $8df1f7376b8e2728$var$e in t, $8df1f7376b8e2728$export$80d2cee7ee556e99 = (e)=>$8df1f7376b8e2728$var$l(e) && e[$8df1f7376b8e2728$var$t] || null, $8df1f7376b8e2728$export$2c8383c890e26a1c = (e, t = !0)=>{
    $8df1f7376b8e2728$var$c.set(e, t);
}, $8df1f7376b8e2728$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $8df1f7376b8e2728$var$f(e) && s.add(e);
        const i = $8df1f7376b8e2728$var$f(e) && t.get($8df1f7376b8e2728$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$8df1f7376b8e2728$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $8df1f7376b8e2728$export$9b4d5450dbd8e67e = (e)=>{
    $8df1f7376b8e2728$var$o = e;
};

});



parcelRegister("f7IXw", function(module, exports) {

$parcel$export(module.exports, "AccountController", function () { return $b02a625f8a7a69b6$export$3a40b83c1282ee40; });

var $c4rfq = parcelRequire("c4rfq");

var $hxXs8 = parcelRequire("hxXs8");

var $br7WV = parcelRequire("br7WV");

var $89gde = parcelRequire("89gde");

var $m3nYM = parcelRequire("m3nYM");

var $d94Xg = parcelRequire("d94Xg");

var $jbD0z = parcelRequire("jbD0z");

var $eAQzZ = parcelRequire("eAQzZ");
// -- State --------------------------------------------- //
const $b02a625f8a7a69b6$var$state = (0, $eAQzZ.proxy)({
    isConnected: false,
    currentTab: 0,
    tokenBalance: [],
    smartAccountDeployed: false,
    addressLabels: new Map(),
    allAccounts: []
});
const $b02a625f8a7a69b6$export$3a40b83c1282ee40 = {
    state: $b02a625f8a7a69b6$var$state,
    replaceState (newState) {
        if (!newState) return;
        Object.assign($b02a625f8a7a69b6$var$state, (0, $eAQzZ.ref)(newState));
    },
    subscribe (callback) {
        return (0, $d94Xg.ChainController).subscribeChainProp("accountState", (accountState)=>{
            if (accountState) return callback(accountState);
            return undefined;
        });
    },
    subscribeKey (property, callback) {
        let prev = undefined;
        return (0, $d94Xg.ChainController).subscribeChainProp("accountState", (accountState)=>{
            if (accountState) {
                const nextValue = accountState[property];
                if (prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    setIsConnected (isConnected, chain) {
        (0, $d94Xg.ChainController).setAccountProp("isConnected", isConnected, chain);
    },
    getChainIsConnected (chain) {
        return (0, $d94Xg.ChainController).getAccountProp("isConnected", chain);
    },
    setCaipAddress (caipAddress, chain) {
        const newCaipAddress = caipAddress ? (0, $c4rfq.CoreHelperUtil).getPlainAddress(caipAddress) : undefined;
        (0, $d94Xg.ChainController).setAccountProp("caipAddress", caipAddress, chain);
        (0, $d94Xg.ChainController).setAccountProp("address", newCaipAddress, chain);
    },
    setBalance (balance, balanceSymbol, chain) {
        (0, $d94Xg.ChainController).setAccountProp("balance", balance, chain);
        (0, $d94Xg.ChainController).setAccountProp("balanceSymbol", balanceSymbol, chain);
    },
    setProfileName (profileName, chain) {
        (0, $d94Xg.ChainController).setAccountProp("profileName", profileName, chain);
    },
    setProfileImage (profileImage, chain) {
        (0, $d94Xg.ChainController).setAccountProp("profileImage", profileImage, chain);
    },
    setAddressExplorerUrl (explorerUrl, chain) {
        (0, $d94Xg.ChainController).setAccountProp("addressExplorerUrl", explorerUrl, chain);
    },
    setSmartAccountDeployed (isDeployed, chain) {
        (0, $d94Xg.ChainController).setAccountProp("smartAccountDeployed", isDeployed, chain);
    },
    setCurrentTab (currentTab) {
        (0, $d94Xg.ChainController).setAccountProp("currentTab", currentTab, (0, $d94Xg.ChainController).state.activeChain);
    },
    setTokenBalance (tokenBalance, chain) {
        if (tokenBalance) (0, $d94Xg.ChainController).setAccountProp("tokenBalance", tokenBalance, chain);
    },
    setShouldUpdateToAddress (address, chain) {
        (0, $d94Xg.ChainController).setAccountProp("shouldUpdateToAddress", address, chain);
    },
    setAllAccounts (accounts, chain) {
        (0, $d94Xg.ChainController).setAccountProp("allAccounts", accounts, chain);
    },
    addAddressLabel (address, label, chain) {
        const map = (0, $d94Xg.ChainController).getAccountProp("addressLabels", chain) || new Map();
        map.set(address, label);
        (0, $d94Xg.ChainController).setAccountProp("addressLabels", map, (0, $d94Xg.ChainController).state.activeChain);
    },
    removeAddressLabel (address, chain) {
        const map = (0, $d94Xg.ChainController).getAccountProp("addressLabels", chain) || new Map();
        map.delete(address);
        (0, $d94Xg.ChainController).setAccountProp("addressLabels", map, (0, $d94Xg.ChainController).state.activeChain);
    },
    setConnectedWalletInfo (connectedWalletInfo, chain) {
        (0, $d94Xg.ChainController).setAccountProp("connectedWalletInfo", connectedWalletInfo, chain);
    },
    setPreferredAccountType (preferredAccountType, chain) {
        (0, $d94Xg.ChainController).setAccountProp("preferredAccountType", preferredAccountType, chain);
    },
    setSocialProvider (socialProvider, chain) {
        if (socialProvider) (0, $d94Xg.ChainController).setAccountProp("socialProvider", socialProvider, chain);
    },
    setSocialWindow (socialWindow, chain) {
        if (socialWindow) (0, $d94Xg.ChainController).setAccountProp("socialWindow", (0, $eAQzZ.ref)(socialWindow), chain);
    },
    setFarcasterUrl (farcasterUrl, chain) {
        if (farcasterUrl) (0, $d94Xg.ChainController).setAccountProp("farcasterUrl", farcasterUrl, chain);
    },
    async fetchTokenBalance () {
        const chainId = (0, $jbD0z.NetworkController).state.caipNetwork?.id;
        const chain = (0, $jbD0z.NetworkController).state.caipNetwork?.chain;
        const address = $b02a625f8a7a69b6$export$3a40b83c1282ee40.state.address;
        try {
            if (address && chainId && chain) {
                const response = await (0, $hxXs8.BlockchainApiController).getBalance(address, chainId);
                const filteredBalances = response.balances.filter((balance)=>balance.quantity.decimals !== "0");
                this.setTokenBalance(filteredBalances, chain);
                (0, $89gde.SwapController).setBalances((0, $m3nYM.SwapApiUtil).mapBalancesToSwapTokens(response.balances));
            }
        } catch (error) {
            (0, $br7WV.SnackController).showError("Failed to fetch token balance");
        }
    },
    resetAccount (chain) {
        (0, $d94Xg.ChainController).resetAccount(chain);
    }
};

});
parcelRegister("c4rfq", function(module, exports) {

$parcel$export(module.exports, "CoreHelperUtil", function () { return $8c9afe99ef992f74$export$d8fe68a4208d58ff; });
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");

var $6AwK8 = parcelRequire("6AwK8");
const $8c9afe99ef992f74$export$d8fe68a4208d58ff = {
    isMobile () {
        if (typeof window !== "undefined") return Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent));
        return false;
    },
    checkCaipNetwork (network, networkName = "") {
        return network?.id.toLocaleLowerCase().includes(networkName.toLowerCase());
    },
    isAndroid () {
        const ua = window.navigator.userAgent.toLowerCase();
        return $8c9afe99ef992f74$export$d8fe68a4208d58ff.isMobile() && ua.includes("android");
    },
    isIos () {
        const ua = window.navigator.userAgent.toLowerCase();
        return $8c9afe99ef992f74$export$d8fe68a4208d58ff.isMobile() && (ua.includes("iphone") || ua.includes("ipad"));
    },
    isClient () {
        return typeof window !== "undefined";
    },
    isPairingExpired (expiry) {
        return expiry ? expiry - Date.now() <= (0, $6AwK8.ConstantsUtil).TEN_SEC_MS : true;
    },
    isAllowedRetry (lastRetry) {
        return Date.now() - lastRetry >= (0, $6AwK8.ConstantsUtil).ONE_SEC_MS;
    },
    copyToClopboard (text) {
        navigator.clipboard.writeText(text);
    },
    getPairingExpiry () {
        return Date.now() + (0, $6AwK8.ConstantsUtil).FOUR_MINUTES_MS;
    },
    getNetworkId (caipAddress) {
        return caipAddress?.split(":")[1];
    },
    getPlainAddress (caipAddress) {
        return caipAddress?.split(":")[2];
    },
    async wait (milliseconds) {
        return new Promise((resolve)=>{
            setTimeout(resolve, milliseconds);
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    debounce (func, timeout = 500) {
        let timer = undefined;
        return (...args)=>{
            function next() {
                func(...args);
            }
            if (timer) clearTimeout(timer);
            timer = setTimeout(next, timeout);
        };
    },
    isHttpUrl (url) {
        return url.startsWith("http://") || url.startsWith("https://");
    },
    formatNativeUrl (appUrl, wcUri) {
        if ($8c9afe99ef992f74$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatUniversalUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.includes("://")) {
            safeAppUrl = appUrl.replaceAll("/", "").replaceAll(":", "");
            safeAppUrl = `${safeAppUrl}://`;
        }
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    formatUniversalUrl (appUrl, wcUri) {
        if (!$8c9afe99ef992f74$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatNativeUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    openHref (href, target, features) {
        window.open(href, target, features || "noreferrer noopener");
    },
    returnOpenHref (href, target, features) {
        return window.open(href, target, features || "noreferrer noopener");
    },
    async preloadImage (src) {
        const imagePromise = new Promise((resolve, reject)=>{
            const image = new Image();
            image.onload = resolve;
            image.onerror = reject;
            image.crossOrigin = "anonymous";
            image.src = src;
        });
        return Promise.race([
            imagePromise,
            $8c9afe99ef992f74$export$d8fe68a4208d58ff.wait(2000)
        ]);
    },
    formatBalance (balance, symbol) {
        let formattedBalance = "0.000";
        if (typeof balance === "string") {
            const number = Number(balance);
            if (number) {
                const formattedValue = Math.floor(number * 1000) / 1000;
                if (formattedValue) formattedBalance = formattedValue.toString();
            }
        }
        return `${formattedBalance}${symbol ? ` ${symbol}` : ""}`;
    },
    formatBalance2 (balance, symbol) {
        let formattedBalance = undefined;
        if (balance === "0") formattedBalance = "0";
        else if (typeof balance === "string") {
            const number = Number(balance);
            if (number) formattedBalance = number.toString().match(/^-?\d+(?:\.\d{0,3})?/u)?.[0];
        }
        return {
            value: formattedBalance ?? "0",
            rest: formattedBalance === "0" ? "000" : "",
            symbol: symbol
        };
    },
    getApiUrl () {
        return (0, $1VCt9.ConstantsUtil).W3M_API_URL;
    },
    getBlockchainApiUrl () {
        return (0, $1VCt9.ConstantsUtil).BLOCKCHAIN_API_RPC_URL;
    },
    getAnalyticsUrl () {
        return (0, $1VCt9.ConstantsUtil).PULSE_API_URL;
    },
    getUUID () {
        if (crypto?.randomUUID) return crypto.randomUUID();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (c)=>{
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseError (error) {
        if (typeof error === "string") return error;
        else if (typeof error?.issues?.[0]?.message === "string") return error.issues[0].message;
        else if (error instanceof Error) return error.message;
        return "Unknown error";
    },
    sortRequestedNetworks (approvedIds, requestedNetworks = []) {
        const approvedIndexMap = {};
        if (requestedNetworks && approvedIds) {
            approvedIds.forEach((id, index)=>{
                approvedIndexMap[id] = index;
            });
            requestedNetworks.sort((a, b)=>{
                const indexA = approvedIndexMap[a.id];
                const indexB = approvedIndexMap[b.id];
                if (indexA !== undefined && indexB !== undefined) return indexA - indexB;
                else if (indexA !== undefined) return -1;
                else if (indexB !== undefined) return 1;
                return 0;
            });
        }
        return requestedNetworks;
    },
    calculateBalance (array) {
        let sum = 0;
        for (const item of array)sum += item.value ?? 0;
        return sum;
    },
    formatTokenBalance (number) {
        const roundedNumber = number.toFixed(2);
        const [dollars, pennies] = roundedNumber.split(".");
        return {
            dollars: dollars,
            pennies: pennies
        };
    },
    isAddress (address) {
        if (!/^(?:0x)?[0-9a-f]{40}$/iu.test(address)) return false;
        else if (/^(?:0x)?[0-9a-f]{40}$/iu.test(address) || /^(?:0x)?[0-9A-F]{40}$/iu.test(address)) return true;
        return false;
    },
    uniqueBy (arr, key) {
        const set = new Set();
        return arr.filter((item)=>{
            const keyValue = item[key];
            if (set.has(keyValue)) return false;
            set.add(keyValue);
            return true;
        });
    }
};

});
parcelRegister("ikDNi", function(module, exports) {
$parcel$export(module.exports, "getW3mThemeVariables", function () { return (parcelRequire("5OPHH")).getW3mThemeVariables; });

$parcel$export(module.exports, "DateUtil", function () { return (parcelRequire("5kBvB")).DateUtil; });
$parcel$export(module.exports, "NetworkUtil", function () { return (parcelRequire("1yWTt")).NetworkUtil; });
$parcel$export(module.exports, "NumberUtil", function () { return (parcelRequire("l2EhC")).NumberUtil; });
$parcel$export(module.exports, "InputUtil", function () { return (parcelRequire("4DADY")).InputUtil; });
$parcel$export(module.exports, "erc20ABI", function () { return (parcelRequire("bZ3oL")).erc20ABI; });
$parcel$export(module.exports, "NavigationUtil", function () { return (parcelRequire("jgvE4")).NavigationUtil; });
$parcel$export(module.exports, "ConstantsUtil", function () { return (parcelRequire("1VCt9")).ConstantsUtil; });

var $5kBvB = parcelRequire("5kBvB");

var $1yWTt = parcelRequire("1yWTt");

var $l2EhC = parcelRequire("l2EhC");

var $4DADY = parcelRequire("4DADY");

var $bZ3oL = parcelRequire("bZ3oL");

var $jgvE4 = parcelRequire("jgvE4");

var $1VCt9 = parcelRequire("1VCt9");
parcelRequire("5OPHH");

});
parcelRegister("5kBvB", function(module, exports) {

$parcel$export(module.exports, "DateUtil", function () { return $3e1bea756c01c936$export$9b575f14aa5e09a1; });

var $l3Lpn = parcelRequire("l3Lpn");

var $fGGR8 = parcelRequire("fGGR8");

var $iwdJC = parcelRequire("iwdJC");

var $eQCpb = parcelRequire("eQCpb");
(0, (/*@__PURE__*/$parcel$interopDefault($l3Lpn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($iwdJC))));
(0, (/*@__PURE__*/$parcel$interopDefault($l3Lpn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($eQCpb))));
const $3e1bea756c01c936$var$localeObject = {
    ...(0, (/*@__PURE__*/$parcel$interopDefault($fGGR8))),
    name: "en-web3-modal",
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "%d sec",
        m: "1 min",
        mm: "%d min",
        h: "1 hr",
        hh: "%d hrs",
        d: "1 d",
        dd: "%d d",
        M: "1 mo",
        MM: "%d mo",
        y: "1 yr",
        yy: "%d yr"
    }
};
(0, (/*@__PURE__*/$parcel$interopDefault($l3Lpn))).locale("en-web3-modal", $3e1bea756c01c936$var$localeObject);
const $3e1bea756c01c936$export$9b575f14aa5e09a1 = {
    getYear (date = new Date().toISOString()) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($l3Lpn)))(date).year();
    },
    getRelativeDateFromNow (date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($l3Lpn)))(date).locale("en-web3-modal").fromNow(true);
    },
    formatDate (date, format = "DD MMM") {
        return (0, (/*@__PURE__*/$parcel$interopDefault($l3Lpn)))(date).format(format);
    }
};

});
parcelRegister("l3Lpn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("fGGR8", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(e) {
            var n = [
                "th",
                "st",
                "nd",
                "rd"
            ], t = e % 100;
            return "[" + e + (n[(t - 20) % 10] || n[t] || n[0]) + "]";
        }
    };
});

});

parcelRegister("iwdJC", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});

parcelRegister("eQCpb", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return function(e, n, t) {
        t.updateLocale = function(e, n) {
            var o = t.Ls[e];
            if (o) return (n ? Object.keys(n) : []).forEach(function(e) {
                o[e] = n[e];
            }), o;
        };
    };
});

});


parcelRegister("1yWTt", function(module, exports) {

$parcel$export(module.exports, "NetworkUtil", function () { return $1236a67ad2e12bec$export$79d00c05833eff69; });
const $1236a67ad2e12bec$export$79d00c05833eff69 = {
    caipNetworkIdToNumber (caipnetworkId) {
        return caipnetworkId ? Number(caipnetworkId.split(":")[1]) : undefined;
    },
    parseEvmChainId (chainId) {
        return typeof chainId === "string" ? this.caipNetworkIdToNumber(chainId) : chainId;
    }
};

});

parcelRegister("l2EhC", function(module, exports) {

$parcel$export(module.exports, "NumberUtil", function () { return $f519084ca3c194a5$export$be098d443162b0ca; });

var $b40il = parcelRequire("b40il");
const $f519084ca3c194a5$export$be098d443162b0ca = {
    bigNumber (value) {
        return new $b40il.BigNumber(value);
    },
    multiply (a, b) {
        if (a === undefined || b === undefined) return $b40il.BigNumber(0);
        const aBigNumber = new $b40il.BigNumber(a);
        const bBigNumber = new $b40il.BigNumber(b);
        return aBigNumber.multipliedBy(bBigNumber);
    },
    formatNumberToLocalString (value, decimals = 2) {
        if (value === undefined) return "0.00";
        if (typeof value === "number") return value.toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
        return parseFloat(value).toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
    }
};

});
parcelRegister("b40il", function(module, exports) {

$parcel$export(module.exports, "BigNumber", function () { return $076bbd81bbc6d5ed$export$d97aa349ed20696; });
/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var $076bbd81bbc6d5ed$var$isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $076bbd81bbc6d5ed$var$mathceil = Math.ceil, $076bbd81bbc6d5ed$var$mathfloor = Math.floor, $076bbd81bbc6d5ed$var$bignumberError = "[BigNumber Error] ", $076bbd81bbc6d5ed$var$tooManyDigits = $076bbd81bbc6d5ed$var$bignumberError + "Number primitive has more than 15 significant digits: ", $076bbd81bbc6d5ed$var$BASE = 1e14, $076bbd81bbc6d5ed$var$LOG_BASE = 14, $076bbd81bbc6d5ed$var$MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
$076bbd81bbc6d5ed$var$POWS_TEN = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $076bbd81bbc6d5ed$var$SQRT_BASE = 1e7, // EDITABLE
// The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
// the arguments to toExponential, toFixed, toFormat, and toPrecision.
$076bbd81bbc6d5ed$var$MAX = 1E9; // 0 to MAX_INT32
/*
 * Create and return a BigNumber constructor.
 */ function $076bbd81bbc6d5ed$var$clone(configObject) {
    var div, convertBase, parseNumeric, P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
    }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.
    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: "\xa0",
        suffix: ""
    }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
    //------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */ function BigNumber(v, b) {
        var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
        // Enable constructor call without `new`.
        if (!(x instanceof BigNumber)) return new BigNumber(v, b);
        if (b == null) {
            if (v && v._isBigNumber === true) {
                x.s = v.s;
                if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                else if (v.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
                else {
                    x.e = v.e;
                    x.c = v.c.slice();
                }
                return;
            }
            if ((isNum = typeof v == "number") && v * 0 == 0) {
                // Use `1 / n` to handle minus zero also.
                x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                // Fast path for integers, where n < 2147483648 (2**31).
                if (v === ~~v) {
                    for(e = 0, i = v; i >= 10; i /= 10, e++);
                    if (e > MAX_EXP) x.c = x.e = null;
                    else {
                        x.e = e;
                        x.c = [
                            v
                        ];
                    }
                    return;
                }
                str = String(v);
            } else {
                if (!$076bbd81bbc6d5ed$var$isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
            }
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
        } else {
            // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
            $076bbd81bbc6d5ed$var$intCheck(b, 2, ALPHABET.length, "Base");
            // Allow exponential notation to be used with base 10 argument, while
            // also rounding to DECIMAL_PLACES as with other bases.
            if (b == 10 && alphabetHasNormalDecimalDigits) {
                x = new BigNumber(v);
                return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
            }
            str = String(v);
            if (isNum = typeof v == "number") {
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error($076bbd81bbc6d5ed$var$tooManyDigits + v);
            } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
            alphabet = ALPHABET.slice(0, b);
            e = i = 0;
            // Check that str is a valid base b number.
            // Don't use RegExp, so alphabet can contain special characters.
            for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                if (c == ".") // If '.' is not the first character and it has not be found before.
                {
                    if (i > e) {
                        e = len;
                        continue;
                    }
                } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                {
                    if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                        caseChanged = true;
                        i = -1;
                        e = 0;
                        continue;
                    }
                }
                return parseNumeric(x, String(v), isNum, b);
            }
            // Prevent later check for length on converted number.
            isNum = false;
            str = convertBase(str, b, 10, x.s);
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            else e = str.length;
        }
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(--len) === 48;);
        if (str = str.slice(i, ++len)) {
            len -= i;
            // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
            if (isNum && BigNumber.DEBUG && len > 15 && (v > $076bbd81bbc6d5ed$var$MAX_SAFE_INTEGER || v !== $076bbd81bbc6d5ed$var$mathfloor(v))) throw Error($076bbd81bbc6d5ed$var$tooManyDigits + x.s * v);
            // Overflow?
            if ((e = e - i - 1) > MAX_EXP) // Infinity.
            x.c = x.e = null;
            else if (e < MIN_EXP) // Zero.
            x.c = [
                x.e = 0
            ];
            else {
                x.e = e;
                x.c = [];
                // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first element of the coefficient array.
                i = (e + 1) % $076bbd81bbc6d5ed$var$LOG_BASE;
                if (e < 0) i += $076bbd81bbc6d5ed$var$LOG_BASE; // i < 1
                if (i < len) {
                    if (i) x.c.push(+str.slice(0, i));
                    for(len -= $076bbd81bbc6d5ed$var$LOG_BASE; i < len;)x.c.push(+str.slice(i, i += $076bbd81bbc6d5ed$var$LOG_BASE));
                    i = $076bbd81bbc6d5ed$var$LOG_BASE - (str = str.slice(i)).length;
                } else i -= len;
                for(; i--; str += "0");
                x.c.push(+str);
            }
        } else // Zero.
        x.c = [
            x.e = 0
        ];
    }
    // CONSTRUCTOR PROPERTIES
    BigNumber.clone = $076bbd81bbc6d5ed$var$clone;
    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;
    /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */ BigNumber.config = BigNumber.set = function(obj) {
        var p, v;
        if (obj != null) {
            if (typeof obj == "object") {
                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                    v = obj[p];
                    $076bbd81bbc6d5ed$var$intCheck(v, 0, $076bbd81bbc6d5ed$var$MAX, p);
                    DECIMAL_PLACES = v;
                }
                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                    v = obj[p];
                    $076bbd81bbc6d5ed$var$intCheck(v, 0, 8, p);
                    ROUNDING_MODE = v;
                }
                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or
                // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $076bbd81bbc6d5ed$var$intCheck(v[0], -$076bbd81bbc6d5ed$var$MAX, 0, p);
                        $076bbd81bbc6d5ed$var$intCheck(v[1], 0, $076bbd81bbc6d5ed$var$MAX, p);
                        TO_EXP_NEG = v[0];
                        TO_EXP_POS = v[1];
                    } else {
                        $076bbd81bbc6d5ed$var$intCheck(v, -$076bbd81bbc6d5ed$var$MAX, $076bbd81bbc6d5ed$var$MAX, p);
                        TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                    }
                }
                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                if (obj.hasOwnProperty(p = "RANGE")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $076bbd81bbc6d5ed$var$intCheck(v[0], -$076bbd81bbc6d5ed$var$MAX, -1, p);
                        $076bbd81bbc6d5ed$var$intCheck(v[1], 1, $076bbd81bbc6d5ed$var$MAX, p);
                        MIN_EXP = v[0];
                        MAX_EXP = v[1];
                    } else {
                        $076bbd81bbc6d5ed$var$intCheck(v, -$076bbd81bbc6d5ed$var$MAX, $076bbd81bbc6d5ed$var$MAX, p);
                        if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                        else throw Error($076bbd81bbc6d5ed$var$bignumberError + p + " cannot be zero: " + v);
                    }
                }
                // CRYPTO {boolean} true or false.
                // '[BigNumber Error] CRYPTO not true or false: {v}'
                // '[BigNumber Error] crypto unavailable'
                if (obj.hasOwnProperty(p = "CRYPTO")) {
                    v = obj[p];
                    if (v === !!v) {
                        if (v) {
                            if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                            else {
                                CRYPTO = !v;
                                throw Error($076bbd81bbc6d5ed$var$bignumberError + "crypto unavailable");
                            }
                        } else CRYPTO = v;
                    } else throw Error($076bbd81bbc6d5ed$var$bignumberError + p + " not true or false: " + v);
                }
                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                    v = obj[p];
                    $076bbd81bbc6d5ed$var$intCheck(v, 0, 9, p);
                    MODULO_MODE = v;
                }
                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                    v = obj[p];
                    $076bbd81bbc6d5ed$var$intCheck(v, 0, $076bbd81bbc6d5ed$var$MAX, p);
                    POW_PRECISION = v;
                }
                // FORMAT {object}
                // '[BigNumber Error] FORMAT not an object: {v}'
                if (obj.hasOwnProperty(p = "FORMAT")) {
                    v = obj[p];
                    if (typeof v == "object") FORMAT = v;
                    else throw Error($076bbd81bbc6d5ed$var$bignumberError + p + " not an object: " + v);
                }
                // ALPHABET {string}
                // '[BigNumber Error] ALPHABET invalid: {v}'
                if (obj.hasOwnProperty(p = "ALPHABET")) {
                    v = obj[p];
                    // Disallow if less than two characters,
                    // or if it contains '+', '-', '.', whitespace, or a repeated character.
                    if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                        alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                        ALPHABET = v;
                    } else throw Error($076bbd81bbc6d5ed$var$bignumberError + p + " invalid: " + v);
                }
            } else // '[BigNumber Error] Object expected: {v}'
            throw Error($076bbd81bbc6d5ed$var$bignumberError + "Object expected: " + obj);
        }
        return {
            DECIMAL_PLACES: DECIMAL_PLACES,
            ROUNDING_MODE: ROUNDING_MODE,
            EXPONENTIAL_AT: [
                TO_EXP_NEG,
                TO_EXP_POS
            ],
            RANGE: [
                MIN_EXP,
                MAX_EXP
            ],
            CRYPTO: CRYPTO,
            MODULO_MODE: MODULO_MODE,
            POW_PRECISION: POW_PRECISION,
            FORMAT: FORMAT,
            ALPHABET: ALPHABET
        };
    };
    /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */ BigNumber.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i, n, c = v.c, e = v.e, s = v.s;
        out: if (({}).toString.call(c) == "[object Array]") {
            if ((s === 1 || s === -1) && e >= -$076bbd81bbc6d5ed$var$MAX && e <= $076bbd81bbc6d5ed$var$MAX && e === $076bbd81bbc6d5ed$var$mathfloor(e)) {
                // If the first element is zero, the BigNumber value must be zero.
                if (c[0] === 0) {
                    if (e === 0 && c.length === 1) return true;
                    break out;
                }
                // Calculate number of digits that c[0] should have, based on the exponent.
                i = (e + 1) % $076bbd81bbc6d5ed$var$LOG_BASE;
                if (i < 1) i += $076bbd81bbc6d5ed$var$LOG_BASE;
                // Calculate number of digits of c[0].
                //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                if (String(c[0]).length == i) {
                    for(i = 0; i < c.length; i++){
                        n = c[i];
                        if (n < 0 || n >= $076bbd81bbc6d5ed$var$BASE || n !== $076bbd81bbc6d5ed$var$mathfloor(n)) break out;
                    }
                    // Last element cannot be zero, unless it is the only element.
                    if (n !== 0) return true;
                }
            }
        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
        throw Error($076bbd81bbc6d5ed$var$bignumberError + "Invalid BigNumber: " + v);
    };
    /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.maximum = BigNumber.max = function() {
        return maxOrMin(arguments, -1);
    };
    /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.minimum = BigNumber.min = function() {
        return maxOrMin(arguments, 1);
    };
    /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */ BigNumber.random = function() {
        var pow2_53 = 0x20000000000000;
        // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
            return $076bbd81bbc6d5ed$var$mathfloor(Math.random() * pow2_53);
        } : function() {
            return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function(dp) {
            var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
            if (dp == null) dp = DECIMAL_PLACES;
            else $076bbd81bbc6d5ed$var$intCheck(dp, 0, $076bbd81bbc6d5ed$var$MAX);
            k = $076bbd81bbc6d5ed$var$mathceil(dp / $076bbd81bbc6d5ed$var$LOG_BASE);
            if (CRYPTO) {
                // Browsers supporting crypto.getRandomValues.
                if (crypto.getRandomValues) {
                    a = crypto.getRandomValues(new Uint32Array(k *= 2));
                    for(; i < k;){
                        // 53 bits:
                        // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                        // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                        // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                        //                                     11111 11111111 11111111
                        // 0x20000 is 2^21.
                        v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                        // Rejection sampling:
                        // 0 <= v < 9007199254740992
                        // Probability that v >= 9e15, is
                        // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                        if (v >= 9e15) {
                            b = crypto.getRandomValues(new Uint32Array(2));
                            a[i] = b[0];
                            a[i + 1] = b[1];
                        } else {
                            // 0 <= v <= 8999999999999999
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 2;
                        }
                    }
                    i = k / 2;
                // Node.js supporting crypto.randomBytes.
                } else if (crypto.randomBytes) {
                    // buffer
                    a = crypto.randomBytes(k *= 7);
                    for(; i < k;){
                        // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                        // 0x100000000 is 2^32, 0x1000000 is 2^24
                        // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                        // 0 <= v < 9007199254740992
                        v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                        if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                        else {
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 7;
                        }
                    }
                    i = k / 7;
                } else {
                    CRYPTO = false;
                    throw Error($076bbd81bbc6d5ed$var$bignumberError + "crypto unavailable");
                }
            }
            // Use Math.random.
            if (!CRYPTO) for(; i < k;){
                v = random53bitInt();
                if (v < 9e15) c[i++] = v % 1e14;
            }
            k = c[--i];
            dp %= $076bbd81bbc6d5ed$var$LOG_BASE;
            // Convert trailing digits to zeros according to dp.
            if (k && dp) {
                v = $076bbd81bbc6d5ed$var$POWS_TEN[$076bbd81bbc6d5ed$var$LOG_BASE - dp];
                c[i] = $076bbd81bbc6d5ed$var$mathfloor(k / v) * v;
            }
            // Remove trailing elements which are zero.
            for(; c[i] === 0; c.pop(), i--);
            // Zero?
            if (i < 0) c = [
                e = 0
            ];
            else {
                // Remove leading elements which are zero and adjust exponent accordingly.
                for(e = -1; c[0] === 0; c.splice(0, 1), e -= $076bbd81bbc6d5ed$var$LOG_BASE);
                // Count the digits of the first element of c to determine leading zeros, and...
                for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                // adjust the exponent accordingly.
                if (i < $076bbd81bbc6d5ed$var$LOG_BASE) e -= $076bbd81bbc6d5ed$var$LOG_BASE - i;
            }
            rand.e = e;
            rand.c = c;
            return rand;
        };
    }();
    /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber(args[0]);
        for(; i < args.length;)sum = sum.plus(args[i++]);
        return sum;
    };
    // PRIVATE FUNCTIONS
    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = function() {
        var decimal = "0123456789";
        /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut, alphabet) {
            var j, arr = [
                0
            ], arrL, i = 0, len = str.length;
            for(; i < len;){
                for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                arr[0] += alphabet.indexOf(str.charAt(i++));
                for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] == null) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
            return arr.reverse();
        }
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.
        return function(str, baseIn, baseOut, sign, callerIsToString) {
            var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace(".", "");
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut($076bbd81bbc6d5ed$var$toFixedPoint($076bbd81bbc6d5ed$var$coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
            // xc now represents str as an integer and converted to baseOut. e is the exponent.
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            // Zero?
            if (!xc[0]) return alphabet.charAt(0);
            // Does str represent an integer? If so, no need for the division.
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // The sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            // xc now represents str converted to baseOut.
            // THe index of the rounding digit.
            d = e + dp + 1;
            // The rounding digit: the digit to the right of the digit that may be rounded up.
            i = xc[d];
            // Look at the rounding digits and mode to determine whether to round up.
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            // If the index of the rounding digit is not greater than zero, or xc represents
            // zero, then the result of the base conversion is zero or, if rounding up, a value
            // such as 0.00001.
            if (d < 1 || !xc[0]) // 1^-dp or 0
            str = r ? $076bbd81bbc6d5ed$var$toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
            else {
                // Truncate xc to the required number of decimal places.
                xc.length = d;
                // Round up?
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                // Add leading zeros, decimal point and trailing zeros as required.
                str = $076bbd81bbc6d5ed$var$toFixedPoint(str, e, alphabet.charAt(0));
            }
            // The caller will add the sign.
            return str;
        };
    }();
    // Perform division in the specified base. Called by div and convertBase.
    div = function() {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
            var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % $076bbd81bbc6d5ed$var$SQRT_BASE, khi = k / $076bbd81bbc6d5ed$var$SQRT_BASE | 0;
            for(x = x.slice(); i--;){
                xlo = x[i] % $076bbd81bbc6d5ed$var$SQRT_BASE;
                xhi = x[i] / $076bbd81bbc6d5ed$var$SQRT_BASE | 0;
                m = khi * xlo + xhi * klo;
                temp = klo * xlo + m % $076bbd81bbc6d5ed$var$SQRT_BASE * $076bbd81bbc6d5ed$var$SQRT_BASE + carry;
                carry = (temp / base | 0) + (m / $076bbd81bbc6d5ed$var$SQRT_BASE | 0) + khi * xhi;
                x[i] = temp % base;
            }
            if (carry) x = [
                carry
            ].concat(x);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, cmp;
            if (aL != bL) cmp = aL > bL ? 1 : -1;
            else {
                for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                    cmp = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return cmp;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1; a.splice(0, 1));
        }
        // x: dividend, y: divisor.
        return function(x, y, dp, rm, base) {
            var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
            // Either NaN, Infinity or 0?
            if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
            q = new BigNumber(s);
            qc = q.c = [];
            e = x.e - y.e;
            s = dp + e + 1;
            if (!base) {
                base = $076bbd81bbc6d5ed$var$BASE;
                e = $076bbd81bbc6d5ed$var$bitFloor(x.e / $076bbd81bbc6d5ed$var$LOG_BASE) - $076bbd81bbc6d5ed$var$bitFloor(y.e / $076bbd81bbc6d5ed$var$LOG_BASE);
                s = s / $076bbd81bbc6d5ed$var$LOG_BASE | 0;
            }
            // Result exponent may be one less then the current value of e.
            // The coefficients of the BigNumbers from convertBase may have trailing zeros.
            for(i = 0; yc[i] == (xc[i] || 0); i++);
            if (yc[i] > (xc[i] || 0)) e--;
            if (s < 0) {
                qc.push(1);
                more = true;
            } else {
                xL = xc.length;
                yL = yc.length;
                i = 0;
                s += 2;
                // Normalise xc and yc so highest order digit of yc is >= base / 2.
                n = $076bbd81bbc6d5ed$var$mathfloor(base / (yc[0] + 1));
                // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                if (n > 1) {
                    yc = multiply(yc, n, base);
                    xc = multiply(xc, n, base);
                    yL = yc.length;
                    xL = xc.length;
                }
                xi = yL;
                rem = xc.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL; rem[remL++] = 0);
                yz = yc.slice();
                yz = [
                    0
                ].concat(yz);
                yc0 = yc[0];
                if (yc[1] >= base / 2) yc0++;
                // Not necessary, but to prevent trial digit n > base, when using base 3.
                // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                do {
                    n = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yc, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, n.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // n is how many times the divisor goes into the current remainder.
                        n = $076bbd81bbc6d5ed$var$mathfloor(rem0 / yc0);
                        //  Algorithm:
                        //  product = divisor multiplied by trial digit (n).
                        //  Compare product and remainder.
                        //  If product is greater than remainder:
                        //    Subtract divisor from product, decrement trial digit.
                        //  Subtract product from remainder.
                        //  If product was less than remainder at the last compare:
                        //    Compare new remainder and divisor.
                        //    If remainder is greater than divisor:
                        //      Subtract divisor from remainder, increment trial digit.
                        if (n > 1) {
                            // n may be > base only when base is 3.
                            if (n >= base) n = base - 1;
                            // product = divisor * trial digit.
                            prod = multiply(yc, n, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            // If product > remainder then trial digit n too high.
                            // n is 1 too high about 5% of the time, and is not known to have
                            // ever been more than 1 too high.
                            while(compare(prod, rem, prodL, remL) == 1){
                                n--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                prodL = prod.length;
                                cmp = 1;
                            }
                        } else {
                            // n is 0 or 1, cmp is -1.
                            // If n is 0, there is no need to compare yc and rem again below,
                            // so change cmp to 1 to avoid it.
                            // If n is 1, leave cmp as -1, so yc and rem are compared again.
                            if (n == 0) // divisor < remainder, so n must be at least 1.
                            cmp = n = 1;
                            // product = divisor
                            prod = yc.slice();
                            prodL = prod.length;
                        }
                        if (prodL < remL) prod = [
                            0
                        ].concat(prod);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        remL = rem.length;
                        // If product was < remainder.
                        if (cmp == -1) // Compare divisor and new remainder.
                        // If divisor < new remainder, subtract divisor from remainder.
                        // Trial digit n too low.
                        // n is 1 too low about 5% of the time, and very rarely 2 too low.
                        while(compare(yc, rem, yL, remL) < 1){
                            n++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yc, remL, base);
                            remL = rem.length;
                        }
                    } else if (cmp === 0) {
                        n++;
                        rem = [
                            0
                        ];
                    } // else cmp === 1 and n will be 0
                    // Add the next digit, n, to the result array.
                    qc[i++] = n;
                    // Update the remainder.
                    if (rem[0]) rem[remL++] = xc[xi] || 0;
                    else {
                        rem = [
                            xc[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] != null) && s--);
                more = rem[0] != null;
                // Leading zero?
                if (!qc[0]) qc.splice(0, 1);
            }
            if (base == $076bbd81bbc6d5ed$var$BASE) {
                // To calculate q.e, first get the number of digits of qc[0].
                for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                round(q, dp + (q.e = i + e * $076bbd81bbc6d5ed$var$LOG_BASE - 1) + 1, rm, more);
            // Caller is convertBase.
            } else {
                q.e = e;
                q.r = +more;
            }
            return q;
        };
    }();
    /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */ function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;
        else $076bbd81bbc6d5ed$var$intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;
        if (i == null) {
            str = $076bbd81bbc6d5ed$var$coeffToString(n.c);
            str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? $076bbd81bbc6d5ed$var$toExponential(str, ne) : $076bbd81bbc6d5ed$var$toFixedPoint(str, ne, "0");
        } else {
            n = round(new BigNumber(n), i, rm);
            // n.e may have changed if the value was rounded up.
            e = n.e;
            str = $076bbd81bbc6d5ed$var$coeffToString(n.c);
            len = str.length;
            // toPrecision returns exponential notation if the number of significant digits
            // specified is less than the number of digits necessary to represent the integer
            // part of the value in fixed-point notation.
            // Exponential notation.
            if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                // Append zeros?
                for(; len < i; str += "0", len++);
                str = $076bbd81bbc6d5ed$var$toExponential(str, e);
            // Fixed-point notation.
            } else {
                i -= ne;
                str = $076bbd81bbc6d5ed$var$toFixedPoint(str, e, "0");
                // Append zeros?
                if (e + 1 > len) {
                    if (--i > 0) for(str += "."; i--; str += "0");
                } else {
                    i += e - len;
                    if (i > 0) {
                        if (e + 1 == len) str += ".";
                        for(; i--; str += "0");
                    }
                }
            }
        }
        return n.s < 0 && c0 ? "-" + str : str;
    }
    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber(args[0]);
        for(; i < args.length; i++){
            y = new BigNumber(args[i]);
            if (!y.s || (k = $076bbd81bbc6d5ed$var$compare(x, y)) === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */ function normalise(n, c, e) {
        var i = 1, j = c.length;
        // Remove trailing zeros.
        for(; !c[--j]; c.pop());
        // Calculate the base 10 exponent. First get the number of digits of c[0].
        for(j = c[0]; j >= 10; j /= 10, i++);
        // Overflow?
        if ((e = i + e * $076bbd81bbc6d5ed$var$LOG_BASE - 1) > MAX_EXP) // Infinity.
        n.c = n.e = null;
        else if (e < MIN_EXP) // Zero.
        n.c = [
            n.e = 0
        ];
        else {
            n.e = e;
            n.c = c;
        }
        return n;
    }
    // Handle values that fail the validity test in BigNumber.
    parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b) {
            var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
            // No exception on ±Infinity or NaN.
            if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
            else {
                if (!isNum) {
                    // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                    s = s.replace(basePrefix, function(m, p1, p2) {
                        base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                        return !b || b == base ? p1 : m;
                    });
                    if (b) {
                        base = b;
                        // E.g. '1.' to '1', '.1' to '0.1'
                        s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                    }
                    if (str != s) return new BigNumber(s, base);
                }
                // '[BigNumber Error] Not a number: {n}'
                // '[BigNumber Error] Not a base {b} number: {n}'
                if (BigNumber.DEBUG) throw Error($076bbd81bbc6d5ed$var$bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                // NaN
                x.s = null;
            }
            x.c = x.e = null;
        };
    }();
    /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */ function round(x, sd, rm, r) {
        var d, i, j, k, n, ni, rd, xc = x.c, pows10 = $076bbd81bbc6d5ed$var$POWS_TEN;
        // if x is not Infinity or NaN...
        if (xc) {
            // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
            // n is a base 1e14 number, the value of the element of array x.c containing rd.
            // ni is the index of n within x.c.
            // d is the number of digits of n.
            // i is the index of rd within n including leading zeros.
            // j is the actual index of rd within n (if < 0, rd is a leading zero).
            out: {
                // Get the number of digits of the first element of xc.
                for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                i = sd - d;
                // If the rounding digit is in the first element of xc...
                if (i < 0) {
                    i += $076bbd81bbc6d5ed$var$LOG_BASE;
                    j = sd;
                    n = xc[ni = 0];
                    // Get the rounding digit at index j of n.
                    rd = $076bbd81bbc6d5ed$var$mathfloor(n / pows10[d - j - 1] % 10);
                } else {
                    ni = $076bbd81bbc6d5ed$var$mathceil((i + 1) / $076bbd81bbc6d5ed$var$LOG_BASE);
                    if (ni >= xc.length) {
                        if (r) {
                            // Needed by sqrt.
                            for(; xc.length <= ni; xc.push(0));
                            n = rd = 0;
                            d = 1;
                            i %= $076bbd81bbc6d5ed$var$LOG_BASE;
                            j = i - $076bbd81bbc6d5ed$var$LOG_BASE + 1;
                        } else break out;
                    } else {
                        n = k = xc[ni];
                        // Get the number of digits of n.
                        for(d = 1; k >= 10; k /= 10, d++);
                        // Get the index of rd within n.
                        i %= $076bbd81bbc6d5ed$var$LOG_BASE;
                        // Get the index of rd within n, adjusted for leading zeros.
                        // The number of leading zeros of n is given by LOG_BASE - d.
                        j = i - $076bbd81bbc6d5ed$var$LOG_BASE + d;
                        // Get the rounding digit at index j of n.
                        rd = j < 0 ? 0 : $076bbd81bbc6d5ed$var$mathfloor(n / pows10[d - j - 1] % 10);
                    }
                }
                r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                if (sd < 1 || !xc[0]) {
                    xc.length = 0;
                    if (r) {
                        // Convert sd to decimal places.
                        sd -= x.e + 1;
                        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                        xc[0] = pows10[($076bbd81bbc6d5ed$var$LOG_BASE - sd % $076bbd81bbc6d5ed$var$LOG_BASE) % $076bbd81bbc6d5ed$var$LOG_BASE];
                        x.e = -sd || 0;
                    } else // Zero.
                    xc[0] = x.e = 0;
                    return x;
                }
                // Remove excess digits.
                if (i == 0) {
                    xc.length = ni;
                    k = 1;
                    ni--;
                } else {
                    xc.length = ni + 1;
                    k = pows10[$076bbd81bbc6d5ed$var$LOG_BASE - i];
                    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                    // j > 0 means i > number of leading zeros of n.
                    xc[ni] = j > 0 ? $076bbd81bbc6d5ed$var$mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                }
                // Round up?
                if (r) {
                    for(;;)// If the digit to be rounded up is in the first element of xc...
                    if (ni == 0) {
                        // i will be the length of xc[0] before k is added.
                        for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                        j = xc[0] += k;
                        for(k = 1; j >= 10; j /= 10, k++);
                        // if i != k the length has increased.
                        if (i != k) {
                            x.e++;
                            if (xc[0] == $076bbd81bbc6d5ed$var$BASE) xc[0] = 1;
                        }
                        break;
                    } else {
                        xc[ni] += k;
                        if (xc[ni] != $076bbd81bbc6d5ed$var$BASE) break;
                        xc[ni--] = 0;
                        k = 1;
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; xc[--i] === 0; xc.pop());
            }
            // Overflow? Infinity.
            if (x.e > MAX_EXP) x.c = x.e = null;
            else if (x.e < MIN_EXP) x.c = [
                x.e = 0
            ];
        }
        return x;
    }
    function valueOf(n) {
        var str, e = n.e;
        if (e === null) return n.toString();
        str = $076bbd81bbc6d5ed$var$coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $076bbd81bbc6d5ed$var$toExponential(str, e) : $076bbd81bbc6d5ed$var$toFixedPoint(str, e, "0");
        return n.s < 0 ? "-" + str : str;
    }
    // PROTOTYPE/INSTANCE METHODS
    /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */ P.absoluteValue = P.abs = function() {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */ P.comparedTo = function(y, b) {
        return $076bbd81bbc6d5ed$var$compare(this, new BigNumber(y, b));
    };
    /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.decimalPlaces = P.dp = function(dp, rm) {
        var c, n, v, x = this;
        if (dp != null) {
            $076bbd81bbc6d5ed$var$intCheck(dp, 0, $076bbd81bbc6d5ed$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $076bbd81bbc6d5ed$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), dp + x.e + 1, rm);
        }
        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - $076bbd81bbc6d5ed$var$bitFloor(this.e / $076bbd81bbc6d5ed$var$LOG_BASE)) * $076bbd81bbc6d5ed$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last number.
        if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.dividedBy = P.div = function(y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };
    /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */ P.dividedToIntegerBy = P.idiv = function(y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
    };
    /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */ P.exponentiatedBy = P.pow = function(n, m) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber(n);
        // Allow NaN and ±Infinity, but not other non-integers.
        if (n.c && !n.isInteger()) throw Error($076bbd81bbc6d5ed$var$bignumberError + "Exponent not an integer: " + valueOf(n));
        if (m != null) m = new BigNumber(m);
        // Exponent of MAX_SAFE_INTEGER is 15.
        nIsBig = n.e > 14;
        // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
            // The sign of the result of pow when x is negative depends on the evenness of n.
            // If +n overflows to ±Infinity, the evenness of n would be not be known.
            y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - $076bbd81bbc6d5ed$var$isOdd(n)) : +valueOf(n)));
            return m ? y.mod(m) : y;
        }
        nIsNeg = n.s < 0;
        if (m) {
            // x % m returns NaN if abs(m) is zero, or m is NaN.
            if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
            isModExp = !nIsNeg && x.isInteger() && m.isInteger();
            if (isModExp) x = x.mod(m);
        // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
        // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
            // If x is negative and n is odd, k = -0, else k = 0.
            k = x.s < 0 && $076bbd81bbc6d5ed$var$isOdd(n) ? -0 : 0;
            // If x >= 1, k = ±Infinity.
            if (x.e > -1) k = 1 / k;
            // If n is negative return ±0, else return ±Infinity.
            return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = $076bbd81bbc6d5ed$var$mathceil(POW_PRECISION / $076bbd81bbc6d5ed$var$LOG_BASE + 2);
        if (nIsBig) {
            half = new BigNumber(0.5);
            if (nIsNeg) n.s = 1;
            nIsOdd = $076bbd81bbc6d5ed$var$isOdd(n);
        } else {
            i = Math.abs(+valueOf(n));
            nIsOdd = i % 2;
        }
        y = new BigNumber(ONE);
        // Performs 54 loop iterations for n of 9007199254740991.
        for(;;){
            if (nIsOdd) {
                y = y.times(x);
                if (!y.c) break;
                if (k) {
                    if (y.c.length > k) y.c.length = k;
                } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
            if (i) {
                i = $076bbd81bbc6d5ed$var$mathfloor(i / 2);
                if (i === 0) break;
                nIsOdd = i % 2;
            } else {
                n = n.times(half);
                round(n, n.e + 1, 1);
                if (n.e > 14) nIsOdd = $076bbd81bbc6d5ed$var$isOdd(n);
                else {
                    i = +valueOf(n);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                }
            }
            x = x.times(x);
            if (k) {
                if (x.c && x.c.length > k) x.c.length = k;
            } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */ P.integerValue = function(rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;
        else $076bbd81bbc6d5ed$var$intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
    };
    /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isEqualTo = P.eq = function(y, b) {
        return $076bbd81bbc6d5ed$var$compare(this, new BigNumber(y, b)) === 0;
    };
    /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */ P.isFinite = function() {
        return !!this.c;
    };
    /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isGreaterThan = P.gt = function(y, b) {
        return $076bbd81bbc6d5ed$var$compare(this, new BigNumber(y, b)) > 0;
    };
    /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
        return (b = $076bbd81bbc6d5ed$var$compare(this, new BigNumber(y, b))) === 1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */ P.isInteger = function() {
        return !!this.c && $076bbd81bbc6d5ed$var$bitFloor(this.e / $076bbd81bbc6d5ed$var$LOG_BASE) > this.c.length - 2;
    };
    /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isLessThan = P.lt = function(y, b) {
        return $076bbd81bbc6d5ed$var$compare(this, new BigNumber(y, b)) < 0;
    };
    /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
        return (b = $076bbd81bbc6d5ed$var$compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */ P.isNegative = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */ P.isPositive = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */ P.isZero = function() {
        return !!this.c && this.c[0] == 0;
    };
    /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */ P.minus = function(y, b) {
        var i, j, t, xLTy, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xe = x.e / $076bbd81bbc6d5ed$var$LOG_BASE, ye = y.e / $076bbd81bbc6d5ed$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Either Infinity?
            if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
            // Either zero?
            if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
        }
        xe = $076bbd81bbc6d5ed$var$bitFloor(xe);
        ye = $076bbd81bbc6d5ed$var$bitFloor(ye);
        xc = xc.slice();
        // Determine which is the bigger number.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            // Prepend zeros to equalise exponents.
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        b = (j = yc.length) - (i = xc.length);
        // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
        if (b > 0) for(; b--; xc[i++] = 0);
        b = $076bbd81bbc6d5ed$var$BASE - 1;
        // Subtract yc from xc.
        for(; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = b);
                --xc[i];
                xc[j] += $076bbd81bbc6d5ed$var$BASE;
            }
            xc[j] -= yc[j];
        }
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] == 0; xc.splice(0, 1), --ye);
        // Zero?
        if (!xc[0]) {
            // Following IEEE 754 (2008) 6.3,
            // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
            y.s = ROUNDING_MODE == 3 ? -1 : 1;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.
        return normalise(y, xc, ye);
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */ P.modulo = P.mod = function(y, b) {
        var q, s, x = this;
        y = new BigNumber(y, b);
        // Return NaN if x is Infinity or NaN, or y is NaN or zero.
        if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
        else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
        if (MODULO_MODE == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // r = x - qy    where  0 <= r < abs(y)
            s = y.s;
            y.s = 1;
            q = div(x, y, 0, 3);
            y.s = s;
            q.s *= s;
        } else q = div(x, y, 0, MODULO_MODE);
        y = x.minus(q.times(y));
        // To match JavaScript %, ensure sign of zero is sign of dividend.
        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */ P.multipliedBy = P.times = function(y, b) {
        var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
        // Either NaN, ±Infinity or ±0?
        if (!xc || !yc || !xc[0] || !yc[0]) {
            // Return NaN if either is NaN, or one is 0 and the other is Infinity.
            if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
            else {
                y.s *= x.s;
                // Return ±Infinity if either is ±Infinity.
                if (!xc || !yc) y.c = y.e = null;
                else {
                    y.c = [
                        0
                    ];
                    y.e = 0;
                }
            }
            return y;
        }
        e = $076bbd81bbc6d5ed$var$bitFloor(x.e / $076bbd81bbc6d5ed$var$LOG_BASE) + $076bbd81bbc6d5ed$var$bitFloor(y.e / $076bbd81bbc6d5ed$var$LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        // Ensure xc points to longer array and xcL to its length.
        if (xcL < ycL) {
            zc = xc;
            xc = yc;
            yc = zc;
            i = xcL;
            xcL = ycL;
            ycL = i;
        }
        // Initialise the result array with zeros.
        for(i = xcL + ycL, zc = []; i--; zc.push(0));
        base = $076bbd81bbc6d5ed$var$BASE;
        sqrtBase = $076bbd81bbc6d5ed$var$SQRT_BASE;
        for(i = ycL; --i >= 0;){
            c = 0;
            ylo = yc[i] % sqrtBase;
            yhi = yc[i] / sqrtBase | 0;
            for(k = xcL, j = i + k; j > i;){
                xlo = xc[--k] % sqrtBase;
                xhi = xc[k] / sqrtBase | 0;
                m = yhi * xlo + xhi * ylo;
                xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                zc[j--] = xlo % base;
            }
            zc[j] = c;
        }
        if (c) ++e;
        else zc.splice(0, 1);
        return normalise(y, zc, e);
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */ P.negated = function() {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */ P.plus = function(y, b) {
        var t, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e / $076bbd81bbc6d5ed$var$LOG_BASE, ye = y.e / $076bbd81bbc6d5ed$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Return ±Infinity if either ±Infinity.
            if (!xc || !yc) return new BigNumber(a / 0);
            // Either zero?
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }
        xe = $076bbd81bbc6d5ed$var$bitFloor(xe);
        ye = $076bbd81bbc6d5ed$var$bitFloor(ye);
        xc = xc.slice();
        // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        a = xc.length;
        b = yc.length;
        // Point xc to the longer array, and b to the shorter length.
        if (a - b < 0) {
            t = yc;
            yc = xc;
            xc = t;
            b = a;
        }
        // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
        for(a = 0; b;){
            a = (xc[--b] = xc[b] + yc[b] + a) / $076bbd81bbc6d5ed$var$BASE | 0;
            xc[b] = $076bbd81bbc6d5ed$var$BASE === xc[b] ? 0 : xc[b] % $076bbd81bbc6d5ed$var$BASE;
        }
        if (a) {
            xc = [
                a
            ].concat(xc);
            ++ye;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible
        return normalise(y, xc, ye);
    };
    /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.precision = P.sd = function(sd, rm) {
        var c, n, v, x = this;
        if (sd != null && sd !== !!sd) {
            $076bbd81bbc6d5ed$var$intCheck(sd, 1, $076bbd81bbc6d5ed$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $076bbd81bbc6d5ed$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), sd, rm);
        }
        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * $076bbd81bbc6d5ed$var$LOG_BASE + 1;
        if (v = c[v]) {
            // Subtract the number of trailing zeros of the last element.
            for(; v % 10 == 0; v /= 10, n--);
            // Add the number of digits of the first element.
            for(v = c[0]; v >= 10; v /= 10, n++);
        }
        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */ P.shiftedBy = function(k) {
        $076bbd81bbc6d5ed$var$intCheck(k, -$076bbd81bbc6d5ed$var$MAX_SAFE_INTEGER, $076bbd81bbc6d5ed$var$MAX_SAFE_INTEGER);
        return this.times("1e" + k);
    };
    /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.squareRoot = P.sqrt = function() {
        var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        // Initial estimate.
        s = Math.sqrt(+valueOf(x));
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = $076bbd81bbc6d5ed$var$coeffToString(c);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(+n);
            e = $076bbd81bbc6d5ed$var$bitFloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new BigNumber(n);
        } else r = new BigNumber(s + "");
        // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.
        if (r.c[0]) {
            e = r.e;
            s = e + dp;
            if (s < 3) s = 0;
            // Newton-Raphson iteration.
            for(;;){
                t = r;
                r = half.times(t.plus(div(x, t, dp, 1)));
                if ($076bbd81bbc6d5ed$var$coeffToString(t.c).slice(0, s) === (n = $076bbd81bbc6d5ed$var$coeffToString(r.c)).slice(0, s)) {
                    // The exponent of r may here be one less than the final result exponent,
                    // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                    // are indexed correctly.
                    if (r.e < e) --s;
                    n = n.slice(s - 3, s + 1);
                    // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                    // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                    // iteration.
                    if (n == "9999" || !rep && n == "4999") {
                        // On the first iteration only, check to see if rounding up gives the
                        // exact result as the nines may infinitely repeat.
                        if (!rep) {
                            round(t, t.e + DECIMAL_PLACES + 2, 0);
                            if (t.times(t).eq(x)) {
                                r = t;
                                break;
                            }
                        }
                        dp += 4;
                        s += 4;
                        rep = 1;
                    } else {
                        // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                        // result. If not, then there are further digits and m will be truthy.
                        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                            // Truncate to the first rounding digit.
                            round(r, r.e + DECIMAL_PLACES + 2, 1);
                            m = !r.times(r).eq(x);
                        }
                        break;
                    }
                }
            }
        }
        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };
    /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toExponential = function(dp, rm) {
        if (dp != null) {
            $076bbd81bbc6d5ed$var$intCheck(dp, 0, $076bbd81bbc6d5ed$var$MAX);
            dp++;
        }
        return format(this, dp, rm, 1);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toFixed = function(dp, rm) {
        if (dp != null) {
            $076bbd81bbc6d5ed$var$intCheck(dp, 0, $076bbd81bbc6d5ed$var$MAX);
            dp = dp + this.e + 1;
        }
        return format(this, dp, rm);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */ P.toFormat = function(dp, rm, format) {
        var str, x = this;
        if (format == null) {
            if (dp != null && rm && typeof rm == "object") {
                format = rm;
                rm = null;
            } else if (dp && typeof dp == "object") {
                format = dp;
                dp = rm = null;
            } else format = FORMAT;
        } else if (typeof format != "object") throw Error($076bbd81bbc6d5ed$var$bignumberError + "Argument not an object: " + format);
        str = x.toFixed(dp, rm);
        if (x.c) {
            var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
            if (g2) {
                i = g1;
                g1 = g2;
                g2 = i;
                len -= i;
            }
            if (g1 > 0 && len > 0) {
                i = len % g1 || g1;
                intPart = intDigits.substr(0, i);
                for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                if (isNeg) intPart = "-" + intPart;
            }
            str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
        }
        return (format.prefix || "") + str + (format.suffix || "");
    };
    /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */ P.toFraction = function(md) {
        var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
            n = new BigNumber(md);
            // Throw if md is less than one or is not an integer, unless it is Infinity.
            if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error($076bbd81bbc6d5ed$var$bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
        }
        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = $076bbd81bbc6d5ed$var$coeffToString(xc);
        // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.
        e = d.e = s.length - x.e - 1;
        d.c[0] = $076bbd81bbc6d5ed$var$POWS_TEN[(exp = e % $076bbd81bbc6d5ed$var$LOG_BASE) < 0 ? $076bbd81bbc6d5ed$var$LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s);
        // n0 = d1 = 0
        n0.c[0] = 0;
        for(;;){
            q = div(n, d, 0, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.comparedTo(md) == 1) break;
            d0 = d1;
            d1 = d2;
            n1 = n0.plus(q.times(d2 = n1));
            n0 = d2;
            d = n.minus(q.times(d2 = d));
            n = d2;
        }
        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2;
        // Determine which fraction is closer to x, n0/d0 or n1/d1
        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        MAX_EXP = exp;
        return r;
    };
    /*
   * Return the value of this BigNumber converted to a number primitive.
   */ P.toNumber = function() {
        return +valueOf(this);
    };
    /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.toPrecision = function(sd, rm) {
        if (sd != null) $076bbd81bbc6d5ed$var$intCheck(sd, 1, $076bbd81bbc6d5ed$var$MAX);
        return format(this, sd, rm, 2);
    };
    /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */ P.toString = function(b) {
        var str, n = this, s = n.s, e = n.e;
        // Infinity or NaN?
        if (e === null) {
            if (s) {
                str = "Infinity";
                if (s < 0) str = "-" + str;
            } else str = "NaN";
        } else {
            if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $076bbd81bbc6d5ed$var$toExponential($076bbd81bbc6d5ed$var$coeffToString(n.c), e) : $076bbd81bbc6d5ed$var$toFixedPoint($076bbd81bbc6d5ed$var$coeffToString(n.c), e, "0");
            else if (b === 10 && alphabetHasNormalDecimalDigits) {
                n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                str = $076bbd81bbc6d5ed$var$toFixedPoint($076bbd81bbc6d5ed$var$coeffToString(n.c), n.e, "0");
            } else {
                $076bbd81bbc6d5ed$var$intCheck(b, 2, ALPHABET.length, "Base");
                str = convertBase($076bbd81bbc6d5ed$var$toFixedPoint($076bbd81bbc6d5ed$var$coeffToString(n.c), e, "0"), 10, b, s, true);
            }
            if (s < 0 && n.c[0]) str = "-" + str;
        }
        return str;
    };
    /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */ P.valueOf = P.toJSON = function() {
        return valueOf(this);
    };
    P._isBigNumber = true;
    P[Symbol.toStringTag] = "BigNumber";
    // Node.js v10.12.0+
    P[Symbol.for("nodejs.util.inspect.custom")] = P.valueOf;
    if (configObject != null) BigNumber.set(configObject);
    return BigNumber;
}
// PRIVATE HELPER FUNCTIONS
// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
function $076bbd81bbc6d5ed$var$bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
}
// Return a coefficient array as a string of base 10 digits.
function $076bbd81bbc6d5ed$var$coeffToString(a) {
    var s, z, i = 1, j = a.length, r = a[0] + "";
    for(; i < j;){
        s = a[i++] + "";
        z = $076bbd81bbc6d5ed$var$LOG_BASE - s.length;
        for(; z--; s = "0" + s);
        r += s;
    }
    // Determine trailing zeros.
    for(j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
}
// Compare the value of BigNumbers x and y.
function $076bbd81bbc6d5ed$var$compare(x, y) {
    var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0];
    b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    a = i < 0;
    b = k == l;
    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
}
/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */ function $076bbd81bbc6d5ed$var$intCheck(n, min, max, name) {
    if (n < min || n > max || n !== $076bbd81bbc6d5ed$var$mathfloor(n)) throw Error($076bbd81bbc6d5ed$var$bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
}
// Assumes finite n.
function $076bbd81bbc6d5ed$var$isOdd(n) {
    var k = n.c.length - 1;
    return $076bbd81bbc6d5ed$var$bitFloor(n.e / $076bbd81bbc6d5ed$var$LOG_BASE) == k && n.c[k] % 2 != 0;
}
function $076bbd81bbc6d5ed$var$toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
}
function $076bbd81bbc6d5ed$var$toFixedPoint(str, e, z) {
    var len, zs;
    // Negative exponent?
    if (e < 0) {
        // Prepend zeros.
        for(zs = z + "."; ++e; zs += z);
        str = zs + str;
    // Positive exponent
    } else {
        len = str.length;
        // Append zeros.
        if (++e > len) {
            for(zs = z, e -= len; --e; zs += z);
            str += zs;
        } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
    }
    return str;
}
var $076bbd81bbc6d5ed$export$d97aa349ed20696 = $076bbd81bbc6d5ed$var$clone();
var $076bbd81bbc6d5ed$export$2e2bcd8739ae039 = $076bbd81bbc6d5ed$export$d97aa349ed20696;

});


parcelRegister("4DADY", function(module, exports) {

$parcel$export(module.exports, "InputUtil", function () { return $36073aa358e06d27$export$14dd5e87e3c1b0c9; });
const $36073aa358e06d27$export$14dd5e87e3c1b0c9 = {
    numericInputKeyDown (event, currentValue, onChange) {
        const allowedKeys = [
            "Backspace",
            "Meta",
            "Ctrl",
            "a",
            "A",
            "c",
            "C",
            "x",
            "X",
            "v",
            "V",
            "ArrowLeft",
            "ArrowRight",
            "Tab"
        ];
        const controlPressed = event.metaKey || event.ctrlKey;
        const eventKey = event.key;
        const lowercaseEventKey = eventKey.toLocaleLowerCase();
        const selectAll = lowercaseEventKey === "a";
        const copyKey = lowercaseEventKey === "c";
        const pasteKey = lowercaseEventKey === "v";
        const cutKey = lowercaseEventKey === "x";
        const isComma = eventKey === ",";
        const isDot = eventKey === ".";
        const isNumericKey = eventKey >= "0" && eventKey <= "9";
        if (!controlPressed && (selectAll || copyKey || pasteKey || cutKey)) event.preventDefault();
        if (currentValue === "0" && !isComma && !isDot && eventKey === "0") event.preventDefault();
        if (currentValue === "0" && isNumericKey) {
            onChange(eventKey);
            event.preventDefault();
        }
        if (isComma || isDot) {
            if (!currentValue) {
                onChange("0.");
                event.preventDefault();
            }
            if (currentValue?.includes(".") || currentValue?.includes(",")) event.preventDefault();
        }
        if (!isNumericKey && !allowedKeys.includes(eventKey) && !isDot && !isComma) event.preventDefault();
    }
};

});

parcelRegister("bZ3oL", function(module, exports) {

$parcel$export(module.exports, "erc20ABI", function () { return $8b98070bcef99484$export$e125cdc2a458cf13; });
const $8b98070bcef99484$export$e125cdc2a458cf13 = [
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_spender",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_from",
                type: "address"
            },
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            },
            {
                name: "_spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        payable: true,
        stateMutability: "payable",
        type: "fallback"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    }
];

});

parcelRegister("jgvE4", function(module, exports) {

$parcel$export(module.exports, "NavigationUtil", function () { return $e0680f0ff5635dae$export$9dec99ba6a2a5c00; });
const $e0680f0ff5635dae$export$9dec99ba6a2a5c00 = {
    URLS: {
        FAQ: "https://walletconnect.com/faq"
    }
};

});

parcelRegister("1VCt9", function(module, exports) {

$parcel$export(module.exports, "ConstantsUtil", function () { return $1678f478a69e6848$export$aafe1f751f1bc52a; });
const $1678f478a69e6848$export$aafe1f751f1bc52a = {
    WC_NAME_SUFFIX: ".wcn.id",
    BLOCKCHAIN_API_RPC_URL: "https://rpc.walletconnect.org",
    PULSE_API_URL: "https://pulse.walletconnect.org",
    W3M_API_URL: "https://api.web3modal.org",
    CHAIN: {
        EVM: "evm",
        SOLANA: "solana"
    },
    CHAIN_NAME_MAP: {
        evm: "Ethereum",
        solana: "Solana"
    }
};

});

parcelRegister("5OPHH", function(module, exports) {

$parcel$export(module.exports, "getW3mThemeVariables", function () { return $43c9ba8f5805adce$export$5ab0d52f4d8873e4; });
function $43c9ba8f5805adce$export$5ab0d52f4d8873e4(themeVariables, themeType) {
    if (themeType === "light") return {
        "--w3m-accent": themeVariables?.["--w3m-accent"] || "hsla(231, 100%, 70%, 1)",
        "--w3m-background": "#fff"
    };
    return {
        "--w3m-accent": themeVariables?.["--w3m-accent"] || "hsla(230, 100%, 67%, 1)",
        "--w3m-background": "#121313"
    };
}

});


parcelRegister("6AwK8", function(module, exports) {

$parcel$export(module.exports, "ONRAMP_PROVIDERS", function () { return $4cbf80fee3472390$export$e021b4b4649620f6; });
$parcel$export(module.exports, "ConstantsUtil", function () { return $4cbf80fee3472390$export$aafe1f751f1bc52a; });
const $4cbf80fee3472390$var$SECURE_SITE = "https://secure.walletconnect.org";
const $4cbf80fee3472390$export$e021b4b4649620f6 = [
    {
        label: "Coinbase",
        name: "coinbase",
        feeRange: "1-2%",
        url: ""
    }
];
const $4cbf80fee3472390$export$aafe1f751f1bc52a = {
    FOUR_MINUTES_MS: 240000,
    TEN_SEC_MS: 10000,
    ONE_SEC_MS: 1000,
    SECURE_SITE: $4cbf80fee3472390$var$SECURE_SITE,
    SECURE_SITE_DASHBOARD: `${$4cbf80fee3472390$var$SECURE_SITE}/dashboard`,
    SECURE_SITE_FAVICON: `${$4cbf80fee3472390$var$SECURE_SITE}/images/favicon.png`,
    RESTRICTED_TIMEZONES: [
        "ASIA/SHANGHAI",
        "ASIA/URUMQI",
        "ASIA/CHONGQING",
        "ASIA/HARBIN",
        "ASIA/KASHGAR",
        "ASIA/MACAU",
        "ASIA/HONG_KONG",
        "ASIA/MACAO",
        "ASIA/BEIJING",
        "ASIA/HARBIN"
    ],
    /**
     * Network name to Coinbase Pay SDK chain name map object
     * @see supported chain names on Coinbase for Pay SDK: https://github.com/coinbase/cbpay-js/blob/d4bda2c05c4d5917c8db6a05476b603546046394/src/types/onramp.ts
     */ WC_COINBASE_PAY_SDK_CHAINS: [
        "ethereum",
        "arbitrum",
        "polygon",
        "avalanche-c-chain",
        "optimism",
        "celo",
        "base"
    ],
    WC_COINBASE_PAY_SDK_FALLBACK_CHAIN: "ethereum",
    WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP: {
        Ethereum: "ethereum",
        "Arbitrum One": "arbitrum",
        Polygon: "polygon",
        Avalanche: "avalanche-c-chain",
        "OP Mainnet": "optimism",
        Celo: "celo",
        Base: "base"
    },
    WC_COINBASE_ONRAMP_APP_ID: "bf18c88d-495a-463b-b249-0b9d3656cf5e",
    SWAP_SUGGESTED_TOKENS: [
        "ETH",
        "UNI",
        "1INCH",
        "AAVE",
        "SOL",
        "ADA",
        "AVAX",
        "DOT",
        "LINK",
        "NITRO",
        "GAIA",
        "MILK",
        "TRX",
        "NEAR",
        "GNO",
        "WBTC",
        "DAI",
        "WETH",
        "USDC",
        "USDT",
        "ARB",
        "BAL",
        "BICO",
        "CRV",
        "ENS",
        "MATIC",
        "OP"
    ],
    SWAP_POPULAR_TOKENS: [
        "ETH",
        "UNI",
        "1INCH",
        "AAVE",
        "SOL",
        "ADA",
        "AVAX",
        "DOT",
        "LINK",
        "NITRO",
        "GAIA",
        "MILK",
        "TRX",
        "NEAR",
        "GNO",
        "WBTC",
        "DAI",
        "WETH",
        "USDC",
        "USDT",
        "ARB",
        "BAL",
        "BICO",
        "CRV",
        "ENS",
        "MATIC",
        "OP",
        "METAL",
        "DAI",
        "CHAMP",
        "WOLF",
        "SALE",
        "BAL",
        "BUSD",
        "MUST",
        "BTCpx",
        "ROUTE",
        "HEX",
        "WELT",
        "amDAI",
        "VSQ",
        "VISION",
        "AURUM",
        "pSP",
        "SNX",
        "VC",
        "LINK",
        "CHP",
        "amUSDT",
        "SPHERE",
        "FOX",
        "GIDDY",
        "GFC",
        "OMEN",
        "OX_OLD",
        "DE",
        "WNT"
    ],
    SWAP_SUPPORTED_NETWORKS: [
        // Ethereum'
        "eip155:1",
        // Arbitrum One'
        "eip155:42161",
        // Optimism'
        "eip155:10",
        // ZKSync Era'
        "eip155:324",
        // Base'
        "eip155:8453",
        // BNB Smart Chain'
        "eip155:56",
        // Polygon'
        "eip155:137",
        // Gnosis'
        "eip155:100",
        // Avalanche'
        "eip155:43114",
        // Fantom'
        "eip155:250",
        // Klaytn'
        "eip155:8217",
        // Aurora
        "eip155:1313161554"
    ],
    NATIVE_TOKEN_ADDRESS: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    CONVERT_SLIPPAGE_TOLERANCE: 1
};

});


parcelRegister("hxXs8", function(module, exports) {

$parcel$export(module.exports, "BlockchainApiController", function () { return $cc63a2d396bdb0a4$export$9c45fcf03cadbfaa; });

var $6AwK8 = parcelRequire("6AwK8");

var $c4rfq = parcelRequire("c4rfq");

var $5j8rJ = parcelRequire("5j8rJ");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");

var $8BVTM = parcelRequire("8BVTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $f7IXw = parcelRequire("f7IXw");
const $cc63a2d396bdb0a4$var$DEFAULT_OPTIONS = {
    purchaseCurrencies: [
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "USD Coin",
            symbol: "USDC",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        },
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "Ether",
            symbol: "ETH",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        }
    ],
    paymentCurrencies: [
        {
            id: "USD",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        },
        {
            id: "EUR",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        }
    ]
};
// -- Helpers ------------------------------------------- //
const $cc63a2d396bdb0a4$var$baseUrl = (0, $c4rfq.CoreHelperUtil).getBlockchainApiUrl();
// -- State --------------------------------------------- //
const $cc63a2d396bdb0a4$var$state = (0, $eAQzZ.proxy)({
    clientId: null,
    api: new (0, $5j8rJ.FetchUtil)({
        baseUrl: $cc63a2d396bdb0a4$var$baseUrl,
        clientId: null
    })
});
const $cc63a2d396bdb0a4$export$9c45fcf03cadbfaa = {
    state: $cc63a2d396bdb0a4$var$state,
    fetchIdentity ({ address: address }) {
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/identity/${address}`,
            params: {
                projectId: (0, $8BVTM.OptionsController).state.projectId,
                sender: (0, $f7IXw.AccountController).state.address
            }
        });
    },
    fetchTransactions ({ account: account, projectId: projectId, cursor: cursor, onramp: onramp, signal: signal, cache: cache }) {
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/account/${account}/history`,
            params: {
                projectId: projectId,
                cursor: cursor,
                onramp: onramp
            },
            signal: signal,
            cache: cache
        });
    },
    fetchSwapQuote ({ projectId: projectId, amount: amount, userAddress: userAddress, from: from, to: to, gasPrice: gasPrice }) {
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/convert/quotes`,
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                projectId: projectId,
                amount: amount,
                userAddress: userAddress,
                from: from,
                to: to,
                gasPrice: gasPrice
            }
        });
    },
    fetchSwapTokens ({ projectId: projectId, chainId: chainId }) {
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/convert/tokens`,
            params: {
                projectId: projectId,
                chainId: chainId
            }
        });
    },
    fetchTokenPrice ({ projectId: projectId, addresses: addresses }) {
        return $cc63a2d396bdb0a4$var$state.api.post({
            path: "/v1/fungible/price",
            body: {
                projectId: projectId,
                currency: "usd",
                addresses: addresses
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    fetchSwapAllowance ({ projectId: projectId, tokenAddress: tokenAddress, userAddress: userAddress }) {
        const { sdkType: sdkType, sdkVersion: sdkVersion } = (0, $8BVTM.OptionsController).state;
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/convert/allowance`,
            params: {
                projectId: projectId,
                tokenAddress: tokenAddress,
                userAddress: userAddress
            },
            headers: {
                "Content-Type": "application/json",
                "x-sdk-type": sdkType,
                "x-sdk-version": sdkVersion
            }
        });
    },
    fetchGasPrice ({ projectId: projectId, chainId: chainId }) {
        const { sdkType: sdkType, sdkVersion: sdkVersion } = (0, $8BVTM.OptionsController).state;
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/convert/gas-price`,
            headers: {
                "Content-Type": "application/json",
                "x-sdk-type": sdkType,
                "x-sdk-version": sdkVersion
            },
            params: {
                projectId: projectId,
                chainId: chainId
            }
        });
    },
    generateSwapCalldata ({ amount: amount, from: from, projectId: projectId, to: to, userAddress: userAddress }) {
        return $cc63a2d396bdb0a4$var$state.api.post({
            path: "/v1/convert/build-transaction",
            headers: {
                "Content-Type": "application/json"
            },
            body: {
                amount: amount,
                eip155: {
                    slippage: (0, $6AwK8.ConstantsUtil).CONVERT_SLIPPAGE_TOLERANCE
                },
                from: from,
                projectId: projectId,
                to: to,
                userAddress: userAddress
            }
        });
    },
    generateApproveCalldata ({ from: from, projectId: projectId, to: to, userAddress: userAddress }) {
        const { sdkType: sdkType, sdkVersion: sdkVersion } = (0, $8BVTM.OptionsController).state;
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/convert/build-approve`,
            headers: {
                "Content-Type": "application/json",
                "x-sdk-type": sdkType,
                "x-sdk-version": sdkVersion
            },
            params: {
                projectId: projectId,
                userAddress: userAddress,
                from: from,
                to: to
            }
        });
    },
    async getBalance (address, chainId, forceUpdate) {
        const { sdkType: sdkType, sdkVersion: sdkVersion } = (0, $8BVTM.OptionsController).state;
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/account/${address}/balance`,
            headers: {
                "x-sdk-type": sdkType,
                "x-sdk-version": sdkVersion
            },
            params: {
                currency: "usd",
                projectId: (0, $8BVTM.OptionsController).state.projectId,
                chainId: chainId,
                forceUpdate: forceUpdate
            }
        });
    },
    async lookupEnsName (name) {
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/profile/account/${name}${(0, $1VCt9.ConstantsUtil).WC_NAME_SUFFIX}`,
            params: {
                projectId: (0, $8BVTM.OptionsController).state.projectId
            }
        });
    },
    async reverseLookupEnsName ({ address: address }) {
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/profile/reverse/${address}`,
            params: {
                sender: (0, $f7IXw.AccountController).state.address,
                projectId: (0, $8BVTM.OptionsController).state.projectId
            }
        });
    },
    async getEnsNameSuggestions (name) {
        return $cc63a2d396bdb0a4$var$state.api.get({
            path: `/v1/profile/suggestions/${name}`,
            params: {
                projectId: (0, $8BVTM.OptionsController).state.projectId
            }
        });
    },
    async registerEnsName ({ coinType: coinType, address: address, message: message, signature: signature }) {
        return $cc63a2d396bdb0a4$var$state.api.post({
            path: `/v1/profile/account`,
            body: {
                coin_type: coinType,
                address: address,
                message: message,
                signature: signature
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    async generateOnRampURL ({ destinationWallets: destinationWallets, partnerUserId: partnerUserId, defaultNetwork: defaultNetwork, purchaseAmount: purchaseAmount, paymentAmount: paymentAmount }) {
        const response = await $cc63a2d396bdb0a4$var$state.api.post({
            path: `/v1/generators/onrampurl`,
            params: {
                projectId: (0, $8BVTM.OptionsController).state.projectId
            },
            body: {
                destinationWallets: destinationWallets,
                defaultNetwork: defaultNetwork,
                partnerUserId: partnerUserId,
                defaultExperience: "buy",
                presetCryptoAmount: purchaseAmount,
                presetFiatAmount: paymentAmount
            }
        });
        return response.url;
    },
    async getOnrampOptions () {
        try {
            const response = await $cc63a2d396bdb0a4$var$state.api.get({
                path: `/v1/onramp/options`,
                params: {
                    projectId: (0, $8BVTM.OptionsController).state.projectId
                }
            });
            return response;
        } catch (e) {
            return $cc63a2d396bdb0a4$var$DEFAULT_OPTIONS;
        }
    },
    async getOnrampQuote ({ purchaseCurrency: purchaseCurrency, paymentCurrency: paymentCurrency, amount: amount, network: network }) {
        try {
            const response = await $cc63a2d396bdb0a4$var$state.api.post({
                path: `/v1/onramp/quote`,
                params: {
                    projectId: (0, $8BVTM.OptionsController).state.projectId
                },
                body: {
                    purchaseCurrency: purchaseCurrency,
                    paymentCurrency: paymentCurrency,
                    amount: amount,
                    network: network
                }
            });
            return response;
        } catch (e) {
            // Mocking response as 1:1 until endpoint is ready
            return {
                coinbaseFee: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                networkFee: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                paymentSubtotal: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                paymentTotal: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                purchaseAmount: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                quoteId: "mocked-quote-id"
            };
        }
    },
    setClientId (clientId) {
        $cc63a2d396bdb0a4$var$state.clientId = clientId;
        $cc63a2d396bdb0a4$var$state.api = new (0, $5j8rJ.FetchUtil)({
            baseUrl: $cc63a2d396bdb0a4$var$baseUrl,
            clientId: clientId
        });
    }
};

});
parcelRegister("5j8rJ", function(module, exports) {

$parcel$export(module.exports, "FetchUtil", function () { return $3dd5475aed93f553$export$ed6eff17d860976a; });
async function $3dd5475aed93f553$var$fetchData(...args) {
    const response = await fetch(...args);
    if (!response.ok) {
        // Create error object and reject if not a 2xx response code
        const err = new Error(`HTTP status code: ${response.status}`, {
            cause: response
        });
        throw err;
    }
    return response;
}
class $3dd5475aed93f553$export$ed6eff17d860976a {
    constructor({ baseUrl: baseUrl, clientId: clientId }){
        this.baseUrl = baseUrl;
        this.clientId = clientId;
    }
    async get({ headers: headers, signal: signal, cache: cache, ...args }) {
        const url = this.createUrl(args);
        const response = await $3dd5475aed93f553$var$fetchData(url, {
            method: "GET",
            headers: headers,
            signal: signal,
            cache: cache
        });
        return response.json();
    }
    async getBlob({ headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await $3dd5475aed93f553$var$fetchData(url, {
            method: "GET",
            headers: headers,
            signal: signal
        });
        return response.blob();
    }
    async post({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await $3dd5475aed93f553$var$fetchData(url, {
            method: "POST",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    async put({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await $3dd5475aed93f553$var$fetchData(url, {
            method: "PUT",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    async delete({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await $3dd5475aed93f553$var$fetchData(url, {
            method: "DELETE",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    createUrl({ path: path, params: params }) {
        const url = new URL(path, this.baseUrl);
        if (params) Object.entries(params).forEach(([key, value])=>{
            if (value) url.searchParams.append(key, value);
        });
        if (this.clientId) url.searchParams.append("clientId", this.clientId);
        return url;
    }
}

});

parcelRegister("8BVTM", function(module, exports) {

$parcel$export(module.exports, "OptionsController", function () { return $644eb0ebb6f5edcb$export$1f4c428077fc6173; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $g4s8N = parcelRequire("g4s8N");
// -- State --------------------------------------------- //
const $644eb0ebb6f5edcb$var$state = (0, $eAQzZ.proxy)({
    projectId: "",
    sdkType: "w3m",
    sdkVersion: "html-wagmi-undefined"
});
const $644eb0ebb6f5edcb$export$1f4c428077fc6173 = {
    state: $644eb0ebb6f5edcb$var$state,
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($644eb0ebb6f5edcb$var$state, key, callback);
    },
    setOptions (options) {
        Object.assign($644eb0ebb6f5edcb$var$state, options);
    },
    setProjectId (projectId) {
        $644eb0ebb6f5edcb$var$state.projectId = projectId;
    },
    setAllWallets (allWallets) {
        $644eb0ebb6f5edcb$var$state.allWallets = allWallets;
    },
    setIncludeWalletIds (includeWalletIds) {
        $644eb0ebb6f5edcb$var$state.includeWalletIds = includeWalletIds;
    },
    setExcludeWalletIds (excludeWalletIds) {
        $644eb0ebb6f5edcb$var$state.excludeWalletIds = excludeWalletIds;
        if (excludeWalletIds) (0, $g4s8N.ApiController).searchWalletByIds({
            ids: excludeWalletIds
        });
    },
    setFeaturedWalletIds (featuredWalletIds) {
        $644eb0ebb6f5edcb$var$state.featuredWalletIds = featuredWalletIds;
    },
    setTokens (tokens) {
        $644eb0ebb6f5edcb$var$state.tokens = tokens;
    },
    setTermsConditionsUrl (termsConditionsUrl) {
        $644eb0ebb6f5edcb$var$state.termsConditionsUrl = termsConditionsUrl;
    },
    setPrivacyPolicyUrl (privacyPolicyUrl) {
        $644eb0ebb6f5edcb$var$state.privacyPolicyUrl = privacyPolicyUrl;
    },
    setCustomWallets (customWallets) {
        $644eb0ebb6f5edcb$var$state.customWallets = customWallets;
    },
    setIsSiweEnabled (isSiweEnabled) {
        $644eb0ebb6f5edcb$var$state.isSiweEnabled = isSiweEnabled;
    },
    setIsUniversalProvider (isUniversalProvider) {
        $644eb0ebb6f5edcb$var$state.isUniversalProvider = isUniversalProvider;
    },
    setEnableAnalytics (enableAnalytics) {
        $644eb0ebb6f5edcb$var$state.enableAnalytics = enableAnalytics;
    },
    setSdkVersion (sdkVersion) {
        $644eb0ebb6f5edcb$var$state.sdkVersion = sdkVersion;
    },
    setMetadata (metadata) {
        $644eb0ebb6f5edcb$var$state.metadata = metadata;
    },
    setOnrampEnabled (enableOnramp) {
        $644eb0ebb6f5edcb$var$state.enableOnramp = enableOnramp;
    },
    setDisableAppend (disableAppend) {
        $644eb0ebb6f5edcb$var$state.disableAppend = disableAppend;
    },
    setEIP6963Enabled (enableEIP6963) {
        $644eb0ebb6f5edcb$var$state.enableEIP6963 = enableEIP6963;
    },
    setHasMultipleAddresses (hasMultipleAddresses) {
        $644eb0ebb6f5edcb$var$state.hasMultipleAddresses = hasMultipleAddresses;
    },
    setEnableSwaps (enableSwaps) {
        $644eb0ebb6f5edcb$var$state.enableSwaps = enableSwaps;
    }
};

});
parcelRegister("g4s8N", function(module, exports) {

$parcel$export(module.exports, "ApiController", function () { return $bb32d93e6b741bc7$export$99411f73957952af; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $c4rfq = parcelRequire("c4rfq");

var $5j8rJ = parcelRequire("5j8rJ");

var $hdC6E = parcelRequire("hdC6E");

var $zKxbI = parcelRequire("zKxbI");

var $7Xn6F = parcelRequire("7Xn6F");

var $jbD0z = parcelRequire("jbD0z");

var $8BVTM = parcelRequire("8BVTM");
// -- Helpers ------------------------------------------- //
const $bb32d93e6b741bc7$var$baseUrl = (0, $c4rfq.CoreHelperUtil).getApiUrl();
const $bb32d93e6b741bc7$export$644d8ea042df96a6 = new (0, $5j8rJ.FetchUtil)({
    baseUrl: $bb32d93e6b741bc7$var$baseUrl,
    clientId: null
});
const $bb32d93e6b741bc7$var$entries = "40";
const $bb32d93e6b741bc7$var$recommendedEntries = "4";
const $bb32d93e6b741bc7$var$imageCountToFetch = 20;
// -- State --------------------------------------------- //
const $bb32d93e6b741bc7$var$state = (0, $eAQzZ.proxy)({
    page: 1,
    count: 0,
    featured: [],
    recommended: [],
    wallets: [],
    search: [],
    isAnalyticsEnabled: false,
    excludedRDNS: []
});
const $bb32d93e6b741bc7$export$99411f73957952af = {
    state: $bb32d93e6b741bc7$var$state,
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($bb32d93e6b741bc7$var$state, key, callback);
    },
    _getApiHeaders () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $8BVTM.OptionsController).state;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    _filterOutExtensions (wallets) {
        if ((0, $8BVTM.OptionsController).state.isUniversalProvider) return wallets.filter((w)=>Boolean(w.mobile_link || w.desktop_link || w.webapp_link));
        return wallets;
    },
    async _fetchWalletImage (imageId) {
        const imageUrl = `${$bb32d93e6b741bc7$export$644d8ea042df96a6.baseUrl}/getWalletImage/${imageId}`;
        const blob = await $bb32d93e6b741bc7$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders()
        });
        (0, $zKxbI.AssetController).setWalletImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchNetworkImage (imageId) {
        const imageUrl = `${$bb32d93e6b741bc7$export$644d8ea042df96a6.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $bb32d93e6b741bc7$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders()
        });
        (0, $zKxbI.AssetController).setNetworkImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchConnectorImage (imageId) {
        const imageUrl = `${$bb32d93e6b741bc7$export$644d8ea042df96a6.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $bb32d93e6b741bc7$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders()
        });
        (0, $zKxbI.AssetController).setConnectorImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchCurrencyImage (countryCode) {
        const imageUrl = `${$bb32d93e6b741bc7$export$644d8ea042df96a6.baseUrl}/public/getCurrencyImage/${countryCode}`;
        const blob = await $bb32d93e6b741bc7$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders()
        });
        (0, $zKxbI.AssetController).setCurrencyImage(countryCode, URL.createObjectURL(blob));
    },
    async _fetchTokenImage (symbol) {
        const imageUrl = `${$bb32d93e6b741bc7$export$644d8ea042df96a6.baseUrl}/public/getTokenImage/${symbol}`;
        const blob = await $bb32d93e6b741bc7$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders()
        });
        (0, $zKxbI.AssetController).setTokenImage(symbol, URL.createObjectURL(blob));
    },
    async fetchNetworkImages () {
        const requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        const ids = requestedCaipNetworks?.map(({ imageId: imageId })=>imageId).filter(Boolean);
        if (ids) await Promise.allSettled(ids.map((id)=>$bb32d93e6b741bc7$export$99411f73957952af._fetchNetworkImage(id)));
    },
    async fetchConnectorImages () {
        const { connectors: connectors } = (0, $7Xn6F.ConnectorController).state;
        const ids = connectors.map(({ imageId: imageId })=>imageId).filter(Boolean);
        await Promise.allSettled(ids.map((id)=>$bb32d93e6b741bc7$export$99411f73957952af._fetchConnectorImage(id)));
    },
    async fetchCurrencyImages (currencies = []) {
        await Promise.allSettled(currencies.map((currency)=>$bb32d93e6b741bc7$export$99411f73957952af._fetchCurrencyImage(currency)));
    },
    async fetchTokenImages (tokens = []) {
        await Promise.allSettled(tokens.map((token)=>$bb32d93e6b741bc7$export$99411f73957952af._fetchTokenImage(token)));
    },
    async fetchFeaturedWallets () {
        const { featuredWalletIds: featuredWalletIds } = (0, $8BVTM.OptionsController).state;
        if (featuredWalletIds?.length) {
            const { data: data } = await $bb32d93e6b741bc7$export$644d8ea042df96a6.get({
                path: "/getWallets",
                headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders(),
                params: {
                    page: "1",
                    entries: featuredWalletIds?.length ? String(featuredWalletIds.length) : $bb32d93e6b741bc7$var$recommendedEntries,
                    include: featuredWalletIds?.join(",")
                }
            });
            data.sort((a, b)=>featuredWalletIds.indexOf(a.id) - featuredWalletIds.indexOf(b.id));
            const images = data.map((d)=>d.image_id).filter(Boolean);
            await Promise.allSettled(images.map((id)=>$bb32d93e6b741bc7$export$99411f73957952af._fetchWalletImage(id)));
            $bb32d93e6b741bc7$var$state.featured = data;
        }
    },
    async fetchRecommendedWallets () {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $8BVTM.OptionsController).state;
        const exclude = [
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const { data: data, count: count } = await $bb32d93e6b741bc7$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                chains: (0, $jbD0z.NetworkController).state.caipNetwork?.id,
                entries: $bb32d93e6b741bc7$var$recommendedEntries,
                include: includeWalletIds?.join(","),
                exclude: exclude?.join(",")
            }
        });
        const recent = (0, $hdC6E.StorageUtil).getRecentWallets();
        const recommendedImages = data.map((d)=>d.image_id).filter(Boolean);
        const recentImages = recent.map((r)=>r.image_id).filter(Boolean);
        await Promise.allSettled([
            ...recommendedImages,
            ...recentImages
        ].map((id)=>$bb32d93e6b741bc7$export$99411f73957952af._fetchWalletImage(id)));
        $bb32d93e6b741bc7$var$state.recommended = data;
        $bb32d93e6b741bc7$var$state.count = count ?? 0;
    },
    async fetchWallets ({ page: page }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $8BVTM.OptionsController).state;
        const exclude = [
            ...$bb32d93e6b741bc7$var$state.recommended.map(({ id: id })=>id),
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const { data: data, count: count } = await $bb32d93e6b741bc7$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders(),
            params: {
                page: String(page),
                entries: $bb32d93e6b741bc7$var$entries,
                chains: (0, $jbD0z.NetworkController).state.caipNetwork?.id,
                include: includeWalletIds?.join(","),
                exclude: exclude.join(",")
            }
        });
        const images = data.slice(0, $bb32d93e6b741bc7$var$imageCountToFetch).map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled(images.map((id)=>$bb32d93e6b741bc7$export$99411f73957952af._fetchWalletImage(id)));
        $bb32d93e6b741bc7$var$state.wallets = (0, $c4rfq.CoreHelperUtil).uniqueBy([
            ...$bb32d93e6b741bc7$var$state.wallets,
            ...$bb32d93e6b741bc7$export$99411f73957952af._filterOutExtensions(data)
        ], "id");
        $bb32d93e6b741bc7$var$state.count = count > $bb32d93e6b741bc7$var$state.count ? count : $bb32d93e6b741bc7$var$state.count;
        $bb32d93e6b741bc7$var$state.page = page;
    },
    async searchWalletByIds ({ ids: ids }) {
        const { data: data } = await $bb32d93e6b741bc7$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                entries: String(ids.length),
                chains: (0, $jbD0z.NetworkController).state.caipNetwork?.id,
                include: ids?.join(",")
            }
        });
        if (data) data.forEach((wallet)=>{
            if (wallet?.rdns) $bb32d93e6b741bc7$var$state.excludedRDNS.push(wallet.rdns);
        });
    },
    async searchWallet ({ search: search }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds } = (0, $8BVTM.OptionsController).state;
        $bb32d93e6b741bc7$var$state.search = [];
        const { data: data } = await $bb32d93e6b741bc7$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                entries: "100",
                search: search?.trim(),
                chains: (0, $jbD0z.NetworkController).state.caipNetwork?.id,
                include: includeWalletIds?.join(","),
                exclude: excludeWalletIds?.join(",")
            }
        });
        const images = data.map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled([
            ...images.map((id)=>$bb32d93e6b741bc7$export$99411f73957952af._fetchWalletImage(id)),
            (0, $c4rfq.CoreHelperUtil).wait(300)
        ]);
        $bb32d93e6b741bc7$var$state.search = $bb32d93e6b741bc7$export$99411f73957952af._filterOutExtensions(data);
    },
    async reFetchWallets () {
        $bb32d93e6b741bc7$var$state.page = 1;
        $bb32d93e6b741bc7$var$state.wallets = [];
        await $bb32d93e6b741bc7$export$99411f73957952af.fetchFeaturedWallets();
        await $bb32d93e6b741bc7$export$99411f73957952af.fetchRecommendedWallets();
    },
    prefetch () {
        const promises = [
            $bb32d93e6b741bc7$export$99411f73957952af.fetchFeaturedWallets(),
            $bb32d93e6b741bc7$export$99411f73957952af.fetchRecommendedWallets(),
            $bb32d93e6b741bc7$export$99411f73957952af.fetchNetworkImages(),
            $bb32d93e6b741bc7$export$99411f73957952af.fetchConnectorImages()
        ];
        if ((0, $8BVTM.OptionsController).state.enableAnalytics === undefined) promises.push($bb32d93e6b741bc7$export$99411f73957952af.fetchAnalyticsConfig());
        $bb32d93e6b741bc7$var$state.prefetchPromise = Promise.race([
            Promise.allSettled(promises)
        ]);
    },
    async fetchAnalyticsConfig () {
        const { isAnalyticsEnabled: isAnalyticsEnabled } = await $bb32d93e6b741bc7$export$644d8ea042df96a6.get({
            path: "/getAnalyticsConfig",
            headers: $bb32d93e6b741bc7$export$99411f73957952af._getApiHeaders()
        });
        (0, $8BVTM.OptionsController).setEnableAnalytics(isAnalyticsEnabled);
    }
};

});
parcelRegister("hdC6E", function(module, exports) {

$parcel$export(module.exports, "StorageUtil", function () { return $c89135a9f65c9cb6$export$d4382c6359971b24; });
// -- Helpers -----------------------------------------------------------------
const $c89135a9f65c9cb6$var$WC_DEEPLINK = "WALLETCONNECT_DEEPLINK_CHOICE";
const $c89135a9f65c9cb6$var$W3M_RECENT = "@w3m/recent";
const $c89135a9f65c9cb6$var$W3M_CONNECTED_CONNECTOR = "@w3m/connected_connector";
const $c89135a9f65c9cb6$var$W3M_CONNECTED_SOCIAL = "@w3m/connected_social";
const $c89135a9f65c9cb6$var$W3M_CONNECTED_SOCIAL_USERNAME = "@w3m-storage/SOCIAL_USERNAME";
const $c89135a9f65c9cb6$export$d4382c6359971b24 = {
    setWalletConnectDeepLink ({ href: href, name: name }) {
        try {
            localStorage.setItem($c89135a9f65c9cb6$var$WC_DEEPLINK, JSON.stringify({
                href: href,
                name: name
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    getWalletConnectDeepLink () {
        try {
            const deepLink = localStorage.getItem($c89135a9f65c9cb6$var$WC_DEEPLINK);
            if (deepLink) return JSON.parse(deepLink);
        } catch  {
            console.info("Unable to get WalletConnect deep link");
        }
        return undefined;
    },
    deleteWalletConnectDeepLink () {
        try {
            localStorage.removeItem($c89135a9f65c9cb6$var$WC_DEEPLINK);
        } catch  {
            console.info("Unable to delete WalletConnect deep link");
        }
    },
    setWeb3ModalRecent (wallet) {
        try {
            const recentWallets = $c89135a9f65c9cb6$export$d4382c6359971b24.getRecentWallets();
            const exists = recentWallets.find((w)=>w.id === wallet.id);
            if (!exists) {
                recentWallets.unshift(wallet);
                if (recentWallets.length > 2) recentWallets.pop();
                localStorage.setItem($c89135a9f65c9cb6$var$W3M_RECENT, JSON.stringify(recentWallets));
            }
        } catch  {
            console.info("Unable to set Web3Modal recent");
        }
    },
    getRecentWallets () {
        try {
            const recent = localStorage.getItem($c89135a9f65c9cb6$var$W3M_RECENT);
            return recent ? JSON.parse(recent) : [];
        } catch  {
            console.info("Unable to get Web3Modal recent");
        }
        return [];
    },
    setConnectedConnector (connectorType) {
        try {
            localStorage.setItem($c89135a9f65c9cb6$var$W3M_CONNECTED_CONNECTOR, connectorType);
        } catch  {
            console.info("Unable to set Connected Connector");
        }
    },
    getConnectedConnector () {
        try {
            return localStorage.getItem($c89135a9f65c9cb6$var$W3M_CONNECTED_CONNECTOR);
        } catch  {
            console.info("Unable to get Connected Connector");
        }
        return undefined;
    },
    setConnectedSocialProvider (socialProvider) {
        try {
            localStorage.setItem($c89135a9f65c9cb6$var$W3M_CONNECTED_SOCIAL, socialProvider);
        } catch  {
            console.info("Unable to set Connected Social Provider");
        }
    },
    getConnectedSocialProvider () {
        try {
            return localStorage.getItem($c89135a9f65c9cb6$var$W3M_CONNECTED_SOCIAL);
        } catch  {
            console.info("Unable to get Connected Social Provider");
        }
        return undefined;
    },
    getConnectedSocialUsername () {
        try {
            return localStorage.getItem($c89135a9f65c9cb6$var$W3M_CONNECTED_SOCIAL_USERNAME);
        } catch  {
            console.info("Unable to get Connected Social Username");
        }
        return undefined;
    }
};

});

parcelRegister("zKxbI", function(module, exports) {

$parcel$export(module.exports, "AssetController", function () { return $06b75dbd6f58a3df$export$4f2a98fee99335; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");
// -- State --------------------------------------------- //
const $06b75dbd6f58a3df$var$state = (0, $eAQzZ.proxy)({
    walletImages: {},
    networkImages: {},
    chainImages: {},
    connectorImages: {},
    tokenImages: {},
    currencyImages: {}
});
const $06b75dbd6f58a3df$export$4f2a98fee99335 = {
    state: $06b75dbd6f58a3df$var$state,
    subscribeNetworkImages (callback) {
        return (0, $eAQzZ.subscribe)($06b75dbd6f58a3df$var$state.networkImages, ()=>callback($06b75dbd6f58a3df$var$state.networkImages));
    },
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($06b75dbd6f58a3df$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($06b75dbd6f58a3df$var$state, ()=>callback($06b75dbd6f58a3df$var$state));
    },
    setWalletImage (key, value) {
        $06b75dbd6f58a3df$var$state.walletImages[key] = value;
    },
    setNetworkImage (key, value) {
        $06b75dbd6f58a3df$var$state.networkImages[key] = value;
    },
    setChainImage (key, value) {
        $06b75dbd6f58a3df$var$state.chainImages[key] = value;
    },
    setConnectorImage (key, value) {
        $06b75dbd6f58a3df$var$state.connectorImages[key] = value;
    },
    setTokenImage (key, value) {
        $06b75dbd6f58a3df$var$state.tokenImages[key] = value;
    },
    setCurrencyImage (key, value) {
        $06b75dbd6f58a3df$var$state.currencyImages[key] = value;
    }
};

});

parcelRegister("7Xn6F", function(module, exports) {

$parcel$export(module.exports, "ConnectorController", function () { return $5caff792c55d8704$export$c83edcb4eee2f517; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
var $5OPHH = parcelRequire("5OPHH");

var $8BVTM = parcelRequire("8BVTM");

var $3Sg6l = parcelRequire("3Sg6l");
// -- State --------------------------------------------- //
const $5caff792c55d8704$var$state = (0, $eAQzZ.proxy)({
    unMergedConnectors: [],
    connectors: []
});
const $5caff792c55d8704$export$c83edcb4eee2f517 = {
    state: $5caff792c55d8704$var$state,
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($5caff792c55d8704$var$state, key, callback);
    },
    setConnectors (connectors) {
        connectors.forEach(this.syncIfAuthConnector);
        $5caff792c55d8704$var$state.unMergedConnectors = [
            ...$5caff792c55d8704$var$state.unMergedConnectors,
            ...connectors
        ];
        $5caff792c55d8704$var$state.connectors = this.mergeMultiChainConnectors($5caff792c55d8704$var$state.unMergedConnectors);
    },
    mergeMultiChainConnectors (connectors) {
        const connectorsByNameMap = this.generateConnectorMapByName(connectors);
        const refactoredConnectors = Array.from(connectorsByNameMap.values()).map((_connectors)=>{
            if (_connectors.length > 1) return {
                name: _connectors[0]?.name,
                imageUrl: _connectors[0]?.imageUrl,
                imageId: _connectors[0]?.imageId,
                providers: this.getUniqueConnectorsByName(_connectors),
                type: "MULTI_CHAIN"
            };
            return _connectors[0];
        });
        return refactoredConnectors;
    },
    generateConnectorMapByName (connectors) {
        const connectorsByNameMap = new Map();
        connectors.forEach((connector)=>{
            const { name: name } = connector;
            if (!name) return;
            const connectorsByName = connectorsByNameMap.get(name) || [];
            const haveSameConnector = connectorsByName.find((c)=>c.chain === connector.chain);
            if (!haveSameConnector) connectorsByName.push(connector);
            connectorsByNameMap.set(name, connectorsByName);
        });
        return connectorsByNameMap;
    },
    getUniqueConnectorsByName (connectors) {
        const uniqueConnectors = [];
        connectors.forEach((c)=>{
            if (!uniqueConnectors.find((uc)=>uc.chain === c.chain)) uniqueConnectors.push({
                ...c,
                name: (0, $1VCt9.ConstantsUtil).CHAIN_NAME_MAP[c.chain]
            });
        });
        return uniqueConnectors;
    },
    addConnector (connector) {
        this.setConnectors([
            connector
        ]);
    },
    getAuthConnector () {
        return $5caff792c55d8704$var$state.connectors.find((c)=>c.type === "AUTH");
    },
    getAnnouncedConnectorRdns () {
        return $5caff792c55d8704$var$state.connectors.filter((c)=>c.type === "ANNOUNCED").map((c)=>c.info?.rdns);
    },
    getConnectors () {
        return $5caff792c55d8704$var$state.connectors;
    },
    getConnector (id, rdns) {
        return $5caff792c55d8704$var$state.connectors.find((c)=>c.explorerId === id || c.info?.rdns === rdns);
    },
    syncIfAuthConnector (connector) {
        if (connector.id !== "w3mAuth") return;
        const authConnector = connector;
        const optionsState = (0, $eAQzZ.snapshot)((0, $8BVTM.OptionsController).state);
        const themeMode = (0, $3Sg6l.ThemeController).getSnapshot().themeMode;
        const themeVariables = (0, $3Sg6l.ThemeController).getSnapshot().themeVariables;
        authConnector?.provider?.syncDappData?.({
            metadata: optionsState.metadata,
            sdkVersion: optionsState.sdkVersion,
            projectId: optionsState.projectId
        });
        authConnector.provider.syncTheme({
            themeMode: themeMode,
            themeVariables: themeVariables,
            w3mThemeVariables: (0, $5OPHH.getW3mThemeVariables)(themeVariables, themeMode)
        });
    }
};

});
parcelRegister("3Sg6l", function(module, exports) {

$parcel$export(module.exports, "ThemeController", function () { return $2d22e79cf460cbfc$export$e18d4112326e72bf; });

var $eAQzZ = parcelRequire("eAQzZ");

var $7Xn6F = parcelRequire("7Xn6F");
parcelRequire("ikDNi");
var $5OPHH = parcelRequire("5OPHH");
// -- State --------------------------------------------- //
const $2d22e79cf460cbfc$var$state = (0, $eAQzZ.proxy)({
    themeMode: "dark",
    themeVariables: {},
    w3mThemeVariables: undefined
});
const $2d22e79cf460cbfc$export$e18d4112326e72bf = {
    state: $2d22e79cf460cbfc$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($2d22e79cf460cbfc$var$state, ()=>callback($2d22e79cf460cbfc$var$state));
    },
    setThemeMode (themeMode) {
        $2d22e79cf460cbfc$var$state.themeMode = themeMode;
        try {
            const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
            if (authConnector) {
                const themeVariables = $2d22e79cf460cbfc$export$e18d4112326e72bf.getSnapshot().themeVariables;
                authConnector.provider.syncTheme({
                    themeMode: themeMode,
                    themeVariables: themeVariables,
                    w3mThemeVariables: (0, $5OPHH.getW3mThemeVariables)(themeVariables, themeMode)
                });
            }
        } catch  {
            // eslint-disable-next-line no-console
            console.info("Unable to sync theme to auth connector");
        }
    },
    setThemeVariables (themeVariables) {
        $2d22e79cf460cbfc$var$state.themeVariables = {
            ...$2d22e79cf460cbfc$var$state.themeVariables,
            ...themeVariables
        };
        try {
            const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
            if (authConnector) {
                const themeVariablesSnapshot = $2d22e79cf460cbfc$export$e18d4112326e72bf.getSnapshot().themeVariables;
                authConnector.provider.syncTheme({
                    themeVariables: themeVariablesSnapshot,
                    w3mThemeVariables: (0, $5OPHH.getW3mThemeVariables)($2d22e79cf460cbfc$var$state.themeVariables, $2d22e79cf460cbfc$var$state.themeMode)
                });
            }
        } catch  {
            // eslint-disable-next-line no-console
            console.info("Unable to sync theme to auth connector");
        }
    },
    getSnapshot () {
        return (0, $eAQzZ.snapshot)($2d22e79cf460cbfc$var$state);
    }
};

});


parcelRegister("jbD0z", function(module, exports) {

$parcel$export(module.exports, "NetworkController", function () { return $df7d4d9f57f43a1c$export$c63f10f788d47d86; });

var $eAQzZ = parcelRequire("eAQzZ");

var $6m17w = parcelRequire("6m17w");

var $ib7WC = parcelRequire("ib7WC");

var $c4rfq = parcelRequire("c4rfq");
parcelRequire("ikDNi");
var $1yWTt = parcelRequire("1yWTt");

var $d94Xg = parcelRequire("d94Xg");

var $1DdOF = parcelRequire("1DdOF");
// -- State --------------------------------------------- //
const $df7d4d9f57f43a1c$var$state = (0, $eAQzZ.proxy)({
    supportsAllNetworks: true,
    isDefaultCaipNetwork: false,
    smartAccountEnabledNetworks: []
});
const $df7d4d9f57f43a1c$export$c63f10f788d47d86 = {
    state: $df7d4d9f57f43a1c$var$state,
    replaceState (newState) {
        if (!newState) return;
        Object.assign($df7d4d9f57f43a1c$var$state, (0, $eAQzZ.ref)(newState));
    },
    subscribeKey (property, callback) {
        let prev = undefined;
        return (0, $d94Xg.ChainController).subscribeChainProp("networkState", (networkState)=>{
            if (networkState) {
                const nextValue = networkState[property];
                if (prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    _getClient () {
        return (0, $d94Xg.ChainController).getNetworkControllerClient();
    },
    initializeDefaultNetwork () {
        const networks = this.getRequestedCaipNetworks();
        if (networks.length > 0) this.setCaipNetwork(networks[0]);
    },
    setDefaultCaipNetwork (caipNetwork) {
        if (caipNetwork) {
            (0, $d94Xg.ChainController).setCaipNetwork(caipNetwork.chain, caipNetwork, true);
            (0, $d94Xg.ChainController).setChainNetworkData(caipNetwork.chain, {
                isDefaultCaipNetwork: true
            });
            (0, $1DdOF.PublicStateController).set({
                selectedNetworkId: caipNetwork.id
            });
        }
    },
    setActiveCaipNetwork (caipNetwork) {
        if (!caipNetwork) return;
        (0, $d94Xg.ChainController).setActiveCaipNetwork(caipNetwork);
        (0, $d94Xg.ChainController).setChainNetworkData(caipNetwork.chain, {
            caipNetwork: caipNetwork
        });
        (0, $1DdOF.PublicStateController).set({
            activeChain: caipNetwork.chain,
            selectedNetworkId: caipNetwork?.id
        });
        if (!(0, $d94Xg.ChainController).state.chains.get(caipNetwork.chain)?.networkState?.allowUnsupportedChain) {
            const isSupported = this.checkIfSupportedNetwork();
            if (!isSupported) this.showUnsupportedChainUI();
        }
    },
    setCaipNetwork (caipNetwork) {
        if (!caipNetwork) return;
        if (!caipNetwork?.chain) throw new Error("chain is required to set active network");
        (0, $d94Xg.ChainController).setCaipNetwork(caipNetwork?.chain, caipNetwork);
        if (!(0, $d94Xg.ChainController).state.chains.get(caipNetwork.chain)?.networkState?.allowUnsupportedChain) {
            const isSupported = this.checkIfSupportedNetwork();
            if (!isSupported) this.showUnsupportedChainUI();
        }
    },
    setRequestedCaipNetworks (requestedNetworks, chain) {
        (0, $d94Xg.ChainController).setChainNetworkData(chain, {
            requestedCaipNetworks: requestedNetworks
        });
    },
    setAllowUnsupportedChain (allowUnsupportedChain, chain) {
        (0, $d94Xg.ChainController).setChainNetworkData(chain || (0, $d94Xg.ChainController).state.activeChain, {
            allowUnsupportedChain: allowUnsupportedChain
        });
    },
    setSmartAccountEnabledNetworks (smartAccountEnabledNetworks, chain) {
        (0, $d94Xg.ChainController).setChainNetworkData(chain, {
            smartAccountEnabledNetworks: smartAccountEnabledNetworks
        });
    },
    getRequestedCaipNetworks (chainToFilter) {
        let chainAdapters = undefined;
        if (!(0, $d94Xg.ChainController).state.activeChain) throw new Error("activeChain is required to get requested networks");
        if (chainToFilter) {
            const chain = chainToFilter;
            if (!chain) throw new Error("chain is required to get requested networks");
            chainAdapters = [
                chain
            ];
        } else {
            const chains = [
                ...(0, $d94Xg.ChainController).state.chains.keys()
            ];
            chainAdapters = chains;
        }
        const approvedIds = [];
        const requestedNetworks = [];
        chainAdapters.forEach((chn)=>{
            if ((0, $d94Xg.ChainController).state.chains.get(chn)?.networkState?.approvedCaipNetworkIds) approvedIds.push(...(0, $d94Xg.ChainController).state.chains.get(chn)?.networkState?.approvedCaipNetworkIds || []);
            if ((0, $d94Xg.ChainController).state.chains.get(chn)?.networkState?.requestedCaipNetworks) requestedNetworks.push(...(0, $d94Xg.ChainController).state.chains.get(chn)?.networkState?.requestedCaipNetworks || []);
        });
        const sortedNetworks = (0, $c4rfq.CoreHelperUtil).sortRequestedNetworks(approvedIds, requestedNetworks);
        return sortedNetworks;
    },
    async switchActiveNetwork (network) {
        const networkControllerClient = network ? (0, $d94Xg.ChainController).state.chains.get(network.chain)?.networkControllerClient : undefined;
        if (!networkControllerClient) throw new Error("networkControllerClient not found for given network object");
        (0, $d94Xg.ChainController).setActiveCaipNetwork(network);
        await networkControllerClient?.switchCaipNetwork(network);
        if (network) (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SWITCH_NETWORK",
            properties: {
                network: network.id
            }
        });
    },
    getApprovedCaipNetworkIds (chainToFilter) {
        if (chainToFilter) {
            const chain = chainToFilter;
            if (!chain) throw new Error("chain is required to get approved network IDs");
            return (0, $d94Xg.ChainController).state.chains.get(chain)?.networkState?.approvedCaipNetworkIds;
        }
        const allCaipNetworkIds = [];
        Object.values((0, $d94Xg.ChainController).state.chains).forEach((adapter)=>{
            if (adapter.networkState.approvedCaipNetworkIds) allCaipNetworkIds.push(...adapter.networkState?.approvedCaipNetworkIds || []);
        });
        return allCaipNetworkIds;
    },
    async setApprovedCaipNetworksData (chain) {
        const networkControllerClient = (0, $d94Xg.ChainController).getNetworkControllerClient();
        const data = await networkControllerClient.getApprovedCaipNetworksData();
        if (!chain) throw new Error("chain is required to set approved network data");
        (0, $d94Xg.ChainController).setChainNetworkData(chain, {
            approvedCaipNetworkIds: data?.approvedCaipNetworkIds,
            supportsAllNetworks: data?.supportsAllNetworks || false
        });
    },
    checkIfSupportedNetwork () {
        const chain = (0, $d94Xg.ChainController).state.activeChain;
        if (!chain) return false;
        const activeCaipNetwork = (0, $d94Xg.ChainController).state.chains.get(chain)?.networkState?.caipNetwork;
        const requestedCaipNetworks = this.getRequestedCaipNetworks();
        return requestedCaipNetworks?.some((network)=>network.id === activeCaipNetwork?.id);
    },
    checkIfSmartAccountEnabled () {
        const networkId = (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber($df7d4d9f57f43a1c$var$state.caipNetwork?.id);
        const activeChain = (0, $d94Xg.ChainController).state.activeChain;
        if (!activeChain) throw new Error("activeChain is required to check if smart account is enabled");
        if (!networkId) return false;
        const smartAccountEnabledNetworks = (0, $d94Xg.ChainController).getNetworkProp("smartAccountEnabledNetworks");
        return Boolean(smartAccountEnabledNetworks?.includes(networkId));
    },
    resetNetwork () {
        const chain = (0, $d94Xg.ChainController).state.activeChain;
        if (!chain) throw new Error("chain is required to reset network");
        (0, $d94Xg.ChainController).setChainNetworkData(chain, {
            approvedCaipNetworkIds: undefined,
            supportsAllNetworks: true,
            smartAccountEnabledNetworks: []
        });
    },
    getSupportsAllNetworks () {
        const chain = (0, $d94Xg.ChainController).state.activeChain;
        if (!chain) throw new Error("chain is required to check if network supports all networks");
        return (0, $d94Xg.ChainController).state.chains.get(chain)?.networkState?.supportsAllNetworks;
    },
    showUnsupportedChainUI () {
        setTimeout(()=>{
            (0, $ib7WC.ModalController).open({
                view: "UnsupportedChain"
            });
        }, 300);
    }
};

});
parcelRegister("6m17w", function(module, exports) {

$parcel$export(module.exports, "EventsController", function () { return $4a05aa9c583d07d5$export$23ca5cb260756952; });

var $eAQzZ = parcelRequire("eAQzZ");

var $c4rfq = parcelRequire("c4rfq");

var $5j8rJ = parcelRequire("5j8rJ");

var $8BVTM = parcelRequire("8BVTM");
// -- Helpers ------------------------------------------- //
const $4a05aa9c583d07d5$var$baseUrl = (0, $c4rfq.CoreHelperUtil).getAnalyticsUrl();
const $4a05aa9c583d07d5$var$api = new (0, $5j8rJ.FetchUtil)({
    baseUrl: $4a05aa9c583d07d5$var$baseUrl,
    clientId: null
});
const $4a05aa9c583d07d5$var$excluded = [
    "MODAL_CREATED"
];
// -- State --------------------------------------------- //
const $4a05aa9c583d07d5$var$state = (0, $eAQzZ.proxy)({
    timestamp: Date.now(),
    data: {
        type: "track",
        event: "MODAL_CREATED"
    }
});
const $4a05aa9c583d07d5$export$23ca5cb260756952 = {
    state: $4a05aa9c583d07d5$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($4a05aa9c583d07d5$var$state, ()=>callback($4a05aa9c583d07d5$var$state));
    },
    _getApiHeaders () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $8BVTM.OptionsController).state;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    async _sendAnalyticsEvent (payload) {
        try {
            if ($4a05aa9c583d07d5$var$excluded.includes(payload.data.event) || typeof window === "undefined") return;
            await $4a05aa9c583d07d5$var$api.post({
                path: "/e",
                headers: $4a05aa9c583d07d5$export$23ca5cb260756952._getApiHeaders(),
                body: {
                    eventId: (0, $c4rfq.CoreHelperUtil).getUUID(),
                    url: window.location.href,
                    domain: window.location.hostname,
                    timestamp: payload.timestamp,
                    props: payload.data
                }
            });
        } catch  {
        // Catch silently
        }
    },
    sendEvent (data) {
        $4a05aa9c583d07d5$var$state.timestamp = Date.now();
        $4a05aa9c583d07d5$var$state.data = data;
        if ((0, $8BVTM.OptionsController).state.enableAnalytics) $4a05aa9c583d07d5$export$23ca5cb260756952._sendAnalyticsEvent($4a05aa9c583d07d5$var$state);
    }
};

});

parcelRegister("d94Xg", function(module, exports) {

$parcel$export(module.exports, "ChainController", function () { return $991ff58b3ac59c2e$export$fbf61adcac1da229; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $jbD0z = parcelRequire("jbD0z");

var $f7IXw = parcelRequire("f7IXw");

var $1DdOF = parcelRequire("1DdOF");
parcelRequire("ikDNi");
// -- Constants ----------------------------------------- //
const $991ff58b3ac59c2e$var$accountState = {
    isConnected: false,
    currentTab: 0,
    tokenBalance: [],
    smartAccountDeployed: false,
    addressLabels: new Map(),
    allAccounts: []
};
const $991ff58b3ac59c2e$var$networkState = {
    supportsAllNetworks: true,
    isDefaultCaipNetwork: false,
    smartAccountEnabledNetworks: []
};
// -- State --------------------------------------------- //
const $991ff58b3ac59c2e$var$state = (0, $eAQzZ.proxy)({
    chains: (0, $dNrTM.proxyMap)(),
    activeChain: undefined,
    activeCaipNetwork: undefined
});
const $991ff58b3ac59c2e$export$fbf61adcac1da229 = {
    state: $991ff58b3ac59c2e$var$state,
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($991ff58b3ac59c2e$var$state, key, callback);
    },
    subscribeChain (callback) {
        let prev = undefined;
        return (0, $eAQzZ.subscribe)($991ff58b3ac59c2e$var$state.chains, ()=>{
            const activeChain = $991ff58b3ac59c2e$var$state.activeChain;
            if (activeChain) {
                const nextValue = $991ff58b3ac59c2e$var$state.chains.get(activeChain);
                if (!prev || prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    subscribeChainProp (property, callback) {
        let prev = undefined;
        return (0, $eAQzZ.subscribe)($991ff58b3ac59c2e$var$state.chains, ()=>{
            const activeChain = $991ff58b3ac59c2e$var$state.activeChain;
            if (activeChain) {
                const nextValue = $991ff58b3ac59c2e$var$state.chains.get(activeChain)?.[property];
                if (prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    initialize (adapters) {
        const adapterToActivate = adapters?.[0];
        if (!adapterToActivate) throw new Error("Adapter is required to initialize ChainController");
        $991ff58b3ac59c2e$var$state.activeChain = adapterToActivate.chain;
        (0, $1DdOF.PublicStateController).set({
            activeChain: adapterToActivate.chain
        });
        this.setActiveCaipNetwork(adapterToActivate.defaultChain);
        adapters.forEach((adapter)=>{
            $991ff58b3ac59c2e$var$state.chains.set(adapter.chain, {
                chain: adapter.chain,
                connectionControllerClient: adapter.connectionControllerClient,
                networkControllerClient: adapter.networkControllerClient,
                accountState: $991ff58b3ac59c2e$var$accountState,
                networkState: $991ff58b3ac59c2e$var$networkState
            });
        });
    },
    setChainNetworkData (chain, props, replaceState = false) {
        if (!chain) throw new Error("Chain is required to update chain network data");
        const chainAdapter = $991ff58b3ac59c2e$var$state.chains.get(chain);
        if (chainAdapter) {
            chainAdapter.networkState = (0, $eAQzZ.ref)({
                ...chainAdapter.networkState,
                ...props
            });
            $991ff58b3ac59c2e$var$state.chains.set(chain, (0, $eAQzZ.ref)(chainAdapter));
            if (replaceState || $991ff58b3ac59c2e$var$state.chains.size === 1 || $991ff58b3ac59c2e$var$state.activeChain === chain) (0, $jbD0z.NetworkController).replaceState(chainAdapter.networkState);
        }
    },
    setChainAccountData (chain, accountProps, replaceState = true) {
        if (!chain) throw new Error("Chain is required to update chain account data");
        const chainAdapter = $991ff58b3ac59c2e$var$state.chains.get(chain);
        if (chainAdapter) {
            chainAdapter.accountState = (0, $eAQzZ.ref)({
                ...chainAdapter.accountState,
                ...accountProps
            });
            $991ff58b3ac59c2e$var$state.chains.set(chain, chainAdapter);
            if (replaceState || $991ff58b3ac59c2e$var$state.chains.size === 1 || $991ff58b3ac59c2e$var$state.activeChain === chain) (0, $f7IXw.AccountController).replaceState(chainAdapter.accountState);
        }
    },
    setAccountProp (prop, value, chain) {
        this.setChainAccountData(chain, {
            [prop]: value
        });
    },
    setActiveChain (chain) {
        const newAdapter = chain ? $991ff58b3ac59c2e$var$state.chains.get(chain) : undefined;
        if (newAdapter && newAdapter.chain !== $991ff58b3ac59c2e$var$state.activeChain) {
            $991ff58b3ac59c2e$var$state.activeChain = newAdapter.chain;
            $991ff58b3ac59c2e$var$state.activeCaipNetwork = newAdapter.networkState?.caipNetwork ? (0, $eAQzZ.ref)(newAdapter.networkState?.caipNetwork) : undefined;
            (0, $f7IXw.AccountController).replaceState(newAdapter.accountState);
            (0, $jbD0z.NetworkController).replaceState(newAdapter.networkState);
            this.setCaipNetwork(newAdapter.chain, newAdapter.networkState?.caipNetwork);
            (0, $1DdOF.PublicStateController).set({
                activeChain: chain,
                selectedNetworkId: newAdapter.networkState?.caipNetwork?.id
            });
        }
    },
    setActiveCaipNetwork (caipNetwork) {
        if (!caipNetwork) return;
        if (caipNetwork.chain !== $991ff58b3ac59c2e$var$state.activeChain) this.setActiveChain(caipNetwork.chain);
        $991ff58b3ac59c2e$var$state.activeCaipNetwork = (0, $eAQzZ.ref)(caipNetwork);
        $991ff58b3ac59c2e$var$state.activeChain = caipNetwork.chain;
        this.setCaipNetwork(caipNetwork.chain, caipNetwork, true);
        (0, $1DdOF.PublicStateController).set({
            activeChain: caipNetwork.chain,
            selectedNetworkId: caipNetwork?.id
        });
    },
    /**
     * The setCaipNetwork function is being called for different purposes and it needs to be controlled if it should replace the NetworkController state or not.
     * While we initializing the adapters, we need to set the caipNetwork without replacing the state.
     * But when we switch the network, we need to replace the state.
     * @param chain
     * @param caipNetwork
     * @param shouldReplace - if true, it will replace the NetworkController state
     */ setCaipNetwork (chain, caipNetwork, shouldReplace = false) {
        this.setChainNetworkData(chain, {
            caipNetwork: caipNetwork
        }, shouldReplace);
    },
    setActiveConnector (connector) {
        if (connector) $991ff58b3ac59c2e$var$state.activeConnector = (0, $eAQzZ.ref)(connector);
    },
    getNetworkControllerClient () {
        const chain = $991ff58b3ac59c2e$var$state.activeChain;
        if (!chain) throw new Error("Chain is required to get network controller client");
        const chainAdapter = $991ff58b3ac59c2e$var$state.chains.get(chain);
        if (!chainAdapter) throw new Error("Chain adapter not found");
        if (!chainAdapter.networkControllerClient) throw new Error("NetworkController client not set");
        return chainAdapter.networkControllerClient;
    },
    getConnectionControllerClient (_chain) {
        const chain = _chain || $991ff58b3ac59c2e$var$state.activeChain;
        if (!chain) throw new Error("Chain is required to get connection controller client");
        const chainAdapter = $991ff58b3ac59c2e$var$state.chains.get(chain);
        if (!chainAdapter) throw new Error("Chain adapter not found");
        if (!chainAdapter.connectionControllerClient) throw new Error("ConnectionController client not set");
        return chainAdapter.connectionControllerClient;
    },
    getAccountProp (key, _chain) {
        let chain = $991ff58b3ac59c2e$var$state.activeChain;
        if (_chain) chain = _chain;
        if (!chain) return undefined;
        const chainAccountState = $991ff58b3ac59c2e$var$state.chains.get(chain)?.accountState;
        if (!chainAccountState) return undefined;
        return chainAccountState[key];
    },
    getNetworkProp (key) {
        const chainToWrite = $991ff58b3ac59c2e$var$state.activeChain;
        if (!chainToWrite) return undefined;
        const chainNetworkState = $991ff58b3ac59c2e$var$state.chains.get(chainToWrite)?.networkState;
        if (!chainNetworkState) return undefined;
        return chainNetworkState[key];
    },
    resetAccount (chain) {
        const chainToWrite = chain;
        if (!chainToWrite) throw new Error("Chain is required to set account prop");
        this.setChainAccountData(chainToWrite, (0, $eAQzZ.ref)({
            isConnected: false,
            smartAccountDeployed: false,
            currentTab: 0,
            caipAddress: undefined,
            address: undefined,
            balance: undefined,
            balanceSymbol: undefined,
            profileName: undefined,
            profileImage: undefined,
            addressExplorerUrl: undefined,
            tokenBalance: [],
            connectedWalletInfo: undefined,
            preferredAccountType: undefined,
            socialProvider: undefined,
            socialWindow: undefined,
            farcasterUrl: undefined
        }));
    }
};

});
parcelRegister("1DdOF", function(module, exports) {

$parcel$export(module.exports, "PublicStateController", function () { return $1304269523ff0fa4$export$24bc8c77cb7c530; });

var $eAQzZ = parcelRequire("eAQzZ");
// -- State --------------------------------------------- //
const $1304269523ff0fa4$var$state = (0, $eAQzZ.proxy)({
    loading: false,
    open: false,
    selectedNetworkId: undefined,
    activeChain: undefined
});
const $1304269523ff0fa4$export$24bc8c77cb7c530 = {
    state: $1304269523ff0fa4$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($1304269523ff0fa4$var$state, ()=>callback($1304269523ff0fa4$var$state));
    },
    set (newState) {
        Object.assign($1304269523ff0fa4$var$state, {
            ...$1304269523ff0fa4$var$state,
            ...newState
        });
    }
};

});






parcelRegister("br7WV", function(module, exports) {

$parcel$export(module.exports, "SnackController", function () { return $853861ef707873e5$export$506cae4b4f746de7; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $c4rfq = parcelRequire("c4rfq");
// -- State --------------------------------------------- //
const $853861ef707873e5$var$state = (0, $eAQzZ.proxy)({
    message: "",
    variant: "success",
    open: false
});
const $853861ef707873e5$export$506cae4b4f746de7 = {
    state: $853861ef707873e5$var$state,
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($853861ef707873e5$var$state, key, callback);
    },
    showLoading (message) {
        $853861ef707873e5$var$state.message = message;
        $853861ef707873e5$var$state.variant = "loading";
        $853861ef707873e5$var$state.open = true;
    },
    showSuccess (message) {
        $853861ef707873e5$var$state.message = message;
        $853861ef707873e5$var$state.variant = "success";
        $853861ef707873e5$var$state.open = true;
    },
    showError (message) {
        const errorMessage = (0, $c4rfq.CoreHelperUtil).parseError(message);
        $853861ef707873e5$var$state.message = errorMessage;
        $853861ef707873e5$var$state.variant = "error";
        $853861ef707873e5$var$state.open = true;
    },
    hide () {
        $853861ef707873e5$var$state.open = false;
    }
};

});

parcelRegister("89gde", function(module, exports) {

$parcel$export(module.exports, "SwapController", function () { return $5eebbd73ea5c6443$export$cb69c6a27866a8a5; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $f7IXw = parcelRequire("f7IXw");

var $6AwK8 = parcelRequire("6AwK8");

var $hlVrM = parcelRequire("hlVrM");

var $m3nYM = parcelRequire("m3nYM");

var $br7WV = parcelRequire("br7WV");

var $6mRzS = parcelRequire("6mRzS");
parcelRequire("ikDNi");
var $l2EhC = parcelRequire("l2EhC");

var $jbD0z = parcelRequire("jbD0z");

var $c4rfq = parcelRequire("c4rfq");

var $hxXs8 = parcelRequire("hxXs8");

var $8BVTM = parcelRequire("8BVTM");

var $7WhJR = parcelRequire("7WhJR");

var $6m17w = parcelRequire("6m17w");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");

var $hdC6E = parcelRequire("hdC6E");

var $7Xn6F = parcelRequire("7Xn6F");
const $5eebbd73ea5c6443$export$3540a8643ebda500 = 150000;
const $5eebbd73ea5c6443$export$7d4f9f74f76f88bb = 6;
class $5eebbd73ea5c6443$var$TransactionError extends Error {
    constructor(message, shortMessage){
        super(message);
        this.name = "TransactionError";
        this.shortMessage = shortMessage;
    }
}
// -- State --------------------------------------------- //
const $5eebbd73ea5c6443$var$initialState = {
    // Loading states
    initializing: false,
    initialized: false,
    loadingPrices: false,
    loadingQuote: false,
    loadingApprovalTransaction: false,
    loadingBuildTransaction: false,
    loadingTransaction: false,
    // Error states
    fetchError: false,
    // Approval & Swap transaction states
    approvalTransaction: undefined,
    swapTransaction: undefined,
    transactionError: undefined,
    // Input values
    sourceToken: undefined,
    sourceTokenAmount: "",
    sourceTokenPriceInUSD: 0,
    toToken: undefined,
    toTokenAmount: "",
    toTokenPriceInUSD: 0,
    networkPrice: "0",
    networkBalanceInUSD: "0",
    networkTokenSymbol: "",
    inputError: undefined,
    // Request values
    slippage: (0, $6AwK8.ConstantsUtil).CONVERT_SLIPPAGE_TOLERANCE,
    // Tokens
    tokens: undefined,
    popularTokens: undefined,
    suggestedTokens: undefined,
    foundTokens: undefined,
    myTokensWithBalance: undefined,
    tokensPriceMap: {},
    // Calculations
    gasFee: "0",
    gasPriceInUSD: 0,
    priceImpact: undefined,
    maxSlippage: undefined,
    providerFee: undefined
};
const $5eebbd73ea5c6443$var$state = (0, $eAQzZ.proxy)($5eebbd73ea5c6443$var$initialState);
const $5eebbd73ea5c6443$export$cb69c6a27866a8a5 = {
    state: $5eebbd73ea5c6443$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($5eebbd73ea5c6443$var$state, ()=>callback($5eebbd73ea5c6443$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($5eebbd73ea5c6443$var$state, key, callback);
    },
    getParams () {
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        const address = (0, $f7IXw.AccountController).state.address;
        const networkAddress = `${caipNetwork?.id}:${(0, $6AwK8.ConstantsUtil).NATIVE_TOKEN_ADDRESS}`;
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (!address) throw new Error("No address found to swap the tokens from.");
        const caipAddress = (0, $f7IXw.AccountController).state.caipAddress;
        const invalidToToken = !$5eebbd73ea5c6443$var$state.toToken?.address || !$5eebbd73ea5c6443$var$state.toToken?.decimals;
        const invalidSourceToken = !$5eebbd73ea5c6443$var$state.sourceToken?.address || !$5eebbd73ea5c6443$var$state.sourceToken?.decimals || !(0, $l2EhC.NumberUtil).bigNumber($5eebbd73ea5c6443$var$state.sourceTokenAmount).isGreaterThan(0);
        const invalidSourceTokenAmount = !$5eebbd73ea5c6443$var$state.sourceTokenAmount;
        return {
            networkAddress: networkAddress,
            fromAddress: address,
            fromCaipAddress: (0, $f7IXw.AccountController).state.caipAddress,
            sourceTokenAddress: $5eebbd73ea5c6443$var$state.sourceToken?.address,
            toTokenAddress: $5eebbd73ea5c6443$var$state.toToken?.address,
            toTokenAmount: $5eebbd73ea5c6443$var$state.toTokenAmount,
            toTokenDecimals: $5eebbd73ea5c6443$var$state.toToken?.decimals,
            sourceTokenAmount: $5eebbd73ea5c6443$var$state.sourceTokenAmount,
            sourceTokenDecimals: $5eebbd73ea5c6443$var$state.sourceToken?.decimals,
            invalidToToken: invalidToToken,
            invalidSourceToken: invalidSourceToken,
            invalidSourceTokenAmount: invalidSourceTokenAmount,
            availableToSwap: caipAddress && !invalidToToken && !invalidSourceToken && !invalidSourceTokenAmount,
            isAuthConnector: authConnector?.walletFeatures && type === "AUTH"
        };
    },
    setSourceToken (sourceToken) {
        if (!sourceToken) {
            $5eebbd73ea5c6443$var$state.sourceToken = sourceToken;
            $5eebbd73ea5c6443$var$state.sourceTokenAmount = "";
            $5eebbd73ea5c6443$var$state.sourceTokenPriceInUSD = 0;
            return;
        }
        $5eebbd73ea5c6443$var$state.sourceToken = sourceToken;
        this.setTokenPrice(sourceToken.address, "sourceToken");
    },
    setSourceTokenAmount (amount) {
        $5eebbd73ea5c6443$var$state.sourceTokenAmount = amount;
    },
    setToToken (toToken) {
        if (!toToken) {
            $5eebbd73ea5c6443$var$state.toToken = toToken;
            $5eebbd73ea5c6443$var$state.toTokenAmount = "";
            $5eebbd73ea5c6443$var$state.toTokenPriceInUSD = 0;
            return;
        }
        $5eebbd73ea5c6443$var$state.toToken = toToken;
        this.setTokenPrice(toToken.address, "toToken");
    },
    setToTokenAmount (amount) {
        $5eebbd73ea5c6443$var$state.toTokenAmount = amount ? (0, $l2EhC.NumberUtil).formatNumberToLocalString(amount, $5eebbd73ea5c6443$export$7d4f9f74f76f88bb) : "";
    },
    async setTokenPrice (address, target) {
        const { availableToSwap: availableToSwap } = this.getParams();
        let price = $5eebbd73ea5c6443$var$state.tokensPriceMap[address] || 0;
        if (!price) {
            $5eebbd73ea5c6443$var$state.loadingPrices = true;
            price = await this.getAddressPrice(address);
        }
        if (target === "sourceToken") $5eebbd73ea5c6443$var$state.sourceTokenPriceInUSD = price;
        else if (target === "toToken") $5eebbd73ea5c6443$var$state.toTokenPriceInUSD = price;
        if ($5eebbd73ea5c6443$var$state.loadingPrices) {
            $5eebbd73ea5c6443$var$state.loadingPrices = false;
            if (availableToSwap) this.swapTokens();
        }
    },
    switchTokens () {
        if ($5eebbd73ea5c6443$var$state.initializing || !$5eebbd73ea5c6443$var$state.initialized) return;
        const newSourceToken = $5eebbd73ea5c6443$var$state.toToken ? {
            ...$5eebbd73ea5c6443$var$state.toToken
        } : undefined;
        const newToToken = $5eebbd73ea5c6443$var$state.sourceToken ? {
            ...$5eebbd73ea5c6443$var$state.sourceToken
        } : undefined;
        const newSourceTokenAmount = newSourceToken && $5eebbd73ea5c6443$var$state.toTokenAmount === "" ? "1" : $5eebbd73ea5c6443$var$state.toTokenAmount;
        this.setSourceToken(newSourceToken);
        this.setToToken(newToToken);
        this.setSourceTokenAmount(newSourceTokenAmount);
        this.setToTokenAmount("");
        this.swapTokens();
    },
    resetState () {
        $5eebbd73ea5c6443$var$state.myTokensWithBalance = $5eebbd73ea5c6443$var$initialState.myTokensWithBalance;
        $5eebbd73ea5c6443$var$state.tokensPriceMap = $5eebbd73ea5c6443$var$initialState.tokensPriceMap;
        $5eebbd73ea5c6443$var$state.initialized = $5eebbd73ea5c6443$var$initialState.initialized;
        $5eebbd73ea5c6443$var$state.sourceToken = $5eebbd73ea5c6443$var$initialState.sourceToken;
        $5eebbd73ea5c6443$var$state.sourceTokenAmount = $5eebbd73ea5c6443$var$initialState.sourceTokenAmount;
        $5eebbd73ea5c6443$var$state.sourceTokenPriceInUSD = $5eebbd73ea5c6443$var$initialState.sourceTokenPriceInUSD;
        $5eebbd73ea5c6443$var$state.toToken = $5eebbd73ea5c6443$var$initialState.toToken;
        $5eebbd73ea5c6443$var$state.toTokenAmount = $5eebbd73ea5c6443$var$initialState.toTokenAmount;
        $5eebbd73ea5c6443$var$state.toTokenPriceInUSD = $5eebbd73ea5c6443$var$initialState.toTokenPriceInUSD;
        $5eebbd73ea5c6443$var$state.networkPrice = $5eebbd73ea5c6443$var$initialState.networkPrice;
        $5eebbd73ea5c6443$var$state.networkTokenSymbol = $5eebbd73ea5c6443$var$initialState.networkTokenSymbol;
        $5eebbd73ea5c6443$var$state.networkBalanceInUSD = $5eebbd73ea5c6443$var$initialState.networkBalanceInUSD;
        $5eebbd73ea5c6443$var$state.inputError = $5eebbd73ea5c6443$var$initialState.inputError;
    },
    resetValues () {
        const { networkAddress: networkAddress } = this.getParams();
        const networkToken = $5eebbd73ea5c6443$var$state.tokens?.find((token)=>token.address === networkAddress);
        this.setSourceToken(networkToken);
        this.setToToken(undefined);
    },
    getApprovalLoadingState () {
        return $5eebbd73ea5c6443$var$state.loadingApprovalTransaction;
    },
    clearError () {
        $5eebbd73ea5c6443$var$state.transactionError = undefined;
    },
    async initializeState () {
        if ($5eebbd73ea5c6443$var$state.initializing) return;
        $5eebbd73ea5c6443$var$state.initializing = true;
        if (!$5eebbd73ea5c6443$var$state.initialized) try {
            await this.fetchTokens();
            $5eebbd73ea5c6443$var$state.initialized = true;
        } catch (error) {
            $5eebbd73ea5c6443$var$state.initialized = false;
            (0, $br7WV.SnackController).showError("Failed to initialize swap");
            (0, $6mRzS.RouterController).goBack();
        }
        $5eebbd73ea5c6443$var$state.initializing = false;
    },
    async fetchTokens () {
        const { networkAddress: networkAddress } = this.getParams();
        await this.getTokenList();
        await this.getNetworkTokenPrice();
        await this.getMyTokensWithBalance();
        const networkToken = $5eebbd73ea5c6443$var$state.tokens?.find((token)=>token.address === networkAddress);
        if (networkToken) {
            $5eebbd73ea5c6443$var$state.networkTokenSymbol = networkToken.symbol;
            this.setSourceToken(networkToken);
            this.setSourceTokenAmount("1");
        }
    },
    async getTokenList () {
        const tokens = await (0, $m3nYM.SwapApiUtil).getTokenList();
        $5eebbd73ea5c6443$var$state.tokens = tokens;
        $5eebbd73ea5c6443$var$state.popularTokens = tokens.sort((aTokenInfo, bTokenInfo)=>{
            if (aTokenInfo.symbol < bTokenInfo.symbol) return -1;
            if (aTokenInfo.symbol > bTokenInfo.symbol) return 1;
            return 0;
        });
        $5eebbd73ea5c6443$var$state.suggestedTokens = tokens.filter((token)=>{
            if ((0, $6AwK8.ConstantsUtil).SWAP_SUGGESTED_TOKENS.includes(token.symbol)) return true;
            return false;
        }, {});
    },
    async getAddressPrice (address) {
        const existPrice = $5eebbd73ea5c6443$var$state.tokensPriceMap[address];
        if (existPrice) return existPrice;
        const response = await (0, $hxXs8.BlockchainApiController).fetchTokenPrice({
            projectId: (0, $8BVTM.OptionsController).state.projectId,
            addresses: [
                address
            ]
        });
        const fungibles = response.fungibles || [];
        const allTokens = [
            ...$5eebbd73ea5c6443$var$state.tokens || [],
            ...$5eebbd73ea5c6443$var$state.myTokensWithBalance || []
        ];
        const symbol = allTokens?.find((token)=>token.address === address)?.symbol;
        const price = fungibles.find((p)=>p.symbol.toLowerCase() === symbol?.toLowerCase())?.price || 0;
        const priceAsFloat = parseFloat(price.toString());
        $5eebbd73ea5c6443$var$state.tokensPriceMap[address] = priceAsFloat;
        return priceAsFloat;
    },
    async getNetworkTokenPrice () {
        const { networkAddress: networkAddress } = this.getParams();
        const response = await (0, $hxXs8.BlockchainApiController).fetchTokenPrice({
            projectId: (0, $8BVTM.OptionsController).state.projectId,
            addresses: [
                networkAddress
            ]
        });
        const token = response.fungibles?.[0];
        const price = token?.price.toString() || "0";
        $5eebbd73ea5c6443$var$state.tokensPriceMap[networkAddress] = parseFloat(price);
        $5eebbd73ea5c6443$var$state.networkTokenSymbol = token?.symbol || "";
        $5eebbd73ea5c6443$var$state.networkPrice = price;
    },
    async getMyTokensWithBalance (forceUpdate) {
        const balances = await (0, $m3nYM.SwapApiUtil).getMyTokensWithBalance(forceUpdate);
        if (!balances) return;
        await this.getInitialGasPrice();
        this.setBalances(balances);
    },
    setBalances (balances) {
        const { networkAddress: networkAddress } = this.getParams();
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        if (!caipNetwork) return;
        const networkToken = balances.find((token)=>token.address === networkAddress);
        balances.forEach((token)=>{
            $5eebbd73ea5c6443$var$state.tokensPriceMap[token.address] = token.price || 0;
        });
        $5eebbd73ea5c6443$var$state.myTokensWithBalance = balances.filter((token)=>token.address.startsWith(caipNetwork.id));
        $5eebbd73ea5c6443$var$state.networkBalanceInUSD = networkToken ? (0, $l2EhC.NumberUtil).multiply(networkToken.quantity.numeric, networkToken.price).toString() : "0";
    },
    async getInitialGasPrice () {
        const res = await (0, $m3nYM.SwapApiUtil).fetchGasPrice();
        if (!res) return {
            gasPrice: null,
            gasPriceInUsd: null
        };
        const value = res.standard;
        const gasFee = BigInt(value);
        const gasLimit = BigInt($5eebbd73ea5c6443$export$3540a8643ebda500);
        const gasPrice = (0, $7WhJR.SwapCalculationUtil).getGasPriceInUSD($5eebbd73ea5c6443$var$state.networkPrice, gasLimit, gasFee);
        $5eebbd73ea5c6443$var$state.gasFee = value;
        $5eebbd73ea5c6443$var$state.gasPriceInUSD = gasPrice;
        return {
            gasPrice: gasFee,
            gasPriceInUSD: $5eebbd73ea5c6443$var$state.gasPriceInUSD
        };
    },
    // -- Swap -------------------------------------- //
    async swapTokens () {
        const address = (0, $f7IXw.AccountController).state.address;
        const sourceToken = $5eebbd73ea5c6443$var$state.sourceToken;
        const toToken = $5eebbd73ea5c6443$var$state.toToken;
        const haveSourceTokenAmount = (0, $l2EhC.NumberUtil).bigNumber($5eebbd73ea5c6443$var$state.sourceTokenAmount).isGreaterThan(0);
        if (!toToken || !sourceToken || $5eebbd73ea5c6443$var$state.loadingPrices || !haveSourceTokenAmount) return;
        $5eebbd73ea5c6443$var$state.loadingQuote = true;
        const amountDecimal = (0, $l2EhC.NumberUtil).bigNumber($5eebbd73ea5c6443$var$state.sourceTokenAmount).multipliedBy(10 ** sourceToken.decimals);
        const quoteResponse = await (0, $hxXs8.BlockchainApiController).fetchSwapQuote({
            userAddress: address,
            projectId: (0, $8BVTM.OptionsController).state.projectId,
            from: sourceToken.address,
            to: toToken.address,
            gasPrice: $5eebbd73ea5c6443$var$state.gasFee,
            amount: amountDecimal.toString()
        });
        $5eebbd73ea5c6443$var$state.loadingQuote = false;
        const quoteToAmount = quoteResponse?.quotes?.[0]?.toAmount;
        if (!quoteToAmount) return;
        const toTokenAmount = (0, $l2EhC.NumberUtil).bigNumber(quoteToAmount).dividedBy(10 ** toToken.decimals).toString();
        this.setToTokenAmount(toTokenAmount);
        const isInsufficientToken = this.hasInsufficientToken($5eebbd73ea5c6443$var$state.sourceTokenAmount, sourceToken.address);
        if (isInsufficientToken) $5eebbd73ea5c6443$var$state.inputError = "Insufficient balance";
        else {
            $5eebbd73ea5c6443$var$state.inputError = undefined;
            this.setTransactionDetails();
        }
    },
    // -- Create Transactions -------------------------------------- //
    async getTransaction () {
        const { fromCaipAddress: fromCaipAddress, availableToSwap: availableToSwap } = this.getParams();
        const sourceToken = $5eebbd73ea5c6443$var$state.sourceToken;
        const toToken = $5eebbd73ea5c6443$var$state.toToken;
        if (!fromCaipAddress || !availableToSwap || !sourceToken || !toToken || $5eebbd73ea5c6443$var$state.loadingQuote) return undefined;
        try {
            $5eebbd73ea5c6443$var$state.loadingBuildTransaction = true;
            const hasAllowance = await (0, $m3nYM.SwapApiUtil).fetchSwapAllowance({
                userAddress: fromCaipAddress,
                tokenAddress: sourceToken.address,
                sourceTokenAmount: $5eebbd73ea5c6443$var$state.sourceTokenAmount,
                sourceTokenDecimals: sourceToken.decimals
            });
            let transaction = undefined;
            if (hasAllowance) transaction = await this.createSwapTransaction();
            else transaction = await this.createAllowanceTransaction();
            $5eebbd73ea5c6443$var$state.loadingBuildTransaction = false;
            $5eebbd73ea5c6443$var$state.fetchError = false;
            return transaction;
        } catch (error) {
            (0, $6mRzS.RouterController).goBack();
            (0, $br7WV.SnackController).showError("Failed to check allowance");
            $5eebbd73ea5c6443$var$state.loadingBuildTransaction = false;
            $5eebbd73ea5c6443$var$state.approvalTransaction = undefined;
            $5eebbd73ea5c6443$var$state.swapTransaction = undefined;
            $5eebbd73ea5c6443$var$state.fetchError = true;
            return undefined;
        }
    },
    async createAllowanceTransaction () {
        const { fromCaipAddress: fromCaipAddress, fromAddress: fromAddress, sourceTokenAddress: sourceTokenAddress, toTokenAddress: toTokenAddress } = this.getParams();
        if (!fromCaipAddress || !toTokenAddress) return undefined;
        if (!sourceTokenAddress) throw new Error("createAllowanceTransaction - No source token address found.");
        try {
            const response = await (0, $hxXs8.BlockchainApiController).generateApproveCalldata({
                projectId: (0, $8BVTM.OptionsController).state.projectId,
                from: sourceTokenAddress,
                to: toTokenAddress,
                userAddress: fromCaipAddress
            });
            const gasLimit = await (0, $hlVrM.ConnectionController).estimateGas({
                address: fromAddress,
                to: (0, $c4rfq.CoreHelperUtil).getPlainAddress(response.tx.to),
                data: response.tx.data
            });
            const transaction = {
                data: response.tx.data,
                to: (0, $c4rfq.CoreHelperUtil).getPlainAddress(response.tx.from),
                gas: gasLimit,
                gasPrice: BigInt(response.tx.eip155.gasPrice),
                value: BigInt(response.tx.value),
                toAmount: $5eebbd73ea5c6443$var$state.toTokenAmount
            };
            $5eebbd73ea5c6443$var$state.swapTransaction = undefined;
            $5eebbd73ea5c6443$var$state.approvalTransaction = transaction;
            return transaction;
        } catch (error) {
            (0, $6mRzS.RouterController).goBack();
            (0, $br7WV.SnackController).showError("Failed to create approval transaction");
            $5eebbd73ea5c6443$var$state.approvalTransaction = undefined;
            $5eebbd73ea5c6443$var$state.swapTransaction = undefined;
            $5eebbd73ea5c6443$var$state.fetchError = true;
            return undefined;
        }
    },
    async createSwapTransaction () {
        const { networkAddress: networkAddress, fromCaipAddress: fromCaipAddress, sourceTokenAmount: sourceTokenAmount } = this.getParams();
        const sourceToken = $5eebbd73ea5c6443$var$state.sourceToken;
        const toToken = $5eebbd73ea5c6443$var$state.toToken;
        if (!fromCaipAddress || !sourceTokenAmount || !sourceToken || !toToken) return undefined;
        const amount = (0, $hlVrM.ConnectionController).parseUnits(sourceTokenAmount, sourceToken.decimals).toString();
        try {
            const response = await (0, $hxXs8.BlockchainApiController).generateSwapCalldata({
                projectId: (0, $8BVTM.OptionsController).state.projectId,
                userAddress: fromCaipAddress,
                from: sourceToken.address,
                to: toToken.address,
                amount: amount
            });
            const isSourceTokenIsNetworkToken = sourceToken.address === networkAddress;
            const gas = BigInt(response.tx.eip155.gas);
            const gasPrice = BigInt(response.tx.eip155.gasPrice);
            const transaction = {
                data: response.tx.data,
                to: (0, $c4rfq.CoreHelperUtil).getPlainAddress(response.tx.to),
                gas: gas,
                gasPrice: gasPrice,
                value: isSourceTokenIsNetworkToken ? BigInt(amount) : BigInt("0"),
                toAmount: $5eebbd73ea5c6443$var$state.toTokenAmount
            };
            $5eebbd73ea5c6443$var$state.gasPriceInUSD = (0, $7WhJR.SwapCalculationUtil).getGasPriceInUSD($5eebbd73ea5c6443$var$state.networkPrice, gas, gasPrice);
            $5eebbd73ea5c6443$var$state.approvalTransaction = undefined;
            $5eebbd73ea5c6443$var$state.swapTransaction = transaction;
            return transaction;
        } catch (error) {
            (0, $6mRzS.RouterController).goBack();
            (0, $br7WV.SnackController).showError("Failed to create transaction");
            $5eebbd73ea5c6443$var$state.approvalTransaction = undefined;
            $5eebbd73ea5c6443$var$state.swapTransaction = undefined;
            $5eebbd73ea5c6443$var$state.fetchError = true;
            return undefined;
        }
    },
    // -- Send Transactions --------------------------------- //
    async sendTransactionForApproval (data) {
        const { fromAddress: fromAddress, isAuthConnector: isAuthConnector } = this.getParams();
        $5eebbd73ea5c6443$var$state.loadingApprovalTransaction = true;
        const approveLimitMessage = `Approve limit increase in your wallet`;
        if (isAuthConnector) (0, $6mRzS.RouterController).pushTransactionStack({
            view: null,
            goBack: true,
            onSuccess () {
                (0, $br7WV.SnackController).showLoading(approveLimitMessage);
            }
        });
        else (0, $br7WV.SnackController).showLoading(approveLimitMessage);
        try {
            await (0, $hlVrM.ConnectionController).sendTransaction({
                address: fromAddress,
                to: data.to,
                data: data.data,
                value: BigInt(data.value),
                gasPrice: BigInt(data.gasPrice)
            });
            await this.swapTokens();
            await this.getTransaction();
            $5eebbd73ea5c6443$var$state.approvalTransaction = undefined;
            $5eebbd73ea5c6443$var$state.loadingApprovalTransaction = false;
        } catch (err) {
            const error = err;
            $5eebbd73ea5c6443$var$state.transactionError = error?.shortMessage;
            $5eebbd73ea5c6443$var$state.loadingApprovalTransaction = false;
            (0, $br7WV.SnackController).showError(error?.shortMessage || "Transaction error");
        }
    },
    async sendTransactionForSwap (data) {
        if (!data) return undefined;
        const { fromAddress: fromAddress, toTokenAmount: toTokenAmount, isAuthConnector: isAuthConnector } = this.getParams();
        $5eebbd73ea5c6443$var$state.loadingTransaction = true;
        const snackbarPendingMessage = `Swapping ${$5eebbd73ea5c6443$var$state.sourceToken?.symbol} to ${(0, $l2EhC.NumberUtil).formatNumberToLocalString(toTokenAmount, 3)} ${$5eebbd73ea5c6443$var$state.toToken?.symbol}`;
        const snackbarSuccessMessage = `Swapped ${$5eebbd73ea5c6443$var$state.sourceToken?.symbol} to ${(0, $l2EhC.NumberUtil).formatNumberToLocalString(toTokenAmount, 3)} ${$5eebbd73ea5c6443$var$state.toToken?.symbol}`;
        if (isAuthConnector) (0, $6mRzS.RouterController).pushTransactionStack({
            view: "Account",
            goBack: false,
            onSuccess () {
                (0, $br7WV.SnackController).showLoading(snackbarPendingMessage);
                $5eebbd73ea5c6443$export$cb69c6a27866a8a5.resetState();
            }
        });
        else (0, $br7WV.SnackController).showLoading("Confirm transaction in your wallet");
        try {
            const forceUpdateAddresses = [
                $5eebbd73ea5c6443$var$state.sourceToken?.address,
                $5eebbd73ea5c6443$var$state.toToken?.address
            ].join(",");
            const transactionHash = await (0, $hlVrM.ConnectionController).sendTransaction({
                address: fromAddress,
                to: data.to,
                data: data.data,
                gas: data.gas,
                gasPrice: BigInt(data.gasPrice),
                value: data.value
            });
            $5eebbd73ea5c6443$var$state.loadingTransaction = false;
            (0, $br7WV.SnackController).showSuccess(snackbarSuccessMessage);
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "SWAP_SUCCESS",
                properties: {
                    network: (0, $jbD0z.NetworkController).state.caipNetwork?.id || "",
                    swapFromToken: this.state.sourceToken?.symbol || "",
                    swapToToken: this.state.toToken?.symbol || "",
                    swapFromAmount: this.state.sourceTokenAmount || "",
                    swapToAmount: this.state.toTokenAmount || "",
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                }
            });
            $5eebbd73ea5c6443$export$cb69c6a27866a8a5.resetState();
            if (!isAuthConnector) (0, $6mRzS.RouterController).replace("Account");
            $5eebbd73ea5c6443$export$cb69c6a27866a8a5.getMyTokensWithBalance(forceUpdateAddresses);
            return transactionHash;
        } catch (err) {
            const error = err;
            $5eebbd73ea5c6443$var$state.transactionError = error?.shortMessage;
            $5eebbd73ea5c6443$var$state.loadingTransaction = false;
            (0, $br7WV.SnackController).showError(error?.shortMessage || "Transaction error");
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "SWAP_ERROR",
                properties: {
                    network: (0, $jbD0z.NetworkController).state.caipNetwork?.id || "",
                    swapFromToken: this.state.sourceToken?.symbol || "",
                    swapToToken: this.state.toToken?.symbol || "",
                    swapFromAmount: this.state.sourceTokenAmount || "",
                    swapToAmount: this.state.toTokenAmount || "",
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                }
            });
            return undefined;
        }
    },
    // -- Checks -------------------------------------------- //
    hasInsufficientToken (sourceTokenAmount, sourceTokenAddress) {
        const isInsufficientSourceTokenForSwap = (0, $7WhJR.SwapCalculationUtil).isInsufficientSourceTokenForSwap(sourceTokenAmount, sourceTokenAddress, $5eebbd73ea5c6443$var$state.myTokensWithBalance);
        const insufficientNetworkTokenForGas = (0, $7WhJR.SwapCalculationUtil).isInsufficientNetworkTokenForGas($5eebbd73ea5c6443$var$state.networkBalanceInUSD, $5eebbd73ea5c6443$var$state.gasPriceInUSD);
        return insufficientNetworkTokenForGas || isInsufficientSourceTokenForSwap;
    },
    // -- Calculations -------------------------------------- //
    setTransactionDetails () {
        const { toTokenAddress: toTokenAddress, toTokenDecimals: toTokenDecimals } = this.getParams();
        if (!toTokenAddress || !toTokenDecimals) return;
        $5eebbd73ea5c6443$var$state.gasPriceInUSD = (0, $7WhJR.SwapCalculationUtil).getGasPriceInUSD($5eebbd73ea5c6443$var$state.networkPrice, BigInt($5eebbd73ea5c6443$var$state.gasFee), BigInt($5eebbd73ea5c6443$export$3540a8643ebda500));
        $5eebbd73ea5c6443$var$state.priceImpact = (0, $7WhJR.SwapCalculationUtil).getPriceImpact({
            sourceTokenAmount: $5eebbd73ea5c6443$var$state.sourceTokenAmount,
            sourceTokenPriceInUSD: $5eebbd73ea5c6443$var$state.sourceTokenPriceInUSD,
            toTokenPriceInUSD: $5eebbd73ea5c6443$var$state.toTokenPriceInUSD,
            toTokenAmount: $5eebbd73ea5c6443$var$state.toTokenAmount
        });
        $5eebbd73ea5c6443$var$state.maxSlippage = (0, $7WhJR.SwapCalculationUtil).getMaxSlippage($5eebbd73ea5c6443$var$state.slippage, $5eebbd73ea5c6443$var$state.toTokenAmount);
        $5eebbd73ea5c6443$var$state.providerFee = (0, $7WhJR.SwapCalculationUtil).getProviderFee($5eebbd73ea5c6443$var$state.sourceTokenAmount);
    }
};

});
parcelRegister("hlVrM", function(module, exports) {

$parcel$export(module.exports, "ConnectionController", function () { return $ca20f5a1140538a0$export$303deccbe6e8c782; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $c4rfq = parcelRequire("c4rfq");

var $hdC6E = parcelRequire("hdC6E");

var $i2wHx = parcelRequire("i2wHx");

var $d94Xg = parcelRequire("d94Xg");
parcelRequire("dUH6N");

var $ib7WC = parcelRequire("ib7WC");

var $7Xn6F = parcelRequire("7Xn6F");

var $6m17w = parcelRequire("6m17w");

var $jbD0z = parcelRequire("jbD0z");
// -- State --------------------------------------------- //
const $ca20f5a1140538a0$var$state = (0, $eAQzZ.proxy)({
    wcError: false,
    buffering: false
});
const $ca20f5a1140538a0$export$303deccbe6e8c782 = {
    state: $ca20f5a1140538a0$var$state,
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($ca20f5a1140538a0$var$state, key, callback);
    },
    _getClient (chain) {
        return (0, $d94Xg.ChainController).getConnectionControllerClient(chain);
    },
    setClient (client) {
        $ca20f5a1140538a0$var$state._client = (0, $eAQzZ.ref)(client);
    },
    async connectWalletConnect () {
        (0, $hdC6E.StorageUtil).setConnectedConnector("WALLET_CONNECT");
        await this._getClient().connectWalletConnect((uri)=>{
            $ca20f5a1140538a0$var$state.wcUri = uri;
            $ca20f5a1140538a0$var$state.wcPairingExpiry = (0, $c4rfq.CoreHelperUtil).getPairingExpiry();
        });
    },
    async connectExternal (options, chain) {
        await this._getClient(chain).connectExternal?.(options);
        (0, $d94Xg.ChainController).setActiveChain(chain);
        (0, $hdC6E.StorageUtil).setConnectedConnector(options.type);
    },
    async reconnectExternal (options) {
        await this._getClient().reconnectExternal?.(options);
        (0, $hdC6E.StorageUtil).setConnectedConnector(options.type);
    },
    async setPreferredAccountType (accountType) {
        (0, $ib7WC.ModalController).setLoading(true);
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (!authConnector) return;
        await authConnector?.provider.setPreferredAccount(accountType);
        await this.reconnectExternal(authConnector);
        (0, $ib7WC.ModalController).setLoading(false);
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SET_PREFERRED_ACCOUNT_TYPE",
            properties: {
                accountType: accountType,
                network: (0, $jbD0z.NetworkController).state.caipNetwork?.id || ""
            }
        });
    },
    async signMessage (message) {
        return this._getClient().signMessage(message);
    },
    parseUnits (value, decimals) {
        return this._getClient().parseUnits(value, decimals);
    },
    formatUnits (value, decimals) {
        return this._getClient().formatUnits(value, decimals);
    },
    async sendTransaction (args) {
        return this._getClient().sendTransaction(args);
    },
    async estimateGas (args) {
        return this._getClient().estimateGas(args);
    },
    async writeContract (args) {
        return this._getClient().writeContract(args);
    },
    async getEnsAddress (value) {
        return this._getClient().getEnsAddress(value);
    },
    async getEnsAvatar (value) {
        return this._getClient().getEnsAvatar(value);
    },
    checkInstalled (ids, chain) {
        return this._getClient(chain).checkInstalled?.(ids) || false;
    },
    resetWcConnection () {
        $ca20f5a1140538a0$var$state.wcUri = undefined;
        $ca20f5a1140538a0$var$state.wcPairingExpiry = undefined;
        $ca20f5a1140538a0$var$state.wcLinking = undefined;
        $ca20f5a1140538a0$var$state.recentWallet = undefined;
        (0, $i2wHx.TransactionsController).resetTransactions();
        (0, $hdC6E.StorageUtil).deleteWalletConnectDeepLink();
    },
    setWcLinking (wcLinking) {
        $ca20f5a1140538a0$var$state.wcLinking = wcLinking;
    },
    setWcError (wcError) {
        $ca20f5a1140538a0$var$state.wcError = wcError;
        $ca20f5a1140538a0$var$state.buffering = false;
    },
    setRecentWallet (wallet) {
        $ca20f5a1140538a0$var$state.recentWallet = wallet;
    },
    setBuffering (buffering) {
        $ca20f5a1140538a0$var$state.buffering = buffering;
    },
    async disconnect () {
        const client = this._getClient();
        try {
            await client.disconnect();
            this.resetWcConnection();
        } catch (error) {
            throw new Error("Failed to disconnect");
        }
    }
};

});
parcelRegister("i2wHx", function(module, exports) {

$parcel$export(module.exports, "TransactionsController", function () { return $d221c7aa4ca26cc3$export$da1e018e28e23fb0; });

var $eAQzZ = parcelRequire("eAQzZ");

var $8BVTM = parcelRequire("8BVTM");

var $6m17w = parcelRequire("6m17w");

var $br7WV = parcelRequire("br7WV");

var $jbD0z = parcelRequire("jbD0z");

var $hxXs8 = parcelRequire("hxXs8");

var $f7IXw = parcelRequire("f7IXw");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
// -- State --------------------------------------------- //
const $d221c7aa4ca26cc3$var$state = (0, $eAQzZ.proxy)({
    transactions: [],
    coinbaseTransactions: {},
    transactionsByYear: {},
    lastNetworkInView: undefined,
    loading: false,
    empty: false,
    next: undefined
});
const $d221c7aa4ca26cc3$export$da1e018e28e23fb0 = {
    state: $d221c7aa4ca26cc3$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($d221c7aa4ca26cc3$var$state, ()=>callback($d221c7aa4ca26cc3$var$state));
    },
    setLastNetworkInView (lastNetworkInView) {
        $d221c7aa4ca26cc3$var$state.lastNetworkInView = lastNetworkInView;
    },
    async fetchTransactions (accountAddress, onramp) {
        const { projectId: projectId } = (0, $8BVTM.OptionsController).state;
        if (!projectId || !accountAddress) throw new Error("Transactions can't be fetched without a projectId and an accountAddress");
        $d221c7aa4ca26cc3$var$state.loading = true;
        try {
            const response = await (0, $hxXs8.BlockchainApiController).fetchTransactions({
                account: accountAddress,
                projectId: projectId,
                cursor: $d221c7aa4ca26cc3$var$state.next,
                onramp: onramp,
                // Coinbase transaction history state updates require the latest data
                cache: onramp === "coinbase" ? "no-cache" : undefined
            });
            const nonSpamTransactions = this.filterSpamTransactions(response.data);
            const sameChainTransactions = this.filterByConnectedChain(nonSpamTransactions);
            const filteredTransactions = [
                ...$d221c7aa4ca26cc3$var$state.transactions,
                ...sameChainTransactions
            ];
            $d221c7aa4ca26cc3$var$state.loading = false;
            if (onramp === "coinbase") $d221c7aa4ca26cc3$var$state.coinbaseTransactions = this.groupTransactionsByYearAndMonth($d221c7aa4ca26cc3$var$state.coinbaseTransactions, response.data);
            else {
                $d221c7aa4ca26cc3$var$state.transactions = filteredTransactions;
                $d221c7aa4ca26cc3$var$state.transactionsByYear = this.groupTransactionsByYearAndMonth($d221c7aa4ca26cc3$var$state.transactionsByYear, sameChainTransactions);
            }
            $d221c7aa4ca26cc3$var$state.empty = filteredTransactions.length === 0;
            $d221c7aa4ca26cc3$var$state.next = response.next ? response.next : undefined;
        } catch (error) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "ERROR_FETCH_TRANSACTIONS",
                properties: {
                    address: accountAddress,
                    projectId: projectId,
                    cursor: $d221c7aa4ca26cc3$var$state.next,
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                }
            });
            (0, $br7WV.SnackController).showError("Failed to fetch transactions");
            $d221c7aa4ca26cc3$var$state.loading = false;
            $d221c7aa4ca26cc3$var$state.empty = true;
            $d221c7aa4ca26cc3$var$state.next = undefined;
        }
    },
    groupTransactionsByYearAndMonth (transactionsMap = {}, transactions = []) {
        const grouped = transactionsMap;
        transactions.forEach((transaction)=>{
            const year = new Date(transaction.metadata.minedAt).getFullYear();
            const month = new Date(transaction.metadata.minedAt).getMonth();
            const yearTransactions = grouped[year] ?? {};
            const monthTransactions = yearTransactions[month] ?? [];
            // If there's a transaction with the same id, remove the old one
            const newMonthTransactions = monthTransactions.filter((tx)=>tx.id !== transaction.id);
            grouped[year] = {
                ...yearTransactions,
                [month]: [
                    ...newMonthTransactions,
                    transaction
                ].sort((a, b)=>new Date(b.metadata.minedAt).getTime() - new Date(a.metadata.minedAt).getTime())
            };
        });
        return grouped;
    },
    filterSpamTransactions (transactions) {
        return transactions.filter((transaction)=>{
            const isAllSpam = transaction.transfers.every((transfer)=>transfer.nft_info?.flags.is_spam === true);
            return !isAllSpam;
        });
    },
    filterByConnectedChain (transactions) {
        const chainId = (0, $jbD0z.NetworkController).state.caipNetwork?.id;
        const filteredTransactions = transactions.filter((transaction)=>transaction.metadata.chain === chainId);
        return filteredTransactions;
    },
    clearCursor () {
        $d221c7aa4ca26cc3$var$state.next = undefined;
    },
    resetTransactions () {
        $d221c7aa4ca26cc3$var$state.transactions = [];
        $d221c7aa4ca26cc3$var$state.transactionsByYear = {};
        $d221c7aa4ca26cc3$var$state.lastNetworkInView = undefined;
        $d221c7aa4ca26cc3$var$state.loading = false;
        $d221c7aa4ca26cc3$var$state.empty = false;
        $d221c7aa4ca26cc3$var$state.next = undefined;
    }
};

});
parcelRegister("dUH6N", function(module, exports) {

$parcel$export(module.exports, "W3mFrameHelpers", function () { return (parcelRequire("l0IQQ")).W3mFrameHelpers; });
$parcel$export(module.exports, "W3mFrameProvider", function () { return (parcelRequire("2xFCG")).W3mFrameProvider; });
$parcel$export(module.exports, "W3mFrameRpcConstants", function () { return (parcelRequire("lr7C8")).W3mFrameRpcConstants; });
parcelRequire("3UUkO");

var $jA9AY = parcelRequire("jA9AY");

var $l0IQQ = parcelRequire("l0IQQ");

var $2xFCG = parcelRequire("2xFCG");

var $7gB8q = parcelRequire("7gB8q");

var $lr7C8 = parcelRequire("lr7C8");

var $jFjd7 = parcelRequire("jFjd7");

});
parcelRegister("3UUkO", function(module, exports) {

var $fxkLe = parcelRequire("fxkLe");
if (typeof window !== "undefined") {
    if (!window.Buffer) window.Buffer = (0, $fxkLe.Buffer);
    if (!window.global) window.global = window;
    if (!window.process) window.process = {};
    if (!window.process?.env) window.process = {
        env: {}
    };
}

});
parcelRegister("fxkLe", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $b4fa0ac54ada5015$export$a143d493d941bafc; }, function (v) { return $b4fa0ac54ada5015$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a; }, function (v) { return $b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $b4fa0ac54ada5015$export$f99ded8fe4b79145; }, function (v) { return $b4fa0ac54ada5015$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $b4fa0ac54ada5015$export$599f31c3813fae4d; }, function (v) { return $b4fa0ac54ada5015$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $b4fa0ac54ada5015$export$a143d493d941bafc;
var $b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a;
var $b4fa0ac54ada5015$export$f99ded8fe4b79145;
var $b4fa0ac54ada5015$export$599f31c3813fae4d;
"use strict";

var $gs6Tx = parcelRequire("gs6Tx");

var $352wC = parcelRequire("352wC");
const $b4fa0ac54ada5015$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$b4fa0ac54ada5015$export$a143d493d941bafc = $b4fa0ac54ada5015$var$Buffer;
$b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a = $b4fa0ac54ada5015$var$SlowBuffer;
$b4fa0ac54ada5015$export$f99ded8fe4b79145 = 50;
const $b4fa0ac54ada5015$var$K_MAX_LENGTH = 0x7fffffff;
$b4fa0ac54ada5015$export$599f31c3813fae4d = $b4fa0ac54ada5015$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $b4fa0ac54ada5015$var$Buffer.TYPED_ARRAY_SUPPORT = $b4fa0ac54ada5015$var$typedArraySupport();
if (!$b4fa0ac54ada5015$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $b4fa0ac54ada5015$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($b4fa0ac54ada5015$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($b4fa0ac54ada5015$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $b4fa0ac54ada5015$var$createBuffer(length) {
    if (length > $b4fa0ac54ada5015$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $b4fa0ac54ada5015$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $b4fa0ac54ada5015$var$allocUnsafe(arg);
    }
    return $b4fa0ac54ada5015$var$from(arg, encodingOrOffset, length);
}
$b4fa0ac54ada5015$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $b4fa0ac54ada5015$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $b4fa0ac54ada5015$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $b4fa0ac54ada5015$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($b4fa0ac54ada5015$var$isInstance(value, ArrayBuffer) || value && $b4fa0ac54ada5015$var$isInstance(value.buffer, ArrayBuffer)) return $b4fa0ac54ada5015$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($b4fa0ac54ada5015$var$isInstance(value, SharedArrayBuffer) || value && $b4fa0ac54ada5015$var$isInstance(value.buffer, SharedArrayBuffer))) return $b4fa0ac54ada5015$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $b4fa0ac54ada5015$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $b4fa0ac54ada5015$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $b4fa0ac54ada5015$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $b4fa0ac54ada5015$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $b4fa0ac54ada5015$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($b4fa0ac54ada5015$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($b4fa0ac54ada5015$var$Buffer, Uint8Array);
function $b4fa0ac54ada5015$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $b4fa0ac54ada5015$var$alloc(size, fill, encoding) {
    $b4fa0ac54ada5015$var$assertSize(size);
    if (size <= 0) return $b4fa0ac54ada5015$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $b4fa0ac54ada5015$var$createBuffer(size).fill(fill, encoding) : $b4fa0ac54ada5015$var$createBuffer(size).fill(fill);
    return $b4fa0ac54ada5015$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $b4fa0ac54ada5015$var$Buffer.alloc = function(size, fill, encoding) {
    return $b4fa0ac54ada5015$var$alloc(size, fill, encoding);
};
function $b4fa0ac54ada5015$var$allocUnsafe(size) {
    $b4fa0ac54ada5015$var$assertSize(size);
    return $b4fa0ac54ada5015$var$createBuffer(size < 0 ? 0 : $b4fa0ac54ada5015$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $b4fa0ac54ada5015$var$Buffer.allocUnsafe = function(size) {
    return $b4fa0ac54ada5015$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $b4fa0ac54ada5015$var$Buffer.allocUnsafeSlow = function(size) {
    return $b4fa0ac54ada5015$var$allocUnsafe(size);
};
function $b4fa0ac54ada5015$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$b4fa0ac54ada5015$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $b4fa0ac54ada5015$var$byteLength(string, encoding) | 0;
    let buf = $b4fa0ac54ada5015$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $b4fa0ac54ada5015$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $b4fa0ac54ada5015$var$checked(array.length) | 0;
    const buf = $b4fa0ac54ada5015$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $b4fa0ac54ada5015$var$fromArrayView(arrayView) {
    if ($b4fa0ac54ada5015$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $b4fa0ac54ada5015$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $b4fa0ac54ada5015$var$fromArrayLike(arrayView);
}
function $b4fa0ac54ada5015$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return buf;
}
function $b4fa0ac54ada5015$var$fromObject(obj) {
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(obj)) {
        const len = $b4fa0ac54ada5015$var$checked(obj.length) | 0;
        const buf = $b4fa0ac54ada5015$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $b4fa0ac54ada5015$var$numberIsNaN(obj.length)) return $b4fa0ac54ada5015$var$createBuffer(0);
        return $b4fa0ac54ada5015$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $b4fa0ac54ada5015$var$fromArrayLike(obj.data);
}
function $b4fa0ac54ada5015$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $b4fa0ac54ada5015$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $b4fa0ac54ada5015$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $b4fa0ac54ada5015$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $b4fa0ac54ada5015$var$Buffer.alloc(+length);
}
$b4fa0ac54ada5015$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $b4fa0ac54ada5015$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$b4fa0ac54ada5015$var$Buffer.compare = function compare(a, b) {
    if ($b4fa0ac54ada5015$var$isInstance(a, Uint8Array)) a = $b4fa0ac54ada5015$var$Buffer.from(a, a.offset, a.byteLength);
    if ($b4fa0ac54ada5015$var$isInstance(b, Uint8Array)) b = $b4fa0ac54ada5015$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(a) || !$b4fa0ac54ada5015$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$b4fa0ac54ada5015$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$b4fa0ac54ada5015$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $b4fa0ac54ada5015$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $b4fa0ac54ada5015$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($b4fa0ac54ada5015$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) buf = $b4fa0ac54ada5015$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $b4fa0ac54ada5015$var$byteLength(string, encoding) {
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $b4fa0ac54ada5015$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $b4fa0ac54ada5015$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $b4fa0ac54ada5015$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $b4fa0ac54ada5015$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$b4fa0ac54ada5015$var$Buffer.byteLength = $b4fa0ac54ada5015$var$byteLength;
function $b4fa0ac54ada5015$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $b4fa0ac54ada5015$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $b4fa0ac54ada5015$var$utf8Slice(this, start, end);
        case "ascii":
            return $b4fa0ac54ada5015$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $b4fa0ac54ada5015$var$latin1Slice(this, start, end);
        case "base64":
            return $b4fa0ac54ada5015$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b4fa0ac54ada5015$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$b4fa0ac54ada5015$var$Buffer.prototype._isBuffer = true;
function $b4fa0ac54ada5015$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$b4fa0ac54ada5015$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$b4fa0ac54ada5015$var$swap(this, i, i + 1);
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $b4fa0ac54ada5015$var$swap(this, i, i + 3);
        $b4fa0ac54ada5015$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $b4fa0ac54ada5015$var$swap(this, i, i + 7);
        $b4fa0ac54ada5015$var$swap(this, i + 1, i + 6);
        $b4fa0ac54ada5015$var$swap(this, i + 2, i + 5);
        $b4fa0ac54ada5015$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $b4fa0ac54ada5015$var$utf8Slice(this, 0, length);
    return $b4fa0ac54ada5015$var$slowToString.apply(this, arguments);
};
$b4fa0ac54ada5015$var$Buffer.prototype.toLocaleString = $b4fa0ac54ada5015$var$Buffer.prototype.toString;
$b4fa0ac54ada5015$var$Buffer.prototype.equals = function equals(b) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $b4fa0ac54ada5015$var$Buffer.compare(this, b) === 0;
};
$b4fa0ac54ada5015$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $b4fa0ac54ada5015$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($b4fa0ac54ada5015$var$customInspectSymbol) $b4fa0ac54ada5015$var$Buffer.prototype[$b4fa0ac54ada5015$var$customInspectSymbol] = $b4fa0ac54ada5015$var$Buffer.prototype.inspect;
$b4fa0ac54ada5015$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($b4fa0ac54ada5015$var$isInstance(target, Uint8Array)) target = $b4fa0ac54ada5015$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $b4fa0ac54ada5015$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($b4fa0ac54ada5015$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $b4fa0ac54ada5015$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $b4fa0ac54ada5015$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $b4fa0ac54ada5015$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $b4fa0ac54ada5015$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$b4fa0ac54ada5015$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $b4fa0ac54ada5015$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$b4fa0ac54ada5015$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $b4fa0ac54ada5015$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $b4fa0ac54ada5015$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($b4fa0ac54ada5015$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $b4fa0ac54ada5015$var$utf8Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $b4fa0ac54ada5015$var$asciiWrite(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$asciiToBytes(string), buf, offset, length);
}
function $b4fa0ac54ada5015$var$base64Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$base64ToBytes(string), buf, offset, length);
}
function $b4fa0ac54ada5015$var$ucs2Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$b4fa0ac54ada5015$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $b4fa0ac54ada5015$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $b4fa0ac54ada5015$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $b4fa0ac54ada5015$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $b4fa0ac54ada5015$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b4fa0ac54ada5015$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$b4fa0ac54ada5015$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $b4fa0ac54ada5015$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gs6Tx.fromByteArray(buf);
    else return $gs6Tx.fromByteArray(buf.slice(start, end));
}
function $b4fa0ac54ada5015$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $b4fa0ac54ada5015$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $b4fa0ac54ada5015$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $b4fa0ac54ada5015$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $b4fa0ac54ada5015$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $b4fa0ac54ada5015$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $b4fa0ac54ada5015$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $b4fa0ac54ada5015$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$b4fa0ac54ada5015$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $b4fa0ac54ada5015$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$b4fa0ac54ada5015$var$Buffer.prototype.readUintLE = $b4fa0ac54ada5015$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUintBE = $b4fa0ac54ada5015$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint8 = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint16LE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint16BE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint32LE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint32BE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readBigUInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$b4fa0ac54ada5015$var$Buffer.prototype.readBigUInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readBigInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readBigInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return $352wC.read(this, offset, true, 23, 4);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return $352wC.read(this, offset, false, 23, 4);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 8, this.length);
    return $352wC.read(this, offset, true, 52, 8);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 8, this.length);
    return $352wC.read(this, offset, false, 52, 8);
};
function $b4fa0ac54ada5015$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeUintLE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUintBE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint8 = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint16LE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint16BE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint32LE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint32BE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $b4fa0ac54ada5015$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $b4fa0ac54ada5015$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigUInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigUInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $b4fa0ac54ada5015$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $352wC.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeFloat(this, value, offset, true, noAssert);
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeFloat(this, value, offset, false, noAssert);
};
function $b4fa0ac54ada5015$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $352wC.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeDouble(this, value, offset, true, noAssert);
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$b4fa0ac54ada5015$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$b4fa0ac54ada5015$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$b4fa0ac54ada5015$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $b4fa0ac54ada5015$var$Buffer.isBuffer(val) ? val : $b4fa0ac54ada5015$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $b4fa0ac54ada5015$var$errors = {};
function $b4fa0ac54ada5015$var$E(sym, getMessage, Base) {
    $b4fa0ac54ada5015$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$b4fa0ac54ada5015$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$b4fa0ac54ada5015$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$b4fa0ac54ada5015$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $b4fa0ac54ada5015$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $b4fa0ac54ada5015$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $b4fa0ac54ada5015$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $b4fa0ac54ada5015$var$checkBounds(buf, offset, byteLength) {
    $b4fa0ac54ada5015$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $b4fa0ac54ada5015$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $b4fa0ac54ada5015$var$checkBounds(buf, offset, byteLength);
}
function $b4fa0ac54ada5015$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $b4fa0ac54ada5015$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $b4fa0ac54ada5015$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $b4fa0ac54ada5015$var$validateNumber(value, type);
        throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $b4fa0ac54ada5015$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $b4fa0ac54ada5015$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $b4fa0ac54ada5015$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($b4fa0ac54ada5015$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $b4fa0ac54ada5015$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $b4fa0ac54ada5015$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $b4fa0ac54ada5015$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $b4fa0ac54ada5015$var$base64ToBytes(str) {
    return $gs6Tx.toByteArray($b4fa0ac54ada5015$var$base64clean(str));
}
function $b4fa0ac54ada5015$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $b4fa0ac54ada5015$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $b4fa0ac54ada5015$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $b4fa0ac54ada5015$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $b4fa0ac54ada5015$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $b4fa0ac54ada5015$var$BufferBigIntNotDefined : fn;
}
function $b4fa0ac54ada5015$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("gs6Tx", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $bfa49c0062a5803d$export$d622b2ad8d90c771; }, function (v) { return $bfa49c0062a5803d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $bfa49c0062a5803d$export$6100ba28696e12de; }, function (v) { return $bfa49c0062a5803d$export$6100ba28696e12de = v; });
var $bfa49c0062a5803d$export$a48f0734ac7c2329;
var $bfa49c0062a5803d$export$d622b2ad8d90c771;
var $bfa49c0062a5803d$export$6100ba28696e12de;
"use strict";
$bfa49c0062a5803d$export$a48f0734ac7c2329 = $bfa49c0062a5803d$var$byteLength;
$bfa49c0062a5803d$export$d622b2ad8d90c771 = $bfa49c0062a5803d$var$toByteArray;
$bfa49c0062a5803d$export$6100ba28696e12de = $bfa49c0062a5803d$var$fromByteArray;
var $bfa49c0062a5803d$var$lookup = [];
var $bfa49c0062a5803d$var$revLookup = [];
var $bfa49c0062a5803d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $bfa49c0062a5803d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $bfa49c0062a5803d$var$i = 0, $bfa49c0062a5803d$var$len = $bfa49c0062a5803d$var$code.length; $bfa49c0062a5803d$var$i < $bfa49c0062a5803d$var$len; ++$bfa49c0062a5803d$var$i){
    $bfa49c0062a5803d$var$lookup[$bfa49c0062a5803d$var$i] = $bfa49c0062a5803d$var$code[$bfa49c0062a5803d$var$i];
    $bfa49c0062a5803d$var$revLookup[$bfa49c0062a5803d$var$code.charCodeAt($bfa49c0062a5803d$var$i)] = $bfa49c0062a5803d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bfa49c0062a5803d$var$revLookup["-".charCodeAt(0)] = 62;
$bfa49c0062a5803d$var$revLookup["_".charCodeAt(0)] = 63;
function $bfa49c0062a5803d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bfa49c0062a5803d$var$byteLength(b64) {
    var lens = $bfa49c0062a5803d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa49c0062a5803d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa49c0062a5803d$var$toByteArray(b64) {
    var tmp;
    var lens = $bfa49c0062a5803d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bfa49c0062a5803d$var$Arr($bfa49c0062a5803d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 18 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 2 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 10 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bfa49c0062a5803d$var$tripletToBase64(num) {
    return $bfa49c0062a5803d$var$lookup[num >> 18 & 0x3F] + $bfa49c0062a5803d$var$lookup[num >> 12 & 0x3F] + $bfa49c0062a5803d$var$lookup[num >> 6 & 0x3F] + $bfa49c0062a5803d$var$lookup[num & 0x3F];
}
function $bfa49c0062a5803d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bfa49c0062a5803d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $bfa49c0062a5803d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bfa49c0062a5803d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bfa49c0062a5803d$var$lookup[tmp >> 2] + $bfa49c0062a5803d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bfa49c0062a5803d$var$lookup[tmp >> 10] + $bfa49c0062a5803d$var$lookup[tmp >> 4 & 0x3F] + $bfa49c0062a5803d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("352wC", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $23e3cc2fb993da68$export$aafa59e2e03f2942; }, function (v) { return $23e3cc2fb993da68$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $23e3cc2fb993da68$export$68d8715fc104d294; }, function (v) { return $23e3cc2fb993da68$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $23e3cc2fb993da68$export$aafa59e2e03f2942;
var $23e3cc2fb993da68$export$68d8715fc104d294;
$23e3cc2fb993da68$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$23e3cc2fb993da68$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("jA9AY", function(module, exports) {

$parcel$export(module.exports, "W3mFrame", function () { return $e418d28d58d94ec7$export$668e35d4f1b0aa08; });

var $lr7C8 = parcelRequire("lr7C8");

var $7gB8q = parcelRequire("7gB8q");

var $l0IQQ = parcelRequire("l0IQQ");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
class $e418d28d58d94ec7$export$668e35d4f1b0aa08 {
    constructor(projectId, isAppClient = false, chainId = "eip155:1"){
        this.iframe = null;
        this.rpcUrl = (0, $1VCt9.ConstantsUtil).BLOCKCHAIN_API_RPC_URL;
        this.events = {
            registerFrameEventHandler: (id, callback, signal)=>{
                function eventHandler({ data: data }) {
                    if (!data.type?.includes((0, $lr7C8.W3mFrameConstants).FRAME_EVENT_KEY)) return;
                    const frameEvent = (0, $7gB8q.W3mFrameSchema).frameEvent.parse(data);
                    if (frameEvent.id === id) {
                        callback(frameEvent);
                        window.removeEventListener("message", eventHandler);
                    }
                }
                if ((0, $l0IQQ.W3mFrameHelpers).isClient) {
                    window.addEventListener("message", eventHandler);
                    signal.addEventListener("abort", ()=>{
                        window.removeEventListener("message", eventHandler);
                    });
                }
            },
            onFrameEvent: (callback)=>{
                if ((0, $l0IQQ.W3mFrameHelpers).isClient) window.addEventListener("message", ({ data: data })=>{
                    if (!data.type?.includes((0, $lr7C8.W3mFrameConstants).FRAME_EVENT_KEY)) return;
                    const frameEvent = (0, $7gB8q.W3mFrameSchema).frameEvent.parse(data);
                    callback(frameEvent);
                });
            },
            onAppEvent: (callback)=>{
                if ((0, $l0IQQ.W3mFrameHelpers).isClient) window.addEventListener("message", ({ data: data })=>{
                    if (!data.type?.includes((0, $lr7C8.W3mFrameConstants).APP_EVENT_KEY)) return;
                    const appEvent = (0, $7gB8q.W3mFrameSchema).appEvent.parse(data);
                    callback(appEvent);
                });
            },
            postAppEvent: (event)=>{
                if ((0, $l0IQQ.W3mFrameHelpers).isClient) {
                    if (!this.iframe?.contentWindow) throw new Error("W3mFrame: iframe is not set");
                    (0, $7gB8q.W3mFrameSchema).appEvent.parse(event);
                    this.iframe.contentWindow.postMessage(event, "*");
                }
            },
            postFrameEvent: (event)=>{
                if ((0, $l0IQQ.W3mFrameHelpers).isClient) {
                    if (!parent) throw new Error("W3mFrame: parent is not set");
                    (0, $7gB8q.W3mFrameSchema).frameEvent.parse(event);
                    parent.postMessage(event, "*");
                }
            }
        };
        this.projectId = projectId;
        this.frameLoadPromise = new Promise((resolve, reject)=>{
            this.frameLoadPromiseResolver = {
                resolve: resolve,
                reject: reject
            };
        });
        if (isAppClient) {
            this.frameLoadPromise = new Promise((resolve, reject)=>{
                this.frameLoadPromiseResolver = {
                    resolve: resolve,
                    reject: reject
                };
            });
            if ((0, $l0IQQ.W3mFrameHelpers).isClient) {
                const iframe = document.createElement("iframe");
                iframe.id = "w3m-iframe";
                iframe.src = `${0, $lr7C8.SECURE_SITE_SDK}?projectId=${projectId}&chainId=${chainId}`;
                iframe.name = "w3m-secure-iframe";
                iframe.style.position = "fixed";
                iframe.style.zIndex = "999999";
                iframe.style.display = "none";
                iframe.style.animationDelay = "0s, 50ms";
                iframe.style.borderBottomLeftRadius = `clamp(0px, var(--wui-border-radius-l), 44px)`;
                iframe.style.borderBottomRightRadius = `clamp(0px, var(--wui-border-radius-l), 44px)`;
                document.body.appendChild(iframe);
                this.iframe = iframe;
                this.iframe.onload = ()=>{
                    this.frameLoadPromiseResolver?.resolve(undefined);
                };
                this.iframe.onerror = ()=>{
                    this.frameLoadPromiseResolver?.reject("Unable to load email login dependency");
                };
            }
        }
    }
    get networks() {
        const data = [
            "eip155:1",
            "eip155:5",
            "eip155:11155111",
            "eip155:10",
            "eip155:420",
            "eip155:42161",
            "eip155:421613",
            "eip155:137",
            "eip155:80001",
            "eip155:42220",
            "eip155:1313161554",
            "eip155:1313161555",
            "eip155:56",
            "eip155:97",
            "eip155:43114",
            "eip155:43113",
            "eip155:324",
            "eip155:280",
            "eip155:100",
            "eip155:8453",
            "eip155:84531",
            "eip155:7777777",
            "eip155:999",
            "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
            "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
            "solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1"
        ].map((id)=>({
                [id]: {
                    rpcUrl: `${this.rpcUrl}/v1/?chainId=${id}&projectId=${this.projectId}`,
                    chainId: id
                }
            }));
        return Object.assign({}, ...data);
    }
}

});
parcelRegister("lr7C8", function(module, exports) {

$parcel$export(module.exports, "SECURE_SITE_SDK", function () { return $f9b2069af91ddf6a$export$b36058160289df06; });
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", function () { return $f9b2069af91ddf6a$export$97d4c6871900dcac; });
$parcel$export(module.exports, "W3mFrameConstants", function () { return $f9b2069af91ddf6a$export$3ff97a7390ed49be; });
$parcel$export(module.exports, "W3mFrameRpcConstants", function () { return $f9b2069af91ddf6a$export$9975694bfb286db; });
const $f9b2069af91ddf6a$export$b36058160289df06 = "https://secure.walletconnect.org/sdk";
const $f9b2069af91ddf6a$export$97d4c6871900dcac = "error";
const $f9b2069af91ddf6a$export$3ff97a7390ed49be = {
    APP_EVENT_KEY: "@w3m-app/",
    FRAME_EVENT_KEY: "@w3m-frame/",
    RPC_METHOD_KEY: "RPC_",
    STORAGE_KEY: "@w3m-storage/",
    SESSION_TOKEN_KEY: "SESSION_TOKEN_KEY",
    EMAIL_LOGIN_USED_KEY: "EMAIL_LOGIN_USED_KEY",
    LAST_USED_CHAIN_KEY: "LAST_USED_CHAIN_KEY",
    LAST_EMAIL_LOGIN_TIME: "LAST_EMAIL_LOGIN_TIME",
    EMAIL: "EMAIL",
    PREFERRED_ACCOUNT_TYPE: "PREFERRED_ACCOUNT_TYPE",
    SMART_ACCOUNT_ENABLED: "SMART_ACCOUNT_ENABLED",
    SMART_ACCOUNT_ENABLED_NETWORKS: "SMART_ACCOUNT_ENABLED_NETWORKS",
    SOCIAL_USERNAME: "SOCIAL_USERNAME",
    SOCIAL: "@w3m/connected_social",
    APP_SWITCH_NETWORK: "@w3m-app/SWITCH_NETWORK",
    APP_CONNECT_EMAIL: "@w3m-app/CONNECT_EMAIL",
    APP_CONNECT_DEVICE: "@w3m-app/CONNECT_DEVICE",
    APP_CONNECT_OTP: "@w3m-app/CONNECT_OTP",
    APP_CONNECT_SOCIAL: "@w3m-app/CONNECT_SOCIAL",
    APP_GET_SOCIAL_REDIRECT_URI: "@w3m-app/GET_SOCIAL_REDIRECT_URI",
    APP_GET_USER: "@w3m-app/GET_USER",
    APP_SIGN_OUT: "@w3m-app/SIGN_OUT",
    APP_IS_CONNECTED: "@w3m-app/IS_CONNECTED",
    APP_GET_CHAIN_ID: "@w3m-app/GET_CHAIN_ID",
    APP_RPC_REQUEST: "@w3m-app/RPC_REQUEST",
    APP_UPDATE_EMAIL: "@w3m-app/UPDATE_EMAIL",
    APP_UPDATE_EMAIL_PRIMARY_OTP: "@w3m-app/UPDATE_EMAIL_PRIMARY_OTP",
    APP_UPDATE_EMAIL_SECONDARY_OTP: "@w3m-app/UPDATE_EMAIL_SECONDARY_OTP",
    APP_AWAIT_UPDATE_EMAIL: "@w3m-app/AWAIT_UPDATE_EMAIL",
    APP_SYNC_THEME: "@w3m-app/SYNC_THEME",
    APP_SYNC_DAPP_DATA: "@w3m-app/SYNC_DAPP_DATA",
    APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS: "@w3m-app/GET_SMART_ACCOUNT_ENABLED_NETWORKS",
    APP_INIT_SMART_ACCOUNT: "@w3m-app/INIT_SMART_ACCOUNT",
    APP_SET_PREFERRED_ACCOUNT: "@w3m-app/SET_PREFERRED_ACCOUNT",
    APP_CONNECT_FARCASTER: "@w3m-app/CONNECT_FARCASTER",
    APP_GET_FARCASTER_URI: "@w3m-app/GET_FARCASTER_URI",
    FRAME_SWITCH_NETWORK_ERROR: "@w3m-frame/SWITCH_NETWORK_ERROR",
    FRAME_SWITCH_NETWORK_SUCCESS: "@w3m-frame/SWITCH_NETWORK_SUCCESS",
    FRAME_CONNECT_EMAIL_ERROR: "@w3m-frame/CONNECT_EMAIL_ERROR",
    FRAME_CONNECT_EMAIL_SUCCESS: "@w3m-frame/CONNECT_EMAIL_SUCCESS",
    FRAME_CONNECT_DEVICE_ERROR: "@w3m-frame/CONNECT_DEVICE_ERROR",
    FRAME_CONNECT_DEVICE_SUCCESS: "@w3m-frame/CONNECT_DEVICE_SUCCESS",
    FRAME_CONNECT_OTP_SUCCESS: "@w3m-frame/CONNECT_OTP_SUCCESS",
    FRAME_CONNECT_OTP_ERROR: "@w3m-frame/CONNECT_OTP_ERROR",
    FRAME_CONNECT_SOCIAL_SUCCESS: "@w3m-frame/CONNECT_SOCIAL_SUCCESS",
    FRAME_CONNECT_SOCIAL_ERROR: "@w3m-frame/CONNECT_SOCIAL_ERROR",
    FRAME_CONNECT_FARCASTER_SUCCESS: "@w3m-frame/CONNECT_FARCASTER_SUCCESS",
    FRAME_CONNECT_FARCASTER_ERROR: "@w3m-frame/CONNECT_FARCASTER_ERROR",
    FRAME_GET_FARCASTER_URI_SUCCESS: "@w3m-frame/GET_FARCASTER_URI_SUCCESS",
    FRAME_GET_FARCASTER_URI_ERROR: "@w3m-frame/GET_FARCASTER_URI_ERROR",
    FRAME_GET_SOCIAL_REDIRECT_URI_SUCCESS: "@w3m-frame/GET_SOCIAL_REDIRECT_URI_SUCCESS",
    FRAME_GET_SOCIAL_REDIRECT_URI_ERROR: "@w3m-frame/GET_SOCIAL_REDIRECT_URI_ERROR",
    FRAME_GET_USER_SUCCESS: "@w3m-frame/GET_USER_SUCCESS",
    FRAME_GET_USER_ERROR: "@w3m-frame/GET_USER_ERROR",
    FRAME_SIGN_OUT_SUCCESS: "@w3m-frame/SIGN_OUT_SUCCESS",
    FRAME_SIGN_OUT_ERROR: "@w3m-frame/SIGN_OUT_ERROR",
    FRAME_IS_CONNECTED_SUCCESS: "@w3m-frame/IS_CONNECTED_SUCCESS",
    FRAME_IS_CONNECTED_ERROR: "@w3m-frame/IS_CONNECTED_ERROR",
    FRAME_GET_CHAIN_ID_SUCCESS: "@w3m-frame/GET_CHAIN_ID_SUCCESS",
    FRAME_GET_CHAIN_ID_ERROR: "@w3m-frame/GET_CHAIN_ID_ERROR",
    FRAME_RPC_REQUEST_SUCCESS: "@w3m-frame/RPC_REQUEST_SUCCESS",
    FRAME_RPC_REQUEST_ERROR: "@w3m-frame/RPC_REQUEST_ERROR",
    FRAME_SESSION_UPDATE: "@w3m-frame/SESSION_UPDATE",
    FRAME_UPDATE_EMAIL_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SUCCESS",
    FRAME_UPDATE_EMAIL_ERROR: "@w3m-frame/UPDATE_EMAIL_ERROR",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_ERROR",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_ERROR",
    FRAME_SYNC_THEME_SUCCESS: "@w3m-frame/SYNC_THEME_SUCCESS",
    FRAME_SYNC_THEME_ERROR: "@w3m-frame/SYNC_THEME_ERROR",
    FRAME_SYNC_DAPP_DATA_SUCCESS: "@w3m-frame/SYNC_DAPP_DATA_SUCCESS",
    FRAME_SYNC_DAPP_DATA_ERROR: "@w3m-frame/SYNC_DAPP_DATA_ERROR",
    FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS: "@w3m-frame/GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS",
    FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR: "@w3m-frame/GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR",
    FRAME_INIT_SMART_ACCOUNT_SUCCESS: "@w3m-frame/INIT_SMART_ACCOUNT_SUCCESS",
    FRAME_INIT_SMART_ACCOUNT_ERROR: "@w3m-frame/INIT_SMART_ACCOUNT_ERROR",
    FRAME_SET_PREFERRED_ACCOUNT_SUCCESS: "@w3m-frame/SET_PREFERRED_ACCOUNT_SUCCESS",
    FRAME_SET_PREFERRED_ACCOUNT_ERROR: "@w3m-frame/SET_PREFERRED_ACCOUNT_ERROR",
    RPC_RESPONSE_TYPE_ERROR: "RPC_RESPONSE_ERROR",
    RPC_RESPONSE_TYPE_TX: "RPC_RESPONSE_TRANSACTION_HASH",
    RPC_RESPONSE_TYPE_OBJECT: "RPC_RESPONSE_OBJECT"
};
const $f9b2069af91ddf6a$export$9975694bfb286db = {
    SAFE_RPC_METHODS: [
        "eth_accounts",
        "eth_blockNumber",
        "eth_call",
        "eth_chainId",
        "eth_estimateGas",
        "eth_feeHistory",
        "eth_gasPrice",
        "eth_getAccount",
        "eth_getBalance",
        "eth_getBlockByHash",
        "eth_getBlockByNumber",
        "eth_getBlockReceipts",
        "eth_getBlockTransactionCountByHash",
        "eth_getBlockTransactionCountByNumber",
        "eth_getCode",
        "eth_getFilterChanges",
        "eth_getFilterLogs",
        "eth_getLogs",
        "eth_getProof",
        "eth_getStorageAt",
        "eth_getTransactionByBlockHashAndIndex",
        "eth_getTransactionByBlockNumberAndIndex",
        "eth_getTransactionByHash",
        "eth_getTransactionCount",
        "eth_getTransactionReceipt",
        "eth_getUncleCountByBlockHash",
        "eth_getUncleCountByBlockNumber",
        "eth_maxPriorityFeePerGas",
        "eth_newBlockFilter",
        "eth_newFilter",
        "eth_newPendingTransactionFilter",
        "eth_sendRawTransaction",
        "eth_syncing",
        "eth_uninstallFilter",
        "wallet_getCapabilities",
        "wallet_getCallsStatus"
    ],
    NOT_SAFE_RPC_METHODS: [
        "personal_sign",
        "eth_signTypedData_v4",
        "eth_sendTransaction",
        "solana_signMessage",
        "solana_signTransaction",
        "solana_signAndSendTransaction",
        "wallet_sendCalls",
        "wallet_grantPermissions"
    ],
    GET_CHAIN_ID: "eth_chainId",
    RPC_METHOD_NOT_ALLOWED_MESSAGE: "Requested RPC call is not allowed",
    RPC_METHOD_NOT_ALLOWED_UI_MESSAGE: "Action not allowed",
    ACCOUNT_TYPES: {
        EOA: "eoa",
        SMART_ACCOUNT: "smartAccount"
    }
};

});

parcelRegister("7gB8q", function(module, exports) {

$parcel$export(module.exports, "W3mFrameSchema", function () { return $54a6d53c80e29a78$export$238f9986c2bb1b9a; });

var $bWVTe = parcelRequire("bWVTe");

var $lr7C8 = parcelRequire("lr7C8");
const $54a6d53c80e29a78$var$zError = (0, $bWVTe.z).object({
    message: (0, $bWVTe.z).string()
});
function $54a6d53c80e29a78$var$zType(key) {
    return (0, $bWVTe.z).literal((0, $lr7C8.W3mFrameConstants)[key]);
}
const $54a6d53c80e29a78$export$89415e8e09b5a4e0 = (0, $bWVTe.z).object({
    accessList: (0, $bWVTe.z).array((0, $bWVTe.z).string()),
    blockHash: (0, $bWVTe.z).string().nullable(),
    blockNumber: (0, $bWVTe.z).string().nullable(),
    chainId: (0, $bWVTe.z).string().or((0, $bWVTe.z).number()),
    from: (0, $bWVTe.z).string(),
    gas: (0, $bWVTe.z).string(),
    hash: (0, $bWVTe.z).string(),
    input: (0, $bWVTe.z).string().nullable(),
    maxFeePerGas: (0, $bWVTe.z).string(),
    maxPriorityFeePerGas: (0, $bWVTe.z).string(),
    nonce: (0, $bWVTe.z).string(),
    r: (0, $bWVTe.z).string(),
    s: (0, $bWVTe.z).string(),
    to: (0, $bWVTe.z).string(),
    transactionIndex: (0, $bWVTe.z).string().nullable(),
    type: (0, $bWVTe.z).string(),
    v: (0, $bWVTe.z).string(),
    value: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$6f296c19518f2ab2 = (0, $bWVTe.z).object({
    chainId: (0, $bWVTe.z).string().or((0, $bWVTe.z).number())
});
const $54a6d53c80e29a78$export$976f191ce42ce5be = (0, $bWVTe.z).object({
    email: (0, $bWVTe.z).string().email()
});
const $54a6d53c80e29a78$export$3c60c26d0e7c7485 = (0, $bWVTe.z).object({
    otp: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$b4cf8f9e803c0857 = (0, $bWVTe.z).object({
    uri: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$2b55edadc32e688a = (0, $bWVTe.z).object({
    chainId: (0, $bWVTe.z).optional((0, $bWVTe.z).string().or((0, $bWVTe.z).number())),
    preferredAccountType: (0, $bWVTe.z).optional((0, $bWVTe.z).string())
});
const $54a6d53c80e29a78$export$9d16112af534cfa2 = (0, $bWVTe.z).object({
    provider: (0, $bWVTe.z).enum([
        "google",
        "github",
        "apple",
        "facebook",
        "x",
        "discord"
    ])
});
const $54a6d53c80e29a78$export$65e6e56482b6df27 = (0, $bWVTe.z).object({
    email: (0, $bWVTe.z).string().email()
});
const $54a6d53c80e29a78$export$63ec130352b88085 = (0, $bWVTe.z).object({
    otp: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$cbb50d2392bf53e2 = (0, $bWVTe.z).object({
    otp: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$c523bb85fd166f04 = (0, $bWVTe.z).object({
    themeMode: (0, $bWVTe.z).optional((0, $bWVTe.z).enum([
        "light",
        "dark"
    ])),
    themeVariables: (0, $bWVTe.z).optional((0, $bWVTe.z).record((0, $bWVTe.z).string(), (0, $bWVTe.z).string().or((0, $bWVTe.z).number()))),
    w3mThemeVariables: (0, $bWVTe.z).optional((0, $bWVTe.z).record((0, $bWVTe.z).string(), (0, $bWVTe.z).string()))
});
const $54a6d53c80e29a78$export$4ca9ea890e921270 = (0, $bWVTe.z).object({
    metadata: (0, $bWVTe.z).object({
        name: (0, $bWVTe.z).string(),
        description: (0, $bWVTe.z).string(),
        url: (0, $bWVTe.z).string(),
        icons: (0, $bWVTe.z).array((0, $bWVTe.z).string())
    }).optional(),
    sdkVersion: (0, $bWVTe.z).string(),
    projectId: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$9cebfb60f9fcc35b = (0, $bWVTe.z).object({
    type: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$333a7bf9d10b914 = (0, $bWVTe.z).object({
    action: (0, $bWVTe.z).enum([
        "VERIFY_DEVICE",
        "VERIFY_OTP"
    ])
});
const $54a6d53c80e29a78$export$da46d112c20de897 = (0, $bWVTe.z).object({
    url: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$e3d16386f65b39d3 = (0, $bWVTe.z).object({
    userName: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$9f099747f910622d = (0, $bWVTe.z).object({
    email: (0, $bWVTe.z).string(),
    address: (0, $bWVTe.z).string(),
    chainId: (0, $bWVTe.z).string().or((0, $bWVTe.z).number()),
    accounts: (0, $bWVTe.z).array((0, $bWVTe.z).object({
        address: (0, $bWVTe.z).string(),
        type: (0, $bWVTe.z).enum([
            (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA,
            (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
        ])
    })).optional(),
    userName: (0, $bWVTe.z).string().optional()
});
const $54a6d53c80e29a78$export$14285ffeae37d072 = (0, $bWVTe.z).object({
    action: (0, $bWVTe.z).enum([
        "VERIFY_PRIMARY_OTP",
        "VERIFY_SECONDARY_OTP"
    ])
});
const $54a6d53c80e29a78$export$2d6662dda0084b61 = (0, $bWVTe.z).object({
    email: (0, $bWVTe.z).string().email().optional().nullable(),
    address: (0, $bWVTe.z).string(),
    chainId: (0, $bWVTe.z).string().or((0, $bWVTe.z).number()),
    smartAccountDeployed: (0, $bWVTe.z).optional((0, $bWVTe.z).boolean()),
    accounts: (0, $bWVTe.z).array((0, $bWVTe.z).object({
        address: (0, $bWVTe.z).string(),
        type: (0, $bWVTe.z).enum([
            (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA,
            (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
        ])
    })).optional(),
    preferredAccountType: (0, $bWVTe.z).optional((0, $bWVTe.z).string())
});
const $54a6d53c80e29a78$export$37bc618e26a3f46 = (0, $bWVTe.z).object({
    uri: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$775a450ce21f8fdf = (0, $bWVTe.z).object({
    isConnected: (0, $bWVTe.z).boolean()
});
const $54a6d53c80e29a78$export$245abc04f43df573 = (0, $bWVTe.z).object({
    chainId: (0, $bWVTe.z).string().or((0, $bWVTe.z).number())
});
const $54a6d53c80e29a78$export$178941fe9bfa6200 = (0, $bWVTe.z).object({
    chainId: (0, $bWVTe.z).string().or((0, $bWVTe.z).number())
});
const $54a6d53c80e29a78$export$d31a2d4d5f5aa2cd = (0, $bWVTe.z).object({
    newEmail: (0, $bWVTe.z).string().email()
});
const $54a6d53c80e29a78$export$31b27be58286b84c = (0, $bWVTe.z).object({
    smartAccountEnabledNetworks: (0, $bWVTe.z).array((0, $bWVTe.z).number())
});
const $54a6d53c80e29a78$export$b8e958c03766c98e = (0, $bWVTe.z).object({
    address: (0, $bWVTe.z).string(),
    isDeployed: (0, $bWVTe.z).boolean()
});
const $54a6d53c80e29a78$export$258085d3b41c15d5 = (0, $bWVTe.z).object({
    type: (0, $bWVTe.z).string(),
    address: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$d4ce1c0118069cf6 = (0, $bWVTe.z).any();
const $54a6d53c80e29a78$export$333c606c26a06359 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_accounts")
});
const $54a6d53c80e29a78$export$ed481a6ef87fb1a4 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_blockNumber")
});
const $54a6d53c80e29a78$export$3746f30d5256aebc = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_call"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$ced6b8fef5e3a1ae = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_chainId")
});
const $54a6d53c80e29a78$export$272161a7d614a7de = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_estimateGas"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$601d25f8f10fb73e = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_feeHistory"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$375f72aea2abe32f = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_gasPrice")
});
const $54a6d53c80e29a78$export$5781e194c9800107 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getAccount"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$e8c54d0244516318 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getBalance"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$ed296586d8ca73e5 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getBlockByHash"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$5930d1a65f85cd1c = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getBlockByNumber"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$728754e9b5ce598 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getBlockReceipts"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$4ddab575d344fe47 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getBlockTransactionCountByHash"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$3a9707a1a95b758c = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getBlockTransactionCountByNumber"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$32d3decd99b4e77c = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getCode"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$70385be35bb1c094 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getFilterChanges"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$67adfcd98750c2a4 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getFilterLogs"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$ec85b0f99f3b0860 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getLogs"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$aad1bb370c749036 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getProof"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$de118eb57c7e99ee = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getStorageAt"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$925a4185b30091ca = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getTransactionByBlockHashAndIndex"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$132e327b9ac8100f = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getTransactionByBlockNumberAndIndex"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$b498be03499c3270 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getTransactionByHash"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$8e3ae636de98a13f = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getTransactionCount"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$ebf4091cc6dfa2ef = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getTransactionReceipt"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$a9e565a5951dbda1 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getUncleCountByBlockHash"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$3e72b948c8cdb33b = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_getUncleCountByBlockNumber"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$35da6e194885ea4f = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_maxPriorityFeePerGas")
});
const $54a6d53c80e29a78$export$f2d7c90f3596d13e = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_newBlockFilter")
});
const $54a6d53c80e29a78$export$f6ccc436669a288e = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_newFilter"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$299d889501e7632c = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_newPendingTransactionFilter")
});
const $54a6d53c80e29a78$export$2f01b91caa317491 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_sendRawTransaction"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$688f7a1e4924e71b = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_syncing"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$1cc394e8ef03e09a = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_uninstallFilter"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$57dc995d18380851 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("personal_sign"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$98d6e3ae5e5869d0 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_signTypedData_v4"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$fc4f4bb7f991c8e0 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("eth_sendTransaction"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$d91e2474cd16d70d = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("solana_signMessage"),
    params: (0, $bWVTe.z).object({
        message: (0, $bWVTe.z).string(),
        pubkey: (0, $bWVTe.z).string()
    })
});
const $54a6d53c80e29a78$export$11543edd53c7f4cb = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("solana_signTransaction"),
    params: (0, $bWVTe.z).object({
        transaction: (0, $bWVTe.z).string()
    })
});
const $54a6d53c80e29a78$export$655852added10635 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("solana_signAndSendTransaction"),
    params: (0, $bWVTe.z).object({
        transaction: (0, $bWVTe.z).string(),
        options: (0, $bWVTe.z).object({
            skipPreflight: (0, $bWVTe.z).boolean().optional(),
            preflightCommitment: (0, $bWVTe.z).enum([
                "processed",
                "confirmed",
                "finalized",
                "recent",
                "single",
                "singleGossip",
                "root",
                "max"
            ]).optional(),
            maxRetries: (0, $bWVTe.z).number().optional(),
            minContextSlot: (0, $bWVTe.z).number().optional()
        }).optional()
    })
});
const $54a6d53c80e29a78$export$22abffcfa04dcf81 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("wallet_sendCalls"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).object({
        chainId: (0, $bWVTe.z).string().or((0, $bWVTe.z).number()).optional(),
        from: (0, $bWVTe.z).string().optional(),
        version: (0, $bWVTe.z).string().optional(),
        capabilities: (0, $bWVTe.z).any().optional(),
        calls: (0, $bWVTe.z).array((0, $bWVTe.z).object({
            to: (0, $bWVTe.z).string().startsWith("0x"),
            data: (0, $bWVTe.z).string().startsWith("0x").optional(),
            value: (0, $bWVTe.z).string().optional()
        }))
    }))
});
const $54a6d53c80e29a78$export$81a313f8ca8f6f80 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("wallet_getCallsStatus"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).string())
});
const $54a6d53c80e29a78$export$193ba0334adb9ab5 = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("wallet_getCapabilities")
});
const $54a6d53c80e29a78$export$b5e7f5679b9a54bb = (0, $bWVTe.z).object({
    method: (0, $bWVTe.z).literal("wallet_grantPermissions"),
    params: (0, $bWVTe.z).array((0, $bWVTe.z).any())
});
const $54a6d53c80e29a78$export$583fad842749c757 = (0, $bWVTe.z).object({
    token: (0, $bWVTe.z).string()
});
const $54a6d53c80e29a78$export$769a4ec051ed522c = (0, $bWVTe.z).object({
    id: (0, $bWVTe.z).string().optional()
});
const $54a6d53c80e29a78$export$238f9986c2bb1b9a = {
    appEvent: $54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_SWITCH_NETWORK"),
        payload: $54a6d53c80e29a78$export$6f296c19518f2ab2
    }).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_CONNECT_EMAIL"),
        payload: $54a6d53c80e29a78$export$976f191ce42ce5be
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_CONNECT_DEVICE")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_CONNECT_OTP"),
        payload: $54a6d53c80e29a78$export$3c60c26d0e7c7485
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_CONNECT_SOCIAL"),
        payload: $54a6d53c80e29a78$export$b4cf8f9e803c0857
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_GET_FARCASTER_URI")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_CONNECT_FARCASTER")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_GET_USER"),
        payload: (0, $bWVTe.z).optional($54a6d53c80e29a78$export$2b55edadc32e688a)
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_GET_SOCIAL_REDIRECT_URI"),
        payload: $54a6d53c80e29a78$export$9d16112af534cfa2
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_SIGN_OUT")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_IS_CONNECTED"),
        payload: (0, $bWVTe.z).optional($54a6d53c80e29a78$export$583fad842749c757)
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_GET_CHAIN_ID")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_INIT_SMART_ACCOUNT")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_SET_PREFERRED_ACCOUNT"),
        payload: $54a6d53c80e29a78$export$9cebfb60f9fcc35b
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_RPC_REQUEST"),
        payload: $54a6d53c80e29a78$export$57dc995d18380851.or($54a6d53c80e29a78$export$fc4f4bb7f991c8e0).or($54a6d53c80e29a78$export$333c606c26a06359).or($54a6d53c80e29a78$export$ed481a6ef87fb1a4).or($54a6d53c80e29a78$export$3746f30d5256aebc).or($54a6d53c80e29a78$export$ced6b8fef5e3a1ae).or($54a6d53c80e29a78$export$272161a7d614a7de).or($54a6d53c80e29a78$export$601d25f8f10fb73e).or($54a6d53c80e29a78$export$375f72aea2abe32f).or($54a6d53c80e29a78$export$5781e194c9800107).or($54a6d53c80e29a78$export$e8c54d0244516318).or($54a6d53c80e29a78$export$ed296586d8ca73e5).or($54a6d53c80e29a78$export$5930d1a65f85cd1c).or($54a6d53c80e29a78$export$728754e9b5ce598).or($54a6d53c80e29a78$export$4ddab575d344fe47).or($54a6d53c80e29a78$export$3a9707a1a95b758c).or($54a6d53c80e29a78$export$32d3decd99b4e77c).or($54a6d53c80e29a78$export$70385be35bb1c094).or($54a6d53c80e29a78$export$67adfcd98750c2a4).or($54a6d53c80e29a78$export$ec85b0f99f3b0860).or($54a6d53c80e29a78$export$aad1bb370c749036).or($54a6d53c80e29a78$export$de118eb57c7e99ee).or($54a6d53c80e29a78$export$925a4185b30091ca).or($54a6d53c80e29a78$export$132e327b9ac8100f).or($54a6d53c80e29a78$export$b498be03499c3270).or($54a6d53c80e29a78$export$8e3ae636de98a13f).or($54a6d53c80e29a78$export$ebf4091cc6dfa2ef).or($54a6d53c80e29a78$export$a9e565a5951dbda1).or($54a6d53c80e29a78$export$3e72b948c8cdb33b).or($54a6d53c80e29a78$export$35da6e194885ea4f).or($54a6d53c80e29a78$export$f2d7c90f3596d13e).or($54a6d53c80e29a78$export$f6ccc436669a288e).or($54a6d53c80e29a78$export$299d889501e7632c).or($54a6d53c80e29a78$export$2f01b91caa317491).or($54a6d53c80e29a78$export$688f7a1e4924e71b).or($54a6d53c80e29a78$export$1cc394e8ef03e09a).or($54a6d53c80e29a78$export$57dc995d18380851).or($54a6d53c80e29a78$export$98d6e3ae5e5869d0).or($54a6d53c80e29a78$export$fc4f4bb7f991c8e0).or($54a6d53c80e29a78$export$d91e2474cd16d70d).or($54a6d53c80e29a78$export$11543edd53c7f4cb).or($54a6d53c80e29a78$export$655852added10635).or($54a6d53c80e29a78$export$81a313f8ca8f6f80).or($54a6d53c80e29a78$export$22abffcfa04dcf81).or($54a6d53c80e29a78$export$193ba0334adb9ab5).or($54a6d53c80e29a78$export$b5e7f5679b9a54bb)
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_UPDATE_EMAIL"),
        payload: $54a6d53c80e29a78$export$65e6e56482b6df27
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_UPDATE_EMAIL_PRIMARY_OTP"),
        payload: $54a6d53c80e29a78$export$63ec130352b88085
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_UPDATE_EMAIL_SECONDARY_OTP"),
        payload: $54a6d53c80e29a78$export$cbb50d2392bf53e2
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_SYNC_THEME"),
        payload: $54a6d53c80e29a78$export$c523bb85fd166f04
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("APP_SYNC_DAPP_DATA"),
        payload: $54a6d53c80e29a78$export$4ca9ea890e921270
    })),
    frameEvent: $54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SWITCH_NETWORK_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    }).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SWITCH_NETWORK_SUCCESS"),
        payload: $54a6d53c80e29a78$export$178941fe9bfa6200
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_EMAIL_SUCCESS"),
        payload: $54a6d53c80e29a78$export$333a7bf9d10b914
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_EMAIL_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_FARCASTER_URI_SUCCESS"),
        payload: $54a6d53c80e29a78$export$da46d112c20de897
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_FARCASTER_URI_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_FARCASTER_SUCCESS"),
        payload: $54a6d53c80e29a78$export$e3d16386f65b39d3
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_FARCASTER_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_OTP_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_OTP_SUCCESS")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_DEVICE_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_DEVICE_SUCCESS")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_SOCIAL_SUCCESS"),
        payload: $54a6d53c80e29a78$export$9f099747f910622d
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_CONNECT_SOCIAL_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_USER_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_USER_SUCCESS"),
        payload: $54a6d53c80e29a78$export$2d6662dda0084b61
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_SOCIAL_REDIRECT_URI_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_SOCIAL_REDIRECT_URI_SUCCESS"),
        payload: $54a6d53c80e29a78$export$37bc618e26a3f46
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SIGN_OUT_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SIGN_OUT_SUCCESS")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_IS_CONNECTED_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_IS_CONNECTED_SUCCESS"),
        payload: $54a6d53c80e29a78$export$775a450ce21f8fdf
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_CHAIN_ID_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_CHAIN_ID_SUCCESS"),
        payload: $54a6d53c80e29a78$export$245abc04f43df573
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_RPC_REQUEST_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_RPC_REQUEST_SUCCESS"),
        payload: $54a6d53c80e29a78$export$d4ce1c0118069cf6
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SESSION_UPDATE"),
        payload: $54a6d53c80e29a78$export$583fad842749c757
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_UPDATE_EMAIL_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_UPDATE_EMAIL_SUCCESS"),
        payload: $54a6d53c80e29a78$export$14285ffeae37d072
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS"),
        payload: $54a6d53c80e29a78$export$d31a2d4d5f5aa2cd
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SYNC_THEME_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SYNC_THEME_SUCCESS")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SYNC_DAPP_DATA_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SYNC_DAPP_DATA_SUCCESS")
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS"),
        payload: $54a6d53c80e29a78$export$31b27be58286b84c
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_INIT_SMART_ACCOUNT_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SET_PREFERRED_ACCOUNT_SUCCESS"),
        payload: $54a6d53c80e29a78$export$258085d3b41c15d5
    })).or($54a6d53c80e29a78$export$769a4ec051ed522c.extend({
        type: $54a6d53c80e29a78$var$zType("FRAME_SET_PREFERRED_ACCOUNT_ERROR"),
        payload: $54a6d53c80e29a78$var$zError
    }))
};

});
parcelRegister("bWVTe", function(module, exports) {

$parcel$export(module.exports, "z", function () { return $3e1d8ac307543186$export$2e2bcd8739ae039; });
var $3e1d8ac307543186$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($3e1d8ac307543186$export$7debb50ef11d5e0b || ($3e1d8ac307543186$export$7debb50ef11d5e0b = {}));
var $3e1d8ac307543186$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($3e1d8ac307543186$export$4aa2142c225fd5c7 || ($3e1d8ac307543186$export$4aa2142c225fd5c7 = {}));
const $3e1d8ac307543186$export$5716da67bfaa244d = $3e1d8ac307543186$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $3e1d8ac307543186$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $3e1d8ac307543186$export$5716da67bfaa244d.undefined;
        case "string":
            return $3e1d8ac307543186$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $3e1d8ac307543186$export$5716da67bfaa244d.nan : $3e1d8ac307543186$export$5716da67bfaa244d.number;
        case "boolean":
            return $3e1d8ac307543186$export$5716da67bfaa244d.boolean;
        case "function":
            return $3e1d8ac307543186$export$5716da67bfaa244d.function;
        case "bigint":
            return $3e1d8ac307543186$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $3e1d8ac307543186$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $3e1d8ac307543186$export$5716da67bfaa244d.array;
            if (data === null) return $3e1d8ac307543186$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $3e1d8ac307543186$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $3e1d8ac307543186$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $3e1d8ac307543186$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $3e1d8ac307543186$export$5716da67bfaa244d.date;
            return $3e1d8ac307543186$export$5716da67bfaa244d.object;
        default:
            return $3e1d8ac307543186$export$5716da67bfaa244d.unknown;
    }
};
const $3e1d8ac307543186$export$5ba560653e4a1035 = $3e1d8ac307543186$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $3e1d8ac307543186$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $3e1d8ac307543186$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $3e1d8ac307543186$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$3e1d8ac307543186$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $3e1d8ac307543186$export$f98dac4b251ab333(issues);
    return error;
};
const $3e1d8ac307543186$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $3e1d8ac307543186$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $3e1d8ac307543186$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$3e1d8ac307543186$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$3e1d8ac307543186$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$3e1d8ac307543186$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $3e1d8ac307543186$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $3e1d8ac307543186$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $3e1d8ac307543186$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $3e1d8ac307543186$var$overrideErrorMap = $3e1d8ac307543186$export$341b0b6e0a6f5099;
function $3e1d8ac307543186$export$1097a8289cfd22d7(map) {
    $3e1d8ac307543186$var$overrideErrorMap = map;
}
function $3e1d8ac307543186$export$32f27c719778d4c4() {
    return $3e1d8ac307543186$var$overrideErrorMap;
}
const $3e1d8ac307543186$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $3e1d8ac307543186$export$1526d2e05f74572 = [];
function $3e1d8ac307543186$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $3e1d8ac307543186$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $3e1d8ac307543186$export$32f27c719778d4c4(),
            $3e1d8ac307543186$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $3e1d8ac307543186$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $3e1d8ac307543186$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $3e1d8ac307543186$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $3e1d8ac307543186$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $3e1d8ac307543186$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $3e1d8ac307543186$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $3e1d8ac307543186$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $3e1d8ac307543186$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $3e1d8ac307543186$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($3e1d8ac307543186$var$errorUtil || ($3e1d8ac307543186$var$errorUtil = {}));
class $3e1d8ac307543186$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $3e1d8ac307543186$var$handleResult = (ctx, result)=>{
    if ($3e1d8ac307543186$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $3e1d8ac307543186$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $3e1d8ac307543186$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $3e1d8ac307543186$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $3e1d8ac307543186$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $3e1d8ac307543186$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $3e1d8ac307543186$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $3e1d8ac307543186$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($3e1d8ac307543186$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $3e1d8ac307543186$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $3e1d8ac307543186$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $3e1d8ac307543186$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($3e1d8ac307543186$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $3e1d8ac307543186$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $3e1d8ac307543186$export$a60af00cc0ce2582({
            schema: this,
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $3e1d8ac307543186$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $3e1d8ac307543186$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $3e1d8ac307543186$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $3e1d8ac307543186$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $3e1d8ac307543186$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $3e1d8ac307543186$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $3e1d8ac307543186$export$a60af00cc0ce2582({
            ...$3e1d8ac307543186$var$processCreateParams(this._def),
            schema: this,
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $3e1d8ac307543186$export$bb19b37874861e7e({
            ...$3e1d8ac307543186$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $3e1d8ac307543186$export$66b0c798a395271f({
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$3e1d8ac307543186$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $3e1d8ac307543186$export$75a44ec6249ac76b({
            ...$3e1d8ac307543186$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $3e1d8ac307543186$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $3e1d8ac307543186$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $3e1d8ac307543186$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $3e1d8ac307543186$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $3e1d8ac307543186$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $3e1d8ac307543186$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $3e1d8ac307543186$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $3e1d8ac307543186$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $3e1d8ac307543186$var$emojiRegex;
const $3e1d8ac307543186$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $3e1d8ac307543186$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $3e1d8ac307543186$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $3e1d8ac307543186$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $3e1d8ac307543186$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $3e1d8ac307543186$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $3e1d8ac307543186$export$1230eb29b8d3b502 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const status = new $3e1d8ac307543186$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$3e1d8ac307543186$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$3e1d8ac307543186$var$emojiRegex) $3e1d8ac307543186$var$emojiRegex = new RegExp($3e1d8ac307543186$var$_emojiRegex, "u");
                if (!$3e1d8ac307543186$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$3e1d8ac307543186$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$3e1d8ac307543186$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$3e1d8ac307543186$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$3e1d8ac307543186$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $3e1d8ac307543186$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$3e1d8ac307543186$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $3e1d8ac307543186$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_string,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $3e1d8ac307543186$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$3e1d8ac307543186$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$3e1d8ac307543186$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $3e1d8ac307543186$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $3e1d8ac307543186$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $3e1d8ac307543186$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $3e1d8ac307543186$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$3e1d8ac307543186$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $3e1d8ac307543186$export$1230eb29b8d3b502({
        checks: [],
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $3e1d8ac307543186$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $3e1d8ac307543186$export$5b070a55c0c43e09 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $3e1d8ac307543186$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$3e1d8ac307543186$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($3e1d8ac307543186$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $3e1d8ac307543186$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $3e1d8ac307543186$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $3e1d8ac307543186$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $3e1d8ac307543186$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $3e1d8ac307543186$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $3e1d8ac307543186$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $3e1d8ac307543186$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $3e1d8ac307543186$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $3e1d8ac307543186$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$3e1d8ac307543186$export$5b070a55c0c43e09.create = (params)=>{
    return new $3e1d8ac307543186$export$5b070a55c0c43e09({
        checks: [],
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$67d741fd70ff98f4 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $3e1d8ac307543186$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $3e1d8ac307543186$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $3e1d8ac307543186$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $3e1d8ac307543186$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $3e1d8ac307543186$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $3e1d8ac307543186$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $3e1d8ac307543186$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $3e1d8ac307543186$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $3e1d8ac307543186$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$3e1d8ac307543186$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $3e1d8ac307543186$export$67d741fd70ff98f4({
        checks: [],
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$723d146f80596191 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
}
$3e1d8ac307543186$export$723d146f80596191.create = (params)=>{
    return new $3e1d8ac307543186$export$723d146f80596191({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$e974be33bdc55521 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_date
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const status = new $3e1d8ac307543186$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $3e1d8ac307543186$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $3e1d8ac307543186$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $3e1d8ac307543186$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$3e1d8ac307543186$export$e974be33bdc55521.create = (params)=>{
    return new $3e1d8ac307543186$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodDate,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$bcc3b40f6b638044 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
}
$3e1d8ac307543186$export$bcc3b40f6b638044.create = (params)=>{
    return new $3e1d8ac307543186$export$bcc3b40f6b638044({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodSymbol,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$4e780e961c30340d extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
}
$3e1d8ac307543186$export$4e780e961c30340d.create = (params)=>{
    return new $3e1d8ac307543186$export$4e780e961c30340d({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodUndefined,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$a96281f914484f2d extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
}
$3e1d8ac307543186$export$a96281f914484f2d.create = (params)=>{
    return new $3e1d8ac307543186$export$a96281f914484f2d({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodNull,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$b9d1edb536b4e4eb extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
}
$3e1d8ac307543186$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $3e1d8ac307543186$export$b9d1edb536b4e4eb({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodAny,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$ef3b1bb1630977ae extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
}
$3e1d8ac307543186$export$ef3b1bb1630977ae.create = (params)=>{
    return new $3e1d8ac307543186$export$ef3b1bb1630977ae({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodUnknown,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$1e576a20c3ce9fb5 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
            code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
            expected: $3e1d8ac307543186$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $3e1d8ac307543186$export$9a105a556e65c2c0;
    }
}
$3e1d8ac307543186$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $3e1d8ac307543186$export$1e576a20c3ce9fb5({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodNever,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$7d39f5df85f21031 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
}
$3e1d8ac307543186$export$7d39f5df85f21031.create = (params)=>{
    return new $3e1d8ac307543186$export$7d39f5df85f21031({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodVoid,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$7acfc3e64785411 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.array) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $3e1d8ac307543186$export$5ba560653e4a1035.too_big : $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $3e1d8ac307543186$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $3e1d8ac307543186$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $3e1d8ac307543186$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $3e1d8ac307543186$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $3e1d8ac307543186$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $3e1d8ac307543186$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$3e1d8ac307543186$export$7acfc3e64785411.create = (schema, params)=>{
    return new $3e1d8ac307543186$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodArray,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
function $3e1d8ac307543186$var$deepPartialify(schema) {
    if (schema instanceof $3e1d8ac307543186$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $3e1d8ac307543186$export$aa56fec1e9d629b8.create($3e1d8ac307543186$var$deepPartialify(fieldSchema));
        }
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $3e1d8ac307543186$export$7acfc3e64785411) return new $3e1d8ac307543186$export$7acfc3e64785411({
        ...schema._def,
        type: $3e1d8ac307543186$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $3e1d8ac307543186$export$aa56fec1e9d629b8) return $3e1d8ac307543186$export$aa56fec1e9d629b8.create($3e1d8ac307543186$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $3e1d8ac307543186$export$aaac0b8b429cef5) return $3e1d8ac307543186$export$aaac0b8b429cef5.create($3e1d8ac307543186$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $3e1d8ac307543186$export$e2a18bb771d8e6a3) return $3e1d8ac307543186$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$3e1d8ac307543186$var$deepPartialify(item)));
    else return schema;
}
class $3e1d8ac307543186$export$736315c5b55efbad extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $3e1d8ac307543186$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $3e1d8ac307543186$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $3e1d8ac307543186$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                        code: $3e1d8ac307543186$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $3e1d8ac307543186$var$errorUtil.errToObj;
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $3e1d8ac307543186$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $3e1d8ac307543186$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $3e1d8ac307543186$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $3e1d8ac307543186$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $3e1d8ac307543186$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $3e1d8ac307543186$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $3e1d8ac307543186$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $3e1d8ac307543186$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $3e1d8ac307543186$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $3e1d8ac307543186$var$createZodEnum($3e1d8ac307543186$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$3e1d8ac307543186$export$736315c5b55efbad.create = (shape, params)=>{
    return new $3e1d8ac307543186$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $3e1d8ac307543186$export$1e576a20c3ce9fb5.create(),
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodObject,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
$3e1d8ac307543186$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $3e1d8ac307543186$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $3e1d8ac307543186$export$1e576a20c3ce9fb5.create(),
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodObject,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
$3e1d8ac307543186$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $3e1d8ac307543186$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $3e1d8ac307543186$export$1e576a20c3ce9fb5.create(),
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodObject,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$a8b236cb5070a311 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $3e1d8ac307543186$export$f98dac4b251ab333(result.ctx.common.issues));
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $3e1d8ac307543186$export$f98dac4b251ab333(issues));
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$3e1d8ac307543186$export$a8b236cb5070a311.create = (types, params)=>{
    return new $3e1d8ac307543186$export$a8b236cb5070a311({
        options: types,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodUnion,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $3e1d8ac307543186$var$getDiscriminator = (type)=>{
    if (type instanceof $3e1d8ac307543186$export$378d0cfce37406e6) return $3e1d8ac307543186$var$getDiscriminator(type.schema);
    else if (type instanceof $3e1d8ac307543186$export$a60af00cc0ce2582) return $3e1d8ac307543186$var$getDiscriminator(type.innerType());
    else if (type instanceof $3e1d8ac307543186$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $3e1d8ac307543186$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $3e1d8ac307543186$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $3e1d8ac307543186$export$bb19b37874861e7e) return $3e1d8ac307543186$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $3e1d8ac307543186$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $3e1d8ac307543186$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $3e1d8ac307543186$export$5ef2424805ac76a3 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.object) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $3e1d8ac307543186$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $3e1d8ac307543186$export$5ef2424805ac76a3({
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$3e1d8ac307543186$var$processCreateParams(params)
        });
    }
}
function $3e1d8ac307543186$var$mergeValues(a, b) {
    const aType = $3e1d8ac307543186$export$3e9057828ebd5c7a(a);
    const bType = $3e1d8ac307543186$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $3e1d8ac307543186$export$5716da67bfaa244d.object && bType === $3e1d8ac307543186$export$5716da67bfaa244d.object) {
        const bKeys = $3e1d8ac307543186$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $3e1d8ac307543186$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $3e1d8ac307543186$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $3e1d8ac307543186$export$5716da67bfaa244d.array && bType === $3e1d8ac307543186$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $3e1d8ac307543186$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $3e1d8ac307543186$export$5716da67bfaa244d.date && bType === $3e1d8ac307543186$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $3e1d8ac307543186$export$c02deaf0bb5203d4 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($3e1d8ac307543186$export$afa861e3c5730743(parsedLeft) || $3e1d8ac307543186$export$afa861e3c5730743(parsedRight)) return $3e1d8ac307543186$export$9a105a556e65c2c0;
            const merged = $3e1d8ac307543186$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $3e1d8ac307543186$export$9a105a556e65c2c0;
            }
            if ($3e1d8ac307543186$export$910b6cdd390341b3(parsedLeft) || $3e1d8ac307543186$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$3e1d8ac307543186$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $3e1d8ac307543186$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodIntersection,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$e2a18bb771d8e6a3 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.array) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $3e1d8ac307543186$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$3e1d8ac307543186$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $3e1d8ac307543186$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$a2acc09968cb4b7f extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.object) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $3e1d8ac307543186$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $3e1d8ac307543186$export$19342e026b58ebb7) return new $3e1d8ac307543186$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodRecord,
            ...$3e1d8ac307543186$var$processCreateParams(third)
        });
        return new $3e1d8ac307543186$export$a2acc09968cb4b7f({
            keyType: $3e1d8ac307543186$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodRecord,
            ...$3e1d8ac307543186$var$processCreateParams(second)
        });
    }
}
class $3e1d8ac307543186$export$163b6a2b712d9542 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.map) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$3e1d8ac307543186$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $3e1d8ac307543186$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodMap,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$977057706f816712 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.set) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $3e1d8ac307543186$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $3e1d8ac307543186$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $3e1d8ac307543186$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $3e1d8ac307543186$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $3e1d8ac307543186$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$3e1d8ac307543186$export$977057706f816712.create = (valueType, params)=>{
    return new $3e1d8ac307543186$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodSet,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$d4602ba55673f53c extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.function) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $3e1d8ac307543186$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $3e1d8ac307543186$export$32f27c719778d4c4(),
                    $3e1d8ac307543186$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $3e1d8ac307543186$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $3e1d8ac307543186$export$32f27c719778d4c4(),
                    $3e1d8ac307543186$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $3e1d8ac307543186$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $3e1d8ac307543186$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $3e1d8ac307543186$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $3e1d8ac307543186$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $3e1d8ac307543186$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $3e1d8ac307543186$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $3e1d8ac307543186$export$d4602ba55673f53c({
            ...this._def,
            args: $3e1d8ac307543186$export$e2a18bb771d8e6a3.create(items).rest($3e1d8ac307543186$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $3e1d8ac307543186$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $3e1d8ac307543186$export$d4602ba55673f53c({
            args: args ? args : $3e1d8ac307543186$export$e2a18bb771d8e6a3.create([]).rest($3e1d8ac307543186$export$ef3b1bb1630977ae.create()),
            returns: returns || $3e1d8ac307543186$export$ef3b1bb1630977ae.create(),
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodFunction,
            ...$3e1d8ac307543186$var$processCreateParams(params)
        });
    }
}
class $3e1d8ac307543186$export$378d0cfce37406e6 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$3e1d8ac307543186$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $3e1d8ac307543186$export$378d0cfce37406e6({
        getter: getter,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodLazy,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$7e44096782a165d3 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$3e1d8ac307543186$export$7e44096782a165d3.create = (value, params)=>{
    return new $3e1d8ac307543186$export$7e44096782a165d3({
        value: value,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodLiteral,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
function $3e1d8ac307543186$var$createZodEnum(values, params) {
    return new $3e1d8ac307543186$export$d325d1f0e1c20179({
        values: values,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodEnum,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
}
class $3e1d8ac307543186$export$d325d1f0e1c20179 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                expected: $3e1d8ac307543186$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $3e1d8ac307543186$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $3e1d8ac307543186$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$3e1d8ac307543186$export$d325d1f0e1c20179.create = $3e1d8ac307543186$var$createZodEnum;
class $3e1d8ac307543186$export$370b2e8d6d6f5c56 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $3e1d8ac307543186$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.string && ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.number) {
            const expectedValues = $3e1d8ac307543186$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                expected: $3e1d8ac307543186$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $3e1d8ac307543186$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$3e1d8ac307543186$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $3e1d8ac307543186$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodNativeEnum,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$3f196b0127d6e50a extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $3e1d8ac307543186$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $3e1d8ac307543186$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$3e1d8ac307543186$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $3e1d8ac307543186$export$3f196b0127d6e50a({
        type: schema,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodPromise,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$a60af00cc0ce2582 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $3e1d8ac307543186$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $3e1d8ac307543186$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$3e1d8ac307543186$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$3e1d8ac307543186$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $3e1d8ac307543186$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$3e1d8ac307543186$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $3e1d8ac307543186$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
$3e1d8ac307543186$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $3e1d8ac307543186$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodEffects,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$aa56fec1e9d629b8 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $3e1d8ac307543186$export$5716da67bfaa244d.undefined) return $3e1d8ac307543186$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$3e1d8ac307543186$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $3e1d8ac307543186$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodOptional,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$aaac0b8b429cef5 extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $3e1d8ac307543186$export$5716da67bfaa244d.null) return $3e1d8ac307543186$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$3e1d8ac307543186$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $3e1d8ac307543186$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodNullable,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$bb19b37874861e7e extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $3e1d8ac307543186$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$3e1d8ac307543186$export$bb19b37874861e7e.create = (type, params)=>{
    return new $3e1d8ac307543186$export$bb19b37874861e7e({
        innerType: type,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$75a44ec6249ac76b extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($3e1d8ac307543186$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $3e1d8ac307543186$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $3e1d8ac307543186$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$3e1d8ac307543186$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $3e1d8ac307543186$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
class $3e1d8ac307543186$export$26ccfa0145e8511f extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3e1d8ac307543186$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $3e1d8ac307543186$export$db7caee60e5d514d(ctx, {
                code: $3e1d8ac307543186$export$5ba560653e4a1035.invalid_type,
                expected: $3e1d8ac307543186$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $3e1d8ac307543186$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$3e1d8ac307543186$export$26ccfa0145e8511f.create = (params)=>{
    return new $3e1d8ac307543186$export$26ccfa0145e8511f({
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodNaN,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
const $3e1d8ac307543186$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $3e1d8ac307543186$export$66b0c798a395271f extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $3e1d8ac307543186$export$a3c3ef8a0e95c6da extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $3e1d8ac307543186$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $3e1d8ac307543186$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $3e1d8ac307543186$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $3e1d8ac307543186$export$5d1f7ef05c4e493a extends $3e1d8ac307543186$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($3e1d8ac307543186$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$3e1d8ac307543186$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $3e1d8ac307543186$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $3e1d8ac307543186$export$558106ce543bd011.ZodReadonly,
        ...$3e1d8ac307543186$var$processCreateParams(params)
    });
};
const $3e1d8ac307543186$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $3e1d8ac307543186$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $3e1d8ac307543186$export$b9d1edb536b4e4eb.create();
};
const $3e1d8ac307543186$export$1ee8ee30835eab8b = {
    object: $3e1d8ac307543186$export$736315c5b55efbad.lazycreate
};
var $3e1d8ac307543186$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($3e1d8ac307543186$export$558106ce543bd011 || ($3e1d8ac307543186$export$558106ce543bd011 = {}));
const $3e1d8ac307543186$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$3e1d8ac307543186$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $3e1d8ac307543186$export$22b082955e083ec3 = $3e1d8ac307543186$export$1230eb29b8d3b502.create;
const $3e1d8ac307543186$export$98e628dec113755e = $3e1d8ac307543186$export$5b070a55c0c43e09.create;
const $3e1d8ac307543186$export$9e06de0973666692 = $3e1d8ac307543186$export$26ccfa0145e8511f.create;
const $3e1d8ac307543186$export$a0f65b52274bcc00 = $3e1d8ac307543186$export$67d741fd70ff98f4.create;
const $3e1d8ac307543186$export$4a21f16c33752377 = $3e1d8ac307543186$export$723d146f80596191.create;
const $3e1d8ac307543186$export$324d90190a8b822a = $3e1d8ac307543186$export$e974be33bdc55521.create;
const $3e1d8ac307543186$export$8f701197936bc2a6 = $3e1d8ac307543186$export$bcc3b40f6b638044.create;
const $3e1d8ac307543186$export$1db45310990710a5 = $3e1d8ac307543186$export$4e780e961c30340d.create;
const $3e1d8ac307543186$export$7b1b591b262c240 = $3e1d8ac307543186$export$a96281f914484f2d.create;
const $3e1d8ac307543186$export$4154a199d7d90455 = $3e1d8ac307543186$export$b9d1edb536b4e4eb.create;
const $3e1d8ac307543186$export$19282c40b967aec6 = $3e1d8ac307543186$export$ef3b1bb1630977ae.create;
const $3e1d8ac307543186$export$b3e22bcfd64c1022 = $3e1d8ac307543186$export$1e576a20c3ce9fb5.create;
const $3e1d8ac307543186$export$490e536ee7389aeb = $3e1d8ac307543186$export$7d39f5df85f21031.create;
const $3e1d8ac307543186$export$2f23118c22fb2630 = $3e1d8ac307543186$export$7acfc3e64785411.create;
const $3e1d8ac307543186$export$be5493f9613cbbe = $3e1d8ac307543186$export$736315c5b55efbad.create;
const $3e1d8ac307543186$export$8fb0df5f40d0b477 = $3e1d8ac307543186$export$736315c5b55efbad.strictCreate;
const $3e1d8ac307543186$export$971dd5b0dfd021b6 = $3e1d8ac307543186$export$a8b236cb5070a311.create;
const $3e1d8ac307543186$export$4b888e40c4ee26dd = $3e1d8ac307543186$export$5ef2424805ac76a3.create;
const $3e1d8ac307543186$export$bc86dfbf7795668c = $3e1d8ac307543186$export$c02deaf0bb5203d4.create;
const $3e1d8ac307543186$export$65e3907585753458 = $3e1d8ac307543186$export$e2a18bb771d8e6a3.create;
const $3e1d8ac307543186$export$e5185e241753e543 = $3e1d8ac307543186$export$a2acc09968cb4b7f.create;
const $3e1d8ac307543186$export$871de8747c9eaa88 = $3e1d8ac307543186$export$163b6a2b712d9542.create;
const $3e1d8ac307543186$export$adaa4cf7ef1b65be = $3e1d8ac307543186$export$977057706f816712.create;
const $3e1d8ac307543186$export$44e51c8aac7c2deb = $3e1d8ac307543186$export$d4602ba55673f53c.create;
const $3e1d8ac307543186$export$488013bae63b21da = $3e1d8ac307543186$export$378d0cfce37406e6.create;
const $3e1d8ac307543186$export$c8ec6e1ec9fefcb0 = $3e1d8ac307543186$export$7e44096782a165d3.create;
const $3e1d8ac307543186$export$78a99c8d44d72635 = $3e1d8ac307543186$export$d325d1f0e1c20179.create;
const $3e1d8ac307543186$export$6fe7eca19ebe5199 = $3e1d8ac307543186$export$370b2e8d6d6f5c56.create;
const $3e1d8ac307543186$export$c957ef27a0ebfd4 = $3e1d8ac307543186$export$3f196b0127d6e50a.create;
const $3e1d8ac307543186$export$dc573d8a6576cdb3 = $3e1d8ac307543186$export$a60af00cc0ce2582.create;
const $3e1d8ac307543186$export$516e28dec6a4b6d4 = $3e1d8ac307543186$export$aa56fec1e9d629b8.create;
const $3e1d8ac307543186$export$133fc36489ac9add = $3e1d8ac307543186$export$aaac0b8b429cef5.create;
const $3e1d8ac307543186$export$fc37fe19dfda43ee = $3e1d8ac307543186$export$a60af00cc0ce2582.createWithPreprocess;
const $3e1d8ac307543186$export$43f28b24e1eb8181 = $3e1d8ac307543186$export$a3c3ef8a0e95c6da.create;
const $3e1d8ac307543186$export$3b3d07727c5b702c = ()=>$3e1d8ac307543186$export$22b082955e083ec3().optional();
const $3e1d8ac307543186$export$eb150471a61fced6 = ()=>$3e1d8ac307543186$export$98e628dec113755e().optional();
const $3e1d8ac307543186$export$269251733cdcbbf1 = ()=>$3e1d8ac307543186$export$4a21f16c33752377().optional();
const $3e1d8ac307543186$export$8c14e57e778d3873 = {
    string: (arg)=>$3e1d8ac307543186$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$3e1d8ac307543186$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$3e1d8ac307543186$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$3e1d8ac307543186$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$3e1d8ac307543186$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $3e1d8ac307543186$export$96c94437c95d7862 = $3e1d8ac307543186$export$9a105a556e65c2c0;
var $3e1d8ac307543186$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $3e1d8ac307543186$export$341b0b6e0a6f5099,
    setErrorMap: $3e1d8ac307543186$export$1097a8289cfd22d7,
    getErrorMap: $3e1d8ac307543186$export$32f27c719778d4c4,
    makeIssue: $3e1d8ac307543186$export$244a85fde9c419ed,
    EMPTY_PATH: $3e1d8ac307543186$export$1526d2e05f74572,
    addIssueToContext: $3e1d8ac307543186$export$db7caee60e5d514d,
    ParseStatus: $3e1d8ac307543186$export$5b20a5c3d05c1f6f,
    INVALID: $3e1d8ac307543186$export$9a105a556e65c2c0,
    DIRTY: $3e1d8ac307543186$export$325a211da9693fcf,
    OK: $3e1d8ac307543186$export$c6813a8d51f77eaf,
    isAborted: $3e1d8ac307543186$export$afa861e3c5730743,
    isDirty: $3e1d8ac307543186$export$910b6cdd390341b3,
    isValid: $3e1d8ac307543186$export$1ea939691cdc45b8,
    isAsync: $3e1d8ac307543186$export$aefee5ebe1dcfd9e,
    get util () {
        return $3e1d8ac307543186$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $3e1d8ac307543186$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $3e1d8ac307543186$export$5716da67bfaa244d,
    getParsedType: $3e1d8ac307543186$export$3e9057828ebd5c7a,
    ZodType: $3e1d8ac307543186$export$19342e026b58ebb7,
    ZodString: $3e1d8ac307543186$export$1230eb29b8d3b502,
    ZodNumber: $3e1d8ac307543186$export$5b070a55c0c43e09,
    ZodBigInt: $3e1d8ac307543186$export$67d741fd70ff98f4,
    ZodBoolean: $3e1d8ac307543186$export$723d146f80596191,
    ZodDate: $3e1d8ac307543186$export$e974be33bdc55521,
    ZodSymbol: $3e1d8ac307543186$export$bcc3b40f6b638044,
    ZodUndefined: $3e1d8ac307543186$export$4e780e961c30340d,
    ZodNull: $3e1d8ac307543186$export$a96281f914484f2d,
    ZodAny: $3e1d8ac307543186$export$b9d1edb536b4e4eb,
    ZodUnknown: $3e1d8ac307543186$export$ef3b1bb1630977ae,
    ZodNever: $3e1d8ac307543186$export$1e576a20c3ce9fb5,
    ZodVoid: $3e1d8ac307543186$export$7d39f5df85f21031,
    ZodArray: $3e1d8ac307543186$export$7acfc3e64785411,
    ZodObject: $3e1d8ac307543186$export$736315c5b55efbad,
    ZodUnion: $3e1d8ac307543186$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $3e1d8ac307543186$export$5ef2424805ac76a3,
    ZodIntersection: $3e1d8ac307543186$export$c02deaf0bb5203d4,
    ZodTuple: $3e1d8ac307543186$export$e2a18bb771d8e6a3,
    ZodRecord: $3e1d8ac307543186$export$a2acc09968cb4b7f,
    ZodMap: $3e1d8ac307543186$export$163b6a2b712d9542,
    ZodSet: $3e1d8ac307543186$export$977057706f816712,
    ZodFunction: $3e1d8ac307543186$export$d4602ba55673f53c,
    ZodLazy: $3e1d8ac307543186$export$378d0cfce37406e6,
    ZodLiteral: $3e1d8ac307543186$export$7e44096782a165d3,
    ZodEnum: $3e1d8ac307543186$export$d325d1f0e1c20179,
    ZodNativeEnum: $3e1d8ac307543186$export$370b2e8d6d6f5c56,
    ZodPromise: $3e1d8ac307543186$export$3f196b0127d6e50a,
    ZodEffects: $3e1d8ac307543186$export$a60af00cc0ce2582,
    ZodTransformer: $3e1d8ac307543186$export$a60af00cc0ce2582,
    ZodOptional: $3e1d8ac307543186$export$aa56fec1e9d629b8,
    ZodNullable: $3e1d8ac307543186$export$aaac0b8b429cef5,
    ZodDefault: $3e1d8ac307543186$export$bb19b37874861e7e,
    ZodCatch: $3e1d8ac307543186$export$75a44ec6249ac76b,
    ZodNaN: $3e1d8ac307543186$export$26ccfa0145e8511f,
    BRAND: $3e1d8ac307543186$export$cf2deea74cde46b4,
    ZodBranded: $3e1d8ac307543186$export$66b0c798a395271f,
    ZodPipeline: $3e1d8ac307543186$export$a3c3ef8a0e95c6da,
    ZodReadonly: $3e1d8ac307543186$export$5d1f7ef05c4e493a,
    custom: $3e1d8ac307543186$export$4c00f665f0d4b443,
    Schema: $3e1d8ac307543186$export$19342e026b58ebb7,
    ZodSchema: $3e1d8ac307543186$export$19342e026b58ebb7,
    late: $3e1d8ac307543186$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $3e1d8ac307543186$export$558106ce543bd011;
    },
    coerce: $3e1d8ac307543186$export$8c14e57e778d3873,
    any: $3e1d8ac307543186$export$4154a199d7d90455,
    array: $3e1d8ac307543186$export$2f23118c22fb2630,
    bigint: $3e1d8ac307543186$export$a0f65b52274bcc00,
    boolean: $3e1d8ac307543186$export$4a21f16c33752377,
    date: $3e1d8ac307543186$export$324d90190a8b822a,
    discriminatedUnion: $3e1d8ac307543186$export$4b888e40c4ee26dd,
    effect: $3e1d8ac307543186$export$dc573d8a6576cdb3,
    "enum": $3e1d8ac307543186$export$78a99c8d44d72635,
    "function": $3e1d8ac307543186$export$44e51c8aac7c2deb,
    "instanceof": $3e1d8ac307543186$export$3d916e7c22dbd8b5,
    intersection: $3e1d8ac307543186$export$bc86dfbf7795668c,
    lazy: $3e1d8ac307543186$export$488013bae63b21da,
    literal: $3e1d8ac307543186$export$c8ec6e1ec9fefcb0,
    map: $3e1d8ac307543186$export$871de8747c9eaa88,
    nan: $3e1d8ac307543186$export$9e06de0973666692,
    nativeEnum: $3e1d8ac307543186$export$6fe7eca19ebe5199,
    never: $3e1d8ac307543186$export$b3e22bcfd64c1022,
    "null": $3e1d8ac307543186$export$7b1b591b262c240,
    nullable: $3e1d8ac307543186$export$133fc36489ac9add,
    number: $3e1d8ac307543186$export$98e628dec113755e,
    object: $3e1d8ac307543186$export$be5493f9613cbbe,
    oboolean: $3e1d8ac307543186$export$269251733cdcbbf1,
    onumber: $3e1d8ac307543186$export$eb150471a61fced6,
    optional: $3e1d8ac307543186$export$516e28dec6a4b6d4,
    ostring: $3e1d8ac307543186$export$3b3d07727c5b702c,
    pipeline: $3e1d8ac307543186$export$43f28b24e1eb8181,
    preprocess: $3e1d8ac307543186$export$fc37fe19dfda43ee,
    promise: $3e1d8ac307543186$export$c957ef27a0ebfd4,
    record: $3e1d8ac307543186$export$e5185e241753e543,
    set: $3e1d8ac307543186$export$adaa4cf7ef1b65be,
    strictObject: $3e1d8ac307543186$export$8fb0df5f40d0b477,
    string: $3e1d8ac307543186$export$22b082955e083ec3,
    symbol: $3e1d8ac307543186$export$8f701197936bc2a6,
    transformer: $3e1d8ac307543186$export$dc573d8a6576cdb3,
    tuple: $3e1d8ac307543186$export$65e3907585753458,
    "undefined": $3e1d8ac307543186$export$1db45310990710a5,
    union: $3e1d8ac307543186$export$971dd5b0dfd021b6,
    unknown: $3e1d8ac307543186$export$19282c40b967aec6,
    "void": $3e1d8ac307543186$export$490e536ee7389aeb,
    NEVER: $3e1d8ac307543186$export$96c94437c95d7862,
    ZodIssueCode: $3e1d8ac307543186$export$5ba560653e4a1035,
    quotelessJson: $3e1d8ac307543186$export$913eddeaf297cfea,
    ZodError: $3e1d8ac307543186$export$f98dac4b251ab333
});

});


parcelRegister("l0IQQ", function(module, exports) {

$parcel$export(module.exports, "W3mFrameHelpers", function () { return $f4bc63988f115bf1$export$794efc40d8765bc4; });

var $jFjd7 = parcelRequire("jFjd7");

var $lr7C8 = parcelRequire("lr7C8");

var $b8Dze = parcelRequire("b8Dze");
const $f4bc63988f115bf1$var$EMAIL_MINIMUM_TIMEOUT = 30000;
const $f4bc63988f115bf1$export$794efc40d8765bc4 = {
    checkIfAllowedToTriggerEmail () {
        const lastEmailLoginTime = (0, $jFjd7.W3mFrameStorage).get((0, $lr7C8.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $f4bc63988f115bf1$var$EMAIL_MINIMUM_TIMEOUT) {
                const cooldownSec = Math.ceil(($f4bc63988f115bf1$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
                throw new Error(`Please try again after ${cooldownSec} seconds`);
            }
        }
    },
    getTimeToNextEmailLogin () {
        const lastEmailLoginTime = (0, $jFjd7.W3mFrameStorage).get((0, $lr7C8.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $f4bc63988f115bf1$var$EMAIL_MINIMUM_TIMEOUT) return Math.ceil(($f4bc63988f115bf1$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
        }
        return 0;
    },
    checkIfRequestExists (request) {
        return (0, $lr7C8.W3mFrameRpcConstants).NOT_SAFE_RPC_METHODS.includes(request.method) || (0, $lr7C8.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(request.method);
    },
    getResponseType (response) {
        const isPayloadString = typeof response === "string";
        const isTransactionHash = isPayloadString && (response?.match((0, $b8Dze.RegexUtil).transactionHash) || response?.match((0, $b8Dze.RegexUtil).signedMessage));
        if (isTransactionHash) return (0, $lr7C8.W3mFrameConstants).RPC_RESPONSE_TYPE_TX;
        return (0, $lr7C8.W3mFrameConstants).RPC_RESPONSE_TYPE_OBJECT;
    },
    checkIfRequestIsAllowed (request) {
        return (0, $lr7C8.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(request.method);
    },
    isClient: typeof window !== "undefined"
};

});
parcelRegister("jFjd7", function(module, exports) {

$parcel$export(module.exports, "W3mFrameStorage", function () { return $e510bf7757b7f96b$export$500c415dce2853c3; });

var $lr7C8 = parcelRequire("lr7C8");

var $l0IQQ = parcelRequire("l0IQQ");
const $e510bf7757b7f96b$export$500c415dce2853c3 = {
    set (key, value) {
        if ((0, $l0IQQ.W3mFrameHelpers).isClient) localStorage.setItem(`${(0, $lr7C8.W3mFrameConstants).STORAGE_KEY}${key}`, value);
    },
    get (key) {
        if ((0, $l0IQQ.W3mFrameHelpers).isClient) return localStorage.getItem(`${(0, $lr7C8.W3mFrameConstants).STORAGE_KEY}${key}`);
        return null;
    },
    delete (key, social) {
        if ((0, $l0IQQ.W3mFrameHelpers).isClient) {
            if (social) localStorage.removeItem(key);
            else localStorage.removeItem(`${(0, $lr7C8.W3mFrameConstants).STORAGE_KEY}${key}`);
        }
    }
};

});

parcelRegister("b8Dze", function(module, exports) {

$parcel$export(module.exports, "RegexUtil", function () { return $81bf224f759c9134$export$e5d4f8e67553e137; });
const $81bf224f759c9134$export$e5d4f8e67553e137 = {
    address: /^0x(?:[A-Fa-f0-9]{40})$/u,
    transactionHash: /^0x(?:[A-Fa-f0-9]{64})$/u,
    signedMessage: /^0x(?:[a-fA-F0-9]{62,})$/u
};

});



parcelRegister("2xFCG", function(module, exports) {

$parcel$export(module.exports, "W3mFrameProvider", function () { return $1d9ef347cf8e3113$export$112ca4a9acf9f612; });

var $jA9AY = parcelRequire("jA9AY");

var $lr7C8 = parcelRequire("lr7C8");

var $jFjd7 = parcelRequire("jFjd7");

var $l0IQQ = parcelRequire("l0IQQ");

var $atydC = parcelRequire("atydC");
class $1d9ef347cf8e3113$export$112ca4a9acf9f612 {
    constructor(projectId, chainId){
        this.openRpcRequests = [];
        this.w3mLogger = new (0, $atydC.W3mFrameLogger)(projectId);
        this.w3mFrame = new (0, $jA9AY.W3mFrame)(projectId, true, chainId);
    }
    getLoginEmailUsed() {
        return Boolean((0, $jFjd7.W3mFrameStorage).get((0, $lr7C8.W3mFrameConstants).EMAIL_LOGIN_USED_KEY));
    }
    getEmail() {
        return (0, $jFjd7.W3mFrameStorage).get((0, $lr7C8.W3mFrameConstants).EMAIL);
    }
    async connectEmail(payload) {
        try {
            (0, $l0IQQ.W3mFrameHelpers).checkIfAllowedToTriggerEmail();
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_CONNECT_EMAIL,
                payload: payload
            });
            this.setNewLastEmailLoginTime();
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error connecting email");
            throw error;
        }
    }
    async connectDevice() {
        try {
            return this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_CONNECT_DEVICE
            });
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error connecting device");
            throw error;
        }
    }
    async connectOtp(payload) {
        try {
            return this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_CONNECT_OTP,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error connecting otp");
            throw error;
        }
    }
    async isConnected() {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_IS_CONNECTED
            });
            if (!response.isConnected) this.deleteAuthLoginCache();
            return response;
        } catch (error) {
            this.deleteAuthLoginCache();
            this.w3mLogger.logger.error({
                error: error
            }, "Error checking connection");
            throw error;
        }
    }
    async getChainId() {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_GET_CHAIN_ID
            });
            this.setLastUsedChainId(response.chainId);
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error getting chain id");
            throw error;
        }
    }
    async getSocialRedirectUri(payload) {
        try {
            return this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_GET_SOCIAL_REDIRECT_URI,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error getting social redirect uri");
            throw error;
        }
    }
    async updateEmail(payload) {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_UPDATE_EMAIL,
                payload: payload
            });
            this.setNewLastEmailLoginTime();
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error updating email");
            throw error;
        }
    }
    async updateEmailPrimaryOtp(payload) {
        try {
            return this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_UPDATE_EMAIL_PRIMARY_OTP,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error updating email primary otp");
            throw error;
        }
    }
    async updateEmailSecondaryOtp(payload) {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_UPDATE_EMAIL_SECONDARY_OTP,
                payload: payload
            });
            this.setLoginSuccess(response.newEmail);
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error updating email secondary otp");
            throw error;
        }
    }
    async syncTheme(payload) {
        try {
            return this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_SYNC_THEME,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error syncing theme");
            throw error;
        }
    }
    async syncDappData(payload) {
        try {
            return this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_SYNC_DAPP_DATA,
                payload: payload
            });
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error syncing dapp data");
            throw error;
        }
    }
    async getSmartAccountEnabledNetworks() {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS
            });
            this.persistSmartAccountEnabledNetworks(response.smartAccountEnabledNetworks);
            return response;
        } catch (error) {
            this.persistSmartAccountEnabledNetworks([]);
            this.w3mLogger.logger.error({
                error: error
            }, "Error getting smart account enabled networks");
            throw error;
        }
    }
    async setPreferredAccount(type) {
        try {
            return this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_SET_PREFERRED_ACCOUNT,
                payload: {
                    type: type
                }
            });
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error setting preferred account");
            throw error;
        }
    }
    async connect(payload) {
        try {
            const chainId = payload?.chainId ?? this.getLastUsedChainId() ?? 1;
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_GET_USER,
                payload: {
                    ...payload,
                    chainId: chainId
                }
            });
            this.setLoginSuccess(response.email);
            this.setLastUsedChainId(response.chainId);
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error connecting");
            throw error;
        }
    }
    async connectSocial(uri) {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_CONNECT_SOCIAL,
                payload: {
                    uri: uri
                }
            });
            if (response.userName) this.setSocialLoginSuccess(response.userName);
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error connecting social");
            throw error;
        }
    }
    async getFarcasterUri() {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_GET_FARCASTER_URI
            });
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error getting farcaster uri");
            throw error;
        }
    }
    async connectFarcaster() {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_CONNECT_FARCASTER
            });
            if (response.userName) this.setSocialLoginSuccess(response.userName);
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error connecting farcaster");
            throw error;
        }
    }
    async switchNetwork(chainId) {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_SWITCH_NETWORK,
                payload: {
                    chainId: chainId
                }
            });
            this.setLastUsedChainId(response.chainId);
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error switching network");
            throw error;
        }
    }
    async disconnect() {
        try {
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_SIGN_OUT
            });
            this.deleteAuthLoginCache();
            return response;
        } catch (error) {
            this.w3mLogger.logger.error({
                error: error
            }, "Error disconnecting");
            throw error;
        }
    }
    async request(req) {
        try {
            if ((0, $lr7C8.W3mFrameRpcConstants).GET_CHAIN_ID === req.method) return this.getLastUsedChainId();
            this.rpcRequestHandler?.(req);
            const response = await this.appEvent({
                type: (0, $lr7C8.W3mFrameConstants).APP_RPC_REQUEST,
                payload: req
            });
            this.rpcSuccessHandler?.(response);
            return response;
        } catch (error) {
            this.rpcErrorHandler?.(error);
            this.w3mLogger.logger.error({
                error: error
            }, "Error requesting");
            throw error;
        }
    }
    onRpcRequest(callback) {
        this.rpcRequestHandler = callback;
    }
    onRpcSuccess(callback) {
        this.rpcSuccessHandler = callback;
    }
    onRpcError(callback) {
        this.rpcErrorHandler = callback;
    }
    onIsConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $lr7C8.W3mFrameConstants).FRAME_GET_USER_SUCCESS) callback(event.payload);
        });
    }
    onNotConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $lr7C8.W3mFrameConstants).FRAME_IS_CONNECTED_ERROR) callback();
            if (event.type === (0, $lr7C8.W3mFrameConstants).FRAME_IS_CONNECTED_SUCCESS && !event.payload.isConnected) callback();
        });
    }
    async getCapabilities() {
        try {
            const capabilities = await this.request({
                method: "wallet_getCapabilities"
            });
            return capabilities || {};
        } catch  {
            return {};
        }
    }
    onSetPreferredAccount(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $lr7C8.W3mFrameConstants).FRAME_SET_PREFERRED_ACCOUNT_SUCCESS) callback(event.payload);
            else if (event.type === (0, $lr7C8.W3mFrameConstants).FRAME_SET_PREFERRED_ACCOUNT_ERROR) callback({
                type: (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA
            });
        });
    }
    onGetSmartAccountEnabledNetworks(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $lr7C8.W3mFrameConstants).FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS) callback(event.payload.smartAccountEnabledNetworks);
            else if (event.type === (0, $lr7C8.W3mFrameConstants).FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR) callback([]);
        });
    }
    getAvailableChainIds() {
        return Object.keys(this.w3mFrame.networks);
    }
    rejectRpcRequests() {
        try {
            this.openRpcRequests.forEach(({ abortController: abortController, method: method })=>{
                if (!(0, $lr7C8.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(method)) abortController.abort();
            });
            this.openRpcRequests = [];
        } catch (e) {
            this.w3mLogger.logger.error({
                error: e
            }, "Error aborting RPC request");
        }
    }
    async appEvent(event) {
        await this.w3mFrame.frameLoadPromise;
        const type = event.type.replace("@w3m-app/", "");
        return new Promise((resolve, reject)=>{
            const id = Math.random().toString(36).substring(7);
            this.w3mLogger.logger.info?.({
                event: event,
                id: id
            }, "Sending app event");
            this.w3mFrame.events.postAppEvent({
                ...event,
                id: id
            });
            const abortController = new AbortController();
            if (type === "RPC_REQUEST") {
                const rpcEvent = event;
                this.openRpcRequests = [
                    ...this.openRpcRequests,
                    {
                        ...rpcEvent.payload,
                        abortController: abortController
                    }
                ];
            }
            abortController.signal.addEventListener("abort", ()=>{
                if (type === "RPC_REQUEST") reject(new Error("Request was aborted"));
            });
            function handler(framEvent) {
                if (framEvent.type === `@w3m-frame/${type}_SUCCESS`) {
                    if ("payload" in framEvent) resolve(framEvent.payload);
                    resolve(undefined);
                } else if (framEvent.type === `@w3m-frame/${type}_ERROR`) {
                    if ("payload" in framEvent) reject(new Error(framEvent.payload?.message || "An error occurred"));
                    reject(new Error("An error occurred"));
                }
            }
            this.w3mFrame.events.registerFrameEventHandler(id, handler, abortController.signal);
        });
    }
    setNewLastEmailLoginTime() {
        (0, $jFjd7.W3mFrameStorage).set((0, $lr7C8.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME, Date.now().toString());
    }
    setSocialLoginSuccess(username) {
        (0, $jFjd7.W3mFrameStorage).set((0, $lr7C8.W3mFrameConstants).SOCIAL_USERNAME, username);
    }
    setLoginSuccess(email) {
        if (email) (0, $jFjd7.W3mFrameStorage).set((0, $lr7C8.W3mFrameConstants).EMAIL, email);
        (0, $jFjd7.W3mFrameStorage).set((0, $lr7C8.W3mFrameConstants).EMAIL_LOGIN_USED_KEY, "true");
        (0, $jFjd7.W3mFrameStorage).delete((0, $lr7C8.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
    }
    deleteAuthLoginCache() {
        (0, $jFjd7.W3mFrameStorage).delete((0, $lr7C8.W3mFrameConstants).EMAIL_LOGIN_USED_KEY);
        (0, $jFjd7.W3mFrameStorage).delete((0, $lr7C8.W3mFrameConstants).EMAIL);
        (0, $jFjd7.W3mFrameStorage).delete((0, $lr7C8.W3mFrameConstants).LAST_USED_CHAIN_KEY);
        (0, $jFjd7.W3mFrameStorage).delete((0, $lr7C8.W3mFrameConstants).SOCIAL_USERNAME);
        (0, $jFjd7.W3mFrameStorage).delete((0, $lr7C8.W3mFrameConstants).SOCIAL, true);
    }
    setLastUsedChainId(chainId) {
        (0, $jFjd7.W3mFrameStorage).set((0, $lr7C8.W3mFrameConstants).LAST_USED_CHAIN_KEY, String(chainId));
    }
    getLastUsedChainId() {
        return Number((0, $jFjd7.W3mFrameStorage).get((0, $lr7C8.W3mFrameConstants).LAST_USED_CHAIN_KEY));
    }
    persistSmartAccountEnabledNetworks(networks) {
        (0, $jFjd7.W3mFrameStorage).set((0, $lr7C8.W3mFrameConstants).SMART_ACCOUNT_ENABLED_NETWORKS, networks.join(","));
    }
}

});
parcelRegister("atydC", function(module, exports) {

$parcel$export(module.exports, "W3mFrameLogger", function () { return $7a0727f3935e9501$export$d95526ab53dea907; });

var $GVAyr = parcelRequire("GVAyr");

var $lr7C8 = parcelRequire("lr7C8");
class $7a0727f3935e9501$export$d95526ab53dea907 {
    constructor(projectId){
        const loggerOptions = (0, $GVAyr.getDefaultLoggerOptions)({
            level: (0, $lr7C8.DEFAULT_LOG_LEVEL)
        });
        const { logger: logger, chunkLoggerController: chunkLoggerController } = (0, $GVAyr.generatePlatformLogger)({
            opts: loggerOptions
        });
        this.logger = (0, $GVAyr.generateChildLogger)(logger, this.constructor.name);
        this.chunkLoggerController = chunkLoggerController;
        if (typeof window !== "undefined" && this.chunkLoggerController?.downloadLogsBlobInBrowser) {
            if (!window.downloadAppKitLogsBlob) window.downloadAppKitLogsBlob = {};
            window.downloadAppKitLogsBlob["sdk"] = ()=>{
                if (this.chunkLoggerController?.downloadLogsBlobInBrowser) this.chunkLoggerController.downloadLogsBlobInBrowser({
                    projectId: projectId
                });
            };
        }
    }
}

});
parcelRegister("GVAyr", function(module, exports) {

$parcel$export(module.exports, "getDefaultLoggerOptions", function () { return $08109840c1c17ae5$export$bad2475df51c8ecc; });
$parcel$export(module.exports, "getLoggerContext", function () { return $08109840c1c17ae5$export$a283a9a0054a3c25; });
$parcel$export(module.exports, "generateChildLogger", function () { return $08109840c1c17ae5$export$4929e0372308a636; });
$parcel$export(module.exports, "generatePlatformLogger", function () { return $08109840c1c17ae5$export$15eba7fb5aaf9303; });
$parcel$export(module.exports, "pino", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6rVbn")))); });

var $6rVbn = parcelRequire("6rVbn");

var $6mXg5 = parcelRequire("6mXg5");
const $08109840c1c17ae5$export$341ee22b43fe3f8e = {
    level: "info"
}, $08109840c1c17ae5$export$fdd446d41f74bf3a = "custom_context", $08109840c1c17ae5$export$64bef9d49cc9288f = 1024000;
class $08109840c1c17ae5$var$O {
    constructor(e){
        this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
    }
    get value() {
        return this.nodeValue;
    }
    get size() {
        return this.sizeInBytes;
    }
}
class $08109840c1c17ae5$var$d {
    constructor(e){
        this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
    }
    append(e) {
        const t = new $08109840c1c17ae5$var$O(e);
        if (t.size > this.maxSizeInBytes) throw new Error(`[LinkedList] Value too big to insert into list: ${e} with size ${t.size}`);
        for(; this.size + t.size > this.maxSizeInBytes;)this.shift();
        this.head ? (this.tail && (this.tail.next = t), this.tail = t) : (this.head = t, this.tail = t), this.lengthInNodes++, this.sizeInBytes += t.size;
    }
    shift() {
        if (!this.head) return;
        const e = this.head;
        this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
    }
    toArray() {
        const e = [];
        let t = this.head;
        for(; t !== null;)e.push(t.value), t = t.next;
        return e;
    }
    get length() {
        return this.lengthInNodes;
    }
    get size() {
        return this.sizeInBytes;
    }
    toOrderedArray() {
        return Array.from(this);
    }
    [Symbol.iterator]() {
        let e = this.head;
        return {
            next: ()=>{
                if (!e) return {
                    done: !0,
                    value: null
                };
                const t = e.value;
                return e = e.next, {
                    done: !1,
                    value: t
                };
            }
        };
    }
}
class $08109840c1c17ae5$var$L {
    constructor(e, t = $08109840c1c17ae5$export$64bef9d49cc9288f){
        this.level = e ?? "error", this.levelValue = (0, $6rVbn.levels).values[this.level], this.MAX_LOG_SIZE_IN_BYTES = t, this.logs = new $08109840c1c17ae5$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    forwardToConsole(e, t) {
        t === (0, $6rVbn.levels).values.error ? console.error(e) : t === (0, $6rVbn.levels).values.warn ? console.warn(e) : t === (0, $6rVbn.levels).values.debug ? console.debug(e) : t === (0, $6rVbn.levels).values.trace ? console.trace(e) : console.log(e);
    }
    appendToLogs(e) {
        this.logs.append((0, $6mXg5.safeJsonStringify)({
            timestamp: new Date().toISOString(),
            log: e
        }));
        const t = typeof e == "string" ? JSON.parse(e).level : e.level;
        t >= this.levelValue && this.forwardToConsole(e, t);
    }
    getLogs() {
        return this.logs;
    }
    clearLogs() {
        this.logs = new $08109840c1c17ae5$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    getLogArray() {
        return Array.from(this.logs);
    }
    logsToBlob(e) {
        const t = this.getLogArray();
        return t.push((0, $6mXg5.safeJsonStringify)({
            extraMetadata: e
        })), new Blob(t, {
            type: "application/json"
        });
    }
}
class $08109840c1c17ae5$var$m {
    constructor(e, t = $08109840c1c17ae5$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $08109840c1c17ae5$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
    downloadLogsBlobInBrowser(e) {
        const t = URL.createObjectURL(this.logsToBlob(e)), o = document.createElement("a");
        o.href = t, o.download = `walletconnect-logs-${new Date().toISOString()}.txt`, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(t);
    }
}
class $08109840c1c17ae5$var$B {
    constructor(e, t = $08109840c1c17ae5$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $08109840c1c17ae5$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
}
var $08109840c1c17ae5$var$x = Object.defineProperty, $08109840c1c17ae5$var$S = Object.defineProperties, $08109840c1c17ae5$var$_ = Object.getOwnPropertyDescriptors, $08109840c1c17ae5$var$p = Object.getOwnPropertySymbols, $08109840c1c17ae5$var$T = Object.prototype.hasOwnProperty, $08109840c1c17ae5$var$z = Object.prototype.propertyIsEnumerable, $08109840c1c17ae5$var$f = (r, e, t)=>e in r ? $08109840c1c17ae5$var$x(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $08109840c1c17ae5$var$i = (r, e)=>{
    for(var t in e || (e = {}))$08109840c1c17ae5$var$T.call(e, t) && $08109840c1c17ae5$var$f(r, t, e[t]);
    if ($08109840c1c17ae5$var$p) for (var t of $08109840c1c17ae5$var$p(e))$08109840c1c17ae5$var$z.call(e, t) && $08109840c1c17ae5$var$f(r, t, e[t]);
    return r;
}, $08109840c1c17ae5$var$g = (r, e)=>$08109840c1c17ae5$var$S(r, $08109840c1c17ae5$var$_(e));
function $08109840c1c17ae5$export$bad2475df51c8ecc(r) {
    return $08109840c1c17ae5$var$g($08109840c1c17ae5$var$i({}, r), {
        level: r?.level || $08109840c1c17ae5$export$341ee22b43fe3f8e.level
    });
}
function $08109840c1c17ae5$export$e8faae0482d84e9e(r, e = $08109840c1c17ae5$export$fdd446d41f74bf3a) {
    return r[e] || "";
}
function $08109840c1c17ae5$export$758f352b7265b00e(r, e, t = $08109840c1c17ae5$export$fdd446d41f74bf3a) {
    return r[t] = e, r;
}
function $08109840c1c17ae5$export$a283a9a0054a3c25(r, e = $08109840c1c17ae5$export$fdd446d41f74bf3a) {
    let t = "";
    return typeof r.bindings > "u" ? t = $08109840c1c17ae5$export$e8faae0482d84e9e(r, e) : t = r.bindings().context || "", t;
}
function $08109840c1c17ae5$export$307261146df20465(r, e, t = $08109840c1c17ae5$export$fdd446d41f74bf3a) {
    const o = $08109840c1c17ae5$export$a283a9a0054a3c25(r, t);
    return o.trim() ? `${o}/${e}` : e;
}
function $08109840c1c17ae5$export$4929e0372308a636(r, e, t = $08109840c1c17ae5$export$fdd446d41f74bf3a) {
    const o = $08109840c1c17ae5$export$307261146df20465(r, e, t), a = r.child({
        context: o
    });
    return $08109840c1c17ae5$export$758f352b7265b00e(a, o, t);
}
function $08109840c1c17ae5$export$2ca1453636a43a7(r) {
    var e, t;
    const o = new $08109840c1c17ae5$var$m((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($6rVbn)))($08109840c1c17ae5$var$g($08109840c1c17ae5$var$i({}, r.opts), {
            level: "trace",
            browser: $08109840c1c17ae5$var$g($08109840c1c17ae5$var$i({}, (t = r.opts) == null ? void 0 : t.browser), {
                write: (a)=>o.write(a)
            })
        })),
        chunkLoggerController: o
    };
}
function $08109840c1c17ae5$export$495ac2973e46cb97(r) {
    var e;
    const t = new $08109840c1c17ae5$var$B((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($6rVbn)))($08109840c1c17ae5$var$g($08109840c1c17ae5$var$i({}, r.opts), {
            level: "trace"
        }), t),
        chunkLoggerController: t
    };
}
function $08109840c1c17ae5$export$15eba7fb5aaf9303(r) {
    return typeof r.loggerOverride < "u" && typeof r.loggerOverride != "string" ? {
        logger: r.loggerOverride,
        chunkLoggerController: null
    } : typeof window < "u" ? $08109840c1c17ae5$export$2ca1453636a43a7(r) : $08109840c1c17ae5$export$495ac2973e46cb97(r);
}

});
parcelRegister("6rVbn", function(module, exports) {
"use strict";

var $jJoQN = parcelRequire("jJoQN");
module.exports = $4b219ef21f602b0d$var$pino;
const $4b219ef21f602b0d$var$_console = $4b219ef21f602b0d$var$pfGlobalThisOrFallback().console || {};
const $4b219ef21f602b0d$var$stdSerializers = {
    mapHttpRequest: $4b219ef21f602b0d$var$mock,
    mapHttpResponse: $4b219ef21f602b0d$var$mock,
    wrapRequestSerializer: $4b219ef21f602b0d$var$passthrough,
    wrapResponseSerializer: $4b219ef21f602b0d$var$passthrough,
    wrapErrorSerializer: $4b219ef21f602b0d$var$passthrough,
    req: $4b219ef21f602b0d$var$mock,
    res: $4b219ef21f602b0d$var$mock,
    err: $4b219ef21f602b0d$var$asErrValue
};
function $4b219ef21f602b0d$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $4b219ef21f602b0d$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $4b219ef21f602b0d$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $4b219ef21f602b0d$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $4b219ef21f602b0d$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $4b219ef21f602b0d$var$getTimeFunction(opts)
    };
    logger.levels = $4b219ef21f602b0d$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $4b219ef21f602b0d$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $4b219ef21f602b0d$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $4b219ef21f602b0d$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $4b219ef21f602b0d$var$set(setOpts, logger, "fatal", "error");
        $4b219ef21f602b0d$var$set(setOpts, logger, "warn", "error");
        $4b219ef21f602b0d$var$set(setOpts, logger, "info", "log");
        $4b219ef21f602b0d$var$set(setOpts, logger, "debug", "log");
        $4b219ef21f602b0d$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $4b219ef21f602b0d$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $4b219ef21f602b0d$var$bind(parent, bindings, "error");
            this.fatal = $4b219ef21f602b0d$var$bind(parent, bindings, "fatal");
            this.warn = $4b219ef21f602b0d$var$bind(parent, bindings, "warn");
            this.info = $4b219ef21f602b0d$var$bind(parent, bindings, "info");
            this.debug = $4b219ef21f602b0d$var$bind(parent, bindings, "debug");
            this.trace = $4b219ef21f602b0d$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $4b219ef21f602b0d$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$4b219ef21f602b0d$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$4b219ef21f602b0d$var$pino.stdSerializers = $4b219ef21f602b0d$var$stdSerializers;
$4b219ef21f602b0d$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $4b219ef21f602b0d$var$nullTime,
    epochTime: $4b219ef21f602b0d$var$epochTime,
    unixTime: $4b219ef21f602b0d$var$unixTime,
    isoTime: $4b219ef21f602b0d$var$isoTime
});
function $4b219ef21f602b0d$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $4b219ef21f602b0d$var$noop : proto[level] ? proto[level] : $4b219ef21f602b0d$var$_console[level] || $4b219ef21f602b0d$var$_console[fallback] || $4b219ef21f602b0d$var$noop;
    $4b219ef21f602b0d$var$wrap(opts, logger, level);
}
function $4b219ef21f602b0d$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $4b219ef21f602b0d$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $4b219ef21f602b0d$var$_console ? $4b219ef21f602b0d$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $4b219ef21f602b0d$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $4b219ef21f602b0d$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $4b219ef21f602b0d$var$pino.levels.values[transmitLevel];
                const methodValue = $4b219ef21f602b0d$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $4b219ef21f602b0d$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $4b219ef21f602b0d$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $4b219ef21f602b0d$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $4b219ef21f602b0d$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $4b219ef21f602b0d$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $jJoQN(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $jJoQN(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $4b219ef21f602b0d$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $4b219ef21f602b0d$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $4b219ef21f602b0d$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $4b219ef21f602b0d$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $4b219ef21f602b0d$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $4b219ef21f602b0d$var$createLogEventShape(bindings);
}
function $4b219ef21f602b0d$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $4b219ef21f602b0d$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $4b219ef21f602b0d$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $4b219ef21f602b0d$var$nullTime;
    return $4b219ef21f602b0d$var$epochTime;
}
function $4b219ef21f602b0d$var$mock() {
    return {};
}
function $4b219ef21f602b0d$var$passthrough(a) {
    return a;
}
function $4b219ef21f602b0d$var$noop() {}
function $4b219ef21f602b0d$var$nullTime() {
    return false;
}
function $4b219ef21f602b0d$var$epochTime() {
    return Date.now();
}
function $4b219ef21f602b0d$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $4b219ef21f602b0d$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $4b219ef21f602b0d$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("jJoQN", function(module, exports) {
"use strict";
function $e5d57f1c717bd9dd$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $e5d57f1c717bd9dd$var$format;
function $e5d57f1c717bd9dd$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $e5d57f1c717bd9dd$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRegister("6mXg5", function(module, exports) {

$parcel$export(module.exports, "safeJsonParse", function () { return $4a32c3a485b06104$export$84137bb44359aed5; });
$parcel$export(module.exports, "safeJsonStringify", function () { return $4a32c3a485b06104$export$abc3f407e87918a4; });
const $4a32c3a485b06104$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $4a32c3a485b06104$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $4a32c3a485b06104$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $4a32c3a485b06104$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $4a32c3a485b06104$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $4a32c3a485b06104$var$JSONStringify(value) || "";
}

});







parcelRegister("m3nYM", function(module, exports) {

$parcel$export(module.exports, "SwapApiUtil", function () { return $0424ae87c9ca135b$export$1f5dcd8c91bd5bea; });

var $hlVrM = parcelRequire("hlVrM");

var $6AwK8 = parcelRequire("6AwK8");

var $hxXs8 = parcelRequire("hxXs8");

var $8BVTM = parcelRequire("8BVTM");

var $jbD0z = parcelRequire("jbD0z");

var $f7IXw = parcelRequire("f7IXw");

var $d94Xg = parcelRequire("d94Xg");
const $0424ae87c9ca135b$export$1f5dcd8c91bd5bea = {
    async getTokenList () {
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        const response = await (0, $hxXs8.BlockchainApiController).fetchSwapTokens({
            chainId: caipNetwork?.id,
            projectId: (0, $8BVTM.OptionsController).state.projectId
        });
        const tokens = response?.tokens?.map((token)=>({
                ...token,
                eip2612: false,
                quantity: {
                    decimals: "0",
                    numeric: "0"
                },
                price: 0,
                value: 0
            })) || [];
        return tokens;
    },
    async fetchGasPrice () {
        const projectId = (0, $8BVTM.OptionsController).state.projectId;
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        if (!caipNetwork) return null;
        return await (0, $hxXs8.BlockchainApiController).fetchGasPrice({
            projectId: projectId,
            chainId: caipNetwork.id
        });
    },
    async fetchSwapAllowance ({ tokenAddress: tokenAddress, userAddress: userAddress, sourceTokenAmount: sourceTokenAmount, sourceTokenDecimals: sourceTokenDecimals }) {
        const projectId = (0, $8BVTM.OptionsController).state.projectId;
        const response = await (0, $hxXs8.BlockchainApiController).fetchSwapAllowance({
            projectId: projectId,
            tokenAddress: tokenAddress,
            userAddress: userAddress
        });
        if (response?.allowance && sourceTokenAmount && sourceTokenDecimals) {
            const parsedValue = (0, $hlVrM.ConnectionController).parseUnits(sourceTokenAmount, sourceTokenDecimals) || 0;
            const hasAllowance = BigInt(response.allowance) >= parsedValue;
            return hasAllowance;
        }
        return false;
    },
    async getMyTokensWithBalance (forceUpdate) {
        const address = (0, $f7IXw.AccountController).state.address;
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        if (!address || !caipNetwork) return [];
        const response = await (0, $hxXs8.BlockchainApiController).getBalance(address, caipNetwork.id, forceUpdate);
        const balances = response.balances.filter((balance)=>balance.quantity.decimals !== "0");
        (0, $f7IXw.AccountController).setTokenBalance(balances, (0, $d94Xg.ChainController).state.activeChain);
        return this.mapBalancesToSwapTokens(balances);
    },
    mapBalancesToSwapTokens (balances) {
        return balances?.map((token)=>({
                ...token,
                address: token?.address ? token.address : `${token.chainId}:${(0, $6AwK8.ConstantsUtil).NATIVE_TOKEN_ADDRESS}`,
                decimals: parseInt(token.quantity.decimals, 10),
                logoUri: token.iconUrl,
                eip2612: false
            })) || [];
    }
};

});

parcelRegister("6mRzS", function(module, exports) {

$parcel$export(module.exports, "RouterController", function () { return $4a2e5b924ffc3e29$export$5ceead2526330ba8; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");
// -- State --------------------------------------------- //
const $4a2e5b924ffc3e29$var$state = (0, $eAQzZ.proxy)({
    view: "Connect",
    history: [
        "Connect"
    ],
    transactionStack: []
});
const $4a2e5b924ffc3e29$export$5ceead2526330ba8 = {
    state: $4a2e5b924ffc3e29$var$state,
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($4a2e5b924ffc3e29$var$state, key, callback);
    },
    pushTransactionStack (action) {
        $4a2e5b924ffc3e29$var$state.transactionStack.push(action);
    },
    popTransactionStack (cancel) {
        const action = $4a2e5b924ffc3e29$var$state.transactionStack.pop();
        if (!action) return;
        if (cancel) {
            this.goBack();
            action?.onCancel?.();
        } else {
            if (action.goBack) this.goBack();
            else if (action.view) this.reset(action.view);
            action?.onSuccess?.();
        }
    },
    push (view, data) {
        if (view !== $4a2e5b924ffc3e29$var$state.view) {
            $4a2e5b924ffc3e29$var$state.view = view;
            $4a2e5b924ffc3e29$var$state.history.push(view);
            $4a2e5b924ffc3e29$var$state.data = data;
        }
    },
    reset (view) {
        $4a2e5b924ffc3e29$var$state.view = view;
        $4a2e5b924ffc3e29$var$state.history = [
            view
        ];
    },
    replace (view, data) {
        if ($4a2e5b924ffc3e29$var$state.history.length >= 1 && $4a2e5b924ffc3e29$var$state.history.at(-1) !== view) {
            $4a2e5b924ffc3e29$var$state.view = view;
            $4a2e5b924ffc3e29$var$state.history[$4a2e5b924ffc3e29$var$state.history.length - 1] = view;
            $4a2e5b924ffc3e29$var$state.data = data;
        }
    },
    goBack () {
        if ($4a2e5b924ffc3e29$var$state.history.length > 1) {
            $4a2e5b924ffc3e29$var$state.history.pop();
            const [last] = $4a2e5b924ffc3e29$var$state.history.slice(-1);
            if (last) $4a2e5b924ffc3e29$var$state.view = last;
        }
    },
    goBackToIndex (historyIndex) {
        if ($4a2e5b924ffc3e29$var$state.history.length > 1) {
            $4a2e5b924ffc3e29$var$state.history = $4a2e5b924ffc3e29$var$state.history.slice(0, historyIndex + 1);
            const [last] = $4a2e5b924ffc3e29$var$state.history.slice(-1);
            if (last) $4a2e5b924ffc3e29$var$state.view = last;
        }
    }
};

});

parcelRegister("7WhJR", function(module, exports) {

$parcel$export(module.exports, "SwapCalculationUtil", function () { return $5c7bb5bb27dea593$export$c185d942b7ce88b4; });
// -- Types --------------------------------------------- //
parcelRequire("ikDNi");
var $l2EhC = parcelRequire("l2EhC");
const $5c7bb5bb27dea593$export$c185d942b7ce88b4 = {
    getGasPriceInEther (gas, gasPrice) {
        const totalGasCostInWei = gasPrice * gas;
        const totalGasCostInEther = Number(totalGasCostInWei) / 1e18;
        return totalGasCostInEther;
    },
    getGasPriceInUSD (networkPrice, gas, gasPrice) {
        const totalGasCostInEther = $5c7bb5bb27dea593$export$c185d942b7ce88b4.getGasPriceInEther(gas, gasPrice);
        const networkPriceInUSD = (0, $l2EhC.NumberUtil).bigNumber(networkPrice);
        const gasCostInUSD = networkPriceInUSD.multipliedBy(totalGasCostInEther);
        return gasCostInUSD.toNumber();
    },
    getPriceImpact ({ sourceTokenAmount: sourceTokenAmount, sourceTokenPriceInUSD: sourceTokenPriceInUSD, toTokenPriceInUSD: toTokenPriceInUSD, toTokenAmount: toTokenAmount }) {
        const inputValue = (0, $l2EhC.NumberUtil).bigNumber(sourceTokenAmount).multipliedBy(sourceTokenPriceInUSD);
        const outputValue = (0, $l2EhC.NumberUtil).bigNumber(toTokenAmount).multipliedBy(toTokenPriceInUSD);
        const priceImpact = inputValue.minus(outputValue).dividedBy(inputValue).multipliedBy(100);
        return priceImpact.toNumber();
    },
    getMaxSlippage (slippage, toTokenAmount) {
        const slippageToleranceDecimal = (0, $l2EhC.NumberUtil).bigNumber(slippage).dividedBy(100);
        const maxSlippageAmount = (0, $l2EhC.NumberUtil).multiply(toTokenAmount, slippageToleranceDecimal);
        return maxSlippageAmount.toNumber();
    },
    getProviderFee (sourceTokenAmount, feePercentage = 0.0085) {
        const providerFee = (0, $l2EhC.NumberUtil).bigNumber(sourceTokenAmount).multipliedBy(feePercentage);
        return providerFee.toString();
    },
    isInsufficientNetworkTokenForGas (networkBalanceInUSD, gasPriceInUSD) {
        const gasPrice = gasPriceInUSD || "0";
        if ((0, $l2EhC.NumberUtil).bigNumber(networkBalanceInUSD).isZero()) return true;
        return (0, $l2EhC.NumberUtil).bigNumber((0, $l2EhC.NumberUtil).bigNumber(gasPrice)).isGreaterThan(networkBalanceInUSD);
    },
    isInsufficientSourceTokenForSwap (sourceTokenAmount, sourceTokenAddress, balance) {
        const sourceTokenBalance = balance?.find((token)=>token.address === sourceTokenAddress)?.quantity?.numeric;
        const isInSufficientBalance = (0, $l2EhC.NumberUtil).bigNumber(sourceTokenBalance || "0").isLessThan(sourceTokenAmount);
        return isInSufficientBalance;
    },
    getToTokenAmount ({ sourceToken: sourceToken, toToken: toToken, sourceTokenPrice: sourceTokenPrice, toTokenPrice: toTokenPrice, sourceTokenAmount: sourceTokenAmount }) {
        if (sourceTokenAmount === "0") return "0";
        if (!sourceToken || !toToken) return "0";
        const sourceTokenDecimals = sourceToken.decimals;
        const sourceTokenPriceInUSD = sourceTokenPrice;
        const toTokenDecimals = toToken.decimals;
        const toTokenPriceInUSD = toTokenPrice;
        if (toTokenPriceInUSD <= 0) return "0";
        // Calculate the provider fee (0.85% of the source token amount)
        const providerFee = (0, $l2EhC.NumberUtil).bigNumber(sourceTokenAmount).multipliedBy(0.0085);
        // Adjust the source token amount by subtracting the provider fee
        const adjustedSourceTokenAmount = (0, $l2EhC.NumberUtil).bigNumber(sourceTokenAmount).minus(providerFee);
        // Proceed with conversion using the adjusted source token amount
        const sourceAmountInSmallestUnit = adjustedSourceTokenAmount.multipliedBy((0, $l2EhC.NumberUtil).bigNumber(10).pow(sourceTokenDecimals));
        const priceRatio = (0, $l2EhC.NumberUtil).bigNumber(sourceTokenPriceInUSD).dividedBy(toTokenPriceInUSD);
        const decimalDifference = sourceTokenDecimals - toTokenDecimals;
        const toTokenAmountInSmallestUnit = sourceAmountInSmallestUnit.multipliedBy(priceRatio).dividedBy((0, $l2EhC.NumberUtil).bigNumber(10).pow(decimalDifference));
        const toTokenAmount = toTokenAmountInSmallestUnit.dividedBy((0, $l2EhC.NumberUtil).bigNumber(10).pow(toTokenDecimals));
        const amount = toTokenAmount.toFixed(toTokenDecimals).toString();
        return amount;
    }
};

});




parcelRegister("jM3Wq", function(module, exports) {

$parcel$export(module.exports, "OnRampController", function () { return $e6558eb39ff37525$export$8cdcd0d64858bea7; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $6AwK8 = parcelRequire("6AwK8");

var $hxXs8 = parcelRequire("hxXs8");

var $g4s8N = parcelRequire("g4s8N");
const $e6558eb39ff37525$export$fed6f7f3caffd3f0 = {
    id: "2b92315d-eab7-5bef-84fa-089a131333f5",
    name: "USD Coin",
    symbol: "USDC",
    networks: [
        {
            name: "ethereum-mainnet",
            display_name: "Ethereum",
            chain_id: "1",
            contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
        },
        {
            name: "polygon-mainnet",
            display_name: "Polygon",
            chain_id: "137",
            contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
        }
    ]
};
const $e6558eb39ff37525$export$213201b848d8007c = {
    id: "USD",
    payment_method_limits: [
        {
            id: "card",
            min: "10.00",
            max: "7500.00"
        },
        {
            id: "ach_bank_account",
            min: "10.00",
            max: "25000.00"
        }
    ]
};
const $e6558eb39ff37525$var$defaultState = {
    providers: (0, $6AwK8.ONRAMP_PROVIDERS),
    selectedProvider: null,
    error: null,
    purchaseCurrency: $e6558eb39ff37525$export$fed6f7f3caffd3f0,
    paymentCurrency: $e6558eb39ff37525$export$213201b848d8007c,
    purchaseCurrencies: [
        $e6558eb39ff37525$export$fed6f7f3caffd3f0
    ],
    paymentCurrencies: [],
    quotesLoading: false
};
// -- State --------------------------------------------- //
const $e6558eb39ff37525$var$state = (0, $eAQzZ.proxy)($e6558eb39ff37525$var$defaultState);
const $e6558eb39ff37525$export$8cdcd0d64858bea7 = {
    state: $e6558eb39ff37525$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($e6558eb39ff37525$var$state, ()=>callback($e6558eb39ff37525$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($e6558eb39ff37525$var$state, key, callback);
    },
    setSelectedProvider (provider) {
        $e6558eb39ff37525$var$state.selectedProvider = provider;
    },
    setPurchaseCurrency (currency) {
        $e6558eb39ff37525$var$state.purchaseCurrency = currency;
    },
    setPaymentCurrency (currency) {
        $e6558eb39ff37525$var$state.paymentCurrency = currency;
    },
    setPurchaseAmount (amount) {
        this.state.purchaseAmount = amount;
    },
    setPaymentAmount (amount) {
        this.state.paymentAmount = amount;
    },
    async getAvailableCurrencies () {
        const options = await (0, $hxXs8.BlockchainApiController).getOnrampOptions();
        $e6558eb39ff37525$var$state.purchaseCurrencies = options.purchaseCurrencies;
        $e6558eb39ff37525$var$state.paymentCurrencies = options.paymentCurrencies;
        $e6558eb39ff37525$var$state.paymentCurrency = options.paymentCurrencies[0] || $e6558eb39ff37525$export$213201b848d8007c;
        $e6558eb39ff37525$var$state.purchaseCurrency = options.purchaseCurrencies[0] || $e6558eb39ff37525$export$fed6f7f3caffd3f0;
        await (0, $g4s8N.ApiController).fetchCurrencyImages(options.paymentCurrencies.map((currency)=>currency.id));
        await (0, $g4s8N.ApiController).fetchTokenImages(options.purchaseCurrencies.map((currency)=>currency.symbol));
    },
    async getQuote () {
        $e6558eb39ff37525$var$state.quotesLoading = true;
        try {
            const quote = await (0, $hxXs8.BlockchainApiController).getOnrampQuote({
                purchaseCurrency: $e6558eb39ff37525$var$state.purchaseCurrency,
                paymentCurrency: $e6558eb39ff37525$var$state.paymentCurrency,
                amount: $e6558eb39ff37525$var$state.paymentAmount?.toString() || "0",
                network: $e6558eb39ff37525$var$state.purchaseCurrency?.symbol
            });
            $e6558eb39ff37525$var$state.quotesLoading = false;
            $e6558eb39ff37525$var$state.purchaseAmount = Number(quote.purchaseAmount.amount);
            return quote;
        } catch (error) {
            $e6558eb39ff37525$var$state.error = error.message;
            $e6558eb39ff37525$var$state.quotesLoading = false;
            return null;
        } finally{
            $e6558eb39ff37525$var$state.quotesLoading = false;
        }
    },
    resetState () {
        $e6558eb39ff37525$var$state.providers = (0, $6AwK8.ONRAMP_PROVIDERS);
        $e6558eb39ff37525$var$state.selectedProvider = null;
        $e6558eb39ff37525$var$state.error = null;
        $e6558eb39ff37525$var$state.purchaseCurrency = $e6558eb39ff37525$export$fed6f7f3caffd3f0;
        $e6558eb39ff37525$var$state.paymentCurrency = $e6558eb39ff37525$export$213201b848d8007c;
        $e6558eb39ff37525$var$state.purchaseCurrencies = [
            $e6558eb39ff37525$export$fed6f7f3caffd3f0
        ];
        $e6558eb39ff37525$var$state.paymentCurrencies = [];
        $e6558eb39ff37525$var$state.paymentAmount = undefined;
        $e6558eb39ff37525$var$state.purchaseAmount = undefined;
        $e6558eb39ff37525$var$state.quotesLoading = false;
    }
};

});

parcelRegister("3BhS7", function(module, exports) {

$parcel$export(module.exports, "SendController", function () { return $29f2b0cac0b3feb7$export$e3bfd79582777e03; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");
parcelRequire("ikDNi");
var $bZ3oL = parcelRequire("bZ3oL");

var $6mRzS = parcelRequire("6mRzS");

var $f7IXw = parcelRequire("f7IXw");

var $hlVrM = parcelRequire("hlVrM");

var $br7WV = parcelRequire("br7WV");

var $c4rfq = parcelRequire("c4rfq");

var $6m17w = parcelRequire("6m17w");

var $jbD0z = parcelRequire("jbD0z");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
// -- State --------------------------------------------- //
const $29f2b0cac0b3feb7$var$state = (0, $eAQzZ.proxy)({
    loading: false
});
const $29f2b0cac0b3feb7$export$e3bfd79582777e03 = {
    state: $29f2b0cac0b3feb7$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($29f2b0cac0b3feb7$var$state, ()=>callback($29f2b0cac0b3feb7$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($29f2b0cac0b3feb7$var$state, key, callback);
    },
    setToken (token) {
        if (token) $29f2b0cac0b3feb7$var$state.token = (0, $eAQzZ.ref)(token);
    },
    setTokenAmount (sendTokenAmount) {
        $29f2b0cac0b3feb7$var$state.sendTokenAmount = sendTokenAmount;
    },
    setReceiverAddress (receiverAddress) {
        $29f2b0cac0b3feb7$var$state.receiverAddress = receiverAddress;
    },
    setReceiverProfileImageUrl (receiverProfileImageUrl) {
        $29f2b0cac0b3feb7$var$state.receiverProfileImageUrl = receiverProfileImageUrl;
    },
    setReceiverProfileName (receiverProfileName) {
        $29f2b0cac0b3feb7$var$state.receiverProfileName = receiverProfileName;
    },
    setGasPrice (gasPrice) {
        $29f2b0cac0b3feb7$var$state.gasPrice = gasPrice;
    },
    setGasPriceInUsd (gasPriceInUSD) {
        $29f2b0cac0b3feb7$var$state.gasPriceInUSD = gasPriceInUSD;
    },
    setLoading (loading) {
        $29f2b0cac0b3feb7$var$state.loading = loading;
    },
    sendToken () {
        if (this.state.token?.address && this.state.sendTokenAmount && this.state.receiverAddress) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "SEND_INITIATED",
                properties: {
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    token: this.state.token.address,
                    amount: this.state.sendTokenAmount,
                    network: (0, $jbD0z.NetworkController).state.caipNetwork?.id || ""
                }
            });
            this.sendERC20Token({
                receiverAddress: this.state.receiverAddress,
                tokenAddress: this.state.token.address,
                sendTokenAmount: this.state.sendTokenAmount,
                decimals: this.state.token.quantity.decimals
            });
        } else if (this.state.receiverAddress && this.state.sendTokenAmount && this.state.gasPrice && this.state.token?.quantity.decimals) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "SEND_INITIATED",
                properties: {
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    token: this.state.token?.symbol,
                    amount: this.state.sendTokenAmount,
                    network: (0, $jbD0z.NetworkController).state.caipNetwork?.id || ""
                }
            });
            this.sendNativeToken({
                receiverAddress: this.state.receiverAddress,
                sendTokenAmount: this.state.sendTokenAmount,
                gasPrice: this.state.gasPrice,
                decimals: this.state.token.quantity.decimals
            });
        }
    },
    async sendNativeToken (params) {
        (0, $6mRzS.RouterController).pushTransactionStack({
            view: "Account",
            goBack: false
        });
        const to = params.receiverAddress;
        const address = (0, $f7IXw.AccountController).state.address;
        const value = (0, $hlVrM.ConnectionController).parseUnits(params.sendTokenAmount.toString(), Number(params.decimals));
        const data = "0x";
        try {
            await (0, $hlVrM.ConnectionController).sendTransaction({
                to: to,
                address: address,
                data: data,
                value: value,
                gasPrice: params.gasPrice
            });
            (0, $br7WV.SnackController).showSuccess("Transaction started");
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "SEND_SUCCESS",
                properties: {
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    token: this.state.token?.symbol || "",
                    amount: params.sendTokenAmount,
                    network: (0, $jbD0z.NetworkController).state.caipNetwork?.id || ""
                }
            });
            this.resetSend();
        } catch (error) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "SEND_ERROR",
                properties: {
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    token: this.state.token?.symbol || "",
                    amount: params.sendTokenAmount,
                    network: (0, $jbD0z.NetworkController).state.caipNetwork?.id || ""
                }
            });
            (0, $br7WV.SnackController).showError("Something went wrong");
        }
    },
    async sendERC20Token (params) {
        (0, $6mRzS.RouterController).pushTransactionStack({
            view: "Account",
            goBack: false
        });
        const amount = (0, $hlVrM.ConnectionController).parseUnits(params.sendTokenAmount.toString(), Number(params.decimals));
        try {
            if ((0, $f7IXw.AccountController).state.address && params.sendTokenAmount && params.receiverAddress && params.tokenAddress) {
                await (0, $hlVrM.ConnectionController).writeContract({
                    fromAddress: (0, $f7IXw.AccountController).state.address,
                    tokenAddress: (0, $c4rfq.CoreHelperUtil).getPlainAddress(params.tokenAddress),
                    receiverAddress: params.receiverAddress,
                    tokenAmount: amount,
                    method: "transfer",
                    abi: (0, $bZ3oL.erc20ABI)
                });
                (0, $br7WV.SnackController).showSuccess("Transaction started");
                this.resetSend();
            }
        } catch (error) {
            (0, $br7WV.SnackController).showError("Something went wrong");
        }
    },
    resetSend () {
        $29f2b0cac0b3feb7$var$state.token = undefined;
        $29f2b0cac0b3feb7$var$state.sendTokenAmount = undefined;
        $29f2b0cac0b3feb7$var$state.receiverAddress = undefined;
        $29f2b0cac0b3feb7$var$state.receiverProfileImageUrl = undefined;
        $29f2b0cac0b3feb7$var$state.receiverProfileName = undefined;
        $29f2b0cac0b3feb7$var$state.loading = false;
    }
};

});

parcelRegister("vBowO", function(module, exports) {

$parcel$export(module.exports, "TooltipController", function () { return $05efe7283aac9af4$export$ad76ea7b944b0d8; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");
// -- State --------------------------------------------- //
const $05efe7283aac9af4$var$state = (0, $eAQzZ.proxy)({
    message: "",
    open: false,
    triggerRect: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    },
    variant: "shade"
});
const $05efe7283aac9af4$export$ad76ea7b944b0d8 = {
    state: $05efe7283aac9af4$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($05efe7283aac9af4$var$state, ()=>callback($05efe7283aac9af4$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($05efe7283aac9af4$var$state, key, callback);
    },
    showTooltip ({ message: message, triggerRect: triggerRect, variant: variant }) {
        $05efe7283aac9af4$var$state.open = true;
        $05efe7283aac9af4$var$state.message = message;
        $05efe7283aac9af4$var$state.triggerRect = triggerRect;
        $05efe7283aac9af4$var$state.variant = variant;
    },
    hide () {
        $05efe7283aac9af4$var$state.open = false;
        $05efe7283aac9af4$var$state.message = "";
        $05efe7283aac9af4$var$state.triggerRect = {
            width: 0,
            height: 0,
            top: 0,
            left: 0
        };
    }
};

});

parcelRegister("4DSpJ", function(module, exports) {

$parcel$export(module.exports, "EnsController", function () { return $36150374a703279d$export$d0d981286ee4cb7; });

var $dNrTM = parcelRequire("dNrTM");

var $eAQzZ = parcelRequire("eAQzZ");

var $hxXs8 = parcelRequire("hxXs8");

var $f7IXw = parcelRequire("f7IXw");

var $7Xn6F = parcelRequire("7Xn6F");

var $6mRzS = parcelRequire("6mRzS");

var $hlVrM = parcelRequire("hlVrM");

var $jbD0z = parcelRequire("jbD0z");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
var $1yWTt = parcelRequire("1yWTt");

var $jjj4b = parcelRequire("jjj4b");

var $d94Xg = parcelRequire("d94Xg");
// -- State --------------------------------------------- //
const $36150374a703279d$var$state = (0, $eAQzZ.proxy)({
    suggestions: [],
    loading: false
});
const $36150374a703279d$export$d0d981286ee4cb7 = {
    state: $36150374a703279d$var$state,
    subscribe (callback) {
        return (0, $eAQzZ.subscribe)($36150374a703279d$var$state, ()=>callback($36150374a703279d$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $dNrTM.subscribeKey)($36150374a703279d$var$state, key, callback);
    },
    async resolveName (name) {
        try {
            return await (0, $hxXs8.BlockchainApiController).lookupEnsName(name);
        } catch (e) {
            const error = e;
            throw new Error(error?.reasons?.[0]?.description || "Error resolving name");
        }
    },
    async isNameRegistered (name) {
        try {
            await (0, $hxXs8.BlockchainApiController).lookupEnsName(name);
            return true;
        } catch  {
            return false;
        }
    },
    async getSuggestions (name) {
        try {
            $36150374a703279d$var$state.loading = true;
            $36150374a703279d$var$state.suggestions = [];
            const response = await (0, $hxXs8.BlockchainApiController).getEnsNameSuggestions(name);
            $36150374a703279d$var$state.suggestions = response.suggestions.map((suggestion)=>({
                    ...suggestion,
                    name: suggestion.name.replace((0, $1VCt9.ConstantsUtil).WC_NAME_SUFFIX, "")
                })) || [];
            return $36150374a703279d$var$state.suggestions;
        } catch (e) {
            const errorMessage = this.parseEnsApiError(e, "Error fetching name suggestions");
            throw new Error(errorMessage);
        } finally{
            $36150374a703279d$var$state.loading = false;
        }
    },
    async getNamesForAddress (address) {
        try {
            const network = (0, $jbD0z.NetworkController).state.caipNetwork;
            if (!network) return [];
            const response = await (0, $hxXs8.BlockchainApiController).reverseLookupEnsName({
                address: address
            });
            return response;
        } catch (e) {
            const errorMessage = this.parseEnsApiError(e, "Error fetching names for address");
            throw new Error(errorMessage);
        }
    },
    async registerName (name) {
        const network = (0, $jbD0z.NetworkController).state.caipNetwork;
        if (!network) throw new Error("Network not found");
        const address = (0, $f7IXw.AccountController).state.address;
        const emailConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (!address || !emailConnector) throw new Error("Address or auth connector not found");
        $36150374a703279d$var$state.loading = true;
        try {
            const message = JSON.stringify({
                name: `${name}${(0, $1VCt9.ConstantsUtil).WC_NAME_SUFFIX}`,
                attributes: {},
                timestamp: Math.floor(Date.now() / 1000)
            });
            (0, $6mRzS.RouterController).pushTransactionStack({
                view: "RegisterAccountNameSuccess",
                goBack: false,
                replace: true,
                onCancel () {
                    $36150374a703279d$var$state.loading = false;
                }
            });
            const signature = await (0, $hlVrM.ConnectionController).signMessage(message);
            const networkId = (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(network.id);
            if (!networkId) throw new Error("Network not found");
            const coinType = (0, $jjj4b.EnsUtil).convertEVMChainIdToCoinType(networkId);
            await (0, $hxXs8.BlockchainApiController).registerEnsName({
                coinType: coinType,
                address: address,
                signature: signature,
                message: message
            });
            (0, $f7IXw.AccountController).setProfileName(`${name}${(0, $1VCt9.ConstantsUtil).WC_NAME_SUFFIX}`, (0, $d94Xg.ChainController).state.activeChain);
            (0, $6mRzS.RouterController).replace("RegisterAccountNameSuccess");
        } catch (e) {
            const errorMessage = this.parseEnsApiError(e, `Error registering name ${name}`);
            (0, $6mRzS.RouterController).replace("RegisterAccountName");
            throw new Error(errorMessage);
        } finally{
            $36150374a703279d$var$state.loading = false;
        }
    },
    validateName (name) {
        return /^[a-zA-Z0-9-]{4,}$/u.test(name);
    },
    parseEnsApiError (error, defaultError) {
        const ensError = error;
        return ensError?.reasons?.[0]?.description || defaultError;
    }
};

});
parcelRegister("jjj4b", function(module, exports) {

$parcel$export(module.exports, "EnsUtil", function () { return $e0ee94e1641cd295$export$88d8d1feba0d56ec; });
const $e0ee94e1641cd295$var$SLIP44_MSB = 0x80000000;
const $e0ee94e1641cd295$export$88d8d1feba0d56ec = {
    convertEVMChainIdToCoinType (chainId) {
        if (chainId >= $e0ee94e1641cd295$var$SLIP44_MSB) throw new Error("Invalid chainId");
        return ($e0ee94e1641cd295$var$SLIP44_MSB | chainId) >>> 0;
    }
};

});


parcelRegister("eOULk", function(module, exports) {

$parcel$export(module.exports, "AssetUtil", function () { return $aca1c4091306211f$export$2a2d471f51b1e9cb; });

var $g4s8N = parcelRequire("g4s8N");

var $zKxbI = parcelRequire("zKxbI");
const $aca1c4091306211f$var$namespaceImageIds = {
    // Ethereum
    evm: "ba0ba0cd-17c6-4806-ad93-f9d174f17900",
    // Solana
    solana: "a1b58899-f671-4276-6a5e-56ca5bd59700"
};
const $aca1c4091306211f$export$2a2d471f51b1e9cb = {
    async fetchWalletImage (imageId) {
        if (!imageId) return undefined;
        await (0, $g4s8N.ApiController)._fetchWalletImage(imageId);
        return this.getWalletImageById(imageId);
    },
    getWalletImageById (imageId) {
        if (!imageId) return undefined;
        return (0, $zKxbI.AssetController).state.walletImages[imageId];
    },
    getWalletImage (wallet) {
        if (wallet?.image_url) return wallet?.image_url;
        if (wallet?.image_id) return (0, $zKxbI.AssetController).state.walletImages[wallet.image_id];
        return undefined;
    },
    getNetworkImage (network) {
        if (network?.imageUrl) return network?.imageUrl;
        if (network?.imageId) return (0, $zKxbI.AssetController).state.networkImages[network.imageId];
        return undefined;
    },
    getNetworkImageById (imageId) {
        if (!imageId) return undefined;
        return (0, $zKxbI.AssetController).state.networkImages[imageId];
    },
    getConnectorImage (connector) {
        if (connector?.imageUrl) return connector.imageUrl;
        if (connector?.imageId) return (0, $zKxbI.AssetController).state.connectorImages[connector.imageId];
        return undefined;
    },
    getChainImage (chain) {
        return (0, $zKxbI.AssetController).state.networkImages[$aca1c4091306211f$var$namespaceImageIds[chain]];
    }
};

});

parcelRegister("bmR1U", function(module, exports) {

$parcel$export(module.exports, "RouterUtil", function () { return $846ae25f83585637$export$12c6341a287a74e0; });

var $6mRzS = parcelRequire("6mRzS");

var $ib7WC = parcelRequire("ib7WC");

var $8BVTM = parcelRequire("8BVTM");

var $d94Xg = parcelRequire("d94Xg");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
const $846ae25f83585637$export$12c6341a287a74e0 = {
    goBackOrCloseModal () {
        if ((0, $6mRzS.RouterController).state.history.length > 1) (0, $6mRzS.RouterController).goBack();
        else (0, $ib7WC.ModalController).close();
    },
    navigateAfterNetworkSwitch () {
        const { history: history } = (0, $6mRzS.RouterController).state;
        const networkSelectIndex = history.findIndex((name)=>name === "Networks");
        if (networkSelectIndex >= 1) (0, $6mRzS.RouterController).goBackToIndex(networkSelectIndex - 1);
        else (0, $ib7WC.ModalController).close();
    },
    navigateAfterPreferredAccountTypeSelect () {
        const { isSiweEnabled: isSiweEnabled } = (0, $8BVTM.OptionsController).state;
        if (isSiweEnabled && (0, $d94Xg.ChainController).state.activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.EVM) (0, $6mRzS.RouterController).push("ConnectingSiwe");
        else (0, $6mRzS.RouterController).push("Account");
    }
};

});


parcelRegister("kbczO", function(module, exports) {

$parcel$export(module.exports, "MathUtil", function () { return (parcelRequire("iazuc")).MathUtil; });
$parcel$export(module.exports, "initializeTheming", function () { return (parcelRequire("jVNMm")).initializeTheming; });
$parcel$export(module.exports, "setColorTheme", function () { return (parcelRequire("jVNMm")).setColorTheme; });
$parcel$export(module.exports, "setThemeVariables", function () { return (parcelRequire("jVNMm")).setThemeVariables; });
$parcel$export(module.exports, "UiHelperUtil", function () { return (parcelRequire("fIDM4")).UiHelperUtil; });
$parcel$export(module.exports, "TransactionUtil", function () { return (parcelRequire("6emWt")).TransactionUtil; });
$parcel$export(module.exports, "customElement", function () { return (parcelRequire("ailZp")).customElement; });

var $gVsRW = parcelRequire("gVsRW");

var $990tu = parcelRequire("990tu");

var $9usS1 = parcelRequire("9usS1");

var $i6mxN = parcelRequire("i6mxN");

var $4BuLe = parcelRequire("4BuLe");

var $e4TV0 = parcelRequire("e4TV0");

var $ck0jF = parcelRequire("ck0jF");

var $j3R5o = parcelRequire("j3R5o");

var $kTgQh = parcelRequire("kTgQh");

var $fCaEm = parcelRequire("fCaEm");

var $991Dm = parcelRequire("991Dm");

var $kVtRm = parcelRequire("kVtRm");

var $kVhUK = parcelRequire("kVhUK");

var $lQgB0 = parcelRequire("lQgB0");

var $hCQbE = parcelRequire("hCQbE");

var $7wNyf = parcelRequire("7wNyf");

var $kjq5y = parcelRequire("kjq5y");

var $2fpsv = parcelRequire("2fpsv");

var $evdH0 = parcelRequire("evdH0");

var $4cL7c = parcelRequire("4cL7c");

var $jpXmH = parcelRequire("jpXmH");

var $38586 = parcelRequire("38586");

var $d856F = parcelRequire("d856F");

var $jlY49 = parcelRequire("jlY49");

var $jcpWm = parcelRequire("jcpWm");

var $7XtWS = parcelRequire("7XtWS");

var $bk8xy = parcelRequire("bk8xy");

var $dnpyM = parcelRequire("dnpyM");

var $jPHPA = parcelRequire("jPHPA");

var $eZmW3 = parcelRequire("eZmW3");

var $7HPis = parcelRequire("7HPis");

var $fPEeo = parcelRequire("fPEeo");

var $lqPpk = parcelRequire("lqPpk");

var $gcmDm = parcelRequire("gcmDm");

var $bneDN = parcelRequire("bneDN");

var $j34cm = parcelRequire("j34cm");

var $aPnTQ = parcelRequire("aPnTQ");

var $ge9kn = parcelRequire("ge9kn");

var $li0PP = parcelRequire("li0PP");

var $kyDrS = parcelRequire("kyDrS");

var $9ZfqC = parcelRequire("9ZfqC");

var $hKdWD = parcelRequire("hKdWD");

var $axRuD = parcelRequire("axRuD");

var $fgtdS = parcelRequire("fgtdS");

var $8OYIX = parcelRequire("8OYIX");

var $DCXdn = parcelRequire("DCXdn");

var $b5O5N = parcelRequire("b5O5N");

var $1Vq2R = parcelRequire("1Vq2R");

var $9p6m6 = parcelRequire("9p6m6");

var $gPs1o = parcelRequire("gPs1o");

var $cLomv = parcelRequire("cLomv");

var $aC3RC = parcelRequire("aC3RC");

var $115m8 = parcelRequire("115m8");

var $8u5Li = parcelRequire("8u5Li");

var $dG5yn = parcelRequire("dG5yn");

var $fpPbv = parcelRequire("fpPbv");

var $4PHOX = parcelRequire("4PHOX");

var $8l3pd = parcelRequire("8l3pd");

var $2eJdn = parcelRequire("2eJdn");

var $df0St = parcelRequire("df0St");

var $qYJ7H = parcelRequire("qYJ7H");

var $1LEz9 = parcelRequire("1LEz9");

var $aOVDi = parcelRequire("aOVDi");

var $jyaVx = parcelRequire("jyaVx");

var $44SOE = parcelRequire("44SOE");

var $h4Y7z = parcelRequire("h4Y7z");

var $3kLy3 = parcelRequire("3kLy3");

var $7XlYf = parcelRequire("7XlYf");

var $2VNEH = parcelRequire("2VNEH");

var $l74IZ = parcelRequire("l74IZ");

var $k2qNo = parcelRequire("k2qNo");

var $aWuyp = parcelRequire("aWuyp");

var $kLh9C = parcelRequire("kLh9C");

var $jrTpg = parcelRequire("jrTpg");

var $2cj9p = parcelRequire("2cj9p");

var $lgpo8 = parcelRequire("lgpo8");

var $iazuc = parcelRequire("iazuc");

var $jVNMm = parcelRequire("jVNMm");

var $fIDM4 = parcelRequire("fIDM4");

var $6emWt = parcelRequire("6emWt");

var $ailZp = parcelRequire("ailZp");
$parcel$exportWildcard(module.exports, $gVsRW);
$parcel$exportWildcard(module.exports, $990tu);
$parcel$exportWildcard(module.exports, $9usS1);
$parcel$exportWildcard(module.exports, $i6mxN);
$parcel$exportWildcard(module.exports, $4BuLe);
$parcel$exportWildcard(module.exports, $e4TV0);
$parcel$exportWildcard(module.exports, $ck0jF);
$parcel$exportWildcard(module.exports, $j3R5o);
$parcel$exportWildcard(module.exports, $kTgQh);
$parcel$exportWildcard(module.exports, $fCaEm);
$parcel$exportWildcard(module.exports, $991Dm);
$parcel$exportWildcard(module.exports, $kVtRm);
$parcel$exportWildcard(module.exports, $kVhUK);
$parcel$exportWildcard(module.exports, $lQgB0);
$parcel$exportWildcard(module.exports, $hCQbE);
$parcel$exportWildcard(module.exports, $7wNyf);
$parcel$exportWildcard(module.exports, $kjq5y);
$parcel$exportWildcard(module.exports, $2fpsv);
$parcel$exportWildcard(module.exports, $evdH0);
$parcel$exportWildcard(module.exports, $4cL7c);
$parcel$exportWildcard(module.exports, $jpXmH);
$parcel$exportWildcard(module.exports, $38586);
$parcel$exportWildcard(module.exports, $d856F);
$parcel$exportWildcard(module.exports, $jlY49);
$parcel$exportWildcard(module.exports, $jcpWm);
$parcel$exportWildcard(module.exports, $7XtWS);
$parcel$exportWildcard(module.exports, $bk8xy);
$parcel$exportWildcard(module.exports, $dnpyM);
$parcel$exportWildcard(module.exports, $jPHPA);
$parcel$exportWildcard(module.exports, $eZmW3);
$parcel$exportWildcard(module.exports, $7HPis);
$parcel$exportWildcard(module.exports, $fPEeo);
$parcel$exportWildcard(module.exports, $lqPpk);
$parcel$exportWildcard(module.exports, $gcmDm);
$parcel$exportWildcard(module.exports, $bneDN);
$parcel$exportWildcard(module.exports, $j34cm);
$parcel$exportWildcard(module.exports, $aPnTQ);
$parcel$exportWildcard(module.exports, $ge9kn);
$parcel$exportWildcard(module.exports, $li0PP);
$parcel$exportWildcard(module.exports, $kyDrS);
$parcel$exportWildcard(module.exports, $9ZfqC);
$parcel$exportWildcard(module.exports, $hKdWD);
$parcel$exportWildcard(module.exports, $axRuD);
$parcel$exportWildcard(module.exports, $fgtdS);
$parcel$exportWildcard(module.exports, $8OYIX);
$parcel$exportWildcard(module.exports, $DCXdn);
$parcel$exportWildcard(module.exports, $b5O5N);
$parcel$exportWildcard(module.exports, $1Vq2R);
$parcel$exportWildcard(module.exports, $9p6m6);
$parcel$exportWildcard(module.exports, $gPs1o);
$parcel$exportWildcard(module.exports, $cLomv);
$parcel$exportWildcard(module.exports, $aC3RC);
$parcel$exportWildcard(module.exports, $115m8);
$parcel$exportWildcard(module.exports, $8u5Li);
$parcel$exportWildcard(module.exports, $dG5yn);
$parcel$exportWildcard(module.exports, $fpPbv);
$parcel$exportWildcard(module.exports, $4PHOX);
$parcel$exportWildcard(module.exports, $8l3pd);
$parcel$exportWildcard(module.exports, $2eJdn);
$parcel$exportWildcard(module.exports, $df0St);
$parcel$exportWildcard(module.exports, $qYJ7H);
$parcel$exportWildcard(module.exports, $1LEz9);
$parcel$exportWildcard(module.exports, $aOVDi);
$parcel$exportWildcard(module.exports, $jyaVx);
$parcel$exportWildcard(module.exports, $44SOE);
$parcel$exportWildcard(module.exports, $h4Y7z);
$parcel$exportWildcard(module.exports, $3kLy3);
$parcel$exportWildcard(module.exports, $7XlYf);
$parcel$exportWildcard(module.exports, $2VNEH);
$parcel$exportWildcard(module.exports, $l74IZ);
$parcel$exportWildcard(module.exports, $k2qNo);
$parcel$exportWildcard(module.exports, $aWuyp);
$parcel$exportWildcard(module.exports, $kLh9C);
$parcel$exportWildcard(module.exports, $jrTpg);
$parcel$exportWildcard(module.exports, $2cj9p);
$parcel$exportWildcard(module.exports, $lgpo8);

});
parcelRegister("gVsRW", function(module, exports) {

$parcel$export(module.exports, "swapInputMaskBottomSvg", function () { return $c5285d064d363019$export$a65dfac536924807; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $c5285d064d363019$export$a65dfac536924807 = (0, $7pRM7.svg)`<svg class="input_mask" width="328" height="100" viewBox="0 0 328 100" fill="none">
  <mask id="path-1-inside-1_18299_4189">
    <path
      class="input_mask__border"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M138.008 0H40C21.1438 0 11.7157 0 5.85786 5.85786C0 11.7157 0 21.1438 0 40V60C0 78.8562 0 88.2843 5.85786 94.1421C11.7157 100 21.1438 100 40 100H288C306.856 100 316.284 100 322.142 94.1421C328 88.2843 328 78.8562 328 60V40C328 21.1438 328 11.7157 322.142 5.85786C316.284 0 306.856 0 288 0H189.992C189.958 4.89122 189.786 7.76279 188.914 10.1564C187.095 15.1562 183.156 19.0947 178.156 20.9145C175.174 22 171.449 22 164 22C156.551 22 152.826 22 149.844 20.9145C144.844 19.0947 140.905 15.1562 139.086 10.1564C138.214 7.76279 138.042 4.89122 138.008 0Z"
    />
  </mask>
  <path
    class="input_mask__background"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M138.008 0H40C21.1438 0 11.7157 0 5.85786 5.85786C0 11.7157 0 21.1438 0 40V60C0 78.8562 0 88.2843 5.85786 94.1421C11.7157 100 21.1438 100 40 100H288C306.856 100 316.284 100 322.142 94.1421C328 88.2843 328 78.8562 328 60V40C328 21.1438 328 11.7157 322.142 5.85786C316.284 0 306.856 0 288 0H189.992C189.958 4.89122 189.786 7.76279 188.914 10.1564C187.095 15.1562 183.156 19.0947 178.156 20.9145C175.174 22 171.449 22 164 22C156.551 22 152.826 22 149.844 20.9145C144.844 19.0947 140.905 15.1562 139.086 10.1564C138.214 7.76279 138.042 4.89122 138.008 0Z"
  />
  <path
    class="input_mask__border"
    d="M138.008 0L139.008 -0.00694413L139.001 -1H138.008V0ZM322.142 94.1421L322.849 94.8492H322.849L322.142 94.1421ZM322.142 5.85786L322.849 5.15076L322.849 5.15076L322.142 5.85786ZM189.992 0V-1H188.999L188.992 -0.00694413L189.992 0ZM188.914 10.1564L189.854 10.4984V10.4984L188.914 10.1564ZM178.156 20.9145L177.814 19.9748V19.9748L178.156 20.9145ZM149.844 20.9145L150.186 19.9748V19.9748L149.844 20.9145ZM139.086 10.1564L138.146 10.4984V10.4984L139.086 10.1564ZM40 1H138.008V-1H40V1ZM6.56497 6.56497C9.27713 3.85281 12.8524 2.44064 18.1878 1.72332C23.552 1.00212 30.5436 1 40 1V-1C30.6002 -1 23.4497 -1.00212 17.9213 -0.25885C12.3641 0.488292 8.29646 2.00506 5.15076 5.15076L6.56497 6.56497ZM1 40C1 30.5436 1.00212 23.552 1.72332 18.1878C2.44064 12.8524 3.85281 9.27713 6.56497 6.56497L5.15076 5.15076C2.00506 8.29646 0.488292 12.3641 -0.25885 17.9213C-1.00212 23.4497 -1 30.6002 -1 40H1ZM1 60V40H-1V60H1ZM6.56497 93.435C3.85281 90.7229 2.44064 87.1476 1.72332 81.8122C1.00212 76.448 1 69.4564 1 60H-1C-1 69.3998 -1.00212 76.5503 -0.25885 82.0787C0.488292 87.6358 2.00506 91.7035 5.15076 94.8492L6.56497 93.435ZM40 99C30.5436 99 23.552 98.9979 18.1878 98.2767C12.8524 97.5594 9.27713 96.1472 6.56497 93.435L5.15076 94.8492C8.29646 97.9949 12.3641 99.5117 17.9213 100.259C23.4497 101.002 30.6002 101 40 101V99ZM288 99H40V101H288V99ZM321.435 93.435C318.723 96.1472 315.148 97.5594 309.812 98.2767C304.448 98.9979 297.456 99 288 99V101C297.4 101 304.55 101.002 310.079 100.259C315.636 99.5117 319.704 97.9949 322.849 94.8492L321.435 93.435ZM327 60C327 69.4564 326.998 76.448 326.277 81.8122C325.559 87.1476 324.147 90.7229 321.435 93.435L322.849 94.8492C325.995 91.7035 327.512 87.6358 328.259 82.0787C329.002 76.5503 329 69.3998 329 60H327ZM327 40V60H329V40H327ZM321.435 6.56497C324.147 9.27713 325.559 12.8524 326.277 18.1878C326.998 23.552 327 30.5436 327 40H329C329 30.6002 329.002 23.4497 328.259 17.9213C327.512 12.3642 325.995 8.29646 322.849 5.15076L321.435 6.56497ZM288 1C297.456 1 304.448 1.00212 309.812 1.72332C315.148 2.44064 318.723 3.85281 321.435 6.56497L322.849 5.15076C319.704 2.00506 315.636 0.488292 310.079 -0.25885C304.55 -1.00212 297.4 -1 288 -1V1ZM189.992 1H288V-1H189.992V1ZM188.992 -0.00694413C188.958 4.90792 188.778 7.60788 187.975 9.81434L189.854 10.4984C190.793 7.9177 190.958 4.87452 190.992 0.00694413L188.992 -0.00694413ZM187.975 9.81434C186.256 14.5364 182.536 18.2561 177.814 19.9748L178.498 21.8542C183.776 19.9333 187.933 15.7759 189.854 10.4984L187.975 9.81434ZM177.814 19.9748C175.039 20.9848 171.536 21 164 21V23C171.362 23 175.308 23.0152 178.498 21.8542L177.814 19.9748ZM164 21C156.464 21 152.961 20.9848 150.186 19.9748L149.502 21.8542C152.692 23.0152 156.638 23 164 23V21ZM150.186 19.9748C145.464 18.2561 141.744 14.5364 140.025 9.81434L138.146 10.4984C140.067 15.7759 144.224 19.9333 149.502 21.8542L150.186 19.9748ZM140.025 9.81434C139.222 7.60788 139.042 4.90792 139.008 -0.00694413L137.008 0.00694413C137.042 4.87452 137.207 7.9177 138.146 10.4984L140.025 9.81434Z"
    mask="url(#path-1-inside-1_18299_4189)"
  />
</svg>`;

});
parcelRegister("4LT4u", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("a71q3")).css; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("7pRM7")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("cLW71")).LitElement; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("7pRM7")).svg; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("a71q3")).unsafeCSS; });
parcelRequire("inrjJ");
parcelRequire("7pRM7");
parcelRequire("cLW71");
parcelRequire("gWxGM");

});
parcelRegister("inrjJ", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", function () { return $d60f90987a7de103$export$7312b35fbf521afb; });
$parcel$export(module.exports, "notEqual", function () { return $d60f90987a7de103$export$53a6892c50694894; });
$parcel$export(module.exports, "ReactiveElement", function () { return $d60f90987a7de103$export$c7c07a37856565d; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("a71q3")).css; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("a71q3")).unsafeCSS; });

var $a71q3 = parcelRequire("a71q3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $d60f90987a7de103$var$i, defineProperty: $d60f90987a7de103$var$e, getOwnPropertyDescriptor: $d60f90987a7de103$var$r, getOwnPropertyNames: $d60f90987a7de103$var$h, getOwnPropertySymbols: $d60f90987a7de103$var$o, getPrototypeOf: $d60f90987a7de103$var$n } = Object, $d60f90987a7de103$var$a = globalThis, $d60f90987a7de103$var$c = $d60f90987a7de103$var$a.trustedTypes, $d60f90987a7de103$var$l = $d60f90987a7de103$var$c ? $d60f90987a7de103$var$c.emptyScript : "", $d60f90987a7de103$var$p = $d60f90987a7de103$var$a.reactiveElementPolyfillSupport, $d60f90987a7de103$var$d = (t, s)=>t, $d60f90987a7de103$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $d60f90987a7de103$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $d60f90987a7de103$export$53a6892c50694894 = (t, s)=>!$d60f90987a7de103$var$i(t, s), $d60f90987a7de103$var$y = {
    attribute: !0,
    type: String,
    converter: $d60f90987a7de103$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $d60f90987a7de103$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $d60f90987a7de103$var$a.litPropertyMetadata ??= new WeakMap;
class $d60f90987a7de103$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $d60f90987a7de103$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $d60f90987a7de103$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $d60f90987a7de103$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $d60f90987a7de103$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($d60f90987a7de103$var$d("elementProperties"))) return;
        const t = $d60f90987a7de103$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($d60f90987a7de103$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($d60f90987a7de103$var$d("properties"))) {
            const t = this.properties, s = [
                ...$d60f90987a7de103$var$h(t),
                ...$d60f90987a7de103$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $a71q3.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $a71q3.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $a71q3.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $d60f90987a7de103$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $d60f90987a7de103$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $d60f90987a7de103$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$d60f90987a7de103$export$c7c07a37856565d.elementStyles = [], $d60f90987a7de103$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $d60f90987a7de103$export$c7c07a37856565d[$d60f90987a7de103$var$d("elementProperties")] = new Map, $d60f90987a7de103$export$c7c07a37856565d[$d60f90987a7de103$var$d("finalized")] = new Map, $d60f90987a7de103$var$p?.({
    ReactiveElement: $d60f90987a7de103$export$c7c07a37856565d
}), ($d60f90987a7de103$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("a71q3", function(module, exports) {

$parcel$export(module.exports, "unsafeCSS", function () { return $75cba8a2217dedb7$export$8d80f9cac07cdb3; });
$parcel$export(module.exports, "css", function () { return $75cba8a2217dedb7$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $75cba8a2217dedb7$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $75cba8a2217dedb7$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $75cba8a2217dedb7$var$t = globalThis, $75cba8a2217dedb7$export$b4d10f6001c083c2 = $75cba8a2217dedb7$var$t.ShadowRoot && (void 0 === $75cba8a2217dedb7$var$t.ShadyCSS || $75cba8a2217dedb7$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $75cba8a2217dedb7$var$s = Symbol(), $75cba8a2217dedb7$var$o = new WeakMap;
class $75cba8a2217dedb7$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $75cba8a2217dedb7$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($75cba8a2217dedb7$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $75cba8a2217dedb7$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $75cba8a2217dedb7$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $75cba8a2217dedb7$export$8d80f9cac07cdb3 = (t)=>new $75cba8a2217dedb7$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $75cba8a2217dedb7$var$s), $75cba8a2217dedb7$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $75cba8a2217dedb7$export$505d1e8739bad805(o, t, $75cba8a2217dedb7$var$s);
}, $75cba8a2217dedb7$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($75cba8a2217dedb7$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $75cba8a2217dedb7$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $75cba8a2217dedb7$export$ee69dfd951e24778 = $75cba8a2217dedb7$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $75cba8a2217dedb7$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("7pRM7", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $566494d6ceefa558$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "svg", function () { return $566494d6ceefa558$export$7ed1367e7fa1ad68; });
$parcel$export(module.exports, "noChange", function () { return $566494d6ceefa558$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $566494d6ceefa558$export$45b790e32b2810ee; });
$parcel$export(module.exports, "_$LH", function () { return $566494d6ceefa558$export$8613d1ca9052b22e; });
$parcel$export(module.exports, "render", function () { return $566494d6ceefa558$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $566494d6ceefa558$var$n = globalThis, $566494d6ceefa558$var$c = $566494d6ceefa558$var$n.trustedTypes, $566494d6ceefa558$var$h = $566494d6ceefa558$var$c ? $566494d6ceefa558$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $566494d6ceefa558$var$f = "$lit$", $566494d6ceefa558$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $566494d6ceefa558$var$m = "?" + $566494d6ceefa558$var$v, $566494d6ceefa558$var$_ = `<${$566494d6ceefa558$var$m}>`, $566494d6ceefa558$var$w = document, $566494d6ceefa558$var$lt = ()=>$566494d6ceefa558$var$w.createComment(""), $566494d6ceefa558$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $566494d6ceefa558$var$g = Array.isArray, $566494d6ceefa558$var$$ = (t)=>$566494d6ceefa558$var$g(t) || "function" == typeof t?.[Symbol.iterator], $566494d6ceefa558$var$x = "[ 	\n\f\r]", $566494d6ceefa558$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $566494d6ceefa558$var$E = /-->/g, $566494d6ceefa558$var$k = />/g, $566494d6ceefa558$var$O = RegExp(`>|${$566494d6ceefa558$var$x}(?:([^\\s"'>=/]+)(${$566494d6ceefa558$var$x}*=${$566494d6ceefa558$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $566494d6ceefa558$var$S = /'/g, $566494d6ceefa558$var$j = /"/g, $566494d6ceefa558$var$M = /^(?:script|style|textarea|title)$/i, $566494d6ceefa558$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $566494d6ceefa558$export$c0bb0b647f701bb5 = $566494d6ceefa558$var$P(1), $566494d6ceefa558$export$7ed1367e7fa1ad68 = $566494d6ceefa558$var$P(2), $566494d6ceefa558$export$47d5b44d225be5b4 = $566494d6ceefa558$var$P(3), $566494d6ceefa558$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $566494d6ceefa558$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $566494d6ceefa558$var$V = new WeakMap, $566494d6ceefa558$var$I = $566494d6ceefa558$var$w.createTreeWalker($566494d6ceefa558$var$w, 129);
function $566494d6ceefa558$var$N(t, i) {
    if (!$566494d6ceefa558$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $566494d6ceefa558$var$h ? $566494d6ceefa558$var$h.createHTML(i) : i;
}
const $566494d6ceefa558$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $566494d6ceefa558$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $566494d6ceefa558$var$T ? "!--" === l[1] ? n = $566494d6ceefa558$var$E : void 0 !== l[1] ? n = $566494d6ceefa558$var$k : void 0 !== l[2] ? ($566494d6ceefa558$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $566494d6ceefa558$var$O) : void 0 !== l[3] && (n = $566494d6ceefa558$var$O) : n === $566494d6ceefa558$var$O ? ">" === l[0] ? (n = h ?? $566494d6ceefa558$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $566494d6ceefa558$var$O : '"' === l[3] ? $566494d6ceefa558$var$j : $566494d6ceefa558$var$S) : n === $566494d6ceefa558$var$j || n === $566494d6ceefa558$var$S ? n = $566494d6ceefa558$var$O : n === $566494d6ceefa558$var$E || n === $566494d6ceefa558$var$k ? n = $566494d6ceefa558$var$T : (n = $566494d6ceefa558$var$O, h = void 0);
        const u = n === $566494d6ceefa558$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $566494d6ceefa558$var$T ? s + $566494d6ceefa558$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $566494d6ceefa558$var$f + s.slice(c) + $566494d6ceefa558$var$v + u) : s + $566494d6ceefa558$var$v + (-2 === c ? i : u);
    }
    return [
        $566494d6ceefa558$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $566494d6ceefa558$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $566494d6ceefa558$var$U(t, i);
        if (this.el = $566494d6ceefa558$var$B.createElement(l, s), $566494d6ceefa558$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $566494d6ceefa558$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($566494d6ceefa558$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($566494d6ceefa558$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $566494d6ceefa558$var$Y : "?" === n[1] ? $566494d6ceefa558$var$Z : "@" === n[1] ? $566494d6ceefa558$var$q : $566494d6ceefa558$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($566494d6ceefa558$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($566494d6ceefa558$var$M.test(e.tagName)) {
                    const t = e.textContent.split($566494d6ceefa558$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $566494d6ceefa558$var$c ? $566494d6ceefa558$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $566494d6ceefa558$var$lt()), $566494d6ceefa558$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $566494d6ceefa558$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $566494d6ceefa558$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($566494d6ceefa558$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $566494d6ceefa558$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $566494d6ceefa558$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $566494d6ceefa558$var$z(t, i, s = t, e) {
    if (i === $566494d6ceefa558$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $566494d6ceefa558$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $566494d6ceefa558$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $566494d6ceefa558$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $566494d6ceefa558$var$w).importNode(i, !0);
        $566494d6ceefa558$var$I.currentNode = e;
        let h = $566494d6ceefa558$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $566494d6ceefa558$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $566494d6ceefa558$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $566494d6ceefa558$var$I.nextNode(), o++);
        }
        return $566494d6ceefa558$var$I.currentNode = $566494d6ceefa558$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $566494d6ceefa558$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $566494d6ceefa558$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $566494d6ceefa558$var$z(this, t, i), $566494d6ceefa558$var$st(t) ? t === $566494d6ceefa558$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $566494d6ceefa558$export$45b790e32b2810ee && this._$AR(), this._$AH = $566494d6ceefa558$export$45b790e32b2810ee) : t !== this._$AH && t !== $566494d6ceefa558$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $566494d6ceefa558$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $566494d6ceefa558$export$45b790e32b2810ee && $566494d6ceefa558$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($566494d6ceefa558$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $566494d6ceefa558$var$B.createElement($566494d6ceefa558$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $566494d6ceefa558$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $566494d6ceefa558$var$V.get(t.strings);
        return void 0 === i && $566494d6ceefa558$var$V.set(t.strings, i = new $566494d6ceefa558$var$B(t)), i;
    }
    k(t) {
        $566494d6ceefa558$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $566494d6ceefa558$var$et(this.O($566494d6ceefa558$var$lt()), this.O($566494d6ceefa558$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $566494d6ceefa558$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $566494d6ceefa558$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $566494d6ceefa558$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $566494d6ceefa558$var$z(this, t, i, 0), o = !$566494d6ceefa558$var$st(t) || t !== this._$AH && t !== $566494d6ceefa558$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $566494d6ceefa558$var$z(this, e[s + n], i, n), r === $566494d6ceefa558$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$566494d6ceefa558$var$st(r) || r !== this._$AH[n], r === $566494d6ceefa558$export$45b790e32b2810ee ? t = $566494d6ceefa558$export$45b790e32b2810ee : t !== $566494d6ceefa558$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $566494d6ceefa558$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $566494d6ceefa558$var$Y extends $566494d6ceefa558$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $566494d6ceefa558$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $566494d6ceefa558$var$Z extends $566494d6ceefa558$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $566494d6ceefa558$export$45b790e32b2810ee);
    }
}
class $566494d6ceefa558$var$q extends $566494d6ceefa558$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $566494d6ceefa558$var$z(this, t, i, 0) ?? $566494d6ceefa558$export$45b790e32b2810ee) === $566494d6ceefa558$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $566494d6ceefa558$export$45b790e32b2810ee && s !== $566494d6ceefa558$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $566494d6ceefa558$export$45b790e32b2810ee && (s === $566494d6ceefa558$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $566494d6ceefa558$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $566494d6ceefa558$var$z(this, t);
    }
}
const $566494d6ceefa558$export$8613d1ca9052b22e = {
    M: $566494d6ceefa558$var$f,
    P: $566494d6ceefa558$var$v,
    A: $566494d6ceefa558$var$m,
    C: 1,
    L: $566494d6ceefa558$var$U,
    R: $566494d6ceefa558$var$F,
    D: $566494d6ceefa558$var$$,
    V: $566494d6ceefa558$var$z,
    I: $566494d6ceefa558$var$et,
    H: $566494d6ceefa558$var$G,
    N: $566494d6ceefa558$var$Z,
    U: $566494d6ceefa558$var$q,
    B: $566494d6ceefa558$var$Y,
    F: $566494d6ceefa558$var$K
}, $566494d6ceefa558$var$Re = $566494d6ceefa558$var$n.litHtmlPolyfillSupport;
$566494d6ceefa558$var$Re?.($566494d6ceefa558$var$B, $566494d6ceefa558$var$et), ($566494d6ceefa558$var$n.litHtmlVersions ??= []).push("3.2.0");
const $566494d6ceefa558$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $566494d6ceefa558$var$et(i.insertBefore($566494d6ceefa558$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("cLW71", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("a71q3")).css; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("inrjJ")).ReactiveElement; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("a71q3")).unsafeCSS; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("7pRM7")).html; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("7pRM7")).noChange; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("7pRM7")).render; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("7pRM7")).svg; });

$parcel$export(module.exports, "LitElement", function () { return $94c6f3b95943c350$export$3f2f9f5909897157; });

var $inrjJ = parcelRequire("inrjJ");

var $7pRM7 = parcelRequire("7pRM7");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $94c6f3b95943c350$export$3f2f9f5909897157 extends (0, $inrjJ.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $7pRM7.render)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $7pRM7.noChange;
    }
}
$94c6f3b95943c350$export$3f2f9f5909897157._$litElement$ = !0, $94c6f3b95943c350$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $94c6f3b95943c350$export$3f2f9f5909897157
});
const $94c6f3b95943c350$var$f = globalThis.litElementPolyfillSupport;
$94c6f3b95943c350$var$f?.({
    LitElement: $94c6f3b95943c350$export$3f2f9f5909897157
});
const $94c6f3b95943c350$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");

});

parcelRegister("gWxGM", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c55c3210e304d9fd$export$6acf61af03e62db = !1;

});



parcelRegister("990tu", function(module, exports) {

$parcel$export(module.exports, "swapInputMaskTopSvg", function () { return $6a8552959d9ca23f$export$5ff8049c8368d155; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $6a8552959d9ca23f$export$5ff8049c8368d155 = (0, $7pRM7.svg)`<svg class="input_mask" width="328" height="100" viewBox="0 0 328 100" fill="none">
  <mask id="path-1-inside-1_18299_4168">
    <path
      class="input_mask__border"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.85786 5.85786C0 11.7157 0 21.1438 0 40V60C0 78.8562 0 88.2843 5.85786 94.1421C11.7157 100 21.1438 100 40 100H138.008C138.042 95.1088 138.214 92.2372 139.086 89.8436C140.905 84.8438 144.844 80.9053 149.844 79.0855C152.826 78 156.551 78 164 78C171.449 78 175.174 78 178.156 79.0855C183.156 80.9053 187.095 84.8438 188.914 89.8436C189.786 92.2372 189.958 95.1088 189.992 100H288C306.856 100 316.284 100 322.142 94.1421C328 88.2843 328 78.8562 328 60V40C328 21.1438 328 11.7157 322.142 5.85786C316.284 0 306.856 0 288 0H40C21.1438 0 11.7157 0 5.85786 5.85786Z"
    />
  </mask>
  <path
    class="input_mask__background"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.85786 5.85786C0 11.7157 0 21.1438 0 40V60C0 78.8562 0 88.2843 5.85786 94.1421C11.7157 100 21.1438 100 40 100H138.008C138.042 95.1088 138.214 92.2372 139.086 89.8436C140.905 84.8438 144.844 80.9053 149.844 79.0855C152.826 78 156.551 78 164 78C171.449 78 175.174 78 178.156 79.0855C183.156 80.9053 187.095 84.8438 188.914 89.8436C189.786 92.2372 189.958 95.1088 189.992 100H288C306.856 100 316.284 100 322.142 94.1421C328 88.2843 328 78.8562 328 60V40C328 21.1438 328 11.7157 322.142 5.85786C316.284 0 306.856 0 288 0H40C21.1438 0 11.7157 0 5.85786 5.85786Z"
  />
  <path
    class="input_mask__border"
    d="M138.008 100V101H139.001L139.008 100.007L138.008 100ZM139.086 89.8436L138.146 89.5016L139.086 89.8436ZM149.844 79.0855L150.186 80.0252L149.844 79.0855ZM178.156 79.0855L177.814 80.0252L178.156 79.0855ZM188.914 89.8436L189.854 89.5016L188.914 89.8436ZM189.992 100L188.992 100.007L188.999 101H189.992V100ZM322.142 94.1421L322.849 94.8492H322.849L322.142 94.1421ZM322.142 5.85786L322.849 5.15076L322.849 5.15076L322.142 5.85786ZM1 40C1 30.5436 1.00212 23.552 1.72332 18.1878C2.44064 12.8524 3.85281 9.27713 6.56497 6.56497L5.15076 5.15076C2.00506 8.29646 0.488292 12.3641 -0.25885 17.9213C-1.00212 23.4497 -1 30.6002 -1 40H1ZM1 60V40H-1V60H1ZM6.56497 93.435C3.85281 90.7229 2.44064 87.1476 1.72332 81.8122C1.00212 76.448 1 69.4564 1 60H-1C-1 69.3998 -1.00212 76.5503 -0.25885 82.0787C0.488292 87.6358 2.00506 91.7035 5.15076 94.8492L6.56497 93.435ZM40 99C30.5436 99 23.552 98.9979 18.1878 98.2767C12.8524 97.5594 9.27713 96.1472 6.56497 93.435L5.15076 94.8492C8.29646 97.9949 12.3641 99.5117 17.9213 100.259C23.4497 101.002 30.6002 101 40 101V99ZM138.008 99H40V101H138.008V99ZM139.008 100.007C139.042 95.0921 139.222 92.3921 140.025 90.1857L138.146 89.5016C137.207 92.0823 137.042 95.1255 137.008 99.9931L139.008 100.007ZM140.025 90.1857C141.744 85.4636 145.464 81.7439 150.186 80.0252L149.502 78.1458C144.224 80.0667 140.067 84.2241 138.146 89.5016L140.025 90.1857ZM150.186 80.0252C152.961 79.0152 156.464 79 164 79V77C156.638 77 152.692 76.9848 149.502 78.1458L150.186 80.0252ZM164 79C171.536 79 175.039 79.0152 177.814 80.0252L178.498 78.1458C175.308 76.9848 171.362 77 164 77V79ZM177.814 80.0252C182.536 81.7439 186.256 85.4636 187.975 90.1857L189.854 89.5016C187.933 84.2241 183.776 80.0667 178.498 78.1458L177.814 80.0252ZM187.975 90.1857C188.778 92.3921 188.958 95.0921 188.992 100.007L190.992 99.9931C190.958 95.1255 190.793 92.0823 189.854 89.5016L187.975 90.1857ZM288 99H189.992V101H288V99ZM321.435 93.435C318.723 96.1472 315.148 97.5594 309.812 98.2767C304.448 98.9979 297.456 99 288 99V101C297.4 101 304.55 101.002 310.079 100.259C315.636 99.5117 319.704 97.9949 322.849 94.8492L321.435 93.435ZM327 60C327 69.4564 326.998 76.448 326.277 81.8122C325.559 87.1476 324.147 90.7229 321.435 93.435L322.849 94.8492C325.995 91.7035 327.512 87.6358 328.259 82.0787C329.002 76.5503 329 69.3998 329 60H327ZM327 40V60H329V40H327ZM321.435 6.56497C324.147 9.27713 325.559 12.8524 326.277 18.1878C326.998 23.552 327 30.5436 327 40H329C329 30.6002 329.002 23.4497 328.259 17.9213C327.512 12.3642 325.995 8.29646 322.849 5.15076L321.435 6.56497ZM288 1C297.456 1 304.448 1.00212 309.812 1.72332C315.148 2.44064 318.723 3.85281 321.435 6.56497L322.849 5.15076C319.704 2.00506 315.636 0.488292 310.079 -0.25885C304.55 -1.00212 297.4 -1 288 -1V1ZM40 1H288V-1H40V1ZM6.56497 6.56497C9.27713 3.85281 12.8524 2.44064 18.1878 1.72332C23.552 1.00212 30.5436 1 40 1V-1C30.6002 -1 23.4497 -1.00212 17.9213 -0.25885C12.3641 0.488292 8.29646 2.00506 5.15076 5.15076L6.56497 6.56497Z"
    mask="url(#path-1-inside-1_18299_4168)"
  />
</svg>`;

});

parcelRegister("9usS1", function(module, exports) {

$parcel$export(module.exports, "WuiCard", function () { return $6e8d4f6fe510f81d$export$9de547c596d443f7; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $c4Avo = parcelRequire("c4Avo");
var $6e8d4f6fe510f81d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6e8d4f6fe510f81d$export$9de547c596d443f7 = class WuiCard extends (0, $cLW71.LitElement) {
    render() {
        return (0, $7pRM7.html)`<slot></slot>`;
    }
};
$6e8d4f6fe510f81d$export$9de547c596d443f7.styles = [
    (0, $jVNMm.resetStyles),
    (0, $c4Avo.default)
];
$6e8d4f6fe510f81d$export$9de547c596d443f7 = $6e8d4f6fe510f81d$var$__decorate([
    (0, $ailZp.customElement)("wui-card")
], $6e8d4f6fe510f81d$export$9de547c596d443f7);

});
parcelRegister("jVNMm", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", function () { return $e829f443cf620f82$export$8ee9916a43f985de; });
$parcel$export(module.exports, "setColorTheme", function () { return $e829f443cf620f82$export$718db041b82c5d23; });
$parcel$export(module.exports, "setThemeVariables", function () { return $e829f443cf620f82$export$b6ed091aa8078e9b; });
$parcel$export(module.exports, "resetStyles", function () { return $e829f443cf620f82$export$6b6f359a824920a4; });
$parcel$export(module.exports, "elementStyles", function () { return $e829f443cf620f82$export$e7ba49a1dbca65c7; });
$parcel$export(module.exports, "colorStyles", function () { return $e829f443cf620f82$export$ab44001f5690ee9c; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
parcelRequire("ikDNi");
var $5OPHH = parcelRequire("5OPHH");
let $e829f443cf620f82$var$themeTag = undefined;
let $e829f443cf620f82$var$darkModeTag = undefined;
let $e829f443cf620f82$var$lightModeTag = undefined;
function $e829f443cf620f82$export$8ee9916a43f985de(themeVariables, themeMode) {
    $e829f443cf620f82$var$themeTag = document.createElement("style");
    $e829f443cf620f82$var$darkModeTag = document.createElement("style");
    $e829f443cf620f82$var$lightModeTag = document.createElement("style");
    $e829f443cf620f82$var$themeTag.textContent = $e829f443cf620f82$var$createRootStyles(themeVariables).core.cssText;
    $e829f443cf620f82$var$darkModeTag.textContent = $e829f443cf620f82$var$createRootStyles(themeVariables).dark.cssText;
    $e829f443cf620f82$var$lightModeTag.textContent = $e829f443cf620f82$var$createRootStyles(themeVariables).light.cssText;
    document.head.appendChild($e829f443cf620f82$var$themeTag);
    document.head.appendChild($e829f443cf620f82$var$darkModeTag);
    document.head.appendChild($e829f443cf620f82$var$lightModeTag);
    $e829f443cf620f82$export$718db041b82c5d23(themeMode);
}
function $e829f443cf620f82$export$718db041b82c5d23(themeMode) {
    if ($e829f443cf620f82$var$darkModeTag && $e829f443cf620f82$var$lightModeTag) {
        if (themeMode === "light") {
            $e829f443cf620f82$var$darkModeTag.removeAttribute("media");
            $e829f443cf620f82$var$lightModeTag.media = "enabled";
        } else {
            $e829f443cf620f82$var$lightModeTag.removeAttribute("media");
            $e829f443cf620f82$var$darkModeTag.media = "enabled";
        }
    }
}
function $e829f443cf620f82$export$b6ed091aa8078e9b(themeVariables) {
    if ($e829f443cf620f82$var$themeTag && $e829f443cf620f82$var$darkModeTag && $e829f443cf620f82$var$lightModeTag) {
        $e829f443cf620f82$var$themeTag.textContent = $e829f443cf620f82$var$createRootStyles(themeVariables).core.cssText;
        $e829f443cf620f82$var$darkModeTag.textContent = $e829f443cf620f82$var$createRootStyles(themeVariables).dark.cssText;
        $e829f443cf620f82$var$lightModeTag.textContent = $e829f443cf620f82$var$createRootStyles(themeVariables).light.cssText;
    }
}
function $e829f443cf620f82$var$createRootStyles(themeVariables) {
    return {
        core: (0, $a71q3.css)`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      @keyframes w3m-shake {
        0% {
          transform: scale(1) rotate(0deg);
        }
        20% {
          transform: scale(1) rotate(-1deg);
        }
        40% {
          transform: scale(1) rotate(1.5deg);
        }
        60% {
          transform: scale(1) rotate(-1.5deg);
        }
        80% {
          transform: scale(1) rotate(1deg);
        }
        100% {
          transform: scale(1) rotate(0deg);
        }
      }
      @keyframes w3m-iframe-fade-out {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
      @keyframes w3m-iframe-zoom-in {
        0% {
          transform: translateY(50px);
          opacity: 0;
        }
        100% {
          transform: translateY(0px);
          opacity: 1;
        }
      }
      @keyframes w3m-iframe-zoom-in-mobile {
        0% {
          transform: scale(0.95);
          opacity: 0;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
      :root {
        --w3m-modal-width: 360px;
        --w3m-color-mix-strength: ${(0, $a71q3.unsafeCSS)(themeVariables?.["--w3m-color-mix-strength"] ? `${themeVariables["--w3m-color-mix-strength"]}%` : "0%")};
        --w3m-font-family: ${(0, $a71q3.unsafeCSS)(themeVariables?.["--w3m-font-family"] || "Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;")};
        --w3m-font-size-master: ${(0, $a71q3.unsafeCSS)(themeVariables?.["--w3m-font-size-master"] || "10px")};
        --w3m-border-radius-master: ${(0, $a71q3.unsafeCSS)(themeVariables?.["--w3m-border-radius-master"] || "4px")};
        --w3m-z-index: ${(0, $a71q3.unsafeCSS)(themeVariables?.["--w3m-z-index"] || 999)};

        --wui-font-family: var(--w3m-font-family);

        --wui-font-size-mini: calc(var(--w3m-font-size-master) * 0.8);
        --wui-font-size-micro: var(--w3m-font-size-master);
        --wui-font-size-tiny: calc(var(--w3m-font-size-master) * 1.2);
        --wui-font-size-small: calc(var(--w3m-font-size-master) * 1.4);
        --wui-font-size-paragraph: calc(var(--w3m-font-size-master) * 1.6);
        --wui-font-size-medium: calc(var(--w3m-font-size-master) * 1.8);
        --wui-font-size-large: calc(var(--w3m-font-size-master) * 2);
        --wui-font-size-title-6: calc(var(--w3m-font-size-master) * 2.2);
        --wui-font-size-medium-title: calc(var(--w3m-font-size-master) * 2.4);
        --wui-font-size-2xl: calc(var(--w3m-font-size-master) * 4);

        --wui-border-radius-5xs: var(--w3m-border-radius-master);
        --wui-border-radius-4xs: calc(var(--w3m-border-radius-master) * 1.5);
        --wui-border-radius-3xs: calc(var(--w3m-border-radius-master) * 2);
        --wui-border-radius-xxs: calc(var(--w3m-border-radius-master) * 3);
        --wui-border-radius-xs: calc(var(--w3m-border-radius-master) * 4);
        --wui-border-radius-s: calc(var(--w3m-border-radius-master) * 5);
        --wui-border-radius-m: calc(var(--w3m-border-radius-master) * 7);
        --wui-border-radius-l: calc(var(--w3m-border-radius-master) * 9);
        --wui-border-radius-3xl: calc(var(--w3m-border-radius-master) * 20);

        --wui-font-weight-light: 400;
        --wui-font-weight-regular: 500;
        --wui-font-weight-medium: 600;
        --wui-font-weight-bold: 700;

        --wui-letter-spacing-2xl: -1.6px;
        --wui-letter-spacing-medium-title: -0.96px;
        --wui-letter-spacing-title-6: -0.88px;
        --wui-letter-spacing-large: -0.8px;
        --wui-letter-spacing-medium: -0.72px;
        --wui-letter-spacing-paragraph: -0.64px;
        --wui-letter-spacing-small: -0.56px;
        --wui-letter-spacing-tiny: -0.48px;
        --wui-letter-spacing-micro: -0.2px;
        --wui-letter-spacing-mini: -0.16px;

        --wui-spacing-0: 0px;
        --wui-spacing-4xs: 2px;
        --wui-spacing-3xs: 4px;
        --wui-spacing-xxs: 6px;
        --wui-spacing-2xs: 7px;
        --wui-spacing-xs: 8px;
        --wui-spacing-1xs: 10px;
        --wui-spacing-s: 12px;
        --wui-spacing-m: 14px;
        --wui-spacing-l: 16px;
        --wui-spacing-2l: 18px;
        --wui-spacing-xl: 20px;
        --wui-spacing-xxl: 24px;
        --wui-spacing-2xl: 32px;
        --wui-spacing-3xl: 40px;
        --wui-spacing-4xl: 90px;
        --wui-spacing-5xl: 95px;

        --wui-icon-box-size-xxs: 14px;
        --wui-icon-box-size-xs: 20px;
        --wui-icon-box-size-sm: 24px;
        --wui-icon-box-size-md: 32px;
        --wui-icon-box-size-lg: 40px;
        --wui-icon-box-size-2lg: 48px;
        --wui-icon-box-size-xl: 64px;

        --wui-icon-size-inherit: inherit;
        --wui-icon-size-xxs: 10px;
        --wui-icon-size-xs: 12px;
        --wui-icon-size-sm: 14px;
        --wui-icon-size-md: 16px;
        --wui-icon-size-mdl: 18px;
        --wui-icon-size-lg: 20px;
        --wui-icon-size-xl: 24px;
        --wui-icon-size-xxl: 28px;

        --wui-wallet-image-size-inherit: inherit;
        --wui-wallet-image-size-sm: 40px;
        --wui-wallet-image-size-md: 56px;
        --wui-wallet-image-size-lg: 80px;

        --wui-visual-size-size-inherit: inherit;
        --wui-visual-size-sm: 40px;
        --wui-visual-size-md: 55px;
        --wui-visual-size-lg: 80px;

        --wui-box-size-md: 100px;
        --wui-box-size-lg: 120px;

        --wui-ease-out-power-2: cubic-bezier(0, 0, 0.22, 1);
        --wui-ease-out-power-1: cubic-bezier(0, 0, 0.55, 1);

        --wui-ease-in-power-3: cubic-bezier(0.66, 0, 1, 1);
        --wui-ease-in-power-2: cubic-bezier(0.45, 0, 1, 1);
        --wui-ease-in-power-1: cubic-bezier(0.3, 0, 1, 1);

        --wui-ease-inout-power-1: cubic-bezier(0.45, 0, 0.55, 1);

        --wui-duration-lg: 200ms;
        --wui-duration-md: 125ms;
        --wui-duration-sm: 75ms;

        --wui-path-network-sm: path(
          'M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z'
        );

        --wui-path-network-md: path(
          'M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z'
        );

        --wui-path-network-lg: path(
          'M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z'
        );

        --wui-width-network-sm: 36px;
        --wui-width-network-md: 48px;
        --wui-width-network-lg: 86px;

        --wui-height-network-sm: 40px;
        --wui-height-network-md: 54px;
        --wui-height-network-lg: 96px;

        --wui-icon-size-network-xs: 12px;
        --wui-icon-size-network-sm: 16px;
        --wui-icon-size-network-md: 24px;
        --wui-icon-size-network-lg: 42px;

        --wui-color-inherit: inherit;

        --wui-color-inverse-100: #fff;
        --wui-color-inverse-000: #000;

        --wui-cover: rgba(20, 20, 20, 0.8);

        --wui-color-modal-bg: var(--wui-color-modal-bg-base);

        --wui-color-accent-100: var(--wui-color-accent-base-100);
        --wui-color-accent-090: var(--wui-color-accent-base-090);
        --wui-color-accent-080: var(--wui-color-accent-base-080);

        --wui-color-success-100: var(--wui-color-success-base-100);

        --wui-color-error-100: var(--wui-color-error-base-100);

        --wui-icon-box-bg-error-100: var(--wui-icon-box-bg-error-base-100);
        --wui-icon-box-bg-blue-100: var(--wui-icon-box-bg-blue-base-100);
        --wui-icon-box-bg-success-100: var(--wui-icon-box-bg-success-base-100);
        --wui-icon-box-bg-inverse-100: var(--wui-icon-box-bg-inverse-base-100);

        --wui-all-wallets-bg-100: var(--wui-all-wallets-bg-100);

        --wui-avatar-border: var(--wui-avatar-border-base);

        --wui-thumbnail-border: var(--wui-thumbnail-border-base);

        --wui-box-shadow-blue: var(--wui-color-accent-glass-020);
      }

      @supports (background: color-mix(in srgb, white 50%, black)) {
        :root {
          --wui-color-modal-bg: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-modal-bg-base)
          );

          --wui-box-shadow-blue: color-mix(in srgb, var(--wui-color-accent-100) 20%, transparent);

          --wui-color-accent-100: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 100%,
            transparent
          );
          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );
          --wui-color-accent-glass-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-color-accent-glass-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );
          --wui-color-accent-glass-020: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 20%,
            transparent
          );
          --wui-color-accent-glass-015: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 15%,
            transparent
          );
          --wui-color-accent-glass-010: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 10%,
            transparent
          );
          --wui-color-accent-glass-005: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 5%,
            transparent
          );
          --wui-color-accent-002: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 2%,
            transparent
          );

          --wui-color-fg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-100)
          );
          --wui-color-fg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-125)
          );
          --wui-color-fg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-150)
          );
          --wui-color-fg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-175)
          );
          --wui-color-fg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-200)
          );
          --wui-color-fg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-225)
          );
          --wui-color-fg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-250)
          );
          --wui-color-fg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-275)
          );
          --wui-color-fg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-300)
          );

          --wui-color-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-100)
          );
          --wui-color-bg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-125)
          );
          --wui-color-bg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-150)
          );
          --wui-color-bg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-175)
          );
          --wui-color-bg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-200)
          );
          --wui-color-bg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-225)
          );
          --wui-color-bg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-250)
          );
          --wui-color-bg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-275)
          );
          --wui-color-bg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-300)
          );

          --wui-color-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-success-base-100)
          );
          --wui-color-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-error-base-100)
          );

          --wui-icon-box-bg-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-error-base-100)
          );
          --wui-icon-box-bg-accent-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-blue-base-100)
          );
          --wui-icon-box-bg-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-success-base-100)
          );
          --wui-icon-box-bg-inverse-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-inverse-base-100)
          );

          --wui-all-wallets-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-all-wallets-bg-100)
          );

          --wui-avatar-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-avatar-border-base)
          );

          --wui-thumbnail-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-thumbnail-border-base)
          );
        }
      }
    `,
        light: (0, $a71q3.css)`
      :root {
        --w3m-color-mix: ${(0, $a71q3.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#fff")};
        --w3m-accent: ${(0, $a71q3.unsafeCSS)((0, $5OPHH.getW3mThemeVariables)(themeVariables, "dark")["--w3m-accent"])};
        --w3m-default: #fff;

        --wui-color-modal-bg-base: ${(0, $a71q3.unsafeCSS)((0, $5OPHH.getW3mThemeVariables)(themeVariables, "dark")["--w3m-background"])};
        --wui-color-accent-base-100: var(--w3m-accent);

        --wui-color-blueberry-100: hsla(230, 100%, 67%, 1);
        --wui-color-blueberry-090: hsla(231, 76%, 61%, 1);
        --wui-color-blueberry-080: hsla(230, 59%, 55%, 1);
        --wui-color-blueberry-050: hsla(231, 100%, 70%, 0.1);

        --wui-color-fg-100: #e4e7e7;
        --wui-color-fg-125: #d0d5d5;
        --wui-color-fg-150: #a8b1b1;
        --wui-color-fg-175: #a8b0b0;
        --wui-color-fg-200: #949e9e;
        --wui-color-fg-225: #868f8f;
        --wui-color-fg-250: #788080;
        --wui-color-fg-275: #788181;
        --wui-color-fg-300: #6e7777;

        --wui-color-bg-100: #141414;
        --wui-color-bg-125: #191a1a;
        --wui-color-bg-150: #1e1f1f;
        --wui-color-bg-175: #222525;
        --wui-color-bg-200: #272a2a;
        --wui-color-bg-225: #2c3030;
        --wui-color-bg-250: #313535;
        --wui-color-bg-275: #363b3b;
        --wui-color-bg-300: #3b4040;

        --wui-color-success-base-100: #26d962;
        --wui-color-error-base-100: #f25a67;

        --wui-color-success-glass-001: rgba(38, 217, 98, 0.01);
        --wui-color-success-glass-002: rgba(38, 217, 98, 0.02);
        --wui-color-success-glass-005: rgba(38, 217, 98, 0.05);
        --wui-color-success-glass-010: rgba(38, 217, 98, 0.1);
        --wui-color-success-glass-015: rgba(38, 217, 98, 0.15);
        --wui-color-success-glass-020: rgba(38, 217, 98, 0.2);
        --wui-color-success-glass-025: rgba(38, 217, 98, 0.25);
        --wui-color-success-glass-030: rgba(38, 217, 98, 0.3);
        --wui-color-success-glass-060: rgba(38, 217, 98, 0.6);
        --wui-color-success-glass-080: rgba(38, 217, 98, 0.8);

        --wui-color-error-glass-001: rgba(242, 90, 103, 0.01);
        --wui-color-error-glass-002: rgba(242, 90, 103, 0.02);
        --wui-color-error-glass-005: rgba(242, 90, 103, 0.05);
        --wui-color-error-glass-010: rgba(242, 90, 103, 0.1);
        --wui-color-error-glass-015: rgba(242, 90, 103, 0.15);
        --wui-color-error-glass-020: rgba(242, 90, 103, 0.2);
        --wui-color-error-glass-025: rgba(242, 90, 103, 0.25);
        --wui-color-error-glass-030: rgba(242, 90, 103, 0.3);
        --wui-color-error-glass-060: rgba(242, 90, 103, 0.6);
        --wui-color-error-glass-080: rgba(242, 90, 103, 0.8);

        --wui-color-gray-glass-001: rgba(255, 255, 255, 0.01);
        --wui-color-gray-glass-002: rgba(255, 255, 255, 0.02);
        --wui-color-gray-glass-005: rgba(255, 255, 255, 0.05);
        --wui-color-gray-glass-010: rgba(255, 255, 255, 0.1);
        --wui-color-gray-glass-015: rgba(255, 255, 255, 0.15);
        --wui-color-gray-glass-020: rgba(255, 255, 255, 0.2);
        --wui-color-gray-glass-025: rgba(255, 255, 255, 0.25);
        --wui-color-gray-glass-030: rgba(255, 255, 255, 0.3);
        --wui-color-gray-glass-060: rgba(255, 255, 255, 0.6);
        --wui-color-gray-glass-080: rgba(255, 255, 255, 0.8);
        --wui-color-gray-glass-090: rgba(255, 255, 255, 0.9);

        --wui-icon-box-bg-error-base-100: #3c2426;
        --wui-icon-box-bg-blue-base-100: #20303f;
        --wui-icon-box-bg-success-base-100: #1f3a28;
        --wui-icon-box-bg-inverse-base-100: #243240;

        --wui-all-wallets-bg-100: #222b35;

        --wui-avatar-border-base: #252525;

        --wui-thumbnail-border-base: #252525;
      }
    `,
        dark: (0, $a71q3.css)`
      :root {
        --w3m-color-mix: ${(0, $a71q3.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#000")};
        --w3m-accent: ${(0, $a71q3.unsafeCSS)((0, $5OPHH.getW3mThemeVariables)(themeVariables, "light")["--w3m-accent"])};
        --w3m-default: #000;

        --wui-color-modal-bg-base: ${(0, $a71q3.unsafeCSS)((0, $5OPHH.getW3mThemeVariables)(themeVariables, "light")["--w3m-background"])};
        --wui-color-accent-base-100: var(--w3m-accent);

        --wui-color-blueberry-100: hsla(231, 100%, 70%, 1);
        --wui-color-blueberry-090: hsla(231, 97%, 72%, 1);
        --wui-color-blueberry-080: hsla(231, 92%, 74%, 1);

        --wui-color-fg-100: #141414;
        --wui-color-fg-125: #2d3131;
        --wui-color-fg-150: #474d4d;
        --wui-color-fg-175: #636d6d;
        --wui-color-fg-200: #798686;
        --wui-color-fg-225: #828f8f;
        --wui-color-fg-250: #8b9797;
        --wui-color-fg-275: #95a0a0;
        --wui-color-fg-300: #9ea9a9;

        --wui-color-bg-100: #ffffff;
        --wui-color-bg-125: #f5fafa;
        --wui-color-bg-150: #f3f8f8;
        --wui-color-bg-175: #eef4f4;
        --wui-color-bg-200: #eaf1f1;
        --wui-color-bg-225: #e5eded;
        --wui-color-bg-250: #e1e9e9;
        --wui-color-bg-275: #dce7e7;
        --wui-color-bg-300: #d8e3e3;

        --wui-color-success-base-100: #26b562;
        --wui-color-error-base-100: #f05142;

        --wui-color-success-glass-001: rgba(38, 181, 98, 0.01);
        --wui-color-success-glass-002: rgba(38, 181, 98, 0.02);
        --wui-color-success-glass-005: rgba(38, 181, 98, 0.05);
        --wui-color-success-glass-010: rgba(38, 181, 98, 0.1);
        --wui-color-success-glass-015: rgba(38, 181, 98, 0.15);
        --wui-color-success-glass-020: rgba(38, 181, 98, 0.2);
        --wui-color-success-glass-025: rgba(38, 181, 98, 0.25);
        --wui-color-success-glass-030: rgba(38, 181, 98, 0.3);
        --wui-color-success-glass-060: rgba(38, 181, 98, 0.6);
        --wui-color-success-glass-080: rgba(38, 181, 98, 0.8);

        --wui-color-error-glass-001: rgba(240, 81, 66, 0.01);
        --wui-color-error-glass-002: rgba(240, 81, 66, 0.02);
        --wui-color-error-glass-005: rgba(240, 81, 66, 0.05);
        --wui-color-error-glass-010: rgba(240, 81, 66, 0.1);
        --wui-color-error-glass-015: rgba(240, 81, 66, 0.15);
        --wui-color-error-glass-020: rgba(240, 81, 66, 0.2);
        --wui-color-error-glass-025: rgba(240, 81, 66, 0.25);
        --wui-color-error-glass-030: rgba(240, 81, 66, 0.3);
        --wui-color-error-glass-060: rgba(240, 81, 66, 0.6);
        --wui-color-error-glass-080: rgba(240, 81, 66, 0.8);

        --wui-icon-box-bg-error-base-100: #f4dfdd;
        --wui-icon-box-bg-blue-base-100: #d9ecfb;
        --wui-icon-box-bg-success-base-100: #daf0e4;
        --wui-icon-box-bg-inverse-base-100: #dcecfc;

        --wui-all-wallets-bg-100: #e8f1fa;

        --wui-avatar-border-base: #f3f4f4;

        --wui-thumbnail-border-base: #eaefef;

        --wui-color-gray-glass-001: rgba(0, 0, 0, 0.01);
        --wui-color-gray-glass-002: rgba(0, 0, 0, 0.02);
        --wui-color-gray-glass-005: rgba(0, 0, 0, 0.05);
        --wui-color-gray-glass-010: rgba(0, 0, 0, 0.1);
        --wui-color-gray-glass-015: rgba(0, 0, 0, 0.15);
        --wui-color-gray-glass-020: rgba(0, 0, 0, 0.2);
        --wui-color-gray-glass-025: rgba(0, 0, 0, 0.25);
        --wui-color-gray-glass-030: rgba(0, 0, 0, 0.3);
        --wui-color-gray-glass-060: rgba(0, 0, 0, 0.6);
        --wui-color-gray-glass-080: rgba(0, 0, 0, 0.8);
        --wui-color-gray-glass-090: rgba(0, 0, 0, 0.9);
      }
    `
    };
}
const $e829f443cf620f82$export$6b6f359a824920a4 = (0, $a71q3.css)`
  *,
  *::after,
  *::before,
  :host {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-style: normal;
    text-rendering: optimizeSpeed;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    font-family: var(--wui-font-family);
    backface-visibility: hidden;
  }
`;
const $e829f443cf620f82$export$e7ba49a1dbca65c7 = (0, $a71q3.css)`
  button,
  a {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition:
      color var(--wui-duration-lg) var(--wui-ease-out-power-1),
      background-color var(--wui-duration-lg) var(--wui-ease-out-power-1),
      border var(--wui-duration-lg) var(--wui-ease-out-power-1),
      box-shadow var(--wui-duration-lg) var(--wui-ease-out-power-1);
    will-change: background-color, color, border, box-shadow;
    outline: none;
    border: none;
    column-gap: var(--wui-spacing-3xs);
    background-color: transparent;
    text-decoration: none;
  }

  button:disabled > wui-wallet-image,
  button:disabled > wui-all-wallets-image,
  button:disabled > wui-network-image,
  button:disabled > wui-image,
  button:disabled > wui-transaction-visual,
  button:disabled > wui-logo {
    filter: grayscale(1);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-gray-glass-005);
    }

    button:active:enabled {
      background-color: var(--wui-color-gray-glass-010);
    }
  }

  button:disabled > wui-icon-box {
    opacity: 0.5;
  }

  input {
    border: none;
    outline: none;
    appearance: none;
  }
`;
const $e829f443cf620f82$export$ab44001f5690ee9c = (0, $a71q3.css)`
  .wui-color-inherit {
    color: var(--wui-color-inherit);
  }

  .wui-color-accent-100 {
    color: var(--wui-color-accent-100);
  }

  .wui-color-error-100 {
    color: var(--wui-color-error-100);
  }

  .wui-color-success-100 {
    color: var(--wui-color-success-100);
  }

  .wui-color-inverse-100 {
    color: var(--wui-color-inverse-100);
  }

  .wui-color-inverse-000 {
    color: var(--wui-color-inverse-000);
  }

  .wui-color-fg-100 {
    color: var(--wui-color-fg-100);
  }

  .wui-color-fg-200 {
    color: var(--wui-color-fg-200);
  }

  .wui-color-fg-300 {
    color: var(--wui-color-fg-300);
  }

  .wui-bg-color-inherit {
    background-color: var(--wui-color-inherit);
  }

  .wui-bg-color-blue-100 {
    background-color: var(--wui-color-accent-100);
  }

  .wui-bg-color-error-100 {
    background-color: var(--wui-color-error-100);
  }

  .wui-bg-color-success-100 {
    background-color: var(--wui-color-success-100);
  }

  .wui-bg-color-inverse-100 {
    background-color: var(--wui-color-inverse-100);
  }

  .wui-bg-color-inverse-000 {
    background-color: var(--wui-color-inverse-000);
  }

  .wui-bg-color-fg-100 {
    background-color: var(--wui-color-fg-100);
  }

  .wui-bg-color-fg-200 {
    background-color: var(--wui-color-fg-200);
  }

  .wui-bg-color-fg-300 {
    background-color: var(--wui-color-fg-300);
  }
`;

});

parcelRegister("ailZp", function(module, exports) {

$parcel$export(module.exports, "customElement", function () { return $77eca47d36e00620$export$da64fc29f17f9d0e; });
function $77eca47d36e00620$var$standardCustomElement(tagName, descriptor) {
    const { kind: kind, elements: elements } = descriptor;
    return {
        kind: kind,
        elements: elements,
        finisher (clazz) {
            if (!customElements.get(tagName)) customElements.define(tagName, clazz);
        }
    };
}
function $77eca47d36e00620$var$legacyCustomElement(tagName, clazz) {
    if (!customElements.get(tagName)) customElements.define(tagName, clazz);
    return clazz;
}
function $77eca47d36e00620$export$da64fc29f17f9d0e(tagName) {
    return function create(classOrDescriptor) {
        return typeof classOrDescriptor === "function" ? $77eca47d36e00620$var$legacyCustomElement(tagName, classOrDescriptor) : $77eca47d36e00620$var$standardCustomElement(tagName, classOrDescriptor);
    };
}

});

parcelRegister("c4Avo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ca22cf27a5e5f8e$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $8ca22cf27a5e5f8e$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    border-radius: clamp(0px, var(--wui-border-radius-l), 44px);
    box-shadow: 0 0 0 1px var(--wui-color-gray-glass-005);
    background-color: var(--wui-color-modal-bg);
    overflow: hidden;
  }
`;

});


parcelRegister("i6mxN", function(module, exports) {

$parcel$export(module.exports, "WuiIcon", function () { return $d2da46517a8702b2$export$10b8e15b42b9fa26; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $kUoxF = parcelRequire("kUoxF");

var $7Islu = parcelRequire("7Islu");

var $9pFRl = parcelRequire("9pFRl");

var $iiz3A = parcelRequire("iiz3A");

var $2HfKy = parcelRequire("2HfKy");

var $9ZroR = parcelRequire("9ZroR");

var $gZJq5 = parcelRequire("gZJq5");

var $iy3ae = parcelRequire("iy3ae");

var $84jXG = parcelRequire("84jXG");

var $jbMP2 = parcelRequire("jbMP2");

var $fjA9Z = parcelRequire("fjA9Z");

var $2ruyF = parcelRequire("2ruyF");

var $e5wiW = parcelRequire("e5wiW");

var $ec0qx = parcelRequire("ec0qx");

var $gxCJe = parcelRequire("gxCJe");

var $lvvVL = parcelRequire("lvvVL");

var $iA5US = parcelRequire("iA5US");

var $gd6Dy = parcelRequire("gd6Dy");

var $89QSe = parcelRequire("89QSe");

var $23jte = parcelRequire("23jte");

var $4QcOh = parcelRequire("4QcOh");

var $aS2YC = parcelRequire("aS2YC");

var $9QIxO = parcelRequire("9QIxO");

var $lhTq2 = parcelRequire("lhTq2");

var $7IJoZ = parcelRequire("7IJoZ");

var $6AJ1Q = parcelRequire("6AJ1Q");

var $8IhNH = parcelRequire("8IhNH");

var $bwGO2 = parcelRequire("bwGO2");

var $1ymc5 = parcelRequire("1ymc5");

var $cVide = parcelRequire("cVide");

var $eMo3z = parcelRequire("eMo3z");

var $1KlqE = parcelRequire("1KlqE");

var $bVjEn = parcelRequire("bVjEn");

var $e6NME = parcelRequire("e6NME");

var $7PVNR = parcelRequire("7PVNR");

var $bUfr2 = parcelRequire("bUfr2");

var $eRxS8 = parcelRequire("eRxS8");

var $2F27M = parcelRequire("2F27M");

var $10x2F = parcelRequire("10x2F");

var $3aPzP = parcelRequire("3aPzP");

var $jiiiN = parcelRequire("jiiiN");

var $96Rj9 = parcelRequire("96Rj9");

var $4dF0m = parcelRequire("4dF0m");

var $hhgrC = parcelRequire("hhgrC");

var $iqK4w = parcelRequire("iqK4w");

var $lfrnA = parcelRequire("lfrnA");

var $3IqGF = parcelRequire("3IqGF");

var $9YQAd = parcelRequire("9YQAd");

var $cisP4 = parcelRequire("cisP4");

var $5o7ln = parcelRequire("5o7ln");

var $aPN0F = parcelRequire("aPN0F");

var $eo9QN = parcelRequire("eo9QN");

var $2qHNn = parcelRequire("2qHNn");

var $m90TI = parcelRequire("m90TI");

var $1sg6D = parcelRequire("1sg6D");

var $hccSf = parcelRequire("hccSf");

var $3EgBh = parcelRequire("3EgBh");

var $bFCtI = parcelRequire("bFCtI");

var $6E0eq = parcelRequire("6E0eq");

var $dZx1R = parcelRequire("dZx1R");

var $9Ytl9 = parcelRequire("9Ytl9");

var $kR0KT = parcelRequire("kR0KT");

var $ggn6d = parcelRequire("ggn6d");

var $lSAmD = parcelRequire("lSAmD");

var $6zO57 = parcelRequire("6zO57");

var $a4Qhc = parcelRequire("a4Qhc");

var $ePCmQ = parcelRequire("ePCmQ");

var $f0FPs = parcelRequire("f0FPs");

var $6Se5K = parcelRequire("6Se5K");

var $aZMJD = parcelRequire("aZMJD");

var $flGAO = parcelRequire("flGAO");

var $kxxjb = parcelRequire("kxxjb");
var $d2da46517a8702b2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $d2da46517a8702b2$var$svgOptions = {
    add: (0, $7Islu.addSvg),
    allWallets: (0, $9pFRl.allWalletsSvg),
    arrowBottomCircle: (0, $iiz3A.arrowBottomCircleSvg),
    appStore: (0, $2HfKy.appStoreSvg),
    apple: (0, $9ZroR.appleSvg),
    arrowBottom: (0, $gZJq5.arrowBottomSvg),
    arrowLeft: (0, $iy3ae.arrowLeftSvg),
    arrowRight: (0, $84jXG.arrowRightSvg),
    arrowTop: (0, $jbMP2.arrowTopSvg),
    bank: (0, $fjA9Z.bankSvg),
    browser: (0, $2ruyF.browserSvg),
    card: (0, $e5wiW.cardSvg),
    checkmark: (0, $gxCJe.checkmarkSvg),
    checkmarkBold: (0, $ec0qx.checkmarkBoldSvg),
    chevronBottom: (0, $lvvVL.chevronBottomSvg),
    chevronLeft: (0, $iA5US.chevronLeftSvg),
    chevronRight: (0, $gd6Dy.chevronRightSvg),
    chevronTop: (0, $89QSe.chevronTopSvg),
    chromeStore: (0, $23jte.chromeStoreSvg),
    clock: (0, $4QcOh.clockSvg),
    close: (0, $aS2YC.closeSvg),
    compass: (0, $lhTq2.compassSvg),
    coinPlaceholder: (0, $9QIxO.coinPlaceholderSvg),
    copy: (0, $7IJoZ.copySvg),
    cursor: (0, $6AJ1Q.cursorSvg),
    cursorTransparent: (0, $8IhNH.cursorTransparentSvg),
    desktop: (0, $bwGO2.desktopSvg),
    disconnect: (0, $1ymc5.disconnectSvg),
    discord: (0, $cVide.discordSvg),
    etherscan: (0, $eMo3z.etherscanSvg),
    extension: (0, $1KlqE.extensionSvg),
    externalLink: (0, $bVjEn.externalLinkSvg),
    facebook: (0, $e6NME.facebookSvg),
    farcaster: (0, $7PVNR.farcasterSvg),
    filters: (0, $bUfr2.filtersSvg),
    github: (0, $eRxS8.githubSvg),
    google: (0, $2F27M.googleSvg),
    helpCircle: (0, $10x2F.helpCircleSvg),
    image: (0, $3aPzP.imageSvg),
    id: (0, $flGAO.idSvg),
    infoCircle: (0, $jiiiN.infoCircleSvg),
    lightbulb: (0, $aZMJD.lightbulbSvg),
    mail: (0, $96Rj9.mailSvg),
    mobile: (0, $4dF0m.mobileSvg),
    more: (0, $hhgrC.moreSvg),
    networkPlaceholder: (0, $iqK4w.networkPlaceholderSvg),
    nftPlaceholder: (0, $lfrnA.nftPlaceholderSvg),
    off: (0, $3IqGF.offSvg),
    playStore: (0, $9YQAd.playStoreSvg),
    plus: (0, $cisP4.plusSvg),
    qrCode: (0, $5o7ln.qrCodeIcon),
    recycleHorizontal: (0, $aPN0F.recycleHorizontalSvg),
    refresh: (0, $eo9QN.refreshSvg),
    search: (0, $2qHNn.searchSvg),
    send: (0, $m90TI.sendSvg),
    swapHorizontal: (0, $1sg6D.swapHorizontalSvg),
    swapHorizontalMedium: (0, $3EgBh.swapHorizontalMediumSvg),
    swapHorizontalBold: (0, $hccSf.swapHorizontalBoldSvg),
    swapHorizontalRoundedBold: (0, $bFCtI.swapHorizontalRoundedBoldSvg),
    swapVertical: (0, $6E0eq.swapVerticalSvg),
    telegram: (0, $dZx1R.telegramSvg),
    threeDots: (0, $9Ytl9.threeDotsSvg),
    twitch: (0, $kR0KT.twitchSvg),
    twitter: (0, $kxxjb.xSvg),
    twitterIcon: (0, $ggn6d.twitterIconSvg),
    verify: (0, $lSAmD.verifySvg),
    verifyFilled: (0, $6zO57.verifyFilledSvg),
    wallet: (0, $ePCmQ.walletSvg),
    walletConnect: (0, $f0FPs.walletConnectSvg),
    walletPlaceholder: (0, $a4Qhc.walletPlaceholderSvg),
    warningCircle: (0, $6Se5K.warningCircleSvg),
    x: (0, $kxxjb.xSvg)
};
let $d2da46517a8702b2$export$10b8e15b42b9fa26 = class WuiIcon extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "copy";
        this.color = "fg-300";
    }
    render() {
        this.style.cssText = `
      --local-color: ${`var(--wui-color-${this.color});`}
      --local-width: ${`var(--wui-icon-size-${this.size});`}
    `;
        return (0, $7pRM7.html)`${$d2da46517a8702b2$var$svgOptions[this.name]}`;
    }
};
$d2da46517a8702b2$export$10b8e15b42b9fa26.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.colorStyles),
    (0, $kUoxF.default)
];
$d2da46517a8702b2$var$__decorate([
    (0, $biDip.property)()
], $d2da46517a8702b2$export$10b8e15b42b9fa26.prototype, "size", void 0);
$d2da46517a8702b2$var$__decorate([
    (0, $biDip.property)()
], $d2da46517a8702b2$export$10b8e15b42b9fa26.prototype, "name", void 0);
$d2da46517a8702b2$var$__decorate([
    (0, $biDip.property)()
], $d2da46517a8702b2$export$10b8e15b42b9fa26.prototype, "color", void 0);
$d2da46517a8702b2$export$10b8e15b42b9fa26 = $d2da46517a8702b2$var$__decorate([
    (0, $ailZp.customElement)("wui-icon")
], $d2da46517a8702b2$export$10b8e15b42b9fa26);

});
parcelRegister("kWsn3", function(module, exports) {
$parcel$export(module.exports, "property", function () { return (parcelRequire("biDip")).property; });
$parcel$export(module.exports, "state", function () { return (parcelRequire("koENb")).state; });
parcelRequire("dKE7g");
parcelRequire("biDip");
parcelRequire("koENb");
parcelRequire("7Enhl");
parcelRequire("iOUc4");
parcelRequire("5bKkO");
parcelRequire("iODhu");
parcelRequire("6l5uw");
parcelRequire("lQyBn");

});
parcelRegister("dKE7g", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a02eb07d0ab9d3ae$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("biDip", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $839fdb85deabdd1b$export$d541bacb2bda4494; });

var $inrjJ = parcelRequire("inrjJ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $839fdb85deabdd1b$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $inrjJ.defaultConverter),
    reflect: !1,
    hasChanged: (0, $inrjJ.notEqual)
}, $839fdb85deabdd1b$export$8d623b1670eb40f4 = (t = $839fdb85deabdd1b$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $839fdb85deabdd1b$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $839fdb85deabdd1b$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("koENb", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $ed95b107cf3c1045$export$ca000e230c0caa3e; });

var $biDip = parcelRequire("biDip");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ed95b107cf3c1045$export$ca000e230c0caa3e(r) {
    return (0, $biDip.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("7Enhl", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $591e5381c52902b1$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("iOUc4", function(module, exports) {

var $fPzX3 = parcelRequire("fPzX3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $db387c67106d598f$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $fPzX3.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $fPzX3.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("fPzX3", function(module, exports) {

$parcel$export(module.exports, "desc", function () { return $b86781a070499de3$export$51987bb50e1f6752; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b86781a070499de3$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("5bKkO", function(module, exports) {

var $fPzX3 = parcelRequire("fPzX3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $3c71ebeeb75475f2$var$e;
function $3c71ebeeb75475f2$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $fPzX3.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($3c71ebeeb75475f2$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("iODhu", function(module, exports) {

var $fPzX3 = parcelRequire("fPzX3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $db2b5de5b04a9917$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $fPzX3.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("6l5uw", function(module, exports) {

var $fPzX3 = parcelRequire("fPzX3");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $49d8f6b84eaeae9f$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $fPzX3.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("lQyBn", function(module, exports) {

var $fPzX3 = parcelRequire("fPzX3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $fe794b836986b98f$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $fPzX3.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("kUoxF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f38c1320830ed605$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $f38c1320830ed605$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    aspect-ratio: 1 / 1;
    color: var(--local-color);
    width: var(--local-width);
  }

  svg {
    width: inherit;
    height: inherit;
    object-fit: contain;
    object-position: center;
  }
`;

});

parcelRegister("7Islu", function(module, exports) {

$parcel$export(module.exports, "addSvg", function () { return $59e2a14bcb165139$export$ca7db417ce6a3550; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $59e2a14bcb165139$export$ca7db417ce6a3550 = (0, $7pRM7.svg)`<svg
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.0023 0.875C7.48571 0.875 7.8776 1.26675 7.8776 1.75V6.125H12.2541C12.7375 6.125 13.1294 6.51675 13.1294 7C13.1294 7.48325 12.7375 7.875 12.2541 7.875H7.8776V12.25C7.8776 12.7332 7.48571 13.125 7.0023 13.125C6.51889 13.125 6.12701 12.7332 6.12701 12.25V7.875H1.75054C1.26713 7.875 0.875244 7.48325 0.875244 7C0.875244 6.51675 1.26713 6.125 1.75054 6.125H6.12701V1.75C6.12701 1.26675 6.51889 0.875 7.0023 0.875Z"
    fill="#667dff"
  /></svg
>`;

});

parcelRegister("9pFRl", function(module, exports) {

$parcel$export(module.exports, "allWalletsSvg", function () { return $6da6eb439c55d95e$export$7d5fd172cc1c231a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $6da6eb439c55d95e$export$7d5fd172cc1c231a = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 24 24">
  <path
    style="fill: var(--wui-color-accent-100);"
    d="M10.2 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM10.2 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z"
  />
</svg>`;

});

parcelRegister("iiz3A", function(module, exports) {

$parcel$export(module.exports, "arrowBottomCircleSvg", function () { return $d52519ff82694373$export$33eab3b897a3adc1; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $d52519ff82694373$export$33eab3b897a3adc1 = (0, $7pRM7.svg)`<svg
  fill="none"
  viewBox="0 0 21 20"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10.5 2.42908C6.31875 2.42908 2.92859 5.81989 2.92859 10.0034C2.92859 14.1869 6.31875 17.5777 10.5 17.5777C14.6813 17.5777 18.0714 14.1869 18.0714 10.0034C18.0714 5.81989 14.6813 2.42908 10.5 2.42908ZM0.928589 10.0034C0.928589 4.71596 5.21355 0.429077 10.5 0.429077C15.7865 0.429077 20.0714 4.71596 20.0714 10.0034C20.0714 15.2908 15.7865 19.5777 10.5 19.5777C5.21355 19.5777 0.928589 15.2908 0.928589 10.0034ZM10.5 5.75003C11.0523 5.75003 11.5 6.19774 11.5 6.75003L11.5 10.8343L12.7929 9.54137C13.1834 9.15085 13.8166 9.15085 14.2071 9.54137C14.5976 9.9319 14.5976 10.5651 14.2071 10.9556L11.2071 13.9556C10.8166 14.3461 10.1834 14.3461 9.79291 13.9556L6.79291 10.9556C6.40239 10.5651 6.40239 9.9319 6.79291 9.54137C7.18343 9.15085 7.8166 9.15085 8.20712 9.54137L9.50002 10.8343L9.50002 6.75003C9.50002 6.19774 9.94773 5.75003 10.5 5.75003Z"
    clip-rule="evenodd"
  /></svg
>`;

});

parcelRegister("2HfKy", function(module, exports) {

$parcel$export(module.exports, "appStoreSvg", function () { return $1f6bd08aebb48adf$export$bda99385bd09fbb7; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $1f6bd08aebb48adf$export$bda99385bd09fbb7 = (0, $7pRM7.svg)`
<svg width="36" height="36">
  <path
    d="M28.724 0H7.271A7.269 7.269 0 0 0 0 7.272v21.46A7.268 7.268 0 0 0 7.271 36H28.73A7.272 7.272 0 0 0 36 28.728V7.272A7.275 7.275 0 0 0 28.724 0Z"
    fill="url(#a)"
  />
  <path
    d="m17.845 8.271.729-1.26a1.64 1.64 0 1 1 2.843 1.638l-7.023 12.159h5.08c1.646 0 2.569 1.935 1.853 3.276H6.434a1.632 1.632 0 0 1-1.638-1.638c0-.909.73-1.638 1.638-1.638h4.176l5.345-9.265-1.67-2.898a1.642 1.642 0 0 1 2.844-1.638l.716 1.264Zm-6.317 17.5-1.575 2.732a1.64 1.64 0 1 1-2.844-1.638l1.17-2.025c1.323-.41 2.398-.095 3.249.931Zm13.56-4.954h4.262c.909 0 1.638.729 1.638 1.638 0 .909-.73 1.638-1.638 1.638h-2.367l1.597 2.772c.45.788.185 1.782-.602 2.241a1.642 1.642 0 0 1-2.241-.603c-2.69-4.666-4.711-8.159-6.052-10.485-1.372-2.367-.391-4.743.576-5.549 1.075 1.846 2.682 4.631 4.828 8.348Z"
    fill="#fff"
  />
  <defs>
    <linearGradient id="a" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
      <stop stop-color="#18BFFB" />
      <stop offset="1" stop-color="#2072F3" />
    </linearGradient>
  </defs>
</svg>`;

});

parcelRegister("9ZroR", function(module, exports) {

$parcel$export(module.exports, "appleSvg", function () { return $745f10a3621d67e3$export$3f5c85d1c093200; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $745f10a3621d67e3$export$3f5c85d1c093200 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#000" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M28.77 23.3c-.69 1.99-2.75 5.52-4.87 5.56-1.4.03-1.86-.84-3.46-.84-1.61 0-2.12.81-3.45.86-2.25.1-5.72-5.1-5.72-9.62 0-4.15 2.9-6.2 5.42-6.25 1.36-.02 2.64.92 3.47.92.83 0 2.38-1.13 4.02-.97.68.03 2.6.28 3.84 2.08-3.27 2.14-2.76 6.61.75 8.25ZM24.2 7.88c-2.47.1-4.49 2.69-4.2 4.84 2.28.17 4.47-2.39 4.2-4.84Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("gZJq5", function(module, exports) {

$parcel$export(module.exports, "arrowBottomSvg", function () { return $c5f59340f118757f$export$6f382756ddebc10; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $c5f59340f118757f$export$6f382756ddebc10 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 1.99a1 1 0 0 1 1 1v7.58l2.46-2.46a1 1 0 0 1 1.41 1.42L7.7 13.69a1 1 0 0 1-1.41 0L2.12 9.53A1 1 0 0 1 3.54 8.1L6 10.57V3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("iy3ae", function(module, exports) {

$parcel$export(module.exports, "arrowLeftSvg", function () { return $d80ddb4136bab6ce$export$539cc194b4601565; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $d80ddb4136bab6ce$export$539cc194b4601565 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13 7.99a1 1 0 0 1-1 1H4.4l2.46 2.46a1 1 0 1 1-1.41 1.41L1.29 8.7a1 1 0 0 1 0-1.41L5.46 3.1a1 1 0 0 1 1.41 1.42L4.41 6.99H12a1 1 0 0 1 1 1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("84jXG", function(module, exports) {

$parcel$export(module.exports, "arrowRightSvg", function () { return $5dfe2e6d60754cb4$export$8c76deeccbfa0068; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $5dfe2e6d60754cb4$export$8c76deeccbfa0068 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1 7.99a1 1 0 0 1 1-1h7.58L7.12 4.53A1 1 0 1 1 8.54 3.1l4.16 4.17a1 1 0 0 1 0 1.41l-4.16 4.17a1 1 0 1 1-1.42-1.41l2.46-2.46H2a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("jbMP2", function(module, exports) {

$parcel$export(module.exports, "arrowTopSvg", function () { return $df84ea7a7b390be5$export$2903aa7e1dab2e70; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $df84ea7a7b390be5$export$2903aa7e1dab2e70 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 13.99a1 1 0 0 1-1-1V5.4L3.54 7.86a1 1 0 0 1-1.42-1.41L6.3 2.28a1 1 0 0 1 1.41 0l4.17 4.17a1 1 0 1 1-1.41 1.41L8 5.4v7.59a1 1 0 0 1-1 1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("fjA9Z", function(module, exports) {

$parcel$export(module.exports, "bankSvg", function () { return $b264ae056e82e47f$export$b7cc4752b6244394; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $b264ae056e82e47f$export$b7cc4752b6244394 = (0, $7pRM7.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.61391 1.57124C5.85142 1.42873 6.14813 1.42873 6.38564 1.57124L11.0793 4.38749C11.9179 4.89067 11.5612 6.17864 10.5832 6.17864H9.96398V10.0358H10.2854C10.6996 10.0358 11.0354 10.3716 11.0354 10.7858C11.0354 11.2 10.6996 11.5358 10.2854 11.5358H1.71416C1.29995 11.5358 0.964172 11.2 0.964172 10.7858C0.964172 10.3716 1.29995 10.0358 1.71416 10.0358H2.03558L2.03558 6.17864H1.41637C0.438389 6.17864 0.0816547 4.89066 0.920263 4.38749L5.61391 1.57124ZM3.53554 6.17864V10.0358H5.24979V6.17864H3.53554ZM6.74976 6.17864V10.0358H8.46401V6.17864H6.74976ZM8.64913 4.67864H3.35043L5.99978 3.089L8.64913 4.67864Z"
    fill="currentColor"
  /></svg
>`;

});

parcelRegister("2ruyF", function(module, exports) {

$parcel$export(module.exports, "browserSvg", function () { return $1c75ce95a0148be1$export$9a659d11e13bcec5; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $1c75ce95a0148be1$export$9a659d11e13bcec5 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4 6.4a1 1 0 0 1-.46.89 6.98 6.98 0 0 0 .38 6.18A7 7 0 0 0 16.46 7.3a1 1 0 0 1-.47-.92 7 7 0 0 0-12 .03Zm-2.02-.5a9 9 0 1 1 16.03 8.2A9 9 0 0 1 1.98 5.9Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.03 8.63c-1.46-.3-2.72-.75-3.6-1.35l-.02-.01-.14-.11a1 1 0 0 1 1.2-1.6l.1.08c.6.4 1.52.74 2.69 1 .16-.99.39-1.88.67-2.65.3-.79.68-1.5 1.15-2.02A2.58 2.58 0 0 1 9.99 1c.8 0 1.45.44 1.92.97.47.52.84 1.23 1.14 2.02.29.77.52 1.66.68 2.64a8 8 0 0 0 2.7-1l.26-.18h.48a1 1 0 0 1 .12 2c-.86.51-2.01.91-3.34 1.18a22.24 22.24 0 0 1-.03 3.19c1.45.29 2.7.73 3.58 1.31a1 1 0 0 1-1.1 1.68c-.6-.4-1.56-.76-2.75-1-.15.8-.36 1.55-.6 2.2-.3.79-.67 1.5-1.14 2.02-.47.53-1.12.97-1.92.97-.8 0-1.45-.44-1.91-.97a6.51 6.51 0 0 1-1.15-2.02c-.24-.65-.44-1.4-.6-2.2-1.18.24-2.13.6-2.73.99a1 1 0 1 1-1.1-1.67c.88-.58 2.12-1.03 3.57-1.31a22.03 22.03 0 0 1-.04-3.2Zm2.2-1.7c.15-.86.34-1.61.58-2.24.24-.65.51-1.12.76-1.4.25-.28.4-.29.42-.29.03 0 .17.01.42.3.25.27.52.74.77 1.4.23.62.43 1.37.57 2.22a19.96 19.96 0 0 1-3.52 0Zm-.18 4.6a20.1 20.1 0 0 1-.03-2.62 21.95 21.95 0 0 0 3.94 0 20.4 20.4 0 0 1-.03 2.63 21.97 21.97 0 0 0-3.88 0Zm.27 2c.13.66.3 1.26.49 1.78.24.65.51 1.12.76 1.4.25.28.4.29.42.29.03 0 .17-.01.42-.3.25-.27.52-.74.77-1.4.19-.5.36-1.1.49-1.78a20.03 20.03 0 0 0-3.35 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("e5wiW", function(module, exports) {

$parcel$export(module.exports, "cardSvg", function () { return $a41a974f9831dcfc$export$996b002521801861; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $a41a974f9831dcfc$export$996b002521801861 = (0, $7pRM7.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.16072 2C4.17367 2 4.18665 2 4.19968 2L7.83857 2C8.36772 1.99998 8.82398 1.99996 9.19518 2.04018C9.5895 2.0829 9.97577 2.17811 10.3221 2.42971C10.5131 2.56849 10.6811 2.73647 10.8198 2.92749C11.0714 3.27379 11.1666 3.66007 11.2094 4.0544C11.2496 4.42561 11.2496 4.88188 11.2495 5.41105V7.58896C11.2496 8.11812 11.2496 8.57439 11.2094 8.94561C11.1666 9.33994 11.0714 9.72621 10.8198 10.0725C10.6811 10.2635 10.5131 10.4315 10.3221 10.5703C9.97577 10.8219 9.5895 10.9171 9.19518 10.9598C8.82398 11 8.36772 11 7.83856 11H4.16073C3.63157 11 3.17531 11 2.80411 10.9598C2.40979 10.9171 2.02352 10.8219 1.67722 10.5703C1.48621 10.4315 1.31824 10.2635 1.17946 10.0725C0.927858 9.72621 0.832652 9.33994 0.78993 8.94561C0.749713 8.5744 0.749733 8.11813 0.749757 7.58896L0.749758 5.45C0.749758 5.43697 0.749758 5.42399 0.749757 5.41104C0.749733 4.88188 0.749713 4.42561 0.78993 4.0544C0.832652 3.66007 0.927858 3.27379 1.17946 2.92749C1.31824 2.73647 1.48621 2.56849 1.67722 2.42971C2.02352 2.17811 2.40979 2.0829 2.80411 2.04018C3.17531 1.99996 3.63157 1.99998 4.16072 2ZM2.96567 3.53145C2.69897 3.56034 2.60687 3.60837 2.55888 3.64324C2.49521 3.6895 2.43922 3.74549 2.39296 3.80916C2.35809 3.85715 2.31007 3.94926 2.28117 4.21597C2.26629 4.35335 2.25844 4.51311 2.25431 4.70832H9.74498C9.74085 4.51311 9.733 4.35335 9.71812 4.21597C9.68922 3.94926 9.6412 3.85715 9.60633 3.80916C9.56007 3.74549 9.50408 3.6895 9.44041 3.64324C9.39242 3.60837 9.30031 3.56034 9.03362 3.53145C8.75288 3.50103 8.37876 3.5 7.79961 3.5H4.19968C3.62053 3.5 3.24641 3.50103 2.96567 3.53145ZM9.74956 6.20832H2.24973V7.55C2.24973 8.12917 2.25076 8.5033 2.28117 8.78404C2.31007 9.05074 2.35809 9.14285 2.39296 9.19084C2.43922 9.25451 2.49521 9.31051 2.55888 9.35677C2.60687 9.39163 2.69897 9.43966 2.96567 9.46856C3.24641 9.49897 3.62053 9.5 4.19968 9.5H7.79961C8.37876 9.5 8.75288 9.49897 9.03362 9.46856C9.30032 9.43966 9.39242 9.39163 9.44041 9.35677C9.50408 9.31051 9.56007 9.25451 9.60633 9.19084C9.6412 9.14285 9.68922 9.05075 9.71812 8.78404C9.74854 8.5033 9.74956 8.12917 9.74956 7.55V6.20832ZM6.74963 8C6.74963 7.58579 7.08541 7.25 7.49961 7.25H8.2496C8.6638 7.25 8.99958 7.58579 8.99958 8C8.99958 8.41422 8.6638 8.75 8.2496 8.75H7.49961C7.08541 8.75 6.74963 8.41422 6.74963 8Z"
    fill="currentColor"
  /></svg
>`;

});

parcelRegister("ec0qx", function(module, exports) {

$parcel$export(module.exports, "checkmarkBoldSvg", function () { return $a5528474843833b1$export$8110e67fa3d88854; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $a5528474843833b1$export$8110e67fa3d88854 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M12.9576 2.23383C13.3807 2.58873 13.4361 3.21947 13.0812 3.64263L6.37159 11.6426C6.19161 11.8572 5.92989 11.9865 5.65009 11.999C5.3703 12.0115 5.09808 11.9062 4.89965 11.7085L0.979321 7.80331C0.588042 7.41354 0.586817 6.78038 0.976585 6.3891C1.36635 5.99782 1.99952 5.99659 2.3908 6.38636L5.53928 9.52268L11.5488 2.35742C11.9037 1.93426 12.5344 1.87893 12.9576 2.23383Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("gxCJe", function(module, exports) {

$parcel$export(module.exports, "checkmarkSvg", function () { return $c0adc511cafff1cc$export$1e994e99baa45d19; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $c0adc511cafff1cc$export$1e994e99baa45d19 = (0, $7pRM7.svg)`<svg
  width="28"
  height="28"
  viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M25.5297 4.92733C26.1221 5.4242 26.1996 6.30724 25.7027 6.89966L12.2836 22.8997C12.0316 23.2001 11.6652 23.3811 11.2735 23.3986C10.8817 23.4161 10.5006 23.2686 10.2228 22.9919L2.38218 15.1815C1.83439 14.6358 1.83268 13.7494 2.37835 13.2016C2.92403 12.6538 3.81046 12.6521 4.35825 13.1978L11.1183 19.9317L23.5573 5.10036C24.0542 4.50794 24.9372 4.43047 25.5297 4.92733Z"
    fill="#26D962"/>
</svg>
`;

});

parcelRegister("lvvVL", function(module, exports) {

$parcel$export(module.exports, "chevronBottomSvg", function () { return $fa854303e5a91dff$export$515090d56df26148; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $fa854303e5a91dff$export$515090d56df26148 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1.46 4.96a1 1 0 0 1 1.41 0L8 10.09l5.13-5.13a1 1 0 1 1 1.41 1.41l-5.83 5.84a1 1 0 0 1-1.42 0L1.46 6.37a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("iA5US", function(module, exports) {

$parcel$export(module.exports, "chevronLeftSvg", function () { return $d8702da335c3b618$export$dd4e32e981ac6b2; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $d8702da335c3b618$export$dd4e32e981ac6b2 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M11.04 1.46a1 1 0 0 1 0 1.41L5.91 8l5.13 5.13a1 1 0 1 1-1.41 1.41L3.79 8.71a1 1 0 0 1 0-1.42l5.84-5.83a1 1 0 0 1 1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("gd6Dy", function(module, exports) {

$parcel$export(module.exports, "chevronRightSvg", function () { return $bcd30238d40118d6$export$79c9cf11f1aff07c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $bcd30238d40118d6$export$79c9cf11f1aff07c = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.96 14.54a1 1 0 0 1 0-1.41L10.09 8 4.96 2.87a1 1 0 0 1 1.41-1.41l5.84 5.83a1 1 0 0 1 0 1.42l-5.84 5.83a1 1 0 0 1-1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("89QSe", function(module, exports) {

$parcel$export(module.exports, "chevronTopSvg", function () { return $5f082da0d3bc0a96$export$95ea2c128f24f835; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $5f082da0d3bc0a96$export$95ea2c128f24f835 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.54 11.04a1 1 0 0 1-1.41 0L8 5.92l-5.13 5.12a1 1 0 1 1-1.41-1.41l5.83-5.84a1 1 0 0 1 1.42 0l5.83 5.84a1 1 0 0 1 0 1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("23jte", function(module, exports) {

$parcel$export(module.exports, "chromeStoreSvg", function () { return $17eaf6fdf0f97086$export$a97c1f844e68ea51; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $17eaf6fdf0f97086$export$a97c1f844e68ea51 = (0, $7pRM7.svg)`<svg width="36" height="36" fill="none">
  <path
    fill="#fff"
    fill-opacity=".05"
    d="M0 14.94c0-5.55 0-8.326 1.182-10.4a9 9 0 0 1 3.359-3.358C6.614 0 9.389 0 14.94 0h6.12c5.55 0 8.326 0 10.4 1.182a9 9 0 0 1 3.358 3.359C36 6.614 36 9.389 36 14.94v6.12c0 5.55 0 8.326-1.182 10.4a9 9 0 0 1-3.359 3.358C29.386 36 26.611 36 21.06 36h-6.12c-5.55 0-8.326 0-10.4-1.182a9 9 0 0 1-3.358-3.359C0 29.386 0 26.611 0 21.06v-6.12Z"
  />
  <path
    stroke="#fff"
    stroke-opacity=".05"
    d="M14.94.5h6.12c2.785 0 4.84 0 6.46.146 1.612.144 2.743.43 3.691.97a8.5 8.5 0 0 1 3.172 3.173c.541.948.826 2.08.971 3.692.145 1.62.146 3.675.146 6.459v6.12c0 2.785 0 4.84-.146 6.46-.145 1.612-.43 2.743-.97 3.691a8.5 8.5 0 0 1-3.173 3.172c-.948.541-2.08.826-3.692.971-1.62.145-3.674.146-6.459.146h-6.12c-2.784 0-4.84 0-6.46-.146-1.612-.145-2.743-.43-3.691-.97a8.5 8.5 0 0 1-3.172-3.173c-.541-.948-.827-2.08-.971-3.692C.5 25.9.5 23.845.5 21.06v-6.12c0-2.784 0-4.84.146-6.46.144-1.612.43-2.743.97-3.691A8.5 8.5 0 0 1 4.79 1.617C5.737 1.076 6.869.79 8.48.646 10.1.5 12.156.5 14.94.5Z"
  />
  <path
    fill="url(#a)"
    d="M17.998 10.8h12.469a14.397 14.397 0 0 0-24.938.001l6.234 10.798.006-.001a7.19 7.19 0 0 1 6.23-10.799Z"
  />
  <path
    fill="url(#b)"
    d="m24.237 21.598-6.234 10.798A14.397 14.397 0 0 0 30.47 10.798H18.002l-.002.006a7.191 7.191 0 0 1 6.237 10.794Z"
  />
  <path
    fill="url(#c)"
    d="M11.765 21.601 5.531 10.803A14.396 14.396 0 0 0 18.001 32.4l6.235-10.798-.004-.004a7.19 7.19 0 0 1-12.466.004Z"
  />
  <path fill="#fff" d="M18 25.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" />
  <path fill="#1A73E8" d="M18 23.7a5.7 5.7 0 1 0 0-11.4 5.7 5.7 0 0 0 0 11.4Z" />
  <defs>
    <linearGradient
      id="a"
      x1="6.294"
      x2="41.1"
      y1="5.995"
      y2="5.995"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#D93025" />
      <stop offset="1" stop-color="#EA4335" />
    </linearGradient>
    <linearGradient
      id="b"
      x1="20.953"
      x2="37.194"
      y1="32.143"
      y2="2.701"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FCC934" />
      <stop offset="1" stop-color="#FBBC04" />
    </linearGradient>
    <linearGradient
      id="c"
      x1="25.873"
      x2="9.632"
      y1="31.2"
      y2="1.759"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#1E8E3E" />
      <stop offset="1" stop-color="#34A853" />
    </linearGradient>
  </defs>
</svg>`;

});

parcelRegister("4QcOh", function(module, exports) {

$parcel$export(module.exports, "clockSvg", function () { return $3865f4872a08462f$export$36e96663783b415c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $3865f4872a08462f$export$36e96663783b415c = (0, $7pRM7.svg)`<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path 
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M7.00235 2C4.24 2 2.00067 4.23858 2.00067 7C2.00067 9.76142 4.24 12 7.00235 12C9.7647 12 12.004 9.76142 12.004 7C12.004 4.23858 9.7647 2 7.00235 2ZM0 7C0 3.13401 3.13506 0 7.00235 0C10.8696 0 14.0047 3.13401 14.0047 7C14.0047 10.866 10.8696 14 7.00235 14C3.13506 14 0 10.866 0 7ZM7.00235 3C7.55482 3 8.00269 3.44771 8.00269 4V6.58579L9.85327 8.43575C10.2439 8.82627 10.2439 9.45944 9.85327 9.84996C9.46262 10.2405 8.82924 10.2405 8.43858 9.84996L6.29501 7.70711C6.10741 7.51957 6.00201 7.26522 6.00201 7V4C6.00201 3.44771 6.44988 3 7.00235 3Z" 
    fill="currentColor"
  />
</svg>`;

});

parcelRegister("aS2YC", function(module, exports) {

$parcel$export(module.exports, "closeSvg", function () { return $7ea141a3c9b46801$export$e973b7b7b0b44400; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $7ea141a3c9b46801$export$e973b7b7b0b44400 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M2.54 2.54a1 1 0 0 1 1.42 0L8 6.6l4.04-4.05a1 1 0 1 1 1.42 1.42L9.4 8l4.05 4.04a1 1 0 0 1-1.42 1.42L8 9.4l-4.04 4.05a1 1 0 0 1-1.42-1.42L6.6 8 2.54 3.96a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("9QIxO", function(module, exports) {

$parcel$export(module.exports, "coinPlaceholderSvg", function () { return $72bb85f2c7e8a799$export$c48cbfcb1f749517; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $72bb85f2c7e8a799$export$c48cbfcb1f749517 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 3a7 7 0 0 0-6.85 8.44l8.29-8.3C10.97 3.06 10.49 3 10 3Zm3.49.93-9.56 9.56c.32.55.71 1.06 1.16 1.5L15 5.1a7.03 7.03 0 0 0-1.5-1.16Zm2.7 2.8-9.46 9.46a7 7 0 0 0 9.46-9.46ZM1.99 5.9A9 9 0 1 1 18 14.09 9 9 0 0 1 1.98 5.91Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("lhTq2", function(module, exports) {

$parcel$export(module.exports, "compassSvg", function () { return $f7f62c958a0e79cc$export$9fe5dd11ac55c8d4; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $f7f62c958a0e79cc$export$9fe5dd11ac55c8d4 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm10.66-2.65a1 1 0 0 1 .23 1.06L9.83 9.24a1 1 0 0 1-.59.58l-2.83 1.06A1 1 0 0 1 5.13 9.6l1.06-2.82a1 1 0 0 1 .58-.59L9.6 5.12a1 1 0 0 1 1.06.23ZM7.9 7.89l-.13.35.35-.13.12-.35-.34.13Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("7IJoZ", function(module, exports) {

$parcel$export(module.exports, "copySvg", function () { return $59efdc6292e567cc$export$ec40c5c35ef5dd82; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $59efdc6292e567cc$export$ec40c5c35ef5dd82 = (0, $7pRM7.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.21498 1.28565H10.5944C11.1458 1.28562 11.6246 1.2856 12.0182 1.32093C12.4353 1.35836 12.853 1.44155 13.2486 1.66724C13.7005 1.92498 14.0749 2.29935 14.3326 2.75122C14.5583 3.14689 14.6415 3.56456 14.6789 3.9817C14.7143 4.37531 14.7142 4.85403 14.7142 5.40545V6.78489C14.7142 7.33631 14.7143 7.81503 14.6789 8.20865C14.6415 8.62578 14.5583 9.04345 14.3326 9.43912C14.0749 9.89099 13.7005 10.2654 13.2486 10.5231C12.853 10.7488 12.4353 10.832 12.0182 10.8694C11.7003 10.8979 11.3269 10.9034 10.9045 10.9045C10.9034 11.3269 10.8979 11.7003 10.8694 12.0182C10.832 12.4353 10.7488 12.853 10.5231 13.2486C10.2654 13.7005 9.89099 14.0749 9.43912 14.3326C9.04345 14.5583 8.62578 14.6415 8.20865 14.6789C7.81503 14.7143 7.33631 14.7142 6.78489 14.7142H5.40545C4.85403 14.7142 4.37531 14.7143 3.9817 14.6789C3.56456 14.6415 3.14689 14.5583 2.75122 14.3326C2.29935 14.0749 1.92498 13.7005 1.66724 13.2486C1.44155 12.853 1.35836 12.4353 1.32093 12.0182C1.2856 11.6246 1.28562 11.1458 1.28565 10.5944V9.21498C1.28562 8.66356 1.2856 8.18484 1.32093 7.79122C1.35836 7.37409 1.44155 6.95642 1.66724 6.56074C1.92498 6.10887 2.29935 5.73451 2.75122 5.47677C3.14689 5.25108 3.56456 5.16789 3.9817 5.13045C4.2996 5.10192 4.67301 5.09645 5.09541 5.09541C5.09645 4.67302 5.10192 4.2996 5.13045 3.9817C5.16789 3.56456 5.25108 3.14689 5.47676 2.75122C5.73451 2.29935 6.10887 1.92498 6.56074 1.66724C6.95642 1.44155 7.37409 1.35836 7.79122 1.32093C8.18484 1.2856 8.66356 1.28562 9.21498 1.28565ZM5.09541 7.09552C4.68397 7.09667 4.39263 7.10161 4.16046 7.12245C3.88053 7.14757 3.78516 7.18949 3.74214 7.21403C3.60139 7.29431 3.48478 7.41091 3.4045 7.55166C3.37997 7.59468 3.33804 7.69005 3.31292 7.96999C3.28659 8.26345 3.28565 8.65147 3.28565 9.25708V10.5523C3.28565 11.1579 3.28659 11.5459 3.31292 11.8394C3.33804 12.1193 3.37997 12.2147 3.4045 12.2577C3.48478 12.3985 3.60139 12.5151 3.74214 12.5954C3.78516 12.6199 3.88053 12.6618 4.16046 12.6869C4.45393 12.7133 4.84195 12.7142 5.44755 12.7142H6.74279C7.3484 12.7142 7.73641 12.7133 8.02988 12.6869C8.30981 12.6618 8.40518 12.6199 8.44821 12.5954C8.58895 12.5151 8.70556 12.3985 8.78584 12.2577C8.81038 12.2147 8.8523 12.1193 8.87742 11.8394C8.89825 11.6072 8.90319 11.3159 8.90435 10.9045C8.48219 10.9034 8.10898 10.8979 7.79122 10.8694C7.37409 10.832 6.95641 10.7488 6.56074 10.5231C6.10887 10.2654 5.73451 9.89099 5.47676 9.43912C5.25108 9.04345 5.16789 8.62578 5.13045 8.20865C5.10194 7.89089 5.09645 7.51767 5.09541 7.09552ZM7.96999 3.31292C7.69005 3.33804 7.59468 3.37997 7.55166 3.4045C7.41091 3.48478 7.29431 3.60139 7.21403 3.74214C7.18949 3.78516 7.14757 3.88053 7.12245 4.16046C7.09611 4.45393 7.09517 4.84195 7.09517 5.44755V6.74279C7.09517 7.3484 7.09611 7.73641 7.12245 8.02988C7.14757 8.30981 7.18949 8.40518 7.21403 8.4482C7.29431 8.58895 7.41091 8.70556 7.55166 8.78584C7.59468 8.81038 7.69005 8.8523 7.96999 8.87742C8.26345 8.90376 8.65147 8.9047 9.25708 8.9047H10.5523C11.1579 8.9047 11.5459 8.90376 11.8394 8.87742C12.1193 8.8523 12.2147 8.81038 12.2577 8.78584C12.3985 8.70556 12.5151 8.58895 12.5954 8.4482C12.6199 8.40518 12.6618 8.30981 12.6869 8.02988C12.7133 7.73641 12.7142 7.3484 12.7142 6.74279V5.44755C12.7142 4.84195 12.7133 4.45393 12.6869 4.16046C12.6618 3.88053 12.6199 3.78516 12.5954 3.74214C12.5151 3.60139 12.3985 3.48478 12.2577 3.4045C12.2147 3.37997 12.1193 3.33804 11.8394 3.31292C11.5459 3.28659 11.1579 3.28565 10.5523 3.28565H9.25708C8.65147 3.28565 8.26345 3.28659 7.96999 3.31292Z"
    fill="#788181"
  /></svg
>`;

});

parcelRegister("6AJ1Q", function(module, exports) {

$parcel$export(module.exports, "cursorSvg", function () { return $4cc908a2545dde7f$export$615c57907ad3661f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $4cc908a2545dde7f$export$615c57907ad3661f = (0, $7pRM7.svg)` <svg fill="none" viewBox="0 0 13 4">
  <path fill="currentColor" d="M.5 0h12L8.9 3.13a3.76 3.76 0 0 1-4.8 0L.5 0Z" />
</svg>`;

});

parcelRegister("8IhNH", function(module, exports) {

$parcel$export(module.exports, "cursorTransparentSvg", function () { return $65803da16f3fe08b$export$e4fd65630ad5bf5b; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $65803da16f3fe08b$export$e4fd65630ad5bf5b = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 6">
  <path style="fill: var(--wui-color-bg-150);" d="M0 1h14L9.21 5.12a3.31 3.31 0 0 1-4.49 0L0 1Z" />
  <path
    style="stroke: var(--wui-color-inverse-100);"
    stroke-opacity=".05"
    d="M1.33 1.5h11.32L8.88 4.75l-.01.01a2.81 2.81 0 0 1-3.8 0l-.02-.01L1.33 1.5Z"
  />
  <path
    style="fill: var(--wui-color-bg-150);"
    d="M1.25.71h11.5L9.21 3.88a3.31 3.31 0 0 1-4.49 0L1.25.71Z"
  />
</svg> `;

});

parcelRegister("bwGO2", function(module, exports) {

$parcel$export(module.exports, "desktopSvg", function () { return $8643e34687eafcf2$export$7a2123fcf97e10d1; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $8643e34687eafcf2$export$7a2123fcf97e10d1 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13.66 2H6.34c-1.07 0-1.96 0-2.68.08-.74.08-1.42.25-2.01.68a4 4 0 0 0-.89.89c-.43.6-.6 1.27-.68 2.01C0 6.38 0 7.26 0 8.34v.89c0 1.07 0 1.96.08 2.68.08.74.25 1.42.68 2.01a4 4 0 0 0 .89.89c.6.43 1.27.6 2.01.68a27 27 0 0 0 2.68.08h7.32a27 27 0 0 0 2.68-.08 4.03 4.03 0 0 0 2.01-.68 4 4 0 0 0 .89-.89c.43-.6.6-1.27.68-2.01.08-.72.08-1.6.08-2.68v-.89c0-1.07 0-1.96-.08-2.68a4.04 4.04 0 0 0-.68-2.01 4 4 0 0 0-.89-.89c-.6-.43-1.27-.6-2.01-.68C15.62 2 14.74 2 13.66 2ZM2.82 4.38c.2-.14.48-.25 1.06-.31C4.48 4 5.25 4 6.4 4h7.2c1.15 0 1.93 0 2.52.07.58.06.86.17 1.06.31a2 2 0 0 1 .44.44c.14.2.25.48.31 1.06.07.6.07 1.37.07 2.52v.77c0 1.15 0 1.93-.07 2.52-.06.58-.17.86-.31 1.06a2 2 0 0 1-.44.44c-.2.14-.48.25-1.06.32-.6.06-1.37.06-2.52.06H6.4c-1.15 0-1.93 0-2.52-.06-.58-.07-.86-.18-1.06-.32a2 2 0 0 1-.44-.44c-.14-.2-.25-.48-.31-1.06C2 11.1 2 10.32 2 9.17V8.4c0-1.15 0-1.93.07-2.52.06-.58.17-.86.31-1.06a2 2 0 0 1 .44-.44Z"
    clip-rule="evenodd"
  />
  <path fill="currentColor" d="M6.14 17.57a1 1 0 1 0 0 2h7.72a1 1 0 1 0 0-2H6.14Z" />
</svg>`;

});

parcelRegister("1ymc5", function(module, exports) {

$parcel$export(module.exports, "disconnectSvg", function () { return $121a2eaf01eb016d$export$50fbdab79b8f082d; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $121a2eaf01eb016d$export$50fbdab79b8f082d = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.07 1h.57a1 1 0 0 1 0 2h-.52c-.98 0-1.64 0-2.14.06-.48.05-.7.14-.84.24-.13.1-.25.22-.34.35-.1.14-.2.35-.25.83-.05.5-.05 1.16-.05 2.15v2.74c0 .99 0 1.65.05 2.15.05.48.14.7.25.83.1.14.2.25.34.35.14.1.36.2.84.25.5.05 1.16.05 2.14.05h.52a1 1 0 0 1 0 2h-.57c-.92 0-1.69 0-2.3-.07a3.6 3.6 0 0 1-1.8-.61c-.3-.22-.57-.49-.8-.8a3.6 3.6 0 0 1-.6-1.79C.5 11.11.5 10.35.5 9.43V6.58c0-.92 0-1.7.06-2.31a3.6 3.6 0 0 1 .62-1.8c.22-.3.48-.57.79-.79a3.6 3.6 0 0 1 1.8-.61C4.37 1 5.14 1 6.06 1ZM9.5 3a1 1 0 0 1 1.42 0l4.28 4.3a1 1 0 0 1 0 1.4L10.93 13a1 1 0 0 1-1.42-1.42L12.1 9H6.8a1 1 0 1 1 0-2h5.3L9.51 4.42a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("cVide", function(module, exports) {

$parcel$export(module.exports, "discordSvg", function () { return $9688ef822d7bf101$export$29470bd7472aef51; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $9688ef822d7bf101$export$29470bd7472aef51 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("eMo3z", function(module, exports) {

$parcel$export(module.exports, "etherscanSvg", function () { return $ac283580d100352b$export$fad2d5a54496223b; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $ac283580d100352b$export$fad2d5a54496223b = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M4.25 7a.63.63 0 0 0-.63.63v3.97c0 .28-.2.51-.47.54l-.75.07a.93.93 0 0 1-.9-.47A7.51 7.51 0 0 1 5.54.92a7.5 7.5 0 0 1 9.54 4.62c.12.35.06.72-.16 1-.74.97-1.68 1.78-2.6 2.44V4.44a.64.64 0 0 0-.63-.64h-1.06c-.35 0-.63.3-.63.64v5.5c0 .23-.12.42-.32.5l-.52.23V6.05c0-.36-.3-.64-.64-.64H7.45c-.35 0-.64.3-.64.64v4.97c0 .25-.17.46-.4.52a5.8 5.8 0 0 0-.45.11v-4c0-.36-.3-.65-.64-.65H4.25ZM14.07 12.4A7.49 7.49 0 0 1 3.6 14.08c4.09-.58 9.14-2.5 11.87-6.6v.03a7.56 7.56 0 0 1-1.41 4.91Z"
  />
</svg>`;

});

parcelRegister("1KlqE", function(module, exports) {

$parcel$export(module.exports, "extensionSvg", function () { return $145ab5a1e53a5ce8$export$df81a22cbcc6237a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $145ab5a1e53a5ce8$export$df81a22cbcc6237a = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.71 2.99a.57.57 0 0 0-.57.57 1 1 0 0 1-1 1c-.58 0-.96 0-1.24.03-.27.03-.37.07-.42.1a.97.97 0 0 0-.36.35c-.04.08-.09.21-.11.67a2.57 2.57 0 0 1 0 5.13c.02.45.07.6.11.66.09.15.21.28.36.36.07.04.21.1.67.12a2.57 2.57 0 0 1 5.12 0c.46-.03.6-.08.67-.12a.97.97 0 0 0 .36-.36c.03-.04.07-.14.1-.41.02-.29.03-.66.03-1.24a1 1 0 0 1 1-1 .57.57 0 0 0 0-1.15 1 1 0 0 1-1-1c0-.58 0-.95-.03-1.24a1.04 1.04 0 0 0-.1-.42.97.97 0 0 0-.36-.36 1.04 1.04 0 0 0-.42-.1c-.28-.02-.65-.02-1.24-.02a1 1 0 0 1-1-1 .57.57 0 0 0-.57-.57ZM5.15 13.98a1 1 0 0 0 .99-1v-.78a.57.57 0 0 1 1.14 0v.78a1 1 0 0 0 .99 1H8.36a66.26 66.26 0 0 0 .73 0 3.78 3.78 0 0 0 1.84-.38c.46-.26.85-.64 1.1-1.1.23-.4.32-.8.36-1.22.02-.2.03-.4.03-.63a2.57 2.57 0 0 0 0-4.75c0-.23-.01-.44-.03-.63a2.96 2.96 0 0 0-.35-1.22 2.97 2.97 0 0 0-1.1-1.1c-.4-.22-.8-.31-1.22-.35a8.7 8.7 0 0 0-.64-.04 2.57 2.57 0 0 0-4.74 0c-.23 0-.44.02-.63.04-.42.04-.83.13-1.22.35-.46.26-.84.64-1.1 1.1-.33.57-.37 1.2-.39 1.84a21.39 21.39 0 0 0 0 .72v.1a1 1 0 0 0 1 .99h.78a.57.57 0 0 1 0 1.15h-.77a1 1 0 0 0-1 .98v.1a63.87 63.87 0 0 0 0 .73c0 .64.05 1.27.38 1.83.26.47.64.85 1.1 1.11.56.32 1.2.37 1.84.38a20.93 20.93 0 0 0 .72 0h.1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("bVjEn", function(module, exports) {

$parcel$export(module.exports, "externalLinkSvg", function () { return $8ae442b870748222$export$34a422f948687038; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $8ae442b870748222$export$34a422f948687038 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.74 3.99a1 1 0 0 1 1-1H11a1 1 0 0 1 1 1v6.26a1 1 0 0 1-2 0V6.4l-6.3 6.3a1 1 0 0 1-1.4-1.42l6.29-6.3H4.74a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("e6NME", function(module, exports) {

$parcel$export(module.exports, "facebookSvg", function () { return $a4583e3a62822c6e$export$1ff5018c782ba6f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $a4583e3a62822c6e$export$1ff5018c782ba6f = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1877F2" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M26 12.38h-2.89c-.92 0-1.61.38-1.61 1.34v1.66H26l-.36 4.5H21.5v12H17v-12h-3v-4.5h3V12.5c0-3.03 1.6-4.62 5.2-4.62H26v4.5Z"
        />
      </g>
    </g>
    <path
      fill="#1877F2"
      d="M40 20a20 20 0 1 0-23.13 19.76V25.78H11.8V20h5.07v-4.4c0-5.02 3-7.79 7.56-7.79 2.19 0 4.48.4 4.48.4v4.91h-2.53c-2.48 0-3.25 1.55-3.25 3.13V20h5.54l-.88 5.78h-4.66v13.98A20 20 0 0 0 40 20Z"
    />
    <path
      fill="#fff"
      d="m27.79 25.78.88-5.78h-5.55v-3.75c0-1.58.78-3.13 3.26-3.13h2.53V8.2s-2.3-.39-4.48-.39c-4.57 0-7.55 2.77-7.55 7.78V20H11.8v5.78h5.07v13.98a20.15 20.15 0 0 0 6.25 0V25.78h4.67Z"
    />
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("7PVNR", function(module, exports) {

$parcel$export(module.exports, "farcasterSvg", function () { return $5b4a2253e59f369b$export$7b0045cfe57afd2f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $5b4a2253e59f369b$export$7b0045cfe57afd2f = (0, $7pRM7.svg)`<svg style="border-radius: 9999px; overflow: hidden;"  fill="none" viewBox="0 0 1000 1000">
  <rect width="1000" height="1000" rx="9999" ry="9999" fill="#855DCD"/>
  <path fill="#855DCD" d="M0 0h1000v1000H0V0Z" />
  <path
    fill="#fff"
    d="M320 248h354v504h-51.96V521.13h-.5c-5.76-63.8-59.31-113.81-124.54-113.81s-118.78 50-124.53 113.81h-.5V752H320V248Z"
  />
  <path
    fill="#fff"
    d="m225 320 21.16 71.46h17.9v289.09a16.29 16.29 0 0 0-16.28 16.24v19.49h-3.25a16.3 16.3 0 0 0-16.28 16.24V752h182.26v-19.48a16.22 16.22 0 0 0-16.28-16.24h-3.25v-19.5a16.22 16.22 0 0 0-16.28-16.23h-19.52V320H225Zm400.3 360.55a16.3 16.3 0 0 0-15.04 10.02 16.2 16.2 0 0 0-1.24 6.22v19.49h-3.25a16.29 16.29 0 0 0-16.27 16.24V752h182.24v-19.48a16.23 16.23 0 0 0-16.27-16.24h-3.25v-19.5a16.2 16.2 0 0 0-10.04-15 16.3 16.3 0 0 0-6.23-1.23v-289.1h17.9L775 320H644.82v360.55H625.3Z"
  />
</svg>`;

});

parcelRegister("bUfr2", function(module, exports) {

$parcel$export(module.exports, "filtersSvg", function () { return $8ab0e5c2629c7538$export$9261929cf6dcbff0; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $8ab0e5c2629c7538$export$9261929cf6dcbff0 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm2.63 5.25a1 1 0 0 1 1-1h8.75a1 1 0 1 1 0 2H3.63a1 1 0 0 1-1-1Zm2.62 5.25a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-3.5a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("eRxS8", function(module, exports) {

$parcel$export(module.exports, "githubSvg", function () { return $ad204a3a334ca4b8$export$f094865edb198013; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $ad204a3a334ca4b8$export$f094865edb198013 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1B1F23" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M8 19.89a12 12 0 1 1 15.8 11.38c-.6.12-.8-.26-.8-.57v-3.3c0-1.12-.4-1.85-.82-2.22 2.67-.3 5.48-1.31 5.48-5.92 0-1.31-.47-2.38-1.24-3.22.13-.3.54-1.52-.12-3.18 0 0-1-.32-3.3 1.23a11.54 11.54 0 0 0-6 0c-2.3-1.55-3.3-1.23-3.3-1.23a4.32 4.32 0 0 0-.12 3.18 4.64 4.64 0 0 0-1.24 3.22c0 4.6 2.8 5.63 5.47 5.93-.34.3-.65.83-.76 1.6-.69.31-2.42.84-3.5-1 0 0-.63-1.15-1.83-1.23 0 0-1.18-.02-.09.73 0 0 .8.37 1.34 1.76 0 0 .7 2.14 4.03 1.41v2.24c0 .31-.2.68-.8.57A12 12 0 0 1 8 19.9Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("2F27M", function(module, exports) {

$parcel$export(module.exports, "googleSvg", function () { return $1f010f015b40ad41$export$62a66155552ed9b0; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $1f010f015b40ad41$export$62a66155552ed9b0 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 40 40">
  <path
    fill="#4285F4"
    d="M32.74 20.3c0-.93-.08-1.81-.24-2.66H20.26v5.03h7a6 6 0 0 1-2.62 3.91v3.28h4.22c2.46-2.27 3.88-5.6 3.88-9.56Z"
  />
  <path
    fill="#34A853"
    d="M20.26 33a12.4 12.4 0 0 0 8.6-3.14l-4.22-3.28a7.74 7.74 0 0 1-4.38 1.26 7.76 7.76 0 0 1-7.28-5.36H8.65v3.36A12.99 12.99 0 0 0 20.26 33Z"
  />
  <path
    fill="#FBBC05"
    d="M12.98 22.47a7.79 7.79 0 0 1 0-4.94v-3.36H8.65a12.84 12.84 0 0 0 0 11.66l3.37-2.63.96-.73Z"
  />
  <path
    fill="#EA4335"
    d="M20.26 12.18a7.1 7.1 0 0 1 4.98 1.93l3.72-3.72A12.47 12.47 0 0 0 20.26 7c-5.08 0-9.47 2.92-11.6 7.17l4.32 3.36a7.76 7.76 0 0 1 7.28-5.35Z"
  />
</svg>`;

});

parcelRegister("10x2F", function(module, exports) {

$parcel$export(module.exports, "helpCircleSvg", function () { return $0bbf6bff99c642b5$export$cbf7b9dd25929c90; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $0bbf6bff99c642b5$export$cbf7b9dd25929c90 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M8.51 5.66a.83.83 0 0 0-.57-.2.83.83 0 0 0-.52.28.8.8 0 0 0-.25.52 1 1 0 0 1-2 0c0-.75.34-1.43.81-1.91a2.75 2.75 0 0 1 4.78 1.92c0 1.24-.8 1.86-1.25 2.2l-.04.03c-.47.36-.5.43-.5.65a1 1 0 1 1-2 0c0-1.25.8-1.86 1.24-2.2l.04-.04c.47-.36.5-.43.5-.65 0-.3-.1-.49-.24-.6ZM9.12 11.87a1.13 1.13 0 1 1-2.25 0 1.13 1.13 0 0 1 2.25 0Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("3aPzP", function(module, exports) {

$parcel$export(module.exports, "imageSvg", function () { return $24fa5060cd6e94bb$export$cb3fb71461a06425; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $24fa5060cd6e94bb$export$cb3fb71461a06425 = (0, $7pRM7.svg)`<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M4.98926 3.73932C4.2989 3.73932 3.73926 4.29896 3.73926 4.98932C3.73926 5.67968 4.2989 6.23932 4.98926 6.23932C5.67962 6.23932 6.23926 5.67968 6.23926 4.98932C6.23926 4.29896 5.67962 3.73932 4.98926 3.73932Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.60497 0.500001H6.39504C5.41068 0.499977 4.59185 0.499958 3.93178 0.571471C3.24075 0.64634 2.60613 0.809093 2.04581 1.21619C1.72745 1.44749 1.44749 1.72745 1.21619 2.04581C0.809093 2.60613 0.64634 3.24075 0.571471 3.93178C0.499958 4.59185 0.499977 5.41065 0.500001 6.39501V7.57815C0.499998 8.37476 0.499995 9.05726 0.534869 9.62725C0.570123 10.2034 0.644114 10.7419 0.828442 11.2302C0.925651 11.4877 1.05235 11.7287 1.21619 11.9542C1.44749 12.2726 1.72745 12.5525 2.04581 12.7838C2.60613 13.1909 3.24075 13.3537 3.93178 13.4285C4.59185 13.5001 5.41066 13.5 6.39503 13.5H7.60496C8.58933 13.5 9.40815 13.5001 10.0682 13.4285C10.7593 13.3537 11.3939 13.1909 11.9542 12.7838C12.2726 12.5525 12.5525 12.2726 12.7838 11.9542C13.1909 11.3939 13.3537 10.7593 13.4285 10.0682C13.5 9.40816 13.5 8.58935 13.5 7.60497V6.39505C13.5 5.41068 13.5 4.59185 13.4285 3.93178C13.3537 3.24075 13.1909 2.60613 12.7838 2.04581C12.5525 1.72745 12.2726 1.44749 11.9542 1.21619C11.3939 0.809093 10.7593 0.64634 10.0682 0.571471C9.40816 0.499958 8.58933 0.499977 7.60497 0.500001ZM3.22138 2.83422C3.38394 2.71612 3.62634 2.61627 4.14721 2.55984C4.68679 2.50138 5.39655 2.5 6.45 2.5H7.55C8.60345 2.5 9.31322 2.50138 9.8528 2.55984C10.3737 2.61627 10.6161 2.71612 10.7786 2.83422C10.9272 2.94216 11.0578 3.07281 11.1658 3.22138C11.2839 3.38394 11.3837 3.62634 11.4402 4.14721C11.4986 4.68679 11.5 5.39655 11.5 6.45V6.49703C10.9674 6.11617 10.386 5.84936 9.74213 5.81948C8.40536 5.75745 7.3556 6.73051 6.40509 7.84229C6.33236 7.92737 6.27406 7.98735 6.22971 8.02911L6.1919 8.00514L6.17483 7.99427C6.09523 7.94353 5.98115 7.87083 5.85596 7.80302C5.56887 7.64752 5.18012 7.4921 4.68105 7.4921C4.66697 7.4921 4.6529 7.49239 4.63884 7.49299C3.79163 7.52878 3.09922 8.1106 2.62901 8.55472C2.58751 8.59392 2.54594 8.6339 2.50435 8.6745C2.50011 8.34653 2.5 7.97569 2.5 7.55V6.45C2.5 5.39655 2.50138 4.68679 2.55984 4.14721C2.61627 3.62634 2.71612 3.38394 2.83422 3.22138C2.94216 3.07281 3.07281 2.94216 3.22138 2.83422ZM10.3703 8.14825C10.6798 8.37526 11.043 8.71839 11.4832 9.20889C11.4744 9.44992 11.4608 9.662 11.4402 9.8528C11.3837 10.3737 11.2839 10.6161 11.1658 10.7786C11.0578 10.9272 10.9272 11.0578 10.7786 11.1658C10.6161 11.2839 10.3737 11.3837 9.8528 11.4402C9.31322 11.4986 8.60345 11.5 7.55 11.5H6.45C5.39655 11.5 4.68679 11.4986 4.14721 11.4402C3.62634 11.3837 3.38394 11.2839 3.22138 11.1658C3.15484 11.1174 3.0919 11.0645 3.03298 11.0075C3.10126 10.9356 3.16806 10.8649 3.23317 10.7959L3.29772 10.7276C3.55763 10.4525 3.78639 10.2126 4.00232 10.0087C4.22016 9.80294 4.39412 9.66364 4.53524 9.57742C4.63352 9.51738 4.69022 9.49897 4.71275 9.49345C4.76387 9.49804 4.81803 9.51537 4.90343 9.56162C4.96409 9.59447 5.02355 9.63225 5.11802 9.69238L5.12363 9.69595C5.20522 9.74789 5.32771 9.82587 5.46078 9.89278C5.76529 10.0459 6.21427 10.186 6.74977 10.0158C7.21485 9.86796 7.59367 9.52979 7.92525 9.14195C8.91377 7.98571 9.38267 7.80495 9.64941 7.81733C9.7858 7.82366 10.0101 7.884 10.3703 8.14825Z" fill="currentColor"/>
</svg>`;

});

parcelRegister("jiiiN", function(module, exports) {

$parcel$export(module.exports, "infoCircleSvg", function () { return $e0bde5308bac62a5$export$313082e449e2d152; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $e0bde5308bac62a5$export$313082e449e2d152 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    d="M6 10.49a1 1 0 1 0 2 0v-2a1 1 0 0 0-2 0v2ZM7 4.49a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 14.99a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("96Rj9", function(module, exports) {

$parcel$export(module.exports, "mailSvg", function () { return $6a1e0672231d736b$export$a9b1939cca165cd6; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $6a1e0672231d736b$export$a9b1939cca165cd6 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.83 1.34h6.34c.68 0 1.26 0 1.73.04.5.05.97.15 1.42.4.52.3.95.72 1.24 1.24.26.45.35.92.4 1.42.04.47.04 1.05.04 1.73v3.71c0 .69 0 1.26-.04 1.74-.05.5-.14.97-.4 1.41-.3.52-.72.95-1.24 1.25-.45.25-.92.35-1.42.4-.47.03-1.05.03-1.73.03H4.83c-.68 0-1.26 0-1.73-.04-.5-.04-.97-.14-1.42-.4-.52-.29-.95-.72-1.24-1.24a3.39 3.39 0 0 1-.4-1.41A20.9 20.9 0 0 1 0 9.88v-3.7c0-.7 0-1.27.04-1.74.05-.5.14-.97.4-1.42.3-.52.72-.95 1.24-1.24.45-.25.92-.35 1.42-.4.47-.04 1.05-.04 1.73-.04ZM3.28 3.38c-.36.03-.51.08-.6.14-.21.11-.39.29-.5.5a.8.8 0 0 0-.08.19l5.16 3.44c.45.3 1.03.3 1.48 0L13.9 4.2a.79.79 0 0 0-.08-.2c-.11-.2-.29-.38-.5-.5-.09-.05-.24-.1-.6-.13-.37-.04-.86-.04-1.6-.04H4.88c-.73 0-1.22 0-1.6.04ZM14 6.54 9.85 9.31a3.33 3.33 0 0 1-3.7 0L2 6.54v3.3c0 .74 0 1.22.03 1.6.04.36.1.5.15.6.11.2.29.38.5.5.09.05.24.1.6.14.37.03.86.03 1.6.03h6.25c.73 0 1.22 0 1.6-.03.35-.03.5-.09.6-.14.2-.12.38-.3.5-.5.05-.1.1-.24.14-.6.03-.38.03-.86.03-1.6v-3.3Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("4dF0m", function(module, exports) {

$parcel$export(module.exports, "mobileSvg", function () { return $31282f088797764a$export$b6a7821857ebc7d7; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $31282f088797764a$export$b6a7821857ebc7d7 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path fill="currentColor" d="M10.81 5.81a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3 4.75A4.75 4.75 0 0 1 7.75 0h4.5A4.75 4.75 0 0 1 17 4.75v10.5A4.75 4.75 0 0 1 12.25 20h-4.5A4.75 4.75 0 0 1 3 15.25V4.75ZM7.75 2A2.75 2.75 0 0 0 5 4.75v10.5A2.75 2.75 0 0 0 7.75 18h4.5A2.75 2.75 0 0 0 15 15.25V4.75A2.75 2.75 0 0 0 12.25 2h-4.5Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hhgrC", function(module, exports) {

$parcel$export(module.exports, "moreSvg", function () { return $c940c7bc508482c5$export$976edb54c21a0ac1; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $c940c7bc508482c5$export$976edb54c21a0ac1 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 41 40">
  <path
    style="fill: var(--wui-color-fg-100);"
    fill-opacity=".05"
    d="M.6 20a20 20 0 1 1 40 0 20 20 0 0 1-40 0Z"
  />
  <path
    fill="#949E9E"
    d="M15.6 20.31a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM23.1 20.31a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM28.1 22.81a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  />
</svg>`;

});

parcelRegister("iqK4w", function(module, exports) {

$parcel$export(module.exports, "networkPlaceholderSvg", function () { return $d6ae64a7996554f8$export$8eef6146d36b9527; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $d6ae64a7996554f8$export$8eef6146d36b9527 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 22 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M16.32 13.62a3.14 3.14 0 1 1-.99 1.72l-1.6-.93a3.83 3.83 0 0 1-3.71 1 3.66 3.66 0 0 1-1.74-1l-1.6.94a3.14 3.14 0 1 1-1-1.73l1.6-.94a3.7 3.7 0 0 1 0-2 3.81 3.81 0 0 1 1.8-2.33c.29-.17.6-.3.92-.38V6.1a3.14 3.14 0 1 1 2 0l-.01.02v1.85H12a3.82 3.82 0 0 1 2.33 1.8 3.7 3.7 0 0 1 .39 2.91l1.6.93ZM2.6 16.54a1.14 1.14 0 0 0 1.98-1.14 1.14 1.14 0 0 0-1.98 1.14ZM11 2.01a1.14 1.14 0 1 0 0 2.28 1.14 1.14 0 0 0 0-2.28Zm1.68 10.45c.08-.19.14-.38.16-.58v-.05l.02-.13v-.13a1.92 1.92 0 0 0-.24-.8l-.11-.15a1.89 1.89 0 0 0-.74-.6 1.86 1.86 0 0 0-.77-.17h-.19a1.97 1.97 0 0 0-.89.34 1.98 1.98 0 0 0-.61.74 1.99 1.99 0 0 0-.16.9v.05a1.87 1.87 0 0 0 .24.74l.1.15c.12.16.26.3.42.42l.16.1.13.07.04.02a1.84 1.84 0 0 0 .76.17h.17a2 2 0 0 0 .91-.35 1.78 1.78 0 0 0 .52-.58l.03-.05a.84.84 0 0 0 .05-.11Zm5.15 4.5a1.14 1.14 0 0 0 1.14-1.97 1.13 1.13 0 0 0-1.55.41c-.32.55-.13 1.25.41 1.56Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.63 9.43a1.5 1.5 0 1 0 1.5-2.6 1.5 1.5 0 0 0-1.5 2.6Zm.32-1.55a.5.5 0 0 1 .68-.19.5.5 0 0 1 .18.68.5.5 0 0 1-.68.19.5.5 0 0 1-.18-.68ZM17.94 8.88a1.5 1.5 0 1 1-2.6-1.5 1.5 1.5 0 1 1 2.6 1.5ZM16.9 7.69a.5.5 0 0 0-.68.19.5.5 0 0 0 .18.68.5.5 0 0 0 .68-.19.5.5 0 0 0-.18-.68ZM9.75 17.75a1.5 1.5 0 1 1 2.6 1.5 1.5 1.5 0 1 1-2.6-1.5Zm1.05 1.18a.5.5 0 0 0 .68-.18.5.5 0 0 0-.18-.68.5.5 0 0 0-.68.18.5.5 0 0 0 .18.68Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("lfrnA", function(module, exports) {

$parcel$export(module.exports, "nftPlaceholderSvg", function () { return $f7803cad092b4ac1$export$cacef02b4679549a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $f7803cad092b4ac1$export$cacef02b4679549a = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.13 1h1.71c1.46 0 2.63 0 3.56.1.97.1 1.8.33 2.53.85a5 5 0 0 1 1.1 1.11c.53.73.75 1.56.86 2.53.1.93.1 2.1.1 3.55v1.72c0 1.45 0 2.62-.1 3.55-.1.97-.33 1.8-.86 2.53a5 5 0 0 1-1.1 1.1c-.73.53-1.56.75-2.53.86-.93.1-2.1.1-3.55.1H9.13c-1.45 0-2.62 0-3.56-.1-.96-.1-1.8-.33-2.52-.85a5 5 0 0 1-1.1-1.11 5.05 5.05 0 0 1-.86-2.53c-.1-.93-.1-2.1-.1-3.55V9.14c0-1.45 0-2.62.1-3.55.1-.97.33-1.8.85-2.53a5 5 0 0 1 1.1-1.1 5.05 5.05 0 0 1 2.53-.86C6.51 1 7.67 1 9.13 1ZM5.79 3.09a3.1 3.1 0 0 0-1.57.48 3 3 0 0 0-.66.67c-.24.32-.4.77-.48 1.56-.1.82-.1 1.88-.1 3.4v1.6c0 1.15 0 2.04.05 2.76l.41-.42c.5-.5.93-.92 1.32-1.24.41-.33.86-.6 1.43-.7a3 3 0 0 1 .94 0c.35.06.66.2.95.37a17.11 17.11 0 0 0 .8.45c.1-.08.2-.2.41-.4l.04-.03a27 27 0 0 1 1.95-1.84 4.03 4.03 0 0 1 1.91-.94 4 4 0 0 1 1.25 0c.73.11 1.33.46 1.91.94l.64.55V9.2c0-1.52 0-2.58-.1-3.4a3.1 3.1 0 0 0-.48-1.56 3 3 0 0 0-.66-.67 3.1 3.1 0 0 0-1.56-.48C13.37 3 12.3 3 10.79 3h-1.6c-1.52 0-2.59 0-3.4.09Zm11.18 10-.04-.05a26.24 26.24 0 0 0-1.83-1.74c-.45-.36-.73-.48-.97-.52a2 2 0 0 0-.63 0c-.24.04-.51.16-.97.52-.46.38-1.01.93-1.83 1.74l-.02.02c-.17.18-.34.34-.49.47a2.04 2.04 0 0 1-1.08.5 1.97 1.97 0 0 1-1.25-.27l-.79-.46-.02-.02a.65.65 0 0 0-.24-.1 1 1 0 0 0-.31 0c-.08.02-.21.06-.49.28-.3.24-.65.59-1.2 1.14l-.56.56-.65.66a3 3 0 0 0 .62.6c.33.24.77.4 1.57.49.81.09 1.88.09 3.4.09h1.6c1.52 0 2.58 0 3.4-.09a3.1 3.1 0 0 0 1.56-.48 3 3 0 0 0 .66-.67c.24-.32.4-.77.49-1.56l.07-1.12Zm-8.02-1.03ZM4.99 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("3IqGF", function(module, exports) {

$parcel$export(module.exports, "offSvg", function () { return $2b4a2eacca811b31$export$7ec09ee48c3bf315; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $2b4a2eacca811b31$export$7ec09ee48c3bf315 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 0a1 1 0 0 1 1 1v5.38a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1ZM5.26 2.6a1 1 0 0 1-.28 1.39 5.46 5.46 0 1 0 6.04 0 1 1 0 1 1 1.1-1.67 7.46 7.46 0 1 1-8.25 0 1 1 0 0 1 1.4.28Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("9YQAd", function(module, exports) {

$parcel$export(module.exports, "playStoreSvg", function () { return $01e00a5916cbcd36$export$65007b9f28ed0950; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $01e00a5916cbcd36$export$65007b9f28ed0950 = (0, $7pRM7.svg)` <svg
  width="36"
  height="36"
  fill="none"
>
  <path
    d="M0 8a8 8 0 0 1 8-8h20a8 8 0 0 1 8 8v20a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
    fill="#fff"
    fill-opacity=".05"
  />
  <path
    d="m18.262 17.513-8.944 9.49v.01a2.417 2.417 0 0 0 3.56 1.452l.026-.017 10.061-5.803-4.703-5.132Z"
    fill="#EA4335"
  />
  <path
    d="m27.307 15.9-.008-.008-4.342-2.52-4.896 4.36 4.913 4.912 4.325-2.494a2.42 2.42 0 0 0 .008-4.25Z"
    fill="#FBBC04"
  />
  <path
    d="M9.318 8.997c-.05.202-.084.403-.084.622V26.39c0 .218.025.42.084.621l9.246-9.247-9.246-8.768Z"
    fill="#4285F4"
  />
  <path
    d="m18.33 18 4.627-4.628-10.053-5.828a2.427 2.427 0 0 0-3.586 1.444L18.329 18Z"
    fill="#34A853"
  />
  <path
    d="M8 .5h20A7.5 7.5 0 0 1 35.5 8v20a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 28V8A7.5 7.5 0 0 1 8 .5Z"
    stroke="#fff"
    stroke-opacity=".05"
  />
</svg>`;

});

parcelRegister("cisP4", function(module, exports) {

$parcel$export(module.exports, "plusSvg", function () { return $8f3d8614f425a194$export$f392b38d2d3751; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $8f3d8614f425a194$export$f392b38d2d3751 = (0, $7pRM7.svg)`<svg
  width="13"
  height="12"
  viewBox="0 0 13 12"
  fill="none"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.794373 5.99982C0.794373 5.52643 1.17812 5.14268 1.6515 5.14268H5.643V1.15109C5.643 0.677701 6.02675 0.293946 6.50012 0.293945C6.9735 0.293946 7.35725 0.677701 7.35725 1.15109V5.14268H11.3488C11.8221 5.14268 12.2059 5.52643 12.2059 5.99982C12.2059 6.47321 11.8221 6.85696 11.3488 6.85696H7.35725V10.8486C7.35725 11.3219 6.9735 11.7057 6.50012 11.7057C6.02675 11.7057 5.643 11.3219 5.643 10.8486V6.85696H1.6515C1.17812 6.85696 0.794373 6.47321 0.794373 5.99982Z"
  /></svg
>`;

});

parcelRegister("5o7ln", function(module, exports) {

$parcel$export(module.exports, "qrCodeIcon", function () { return $3ec4e3f5f7a177bd$export$b033e2eb4807deba; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $3ec4e3f5f7a177bd$export$b033e2eb4807deba = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M3 6a3 3 0 0 1 3-3h1a1 1 0 1 0 0-2H6a5 5 0 0 0-5 5v1a1 1 0 0 0 2 0V6ZM13 1a1 1 0 1 0 0 2h1a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0V6a5 5 0 0 0-5-5h-1ZM3 13a1 1 0 1 0-2 0v1a5 5 0 0 0 5 5h1a1 1 0 1 0 0-2H6a3 3 0 0 1-3-3v-1ZM19 13a1 1 0 1 0-2 0v1a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1.01a5 5 0 0 0 5-5v-1ZM5.3 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05A1.5 1.5 0 0 0 9.2 8.14c.06-.2.06-.43.06-.89s0-.7-.06-.89A1.5 1.5 0 0 0 8.14 5.3c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM10.8 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM5.26 12.75c0-.46 0-.7.05-.89a1.5 1.5 0 0 1 1.06-1.06c.19-.05.42-.05.89-.05.46 0 .7 0 .88.05.52.14.93.54 1.06 1.06.06.2.06.43.06.89s0 .7-.06.89a1.5 1.5 0 0 1-1.06 1.06c-.19.05-.42.05-.88.05-.47 0-.7 0-.9-.05a1.5 1.5 0 0 1-1.05-1.06c-.05-.2-.05-.43-.05-.89ZM10.8 11.86c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06Z"
  />
</svg>`;

});

parcelRegister("aPN0F", function(module, exports) {

$parcel$export(module.exports, "recycleHorizontalSvg", function () { return $7e34af19b4a9ae4d$export$abad67e618866d01; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $7e34af19b4a9ae4d$export$abad67e618866d01 = (0, $7pRM7.svg)`<svg
  fill="none"
  viewBox="0 0 21 20"
>
  <path
    fill="currentColor"
    d="M8.8071 0.292893C9.19763 0.683417 9.19763 1.31658 8.8071 1.70711L6.91421 3.6H11.8404C14.3368 3.6 16.5533 5.1975 17.3427 7.56588L17.4487 7.88377C17.6233 8.40772 17.3402 8.97404 16.8162 9.14868C16.2923 9.32333 15.726 9.04017 15.5513 8.51623L15.4453 8.19834C14.9281 6.64664 13.476 5.6 11.8404 5.6H6.91421L8.8071 7.49289C9.19763 7.88342 9.19763 8.51658 8.8071 8.90711C8.41658 9.29763 7.78341 9.29763 7.39289 8.90711L3.79289 5.30711C3.40236 4.91658 3.40236 4.28342 3.79289 3.89289L7.39289 0.292893C7.78341 -0.0976311 8.41658 -0.0976311 8.8071 0.292893ZM4.18377 10.8513C4.70771 10.6767 5.27403 10.9598 5.44868 11.4838L5.55464 11.8017C6.07188 13.3534 7.52401 14.4 9.15964 14.4L14.0858 14.4L12.1929 12.5071C11.8024 12.1166 11.8024 11.4834 12.1929 11.0929C12.5834 10.7024 13.2166 10.7024 13.6071 11.0929L17.2071 14.6929C17.5976 15.0834 17.5976 15.7166 17.2071 16.1071L13.6071 19.7071C13.2166 20.0976 12.5834 20.0976 12.1929 19.7071C11.8024 19.3166 11.8024 18.6834 12.1929 18.2929L14.0858 16.4L9.15964 16.4C6.66314 16.4 4.44674 14.8025 3.65728 12.4341L3.55131 12.1162C3.37667 11.5923 3.65983 11.026 4.18377 10.8513Z"
  /></svg
>`;

});

parcelRegister("eo9QN", function(module, exports) {

$parcel$export(module.exports, "refreshSvg", function () { return $a79af2b55ab7c275$export$bbe3b42eaaf82fae; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $a79af2b55ab7c275$export$bbe3b42eaaf82fae = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.94 1.04a1 1 0 0 1 .7 1.23l-.48 1.68a5.85 5.85 0 0 1 8.53 4.32 5.86 5.86 0 0 1-11.4 2.56 1 1 0 0 1 1.9-.57 3.86 3.86 0 1 0 1.83-4.5l1.87.53a1 1 0 0 1-.55 1.92l-4.1-1.15a1 1 0 0 1-.69-1.23l1.16-4.1a1 1 0 0 1 1.23-.7Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("2qHNn", function(module, exports) {

$parcel$export(module.exports, "searchSvg", function () { return $1c4ffb4ff14bdefd$export$28881e95f40c5f68; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $1c4ffb4ff14bdefd$export$28881e95f40c5f68 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.36 4.21a5.14 5.14 0 1 0 0 10.29 5.14 5.14 0 0 0 0-10.29ZM1.64 9.36a7.71 7.71 0 1 1 14 4.47l2.52 2.5a1.29 1.29 0 1 1-1.82 1.83l-2.51-2.51A7.71 7.71 0 0 1 1.65 9.36Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("m90TI", function(module, exports) {

$parcel$export(module.exports, "sendSvg", function () { return $04290c13d210f8cc$export$cc4f2fc255fe3f38; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $04290c13d210f8cc$export$cc4f2fc255fe3f38 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 21 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.3808 4.34812C13.72 4.47798 12.8501 4.7587 11.5748 5.17296L9.00869 6.00646C6.90631 6.68935 5.40679 7.17779 4.38121 7.63178C3.87166 7.85734 3.5351 8.05091 3.32022 8.22035C3.11183 8.38466 3.07011 8.48486 3.05969 8.51817C2.98058 8.77103 2.98009 9.04195 3.05831 9.29509C3.06861 9.32844 3.10998 9.42878 3.31777 9.59384C3.53205 9.76404 3.86792 9.95881 4.37667 10.1862C5.29287 10.5957 6.58844 11.0341 8.35529 11.6164L10.8876 8.59854C11.2426 8.17547 11.8733 8.12028 12.2964 8.47528C12.7195 8.83029 12.7746 9.46104 12.4196 9.88412L9.88738 12.9019C10.7676 14.5408 11.4244 15.7406 11.9867 16.5718C12.299 17.0333 12.5491 17.3303 12.7539 17.5117C12.9526 17.6877 13.0586 17.711 13.0932 17.7154C13.3561 17.7484 13.6228 17.7009 13.8581 17.5791C13.8891 17.563 13.9805 17.5046 14.1061 17.2708C14.2357 17.0298 14.3679 16.6647 14.5015 16.1237C14.7705 15.0349 14.9912 13.4733 15.2986 11.2843L15.6738 8.61249C15.8603 7.28456 15.9857 6.37917 15.9989 5.7059C16.012 5.03702 15.9047 4.8056 15.8145 4.69183C15.7044 4.55297 15.5673 4.43792 15.4114 4.35365C15.2837 4.28459 15.0372 4.2191 14.3808 4.34812ZM7.99373 13.603C6.11919 12.9864 4.6304 12.4902 3.5606 12.0121C2.98683 11.7557 2.4778 11.4808 2.07383 11.1599C1.66337 10.8339 1.31312 10.4217 1.14744 9.88551C0.949667 9.24541 0.950886 8.56035 1.15094 7.92096C1.31852 7.38534 1.67024 6.97442 2.08185 6.64985C2.48697 6.33041 2.99697 6.05734 3.57166 5.80295C4.70309 5.3021 6.30179 4.78283 8.32903 4.12437L11.0196 3.25042C12.2166 2.86159 13.2017 2.54158 13.9951 2.38566C14.8065 2.22618 15.6202 2.19289 16.3627 2.59437C16.7568 2.80747 17.1035 3.09839 17.3818 3.4495C17.9062 4.111 18.0147 4.91815 17.9985 5.74496C17.9827 6.55332 17.8386 7.57903 17.6636 8.82534L17.2701 11.6268C16.9737 13.7376 16.7399 15.4022 16.4432 16.6034C16.2924 17.2135 16.1121 17.7632 15.8678 18.2176C15.6197 18.6794 15.2761 19.0971 14.7777 19.3551C14.1827 19.6632 13.5083 19.7833 12.8436 19.6997C12.2867 19.6297 11.82 19.3563 11.4277 19.0087C11.0415 18.6666 10.6824 18.213 10.3302 17.6925C9.67361 16.722 8.92648 15.342 7.99373 13.603Z"
    clip-rule="evenodd"
  />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  ></svg></svg
>`;

});

parcelRegister("1sg6D", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalSvg", function () { return $10f4e64b694d6da7$export$43cc65051e9f7716; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $10f4e64b694d6da7$export$43cc65051e9f7716 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.76.3a1 1 0 0 1 0 1.4L4.07 4.4h9a1 1 0 1 1 0 2h-9l2.69 2.68a1 1 0 1 1-1.42 1.42L.95 6.09a1 1 0 0 1 0-1.4l4.4-4.4a1 1 0 0 1 1.4 0Zm6.49 9.21a1 1 0 0 1 1.41 0l4.39 4.4a1 1 0 0 1 0 1.4l-4.39 4.4a1 1 0 0 1-1.41-1.42l2.68-2.68h-9a1 1 0 0 1 0-2h9l-2.68-2.68a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hccSf", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalBoldSvg", function () { return $c84d8b2951cbbac2$export$6929881544dda4e0; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $c84d8b2951cbbac2$export$6929881544dda4e0 = (0, $7pRM7.svg)`<svg width="10" height="10" viewBox="0 0 10 10">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.77986 0.566631C4.0589 0.845577 4.0589 1.29784 3.77986 1.57678L3.08261 2.2738H6.34184C6.73647 2.2738 7.05637 2.5936 7.05637 2.98808C7.05637 3.38257 6.73647 3.70237 6.34184 3.70237H3.08261L3.77986 4.39938C4.0589 4.67833 4.0589 5.13059 3.77986 5.40954C3.50082 5.68848 3.04841 5.68848 2.76937 5.40954L0.852346 3.49316C0.573306 3.21421 0.573306 2.76195 0.852346 2.48301L2.76937 0.566631C3.04841 0.287685 3.50082 0.287685 3.77986 0.566631ZM6.22 4.59102C6.49904 4.31208 6.95145 4.31208 7.23049 4.59102L9.14751 6.5074C9.42655 6.78634 9.42655 7.23861 9.14751 7.51755L7.23049 9.43393C6.95145 9.71287 6.49904 9.71287 6.22 9.43393C5.94096 9.15498 5.94096 8.70272 6.22 8.42377L6.91725 7.72676L3.65802 7.72676C3.26339 7.72676 2.94349 7.40696 2.94349 7.01247C2.94349 6.61798 3.26339 6.29819 3.65802 6.29819L6.91725 6.29819L6.22 5.60117C5.94096 5.32223 5.94096 4.86997 6.22 4.59102Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("3EgBh", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalMediumSvg", function () { return $2a81fbfaba1ea477$export$f0d7b23b1c8e0312; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $2a81fbfaba1ea477$export$f0d7b23b1c8e0312 = (0, $7pRM7.svg)`<svg
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.7306 3.24213C14.0725 3.58384 14.0725 4.13786 13.7306 4.47957L10.7418 7.46737C10.4 7.80908 9.84581 7.80908 9.50399 7.46737C9.16216 7.12567 9.16216 6.57165 9.50399 6.22994L10.9986 4.73585H5.34082C4.85741 4.73585 4.46553 4.3441 4.46553 3.86085C4.46553 3.3776 4.85741 2.98585 5.34082 2.98585L10.9986 2.98585L9.50399 1.49177C9.16216 1.15006 9.16216 0.596037 9.50399 0.254328C9.84581 -0.0873803 10.4 -0.0873803 10.7418 0.254328L13.7306 3.24213ZM9.52515 10.1352C9.52515 10.6185 9.13327 11.0102 8.64986 11.0102L2.9921 11.0102L4.48669 12.5043C4.82852 12.846 4.82852 13.4001 4.48669 13.7418C4.14487 14.0835 3.59066 14.0835 3.24884 13.7418L0.26003 10.754C0.0958806 10.5899 0.0036621 10.3673 0.00366211 10.1352C0.00366212 9.90318 0.0958806 9.68062 0.26003 9.51652L3.24884 6.52872C3.59066 6.18701 4.14487 6.18701 4.48669 6.52872C4.82851 6.87043 4.82851 7.42445 4.48669 7.76616L2.9921 9.26024L8.64986 9.26024C9.13327 9.26024 9.52515 9.65199 9.52515 10.1352Z"
    fill="currentColor"
  />
</svg>

`;

});

parcelRegister("bFCtI", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalRoundedBoldSvg", function () { return $87f15f0b9bb20333$export$30367478a181008c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $87f15f0b9bb20333$export$30367478a181008c = (0, $7pRM7.svg)`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path 
    fill="currentColor"
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M8.3071 0.292893C8.69763 0.683417 8.69763 1.31658 8.3071 1.70711L6.41421 3.6H11.3404C13.8368 3.6 16.0533 5.1975 16.8427 7.56588L16.9487 7.88377C17.1233 8.40772 16.8402 8.97404 16.3162 9.14868C15.7923 9.32333 15.226 9.04017 15.0513 8.51623L14.9453 8.19834C14.4281 6.64664 12.976 5.6 11.3404 5.6H6.41421L8.3071 7.49289C8.69763 7.88342 8.69763 8.51658 8.3071 8.90711C7.91658 9.29763 7.28341 9.29763 6.89289 8.90711L3.29289 5.30711C2.90236 4.91658 2.90236 4.28342 3.29289 3.89289L6.89289 0.292893C7.28341 -0.0976311 7.91658 -0.0976311 8.3071 0.292893ZM3.68377 10.8513C4.20771 10.6767 4.77403 10.9598 4.94868 11.4838L5.05464 11.8017C5.57188 13.3534 7.024 14.4 8.65964 14.4L13.5858 14.4L11.6929 12.5071C11.3024 12.1166 11.3024 11.4834 11.6929 11.0929C12.0834 10.7024 12.7166 10.7024 13.1071 11.0929L16.7071 14.6929C17.0976 15.0834 17.0976 15.7166 16.7071 16.1071L13.1071 19.7071C12.7166 20.0976 12.0834 20.0976 11.6929 19.7071C11.3024 19.3166 11.3024 18.6834 11.6929 18.2929L13.5858 16.4L8.65964 16.4C6.16314 16.4 3.94674 14.8025 3.15728 12.4341L3.05131 12.1162C2.87667 11.5923 3.15983 11.026 3.68377 10.8513Z" 
  />
</svg>`;

});

parcelRegister("6E0eq", function(module, exports) {

$parcel$export(module.exports, "swapVerticalSvg", function () { return $4d66a885b679a091$export$8fbc1b2c09145763; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $4d66a885b679a091$export$8fbc1b2c09145763 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.48 2.18a1 1 0 0 1 1.41 0l2.68 2.68a1 1 0 1 1-1.41 1.42l-.98-.98v4.56a1 1 0 0 1-2 0V5.3l-.97.98A1 1 0 0 1 .79 4.86l2.69-2.68Zm6.34 2.93a1 1 0 0 1 1 1v4.56l.97-.98a1 1 0 1 1 1.42 1.42l-2.69 2.68a1 1 0 0 1-1.41 0l-2.68-2.68a1 1 0 0 1 1.41-1.42l.98.98V6.1a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("dZx1R", function(module, exports) {

$parcel$export(module.exports, "telegramSvg", function () { return $a2fa97b9e137a6d6$export$367999698d7de87a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $a2fa97b9e137a6d6$export$367999698d7de87a = (0, $7pRM7.svg)`<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g clip-path="url(#a)">
    <path fill="url(#b)" d="M0 0h32v32H0z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.034 15.252c4.975-2.167 8.293-3.596 9.953-4.287 4.74-1.971 5.725-2.314 6.366-2.325.142-.002.457.033.662.198.172.14.22.33.243.463.022.132.05.435.028.671-.257 2.7-1.368 9.248-1.933 12.27-.24 1.28-.71 1.708-1.167 1.75-.99.091-1.743-.655-2.703-1.284-1.502-.985-2.351-1.598-3.81-2.558-1.684-1.11-.592-1.721.368-2.718.252-.261 4.619-4.233 4.703-4.594.01-.045.02-.213-.08-.301-.1-.09-.246-.059-.353-.035-.15.034-2.55 1.62-7.198 4.758-.682.468-1.298.696-1.851.684-.61-.013-1.782-.344-2.653-.628-1.069-.347-1.918-.53-1.845-1.12.039-.308.462-.623 1.27-.944Z" fill="#fff"/>
  </g>
  <path d="M.5 16C.5 7.44 7.44.5 16 .5 24.56.5 31.5 7.44 31.5 16c0 8.56-6.94 15.5-15.5 15.5C7.44 31.5.5 24.56.5 16Z" stroke="#141414" stroke-opacity=".05"/>
  <defs>
    <linearGradient id="b" x1="1600" y1="0" x2="1600" y2="3176.27" gradientUnits="userSpaceOnUse">
      <stop stop-color="#2AABEE"/>
      <stop offset="1" stop-color="#229ED9"/>
    </linearGradient>
    <clipPath id="a">
      <path d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z" fill="#fff"/>
    </clipPath>
  </defs>
</svg>`;

});

parcelRegister("9Ytl9", function(module, exports) {

$parcel$export(module.exports, "threeDotsSvg", function () { return $743079ffd739d05e$export$51d10a72e5cebc7a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $743079ffd739d05e$export$51d10a72e5cebc7a = (0, $7pRM7.svg)`<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 3.71875C6.0335 3.71875 5.25 2.93525 5.25 1.96875C5.25 1.00225 6.0335 0.21875 7 0.21875C7.9665 0.21875 8.75 1.00225 8.75 1.96875C8.75 2.93525 7.9665 3.71875 7 3.71875Z" fill="#949E9E"/>
  <path d="M7 8.96875C6.0335 8.96875 5.25 8.18525 5.25 7.21875C5.25 6.25225 6.0335 5.46875 7 5.46875C7.9665 5.46875 8.75 6.25225 8.75 7.21875C8.75 8.18525 7.9665 8.96875 7 8.96875Z" fill="#949E9E"/>
  <path d="M5.25 12.4688C5.25 13.4352 6.0335 14.2187 7 14.2187C7.9665 14.2187 8.75 13.4352 8.75 12.4688C8.75 11.5023 7.9665 10.7188 7 10.7188C6.0335 10.7188 5.25 11.5023 5.25 12.4688Z" fill="#949E9E"/>
</svg>`;

});

parcelRegister("kR0KT", function(module, exports) {

$parcel$export(module.exports, "twitchSvg", function () { return $03eafd49e710992f$export$759b73a5195b6264; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $03eafd49e710992f$export$759b73a5195b6264 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5A3E85" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M18.22 25.7 20 23.91h3.34l2.1-2.1v-6.68H15.4v8.78h2.82v1.77Zm3.87-8.16h1.25v3.66H22.1v-3.66Zm-3.34 0H20v3.66h-1.25v-3.66ZM20 7.9a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm6.69 14.56-3.66 3.66h-2.72l-1.77 1.78h-1.88V26.1H13.3v-9.82l.94-2.4H26.7v8.56Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("ggn6d", function(module, exports) {

$parcel$export(module.exports, "twitterIconSvg", function () { return $bd700ef8b29357e4$export$d6bfd63304732c58; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $bd700ef8b29357e4$export$d6bfd63304732c58 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="m14.36 4.74.01.42c0 4.34-3.3 9.34-9.34 9.34A9.3 9.3 0 0 1 0 13.03a6.6 6.6 0 0 0 4.86-1.36 3.29 3.29 0 0 1-3.07-2.28c.5.1 1 .07 1.48-.06A3.28 3.28 0 0 1 .64 6.11v-.04c.46.26.97.4 1.49.41A3.29 3.29 0 0 1 1.11 2.1a9.32 9.32 0 0 0 6.77 3.43 3.28 3.28 0 0 1 5.6-3 6.59 6.59 0 0 0 2.08-.8 3.3 3.3 0 0 1-1.45 1.82A6.53 6.53 0 0 0 16 3.04c-.44.66-1 1.23-1.64 1.7Z"
  />
</svg>`;

});

parcelRegister("lSAmD", function(module, exports) {

$parcel$export(module.exports, "verifySvg", function () { return $fedad948e5f3ad62$export$dddaa7bddf7e22f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $fedad948e5f3ad62$export$dddaa7bddf7e22f = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 28 28">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M18.1 4.76c-.42-.73-1.33-1.01-2.09-.66l-1.42.66c-.37.18-.8.18-1.18 0l-1.4-.65a1.63 1.63 0 0 0-2.1.66l-.84 1.45c-.2.34-.53.59-.92.67l-1.7.35c-.83.17-1.39.94-1.3 1.78l.19 1.56c.04.39-.08.78-.33 1.07l-1.12 1.3c-.52.6-.52 1.5 0 2.11L5 16.38c.25.3.37.68.33 1.06l-.18 1.57c-.1.83.46 1.6 1.28 1.78l1.7.35c.4.08.73.32.93.66l.84 1.43a1.63 1.63 0 0 0 2.09.66l1.41-.66c.37-.17.8-.17 1.18 0l1.43.67c.76.35 1.66.07 2.08-.65l.86-1.45c.2-.34.54-.58.92-.66l1.68-.35A1.63 1.63 0 0 0 22.84 19l-.18-1.57a1.4 1.4 0 0 1 .33-1.06l1.12-1.32c.52-.6.52-1.5 0-2.11l-1.12-1.3a1.4 1.4 0 0 1-.33-1.07l.18-1.57c.1-.83-.46-1.6-1.28-1.77l-1.68-.35a1.4 1.4 0 0 1-.92-.66l-.86-1.47Zm-3.27-3.2a4.43 4.43 0 0 1 5.69 1.78l.54.93 1.07.22a4.43 4.43 0 0 1 3.5 4.84l-.11.96.7.83a4.43 4.43 0 0 1 .02 5.76l-.72.85.1.96a4.43 4.43 0 0 1-3.5 4.84l-1.06.22-.54.92a4.43 4.43 0 0 1-5.68 1.77l-.84-.4-.82.39a4.43 4.43 0 0 1-5.7-1.79l-.51-.89-1.09-.22a4.43 4.43 0 0 1-3.5-4.84l.1-.96-.72-.85a4.43 4.43 0 0 1 .01-5.76l.71-.83-.1-.95a4.43 4.43 0 0 1 3.5-4.84l1.08-.23.53-.9a4.43 4.43 0 0 1 5.7-1.8l.81.38.83-.39ZM18.2 9.4c.65.42.84 1.28.42 1.93l-4.4 6.87a1.4 1.4 0 0 1-2.26.14L9.5 15.39a1.4 1.4 0 0 1 2.15-1.8l1.23 1.48 3.38-5.26a1.4 1.4 0 0 1 1.93-.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("6zO57", function(module, exports) {

$parcel$export(module.exports, "verifyFilledSvg", function () { return $4c9cdc1f3489a168$export$1f9737848f580d88; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $4c9cdc1f3489a168$export$1f9737848f580d88 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="m4.1 12.43-.45-.78-.93-.2a1.65 1.65 0 0 1-1.31-1.8l.1-.86-.61-.71a1.65 1.65 0 0 1 0-2.16l.6-.7-.09-.85c-.1-.86.47-1.64 1.3-1.81l.94-.2.45-.78A1.65 1.65 0 0 1 6.23.9l.77.36.78-.36c.77-.36 1.69-.07 2.12.66l.47.8.91.2c.84.17 1.4.95 1.31 1.8l-.1.86.6.7c.54.62.54 1.54.01 2.16l-.6.71.09.86c.1.85-.47 1.63-1.3 1.8l-.92.2-.47.79a1.65 1.65 0 0 1-2.12.66L7 12.74l-.77.36c-.78.35-1.7.07-2.13-.67Zm5.74-6.9a1 1 0 1 0-1.68-1.07L6.32 7.3l-.55-.66a1 1 0 0 0-1.54 1.28l1.43 1.71a1 1 0 0 0 1.61-.1l2.57-4Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("a4Qhc", function(module, exports) {

$parcel$export(module.exports, "walletPlaceholderSvg", function () { return $7562d41dcf501b90$export$e1456ec7b14fe70e; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $7562d41dcf501b90$export$e1456ec7b14fe70e = (0, $7pRM7.svg)`
  <svg fill="none" viewBox="0 0 48 44">
    <path
      style="fill: var(--wui-color-bg-300);"
      d="M4.56 8.64c-1.23 1.68-1.23 4.08-1.23 8.88v8.96c0 4.8 0 7.2 1.23 8.88.39.55.87 1.02 1.41 1.42C7.65 38 10.05 38 14.85 38h14.3c4.8 0 7.2 0 8.88-1.22a6.4 6.4 0 0 0 1.41-1.42c.83-1.14 1.1-2.6 1.19-4.92a6.4 6.4 0 0 0 5.16-4.65c.21-.81.21-1.8.21-3.79 0-1.98 0-2.98-.22-3.79a6.4 6.4 0 0 0-5.15-4.65c-.1-2.32-.36-3.78-1.19-4.92a6.4 6.4 0 0 0-1.41-1.42C36.35 6 33.95 6 29.15 6h-14.3c-4.8 0-7.2 0-8.88 1.22a6.4 6.4 0 0 0-1.41 1.42Z"
    />
    <path
      style="fill: var(--wui-color-fg-200);"
      fill-rule="evenodd"
      d="M2.27 11.33a6.4 6.4 0 0 1 6.4-6.4h26.66a6.4 6.4 0 0 1 6.4 6.4v1.7a6.4 6.4 0 0 1 5.34 6.3v5.34a6.4 6.4 0 0 1-5.34 6.3v1.7a6.4 6.4 0 0 1-6.4 6.4H8.67a6.4 6.4 0 0 1-6.4-6.4V11.33ZM39.6 31.07h-6.93a9.07 9.07 0 1 1 0-18.14h6.93v-1.6a4.27 4.27 0 0 0-4.27-4.26H8.67a4.27 4.27 0 0 0-4.27 4.26v21.34a4.27 4.27 0 0 0 4.27 4.26h26.66a4.27 4.27 0 0 0 4.27-4.26v-1.6Zm-6.93-16a6.93 6.93 0 0 0 0 13.86h8a4.27 4.27 0 0 0 4.26-4.26v-5.34a4.27 4.27 0 0 0-4.26-4.26h-8Z"
      clip-rule="evenodd"
    />
  </svg>
`;

});

parcelRegister("ePCmQ", function(module, exports) {

$parcel$export(module.exports, "walletSvg", function () { return $acc3971901a26502$export$9025df5921500944; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $acc3971901a26502$export$9025df5921500944 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 5.5c0-1.8 1.46-3.25 3.25-3.25H14.5c1.8 0 3.25 1.46 3.25 3.25v.28A3.25 3.25 0 0 1 20 8.88v2.24c0 1.45-.94 2.68-2.25 3.1v.28c0 1.8-1.46 3.25-3.25 3.25H3.25A3.25 3.25 0 0 1 0 14.5v-9Zm15.75 8.88h-2.38a4.38 4.38 0 0 1 0-8.76h2.38V5.5c0-.69-.56-1.25-1.25-1.25H3.25C2.56 4.25 2 4.81 2 5.5v9c0 .69.56 1.25 1.25 1.25H14.5c.69 0 1.25-.56 1.25-1.25v-.13Zm-2.38-6.76a2.37 2.37 0 1 0 0 4.75h3.38c.69 0 1.25-.55 1.25-1.24V8.87c0-.69-.56-1.24-1.25-1.24h-3.38Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("f0FPs", function(module, exports) {

$parcel$export(module.exports, "walletConnectSvg", function () { return $aed74d7bc99524f7$export$84e288e571149f90; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $aed74d7bc99524f7$export$84e288e571149f90 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 96 67">
  <path
    fill="currentColor"
    d="M25.32 18.8a32.56 32.56 0 0 1 45.36 0l1.5 1.47c.63.62.63 1.61 0 2.22l-5.15 5.05c-.31.3-.82.3-1.14 0l-2.07-2.03a22.71 22.71 0 0 0-31.64 0l-2.22 2.18c-.31.3-.82.3-1.14 0l-5.15-5.05a1.55 1.55 0 0 1 0-2.22l1.65-1.62Zm56.02 10.44 4.59 4.5c.63.6.63 1.6 0 2.21l-20.7 20.26c-.62.61-1.63.61-2.26 0L48.28 41.83a.4.4 0 0 0-.56 0L33.03 56.21c-.63.61-1.64.61-2.27 0L10.07 35.95a1.55 1.55 0 0 1 0-2.22l4.59-4.5a1.63 1.63 0 0 1 2.27 0L31.6 43.63a.4.4 0 0 0 .57 0l14.69-14.38a1.63 1.63 0 0 1 2.26 0l14.69 14.38a.4.4 0 0 0 .57 0l14.68-14.38a1.63 1.63 0 0 1 2.27 0Z"
  />
  <path
    stroke="#000"
    stroke-opacity=".1"
    d="M25.67 19.15a32.06 32.06 0 0 1 44.66 0l1.5 1.48c.43.42.43 1.09 0 1.5l-5.15 5.05a.31.31 0 0 1-.44 0l-2.07-2.03a23.21 23.21 0 0 0-32.34 0l-2.22 2.18a.31.31 0 0 1-.44 0l-5.15-5.05a1.05 1.05 0 0 1 0-1.5l1.65-1.63ZM81 29.6l4.6 4.5c.42.41.42 1.09 0 1.5l-20.7 20.26c-.43.43-1.14.43-1.57 0L48.63 41.47a.9.9 0 0 0-1.26 0L32.68 55.85c-.43.43-1.14.43-1.57 0L10.42 35.6a1.05 1.05 0 0 1 0-1.5l4.59-4.5a1.13 1.13 0 0 1 1.57 0l14.68 14.38a.9.9 0 0 0 1.27 0l-.35-.35.35.35L47.22 29.6a1.13 1.13 0 0 1 1.56 0l14.7 14.38a.9.9 0 0 0 1.26 0L79.42 29.6a1.13 1.13 0 0 1 1.57 0Z"
  />
</svg>`;

});

parcelRegister("6Se5K", function(module, exports) {

$parcel$export(module.exports, "warningCircleSvg", function () { return $014a9fdd22dbc193$export$6e55d6021a3f4197; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $014a9fdd22dbc193$export$6e55d6021a3f4197 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M11 6.67a1 1 0 1 0-2 0v2.66a1 1 0 0 0 2 0V6.67ZM10 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("aZMJD", function(module, exports) {

$parcel$export(module.exports, "lightbulbSvg", function () { return $801567a3cac78378$export$e3455d95c95b44fb; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $801567a3cac78378$export$e3455d95c95b44fb = (0, $7pRM7.svg)`<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.00177 1.78569C3.8179 1.78569 2.85819 2.74508 2.85819 3.92855C2.85819 4.52287 3.09928 5.05956 3.49077 5.4485L3.5005 5.45817C3.64381 5.60054 3.76515 5.72108 3.85631 5.81845C3.93747 5.90512 4.05255 6.03218 4.12889 6.1805C4.16999 6.26034 4.19 6.30843 4.21768 6.39385C4.22145 6.40546 4.22499 6.41703 4.22833 6.42855H5.77521C5.77854 6.41703 5.78208 6.40547 5.78585 6.39385C5.81353 6.30843 5.83354 6.26034 5.87464 6.1805C5.95098 6.03218 6.06606 5.90512 6.14722 5.81845C6.23839 5.72108 6.35973 5.60053 6.50304 5.45816L6.51276 5.4485C6.90425 5.05956 7.14534 4.52287 7.14534 3.92855C7.14534 2.74508 6.18563 1.78569 5.00177 1.78569ZM5.71629 7.85712H4.28724C4.28724 8.21403 4.28876 8.40985 4.30703 8.54571C4.30727 8.54748 4.30751 8.54921 4.30774 8.55091C4.30944 8.55115 4.31118 8.55138 4.31295 8.55162C4.44884 8.56989 4.64474 8.5714 5.00177 8.5714C5.3588 8.5714 5.55469 8.56989 5.69059 8.55162C5.69236 8.55138 5.69409 8.55115 5.69579 8.55091C5.69603 8.54921 5.69627 8.54748 5.6965 8.54571C5.71477 8.40985 5.71629 8.21403 5.71629 7.85712ZM2.85819 7.14283C2.85819 6.9948 2.85796 6.91114 2.8548 6.85032C2.85461 6.84656 2.85441 6.84309 2.85421 6.83988C2.84393 6.8282 2.83047 6.81334 2.81301 6.79469C2.74172 6.71856 2.63908 6.61643 2.48342 6.46178C1.83307 5.81566 1.42914 4.91859 1.42914 3.92855C1.42914 1.9561 3.02866 0.357117 5.00177 0.357117C6.97487 0.357117 8.57439 1.9561 8.57439 3.92855C8.57439 4.91859 8.17047 5.81566 7.52012 6.46178C7.36445 6.61643 7.26182 6.71856 7.19053 6.79469C7.17306 6.81334 7.1596 6.8282 7.14932 6.83988C7.14912 6.84309 7.14892 6.84656 7.14873 6.85032C7.14557 6.91114 7.14534 6.9948 7.14534 7.14283V7.85712C7.14534 7.87009 7.14535 7.88304 7.14535 7.89598C7.14541 8.19889 7.14547 8.49326 7.11281 8.73606C7.076 9.00978 6.98631 9.32212 6.72678 9.58156C6.46726 9.841 6.15481 9.93065 5.881 9.96745C5.63813 10.0001 5.34365 10 5.04064 9.99998C5.0277 9.99998 5.01474 9.99998 5.00177 9.99998C4.98879 9.99998 4.97583 9.99998 4.96289 9.99998C4.65988 10 4.36541 10.0001 4.12253 9.96745C3.84872 9.93065 3.53628 9.841 3.27675 9.58156C3.01722 9.32212 2.92753 9.00978 2.89072 8.73606C2.85807 8.49326 2.85812 8.19889 2.85818 7.89598C2.85819 7.88304 2.85819 7.87008 2.85819 7.85712V7.14283ZM7.1243 6.86977C7.12366 6.87069 7.1233 6.87116 7.12327 6.87119C7.12323 6.87123 7.12356 6.87076 7.1243 6.86977ZM2.88027 6.8712C2.88025 6.87119 2.87988 6.8707 2.87921 6.86975C2.87995 6.87072 2.88028 6.8712 2.88027 6.8712Z" fill="#949E9E"/>
</svg>`;

});

parcelRegister("flGAO", function(module, exports) {

$parcel$export(module.exports, "idSvg", function () { return $b2c9db3b1c38cb99$export$617f4a80e2acdd4f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $b2c9db3b1c38cb99$export$617f4a80e2acdd4f = (0, $7pRM7.svg)`<svg
 xmlns="http://www.w3.org/2000/svg"
 width="28"
 height="28"
 viewBox="0 0 28 28"
 fill="none">
  <path
    fill="#949E9E"
    fill-rule="evenodd"
    d="M7.974 2.975h12.052c1.248 0 2.296 0 3.143.092.89.096 1.723.307 2.461.844a4.9 4.9 0 0 1 1.084 1.084c.537.738.748 1.57.844 2.461.092.847.092 1.895.092 3.143v6.802c0 1.248 0 2.296-.092 3.143-.096.89-.307 1.723-.844 2.461a4.9 4.9 0 0 1-1.084 1.084c-.738.537-1.57.748-2.461.844-.847.092-1.895.092-3.143.092H7.974c-1.247 0-2.296 0-3.143-.092-.89-.096-1.723-.307-2.461-.844a4.901 4.901 0 0 1-1.084-1.084c-.537-.738-.748-1.571-.844-2.461C.35 19.697.35 18.649.35 17.4v-6.802c0-1.248 0-2.296.092-3.143.096-.89.307-1.723.844-2.461A4.9 4.9 0 0 1 2.37 3.91c.738-.537 1.571-.748 2.461-.844.847-.092 1.895-.092 3.143-.092ZM5.133 5.85c-.652.071-.936.194-1.117.326a2.1 2.1 0 0 0-.465.465c-.132.181-.255.465-.325 1.117-.074.678-.076 1.573-.076 2.917v6.65c0 1.344.002 2.239.076 2.917.07.652.193.936.325 1.117a2.1 2.1 0 0 0 .465.465c.181.132.465.255 1.117.326.678.073 1.574.075 2.917.075h11.9c1.344 0 2.239-.002 2.917-.075.652-.071.936-.194 1.117-.326.179-.13.335-.286.465-.465.132-.181.255-.465.326-1.117.073-.678.075-1.573.075-2.917v-6.65c0-1.344-.002-2.239-.075-2.917-.071-.652-.194-.936-.326-1.117a2.1 2.1 0 0 0-.465-.465c-.181-.132-.465-.255-1.117-.326-.678-.073-1.573-.075-2.917-.075H8.05c-1.343 0-2.239.002-2.917.075Zm.467 7.275a3.15 3.15 0 1 1 6.3 0 3.15 3.15 0 0 1-6.3 0Zm8.75-1.75a1.4 1.4 0 0 1 1.4-1.4h3.5a1.4 1.4 0 0 1 0 2.8h-3.5a1.4 1.4 0 0 1-1.4-1.4Zm0 5.25a1.4 1.4 0 0 1 1.4-1.4H21a1.4 1.4 0 1 1 0 2.8h-5.25a1.4 1.4 0 0 1-1.4-1.4Z"
    clip-rule="evenodd"/>
</svg>`;

});

parcelRegister("kxxjb", function(module, exports) {

$parcel$export(module.exports, "xSvg", function () { return $ef40ba0efc4a6802$export$de73a2de604c6323; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $ef40ba0efc4a6802$export$de73a2de604c6323 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 41 40">
  <g clip-path="url(#a)">
    <path fill="#000" d="M.8 0h40v40H.8z" />
    <path
      fill="#fff"
      d="m22.63 18.46 7.14-8.3h-1.69l-6.2 7.2-4.96-7.2H11.2l7.5 10.9-7.5 8.71h1.7l6.55-7.61 5.23 7.61h5.72l-7.77-11.31Zm-9.13-7.03h2.6l11.98 17.13h-2.6L13.5 11.43Z"
    />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M.8 20a20 20 0 1 1 40 0 20 20 0 0 1-40 0Z" /></clipPath>
  </defs>
</svg>`;

});


parcelRegister("4BuLe", function(module, exports) {

$parcel$export(module.exports, "WuiImage", function () { return $35a27a8e5bad18a5$export$6985d0bcc76e605c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $eWzjc = parcelRequire("eWzjc");
var $35a27a8e5bad18a5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $35a27a8e5bad18a5$export$6985d0bcc76e605c = class WuiImage extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.src = "./path/to/image.jpg";
        this.alt = "Image";
        this.size = undefined;
    }
    render() {
        this.style.cssText = `
      --local-width: ${this.size ? `var(--wui-icon-size-${this.size});` : "100%"};
      --local-height: ${this.size ? `var(--wui-icon-size-${this.size});` : "100%"};
      `;
        return (0, $7pRM7.html)`<img src=${this.src} alt=${this.alt} @error=${this.handleImageError} />`;
    }
    handleImageError() {
        this.dispatchEvent(new CustomEvent("onLoadError", {
            bubbles: true,
            composed: true
        }));
    }
};
$35a27a8e5bad18a5$export$6985d0bcc76e605c.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.colorStyles),
    (0, $eWzjc.default)
];
$35a27a8e5bad18a5$var$__decorate([
    (0, $biDip.property)()
], $35a27a8e5bad18a5$export$6985d0bcc76e605c.prototype, "src", void 0);
$35a27a8e5bad18a5$var$__decorate([
    (0, $biDip.property)()
], $35a27a8e5bad18a5$export$6985d0bcc76e605c.prototype, "alt", void 0);
$35a27a8e5bad18a5$var$__decorate([
    (0, $biDip.property)()
], $35a27a8e5bad18a5$export$6985d0bcc76e605c.prototype, "size", void 0);
$35a27a8e5bad18a5$export$6985d0bcc76e605c = $35a27a8e5bad18a5$var$__decorate([
    (0, $ailZp.customElement)("wui-image")
], $35a27a8e5bad18a5$export$6985d0bcc76e605c);

});
parcelRegister("eWzjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae11df0300edf7a0$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $ae11df0300edf7a0$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    width: var(--local-width);
    height: var(--local-height);
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    border-radius: inherit;
  }
`;

});


parcelRegister("e4TV0", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingHexagon", function () { return $a3fcd0a8adc9d141$export$8429fc8b8d557b81; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $jASgN = parcelRequire("jASgN");
var $a3fcd0a8adc9d141$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a3fcd0a8adc9d141$export$8429fc8b8d557b81 = class WuiLoadingHexagon extends (0, $cLW71.LitElement) {
    render() {
        return (0, $7pRM7.html)`
      <svg viewBox="0 0 54 59">
        <path
          id="wui-loader-path"
          d="M17.22 5.295c3.877-2.277 5.737-3.363 7.72-3.726a11.44 11.44 0 0 1 4.12 0c1.983.363 3.844 1.45 7.72 3.726l6.065 3.562c3.876 2.276 5.731 3.372 7.032 4.938a11.896 11.896 0 0 1 2.06 3.63c.683 1.928.688 4.11.688 8.663v7.124c0 4.553-.005 6.735-.688 8.664a11.896 11.896 0 0 1-2.06 3.63c-1.3 1.565-3.156 2.66-7.032 4.937l-6.065 3.563c-3.877 2.276-5.737 3.362-7.72 3.725a11.46 11.46 0 0 1-4.12 0c-1.983-.363-3.844-1.449-7.72-3.726l-6.065-3.562c-3.876-2.276-5.731-3.372-7.032-4.938a11.885 11.885 0 0 1-2.06-3.63c-.682-1.928-.688-4.11-.688-8.663v-7.124c0-4.553.006-6.735.688-8.664a11.885 11.885 0 0 1 2.06-3.63c1.3-1.565 3.156-2.66 7.032-4.937l6.065-3.562Z"
        />
        <use xlink:href="#wui-loader-path"></use>
      </svg>
    `;
    }
};
$a3fcd0a8adc9d141$export$8429fc8b8d557b81.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jASgN.default)
];
$a3fcd0a8adc9d141$export$8429fc8b8d557b81 = $a3fcd0a8adc9d141$var$__decorate([
    (0, $ailZp.customElement)("wui-loading-hexagon")
], $a3fcd0a8adc9d141$export$8429fc8b8d557b81);

});
parcelRegister("jASgN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e43b79fa34e19be7$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $e43b79fa34e19be7$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
  }

  svg {
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
    fill: none;
    stroke: transparent;
    stroke-linecap: round;
  }

  use {
    stroke: var(--wui-color-accent-100);
    stroke-width: 2px;
    stroke-dasharray: 54, 118;
    stroke-dashoffset: 172;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;

});


parcelRegister("ck0jF", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingSpinner", function () { return $8f879911c55d2a23$export$3a84ab9b4ee14f8a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $lhjb8 = parcelRequire("lhjb8");
var $8f879911c55d2a23$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8f879911c55d2a23$export$3a84ab9b4ee14f8a = class WuiLoadingSpinner extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.color = "accent-100";
        this.size = "lg";
    }
    render() {
        this.style.cssText = `--local-color: ${this.color === "inherit" ? "inherit" : `var(--wui-color-${this.color})`}`;
        this.dataset["size"] = this.size;
        return (0, $7pRM7.html)`<svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50"></circle>
    </svg>`;
    }
};
$8f879911c55d2a23$export$3a84ab9b4ee14f8a.styles = [
    (0, $jVNMm.resetStyles),
    (0, $lhjb8.default)
];
$8f879911c55d2a23$var$__decorate([
    (0, $biDip.property)()
], $8f879911c55d2a23$export$3a84ab9b4ee14f8a.prototype, "color", void 0);
$8f879911c55d2a23$var$__decorate([
    (0, $biDip.property)()
], $8f879911c55d2a23$export$3a84ab9b4ee14f8a.prototype, "size", void 0);
$8f879911c55d2a23$export$3a84ab9b4ee14f8a = $8f879911c55d2a23$var$__decorate([
    (0, $ailZp.customElement)("wui-loading-spinner")
], $8f879911c55d2a23$export$3a84ab9b4ee14f8a);

});
parcelRegister("lhjb8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7da0ffdca95e78b$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $f7da0ffdca95e78b$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
  }

  :host([data-size='sm']) > svg {
    width: 12px;
    height: 12px;
  }

  :host([data-size='md']) > svg {
    width: 16px;
    height: 16px;
  }

  :host([data-size='lg']) > svg {
    width: 24px;
    height: 24px;
  }

  :host([data-size='xl']) > svg {
    width: 32px;
    height: 32px;
  }

  svg {
    animation: rotate 2s linear infinite;
  }

  circle {
    fill: none;
    stroke: var(--local-color);
    stroke-width: 4px;
    stroke-dasharray: 1, 124;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  :host([data-size='md']) > svg > circle {
    stroke-width: 6px;
  }

  :host([data-size='sm']) > svg > circle {
    stroke-width: 8px;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 124;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 124;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dashoffset: -125;
    }
  }
`;

});


parcelRegister("j3R5o", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingThumbnail", function () { return $de0779e7bf1de201$export$a8f5e0b29edd5ad2; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $jChHY = parcelRequire("jChHY");
var $de0779e7bf1de201$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $de0779e7bf1de201$export$a8f5e0b29edd5ad2 = class WuiLoadingThumbnail extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.radius = 36;
    }
    render() {
        return this.svgLoaderTemplate();
    }
    svgLoaderTemplate() {
        const radius = this.radius > 50 ? 50 : this.radius;
        const standardValue = 36;
        const radiusFactor = standardValue - radius;
        const dashArrayStart = 116 + radiusFactor;
        const dashArrayEnd = 245 + radiusFactor;
        const dashOffset = 360 + radiusFactor * 1.75;
        return (0, $7pRM7.html)`
      <svg viewBox="0 0 110 110" width="110" height="110">
        <rect
          x="2"
          y="2"
          width="106"
          height="106"
          rx=${radius}
          stroke-dasharray="${dashArrayStart} ${dashArrayEnd}"
          stroke-dashoffset=${dashOffset}
        />
      </svg>
    `;
    }
};
$de0779e7bf1de201$export$a8f5e0b29edd5ad2.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jChHY.default)
];
$de0779e7bf1de201$var$__decorate([
    (0, $biDip.property)({
        type: Number
    })
], $de0779e7bf1de201$export$a8f5e0b29edd5ad2.prototype, "radius", void 0);
$de0779e7bf1de201$export$a8f5e0b29edd5ad2 = $de0779e7bf1de201$var$__decorate([
    (0, $ailZp.customElement)("wui-loading-thumbnail")
], $de0779e7bf1de201$export$a8f5e0b29edd5ad2);

});
parcelRegister("jChHY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e47f4d6940acff5b$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $e47f4d6940acff5b$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
  }

  svg {
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
  }

  rect {
    fill: none;
    stroke: var(--wui-color-accent-100);
    stroke-width: 4px;
    stroke-linecap: round;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;

});


parcelRegister("kTgQh", function(module, exports) {

$parcel$export(module.exports, "WuiShimmer", function () { return $f35602319ed39036$export$22033065aa649938; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $ailZp = parcelRequire("ailZp");

var $j778t = parcelRequire("j778t");
var $f35602319ed39036$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f35602319ed39036$export$22033065aa649938 = class WuiShimmer extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.width = "";
        this.height = "";
        this.borderRadius = "m";
        this.variant = "default";
    }
    render() {
        this.style.cssText = `
      width: ${this.width};
      height: ${this.height};
      border-radius: ${`clamp(0px,var(--wui-border-radius-${this.borderRadius}), 40px)`};
    `;
        return (0, $7pRM7.html)`<slot></slot>`;
    }
};
$f35602319ed39036$export$22033065aa649938.styles = [
    (0, $j778t.default)
];
$f35602319ed39036$var$__decorate([
    (0, $biDip.property)()
], $f35602319ed39036$export$22033065aa649938.prototype, "width", void 0);
$f35602319ed39036$var$__decorate([
    (0, $biDip.property)()
], $f35602319ed39036$export$22033065aa649938.prototype, "height", void 0);
$f35602319ed39036$var$__decorate([
    (0, $biDip.property)()
], $f35602319ed39036$export$22033065aa649938.prototype, "borderRadius", void 0);
$f35602319ed39036$var$__decorate([
    (0, $biDip.property)()
], $f35602319ed39036$export$22033065aa649938.prototype, "variant", void 0);
$f35602319ed39036$export$22033065aa649938 = $f35602319ed39036$var$__decorate([
    (0, $ailZp.customElement)("wui-shimmer")
], $f35602319ed39036$export$22033065aa649938);

});
parcelRegister("j778t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dea434bd0ade051e$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $dea434bd0ade051e$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
    background: linear-gradient(
      120deg,
      var(--wui-color-bg-200) 5%,
      var(--wui-color-bg-200) 48%,
      var(--wui-color-bg-300) 55%,
      var(--wui-color-bg-300) 60%,
      var(--wui-color-bg-300) calc(60% + 10px),
      var(--wui-color-bg-200) calc(60% + 12px),
      var(--wui-color-bg-200) 100%
    );
    background-size: 250%;
    animation: shimmer 3s linear infinite reverse;
  }

  :host([variant='light']) {
    background: linear-gradient(
      120deg,
      var(--wui-color-bg-150) 5%,
      var(--wui-color-bg-150) 48%,
      var(--wui-color-bg-200) 55%,
      var(--wui-color-bg-200) 60%,
      var(--wui-color-bg-200) calc(60% + 10px),
      var(--wui-color-bg-150) calc(60% + 12px),
      var(--wui-color-bg-150) 100%
    );
    background-size: 250%;
  }

  @keyframes shimmer {
    from {
      background-position: -250% 0;
    }
    to {
      background-position: 250% 0;
    }
  }
`;

});


parcelRegister("fCaEm", function(module, exports) {

$parcel$export(module.exports, "WuiText", function () { return $b5e2aa82db766cbb$export$406e1aa02d8022e4; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("efM2M");
var $gQcSn = parcelRequire("gQcSn");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $bsTRx = parcelRequire("bsTRx");
var $b5e2aa82db766cbb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b5e2aa82db766cbb$export$406e1aa02d8022e4 = class WuiText extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "paragraph-500";
        this.color = "fg-300";
        this.align = "left";
        this.lineClamp = undefined;
    }
    render() {
        const classes = {
            [`wui-font-${this.variant}`]: true,
            [`wui-color-${this.color}`]: true,
            [`wui-line-clamp-${this.lineClamp}`]: this.lineClamp ? true : false
        };
        this.style.cssText = `
      --local-align: ${this.align};
      --local-color: var(--wui-color-${this.color});
    `;
        return (0, $7pRM7.html)`<slot class=${(0, $gQcSn.classMap)(classes)}></slot>`;
    }
};
$b5e2aa82db766cbb$export$406e1aa02d8022e4.styles = [
    (0, $jVNMm.resetStyles),
    (0, $bsTRx.default)
];
$b5e2aa82db766cbb$var$__decorate([
    (0, $biDip.property)()
], $b5e2aa82db766cbb$export$406e1aa02d8022e4.prototype, "variant", void 0);
$b5e2aa82db766cbb$var$__decorate([
    (0, $biDip.property)()
], $b5e2aa82db766cbb$export$406e1aa02d8022e4.prototype, "color", void 0);
$b5e2aa82db766cbb$var$__decorate([
    (0, $biDip.property)()
], $b5e2aa82db766cbb$export$406e1aa02d8022e4.prototype, "align", void 0);
$b5e2aa82db766cbb$var$__decorate([
    (0, $biDip.property)()
], $b5e2aa82db766cbb$export$406e1aa02d8022e4.prototype, "lineClamp", void 0);
$b5e2aa82db766cbb$export$406e1aa02d8022e4 = $b5e2aa82db766cbb$var$__decorate([
    (0, $ailZp.customElement)("wui-text")
], $b5e2aa82db766cbb$export$406e1aa02d8022e4);

});
parcelRegister("efM2M", function(module, exports) {
$parcel$export(module.exports, "classMap", function () { return (parcelRequire("gQcSn")).classMap; });
parcelRequire("gQcSn");

});
parcelRegister("gQcSn", function(module, exports) {

$parcel$export(module.exports, "classMap", function () { return $c42b7d95201f7e82$export$56cc687933817664; });

var $7pRM7 = parcelRequire("7pRM7");

var $VcZVx = parcelRequire("VcZVx");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c42b7d95201f7e82$export$56cc687933817664 = (0, $VcZVx.directive)(class extends (0, $VcZVx.Directive) {
    constructor(s){
        if (super(s), s.type !== (0, $VcZVx.PartType).ATTRIBUTE || "class" !== s.name || s.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(t, [s]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== t.strings && (this.nt = new Set(t.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(s);
        }
        const i = t.element.classList;
        for (const t of this.st)t in s || (i.remove(t), this.st.delete(t));
        for(const t in s){
            const r = !!s[t];
            r === this.st.has(t) || this.nt?.has(t) || (r ? (i.add(t), this.st.add(t)) : (i.remove(t), this.st.delete(t)));
        }
        return 0, $7pRM7.noChange;
    }
});

});
parcelRegister("VcZVx", function(module, exports) {

$parcel$export(module.exports, "PartType", function () { return $0abf68153e046a45$export$9ba3b3f20a85bfa; });
$parcel$export(module.exports, "directive", function () { return $0abf68153e046a45$export$99b43ad1ed32e735; });
$parcel$export(module.exports, "Directive", function () { return $0abf68153e046a45$export$befdefbdce210f91; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0abf68153e046a45$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $0abf68153e046a45$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $0abf68153e046a45$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("bsTRx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $858da45cc6dd42c8$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $858da45cc6dd42c8$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: inline-flex !important;
  }

  slot {
    width: 100%;
    display: inline-block;
    font-style: normal;
    font-family: var(--wui-font-family);
    font-feature-settings:
      'tnum' on,
      'lnum' on,
      'case' on;
    line-height: 130%;
    font-weight: var(--wui-font-weight-regular);
    overflow: inherit;
    text-overflow: inherit;
    text-align: var(--local-align);
    color: var(--local-color);
  }

  .wui-line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .wui-line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .wui-font-medium-400 {
    font-size: var(--wui-font-size-medium);
    font-weight: var(--wui-font-weight-light);
    letter-spacing: var(--wui-letter-spacing-medium);
  }

  .wui-font-medium-600 {
    font-size: var(--wui-font-size-medium);
    letter-spacing: var(--wui-letter-spacing-medium);
  }

  .wui-font-title-600 {
    font-size: var(--wui-font-size-title);
    letter-spacing: var(--wui-letter-spacing-title);
  }

  .wui-font-title-6-600 {
    font-size: var(--wui-font-size-title-6);
    letter-spacing: var(--wui-letter-spacing-title-6);
  }

  .wui-font-mini-700 {
    font-size: var(--wui-font-size-mini);
    letter-spacing: var(--wui-letter-spacing-mini);
    text-transform: uppercase;
  }

  .wui-font-large-500,
  .wui-font-large-600,
  .wui-font-large-700 {
    font-size: var(--wui-font-size-large);
    letter-spacing: var(--wui-letter-spacing-large);
  }

  .wui-font-2xl-500,
  .wui-font-2xl-600,
  .wui-font-2xl-700 {
    font-size: var(--wui-font-size-2xl);
    letter-spacing: var(--wui-letter-spacing-2xl);
  }

  .wui-font-paragraph-400,
  .wui-font-paragraph-500,
  .wui-font-paragraph-600,
  .wui-font-paragraph-700 {
    font-size: var(--wui-font-size-paragraph);
    letter-spacing: var(--wui-letter-spacing-paragraph);
  }

  .wui-font-small-400,
  .wui-font-small-500,
  .wui-font-small-600 {
    font-size: var(--wui-font-size-small);
    letter-spacing: var(--wui-letter-spacing-small);
  }

  .wui-font-tiny-400,
  .wui-font-tiny-500,
  .wui-font-tiny-600 {
    font-size: var(--wui-font-size-tiny);
    letter-spacing: var(--wui-letter-spacing-tiny);
  }

  .wui-font-micro-700,
  .wui-font-micro-600 {
    font-size: var(--wui-font-size-micro);
    letter-spacing: var(--wui-letter-spacing-micro);
    text-transform: uppercase;
  }

  .wui-font-tiny-400,
  .wui-font-small-400,
  .wui-font-medium-400,
  .wui-font-paragraph-400 {
    font-weight: var(--wui-font-weight-light);
  }

  .wui-font-large-700,
  .wui-font-paragraph-700,
  .wui-font-micro-700,
  .wui-font-mini-700 {
    font-weight: var(--wui-font-weight-bold);
  }

  .wui-font-medium-600,
  .wui-font-medium-title-600,
  .wui-font-title-6-600,
  .wui-font-large-600,
  .wui-font-paragraph-600,
  .wui-font-small-600,
  .wui-font-tiny-600,
  .wui-font-micro-600 {
    font-weight: var(--wui-font-weight-medium);
  }

  :host([disabled]) {
    opacity: 0.4;
  }
`;

});


parcelRegister("991Dm", function(module, exports) {

$parcel$export(module.exports, "WuiVisual", function () { return $01b7d7a01607bd1a$export$e6365a334c1a5845; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $juZ9Q = parcelRequire("juZ9Q");

var $1xYCa = parcelRequire("1xYCa");

var $iOZCm = parcelRequire("iOZCm");

var $82crT = parcelRequire("82crT");

var $krC3I = parcelRequire("krC3I");

var $1NOrS = parcelRequire("1NOrS");

var $5lacT = parcelRequire("5lacT");

var $cbYVN = parcelRequire("cbYVN");

var $ysPwh = parcelRequire("ysPwh");

var $26xpP = parcelRequire("26xpP");

var $hbEzj = parcelRequire("hbEzj");

var $lqPWQ = parcelRequire("lqPWQ");

var $9oXgV = parcelRequire("9oXgV");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $6FvFh = parcelRequire("6FvFh");

var $1Ng2D = parcelRequire("1Ng2D");

var $j0KR9 = parcelRequire("j0KR9");

var $5ySJS = parcelRequire("5ySJS");

var $54Cbz = parcelRequire("54Cbz");

var $lRU4h = parcelRequire("lRU4h");

var $7y1a6 = parcelRequire("7y1a6");

var $laAq3 = parcelRequire("laAq3");

var $hTC5l = parcelRequire("hTC5l");
var $01b7d7a01607bd1a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $01b7d7a01607bd1a$var$svgOptions = {
    browser: (0, $juZ9Q.browserSvg),
    dao: (0, $1xYCa.daoSvg),
    defi: (0, $iOZCm.defiSvg),
    defiAlt: (0, $82crT.defiAltSvg),
    eth: (0, $krC3I.ethSvg),
    layers: (0, $1NOrS.layersSvg),
    lock: (0, $5lacT.lockSvg),
    login: (0, $cbYVN.loginSvg),
    network: (0, $ysPwh.networkSvg),
    nft: (0, $26xpP.nftSvg),
    noun: (0, $hbEzj.nounSvg),
    profile: (0, $lqPWQ.profileSvg),
    system: (0, $9oXgV.systemSvg),
    coinbase: (0, $6FvFh.coinbaseSvg),
    onrampCard: (0, $54Cbz.onrampCardSvg),
    moonpay: (0, $1Ng2D.moonpaySvg),
    stripe: (0, $j0KR9.stripeSvg),
    paypal: (0, $5ySJS.paypalSvg),
    google: (0, $lRU4h.googleSvg),
    pencil: (0, $7y1a6.pencilSvg),
    lightbulb: (0, $laAq3.lightbulbSvg)
};
let $01b7d7a01607bd1a$export$e6365a334c1a5845 = class WuiVisual extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "browser";
        this.size = "md";
    }
    render() {
        this.style.cssText = `
       --local-size: var(--wui-visual-size-${this.size});
   `;
        return (0, $7pRM7.html)`${$01b7d7a01607bd1a$var$svgOptions[this.name]}`;
    }
};
$01b7d7a01607bd1a$export$e6365a334c1a5845.styles = [
    (0, $jVNMm.resetStyles),
    (0, $hTC5l.default)
];
$01b7d7a01607bd1a$var$__decorate([
    (0, $biDip.property)()
], $01b7d7a01607bd1a$export$e6365a334c1a5845.prototype, "name", void 0);
$01b7d7a01607bd1a$var$__decorate([
    (0, $biDip.property)()
], $01b7d7a01607bd1a$export$e6365a334c1a5845.prototype, "size", void 0);
$01b7d7a01607bd1a$export$e6365a334c1a5845 = $01b7d7a01607bd1a$var$__decorate([
    (0, $ailZp.customElement)("wui-visual")
], $01b7d7a01607bd1a$export$e6365a334c1a5845);

});
parcelRegister("juZ9Q", function(module, exports) {

$parcel$export(module.exports, "browserSvg", function () { return $e3204252790507d6$export$9a659d11e13bcec5; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $e3204252790507d6$export$9a659d11e13bcec5 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="30" />
  <circle cx="30" cy="30" r="3" fill="#fff" />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m45.32 17.9-.88-.42.88.42.02-.05c.1-.2.21-.44.26-.7l-.82-.15.82.16a2 2 0 0 0-.24-1.4c-.13-.23-.32-.42-.47-.57a8.42 8.42 0 0 1-.04-.04l-.04-.04a2.9 2.9 0 0 0-.56-.47l-.51.86.5-.86a2 2 0 0 0-1.4-.24c-.26.05-.5.16-.69.26l-.05.02-15.05 7.25-.1.05c-1.14.55-1.85.89-2.46 1.37a7 7 0 0 0-1.13 1.14c-.5.6-.83 1.32-1.38 2.45l-.05.11-7.25 15.05-.02.05c-.1.2-.21.43-.26.69a2 2 0 0 0 .24 1.4l.85-.5-.85.5c.13.23.32.42.47.57l.04.04.04.04c.15.15.34.34.56.47a2 2 0 0 0 1.41.24l-.2-.98.2.98c.25-.05.5-.17.69-.26l.05-.02-.42-.87.42.87 15.05-7.25.1-.05c1.14-.55 1.85-.89 2.46-1.38a7 7 0 0 0 1.13-1.13 12.87 12.87 0 0 0 1.43-2.56l7.25-15.05Z"
  />
  <path
    fill="#1DC956"
    d="M33.38 32.72 30.7 29.3 15.86 44.14l.2.2a1 1 0 0 0 1.14.2l15.1-7.27a3 3 0 0 0 1.08-4.55Z"
  />
  <path
    fill="#86F999"
    d="m26.62 27.28 2.67 3.43 14.85-14.85-.2-.2a1 1 0 0 0-1.14-.2l-15.1 7.27a3 3 0 0 0-1.08 4.55Z"
  />
  <circle cx="30" cy="30" r="3" fill="#fff" transform="rotate(45 30 30)" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
</svg> `;

});

parcelRegister("1xYCa", function(module, exports) {

$parcel$export(module.exports, "daoSvg", function () { return $1207e45255d089be$export$4c380a6200fee43; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $1207e45255d089be$export$4c380a6200fee43 = (0, $7pRM7.svg)`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#clip0_7734_50402)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#EB8B47"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M19 52C24.5228 52 29 47.5228 29 42C29 36.4772 24.5228 32 19 32C13.4772 32 9 36.4772 9 42C9 47.5228 13.4772 52 19 52Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.8437 8.3264C42.4507 7.70891 41.5493 7.70891 41.1564 8.32641L28.978 27.4638C28.5544 28.1295 29.0326 29.0007 29.8217 29.0007H54.1783C54.9674 29.0007 55.4456 28.1295 55.022 27.4638L42.8437 8.3264Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.3348 11.6456C42.659 11.7608 42.9061 12.1492 43.4005 12.926L50.7332 24.4488C51.2952 25.332 51.5763 25.7737 51.5254 26.1382C51.4915 26.3808 51.3698 26.6026 51.1833 26.7614C50.9031 27 50.3796 27 49.3327 27H34.6673C33.6204 27 33.0969 27 32.8167 26.7614C32.6302 26.6026 32.5085 26.3808 32.4746 26.1382C32.4237 25.7737 32.7048 25.332 33.2669 24.4488L40.5995 12.926C41.0939 12.1492 41.341 11.7608 41.6652 11.6456C41.8818 11.5687 42.1182 11.5687 42.3348 11.6456ZM35.0001 26.999C38.8661 26.999 42.0001 23.865 42.0001 19.999C42.0001 23.865 45.1341 26.999 49.0001 26.999H35.0001Z"
      fill="#FF974C"
    />
    <path
      d="M10.1061 9.35712C9.9973 9.67775 9.99867 10.0388 9.99978 10.3323C9.99989 10.3611 10 10.3893 10 10.4167V25.5833C10 25.6107 9.99989 25.6389 9.99978 25.6677C9.99867 25.9612 9.9973 26.3222 10.1061 26.6429C10.306 27.2317 10.7683 27.694 11.3571 27.8939C11.6777 28.0027 12.0388 28.0013 12.3323 28.0002C12.3611 28.0001 12.3893 28 12.4167 28H19C24.5228 28 29 23.5228 29 18C29 12.4772 24.5228 8 19 8H12.4167C12.3893 8 12.3611 7.99989 12.3323 7.99978C12.0388 7.99867 11.6778 7.9973 11.3571 8.10614C10.7683 8.306 10.306 8.76834 10.1061 9.35712Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="19" cy="18" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
    <circle cx="19" cy="42" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="clip0_7734_50402">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("iOZCm", function(module, exports) {

$parcel$export(module.exports, "defiSvg", function () { return $db3cb17d5ce0262c$export$400ef2a1f7fc3217; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $db3cb17d5ce0262c$export$400ef2a1f7fc3217 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#1DC956"
      d="M0 25.01c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02.11 15.65.11 24.9.11h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.13 60 15.76 60 25v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-3.45 1.97-8.08 1.97-17.33 1.97H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 49.1 0 44.46 0 35.21v-10.2Z"
    />
    <path
      fill="#2BEE6C"
      d="M16.1 60c-3.82-.18-6.4-.64-8.53-1.86a15 15 0 0 1-5.6-5.6C.55 50.06.16 46.97.04 41.98L4.2 40.6a4 4 0 0 0 2.48-2.39l4.65-12.4a2 2 0 0 1 2.5-1.2l2.53.84a2 2 0 0 0 2.43-1l2.96-5.94a2 2 0 0 1 3.7.32l3.78 12.58a2 2 0 0 0 3.03 1.09l3.34-2.23a2 2 0 0 0 .65-.7l5.3-9.72a2 2 0 0 1 1.42-1.01l4.14-.69a2 2 0 0 1 1.6.44l3.9 3.24a2 2 0 0 0 2.7-.12l4.62-4.63c.08 2.2.08 4.8.08 7.93v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-2.13 1.22-4.7 1.68-8.54 1.86H16.11Z"
    />
    <path
      fill="#fff"
      d="m.07 43.03-.05-2.1 3.85-1.28a3 3 0 0 0 1.86-1.79l4.66-12.4a3 3 0 0 1 3.75-1.8l2.53.84a1 1 0 0 0 1.21-.5l2.97-5.94a3 3 0 0 1 5.56.48l3.77 12.58a1 1 0 0 0 1.51.55l3.34-2.23a1 1 0 0 0 .33-.35l5.3-9.71a3 3 0 0 1 2.14-1.53l4.13-.69a3 3 0 0 1 2.41.66l3.9 3.24a1 1 0 0 0 1.34-.06l5.28-5.28c.05.85.08 1.75.1 2.73L56 22.41a3 3 0 0 1-4.04.19l-3.9-3.25a1 1 0 0 0-.8-.21l-4.13.69a1 1 0 0 0-.72.5l-5.3 9.72a3 3 0 0 1-.97 1.05l-3.34 2.23a3 3 0 0 1-4.53-1.63l-3.78-12.58a1 1 0 0 0-1.85-.16l-2.97 5.94a3 3 0 0 1-3.63 1.5l-2.53-.84a1 1 0 0 0-1.25.6l-4.65 12.4a5 5 0 0 1-3.1 3L.07 43.02Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M49.5 19a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M45 .28v59.66l-2 .1V.19c.7.02 1.37.05 2 .1Z" />
    <path fill="#2BEE6C" d="M47.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
    <path
      stroke="#fff"
      stroke-opacity=".1"
      d="M.5 25.01c0-4.63 0-8.08.24-10.8.25-2.7.73-4.64 1.66-6.28a14.5 14.5 0 0 1 5.42-5.41C9.46 1.58 11.39 1.1 14.1.85A133 133 0 0 1 24.9.61h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.67a14.5 14.5 0 0 1 5.42 5.4c.93 1.65 1.41 3.58 1.66 6.3.24 2.71.24 6.16.24 10.79v10.2c0 4.64 0 8.08-.24 10.8-.25 2.7-.73 4.65-1.66 6.28a14.5 14.5 0 0 1-5.42 5.42c-1.63.93-3.57 1.41-6.28 1.66-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.66a14.5 14.5 0 0 1-5.42-5.42C1.47 50.66 1 48.72.74 46.01A133 133 0 0 1 .5 35.2v-10.2Z"
    />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("82crT", function(module, exports) {

$parcel$export(module.exports, "defiAltSvg", function () { return $5d982abf1a075d47$export$f1568dd015c8f3b9; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $5d982abf1a075d47$export$f1568dd015c8f3b9 = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="30" />
    <path
      fill="#E87DE8"
      d="M57.98.01v19.5a4.09 4.09 0 0 0-2.63 2.29L50.7 34.2a2 2 0 0 1-2.5 1.2l-2.53-.84a2 2 0 0 0-2.42 1l-2.97 5.94a2 2 0 0 1-3.7-.32L32.8 28.6a2 2 0 0 0-3.02-1.09l-3.35 2.23a2 2 0 0 0-.64.7l-5.3 9.72a2 2 0 0 1-1.43 1.01l-4.13.69a2 2 0 0 1-1.61-.44l-3.9-3.24a2 2 0 0 0-2.69.12L2.1 42.93.02 43V.01h57.96Z"
    />
    <path
      fill="#fff"
      d="m61.95 16.94.05 2.1-3.85 1.28a3 3 0 0 0-1.86 1.79l-4.65 12.4a3 3 0 0 1-3.76 1.8l-2.53-.84a1 1 0 0 0-1.2.5l-2.98 5.94a3 3 0 0 1-5.55-.48l-3.78-12.58a1 1 0 0 0-1.5-.55l-3.35 2.23a1 1 0 0 0-.32.35l-5.3 9.72a3 3 0 0 1-2.14 1.52l-4.14.69a3 3 0 0 1-2.41-.66l-3.9-3.24a1 1 0 0 0-1.34.06l-5.28 5.28c-.05-.84-.08-1.75-.1-2.73l3.97-3.96a3 3 0 0 1 4.04-.19l3.89 3.25a1 1 0 0 0 .8.21l4.14-.68a1 1 0 0 0 .71-.51l5.3-9.71a3 3 0 0 1 .97-1.06l3.34-2.23a3 3 0 0 1 4.54 1.63l3.77 12.58a1 1 0 0 0 1.86.16l2.96-5.93a3 3 0 0 1 3.64-1.5l2.52.83a1 1 0 0 0 1.25-.6l4.66-12.4a5 5 0 0 1 3.1-2.99l4.43-1.48Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M35.5 27a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M31 0v60h-2V0h2Z" />
    <path fill="#E87DE8" d="M33.5 27a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("krC3I", function(module, exports) {

$parcel$export(module.exports, "ethSvg", function () { return $ee23d9fa017868ee$export$9c7a8a6662d6e69b; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $ee23d9fa017868ee$export$9c7a8a6662d6e69b = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#987DE8" rx="30" />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="m15.48 28.37 11.97-19.3a3 3 0 0 1 5.1 0l11.97 19.3a6 6 0 0 1 .9 3.14v.03a6 6 0 0 1-1.16 3.56L33.23 50.2a4 4 0 0 1-6.46 0L15.73 35.1a6 6 0 0 1-1.15-3.54v-.03a6 6 0 0 1 .9-3.16Z"
      clip-rule="evenodd"
    />
    <path
      fill="#643CDD"
      d="M30.84 10.11a1 1 0 0 0-.84-.46V24.5l12.6 5.53a2 2 0 0 0-.28-1.4L30.84 10.11Z"
    />
    <path
      fill="#BDADEB"
      d="M30 9.65a1 1 0 0 0-.85.46L17.66 28.64a2 2 0 0 0-.26 1.39L30 24.5V9.65Z"
    />
    <path
      fill="#643CDD"
      d="M30 50.54a1 1 0 0 0 .8-.4l11.24-15.38c.3-.44-.2-1-.66-.73l-9.89 5.68a3 3 0 0 1-1.5.4v10.43Z"
    />
    <path
      fill="#BDADEB"
      d="m17.97 34.76 11.22 15.37c.2.28.5.41.8.41V40.11a3 3 0 0 1-1.49-.4l-9.88-5.68c-.47-.27-.97.3-.65.73Z"
    />
    <path
      fill="#401AB3"
      d="M42.6 30.03 30 24.5v13.14a3 3 0 0 0 1.5-.4l10.14-5.83a2 2 0 0 0 .95-1.38Z"
    />
    <path
      fill="#7C5AE2"
      d="M30 37.64V24.46l-12.6 5.57a2 2 0 0 0 .97 1.39l10.13 5.82a3 3 0 0 0 1.5.4Z"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("1NOrS", function(module, exports) {

$parcel$export(module.exports, "layersSvg", function () { return $15018017afef5d22$export$92af4cd19d37b5ea; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $15018017afef5d22$export$92af4cd19d37b5ea = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="3" />
  <path
    fill="#1FAD7E"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 29.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 19.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#86F999"
    stroke="#fff"
    stroke-width="2"
    d="m46.69 21.06-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-6.32-3.51-.18-.1c-2.33-1.3-3.72-2.06-5.22-2.33a9 9 0 0 0-3.08 0c-1.5.27-2.9 1.04-5.22 2.33l-.17.1-6.33 3.51-.05.03c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45Z"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("5lacT", function(module, exports) {

$parcel$export(module.exports, "lockSvg", function () { return $0100e26655db78ef$export$70be6a782cc364be; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $0100e26655db78ef$export$70be6a782cc364be = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#C653C6" rx="3" />
  <path
    fill="#fff"
    d="M20.03 15.22C20 15.6 20 16.07 20 17v2.8c0 1.14 0 1.7-.2 2.12-.15.31-.3.5-.58.71-.37.28-1.06.42-2.43.7-.59.12-1.11.29-1.6.51a9 9 0 0 0-4.35 4.36C10 30 10 32.34 10 37c0 4.66 0 7 .84 8.8a9 9 0 0 0 4.36 4.36C17 51 19.34 51 24 51h12c4.66 0 7 0 8.8-.84a9 9 0 0 0 4.36-4.36C50 44 50 41.66 50 37c0-4.66 0-7-.84-8.8a9 9 0 0 0-4.36-4.36c-.48-.22-1-.39-1.6-.5-1.36-.29-2.05-.43-2.42-.7-.27-.22-.43-.4-.58-.72-.2-.42-.2-.98-.2-2.11V17c0-.93 0-1.4-.03-1.78a9 9 0 0 0-8.19-8.19C31.4 7 30.93 7 30 7s-1.4 0-1.78.03a9 9 0 0 0-8.19 8.19Z"
  />
  <path
    fill="#E87DE8"
    d="M22 17c0-.93 0-1.4.04-1.78a7 7 0 0 1 6.18-6.18C28.6 9 29.07 9 30 9s1.4 0 1.78.04a7 7 0 0 1 6.18 6.18c.04.39.04.85.04 1.78v4.5a1.5 1.5 0 0 1-3 0V17c0-.93 0-1.4-.08-1.78a4 4 0 0 0-3.14-3.14C31.39 12 30.93 12 30 12s-1.4 0-1.78.08a4 4 0 0 0-3.14 3.14c-.08.39-.08.85-.08 1.78v4.5a1.5 1.5 0 0 1-3 0V17Z"
  />
  <path
    fill="#E87DE8"
    fill-rule="evenodd"
    d="M12 36.62c0-4.32 0-6.48.92-8.09a7 7 0 0 1 2.61-2.61C17.14 25 19.3 25 23.62 25h6.86c.46 0 .7 0 .9.02 2.73.22 4.37 2.43 4.62 4.98.27-2.7 2.11-5 5.02-5A6.98 6.98 0 0 1 48 31.98v5.4c0 4.32 0 6.48-.92 8.09a7 7 0 0 1-2.61 2.61c-1.61.92-3.77.92-8.09.92h-5.86c-.46 0-.7 0-.9-.02-2.73-.22-4.37-2.43-4.62-4.98-.26 2.58-1.94 4.82-4.71 4.99l-.7.01c-.55 0-.82 0-1.05-.02a7 7 0 0 1-6.52-6.52c-.02-.23-.02-.5-.02-1.05v-4.79Zm21.24-.27a4 4 0 1 0-6.48 0 31.28 31.28 0 0 1 1.57 2.23c.17.4.17.81.17 1.24V42.5a1.5 1.5 0 0 0 3 0V39.82c0-.43 0-.85.17-1.24.09-.2.58-.87 1.57-2.23Z"
    clip-rule="evenodd"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("cbYVN", function(module, exports) {

$parcel$export(module.exports, "loginSvg", function () { return $8e05c6cb6f0b784b$export$c9aa74efff8430c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $8e05c6cb6f0b784b$export$c9aa74efff8430c = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#EB8B47"
      d="M0 24.9c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02 0 15.65 0 24.9 0h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.02 60 15.65 60 24.9v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6C48.98 60 44.35 60 35.1 60H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 48.98 0 44.35 0 35.1V24.9Z"
    />
    <path
      stroke="#062B2B"
      stroke-opacity=".1"
      d="M.5 24.9c0-4.64 0-8.08.24-10.8.25-2.7.73-4.65 1.66-6.28A14.5 14.5 0 0 1 7.82 2.4C9.46 1.47 11.39 1 14.1.74A133 133 0 0 1 24.9.5h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.66a14.5 14.5 0 0 1 5.42 5.42c.93 1.63 1.41 3.57 1.66 6.28.24 2.72.24 6.16.24 10.8v10.2c0 4.63 0 8.08-.24 10.8-.25 2.7-.73 4.64-1.66 6.28a14.5 14.5 0 0 1-5.42 5.41c-1.63.94-3.57 1.42-6.28 1.67-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.67a14.5 14.5 0 0 1-5.42-5.4C1.47 50.53 1 48.6.74 45.88A133 133 0 0 1 .5 35.1V24.9Z"
    />
    <path
      fill="#FF974C"
      stroke="#fff"
      stroke-width="2"
      d="M39.2 29.2a13 13 0 1 0-18.4 0l1.3 1.28a12.82 12.82 0 0 1 2.1 2.39 6 6 0 0 1 .6 1.47c.2.76.2 1.56.2 3.17v11.24c0 1.08 0 1.61.13 2.12a4 4 0 0 0 .41.98c.26.45.64.83 1.4 1.6l.3.29c.65.65.98.98 1.36 1.09.26.07.54.07.8 0 .38-.11.7-.44 1.36-1.1l3.48-3.47c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.47-.48c-.65-.65-.98-.98-1.09-1.36a1.5 1.5 0 0 1 0-.8c.1-.38.44-.7 1.1-1.36l.47-.48c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.48-.5c-.65-.64-.98-.97-1.08-1.35a1.5 1.5 0 0 1 0-.79c.1-.38.42-.7 1.06-1.36l5.46-5.55Z"
    />
    <circle cx="30" cy="17" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("ysPwh", function(module, exports) {

$parcel$export(module.exports, "networkSvg", function () { return $06798a1eeacb7b5e$export$1a3efa751581ed0a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $06798a1eeacb7b5e$export$1a3efa751581ed0a = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#00ACE6" rx="30" />
    <circle cx="64" cy="39" r="50" fill="#1AC6FF" stroke="#fff" stroke-width="2" />
    <circle cx="78" cy="30" r="50" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="72" cy="15" r="35" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-17" r="45" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-5" r="50" stroke="#fff" stroke-width="2" />
    <circle cx="30" cy="45" r="4" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="39.5" cy="27.5" r="4" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="16" cy="24" r="4" fill="#19C6FF" stroke="#fff" stroke-width="2" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("26xpP", function(module, exports) {

$parcel$export(module.exports, "nftSvg", function () { return $18860fee998e2918$export$1c5022265b1a9f1f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $18860fee998e2918$export$1c5022265b1a9f1f = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="3" />
    <path
      fill="#E87DE8"
      stroke="#fff"
      stroke-width="2"
      d="M52.1 47.34c0-4.24-1.44-9.55-5.9-12.4a2.86 2.86 0 0 0-1.6-3.89v-.82c0-1.19-.52-2.26-1.35-3a4.74 4.74 0 0 0-2.4-6.26v-5.5a11.31 11.31 0 1 0-22.63 0v2.15a3.34 3.34 0 0 0-1.18 5.05 4.74 4.74 0 0 0-.68 6.44A5.22 5.22 0 0 0 14 35.92c-3.06 4.13-6.1 8.3-6.1 15.64 0 2.67.37 4.86.74 6.39a20.3 20.3 0 0 0 .73 2.39l.02.04v.01l.92-.39-.92.4.26.6h38.26l.3-.49-.87-.51.86.5.02-.01.03-.07a16.32 16.32 0 0 0 .57-1.05c.36-.72.85-1.74 1.33-2.96a25.51 25.51 0 0 0 1.94-9.07Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M26.5 29.5c-3-.5-5.5-3-5.5-7v-7c0-.47 0-.7.03-.9a3 3 0 0 1 2.58-2.57c.2-.03.42-.03.89-.03 2 0 2.5-2.5 2.5-2.5s0 2.5 2.5 2.5c1.4 0 2.1 0 2.65.23a3 3 0 0 1 1.62 1.62c.23.55.23 1.25.23 2.65v6c0 4-3 7-6.5 7 1.35.23 4 0 6.5-2v9.53C34 38.5 31.5 40 28 40s-6-1.5-6-2.97L24 34l2.5 1.5v-6ZM26 47h4.5c2.5 0 3 4 3 5.5h-3l-1-1.5H26v-4Zm-6.25 5.5H24V57h-8c0-1 1-4.5 3.75-4.5Z"
      clip-rule="evenodd"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="3" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("hbEzj", function(module, exports) {

$parcel$export(module.exports, "nounSvg", function () { return $c832eed1114ba4a2$export$3bfdd1a0cad16fad; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $c832eed1114ba4a2$export$3bfdd1a0cad16fad = (0, $7pRM7.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#794CFF" rx="3" />
  <path
    fill="#987DE8"
    stroke="#fff"
    stroke-width="2"
    d="M33 22.5v-1H16v5H8.5V36H13v-5h3v7.5h17V31h1v7.5h17v-17H34v5h-1v-4Z"
  />
  <path fill="#fff" d="M37.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M42.5 25h5v10h-5z" />
  <path fill="#fff" d="M19.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M24.5 25h5v10h-5z" />
  <path fill="#fff" d="M12 30.5h4V37h-4v-6.5Z" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("lqPWQ", function(module, exports) {

$parcel$export(module.exports, "profileSvg", function () { return $f9a45284c8c19525$export$f1a0ec1d6376e59; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $f9a45284c8c19525$export$f1a0ec1d6376e59 = (0, $7pRM7.svg)`<svg
  viewBox="0 0 60 60"
  fill="none"
>
  <g clip-path="url(#1)">
    <rect width="60" height="60" rx="30" fill="#00ACE6" />
    <path
      d="M59 73C59 89.0163 46.0163 102 30 102C13.9837 102 1 89.0163 1 73C1 56.9837 12 44 30 44C48 44 59 56.9837 59 73Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M18.6904 19.9015C19.6264 15.3286 23.3466 11.8445 27.9708 11.2096C29.3231 11.024 30.6751 11.0238 32.0289 11.2096C36.6532 11.8445 40.3733 15.3286 41.3094 19.9015C41.4868 20.7681 41.6309 21.6509 41.7492 22.5271C41.8811 23.5041 41.8811 24.4944 41.7492 25.4715C41.6309 26.3476 41.4868 27.2304 41.3094 28.097C40.3733 32.6699 36.6532 36.154 32.0289 36.7889C30.6772 36.9744 29.3216 36.9743 27.9708 36.7889C23.3466 36.154 19.6264 32.6699 18.6904 28.097C18.513 27.2304 18.3689 26.3476 18.2506 25.4715C18.1186 24.4944 18.1186 23.5041 18.2506 22.5271C18.3689 21.6509 18.513 20.7681 18.6904 19.9015Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="24.5" cy="23.5" r="1.5" fill="white" />
    <circle cx="35.5" cy="23.5" r="1.5" fill="white" />
    <path
      d="M31 20L28 28H32"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="white" stroke-opacity="0.1" />
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" rx="30" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("9oXgV", function(module, exports) {

$parcel$export(module.exports, "systemSvg", function () { return $6d845523e42f5138$export$5752b741a746ef10; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $6d845523e42f5138$export$5752b741a746ef10 = (0, $7pRM7.svg)`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#1)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#794CFF"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M35.1403 31.5016C35.1193 30.9637 35.388 30.4558 35.8446 30.1707C36.1207 29.9982 36.4761 29.8473 36.7921 29.7685C37.3143 29.6382 37.8664 29.7977 38.2386 30.1864C38.8507 30.8257 39.3004 31.6836 39.8033 32.408C40.2796 33.0942 41.4695 33.2512 41.9687 32.5047C42.4839 31.7341 42.9405 30.8229 43.572 30.1399C43.9375 29.7447 44.4866 29.5756 45.0111 29.6967C45.3283 29.7701 45.6863 29.9147 45.9655 30.0823C46.4269 30.3595 46.7045 30.8626 46.6928 31.4008C46.6731 32.3083 46.3764 33.2571 46.2158 34.1473C46.061 35.0048 46.9045 35.8337 47.7592 35.664C48.6464 35.4878 49.5899 35.1747 50.497 35.1391C51.0348 35.1181 51.5427 35.3868 51.8279 35.8433C52.0004 36.1195 52.1513 36.4749 52.2301 36.7908C52.3604 37.3131 52.2009 37.8651 51.8121 38.2374C51.1729 38.8495 50.3151 39.2991 49.5908 39.8019C48.9046 40.2782 48.7473 41.4683 49.4939 41.9675C50.2644 42.4827 51.1757 42.9393 51.8587 43.5708C52.2539 43.9362 52.423 44.4854 52.3018 45.0099C52.2285 45.3271 52.0839 45.6851 51.9162 45.9642C51.6391 46.4257 51.1359 46.7032 50.5978 46.6916C49.6903 46.6719 48.7417 46.3753 47.8516 46.2146C46.9939 46.0598 46.1648 46.9035 46.3346 47.7583C46.5108 48.6454 46.8239 49.5888 46.8594 50.4958C46.8805 51.0336 46.6117 51.5415 46.1552 51.8267C45.879 51.9992 45.5236 52.15 45.2077 52.2289C44.6854 52.3592 44.1334 52.1997 43.7611 51.8109C43.1491 51.1718 42.6996 50.314 42.1968 49.5897C41.7203 48.9034 40.5301 48.7463 40.0309 49.493C39.5157 50.2634 39.0592 51.1746 38.4278 51.8574C38.0623 52.2527 37.5132 52.4218 36.9887 52.3006C36.6715 52.2273 36.3135 52.0826 36.0343 51.915C35.5729 51.6379 35.2953 51.1347 35.307 50.5966C35.3267 49.6891 35.6233 48.7405 35.7839 47.8505C35.9388 46.9928 35.0951 46.1636 34.2402 46.3334C33.3531 46.5096 32.4098 46.8227 31.5028 46.8582C30.9649 46.8793 30.457 46.6105 30.1719 46.154C29.9994 45.8778 29.8485 45.5224 29.7697 45.2065C29.6394 44.6842 29.7989 44.1322 30.1877 43.7599C30.8269 43.1479 31.6847 42.6982 32.4091 42.1954C33.0954 41.7189 33.2522 40.5289 32.5056 40.0297C31.7351 39.5145 30.824 39.058 30.1411 38.4265C29.7459 38.0611 29.5768 37.5119 29.698 36.9875C29.7713 36.6702 29.9159 36.3122 30.0836 36.0331C30.3607 35.5717 30.8638 35.2941 31.402 35.3058C32.3095 35.3255 33.2583 35.6221 34.1485 35.7828C35.006 35.9376 35.8349 35.094 35.6652 34.2393C35.489 33.3521 35.1759 32.4087 35.1403 31.5016Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M20.7706 8.22357C20.9036 7.51411 21.5231 7 22.2449 7H23.7551C24.4769 7 25.0964 7.51411 25.2294 8.22357C25.5051 9.69403 25.4829 11.6321 27.1202 12.2606C27.3092 12.3331 27.4958 12.4105 27.6798 12.4926C29.2818 13.2072 30.6374 11.8199 31.8721 10.9752C32.4678 10.5676 33.2694 10.6421 33.7798 11.1525L34.8477 12.2204C35.3581 12.7308 35.4326 13.5323 35.025 14.128C34.1802 15.3627 32.7931 16.7183 33.5077 18.3202C33.5898 18.5043 33.6672 18.6909 33.7398 18.88C34.3683 20.5171 36.3061 20.4949 37.7764 20.7706C38.4859 20.9036 39 21.5231 39 22.2449V23.7551C39 24.4769 38.4859 25.0964 37.7764 25.2294C36.3061 25.5051 34.3685 25.483 33.7401 27.1201C33.6675 27.3093 33.59 27.4961 33.5079 27.6803C32.7934 29.282 34.1803 30.6374 35.025 31.8719C35.4326 32.4677 35.3581 33.2692 34.8477 33.7796L33.7798 34.8475C33.2694 35.3579 32.4678 35.4324 31.8721 35.0248C30.6376 34.1801 29.2823 32.7934 27.6806 33.508C27.4962 33.5903 27.3093 33.6678 27.12 33.7405C25.483 34.3688 25.5051 36.3062 25.2294 37.7764C25.0964 38.4859 24.4769 39 23.7551 39H22.2449C21.5231 39 20.9036 38.4859 20.7706 37.7764C20.4949 36.3062 20.517 34.3688 18.88 33.7405C18.6908 33.6678 18.5039 33.5903 18.3196 33.5081C16.7179 32.7936 15.3625 34.1804 14.1279 35.0251C13.5322 35.4327 12.7307 35.3582 12.2203 34.8478L11.1524 33.7799C10.642 33.2695 10.5675 32.4679 10.9751 31.8722C11.8198 30.6376 13.2067 29.2822 12.4922 27.6804C12.41 27.4962 12.3325 27.3093 12.2599 27.1201C11.6315 25.483 9.69392 25.5051 8.22357 25.2294C7.51411 25.0964 7 24.4769 7 23.7551V22.2449C7 21.5231 7.51411 20.9036 8.22357 20.7706C9.69394 20.4949 11.6317 20.5171 12.2602 18.88C12.3328 18.6909 12.4103 18.5042 12.4924 18.3201C13.207 16.7181 11.8198 15.3625 10.975 14.1278C10.5674 13.5321 10.6419 12.7305 11.1523 12.2201L12.2202 11.1522C12.7306 10.6418 13.5322 10.5673 14.1279 10.9749C15.3626 11.8197 16.7184 13.2071 18.3204 12.4925C18.5044 12.4105 18.6909 12.3331 18.8799 12.2606C20.5171 11.6321 20.4949 9.69403 20.7706 8.22357Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="23" cy="23" r="6" fill="#794CFF" stroke="white" stroke-width="2" />
    <circle cx="41" cy="41" r="4" fill="#794CFF" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("6FvFh", function(module, exports) {

$parcel$export(module.exports, "coinbaseSvg", function () { return $4daf22678a809bac$export$8661898196b83c8c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $4daf22678a809bac$export$8661898196b83c8c = (0, $7pRM7.svg)`<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <g clip-path="url(#clip0_187_29)">
    <path d="M1.18187e-05 15.8055C1.18187e-05 9.8015 -5.19442e-07 6.91338 1.69991e-08 0C4.5 3.72236e-05 9.62249 0 16.5 0L23.5 4.31399e-05C29.9349 4.31399e-05 35.5 0.000206332 40 3.73468e-05C40 2.77754 40 9.36708 40 15.8055V22.8364C40 29.2647 40 33.7962 40 40C31.5 40 29.8337 40 23.4 40H16.6C10.5092 40 6.50004 40 4.04289e-05 40C3.05176e-05 32.2453 1.18187e-05 29.6382 1.18187e-05 22.8364V15.8055Z" fill="#0052FF"/>
    <path d="M20.0236 26.5C16.4342 26.5 13.5236 23.5931 13.5236 20C13.5236 16.4069 16.4342 13.5 20.0236 13.5C23.2411 13.5 25.9134 15.8472 26.4261 18.9167H32.9731C32.4206 12.2433 26.8342 7 20.02 7C12.8411 7 7.02002 12.8211 7.02002 20C7.02002 27.1789 12.8411 33 20.02 33C26.8342 33 32.4206 27.7567 32.9731 21.0833H26.4225C25.9061 24.1528 23.2411 26.5 20.0236 26.5Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_187_29">
      <rect width="40" height="40" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

});

parcelRegister("1Ng2D", function(module, exports) {

$parcel$export(module.exports, "moonpaySvg", function () { return $14e6cf89175fc8a4$export$a9ed45040996931e; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $14e6cf89175fc8a4$export$a9ed45040996931e = (0, $7pRM7.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#7D00FF"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        d="M28.306 15.381a3.69 3.69 0 1 0 0-7.381 3.69 3.69 0 0 0 0 7.381ZM16.987 32a8.991 8.991 0 1 1 .016-17.983A8.991 8.991 0 0 1 16.988 32Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("j0KR9", function(module, exports) {

$parcel$export(module.exports, "stripeSvg", function () { return $dd725d18e2d0cf8f$export$e3fac6a9cb8f9c7b; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $dd725d18e2d0cf8f$export$e3fac6a9cb8f9c7b = (0, $7pRM7.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#635BFF"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.299 15.147c0-1.028.844-1.424 2.242-1.424 2.004 0 4.536.607 6.54 1.688V9.213C24.892 8.343 22.73 8 20.541 8c-5.354 0-8.915 2.796-8.915 7.464 0 7.279 10.022 6.118 10.022 9.257 0 1.213-1.055 1.609-2.531 1.609-2.19 0-4.985-.897-7.2-2.11v6.277a18.283 18.283 0 0 0 7.2 1.503c5.485 0 9.257-2.716 9.257-7.437-.027-7.86-10.075-6.462-10.075-9.416Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("5ySJS", function(module, exports) {

$parcel$export(module.exports, "paypalSvg", function () { return $40ca96bcb796e204$export$aa910b71a02cb299; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $40ca96bcb796e204$export$aa910b71a02cb299 = (0, $7pRM7.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#fff"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        d="M18.606 12.642a.781.781 0 0 0-.771.66l-1.281 8.125a.78.78 0 0 1 .77-.66h3.755a7.668 7.668 0 0 0 7.57-6.49 6.26 6.26 0 0 0 .075-.843c-.96-.504-2.089-.792-3.325-.792h-6.793Z"
        fill="#001C64"
      />
      <path
        d="M28.724 13.434c-.006.282-.03.564-.075.843a7.668 7.668 0 0 1-7.57 6.491h-3.754a.78.78 0 0 0-.771.66l-1.916 12.15a.634.634 0 0 0 .626.734h4.075a.781.781 0 0 0 .77-.66l1.074-6.807a.781.781 0 0 1 .772-.66h2.4a7.668 7.668 0 0 0 7.57-6.491c.415-2.651-.92-5.064-3.201-6.26Z"
        fill="#0070E0"
      />
      <path
        d="M13.977 7.226a.78.78 0 0 0-.771.658l-3.198 20.277a.634.634 0 0 0 .626.733h4.742l1.178-7.467 1.281-8.125a.782.782 0 0 1 .771-.66H25.4c1.237 0 2.364.289 3.325.792.065-3.4-2.74-6.208-6.599-6.208h-8.148Z"
        fill="#003087"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("54Cbz", function(module, exports) {

$parcel$export(module.exports, "onrampCardSvg", function () { return $3b1af2594b2302ea$export$bfa60d0bcc3bcad2; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $3b1af2594b2302ea$export$bfa60d0bcc3bcad2 = (0, $7pRM7.svg)`<svg width="60" height="60" viewBox="0 0 60 60" fill="none">
<g clip-path="url(#clip0_13859_31161)">
  <path d="M0 24.8995C0 15.6481 0 11.0223 1.97053 7.56763C3.3015 5.2342 5.23468 3.30101 7.56812 1.97004C11.0228 -0.000488281 15.6485 -0.000488281 24.9 -0.000488281H35.1C44.3514 -0.000488281 48.9772 -0.000488281 52.4319 1.97004C54.7653 3.30101 56.6985 5.2342 58.0295 7.56763C60 11.0223 60 15.6481 60 24.8995V35.0995C60 44.351 60 48.9767 58.0295 52.4314C56.6985 54.7648 54.7653 56.698 52.4319 58.029C48.9772 59.9995 44.3514 59.9995 35.1 59.9995H24.9C15.6485 59.9995 11.0228 59.9995 7.56812 58.029C5.23468 56.698 3.3015 54.7648 1.97053 52.4314C0 48.9767 0 44.351 0 35.0995V24.8995Z" fill="#EB8B47"/>
  <path d="M0.5 24.8995C0.5 20.2647 0.50047 16.8216 0.744315 14.1045C0.987552 11.3941 1.46987 9.45455 2.40484 7.81536C3.69145 5.55971 5.56019 3.69096 7.81585 2.40435C9.45504 1.46938 11.3946 0.987064 14.105 0.743826C16.8221 0.499981 20.2652 0.499512 24.9 0.499512H35.1C39.7348 0.499512 43.1779 0.499981 45.895 0.743826C48.6054 0.987064 50.545 1.46938 52.1841 2.40435C54.4398 3.69096 56.3086 5.55971 57.5952 7.81536C58.5301 9.45455 59.0124 11.3941 59.2557 14.1045C59.4995 16.8216 59.5 20.2647 59.5 24.8995V35.0995C59.5 39.7343 59.4995 43.1774 59.2557 45.8945C59.0124 48.6049 58.5301 50.5445 57.5952 52.1837C56.3086 54.4393 54.4398 56.3081 52.1841 57.5947C50.545 58.5296 48.6054 59.012 45.895 59.2552C43.1779 59.499 39.7348 59.4995 35.1 59.4995H24.9C20.2652 59.4995 16.8221 59.499 14.105 59.2552C11.3946 59.012 9.45504 58.5296 7.81585 57.5947C5.56019 56.3081 3.69145 54.4393 2.40484 52.1837C1.46987 50.5445 0.987552 48.6049 0.744315 45.8945C0.50047 43.1774 0.5 39.7343 0.5 35.0995V24.8995Z" stroke="#141414" stroke-opacity="0.1"/>
  <path d="M13 26.0335C13 21.7838 13 19.659 14.0822 18.1694C14.4318 17.6883 14.8548 17.2653 15.3359 16.9157C16.8255 15.8335 18.9503 15.8335 23.2 15.8335H36.8C41.0497 15.8335 43.1745 15.8335 44.6641 16.9157C45.1452 17.2653 45.5682 17.6883 45.9178 18.1694C47 19.659 47 21.7838 47 26.0335V33.9668C47 38.2165 47 40.3414 45.9178 41.831C45.5682 42.312 45.1452 42.7351 44.6641 43.0846C43.1745 44.1668 41.0497 44.1668 36.8 44.1668H23.2C18.9503 44.1668 16.8255 44.1668 15.3359 43.0846C14.8548 42.7351 14.4318 42.312 14.0822 41.831C13 40.3414 13 38.2165 13 33.9668V26.0335Z" fill="#FF974C" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M39.5 36.667H36.6666" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M45.2 23.0645H14.8C14.0501 23.0645 13.6751 23.0645 13.4122 23.2554C13.3273 23.3171 13.2527 23.3918 13.191 23.4767C13 23.7395 13 24.1145 13 24.8645V27.2645C13 28.0144 13 28.3894 13.191 28.6522C13.2527 28.7371 13.3273 28.8118 13.4122 28.8735C13.6751 29.0645 14.0501 29.0645 14.8 29.0645H45.2C45.9499 29.0645 46.3249 29.0645 46.5878 28.8735C46.6727 28.8118 46.7473 28.7371 46.809 28.6522C47 28.3894 47 28.0144 47 27.2645V24.8645C47 24.1145 47 23.7395 46.809 23.4767C46.7473 23.3918 46.6727 23.3171 46.5878 23.2554C46.3249 23.0645 45.9499 23.0645 45.2 23.0645Z" fill="white" fill-opacity="0.4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
  <clipPath id="clip0_13859_31161">
    <rect width="60" height="60" fill="white"/>
  </clipPath>
</defs>
</svg>`;

});

parcelRegister("lRU4h", function(module, exports) {

$parcel$export(module.exports, "googleSvg", function () { return $feba0a26570efa2d$export$62a66155552ed9b0; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $feba0a26570efa2d$export$62a66155552ed9b0 = (0, $7pRM7.svg)`<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="30" fill="#1DC956"/>
  <rect x="0.5" y="0.5" width="63" height="63" rx="29.5" stroke="#141414" stroke-opacity="0.1"/>
  <path d="M32.4053 19.8031C35.3901 19.8031 38.0431 20.8349 40.1619 22.8247L45.9656 17.0211C42.4465 13.7416 37.8773 11.7333 32.4053 11.7333C24.4829 11.7333 17.6475 16.2841 14.3127 22.9168L21.056 28.1493C22.6589 23.359 27.136 19.8031 32.4053 19.8031Z" fill="#1DC956" stroke="white" stroke-width="2" stroke-linejoin="round"/>
  <path d="M32.4053 52.2667C37.8773 52.2667 42.465 50.4611 45.8182 47.3658L39.2407 42.2623C37.4351 43.4783 35.1321 44.2153 32.4053 44.2153C27.136 44.2153 22.6589 40.6594 21.056 35.8691L14.3127 41.1016C17.6475 47.7159 24.4829 52.2667 32.4053 52.2667Z" fill="#2BEE6C"/>
  <path d="M21.056 35.8507L19.5636 36.993L14.3127 41.0832M39.2407 42.2623L45.8182 47.3658C42.465 50.4611 37.8773 52.2667 32.4053 52.2667C24.4829 52.2667 17.6475 47.7159 14.3127 41.1016L21.056 35.8691C22.6589 40.6594 27.136 44.2153 32.4053 44.2153C35.1321 44.2153 37.4351 43.4783 39.2407 42.2623Z" stroke="white" stroke-width="2" stroke-linejoin="round"/>
  <path d="M51.8613 32.4606C51.8613 31.0235 51.7323 29.6417 51.4928 28.3151H32.4053V36.1638H43.3124C42.8334 38.688 41.3963 40.8252 39.2407 42.2623L45.8181 47.3658C49.6503 43.8283 51.8613 38.6327 51.8613 32.4606Z" fill="#1FAD7E" stroke="white" stroke-width="2" stroke-linejoin="round"/>
  <path d="M21.056 35.8507C20.6507 34.6347 20.4111 33.345 20.4111 32C20.4111 30.655 20.6507 29.3653 21.056 28.1493L14.3127 22.9169C12.9309 25.6437 12.1387 28.7205 12.1387 32C12.1387 35.2795 12.9309 38.3564 14.3127 41.0831L19.5636 36.993L21.056 35.8507Z" fill="#86F999"/>
  <path d="M21.056 35.8691L14.3127 41.1016M21.056 35.8507C20.6507 34.6347 20.4111 33.345 20.4111 32C20.4111 30.655 20.6507 29.3653 21.056 28.1493L14.3127 22.9169C12.9309 25.6437 12.1387 28.7205 12.1387 32C12.1387 35.2795 12.9309 38.3564 14.3127 41.0831L19.5636 36.993L21.056 35.8507Z" stroke="white" stroke-width="2" stroke-linejoin="round"/>
</svg>
`;

});

parcelRegister("7y1a6", function(module, exports) {

$parcel$export(module.exports, "pencilSvg", function () { return $57ec9c194fe252c9$export$e79a0508cc0c8f91; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $57ec9c194fe252c9$export$e79a0508cc0c8f91 = (0, $7pRM7.svg)`<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_241_31635)">
    <path d="M0 26.5595C0 16.6913 0 11.7572 2.1019 8.07217C3.5216 5.58317 5.58366 3.52111 8.07266 2.10141C11.7577 -0.000488281 16.6918 -0.000488281 26.56 -0.000488281H37.44C47.3082 -0.000488281 52.2423 -0.000488281 55.9273 2.10141C58.4163 3.52111 60.4784 5.58317 61.8981 8.07217C64 11.7572 64 16.6913 64 26.5595V37.4395C64 47.3077 64 52.2418 61.8981 55.9268C60.4784 58.4158 58.4163 60.4779 55.9273 61.8976C52.2423 63.9995 47.3082 63.9995 37.44 63.9995H26.56C16.6918 63.9995 11.7577 63.9995 8.07266 61.8976C5.58366 60.4779 3.5216 58.4158 2.1019 55.9268C0 52.2418 0 47.3077 0 37.4395V26.5595Z" fill="#EB8B47"/>
    <path d="M0.5 26.5595C0.5 21.6163 0.50047 17.942 0.760736 15.0418C1.02039 12.1485 1.53555 10.0742 2.53621 8.3199C3.91155 5.90869 5.90917 3.91106 8.32039 2.53572C10.0747 1.53506 12.1489 1.01991 15.0423 0.760247C17.9425 0.499981 21.6168 0.499512 26.56 0.499512H37.44C42.3832 0.499512 46.0575 0.499981 48.9577 0.760247C51.8511 1.01991 53.9253 1.53506 55.6796 2.53572C58.0908 3.91106 60.0885 5.90869 61.4638 8.3199C62.4645 10.0742 62.9796 12.1485 63.2393 15.0418C63.4995 17.942 63.5 21.6163 63.5 26.5595V37.4395C63.5 42.3827 63.4995 46.057 63.2393 48.9572C62.9796 51.8506 62.4645 53.9248 61.4638 55.6791C60.0885 58.0903 58.0908 60.088 55.6796 61.4633C53.9253 62.464 51.8511 62.9791 48.9577 63.2388C46.0575 63.499 42.3832 63.4995 37.44 63.4995H26.56C21.6168 63.4995 17.9425 63.499 15.0423 63.2388C12.1489 62.9791 10.0747 62.464 8.32039 61.4633C5.90917 60.088 3.91155 58.0903 2.53621 55.6791C1.53555 53.9248 1.02039 51.8506 0.760736 48.9572C0.50047 46.057 0.5 42.3827 0.5 37.4395V26.5595Z" stroke="#141414" stroke-opacity="0.1"/>
    <path d="M28.1042 49.2329L13.1024 51.2077L15.0772 36.2059L37.1015 14.1815C39.2441 12.039 40.3154 10.9677 41.5718 10.624C42.4205 10.3918 43.3159 10.3918 44.1645 10.624C45.421 10.9677 46.4922 12.039 48.6348 14.1815L50.1286 15.6753C52.2711 17.8179 53.3424 18.8891 53.6861 20.1456C53.9183 20.9942 53.9183 21.8896 53.6861 22.7383C53.3424 23.9947 52.2711 25.066 50.1286 27.2086L28.1042 49.2329Z" fill="#FF974C" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M38.5962 20.5376L22.4199 36.7139" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M43.7727 25.714L27.5964 41.8903" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M22.3703 36.7635C19.3258 39.808 16.0198 36.6395 16.2616 35.0324" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M27.5466 41.9399C24.5034 44.9831 28.155 48.7098 29.2738 48.0475" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M27.5468 41.9398C23.428 46.0586 18.2516 40.8822 22.3704 36.7634" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8191 50.5214C15.4711 49.5823 14.728 48.8392 13.7889 48.4912" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M49.2862 29.5805L34.7275 15.0219" stroke="#E4E7E7" stroke-width="2" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_241_31635">
      <rect width="64" height="64" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;

});

parcelRegister("laAq3", function(module, exports) {

$parcel$export(module.exports, "lightbulbSvg", function () { return $f696c83f59bd470c$export$e3455d95c95b44fb; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $f696c83f59bd470c$export$e3455d95c95b44fb = (0, $7pRM7.svg)`<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_241_31636)">
    <path d="M0 26.5595C0 16.6913 0 11.7572 2.1019 8.07217C3.5216 5.58318 5.58366 3.52111 8.07266 2.10141C11.7577 -0.000488281 16.6918 -0.000488281 26.56 -0.000488281H37.44C47.3082 -0.000488281 52.2423 -0.000488281 55.9273 2.10141C58.4163 3.52111 60.4784 5.58318 61.8981 8.07217C64 11.7572 64 16.6913 64 26.5595V37.4395C64 47.3077 64 52.2418 61.8981 55.9269C60.4784 58.4159 58.4163 60.4779 55.9273 61.8976C52.2423 63.9995 47.3082 63.9995 37.44 63.9995H26.56C16.6918 63.9995 11.7577 63.9995 8.07266 61.8976C5.58366 60.4779 3.5216 58.4159 2.1019 55.9269C0 52.2418 0 47.3077 0 37.4395V26.5595Z" fill="#794CFF"/>
    <path d="M0.5 26.5595C0.5 21.6163 0.50047 17.942 0.760736 15.0418C1.02039 12.1485 1.53555 10.0742 2.53621 8.3199C3.91155 5.90869 5.90917 3.91106 8.32039 2.53572C10.0747 1.53506 12.1489 1.01991 15.0423 0.760247C17.9425 0.499981 21.6168 0.499512 26.56 0.499512H37.44C42.3832 0.499512 46.0575 0.499981 48.9577 0.760247C51.8511 1.01991 53.9253 1.53506 55.6796 2.53572C58.0908 3.91106 60.0885 5.90869 61.4638 8.3199C62.4645 10.0742 62.9796 12.1485 63.2393 15.0418C63.4995 17.942 63.5 21.6163 63.5 26.5595V37.4395C63.5 42.3827 63.4995 46.057 63.2393 48.9572C62.9796 51.8506 62.4645 53.9248 61.4638 55.6791C60.0885 58.0903 58.0908 60.088 55.6796 61.4633C53.9253 62.464 51.8511 62.9791 48.9577 63.2388C46.0575 63.499 42.3832 63.4995 37.44 63.4995H26.56C21.6168 63.4995 17.9425 63.499 15.0423 63.2388C12.1489 62.9791 10.0747 62.464 8.32039 61.4633C5.90917 60.088 3.91155 58.0903 2.53621 55.6791C1.53555 53.9248 1.02039 51.8506 0.760736 48.9572C0.50047 46.057 0.5 42.3827 0.5 37.4395V26.5595Z" stroke="#141414" stroke-opacity="0.1"/>
    <path d="M40 39.4595C44.7824 36.693 48 31.5222 48 25.6C48 16.7634 40.8366 9.59998 32 9.59998C23.1634 9.59998 16 16.7634 16 25.6C16 31.5222 19.2176 36.693 24 39.4595V45.8144H40V39.4595Z" fill="#906EF7"/>
    <path d="M24 49.9689C24 51.8192 24 52.7444 24.3941 53.4353C24.6603 53.902 25.0469 54.2886 25.5136 54.5548C26.2046 54.9489 27.1297 54.9489 28.98 54.9489H35.02C36.8703 54.9489 37.7954 54.9489 38.4864 54.5548C38.9531 54.2886 39.3397 53.902 39.6059 53.4353C40 52.7444 40 51.8192 40 49.9689V45.8144H24V49.9689Z" fill="#906EF7"/>
    <path d="M24 45.8144V39.4595C19.2176 36.693 16 31.5222 16 25.6C16 16.7634 23.1634 9.59998 32 9.59998C40.8366 9.59998 48 16.7634 48 25.6C48 31.5222 44.7824 36.693 40 39.4595V45.8144M24 45.8144H40M24 45.8144V49.9689C24 51.8192 24 52.7444 24.3941 53.4353C24.6603 53.902 25.0469 54.2886 25.5136 54.5548C26.2046 54.9489 27.1297 54.9489 28.98 54.9489H35.02C36.8703 54.9489 37.7954 54.9489 38.4864 54.5548C38.9531 54.2886 39.3397 53.902 39.6059 53.4353C40 52.7444 40 51.8192 40 49.9689V45.8144" stroke="white" stroke-width="2" stroke-linejoin="round"/>
    <path d="M24 49.9689C24 51.8192 24 52.7444 24.3941 53.4353C24.6603 53.902 25.0469 54.2886 25.5136 54.5548C26.2046 54.9489 27.1297 54.9489 28.98 54.9489H35.02C36.8703 54.9489 37.7954 54.9489 38.4864 54.5548C38.9531 54.2886 39.3397 53.902 39.6059 53.4353C40 52.7444 40 51.8192 40 49.9689V45.8144H24V49.9689Z" fill="#643CDD" stroke="white" stroke-width="2" stroke-linejoin="round"/>
    <path d="M29.6735 26.9101V29.1109H34.0753V26.9101C34.0753 25.6945 35.0607 24.7092 36.2762 24.7092C37.4917 24.7092 38.4771 25.6945 38.4771 26.9101C38.4771 28.1256 37.4917 29.1109 36.2762 29.1109H34.0753H29.6735H27.4726C26.2571 29.1109 25.2717 28.1256 25.2717 26.9101C25.2717 25.6945 26.2571 24.7092 27.4726 24.7092C28.6881 24.7092 29.6735 25.6945 29.6735 26.9101Z" fill="#906EF7"/>
    <path d="M29.6735 45.3183V26.9101C29.6735 25.6945 28.6881 24.7092 27.4726 24.7092V24.7092C26.2571 24.7092 25.2717 25.6945 25.2717 26.9101V26.9101C25.2717 28.1256 26.2571 29.1109 27.4726 29.1109H36.2762C37.4917 29.1109 38.4771 28.1256 38.4771 26.9101V26.9101C38.4771 25.6945 37.4917 24.7092 36.2762 24.7092V24.7092C35.0607 24.7092 34.0753 25.6945 34.0753 26.9101V45.3183" stroke="white" stroke-width="2" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_241_31636">
      <rect width="64" height="64" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;

});

parcelRegister("hTC5l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0751dad0bd21c29$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $d0751dad0bd21c29$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    width: var(--local-size);
    height: var(--local-size);
  }

  :host svg {
    width: 100%;
    height: 100%;
  }
`;

});


parcelRegister("kVtRm", function(module, exports) {

$parcel$export(module.exports, "WuiAccountButton", function () { return $f3c04b079180c298$export$bfec9622ebde4e9e; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("3TXJn");
var $2utwL = parcelRequire("2utwL");
parcelRequire("4BuLe");
parcelRequire("fCaEm");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $fIDM4 = parcelRequire("fIDM4");

var $ailZp = parcelRequire("ailZp");
parcelRequire("lQgB0");
parcelRequire("7XtWS");

var $8eKML = parcelRequire("8eKML");
var $f3c04b079180c298$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f3c04b079180c298$export$bfec9622ebde4e9e = class WuiAccountButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.networkSrc = undefined;
        this.avatarSrc = undefined;
        this.balance = undefined;
        this.isUnsupportedChain = undefined;
        this.disabled = false;
        this.address = "";
        this.profileName = "";
        this.charsStart = 4;
        this.charsEnd = 6;
    }
    render() {
        return (0, $7pRM7.html)`
      <button
        ?disabled=${this.disabled}
        class=${(0, $2utwL.ifDefined)(this.balance ? undefined : "local-no-balance")}
      >
        ${this.balanceTemplate()}
        <wui-flex gap="xxs" alignItems="center">
          <wui-avatar
            .imageSrc=${this.avatarSrc}
            alt=${this.address}
            address=${this.address}
          ></wui-avatar>
          <wui-text variant="paragraph-600" color="inherit">
            ${this.address ? (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.profileName || this.address,
            charsStart: this.profileName ? 18 : this.charsStart,
            charsEnd: this.profileName ? 0 : this.charsEnd,
            truncate: this.profileName ? "end" : "middle"
        }) : null}
          </wui-text>
        </wui-flex>
      </button>
    `;
    }
    balanceTemplate() {
        if (this.isUnsupportedChain) return (0, $7pRM7.html)` <wui-icon-box
          size="sm"
          iconColor="error-100"
          backgroundColor="error-100"
          icon="warningCircle"
        ></wui-icon-box>
        <wui-text variant="paragraph-600" color="inherit"> Switch Network</wui-text>`;
        if (this.balance) {
            const networkElement = this.networkSrc ? (0, $7pRM7.html)`<wui-image src=${this.networkSrc}></wui-image>` : (0, $7pRM7.html)`
            <wui-icon-box
              size="sm"
              iconColor="fg-200"
              backgroundColor="fg-300"
              icon="networkPlaceholder"
            ></wui-icon-box>
          `;
            return (0, $7pRM7.html)`
        ${networkElement}
        <wui-text variant="paragraph-600" color="inherit"> ${this.balance}</wui-text>
      `;
        }
        return null;
    }
};
$f3c04b079180c298$export$bfec9622ebde4e9e.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $8eKML.default)
];
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)()
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "networkSrc", void 0);
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)()
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "avatarSrc", void 0);
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)()
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "balance", void 0);
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "isUnsupportedChain", void 0);
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "disabled", void 0);
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)()
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "address", void 0);
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)()
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "profileName", void 0);
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)()
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "charsStart", void 0);
$f3c04b079180c298$var$__decorate([
    (0, $biDip.property)()
], $f3c04b079180c298$export$bfec9622ebde4e9e.prototype, "charsEnd", void 0);
$f3c04b079180c298$export$bfec9622ebde4e9e = $f3c04b079180c298$var$__decorate([
    (0, $ailZp.customElement)("wui-account-button")
], $f3c04b079180c298$export$bfec9622ebde4e9e);

});
parcelRegister("3TXJn", function(module, exports) {
$parcel$export(module.exports, "ifDefined", function () { return (parcelRequire("2utwL")).ifDefined; });
parcelRequire("2utwL");

});
parcelRegister("2utwL", function(module, exports) {

$parcel$export(module.exports, "ifDefined", function () { return $1d0549aa9d9ff4a7$export$f68dd208b5df064d; });

var $7pRM7 = parcelRequire("7pRM7");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1d0549aa9d9ff4a7$export$f68dd208b5df064d = (t)=>t ?? (0, $7pRM7.nothing);

});


parcelRegister("jrTpg", function(module, exports) {

$parcel$export(module.exports, "WuiFlex", function () { return $e28b847ce38f9c00$export$cb455767ea18ce95; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $fIDM4 = parcelRequire("fIDM4");

var $ailZp = parcelRequire("ailZp");

var $a8h66 = parcelRequire("a8h66");
var $e28b847ce38f9c00$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e28b847ce38f9c00$export$cb455767ea18ce95 = class WuiFlex extends (0, $cLW71.LitElement) {
    render() {
        this.style.cssText = `
      flex-direction: ${this.flexDirection};
      flex-wrap: ${this.flexWrap};
      flex-basis: ${this.flexBasis};
      flex-grow: ${this.flexGrow};
      flex-shrink: ${this.flexShrink};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.margin, 3)};
    `;
        return (0, $7pRM7.html)`<slot></slot>`;
    }
};
$e28b847ce38f9c00$export$cb455767ea18ce95.styles = [
    (0, $jVNMm.resetStyles),
    (0, $a8h66.default)
];
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "flexDirection", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "flexWrap", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "flexBasis", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "flexGrow", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "flexShrink", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "alignItems", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "justifyContent", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "columnGap", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "rowGap", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "gap", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "padding", void 0);
$e28b847ce38f9c00$var$__decorate([
    (0, $biDip.property)()
], $e28b847ce38f9c00$export$cb455767ea18ce95.prototype, "margin", void 0);
$e28b847ce38f9c00$export$cb455767ea18ce95 = $e28b847ce38f9c00$var$__decorate([
    (0, $ailZp.customElement)("wui-flex")
], $e28b847ce38f9c00$export$cb455767ea18ce95);

});
parcelRegister("fIDM4", function(module, exports) {

$parcel$export(module.exports, "UiHelperUtil", function () { return $b719d16adccd6c88$export$be769b74c01bc1bc; });
const $b719d16adccd6c88$export$be769b74c01bc1bc = {
    getSpacingStyles (spacing, index) {
        if (Array.isArray(spacing)) return spacing[index] ? `var(--wui-spacing-${spacing[index]})` : undefined;
        else if (typeof spacing === "string") return `var(--wui-spacing-${spacing})`;
        return undefined;
    },
    getFormattedDate (date) {
        return new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric"
        }).format(date);
    },
    getHostName (url) {
        try {
            const newUrl = new URL(url);
            return newUrl.hostname;
        } catch (error) {
            return "";
        }
    },
    getTruncateString ({ string: string, charsStart: charsStart, charsEnd: charsEnd, truncate: truncate }) {
        if (string.length <= charsStart + charsEnd) return string;
        if (truncate === "end") return `${string.substring(0, charsStart)}...`;
        else if (truncate === "start") return `...${string.substring(string.length - charsEnd)}`;
        return `${string.substring(0, Math.floor(charsStart))}...${string.substring(string.length - Math.floor(charsEnd))}`;
    },
    generateAvatarColors (address) {
        const hash = address.toLowerCase().replace(/^0x/iu, "");
        const baseColor = hash.substring(0, 6);
        const rgbColor = this.hexToRgb(baseColor);
        const masterBorderRadius = getComputedStyle(document.documentElement).getPropertyValue("--w3m-border-radius-master");
        const radius = Number(masterBorderRadius?.replace("px", ""));
        const edge = 100 - 3 * radius;
        const gradientCircle = `${edge}% ${edge}% at 65% 40%`;
        const colors = [];
        for(let i = 0; i < 5; i += 1){
            const tintedColor = this.tintColor(rgbColor, 0.15 * i);
            colors.push(`rgb(${tintedColor[0]}, ${tintedColor[1]}, ${tintedColor[2]})`);
        }
        return `
    --local-color-1: ${colors[0]};
    --local-color-2: ${colors[1]};
    --local-color-3: ${colors[2]};
    --local-color-4: ${colors[3]};
    --local-color-5: ${colors[4]};
    --local-radial-circle: ${gradientCircle}
   `;
    },
    hexToRgb (hex) {
        const bigint = parseInt(hex, 16);
        const r = bigint >> 16 & 255;
        const g = bigint >> 8 & 255;
        const b = bigint & 255;
        return [
            r,
            g,
            b
        ];
    },
    tintColor (rgb, tint) {
        const [r, g, b] = rgb;
        const tintedR = Math.round(r + (255 - r) * tint);
        const tintedG = Math.round(g + (255 - g) * tint);
        const tintedB = Math.round(b + (255 - b) * tint);
        return [
            tintedR,
            tintedG,
            tintedB
        ];
    },
    isNumber (character) {
        const regex = {
            number: /^[0-9]+$/u
        };
        return regex.number.test(character);
    },
    getColorTheme (theme) {
        if (theme) return theme;
        else if (typeof window !== "undefined" && window.matchMedia) {
            if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
            return "light";
        }
        return "dark";
    },
    splitBalance (input) {
        const parts = input.split(".");
        if (parts.length === 2) return [
            parts[0],
            parts[1]
        ];
        return [
            "0",
            "00"
        ];
    },
    roundNumber (number, threshold, fixed) {
        const roundedNumber = number.toString().length >= threshold ? Number(number).toFixed(fixed) : number;
        return roundedNumber;
    },
    formatNumberToLocalString (value, decimals = 2) {
        if (value === undefined) return "0.00";
        if (typeof value === "number") return value.toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
        return parseFloat(value).toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
    }
};

});

parcelRegister("a8h66", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7607e9f366233ad5$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $7607e9f366233ad5$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    width: inherit;
    height: inherit;
  }
`;

});


parcelRegister("lQgB0", function(module, exports) {

$parcel$export(module.exports, "WuiAvatar", function () { return $fe6b53e02d030578$export$21cc36693be5eb11; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("4BuLe");

var $jVNMm = parcelRequire("jVNMm");

var $fIDM4 = parcelRequire("fIDM4");

var $ailZp = parcelRequire("ailZp");

var $7bqdd = parcelRequire("7bqdd");
var $fe6b53e02d030578$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $fe6b53e02d030578$export$21cc36693be5eb11 = class WuiAvatar extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.alt = undefined;
        this.address = undefined;
        this.size = "xl";
    }
    render() {
        this.style.cssText = `
    --local-width: var(--wui-icon-box-size-${this.size});
    --local-height: var(--wui-icon-box-size-${this.size});
    `;
        return (0, $7pRM7.html)`${this.visualTemplate()}`;
    }
    visualTemplate() {
        if (this.imageSrc) {
            this.dataset["variant"] = "image";
            return (0, $7pRM7.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "avatar"}></wui-image>`;
        } else if (this.address) {
            this.dataset["variant"] = "generated";
            const cssColors = (0, $fIDM4.UiHelperUtil).generateAvatarColors(this.address);
            this.style.cssText += `\n ${cssColors}`;
            return null;
        }
        this.dataset["variant"] = "default";
        return null;
    }
};
$fe6b53e02d030578$export$21cc36693be5eb11.styles = [
    (0, $jVNMm.resetStyles),
    (0, $7bqdd.default)
];
$fe6b53e02d030578$var$__decorate([
    (0, $biDip.property)()
], $fe6b53e02d030578$export$21cc36693be5eb11.prototype, "imageSrc", void 0);
$fe6b53e02d030578$var$__decorate([
    (0, $biDip.property)()
], $fe6b53e02d030578$export$21cc36693be5eb11.prototype, "alt", void 0);
$fe6b53e02d030578$var$__decorate([
    (0, $biDip.property)()
], $fe6b53e02d030578$export$21cc36693be5eb11.prototype, "address", void 0);
$fe6b53e02d030578$var$__decorate([
    (0, $biDip.property)()
], $fe6b53e02d030578$export$21cc36693be5eb11.prototype, "size", void 0);
$fe6b53e02d030578$export$21cc36693be5eb11 = $fe6b53e02d030578$var$__decorate([
    (0, $ailZp.customElement)("wui-avatar")
], $fe6b53e02d030578$export$21cc36693be5eb11);

});
parcelRegister("7bqdd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ade4a9609c1d03$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $53ade4a9609c1d03$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    width: var(--local-width);
    height: var(--local-height);
    border-radius: var(--wui-border-radius-3xl);
    box-shadow: 0 0 0 8px var(--wui-color-gray-glass-005);
    overflow: hidden;
    position: relative;
  }

  :host([data-variant='generated']) {
    --mixed-local-color-1: var(--local-color-1);
    --mixed-local-color-2: var(--local-color-2);
    --mixed-local-color-3: var(--local-color-3);
    --mixed-local-color-4: var(--local-color-4);
    --mixed-local-color-5: var(--local-color-5);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host([data-variant='generated']) {
      --mixed-local-color-1: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-1)
      );
      --mixed-local-color-2: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-2)
      );
      --mixed-local-color-3: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-3)
      );
      --mixed-local-color-4: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-4)
      );
      --mixed-local-color-5: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-5)
      );
    }
  }

  :host([data-variant='generated']) {
    box-shadow: 0 0 0 8px var(--wui-color-gray-glass-005);
    background: radial-gradient(
      var(--local-radial-circle),
      #fff 0.52%,
      var(--mixed-local-color-5) 31.25%,
      var(--mixed-local-color-3) 51.56%,
      var(--mixed-local-color-2) 65.63%,
      var(--mixed-local-color-1) 82.29%,
      var(--mixed-local-color-4) 100%
    );
  }

  :host([data-variant='default']) {
    box-shadow: 0 0 0 8px var(--wui-color-gray-glass-005);
    background: radial-gradient(
      75.29% 75.29% at 64.96% 24.36%,
      #fff 0.52%,
      #f5ccfc 31.25%,
      #dba4f5 51.56%,
      #9a8ee8 65.63%,
      #6493da 82.29%,
      #6ebdea 100%
    );
  }
`;

});


parcelRegister("7XtWS", function(module, exports) {

$parcel$export(module.exports, "WuiIconBox", function () { return $5cb5464a50ad628a$export$df20651935c1141; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $8bCH6 = parcelRequire("8bCH6");
var $5cb5464a50ad628a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5cb5464a50ad628a$export$df20651935c1141 = class WuiIconBox extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.backgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.background = "transparent";
        this.border = false;
        this.borderColor = "wui-color-bg-125";
        this.icon = "copy";
    }
    render() {
        const iconSize = this.iconSize || this.size;
        const isLg = this.size === "lg";
        const isXl = this.size === "xl";
        const bgMix = isLg ? "12%" : "16%";
        const borderRadius = isLg ? "xxs" : isXl ? "s" : "3xl";
        const isGray = this.background === "gray";
        const isOpaque = this.background === "opaque";
        const isColorChange = this.backgroundColor === "accent-100" && isOpaque || this.backgroundColor === "success-100" && isOpaque || this.backgroundColor === "error-100" && isOpaque || this.backgroundColor === "inverse-100" && isOpaque;
        let bgValueVariable = `var(--wui-color-${this.backgroundColor})`;
        if (isColorChange) bgValueVariable = `var(--wui-icon-box-bg-${this.backgroundColor})`;
        else if (isGray) bgValueVariable = `var(--wui-color-gray-${this.backgroundColor})`;
        this.style.cssText = `
       --local-bg-value: ${bgValueVariable};
       --local-bg-mix: ${isColorChange || isGray ? `100%` : bgMix};
       --local-border-radius: var(--wui-border-radius-${borderRadius});
       --local-size: var(--wui-icon-box-size-${this.size});
       --local-border: ${this.borderColor === "wui-color-bg-125" ? `2px` : `1px`} solid ${this.border ? `var(--${this.borderColor})` : `transparent`}
   `;
        return (0, $7pRM7.html)` <wui-icon color=${this.iconColor} size=${iconSize} name=${this.icon}></wui-icon> `;
    }
};
$5cb5464a50ad628a$export$df20651935c1141.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $8bCH6.default)
];
$5cb5464a50ad628a$var$__decorate([
    (0, $biDip.property)()
], $5cb5464a50ad628a$export$df20651935c1141.prototype, "size", void 0);
$5cb5464a50ad628a$var$__decorate([
    (0, $biDip.property)()
], $5cb5464a50ad628a$export$df20651935c1141.prototype, "backgroundColor", void 0);
$5cb5464a50ad628a$var$__decorate([
    (0, $biDip.property)()
], $5cb5464a50ad628a$export$df20651935c1141.prototype, "iconColor", void 0);
$5cb5464a50ad628a$var$__decorate([
    (0, $biDip.property)()
], $5cb5464a50ad628a$export$df20651935c1141.prototype, "iconSize", void 0);
$5cb5464a50ad628a$var$__decorate([
    (0, $biDip.property)()
], $5cb5464a50ad628a$export$df20651935c1141.prototype, "background", void 0);
$5cb5464a50ad628a$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $5cb5464a50ad628a$export$df20651935c1141.prototype, "border", void 0);
$5cb5464a50ad628a$var$__decorate([
    (0, $biDip.property)()
], $5cb5464a50ad628a$export$df20651935c1141.prototype, "borderColor", void 0);
$5cb5464a50ad628a$var$__decorate([
    (0, $biDip.property)()
], $5cb5464a50ad628a$export$df20651935c1141.prototype, "icon", void 0);
$5cb5464a50ad628a$export$df20651935c1141 = $5cb5464a50ad628a$var$__decorate([
    (0, $ailZp.customElement)("wui-icon-box")
], $5cb5464a50ad628a$export$df20651935c1141);

});
parcelRegister("8bCH6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f5d5db1828d70cf$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $5f5d5db1828d70cf$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    background-color: var(--wui-color-gray-glass-020);
    border-radius: var(--local-border-radius);
    border: var(--local-border);
    box-sizing: content-box;
    width: var(--local-size);
    height: var(--local-size);
    min-height: var(--local-size);
    min-width: var(--local-size);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host {
      background-color: color-mix(in srgb, var(--local-bg-value) var(--local-bg-mix), transparent);
    }
  }
`;

});


parcelRegister("8eKML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff3ec2895b8aa29$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $5ff3ec2895b8aa29$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    background: var(--wui-color-gray-glass-002);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-color-gray-glass-005);
  }

  button:disabled {
    background: var(--wui-color-gray-glass-015);
  }

  button:disabled > wui-text {
    color: var(--wui-color-gray-glass-015);
  }

  button:disabled > wui-flex > wui-text {
    color: var(--wui-color-gray-glass-015);
  }

  button:disabled > wui-image,
  button:disabled > wui-flex > wui-avatar {
    filter: grayscale(1);
  }

  button:has(wui-image) {
    padding: var(--wui-spacing-3xs) var(--wui-spacing-3xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
  }

  wui-text {
    color: var(--wui-color-fg-100);
  }

  wui-flex > wui-text {
    color: var(--wui-color-fg-200);
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);
  }

  wui-flex {
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-color-gray-glass-005);
    background: var(--wui-color-gray-glass-005);
    padding: 4px var(--wui-spacing-m) 4px var(--wui-spacing-xxs);
  }

  button.local-no-balance {
    border-radius: 0px;
    border: none;
    background: transparent;
  }

  wui-avatar {
    width: 20px;
    height: 20px;
    box-shadow: 0 0 0 2px var(--wui-color-accent-glass-010);
  }

  @media (max-width: 500px) {
    button {
      gap: 0px;
      padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) !important;
      height: 32px;
    }
    wui-image,
    wui-icon-box,
    button > wui-text {
      visibility: hidden;
      width: 0px;
      height: 0px;
    }
    button {
      border-radius: 0px;
      border: none;
      background: transparent;
      padding: 0px;
    }
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }

    button:active:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }
  }
`;

});


parcelRegister("kVhUK", function(module, exports) {

$parcel$export(module.exports, "WuiAllWalletsImage", function () { return $f3b706e980171bb9$export$92558ad1dd06e644; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("3TXJn");
var $2utwL = parcelRequire("2utwL");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("cLomv");
parcelRequire("7XtWS");

var $5keWG = parcelRequire("5keWG");
var $f3b706e980171bb9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $f3b706e980171bb9$var$TOTAL_IMAGES = 4;
let $f3b706e980171bb9$export$92558ad1dd06e644 = class WuiAllWalletsImage extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.walletImages = [];
    }
    render() {
        const isPlaceholders = this.walletImages.length < $f3b706e980171bb9$var$TOTAL_IMAGES;
        return (0, $7pRM7.html)`${this.walletImages.slice(0, $f3b706e980171bb9$var$TOTAL_IMAGES).map(({ src: src, walletName: walletName })=>(0, $7pRM7.html)`
            <wui-wallet-image
              size="inherit"
              imageSrc=${src}
              name=${(0, $2utwL.ifDefined)(walletName)}
            ></wui-wallet-image>
          `)}
      ${isPlaceholders ? [
            ...Array($f3b706e980171bb9$var$TOTAL_IMAGES - this.walletImages.length)
        ].map(()=>(0, $7pRM7.html)` <wui-wallet-image size="inherit" name=""></wui-wallet-image>`) : null}
      <wui-flex>
        <wui-icon-box
          size="xxs"
          iconSize="xxs"
          iconcolor="success-100"
          backgroundcolor="success-100"
          icon="checkmark"
          background="opaque"
        ></wui-icon-box>
      </wui-flex>`;
    }
};
$f3b706e980171bb9$export$92558ad1dd06e644.styles = [
    (0, $jVNMm.resetStyles),
    (0, $5keWG.default)
];
$f3b706e980171bb9$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $f3b706e980171bb9$export$92558ad1dd06e644.prototype, "walletImages", void 0);
$f3b706e980171bb9$export$92558ad1dd06e644 = $f3b706e980171bb9$var$__decorate([
    (0, $ailZp.customElement)("wui-all-wallets-image")
], $f3b706e980171bb9$export$92558ad1dd06e644);

});
parcelRegister("cLomv", function(module, exports) {

$parcel$export(module.exports, "WuiWalletImage", function () { return $94acc594fed0cf74$export$2df48f4f4e74a226; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("4BuLe");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("7XtWS");

var $9ddGv = parcelRequire("9ddGv");
var $94acc594fed0cf74$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $94acc594fed0cf74$export$2df48f4f4e74a226 = class WuiWalletImage extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "";
        this.installed = false;
        this.badgeSize = "xs";
    }
    render() {
        let borderRadius = "xxs";
        if (this.size === "lg") borderRadius = "m";
        else if (this.size === "md") borderRadius = "xs";
        else borderRadius = "xxs";
        this.style.cssText = `
       --local-border-radius: var(--wui-border-radius-${borderRadius});
       --local-size: var(--wui-wallet-image-size-${this.size});
   `;
        if (this.walletIcon) this.dataset["walletIcon"] = this.walletIcon;
        return (0, $7pRM7.html)`
      <wui-flex justifyContent="center" alignItems="center"> ${this.templateVisual()} </wui-flex>
    `;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>`;
        else if (this.walletIcon) return (0, $7pRM7.html)`<wui-icon
        data-parent-size="md"
        size="md"
        color="inherit"
        name=${this.walletIcon}
      ></wui-icon>`;
        return (0, $7pRM7.html)`<wui-icon
      data-parent-size=${this.size}
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
    }
};
$94acc594fed0cf74$export$2df48f4f4e74a226.styles = [
    (0, $jVNMm.resetStyles),
    (0, $9ddGv.default)
];
$94acc594fed0cf74$var$__decorate([
    (0, $biDip.property)()
], $94acc594fed0cf74$export$2df48f4f4e74a226.prototype, "size", void 0);
$94acc594fed0cf74$var$__decorate([
    (0, $biDip.property)()
], $94acc594fed0cf74$export$2df48f4f4e74a226.prototype, "name", void 0);
$94acc594fed0cf74$var$__decorate([
    (0, $biDip.property)()
], $94acc594fed0cf74$export$2df48f4f4e74a226.prototype, "imageSrc", void 0);
$94acc594fed0cf74$var$__decorate([
    (0, $biDip.property)()
], $94acc594fed0cf74$export$2df48f4f4e74a226.prototype, "walletIcon", void 0);
$94acc594fed0cf74$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $94acc594fed0cf74$export$2df48f4f4e74a226.prototype, "installed", void 0);
$94acc594fed0cf74$var$__decorate([
    (0, $biDip.property)()
], $94acc594fed0cf74$export$2df48f4f4e74a226.prototype, "badgeSize", void 0);
$94acc594fed0cf74$export$2df48f4f4e74a226 = $94acc594fed0cf74$var$__decorate([
    (0, $ailZp.customElement)("wui-wallet-image")
], $94acc594fed0cf74$export$2df48f4f4e74a226);

});
parcelRegister("9ddGv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b4ff16df761c56a$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $6b4ff16df761c56a$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    background-color: var(--wui-color-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-size);
    height: var(--local-size);
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host > wui-flex {
    overflow: hidden;
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-color-gray-glass-010);
    pointer-events: none;
  }

  :host([name='Extension'])::after {
    border: 1px solid var(--wui-color-accent-glass-010);
  }

  :host([data-wallet-icon='allWallets']) {
    background-color: var(--wui-all-wallets-bg-100);
  }

  :host([data-wallet-icon='allWallets'])::after {
    border: 1px solid var(--wui-color-accent-glass-010);
  }

  wui-icon[data-parent-size='inherit'] {
    width: 75%;
    height: 75%;
    align-items: center;
  }

  wui-icon[data-parent-size='sm'] {
    width: 18px;
    height: 18px;
  }

  wui-icon[data-parent-size='md'] {
    width: 24px;
    height: 24px;
  }

  wui-icon[data-parent-size='lg'] {
    width: 42px;
    height: 42px;
  }

  wui-icon[data-parent-size='full'] {
    width: 100%;
    height: 100%;
  }

  :host > wui-icon-box {
    position: absolute;
    overflow: hidden;
    right: -1px;
    bottom: -2px;
    z-index: 1;
    border: 2px solid var(--wui-color-bg-150, #1e1f1f);
    padding: 1px;
  }
`;

});


parcelRegister("5keWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e0a69e30ffba3c8$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $3e0a69e30ffba3c8$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    border-radius: var(--wui-border-radius-xxs);
    width: 40px;
    height: 40px;
    overflow: hidden;
    background: var(--wui-color-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--wui-spacing-4xs);
    padding: 3.75px !important;
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-color-gray-glass-010);
    pointer-events: none;
  }

  :host > wui-wallet-image {
    width: 14px;
    height: 14px;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host > wui-flex {
    padding: 2px;
    position: fixed;
    overflow: hidden;
    left: 34px;
    bottom: 8px;
    background: var(--dark-background-150, #1e1f1f);
    border-radius: 50%;
    z-index: 2;
    display: flex;
  }
`;

});


parcelRegister("hCQbE", function(module, exports) {

$parcel$export(module.exports, "WuiButton", function () { return $cd4e77828a745f9b$export$5496564a8aaab1b8; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("ck0jF");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $9XCrK = parcelRequire("9XCrK");
var $cd4e77828a745f9b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $cd4e77828a745f9b$var$SPINNER_COLOR_BY_VARIANT = {
    main: "inverse-100",
    inverse: "inverse-000",
    accent: "accent-100",
    "accent-error": "error-100",
    "accent-success": "success-100",
    neutral: "fg-100",
    disabled: "gray-glass-020"
};
const $cd4e77828a745f9b$var$TEXT_VARIANT_BY_SIZE = {
    lg: "paragraph-600",
    md: "small-600"
};
const $cd4e77828a745f9b$var$SPINNER_SIZE_BY_SIZE = {
    lg: "md",
    md: "md"
};
let $cd4e77828a745f9b$export$5496564a8aaab1b8 = class WuiButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "lg";
        this.disabled = false;
        this.fullWidth = false;
        this.loading = false;
        this.variant = "main";
        this.hasIconLeft = false;
        this.hasIconRight = false;
        this.borderRadius = "m";
    }
    render() {
        this.style.cssText = `
    --local-width: ${this.fullWidth ? "100%" : "auto"};
    --local-opacity-100: ${this.loading ? 0 : 1};
    --local-opacity-000: ${this.loading ? 1 : 0};
    --local-border-radius: var(--wui-border-radius-${this.borderRadius});
    `;
        const textVariant = this.textVariant ?? $cd4e77828a745f9b$var$TEXT_VARIANT_BY_SIZE[this.size];
        return (0, $7pRM7.html)`
      <button
        data-variant=${this.variant}
        data-icon-left=${this.hasIconLeft}
        data-icon-right=${this.hasIconRight}
        data-size=${this.size}
        ?disabled=${this.disabled}
        ontouchstart
      >
        ${this.loadingTemplate()}
        <slot name="iconLeft" @slotchange=${()=>this.handleSlotLeftChange()}></slot>
        <wui-text variant=${textVariant} color="inherit">
          <slot></slot>
        </wui-text>
        <slot name="iconRight" @slotchange=${()=>this.handleSlotRightChange()}></slot>
      </button>
    `;
    }
    handleSlotLeftChange() {
        this.hasIconLeft = true;
    }
    handleSlotRightChange() {
        this.hasIconRight = true;
    }
    loadingTemplate() {
        if (this.loading) {
            const size = $cd4e77828a745f9b$var$SPINNER_SIZE_BY_SIZE[this.size];
            const color = this.disabled ? $cd4e77828a745f9b$var$SPINNER_COLOR_BY_VARIANT["disabled"] : $cd4e77828a745f9b$var$SPINNER_COLOR_BY_VARIANT[this.variant];
            return (0, $7pRM7.html)`<wui-loading-spinner color=${color} size=${size}></wui-loading-spinner>`;
        }
        return (0, $7pRM7.html)``;
    }
};
$cd4e77828a745f9b$export$5496564a8aaab1b8.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $9XCrK.default)
];
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)()
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "size", void 0);
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "disabled", void 0);
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "fullWidth", void 0);
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "loading", void 0);
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)()
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "variant", void 0);
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "hasIconLeft", void 0);
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "hasIconRight", void 0);
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)()
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "borderRadius", void 0);
$cd4e77828a745f9b$var$__decorate([
    (0, $biDip.property)()
], $cd4e77828a745f9b$export$5496564a8aaab1b8.prototype, "textVariant", void 0);
$cd4e77828a745f9b$export$5496564a8aaab1b8 = $cd4e77828a745f9b$var$__decorate([
    (0, $ailZp.customElement)("wui-button")
], $cd4e77828a745f9b$export$5496564a8aaab1b8);

});
parcelRegister("9XCrK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7407726fed457ed2$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $7407726fed457ed2$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    width: var(--local-width);
    position: relative;
  }

  button {
    border: none;
    border-radius: var(--local-border-radius);
    width: var(--local-width);
    white-space: nowrap;
  }

  /* -- Sizes --------------------------------------------------- */
  button[data-size='md'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-l);
    height: 36px;
  }

  button[data-size='md'][data-icon-left='true'][data-icon-right='false'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-s);
  }

  button[data-size='md'][data-icon-right='true'][data-icon-left='false'] {
    padding: 8.2px var(--wui-spacing-s) 9px var(--wui-spacing-l);
  }

  button[data-size='lg'] {
    padding: var(--wui-spacing-m) var(--wui-spacing-2l);
    height: 48px;
  }

  /* -- Variants --------------------------------------------------------- */
  button[data-variant='main'] {
    background-color: var(--wui-color-accent-100);
    color: var(--wui-color-inverse-100);
    border: none;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }

  button[data-variant='inverse'] {
    background-color: var(--wui-color-inverse-100);
    color: var(--wui-color-inverse-000);
    border: none;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }

  button[data-variant='accent'] {
    background-color: var(--wui-color-accent-glass-010);
    color: var(--wui-color-accent-100);
    border: none;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
  }

  button[data-variant='accent-error'] {
    background: var(--wui-color-error-glass-015);
    color: var(--wui-color-error-100);
    border: none;
    box-shadow: inset 0 0 0 1px var(--wui-color-error-glass-010);
  }

  button[data-variant='accent-success'] {
    background: var(--wui-color-success-glass-015);
    color: var(--wui-color-success-100);
    border: none;
    box-shadow: inset 0 0 0 1px var(--wui-color-success-glass-010);
  }

  button[data-variant='neutral'] {
    background: transparent;
    color: var(--wui-color-fg-100);
    border: none;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
  }

  /* -- Focus states --------------------------------------------------- */
  button[data-variant='main']:focus-visible:enabled {
    background-color: var(--wui-color-accent-090);
    box-shadow:
      inset 0 0 0 1px var(--wui-color-accent-100),
      0 0 0 4px var(--wui-color-accent-glass-020);
  }
  button[data-variant='inverse']:focus-visible:enabled {
    background-color: var(--wui-color-inverse-100);
    box-shadow:
      inset 0 0 0 1px var(--wui-color-gray-glass-010),
      0 0 0 4px var(--wui-color-accent-glass-020);
  }
  button[data-variant='accent']:focus-visible:enabled {
    background-color: var(--wui-color-accent-glass-010);
    box-shadow:
      inset 0 0 0 1px var(--wui-color-accent-100),
      0 0 0 4px var(--wui-color-accent-glass-020);
  }
  button[data-variant='accent-error']:focus-visible:enabled {
    background: var(--wui-color-error-glass-015);
    box-shadow:
      inset 0 0 0 1px var(--wui-color-error-100),
      0 0 0 4px var(--wui-color-error-glass-020);
  }
  button[data-variant='accent-success']:focus-visible:enabled {
    background: var(--wui-color-success-glass-015);
    box-shadow:
      inset 0 0 0 1px var(--wui-color-success-100),
      0 0 0 4px var(--wui-color-success-glass-020);
  }
  button[data-variant='neutral']:focus-visible:enabled {
    background: var(--wui-color-gray-glass-005);
    box-shadow:
      inset 0 0 0 1px var(--wui-color-gray-glass-010),
      0 0 0 4px var(--wui-color-gray-glass-002);
  }

  /* -- Hover & Active states ----------------------------------------------------------- */
  @media (hover: hover) and (pointer: fine) {
    button[data-variant='main']:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button[data-variant='main']:active:enabled {
      background-color: var(--wui-color-accent-080);
    }

    button[data-variant='accent']:hover:enabled {
      background-color: var(--wui-color-accent-glass-015);
    }

    button[data-variant='accent']:active:enabled {
      background-color: var(--wui-color-accent-glass-020);
    }

    button[data-variant='accent-error']:hover:enabled {
      background: var(--wui-color-error-glass-020);
      color: var(--wui-color-error-100);
    }

    button[data-variant='accent-error']:active:enabled {
      background: var(--wui-color-error-glass-030);
      color: var(--wui-color-error-100);
    }

    button[data-variant='accent-success']:hover:enabled {
      background: var(--wui-color-success-glass-020);
      color: var(--wui-color-success-100);
    }

    button[data-variant='accent-success']:active:enabled {
      background: var(--wui-color-success-glass-030);
      color: var(--wui-color-success-100);
    }

    button[data-variant='neutral']:hover:enabled {
      background: var(--wui-color-gray-glass-002);
    }

    button[data-variant='neutral']:active:enabled {
      background: var(--wui-color-gray-glass-005);
    }

    button[data-size='lg'][data-icon-left='true'][data-icon-right='false'] {
      padding-left: var(--wui-spacing-m);
    }

    button[data-size='lg'][data-icon-right='true'][data-icon-left='false'] {
      padding-right: var(--wui-spacing-m);
    }
  }

  /* -- Disabled state --------------------------------------------------- */
  button:disabled {
    background-color: var(--wui-color-gray-glass-002);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);
    color: var(--wui-color-gray-glass-020);
    cursor: not-allowed;
  }

  button > wui-text {
    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: opacity;
    opacity: var(--local-opacity-100);
  }

  ::slotted(*) {
    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: opacity;
    opacity: var(--local-opacity-100);
  }

  wui-loading-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: var(--local-opacity-000);
  }
`;

});


parcelRegister("7wNyf", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelectLoader", function () { return $57b1f572c88b3efd$export$fc388e944144bd3a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $b9Re7 = parcelRequire("b9Re7");
parcelRequire("kTgQh");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $45rNX = parcelRequire("45rNX");
var $57b1f572c88b3efd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $57b1f572c88b3efd$export$fc388e944144bd3a = class WuiCardSelectLoader extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.type = "wallet";
    }
    render() {
        return (0, $7pRM7.html)`
      ${this.shimmerTemplate()}
      <wui-shimmer width="56px" height="20px" borderRadius="xs"></wui-shimmer>
    `;
    }
    shimmerTemplate() {
        if (this.type === "network") return (0, $7pRM7.html)` <wui-shimmer
          data-type=${this.type}
          width="48px"
          height="54px"
          borderRadius="xs"
        ></wui-shimmer>
        ${0, $b9Re7.networkSvgMd}`;
        return (0, $7pRM7.html)`<wui-shimmer width="56px" height="56px" borderRadius="xs"></wui-shimmer>`;
    }
};
$57b1f572c88b3efd$export$fc388e944144bd3a.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $45rNX.default)
];
$57b1f572c88b3efd$var$__decorate([
    (0, $biDip.property)()
], $57b1f572c88b3efd$export$fc388e944144bd3a.prototype, "type", void 0);
$57b1f572c88b3efd$export$fc388e944144bd3a = $57b1f572c88b3efd$var$__decorate([
    (0, $ailZp.customElement)("wui-card-select-loader")
], $57b1f572c88b3efd$export$fc388e944144bd3a);

});
parcelRegister("b9Re7", function(module, exports) {

$parcel$export(module.exports, "networkSvgMd", function () { return $81f9d2ad26aaa539$export$711c5994129523c4; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $81f9d2ad26aaa539$export$711c5994129523c4 = (0, $7pRM7.svg)`<svg  viewBox="0 0 48 54" fill="none">
  <path
    d="M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z"
  />
</svg>`;

});

parcelRegister("45rNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f9d327a848fb636$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $2f9d327a848fb636$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) 10px;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
    position: relative;
  }

  wui-shimmer[data-type='network'] {
    border: none;
    -webkit-clip-path: var(--wui-path-network);
    clip-path: var(--wui-path-network);
  }

  svg {
    position: absolute;
    width: 48px;
    height: 54px;
    z-index: 1;
  }

  svg > path {
    stroke: var(--wui-color-gray-glass-010);
    stroke-width: 1px;
  }
`;

});


parcelRegister("kjq5y", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelect", function () { return $ec99d19fe3de9368$export$815c16e0af51756a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("3TXJn");
var $2utwL = parcelRequire("2utwL");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("li0PP");
parcelRequire("cLomv");

var $7osVv = parcelRequire("7osVv");
var $ec99d19fe3de9368$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ec99d19fe3de9368$export$815c16e0af51756a = class WuiCardSelect extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "Unknown";
        this.type = "wallet";
        this.imageSrc = undefined;
        this.disabled = false;
        this.selected = false;
        this.installed = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button data-selected=${(0, $2utwL.ifDefined)(this.selected)} ?disabled=${this.disabled} ontouchstart>
        ${this.imageTemplate()}
        <wui-text variant="tiny-500" color=${this.selected ? "accent-100" : "inherit"}>
          ${this.name}
        </wui-text>
      </button>
    `;
    }
    imageTemplate() {
        if (this.type === "network") return (0, $7pRM7.html)`
        <wui-network-image
          .selected=${this.selected}
          imageSrc=${(0, $2utwL.ifDefined)(this.imageSrc)}
          name=${this.name}
        >
        </wui-network-image>
      `;
        return (0, $7pRM7.html)`
      <wui-wallet-image
        size="md"
        imageSrc=${(0, $2utwL.ifDefined)(this.imageSrc)}
        name=${this.name}
        .installed=${this.installed}
        badgeSize="sm"
      >
      </wui-wallet-image>
    `;
    }
};
$ec99d19fe3de9368$export$815c16e0af51756a.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $7osVv.default)
];
$ec99d19fe3de9368$var$__decorate([
    (0, $biDip.property)()
], $ec99d19fe3de9368$export$815c16e0af51756a.prototype, "name", void 0);
$ec99d19fe3de9368$var$__decorate([
    (0, $biDip.property)()
], $ec99d19fe3de9368$export$815c16e0af51756a.prototype, "type", void 0);
$ec99d19fe3de9368$var$__decorate([
    (0, $biDip.property)()
], $ec99d19fe3de9368$export$815c16e0af51756a.prototype, "imageSrc", void 0);
$ec99d19fe3de9368$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $ec99d19fe3de9368$export$815c16e0af51756a.prototype, "disabled", void 0);
$ec99d19fe3de9368$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $ec99d19fe3de9368$export$815c16e0af51756a.prototype, "selected", void 0);
$ec99d19fe3de9368$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $ec99d19fe3de9368$export$815c16e0af51756a.prototype, "installed", void 0);
$ec99d19fe3de9368$export$815c16e0af51756a = $ec99d19fe3de9368$var$__decorate([
    (0, $ailZp.customElement)("wui-card-select")
], $ec99d19fe3de9368$export$815c16e0af51756a);

});
parcelRegister("li0PP", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkImage", function () { return $f7fbed35f0e08305$export$4dc5510728d31c71; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $gE8hs = parcelRequire("gE8hs");

var $b9Re7 = parcelRequire("b9Re7");

var $k1VQG = parcelRequire("k1VQG");
parcelRequire("i6mxN");
parcelRequire("4BuLe");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $633S7 = parcelRequire("633S7");
var $f7fbed35f0e08305$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f7fbed35f0e08305$export$4dc5510728d31c71 = class WuiNetworkImage extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "uknown";
        this.networkImagesBySize = {
            sm: (0, $gE8hs.networkSvgSm),
            md: (0, $b9Re7.networkSvgMd),
            lg: (0, $k1VQG.networkSvgLg)
        };
        this.selected = false;
        this.round = false;
    }
    render() {
        if (this.round) {
            this.dataset["round"] = "true";
            this.style.cssText = `
      --local-width: var(--wui-spacing-3xl);
      --local-height: var(--wui-spacing-3xl);
      --local-icon-size: var(--wui-spacing-l);
    `;
        } else this.style.cssText = `

      --local-path: var(--wui-path-network-${this.size});
      --local-width:  var(--wui-width-network-${this.size});
      --local-height:  var(--wui-height-network-${this.size});
      --local-icon-size:  var(--wui-icon-size-network-${this.size});
    `;
        return (0, $7pRM7.html)`${this.templateVisual()} ${this.svgTemplate()} `;
    }
    svgTemplate() {
        if (this.round) return null;
        return this.networkImagesBySize[this.size];
    }
    templateVisual() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>`;
        return (0, $7pRM7.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$f7fbed35f0e08305$export$4dc5510728d31c71.styles = [
    (0, $jVNMm.resetStyles),
    (0, $633S7.default)
];
$f7fbed35f0e08305$var$__decorate([
    (0, $biDip.property)()
], $f7fbed35f0e08305$export$4dc5510728d31c71.prototype, "size", void 0);
$f7fbed35f0e08305$var$__decorate([
    (0, $biDip.property)()
], $f7fbed35f0e08305$export$4dc5510728d31c71.prototype, "name", void 0);
$f7fbed35f0e08305$var$__decorate([
    (0, $biDip.property)({
        type: Object
    })
], $f7fbed35f0e08305$export$4dc5510728d31c71.prototype, "networkImagesBySize", void 0);
$f7fbed35f0e08305$var$__decorate([
    (0, $biDip.property)()
], $f7fbed35f0e08305$export$4dc5510728d31c71.prototype, "imageSrc", void 0);
$f7fbed35f0e08305$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $f7fbed35f0e08305$export$4dc5510728d31c71.prototype, "selected", void 0);
$f7fbed35f0e08305$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $f7fbed35f0e08305$export$4dc5510728d31c71.prototype, "round", void 0);
$f7fbed35f0e08305$export$4dc5510728d31c71 = $f7fbed35f0e08305$var$__decorate([
    (0, $ailZp.customElement)("wui-network-image")
], $f7fbed35f0e08305$export$4dc5510728d31c71);

});
parcelRegister("gE8hs", function(module, exports) {

$parcel$export(module.exports, "networkSvgSm", function () { return $c1e6ce1c918c5bc9$export$a36e707df42c73a2; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $c1e6ce1c918c5bc9$export$a36e707df42c73a2 = (0, $7pRM7.svg)`
  <svg fill="none" viewBox="0 0 36 40">
    <path
      d="M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z"
    />
  </svg>
`;

});

parcelRegister("k1VQG", function(module, exports) {

$parcel$export(module.exports, "networkSvgLg", function () { return $e950c62b9e6f4aa3$export$d2869a6a8000adfa; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
const $e950c62b9e6f4aa3$export$d2869a6a8000adfa = (0, $7pRM7.svg)`<svg width="86" height="96" fill="none">
  <path
    d="M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z"
  />
</svg>`;

});

parcelRegister("633S7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $467606c27ee34926$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $467606c27ee34926$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-width);
    height: var(--local-height);
  }

  :host([data-round='true']) {
    background: var(--wui-color-gray-glass-002);
    border-radius: 100%;
    outline: 1px solid var(--wui-color-gray-glass-005);
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    fill: var(--wui-color-gray-glass-002);
  }

  svg > path {
    stroke: var(--local-stroke);
  }

  wui-image {
    width: 100%;
    height: 100%;
    -webkit-clip-path: var(--local-path);
    clip-path: var(--local-path);
    background: var(--wui-color-gray-glass-002);
  }

  wui-icon {
    transform: translateY(-5%);
    width: var(--local-icon-size);
    height: var(--local-icon-size);
  }
`;

});


parcelRegister("7osVv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5621367d3bec8946$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $5621367d3bec8946$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    flex-direction: column;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) var(--wui-spacing-0);
    background-color: var(--wui-color-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
  }

  button > wui-text {
    color: var(--wui-color-fg-100);
    max-width: var(--wui-icon-box-size-xl);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: center;
  }

  button:disabled > wui-text {
    color: var(--wui-color-gray-glass-015);
  }

  [data-selected='true'] {
    background-color: var(--wui-color-accent-glass-020);
  }

  @media (hover: hover) and (pointer: fine) {
    [data-selected='true']:hover:enabled {
      background-color: var(--wui-color-accent-glass-015);
    }
  }

  [data-selected='true']:active:enabled {
    background-color: var(--wui-color-accent-glass-010);
  }
`;

});


parcelRegister("2fpsv", function(module, exports) {

$parcel$export(module.exports, "WuiChip", function () { return $1a30bb16db475bac$export$418286c4c7ff87c6; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("4BuLe");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $fIDM4 = parcelRequire("fIDM4");

var $ailZp = parcelRequire("ailZp");

var $5BSSh = parcelRequire("5BSSh");
var $1a30bb16db475bac$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1a30bb16db475bac$export$418286c4c7ff87c6 = class WuiChip extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "fill";
        this.imageSrc = undefined;
        this.disabled = false;
        this.icon = "externalLink";
        this.href = "";
        this.text = undefined;
    }
    render() {
        const isSmall = this.variant === "success" || this.variant === "transparent" || this.variant === "shadeSmall";
        const textVariant = isSmall ? "small-600" : "paragraph-600";
        return (0, $7pRM7.html)`
      <a
        rel="noreferrer"
        target="_blank"
        href=${this.href}
        class=${this.disabled ? "disabled" : ""}
        data-variant=${this.variant}
      >
        ${this.imageTemplate()}
        <wui-text variant=${textVariant} color="inherit">
          ${this.title ? this.title : (0, $fIDM4.UiHelperUtil).getHostName(this.href)}
        </wui-text>
        <wui-icon name=${this.icon} color="inherit" size="inherit"></wui-icon>
      </a>
    `;
    }
    imageTemplate() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return null;
    }
};
$1a30bb16db475bac$export$418286c4c7ff87c6.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $5BSSh.default)
];
$1a30bb16db475bac$var$__decorate([
    (0, $biDip.property)()
], $1a30bb16db475bac$export$418286c4c7ff87c6.prototype, "variant", void 0);
$1a30bb16db475bac$var$__decorate([
    (0, $biDip.property)()
], $1a30bb16db475bac$export$418286c4c7ff87c6.prototype, "imageSrc", void 0);
$1a30bb16db475bac$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $1a30bb16db475bac$export$418286c4c7ff87c6.prototype, "disabled", void 0);
$1a30bb16db475bac$var$__decorate([
    (0, $biDip.property)()
], $1a30bb16db475bac$export$418286c4c7ff87c6.prototype, "icon", void 0);
$1a30bb16db475bac$var$__decorate([
    (0, $biDip.property)()
], $1a30bb16db475bac$export$418286c4c7ff87c6.prototype, "href", void 0);
$1a30bb16db475bac$var$__decorate([
    (0, $biDip.property)()
], $1a30bb16db475bac$export$418286c4c7ff87c6.prototype, "text", void 0);
$1a30bb16db475bac$export$418286c4c7ff87c6 = $1a30bb16db475bac$var$__decorate([
    (0, $ailZp.customElement)("wui-chip")
], $1a30bb16db475bac$export$418286c4c7ff87c6);

});
parcelRegister("5BSSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $415af960508d8c1f$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $415af960508d8c1f$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  a {
    border: 1px solid var(--wui-color-gray-glass-010);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-image {
    border-radius: var(--wui-border-radius-3xl);
    overflow: hidden;
  }

  a.disabled > wui-icon,
  a.disabled > wui-image {
    filter: grayscale(1);
  }

  a[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  a[data-variant='shade'],
  a[data-variant='shadeSmall'] {
    background-color: transparent;
    background-color: var(--wui-color-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  a[data-variant='success'] {
    column-gap: var(--wui-spacing-xxs);
    border: 1px solid var(--wui-color-success-glass-010);
    background-color: var(--wui-color-success-glass-010);
    color: var(--wui-color-success-100);
  }

  a[data-variant='error'] {
    column-gap: var(--wui-spacing-xxs);
    border: 1px solid var(--wui-color-error-glass-010);
    background-color: var(--wui-color-error-glass-010);
    color: var(--wui-color-error-100);
  }

  a[data-variant='transparent'] {
    column-gap: var(--wui-spacing-xxs);
    background-color: transparent;
    color: var(--wui-color-fg-150);
  }

  a[data-variant='transparent'],
  a[data-variant='success'],
  a[data-variant='shadeSmall'],
  a[data-variant='error'] {
    padding: 7px var(--wui-spacing-s) 7px 10px;
  }

  a[data-variant='transparent']:has(wui-text:first-child),
  a[data-variant='success']:has(wui-text:first-child),
  a[data-variant='shadeSmall']:has(wui-text:first-child),
  a[data-variant='error']:has(wui-text:first-child) {
    padding: 7px var(--wui-spacing-s);
  }

  a[data-variant='fill'],
  a[data-variant='shade'] {
    column-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  a[data-variant='fill']:has(wui-text:first-child),
  a[data-variant='shade']:has(wui-text:first-child) {
    padding: 9px var(--wui-spacing-m) 9px var(--wui-spacing-m);
  }

  a[data-variant='fill'] > wui-image,
  a[data-variant='shade'] > wui-image {
    width: 24px;
    height: 24px;
  }

  a[data-variant='fill'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-color-accent-090);
  }

  a[data-variant='shade'] > wui-image,
  a[data-variant='shadeSmall'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }

  a[data-variant='fill'] > wui-icon,
  a[data-variant='shade'] > wui-icon {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-image,
  a[data-variant='success'] > wui-image,
  a[data-variant='shadeSmall'] > wui-image,
  a[data-variant='error'] > wui-image {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-icon,
  a[data-variant='success'] > wui-icon,
  a[data-variant='shadeSmall'] > wui-icon,
  a[data-variant='error'] > wui-icon {
    width: 12px;
    height: 12px;
  }

  a[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  a[data-variant='shade']:focus-visible,
  a[data-variant='shadeSmall']:focus-visible {
    background-color: var(--wui-color-gray-glass-015);
  }

  a[data-variant='transparent']:focus-visible {
    background-color: var(--wui-color-gray-glass-005);
  }

  a[data-variant='success']:focus-visible {
    background-color: var(--wui-color-success-glass-015);
  }

  a[data-variant='error']:focus-visible {
    background-color: var(--wui-color-error-glass-015);
  }

  a.disabled {
    color: var(--wui-color-gray-glass-015);
    background-color: var(--wui-color-gray-glass-015);
    pointer-events: none;
  }

  @media (hover: hover) and (pointer: fine) {
    a[data-variant='fill']:hover {
      background-color: var(--wui-color-accent-090);
    }

    a[data-variant='shade']:hover,
    a[data-variant='shadeSmall']:hover {
      background-color: var(--wui-color-gray-glass-015);
    }

    a[data-variant='transparent']:hover {
      background-color: var(--wui-color-gray-glass-005);
    }

    a[data-variant='success']:hover {
      background-color: var(--wui-color-success-glass-015);
    }

    a[data-variant='error']:hover {
      background-color: var(--wui-color-error-glass-015);
    }
  }

  a[data-variant='fill']:active {
    background-color: var(--wui-color-accent-080);
  }

  a[data-variant='shade']:active,
  a[data-variant='shadeSmall']:active {
    background-color: var(--wui-color-gray-glass-020);
  }

  a[data-variant='transparent']:active {
    background-color: var(--wui-color-gray-glass-010);
  }

  a[data-variant='success']:active {
    background-color: var(--wui-color-success-glass-020);
  }

  a[data-variant='error']:active {
    background-color: var(--wui-color-error-glass-020);
  }
`;

});


parcelRegister("evdH0", function(module, exports) {

$parcel$export(module.exports, "WuiConnectButton", function () { return $a8ee95065f8d05ff$export$7e12422df5cbb04c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("ck0jF");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $77e1g = parcelRequire("77e1g");
var $a8ee95065f8d05ff$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a8ee95065f8d05ff$export$7e12422df5cbb04c = class WuiConnectButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.loading = false;
    }
    render() {
        const textVariant = this.size === "md" ? "paragraph-600" : "small-600";
        return (0, $7pRM7.html)`
      <button data-size=${this.size} ?disabled=${this.loading} ontouchstart>
        ${this.loadingTemplate()}
        <wui-text variant=${textVariant} color=${this.loading ? "accent-100" : "inherit"}>
          <slot></slot>
        </wui-text>
      </button>
    `;
    }
    loadingTemplate() {
        if (!this.loading) return null;
        return (0, $7pRM7.html)`<wui-loading-spinner size=${this.size} color="accent-100"></wui-loading-spinner>`;
    }
};
$a8ee95065f8d05ff$export$7e12422df5cbb04c.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $77e1g.default)
];
$a8ee95065f8d05ff$var$__decorate([
    (0, $biDip.property)()
], $a8ee95065f8d05ff$export$7e12422df5cbb04c.prototype, "size", void 0);
$a8ee95065f8d05ff$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $a8ee95065f8d05ff$export$7e12422df5cbb04c.prototype, "loading", void 0);
$a8ee95065f8d05ff$export$7e12422df5cbb04c = $a8ee95065f8d05ff$var$__decorate([
    (0, $ailZp.customElement)("wui-connect-button")
], $a8ee95065f8d05ff$export$7e12422df5cbb04c);

});
parcelRegister("77e1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52e40fd2cfd5d5aa$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $52e40fd2cfd5d5aa$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    display: block;
  }

  button {
    background: var(--wui-color-accent-100);
    border: 1px solid var(--wui-color-gray-glass-010);
    border-radius: var(--wui-border-radius-m);
    gap: var(--wui-spacing-xs);
  }

  button.loading {
    background: var(--wui-color-gray-glass-010);
    border: 1px solid var(--wui-color-gray-glass-010);
    pointer-events: none;
  }

  button:disabled {
    background-color: var(--wui-color-gray-glass-015);
    border: 1px solid var(--wui-color-gray-glass-010);
  }

  button:disabled > wui-text {
    color: var(--wui-color-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button:active:enabled {
      background-color: var(--wui-color-accent-080);
    }
  }

  button:focus-visible {
    border: 1px solid var(--wui-color-gray-glass-010);
    background-color: var(--wui-color-accent-090);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-size='sm'] {
    padding: 6.75px 10px 7.25px;
  }

  ::slotted(*) {
    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: opacity;
    opacity: var(--local-opacity-100);
  }

  button > wui-text {
    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: opacity;
    opacity: var(--local-opacity-100);
    color: var(--wui-color-inverse-100);
  }

  button[data-size='md'] {
    padding: 9px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'] + wui-text {
    padding-left: var(--wui-spacing-3xs);
  }

  @media (max-width: 500px) {
    button[data-size='md'] {
      height: 32px;
      padding: 5px 12px;
    }

    button[data-size='md'] > wui-text > slot {
      font-size: 14px !important;
    }
  }

  wui-loading-spinner {
    width: 14px;
    height: 14px;
  }

  wui-loading-spinner::slotted(svg) {
    width: 10px !important;
    height: 10px !important;
  }

  button[data-size='sm'] > wui-loading-spinner {
    width: 12px;
    height: 12px;
  }
`;

});


parcelRegister("4cL7c", function(module, exports) {

$parcel$export(module.exports, "WuiCtaButton", function () { return $30fcd482b915cd9a$export$4cb12aabb6d5d23c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");
parcelRequire("hCQbE");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $7viai = parcelRequire("7viai");
var $30fcd482b915cd9a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $30fcd482b915cd9a$export$4cb12aabb6d5d23c = class WuiCtaButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.label = "";
        this.buttonLabel = "";
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-flex
        justifyContent="space-between"
        alignItems="center"
        .padding=${[
            "1xs",
            "2l",
            "1xs",
            "2l"
        ]}
      >
        <wui-text variant="paragraph-500" color="fg-200">${this.label}</wui-text>
        <wui-chip-button size="sm" variant="shade" text=${this.buttonLabel} icon="chevronRight">
        </wui-chip-button>
      </wui-flex>
    `;
    }
};
$30fcd482b915cd9a$export$4cb12aabb6d5d23c.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $7viai.default)
];
$30fcd482b915cd9a$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $30fcd482b915cd9a$export$4cb12aabb6d5d23c.prototype, "disabled", void 0);
$30fcd482b915cd9a$var$__decorate([
    (0, $biDip.property)()
], $30fcd482b915cd9a$export$4cb12aabb6d5d23c.prototype, "label", void 0);
$30fcd482b915cd9a$var$__decorate([
    (0, $biDip.property)()
], $30fcd482b915cd9a$export$4cb12aabb6d5d23c.prototype, "buttonLabel", void 0);
$30fcd482b915cd9a$export$4cb12aabb6d5d23c = $30fcd482b915cd9a$var$__decorate([
    (0, $ailZp.customElement)("wui-cta-button")
], $30fcd482b915cd9a$export$4cb12aabb6d5d23c);

});
parcelRegister("7viai", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $576984de73e72bee$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $576984de73e72bee$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  wui-flex {
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("jpXmH", function(module, exports) {

$parcel$export(module.exports, "WuiDetailsGroup", function () { return $e22e66c84efaf85d$export$37645d4570816cfe; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $kDNVE = parcelRequire("kDNVE");
var $e22e66c84efaf85d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e22e66c84efaf85d$export$37645d4570816cfe = class WuiDetailsGroup extends (0, $cLW71.LitElement) {
    render() {
        return (0, $7pRM7.html)`
      <wui-flex gap="xl" flexDirection="column" justifyContent="space-between" alignItems="center">
        <slot></slot>
      </wui-flex>
    `;
    }
};
$e22e66c84efaf85d$export$37645d4570816cfe.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $kDNVE.default)
];
$e22e66c84efaf85d$export$37645d4570816cfe = $e22e66c84efaf85d$var$__decorate([
    (0, $ailZp.customElement)("wui-details-group")
], $e22e66c84efaf85d$export$37645d4570816cfe);

});
parcelRegister("kDNVE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f06e2e012abdf8f7$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $f06e2e012abdf8f7$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    padding: var(--wui-spacing-l) var(--wui-spacing-m);
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    width: 100%;
  }
`;

});


parcelRegister("38586", function(module, exports) {

$parcel$export(module.exports, "WuiDetailsGroupItem", function () { return $2476191f4e8fe2c5$export$d005980beb1c2a86; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $4dBkL = parcelRequire("4dBkL");
var $2476191f4e8fe2c5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2476191f4e8fe2c5$export$d005980beb1c2a86 = class WuiDetailsGroupItem extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "";
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">${this.name}</wui-text>
        <wui-flex gap="xs" alignItems="center">
          <slot></slot>
        </wui-flex>
      </wui-flex>
    `;
    }
};
$2476191f4e8fe2c5$export$d005980beb1c2a86.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $4dBkL.default)
];
$2476191f4e8fe2c5$var$__decorate([
    (0, $biDip.property)()
], $2476191f4e8fe2c5$export$d005980beb1c2a86.prototype, "name", void 0);
$2476191f4e8fe2c5$export$d005980beb1c2a86 = $2476191f4e8fe2c5$var$__decorate([
    (0, $ailZp.customElement)("wui-details-group-item")
], $2476191f4e8fe2c5$export$d005980beb1c2a86);

});
parcelRegister("4dBkL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3125560c868abdee$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $3125560c868abdee$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    flex-direction: row;
    gap: var(--wui-spacing-l);
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("d856F", function(module, exports) {

$parcel$export(module.exports, "WuiDropdownMenu", function () { return $98effbc2275b6e89$export$868b19dbe6f5fb81; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("4BuLe");
parcelRequire("ck0jF");
parcelRequire("fCaEm");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("7XtWS");

var $cZf2A = parcelRequire("cZf2A");
var $98effbc2275b6e89$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $98effbc2275b6e89$export$868b19dbe6f5fb81 = class WuiDropdownMenu extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.actions = [];
        this.isOpen = false;
    }
    render() {
        if (!this.isOpen) return null;
        return (0, $7pRM7.html)`
      <wui-flex flexDirection="column" gap="4xs">
        ${this.actions.map((action)=>(0, $7pRM7.html)`
            <wui-list-item
              icon=${action.icon}
              iconSize="sm"
              variant="icon"
              @click=${action.onClick}
            >
              <wui-text variant="small-400" color="fg-100">${action.label}</wui-text>
            </wui-list-item>
          `)}
      </wui-flex>
    `;
    }
};
$98effbc2275b6e89$export$868b19dbe6f5fb81.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $cZf2A.default)
];
$98effbc2275b6e89$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $98effbc2275b6e89$export$868b19dbe6f5fb81.prototype, "actions", void 0);
$98effbc2275b6e89$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $98effbc2275b6e89$export$868b19dbe6f5fb81.prototype, "isOpen", void 0);
$98effbc2275b6e89$export$868b19dbe6f5fb81 = $98effbc2275b6e89$var$__decorate([
    (0, $ailZp.customElement)("wui-dropdown-menu")
], $98effbc2275b6e89$export$868b19dbe6f5fb81);

});
parcelRegister("cZf2A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9746d954ce36eb21$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $9746d954ce36eb21$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    z-index: calc(var(--w3m-z-index) + 1);
    width: 200px;
    padding: var(--wui-spacing-3xs);
    align-items: center;
    display: inherit;
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-color-gray-glass-002);
    background: var(--wui-color-fg-base-125);
    /* Dark/Elevation/L */
    box-shadow:
      0px 8px 22px -6px rgba(0, 0, 0, 0.12),
      0px 14px 64px -4px rgba(0, 0, 0, 0.12);
  }
`;

});


parcelRegister("jlY49", function(module, exports) {

$parcel$export(module.exports, "WuiEmailInput", function () { return $e16e92541719033c$export$99face4607bb46ea; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("eZmW3");

var $3CVPM = parcelRequire("3CVPM");
var $e16e92541719033c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e16e92541719033c$export$99face4607bb46ea = class WuiEmailInput extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-input-text
        placeholder="Email"
        icon="mail"
        size="mdl"
        .disabled=${this.disabled}
        .value=${this.value}
        data-testid="wui-email-input"
      ></wui-input-text>
      ${this.templateError()}
    `;
    }
    templateError() {
        if (this.errorMessage) return (0, $7pRM7.html)`<wui-text variant="tiny-500" color="error-100">${this.errorMessage}</wui-text>`;
        return null;
    }
};
$e16e92541719033c$export$99face4607bb46ea.styles = [
    (0, $jVNMm.resetStyles),
    (0, $3CVPM.default)
];
$e16e92541719033c$var$__decorate([
    (0, $biDip.property)()
], $e16e92541719033c$export$99face4607bb46ea.prototype, "errorMessage", void 0);
$e16e92541719033c$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $e16e92541719033c$export$99face4607bb46ea.prototype, "disabled", void 0);
$e16e92541719033c$var$__decorate([
    (0, $biDip.property)()
], $e16e92541719033c$export$99face4607bb46ea.prototype, "value", void 0);
$e16e92541719033c$export$99face4607bb46ea = $e16e92541719033c$var$__decorate([
    (0, $ailZp.customElement)("wui-email-input")
], $e16e92541719033c$export$99face4607bb46ea);

});
parcelRegister("eZmW3", function(module, exports) {

$parcel$export(module.exports, "WuiInputText", function () { return $ae988db1bc4bf8cb$export$487c694bc02cf7da; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("3TXJn");
var $2utwL = parcelRequire("2utwL");
parcelRequire("7rFd7");
var $kELMR = parcelRequire("kELMR");
parcelRequire("efM2M");
var $gQcSn = parcelRequire("gQcSn");
parcelRequire("i6mxN");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $3gult = parcelRequire("3gult");
var $ae988db1bc4bf8cb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ae988db1bc4bf8cb$export$487c694bc02cf7da = class WuiInputText extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.inputElementRef = (0, $kELMR.createRef)();
        this.size = "md";
        this.disabled = false;
        this.placeholder = "";
        this.type = "text";
        this.value = "";
    }
    render() {
        const inputClass = `wui-padding-right-${this.inputRightPadding}`;
        const sizeClass = `wui-size-${this.size}`;
        const classes = {
            [sizeClass]: true,
            [inputClass]: Boolean(this.inputRightPadding)
        };
        return (0, $7pRM7.html)`${this.templateIcon()}
      <input
        data-testid="wui-input-text"
        ${(0, $kELMR.ref)(this.inputElementRef)}
        class=${(0, $gQcSn.classMap)(classes)}
        type=${this.type}
        enterkeyhint=${(0, $2utwL.ifDefined)(this.enterKeyHint)}
        ?disabled=${this.disabled}
        placeholder=${this.placeholder}
        @input=${this.dispatchInputChangeEvent.bind(this)}
        .value=${this.value || ""}
      />
      <slot></slot>`;
    }
    templateIcon() {
        if (this.icon) return (0, $7pRM7.html)`<wui-icon
        data-input=${this.size}
        size=${this.size}
        color="inherit"
        name=${this.icon}
      ></wui-icon>`;
        return null;
    }
    dispatchInputChangeEvent() {
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: this.inputElementRef.value?.value,
            bubbles: true,
            composed: true
        }));
    }
};
$ae988db1bc4bf8cb$export$487c694bc02cf7da.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $3gult.default)
];
$ae988db1bc4bf8cb$var$__decorate([
    (0, $biDip.property)()
], $ae988db1bc4bf8cb$export$487c694bc02cf7da.prototype, "size", void 0);
$ae988db1bc4bf8cb$var$__decorate([
    (0, $biDip.property)()
], $ae988db1bc4bf8cb$export$487c694bc02cf7da.prototype, "icon", void 0);
$ae988db1bc4bf8cb$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $ae988db1bc4bf8cb$export$487c694bc02cf7da.prototype, "disabled", void 0);
$ae988db1bc4bf8cb$var$__decorate([
    (0, $biDip.property)()
], $ae988db1bc4bf8cb$export$487c694bc02cf7da.prototype, "placeholder", void 0);
$ae988db1bc4bf8cb$var$__decorate([
    (0, $biDip.property)()
], $ae988db1bc4bf8cb$export$487c694bc02cf7da.prototype, "type", void 0);
$ae988db1bc4bf8cb$var$__decorate([
    (0, $biDip.property)()
], $ae988db1bc4bf8cb$export$487c694bc02cf7da.prototype, "keyHint", void 0);
$ae988db1bc4bf8cb$var$__decorate([
    (0, $biDip.property)()
], $ae988db1bc4bf8cb$export$487c694bc02cf7da.prototype, "value", void 0);
$ae988db1bc4bf8cb$var$__decorate([
    (0, $biDip.property)()
], $ae988db1bc4bf8cb$export$487c694bc02cf7da.prototype, "inputRightPadding", void 0);
$ae988db1bc4bf8cb$export$487c694bc02cf7da = $ae988db1bc4bf8cb$var$__decorate([
    (0, $ailZp.customElement)("wui-input-text")
], $ae988db1bc4bf8cb$export$487c694bc02cf7da);

});
parcelRegister("7rFd7", function(module, exports) {
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("kELMR")).createRef; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("kELMR")).ref; });
parcelRequire("kELMR");

});
parcelRegister("kELMR", function(module, exports) {

$parcel$export(module.exports, "createRef", function () { return $f09c9c98ab063a18$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "ref", function () { return $f09c9c98ab063a18$export$eff4d24c3ff7876e; });

var $7pRM7 = parcelRequire("7pRM7");

var $gf7NV = parcelRequire("gf7NV");

var $VcZVx = parcelRequire("VcZVx");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f09c9c98ab063a18$export$7d1e3a5e95ceca43 = ()=>new $f09c9c98ab063a18$var$Zt;
class $f09c9c98ab063a18$var$Zt {
}
const $f09c9c98ab063a18$var$qt = new WeakMap, $f09c9c98ab063a18$export$eff4d24c3ff7876e = (0, $VcZVx.directive)(class extends (0, $gf7NV.AsyncDirective) {
    render(t) {
        return 0, $7pRM7.nothing;
    }
    update(t, [i]) {
        const s = i !== this.Y;
        return s && void 0 !== this.Y && this.rt(void 0), (s || this.lt !== this.ct) && (this.Y = i, this.ht = t.options?.host, this.rt(this.ct = t.element)), $7pRM7.nothing;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $f09c9c98ab063a18$var$qt.get(i);
            void 0 === s && (s = new WeakMap, $f09c9c98ab063a18$var$qt.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $f09c9c98ab063a18$var$qt.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});

});
parcelRegister("gf7NV", function(module, exports) {

$parcel$export(module.exports, "AsyncDirective", function () { return $bd3419d6d610baba$export$7d025501802325e; });

var $fISxK = parcelRequire("fISxK");

var $VcZVx = parcelRequire("VcZVx");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $bd3419d6d610baba$var$mt = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $bd3419d6d610baba$var$mt(i, t);
    return !0;
}, $bd3419d6d610baba$var$_t = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $bd3419d6d610baba$var$wt = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $bd3419d6d610baba$var$gt(t);
    }
};
function $bd3419d6d610baba$var$bt(i) {
    void 0 !== this._$AN ? ($bd3419d6d610baba$var$_t(this), this._$AM = i, $bd3419d6d610baba$var$wt(this)) : this._$AM = i;
}
function $bd3419d6d610baba$var$yt(i, t = !1, e = 0) {
    const s = this._$AH, o = this._$AN;
    if (void 0 !== o && 0 !== o.size) {
        if (t) {
            if (Array.isArray(s)) for(let i = e; i < s.length; i++)$bd3419d6d610baba$var$mt(s[i], !1), $bd3419d6d610baba$var$_t(s[i]);
            else null != s && ($bd3419d6d610baba$var$mt(s, !1), $bd3419d6d610baba$var$_t(s));
        } else $bd3419d6d610baba$var$mt(this, i);
    }
}
const $bd3419d6d610baba$var$gt = (i)=>{
    i.type == (0, $VcZVx.PartType).CHILD && (i._$AP ??= $bd3419d6d610baba$var$yt, i._$AQ ??= $bd3419d6d610baba$var$bt);
};
class $bd3419d6d610baba$export$7d025501802325e extends (0, $VcZVx.Directive) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $bd3419d6d610baba$var$wt(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($bd3419d6d610baba$var$mt(this, i), $bd3419d6d610baba$var$_t(this));
    }
    setValue(i) {
        if ((0, $fISxK.isSingleExpression)(this.t)) this.t._$AI(i, this);
        else {
            const t = [
                ...this.t._$AH
            ];
            t[this.i] = i, this.t._$AI(t, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}

});
parcelRegister("fISxK", function(module, exports) {

$parcel$export(module.exports, "isSingleExpression", function () { return $b725464132ba0230$export$7f431ad0fff82fd9; });

var $7pRM7 = parcelRequire("7pRM7");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $b725464132ba0230$var$et } = (0, $7pRM7._$LH), $b725464132ba0230$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $b725464132ba0230$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $b725464132ba0230$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $b725464132ba0230$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $b725464132ba0230$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $b725464132ba0230$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $b725464132ba0230$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $b725464132ba0230$var$lt = ()=>document.createComment(""), $b725464132ba0230$export$291b2338ad9b0b30 = (o, t, i)=>{
    const n = o._$AA.parentNode, e = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = n.insertBefore($b725464132ba0230$var$lt(), e), l = n.insertBefore($b725464132ba0230$var$lt(), e);
        i = new $b725464132ba0230$var$et(t, l, o, o.options);
    } else {
        const t = i._$AB.nextSibling, l = i._$AM, c = l !== o;
        if (c) {
            let t;
            i._$AQ?.(o), i._$AM = o, void 0 !== i._$AP && (t = o._$AU) !== l._$AU && i._$AP(t);
        }
        if (t !== e || c) {
            let o = i._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                n.insertBefore(o, e), o = t;
            }
        }
    }
    return i;
}, $b725464132ba0230$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $b725464132ba0230$var$ht = {}, $b725464132ba0230$export$ea70d9dd5965b1c8 = (o, t = $b725464132ba0230$var$ht)=>o._$AH = t, $b725464132ba0230$export$59e9bce518cde500 = (o)=>o._$AH, $b725464132ba0230$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $b725464132ba0230$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});




parcelRegister("3gult", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $260a67b350b211af$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $260a67b350b211af$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    width: 100%;
    display: inline-block;
    color: var(--wui-color-fg-275);
  }

  input {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);
    background: var(--wui-color-gray-glass-002);
    font-size: var(--wui-font-size-paragraph);
    letter-spacing: var(--wui-letter-spacing-paragraph);
    color: var(--wui-color-fg-100);
    transition:
      background-color var(--wui-ease-inout-power-1) var(--wui-duration-md),
      border-color var(--wui-ease-inout-power-1) var(--wui-duration-md),
      box-shadow var(--wui-ease-inout-power-1) var(--wui-duration-md);
    will-change: background-color, border-color, box-shadow;
    caret-color: var(--wui-color-accent-100);
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-color-gray-glass-010);
  }

  input:disabled::placeholder,
  input:disabled + wui-icon {
    color: var(--wui-color-fg-300);
  }

  input::placeholder {
    color: var(--wui-color-fg-275);
  }

  input:focus:enabled {
    background-color: var(--wui-color-gray-glass-005);
    -webkit-box-shadow:
      inset 0 0 0 1px var(--wui-color-accent-100),
      0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow:
      inset 0 0 0 1px var(--wui-color-accent-100),
      0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow:
      inset 0 0 0 1px var(--wui-color-accent-100),
      0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  input:hover:enabled {
    background-color: var(--wui-color-gray-glass-005);
  }

  wui-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px var(--wui-spacing-s);
  }

  wui-icon + .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px 36px;
  }

  wui-icon[data-input='sm'] {
    left: var(--wui-spacing-s);
  }

  .wui-size-md {
    padding: 15px var(--wui-spacing-m) var(--wui-spacing-l) var(--wui-spacing-m);
  }

  wui-icon + .wui-size-md,
  wui-loading-spinner + .wui-size-md {
    padding: 10.5px var(--wui-spacing-3xl) 10.5px var(--wui-spacing-3xl);
  }

  wui-icon[data-input='md'] {
    left: var(--wui-spacing-l);
  }

  .wui-size-lg {
    padding: var(--wui-spacing-s) var(--wui-spacing-s) var(--wui-spacing-s) var(--wui-spacing-l);
    letter-spacing: var(--wui-letter-spacing-medium-title);
    font-size: var(--wui-font-size-medium-title);
    font-weight: var(--wui-font-weight-light);
    line-height: 130%;
    color: var(--wui-color-fg-100);
    height: 64px;
  }

  .wui-padding-right-xs {
    padding-right: var(--wui-spacing-xs);
  }

  .wui-padding-right-s {
    padding-right: var(--wui-spacing-s);
  }

  .wui-padding-right-m {
    padding-right: var(--wui-spacing-m);
  }

  .wui-padding-right-l {
    padding-right: var(--wui-spacing-l);
  }

  .wui-padding-right-xl {
    padding-right: var(--wui-spacing-xl);
  }

  .wui-padding-right-2xl {
    padding-right: var(--wui-spacing-2xl);
  }

  .wui-padding-right-3xl {
    padding-right: var(--wui-spacing-3xl);
  }

  .wui-padding-right-4xl {
    padding-right: var(--wui-spacing-4xl);
  }

  .wui-padding-right-5xl {
    padding-right: var(--wui-spacing-5xl);
  }

  wui-icon + .wui-size-lg,
  wui-loading-spinner + .wui-size-lg {
    padding-left: 50px;
  }

  wui-icon[data-input='lg'] {
    left: var(--wui-spacing-l);
  }

  .wui-size-mdl {
    padding: 17.25px var(--wui-spacing-m) 17.25px var(--wui-spacing-m);
  }
  wui-icon + .wui-size-mdl,
  wui-loading-spinner + .wui-size-mdl {
    padding: 17.25px var(--wui-spacing-3xl) 17.25px 40px;
  }
  wui-icon[data-input='mdl'] {
    left: var(--wui-spacing-m);
  }

  input:placeholder-shown ~ ::slotted(wui-input-element),
  input:placeholder-shown ~ ::slotted(wui-icon) {
    opacity: 0;
    pointer-events: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  ::slotted(wui-input-element),
  ::slotted(wui-icon) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  ::slotted(wui-input-element) {
    right: var(--wui-spacing-m);
  }

  ::slotted(wui-icon) {
    right: 0px;
  }
`;

});


parcelRegister("3CVPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a41c86444fda84f$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $2a41c86444fda84f$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  wui-text {
    margin: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-0) var(--wui-spacing-m);
  }
`;

});


parcelRegister("jcpWm", function(module, exports) {

$parcel$export(module.exports, "WuiEnsInput", function () { return $dfa3427d2f734454$export$2dc775ce7bfee34f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("eZmW3");

var $cxRsf = parcelRequire("cxRsf");
parcelRequire("3TXJn");
var $2utwL = parcelRequire("2utwL");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
var $dfa3427d2f734454$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dfa3427d2f734454$export$2dc775ce7bfee34f = class WuiEnsInput extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.loading = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-input-text
        value=${(0, $2utwL.ifDefined)(this.value)}
        ?disabled=${this.disabled}
        .value=${this.value || ""}
        data-testid="wui-ens-input"
        inputRightPadding="5xl"
      >
        ${this.baseNameTemplate()} ${this.errorTemplate()}${this.loadingTemplate()}
      </wui-input-text>
    `;
    }
    baseNameTemplate() {
        return (0, $7pRM7.html)`<wui-text variant="paragraph-400" color="fg-200" class="base-name">
      ${(0, $1VCt9.ConstantsUtil).WC_NAME_SUFFIX}
    </wui-text>`;
    }
    loadingTemplate() {
        return this.loading ? (0, $7pRM7.html)`<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>` : null;
    }
    errorTemplate() {
        if (this.errorMessage) return (0, $7pRM7.html)`<wui-text variant="tiny-500" color="error-100" class="error"
        >${this.errorMessage}</wui-text
      >`;
        return null;
    }
};
$dfa3427d2f734454$export$2dc775ce7bfee34f.styles = [
    (0, $jVNMm.resetStyles),
    (0, $cxRsf.default)
];
$dfa3427d2f734454$var$__decorate([
    (0, $biDip.property)()
], $dfa3427d2f734454$export$2dc775ce7bfee34f.prototype, "errorMessage", void 0);
$dfa3427d2f734454$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $dfa3427d2f734454$export$2dc775ce7bfee34f.prototype, "disabled", void 0);
$dfa3427d2f734454$var$__decorate([
    (0, $biDip.property)()
], $dfa3427d2f734454$export$2dc775ce7bfee34f.prototype, "value", void 0);
$dfa3427d2f734454$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $dfa3427d2f734454$export$2dc775ce7bfee34f.prototype, "loading", void 0);
$dfa3427d2f734454$export$2dc775ce7bfee34f = $dfa3427d2f734454$var$__decorate([
    (0, $ailZp.customElement)("wui-ens-input")
], $dfa3427d2f734454$export$2dc775ce7bfee34f);

});
parcelRegister("cxRsf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9222080dcb1276e3$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $9222080dcb1276e3$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    width: 100%;
    display: inline-block;
    color: var(--wui-color-fg-275);
  }

  .error {
    margin: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-0) var(--wui-spacing-m);
  }

  .base-name {
    position: absolute;
    right: 45px;
    top: 15px;
    text-align: right;
  }
`;

});


parcelRegister("bk8xy", function(module, exports) {

$parcel$export(module.exports, "WuiIconLink", function () { return $83e82fdbbfff67e8$export$5a944ba239383166; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $4ySo0 = parcelRequire("4ySo0");
var $83e82fdbbfff67e8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $83e82fdbbfff67e8$export$5a944ba239383166 = class WuiIconLink extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.disabled = false;
        this.icon = "copy";
        this.iconColor = "inherit";
    }
    render() {
        const borderRadius = this.size === "lg" ? "--wui-border-radius-xs" : "--wui-border-radius-xxs";
        const padding = this.size === "lg" ? "--wui-spacing-1xs" : "--wui-spacing-2xs";
        this.style.cssText = `
    --local-border-radius: var(${borderRadius});
    --local-padding: var(${padding});
`;
        return (0, $7pRM7.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-icon color=${this.iconColor} size=${this.size} name=${this.icon}></wui-icon>
      </button>
    `;
    }
};
$83e82fdbbfff67e8$export$5a944ba239383166.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $jVNMm.colorStyles),
    (0, $4ySo0.default)
];
$83e82fdbbfff67e8$var$__decorate([
    (0, $biDip.property)()
], $83e82fdbbfff67e8$export$5a944ba239383166.prototype, "size", void 0);
$83e82fdbbfff67e8$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $83e82fdbbfff67e8$export$5a944ba239383166.prototype, "disabled", void 0);
$83e82fdbbfff67e8$var$__decorate([
    (0, $biDip.property)()
], $83e82fdbbfff67e8$export$5a944ba239383166.prototype, "icon", void 0);
$83e82fdbbfff67e8$var$__decorate([
    (0, $biDip.property)()
], $83e82fdbbfff67e8$export$5a944ba239383166.prototype, "iconColor", void 0);
$83e82fdbbfff67e8$export$5a944ba239383166 = $83e82fdbbfff67e8$var$__decorate([
    (0, $ailZp.customElement)("wui-icon-link")
], $83e82fdbbfff67e8$export$5a944ba239383166);

});
parcelRegister("4ySo0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3524865ee765ca01$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $3524865ee765ca01$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    border-radius: var(--local-border-radius);
    color: var(--wui-color-fg-100);
    padding: var(--local-padding);
  }

  @media (max-width: 700px) {
    button {
      padding: var(--wui-spacing-s);
    }
  }

  button > wui-icon {
    pointer-events: none;
  }

  button:disabled > wui-icon {
    color: var(--wui-color-bg-300) !important;
  }

  button:disabled {
    background-color: transparent;
  }
`;

});


parcelRegister("dnpyM", function(module, exports) {

$parcel$export(module.exports, "WuiInputElement", function () { return $9bd14009a773a7e4$export$673191bf93fc142c; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $g6uKI = parcelRequire("g6uKI");
var $9bd14009a773a7e4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9bd14009a773a7e4$export$673191bf93fc142c = class WuiInputElement extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.icon = "copy";
    }
    render() {
        return (0, $7pRM7.html)`
      <button>
        <wui-icon color="inherit" size="xxs" name=${this.icon}></wui-icon>
      </button>
    `;
    }
};
$9bd14009a773a7e4$export$673191bf93fc142c.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $g6uKI.default)
];
$9bd14009a773a7e4$var$__decorate([
    (0, $biDip.property)()
], $9bd14009a773a7e4$export$673191bf93fc142c.prototype, "icon", void 0);
$9bd14009a773a7e4$export$673191bf93fc142c = $9bd14009a773a7e4$var$__decorate([
    (0, $ailZp.customElement)("wui-input-element")
], $9bd14009a773a7e4$export$673191bf93fc142c);

});
parcelRegister("g6uKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb950fb24dd23647$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $bb950fb24dd23647$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    background-color: var(--wui-color-fg-300);
    border-radius: var(--wui-border-radius-4xs);
    width: 16px;
    height: 16px;
  }

  button:disabled {
    background-color: var(--wui-color-bg-300);
  }

  wui-icon {
    color: var(--wui-color-bg-200) !important;
  }

  button:focus-visible {
    background-color: var(--wui-color-fg-250);
    border: 1px solid var(--wui-color-accent-100);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-fg-250);
    }

    button:active:enabled {
      background-color: var(--wui-color-fg-225);
    }
  }
`;

});


parcelRegister("jPHPA", function(module, exports) {

$parcel$export(module.exports, "WuiInputNumeric", function () { return $e704c7ad8f7e04d7$export$230332bec9d0029b; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $8DPmI = parcelRequire("8DPmI");
var $e704c7ad8f7e04d7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e704c7ad8f7e04d7$export$230332bec9d0029b = class WuiInputNumeric extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.value = "";
    }
    render() {
        return (0, $7pRM7.html)`<input
      type="number"
      maxlength="1"
      inputmode="numeric"
      autofocus
      ?disabled=${this.disabled}
      value=${this.value}
    /> `;
    }
};
$e704c7ad8f7e04d7$export$230332bec9d0029b.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $8DPmI.default)
];
$e704c7ad8f7e04d7$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $e704c7ad8f7e04d7$export$230332bec9d0029b.prototype, "disabled", void 0);
$e704c7ad8f7e04d7$var$__decorate([
    (0, $biDip.property)({
        type: String
    })
], $e704c7ad8f7e04d7$export$230332bec9d0029b.prototype, "value", void 0);
$e704c7ad8f7e04d7$export$230332bec9d0029b = $e704c7ad8f7e04d7$var$__decorate([
    (0, $ailZp.customElement)("wui-input-numeric")
], $e704c7ad8f7e04d7$export$230332bec9d0029b);

});
parcelRegister("8DPmI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a9cf5e5a79afdf$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $64a9cf5e5a79afdf$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  input {
    width: 50px;
    height: 50px;
    background: var(--wui-color-gray-glass-010);
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-color-gray-glass-005);
    font-family: var(--wui-font-family);
    font-size: var(--wui-font-size-large);
    font-weight: var(--wui-font-weight-regular);
    letter-spacing: var(--wui-letter-spacing-large);
    text-align: center;
    color: var(--wui-color-fg-100);
    caret-color: var(--wui-color-accent-100);
    transition:
      background-color var(--wui-ease-inout-power-1) var(--wui-duration-md),
      border-color var(--wui-ease-inout-power-1) var(--wui-duration-md),
      box-shadow var(--wui-ease-inout-power-1) var(--wui-duration-md);
    will-change: background-color, border-color, box-shadow;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    padding: 0px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-color-gray-glass-010);
    background: var(--wui-color-gray-glass-005);
  }

  input:focus:enabled {
    background-color: var(--wui-color-gray-glass-015);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  @media (hover: hover) and (pointer: fine) {
    input:hover:enabled {
      background-color: var(--wui-color-gray-glass-015);
    }
  }
`;

});


parcelRegister("7HPis", function(module, exports) {

$parcel$export(module.exports, "WuiLink", function () { return $59c457023c195a68$export$f279fe723271abb; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $8geHl = parcelRequire("8geHl");
var $59c457023c195a68$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $59c457023c195a68$export$f279fe723271abb = class WuiLink extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
    }
    render() {
        return (0, $7pRM7.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <slot name="iconLeft"></slot>
        <wui-text variant="small-600" color=${this.color}>
          <slot></slot>
        </wui-text>
        <slot name="iconRight"></slot>
      </button>
    `;
    }
};
$59c457023c195a68$export$f279fe723271abb.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $8geHl.default)
];
$59c457023c195a68$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $59c457023c195a68$export$f279fe723271abb.prototype, "disabled", void 0);
$59c457023c195a68$var$__decorate([
    (0, $biDip.property)()
], $59c457023c195a68$export$f279fe723271abb.prototype, "color", void 0);
$59c457023c195a68$export$f279fe723271abb = $59c457023c195a68$var$__decorate([
    (0, $ailZp.customElement)("wui-link")
], $59c457023c195a68$export$f279fe723271abb);

});
parcelRegister("8geHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $603b38181335e582$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $603b38181335e582$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
    border-radius: var(--wui-border-radius-3xs);
    background-color: transparent;
    color: var(--wui-color-accent-100);
  }

  button:disabled {
    background-color: transparent;
    color: var(--wui-color-gray-glass-015);
  }

  button:hover {
    background-color: var(--wui-color-gray-glass-005);
  }
`;

});


parcelRegister("fPEeo", function(module, exports) {

$parcel$export(module.exports, "WuiListItem", function () { return $b86ad382dc7194c1$export$cd9b2e41f828fc8a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("3TXJn");
var $2utwL = parcelRequire("2utwL");
parcelRequire("i6mxN");
parcelRequire("4BuLe");
parcelRequire("ck0jF");
parcelRequire("fCaEm");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("7XtWS");

var $7Z6Wa = parcelRequire("7Z6Wa");
var $b86ad382dc7194c1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b86ad382dc7194c1$export$cd9b2e41f828fc8a = class WuiListItem extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "icon";
        this.disabled = false;
        this.imageSrc = undefined;
        this.alt = undefined;
        this.chevron = false;
        this.loading = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button
        ?disabled=${this.loading ? true : Boolean(this.disabled)}
        data-loading=${this.loading}
        data-iconvariant=${(0, $2utwL.ifDefined)(this.iconVariant)}
        ontouchstart
      >
        ${this.loadingTemplate()} ${this.visualTemplate()}
        <wui-flex gap="3xs">
          <slot></slot>
        </wui-flex>
        ${this.chevronTemplate()}
      </button>
    `;
    }
    visualTemplate() {
        if (this.variant === "image" && this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "list item"}></wui-image>`;
        if (this.iconVariant === "square" && this.icon && this.variant === "icon") return (0, $7pRM7.html)`<wui-icon name=${this.icon}></wui-icon>`;
        if (this.variant === "icon" && this.icon && this.iconVariant) {
            const color = [
                "blue",
                "square-blue"
            ].includes(this.iconVariant) ? "accent-100" : "fg-200";
            const size = this.iconVariant === "square-blue" ? "mdl" : "md";
            const iconSize = this.iconSize ? this.iconSize : size;
            return (0, $7pRM7.html)`
        <wui-icon-box
          data-variant=${this.iconVariant}
          icon=${this.icon}
          iconSize=${iconSize}
          background="transparent"
          iconColor=${color}
          backgroundColor=${color}
          size=${size}
        ></wui-icon-box>
      `;
        }
        return null;
    }
    loadingTemplate() {
        if (this.loading) return (0, $7pRM7.html)`<wui-loading-spinner color="fg-300"></wui-loading-spinner>`;
        return (0, $7pRM7.html)``;
    }
    chevronTemplate() {
        if (this.chevron) return (0, $7pRM7.html)`<wui-icon size="inherit" color="fg-200" name="chevronRight"></wui-icon>`;
        return null;
    }
};
$b86ad382dc7194c1$export$cd9b2e41f828fc8a.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $7Z6Wa.default)
];
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)()
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "icon", void 0);
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)()
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "iconSize", void 0);
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)()
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "variant", void 0);
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)()
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "iconVariant", void 0);
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "disabled", void 0);
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)()
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "imageSrc", void 0);
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)()
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "alt", void 0);
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "chevron", void 0);
$b86ad382dc7194c1$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a.prototype, "loading", void 0);
$b86ad382dc7194c1$export$cd9b2e41f828fc8a = $b86ad382dc7194c1$var$__decorate([
    (0, $ailZp.customElement)("wui-list-item")
], $b86ad382dc7194c1$export$cd9b2e41f828fc8a);

});
parcelRegister("7Z6Wa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d039c8244de0ba5$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $5d039c8244de0ba5$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 11px 18px 11px var(--wui-spacing-s);
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
    transition:
      color var(--wui-ease-out-power-1) var(--wui-duration-md),
      background-color var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: color, background-color;
  }

  button[data-iconvariant='square'],
  button[data-iconvariant='square-blue'] {
    padding: 6px 18px 6px 9px;
  }

  button > wui-flex {
    flex: 1;
  }

  button > wui-image {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);
    border-radius: var(--wui-border-radius-3xl);
  }

  button > wui-icon {
    width: 36px;
    height: 36px;
    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: opacity;
  }

  button > wui-icon-box[data-variant='blue'] {
    box-shadow: 0 0 0 2px var(--wui-color-accent-glass-005);
  }

  button > wui-icon-box[data-variant='overlay'] {
    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);
  }

  button > wui-icon-box[data-variant='square-blue'] {
    border-radius: var(--wui-border-radius-3xs);
    position: relative;
    border: none;
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='square-blue']::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-color-accent-glass-010);
    pointer-events: none;
  }

  button > wui-icon:last-child {
    width: 14px;
    height: 14px;
  }

  button:disabled {
    color: var(--wui-color-gray-glass-020);
  }

  button[data-loading='true'] > wui-icon {
    opacity: 0;
  }

  wui-loading-spinner {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

});


parcelRegister("lqPpk", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItem", function () { return $f9a3e7217a1f4662$export$ee516ccb0af19908; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $ailZp = parcelRequire("ailZp");

var $2gKmg = parcelRequire("2gKmg");

var $jVNMm = parcelRequire("jVNMm");
parcelRequire("fCaEm");
parcelRequire("9p6m6");
parcelRequire("3TXJn");
var $2utwL = parcelRequire("2utwL");

var $lomvy = parcelRequire("lomvy");
var $f9a3e7217a1f4662$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f9a3e7217a1f4662$export$ee516ccb0af19908 = class WuiTransactionListItem extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.type = "approve";
        this.onlyDirectionIcon = false;
        this.images = [];
        this.price = [];
        this.amount = [];
        this.symbol = [];
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-flex>
        <wui-transaction-visual
          .status=${this.status}
          direction=${(0, $2utwL.ifDefined)(this.direction)}
          type=${this.type}
          onlyDirectionIcon=${(0, $2utwL.ifDefined)(this.onlyDirectionIcon)}
          .images=${this.images}
        ></wui-transaction-visual>
        <wui-flex flexDirection="column" gap="3xs">
          <wui-text variant="paragraph-600" color="fg-100">
            ${(0, $2gKmg.TransactionTypePastTense)[this.type] || this.type}
          </wui-text>
          <wui-flex class="description-container">
            ${this.templateDescription()} ${this.templateSecondDescription()}
          </wui-flex>
        </wui-flex>
        <wui-text variant="micro-700" color="fg-300"><span>${this.date}</span></wui-text>
      </wui-flex>
    `;
    }
    templateDescription() {
        const description = this.descriptions?.[0];
        return description ? (0, $7pRM7.html)`
          <wui-text variant="small-500" color="fg-200">
            <span>${description}</span>
          </wui-text>
        ` : null;
    }
    templateSecondDescription() {
        const description = this.descriptions?.[1];
        return description ? (0, $7pRM7.html)`
          <wui-icon class="description-separator-icon" size="xxs" name="arrowRight"></wui-icon>
          <wui-text variant="small-400" color="fg-200">
            <span>${description}</span>
          </wui-text>
        ` : null;
    }
};
$f9a3e7217a1f4662$export$ee516ccb0af19908.styles = [
    (0, $jVNMm.resetStyles),
    (0, $lomvy.default)
];
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)()
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "type", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "descriptions", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)()
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "date", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "onlyDirectionIcon", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)()
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "status", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)()
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "direction", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "images", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "price", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "amount", void 0);
$f9a3e7217a1f4662$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $f9a3e7217a1f4662$export$ee516ccb0af19908.prototype, "symbol", void 0);
$f9a3e7217a1f4662$export$ee516ccb0af19908 = $f9a3e7217a1f4662$var$__decorate([
    (0, $ailZp.customElement)("wui-transaction-list-item")
], $f9a3e7217a1f4662$export$ee516ccb0af19908);

});
parcelRegister("2gKmg", function(module, exports) {

$parcel$export(module.exports, "TransactionTypePastTense", function () { return $1a71092bb39184b5$export$1c6b44bd2bf7f8fa; });
var $1a71092bb39184b5$export$1c6b44bd2bf7f8fa;
(function(TransactionTypePastTense) {
    TransactionTypePastTense["approve"] = "approved";
    TransactionTypePastTense["bought"] = "bought";
    TransactionTypePastTense["borrow"] = "borrowed";
    TransactionTypePastTense["burn"] = "burnt";
    TransactionTypePastTense["cancel"] = "canceled";
    TransactionTypePastTense["claim"] = "claimed";
    TransactionTypePastTense["deploy"] = "deployed";
    TransactionTypePastTense["deposit"] = "deposited";
    TransactionTypePastTense["execute"] = "executed";
    TransactionTypePastTense["mint"] = "minted";
    TransactionTypePastTense["receive"] = "received";
    TransactionTypePastTense["repay"] = "repaid";
    TransactionTypePastTense["send"] = "sent";
    TransactionTypePastTense["sell"] = "sold";
    TransactionTypePastTense["stake"] = "staked";
    TransactionTypePastTense["trade"] = "swapped";
    TransactionTypePastTense["unstake"] = "unstaked";
    TransactionTypePastTense["withdraw"] = "withdrawn";
})($1a71092bb39184b5$export$1c6b44bd2bf7f8fa || ($1a71092bb39184b5$export$1c6b44bd2bf7f8fa = {}));

});

parcelRegister("9p6m6", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionVisual", function () { return $6d8b60ec3b314227$export$98664c16c41f47e3; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $ailZp = parcelRequire("ailZp");
parcelRequire("4BuLe");
parcelRequire("7XtWS");

var $jjCs1 = parcelRequire("jjCs1");
var $6d8b60ec3b314227$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6d8b60ec3b314227$export$98664c16c41f47e3 = class WuiTransactionVisual extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.images = [];
        this.secondImage = {
            type: undefined,
            url: ""
        };
    }
    render() {
        const [firstImage, secondImage] = this.images;
        const isLeftNFT = firstImage?.type === "NFT";
        const isRightNFT = secondImage?.url ? secondImage.type === "NFT" : isLeftNFT;
        const leftRadius = isLeftNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
        const rightRadius = isRightNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
        this.style.cssText = `
    --local-left-border-radius: ${leftRadius};
    --local-right-border-radius: ${rightRadius};
    `;
        return (0, $7pRM7.html)`<wui-flex> ${this.templateVisual()} ${this.templateIcon()} </wui-flex>`;
    }
    templateVisual() {
        const [firstImage, secondImage] = this.images;
        const firstImageType = firstImage?.type;
        const haveTwoImages = this.images.length === 2;
        if (haveTwoImages && (firstImage?.url || secondImage?.url)) return (0, $7pRM7.html)`<div class="swap-images-container">
        ${firstImage?.url ? (0, $7pRM7.html)`<wui-image src=${firstImage.url} alt="Transaction image"></wui-image>` : null}
        ${secondImage?.url ? (0, $7pRM7.html)`<wui-image src=${secondImage.url} alt="Transaction image"></wui-image>` : null}
      </div>`;
        else if (firstImage?.url) return (0, $7pRM7.html)`<wui-image src=${firstImage.url} alt="Transaction image"></wui-image>`;
        else if (firstImageType === "NFT") return (0, $7pRM7.html)`<wui-icon size="inherit" color="fg-200" name="nftPlaceholder"></wui-icon>`;
        return (0, $7pRM7.html)`<wui-icon size="inherit" color="fg-200" name="coinPlaceholder"></wui-icon>`;
    }
    templateIcon() {
        let color = "accent-100";
        let icon = undefined;
        icon = this.getIcon();
        if (this.status) color = this.getStatusColor();
        if (!icon) return null;
        return (0, $7pRM7.html)`
      <wui-icon-box
        size="xxs"
        iconColor=${color}
        backgroundColor=${color}
        background="opaque"
        icon=${icon}
        ?border=${true}
        borderColor="wui-color-bg-125"
      ></wui-icon-box>
    `;
    }
    getDirectionIcon() {
        switch(this.direction){
            case "in":
                return "arrowBottom";
            case "out":
                return "arrowTop";
            default:
                return undefined;
        }
    }
    getIcon() {
        if (this.onlyDirectionIcon) return this.getDirectionIcon();
        if (this.type === "trade") return "swapHorizontalBold";
        else if (this.type === "approve") return "checkmark";
        else if (this.type === "cancel") return "close";
        return this.getDirectionIcon();
    }
    getStatusColor() {
        switch(this.status){
            case "confirmed":
                return "success-100";
            case "failed":
                return "error-100";
            case "pending":
                return "inverse-100";
            default:
                return "accent-100";
        }
    }
};
$6d8b60ec3b314227$export$98664c16c41f47e3.styles = [
    (0, $jjCs1.default)
];
$6d8b60ec3b314227$var$__decorate([
    (0, $biDip.property)()
], $6d8b60ec3b314227$export$98664c16c41f47e3.prototype, "type", void 0);
$6d8b60ec3b314227$var$__decorate([
    (0, $biDip.property)()
], $6d8b60ec3b314227$export$98664c16c41f47e3.prototype, "status", void 0);
$6d8b60ec3b314227$var$__decorate([
    (0, $biDip.property)()
], $6d8b60ec3b314227$export$98664c16c41f47e3.prototype, "direction", void 0);
$6d8b60ec3b314227$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $6d8b60ec3b314227$export$98664c16c41f47e3.prototype, "onlyDirectionIcon", void 0);
$6d8b60ec3b314227$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $6d8b60ec3b314227$export$98664c16c41f47e3.prototype, "images", void 0);
$6d8b60ec3b314227$var$__decorate([
    (0, $biDip.property)({
        type: Object
    })
], $6d8b60ec3b314227$export$98664c16c41f47e3.prototype, "secondImage", void 0);
$6d8b60ec3b314227$export$98664c16c41f47e3 = $6d8b60ec3b314227$var$__decorate([
    (0, $ailZp.customElement)("wui-transaction-visual")
], $6d8b60ec3b314227$export$98664c16c41f47e3);

});
parcelRegister("jjCs1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0fd9e38c60d8fd7$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $e0fd9e38c60d8fd7$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host > wui-flex {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 40px;
    height: 40px;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
    background-color: var(--wui-color-gray-glass-005);
  }

  :host > wui-flex wui-image {
    display: block;
  }

  :host > wui-flex,
  :host > wui-flex wui-image,
  .swap-images-container,
  .swap-images-container.nft,
  wui-image.nft {
    border-top-left-radius: var(--local-left-border-radius);
    border-top-right-radius: var(--local-right-border-radius);
    border-bottom-left-radius: var(--local-left-border-radius);
    border-bottom-right-radius: var(--local-right-border-radius);
  }

  wui-icon {
    width: 20px;
    height: 20px;
  }

  wui-icon-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
  }

  .swap-images-container {
    position: relative;
    width: 40px;
    height: 40px;
    overflow: hidden;
  }

  .swap-images-container wui-image:first-child {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    left: 0%;
    clip-path: inset(0px calc(50% + 2px) 0px 0%);
  }

  .swap-images-container wui-image:last-child {
    clip-path: inset(0px 0px 0px calc(50% + 2px));
  }
`;

});


parcelRegister("lomvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f92d4c73bac62d9f$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $f92d4c73bac62d9f$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host > wui-flex:first-child {
    align-items: center;
    column-gap: var(--wui-spacing-s);
    padding: 6.5px var(--wui-spacing-xs) 6.5px var(--wui-spacing-xs);
    width: 100%;
  }

  :host > wui-flex:first-child wui-text:nth-child(1) {
    text-transform: capitalize;
  }

  wui-transaction-visual {
    width: 40px;
    height: 40px;
  }

  wui-flex {
    flex: 1;
  }

  :host wui-flex wui-flex {
    overflow: hidden;
  }

  :host .description-container wui-text span {
    word-break: break-all;
  }

  :host .description-container wui-text {
    overflow: hidden;
  }

  :host .description-separator-icon {
    margin: 0px 6px;
  }

  :host wui-text > span {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
`;

});


parcelRegister("gcmDm", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItemLoader", function () { return $bcaf52f77ffe7d9f$export$994c2d15662c37cc; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");

var $ailZp = parcelRequire("ailZp");

var $jVNMm = parcelRequire("jVNMm");
parcelRequire("fCaEm");
parcelRequire("9p6m6");

var $9Zl2S = parcelRequire("9Zl2S");
var $bcaf52f77ffe7d9f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bcaf52f77ffe7d9f$export$994c2d15662c37cc = class WuiTransactionListItemLoader extends (0, $cLW71.LitElement) {
    render() {
        return (0, $7pRM7.html)`
      <wui-flex alignItems="center">
        <wui-shimmer width="40px" height="40px"></wui-shimmer>
        <wui-flex flexDirection="column" gap="2xs">
          <wui-shimmer width="72px" height="16px" borderRadius="4xs"></wui-shimmer>
          <wui-shimmer width="148px" height="14px" borderRadius="4xs"></wui-shimmer>
        </wui-flex>
        <wui-shimmer width="24px" height="12px" borderRadius="5xs"></wui-shimmer>
      </wui-flex>
    `;
    }
};
$bcaf52f77ffe7d9f$export$994c2d15662c37cc.styles = [
    (0, $jVNMm.resetStyles),
    (0, $9Zl2S.default)
];
$bcaf52f77ffe7d9f$export$994c2d15662c37cc = $bcaf52f77ffe7d9f$var$__decorate([
    (0, $ailZp.customElement)("wui-transaction-list-item-loader")
], $bcaf52f77ffe7d9f$export$994c2d15662c37cc);

});
parcelRegister("9Zl2S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $745a22c05ff9756a$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $745a22c05ff9756a$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host > wui-flex:first-child {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
  }

  wui-flex {
    display: flex;
    flex: 1;
  }
`;

});


parcelRegister("bneDN", function(module, exports) {

$parcel$export(module.exports, "WuiListWallet", function () { return $847d3315dfee9779$export$fe01be9b7ff81a09; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("7XtWS");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("kVhUK");
parcelRequire("DCXdn");
parcelRequire("cLomv");

var $gYqOl = parcelRequire("gYqOl");
var $847d3315dfee9779$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $847d3315dfee9779$export$fe01be9b7ff81a09 = class WuiListWallet extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.walletImages = [];
        this.imageSrc = "";
        this.name = "";
        this.installed = false;
        this.disabled = false;
        this.showAllWallets = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        ${this.templateAllWallets()} ${this.templateWalletImage()}
        <wui-text variant="paragraph-500" color="inherit">${this.name}</wui-text>
        ${this.templateStatus()}
      </button>
    `;
    }
    templateAllWallets() {
        if (this.showAllWallets && this.imageSrc) return (0, $7pRM7.html)` <wui-all-wallets-image .imageeSrc=${this.imageSrc}> </wui-all-wallets-image> `;
        else if (this.showAllWallets && this.walletIcon) return (0, $7pRM7.html)` <wui-wallet-image .walletIcon=${this.walletIcon} size="sm"> </wui-wallet-image> `;
        return null;
    }
    templateWalletImage() {
        if (!this.showAllWallets && this.imageSrc) return (0, $7pRM7.html)`<wui-wallet-image
        size="sm"
        imageSrc=${this.imageSrc}
        name=${this.name}
        .installed=${this.installed}
      ></wui-wallet-image>`;
        else if (!this.showAllWallets && !this.imageSrc) return (0, $7pRM7.html)`<wui-wallet-image size="sm" name=${this.name}></wui-wallet-image>`;
        return null;
    }
    templateStatus() {
        if (this.tagLabel && this.tagVariant) return (0, $7pRM7.html)`<wui-tag variant=${this.tagVariant}>${this.tagLabel}</wui-tag>`;
        else if (this.icon) return (0, $7pRM7.html)`<wui-icon color="inherit" size="sm" name=${this.icon}></wui-icon>`;
        return null;
    }
};
$847d3315dfee9779$export$fe01be9b7ff81a09.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $gYqOl.default)
];
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "walletImages", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)()
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "imageSrc", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)()
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "name", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)()
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "tagLabel", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)()
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "tagVariant", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)()
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "icon", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)()
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "walletIcon", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "installed", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "disabled", void 0);
$847d3315dfee9779$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $847d3315dfee9779$export$fe01be9b7ff81a09.prototype, "showAllWallets", void 0);
$847d3315dfee9779$export$fe01be9b7ff81a09 = $847d3315dfee9779$var$__decorate([
    (0, $ailZp.customElement)("wui-list-wallet")
], $847d3315dfee9779$export$fe01be9b7ff81a09);

});
parcelRegister("DCXdn", function(module, exports) {

$parcel$export(module.exports, "WuiTag", function () { return $0771dc19d838aedb$export$989e5aad4666150; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $5iHwy = parcelRequire("5iHwy");
var $0771dc19d838aedb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0771dc19d838aedb$export$989e5aad4666150 = class WuiTag extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "main";
        this.size = "lg";
    }
    render() {
        this.dataset["variant"] = this.variant;
        this.dataset["size"] = this.size;
        const textVariant = this.size === "md" ? "mini-700" : "micro-700";
        return (0, $7pRM7.html)`
      <wui-text data-variant=${this.variant} variant=${textVariant} color="inherit">
        <slot></slot>
      </wui-text>
    `;
    }
};
$0771dc19d838aedb$export$989e5aad4666150.styles = [
    (0, $jVNMm.resetStyles),
    (0, $5iHwy.default)
];
$0771dc19d838aedb$var$__decorate([
    (0, $biDip.property)()
], $0771dc19d838aedb$export$989e5aad4666150.prototype, "variant", void 0);
$0771dc19d838aedb$var$__decorate([
    (0, $biDip.property)()
], $0771dc19d838aedb$export$989e5aad4666150.prototype, "size", void 0);
$0771dc19d838aedb$export$989e5aad4666150 = $0771dc19d838aedb$var$__decorate([
    (0, $ailZp.customElement)("wui-tag")
], $0771dc19d838aedb$export$989e5aad4666150);

});
parcelRegister("5iHwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dc0652a0afadaf5$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $3dc0652a0afadaf5$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    height: var(--wui-spacing-m);
    padding: 0 var(--wui-spacing-3xs) !important;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host > wui-text {
    transform: translateY(5%);
  }

  :host([data-variant='main']) {
    background-color: var(--wui-color-accent-glass-015);
    color: var(--wui-color-accent-100);
  }

  :host([data-variant='shade']) {
    background-color: var(--wui-color-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  :host([data-variant='success']) {
    background-color: var(--wui-icon-box-bg-success-100);
    color: var(--wui-color-success-100);
  }

  :host([data-variant='error']) {
    background-color: var(--wui-icon-box-bg-error-100);
    color: var(--wui-color-error-100);
  }

  :host([data-size='lg']) {
    padding: 11px 5px !important;
  }

  :host([data-size='lg']) > wui-text {
    transform: translateY(2%);
  }
`;

});


parcelRegister("gYqOl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5b70c11802f78d9$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $c5b70c11802f78d9$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  button > wui-text:nth-child(2) {
    display: flex;
    flex: 1;
  }

  button:disabled {
    background-color: var(--wui-color-gray-glass-015);
    color: var(--wui-color-gray-glass-015);
  }

  button:disabled > wui-tag {
    background-color: var(--wui-color-gray-glass-010);
    color: var(--wui-color-fg-300);
  }

  wui-icon {
    color: var(--wui-color-fg-200) !important;
  }
`;

});


parcelRegister("j34cm", function(module, exports) {

$parcel$export(module.exports, "WuiLogoSelect", function () { return $dde18dd656a1800d$export$aadc276ee48f1572; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("aPnTQ");

var $axHIY = parcelRequire("axHIY");
var $dde18dd656a1800d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dde18dd656a1800d$export$aadc276ee48f1572 = class WuiLogoSelect extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
        this.disabled = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-logo logo=${this.logo}></wui-logo>
      </button>
    `;
    }
};
$dde18dd656a1800d$export$aadc276ee48f1572.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $axHIY.default)
];
$dde18dd656a1800d$var$__decorate([
    (0, $biDip.property)()
], $dde18dd656a1800d$export$aadc276ee48f1572.prototype, "logo", void 0);
$dde18dd656a1800d$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $dde18dd656a1800d$export$aadc276ee48f1572.prototype, "disabled", void 0);
$dde18dd656a1800d$export$aadc276ee48f1572 = $dde18dd656a1800d$var$__decorate([
    (0, $ailZp.customElement)("wui-logo-select")
], $dde18dd656a1800d$export$aadc276ee48f1572);

});
parcelRegister("aPnTQ", function(module, exports) {

$parcel$export(module.exports, "WuiLogo", function () { return $7e2134c73be82d41$export$e515c2183ed1fdbc; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $1ZdOS = parcelRequire("1ZdOS");
var $7e2134c73be82d41$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7e2134c73be82d41$export$e515c2183ed1fdbc = class WuiLogo extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
    }
    render() {
        return (0, $7pRM7.html)`<wui-icon color="inherit" size="inherit" name=${this.logo}></wui-icon> `;
    }
};
$7e2134c73be82d41$export$e515c2183ed1fdbc.styles = [
    (0, $jVNMm.resetStyles),
    (0, $1ZdOS.default)
];
$7e2134c73be82d41$var$__decorate([
    (0, $biDip.property)()
], $7e2134c73be82d41$export$e515c2183ed1fdbc.prototype, "logo", void 0);
$7e2134c73be82d41$export$e515c2183ed1fdbc = $7e2134c73be82d41$var$__decorate([
    (0, $ailZp.customElement)("wui-logo")
], $7e2134c73be82d41$export$e515c2183ed1fdbc);

});
parcelRegister("1ZdOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17263540f771dad4$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $17263540f771dad4$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-color-gray-glass-005);
    overflow: hidden;
  }

  wui-icon {
    width: 100%;
    height: 100%;
  }
`;

});


parcelRegister("axHIY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7acee734ff3a4908$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $7acee734ff3a4908$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    width: 100%;
  }

  button {
    width: 100%;
    height: 56px;
    background: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("ge9kn", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkButton", function () { return $bd0530728f910fc8$export$bb00a3a9463dc4a7; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("4BuLe");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("7XtWS");

var $dDsGF = parcelRequire("dDsGF");
var $bd0530728f910fc8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bd0530728f910fc8$export$bb00a3a9463dc4a7 = class WuiNetworkButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.isUnsupportedChain = undefined;
        this.disabled = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button data-testid="w3m-network-button" ?disabled=${this.disabled}>
        ${this.visualTemplate()}
        <wui-text variant="paragraph-600" color="inherit">
          <slot></slot>
        </wui-text>
      </button>
    `;
    }
    visualTemplate() {
        if (this.isUnsupportedChain) return (0, $7pRM7.html)`
        <wui-icon-box
          size="sm"
          iconColor="error-100"
          backgroundColor="error-100"
          icon="warningCircle"
        ></wui-icon-box>
      `;
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return (0, $7pRM7.html)`
      <wui-icon-box
        size="sm"
        iconColor="inverse-100"
        backgroundColor="fg-100"
        icon="networkPlaceholder"
      ></wui-icon-box>
    `;
    }
};
$bd0530728f910fc8$export$bb00a3a9463dc4a7.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $dDsGF.default)
];
$bd0530728f910fc8$var$__decorate([
    (0, $biDip.property)()
], $bd0530728f910fc8$export$bb00a3a9463dc4a7.prototype, "imageSrc", void 0);
$bd0530728f910fc8$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $bd0530728f910fc8$export$bb00a3a9463dc4a7.prototype, "isUnsupportedChain", void 0);
$bd0530728f910fc8$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $bd0530728f910fc8$export$bb00a3a9463dc4a7.prototype, "disabled", void 0);
$bd0530728f910fc8$export$bb00a3a9463dc4a7 = $bd0530728f910fc8$var$__decorate([
    (0, $ailZp.customElement)("wui-network-button")
], $bd0530728f910fc8$export$bb00a3a9463dc4a7);

});
parcelRegister("dDsGF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ed52b88e0148dc8$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $9ed52b88e0148dc8$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-2xs) var(--wui-spacing-s) var(--wui-spacing-2xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-color-gray-glass-010);
    background-color: var(--wui-color-gray-glass-005);
    color: var(--wui-color-fg-100);
  }

  button:disabled {
    border: 1px solid var(--wui-color-gray-glass-005);
    background-color: var(--wui-color-gray-glass-015);
    color: var(--wui-color-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-gray-glass-010);
    }

    button:active:enabled {
      background-color: var(--wui-color-gray-glass-015);
    }
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);
  }
`;

});


parcelRegister("kyDrS", function(module, exports) {

$parcel$export(module.exports, "WuiOtp", function () { return $ef759547ebf4ddeb$export$443bf27d3bf7bc18; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
var $koENb = parcelRequire("koENb");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $fIDM4 = parcelRequire("fIDM4");

var $ailZp = parcelRequire("ailZp");
parcelRequire("jPHPA");

var $fMUGw = parcelRequire("fMUGw");
var $ef759547ebf4ddeb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ef759547ebf4ddeb$export$443bf27d3bf7bc18 = class WuiOtp extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.length = 6;
        this.otp = "";
        this.values = Array.from({
            length: this.length
        }).map(()=>"");
        this.numerics = [];
        this.shouldInputBeEnabled = (index)=>{
            const previousInputs = this.values.slice(0, index);
            return previousInputs.every((input)=>input !== "");
        };
        this.handleKeyDown = (e, index)=>{
            const inputElement = e.target;
            const input = this.getInputElement(inputElement);
            const keyArr = [
                "ArrowLeft",
                "ArrowRight",
                "Shift",
                "Delete"
            ];
            if (!input) return;
            if (keyArr.includes(e.key)) e.preventDefault();
            const currentCaretPos = input.selectionStart;
            switch(e.key){
                case "ArrowLeft":
                    if (currentCaretPos) input.setSelectionRange(currentCaretPos + 1, currentCaretPos + 1);
                    this.focusInputField("prev", index);
                    break;
                case "ArrowRight":
                    this.focusInputField("next", index);
                    break;
                case "Shift":
                    this.focusInputField("next", index);
                    break;
                case "Delete":
                    if (input.value === "") this.focusInputField("prev", index);
                    else this.updateInput(input, index, "");
                    break;
                case "Backspace":
                    if (input.value === "") this.focusInputField("prev", index);
                    else this.updateInput(input, index, "");
                    break;
                default:
            }
        };
        this.focusInputField = (dir, index)=>{
            if (dir === "next") {
                const nextIndex = index + 1;
                if (!this.shouldInputBeEnabled(nextIndex)) return;
                const numeric = this.numerics[nextIndex < this.length ? nextIndex : index];
                const input = numeric ? this.getInputElement(numeric) : undefined;
                if (input) {
                    input.disabled = false;
                    input.focus();
                }
            }
            if (dir === "prev") {
                const nextIndex = index - 1;
                const numeric = this.numerics[nextIndex > -1 ? nextIndex : index];
                const input = numeric ? this.getInputElement(numeric) : undefined;
                if (input) input.focus();
            }
        };
    }
    firstUpdated() {
        if (this.otp) this.values = this.otp.split("");
        const numericElements = this.shadowRoot?.querySelectorAll("wui-input-numeric");
        if (numericElements) this.numerics = Array.from(numericElements);
        this.numerics[0]?.focus();
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-flex gap="xxs" data-testid="wui-otp-input">
        ${Array.from({
            length: this.length
        }).map((_, index)=>(0, $7pRM7.html)`
            <wui-input-numeric
              @input=${(e)=>this.handleInput(e, index)}
              @click=${(e)=>this.selectInput(e)}
              @keydown=${(e)=>this.handleKeyDown(e, index)}
              .disabled=${!this.shouldInputBeEnabled(index)}
              .value=${this.values[index] || ""}
            >
            </wui-input-numeric>
          `)}
      </wui-flex>
    `;
    }
    updateInput(element, index, value) {
        const numeric = this.numerics[index];
        const input = element || (numeric ? this.getInputElement(numeric) : undefined);
        if (input) {
            input.value = value;
            this.values = this.values.map((val, i)=>i === index ? value : val);
        }
    }
    selectInput(e) {
        const targetElement = e.target;
        if (targetElement) {
            const inputElement = this.getInputElement(targetElement);
            inputElement?.select();
        }
    }
    handleInput(e, index) {
        const inputElement = e.target;
        const input = this.getInputElement(inputElement);
        if (input) {
            const inputValue = input.value;
            if (e.inputType === "insertFromPaste") this.handlePaste(input, inputValue, index);
            else {
                const isValid = (0, $fIDM4.UiHelperUtil).isNumber(inputValue);
                if (isValid && e.data) {
                    this.updateInput(input, index, e.data);
                    this.focusInputField("next", index);
                } else this.updateInput(input, index, "");
            }
        }
        this.dispatchInputChangeEvent();
    }
    handlePaste(input, inputValue, index) {
        const value = inputValue[0];
        const isValid = value && (0, $fIDM4.UiHelperUtil).isNumber(value);
        if (isValid) {
            this.updateInput(input, index, value);
            const inputString = inputValue.substring(1);
            if (index + 1 < this.length && inputString.length) {
                const nextNumeric = this.numerics[index + 1];
                const nextInput = nextNumeric ? this.getInputElement(nextNumeric) : undefined;
                if (nextInput) this.handlePaste(nextInput, inputString, index + 1);
            } else this.focusInputField("next", index);
        } else this.updateInput(input, index, "");
    }
    getInputElement(el) {
        if (el.shadowRoot?.querySelector("input")) return el.shadowRoot.querySelector("input");
        return null;
    }
    dispatchInputChangeEvent() {
        const value = this.values.join("");
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
};
$ef759547ebf4ddeb$export$443bf27d3bf7bc18.styles = [
    (0, $jVNMm.resetStyles),
    (0, $fMUGw.default)
];
$ef759547ebf4ddeb$var$__decorate([
    (0, $biDip.property)({
        type: Number
    })
], $ef759547ebf4ddeb$export$443bf27d3bf7bc18.prototype, "length", void 0);
$ef759547ebf4ddeb$var$__decorate([
    (0, $biDip.property)({
        type: String
    })
], $ef759547ebf4ddeb$export$443bf27d3bf7bc18.prototype, "otp", void 0);
$ef759547ebf4ddeb$var$__decorate([
    (0, $koENb.state)()
], $ef759547ebf4ddeb$export$443bf27d3bf7bc18.prototype, "values", void 0);
$ef759547ebf4ddeb$export$443bf27d3bf7bc18 = $ef759547ebf4ddeb$var$__decorate([
    (0, $ailZp.customElement)("wui-otp")
], $ef759547ebf4ddeb$export$443bf27d3bf7bc18);

});
parcelRegister("fMUGw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7e74f20a99411bb$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $b7e74f20a99411bb$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    display: block;
  }
`;

});


parcelRegister("9ZfqC", function(module, exports) {

$parcel$export(module.exports, "WuiQrCode", function () { return $7455c74a703a457b$export$29f6e16532a663bf; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("4BuLe");

var $gKi5m = parcelRequire("gKi5m");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $b7TQv = parcelRequire("b7TQv");
var $7455c74a703a457b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7455c74a703a457b$export$29f6e16532a663bf = class WuiQrCode extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.uri = "";
        this.size = 0;
        this.theme = "dark";
        this.imageSrc = undefined;
        this.alt = undefined;
        this.arenaClear = undefined;
        this.farcaster = undefined;
    }
    render() {
        this.dataset["theme"] = this.theme;
        this.dataset["clear"] = String(this.arenaClear);
        this.style.cssText = `--local-size: ${this.size}px`;
        return (0, $7pRM7.html)`${this.templateVisual()} ${this.templateSvg()}`;
    }
    templateSvg() {
        const size = this.theme === "light" ? this.size : this.size - 32;
        return (0, $7pRM7.svg)`
      <svg height=${size} width=${size}>
        ${(0, $gKi5m.QrCodeUtil).generate(this.uri, size, this.arenaClear ? 0 : size / 4)}
      </svg>
    `;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "logo"}></wui-image>`;
        if (this.farcaster) return (0, $7pRM7.html)`<wui-icon
        class="farcaster"
        size="inherit"
        color="inherit"
        name="farcaster"
      ></wui-icon>`;
        return (0, $7pRM7.html)`<wui-icon size="inherit" color="inherit" name="walletConnect"></wui-icon>`;
    }
};
$7455c74a703a457b$export$29f6e16532a663bf.styles = [
    (0, $jVNMm.resetStyles),
    (0, $b7TQv.default)
];
$7455c74a703a457b$var$__decorate([
    (0, $biDip.property)()
], $7455c74a703a457b$export$29f6e16532a663bf.prototype, "uri", void 0);
$7455c74a703a457b$var$__decorate([
    (0, $biDip.property)({
        type: Number
    })
], $7455c74a703a457b$export$29f6e16532a663bf.prototype, "size", void 0);
$7455c74a703a457b$var$__decorate([
    (0, $biDip.property)()
], $7455c74a703a457b$export$29f6e16532a663bf.prototype, "theme", void 0);
$7455c74a703a457b$var$__decorate([
    (0, $biDip.property)()
], $7455c74a703a457b$export$29f6e16532a663bf.prototype, "imageSrc", void 0);
$7455c74a703a457b$var$__decorate([
    (0, $biDip.property)()
], $7455c74a703a457b$export$29f6e16532a663bf.prototype, "alt", void 0);
$7455c74a703a457b$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $7455c74a703a457b$export$29f6e16532a663bf.prototype, "arenaClear", void 0);
$7455c74a703a457b$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $7455c74a703a457b$export$29f6e16532a663bf.prototype, "farcaster", void 0);
$7455c74a703a457b$export$29f6e16532a663bf = $7455c74a703a457b$var$__decorate([
    (0, $ailZp.customElement)("wui-qr-code")
], $7455c74a703a457b$export$29f6e16532a663bf);

});
parcelRegister("gKi5m", function(module, exports) {

$parcel$export(module.exports, "QrCodeUtil", function () { return $c30ef899e7065f8b$export$2faef7998946735; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");

var $3DBmx = parcelRequire("3DBmx");
const $c30ef899e7065f8b$var$CONNECTING_ERROR_MARGIN = 0.1;
const $c30ef899e7065f8b$var$CIRCLE_SIZE_MODIFIER = 2.5;
const $c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN = 7;
function $c30ef899e7065f8b$var$isAdjecentDots(cy, otherCy, cellSize) {
    if (cy === otherCy) return false;
    const diff = cy - otherCy < 0 ? otherCy - cy : cy - otherCy;
    return diff <= cellSize + $c30ef899e7065f8b$var$CONNECTING_ERROR_MARGIN;
}
function $c30ef899e7065f8b$var$getMatrix(value, errorCorrectionLevel) {
    const arr = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($3DBmx))).create(value, {
        errorCorrectionLevel: errorCorrectionLevel
    }).modules.data, 0);
    const sqrt = Math.sqrt(arr.length);
    return arr.reduce((rows, key, index)=>(index % sqrt === 0 ? rows.push([
            key
        ]) : rows[rows.length - 1].push(key)) && rows, []);
}
const $c30ef899e7065f8b$export$2faef7998946735 = {
    generate (uri, size, logoSize) {
        const dotColor = "#141414";
        const edgeColor = "transparent";
        const strokeWidth = 5;
        const dots = [];
        const matrix = $c30ef899e7065f8b$var$getMatrix(uri, "Q");
        const cellSize = size / matrix.length;
        const qrList = [
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            }
        ];
        qrList.forEach(({ x: x, y: y })=>{
            const x1 = (matrix.length - $c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN) * cellSize * x;
            const y1 = (matrix.length - $c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN) * cellSize * y;
            const borderRadius = 0.45;
            for(let i = 0; i < qrList.length; i += 1){
                const dotSize = cellSize * ($c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN - i * 2);
                dots.push((0, $7pRM7.svg)`
            <rect
              fill=${i === 2 ? dotColor : edgeColor}
              width=${i === 0 ? dotSize - strokeWidth : dotSize}
              rx= ${i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius}
              ry= ${i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius}
              stroke=${dotColor}
              stroke-width=${i === 0 ? strokeWidth : 0}
              height=${i === 0 ? dotSize - strokeWidth : dotSize}
              x= ${i === 0 ? y1 + cellSize * i + strokeWidth / 2 : y1 + cellSize * i}
              y= ${i === 0 ? x1 + cellSize * i + strokeWidth / 2 : x1 + cellSize * i}
            />
          `);
            }
        });
        const clearArenaSize = Math.floor((logoSize + 25) / cellSize);
        const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
        const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
        const circles = [];
        matrix.forEach((row, i)=>{
            row.forEach((_, j)=>{
                if (matrix[i][j]) {
                    if (!(i < $c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN && j < $c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN || i > matrix.length - ($c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN + 1) && j < $c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN || i < $c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN && j > matrix.length - ($c30ef899e7065f8b$var$QRCODE_MATRIX_MARGIN + 1))) {
                        if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
                            const cx = i * cellSize + cellSize / 2;
                            const cy = j * cellSize + cellSize / 2;
                            circles.push([
                                cx,
                                cy
                            ]);
                        }
                    }
                }
            });
        });
        const circlesToConnect = {};
        circles.forEach(([cx, cy])=>{
            if (circlesToConnect[cx]) circlesToConnect[cx]?.push(cy);
            else circlesToConnect[cx] = [
                cy
            ];
        });
        Object.entries(circlesToConnect).map(([cx, cys])=>{
            const newCys = cys.filter((cy)=>cys.every((otherCy)=>!$c30ef899e7065f8b$var$isAdjecentDots(cy, otherCy, cellSize)));
            return [
                Number(cx),
                newCys
            ];
        }).forEach(([cx, cys])=>{
            cys.forEach((cy)=>{
                dots.push((0, $7pRM7.svg)`<circle cx=${cx} cy=${cy} fill=${dotColor} r=${cellSize / $c30ef899e7065f8b$var$CIRCLE_SIZE_MODIFIER} />`);
            });
        });
        Object.entries(circlesToConnect).filter(([_, cys])=>cys.length > 1).map(([cx, cys])=>{
            const newCys = cys.filter((cy)=>cys.some((otherCy)=>$c30ef899e7065f8b$var$isAdjecentDots(cy, otherCy, cellSize)));
            return [
                Number(cx),
                newCys
            ];
        }).map(([cx, cys])=>{
            cys.sort((a, b)=>a < b ? -1 : 1);
            const groups = [];
            for (const cy of cys){
                const group = groups.find((item)=>item.some((otherCy)=>$c30ef899e7065f8b$var$isAdjecentDots(cy, otherCy, cellSize)));
                if (group) group.push(cy);
                else groups.push([
                    cy
                ]);
            }
            return [
                cx,
                groups.map((item)=>[
                        item[0],
                        item[item.length - 1]
                    ])
            ];
        }).forEach(([cx, groups])=>{
            groups.forEach(([y1, y2])=>{
                dots.push((0, $7pRM7.svg)`
              <line
                x1=${cx}
                x2=${cx}
                y1=${y1}
                y2=${y2}
                stroke=${dotColor}
                stroke-width=${cellSize / ($c30ef899e7065f8b$var$CIRCLE_SIZE_MODIFIER / 2)}
                stroke-linecap="round"
              />
            `);
            });
        });
        return dots;
    }
};

});
parcelRegister("3DBmx", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $2a61ff06c549a25c$export$185802fd694ee1f5; }, function (v) { return $2a61ff06c549a25c$export$185802fd694ee1f5 = v; });
$parcel$export(module.exports, "toCanvas", function () { return $2a61ff06c549a25c$export$f87f6982d1fd4f81; }, function (v) { return $2a61ff06c549a25c$export$f87f6982d1fd4f81 = v; });
$parcel$export(module.exports, "toDataURL", function () { return $2a61ff06c549a25c$export$723e4939e5a27c8; }, function (v) { return $2a61ff06c549a25c$export$723e4939e5a27c8 = v; });
$parcel$export(module.exports, "toString", function () { return $2a61ff06c549a25c$export$f84e8e69fd4488a5; }, function (v) { return $2a61ff06c549a25c$export$f84e8e69fd4488a5 = v; });
var $2a61ff06c549a25c$export$185802fd694ee1f5;
var $2a61ff06c549a25c$export$f87f6982d1fd4f81;
var $2a61ff06c549a25c$export$723e4939e5a27c8;
// only svg for now.
var $2a61ff06c549a25c$export$f84e8e69fd4488a5;

var $7yksF = parcelRequire("7yksF");

var $dkU3O = parcelRequire("dkU3O");

var $b61fA = parcelRequire("b61fA");

var $7wZuz = parcelRequire("7wZuz");
function $2a61ff06c549a25c$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$7yksF()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $dkU3O.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $dkU3O.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$2a61ff06c549a25c$export$185802fd694ee1f5 = $dkU3O.create;
$2a61ff06c549a25c$export$f87f6982d1fd4f81 = $2a61ff06c549a25c$var$renderCanvas.bind(null, $b61fA.render);
$2a61ff06c549a25c$export$723e4939e5a27c8 = $2a61ff06c549a25c$var$renderCanvas.bind(null, $b61fA.renderToDataURL);
$2a61ff06c549a25c$export$f84e8e69fd4488a5 = $2a61ff06c549a25c$var$renderCanvas.bind(null, function(data, _, opts) {
    return $7wZuz.render(data, opts);
});

});
parcelRegister("7yksF", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("dkU3O", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $9b58a10f0914091c$export$185802fd694ee1f5; }, function (v) { return $9b58a10f0914091c$export$185802fd694ee1f5 = v; });
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $9b58a10f0914091c$export$185802fd694ee1f5;

var $6afEA = parcelRequire("6afEA");

var $lOroe = parcelRequire("lOroe");

var $hA6bq = parcelRequire("hA6bq");

var $lwSGX = parcelRequire("lwSGX");

var $ksClQ = parcelRequire("ksClQ");

var $lKb8g = parcelRequire("lKb8g");

var $kTdUK = parcelRequire("kTdUK");

var $7OC1n = parcelRequire("7OC1n");

var $77ouF = parcelRequire("77ouF");

var $9nd1l = parcelRequire("9nd1l");

var $fuxAT = parcelRequire("fuxAT");

var $5zN19 = parcelRequire("5zN19");

var $fpVnK = parcelRequire("fpVnK");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $9b58a10f0914091c$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $lKb8g.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $9b58a10f0914091c$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $9b58a10f0914091c$var$setupAlignmentPattern(matrix, version) {
    const pos = $ksClQ.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $9b58a10f0914091c$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $9nd1l.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $9b58a10f0914091c$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $fuxAT.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $9b58a10f0914091c$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $9b58a10f0914091c$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $hA6bq();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $5zN19.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $6afEA.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $7OC1n.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $9b58a10f0914091c$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $9b58a10f0914091c$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $6afEA.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7OC1n.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7OC1n.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $77ouF(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $9b58a10f0914091c$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $fpVnK.fromArray(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $fpVnK.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $9nd1l.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $fpVnK.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $9nd1l.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $9b58a10f0914091c$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $6afEA.getSymbolSize(version);
    const modules = new $lwSGX(moduleCount);
    // Add function modules
    $9b58a10f0914091c$var$setupFinderPattern(modules, version);
    $9b58a10f0914091c$var$setupTimingPattern(modules);
    $9b58a10f0914091c$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $9b58a10f0914091c$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $9b58a10f0914091c$var$setupVersionInfo(modules, version);
    // Add data codewords
    $9b58a10f0914091c$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $kTdUK.getBestMask(modules, $9b58a10f0914091c$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $kTdUK.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $9b58a10f0914091c$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$9b58a10f0914091c$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $lOroe.M;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $lOroe.from(options.errorCorrectionLevel, $lOroe.M);
        version = $9nd1l.from(options.version);
        mask = $kTdUK.from(options.maskPattern);
        if (options.toSJISFunc) $6afEA.setToSJISFunction(options.toSJISFunc);
    }
    return $9b58a10f0914091c$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("6afEA", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", function () { return $47cfd1bcb0d7f1fb$export$8d4a06d3facd414b; }, function (v) { return $47cfd1bcb0d7f1fb$export$8d4a06d3facd414b = v; });
$parcel$export(module.exports, "getSymbolTotalCodewords", function () { return $47cfd1bcb0d7f1fb$export$b05dac13c7a35c32; }, function (v) { return $47cfd1bcb0d7f1fb$export$b05dac13c7a35c32 = v; });
$parcel$export(module.exports, "getBCHDigit", function () { return $47cfd1bcb0d7f1fb$export$ed1d66da50968976; }, function (v) { return $47cfd1bcb0d7f1fb$export$ed1d66da50968976 = v; });
$parcel$export(module.exports, "setToSJISFunction", function () { return $47cfd1bcb0d7f1fb$export$6733b14783f975c2; }, function (v) { return $47cfd1bcb0d7f1fb$export$6733b14783f975c2 = v; });
$parcel$export(module.exports, "isKanjiModeEnabled", function () { return $47cfd1bcb0d7f1fb$export$ce5b1274f8597fa0; }, function (v) { return $47cfd1bcb0d7f1fb$export$ce5b1274f8597fa0 = v; });
$parcel$export(module.exports, "toSJIS", function () { return $47cfd1bcb0d7f1fb$export$43dd553ecded716d; }, function (v) { return $47cfd1bcb0d7f1fb$export$43dd553ecded716d = v; });
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $47cfd1bcb0d7f1fb$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $47cfd1bcb0d7f1fb$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $47cfd1bcb0d7f1fb$export$ed1d66da50968976;
var $47cfd1bcb0d7f1fb$export$6733b14783f975c2;
var $47cfd1bcb0d7f1fb$export$ce5b1274f8597fa0;
var $47cfd1bcb0d7f1fb$export$43dd553ecded716d;
let $47cfd1bcb0d7f1fb$var$toSJISFunction;
const $47cfd1bcb0d7f1fb$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$47cfd1bcb0d7f1fb$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$47cfd1bcb0d7f1fb$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $47cfd1bcb0d7f1fb$var$CODEWORDS_COUNT[version];
};
$47cfd1bcb0d7f1fb$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$47cfd1bcb0d7f1fb$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $47cfd1bcb0d7f1fb$var$toSJISFunction = f;
};
$47cfd1bcb0d7f1fb$export$ce5b1274f8597fa0 = function() {
    return typeof $47cfd1bcb0d7f1fb$var$toSJISFunction !== "undefined";
};
$47cfd1bcb0d7f1fb$export$43dd553ecded716d = function toSJIS(kanji) {
    return $47cfd1bcb0d7f1fb$var$toSJISFunction(kanji);
};

});

parcelRegister("lOroe", function(module, exports) {

$parcel$export(module.exports, "L", function () { return $fe1383883c3bb675$export$61196ced6d74a310; }, function (v) { return $fe1383883c3bb675$export$61196ced6d74a310 = v; });
$parcel$export(module.exports, "M", function () { return $fe1383883c3bb675$export$3a1a48c8f6ef640e; }, function (v) { return $fe1383883c3bb675$export$3a1a48c8f6ef640e = v; });
$parcel$export(module.exports, "Q", function () { return $fe1383883c3bb675$export$3722cfe417b6ed86; }, function (v) { return $fe1383883c3bb675$export$3722cfe417b6ed86 = v; });
$parcel$export(module.exports, "H", function () { return $fe1383883c3bb675$export$7f8ddf7c7c20b3cd; }, function (v) { return $fe1383883c3bb675$export$7f8ddf7c7c20b3cd = v; });
$parcel$export(module.exports, "isValid", function () { return $fe1383883c3bb675$export$1ea939691cdc45b8; }, function (v) { return $fe1383883c3bb675$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $fe1383883c3bb675$export$6788812c4e6611e6; }, function (v) { return $fe1383883c3bb675$export$6788812c4e6611e6 = v; });
var $fe1383883c3bb675$export$61196ced6d74a310;
var $fe1383883c3bb675$export$3a1a48c8f6ef640e;
var $fe1383883c3bb675$export$3722cfe417b6ed86;
var $fe1383883c3bb675$export$7f8ddf7c7c20b3cd;
var $fe1383883c3bb675$export$1ea939691cdc45b8;
var $fe1383883c3bb675$export$6788812c4e6611e6;
$fe1383883c3bb675$export$61196ced6d74a310 = {
    bit: 1
};
$fe1383883c3bb675$export$3a1a48c8f6ef640e = {
    bit: 0
};
$fe1383883c3bb675$export$3722cfe417b6ed86 = {
    bit: 3
};
$fe1383883c3bb675$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $fe1383883c3bb675$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $fe1383883c3bb675$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $fe1383883c3bb675$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $fe1383883c3bb675$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $fe1383883c3bb675$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$fe1383883c3bb675$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$fe1383883c3bb675$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($fe1383883c3bb675$export$1ea939691cdc45b8(value)) return value;
    try {
        return $fe1383883c3bb675$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("hA6bq", function(module, exports) {
function $ccca98566879a1ce$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$ccca98566879a1ce$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $ccca98566879a1ce$var$BitBuffer;

});

parcelRegister("lwSGX", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $fac702cf77072ea9$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $fac702cf77072ea9$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $fac702cf77072ea9$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $fac702cf77072ea9$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $fac702cf77072ea9$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $fac702cf77072ea9$var$BitMatrix;

});

parcelRegister("ksClQ", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", function () { return $ee542bf46e0db338$export$cb05537eb8e57a83; }, function (v) { return $ee542bf46e0db338$export$cb05537eb8e57a83 = v; });
$parcel$export(module.exports, "getPositions", function () { return $ee542bf46e0db338$export$c39457c570f2b189; }, function (v) { return $ee542bf46e0db338$export$c39457c570f2b189 = v; });
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $ee542bf46e0db338$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $ee542bf46e0db338$export$c39457c570f2b189;

var $6afEA = parcelRequire("6afEA");
var $ee542bf46e0db338$require$getSymbolSize = $6afEA.getSymbolSize;
$ee542bf46e0db338$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $ee542bf46e0db338$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$ee542bf46e0db338$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $ee542bf46e0db338$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("lKb8g", function(module, exports) {

$parcel$export(module.exports, "getPositions", function () { return $fd468779d2436815$export$c39457c570f2b189; }, function (v) { return $fd468779d2436815$export$c39457c570f2b189 = v; });
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $fd468779d2436815$export$c39457c570f2b189;

var $6afEA = parcelRequire("6afEA");
var $fd468779d2436815$require$getSymbolSize = $6afEA.getSymbolSize;
const $fd468779d2436815$var$FINDER_PATTERN_SIZE = 7;
$fd468779d2436815$export$c39457c570f2b189 = function getPositions(version) {
    const size = $fd468779d2436815$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $fd468779d2436815$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $fd468779d2436815$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("kTdUK", function(module, exports) {

$parcel$export(module.exports, "Patterns", function () { return $f353bcc901afc08f$export$7ed115685df827af; }, function (v) { return $f353bcc901afc08f$export$7ed115685df827af = v; });
$parcel$export(module.exports, "isValid", function () { return $f353bcc901afc08f$export$1ea939691cdc45b8; }, function (v) { return $f353bcc901afc08f$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $f353bcc901afc08f$export$6788812c4e6611e6; }, function (v) { return $f353bcc901afc08f$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getPenaltyN1", function () { return $f353bcc901afc08f$export$a5fd3a02c14d0b3e; }, function (v) { return $f353bcc901afc08f$export$a5fd3a02c14d0b3e = v; });
$parcel$export(module.exports, "getPenaltyN2", function () { return $f353bcc901afc08f$export$9a9385107a518e46; }, function (v) { return $f353bcc901afc08f$export$9a9385107a518e46 = v; });
$parcel$export(module.exports, "getPenaltyN3", function () { return $f353bcc901afc08f$export$ade754353f0dc75e; }, function (v) { return $f353bcc901afc08f$export$ade754353f0dc75e = v; });
$parcel$export(module.exports, "getPenaltyN4", function () { return $f353bcc901afc08f$export$3ff6f04d40d9962b; }, function (v) { return $f353bcc901afc08f$export$3ff6f04d40d9962b = v; });
$parcel$export(module.exports, "applyMask", function () { return $f353bcc901afc08f$export$a1c9aa9c0e8ba394; }, function (v) { return $f353bcc901afc08f$export$a1c9aa9c0e8ba394 = v; });
$parcel$export(module.exports, "getBestMask", function () { return $f353bcc901afc08f$export$fe9625aaceb0e563; }, function (v) { return $f353bcc901afc08f$export$fe9625aaceb0e563 = v; });
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $f353bcc901afc08f$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $f353bcc901afc08f$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $f353bcc901afc08f$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $f353bcc901afc08f$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $f353bcc901afc08f$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $f353bcc901afc08f$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $f353bcc901afc08f$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $f353bcc901afc08f$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $f353bcc901afc08f$export$fe9625aaceb0e563;
$f353bcc901afc08f$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $f353bcc901afc08f$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$f353bcc901afc08f$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$f353bcc901afc08f$export$6788812c4e6611e6 = function from(value) {
    return $f353bcc901afc08f$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$f353bcc901afc08f$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $f353bcc901afc08f$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $f353bcc901afc08f$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $f353bcc901afc08f$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $f353bcc901afc08f$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$f353bcc901afc08f$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $f353bcc901afc08f$var$PenaltyScores.N2;
};
$f353bcc901afc08f$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $f353bcc901afc08f$var$PenaltyScores.N3;
};
$f353bcc901afc08f$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $f353bcc901afc08f$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $f353bcc901afc08f$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $f353bcc901afc08f$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $f353bcc901afc08f$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $f353bcc901afc08f$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $f353bcc901afc08f$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $f353bcc901afc08f$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $f353bcc901afc08f$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $f353bcc901afc08f$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $f353bcc901afc08f$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$f353bcc901afc08f$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $f353bcc901afc08f$var$getMaskAt(pattern, row, col));
    }
};
$f353bcc901afc08f$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($f353bcc901afc08f$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $f353bcc901afc08f$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $f353bcc901afc08f$export$a5fd3a02c14d0b3e(data) + $f353bcc901afc08f$export$9a9385107a518e46(data) + $f353bcc901afc08f$export$ade754353f0dc75e(data) + $f353bcc901afc08f$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $f353bcc901afc08f$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("7OC1n", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", function () { return $5b0ab227c1964f67$export$41a1fc627aca72b9; }, function (v) { return $5b0ab227c1964f67$export$41a1fc627aca72b9 = v; });
$parcel$export(module.exports, "getTotalCodewordsCount", function () { return $5b0ab227c1964f67$export$683d1b3e8a1a8438; }, function (v) { return $5b0ab227c1964f67$export$683d1b3e8a1a8438 = v; });
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $5b0ab227c1964f67$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $5b0ab227c1964f67$export$683d1b3e8a1a8438;

var $lOroe = parcelRequire("lOroe");
const $5b0ab227c1964f67$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $5b0ab227c1964f67$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$5b0ab227c1964f67$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $lOroe.L:
            return $5b0ab227c1964f67$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $lOroe.M:
            return $5b0ab227c1964f67$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $lOroe.Q:
            return $5b0ab227c1964f67$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $lOroe.H:
            return $5b0ab227c1964f67$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$5b0ab227c1964f67$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $lOroe.L:
            return $5b0ab227c1964f67$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $lOroe.M:
            return $5b0ab227c1964f67$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $lOroe.Q:
            return $5b0ab227c1964f67$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $lOroe.H:
            return $5b0ab227c1964f67$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("77ouF", function(module, exports) {

var $3J5NQ = parcelRequire("3J5NQ");
function $52ec2fc935b3ff33$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $52ec2fc935b3ff33$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $3J5NQ.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $52ec2fc935b3ff33$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $3J5NQ.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $52ec2fc935b3ff33$var$ReedSolomonEncoder;

});
parcelRegister("3J5NQ", function(module, exports) {

$parcel$export(module.exports, "mul", function () { return $2b6a136b99dcd841$export$6e3a27864ab166fe; }, function (v) { return $2b6a136b99dcd841$export$6e3a27864ab166fe = v; });
$parcel$export(module.exports, "mod", function () { return $2b6a136b99dcd841$export$842a2cf37af977e1; }, function (v) { return $2b6a136b99dcd841$export$842a2cf37af977e1 = v; });
$parcel$export(module.exports, "generateECPolynomial", function () { return $2b6a136b99dcd841$export$7b8be06a973a9d05; }, function (v) { return $2b6a136b99dcd841$export$7b8be06a973a9d05 = v; });
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $2b6a136b99dcd841$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $2b6a136b99dcd841$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $2b6a136b99dcd841$export$7b8be06a973a9d05;

var $7aoUO = parcelRequire("7aoUO");
$2b6a136b99dcd841$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $7aoUO.mul(p1[i], p2[j]);
    return coeff;
};
$2b6a136b99dcd841$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $7aoUO.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$2b6a136b99dcd841$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $2b6a136b99dcd841$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $7aoUO.exp(i)
    ]));
    return poly;
};

});
parcelRegister("7aoUO", function(module, exports) {

$parcel$export(module.exports, "exp", function () { return $537ccb3b3e10fe4d$export$b310ec824aaee37f; }, function (v) { return $537ccb3b3e10fe4d$export$b310ec824aaee37f = v; });
$parcel$export(module.exports, "mul", function () { return $537ccb3b3e10fe4d$export$6e3a27864ab166fe; }, function (v) { return $537ccb3b3e10fe4d$export$6e3a27864ab166fe = v; });
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $537ccb3b3e10fe4d$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $537ccb3b3e10fe4d$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $537ccb3b3e10fe4d$export$6e3a27864ab166fe;
const $537ccb3b3e10fe4d$var$EXP_TABLE = new Uint8Array(512);
const $537ccb3b3e10fe4d$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $537ccb3b3e10fe4d$var$EXP_TABLE[i] = x;
        $537ccb3b3e10fe4d$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$537ccb3b3e10fe4d$var$EXP_TABLE[i] = $537ccb3b3e10fe4d$var$EXP_TABLE[i - 255];
})();
$537ccb3b3e10fe4d$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $537ccb3b3e10fe4d$var$LOG_TABLE[n];
};
$537ccb3b3e10fe4d$export$b310ec824aaee37f = function exp(n) {
    return $537ccb3b3e10fe4d$var$EXP_TABLE[n];
};
$537ccb3b3e10fe4d$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $537ccb3b3e10fe4d$var$EXP_TABLE[$537ccb3b3e10fe4d$var$LOG_TABLE[x] + $537ccb3b3e10fe4d$var$LOG_TABLE[y]];
};

});



parcelRegister("9nd1l", function(module, exports) {

$parcel$export(module.exports, "getCapacity", function () { return $6d305cb119fe23c7$export$55b283886ec2d3fb; }, function (v) { return $6d305cb119fe23c7$export$55b283886ec2d3fb = v; });
$parcel$export(module.exports, "from", function () { return $6d305cb119fe23c7$export$6788812c4e6611e6; }, function (v) { return $6d305cb119fe23c7$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getBestVersionForData", function () { return $6d305cb119fe23c7$export$264e969aa7a8ff7e; }, function (v) { return $6d305cb119fe23c7$export$264e969aa7a8ff7e = v; });
$parcel$export(module.exports, "getEncodedBits", function () { return $6d305cb119fe23c7$export$eee5438974ef6f0e; }, function (v) { return $6d305cb119fe23c7$export$eee5438974ef6f0e = v; });
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $6d305cb119fe23c7$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $6d305cb119fe23c7$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $6d305cb119fe23c7$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $6d305cb119fe23c7$export$eee5438974ef6f0e;

var $6afEA = parcelRequire("6afEA");

var $7OC1n = parcelRequire("7OC1n");

var $lOroe = parcelRequire("lOroe");

var $5zN19 = parcelRequire("5zN19");

var $9v4ps = parcelRequire("9v4ps");
// Generator polynomial used to encode version information
const $6d305cb119fe23c7$var$G18 = 7973;
const $6d305cb119fe23c7$var$G18_BCH = $6afEA.getBCHDigit($6d305cb119fe23c7$var$G18);
function $6d305cb119fe23c7$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $6d305cb119fe23c7$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $6d305cb119fe23c7$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $5zN19.getCharCountIndicator(mode, version) + 4;
}
function $6d305cb119fe23c7$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $6d305cb119fe23c7$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $6d305cb119fe23c7$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $6d305cb119fe23c7$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $6d305cb119fe23c7$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $5zN19.MIXED)) return currentVersion;
    }
    return undefined;
}
$6d305cb119fe23c7$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($9v4ps.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$6d305cb119fe23c7$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$9v4ps.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $5zN19.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $6afEA.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7OC1n.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $5zN19.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $6d305cb119fe23c7$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $5zN19.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $5zN19.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $5zN19.KANJI:
            return Math.floor(usableBits / 13);
        case $5zN19.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$6d305cb119fe23c7$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $lOroe.from(errorCorrectionLevel, $lOroe.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $6d305cb119fe23c7$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $6d305cb119fe23c7$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$6d305cb119fe23c7$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$9v4ps.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($6afEA.getBCHDigit(d) - $6d305cb119fe23c7$var$G18_BCH >= 0)d ^= $6d305cb119fe23c7$var$G18 << $6afEA.getBCHDigit(d) - $6d305cb119fe23c7$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("5zN19", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", function () { return $40f63e7d31fddcd9$export$4d318981b5a83836; }, function (v) { return $40f63e7d31fddcd9$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $40f63e7d31fddcd9$export$376a9ed239d6c1c8; }, function (v) { return $40f63e7d31fddcd9$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "BYTE", function () { return $40f63e7d31fddcd9$export$8f4bf8f7eb581284; }, function (v) { return $40f63e7d31fddcd9$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "KANJI", function () { return $40f63e7d31fddcd9$export$a4d452c2363c8e12; }, function (v) { return $40f63e7d31fddcd9$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "MIXED", function () { return $40f63e7d31fddcd9$export$bb410559a65d3418; }, function (v) { return $40f63e7d31fddcd9$export$bb410559a65d3418 = v; });
$parcel$export(module.exports, "getCharCountIndicator", function () { return $40f63e7d31fddcd9$export$e79764af6ffaeb8d; }, function (v) { return $40f63e7d31fddcd9$export$e79764af6ffaeb8d = v; });
$parcel$export(module.exports, "getBestModeForData", function () { return $40f63e7d31fddcd9$export$1bd4c93ffb42e55e; }, function (v) { return $40f63e7d31fddcd9$export$1bd4c93ffb42e55e = v; });
$parcel$export(module.exports, "toString", function () { return $40f63e7d31fddcd9$export$f84e8e69fd4488a5; }, function (v) { return $40f63e7d31fddcd9$export$f84e8e69fd4488a5 = v; });
$parcel$export(module.exports, "isValid", function () { return $40f63e7d31fddcd9$export$1ea939691cdc45b8; }, function (v) { return $40f63e7d31fddcd9$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $40f63e7d31fddcd9$export$6788812c4e6611e6; }, function (v) { return $40f63e7d31fddcd9$export$6788812c4e6611e6 = v; });
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $40f63e7d31fddcd9$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $40f63e7d31fddcd9$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $40f63e7d31fddcd9$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $40f63e7d31fddcd9$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $40f63e7d31fddcd9$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $40f63e7d31fddcd9$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $40f63e7d31fddcd9$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $40f63e7d31fddcd9$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $40f63e7d31fddcd9$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $40f63e7d31fddcd9$export$6788812c4e6611e6;

var $9v4ps = parcelRequire("9v4ps");

var $90tf9 = parcelRequire("90tf9");
$40f63e7d31fddcd9$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$40f63e7d31fddcd9$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$40f63e7d31fddcd9$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$40f63e7d31fddcd9$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$40f63e7d31fddcd9$export$bb410559a65d3418 = {
    bit: -1
};
$40f63e7d31fddcd9$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$9v4ps.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$40f63e7d31fddcd9$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($90tf9.testNumeric(dataStr)) return $40f63e7d31fddcd9$export$4d318981b5a83836;
    else if ($90tf9.testAlphanumeric(dataStr)) return $40f63e7d31fddcd9$export$376a9ed239d6c1c8;
    else if ($90tf9.testKanji(dataStr)) return $40f63e7d31fddcd9$export$a4d452c2363c8e12;
    else return $40f63e7d31fddcd9$export$8f4bf8f7eb581284;
};
$40f63e7d31fddcd9$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$40f63e7d31fddcd9$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $40f63e7d31fddcd9$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $40f63e7d31fddcd9$export$4d318981b5a83836;
        case "alphanumeric":
            return $40f63e7d31fddcd9$export$376a9ed239d6c1c8;
        case "kanji":
            return $40f63e7d31fddcd9$export$a4d452c2363c8e12;
        case "byte":
            return $40f63e7d31fddcd9$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$40f63e7d31fddcd9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($40f63e7d31fddcd9$export$1ea939691cdc45b8(value)) return value;
    try {
        return $40f63e7d31fddcd9$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("9v4ps", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $01c8f141ddc3f325$export$1ea939691cdc45b8; }, function (v) { return $01c8f141ddc3f325$export$1ea939691cdc45b8 = v; });
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $01c8f141ddc3f325$export$1ea939691cdc45b8;
$01c8f141ddc3f325$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("90tf9", function(module, exports) {

$parcel$export(module.exports, "KANJI", function () { return $68eacc411934c8f4$export$a4d452c2363c8e12; }, function (v) { return $68eacc411934c8f4$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "BYTE_KANJI", function () { return $68eacc411934c8f4$export$9df7c29d562bab83; }, function (v) { return $68eacc411934c8f4$export$9df7c29d562bab83 = v; });
$parcel$export(module.exports, "BYTE", function () { return $68eacc411934c8f4$export$8f4bf8f7eb581284; }, function (v) { return $68eacc411934c8f4$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "NUMERIC", function () { return $68eacc411934c8f4$export$4d318981b5a83836; }, function (v) { return $68eacc411934c8f4$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $68eacc411934c8f4$export$376a9ed239d6c1c8; }, function (v) { return $68eacc411934c8f4$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "testKanji", function () { return $68eacc411934c8f4$export$175f16aef75a4569; }, function (v) { return $68eacc411934c8f4$export$175f16aef75a4569 = v; });
$parcel$export(module.exports, "testNumeric", function () { return $68eacc411934c8f4$export$50b7f9bf92c74274; }, function (v) { return $68eacc411934c8f4$export$50b7f9bf92c74274 = v; });
$parcel$export(module.exports, "testAlphanumeric", function () { return $68eacc411934c8f4$export$4ba5f52893b4ac97; }, function (v) { return $68eacc411934c8f4$export$4ba5f52893b4ac97 = v; });
var $68eacc411934c8f4$export$a4d452c2363c8e12;
var $68eacc411934c8f4$export$9df7c29d562bab83;
var $68eacc411934c8f4$export$8f4bf8f7eb581284;
var $68eacc411934c8f4$export$4d318981b5a83836;
var $68eacc411934c8f4$export$376a9ed239d6c1c8;
var $68eacc411934c8f4$export$175f16aef75a4569;
var $68eacc411934c8f4$export$50b7f9bf92c74274;
var $68eacc411934c8f4$export$4ba5f52893b4ac97;
const $68eacc411934c8f4$var$numeric = "[0-9]+";
const $68eacc411934c8f4$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $68eacc411934c8f4$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$68eacc411934c8f4$var$kanji = $68eacc411934c8f4$var$kanji.replace(/u/g, "\\u");
const $68eacc411934c8f4$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $68eacc411934c8f4$var$kanji + ")(?:.|[\r\n]))+";
$68eacc411934c8f4$export$a4d452c2363c8e12 = new RegExp($68eacc411934c8f4$var$kanji, "g");
$68eacc411934c8f4$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$68eacc411934c8f4$export$8f4bf8f7eb581284 = new RegExp($68eacc411934c8f4$var$byte, "g");
$68eacc411934c8f4$export$4d318981b5a83836 = new RegExp($68eacc411934c8f4$var$numeric, "g");
$68eacc411934c8f4$export$376a9ed239d6c1c8 = new RegExp($68eacc411934c8f4$var$alphanumeric, "g");
const $68eacc411934c8f4$var$TEST_KANJI = new RegExp("^" + $68eacc411934c8f4$var$kanji + "$");
const $68eacc411934c8f4$var$TEST_NUMERIC = new RegExp("^" + $68eacc411934c8f4$var$numeric + "$");
const $68eacc411934c8f4$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$68eacc411934c8f4$export$175f16aef75a4569 = function testKanji(str) {
    return $68eacc411934c8f4$var$TEST_KANJI.test(str);
};
$68eacc411934c8f4$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $68eacc411934c8f4$var$TEST_NUMERIC.test(str);
};
$68eacc411934c8f4$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $68eacc411934c8f4$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("fuxAT", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", function () { return $b473b76c49bc66e8$export$eee5438974ef6f0e; }, function (v) { return $b473b76c49bc66e8$export$eee5438974ef6f0e = v; });
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $b473b76c49bc66e8$export$eee5438974ef6f0e;

var $6afEA = parcelRequire("6afEA");
const $b473b76c49bc66e8$var$G15 = 1335;
const $b473b76c49bc66e8$var$G15_MASK = 21522;
const $b473b76c49bc66e8$var$G15_BCH = $6afEA.getBCHDigit($b473b76c49bc66e8$var$G15);
$b473b76c49bc66e8$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($6afEA.getBCHDigit(d) - $b473b76c49bc66e8$var$G15_BCH >= 0)d ^= $b473b76c49bc66e8$var$G15 << $6afEA.getBCHDigit(d) - $b473b76c49bc66e8$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $b473b76c49bc66e8$var$G15_MASK;
};

});

parcelRegister("fpVnK", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $b395b3b419142eac$export$571d59b505e6bb4e; }, function (v) { return $b395b3b419142eac$export$571d59b505e6bb4e = v; });
$parcel$export(module.exports, "fromString", function () { return $b395b3b419142eac$export$3004f64547af360e; }, function (v) { return $b395b3b419142eac$export$3004f64547af360e = v; });
$parcel$export(module.exports, "rawSplit", function () { return $b395b3b419142eac$export$89ab1afb9839589b; }, function (v) { return $b395b3b419142eac$export$89ab1afb9839589b = v; });
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $b395b3b419142eac$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $b395b3b419142eac$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $b395b3b419142eac$export$89ab1afb9839589b;

var $5zN19 = parcelRequire("5zN19");

var $5Cuoz = parcelRequire("5Cuoz");

var $3hFxh = parcelRequire("3hFxh");

var $htDTG = parcelRequire("htDTG");

var $aKPhO = parcelRequire("aKPhO");

var $90tf9 = parcelRequire("90tf9");

var $6afEA = parcelRequire("6afEA");

var $c0NC5 = parcelRequire("c0NC5");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $b395b3b419142eac$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $b395b3b419142eac$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $b395b3b419142eac$var$getSegmentsFromString(dataStr) {
    const numSegs = $b395b3b419142eac$var$getSegments($90tf9.NUMERIC, $5zN19.NUMERIC, dataStr);
    const alphaNumSegs = $b395b3b419142eac$var$getSegments($90tf9.ALPHANUMERIC, $5zN19.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($6afEA.isKanjiModeEnabled()) {
        byteSegs = $b395b3b419142eac$var$getSegments($90tf9.BYTE, $5zN19.BYTE, dataStr);
        kanjiSegs = $b395b3b419142eac$var$getSegments($90tf9.KANJI, $5zN19.KANJI, dataStr);
    } else {
        byteSegs = $b395b3b419142eac$var$getSegments($90tf9.BYTE_KANJI, $5zN19.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $b395b3b419142eac$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $5zN19.NUMERIC:
            return $5Cuoz.getBitsLength(length);
        case $5zN19.ALPHANUMERIC:
            return $3hFxh.getBitsLength(length);
        case $5zN19.KANJI:
            return $aKPhO.getBitsLength(length);
        case $5zN19.BYTE:
            return $htDTG.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $b395b3b419142eac$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $b395b3b419142eac$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $5zN19.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $5zN19.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $5zN19.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $5zN19.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $5zN19.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $5zN19.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $5zN19.BYTE,
                        length: $b395b3b419142eac$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $5zN19.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $5zN19.BYTE,
                        length: $b395b3b419142eac$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $b395b3b419142eac$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $b395b3b419142eac$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $b395b3b419142eac$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $b395b3b419142eac$var$getSegmentBitsLength(node.length, node.mode) + 4 + $5zN19.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $b395b3b419142eac$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $5zN19.getBestModeForData(data);
    mode = $5zN19.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $5zN19.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $5zN19.toString(mode) + ".\n Suggested mode is: " + $5zN19.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $5zN19.KANJI && !$6afEA.isKanjiModeEnabled()) mode = $5zN19.BYTE;
    switch(mode){
        case $5zN19.NUMERIC:
            return new $5Cuoz(data);
        case $5zN19.ALPHANUMERIC:
            return new $3hFxh(data);
        case $5zN19.KANJI:
            return new $aKPhO(data);
        case $5zN19.BYTE:
            return new $htDTG(data);
    }
}
$b395b3b419142eac$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($b395b3b419142eac$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($b395b3b419142eac$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$b395b3b419142eac$export$3004f64547af360e = function fromString(data, version) {
    const segs = $b395b3b419142eac$var$getSegmentsFromString(data, $6afEA.isKanjiModeEnabled());
    const nodes = $b395b3b419142eac$var$buildNodes(segs);
    const graph = $b395b3b419142eac$var$buildGraph(nodes, version);
    const path = $c0NC5.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $b395b3b419142eac$export$571d59b505e6bb4e($b395b3b419142eac$var$mergeSegments(optimizedSegs));
};
$b395b3b419142eac$export$89ab1afb9839589b = function rawSplit(data) {
    return $b395b3b419142eac$export$571d59b505e6bb4e($b395b3b419142eac$var$getSegmentsFromString(data, $6afEA.isKanjiModeEnabled()));
};

});
parcelRegister("5Cuoz", function(module, exports) {

var $5zN19 = parcelRequire("5zN19");
function $4178143841f46fa9$var$NumericData(data) {
    this.mode = $5zN19.NUMERIC;
    this.data = data.toString();
}
$4178143841f46fa9$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$4178143841f46fa9$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$4178143841f46fa9$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $4178143841f46fa9$var$NumericData.getBitsLength(this.data.length);
};
$4178143841f46fa9$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $4178143841f46fa9$var$NumericData;

});

parcelRegister("3hFxh", function(module, exports) {

var $5zN19 = parcelRequire("5zN19");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $26432dc04b1311f6$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $26432dc04b1311f6$var$AlphanumericData(data) {
    this.mode = $5zN19.ALPHANUMERIC;
    this.data = data;
}
$26432dc04b1311f6$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$26432dc04b1311f6$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$26432dc04b1311f6$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $26432dc04b1311f6$var$AlphanumericData.getBitsLength(this.data.length);
};
$26432dc04b1311f6$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $26432dc04b1311f6$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $26432dc04b1311f6$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($26432dc04b1311f6$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $26432dc04b1311f6$var$AlphanumericData;

});

parcelRegister("htDTG", function(module, exports) {

var $kk7MK = parcelRequire("kk7MK");

var $5zN19 = parcelRequire("5zN19");
function $cb9417dbab483c39$var$ByteData(data) {
    this.mode = $5zN19.BYTE;
    if (typeof data === "string") data = $kk7MK(data);
    this.data = new Uint8Array(data);
}
$cb9417dbab483c39$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$cb9417dbab483c39$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$cb9417dbab483c39$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $cb9417dbab483c39$var$ByteData.getBitsLength(this.data.length);
};
$cb9417dbab483c39$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $cb9417dbab483c39$var$ByteData;

});
parcelRegister("kk7MK", function(module, exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

});


parcelRegister("aKPhO", function(module, exports) {

var $5zN19 = parcelRequire("5zN19");

var $6afEA = parcelRequire("6afEA");
function $7d45fbac80c87b20$var$KanjiData(data) {
    this.mode = $5zN19.KANJI;
    this.data = data;
}
$7d45fbac80c87b20$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$7d45fbac80c87b20$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7d45fbac80c87b20$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $7d45fbac80c87b20$var$KanjiData.getBitsLength(this.data.length);
};
$7d45fbac80c87b20$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $6afEA.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $7d45fbac80c87b20$var$KanjiData;

});

parcelRegister("c0NC5", function(module, exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $8bebf846117deb2b$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $8bebf846117deb2b$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $8bebf846117deb2b$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $8bebf846117deb2b$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $8bebf846117deb2b$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $8bebf846117deb2b$var$dijkstra;

});



parcelRegister("b61fA", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $8141398fa4dd325e$export$b3890eb0ae9dca99; }, function (v) { return $8141398fa4dd325e$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "renderToDataURL", function () { return $8141398fa4dd325e$export$c3e5526bbaf70a25; }, function (v) { return $8141398fa4dd325e$export$c3e5526bbaf70a25 = v; });
var $8141398fa4dd325e$export$b3890eb0ae9dca99;
var $8141398fa4dd325e$export$c3e5526bbaf70a25;

var $ePhXF = parcelRequire("ePhXF");
function $8141398fa4dd325e$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $8141398fa4dd325e$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$8141398fa4dd325e$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $8141398fa4dd325e$var$getCanvasElement();
    opts = $ePhXF.getOptions(opts);
    const size = $ePhXF.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $ePhXF.qrToImageData(image.data, qrData, opts);
    $8141398fa4dd325e$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$8141398fa4dd325e$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $8141398fa4dd325e$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("ePhXF", function(module, exports) {

$parcel$export(module.exports, "getOptions", function () { return $acb3c2dcd993bdca$export$d2312e68e1f5ad00; }, function (v) { return $acb3c2dcd993bdca$export$d2312e68e1f5ad00 = v; });
$parcel$export(module.exports, "getScale", function () { return $acb3c2dcd993bdca$export$5cdac61cf538712e; }, function (v) { return $acb3c2dcd993bdca$export$5cdac61cf538712e = v; });
$parcel$export(module.exports, "getImageWidth", function () { return $acb3c2dcd993bdca$export$c3a1a1f268a8142b; }, function (v) { return $acb3c2dcd993bdca$export$c3a1a1f268a8142b = v; });
$parcel$export(module.exports, "qrToImageData", function () { return $acb3c2dcd993bdca$export$83136f57c739c5f3; }, function (v) { return $acb3c2dcd993bdca$export$83136f57c739c5f3 = v; });
var $acb3c2dcd993bdca$export$d2312e68e1f5ad00;
var $acb3c2dcd993bdca$export$5cdac61cf538712e;
var $acb3c2dcd993bdca$export$c3a1a1f268a8142b;
var $acb3c2dcd993bdca$export$83136f57c739c5f3;
function $acb3c2dcd993bdca$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$acb3c2dcd993bdca$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $acb3c2dcd993bdca$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $acb3c2dcd993bdca$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$acb3c2dcd993bdca$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$acb3c2dcd993bdca$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $acb3c2dcd993bdca$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$acb3c2dcd993bdca$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $acb3c2dcd993bdca$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("7wZuz", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $57bb38963e7d15fe$export$b3890eb0ae9dca99; }, function (v) { return $57bb38963e7d15fe$export$b3890eb0ae9dca99 = v; });
var $57bb38963e7d15fe$export$b3890eb0ae9dca99;

var $ePhXF = parcelRequire("ePhXF");
function $57bb38963e7d15fe$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $57bb38963e7d15fe$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $57bb38963e7d15fe$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $57bb38963e7d15fe$var$svgCmd("M", col + margin, 0.5 + row + margin) : $57bb38963e7d15fe$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $57bb38963e7d15fe$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$57bb38963e7d15fe$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $ePhXF.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $57bb38963e7d15fe$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $57bb38963e7d15fe$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $57bb38963e7d15fe$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

});



parcelRegister("b7TQv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $021727eb38ac1e4f$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $021727eb38ac1e4f$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    user-select: none;
    display: block;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    width: var(--local-size);
  }

  :host([data-theme='dark']) {
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px);
    background-color: var(--wui-color-inverse-100);
    padding: var(--wui-spacing-l);
  }

  :host([data-theme='light']) {
    box-shadow: 0 0 0 1px var(--wui-color-bg-125);
    background-color: var(--wui-color-bg-125);
  }

  :host([data-clear='true']) > wui-icon {
    display: none;
  }

  svg:first-child,
  wui-image,
  wui-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  wui-image {
    width: 25%;
    height: 25%;
    border-radius: var(--wui-border-radius-xs);
  }

  wui-icon {
    width: 100%;
    height: 100%;
    color: #3396ff !important;
    transform: translateY(-50%) translateX(-50%) scale(0.25);
  }
`;

});


parcelRegister("hKdWD", function(module, exports) {

$parcel$export(module.exports, "WuiSearchBar", function () { return $ceb18cb0431669f2$export$208b8ce22c764062; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("7rFd7");
var $kELMR = parcelRequire("kELMR");
parcelRequire("dnpyM");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("eZmW3");

var $keU94 = parcelRequire("keU94");
var $ceb18cb0431669f2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ceb18cb0431669f2$export$208b8ce22c764062 = class WuiSearchBar extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.inputComponentRef = (0, $kELMR.createRef)();
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-input-text
        ${(0, $kELMR.ref)(this.inputComponentRef)}
        placeholder="Search wallet"
        icon="search"
        type="search"
        enterKeyHint="search"
        size="sm"
      >
        <wui-input-element @click=${this.clearValue} icon="close"></wui-input-element>
      </wui-input-text>
    `;
    }
    clearValue() {
        const inputComponent = this.inputComponentRef.value;
        const inputElement = inputComponent?.inputElementRef.value;
        if (inputElement) {
            inputElement.value = "";
            inputElement.focus();
            inputElement.dispatchEvent(new Event("input"));
        }
    }
};
$ceb18cb0431669f2$export$208b8ce22c764062.styles = [
    (0, $jVNMm.resetStyles),
    (0, $keU94.default)
];
$ceb18cb0431669f2$export$208b8ce22c764062 = $ceb18cb0431669f2$var$__decorate([
    (0, $ailZp.customElement)("wui-search-bar")
], $ceb18cb0431669f2$export$208b8ce22c764062);

});
parcelRegister("keU94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebc0aabdc0979073$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $ebc0aabdc0979073$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    display: inline-block;
    width: 100%;
  }
`;

});


parcelRegister("axRuD", function(module, exports) {

$parcel$export(module.exports, "WuiSnackbar", function () { return $7ad67b12b3de4337$export$864d710a9db8f7a3; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");
parcelRequire("ck0jF");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("7XtWS");

var $i2LKv = parcelRequire("i2LKv");
var $7ad67b12b3de4337$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7ad67b12b3de4337$export$864d710a9db8f7a3 = class WuiSnackbar extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.backgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.icon = "checkmark";
        this.message = "";
        this.loading = false;
    }
    render() {
        return (0, $7pRM7.html)`
      ${this.loading ? (0, $7pRM7.html)`<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>` : (0, $7pRM7.html)`<wui-icon-box
            size="sm"
            iconSize="xs"
            iconColor=${this.iconColor}
            backgroundColor=${this.backgroundColor}
            icon=${this.icon}
            background="opaque"
          ></wui-icon-box>`}
      <wui-text variant="paragraph-500" color="fg-100">${this.message}</wui-text>
    `;
    }
};
$7ad67b12b3de4337$export$864d710a9db8f7a3.styles = [
    (0, $jVNMm.resetStyles),
    (0, $i2LKv.default)
];
$7ad67b12b3de4337$var$__decorate([
    (0, $biDip.property)()
], $7ad67b12b3de4337$export$864d710a9db8f7a3.prototype, "backgroundColor", void 0);
$7ad67b12b3de4337$var$__decorate([
    (0, $biDip.property)()
], $7ad67b12b3de4337$export$864d710a9db8f7a3.prototype, "iconColor", void 0);
$7ad67b12b3de4337$var$__decorate([
    (0, $biDip.property)()
], $7ad67b12b3de4337$export$864d710a9db8f7a3.prototype, "icon", void 0);
$7ad67b12b3de4337$var$__decorate([
    (0, $biDip.property)()
], $7ad67b12b3de4337$export$864d710a9db8f7a3.prototype, "message", void 0);
$7ad67b12b3de4337$var$__decorate([
    (0, $biDip.property)()
], $7ad67b12b3de4337$export$864d710a9db8f7a3.prototype, "loading", void 0);
$7ad67b12b3de4337$export$864d710a9db8f7a3 = $7ad67b12b3de4337$var$__decorate([
    (0, $ailZp.customElement)("wui-snackbar")
], $7ad67b12b3de4337$export$864d710a9db8f7a3);

});
parcelRegister("i2LKv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d22d73de89f4f8ba$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $d22d73de89f4f8ba$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-xs);
    align-items: center;
    padding: var(--wui-spacing-xs) var(--wui-spacing-m) var(--wui-spacing-xs) var(--wui-spacing-xs);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-color-gray-glass-005);
    box-sizing: border-box;
    max-height: 40px;
    background-color: var(--wui-color-bg-175);
    box-shadow:
      0px 14px 64px -4px rgba(0, 0, 0, 0.15),
      0px 8px 22px -6px rgba(0, 0, 0, 0.15);
  }

  :host wui-loading-spinner {
    margin-left: var(--wui-spacing-3xs);
  }
`;

});


parcelRegister("fgtdS", function(module, exports) {

$parcel$export(module.exports, "WuiTabs", function () { return $b1cf04ae698f56ae$export$78c669163db53348; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
var $koENb = parcelRequire("koENb");

var $jVNMm = parcelRequire("jVNMm");
parcelRequire("i6mxN");

var $ailZp = parcelRequire("ailZp");

var $8X9A3 = parcelRequire("8X9A3");
var $b1cf04ae698f56ae$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b1cf04ae698f56ae$export$78c669163db53348 = class WuiTabs extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.tabs = [];
        this.onTabChange = ()=>null;
        this.buttons = [];
        this.disabled = false;
        this.localTabWidth = "100px";
        this.activeTab = 0;
        this.isDense = false;
    }
    render() {
        this.isDense = this.tabs.length > 3;
        this.style.cssText = `
      --local-tab: ${this.activeTab};
      --local-tab-width: ${this.localTabWidth};
    `;
        this.dataset["type"] = this.isDense ? "flex" : "block";
        return this.tabs.map((tab, index)=>{
            const isActive = index === this.activeTab;
            return (0, $7pRM7.html)`
        <button
          ?disabled=${this.disabled}
          @click=${()=>this.onTabClick(index)}
          data-active=${isActive}
          data-testid="tab-${tab.label?.toLowerCase()}"
        >
          ${this.iconTemplate(tab)}
          <wui-text variant="small-600" color="inherit"> ${tab.label} </wui-text>
        </button>
      `;
        });
    }
    firstUpdated() {
        if (this.shadowRoot && this.isDense) {
            this.buttons = [
                ...this.shadowRoot.querySelectorAll("button")
            ];
            setTimeout(()=>{
                this.animateTabs(0, true);
            }, 0);
        }
    }
    iconTemplate(tab) {
        if (tab.icon) return (0, $7pRM7.html)`<wui-icon size="xs" color="inherit" name=${tab.icon}></wui-icon>`;
        return null;
    }
    onTabClick(index) {
        if (this.buttons) this.animateTabs(index, false);
        this.activeTab = index;
        this.onTabChange(index);
    }
    animateTabs(index, initialAnimation) {
        const passiveBtn = this.buttons[this.activeTab];
        const activeBtn = this.buttons[index];
        const passiveBtnText = passiveBtn?.querySelector("wui-text");
        const activeBtnText = activeBtn?.querySelector("wui-text");
        const activeBtnBounds = activeBtn?.getBoundingClientRect();
        const activeBtnTextBounds = activeBtnText?.getBoundingClientRect();
        if (passiveBtn && passiveBtnText && !initialAnimation && index !== this.activeTab) {
            passiveBtnText.animate([
                {
                    opacity: 0
                }
            ], {
                duration: 50,
                easing: "ease",
                fill: "forwards"
            });
            passiveBtn.animate([
                {
                    width: `34px`
                }
            ], {
                duration: 500,
                easing: "ease",
                fill: "forwards"
            });
        }
        if (activeBtn && activeBtnBounds && activeBtnTextBounds && activeBtnText) {
            if (index !== this.activeTab || initialAnimation) {
                this.localTabWidth = `${Math.round(activeBtnBounds.width + activeBtnTextBounds.width) + 6}px`;
                activeBtn.animate([
                    {
                        width: `${activeBtnBounds.width + activeBtnTextBounds.width}px`
                    }
                ], {
                    duration: initialAnimation ? 0 : 500,
                    fill: "forwards",
                    easing: "ease"
                });
                activeBtnText.animate([
                    {
                        opacity: 1
                    }
                ], {
                    duration: initialAnimation ? 0 : 125,
                    delay: initialAnimation ? 0 : 200,
                    fill: "forwards",
                    easing: "ease"
                });
            }
        }
    }
};
$b1cf04ae698f56ae$export$78c669163db53348.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $8X9A3.default)
];
$b1cf04ae698f56ae$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $b1cf04ae698f56ae$export$78c669163db53348.prototype, "tabs", void 0);
$b1cf04ae698f56ae$var$__decorate([
    (0, $biDip.property)()
], $b1cf04ae698f56ae$export$78c669163db53348.prototype, "onTabChange", void 0);
$b1cf04ae698f56ae$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $b1cf04ae698f56ae$export$78c669163db53348.prototype, "buttons", void 0);
$b1cf04ae698f56ae$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $b1cf04ae698f56ae$export$78c669163db53348.prototype, "disabled", void 0);
$b1cf04ae698f56ae$var$__decorate([
    (0, $biDip.property)()
], $b1cf04ae698f56ae$export$78c669163db53348.prototype, "localTabWidth", void 0);
$b1cf04ae698f56ae$var$__decorate([
    (0, $koENb.state)()
], $b1cf04ae698f56ae$export$78c669163db53348.prototype, "activeTab", void 0);
$b1cf04ae698f56ae$var$__decorate([
    (0, $koENb.state)()
], $b1cf04ae698f56ae$export$78c669163db53348.prototype, "isDense", void 0);
$b1cf04ae698f56ae$export$78c669163db53348 = $b1cf04ae698f56ae$var$__decorate([
    (0, $ailZp.customElement)("wui-tabs")
], $b1cf04ae698f56ae$export$78c669163db53348);

});
parcelRegister("8X9A3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $684b43e63e36fadb$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $684b43e63e36fadb$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: inline-flex;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-3xl);
    padding: var(--wui-spacing-3xs);
    position: relative;
    height: 36px;
    min-height: 36px;
    overflow: hidden;
  }

  :host::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 4px;
    left: 4px;
    display: block;
    width: var(--local-tab-width);
    height: 28px;
    border-radius: var(--wui-border-radius-3xl);
    background-color: var(--wui-color-gray-glass-002);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);
    transform: translateX(calc(var(--local-tab) * var(--local-tab-width)));
    transition: transform var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: background-color, opacity;
  }

  :host([data-type='flex'])::before {
    left: 3px;
    transform: translateX(calc((var(--local-tab) * 34px) + (var(--local-tab) * 4px)));
  }

  :host([data-type='flex']) {
    display: flex;
    padding: 0px 0px 0px 12px;
    gap: 4px;
  }

  :host([data-type='flex']) > button > wui-text {
    position: absolute;
    left: 18px;
    opacity: 0;
  }

  button[data-active='true'] > wui-icon,
  button[data-active='true'] > wui-text {
    color: var(--wui-color-fg-100);
  }

  button[data-active='false'] > wui-icon,
  button[data-active='false'] > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='true']:disabled,
  button[data-active='false']:disabled {
    background-color: transparent;
    opacity: 0.5;
    cursor: not-allowed;
  }

  button[data-active='true']:disabled > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='false']:disabled > wui-text {
    color: var(--wui-color-fg-300);
  }

  button > wui-icon,
  button > wui-text {
    pointer-events: none;
    transition: color var(--wui-e ase-out-power-1) var(--wui-duration-md);
    will-change: color;
  }

  button {
    width: var(--local-tab-width);
    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: background-color;
  }

  :host([data-type='flex']) > button {
    width: 34px;
    position: relative;
    display: flex;
    justify-content: flex-start;
  }

  button:hover:enabled,
  button:active:enabled {
    background-color: transparent !important;
  }

  button:hover:enabled > wui-icon,
  button:active:enabled > wui-icon {
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
    color: var(--wui-color-fg-125);
  }

  button:hover:enabled > wui-text,
  button:active:enabled > wui-text {
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
    color: var(--wui-color-fg-125);
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
  }
`;

});


parcelRegister("8OYIX", function(module, exports) {

$parcel$export(module.exports, "WuiTokenButton", function () { return $66c218c6b750366d$export$8a423828f5c8fb29; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $ailZp = parcelRequire("ailZp");

var $jVNMm = parcelRequire("jVNMm");
parcelRequire("fCaEm");
parcelRequire("4BuLe");
parcelRequire("7XtWS");

var $jYhmK = parcelRequire("jYhmK");
var $66c218c6b750366d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $66c218c6b750366d$export$8a423828f5c8fb29 = class WuiTokenButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
    }
    render() {
        return (0, $7pRM7.html)`
      <button ontouchstart>
        ${this.tokenTemplate()}
        <wui-text variant="paragraph-600" color="fg-100">${this.text}</wui-text>
      </button>
    `;
    }
    tokenTemplate() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return (0, $7pRM7.html)`
      <wui-icon-box
        size="sm"
        iconColor="fg-200"
        backgroundColor="fg-300"
        icon="networkPlaceholder"
      ></wui-icon-box>
    `;
    }
};
$66c218c6b750366d$export$8a423828f5c8fb29.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $jYhmK.default)
];
$66c218c6b750366d$var$__decorate([
    (0, $biDip.property)()
], $66c218c6b750366d$export$8a423828f5c8fb29.prototype, "imageSrc", void 0);
$66c218c6b750366d$var$__decorate([
    (0, $biDip.property)()
], $66c218c6b750366d$export$8a423828f5c8fb29.prototype, "text", void 0);
$66c218c6b750366d$export$8a423828f5c8fb29 = $66c218c6b750366d$var$__decorate([
    (0, $ailZp.customElement)("wui-token-button")
], $66c218c6b750366d$export$8a423828f5c8fb29);

});
parcelRegister("jYhmK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8a1176cb6aa87af$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $e8a1176cb6aa87af$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
  }

  :host > button {
    gap: var(--wui-spacing-xxs);
    padding: var(--wui-spacing-xs);
    padding-right: var(--wui-spacing-1xs);
    height: 40px;
    border-radius: var(--wui-border-radius-l);
    background: var(--wui-color-gray-glass-002);
    border-width: 0px;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);
  }

  :host > button wui-image {
    width: 24px;
    height: 24px;
    border-radius: var(--wui-border-radius-s);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }
`;

});


parcelRegister("b5O5N", function(module, exports) {

$parcel$export(module.exports, "WuiTooltip", function () { return $813704aadf1dd77d$export$eee74dbee7f7f64b; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $cBEkA = parcelRequire("cBEkA");
var $813704aadf1dd77d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $813704aadf1dd77d$export$eee74dbee7f7f64b = class WuiTooltip extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.placement = "top";
        this.variant = "fill";
        this.message = "";
    }
    render() {
        this.dataset["variant"] = this.variant;
        return (0, $7pRM7.html)`<wui-icon
        data-placement=${this.placement}
        color="fg-100"
        size="inherit"
        name=${this.variant === "fill" ? "cursor" : "cursorTransparent"}
      ></wui-icon>
      <wui-text color="inherit" variant="small-500">${this.message}</wui-text>`;
    }
};
$813704aadf1dd77d$export$eee74dbee7f7f64b.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $cBEkA.default)
];
$813704aadf1dd77d$var$__decorate([
    (0, $biDip.property)()
], $813704aadf1dd77d$export$eee74dbee7f7f64b.prototype, "placement", void 0);
$813704aadf1dd77d$var$__decorate([
    (0, $biDip.property)()
], $813704aadf1dd77d$export$eee74dbee7f7f64b.prototype, "variant", void 0);
$813704aadf1dd77d$var$__decorate([
    (0, $biDip.property)()
], $813704aadf1dd77d$export$eee74dbee7f7f64b.prototype, "message", void 0);
$813704aadf1dd77d$export$eee74dbee7f7f64b = $813704aadf1dd77d$var$__decorate([
    (0, $ailZp.customElement)("wui-tooltip")
], $813704aadf1dd77d$export$eee74dbee7f7f64b);

});
parcelRegister("cBEkA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92d839a0d6ad8537$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $92d839a0d6ad8537$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
    padding: 9px var(--wui-spacing-s) 10px var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);

    color: var(--wui-color-bg-100);
    position: relative;
  }

  :host([data-variant='shade']) {
    background-color: var(--wui-color-bg-150);
    border: 1px solid var(--wui-color-gray-glass-005);
  }

  :host([data-variant='shade']) > wui-text {
    color: var(--wui-color-fg-150);
  }

  :host([data-variant='fill']) {
    background-color: var(--wui-color-fg-100);
    border: none;
  }

  wui-icon {
    position: absolute;
    width: 12px !important;
    height: 4px !important;
  }

  wui-icon[data-placement='top'] {
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 95%);
  }

  wui-icon[data-placement='bottom'] {
    top: 0;
    left: 50%;
    transform: translate(-50%, -95%) rotate(180deg);
  }

  wui-icon[data-placement='right'] {
    top: 50%;
    left: 0;
    transform: translate(-65%, -50%) rotate(90deg);
  }

  wui-icon[data-placement='left'] {
    top: 50%;
    right: 0%;
    transform: translate(65%, -50%) rotate(270deg);
  }
`;

});


parcelRegister("1Vq2R", function(module, exports) {

$parcel$export(module.exports, "WuiTokenListItem", function () { return $166f51573e63b5c3$export$85f8def8a6b9b172; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
var $koENb = parcelRequire("koENb");
parcelRequire("4BuLe");
parcelRequire("fCaEm");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $d4l3Q = parcelRequire("d4l3Q");

var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("ikDNi");
var $l2EhC = parcelRequire("l2EhC");
var $166f51573e63b5c3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $166f51573e63b5c3$export$85f8def8a6b9b172 = class WuiTokenListItem extends (0, $cLW71.LitElement) {
    constructor(){
        super();
        this.observer = new IntersectionObserver(()=>undefined);
        this.imageSrc = undefined;
        this.name = undefined;
        this.symbol = undefined;
        this.price = undefined;
        this.amount = undefined;
        this.visible = false;
        this.imageError = false;
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) this.visible = true;
                else this.visible = false;
            });
        }, {
            threshold: 0.1
        });
    }
    firstUpdated() {
        this.observer.observe(this);
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    render() {
        if (!this.visible) return null;
        const value = this.amount && this.price ? (0, $l2EhC.NumberUtil).multiply(this.price, this.amount)?.toFixed(3) : null;
        return (0, $7pRM7.html)`
      <wui-flex alignItems="center">
        ${this.visualTemplate()}
        <wui-flex flexDirection="column" gap="3xs">
          <wui-flex justifyContent="space-between">
            <wui-text variant="paragraph-500" color="fg-100" lineClamp="1">${this.name}</wui-text>
            ${value ? (0, $7pRM7.html)`
                  <wui-text variant="paragraph-500" color="fg-100">
                    $${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(value, 3)}
                  </wui-text>
                ` : null}
          </wui-flex>
          <wui-flex justifyContent="space-between">
            <wui-text variant="small-400" color="fg-200" lineClamp="1">${this.symbol}</wui-text>
            ${this.amount ? (0, $7pRM7.html)`<wui-text variant="small-400" color="fg-200">
                  ${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.amount, 4)}
                </wui-text>` : null}
          </wui-flex>
        </wui-flex>
      </wui-flex>
    `;
    }
    visualTemplate() {
        if (this.imageError) return (0, $7pRM7.html)`<wui-flex class="token-item-image-placeholder">
        <wui-icon name="image" color="inherit"></wui-icon>
      </wui-flex>`;
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image
        width="40"
        height="40"
        src=${this.imageSrc}
        @onLoadError=${this.imageLoadError}
      ></wui-image>`;
        return null;
    }
    imageLoadError() {
        this.imageError = true;
    }
};
$166f51573e63b5c3$export$85f8def8a6b9b172.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $d4l3Q.default)
];
$166f51573e63b5c3$var$__decorate([
    (0, $biDip.property)()
], $166f51573e63b5c3$export$85f8def8a6b9b172.prototype, "imageSrc", void 0);
$166f51573e63b5c3$var$__decorate([
    (0, $biDip.property)()
], $166f51573e63b5c3$export$85f8def8a6b9b172.prototype, "name", void 0);
$166f51573e63b5c3$var$__decorate([
    (0, $biDip.property)()
], $166f51573e63b5c3$export$85f8def8a6b9b172.prototype, "symbol", void 0);
$166f51573e63b5c3$var$__decorate([
    (0, $biDip.property)()
], $166f51573e63b5c3$export$85f8def8a6b9b172.prototype, "price", void 0);
$166f51573e63b5c3$var$__decorate([
    (0, $biDip.property)()
], $166f51573e63b5c3$export$85f8def8a6b9b172.prototype, "amount", void 0);
$166f51573e63b5c3$var$__decorate([
    (0, $koENb.state)()
], $166f51573e63b5c3$export$85f8def8a6b9b172.prototype, "visible", void 0);
$166f51573e63b5c3$var$__decorate([
    (0, $koENb.state)()
], $166f51573e63b5c3$export$85f8def8a6b9b172.prototype, "imageError", void 0);
$166f51573e63b5c3$export$85f8def8a6b9b172 = $166f51573e63b5c3$var$__decorate([
    (0, $ailZp.customElement)("wui-token-list-item")
], $166f51573e63b5c3$export$85f8def8a6b9b172);

});
parcelRegister("d4l3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $983bfc595f19b946$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $983bfc595f19b946$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    height: 60px;
    min-height: 60px;
  }

  :host > wui-flex {
    cursor: pointer;
    height: 100%;
    display: flex;
    column-gap: var(--wui-spacing-s);
    padding: var(--wui-spacing-xs);
    padding-right: var(--wui-spacing-l);
    width: 100%;
    background-color: transparent;
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
    transition:
      background-color var(--wui-ease-out-power-1) var(--wui-duration-lg),
      opacity var(--wui-ease-out-power-1) var(--wui-duration-lg);
    will-change: background-color, opacity;
  }

  @media (hover: hover) and (pointer: fine) {
    :host > wui-flex:hover {
      background-color: var(--wui-color-gray-glass-002);
    }

    :host > wui-flex:active {
      background-color: var(--wui-color-gray-glass-005);
    }
  }

  :host([disabled]) > wui-flex {
    opacity: 0.6;
  }

  :host([disabled]) > wui-flex:hover {
    background-color: transparent;
  }

  :host > wui-flex > wui-flex {
    flex: 1;
  }

  :host > wui-flex > wui-image,
  :host > wui-flex > .token-item-image-placeholder {
    width: 40px;
    max-width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-3xl);
    position: relative;
  }

  :host > wui-flex > .token-item-image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :host > wui-flex > wui-image::after,
  :host > wui-flex > .token-item-image-placeholder::after {
    position: absolute;
    content: '';
    inset: 0;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
    border-radius: var(--wui-border-radius-l);
  }

  button > wui-icon-box[data-variant='square-blue'] {
    border-radius: var(--wui-border-radius-3xs);
    position: relative;
    border: none;
    width: 36px;
    height: 36px;
  }
`;

});


parcelRegister("gPs1o", function(module, exports) {

$parcel$export(module.exports, "WuiVisualThumbnail", function () { return $c407253f927a5c7a$export$fb0fe7c7cc2031fe; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("4BuLe");
parcelRequire("i6mxN");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $a9zHU = parcelRequire("a9zHU");
var $c407253f927a5c7a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c407253f927a5c7a$export$fb0fe7c7cc2031fe = class WuiVisualThumbnail extends (0, $cLW71.LitElement) {
    render() {
        this.style.cssText = `--local-border-radius: ${this.borderRadiusFull ? "1000px" : "20px"}; background-color: var(--wui-color-modal-bg);`;
        return (0, $7pRM7.html)`${this.templateVisual()}`;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? ""}></wui-image>`;
        return (0, $7pRM7.html)`<wui-icon
      data-parent-size="md"
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
    }
};
$c407253f927a5c7a$export$fb0fe7c7cc2031fe.styles = [
    (0, $jVNMm.resetStyles),
    (0, $a9zHU.default)
];
$c407253f927a5c7a$var$__decorate([
    (0, $biDip.property)()
], $c407253f927a5c7a$export$fb0fe7c7cc2031fe.prototype, "imageSrc", void 0);
$c407253f927a5c7a$var$__decorate([
    (0, $biDip.property)()
], $c407253f927a5c7a$export$fb0fe7c7cc2031fe.prototype, "alt", void 0);
$c407253f927a5c7a$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $c407253f927a5c7a$export$fb0fe7c7cc2031fe.prototype, "borderRadiusFull", void 0);
$c407253f927a5c7a$export$fb0fe7c7cc2031fe = $c407253f927a5c7a$var$__decorate([
    (0, $ailZp.customElement)("wui-visual-thumbnail")
], $c407253f927a5c7a$export$fb0fe7c7cc2031fe);

});
parcelRegister("a9zHU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76467159b5c353f0$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $76467159b5c353f0$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--wui-icon-box-size-xl);
    height: var(--wui-icon-box-size-xl);
    box-shadow: 0 0 0 8px var(--wui-thumbnail-border);
    border-radius: var(--local-border-radius);
    overflow: hidden;
  }

  wui-icon {
    width: 32px;
    height: 32px;
  }
`;

});


parcelRegister("aC3RC", function(module, exports) {

$parcel$export(module.exports, "WuiNoticeCard", function () { return $7ba0733e3b8118be$export$bdf6de60cd1210c8; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("jrTpg");
parcelRequire("fCaEm");
parcelRequire("hCQbE");
parcelRequire("7XtWS");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $49duf = parcelRequire("49duf");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
var $7ba0733e3b8118be$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7ba0733e3b8118be$export$bdf6de60cd1210c8 = class WuiNoticeCard extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.label = "";
        this.description = "";
        this.icon = "wallet";
    }
    render() {
        return (0, $7pRM7.html)`
      <button>
        <wui-flex gap="m" alignItems="center" justifyContent="space-between">
          <wui-icon-box
            size="lg"
            iconcolor="accent-100"
            backgroundcolor="accent-100"
            icon=${this.icon}
            background="transparent"
          ></wui-icon-box>

          <wui-flex flexDirection="column" gap="3xs">
            <wui-text variant="paragraph-500" color="fg-100">${this.label}</wui-text>
            <wui-text variant="small-400" color="fg-200">${this.description}</wui-text>
          </wui-flex>

          <wui-icon size="md" color="fg-200" name="chevronRight"></wui-icon>
        </wui-flex>
      </button>
    `;
    }
};
$7ba0733e3b8118be$export$bdf6de60cd1210c8.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $49duf.default)
];
$7ba0733e3b8118be$var$__decorate([
    (0, $biDip.property)()
], $7ba0733e3b8118be$export$bdf6de60cd1210c8.prototype, "label", void 0);
$7ba0733e3b8118be$var$__decorate([
    (0, $biDip.property)()
], $7ba0733e3b8118be$export$bdf6de60cd1210c8.prototype, "description", void 0);
$7ba0733e3b8118be$var$__decorate([
    (0, $biDip.property)()
], $7ba0733e3b8118be$export$bdf6de60cd1210c8.prototype, "icon", void 0);
$7ba0733e3b8118be$export$bdf6de60cd1210c8 = $7ba0733e3b8118be$var$__decorate([
    (0, $ailZp.customElement)("wui-notice-card")
], $7ba0733e3b8118be$export$bdf6de60cd1210c8);

});
parcelRegister("49duf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $305276e412537f89$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $305276e412537f89$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: block;
  }

  button {
    width: 100%;
    display: block;
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    padding-left: var(--wui-spacing-s);
    padding-right: var(--wui-spacing-2l);
    border-radius: var(--wui-border-radius-s);
    background-color: var(--wui-color-accent-glass-010);
  }

  button:hover {
    background-color: var(--wui-color-accent-glass-015) !important;
  }

  button:active {
    background-color: var(--wui-color-accent-glass-020) !important;
  }
`;

});


parcelRegister("115m8", function(module, exports) {

$parcel$export(module.exports, "WuiListAccordion", function () { return $0bda0a085fdb14de$export$f885ba019a6ba4db; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $kQG0Z = parcelRequire("kQG0Z");
var $0bda0a085fdb14de$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $0bda0a085fdb14de$var$MAX_HEIGHT = 100;
let $0bda0a085fdb14de$export$f885ba019a6ba4db = class WuiListAccordion extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.textTitle = "";
        this.overflowedContent = "";
        this.toggled = false;
        this.enableAccordion = false;
        this.scrollElement = undefined;
        this.scrollHeightElement = 0;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("textTitle") || changedProperties.has("overflowedContent")) setTimeout(()=>{
            this.checkHeight();
        }, 1);
    }
    checkHeight() {
        this.updateComplete.then(()=>{
            const heightElement = this.shadowRoot?.querySelector(".heightContent");
            const textElement = this.shadowRoot?.querySelector(".textContent");
            if (heightElement && textElement) {
                this.scrollElement = heightElement;
                const scrollHeight = textElement?.scrollHeight;
                if (scrollHeight && scrollHeight > $0bda0a085fdb14de$var$MAX_HEIGHT) {
                    this.enableAccordion = true;
                    this.scrollHeightElement = scrollHeight;
                    this.requestUpdate();
                }
            }
        });
    }
    render() {
        return (0, $7pRM7.html)`
      <button ontouchstart @click=${()=>this.onClick()}>
        <wui-flex justifyContent="space-between" alignItems="center">
          <wui-text variant="paragraph-500" color="fg-100">${this.textTitle}</wui-text>
          ${this.chevronTemplate()}
        </wui-flex>
        <div
          data-active=${this.enableAccordion ? Boolean(this.toggled) : true}
          class="overflowedContent"
        >
          <div class="heightContent">
            <wui-text class="textContent" variant="paragraph-400" color="fg-200">
              <pre>${this.overflowedContent}</pre>
            </wui-text>
          </div>
        </div>
      </button>
    `;
    }
    onClick() {
        const icon = this.shadowRoot?.querySelector("wui-icon");
        if (this.enableAccordion) {
            this.toggled = !this.toggled;
            this.requestUpdate();
            if (this.scrollElement) this.scrollElement.animate([
                {
                    maxHeight: this.toggled ? `${$0bda0a085fdb14de$var$MAX_HEIGHT}px` : `${this.scrollHeightElement}px`
                },
                {
                    maxHeight: this.toggled ? `${this.scrollHeightElement}px` : `${$0bda0a085fdb14de$var$MAX_HEIGHT}px`
                }
            ], {
                duration: 300,
                fill: "forwards",
                easing: "ease"
            });
            if (icon) icon.animate([
                {
                    transform: this.toggled ? `rotate(0deg)` : `rotate(180deg)`
                },
                {
                    transform: this.toggled ? `rotate(180deg)` : `rotate(0deg)`
                }
            ], {
                duration: 300,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    chevronTemplate() {
        if (this.enableAccordion) return (0, $7pRM7.html)` <wui-icon color="fg-100" size="sm" name="chevronBottom"></wui-icon>`;
        return null;
    }
};
$0bda0a085fdb14de$export$f885ba019a6ba4db.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $kQG0Z.default)
];
$0bda0a085fdb14de$var$__decorate([
    (0, $biDip.property)()
], $0bda0a085fdb14de$export$f885ba019a6ba4db.prototype, "textTitle", void 0);
$0bda0a085fdb14de$var$__decorate([
    (0, $biDip.property)()
], $0bda0a085fdb14de$export$f885ba019a6ba4db.prototype, "overflowedContent", void 0);
$0bda0a085fdb14de$export$f885ba019a6ba4db = $0bda0a085fdb14de$var$__decorate([
    (0, $ailZp.customElement)("wui-list-accordion")
], $0bda0a085fdb14de$export$f885ba019a6ba4db);

});
parcelRegister("kQG0Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2d94140e35a4924$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $f2d94140e35a4924$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    height: auto;
    position: relative;
    flex-direction: column;
    gap: var(--wui-spacing-s);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  .overflowedContent {
    width: 100%;
    overflow: hidden;
  }

  .overflowedContent[data-active='false']:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, var(--wui-color-bg-150), transparent);
    border-bottom-left-radius: var(--wui-border-radius-xs);
    border-bottom-right-radius: var(--wui-border-radius-xs);
  }

  .heightContent {
    max-height: 100px;
  }

  pre {
    text-align: left;
    white-space: pre-wrap;
    height: auto;
    overflow-x: auto;
    overflow-wrap: anywhere;
  }
`;

});


parcelRegister("8u5Li", function(module, exports) {

$parcel$export(module.exports, "WuiListContent", function () { return $62d5983ad290a472$export$621c7f09b7560b89; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("4BuLe");
parcelRequire("fCaEm");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $bNB6G = parcelRequire("bNB6G");
var $62d5983ad290a472$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $62d5983ad290a472$export$621c7f09b7560b89 = class WuiListContent extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.textTitle = "";
        this.textValue = undefined;
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color=${this.textValue ? "fg-200" : "fg-100"}>
          ${this.textTitle}
        </wui-text>
        ${this.templateContent()}
      </wui-flex>
    `;
    }
    templateContent() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc} alt=${this.textTitle}></wui-image>`;
        else if (this.textValue) return (0, $7pRM7.html)` <wui-text variant="paragraph-400" color="fg-100"> ${this.textValue} </wui-text>`;
        return (0, $7pRM7.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$62d5983ad290a472$export$621c7f09b7560b89.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $bNB6G.default)
];
$62d5983ad290a472$var$__decorate([
    (0, $biDip.property)()
], $62d5983ad290a472$export$621c7f09b7560b89.prototype, "imageSrc", void 0);
$62d5983ad290a472$var$__decorate([
    (0, $biDip.property)()
], $62d5983ad290a472$export$621c7f09b7560b89.prototype, "textTitle", void 0);
$62d5983ad290a472$var$__decorate([
    (0, $biDip.property)()
], $62d5983ad290a472$export$621c7f09b7560b89.prototype, "textValue", void 0);
$62d5983ad290a472$export$621c7f09b7560b89 = $62d5983ad290a472$var$__decorate([
    (0, $ailZp.customElement)("wui-list-content")
], $62d5983ad290a472$export$621c7f09b7560b89);

});
parcelRegister("bNB6G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89710df1a94a91c0$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $89710df1a94a91c0$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-s);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  wui-image {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-icon {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
  }
`;

});


parcelRegister("dG5yn", function(module, exports) {

$parcel$export(module.exports, "WuiListNetwork", function () { return $9f53816e4d7d770a$export$f7ecfb3cf2878ec8; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("li0PP");

var $cNo8m = parcelRequire("cNo8m");
var $9f53816e4d7d770a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9f53816e4d7d770a$export$f7ecfb3cf2878ec8 = class WuiListNetwork extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = "";
        this.name = "";
        this.disabled = false;
        this.selected = false;
        this.transparent = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button data-transparent=${this.transparent} ?disabled=${this.disabled} ontouchstart>
        <wui-flex gap="s" alignItems="center">
          ${this.templateNetworkImage()}
          <wui-text variant="paragraph-500" color="inherit">${this.name}</wui-text></wui-flex
        >
        ${this.checkmarkTemplate()}
      </button>
    `;
    }
    checkmarkTemplate() {
        if (this.selected) return (0, $7pRM7.html)`<wui-icon size="sm" color="accent-100" name="checkmarkBold"></wui-icon>`;
        return null;
    }
    templateNetworkImage() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image size="sm" src=${this.imageSrc} name=${this.name}></wui-image>`;
        if (!this.imageSrc) return (0, $7pRM7.html)`<wui-network-image
        ?round=${true}
        size="md"
        name=${this.name}
      ></wui-network-image>`;
        return null;
    }
};
$9f53816e4d7d770a$export$f7ecfb3cf2878ec8.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $cNo8m.default)
];
$9f53816e4d7d770a$var$__decorate([
    (0, $biDip.property)()
], $9f53816e4d7d770a$export$f7ecfb3cf2878ec8.prototype, "imageSrc", void 0);
$9f53816e4d7d770a$var$__decorate([
    (0, $biDip.property)()
], $9f53816e4d7d770a$export$f7ecfb3cf2878ec8.prototype, "name", void 0);
$9f53816e4d7d770a$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $9f53816e4d7d770a$export$f7ecfb3cf2878ec8.prototype, "disabled", void 0);
$9f53816e4d7d770a$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $9f53816e4d7d770a$export$f7ecfb3cf2878ec8.prototype, "selected", void 0);
$9f53816e4d7d770a$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $9f53816e4d7d770a$export$f7ecfb3cf2878ec8.prototype, "transparent", void 0);
$9f53816e4d7d770a$export$f7ecfb3cf2878ec8 = $9f53816e4d7d770a$var$__decorate([
    (0, $ailZp.customElement)("wui-list-network")
], $9f53816e4d7d770a$export$f7ecfb3cf2878ec8);

});
parcelRegister("cNo8m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $950cc81b3190ce69$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $950cc81b3190ce69$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-md);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  button > wui-text:nth-child(2) {
    display: flex;
    flex: 1;
  }

  button[data-transparent='true'] {
    pointer-events: none;
    background-color: transparent;
  }

  button:hover {
    background-color: var(--wui-color-gray-glass-002);
  }

  button:active {
    background-color: var(--wui-color-gray-glass-005);
  }

  wui-image {
    width: var(--wui-spacing-3xl);
    height: var(--wui-spacing-3xl);
    border-radius: 100%;
  }

  button:disabled {
    background-color: var(--wui-color-gray-glass-002);
    opacity: 0.5;
    cursor: not-allowed;
  }

  button:disabled > wui-tag {
    background-color: var(--wui-color-gray-glass-010);
    color: var(--wui-color-fg-300);
  }
`;

});


parcelRegister("fpPbv", function(module, exports) {

$parcel$export(module.exports, "WuiListWalletTransaction", function () { return $b390e4fb3ec2c083$export$fc79cdc2df8cc885; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("4BuLe");
parcelRequire("fCaEm");
parcelRequire("2fpsv");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $hA6ML = parcelRequire("hA6ML");
var $b390e4fb3ec2c083$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b390e4fb3ec2c083$export$fc79cdc2df8cc885 = class WuiListWalletTransaction extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.amount = "";
        this.networkCurreny = "";
        this.networkImageUrl = "";
        this.receiverAddress = "";
        this.addressExplorerUrl = "";
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">Sending</wui-text>
        <wui-flex gap="xs" alignItems="center">
          <wui-text variant="paragraph-400" color="fg-100">
            ${this.amount} ${this.networkCurreny}
          </wui-text>
          ${this.templateNetworkVisual()}
        </wui-flex>
      </wui-flex>
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">To</wui-text>
        <wui-chip
          icon="externalLink"
          variant="shadeSmall"
          href=${this.addressExplorerUrl}
          title=${this.receiverAddress}
        ></wui-chip>
      </wui-flex>
    `;
    }
    templateNetworkVisual() {
        if (this.networkImageUrl) return (0, $7pRM7.html)`<wui-image src=${this.networkImageUrl} alt="Network Image"></wui-image>`;
        return (0, $7pRM7.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$b390e4fb3ec2c083$export$fc79cdc2df8cc885.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $hA6ML.default)
];
$b390e4fb3ec2c083$var$__decorate([
    (0, $biDip.property)()
], $b390e4fb3ec2c083$export$fc79cdc2df8cc885.prototype, "amount", void 0);
$b390e4fb3ec2c083$var$__decorate([
    (0, $biDip.property)()
], $b390e4fb3ec2c083$export$fc79cdc2df8cc885.prototype, "networkCurreny", void 0);
$b390e4fb3ec2c083$var$__decorate([
    (0, $biDip.property)()
], $b390e4fb3ec2c083$export$fc79cdc2df8cc885.prototype, "networkImageUrl", void 0);
$b390e4fb3ec2c083$var$__decorate([
    (0, $biDip.property)()
], $b390e4fb3ec2c083$export$fc79cdc2df8cc885.prototype, "receiverAddress", void 0);
$b390e4fb3ec2c083$var$__decorate([
    (0, $biDip.property)()
], $b390e4fb3ec2c083$export$fc79cdc2df8cc885.prototype, "addressExplorerUrl", void 0);
$b390e4fb3ec2c083$export$fc79cdc2df8cc885 = $b390e4fb3ec2c083$var$__decorate([
    (0, $ailZp.customElement)("wui-list-wallet-transaction")
], $b390e4fb3ec2c083$export$fc79cdc2df8cc885);

});
parcelRegister("hA6ML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cccb0fe7cc178e71$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $cccb0fe7cc178e71$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    flex-direction: column;
    gap: var(--wui-spacing-l);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  wui-image {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-icon {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
  }
`;

});


parcelRegister("4PHOX", function(module, exports) {

$parcel$export(module.exports, "WuiPromo", function () { return $384deabd08e088e9$export$73a995aef5d1b186; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $ailZp = parcelRequire("ailZp");

var $4qQqb = parcelRequire("4qQqb");
parcelRequire("fCaEm");
parcelRequire("i6mxN");

var $jVNMm = parcelRequire("jVNMm");
var $384deabd08e088e9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $384deabd08e088e9$export$73a995aef5d1b186 = class WuiPromo extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
    }
    render() {
        return (0, $7pRM7.html)`<button ontouchstart>
      <wui-text variant="small-600" color="bg-100">${this.text}</wui-text>
      <wui-icon color="bg-100" size="xs" name="arrowRight"></wui-icon>
    </button>`;
    }
};
$384deabd08e088e9$export$73a995aef5d1b186.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $4qQqb.default)
];
$384deabd08e088e9$var$__decorate([
    (0, $biDip.property)()
], $384deabd08e088e9$export$73a995aef5d1b186.prototype, "text", void 0);
$384deabd08e088e9$export$73a995aef5d1b186 = $384deabd08e088e9$var$__decorate([
    (0, $ailZp.customElement)("wui-promo")
], $384deabd08e088e9$export$73a995aef5d1b186);

});
parcelRegister("4qQqb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33a240eff3509bfa$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $33a240eff3509bfa$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    display: flex;
    gap: var(--wui-spacing-3xs);
    align-items: center;
    padding: 6.25px var(--wui-spacing-xs) 7.25px var(--wui-spacing-s);
    background-color: var(--wui-color-gray-glass-090);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-color-gray-glass-060);
    transition: background-color var(--wui-duration-md) var(--wui-ease-inout-power-1);
    will-change: background-color;
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-gray-glass-080);
    }

    button:active:enabled {
      background-color: var(--wui-color-gray-glass-060);
    }
  }
`;

});


parcelRegister("8l3pd", function(module, exports) {

$parcel$export(module.exports, "WuiBalance", function () { return $6122ed31fe4af200$export$cc964192ca050c2f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $ailZp = parcelRequire("ailZp");

var $jIyHQ = parcelRequire("jIyHQ");

var $jVNMm = parcelRequire("jVNMm");
var $6122ed31fe4af200$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6122ed31fe4af200$export$cc964192ca050c2f = class WuiBalance extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.dollars = "0";
        this.pennies = "00";
    }
    render() {
        return (0, $7pRM7.html)`<span>$${this.dollars}<span class="pennies">.${this.pennies}</span></span>`;
    }
};
$6122ed31fe4af200$export$cc964192ca050c2f.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jIyHQ.default)
];
$6122ed31fe4af200$var$__decorate([
    (0, $biDip.property)()
], $6122ed31fe4af200$export$cc964192ca050c2f.prototype, "dollars", void 0);
$6122ed31fe4af200$var$__decorate([
    (0, $biDip.property)()
], $6122ed31fe4af200$export$cc964192ca050c2f.prototype, "pennies", void 0);
$6122ed31fe4af200$export$cc964192ca050c2f = $6122ed31fe4af200$var$__decorate([
    (0, $ailZp.customElement)("wui-balance")
], $6122ed31fe4af200$export$cc964192ca050c2f);

});
parcelRegister("jIyHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5ad0c4e34b32b2b$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $e5ad0c4e34b32b2b$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  span {
    font-weight: 500;
    font-size: 40px;
    color: var(--wui-color-fg-100);
    line-height: 130%; /* 52px */
    letter-spacing: -1.6px;
    text-align: center;
  }

  .pennies {
    color: var(--wui-color-fg-200);
  }
`;

});


parcelRegister("2eJdn", function(module, exports) {

$parcel$export(module.exports, "WuiProfileButton", function () { return $1a0ff64ea4c092d1$export$7833c7acf4c9684a; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");
parcelRequire("4BuLe");
parcelRequire("jrTpg");
parcelRequire("lQgB0");
parcelRequire("7XtWS");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $ovuOC = parcelRequire("ovuOC");

var $fIDM4 = parcelRequire("fIDM4");
var $1a0ff64ea4c092d1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1a0ff64ea4c092d1$export$7833c7acf4c9684a = class WuiProfileButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.networkSrc = undefined;
        this.avatarSrc = undefined;
        this.profileName = "";
        this.address = "";
        this.icon = "chevronBottom";
    }
    render() {
        return (0, $7pRM7.html)`<button ontouchstart data-testid="wui-profile-button">
      <wui-flex gap="xs" alignItems="center">
        <wui-avatar
          .imageSrc=${this.avatarSrc}
          alt=${this.address}
          address=${this.address}
        ></wui-avatar>
        ${this.networkImageTemplate()}
        <wui-flex gap="xs" alignItems="center">
          <wui-text variant="large-600" color="fg-100">
            ${(0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.profileName || this.address,
            charsStart: this.profileName ? 18 : 4,
            charsEnd: this.profileName ? 0 : 4,
            truncate: this.profileName ? "end" : "middle"
        })}
          </wui-text>
          <wui-icon size="sm" color="fg-200" name=${this.icon}></wui-icon>
        </wui-flex>
      </wui-flex>
    </button>`;
    }
    networkImageTemplate() {
        if (this.networkSrc) return (0, $7pRM7.html)`<wui-image src=${this.networkSrc}></wui-image>`;
        return (0, $7pRM7.html)`
      <wui-icon-box
        size="xxs"
        iconColor="fg-200"
        backgroundColor="bg-100"
        icon="networkPlaceholder"
      ></wui-icon-box>
    `;
    }
};
$1a0ff64ea4c092d1$export$7833c7acf4c9684a.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $ovuOC.default)
];
$1a0ff64ea4c092d1$var$__decorate([
    (0, $biDip.property)()
], $1a0ff64ea4c092d1$export$7833c7acf4c9684a.prototype, "networkSrc", void 0);
$1a0ff64ea4c092d1$var$__decorate([
    (0, $biDip.property)()
], $1a0ff64ea4c092d1$export$7833c7acf4c9684a.prototype, "avatarSrc", void 0);
$1a0ff64ea4c092d1$var$__decorate([
    (0, $biDip.property)()
], $1a0ff64ea4c092d1$export$7833c7acf4c9684a.prototype, "profileName", void 0);
$1a0ff64ea4c092d1$var$__decorate([
    (0, $biDip.property)()
], $1a0ff64ea4c092d1$export$7833c7acf4c9684a.prototype, "address", void 0);
$1a0ff64ea4c092d1$var$__decorate([
    (0, $biDip.property)()
], $1a0ff64ea4c092d1$export$7833c7acf4c9684a.prototype, "icon", void 0);
$1a0ff64ea4c092d1$export$7833c7acf4c9684a = $1a0ff64ea4c092d1$var$__decorate([
    (0, $ailZp.customElement)("wui-profile-button")
], $1a0ff64ea4c092d1$export$7833c7acf4c9684a);

});
parcelRegister("ovuOC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $049aac75a4ae3cc3$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $049aac75a4ae3cc3$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-color-gray-glass-002);
    padding: var(--wui-spacing-xs) var(--wui-spacing-s) var(--wui-spacing-xs) var(--wui-spacing-xs);
    position: relative;
  }

  wui-avatar {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 0;
    outline: 3px solid var(--wui-color-gray-glass-005);
  }

  wui-icon-box,
  wui-image {
    width: 16px;
    height: 16px;
    border-radius: var(--wui-border-radius-3xl);
    position: absolute;
    left: 26px;
    top: 24px;
  }

  wui-image {
    outline: 2px solid var(--wui-color-bg-125);
  }

  wui-icon-box {
    outline: 2px solid var(--wui-color-bg-200);
    background-color: var(--wui-color-bg-250);
  }
`;

});


parcelRegister("df0St", function(module, exports) {

$parcel$export(module.exports, "WuiProfileButtonV2", function () { return $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");
parcelRequire("4BuLe");
parcelRequire("jrTpg");
parcelRequire("lQgB0");
parcelRequire("7XtWS");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $7eNlm = parcelRequire("7eNlm");

var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("eNJDH");
var $hdC6E = parcelRequire("hdC6E");
var $9a3d5b5a96b5f42e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d = class WuiProfileButtonV2 extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.avatarSrc = undefined;
        this.profileName = "";
        this.address = "";
        this.icon = "mail";
        this.connectedConnector = (0, $hdC6E.StorageUtil).getConnectedConnector();
        this.shouldShowIcon = this.connectedConnector === "AUTH";
    }
    render() {
        return (0, $7pRM7.html)`<button ontouchstart data-testid="wui-profile-button" @click=${this.handleClick}>
      <wui-flex gap="xs" alignItems="center">
        <wui-avatar
          .imageSrc=${this.avatarSrc}
          alt=${this.address}
          address=${this.address}
        ></wui-avatar>
        ${this.shouldShowIcon ? this.getIconTemplate(this.icon) : ""}
        <wui-flex gap="xs" alignItems="center">
          <wui-text variant="large-600" color="fg-100">
            ${(0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.profileName || this.address,
            charsStart: this.profileName ? 18 : 4,
            charsEnd: this.profileName ? 0 : 4,
            truncate: this.profileName ? "end" : "middle"
        })}
          </wui-text>
          <wui-icon size="sm" color="fg-200" name="copy" id="copy-address"></wui-icon>
        </wui-flex>
      </wui-flex>
    </button>`;
    }
    handleClick(event) {
        if (event.target instanceof HTMLElement && event.target.id === "copy-address") {
            this.onCopyClick?.(event);
            return;
        }
        this.onProfileClick?.(event);
    }
    getIconTemplate(icon) {
        return (0, $7pRM7.html)`
      <wui-icon-box
        size="xxs"
        iconColor="fg-200"
        backgroundColor="bg-100"
        icon="${icon || "networkPlaceholder"}"
      ></wui-icon-box>
    `;
    }
};
$9a3d5b5a96b5f42e$export$ceb46aef168f6a4d.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $7eNlm.default)
];
$9a3d5b5a96b5f42e$var$__decorate([
    (0, $biDip.property)()
], $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d.prototype, "avatarSrc", void 0);
$9a3d5b5a96b5f42e$var$__decorate([
    (0, $biDip.property)()
], $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d.prototype, "profileName", void 0);
$9a3d5b5a96b5f42e$var$__decorate([
    (0, $biDip.property)()
], $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d.prototype, "address", void 0);
$9a3d5b5a96b5f42e$var$__decorate([
    (0, $biDip.property)()
], $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d.prototype, "icon", void 0);
$9a3d5b5a96b5f42e$var$__decorate([
    (0, $biDip.property)()
], $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d.prototype, "onProfileClick", void 0);
$9a3d5b5a96b5f42e$var$__decorate([
    (0, $biDip.property)()
], $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d.prototype, "onCopyClick", void 0);
$9a3d5b5a96b5f42e$export$ceb46aef168f6a4d = $9a3d5b5a96b5f42e$var$__decorate([
    (0, $ailZp.customElement)("wui-profile-button-v2")
], $9a3d5b5a96b5f42e$export$ceb46aef168f6a4d);

});
parcelRegister("7eNlm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54501dd11899061b$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $54501dd11899061b$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-color-gray-glass-002);
    padding: var(--wui-spacing-xs) var(--wui-spacing-s) var(--wui-spacing-xs) var(--wui-spacing-xs);
    position: relative;
  }

  wui-avatar {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 0;
    outline: 3px solid var(--wui-color-gray-glass-005);
  }

  wui-icon-box,
  wui-image {
    width: 16px;
    height: 16px;
    border-radius: var(--wui-border-radius-3xl);
    position: absolute;
    left: 26px;
    top: 24px;
  }

  wui-image {
    outline: 2px solid var(--wui-color-bg-125);
  }

  wui-icon-box {
    outline: 2px solid var(--wui-color-bg-200);
    background-color: var(--wui-color-bg-250);
  }
`;

});


parcelRegister("qYJ7H", function(module, exports) {

$parcel$export(module.exports, "WuiChipButton", function () { return $051188e606d259df$export$f49ca3c577c0b16f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("4BuLe");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $gUGuR = parcelRequire("gUGuR");
var $051188e606d259df$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $051188e606d259df$export$f49ca3c577c0b16f = class WuiChipButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "accent";
        this.imageSrc = "";
        this.disabled = false;
        this.icon = "externalLink";
        this.size = "md";
        this.text = "";
    }
    render() {
        const textVariant = this.size === "sm" ? "small-600" : "paragraph-600";
        return (0, $7pRM7.html)`
      <button
        class=${this.disabled ? "disabled" : ""}
        data-variant=${this.variant}
        data-size=${this.size}
      >
        ${this.imageSrc ? (0, $7pRM7.html)`<wui-image src=${this.imageSrc}></wui-image>` : null}
        <wui-text variant=${textVariant} color="inherit"> ${this.text} </wui-text>
        <wui-icon name=${this.icon} color="inherit" size="inherit"></wui-icon>
      </button>
    `;
    }
};
$051188e606d259df$export$f49ca3c577c0b16f.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $gUGuR.default)
];
$051188e606d259df$var$__decorate([
    (0, $biDip.property)()
], $051188e606d259df$export$f49ca3c577c0b16f.prototype, "variant", void 0);
$051188e606d259df$var$__decorate([
    (0, $biDip.property)()
], $051188e606d259df$export$f49ca3c577c0b16f.prototype, "imageSrc", void 0);
$051188e606d259df$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $051188e606d259df$export$f49ca3c577c0b16f.prototype, "disabled", void 0);
$051188e606d259df$var$__decorate([
    (0, $biDip.property)()
], $051188e606d259df$export$f49ca3c577c0b16f.prototype, "icon", void 0);
$051188e606d259df$var$__decorate([
    (0, $biDip.property)()
], $051188e606d259df$export$f49ca3c577c0b16f.prototype, "size", void 0);
$051188e606d259df$var$__decorate([
    (0, $biDip.property)()
], $051188e606d259df$export$f49ca3c577c0b16f.prototype, "text", void 0);
$051188e606d259df$export$f49ca3c577c0b16f = $051188e606d259df$var$__decorate([
    (0, $ailZp.customElement)("wui-chip-button")
], $051188e606d259df$export$f49ca3c577c0b16f);

});
parcelRegister("gUGuR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c502d74b0cfe8a94$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $c502d74b0cfe8a94$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    border: none;
    border-radius: var(--wui-border-radius-3xl);
  }

  button[data-variant='main'] {
    background-color: var(--wui-color-accent-100);
    color: var(--wui-color-inverse-100);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }

  button[data-variant='accent'] {
    background-color: var(--wui-color-accent-glass-010);
    color: var(--wui-color-accent-100);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
  }

  button[data-variant='gray'] {
    background-color: transparent;
    color: var(--wui-color-fg-200);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }

  button[data-variant='shade'] {
    background-color: transparent;
    color: var(--wui-color-accent-100);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }

  button[data-size='sm'] {
    height: 32px;
    padding: 0 var(--wui-spacing-s);
  }

  button[data-size='md'] {
    height: 40px;
    padding: 0 var(--wui-spacing-l);
  }

  button[data-size='sm'] > wui-image {
    width: 16px;
    height: 16px;
  }

  button[data-size='md'] > wui-image {
    width: 24px;
    height: 24px;
  }

  button[data-size='sm'] > wui-icon {
    width: 12px;
    height: 12px;
  }

  button[data-size='md'] > wui-icon {
    width: 14px;
    height: 14px;
  }

  wui-image {
    border-radius: var(--wui-border-radius-3xl);
    overflow: hidden;
  }

  button.disabled > wui-icon,
  button.disabled > wui-image {
    filter: grayscale(1);
  }

  button[data-variant='main'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-color-accent-090);
  }

  button[data-variant='shade'] > wui-image,
  button[data-variant='gray'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }

  @media (hover: hover) and (pointer: fine) {
    button[data-variant='main']:focus-visible {
      background-color: var(--wui-color-accent-090);
    }

    button[data-variant='main']:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button[data-variant='main']:active:enabled {
      background-color: var(--wui-color-accent-080);
    }

    button[data-variant='accent']:hover:enabled {
      background-color: var(--wui-color-accent-glass-015);
    }

    button[data-variant='accent']:active:enabled {
      background-color: var(--wui-color-accent-glass-020);
    }

    button[data-variant='shade']:focus-visible,
    button[data-variant='gray']:focus-visible,
    button[data-variant='shade']:hover,
    button[data-variant='gray']:hover {
      background-color: var(--wui-color-gray-glass-002);
    }

    button[data-variant='gray']:active,
    button[data-variant='shade']:active {
      background-color: var(--wui-color-gray-glass-005);
    }
  }

  button.disabled {
    color: var(--wui-color-gray-glass-020);
    background-color: var(--wui-color-gray-glass-002);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);
    pointer-events: none;
  }
`;

});


parcelRegister("1LEz9", function(module, exports) {

$parcel$export(module.exports, "WuiCompatibleNetwork", function () { return $1499a5cc5c46171c$export$baf057fb6d6ac7c2; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("i6mxN");
parcelRequire("fCaEm");
parcelRequire("4BuLe");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $4jmiH = parcelRequire("4jmiH");
var $1499a5cc5c46171c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1499a5cc5c46171c$export$baf057fb6d6ac7c2 = class WuiCompatibleNetwork extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.networkImages = [
            ""
        ];
        this.text = "";
    }
    render() {
        return (0, $7pRM7.html)`
      <button ontouchstart>
        <wui-text variant="small-400" color="fg-200">${this.text}</wui-text>
        <wui-flex gap="3xs" alignItems="center">
          ${this.networksTemplate()}
          <wui-icon name="chevronRight" size="sm" color="fg-200"></wui-icon>
        </wui-flex>
      </button>
    `;
    }
    networksTemplate() {
        const slicedNetworks = this.networkImages.slice(0, 5);
        return (0, $7pRM7.html)` <wui-flex class="networks">
      ${slicedNetworks?.map((network)=>(0, $7pRM7.html)` <wui-flex class="network-icon"> <wui-image src=${network}></wui-image> </wui-flex>`)}
    </wui-flex>`;
    }
};
$1499a5cc5c46171c$export$baf057fb6d6ac7c2.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $4jmiH.default)
];
$1499a5cc5c46171c$var$__decorate([
    (0, $biDip.property)({
        type: Array
    })
], $1499a5cc5c46171c$export$baf057fb6d6ac7c2.prototype, "networkImages", void 0);
$1499a5cc5c46171c$var$__decorate([
    (0, $biDip.property)()
], $1499a5cc5c46171c$export$baf057fb6d6ac7c2.prototype, "text", void 0);
$1499a5cc5c46171c$export$baf057fb6d6ac7c2 = $1499a5cc5c46171c$var$__decorate([
    (0, $ailZp.customElement)("wui-compatible-network")
], $1499a5cc5c46171c$export$baf057fb6d6ac7c2);

});
parcelRegister("4jmiH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $323a3c342e97209d$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $323a3c342e97209d$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    display: flex;
    gap: var(--wui-spacing-xl);
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xxs);
    padding: var(--wui-spacing-m) var(--wui-spacing-s);
  }

  wui-text {
    width: 100%;
  }

  wui-flex {
    width: auto;
  }

  .network-icon {
    width: var(--wui-spacing-2l);
    height: var(--wui-spacing-2l);
    border-radius: calc(var(--wui-spacing-2l) / 2);
    overflow: hidden;
    box-shadow:
      0 0 0 3px var(--wui-color-gray-glass-002),
      0 0 0 3px var(--wui-color-modal-bg);
  }
`;

});


parcelRegister("aOVDi", function(module, exports) {

$parcel$export(module.exports, "WuiBanner", function () { return $7e0b478df4f9e028$export$51cf21fa3212b001; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");
parcelRequire("7XtWS");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $4CbgY = parcelRequire("4CbgY");
var $7e0b478df4f9e028$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7e0b478df4f9e028$export$51cf21fa3212b001 = class WuiBanner extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.icon = "externalLink";
        this.text = "";
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-flex gap="1xs" alignItems="center">
        <wui-icon-box
          size="sm"
          iconcolor="fg-200"
          backgroundcolor="fg-200"
          icon=${this.icon}
          background="transparent"
        ></wui-icon-box>
        <wui-text variant="small-400" color="fg-200">${this.text}</wui-text>
      </wui-flex>
    `;
    }
};
$7e0b478df4f9e028$export$51cf21fa3212b001.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $4CbgY.default)
];
$7e0b478df4f9e028$var$__decorate([
    (0, $biDip.property)()
], $7e0b478df4f9e028$export$51cf21fa3212b001.prototype, "icon", void 0);
$7e0b478df4f9e028$var$__decorate([
    (0, $biDip.property)()
], $7e0b478df4f9e028$export$51cf21fa3212b001.prototype, "text", void 0);
$7e0b478df4f9e028$export$51cf21fa3212b001 = $7e0b478df4f9e028$var$__decorate([
    (0, $ailZp.customElement)("wui-banner")
], $7e0b478df4f9e028$export$51cf21fa3212b001);

});
parcelRegister("4CbgY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35c3748ca134a736$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $35c3748ca134a736$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  wui-flex {
    width: 100%;
    background-color: var(--wui-color-gray-glass-005);
    border-radius: var(--wui-border-radius-s);
    padding: var(--wui-spacing-1xs) var(--wui-spacing-s) var(--wui-spacing-1xs)
      var(--wui-spacing-1xs);
  }
`;

});


parcelRegister("jyaVx", function(module, exports) {

$parcel$export(module.exports, "WuiBannerImg", function () { return $e3b9ab2e9174aa76$export$e5edb823776f5f6f; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");
parcelRequire("7XtWS");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $2L7Y4 = parcelRequire("2L7Y4");
var $e3b9ab2e9174aa76$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e3b9ab2e9174aa76$export$e5edb823776f5f6f = class WuiBannerImg extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = "";
        this.text = "";
        this.size = "";
    }
    render() {
        return (0, $7pRM7.html)`
      <wui-flex gap="1xs" alignItems="center">
        <wui-avatar size=${this.size} imageSrc=${this.imageSrc}></wui-avatar>
        <wui-text variant="small-400" color="fg-200">${this.text}</wui-text>
      </wui-flex>
    `;
    }
};
$e3b9ab2e9174aa76$export$e5edb823776f5f6f.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $2L7Y4.default)
];
$e3b9ab2e9174aa76$var$__decorate([
    (0, $biDip.property)()
], $e3b9ab2e9174aa76$export$e5edb823776f5f6f.prototype, "imageSrc", void 0);
$e3b9ab2e9174aa76$var$__decorate([
    (0, $biDip.property)()
], $e3b9ab2e9174aa76$export$e5edb823776f5f6f.prototype, "text", void 0);
$e3b9ab2e9174aa76$var$__decorate([
    (0, $biDip.property)()
], $e3b9ab2e9174aa76$export$e5edb823776f5f6f.prototype, "size", void 0);
$e3b9ab2e9174aa76$export$e5edb823776f5f6f = $e3b9ab2e9174aa76$var$__decorate([
    (0, $ailZp.customElement)("wui-banner-img")
], $e3b9ab2e9174aa76$export$e5edb823776f5f6f);

});
parcelRegister("2L7Y4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202626d04fc4297e$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $202626d04fc4297e$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  wui-flex {
    width: 100%;
    background-color: var(--wui-color-gray-glass-005);
    border-radius: var(--wui-border-radius-m);
    padding: var(--wui-spacing-1xs) var(--wui-spacing-s) var(--wui-spacing-1xs)
      var(--wui-spacing-1xs);
  }
`;

});


parcelRegister("44SOE", function(module, exports) {

$parcel$export(module.exports, "WuiListToken", function () { return $2f820e71c33c9b15$export$13e50b688b8e5b1; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");
parcelRequire("4BuLe");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $4TGat = parcelRequire("4TGat");

var $fIDM4 = parcelRequire("fIDM4");
var $2f820e71c33c9b15$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2f820e71c33c9b15$export$13e50b688b8e5b1 = class WuiListToken extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.tokenName = "";
        this.tokenImageUrl = "";
        this.tokenValue = 0.0;
        this.tokenAmount = "0.0";
        this.tokenCurrency = "";
        this.clickable = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button data-clickable=${String(this.clickable)} ontouchstart>
        <wui-flex gap="s" alignItems="center">
          ${this.visualTemplate()}
          <wui-flex flexDirection="column" justifyContent="spaceBetween">
            <wui-text variant="paragraph-500" color="fg-100">${this.tokenName}</wui-text>
            <wui-text variant="small-400" color="fg-200">
              ${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.tokenAmount, 4)} ${this.tokenCurrency}
            </wui-text>
          </wui-flex>
        </wui-flex>
        <wui-text variant="paragraph-500" color="fg-100">$${this.tokenValue.toFixed(2)}</wui-text>
      </button>
    `;
    }
    visualTemplate() {
        if (this.tokenName && this.tokenImageUrl) return (0, $7pRM7.html)`<wui-image alt=${this.tokenName} src=${this.tokenImageUrl}></wui-image>`;
        return (0, $7pRM7.html)`<wui-icon name="coinPlaceholder" color="fg-100"></wui-icon>`;
    }
};
$2f820e71c33c9b15$export$13e50b688b8e5b1.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $4TGat.default)
];
$2f820e71c33c9b15$var$__decorate([
    (0, $biDip.property)()
], $2f820e71c33c9b15$export$13e50b688b8e5b1.prototype, "tokenName", void 0);
$2f820e71c33c9b15$var$__decorate([
    (0, $biDip.property)()
], $2f820e71c33c9b15$export$13e50b688b8e5b1.prototype, "tokenImageUrl", void 0);
$2f820e71c33c9b15$var$__decorate([
    (0, $biDip.property)({
        type: Number
    })
], $2f820e71c33c9b15$export$13e50b688b8e5b1.prototype, "tokenValue", void 0);
$2f820e71c33c9b15$var$__decorate([
    (0, $biDip.property)()
], $2f820e71c33c9b15$export$13e50b688b8e5b1.prototype, "tokenAmount", void 0);
$2f820e71c33c9b15$var$__decorate([
    (0, $biDip.property)()
], $2f820e71c33c9b15$export$13e50b688b8e5b1.prototype, "tokenCurrency", void 0);
$2f820e71c33c9b15$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $2f820e71c33c9b15$export$13e50b688b8e5b1.prototype, "clickable", void 0);
$2f820e71c33c9b15$export$13e50b688b8e5b1 = $2f820e71c33c9b15$var$__decorate([
    (0, $ailZp.customElement)("wui-list-token")
], $2f820e71c33c9b15$export$13e50b688b8e5b1);

});
parcelRegister("4TGat", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $390d0226ce87b301$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $390d0226ce87b301$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    padding: 6.5px var(--wui-spacing-l) 6.5px var(--wui-spacing-xs);
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    background-color: var(--wui-color-gray-glass-002);
  }

  button[data-clickable='false'] {
    pointer-events: none;
    background-color: transparent;
  }

  wui-image,
  wui-icon {
    width: var(--wui-spacing-3xl);
    height: var(--wui-spacing-3xl);
  }

  wui-image {
    border-radius: var(--wui-border-radius-3xl);
  }
`;

});


parcelRegister("h4Y7z", function(module, exports) {

$parcel$export(module.exports, "WuiListDescription", function () { return $c6f1722afa1417e9$export$f327e80cbe72e7a9; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");
parcelRequire("4BuLe");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $lUjg4 = parcelRequire("lUjg4");
var $c6f1722afa1417e9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c6f1722afa1417e9$export$f327e80cbe72e7a9 = class WuiListDescription extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.icon = "card";
        this.text = "";
        this.description = "";
        this.tag = undefined;
        this.iconBackgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.disabled = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button ontouchstart ?disabled=${this.disabled}>
        <wui-icon-box
          iconColor=${this.iconColor}
          backgroundColor=${this.iconBackgroundColor}
          size="inherit"
          icon=${this.icon}
          iconSize="md"
        ></wui-icon-box>
        <wui-flex flexDirection="column" justifyContent="spaceBetween">
          ${this.titleTemplate()}
          <wui-text variant="small-400" color="fg-200"> ${this.description}</wui-text></wui-flex
        >
      </button>
    `;
    }
    titleTemplate() {
        if (this.tag) return (0, $7pRM7.html)` <wui-flex alignItems="center" gap="xxs"
        ><wui-text variant="paragraph-500" color="fg-100">${this.text}</wui-text
        ><wui-tag tagType="main" size="md">${this.tag}</wui-tag>
      </wui-flex>`;
        return (0, $7pRM7.html)`<wui-text variant="paragraph-500" color="fg-100">${this.text}</wui-text>`;
    }
};
$c6f1722afa1417e9$export$f327e80cbe72e7a9.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $lUjg4.default)
];
$c6f1722afa1417e9$var$__decorate([
    (0, $biDip.property)()
], $c6f1722afa1417e9$export$f327e80cbe72e7a9.prototype, "icon", void 0);
$c6f1722afa1417e9$var$__decorate([
    (0, $biDip.property)()
], $c6f1722afa1417e9$export$f327e80cbe72e7a9.prototype, "text", void 0);
$c6f1722afa1417e9$var$__decorate([
    (0, $biDip.property)()
], $c6f1722afa1417e9$export$f327e80cbe72e7a9.prototype, "description", void 0);
$c6f1722afa1417e9$var$__decorate([
    (0, $biDip.property)()
], $c6f1722afa1417e9$export$f327e80cbe72e7a9.prototype, "tag", void 0);
$c6f1722afa1417e9$var$__decorate([
    (0, $biDip.property)()
], $c6f1722afa1417e9$export$f327e80cbe72e7a9.prototype, "iconBackgroundColor", void 0);
$c6f1722afa1417e9$var$__decorate([
    (0, $biDip.property)()
], $c6f1722afa1417e9$export$f327e80cbe72e7a9.prototype, "iconColor", void 0);
$c6f1722afa1417e9$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $c6f1722afa1417e9$export$f327e80cbe72e7a9.prototype, "disabled", void 0);
$c6f1722afa1417e9$export$f327e80cbe72e7a9 = $c6f1722afa1417e9$var$__decorate([
    (0, $ailZp.customElement)("wui-list-description")
], $c6f1722afa1417e9$export$f327e80cbe72e7a9);

});
parcelRegister("lUjg4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff2dc43c71cb1763$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $ff2dc43c71cb1763$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    width: 100%;
    display: flex;
    gap: var(--wui-spacing-s);
    align-items: center;
    justify-content: flex-start;
    padding: var(--wui-spacing-s) var(--wui-spacing-m) var(--wui-spacing-s) var(--wui-spacing-s);
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }

  wui-icon-box {
    width: var(--wui-spacing-2xl);
    height: var(--wui-spacing-2xl);
  }

  wui-flex {
    width: auto;
  }
`;

});


parcelRegister("3kLy3", function(module, exports) {

$parcel$export(module.exports, "WuiInputAmount", function () { return $26d81f71bbe31774$export$b2838f44ec9f0443; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $exTpe = parcelRequire("exTpe");
parcelRequire("7rFd7");
var $kELMR = parcelRequire("kELMR");

var $gKgzb = parcelRequire("gKgzb");
var $26d81f71bbe31774$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $26d81f71bbe31774$export$b2838f44ec9f0443 = class WuiInputAmount extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.inputElementRef = (0, $kELMR.createRef)();
        this.disabled = false;
        this.value = "";
        this.placeholder = "0";
    }
    render() {
        if (this.inputElementRef?.value && this.value) this.inputElementRef.value.value = this.value;
        return (0, $7pRM7.html)`<input
      ${(0, $kELMR.ref)(this.inputElementRef)}
      type="text"
      inputmode="decimal"
      pattern="[0-9,.]*"
      placeholder=${this.placeholder}
      ?disabled=${this.disabled}
      autofocus
      value=${this.value ?? ""}
      @input=${this.dispatchInputChangeEvent.bind(this)}
    /> `;
    }
    dispatchInputChangeEvent(e) {
        const inputChar = e.data;
        if (inputChar && this.inputElementRef?.value) {
            if (inputChar === ",") {
                const inputValue = this.inputElementRef.value.value.replace(",", ".");
                this.inputElementRef.value.value = inputValue;
                this.value = `${this.value}${inputValue}`;
            } else if (!(0, $gKgzb.numbersRegex).test(inputChar)) this.inputElementRef.value.value = this.value.replace(new RegExp(inputChar.replace((0, $gKgzb.specialCharactersRegex), "\\$&"), "gu"), "");
        }
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: this.inputElementRef.value?.value,
            bubbles: true,
            composed: true
        }));
    }
};
$26d81f71bbe31774$export$b2838f44ec9f0443.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $exTpe.default)
];
$26d81f71bbe31774$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $26d81f71bbe31774$export$b2838f44ec9f0443.prototype, "disabled", void 0);
$26d81f71bbe31774$var$__decorate([
    (0, $biDip.property)({
        type: String
    })
], $26d81f71bbe31774$export$b2838f44ec9f0443.prototype, "value", void 0);
$26d81f71bbe31774$var$__decorate([
    (0, $biDip.property)({
        type: String
    })
], $26d81f71bbe31774$export$b2838f44ec9f0443.prototype, "placeholder", void 0);
$26d81f71bbe31774$export$b2838f44ec9f0443 = $26d81f71bbe31774$var$__decorate([
    (0, $ailZp.customElement)("wui-input-amount")
], $26d81f71bbe31774$export$b2838f44ec9f0443);

});
parcelRegister("exTpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a96f203fed5ce1bf$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $a96f203fed5ce1bf$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  input {
    background: transparent;
    width: 100%;
    height: auto;
    font-family: var(--wui-font-family);
    color: var(--wui-color-fg-100);

    font-feature-settings: 'case' on;
    font-size: 32px;
    font-weight: var(--wui-font-weight-light);
    caret-color: var(--wui-color-accent-100);
    line-height: 130%;
    letter-spacing: -1.28px;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    padding: 0px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input::placeholder {
    color: var(--wui-color-fg-275);
  }
`;

});

parcelRegister("gKgzb", function(module, exports) {

$parcel$export(module.exports, "specialCharactersRegex", function () { return $c30dcaf74cd9cb66$export$c39fd9747ee8dc1a; });
$parcel$export(module.exports, "numbersRegex", function () { return $c30dcaf74cd9cb66$export$e4e17532376f38ea; });
const $c30dcaf74cd9cb66$export$c39fd9747ee8dc1a = /[.*+?^${}()|[\]\\]/gu;
const $c30dcaf74cd9cb66$export$e4e17532376f38ea = /[0-9,.]/u;

});


parcelRegister("7XlYf", function(module, exports) {

$parcel$export(module.exports, "WuiPreviewItem", function () { return $5caf160a3a6d3e6b$export$60b39244fc096362; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");
parcelRequire("4BuLe");
parcelRequire("i6mxN");
parcelRequire("lQgB0");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $lx6M8 = parcelRequire("lx6M8");
var $5caf160a3a6d3e6b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5caf160a3a6d3e6b$export$60b39244fc096362 = class WuiPreviewItem extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
        this.address = "";
        this.isAddress = false;
    }
    render() {
        return (0, $7pRM7.html)`<wui-text variant="large-500" color="fg-100">${this.text}</wui-text>
      ${this.imageTemplate()}`;
    }
    imageTemplate() {
        if (this.isAddress) return (0, $7pRM7.html)`<wui-avatar address=${this.address} .imageSrc=${this.imageSrc}></wui-avatar>`;
        else if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return (0, $7pRM7.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$5caf160a3a6d3e6b$export$60b39244fc096362.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $lx6M8.default)
];
$5caf160a3a6d3e6b$var$__decorate([
    (0, $biDip.property)()
], $5caf160a3a6d3e6b$export$60b39244fc096362.prototype, "text", void 0);
$5caf160a3a6d3e6b$var$__decorate([
    (0, $biDip.property)()
], $5caf160a3a6d3e6b$export$60b39244fc096362.prototype, "address", void 0);
$5caf160a3a6d3e6b$var$__decorate([
    (0, $biDip.property)()
], $5caf160a3a6d3e6b$export$60b39244fc096362.prototype, "imageSrc", void 0);
$5caf160a3a6d3e6b$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $5caf160a3a6d3e6b$export$60b39244fc096362.prototype, "isAddress", void 0);
$5caf160a3a6d3e6b$export$60b39244fc096362 = $5caf160a3a6d3e6b$var$__decorate([
    (0, $ailZp.customElement)("wui-preview-item")
], $5caf160a3a6d3e6b$export$60b39244fc096362);

});
parcelRegister("lx6M8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fad1ef81941085ce$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $fad1ef81941085ce$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: flex;
    gap: var(--wui-spacing-xs);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-color-gray-glass-002);
    background: var(--wui-color-gray-glass-002);
    padding: var(--wui-spacing-2xs) var(--wui-spacing-xs) var(--wui-spacing-2xs)
      var(--wui-spacing-s);
    align-items: center;
  }

  wui-avatar,
  wui-icon,
  wui-image {
    width: 32px;
    height: 32px;
    border: 1px solid var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-3xl);
    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-002);
  }
`;

});


parcelRegister("2VNEH", function(module, exports) {

$parcel$export(module.exports, "WuiListAccount", function () { return $22276c31b49f976f$export$5ac51030fb805c58; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");
parcelRequire("4BuLe");
parcelRequire("jrTpg");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $8y322 = parcelRequire("8y322");

var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $hxXs8 = parcelRequire("hxXs8");
var $jbD0z = parcelRequire("jbD0z");
var $hdC6E = parcelRequire("hdC6E");
var $22276c31b49f976f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $22276c31b49f976f$export$5ac51030fb805c58 = class WuiListAccount extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.accountAddress = "";
        this.accountType = "";
        this.connectedConnector = (0, $hdC6E.StorageUtil).getConnectedConnector();
        this.labels = (0, $f7IXw.AccountController).state.addressLabels;
        this.caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.socialProvider = (0, $hdC6E.StorageUtil).getConnectedSocialProvider();
        this.balance = 0;
        this.fetchingBalance = true;
        this.shouldShowIcon = false;
        this.selected = false;
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $hxXs8.BlockchainApiController).getBalance(this.accountAddress, this.caipNetwork?.id).then((response)=>{
            let total = this.balance;
            if (response.balances.length > 0) total = response.balances.reduce((acc, balance)=>acc + (balance?.value || 0), 0);
            this.balance = total;
            this.fetchingBalance = false;
            this.requestUpdate();
        });
    }
    render() {
        const label = this.getLabel();
        this.shouldShowIcon = this.connectedConnector === "AUTH";
        return (0, $7pRM7.html)`
      <wui-flex
        flexDirection="row"
        justifyContent="space-between"
        .padding=${[
            "0",
            "0",
            "s",
            "1xs"
        ]}
      >
        <wui-flex gap="md" alignItems="center">
          <wui-avatar address=${this.accountAddress}></wui-avatar>
          ${this.shouldShowIcon ? (0, $7pRM7.html)`<wui-icon-box
                size="sm"
                iconcolor="fg-200"
                backgroundcolor="fg-300"
                icon=${this.accountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA ? this.socialProvider ?? "mail" : "lightbulb"}
                background="fg-300"
              ></wui-icon-box>` : (0, $7pRM7.html)`<wui-flex .padding="${[
            "0",
            "0",
            "0",
            "s"
        ]}"></wui-flex>`}
          <wui-flex flexDirection="column">
            <wui-text class="address" variant="paragraph-500" color="fg-100"
              >${(0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.accountAddress,
            charsStart: 4,
            charsEnd: 6,
            truncate: "middle"
        })}</wui-text
            >
            <wui-text class="address-description" variant="small-400">${label}</wui-text></wui-flex
          >
        </wui-flex>
        <wui-flex gap="s" alignItems="center">
          ${this.fetchingBalance ? (0, $7pRM7.html)`<wui-loading-spinner size="sm" color="accent-100"></wui-loading-spinner>` : (0, $7pRM7.html)` <wui-text variant="small-400">$${this.balance.toFixed(2)}</wui-text>`}
          <slot name="action"></slot>
        </wui-flex>
      </wui-flex>
    `;
    }
    getLabel() {
        let label = this.labels?.get(this.accountAddress);
        if (!label && this.connectedConnector === "AUTH") label = `${this.accountType === "eoa" ? this.socialProvider ?? "Email" : "Smart"} Account`;
        else if (!label && this.connectedConnector === "INJECTED" || this.connectedConnector === "ANNOUNCED") label = `Injected Account`;
        else if (!label) label = "EOA";
        return label;
    }
};
$22276c31b49f976f$export$5ac51030fb805c58.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $8y322.default)
];
$22276c31b49f976f$var$__decorate([
    (0, $biDip.property)()
], $22276c31b49f976f$export$5ac51030fb805c58.prototype, "accountAddress", void 0);
$22276c31b49f976f$var$__decorate([
    (0, $biDip.property)()
], $22276c31b49f976f$export$5ac51030fb805c58.prototype, "accountType", void 0);
$22276c31b49f976f$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $22276c31b49f976f$export$5ac51030fb805c58.prototype, "selected", void 0);
$22276c31b49f976f$var$__decorate([
    (0, $biDip.property)({
        type: Function
    })
], $22276c31b49f976f$export$5ac51030fb805c58.prototype, "onSelect", void 0);
$22276c31b49f976f$export$5ac51030fb805c58 = $22276c31b49f976f$var$__decorate([
    (0, $ailZp.customElement)("wui-list-account")
], $22276c31b49f976f$export$5ac51030fb805c58);

});
parcelRegister("8y322", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6393d9caf68c6e6a$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $6393d9caf68c6e6a$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    padding: 6.5px var(--wui-spacing-l) 6.5px var(--wui-spacing-xs);
    display: flex;
    justify-content: space-between;
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    background-color: var(--wui-color-gray-glass-002);
  }

  button[data-clickable='false'] {
    pointer-events: none;
    background-color: transparent;
  }

  wui-image {
    width: var(--wui-spacing-3xl);
    height: var(--wui-spacing-3xl);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-avatar {
    width: var(--wui-spacing-3xl);
    height: var(--wui-spacing-3xl);
    box-shadow: 0 0 0 0;
  }
  .address {
    color: var(--wui-color-fg-base-100);
  }
  .address-description {
    text-transform: capitalize;
    color: var(--wui-color-fg-base-200);
  }

  wui-icon-box {
    position: relative;
    right: 15px;
    top: 15px;
    border: 2px solid var(--wui-color-bg-150);
    background-color: var(--wui-color-bg-125);
  }
`;

});


parcelRegister("l74IZ", function(module, exports) {

$parcel$export(module.exports, "WuiIconButton", function () { return $f5edeaa4ed3e6e8d$export$91b5dd827cb523b7; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $ailZp = parcelRequire("ailZp");

var $bkCDa = parcelRequire("bkCDa");
parcelRequire("b5O5N");
parcelRequire("i6mxN");

var $jVNMm = parcelRequire("jVNMm");
var $f5edeaa4ed3e6e8d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f5edeaa4ed3e6e8d$export$91b5dd827cb523b7 = class WuiIconButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
        this.icon = "card";
    }
    render() {
        return (0, $7pRM7.html)`<button>
      <wui-icon color="accent-100" name=${this.icon} size="lg"></wui-icon>
    </button>`;
    }
};
$f5edeaa4ed3e6e8d$export$91b5dd827cb523b7.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $bkCDa.default)
];
$f5edeaa4ed3e6e8d$var$__decorate([
    (0, $biDip.property)()
], $f5edeaa4ed3e6e8d$export$91b5dd827cb523b7.prototype, "text", void 0);
$f5edeaa4ed3e6e8d$var$__decorate([
    (0, $biDip.property)()
], $f5edeaa4ed3e6e8d$export$91b5dd827cb523b7.prototype, "icon", void 0);
$f5edeaa4ed3e6e8d$export$91b5dd827cb523b7 = $f5edeaa4ed3e6e8d$var$__decorate([
    (0, $ailZp.customElement)("wui-icon-button")
], $f5edeaa4ed3e6e8d$export$91b5dd827cb523b7);

});
parcelRegister("bkCDa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83ff873d28d83561$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $83ff873d28d83561$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    width: 100%;
    background-color: var(--wui-color-accent-glass-010);
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-color-accent-glass-010);
    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: background-color;
  }

  wui-tooltip {
    padding: 7px var(--wui-spacing-s) 8px var(--wui-spacing-s);
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translate(-50%, -100%);
    opacity: 0;
    display: none;
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-accent-glass-015);
    }

    button:active:enabled {
      background-color: var(--wui-color-accent-glass-020);
    }
  }
`;

});


parcelRegister("k2qNo", function(module, exports) {

$parcel$export(module.exports, "WuiListButton", function () { return $e968c79d06c18a77$export$ce16820f038eaf8e; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $fgBEM = parcelRequire("fgBEM");
var $e968c79d06c18a77$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e968c79d06c18a77$export$ce16820f038eaf8e = class WuiListButton extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
        this.disabled = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-text align="center" variant="paragraph-500" color="inherit">${this.text}</wui-text>
      </button>
    `;
    }
};
$e968c79d06c18a77$export$ce16820f038eaf8e.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $fgBEM.default)
];
$e968c79d06c18a77$var$__decorate([
    (0, $biDip.property)()
], $e968c79d06c18a77$export$ce16820f038eaf8e.prototype, "text", void 0);
$e968c79d06c18a77$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $e968c79d06c18a77$export$ce16820f038eaf8e.prototype, "disabled", void 0);
$e968c79d06c18a77$export$ce16820f038eaf8e = $e968c79d06c18a77$var$__decorate([
    (0, $ailZp.customElement)("wui-list-button")
], $e968c79d06c18a77$export$ce16820f038eaf8e);

});
parcelRegister("fgBEM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1d58f76012ca1be$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $b1d58f76012ca1be$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 16.5px var(--wui-spacing-l) 16.5px var(--wui-spacing-xs);
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
    justify-content: center;
    align-items: center;
  }

  button:disabled {
    background-color: var(--wui-color-gray-glass-015);
    color: var(--wui-color-gray-glass-015);
  }
`;

});


parcelRegister("aWuyp", function(module, exports) {

$parcel$export(module.exports, "WuiListSocial", function () { return $7f77058da277a6b7$export$6d44576f6b47c46b; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");
parcelRequire("aPnTQ");

var $b0Sx5 = parcelRequire("b0Sx5");
var $7f77058da277a6b7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7f77058da277a6b7$export$6d44576f6b47c46b = class WuiListSocial extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
        this.name = "Continue with google";
        this.align = "left";
        this.disabled = false;
    }
    render() {
        return (0, $7pRM7.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-logo logo=${this.logo}></wui-logo>
        <wui-text
          data-align=${this.align}
          variant="paragraph-500"
          color="inherit"
          align=${this.align}
          >${this.name}</wui-text
        >
        ${this.templatePlacement()}
      </button>
    `;
    }
    templatePlacement() {
        if (this.align === "center") return (0, $7pRM7.html)` <wui-logo class="invisible" logo=${this.logo}></wui-logo>`;
        return null;
    }
};
$7f77058da277a6b7$export$6d44576f6b47c46b.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $b0Sx5.default)
];
$7f77058da277a6b7$var$__decorate([
    (0, $biDip.property)()
], $7f77058da277a6b7$export$6d44576f6b47c46b.prototype, "logo", void 0);
$7f77058da277a6b7$var$__decorate([
    (0, $biDip.property)()
], $7f77058da277a6b7$export$6d44576f6b47c46b.prototype, "name", void 0);
$7f77058da277a6b7$var$__decorate([
    (0, $biDip.property)()
], $7f77058da277a6b7$export$6d44576f6b47c46b.prototype, "align", void 0);
$7f77058da277a6b7$var$__decorate([
    (0, $biDip.property)({
        type: Boolean
    })
], $7f77058da277a6b7$export$6d44576f6b47c46b.prototype, "disabled", void 0);
$7f77058da277a6b7$export$6d44576f6b47c46b = $7f77058da277a6b7$var$__decorate([
    (0, $ailZp.customElement)("wui-list-social")
], $7f77058da277a6b7$export$6d44576f6b47c46b);

});
parcelRegister("b0Sx5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8049feda07c1b031$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $8049feda07c1b031$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    justify-content: flex-start;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  wui-text {
    text-transform: capitalize;
  }

  wui-text[data-align='left'] {
    display: flex;
    flex: 1;
  }

  wui-text[data-align='center'] {
    display: flex;
    flex: 1;
    justify-content: center;
  }

  .invisible {
    opacity: 0;
    pointer-events: none;
  }

  button:disabled {
    background-color: var(--wui-color-gray-glass-015);
    color: var(--wui-color-gray-glass-015);
  }
`;

});


parcelRegister("kLh9C", function(module, exports) {

$parcel$export(module.exports, "WuiSelect", function () { return $f1d580e0905e13a1$export$1ff92e25bd10418b; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $F8s4l = parcelRequire("F8s4l");
parcelRequire("i6mxN");
parcelRequire("4BuLe");
parcelRequire("7XtWS");
var $f1d580e0905e13a1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f1d580e0905e13a1$export$1ff92e25bd10418b = class WuiSelect extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = "";
    }
    render() {
        return (0, $7pRM7.html)`<button>
      ${this.imageTemplate()}
      <wui-icon size="xs" color="fg-200" name="chevronBottom"></wui-icon>
    </button>`;
    }
    imageTemplate() {
        if (this.imageSrc) return (0, $7pRM7.html)`<wui-image src=${this.imageSrc} alt="select visual"></wui-image>`;
        return (0, $7pRM7.html)`<wui-icon-box
      size="xxs"
      iconColor="fg-200"
      backgroundColor="fg-100"
      background="opaque"
      icon="networkPlaceholder"
    ></wui-icon-box>`;
    }
};
$f1d580e0905e13a1$export$1ff92e25bd10418b.styles = [
    (0, $jVNMm.resetStyles),
    (0, $jVNMm.elementStyles),
    (0, $jVNMm.colorStyles),
    (0, $F8s4l.default)
];
$f1d580e0905e13a1$var$__decorate([
    (0, $biDip.property)()
], $f1d580e0905e13a1$export$1ff92e25bd10418b.prototype, "imageSrc", void 0);
$f1d580e0905e13a1$export$1ff92e25bd10418b = $f1d580e0905e13a1$var$__decorate([
    (0, $ailZp.customElement)("wui-select")
], $f1d580e0905e13a1$export$1ff92e25bd10418b);

});
parcelRegister("F8s4l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07ba62c9709485fb$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $07ba62c9709485fb$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  button {
    display: block;
    display: flex;
    align-items: center;
    padding: var(--wui-spacing-xxs);
    gap: var(--wui-spacing-xxs);
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-md);
    border-radius: var(--wui-border-radius-xxs);
  }

  wui-image {
    border-radius: 100%;
    width: var(--wui-spacing-xl);
    height: var(--wui-spacing-xl);
  }

  wui-icon-box {
    width: var(--wui-spacing-xl);
    height: var(--wui-spacing-xl);
  }

  button:hover {
    background-color: var(--wui-color-gray-glass-002);
  }

  button:active {
    background-color: var(--wui-color-gray-glass-005);
  }
`;

});


parcelRegister("2cj9p", function(module, exports) {

$parcel$export(module.exports, "WuiGrid", function () { return $199b8eb5d0c045f0$export$834debd63a0ca469; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");

var $jVNMm = parcelRequire("jVNMm");

var $fIDM4 = parcelRequire("fIDM4");

var $ailZp = parcelRequire("ailZp");

var $5bNZy = parcelRequire("5bNZy");
var $199b8eb5d0c045f0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $199b8eb5d0c045f0$export$834debd63a0ca469 = class WuiGrid extends (0, $cLW71.LitElement) {
    render() {
        this.style.cssText = `
      grid-template-rows: ${this.gridTemplateRows};
      grid-template-columns: ${this.gridTemplateColumns};
      justify-items: ${this.justifyItems};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      align-content: ${this.alignContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && (0, $fIDM4.UiHelperUtil).getSpacingStyles(this.margin, 3)};
    `;
        return (0, $7pRM7.html)`<slot></slot>`;
    }
};
$199b8eb5d0c045f0$export$834debd63a0ca469.styles = [
    (0, $jVNMm.resetStyles),
    (0, $5bNZy.default)
];
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "gridTemplateRows", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "gridTemplateColumns", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "justifyItems", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "alignItems", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "justifyContent", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "alignContent", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "columnGap", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "rowGap", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "gap", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "padding", void 0);
$199b8eb5d0c045f0$var$__decorate([
    (0, $biDip.property)()
], $199b8eb5d0c045f0$export$834debd63a0ca469.prototype, "margin", void 0);
$199b8eb5d0c045f0$export$834debd63a0ca469 = $199b8eb5d0c045f0$var$__decorate([
    (0, $ailZp.customElement)("wui-grid")
], $199b8eb5d0c045f0$export$834debd63a0ca469);

});
parcelRegister("5bNZy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c74c229aa4e5501$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $3c74c229aa4e5501$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    display: grid;
    width: inherit;
    height: inherit;
  }
`;

});


parcelRegister("lgpo8", function(module, exports) {

$parcel$export(module.exports, "WuiSeparator", function () { return $f7aec93237584491$export$987a8443516753c9; });
parcelRequire("4LT4u");
var $7pRM7 = parcelRequire("7pRM7");
var $cLW71 = parcelRequire("cLW71");
parcelRequire("kWsn3");
var $biDip = parcelRequire("biDip");
parcelRequire("fCaEm");

var $jVNMm = parcelRequire("jVNMm");

var $ailZp = parcelRequire("ailZp");

var $7uwOH = parcelRequire("7uwOH");
var $f7aec93237584491$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f7aec93237584491$export$987a8443516753c9 = class WuiSeparator extends (0, $cLW71.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
    }
    render() {
        return (0, $7pRM7.html)`${this.template()}`;
    }
    template() {
        if (this.text) return (0, $7pRM7.html)`<wui-text variant="small-500" color="fg-200">${this.text}</wui-text>`;
        return null;
    }
};
$f7aec93237584491$export$987a8443516753c9.styles = [
    (0, $jVNMm.resetStyles),
    (0, $7uwOH.default)
];
$f7aec93237584491$var$__decorate([
    (0, $biDip.property)()
], $f7aec93237584491$export$987a8443516753c9.prototype, "text", void 0);
$f7aec93237584491$export$987a8443516753c9 = $f7aec93237584491$var$__decorate([
    (0, $ailZp.customElement)("wui-separator")
], $f7aec93237584491$export$987a8443516753c9);

});
parcelRegister("7uwOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5744ca7d62501dee$export$2e2bcd8739ae039; });
parcelRequire("4LT4u");
var $a71q3 = parcelRequire("a71q3");
var $5744ca7d62501dee$export$2e2bcd8739ae039 = (0, $a71q3.css)`
  :host {
    position: relative;
    display: flex;
    width: 100%;
    height: 1px;
    background-color: var(--wui-color-gray-glass-005);
    justify-content: center;
    align-items: center;
  }

  :host > wui-text {
    position: absolute;
    padding: 0px 10px;
    background-color: var(--wui-color-modal-bg);
  }
`;

});


parcelRegister("iazuc", function(module, exports) {

$parcel$export(module.exports, "MathUtil", function () { return $d3a4aff5f2eac733$export$cdbe365d8c7d477d; });
const $d3a4aff5f2eac733$export$cdbe365d8c7d477d = {
    interpolate (inputRange, outputRange, value) {
        if (inputRange.length !== 2 || outputRange.length !== 2) throw new Error("inputRange and outputRange must be an array of length 2");
        const originalRangeMin = inputRange[0] || 0;
        const originalRangeMax = inputRange[1] || 0;
        const newRangeMin = outputRange[0] || 0;
        const newRangeMax = outputRange[1] || 0;
        if (value < originalRangeMin) return newRangeMin;
        if (value > originalRangeMax) return newRangeMax;
        return (newRangeMax - newRangeMin) / (originalRangeMax - originalRangeMin) * (value - originalRangeMin) + newRangeMin;
    }
};

});

parcelRegister("6emWt", function(module, exports) {

$parcel$export(module.exports, "TransactionUtil", function () { return $4895d8b3e877ee4f$export$445ed8d5992cc5e0; });
parcelRequire("ikDNi");
var $5kBvB = parcelRequire("5kBvB");

var $fIDM4 = parcelRequire("fIDM4");
const $4895d8b3e877ee4f$var$FLOAT_FIXED_VALUE = 3;
const $4895d8b3e877ee4f$var$plusTypes = [
    "receive",
    "deposit",
    "borrow",
    "claim"
];
const $4895d8b3e877ee4f$var$minusTypes = [
    "withdraw",
    "repay",
    "burn"
];
const $4895d8b3e877ee4f$export$445ed8d5992cc5e0 = {
    getMonthName (monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber);
        return date.toLocaleString("en-US", {
            month: "long"
        });
    },
    getTransactionGroupTitle (year, month) {
        const currentYear = (0, $5kBvB.DateUtil).getYear();
        const monthName = this.getMonthName(month);
        const isCurrentYear = year === currentYear;
        const groupTitle = isCurrentYear ? monthName : `${monthName} ${year}`;
        return groupTitle;
    },
    getTransactionImages (transfers) {
        const [transfer, secondTransfer] = transfers;
        const isAllNFT = Boolean(transfer) && transfers?.every((item)=>Boolean(item.nft_info));
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return [
            this.getTransactionImage(transfer),
            this.getTransactionImage(secondTransfer)
        ];
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransactionImage(item));
        return [
            this.getTransactionImage(transfer)
        ];
    },
    getTransactionImage (transfer) {
        return {
            type: $4895d8b3e877ee4f$export$445ed8d5992cc5e0.getTransactionTransferTokenType(transfer),
            url: $4895d8b3e877ee4f$export$445ed8d5992cc5e0.getTransactionImageURL(transfer)
        };
    },
    getTransactionImageURL (transfer) {
        let imageURL = undefined;
        const isNFT = Boolean(transfer?.nft_info);
        const isFungible = Boolean(transfer?.fungible_info);
        if (transfer && isNFT) imageURL = transfer?.nft_info?.content?.preview?.url;
        else if (transfer && isFungible) imageURL = transfer?.fungible_info?.icon?.url;
        return imageURL;
    },
    getTransactionTransferTokenType (transfer) {
        if (transfer?.fungible_info) return "FUNGIBLE";
        else if (transfer?.nft_info) return "NFT";
        return undefined;
    },
    getTransactionDescriptions (transaction) {
        const type = transaction?.metadata?.operationType;
        const transfers = transaction?.transfers;
        const haveTransfer = transaction?.transfers?.length > 0;
        const haveMultipleTransfers = transaction?.transfers?.length > 1;
        const isFungible = haveTransfer && transfers?.every((transfer)=>Boolean(transfer?.fungible_info));
        const [firstTransfer, secondTransfer] = transfers;
        let firstDescription = this.getTransferDescription(firstTransfer);
        let secondDescription = this.getTransferDescription(secondTransfer);
        if (!haveTransfer) {
            const isSendOrReceive = type === "send" || type === "receive";
            if (isSendOrReceive && isFungible) {
                firstDescription = (0, $fIDM4.UiHelperUtil).getTruncateString({
                    string: transaction?.metadata.sentFrom,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                secondDescription = (0, $fIDM4.UiHelperUtil).getTruncateString({
                    string: transaction?.metadata.sentTo,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                return [
                    firstDescription,
                    secondDescription
                ];
            }
            return [
                transaction.metadata.status
            ];
        }
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransferDescription(item));
        let prefix = "";
        if ($4895d8b3e877ee4f$var$plusTypes.includes(type)) prefix = "+";
        else if ($4895d8b3e877ee4f$var$minusTypes.includes(type)) prefix = "-";
        firstDescription = prefix.concat(firstDescription);
        return [
            firstDescription
        ];
    },
    getTransferDescription (transfer) {
        let description = "";
        if (!transfer) return description;
        if (transfer?.nft_info) description = transfer?.nft_info?.name || "-";
        else if (transfer?.fungible_info) description = this.getFungibleTransferDescription(transfer) || "-";
        return description;
    },
    getFungibleTransferDescription (transfer) {
        if (!transfer) return null;
        const quantity = this.getQuantityFixedValue(transfer?.quantity.numeric);
        const description = [
            quantity,
            transfer?.fungible_info?.symbol
        ].join(" ").trim();
        return description;
    },
    getQuantityFixedValue (value) {
        if (!value) return null;
        const parsedValue = parseFloat(value);
        return parsedValue.toFixed($4895d8b3e877ee4f$var$FLOAT_FIXED_VALUE);
    }
};

});


parcelRegister("XE6yD", function(module, exports) {


module.exports = (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("bdAau")).then(()=>parcelRequire("1yCWa"));

});
parcelRegister("4GIuy", function(module, exports) {
"use strict";

var $9seqW = parcelRequire("9seqW");
module.exports = $9seqW(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("9seqW", function(module, exports) {
"use strict";
var $6e21ecc8bcb30e78$var$cachedBundles = {};
var $6e21ecc8bcb30e78$var$cachedPreloads = {};
var $6e21ecc8bcb30e78$var$cachedPrefetches = {};
function $6e21ecc8bcb30e78$var$getCache(type) {
    switch(type){
        case "preload":
            return $6e21ecc8bcb30e78$var$cachedPreloads;
        case "prefetch":
            return $6e21ecc8bcb30e78$var$cachedPrefetches;
        default:
            return $6e21ecc8bcb30e78$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6e21ecc8bcb30e78$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("2qiOA", function(module, exports) {


module.exports = (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("1BPiH")).then(()=>parcelRequire("dnS6b"));

});

parcelRegister("6uVJz", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("7sblP")).css; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("aTf3K")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("g305D")).LitElement; });
parcelRequire("HuMWY");
parcelRequire("aTf3K");
parcelRequire("g305D");
parcelRequire("jjFax");

});
parcelRegister("HuMWY", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", function () { return $082be639ce71034b$export$7312b35fbf521afb; });
$parcel$export(module.exports, "notEqual", function () { return $082be639ce71034b$export$53a6892c50694894; });
$parcel$export(module.exports, "ReactiveElement", function () { return $082be639ce71034b$export$c7c07a37856565d; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("7sblP")).css; });

var $7sblP = parcelRequire("7sblP");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $082be639ce71034b$var$i, defineProperty: $082be639ce71034b$var$e, getOwnPropertyDescriptor: $082be639ce71034b$var$r, getOwnPropertyNames: $082be639ce71034b$var$h, getOwnPropertySymbols: $082be639ce71034b$var$o, getPrototypeOf: $082be639ce71034b$var$n } = Object, $082be639ce71034b$var$a = globalThis, $082be639ce71034b$var$c = $082be639ce71034b$var$a.trustedTypes, $082be639ce71034b$var$l = $082be639ce71034b$var$c ? $082be639ce71034b$var$c.emptyScript : "", $082be639ce71034b$var$p = $082be639ce71034b$var$a.reactiveElementPolyfillSupport, $082be639ce71034b$var$d = (t, s)=>t, $082be639ce71034b$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $082be639ce71034b$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $082be639ce71034b$export$53a6892c50694894 = (t, s)=>!$082be639ce71034b$var$i(t, s), $082be639ce71034b$var$y = {
    attribute: !0,
    type: String,
    converter: $082be639ce71034b$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $082be639ce71034b$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $082be639ce71034b$var$a.litPropertyMetadata ??= new WeakMap;
class $082be639ce71034b$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $082be639ce71034b$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $082be639ce71034b$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $082be639ce71034b$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $082be639ce71034b$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($082be639ce71034b$var$d("elementProperties"))) return;
        const t = $082be639ce71034b$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($082be639ce71034b$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($082be639ce71034b$var$d("properties"))) {
            const t = this.properties, s = [
                ...$082be639ce71034b$var$h(t),
                ...$082be639ce71034b$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $7sblP.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $7sblP.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $7sblP.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $082be639ce71034b$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $082be639ce71034b$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $082be639ce71034b$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$082be639ce71034b$export$c7c07a37856565d.elementStyles = [], $082be639ce71034b$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $082be639ce71034b$export$c7c07a37856565d[$082be639ce71034b$var$d("elementProperties")] = new Map, $082be639ce71034b$export$c7c07a37856565d[$082be639ce71034b$var$d("finalized")] = new Map, $082be639ce71034b$var$p?.({
    ReactiveElement: $082be639ce71034b$export$c7c07a37856565d
}), ($082be639ce71034b$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("7sblP", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $56d3f402d23088fd$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $56d3f402d23088fd$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $56d3f402d23088fd$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $56d3f402d23088fd$var$t = globalThis, $56d3f402d23088fd$export$b4d10f6001c083c2 = $56d3f402d23088fd$var$t.ShadowRoot && (void 0 === $56d3f402d23088fd$var$t.ShadyCSS || $56d3f402d23088fd$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $56d3f402d23088fd$var$s = Symbol(), $56d3f402d23088fd$var$o = new WeakMap;
class $56d3f402d23088fd$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $56d3f402d23088fd$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($56d3f402d23088fd$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $56d3f402d23088fd$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $56d3f402d23088fd$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $56d3f402d23088fd$export$8d80f9cac07cdb3 = (t)=>new $56d3f402d23088fd$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $56d3f402d23088fd$var$s), $56d3f402d23088fd$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $56d3f402d23088fd$export$505d1e8739bad805(o, t, $56d3f402d23088fd$var$s);
}, $56d3f402d23088fd$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($56d3f402d23088fd$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $56d3f402d23088fd$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $56d3f402d23088fd$export$ee69dfd951e24778 = $56d3f402d23088fd$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $56d3f402d23088fd$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("aTf3K", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $7edab8f2175c56f8$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "noChange", function () { return $7edab8f2175c56f8$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $7edab8f2175c56f8$export$45b790e32b2810ee; });
$parcel$export(module.exports, "_$LH", function () { return $7edab8f2175c56f8$export$8613d1ca9052b22e; });
$parcel$export(module.exports, "render", function () { return $7edab8f2175c56f8$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7edab8f2175c56f8$var$n = globalThis, $7edab8f2175c56f8$var$c = $7edab8f2175c56f8$var$n.trustedTypes, $7edab8f2175c56f8$var$h = $7edab8f2175c56f8$var$c ? $7edab8f2175c56f8$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $7edab8f2175c56f8$var$f = "$lit$", $7edab8f2175c56f8$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $7edab8f2175c56f8$var$m = "?" + $7edab8f2175c56f8$var$v, $7edab8f2175c56f8$var$_ = `<${$7edab8f2175c56f8$var$m}>`, $7edab8f2175c56f8$var$w = document, $7edab8f2175c56f8$var$lt = ()=>$7edab8f2175c56f8$var$w.createComment(""), $7edab8f2175c56f8$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $7edab8f2175c56f8$var$g = Array.isArray, $7edab8f2175c56f8$var$$ = (t)=>$7edab8f2175c56f8$var$g(t) || "function" == typeof t?.[Symbol.iterator], $7edab8f2175c56f8$var$x = "[ 	\n\f\r]", $7edab8f2175c56f8$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $7edab8f2175c56f8$var$E = /-->/g, $7edab8f2175c56f8$var$k = />/g, $7edab8f2175c56f8$var$O = RegExp(`>|${$7edab8f2175c56f8$var$x}(?:([^\\s"'>=/]+)(${$7edab8f2175c56f8$var$x}*=${$7edab8f2175c56f8$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $7edab8f2175c56f8$var$S = /'/g, $7edab8f2175c56f8$var$j = /"/g, $7edab8f2175c56f8$var$M = /^(?:script|style|textarea|title)$/i, $7edab8f2175c56f8$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $7edab8f2175c56f8$export$c0bb0b647f701bb5 = $7edab8f2175c56f8$var$P(1), $7edab8f2175c56f8$export$7ed1367e7fa1ad68 = $7edab8f2175c56f8$var$P(2), $7edab8f2175c56f8$export$47d5b44d225be5b4 = $7edab8f2175c56f8$var$P(3), $7edab8f2175c56f8$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $7edab8f2175c56f8$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $7edab8f2175c56f8$var$V = new WeakMap, $7edab8f2175c56f8$var$I = $7edab8f2175c56f8$var$w.createTreeWalker($7edab8f2175c56f8$var$w, 129);
function $7edab8f2175c56f8$var$N(t, i) {
    if (!$7edab8f2175c56f8$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $7edab8f2175c56f8$var$h ? $7edab8f2175c56f8$var$h.createHTML(i) : i;
}
const $7edab8f2175c56f8$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $7edab8f2175c56f8$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $7edab8f2175c56f8$var$T ? "!--" === l[1] ? n = $7edab8f2175c56f8$var$E : void 0 !== l[1] ? n = $7edab8f2175c56f8$var$k : void 0 !== l[2] ? ($7edab8f2175c56f8$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $7edab8f2175c56f8$var$O) : void 0 !== l[3] && (n = $7edab8f2175c56f8$var$O) : n === $7edab8f2175c56f8$var$O ? ">" === l[0] ? (n = h ?? $7edab8f2175c56f8$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $7edab8f2175c56f8$var$O : '"' === l[3] ? $7edab8f2175c56f8$var$j : $7edab8f2175c56f8$var$S) : n === $7edab8f2175c56f8$var$j || n === $7edab8f2175c56f8$var$S ? n = $7edab8f2175c56f8$var$O : n === $7edab8f2175c56f8$var$E || n === $7edab8f2175c56f8$var$k ? n = $7edab8f2175c56f8$var$T : (n = $7edab8f2175c56f8$var$O, h = void 0);
        const u = n === $7edab8f2175c56f8$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $7edab8f2175c56f8$var$T ? s + $7edab8f2175c56f8$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $7edab8f2175c56f8$var$f + s.slice(c) + $7edab8f2175c56f8$var$v + u) : s + $7edab8f2175c56f8$var$v + (-2 === c ? i : u);
    }
    return [
        $7edab8f2175c56f8$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $7edab8f2175c56f8$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $7edab8f2175c56f8$var$U(t, i);
        if (this.el = $7edab8f2175c56f8$var$B.createElement(l, s), $7edab8f2175c56f8$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $7edab8f2175c56f8$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($7edab8f2175c56f8$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($7edab8f2175c56f8$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $7edab8f2175c56f8$var$Y : "?" === n[1] ? $7edab8f2175c56f8$var$Z : "@" === n[1] ? $7edab8f2175c56f8$var$q : $7edab8f2175c56f8$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($7edab8f2175c56f8$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($7edab8f2175c56f8$var$M.test(e.tagName)) {
                    const t = e.textContent.split($7edab8f2175c56f8$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $7edab8f2175c56f8$var$c ? $7edab8f2175c56f8$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $7edab8f2175c56f8$var$lt()), $7edab8f2175c56f8$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $7edab8f2175c56f8$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $7edab8f2175c56f8$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($7edab8f2175c56f8$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $7edab8f2175c56f8$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $7edab8f2175c56f8$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $7edab8f2175c56f8$var$z(t, i, s = t, e) {
    if (i === $7edab8f2175c56f8$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $7edab8f2175c56f8$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $7edab8f2175c56f8$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $7edab8f2175c56f8$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $7edab8f2175c56f8$var$w).importNode(i, !0);
        $7edab8f2175c56f8$var$I.currentNode = e;
        let h = $7edab8f2175c56f8$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $7edab8f2175c56f8$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $7edab8f2175c56f8$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $7edab8f2175c56f8$var$I.nextNode(), o++);
        }
        return $7edab8f2175c56f8$var$I.currentNode = $7edab8f2175c56f8$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $7edab8f2175c56f8$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $7edab8f2175c56f8$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $7edab8f2175c56f8$var$z(this, t, i), $7edab8f2175c56f8$var$st(t) ? t === $7edab8f2175c56f8$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $7edab8f2175c56f8$export$45b790e32b2810ee && this._$AR(), this._$AH = $7edab8f2175c56f8$export$45b790e32b2810ee) : t !== this._$AH && t !== $7edab8f2175c56f8$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $7edab8f2175c56f8$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $7edab8f2175c56f8$export$45b790e32b2810ee && $7edab8f2175c56f8$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($7edab8f2175c56f8$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $7edab8f2175c56f8$var$B.createElement($7edab8f2175c56f8$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $7edab8f2175c56f8$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $7edab8f2175c56f8$var$V.get(t.strings);
        return void 0 === i && $7edab8f2175c56f8$var$V.set(t.strings, i = new $7edab8f2175c56f8$var$B(t)), i;
    }
    k(t) {
        $7edab8f2175c56f8$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $7edab8f2175c56f8$var$et(this.O($7edab8f2175c56f8$var$lt()), this.O($7edab8f2175c56f8$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $7edab8f2175c56f8$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $7edab8f2175c56f8$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $7edab8f2175c56f8$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $7edab8f2175c56f8$var$z(this, t, i, 0), o = !$7edab8f2175c56f8$var$st(t) || t !== this._$AH && t !== $7edab8f2175c56f8$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $7edab8f2175c56f8$var$z(this, e[s + n], i, n), r === $7edab8f2175c56f8$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$7edab8f2175c56f8$var$st(r) || r !== this._$AH[n], r === $7edab8f2175c56f8$export$45b790e32b2810ee ? t = $7edab8f2175c56f8$export$45b790e32b2810ee : t !== $7edab8f2175c56f8$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $7edab8f2175c56f8$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $7edab8f2175c56f8$var$Y extends $7edab8f2175c56f8$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $7edab8f2175c56f8$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $7edab8f2175c56f8$var$Z extends $7edab8f2175c56f8$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $7edab8f2175c56f8$export$45b790e32b2810ee);
    }
}
class $7edab8f2175c56f8$var$q extends $7edab8f2175c56f8$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $7edab8f2175c56f8$var$z(this, t, i, 0) ?? $7edab8f2175c56f8$export$45b790e32b2810ee) === $7edab8f2175c56f8$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $7edab8f2175c56f8$export$45b790e32b2810ee && s !== $7edab8f2175c56f8$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $7edab8f2175c56f8$export$45b790e32b2810ee && (s === $7edab8f2175c56f8$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $7edab8f2175c56f8$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $7edab8f2175c56f8$var$z(this, t);
    }
}
const $7edab8f2175c56f8$export$8613d1ca9052b22e = {
    M: $7edab8f2175c56f8$var$f,
    P: $7edab8f2175c56f8$var$v,
    A: $7edab8f2175c56f8$var$m,
    C: 1,
    L: $7edab8f2175c56f8$var$U,
    R: $7edab8f2175c56f8$var$F,
    D: $7edab8f2175c56f8$var$$,
    V: $7edab8f2175c56f8$var$z,
    I: $7edab8f2175c56f8$var$et,
    H: $7edab8f2175c56f8$var$G,
    N: $7edab8f2175c56f8$var$Z,
    U: $7edab8f2175c56f8$var$q,
    B: $7edab8f2175c56f8$var$Y,
    F: $7edab8f2175c56f8$var$K
}, $7edab8f2175c56f8$var$Re = $7edab8f2175c56f8$var$n.litHtmlPolyfillSupport;
$7edab8f2175c56f8$var$Re?.($7edab8f2175c56f8$var$B, $7edab8f2175c56f8$var$et), ($7edab8f2175c56f8$var$n.litHtmlVersions ??= []).push("3.2.0");
const $7edab8f2175c56f8$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $7edab8f2175c56f8$var$et(i.insertBefore($7edab8f2175c56f8$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("g305D", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("7sblP")).css; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("HuMWY")).ReactiveElement; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("aTf3K")).html; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("aTf3K")).noChange; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("aTf3K")).render; });

$parcel$export(module.exports, "LitElement", function () { return $baecff0472722170$export$3f2f9f5909897157; });

var $HuMWY = parcelRequire("HuMWY");

var $aTf3K = parcelRequire("aTf3K");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $baecff0472722170$export$3f2f9f5909897157 extends (0, $HuMWY.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $aTf3K.render)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $aTf3K.noChange;
    }
}
$baecff0472722170$export$3f2f9f5909897157._$litElement$ = !0, $baecff0472722170$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $baecff0472722170$export$3f2f9f5909897157
});
const $baecff0472722170$var$f = globalThis.litElementPolyfillSupport;
$baecff0472722170$var$f?.({
    LitElement: $baecff0472722170$export$3f2f9f5909897157
});
const $baecff0472722170$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");

});

parcelRegister("jjFax", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e0ffb9fc55d9a80b$export$6acf61af03e62db = !1;

});


parcelRegister("2HtFW", function(module, exports) {
$parcel$export(module.exports, "property", function () { return (parcelRequire("jJP2r")).property; });
$parcel$export(module.exports, "state", function () { return (parcelRequire("faUle")).state; });
parcelRequire("8pS0H");
parcelRequire("jJP2r");
parcelRequire("faUle");
parcelRequire("4Z3gM");
parcelRequire("j0Q46");
parcelRequire("g866e");
parcelRequire("f2vyp");
parcelRequire("crxzT");
parcelRequire("jsL3R");

});
parcelRegister("8pS0H", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $620a8dd6b9bbfe5c$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("jJP2r", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $e5e9cf76cc04f4a3$export$d541bacb2bda4494; });

var $HuMWY = parcelRequire("HuMWY");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5e9cf76cc04f4a3$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $HuMWY.defaultConverter),
    reflect: !1,
    hasChanged: (0, $HuMWY.notEqual)
}, $e5e9cf76cc04f4a3$export$8d623b1670eb40f4 = (t = $e5e9cf76cc04f4a3$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $e5e9cf76cc04f4a3$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $e5e9cf76cc04f4a3$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("faUle", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $b0c37e707ac2def9$export$ca000e230c0caa3e; });

var $jJP2r = parcelRequire("jJP2r");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $b0c37e707ac2def9$export$ca000e230c0caa3e(r) {
    return (0, $jJP2r.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("4Z3gM", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3a0f6539571dd80c$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("j0Q46", function(module, exports) {

var $9yCHe = parcelRequire("9yCHe");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $dd766771db08b452$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $9yCHe.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $9yCHe.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("9yCHe", function(module, exports) {

$parcel$export(module.exports, "desc", function () { return $6f554e50c190456a$export$51987bb50e1f6752; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6f554e50c190456a$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("g866e", function(module, exports) {

var $9yCHe = parcelRequire("9yCHe");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $bbe21fe8e557c25f$var$e;
function $bbe21fe8e557c25f$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $9yCHe.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($bbe21fe8e557c25f$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("f2vyp", function(module, exports) {

var $9yCHe = parcelRequire("9yCHe");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $af2f84de7f63eb47$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $9yCHe.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("crxzT", function(module, exports) {

var $9yCHe = parcelRequire("9yCHe");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $90f20d81e2af639f$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $9yCHe.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("jsL3R", function(module, exports) {

var $9yCHe = parcelRequire("9yCHe");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e2b5233fe6038d4e$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $9yCHe.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("43P4H", function(module, exports) {

$parcel$export(module.exports, "OPTIONAL_METHODS", function () { return $2f4f0f9a6698a38f$export$bc85197675500780; });
$parcel$export(module.exports, "EthereumProvider", function () { return $2f4f0f9a6698a38f$export$cdfbbad9b2980226; });

var $jMGWz = parcelRequire("jMGWz");

var $iN1TF = parcelRequire("iN1TF");

var $9nUAO = parcelRequire("9nUAO");
const $2f4f0f9a6698a38f$var$R = "wc", $2f4f0f9a6698a38f$var$T = "ethereum_provider", $2f4f0f9a6698a38f$var$$ = `${$2f4f0f9a6698a38f$var$R}@2:${$2f4f0f9a6698a38f$var$T}:`, $2f4f0f9a6698a38f$var$j = "https://rpc.walletconnect.com/v1/", $2f4f0f9a6698a38f$export$cfec112b6d27bf = [
    "eth_sendTransaction",
    "personal_sign"
], $2f4f0f9a6698a38f$export$bc85197675500780 = [
    "eth_accounts",
    "eth_requestAccounts",
    "eth_sendRawTransaction",
    "eth_sign",
    "eth_signTransaction",
    "eth_signTypedData",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "personal_sign",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode",
    "wallet_sendCalls",
    "wallet_getCapabilities",
    "wallet_getCallsStatus",
    "wallet_showCallsStatus"
], $2f4f0f9a6698a38f$export$2c607e5ce12221af = [
    "chainChanged",
    "accountsChanged"
], $2f4f0f9a6698a38f$export$1d352f96d67d51e6 = [
    "chainChanged",
    "accountsChanged",
    "message",
    "disconnect",
    "connect"
];
var $2f4f0f9a6698a38f$var$q = Object.defineProperty, $2f4f0f9a6698a38f$var$N = Object.defineProperties, $2f4f0f9a6698a38f$var$D = Object.getOwnPropertyDescriptors, $2f4f0f9a6698a38f$var$M = Object.getOwnPropertySymbols, $2f4f0f9a6698a38f$var$U = Object.prototype.hasOwnProperty, $2f4f0f9a6698a38f$var$Q = Object.prototype.propertyIsEnumerable, $2f4f0f9a6698a38f$var$O = (a, t, s)=>t in a ? $2f4f0f9a6698a38f$var$q(a, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : a[t] = s, $2f4f0f9a6698a38f$var$p = (a, t)=>{
    for(var s in t || (t = {}))$2f4f0f9a6698a38f$var$U.call(t, s) && $2f4f0f9a6698a38f$var$O(a, s, t[s]);
    if ($2f4f0f9a6698a38f$var$M) for (var s of $2f4f0f9a6698a38f$var$M(t))$2f4f0f9a6698a38f$var$Q.call(t, s) && $2f4f0f9a6698a38f$var$O(a, s, t[s]);
    return a;
}, $2f4f0f9a6698a38f$var$E = (a, t)=>$2f4f0f9a6698a38f$var$N(a, $2f4f0f9a6698a38f$var$D(t));
function $2f4f0f9a6698a38f$var$m(a) {
    return Number(a[0].split(":")[1]);
}
function $2f4f0f9a6698a38f$var$v(a) {
    return `0x${a.toString(16)}`;
}
function $2f4f0f9a6698a38f$var$L(a) {
    const { chains: t, optionalChains: s, methods: i, optionalMethods: e, events: n, optionalEvents: o, rpcMap: r } = a;
    if (!(0, $iN1TF.isValidArray)(t)) throw new Error("Invalid chains");
    const c = {
        chains: t,
        methods: i || $2f4f0f9a6698a38f$export$cfec112b6d27bf,
        events: n || $2f4f0f9a6698a38f$export$2c607e5ce12221af,
        rpcMap: $2f4f0f9a6698a38f$var$p({}, t.length ? {
            [$2f4f0f9a6698a38f$var$m(t)]: r[$2f4f0f9a6698a38f$var$m(t)]
        } : {})
    }, h = n?.filter((l)=>!$2f4f0f9a6698a38f$export$2c607e5ce12221af.includes(l)), d = i?.filter((l)=>!$2f4f0f9a6698a38f$export$cfec112b6d27bf.includes(l));
    if (!s && !o && !e && !(h != null && h.length) && !(d != null && d.length)) return {
        required: t.length ? c : void 0
    };
    const w = h?.length && d?.length || !s, I = {
        chains: [
            ...new Set(w ? c.chains.concat(s || []) : s)
        ],
        methods: [
            ...new Set(c.methods.concat(e != null && e.length ? e : $2f4f0f9a6698a38f$export$bc85197675500780))
        ],
        events: [
            ...new Set(c.events.concat(o != null && o.length ? o : $2f4f0f9a6698a38f$export$1d352f96d67d51e6))
        ],
        rpcMap: r
    };
    return {
        required: t.length ? c : void 0,
        optional: s.length ? I : void 0
    };
}

class $2f4f0f9a6698a38f$export$2e2bcd8739ae039 {
    constructor(){
        this.events = new (0, $jMGWz.EventEmitter), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = $2f4f0f9a6698a38f$var$$, this.on = (t, s)=>(this.events.on(t, s), this), this.once = (t, s)=>(this.events.once(t, s), this), this.removeListener = (t, s)=>(this.events.removeListener(t, s), this), this.off = (t, s)=>(this.events.off(t, s), this), this.parseAccount = (t)=>this.isCompatibleChainId(t) ? this.parseAccountId(t).address : t, this.signer = {}, this.rpc = {};
    }
    static async init(t) {
        const s = new $2f4f0f9a6698a38f$export$2e2bcd8739ae039;
        return await s.initialize(t), s;
    }
    async request(t, s) {
        return await this.signer.request(t, this.formatChainId(this.chainId), s);
    }
    sendAsync(t, s, i) {
        this.signer.sendAsync(t, s, this.formatChainId(this.chainId), i);
    }
    get connected() {
        return this.signer.client ? this.signer.client.core.relayer.connected : !1;
    }
    get connecting() {
        return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
    }
    async enable() {
        return this.session || await this.connect(), await this.request({
            method: "eth_requestAccounts"
        });
    }
    async connect(t) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts(t);
        const { required: s, optional: i } = $2f4f0f9a6698a38f$var$L(this.rpc);
        try {
            const e = await new Promise(async (o, r)=>{
                var c;
                this.rpc.showQrModal && ((c = this.modal) == null || c.subscribeModal((h)=>{
                    !h.open && !this.signer.session && (this.signer.abortPairingAttempt(), r(new Error("Connection request reset. Please try again.")));
                })), await this.signer.connect($2f4f0f9a6698a38f$var$E($2f4f0f9a6698a38f$var$p({
                    namespaces: $2f4f0f9a6698a38f$var$p({}, s && {
                        [this.namespace]: s
                    })
                }, i && {
                    optionalNamespaces: {
                        [this.namespace]: i
                    }
                }), {
                    pairingTopic: t?.pairingTopic
                })).then((h)=>{
                    o(h);
                }).catch((h)=>{
                    r(new Error(h.message));
                });
            });
            if (!e) return;
            const n = (0, $iN1TF.getAccountsFromNamespaces)(e.namespaces, [
                this.namespace
            ]);
            this.setChainIds(this.rpc.chains.length ? this.rpc.chains : n), this.setAccounts(n), this.events.emit("connect", {
                chainId: $2f4f0f9a6698a38f$var$v(this.chainId)
            });
        } catch (e) {
            throw this.signer.logger.error(e), e;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async authenticate(t) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts({
            chains: t?.chains
        });
        try {
            const s = await new Promise(async (e, n)=>{
                var o;
                this.rpc.showQrModal && ((o = this.modal) == null || o.subscribeModal((r)=>{
                    !r.open && !this.signer.session && (this.signer.abortPairingAttempt(), n(new Error("Connection request reset. Please try again.")));
                })), await this.signer.authenticate($2f4f0f9a6698a38f$var$E($2f4f0f9a6698a38f$var$p({}, t), {
                    chains: this.rpc.chains
                })).then((r)=>{
                    e(r);
                }).catch((r)=>{
                    n(new Error(r.message));
                });
            }), i = s.session;
            if (i) {
                const e = (0, $iN1TF.getAccountsFromNamespaces)(i.namespaces, [
                    this.namespace
                ]);
                this.setChainIds(this.rpc.chains.length ? this.rpc.chains : e), this.setAccounts(e), this.events.emit("connect", {
                    chainId: $2f4f0f9a6698a38f$var$v(this.chainId)
                });
            }
            return s;
        } catch (s) {
            throw this.signer.logger.error(s), s;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async disconnect() {
        this.session && await this.signer.disconnect(), this.reset();
    }
    get isWalletConnect() {
        return !0;
    }
    get session() {
        return this.signer.session;
    }
    registerEventListeners() {
        this.signer.on("session_event", (t)=>{
            const { params: s } = t, { event: i } = s;
            i.name === "accountsChanged" ? (this.accounts = this.parseAccounts(i.data), this.events.emit("accountsChanged", this.accounts)) : i.name === "chainChanged" ? this.setChainId(this.formatChainId(i.data)) : this.events.emit(i.name, i.data), this.events.emit("session_event", t);
        }), this.signer.on("chainChanged", (t)=>{
            const s = parseInt(t);
            this.chainId = s, this.events.emit("chainChanged", $2f4f0f9a6698a38f$var$v(this.chainId)), this.persist();
        }), this.signer.on("session_update", (t)=>{
            this.events.emit("session_update", t);
        }), this.signer.on("session_delete", (t)=>{
            this.reset(), this.events.emit("session_delete", t), this.events.emit("disconnect", $2f4f0f9a6698a38f$var$E($2f4f0f9a6698a38f$var$p({}, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")), {
                data: t.topic,
                name: "USER_DISCONNECTED"
            }));
        }), this.signer.on("display_uri", (t)=>{
            var s, i;
            this.rpc.showQrModal && ((s = this.modal) == null || s.closeModal(), (i = this.modal) == null || i.openModal({
                uri: t
            })), this.events.emit("display_uri", t);
        });
    }
    switchEthereumChain(t) {
        this.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: t.toString(16)
                }
            ]
        });
    }
    isCompatibleChainId(t) {
        return typeof t == "string" ? t.startsWith(`${this.namespace}:`) : !1;
    }
    formatChainId(t) {
        return `${this.namespace}:${t}`;
    }
    parseChainId(t) {
        return Number(t.split(":")[1]);
    }
    setChainIds(t) {
        const s = t.filter((i)=>this.isCompatibleChainId(i)).map((i)=>this.parseChainId(i));
        s.length && (this.chainId = s[0], this.events.emit("chainChanged", $2f4f0f9a6698a38f$var$v(this.chainId)), this.persist());
    }
    setChainId(t) {
        if (this.isCompatibleChainId(t)) {
            const s = this.parseChainId(t);
            this.chainId = s, this.switchEthereumChain(s);
        }
    }
    parseAccountId(t) {
        const [s, i, e] = t.split(":");
        return {
            chainId: `${s}:${i}`,
            address: e
        };
    }
    setAccounts(t) {
        this.accounts = t.filter((s)=>this.parseChainId(this.parseAccountId(s).chainId) === this.chainId).map((s)=>this.parseAccountId(s).address), this.events.emit("accountsChanged", this.accounts);
    }
    getRpcConfig(t) {
        var s, i;
        const e = (s = t?.chains) != null ? s : [], n = (i = t?.optionalChains) != null ? i : [], o = e.concat(n);
        if (!o.length) throw new Error("No chains specified in either `chains` or `optionalChains`");
        const r = e.length ? t?.methods || $2f4f0f9a6698a38f$export$cfec112b6d27bf : [], c = e.length ? t?.events || $2f4f0f9a6698a38f$export$2c607e5ce12221af : [], h = t?.optionalMethods || [], d = t?.optionalEvents || [], w = t?.rpcMap || this.buildRpcMap(o, t.projectId), I = t?.qrModalOptions || void 0;
        return {
            chains: e?.map((l)=>this.formatChainId(l)),
            optionalChains: n.map((l)=>this.formatChainId(l)),
            methods: r,
            events: c,
            optionalMethods: h,
            optionalEvents: d,
            rpcMap: w,
            showQrModal: !!(t != null && t.showQrModal),
            qrModalOptions: I,
            projectId: t.projectId,
            metadata: t.metadata
        };
    }
    buildRpcMap(t, s) {
        const i = {};
        return t.forEach((e)=>{
            i[e] = this.getRpcUrl(e, s);
        }), i;
    }
    async initialize(t) {
        if (this.rpc = this.getRpcConfig(t), this.chainId = this.rpc.chains.length ? $2f4f0f9a6698a38f$var$m(this.rpc.chains) : $2f4f0f9a6698a38f$var$m(this.rpc.optionalChains), this.signer = await (0, $9nUAO.UniversalProvider).init({
            projectId: this.rpc.projectId,
            metadata: this.rpc.metadata,
            disableProviderPing: t.disableProviderPing,
            relayUrl: t.relayUrl,
            storageOptions: t.storageOptions,
            customStoragePrefix: t.customStoragePrefix,
            telemetryEnabled: t.telemetryEnabled
        }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
            let s;
            try {
                const { WalletConnectModal: i } = await (parcelRequire("dK4kP"));
                s = i;
            } catch  {
                throw new Error("To use QR modal, please install @walletconnect/modal package");
            }
            if (s) try {
                this.modal = new s($2f4f0f9a6698a38f$var$p({
                    projectId: this.rpc.projectId
                }, this.rpc.qrModalOptions));
            } catch (i) {
                throw this.signer.logger.error(i), new Error("Could not generate WalletConnectModal Instance");
            }
        }
    }
    loadConnectOpts(t) {
        if (!t) return;
        const { chains: s, optionalChains: i, rpcMap: e } = t;
        s && (0, $iN1TF.isValidArray)(s) && (this.rpc.chains = s.map((n)=>this.formatChainId(n)), s.forEach((n)=>{
            this.rpc.rpcMap[n] = e?.[n] || this.getRpcUrl(n);
        })), i && (0, $iN1TF.isValidArray)(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i?.map((n)=>this.formatChainId(n)), i.forEach((n)=>{
            this.rpc.rpcMap[n] = e?.[n] || this.getRpcUrl(n);
        }));
    }
    getRpcUrl(t, s) {
        var i;
        return ((i = this.rpc.rpcMap) == null ? void 0 : i[t]) || `${$2f4f0f9a6698a38f$var$j}?chainId=eip155:${t}&projectId=${s || this.rpc.projectId}`;
    }
    async loadPersistedSession() {
        if (this.session) try {
            const t = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), s = this.session.namespaces[`${this.namespace}:${t}`] ? this.session.namespaces[`${this.namespace}:${t}`] : this.session.namespaces[this.namespace];
            this.setChainIds(t ? [
                this.formatChainId(t)
            ] : s?.accounts), this.setAccounts(s?.accounts);
        } catch (t) {
            this.signer.logger.error("Failed to load persisted session, clearing state..."), this.signer.logger.error(t), await this.disconnect().catch((s)=>this.signer.logger.warn(s));
        }
    }
    reset() {
        this.chainId = 1, this.accounts = [];
    }
    persist() {
        this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
    }
    parseAccounts(t) {
        return typeof t == "string" || t instanceof String ? [
            this.parseAccount(t)
        ] : t.map((s)=>this.parseAccount(s));
    }
}
const $2f4f0f9a6698a38f$export$cdfbbad9b2980226 = $2f4f0f9a6698a38f$export$2e2bcd8739ae039;

});
parcelRegister("jMGWz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $e673cfb7e096dac0$var$R = typeof Reflect === "object" ? Reflect : null;
var $e673cfb7e096dac0$var$ReflectApply = $e673cfb7e096dac0$var$R && typeof $e673cfb7e096dac0$var$R.apply === "function" ? $e673cfb7e096dac0$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e673cfb7e096dac0$var$ReflectOwnKeys;
if ($e673cfb7e096dac0$var$R && typeof $e673cfb7e096dac0$var$R.ownKeys === "function") $e673cfb7e096dac0$var$ReflectOwnKeys = $e673cfb7e096dac0$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e673cfb7e096dac0$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e673cfb7e096dac0$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e673cfb7e096dac0$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e673cfb7e096dac0$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e673cfb7e096dac0$var$EventEmitter() {
    $e673cfb7e096dac0$var$EventEmitter.init.call(this);
}
module.exports = $e673cfb7e096dac0$var$EventEmitter;
module.exports.once = $e673cfb7e096dac0$var$once;
// Backwards-compat with node 0.10.x
$e673cfb7e096dac0$var$EventEmitter.EventEmitter = $e673cfb7e096dac0$var$EventEmitter;
$e673cfb7e096dac0$var$EventEmitter.prototype._events = undefined;
$e673cfb7e096dac0$var$EventEmitter.prototype._eventsCount = 0;
$e673cfb7e096dac0$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e673cfb7e096dac0$var$defaultMaxListeners = 10;
function $e673cfb7e096dac0$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e673cfb7e096dac0$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $e673cfb7e096dac0$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $e673cfb7e096dac0$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $e673cfb7e096dac0$var$defaultMaxListeners = arg;
    }
});
$e673cfb7e096dac0$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e673cfb7e096dac0$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $e673cfb7e096dac0$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $e673cfb7e096dac0$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e673cfb7e096dac0$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e673cfb7e096dac0$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e673cfb7e096dac0$var$_getMaxListeners(this);
};
$e673cfb7e096dac0$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $e673cfb7e096dac0$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e673cfb7e096dac0$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e673cfb7e096dac0$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e673cfb7e096dac0$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e673cfb7e096dac0$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e673cfb7e096dac0$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e673cfb7e096dac0$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e673cfb7e096dac0$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e673cfb7e096dac0$var$_addListener(this, type, listener, false);
};
$e673cfb7e096dac0$var$EventEmitter.prototype.on = $e673cfb7e096dac0$var$EventEmitter.prototype.addListener;
$e673cfb7e096dac0$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e673cfb7e096dac0$var$_addListener(this, type, listener, true);
};
function $e673cfb7e096dac0$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e673cfb7e096dac0$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e673cfb7e096dac0$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e673cfb7e096dac0$var$EventEmitter.prototype.once = function once(type, listener) {
    $e673cfb7e096dac0$var$checkListener(listener);
    this.on(type, $e673cfb7e096dac0$var$_onceWrap(this, type, listener));
    return this;
};
$e673cfb7e096dac0$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e673cfb7e096dac0$var$checkListener(listener);
    this.prependListener(type, $e673cfb7e096dac0$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e673cfb7e096dac0$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e673cfb7e096dac0$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e673cfb7e096dac0$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$e673cfb7e096dac0$var$EventEmitter.prototype.off = $e673cfb7e096dac0$var$EventEmitter.prototype.removeListener;
$e673cfb7e096dac0$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e673cfb7e096dac0$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e673cfb7e096dac0$var$unwrapListeners(evlistener) : $e673cfb7e096dac0$var$arrayClone(evlistener, evlistener.length);
}
$e673cfb7e096dac0$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e673cfb7e096dac0$var$_listeners(this, type, true);
};
$e673cfb7e096dac0$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e673cfb7e096dac0$var$_listeners(this, type, false);
};
$e673cfb7e096dac0$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $e673cfb7e096dac0$var$listenerCount.call(emitter, type);
};
$e673cfb7e096dac0$var$EventEmitter.prototype.listenerCount = $e673cfb7e096dac0$var$listenerCount;
function $e673cfb7e096dac0$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e673cfb7e096dac0$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e673cfb7e096dac0$var$ReflectOwnKeys(this._events) : [];
};
function $e673cfb7e096dac0$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e673cfb7e096dac0$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e673cfb7e096dac0$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e673cfb7e096dac0$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $e673cfb7e096dac0$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $e673cfb7e096dac0$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e673cfb7e096dac0$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $e673cfb7e096dac0$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $e673cfb7e096dac0$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("iN1TF", function(module, exports) {

$parcel$export(module.exports, "parseChainId", function () { return $dade464b59c7f664$export$4764229d78de4437; });
$parcel$export(module.exports, "getAccountsFromNamespaces", function () { return $dade464b59c7f664$export$23329703ad972840; });
$parcel$export(module.exports, "isNode", function () { return $dade464b59c7f664$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "isBrowser", function () { return $dade464b59c7f664$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "getBundleId", function () { return $dade464b59c7f664$export$40a40f90174d197c; });
$parcel$export(module.exports, "getAppMetadata", function () { return $dade464b59c7f664$export$ba31e015127122bb; });
$parcel$export(module.exports, "formatRelayRpcUrl", function () { return $dade464b59c7f664$export$d875b3963ef774f5; });
$parcel$export(module.exports, "mapToObj", function () { return $dade464b59c7f664$export$c4b8dfeb6e237eb9; });
$parcel$export(module.exports, "objToMap", function () { return $dade464b59c7f664$export$ac31b37c726bc3ba; });
$parcel$export(module.exports, "createDelayedPromise", function () { return $dade464b59c7f664$export$cbf9e3cc9ffc85cb; });
$parcel$export(module.exports, "createExpiringPromise", function () { return $dade464b59c7f664$export$3da2293b007ed708; });
$parcel$export(module.exports, "formatTopicTarget", function () { return $dade464b59c7f664$export$43ab92477f8713b9; });
$parcel$export(module.exports, "formatIdTarget", function () { return $dade464b59c7f664$export$bd13103c2e5cc0c3; });
$parcel$export(module.exports, "parseExpirerTarget", function () { return $dade464b59c7f664$export$93adeb0f16e8e51d; });
$parcel$export(module.exports, "calcExpiry", function () { return $dade464b59c7f664$export$b136d03015bfc12; });
$parcel$export(module.exports, "isExpired", function () { return $dade464b59c7f664$export$57947cfd429801a2; });
$parcel$export(module.exports, "engineEvent", function () { return $dade464b59c7f664$export$e3eb27ce66c0f6d9; });
$parcel$export(module.exports, "mergeArrays", function () { return $dade464b59c7f664$export$9826fe7ad3921016; });
$parcel$export(module.exports, "handleDeeplinkRedirect", function () { return $dade464b59c7f664$export$694a208c8abca99a; });
$parcel$export(module.exports, "getDeepLink", function () { return $dade464b59c7f664$export$e55bfdac47149a32; });
$parcel$export(module.exports, "uuidv4", function () { return $dade464b59c7f664$export$abe4376e1bf796d6; });
$parcel$export(module.exports, "getNamespacedDidChainId", function () { return $dade464b59c7f664$export$a8b149927aef7051; });
$parcel$export(module.exports, "getDidAddress", function () { return $dade464b59c7f664$export$bf43cfbb4bd95de9; });
$parcel$export(module.exports, "validateSignedCacao", function () { return $dade464b59c7f664$export$b7d566fce8e2b970; });
$parcel$export(module.exports, "formatMessage", function () { return $dade464b59c7f664$export$25868d1e8e76735f; });
$parcel$export(module.exports, "getRecapFromResources", function () { return $dade464b59c7f664$export$3bb18ae0fb9a9fa9; });
$parcel$export(module.exports, "createEncodedRecap", function () { return $dade464b59c7f664$export$2bc35d2a08a09ad5; });
$parcel$export(module.exports, "mergeEncodedRecaps", function () { return $dade464b59c7f664$export$c7a40c552af428b5; });
$parcel$export(module.exports, "getMethodsFromRecap", function () { return $dade464b59c7f664$export$d6c6a43d36418efe; });
$parcel$export(module.exports, "getChainsFromRecap", function () { return $dade464b59c7f664$export$372f88051a611988; });
$parcel$export(module.exports, "BASE16", function () { return $dade464b59c7f664$export$49eb910ab2518105; });
$parcel$export(module.exports, "TYPE_1", function () { return $dade464b59c7f664$export$406e97c329f0f3d4; });
$parcel$export(module.exports, "generateKeyPair", function () { return $dade464b59c7f664$export$a949d36eab55b41f; });
$parcel$export(module.exports, "generateRandomBytes32", function () { return $dade464b59c7f664$export$d15a28e4f1821243; });
$parcel$export(module.exports, "deriveSymKey", function () { return $dade464b59c7f664$export$f8378f68e053f5c6; });
$parcel$export(module.exports, "hashKey", function () { return $dade464b59c7f664$export$1e87d19d4aab5805; });
$parcel$export(module.exports, "hashMessage", function () { return $dade464b59c7f664$export$d4c241cec96564c1; });
$parcel$export(module.exports, "decodeTypeByte", function () { return $dade464b59c7f664$export$7547a514ee29b9d4; });
$parcel$export(module.exports, "encrypt", function () { return $dade464b59c7f664$export$5b0f6292f11d1d18; });
$parcel$export(module.exports, "decrypt", function () { return $dade464b59c7f664$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "deserialize", function () { return $dade464b59c7f664$export$efcd34ab6248d3cd; });
$parcel$export(module.exports, "validateDecoding", function () { return $dade464b59c7f664$export$177f3e316562333d; });
$parcel$export(module.exports, "validateEncoding", function () { return $dade464b59c7f664$export$7949f60f2444aef2; });
$parcel$export(module.exports, "isTypeOneEnvelope", function () { return $dade464b59c7f664$export$8c165704db2d5c15; });
$parcel$export(module.exports, "verifyP256Jwt", function () { return $dade464b59c7f664$export$f65520390041ee33; });
$parcel$export(module.exports, "getRelayProtocolName", function () { return $dade464b59c7f664$export$cf77af25151525db; });
$parcel$export(module.exports, "getRelayProtocolApi", function () { return $dade464b59c7f664$export$604e3deb95e1b734; });
$parcel$export(module.exports, "parseUri", function () { return $dade464b59c7f664$export$59f58847421cfb28; });
$parcel$export(module.exports, "formatUri", function () { return $dade464b59c7f664$export$b2786ede34fb2350; });
$parcel$export(module.exports, "isValidNamespaces", function () { return $dade464b59c7f664$export$93f7b81dc815a714; });
$parcel$export(module.exports, "isConformingNamespaces", function () { return $dade464b59c7f664$export$ba5b0a4b585cd1b4; });
$parcel$export(module.exports, "isCaipNamespace", function () { return $dade464b59c7f664$export$e03e993df4723bde; });
$parcel$export(module.exports, "parseNamespaceKey", function () { return $dade464b59c7f664$export$dd404c96fbbb1ff8; });
$parcel$export(module.exports, "isValidObject", function () { return $dade464b59c7f664$export$16a0268bc22b47b0; });
$parcel$export(module.exports, "buildNamespacesFromAuth", function () { return $dade464b59c7f664$export$b5744b1c39447540; });
$parcel$export(module.exports, "getInternalError", function () { return $dade464b59c7f664$export$500d4c4a8fafe35; });
$parcel$export(module.exports, "getSdkError", function () { return $dade464b59c7f664$export$8203ef1531c8b5b5; });
$parcel$export(module.exports, "isValidArray", function () { return $dade464b59c7f664$export$41dd3d480aac4a71; });
$parcel$export(module.exports, "isUndefined", function () { return $dade464b59c7f664$export$fce6876652108ab; });
$parcel$export(module.exports, "isValidString", function () { return $dade464b59c7f664$export$ee898ca48ab56c74; });
$parcel$export(module.exports, "isSessionCompatible", function () { return $dade464b59c7f664$export$6fc4971bf8f326a; });
$parcel$export(module.exports, "isValidUrl", function () { return $dade464b59c7f664$export$bef94a5618bf18bf; });
$parcel$export(module.exports, "isProposalStruct", function () { return $dade464b59c7f664$export$f657f7976bb2769d; });
$parcel$export(module.exports, "isSessionStruct", function () { return $dade464b59c7f664$export$c96d5113768aaf5e; });
$parcel$export(module.exports, "isValidController", function () { return $dade464b59c7f664$export$5e1c5c89613c213f; });
$parcel$export(module.exports, "isValidRequiredNamespaces", function () { return $dade464b59c7f664$export$9e2b2cae22c6a8b3; });
$parcel$export(module.exports, "isValidRelay", function () { return $dade464b59c7f664$export$1b3fc298be8c9a7b; });
$parcel$export(module.exports, "isValidRelays", function () { return $dade464b59c7f664$export$6294c30b976bd21e; });
$parcel$export(module.exports, "isValidId", function () { return $dade464b59c7f664$export$53551be28ad5e34d; });
$parcel$export(module.exports, "isValidParams", function () { return $dade464b59c7f664$export$b3f5fcca1d210454; });
$parcel$export(module.exports, "isValidErrorReason", function () { return $dade464b59c7f664$export$766fe78377d96f2a; });
$parcel$export(module.exports, "isValidRequest", function () { return $dade464b59c7f664$export$1a2af3c017fb6d42; });
$parcel$export(module.exports, "isValidResponse", function () { return $dade464b59c7f664$export$1ae38cf0a848f651; });
$parcel$export(module.exports, "isValidEvent", function () { return $dade464b59c7f664$export$cbe4cdc5960cfa11; });
$parcel$export(module.exports, "isValidNamespacesChainId", function () { return $dade464b59c7f664$export$144fc36610eb6522; });
$parcel$export(module.exports, "isValidNamespacesRequest", function () { return $dade464b59c7f664$export$8db4804e3a6de711; });
$parcel$export(module.exports, "isValidNamespacesEvent", function () { return $dade464b59c7f664$export$df2c67ef8baad16b; });
$parcel$export(module.exports, "isValidRequestExpiry", function () { return $dade464b59c7f664$export$59fba2af1ac782b; });
$parcel$export(module.exports, "isOnline", function () { return $dade464b59c7f664$export$53c2fd0173ad2b80; });
$parcel$export(module.exports, "subscribeToNetworkChange", function () { return $dade464b59c7f664$export$600a1ee4bc680996; });
$parcel$export(module.exports, "MemoryStore", function () { return $dade464b59c7f664$export$b72d712fed4d036d; });

var $f3fVd = parcelRequire("f3fVd");

var $iNdL8 = parcelRequire("iNdL8");

var $89XCI = parcelRequire("89XCI");

var $8lDxr = parcelRequire("8lDxr");

var $ezpuP = parcelRequire("ezpuP");

var $1YStM = parcelRequire("1YStM");

var $bNsWC = parcelRequire("bNsWC");

var $aftW8 = parcelRequire("aftW8");

var $41Mfc = parcelRequire("41Mfc");

var $lzf2X = parcelRequire("lzf2X");
parcelRequire("lgSQS");
var $7GAet = parcelRequire("7GAet");
var $50fYI = parcelRequire("50fYI");
var $5t5tf = parcelRequire("5t5tf");

var $hYa4V = parcelRequire("hYa4V");
parcelRequire("fjT6R");
var $i4OlP = parcelRequire("i4OlP");

var $7Dl6y = parcelRequire("7Dl6y");

var $eSBMZ = parcelRequire("eSBMZ");

var $fxkLe = parcelRequire("fxkLe");
var $dade464b59c7f664$require$Buffer = $fxkLe.Buffer;
const $dade464b59c7f664$var$Ir = ":";
function $dade464b59c7f664$export$4764229d78de4437(e) {
    const [t, r] = e.split($dade464b59c7f664$var$Ir);
    return {
        namespace: t,
        reference: r
    };
}
function $dade464b59c7f664$export$a5999672e4930644(e) {
    const { namespace: t, reference: r } = e;
    return [
        t,
        r
    ].join($dade464b59c7f664$var$Ir);
}
function $dade464b59c7f664$export$276ab0158c66e3d(e) {
    const [t, r, i] = e.split($dade464b59c7f664$var$Ir);
    return {
        namespace: t,
        reference: r,
        address: i
    };
}
function $dade464b59c7f664$export$566a25328fb93a18(e) {
    const { namespace: t, reference: r, address: i } = e;
    return [
        t,
        r,
        i
    ].join($dade464b59c7f664$var$Ir);
}
function $dade464b59c7f664$export$d579bc26e95946b5(e, t) {
    const r = [];
    return e.forEach((i)=>{
        const n = t(i);
        r.includes(n) || r.push(n);
    }), r;
}
function $dade464b59c7f664$export$2806d446053abd1d(e) {
    const { address: t } = $dade464b59c7f664$export$276ab0158c66e3d(e);
    return t;
}
function $dade464b59c7f664$export$93512919ec2ab555(e) {
    const { namespace: t, reference: r } = $dade464b59c7f664$export$276ab0158c66e3d(e);
    return $dade464b59c7f664$export$a5999672e4930644({
        namespace: t,
        reference: r
    });
}
function $dade464b59c7f664$export$40283ddc77f27f6e(e, t) {
    const { namespace: r, reference: i } = $dade464b59c7f664$export$4764229d78de4437(t);
    return $dade464b59c7f664$export$566a25328fb93a18({
        namespace: r,
        reference: i,
        address: e
    });
}
function $dade464b59c7f664$export$aa4a6b630dfcfa83(e) {
    return $dade464b59c7f664$export$d579bc26e95946b5(e, $dade464b59c7f664$export$2806d446053abd1d);
}
function $dade464b59c7f664$export$d5ee58c6b13696e9(e) {
    return $dade464b59c7f664$export$d579bc26e95946b5(e, $dade464b59c7f664$export$93512919ec2ab555);
}
function $dade464b59c7f664$export$23329703ad972840(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...n.accounts);
    }), r;
}
function $dade464b59c7f664$export$6281ff29da5f85fe(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...$dade464b59c7f664$export$d5ee58c6b13696e9(n.accounts));
    }), r;
}
function $dade464b59c7f664$export$d1109eeb751412cf(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...$dade464b59c7f664$export$376384387cd15b27(i, n));
    }), r;
}
function $dade464b59c7f664$export$376384387cd15b27(e, t) {
    return e.includes(":") ? [
        e
    ] : t.chains || [];
}
var $dade464b59c7f664$var$Wo = Object.defineProperty, $dade464b59c7f664$var$yn = Object.getOwnPropertySymbols, $dade464b59c7f664$var$Xo = Object.prototype.hasOwnProperty, $dade464b59c7f664$var$Zo = Object.prototype.propertyIsEnumerable, $dade464b59c7f664$var$wn = (e, t, r)=>t in e ? $dade464b59c7f664$var$Wo(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $dade464b59c7f664$var$xn = (e, t)=>{
    for(var r in t || (t = {}))$dade464b59c7f664$var$Xo.call(t, r) && $dade464b59c7f664$var$wn(e, r, t[r]);
    if ($dade464b59c7f664$var$yn) for (var r of $dade464b59c7f664$var$yn(t))$dade464b59c7f664$var$Zo.call(t, r) && $dade464b59c7f664$var$wn(e, r, t[r]);
    return e;
};
const $dade464b59c7f664$export$f12873d77424d47b = "ReactNative", $dade464b59c7f664$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $dade464b59c7f664$export$657dee6d5648750a = " ", $dade464b59c7f664$export$96c3628b3b9d2079 = ":", $dade464b59c7f664$export$98238152dfccf046 = "/", $dade464b59c7f664$export$7f882bb969de14a3 = 2, $dade464b59c7f664$export$77baccb4c6bd5852 = 1e3, $dade464b59c7f664$export$e08b61c98317d88c = "js";
function $dade464b59c7f664$export$8ee0fc9ee280b4ee() {
    return typeof $eSBMZ < "u" && typeof $eSBMZ.versions < "u" && typeof $eSBMZ.versions.node < "u";
}
function $dade464b59c7f664$export$f7a1e23e542d38e3() {
    return !(0, $89XCI.getDocument)() && !!(0, $89XCI.getNavigator)() && navigator.product === $dade464b59c7f664$export$f12873d77424d47b;
}
function $dade464b59c7f664$export$4e09c449d6c407f7() {
    return !$dade464b59c7f664$export$8ee0fc9ee280b4ee() && !!(0, $89XCI.getNavigator)() && !!(0, $89XCI.getDocument)();
}
function $dade464b59c7f664$export$57570b1603cf6adb() {
    return $dade464b59c7f664$export$f7a1e23e542d38e3() ? $dade464b59c7f664$export$86b1301a63b15dd9.reactNative : $dade464b59c7f664$export$8ee0fc9ee280b4ee() ? $dade464b59c7f664$export$86b1301a63b15dd9.node : $dade464b59c7f664$export$4e09c449d6c407f7() ? $dade464b59c7f664$export$86b1301a63b15dd9.browser : $dade464b59c7f664$export$86b1301a63b15dd9.unknown;
}
function $dade464b59c7f664$export$40a40f90174d197c() {
    var e;
    try {
        return $dade464b59c7f664$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $dade464b59c7f664$export$c4147c69f6845da(e, t) {
    let r = $ezpuP.parse(e);
    return r = $dade464b59c7f664$var$xn($dade464b59c7f664$var$xn({}, r), t), e = $ezpuP.stringify(r), e;
}
function $dade464b59c7f664$export$ba31e015127122bb() {
    return (0, $8lDxr.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $dade464b59c7f664$export$6b05aa0115b6fc2d(e, t) {
    var r;
    const i = $dade464b59c7f664$export$57570b1603cf6adb(), n = {
        protocol: e,
        version: t,
        env: i
    };
    return i === "browser" && (n.host = ((r = (0, $89XCI.getLocation)()) == null ? void 0 : r.host) || "unknown"), n;
}
function $dade464b59c7f664$export$20d4a3cb5829b8b6() {
    if ($dade464b59c7f664$export$57570b1603cf6adb() === $dade464b59c7f664$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: r, Version: i } = $parcel$global.Platform;
        return [
            r,
            i
        ].join("-");
    }
    const e = (0, $f3fVd.detect)();
    if (e === null) return "unknown";
    const t = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        t,
        e.name,
        e.version
    ].join("-") : [
        t,
        e.version
    ].join("-");
}
function $dade464b59c7f664$export$4389b0987726d52d() {
    var e;
    const t = $dade464b59c7f664$export$57570b1603cf6adb();
    return t === $dade464b59c7f664$export$86b1301a63b15dd9.browser ? [
        t,
        ((e = (0, $89XCI.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : t;
}
function $dade464b59c7f664$export$b55a4c6e272b719f(e, t, r) {
    const i = $dade464b59c7f664$export$20d4a3cb5829b8b6(), n = $dade464b59c7f664$export$4389b0987726d52d();
    return [
        [
            e,
            t
        ].join("-"),
        [
            $dade464b59c7f664$export$e08b61c98317d88c,
            r
        ].join("-"),
        i,
        n
    ].join("/");
}
function $dade464b59c7f664$export$d875b3963ef774f5({ protocol: e, version: t, relayUrl: r, sdkVersion: i, auth: n, projectId: o, useOnCloseEvent: h, bundleId: p }) {
    const A = r.split("?"), m = $dade464b59c7f664$export$b55a4c6e272b719f(e, t, i), w = {
        auth: n,
        ua: m,
        projectId: o,
        useOnCloseEvent: h || void 0,
        origin: p || void 0
    }, y = $dade464b59c7f664$export$c4147c69f6845da(A[1] || "", w);
    return A[0] + "?" + y;
}
function $dade464b59c7f664$export$ed08891a8a54eb(e) {
    let t = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const r = typeof t < "u" ? e.split("://")[1] : e;
    return t = t === "wss" ? "https" : "http", [
        t,
        r
    ].join("://");
}
function $dade464b59c7f664$export$804de46662e4ac95(e, t, r) {
    if (!e[t] || typeof e[t] !== r) throw new Error(`Missing or invalid "${t}" param`);
}
function $dade464b59c7f664$export$1e21530e896c0b0b(e, t = $dade464b59c7f664$export$7f882bb969de14a3) {
    return $dade464b59c7f664$export$7f00885504704576(e.split($dade464b59c7f664$export$98238152dfccf046), t);
}
function $dade464b59c7f664$export$80bffd46c37a96f6(e) {
    return $dade464b59c7f664$export$1e21530e896c0b0b(e).join($dade464b59c7f664$export$657dee6d5648750a);
}
function $dade464b59c7f664$export$1468a49de573f7f9(e, t) {
    return e.filter((r)=>t.includes(r)).length === e.length;
}
function $dade464b59c7f664$export$7f00885504704576(e, t = $dade464b59c7f664$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - t, 0));
}
function $dade464b59c7f664$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $dade464b59c7f664$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $dade464b59c7f664$export$592ef47eabb05614(e, t) {
    const r = {};
    return Object.keys(e).forEach((i)=>{
        r[i] = t(e[i]);
    }), r;
}
const $dade464b59c7f664$export$85c927578394b28b = (e)=>e;
function $dade464b59c7f664$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (t)=>t.toUpperCase());
}
function $dade464b59c7f664$export$9a00dee1beb8f576(e) {
    return e.split($dade464b59c7f664$export$657dee6d5648750a).map((t)=>$dade464b59c7f664$export$e9f8fcacef3bca4b(t)).join($dade464b59c7f664$export$657dee6d5648750a);
}
function $dade464b59c7f664$export$cbf9e3cc9ffc85cb(e = (0, $iNdL8.FIVE_MINUTES), t) {
    const r = (0, $iNdL8.toMiliseconds)(e || (0, $iNdL8.FIVE_MINUTES));
    let i, n, o;
    return {
        resolve: (h)=>{
            o && i && (clearTimeout(o), i(h));
        },
        reject: (h)=>{
            o && n && (clearTimeout(o), n(h));
        },
        done: ()=>new Promise((h, p)=>{
                o = setTimeout(()=>{
                    p(new Error(t));
                }, r), i = h, n = p;
            })
    };
}
function $dade464b59c7f664$export$3da2293b007ed708(e, t, r) {
    return new Promise(async (i, n)=>{
        const o = setTimeout(()=>n(new Error(r)), t);
        try {
            const h = await e;
            i(h);
        } catch (h) {
            n(h);
        }
        clearTimeout(o);
    });
}
function $dade464b59c7f664$export$187ab6574b2ae23f(e, t) {
    if (typeof t == "string" && t.startsWith(`${e}:`)) return t;
    if (e.toLowerCase() === "topic") {
        if (typeof t != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${t}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof t != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${t}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $dade464b59c7f664$export$43ab92477f8713b9(e) {
    return $dade464b59c7f664$export$187ab6574b2ae23f("topic", e);
}
function $dade464b59c7f664$export$bd13103c2e5cc0c3(e) {
    return $dade464b59c7f664$export$187ab6574b2ae23f("id", e);
}
function $dade464b59c7f664$export$93adeb0f16e8e51d(e) {
    const [t, r] = e.split(":"), i = {
        id: void 0,
        topic: void 0
    };
    if (t === "topic" && typeof r == "string") i.topic = r;
    else if (t === "id" && Number.isInteger(Number(r))) i.id = Number(r);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${t}:${r}`);
    return i;
}
function $dade464b59c7f664$export$b136d03015bfc12(e, t) {
    return (0, $iNdL8.fromMiliseconds)((t || Date.now()) + (0, $iNdL8.toMiliseconds)(e));
}
function $dade464b59c7f664$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $iNdL8.toMiliseconds)(e);
}
function $dade464b59c7f664$export$e3eb27ce66c0f6d9(e, t) {
    return `${e}${t ? `:${t}` : ""}`;
}
function $dade464b59c7f664$export$9826fe7ad3921016(e = [], t = []) {
    return [
        ...new Set([
            ...e,
            ...t
        ])
    ];
}
async function $dade464b59c7f664$export$694a208c8abca99a({ id: e, topic: t, wcDeepLink: r }) {
    try {
        if (!r) return;
        const i = typeof r == "string" ? JSON.parse(r) : r;
        let n = i?.href;
        if (typeof n != "string") return;
        n.endsWith("/") && (n = n.slice(0, -1));
        const o = `${n}/wc?requestId=${e}&sessionTopic=${t}`, h = $dade464b59c7f664$export$57570b1603cf6adb();
        h === $dade464b59c7f664$export$86b1301a63b15dd9.browser ? o.startsWith("https://") || o.startsWith("http://") ? window.open(o, "_blank", "noreferrer noopener") : window.open(o, "_self", "noreferrer noopener") : h === $dade464b59c7f664$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(o);
    } catch (i) {
        console.error(i);
    }
}
async function $dade464b59c7f664$export$e55bfdac47149a32(e, t) {
    try {
        return await e.getItem(t) || ($dade464b59c7f664$export$4e09c449d6c407f7() ? localStorage.getItem(t) : void 0);
    } catch (r) {
        console.error(r);
    }
}
function $dade464b59c7f664$export$f8aaf09178dd8b96(e, t) {
    return e.filter((r)=>t.includes(r));
}
function $dade464b59c7f664$export$abe4376e1bf796d6() {
    return typeof crypto < "u" && crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (e)=>{
        const t = Math.random() * 16 | 0;
        return (e === "x" ? t : t & 3 | 8).toString(16);
    });
}
var $dade464b59c7f664$var$Pn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $dade464b59c7f664$var$Es(e) {
    var t = e.default;
    if (typeof t == "function") {
        var r = function() {
            return t.apply(this, arguments);
        };
        r.prototype = t.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(i) {
        var n = Object.getOwnPropertyDescriptor(e, i);
        Object.defineProperty(r, i, n.get ? n : {
            enumerable: !0,
            get: function() {
                return e[i];
            }
        });
    }), r;
}
var $dade464b59c7f664$var$Dn = {
    exports: {}
}; /**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ 
(function(e) {
    (function() {
        var t = "input is invalid type", r = "finalize already called", i = typeof window == "object", n = i ? window : {};
        n.JS_SHA3_NO_WINDOW && (i = !1);
        var o = !i && typeof self == "object", h = !n.JS_SHA3_NO_NODE_JS && typeof $eSBMZ == "object" && $eSBMZ.versions && $eSBMZ.versions.node;
        h ? n = $dade464b59c7f664$var$Pn : o && (n = self);
        var p = !n.JS_SHA3_NO_COMMON_JS && !0 && e.exports, A = !n.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", m = "0123456789abcdef".split(""), w = [
            31,
            7936,
            2031616,
            520093696
        ], y = [
            4,
            1024,
            262144,
            67108864
        ], S = [
            1,
            256,
            65536,
            16777216
        ], I = [
            6,
            1536,
            393216,
            100663296
        ], N = [
            0,
            8,
            16,
            24
        ], C = [
            1,
            0,
            32898,
            0,
            32906,
            2147483648,
            2147516416,
            2147483648,
            32907,
            0,
            2147483649,
            0,
            2147516545,
            2147483648,
            32777,
            2147483648,
            138,
            0,
            136,
            0,
            2147516425,
            0,
            2147483658,
            0,
            2147516555,
            0,
            139,
            2147483648,
            32905,
            2147483648,
            32771,
            2147483648,
            32770,
            2147483648,
            128,
            2147483648,
            32778,
            0,
            2147483658,
            2147483648,
            2147516545,
            2147483648,
            32896,
            2147483648,
            2147483649,
            0,
            2147516424,
            2147483648
        ], F = [
            224,
            256,
            384,
            512
        ], U = [
            128,
            256
        ], J = [
            "hex",
            "buffer",
            "arrayBuffer",
            "array",
            "digest"
        ], Bt = {
            128: 168,
            256: 136
        };
        (n.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(u) {
            return Object.prototype.toString.call(u) === "[object Array]";
        }), A && (n.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(u) {
            return typeof u == "object" && u.buffer && u.buffer.constructor === ArrayBuffer;
        });
        for(var G = function(u, E, _) {
            return function(B) {
                return new s(u, E, u).update(B)[_]();
            };
        }, H = function(u, E, _) {
            return function(B, R) {
                return new s(u, E, R).update(B)[_]();
            };
        }, z = function(u, E, _) {
            return function(B, R, T, P) {
                return f["cshake" + u].update(B, R, T, P)[_]();
            };
        }, Pt = function(u, E, _) {
            return function(B, R, T, P) {
                return f["kmac" + u].update(B, R, T, P)[_]();
            };
        }, W = function(u, E, _, B) {
            for(var R = 0; R < J.length; ++R){
                var T = J[R];
                u[T] = E(_, B, T);
            }
            return u;
        }, Rt = function(u, E) {
            var _ = G(u, E, "hex");
            return _.create = function() {
                return new s(u, E, u);
            }, _.update = function(B) {
                return _.create().update(B);
            }, W(_, G, u, E);
        }, Yt = function(u, E) {
            var _ = H(u, E, "hex");
            return _.create = function(B) {
                return new s(u, E, B);
            }, _.update = function(B, R) {
                return _.create(R).update(B);
            }, W(_, H, u, E);
        }, Y = function(u, E) {
            var _ = Bt[u], B = z(u, E, "hex");
            return B.create = function(R, T, P) {
                return !T && !P ? f["shake" + u].create(R) : new s(u, E, R).bytepad([
                    T,
                    P
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(T, P, O).update(R);
            }, W(B, z, u, E);
        }, Vt = function(u, E) {
            var _ = Bt[u], B = Pt(u, E, "hex");
            return B.create = function(R, T, P) {
                return new v(u, E, T).bytepad([
                    "KMAC",
                    P
                ], _).bytepad([
                    R
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(R, P, O).update(T);
            }, W(B, Pt, u, E);
        }, b = [
            {
                name: "keccak",
                padding: S,
                bits: F,
                createMethod: Rt
            },
            {
                name: "sha3",
                padding: I,
                bits: F,
                createMethod: Rt
            },
            {
                name: "shake",
                padding: w,
                bits: U,
                createMethod: Yt
            },
            {
                name: "cshake",
                padding: y,
                bits: U,
                createMethod: Y
            },
            {
                name: "kmac",
                padding: y,
                bits: U,
                createMethod: Vt
            }
        ], f = {}, a = [], c = 0; c < b.length; ++c)for(var d = b[c], g = d.bits, x = 0; x < g.length; ++x){
            var M = d.name + "_" + g[x];
            if (a.push(M), f[M] = d.createMethod(g[x], d.padding), d.name !== "sha3") {
                var l = d.name + g[x];
                a.push(l), f[l] = f[M];
            }
        }
        function s(u, E, _) {
            this.blocks = [], this.s = [], this.padding = E, this.outputBits = _, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (u << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = _ >> 5, this.extraBytes = (_ & 31) >> 3;
            for(var B = 0; B < 50; ++B)this.s[B] = 0;
        }
        s.prototype.update = function(u) {
            if (this.finalized) throw new Error(r);
            var E, _ = typeof u;
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (A && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!A || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            for(var B = this.blocks, R = this.byteCount, T = u.length, P = this.blockCount, O = 0, Ct = this.s, D, q; O < T;){
                if (this.reset) for(this.reset = !1, B[0] = this.block, D = 1; D < P + 1; ++D)B[D] = 0;
                if (E) for(D = this.start; O < T && D < R; ++O)B[D >> 2] |= u[O] << N[D++ & 3];
                else for(D = this.start; O < T && D < R; ++O)q = u.charCodeAt(O), q < 128 ? B[D >> 2] |= q << N[D++ & 3] : q < 2048 ? (B[D >> 2] |= (192 | q >> 6) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : q < 55296 || q >= 57344 ? (B[D >> 2] |= (224 | q >> 12) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : (q = 65536 + ((q & 1023) << 10 | u.charCodeAt(++O) & 1023), B[D >> 2] |= (240 | q >> 18) << N[D++ & 3], B[D >> 2] |= (128 | q >> 12 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]);
                if (this.lastByteIndex = D, D >= R) {
                    for(this.start = D - R, this.block = B[P], D = 0; D < P; ++D)Ct[D] ^= B[D];
                    k(Ct), this.reset = !0;
                } else this.start = D;
            }
            return this;
        }, s.prototype.encode = function(u, E) {
            var _ = u & 255, B = 1, R = [
                _
            ];
            for(u = u >> 8, _ = u & 255; _ > 0;)R.unshift(_), u = u >> 8, _ = u & 255, ++B;
            return E ? R.push(B) : R.unshift(B), this.update(R), R.length;
        }, s.prototype.encodeString = function(u) {
            var E, _ = typeof u;
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (A && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!A || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            var B = 0, R = u.length;
            if (E) B = R;
            else for(var T = 0; T < u.length; ++T){
                var P = u.charCodeAt(T);
                P < 128 ? B += 1 : P < 2048 ? B += 2 : P < 55296 || P >= 57344 ? B += 3 : (P = 65536 + ((P & 1023) << 10 | u.charCodeAt(++T) & 1023), B += 4);
            }
            return B += this.encode(B * 8), this.update(u), B;
        }, s.prototype.bytepad = function(u, E) {
            for(var _ = this.encode(E), B = 0; B < u.length; ++B)_ += this.encodeString(u[B]);
            var R = E - _ % E, T = [];
            return T.length = R, this.update(T), this;
        }, s.prototype.finalize = function() {
            if (!this.finalized) {
                this.finalized = !0;
                var u = this.blocks, E = this.lastByteIndex, _ = this.blockCount, B = this.s;
                if (u[E >> 2] |= this.padding[E & 3], this.lastByteIndex === this.byteCount) for(u[0] = u[_], E = 1; E < _ + 1; ++E)u[E] = 0;
                for(u[_ - 1] |= 2147483648, E = 0; E < _; ++E)B[E] ^= u[E];
                k(B);
            }
        }, s.prototype.toString = s.prototype.hex = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = "", O; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = E[R], P += m[O >> 4 & 15] + m[O & 15] + m[O >> 12 & 15] + m[O >> 8 & 15] + m[O >> 20 & 15] + m[O >> 16 & 15] + m[O >> 28 & 15] + m[O >> 24 & 15];
                T % u === 0 && (k(E), R = 0);
            }
            return B && (O = E[R], P += m[O >> 4 & 15] + m[O & 15], B > 1 && (P += m[O >> 12 & 15] + m[O >> 8 & 15]), B > 2 && (P += m[O >> 20 & 15] + m[O >> 16 & 15])), P;
        }, s.prototype.arrayBuffer = function() {
            this.finalize();
            var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = this.outputBits >> 3, O;
            B ? O = new ArrayBuffer(_ + 1 << 2) : O = new ArrayBuffer(P);
            for(var Ct = new Uint32Array(O); T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)Ct[T] = E[R];
                T % u === 0 && k(E);
            }
            return B && (Ct[R] = E[R], O = O.slice(0, P)), O;
        }, s.prototype.buffer = s.prototype.arrayBuffer, s.prototype.digest = s.prototype.array = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = [], O, Ct; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = T << 2, Ct = E[R], P[O] = Ct & 255, P[O + 1] = Ct >> 8 & 255, P[O + 2] = Ct >> 16 & 255, P[O + 3] = Ct >> 24 & 255;
                T % u === 0 && k(E);
            }
            return B && (O = T << 2, Ct = E[R], P[O] = Ct & 255, B > 1 && (P[O + 1] = Ct >> 8 & 255), B > 2 && (P[O + 2] = Ct >> 16 & 255)), P;
        };
        function v(u, E, _) {
            s.call(this, u, E, _);
        }
        v.prototype = new s, v.prototype.finalize = function() {
            return this.encode(this.outputBits, !0), s.prototype.finalize.call(this);
        };
        var k = function(u) {
            var E, _, B, R, T, P, O, Ct, D, q, De, X, Z, Fe, $, tt, Te, et, rt, Ue, it, nt, ke, ft, ot, qe, st, at, Ke, ut, ht, He, ct, lt, ze, dt, pt, Le, vt, mt, je, gt, At, Qe, bt, yt, Je, wt, xt, Ge, Mt, Et, Ye, St, Nt, Ve, It, _t, Me, Ee, Se, Ne, Ie;
            for(B = 0; B < 48; B += 2)R = u[0] ^ u[10] ^ u[20] ^ u[30] ^ u[40], T = u[1] ^ u[11] ^ u[21] ^ u[31] ^ u[41], P = u[2] ^ u[12] ^ u[22] ^ u[32] ^ u[42], O = u[3] ^ u[13] ^ u[23] ^ u[33] ^ u[43], Ct = u[4] ^ u[14] ^ u[24] ^ u[34] ^ u[44], D = u[5] ^ u[15] ^ u[25] ^ u[35] ^ u[45], q = u[6] ^ u[16] ^ u[26] ^ u[36] ^ u[46], De = u[7] ^ u[17] ^ u[27] ^ u[37] ^ u[47], X = u[8] ^ u[18] ^ u[28] ^ u[38] ^ u[48], Z = u[9] ^ u[19] ^ u[29] ^ u[39] ^ u[49], E = X ^ (P << 1 | O >>> 31), _ = Z ^ (O << 1 | P >>> 31), u[0] ^= E, u[1] ^= _, u[10] ^= E, u[11] ^= _, u[20] ^= E, u[21] ^= _, u[30] ^= E, u[31] ^= _, u[40] ^= E, u[41] ^= _, E = R ^ (Ct << 1 | D >>> 31), _ = T ^ (D << 1 | Ct >>> 31), u[2] ^= E, u[3] ^= _, u[12] ^= E, u[13] ^= _, u[22] ^= E, u[23] ^= _, u[32] ^= E, u[33] ^= _, u[42] ^= E, u[43] ^= _, E = P ^ (q << 1 | De >>> 31), _ = O ^ (De << 1 | q >>> 31), u[4] ^= E, u[5] ^= _, u[14] ^= E, u[15] ^= _, u[24] ^= E, u[25] ^= _, u[34] ^= E, u[35] ^= _, u[44] ^= E, u[45] ^= _, E = Ct ^ (X << 1 | Z >>> 31), _ = D ^ (Z << 1 | X >>> 31), u[6] ^= E, u[7] ^= _, u[16] ^= E, u[17] ^= _, u[26] ^= E, u[27] ^= _, u[36] ^= E, u[37] ^= _, u[46] ^= E, u[47] ^= _, E = q ^ (R << 1 | T >>> 31), _ = De ^ (T << 1 | R >>> 31), u[8] ^= E, u[9] ^= _, u[18] ^= E, u[19] ^= _, u[28] ^= E, u[29] ^= _, u[38] ^= E, u[39] ^= _, u[48] ^= E, u[49] ^= _, Fe = u[0], $ = u[1], yt = u[11] << 4 | u[10] >>> 28, Je = u[10] << 4 | u[11] >>> 28, at = u[20] << 3 | u[21] >>> 29, Ke = u[21] << 3 | u[20] >>> 29, Ee = u[31] << 9 | u[30] >>> 23, Se = u[30] << 9 | u[31] >>> 23, gt = u[40] << 18 | u[41] >>> 14, At = u[41] << 18 | u[40] >>> 14, lt = u[2] << 1 | u[3] >>> 31, ze = u[3] << 1 | u[2] >>> 31, tt = u[13] << 12 | u[12] >>> 20, Te = u[12] << 12 | u[13] >>> 20, wt = u[22] << 10 | u[23] >>> 22, xt = u[23] << 10 | u[22] >>> 22, ut = u[33] << 13 | u[32] >>> 19, ht = u[32] << 13 | u[33] >>> 19, Ne = u[42] << 2 | u[43] >>> 30, Ie = u[43] << 2 | u[42] >>> 30, St = u[5] << 30 | u[4] >>> 2, Nt = u[4] << 30 | u[5] >>> 2, dt = u[14] << 6 | u[15] >>> 26, pt = u[15] << 6 | u[14] >>> 26, et = u[25] << 11 | u[24] >>> 21, rt = u[24] << 11 | u[25] >>> 21, Ge = u[34] << 15 | u[35] >>> 17, Mt = u[35] << 15 | u[34] >>> 17, He = u[45] << 29 | u[44] >>> 3, ct = u[44] << 29 | u[45] >>> 3, ft = u[6] << 28 | u[7] >>> 4, ot = u[7] << 28 | u[6] >>> 4, Ve = u[17] << 23 | u[16] >>> 9, It = u[16] << 23 | u[17] >>> 9, Le = u[26] << 25 | u[27] >>> 7, vt = u[27] << 25 | u[26] >>> 7, Ue = u[36] << 21 | u[37] >>> 11, it = u[37] << 21 | u[36] >>> 11, Et = u[47] << 24 | u[46] >>> 8, Ye = u[46] << 24 | u[47] >>> 8, Qe = u[8] << 27 | u[9] >>> 5, bt = u[9] << 27 | u[8] >>> 5, qe = u[18] << 20 | u[19] >>> 12, st = u[19] << 20 | u[18] >>> 12, _t = u[29] << 7 | u[28] >>> 25, Me = u[28] << 7 | u[29] >>> 25, mt = u[38] << 8 | u[39] >>> 24, je = u[39] << 8 | u[38] >>> 24, nt = u[48] << 14 | u[49] >>> 18, ke = u[49] << 14 | u[48] >>> 18, u[0] = Fe ^ ~tt & et, u[1] = $ ^ ~Te & rt, u[10] = ft ^ ~qe & at, u[11] = ot ^ ~st & Ke, u[20] = lt ^ ~dt & Le, u[21] = ze ^ ~pt & vt, u[30] = Qe ^ ~yt & wt, u[31] = bt ^ ~Je & xt, u[40] = St ^ ~Ve & _t, u[41] = Nt ^ ~It & Me, u[2] = tt ^ ~et & Ue, u[3] = Te ^ ~rt & it, u[12] = qe ^ ~at & ut, u[13] = st ^ ~Ke & ht, u[22] = dt ^ ~Le & mt, u[23] = pt ^ ~vt & je, u[32] = yt ^ ~wt & Ge, u[33] = Je ^ ~xt & Mt, u[42] = Ve ^ ~_t & Ee, u[43] = It ^ ~Me & Se, u[4] = et ^ ~Ue & nt, u[5] = rt ^ ~it & ke, u[14] = at ^ ~ut & He, u[15] = Ke ^ ~ht & ct, u[24] = Le ^ ~mt & gt, u[25] = vt ^ ~je & At, u[34] = wt ^ ~Ge & Et, u[35] = xt ^ ~Mt & Ye, u[44] = _t ^ ~Ee & Ne, u[45] = Me ^ ~Se & Ie, u[6] = Ue ^ ~nt & Fe, u[7] = it ^ ~ke & $, u[16] = ut ^ ~He & ft, u[17] = ht ^ ~ct & ot, u[26] = mt ^ ~gt & lt, u[27] = je ^ ~At & ze, u[36] = Ge ^ ~Et & Qe, u[37] = Mt ^ ~Ye & bt, u[46] = Ee ^ ~Ne & St, u[47] = Se ^ ~Ie & Nt, u[8] = nt ^ ~Fe & tt, u[9] = ke ^ ~$ & Te, u[18] = He ^ ~ft & qe, u[19] = ct ^ ~ot & st, u[28] = gt ^ ~lt & dt, u[29] = At ^ ~ze & pt, u[38] = Et ^ ~Qe & yt, u[39] = Ye ^ ~bt & Je, u[48] = Ne ^ ~St & Ve, u[49] = Ie ^ ~Nt & It, u[0] ^= C[B], u[1] ^= C[B + 1];
        };
        if (p) e.exports = f;
        else for(c = 0; c < a.length; ++c)n[a[c]] = f[a[c]];
    })();
})($dade464b59c7f664$var$Dn);
var $dade464b59c7f664$var$Ss = $dade464b59c7f664$var$Dn.exports;
const $dade464b59c7f664$var$Ns = "logger/5.7.0";
let $dade464b59c7f664$var$Fn = !1, $dade464b59c7f664$var$Tn = !1;
const $dade464b59c7f664$var$Cr = {
    debug: 1,
    default: 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $dade464b59c7f664$var$Un = $dade464b59c7f664$var$Cr.default, $dade464b59c7f664$var$gi = null;
function $dade464b59c7f664$var$Is() {
    try {
        const e = [];
        if ([
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((t)=>{
            try {
                if ("test".normalize(t) !== "test") throw new Error("bad normalize");
            } catch  {
                e.push(t);
            }
        }), e.length) throw new Error("missing " + e.join(", "));
        if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
    } catch (e) {
        return e.message;
    }
    return null;
}
const $dade464b59c7f664$var$kn = $dade464b59c7f664$var$Is();
var $dade464b59c7f664$var$Ai;
(function(e) {
    e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})($dade464b59c7f664$var$Ai || ($dade464b59c7f664$var$Ai = {}));
var $dade464b59c7f664$var$re;
(function(e) {
    e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})($dade464b59c7f664$var$re || ($dade464b59c7f664$var$re = {}));
const $dade464b59c7f664$var$qn = "0123456789abcdef";
class $dade464b59c7f664$var$L {
    constructor(t){
        Object.defineProperty(this, "version", {
            enumerable: !0,
            value: t,
            writable: !1
        });
    }
    _log(t, r) {
        const i = t.toLowerCase();
        $dade464b59c7f664$var$Cr[i] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !($dade464b59c7f664$var$Un > $dade464b59c7f664$var$Cr[i]) && console.log.apply(console, r);
    }
    debug(...t) {
        this._log($dade464b59c7f664$var$L.levels.DEBUG, t);
    }
    info(...t) {
        this._log($dade464b59c7f664$var$L.levels.INFO, t);
    }
    warn(...t) {
        this._log($dade464b59c7f664$var$L.levels.WARNING, t);
    }
    makeError(t, r, i) {
        if ($dade464b59c7f664$var$Tn) return this.makeError("censored error", r, {});
        r || (r = $dade464b59c7f664$var$L.errors.UNKNOWN_ERROR), i || (i = {});
        const n = [];
        Object.keys(i).forEach((A)=>{
            const m = i[A];
            try {
                if (m instanceof Uint8Array) {
                    let w = "";
                    for(let y = 0; y < m.length; y++)w += $dade464b59c7f664$var$qn[m[y] >> 4], w += $dade464b59c7f664$var$qn[m[y] & 15];
                    n.push(A + "=Uint8Array(0x" + w + ")");
                } else n.push(A + "=" + JSON.stringify(m));
            } catch  {
                n.push(A + "=" + JSON.stringify(i[A].toString()));
            }
        }), n.push(`code=${r}`), n.push(`version=${this.version}`);
        const o = t;
        let h = "";
        switch(r){
            case $dade464b59c7f664$var$re.NUMERIC_FAULT:
                {
                    h = "NUMERIC_FAULT";
                    const A = t;
                    switch(A){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            h += "-" + A;
                            break;
                        case "negative-power":
                        case "negative-width":
                            h += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            h += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $dade464b59c7f664$var$re.CALL_EXCEPTION:
            case $dade464b59c7f664$var$re.INSUFFICIENT_FUNDS:
            case $dade464b59c7f664$var$re.MISSING_NEW:
            case $dade464b59c7f664$var$re.NONCE_EXPIRED:
            case $dade464b59c7f664$var$re.REPLACEMENT_UNDERPRICED:
            case $dade464b59c7f664$var$re.TRANSACTION_REPLACED:
            case $dade464b59c7f664$var$re.UNPREDICTABLE_GAS_LIMIT:
                h = r;
                break;
        }
        h && (t += " [ See: https://links.ethers.org/v5-errors-" + h + " ]"), n.length && (t += " (" + n.join(", ") + ")");
        const p = new Error(t);
        return p.reason = o, p.code = r, Object.keys(i).forEach(function(A) {
            p[A] = i[A];
        }), p;
    }
    throwError(t, r, i) {
        throw this.makeError(t, r, i);
    }
    throwArgumentError(t, r, i) {
        return this.throwError(t, $dade464b59c7f664$var$L.errors.INVALID_ARGUMENT, {
            argument: r,
            value: i
        });
    }
    assert(t, r, i, n) {
        t || this.throwError(r, i, n);
    }
    assertArgument(t, r, i, n) {
        t || this.throwArgumentError(r, i, n);
    }
    checkNormalize(t) {
        $dade464b59c7f664$var$kn && this.throwError("platform missing String.prototype.normalize", $dade464b59c7f664$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $dade464b59c7f664$var$kn
        });
    }
    checkSafeUint53(t, r) {
        typeof t == "number" && (r == null && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, $dade464b59c7f664$var$L.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: t
        }), t % 1 && this.throwError(r, $dade464b59c7f664$var$L.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: t
        }));
    }
    checkArgumentCount(t, r, i) {
        i ? i = ": " + i : i = "", t < r && this.throwError("missing argument" + i, $dade464b59c7f664$var$L.errors.MISSING_ARGUMENT, {
            count: t,
            expectedCount: r
        }), t > r && this.throwError("too many arguments" + i, $dade464b59c7f664$var$L.errors.UNEXPECTED_ARGUMENT, {
            count: t,
            expectedCount: r
        });
    }
    checkNew(t, r) {
        (t === Object || t == null) && this.throwError("missing new", $dade464b59c7f664$var$L.errors.MISSING_NEW, {
            name: r.name
        });
    }
    checkAbstract(t, r) {
        t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", $dade464b59c7f664$var$L.errors.UNSUPPORTED_OPERATION, {
            name: t.name,
            operation: "new"
        }) : (t === Object || t == null) && this.throwError("missing new", $dade464b59c7f664$var$L.errors.MISSING_NEW, {
            name: r.name
        });
    }
    static globalLogger() {
        return $dade464b59c7f664$var$gi || ($dade464b59c7f664$var$gi = new $dade464b59c7f664$var$L($dade464b59c7f664$var$Ns)), $dade464b59c7f664$var$gi;
    }
    static setCensorship(t, r) {
        if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", $dade464b59c7f664$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        }), $dade464b59c7f664$var$Fn) {
            if (!t) return;
            this.globalLogger().throwError("error censorship permanent", $dade464b59c7f664$var$L.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $dade464b59c7f664$var$Tn = !!t, $dade464b59c7f664$var$Fn = !!r;
    }
    static setLogLevel(t) {
        const r = $dade464b59c7f664$var$Cr[t.toLowerCase()];
        if (r == null) {
            $dade464b59c7f664$var$L.globalLogger().warn("invalid log level - " + t);
            return;
        }
        $dade464b59c7f664$var$Un = r;
    }
    static from(t) {
        return new $dade464b59c7f664$var$L(t);
    }
}
$dade464b59c7f664$var$L.errors = $dade464b59c7f664$var$re, $dade464b59c7f664$var$L.levels = $dade464b59c7f664$var$Ai;
const $dade464b59c7f664$var$_s = "bytes/5.7.0", $dade464b59c7f664$var$Dt = new $dade464b59c7f664$var$L($dade464b59c7f664$var$_s);
function $dade464b59c7f664$var$Kn(e) {
    return !!e.toHexString;
}
function $dade464b59c7f664$var$rr(e) {
    return e.slice || (e.slice = function() {
        const t = Array.prototype.slice.call(arguments);
        return $dade464b59c7f664$var$rr(new Uint8Array(Array.prototype.slice.apply(e, t)));
    }), e;
}
function $dade464b59c7f664$var$Bs(e) {
    return $dade464b59c7f664$var$Qt(e) && !(e.length % 2) || $dade464b59c7f664$var$ir(e);
}
function $dade464b59c7f664$var$Hn(e) {
    return typeof e == "number" && e == e && e % 1 === 0;
}
function $dade464b59c7f664$var$ir(e) {
    if (e == null) return !1;
    if (e.constructor === Uint8Array) return !0;
    if (typeof e == "string" || !$dade464b59c7f664$var$Hn(e.length) || e.length < 0) return !1;
    for(let t = 0; t < e.length; t++){
        const r = e[t];
        if (!$dade464b59c7f664$var$Hn(r) || r < 0 || r >= 256) return !1;
    }
    return !0;
}
function $dade464b59c7f664$var$Ot(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $dade464b59c7f664$var$Dt.checkSafeUint53(e, "invalid arrayify value");
        const r = [];
        for(; e;)r.unshift(e & 255), e = parseInt(String(e / 256));
        return r.length === 0 && r.push(0), $dade464b59c7f664$var$rr(new Uint8Array(r));
    }
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $dade464b59c7f664$var$Kn(e) && (e = e.toHexString()), $dade464b59c7f664$var$Qt(e)) {
        let r = e.substring(2);
        r.length % 2 && (t.hexPad === "left" ? r = "0" + r : t.hexPad === "right" ? r += "0" : $dade464b59c7f664$var$Dt.throwArgumentError("hex data is odd-length", "value", e));
        const i = [];
        for(let n = 0; n < r.length; n += 2)i.push(parseInt(r.substring(n, n + 2), 16));
        return $dade464b59c7f664$var$rr(new Uint8Array(i));
    }
    return $dade464b59c7f664$var$ir(e) ? $dade464b59c7f664$var$rr(new Uint8Array(e)) : $dade464b59c7f664$var$Dt.throwArgumentError("invalid arrayify value", "value", e);
}
function $dade464b59c7f664$var$Cs(e) {
    const t = e.map((n)=>$dade464b59c7f664$var$Ot(n)), r = t.reduce((n, o)=>n + o.length, 0), i = new Uint8Array(r);
    return t.reduce((n, o)=>(i.set(o, n), n + o.length), 0), $dade464b59c7f664$var$rr(i);
}
function $dade464b59c7f664$var$Rs(e, t) {
    e = $dade464b59c7f664$var$Ot(e), e.length > t && $dade464b59c7f664$var$Dt.throwArgumentError("value out of range", "value", arguments[0]);
    const r = new Uint8Array(t);
    return r.set(e, t - e.length), $dade464b59c7f664$var$rr(r);
}
function $dade464b59c7f664$var$Qt(e, t) {
    return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
}
const $dade464b59c7f664$var$bi = "0123456789abcdef";
function $dade464b59c7f664$var$Kt(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $dade464b59c7f664$var$Dt.checkSafeUint53(e, "invalid hexlify value");
        let r = "";
        for(; e;)r = $dade464b59c7f664$var$bi[e & 15] + r, e = Math.floor(e / 16);
        return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
    }
    if (typeof e == "bigint") return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $dade464b59c7f664$var$Kn(e)) return e.toHexString();
    if ($dade464b59c7f664$var$Qt(e)) return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : $dade464b59c7f664$var$Dt.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
    if ($dade464b59c7f664$var$ir(e)) {
        let r = "0x";
        for(let i = 0; i < e.length; i++){
            let n = e[i];
            r += $dade464b59c7f664$var$bi[(n & 240) >> 4] + $dade464b59c7f664$var$bi[n & 15];
        }
        return r;
    }
    return $dade464b59c7f664$var$Dt.throwArgumentError("invalid hexlify value", "value", e);
}
function $dade464b59c7f664$var$Os(e) {
    if (typeof e != "string") e = $dade464b59c7f664$var$Kt(e);
    else if (!$dade464b59c7f664$var$Qt(e) || e.length % 2) return null;
    return (e.length - 2) / 2;
}
function $dade464b59c7f664$var$zn(e, t, r) {
    return typeof e != "string" ? e = $dade464b59c7f664$var$Kt(e) : (!$dade464b59c7f664$var$Qt(e) || e.length % 2) && $dade464b59c7f664$var$Dt.throwArgumentError("invalid hexData", "value", e), t = 2 + 2 * t, r != null ? "0x" + e.substring(t, 2 + 2 * r) : "0x" + e.substring(t);
}
function $dade464b59c7f664$var$oe(e, t) {
    for(typeof e != "string" ? e = $dade464b59c7f664$var$Kt(e) : $dade464b59c7f664$var$Qt(e) || $dade464b59c7f664$var$Dt.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && $dade464b59c7f664$var$Dt.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2;)e = "0x0" + e.substring(2);
    return e;
}
function $dade464b59c7f664$var$Ln(e) {
    const t = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($dade464b59c7f664$var$Bs(e)) {
        let r = $dade464b59c7f664$var$Ot(e);
        r.length === 64 ? (t.v = 27 + (r[32] >> 7), r[32] &= 127, t.r = $dade464b59c7f664$var$Kt(r.slice(0, 32)), t.s = $dade464b59c7f664$var$Kt(r.slice(32, 64))) : r.length === 65 ? (t.r = $dade464b59c7f664$var$Kt(r.slice(0, 32)), t.s = $dade464b59c7f664$var$Kt(r.slice(32, 64)), t.v = r[64]) : $dade464b59c7f664$var$Dt.throwArgumentError("invalid signature string", "signature", e), t.v < 27 && (t.v === 0 || t.v === 1 ? t.v += 27 : $dade464b59c7f664$var$Dt.throwArgumentError("signature invalid v byte", "signature", e)), t.recoveryParam = 1 - t.v % 2, t.recoveryParam && (r[32] |= 128), t._vs = $dade464b59c7f664$var$Kt(r.slice(32, 64));
    } else {
        if (t.r = e.r, t.s = e.s, t.v = e.v, t.recoveryParam = e.recoveryParam, t._vs = e._vs, t._vs != null) {
            const n = $dade464b59c7f664$var$Rs($dade464b59c7f664$var$Ot(t._vs), 32);
            t._vs = $dade464b59c7f664$var$Kt(n);
            const o = n[0] >= 128 ? 1 : 0;
            t.recoveryParam == null ? t.recoveryParam = o : t.recoveryParam !== o && $dade464b59c7f664$var$Dt.throwArgumentError("signature recoveryParam mismatch _vs", "signature", e), n[0] &= 127;
            const h = $dade464b59c7f664$var$Kt(n);
            t.s == null ? t.s = h : t.s !== h && $dade464b59c7f664$var$Dt.throwArgumentError("signature v mismatch _vs", "signature", e);
        }
        if (t.recoveryParam == null) t.v == null ? $dade464b59c7f664$var$Dt.throwArgumentError("signature missing v and recoveryParam", "signature", e) : t.v === 0 || t.v === 1 ? t.recoveryParam = t.v : t.recoveryParam = 1 - t.v % 2;
        else if (t.v == null) t.v = 27 + t.recoveryParam;
        else {
            const n = t.v === 0 || t.v === 1 ? t.v : 1 - t.v % 2;
            t.recoveryParam !== n && $dade464b59c7f664$var$Dt.throwArgumentError("signature recoveryParam mismatch v", "signature", e);
        }
        t.r == null || !$dade464b59c7f664$var$Qt(t.r) ? $dade464b59c7f664$var$Dt.throwArgumentError("signature missing or invalid r", "signature", e) : t.r = $dade464b59c7f664$var$oe(t.r, 32), t.s == null || !$dade464b59c7f664$var$Qt(t.s) ? $dade464b59c7f664$var$Dt.throwArgumentError("signature missing or invalid s", "signature", e) : t.s = $dade464b59c7f664$var$oe(t.s, 32);
        const r = $dade464b59c7f664$var$Ot(t.s);
        r[0] >= 128 && $dade464b59c7f664$var$Dt.throwArgumentError("signature s out of range", "signature", e), t.recoveryParam && (r[0] |= 128);
        const i = $dade464b59c7f664$var$Kt(r);
        t._vs && ($dade464b59c7f664$var$Qt(t._vs) || $dade464b59c7f664$var$Dt.throwArgumentError("signature invalid _vs", "signature", e), t._vs = $dade464b59c7f664$var$oe(t._vs, 32)), t._vs == null ? t._vs = i : t._vs !== i && $dade464b59c7f664$var$Dt.throwArgumentError("signature _vs mismatch v and s", "signature", e);
    }
    return t.yParityAndS = t._vs, t.compact = t.r + t.yParityAndS.substring(2), t;
}
function $dade464b59c7f664$var$yi(e) {
    return "0x" + $dade464b59c7f664$var$Ss.keccak_256($dade464b59c7f664$var$Ot(e));
}
var $dade464b59c7f664$var$jn = {
    exports: {}
}, $dade464b59c7f664$var$Ps = {}, $dade464b59c7f664$var$Ds = Object.freeze({
    __proto__: null,
    default: $dade464b59c7f664$var$Ps
}), $dade464b59c7f664$var$Fs = $dade464b59c7f664$var$Es($dade464b59c7f664$var$Ds);
(function(e) {
    (function(t, r) {
        function i(b, f) {
            if (!b) throw new Error(f || "Assertion failed");
        }
        function n(b, f) {
            b.super_ = f;
            var a = function() {};
            a.prototype = f.prototype, b.prototype = new a, b.prototype.constructor = b;
        }
        function o(b, f, a) {
            if (o.isBN(b)) return b;
            this.negative = 0, this.words = null, this.length = 0, this.red = null, b !== null && ((f === "le" || f === "be") && (a = f, f = 10), this._init(b || 0, f || 10, a || "be"));
        }
        typeof t == "object" ? t.exports = o : r.BN = o, o.BN = o, o.wordSize = 26;
        var h;
        try {
            typeof window < "u" && typeof window.Buffer < "u" ? h = window.Buffer : h = $dade464b59c7f664$var$Fs.Buffer;
        } catch  {}
        o.isBN = function(f) {
            return f instanceof o ? !0 : f !== null && typeof f == "object" && f.constructor.wordSize === o.wordSize && Array.isArray(f.words);
        }, o.max = function(f, a) {
            return f.cmp(a) > 0 ? f : a;
        }, o.min = function(f, a) {
            return f.cmp(a) < 0 ? f : a;
        }, o.prototype._init = function(f, a, c) {
            if (typeof f == "number") return this._initNumber(f, a, c);
            if (typeof f == "object") return this._initArray(f, a, c);
            a === "hex" && (a = 16), i(a === (a | 0) && a >= 2 && a <= 36), f = f.toString().replace(/\s+/g, "");
            var d = 0;
            f[0] === "-" && (d++, this.negative = 1), d < f.length && (a === 16 ? this._parseHex(f, d, c) : (this._parseBase(f, a, d), c === "le" && this._initArray(this.toArray(), a, c)));
        }, o.prototype._initNumber = function(f, a, c) {
            f < 0 && (this.negative = 1, f = -f), f < 67108864 ? (this.words = [
                f & 67108863
            ], this.length = 1) : f < 4503599627370496 ? (this.words = [
                f & 67108863,
                f / 67108864 & 67108863
            ], this.length = 2) : (i(f < 9007199254740992), this.words = [
                f & 67108863,
                f / 67108864 & 67108863,
                1
            ], this.length = 3), c === "le" && this._initArray(this.toArray(), a, c);
        }, o.prototype._initArray = function(f, a, c) {
            if (i(typeof f.length == "number"), f.length <= 0) return this.words = [
                0
            ], this.length = 1, this;
            this.length = Math.ceil(f.length / 3), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g, x, M = 0;
            if (c === "be") for(d = f.length - 1, g = 0; d >= 0; d -= 3)x = f[d] | f[d - 1] << 8 | f[d - 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            else if (c === "le") for(d = 0, g = 0; d < f.length; d += 3)x = f[d] | f[d + 1] << 8 | f[d + 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            return this._strip();
        };
        function p(b, f) {
            var a = b.charCodeAt(f);
            if (a >= 48 && a <= 57) return a - 48;
            if (a >= 65 && a <= 70) return a - 55;
            if (a >= 97 && a <= 102) return a - 87;
            i(!1, "Invalid character in " + b);
        }
        function A(b, f, a) {
            var c = p(b, a);
            return a - 1 >= f && (c |= p(b, a - 1) << 4), c;
        }
        o.prototype._parseHex = function(f, a, c) {
            this.length = Math.ceil((f.length - a) / 6), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g = 0, x = 0, M;
            if (c === "be") for(d = f.length - 1; d >= a; d -= 2)M = A(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            else {
                var l = f.length - a;
                for(d = l % 2 === 0 ? a + 1 : a; d < f.length; d += 2)M = A(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            }
            this._strip();
        };
        function m(b, f, a, c) {
            for(var d = 0, g = 0, x = Math.min(b.length, a), M = f; M < x; M++){
                var l = b.charCodeAt(M) - 48;
                d *= c, l >= 49 ? g = l - 49 + 10 : l >= 17 ? g = l - 17 + 10 : g = l, i(l >= 0 && g < c, "Invalid character"), d += g;
            }
            return d;
        }
        o.prototype._parseBase = function(f, a, c) {
            this.words = [
                0
            ], this.length = 1;
            for(var d = 0, g = 1; g <= 67108863; g *= a)d++;
            d--, g = g / a | 0;
            for(var x = f.length - c, M = x % d, l = Math.min(x, x - M) + c, s = 0, v = c; v < l; v += d)s = m(f, v, v + d, a), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            if (M !== 0) {
                var k = 1;
                for(s = m(f, v, f.length, a), v = 0; v < M; v++)k *= a;
                this.imuln(k), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            }
            this._strip();
        }, o.prototype.copy = function(f) {
            f.words = new Array(this.length);
            for(var a = 0; a < this.length; a++)f.words[a] = this.words[a];
            f.length = this.length, f.negative = this.negative, f.red = this.red;
        };
        function w(b, f) {
            b.words = f.words, b.length = f.length, b.negative = f.negative, b.red = f.red;
        }
        if (o.prototype._move = function(f) {
            w(f, this);
        }, o.prototype.clone = function() {
            var f = new o(null);
            return this.copy(f), f;
        }, o.prototype._expand = function(f) {
            for(; this.length < f;)this.words[this.length++] = 0;
            return this;
        }, o.prototype._strip = function() {
            for(; this.length > 1 && this.words[this.length - 1] === 0;)this.length--;
            return this._normSign();
        }, o.prototype._normSign = function() {
            return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
        }, typeof Symbol < "u" && typeof Symbol.for == "function") try {
            o.prototype[Symbol.for("nodejs.util.inspect.custom")] = y;
        } catch  {
            o.prototype.inspect = y;
        }
        else o.prototype.inspect = y;
        function y() {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        }
        var S = [
            "",
            "0",
            "00",
            "000",
            "0000",
            "00000",
            "000000",
            "0000000",
            "00000000",
            "000000000",
            "0000000000",
            "00000000000",
            "000000000000",
            "0000000000000",
            "00000000000000",
            "000000000000000",
            "0000000000000000",
            "00000000000000000",
            "000000000000000000",
            "0000000000000000000",
            "00000000000000000000",
            "000000000000000000000",
            "0000000000000000000000",
            "00000000000000000000000",
            "000000000000000000000000",
            "0000000000000000000000000"
        ], I = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ], N = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            1e7,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64e6,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            243e5,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        o.prototype.toString = function(f, a) {
            f = f || 10, a = a | 0 || 1;
            var c;
            if (f === 16 || f === "hex") {
                c = "";
                for(var d = 0, g = 0, x = 0; x < this.length; x++){
                    var M = this.words[x], l = ((M << d | g) & 16777215).toString(16);
                    g = M >>> 24 - d & 16777215, d += 2, d >= 26 && (d -= 26, x--), g !== 0 || x !== this.length - 1 ? c = S[6 - l.length] + l + c : c = l + c;
                }
                for(g !== 0 && (c = g.toString(16) + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            if (f === (f | 0) && f >= 2 && f <= 36) {
                var s = I[f], v = N[f];
                c = "";
                var k = this.clone();
                for(k.negative = 0; !k.isZero();){
                    var u = k.modrn(v).toString(f);
                    k = k.idivn(v), k.isZero() ? c = u + c : c = S[s - u.length] + u + c;
                }
                for(this.isZero() && (c = "0" + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            i(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function() {
            var f = this.words[0];
            return this.length === 2 ? f += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? f += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -f : f;
        }, o.prototype.toJSON = function() {
            return this.toString(16, 2);
        }, h && (o.prototype.toBuffer = function(f, a) {
            return this.toArrayLike(h, f, a);
        }), o.prototype.toArray = function(f, a) {
            return this.toArrayLike(Array, f, a);
        };
        var C = function(f, a) {
            return f.allocUnsafe ? f.allocUnsafe(a) : new f(a);
        };
        o.prototype.toArrayLike = function(f, a, c) {
            this._strip();
            var d = this.byteLength(), g = c || Math.max(1, d);
            i(d <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0");
            var x = C(f, g), M = a === "le" ? "LE" : "BE";
            return this["_toArrayLike" + M](x, d), x;
        }, o.prototype._toArrayLikeLE = function(f, a) {
            for(var c = 0, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c++] = M & 255, c < f.length && (f[c++] = M >> 8 & 255), c < f.length && (f[c++] = M >> 16 & 255), x === 6 ? (c < f.length && (f[c++] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c < f.length) for(f[c++] = d; c < f.length;)f[c++] = 0;
        }, o.prototype._toArrayLikeBE = function(f, a) {
            for(var c = f.length - 1, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c--] = M & 255, c >= 0 && (f[c--] = M >> 8 & 255), c >= 0 && (f[c--] = M >> 16 & 255), x === 6 ? (c >= 0 && (f[c--] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c >= 0) for(f[c--] = d; c >= 0;)f[c--] = 0;
        }, Math.clz32 ? o.prototype._countBits = function(f) {
            return 32 - Math.clz32(f);
        } : o.prototype._countBits = function(f) {
            var a = f, c = 0;
            return a >= 4096 && (c += 13, a >>>= 13), a >= 64 && (c += 7, a >>>= 7), a >= 8 && (c += 4, a >>>= 4), a >= 2 && (c += 2, a >>>= 2), c + a;
        }, o.prototype._zeroBits = function(f) {
            if (f === 0) return 26;
            var a = f, c = 0;
            return a & 8191 || (c += 13, a >>>= 13), a & 127 || (c += 7, a >>>= 7), a & 15 || (c += 4, a >>>= 4), a & 3 || (c += 2, a >>>= 2), a & 1 || c++, c;
        }, o.prototype.bitLength = function() {
            var f = this.words[this.length - 1], a = this._countBits(f);
            return (this.length - 1) * 26 + a;
        };
        function F(b) {
            for(var f = new Array(b.bitLength()), a = 0; a < f.length; a++){
                var c = a / 26 | 0, d = a % 26;
                f[a] = b.words[c] >>> d & 1;
            }
            return f;
        }
        o.prototype.zeroBits = function() {
            if (this.isZero()) return 0;
            for(var f = 0, a = 0; a < this.length; a++){
                var c = this._zeroBits(this.words[a]);
                if (f += c, c !== 26) break;
            }
            return f;
        }, o.prototype.byteLength = function() {
            return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function(f) {
            return this.negative !== 0 ? this.abs().inotn(f).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function(f) {
            return this.testn(f - 1) ? this.notn(f).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function() {
            return this.negative !== 0;
        }, o.prototype.neg = function() {
            return this.clone().ineg();
        }, o.prototype.ineg = function() {
            return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function(f) {
            for(; this.length < f.length;)this.words[this.length++] = 0;
            for(var a = 0; a < f.length; a++)this.words[a] = this.words[a] | f.words[a];
            return this._strip();
        }, o.prototype.ior = function(f) {
            return i((this.negative | f.negative) === 0), this.iuor(f);
        }, o.prototype.or = function(f) {
            return this.length > f.length ? this.clone().ior(f) : f.clone().ior(this);
        }, o.prototype.uor = function(f) {
            return this.length > f.length ? this.clone().iuor(f) : f.clone().iuor(this);
        }, o.prototype.iuand = function(f) {
            var a;
            this.length > f.length ? a = f : a = this;
            for(var c = 0; c < a.length; c++)this.words[c] = this.words[c] & f.words[c];
            return this.length = a.length, this._strip();
        }, o.prototype.iand = function(f) {
            return i((this.negative | f.negative) === 0), this.iuand(f);
        }, o.prototype.and = function(f) {
            return this.length > f.length ? this.clone().iand(f) : f.clone().iand(this);
        }, o.prototype.uand = function(f) {
            return this.length > f.length ? this.clone().iuand(f) : f.clone().iuand(this);
        }, o.prototype.iuxor = function(f) {
            var a, c;
            this.length > f.length ? (a = this, c = f) : (a = f, c = this);
            for(var d = 0; d < c.length; d++)this.words[d] = a.words[d] ^ c.words[d];
            if (this !== a) for(; d < a.length; d++)this.words[d] = a.words[d];
            return this.length = a.length, this._strip();
        }, o.prototype.ixor = function(f) {
            return i((this.negative | f.negative) === 0), this.iuxor(f);
        }, o.prototype.xor = function(f) {
            return this.length > f.length ? this.clone().ixor(f) : f.clone().ixor(this);
        }, o.prototype.uxor = function(f) {
            return this.length > f.length ? this.clone().iuxor(f) : f.clone().iuxor(this);
        }, o.prototype.inotn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = Math.ceil(f / 26) | 0, c = f % 26;
            this._expand(a), c > 0 && a--;
            for(var d = 0; d < a; d++)this.words[d] = ~this.words[d] & 67108863;
            return c > 0 && (this.words[d] = ~this.words[d] & 67108863 >> 26 - c), this._strip();
        }, o.prototype.notn = function(f) {
            return this.clone().inotn(f);
        }, o.prototype.setn = function(f, a) {
            i(typeof f == "number" && f >= 0);
            var c = f / 26 | 0, d = f % 26;
            return this._expand(c + 1), a ? this.words[c] = this.words[c] | 1 << d : this.words[c] = this.words[c] & ~(1 << d), this._strip();
        }, o.prototype.iadd = function(f) {
            var a;
            if (this.negative !== 0 && f.negative === 0) return this.negative = 0, a = this.isub(f), this.negative ^= 1, this._normSign();
            if (this.negative === 0 && f.negative !== 0) return f.negative = 0, a = this.isub(f), f.negative = 1, a._normSign();
            var c, d;
            this.length > f.length ? (c = this, d = f) : (c = f, d = this);
            for(var g = 0, x = 0; x < d.length; x++)a = (c.words[x] | 0) + (d.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            for(; g !== 0 && x < c.length; x++)a = (c.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            if (this.length = c.length, g !== 0) this.words[this.length] = g, this.length++;
            else if (c !== this) for(; x < c.length; x++)this.words[x] = c.words[x];
            return this;
        }, o.prototype.add = function(f) {
            var a;
            return f.negative !== 0 && this.negative === 0 ? (f.negative = 0, a = this.sub(f), f.negative ^= 1, a) : f.negative === 0 && this.negative !== 0 ? (this.negative = 0, a = f.sub(this), this.negative = 1, a) : this.length > f.length ? this.clone().iadd(f) : f.clone().iadd(this);
        }, o.prototype.isub = function(f) {
            if (f.negative !== 0) {
                f.negative = 0;
                var a = this.iadd(f);
                return f.negative = 1, a._normSign();
            } else if (this.negative !== 0) return this.negative = 0, this.iadd(f), this.negative = 1, this._normSign();
            var c = this.cmp(f);
            if (c === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            var d, g;
            c > 0 ? (d = this, g = f) : (d = f, g = this);
            for(var x = 0, M = 0; M < g.length; M++)a = (d.words[M] | 0) - (g.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            for(; x !== 0 && M < d.length; M++)a = (d.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            if (x === 0 && M < d.length && d !== this) for(; M < d.length; M++)this.words[M] = d.words[M];
            return this.length = Math.max(this.length, M), d !== this && (this.negative = 1), this._strip();
        }, o.prototype.sub = function(f) {
            return this.clone().isub(f);
        };
        function U(b, f, a) {
            a.negative = f.negative ^ b.negative;
            var c = b.length + f.length | 0;
            a.length = c, c = c - 1 | 0;
            var d = b.words[0] | 0, g = f.words[0] | 0, x = d * g, M = x & 67108863, l = x / 67108864 | 0;
            a.words[0] = M;
            for(var s = 1; s < c; s++){
                for(var v = l >>> 26, k = l & 67108863, u = Math.min(s, f.length - 1), E = Math.max(0, s - b.length + 1); E <= u; E++){
                    var _ = s - E | 0;
                    d = b.words[_] | 0, g = f.words[E] | 0, x = d * g + k, v += x / 67108864 | 0, k = x & 67108863;
                }
                a.words[s] = k | 0, l = v | 0;
            }
            return l !== 0 ? a.words[s] = l | 0 : a.length--, a._strip();
        }
        var J = function(f, a, c) {
            var d = f.words, g = a.words, x = c.words, M = 0, l, s, v, k = d[0] | 0, u = k & 8191, E = k >>> 13, _ = d[1] | 0, B = _ & 8191, R = _ >>> 13, T = d[2] | 0, P = T & 8191, O = T >>> 13, Ct = d[3] | 0, D = Ct & 8191, q = Ct >>> 13, De = d[4] | 0, X = De & 8191, Z = De >>> 13, Fe = d[5] | 0, $ = Fe & 8191, tt = Fe >>> 13, Te = d[6] | 0, et = Te & 8191, rt = Te >>> 13, Ue = d[7] | 0, it = Ue & 8191, nt = Ue >>> 13, ke = d[8] | 0, ft = ke & 8191, ot = ke >>> 13, qe = d[9] | 0, st = qe & 8191, at = qe >>> 13, Ke = g[0] | 0, ut = Ke & 8191, ht = Ke >>> 13, He = g[1] | 0, ct = He & 8191, lt = He >>> 13, ze = g[2] | 0, dt = ze & 8191, pt = ze >>> 13, Le = g[3] | 0, vt = Le & 8191, mt = Le >>> 13, je = g[4] | 0, gt = je & 8191, At = je >>> 13, Qe = g[5] | 0, bt = Qe & 8191, yt = Qe >>> 13, Je = g[6] | 0, wt = Je & 8191, xt = Je >>> 13, Ge = g[7] | 0, Mt = Ge & 8191, Et = Ge >>> 13, Ye = g[8] | 0, St = Ye & 8191, Nt = Ye >>> 13, Ve = g[9] | 0, It = Ve & 8191, _t = Ve >>> 13;
            c.negative = f.negative ^ a.negative, c.length = 19, l = Math.imul(u, ut), s = Math.imul(u, ht), s = s + Math.imul(E, ut) | 0, v = Math.imul(E, ht);
            var Me = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, l = Math.imul(B, ut), s = Math.imul(B, ht), s = s + Math.imul(R, ut) | 0, v = Math.imul(R, ht), l = l + Math.imul(u, ct) | 0, s = s + Math.imul(u, lt) | 0, s = s + Math.imul(E, ct) | 0, v = v + Math.imul(E, lt) | 0;
            var Ee = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, l = Math.imul(P, ut), s = Math.imul(P, ht), s = s + Math.imul(O, ut) | 0, v = Math.imul(O, ht), l = l + Math.imul(B, ct) | 0, s = s + Math.imul(B, lt) | 0, s = s + Math.imul(R, ct) | 0, v = v + Math.imul(R, lt) | 0, l = l + Math.imul(u, dt) | 0, s = s + Math.imul(u, pt) | 0, s = s + Math.imul(E, dt) | 0, v = v + Math.imul(E, pt) | 0;
            var Se = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, l = Math.imul(D, ut), s = Math.imul(D, ht), s = s + Math.imul(q, ut) | 0, v = Math.imul(q, ht), l = l + Math.imul(P, ct) | 0, s = s + Math.imul(P, lt) | 0, s = s + Math.imul(O, ct) | 0, v = v + Math.imul(O, lt) | 0, l = l + Math.imul(B, dt) | 0, s = s + Math.imul(B, pt) | 0, s = s + Math.imul(R, dt) | 0, v = v + Math.imul(R, pt) | 0, l = l + Math.imul(u, vt) | 0, s = s + Math.imul(u, mt) | 0, s = s + Math.imul(E, vt) | 0, v = v + Math.imul(E, mt) | 0;
            var Ne = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l = Math.imul(X, ut), s = Math.imul(X, ht), s = s + Math.imul(Z, ut) | 0, v = Math.imul(Z, ht), l = l + Math.imul(D, ct) | 0, s = s + Math.imul(D, lt) | 0, s = s + Math.imul(q, ct) | 0, v = v + Math.imul(q, lt) | 0, l = l + Math.imul(P, dt) | 0, s = s + Math.imul(P, pt) | 0, s = s + Math.imul(O, dt) | 0, v = v + Math.imul(O, pt) | 0, l = l + Math.imul(B, vt) | 0, s = s + Math.imul(B, mt) | 0, s = s + Math.imul(R, vt) | 0, v = v + Math.imul(R, mt) | 0, l = l + Math.imul(u, gt) | 0, s = s + Math.imul(u, At) | 0, s = s + Math.imul(E, gt) | 0, v = v + Math.imul(E, At) | 0;
            var Ie = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, l = Math.imul($, ut), s = Math.imul($, ht), s = s + Math.imul(tt, ut) | 0, v = Math.imul(tt, ht), l = l + Math.imul(X, ct) | 0, s = s + Math.imul(X, lt) | 0, s = s + Math.imul(Z, ct) | 0, v = v + Math.imul(Z, lt) | 0, l = l + Math.imul(D, dt) | 0, s = s + Math.imul(D, pt) | 0, s = s + Math.imul(q, dt) | 0, v = v + Math.imul(q, pt) | 0, l = l + Math.imul(P, vt) | 0, s = s + Math.imul(P, mt) | 0, s = s + Math.imul(O, vt) | 0, v = v + Math.imul(O, mt) | 0, l = l + Math.imul(B, gt) | 0, s = s + Math.imul(B, At) | 0, s = s + Math.imul(R, gt) | 0, v = v + Math.imul(R, At) | 0, l = l + Math.imul(u, bt) | 0, s = s + Math.imul(u, yt) | 0, s = s + Math.imul(E, bt) | 0, v = v + Math.imul(E, yt) | 0;
            var Wr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Wr >>> 26) | 0, Wr &= 67108863, l = Math.imul(et, ut), s = Math.imul(et, ht), s = s + Math.imul(rt, ut) | 0, v = Math.imul(rt, ht), l = l + Math.imul($, ct) | 0, s = s + Math.imul($, lt) | 0, s = s + Math.imul(tt, ct) | 0, v = v + Math.imul(tt, lt) | 0, l = l + Math.imul(X, dt) | 0, s = s + Math.imul(X, pt) | 0, s = s + Math.imul(Z, dt) | 0, v = v + Math.imul(Z, pt) | 0, l = l + Math.imul(D, vt) | 0, s = s + Math.imul(D, mt) | 0, s = s + Math.imul(q, vt) | 0, v = v + Math.imul(q, mt) | 0, l = l + Math.imul(P, gt) | 0, s = s + Math.imul(P, At) | 0, s = s + Math.imul(O, gt) | 0, v = v + Math.imul(O, At) | 0, l = l + Math.imul(B, bt) | 0, s = s + Math.imul(B, yt) | 0, s = s + Math.imul(R, bt) | 0, v = v + Math.imul(R, yt) | 0, l = l + Math.imul(u, wt) | 0, s = s + Math.imul(u, xt) | 0, s = s + Math.imul(E, wt) | 0, v = v + Math.imul(E, xt) | 0;
            var Xr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, l = Math.imul(it, ut), s = Math.imul(it, ht), s = s + Math.imul(nt, ut) | 0, v = Math.imul(nt, ht), l = l + Math.imul(et, ct) | 0, s = s + Math.imul(et, lt) | 0, s = s + Math.imul(rt, ct) | 0, v = v + Math.imul(rt, lt) | 0, l = l + Math.imul($, dt) | 0, s = s + Math.imul($, pt) | 0, s = s + Math.imul(tt, dt) | 0, v = v + Math.imul(tt, pt) | 0, l = l + Math.imul(X, vt) | 0, s = s + Math.imul(X, mt) | 0, s = s + Math.imul(Z, vt) | 0, v = v + Math.imul(Z, mt) | 0, l = l + Math.imul(D, gt) | 0, s = s + Math.imul(D, At) | 0, s = s + Math.imul(q, gt) | 0, v = v + Math.imul(q, At) | 0, l = l + Math.imul(P, bt) | 0, s = s + Math.imul(P, yt) | 0, s = s + Math.imul(O, bt) | 0, v = v + Math.imul(O, yt) | 0, l = l + Math.imul(B, wt) | 0, s = s + Math.imul(B, xt) | 0, s = s + Math.imul(R, wt) | 0, v = v + Math.imul(R, xt) | 0, l = l + Math.imul(u, Mt) | 0, s = s + Math.imul(u, Et) | 0, s = s + Math.imul(E, Mt) | 0, v = v + Math.imul(E, Et) | 0;
            var Zr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, l = Math.imul(ft, ut), s = Math.imul(ft, ht), s = s + Math.imul(ot, ut) | 0, v = Math.imul(ot, ht), l = l + Math.imul(it, ct) | 0, s = s + Math.imul(it, lt) | 0, s = s + Math.imul(nt, ct) | 0, v = v + Math.imul(nt, lt) | 0, l = l + Math.imul(et, dt) | 0, s = s + Math.imul(et, pt) | 0, s = s + Math.imul(rt, dt) | 0, v = v + Math.imul(rt, pt) | 0, l = l + Math.imul($, vt) | 0, s = s + Math.imul($, mt) | 0, s = s + Math.imul(tt, vt) | 0, v = v + Math.imul(tt, mt) | 0, l = l + Math.imul(X, gt) | 0, s = s + Math.imul(X, At) | 0, s = s + Math.imul(Z, gt) | 0, v = v + Math.imul(Z, At) | 0, l = l + Math.imul(D, bt) | 0, s = s + Math.imul(D, yt) | 0, s = s + Math.imul(q, bt) | 0, v = v + Math.imul(q, yt) | 0, l = l + Math.imul(P, wt) | 0, s = s + Math.imul(P, xt) | 0, s = s + Math.imul(O, wt) | 0, v = v + Math.imul(O, xt) | 0, l = l + Math.imul(B, Mt) | 0, s = s + Math.imul(B, Et) | 0, s = s + Math.imul(R, Mt) | 0, v = v + Math.imul(R, Et) | 0, l = l + Math.imul(u, St) | 0, s = s + Math.imul(u, Nt) | 0, s = s + Math.imul(E, St) | 0, v = v + Math.imul(E, Nt) | 0;
            var $r = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, l = Math.imul(st, ut), s = Math.imul(st, ht), s = s + Math.imul(at, ut) | 0, v = Math.imul(at, ht), l = l + Math.imul(ft, ct) | 0, s = s + Math.imul(ft, lt) | 0, s = s + Math.imul(ot, ct) | 0, v = v + Math.imul(ot, lt) | 0, l = l + Math.imul(it, dt) | 0, s = s + Math.imul(it, pt) | 0, s = s + Math.imul(nt, dt) | 0, v = v + Math.imul(nt, pt) | 0, l = l + Math.imul(et, vt) | 0, s = s + Math.imul(et, mt) | 0, s = s + Math.imul(rt, vt) | 0, v = v + Math.imul(rt, mt) | 0, l = l + Math.imul($, gt) | 0, s = s + Math.imul($, At) | 0, s = s + Math.imul(tt, gt) | 0, v = v + Math.imul(tt, At) | 0, l = l + Math.imul(X, bt) | 0, s = s + Math.imul(X, yt) | 0, s = s + Math.imul(Z, bt) | 0, v = v + Math.imul(Z, yt) | 0, l = l + Math.imul(D, wt) | 0, s = s + Math.imul(D, xt) | 0, s = s + Math.imul(q, wt) | 0, v = v + Math.imul(q, xt) | 0, l = l + Math.imul(P, Mt) | 0, s = s + Math.imul(P, Et) | 0, s = s + Math.imul(O, Mt) | 0, v = v + Math.imul(O, Et) | 0, l = l + Math.imul(B, St) | 0, s = s + Math.imul(B, Nt) | 0, s = s + Math.imul(R, St) | 0, v = v + Math.imul(R, Nt) | 0, l = l + Math.imul(u, It) | 0, s = s + Math.imul(u, _t) | 0, s = s + Math.imul(E, It) | 0, v = v + Math.imul(E, _t) | 0;
            var ti = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ti >>> 26) | 0, ti &= 67108863, l = Math.imul(st, ct), s = Math.imul(st, lt), s = s + Math.imul(at, ct) | 0, v = Math.imul(at, lt), l = l + Math.imul(ft, dt) | 0, s = s + Math.imul(ft, pt) | 0, s = s + Math.imul(ot, dt) | 0, v = v + Math.imul(ot, pt) | 0, l = l + Math.imul(it, vt) | 0, s = s + Math.imul(it, mt) | 0, s = s + Math.imul(nt, vt) | 0, v = v + Math.imul(nt, mt) | 0, l = l + Math.imul(et, gt) | 0, s = s + Math.imul(et, At) | 0, s = s + Math.imul(rt, gt) | 0, v = v + Math.imul(rt, At) | 0, l = l + Math.imul($, bt) | 0, s = s + Math.imul($, yt) | 0, s = s + Math.imul(tt, bt) | 0, v = v + Math.imul(tt, yt) | 0, l = l + Math.imul(X, wt) | 0, s = s + Math.imul(X, xt) | 0, s = s + Math.imul(Z, wt) | 0, v = v + Math.imul(Z, xt) | 0, l = l + Math.imul(D, Mt) | 0, s = s + Math.imul(D, Et) | 0, s = s + Math.imul(q, Mt) | 0, v = v + Math.imul(q, Et) | 0, l = l + Math.imul(P, St) | 0, s = s + Math.imul(P, Nt) | 0, s = s + Math.imul(O, St) | 0, v = v + Math.imul(O, Nt) | 0, l = l + Math.imul(B, It) | 0, s = s + Math.imul(B, _t) | 0, s = s + Math.imul(R, It) | 0, v = v + Math.imul(R, _t) | 0;
            var ei = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, l = Math.imul(st, dt), s = Math.imul(st, pt), s = s + Math.imul(at, dt) | 0, v = Math.imul(at, pt), l = l + Math.imul(ft, vt) | 0, s = s + Math.imul(ft, mt) | 0, s = s + Math.imul(ot, vt) | 0, v = v + Math.imul(ot, mt) | 0, l = l + Math.imul(it, gt) | 0, s = s + Math.imul(it, At) | 0, s = s + Math.imul(nt, gt) | 0, v = v + Math.imul(nt, At) | 0, l = l + Math.imul(et, bt) | 0, s = s + Math.imul(et, yt) | 0, s = s + Math.imul(rt, bt) | 0, v = v + Math.imul(rt, yt) | 0, l = l + Math.imul($, wt) | 0, s = s + Math.imul($, xt) | 0, s = s + Math.imul(tt, wt) | 0, v = v + Math.imul(tt, xt) | 0, l = l + Math.imul(X, Mt) | 0, s = s + Math.imul(X, Et) | 0, s = s + Math.imul(Z, Mt) | 0, v = v + Math.imul(Z, Et) | 0, l = l + Math.imul(D, St) | 0, s = s + Math.imul(D, Nt) | 0, s = s + Math.imul(q, St) | 0, v = v + Math.imul(q, Nt) | 0, l = l + Math.imul(P, It) | 0, s = s + Math.imul(P, _t) | 0, s = s + Math.imul(O, It) | 0, v = v + Math.imul(O, _t) | 0;
            var ri = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ri >>> 26) | 0, ri &= 67108863, l = Math.imul(st, vt), s = Math.imul(st, mt), s = s + Math.imul(at, vt) | 0, v = Math.imul(at, mt), l = l + Math.imul(ft, gt) | 0, s = s + Math.imul(ft, At) | 0, s = s + Math.imul(ot, gt) | 0, v = v + Math.imul(ot, At) | 0, l = l + Math.imul(it, bt) | 0, s = s + Math.imul(it, yt) | 0, s = s + Math.imul(nt, bt) | 0, v = v + Math.imul(nt, yt) | 0, l = l + Math.imul(et, wt) | 0, s = s + Math.imul(et, xt) | 0, s = s + Math.imul(rt, wt) | 0, v = v + Math.imul(rt, xt) | 0, l = l + Math.imul($, Mt) | 0, s = s + Math.imul($, Et) | 0, s = s + Math.imul(tt, Mt) | 0, v = v + Math.imul(tt, Et) | 0, l = l + Math.imul(X, St) | 0, s = s + Math.imul(X, Nt) | 0, s = s + Math.imul(Z, St) | 0, v = v + Math.imul(Z, Nt) | 0, l = l + Math.imul(D, It) | 0, s = s + Math.imul(D, _t) | 0, s = s + Math.imul(q, It) | 0, v = v + Math.imul(q, _t) | 0;
            var ii = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, l = Math.imul(st, gt), s = Math.imul(st, At), s = s + Math.imul(at, gt) | 0, v = Math.imul(at, At), l = l + Math.imul(ft, bt) | 0, s = s + Math.imul(ft, yt) | 0, s = s + Math.imul(ot, bt) | 0, v = v + Math.imul(ot, yt) | 0, l = l + Math.imul(it, wt) | 0, s = s + Math.imul(it, xt) | 0, s = s + Math.imul(nt, wt) | 0, v = v + Math.imul(nt, xt) | 0, l = l + Math.imul(et, Mt) | 0, s = s + Math.imul(et, Et) | 0, s = s + Math.imul(rt, Mt) | 0, v = v + Math.imul(rt, Et) | 0, l = l + Math.imul($, St) | 0, s = s + Math.imul($, Nt) | 0, s = s + Math.imul(tt, St) | 0, v = v + Math.imul(tt, Nt) | 0, l = l + Math.imul(X, It) | 0, s = s + Math.imul(X, _t) | 0, s = s + Math.imul(Z, It) | 0, v = v + Math.imul(Z, _t) | 0;
            var ni = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ni >>> 26) | 0, ni &= 67108863, l = Math.imul(st, bt), s = Math.imul(st, yt), s = s + Math.imul(at, bt) | 0, v = Math.imul(at, yt), l = l + Math.imul(ft, wt) | 0, s = s + Math.imul(ft, xt) | 0, s = s + Math.imul(ot, wt) | 0, v = v + Math.imul(ot, xt) | 0, l = l + Math.imul(it, Mt) | 0, s = s + Math.imul(it, Et) | 0, s = s + Math.imul(nt, Mt) | 0, v = v + Math.imul(nt, Et) | 0, l = l + Math.imul(et, St) | 0, s = s + Math.imul(et, Nt) | 0, s = s + Math.imul(rt, St) | 0, v = v + Math.imul(rt, Nt) | 0, l = l + Math.imul($, It) | 0, s = s + Math.imul($, _t) | 0, s = s + Math.imul(tt, It) | 0, v = v + Math.imul(tt, _t) | 0;
            var fi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (fi >>> 26) | 0, fi &= 67108863, l = Math.imul(st, wt), s = Math.imul(st, xt), s = s + Math.imul(at, wt) | 0, v = Math.imul(at, xt), l = l + Math.imul(ft, Mt) | 0, s = s + Math.imul(ft, Et) | 0, s = s + Math.imul(ot, Mt) | 0, v = v + Math.imul(ot, Et) | 0, l = l + Math.imul(it, St) | 0, s = s + Math.imul(it, Nt) | 0, s = s + Math.imul(nt, St) | 0, v = v + Math.imul(nt, Nt) | 0, l = l + Math.imul(et, It) | 0, s = s + Math.imul(et, _t) | 0, s = s + Math.imul(rt, It) | 0, v = v + Math.imul(rt, _t) | 0;
            var oi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, l = Math.imul(st, Mt), s = Math.imul(st, Et), s = s + Math.imul(at, Mt) | 0, v = Math.imul(at, Et), l = l + Math.imul(ft, St) | 0, s = s + Math.imul(ft, Nt) | 0, s = s + Math.imul(ot, St) | 0, v = v + Math.imul(ot, Nt) | 0, l = l + Math.imul(it, It) | 0, s = s + Math.imul(it, _t) | 0, s = s + Math.imul(nt, It) | 0, v = v + Math.imul(nt, _t) | 0;
            var si = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (si >>> 26) | 0, si &= 67108863, l = Math.imul(st, St), s = Math.imul(st, Nt), s = s + Math.imul(at, St) | 0, v = Math.imul(at, Nt), l = l + Math.imul(ft, It) | 0, s = s + Math.imul(ft, _t) | 0, s = s + Math.imul(ot, It) | 0, v = v + Math.imul(ot, _t) | 0;
            var ai = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, l = Math.imul(st, It), s = Math.imul(st, _t), s = s + Math.imul(at, It) | 0, v = Math.imul(at, _t);
            var ui = (M + l | 0) + ((s & 8191) << 13) | 0;
            return M = (v + (s >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, x[0] = Me, x[1] = Ee, x[2] = Se, x[3] = Ne, x[4] = Ie, x[5] = Wr, x[6] = Xr, x[7] = Zr, x[8] = $r, x[9] = ti, x[10] = ei, x[11] = ri, x[12] = ii, x[13] = ni, x[14] = fi, x[15] = oi, x[16] = si, x[17] = ai, x[18] = ui, M !== 0 && (x[19] = M, c.length++), c;
        };
        Math.imul || (J = U);
        function Bt(b, f, a) {
            a.negative = f.negative ^ b.negative, a.length = b.length + f.length;
            for(var c = 0, d = 0, g = 0; g < a.length - 1; g++){
                var x = d;
                d = 0;
                for(var M = c & 67108863, l = Math.min(g, f.length - 1), s = Math.max(0, g - b.length + 1); s <= l; s++){
                    var v = g - s, k = b.words[v] | 0, u = f.words[s] | 0, E = k * u, _ = E & 67108863;
                    x = x + (E / 67108864 | 0) | 0, _ = _ + M | 0, M = _ & 67108863, x = x + (_ >>> 26) | 0, d += x >>> 26, x &= 67108863;
                }
                a.words[g] = M, c = x, x = d;
            }
            return c !== 0 ? a.words[g] = c : a.length--, a._strip();
        }
        function G(b, f, a) {
            return Bt(b, f, a);
        }
        o.prototype.mulTo = function(f, a) {
            var c, d = this.length + f.length;
            return this.length === 10 && f.length === 10 ? c = J(this, f, a) : d < 63 ? c = U(this, f, a) : d < 1024 ? c = Bt(this, f, a) : c = G(this, f, a), c;
        }, o.prototype.mul = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), this.mulTo(f, a);
        }, o.prototype.mulf = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), G(this, f, a);
        }, o.prototype.imul = function(f) {
            return this.clone().mulTo(f, this);
        }, o.prototype.imuln = function(f) {
            var a = f < 0;
            a && (f = -f), i(typeof f == "number"), i(f < 67108864);
            for(var c = 0, d = 0; d < this.length; d++){
                var g = (this.words[d] | 0) * f, x = (g & 67108863) + (c & 67108863);
                c >>= 26, c += g / 67108864 | 0, c += x >>> 26, this.words[d] = x & 67108863;
            }
            return c !== 0 && (this.words[d] = c, this.length++), a ? this.ineg() : this;
        }, o.prototype.muln = function(f) {
            return this.clone().imuln(f);
        }, o.prototype.sqr = function() {
            return this.mul(this);
        }, o.prototype.isqr = function() {
            return this.imul(this.clone());
        }, o.prototype.pow = function(f) {
            var a = F(f);
            if (a.length === 0) return new o(1);
            for(var c = this, d = 0; d < a.length && a[d] === 0; d++, c = c.sqr());
            if (++d < a.length) for(var g = c.sqr(); d < a.length; d++, g = g.sqr())a[d] !== 0 && (c = c.mul(g));
            return c;
        }, o.prototype.iushln = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 67108863 >>> 26 - a << 26 - a, g;
            if (a !== 0) {
                var x = 0;
                for(g = 0; g < this.length; g++){
                    var M = this.words[g] & d, l = (this.words[g] | 0) - M << a;
                    this.words[g] = l | x, x = M >>> 26 - a;
                }
                x && (this.words[g] = x, this.length++);
            }
            if (c !== 0) {
                for(g = this.length - 1; g >= 0; g--)this.words[g + c] = this.words[g];
                for(g = 0; g < c; g++)this.words[g] = 0;
                this.length += c;
            }
            return this._strip();
        }, o.prototype.ishln = function(f) {
            return i(this.negative === 0), this.iushln(f);
        }, o.prototype.iushrn = function(f, a, c) {
            i(typeof f == "number" && f >= 0);
            var d;
            a ? d = (a - a % 26) / 26 : d = 0;
            var g = f % 26, x = Math.min((f - g) / 26, this.length), M = 67108863 ^ 67108863 >>> g << g, l = c;
            if (d -= x, d = Math.max(0, d), l) {
                for(var s = 0; s < x; s++)l.words[s] = this.words[s];
                l.length = x;
            }
            if (x !== 0) {
                if (this.length > x) for(this.length -= x, s = 0; s < this.length; s++)this.words[s] = this.words[s + x];
                else this.words[0] = 0, this.length = 1;
            }
            var v = 0;
            for(s = this.length - 1; s >= 0 && (v !== 0 || s >= d); s--){
                var k = this.words[s] | 0;
                this.words[s] = v << 26 - g | k >>> g, v = k & M;
            }
            return l && v !== 0 && (l.words[l.length++] = v), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
        }, o.prototype.ishrn = function(f, a, c) {
            return i(this.negative === 0), this.iushrn(f, a, c);
        }, o.prototype.shln = function(f) {
            return this.clone().ishln(f);
        }, o.prototype.ushln = function(f) {
            return this.clone().iushln(f);
        }, o.prototype.shrn = function(f) {
            return this.clone().ishrn(f);
        }, o.prototype.ushrn = function(f) {
            return this.clone().iushrn(f);
        }, o.prototype.testn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return !1;
            var g = this.words[c];
            return !!(g & d);
        }, o.prototype.imaskn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26;
            if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= c) return this;
            if (a !== 0 && c++, this.length = Math.min(c, this.length), a !== 0) {
                var d = 67108863 ^ 67108863 >>> a << a;
                this.words[this.length - 1] &= d;
            }
            return this._strip();
        }, o.prototype.maskn = function(f) {
            return this.clone().imaskn(f);
        }, o.prototype.iaddn = function(f) {
            return i(typeof f == "number"), i(f < 67108864), f < 0 ? this.isubn(-f) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= f ? (this.words[0] = f - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(f), this.negative = 1, this) : this._iaddn(f);
        }, o.prototype._iaddn = function(f) {
            this.words[0] += f;
            for(var a = 0; a < this.length && this.words[a] >= 67108864; a++)this.words[a] -= 67108864, a === this.length - 1 ? this.words[a + 1] = 1 : this.words[a + 1]++;
            return this.length = Math.max(this.length, a + 1), this;
        }, o.prototype.isubn = function(f) {
            if (i(typeof f == "number"), i(f < 67108864), f < 0) return this.iaddn(-f);
            if (this.negative !== 0) return this.negative = 0, this.iaddn(f), this.negative = 1, this;
            if (this.words[0] -= f, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
            else for(var a = 0; a < this.length && this.words[a] < 0; a++)this.words[a] += 67108864, this.words[a + 1] -= 1;
            return this._strip();
        }, o.prototype.addn = function(f) {
            return this.clone().iaddn(f);
        }, o.prototype.subn = function(f) {
            return this.clone().isubn(f);
        }, o.prototype.iabs = function() {
            return this.negative = 0, this;
        }, o.prototype.abs = function() {
            return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function(f, a, c) {
            var d = f.length + c, g;
            this._expand(d);
            var x, M = 0;
            for(g = 0; g < f.length; g++){
                x = (this.words[g + c] | 0) + M;
                var l = (f.words[g] | 0) * a;
                x -= l & 67108863, M = (x >> 26) - (l / 67108864 | 0), this.words[g + c] = x & 67108863;
            }
            for(; g < this.length - c; g++)x = (this.words[g + c] | 0) + M, M = x >> 26, this.words[g + c] = x & 67108863;
            if (M === 0) return this._strip();
            for(i(M === -1), M = 0, g = 0; g < this.length; g++)x = -(this.words[g] | 0) + M, M = x >> 26, this.words[g] = x & 67108863;
            return this.negative = 1, this._strip();
        }, o.prototype._wordDiv = function(f, a) {
            var c = this.length - f.length, d = this.clone(), g = f, x = g.words[g.length - 1] | 0, M = this._countBits(x);
            c = 26 - M, c !== 0 && (g = g.ushln(c), d.iushln(c), x = g.words[g.length - 1] | 0);
            var l = d.length - g.length, s;
            if (a !== "mod") {
                s = new o(null), s.length = l + 1, s.words = new Array(s.length);
                for(var v = 0; v < s.length; v++)s.words[v] = 0;
            }
            var k = d.clone()._ishlnsubmul(g, 1, l);
            k.negative === 0 && (d = k, s && (s.words[l] = 1));
            for(var u = l - 1; u >= 0; u--){
                var E = (d.words[g.length + u] | 0) * 67108864 + (d.words[g.length + u - 1] | 0);
                for(E = Math.min(E / x | 0, 67108863), d._ishlnsubmul(g, E, u); d.negative !== 0;)E--, d.negative = 0, d._ishlnsubmul(g, 1, u), d.isZero() || (d.negative ^= 1);
                s && (s.words[u] = E);
            }
            return s && s._strip(), d._strip(), a !== "div" && c !== 0 && d.iushrn(c), {
                div: s || null,
                mod: d
            };
        }, o.prototype.divmod = function(f, a, c) {
            if (i(!f.isZero()), this.isZero()) return {
                div: new o(0),
                mod: new o(0)
            };
            var d, g, x;
            return this.negative !== 0 && f.negative === 0 ? (x = this.neg().divmod(f, a), a !== "mod" && (d = x.div.neg()), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.iadd(f)), {
                div: d,
                mod: g
            }) : this.negative === 0 && f.negative !== 0 ? (x = this.divmod(f.neg(), a), a !== "mod" && (d = x.div.neg()), {
                div: d,
                mod: x.mod
            }) : this.negative & f.negative ? (x = this.neg().divmod(f.neg(), a), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.isub(f)), {
                div: x.div,
                mod: g
            }) : f.length > this.length || this.cmp(f) < 0 ? {
                div: new o(0),
                mod: this
            } : f.length === 1 ? a === "div" ? {
                div: this.divn(f.words[0]),
                mod: null
            } : a === "mod" ? {
                div: null,
                mod: new o(this.modrn(f.words[0]))
            } : {
                div: this.divn(f.words[0]),
                mod: new o(this.modrn(f.words[0]))
            } : this._wordDiv(f, a);
        }, o.prototype.div = function(f) {
            return this.divmod(f, "div", !1).div;
        }, o.prototype.mod = function(f) {
            return this.divmod(f, "mod", !1).mod;
        }, o.prototype.umod = function(f) {
            return this.divmod(f, "mod", !0).mod;
        }, o.prototype.divRound = function(f) {
            var a = this.divmod(f);
            if (a.mod.isZero()) return a.div;
            var c = a.div.negative !== 0 ? a.mod.isub(f) : a.mod, d = f.ushrn(1), g = f.andln(1), x = c.cmp(d);
            return x < 0 || g === 1 && x === 0 ? a.div : a.div.negative !== 0 ? a.div.isubn(1) : a.div.iaddn(1);
        }, o.prototype.modrn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 67108864 % f, d = 0, g = this.length - 1; g >= 0; g--)d = (c * d + (this.words[g] | 0)) % f;
            return a ? -d : d;
        }, o.prototype.modn = function(f) {
            return this.modrn(f);
        }, o.prototype.idivn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 0, d = this.length - 1; d >= 0; d--){
                var g = (this.words[d] | 0) + c * 67108864;
                this.words[d] = g / f | 0, c = g % f;
            }
            return this._strip(), a ? this.ineg() : this;
        }, o.prototype.divn = function(f) {
            return this.clone().idivn(f);
        }, o.prototype.egcd = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = new o(0), M = new o(1), l = 0; a.isEven() && c.isEven();)a.iushrn(1), c.iushrn(1), ++l;
            for(var s = c.clone(), v = a.clone(); !a.isZero();){
                for(var k = 0, u = 1; !(a.words[0] & u) && k < 26; ++k, u <<= 1);
                if (k > 0) for(a.iushrn(k); k-- > 0;)(d.isOdd() || g.isOdd()) && (d.iadd(s), g.isub(v)), d.iushrn(1), g.iushrn(1);
                for(var E = 0, _ = 1; !(c.words[0] & _) && E < 26; ++E, _ <<= 1);
                if (E > 0) for(c.iushrn(E); E-- > 0;)(x.isOdd() || M.isOdd()) && (x.iadd(s), M.isub(v)), x.iushrn(1), M.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(x), g.isub(M)) : (c.isub(a), x.isub(d), M.isub(g));
            }
            return {
                a: x,
                b: M,
                gcd: c.iushln(l)
            };
        }, o.prototype._invmp = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = c.clone(); a.cmpn(1) > 0 && c.cmpn(1) > 0;){
                for(var M = 0, l = 1; !(a.words[0] & l) && M < 26; ++M, l <<= 1);
                if (M > 0) for(a.iushrn(M); M-- > 0;)d.isOdd() && d.iadd(x), d.iushrn(1);
                for(var s = 0, v = 1; !(c.words[0] & v) && s < 26; ++s, v <<= 1);
                if (s > 0) for(c.iushrn(s); s-- > 0;)g.isOdd() && g.iadd(x), g.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(g)) : (c.isub(a), g.isub(d));
            }
            var k;
            return a.cmpn(1) === 0 ? k = d : k = g, k.cmpn(0) < 0 && k.iadd(f), k;
        }, o.prototype.gcd = function(f) {
            if (this.isZero()) return f.abs();
            if (f.isZero()) return this.abs();
            var a = this.clone(), c = f.clone();
            a.negative = 0, c.negative = 0;
            for(var d = 0; a.isEven() && c.isEven(); d++)a.iushrn(1), c.iushrn(1);
            do {
                for(; a.isEven();)a.iushrn(1);
                for(; c.isEven();)c.iushrn(1);
                var g = a.cmp(c);
                if (g < 0) {
                    var x = a;
                    a = c, c = x;
                } else if (g === 0 || c.cmpn(1) === 0) break;
                a.isub(c);
            }while (!0);
            return c.iushln(d);
        }, o.prototype.invm = function(f) {
            return this.egcd(f).a.umod(f);
        }, o.prototype.isEven = function() {
            return (this.words[0] & 1) === 0;
        }, o.prototype.isOdd = function() {
            return (this.words[0] & 1) === 1;
        }, o.prototype.andln = function(f) {
            return this.words[0] & f;
        }, o.prototype.bincn = function(f) {
            i(typeof f == "number");
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return this._expand(c + 1), this.words[c] |= d, this;
            for(var g = d, x = c; g !== 0 && x < this.length; x++){
                var M = this.words[x] | 0;
                M += g, g = M >>> 26, M &= 67108863, this.words[x] = M;
            }
            return g !== 0 && (this.words[x] = g, this.length++), this;
        }, o.prototype.isZero = function() {
            return this.length === 1 && this.words[0] === 0;
        }, o.prototype.cmpn = function(f) {
            var a = f < 0;
            if (this.negative !== 0 && !a) return -1;
            if (this.negative === 0 && a) return 1;
            this._strip();
            var c;
            if (this.length > 1) c = 1;
            else {
                a && (f = -f), i(f <= 67108863, "Number is too big");
                var d = this.words[0] | 0;
                c = d === f ? 0 : d < f ? -1 : 1;
            }
            return this.negative !== 0 ? -c | 0 : c;
        }, o.prototype.cmp = function(f) {
            if (this.negative !== 0 && f.negative === 0) return -1;
            if (this.negative === 0 && f.negative !== 0) return 1;
            var a = this.ucmp(f);
            return this.negative !== 0 ? -a | 0 : a;
        }, o.prototype.ucmp = function(f) {
            if (this.length > f.length) return 1;
            if (this.length < f.length) return -1;
            for(var a = 0, c = this.length - 1; c >= 0; c--){
                var d = this.words[c] | 0, g = f.words[c] | 0;
                if (d !== g) {
                    d < g ? a = -1 : d > g && (a = 1);
                    break;
                }
            }
            return a;
        }, o.prototype.gtn = function(f) {
            return this.cmpn(f) === 1;
        }, o.prototype.gt = function(f) {
            return this.cmp(f) === 1;
        }, o.prototype.gten = function(f) {
            return this.cmpn(f) >= 0;
        }, o.prototype.gte = function(f) {
            return this.cmp(f) >= 0;
        }, o.prototype.ltn = function(f) {
            return this.cmpn(f) === -1;
        }, o.prototype.lt = function(f) {
            return this.cmp(f) === -1;
        }, o.prototype.lten = function(f) {
            return this.cmpn(f) <= 0;
        }, o.prototype.lte = function(f) {
            return this.cmp(f) <= 0;
        }, o.prototype.eqn = function(f) {
            return this.cmpn(f) === 0;
        }, o.prototype.eq = function(f) {
            return this.cmp(f) === 0;
        }, o.red = function(f) {
            return new Y(f);
        }, o.prototype.toRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), f.convertTo(this)._forceRed(f);
        }, o.prototype.fromRed = function() {
            return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function(f) {
            return this.red = f, this;
        }, o.prototype.forceRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), this._forceRed(f);
        }, o.prototype.redAdd = function(f) {
            return i(this.red, "redAdd works only with red numbers"), this.red.add(this, f);
        }, o.prototype.redIAdd = function(f) {
            return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, f);
        }, o.prototype.redSub = function(f) {
            return i(this.red, "redSub works only with red numbers"), this.red.sub(this, f);
        }, o.prototype.redISub = function(f) {
            return i(this.red, "redISub works only with red numbers"), this.red.isub(this, f);
        }, o.prototype.redShl = function(f) {
            return i(this.red, "redShl works only with red numbers"), this.red.shl(this, f);
        }, o.prototype.redMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.mul(this, f);
        }, o.prototype.redIMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.imul(this, f);
        }, o.prototype.redSqr = function() {
            return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function() {
            return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function() {
            return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function() {
            return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function() {
            return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function(f) {
            return i(this.red && !f.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, f);
        };
        var H = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function z(b, f) {
            this.name = b, this.p = new o(f, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }
        z.prototype._tmp = function() {
            var f = new o(null);
            return f.words = new Array(Math.ceil(this.n / 13)), f;
        }, z.prototype.ireduce = function(f) {
            var a = f, c;
            do this.split(a, this.tmp), a = this.imulK(a), a = a.iadd(this.tmp), c = a.bitLength();
            while (c > this.n);
            var d = c < this.n ? -1 : a.ucmp(this.p);
            return d === 0 ? (a.words[0] = 0, a.length = 1) : d > 0 ? a.isub(this.p) : a.strip !== void 0 ? a.strip() : a._strip(), a;
        }, z.prototype.split = function(f, a) {
            f.iushrn(this.n, 0, a);
        }, z.prototype.imulK = function(f) {
            return f.imul(this.k);
        };
        function Pt() {
            z.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }
        n(Pt, z), Pt.prototype.split = function(f, a) {
            for(var c = 4194303, d = Math.min(f.length, 9), g = 0; g < d; g++)a.words[g] = f.words[g];
            if (a.length = d, f.length <= 9) {
                f.words[0] = 0, f.length = 1;
                return;
            }
            var x = f.words[9];
            for(a.words[a.length++] = x & c, g = 10; g < f.length; g++){
                var M = f.words[g] | 0;
                f.words[g - 10] = (M & c) << 4 | x >>> 22, x = M;
            }
            x >>>= 22, f.words[g - 10] = x, x === 0 && f.length > 10 ? f.length -= 10 : f.length -= 9;
        }, Pt.prototype.imulK = function(f) {
            f.words[f.length] = 0, f.words[f.length + 1] = 0, f.length += 2;
            for(var a = 0, c = 0; c < f.length; c++){
                var d = f.words[c] | 0;
                a += d * 977, f.words[c] = a & 67108863, a = d * 64 + (a / 67108864 | 0);
            }
            return f.words[f.length - 1] === 0 && (f.length--, f.words[f.length - 1] === 0 && f.length--), f;
        };
        function W() {
            z.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }
        n(W, z);
        function Rt() {
            z.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }
        n(Rt, z);
        function Yt() {
            z.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }
        n(Yt, z), Yt.prototype.imulK = function(f) {
            for(var a = 0, c = 0; c < f.length; c++){
                var d = (f.words[c] | 0) * 19 + a, g = d & 67108863;
                d >>>= 26, f.words[c] = g, a = d;
            }
            return a !== 0 && (f.words[f.length++] = a), f;
        }, o._prime = function(f) {
            if (H[f]) return H[f];
            var a;
            if (f === "k256") a = new Pt;
            else if (f === "p224") a = new W;
            else if (f === "p192") a = new Rt;
            else if (f === "p25519") a = new Yt;
            else throw new Error("Unknown prime " + f);
            return H[f] = a, a;
        };
        function Y(b) {
            if (typeof b == "string") {
                var f = o._prime(b);
                this.m = f.p, this.prime = f;
            } else i(b.gtn(1), "modulus must be greater than 1"), this.m = b, this.prime = null;
        }
        Y.prototype._verify1 = function(f) {
            i(f.negative === 0, "red works only with positives"), i(f.red, "red works only with red numbers");
        }, Y.prototype._verify2 = function(f, a) {
            i((f.negative | a.negative) === 0, "red works only with positives"), i(f.red && f.red === a.red, "red works only with red numbers");
        }, Y.prototype.imod = function(f) {
            return this.prime ? this.prime.ireduce(f)._forceRed(this) : (w(f, f.umod(this.m)._forceRed(this)), f);
        }, Y.prototype.neg = function(f) {
            return f.isZero() ? f.clone() : this.m.sub(f)._forceRed(this);
        }, Y.prototype.add = function(f, a) {
            this._verify2(f, a);
            var c = f.add(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c._forceRed(this);
        }, Y.prototype.iadd = function(f, a) {
            this._verify2(f, a);
            var c = f.iadd(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c;
        }, Y.prototype.sub = function(f, a) {
            this._verify2(f, a);
            var c = f.sub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c._forceRed(this);
        }, Y.prototype.isub = function(f, a) {
            this._verify2(f, a);
            var c = f.isub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c;
        }, Y.prototype.shl = function(f, a) {
            return this._verify1(f), this.imod(f.ushln(a));
        }, Y.prototype.imul = function(f, a) {
            return this._verify2(f, a), this.imod(f.imul(a));
        }, Y.prototype.mul = function(f, a) {
            return this._verify2(f, a), this.imod(f.mul(a));
        }, Y.prototype.isqr = function(f) {
            return this.imul(f, f.clone());
        }, Y.prototype.sqr = function(f) {
            return this.mul(f, f);
        }, Y.prototype.sqrt = function(f) {
            if (f.isZero()) return f.clone();
            var a = this.m.andln(3);
            if (i(a % 2 === 1), a === 3) {
                var c = this.m.add(new o(1)).iushrn(2);
                return this.pow(f, c);
            }
            for(var d = this.m.subn(1), g = 0; !d.isZero() && d.andln(1) === 0;)g++, d.iushrn(1);
            i(!d.isZero());
            var x = new o(1).toRed(this), M = x.redNeg(), l = this.m.subn(1).iushrn(1), s = this.m.bitLength();
            for(s = new o(2 * s * s).toRed(this); this.pow(s, l).cmp(M) !== 0;)s.redIAdd(M);
            for(var v = this.pow(s, d), k = this.pow(f, d.addn(1).iushrn(1)), u = this.pow(f, d), E = g; u.cmp(x) !== 0;){
                for(var _ = u, B = 0; _.cmp(x) !== 0; B++)_ = _.redSqr();
                i(B < E);
                var R = this.pow(v, new o(1).iushln(E - B - 1));
                k = k.redMul(R), v = R.redSqr(), u = u.redMul(v), E = B;
            }
            return k;
        }, Y.prototype.invm = function(f) {
            var a = f._invmp(this.m);
            return a.negative !== 0 ? (a.negative = 0, this.imod(a).redNeg()) : this.imod(a);
        }, Y.prototype.pow = function(f, a) {
            if (a.isZero()) return new o(1).toRed(this);
            if (a.cmpn(1) === 0) return f.clone();
            var c = 4, d = new Array(1 << c);
            d[0] = new o(1).toRed(this), d[1] = f;
            for(var g = 2; g < d.length; g++)d[g] = this.mul(d[g - 1], f);
            var x = d[0], M = 0, l = 0, s = a.bitLength() % 26;
            for(s === 0 && (s = 26), g = a.length - 1; g >= 0; g--){
                for(var v = a.words[g], k = s - 1; k >= 0; k--){
                    var u = v >> k & 1;
                    if (x !== d[0] && (x = this.sqr(x)), u === 0 && M === 0) {
                        l = 0;
                        continue;
                    }
                    M <<= 1, M |= u, l++, !(l !== c && (g !== 0 || k !== 0)) && (x = this.mul(x, d[M]), l = 0, M = 0);
                }
                s = 26;
            }
            return x;
        }, Y.prototype.convertTo = function(f) {
            var a = f.umod(this.m);
            return a === f ? a.clone() : a;
        }, Y.prototype.convertFrom = function(f) {
            var a = f.clone();
            return a.red = null, a;
        }, o.mont = function(f) {
            return new Vt(f);
        };
        function Vt(b) {
            Y.call(this, b), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }
        n(Vt, Y), Vt.prototype.convertTo = function(f) {
            return this.imod(f.ushln(this.shift));
        }, Vt.prototype.convertFrom = function(f) {
            var a = this.imod(f.mul(this.rinv));
            return a.red = null, a;
        }, Vt.prototype.imul = function(f, a) {
            if (f.isZero() || a.isZero()) return f.words[0] = 0, f.length = 1, f;
            var c = f.imul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.mul = function(f, a) {
            if (f.isZero() || a.isZero()) return new o(0)._forceRed(this);
            var c = f.mul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.invm = function(f) {
            var a = this.imod(f._invmp(this.m).mul(this.r2));
            return a._forceRed(this);
        };
    })(e, $dade464b59c7f664$var$Pn);
})($dade464b59c7f664$var$jn);
var $dade464b59c7f664$var$K = $dade464b59c7f664$var$jn.exports;
const $dade464b59c7f664$var$Qn = "bignumber/5.7.0";
var $dade464b59c7f664$var$Rr = $dade464b59c7f664$var$K.BN;
const $dade464b59c7f664$var$Ae = new $dade464b59c7f664$var$L($dade464b59c7f664$var$Qn), $dade464b59c7f664$var$wi = {}, $dade464b59c7f664$var$Jn = 9007199254740991;
function $dade464b59c7f664$var$Ts(e) {
    return e != null && ($dade464b59c7f664$var$V.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || $dade464b59c7f664$var$Qt(e) || typeof e == "bigint" || $dade464b59c7f664$var$ir(e));
}
let $dade464b59c7f664$var$Gn = !1;
class $dade464b59c7f664$var$V {
    constructor(t, r){
        t !== $dade464b59c7f664$var$wi && $dade464b59c7f664$var$Ae.throwError("cannot call constructor directly; use BigNumber.from", $dade464b59c7f664$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
    }
    fromTwos(t) {
        return $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).fromTwos(t));
    }
    toTwos(t) {
        return $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).toTwos(t));
    }
    abs() {
        return this._hex[0] === "-" ? $dade464b59c7f664$var$V.from(this._hex.substring(1)) : this;
    }
    add(t) {
        return $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).add($dade464b59c7f664$var$j(t)));
    }
    sub(t) {
        return $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).sub($dade464b59c7f664$var$j(t)));
    }
    div(t) {
        return $dade464b59c7f664$var$V.from(t).isZero() && $dade464b59c7f664$var$Wt("division-by-zero", "div"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).div($dade464b59c7f664$var$j(t)));
    }
    mul(t) {
        return $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).mul($dade464b59c7f664$var$j(t)));
    }
    mod(t) {
        const r = $dade464b59c7f664$var$j(t);
        return r.isNeg() && $dade464b59c7f664$var$Wt("division-by-zero", "mod"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).umod(r));
    }
    pow(t) {
        const r = $dade464b59c7f664$var$j(t);
        return r.isNeg() && $dade464b59c7f664$var$Wt("negative-power", "pow"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).pow(r));
    }
    and(t) {
        const r = $dade464b59c7f664$var$j(t);
        return (this.isNegative() || r.isNeg()) && $dade464b59c7f664$var$Wt("unbound-bitwise-result", "and"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).and(r));
    }
    or(t) {
        const r = $dade464b59c7f664$var$j(t);
        return (this.isNegative() || r.isNeg()) && $dade464b59c7f664$var$Wt("unbound-bitwise-result", "or"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).or(r));
    }
    xor(t) {
        const r = $dade464b59c7f664$var$j(t);
        return (this.isNegative() || r.isNeg()) && $dade464b59c7f664$var$Wt("unbound-bitwise-result", "xor"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).xor(r));
    }
    mask(t) {
        return (this.isNegative() || t < 0) && $dade464b59c7f664$var$Wt("negative-width", "mask"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).maskn(t));
    }
    shl(t) {
        return (this.isNegative() || t < 0) && $dade464b59c7f664$var$Wt("negative-width", "shl"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).shln(t));
    }
    shr(t) {
        return (this.isNegative() || t < 0) && $dade464b59c7f664$var$Wt("negative-width", "shr"), $dade464b59c7f664$var$Lt($dade464b59c7f664$var$j(this).shrn(t));
    }
    eq(t) {
        return $dade464b59c7f664$var$j(this).eq($dade464b59c7f664$var$j(t));
    }
    lt(t) {
        return $dade464b59c7f664$var$j(this).lt($dade464b59c7f664$var$j(t));
    }
    lte(t) {
        return $dade464b59c7f664$var$j(this).lte($dade464b59c7f664$var$j(t));
    }
    gt(t) {
        return $dade464b59c7f664$var$j(this).gt($dade464b59c7f664$var$j(t));
    }
    gte(t) {
        return $dade464b59c7f664$var$j(this).gte($dade464b59c7f664$var$j(t));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $dade464b59c7f664$var$j(this).isZero();
    }
    toNumber() {
        try {
            return $dade464b59c7f664$var$j(this).toNumber();
        } catch  {
            $dade464b59c7f664$var$Wt("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch  {}
        return $dade464b59c7f664$var$Ae.throwError("this platform does not support BigInt", $dade464b59c7f664$var$L.errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        return arguments.length > 0 && (arguments[0] === 10 ? $dade464b59c7f664$var$Gn || ($dade464b59c7f664$var$Gn = !0, $dade464b59c7f664$var$Ae.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? $dade464b59c7f664$var$Ae.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", $dade464b59c7f664$var$L.errors.UNEXPECTED_ARGUMENT, {}) : $dade464b59c7f664$var$Ae.throwError("BigNumber.toString does not accept parameters", $dade464b59c7f664$var$L.errors.UNEXPECTED_ARGUMENT, {})), $dade464b59c7f664$var$j(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(t) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(t) {
        if (t instanceof $dade464b59c7f664$var$V) return t;
        if (typeof t == "string") return t.match(/^-?0x[0-9a-f]+$/i) ? new $dade464b59c7f664$var$V($dade464b59c7f664$var$wi, $dade464b59c7f664$var$vr(t)) : t.match(/^-?[0-9]+$/) ? new $dade464b59c7f664$var$V($dade464b59c7f664$var$wi, $dade464b59c7f664$var$vr(new $dade464b59c7f664$var$Rr(t))) : $dade464b59c7f664$var$Ae.throwArgumentError("invalid BigNumber string", "value", t);
        if (typeof t == "number") return t % 1 && $dade464b59c7f664$var$Wt("underflow", "BigNumber.from", t), (t >= $dade464b59c7f664$var$Jn || t <= -$dade464b59c7f664$var$Jn) && $dade464b59c7f664$var$Wt("overflow", "BigNumber.from", t), $dade464b59c7f664$var$V.from(String(t));
        const r = t;
        if (typeof r == "bigint") return $dade464b59c7f664$var$V.from(r.toString());
        if ($dade464b59c7f664$var$ir(r)) return $dade464b59c7f664$var$V.from($dade464b59c7f664$var$Kt(r));
        if (r) {
            if (r.toHexString) {
                const i = r.toHexString();
                if (typeof i == "string") return $dade464b59c7f664$var$V.from(i);
            } else {
                let i = r._hex;
                if (i == null && r.type === "BigNumber" && (i = r.hex), typeof i == "string" && ($dade464b59c7f664$var$Qt(i) || i[0] === "-" && $dade464b59c7f664$var$Qt(i.substring(1)))) return $dade464b59c7f664$var$V.from(i);
            }
        }
        return $dade464b59c7f664$var$Ae.throwArgumentError("invalid BigNumber value", "value", t);
    }
    static isBigNumber(t) {
        return !!(t && t._isBigNumber);
    }
}
function $dade464b59c7f664$var$vr(e) {
    if (typeof e != "string") return $dade464b59c7f664$var$vr(e.toString(16));
    if (e[0] === "-") return e = e.substring(1), e[0] === "-" && $dade464b59c7f664$var$Ae.throwArgumentError("invalid hex", "value", e), e = $dade464b59c7f664$var$vr(e), e === "0x00" ? e : "-" + e;
    if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x") return "0x00";
    for(e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00";)e = "0x" + e.substring(4);
    return e;
}
function $dade464b59c7f664$var$Lt(e) {
    return $dade464b59c7f664$var$V.from($dade464b59c7f664$var$vr(e));
}
function $dade464b59c7f664$var$j(e) {
    const t = $dade464b59c7f664$var$V.from(e).toHexString();
    return t[0] === "-" ? new $dade464b59c7f664$var$Rr("-" + t.substring(3), 16) : new $dade464b59c7f664$var$Rr(t.substring(2), 16);
}
function $dade464b59c7f664$var$Wt(e, t, r) {
    const i = {
        fault: e,
        operation: t
    };
    return r != null && (i.value = r), $dade464b59c7f664$var$Ae.throwError(e, $dade464b59c7f664$var$L.errors.NUMERIC_FAULT, i);
}
function $dade464b59c7f664$var$Us(e) {
    return new $dade464b59c7f664$var$Rr(e, 36).toString(16);
}
const $dade464b59c7f664$var$Ht = new $dade464b59c7f664$var$L($dade464b59c7f664$var$Qn), $dade464b59c7f664$var$mr = {}, $dade464b59c7f664$var$Yn = $dade464b59c7f664$var$V.from(0), $dade464b59c7f664$var$Vn = $dade464b59c7f664$var$V.from(-1);
function $dade464b59c7f664$var$Wn(e, t, r, i) {
    const n = {
        fault: t,
        operation: r
    };
    return i !== void 0 && (n.value = i), $dade464b59c7f664$var$Ht.throwError(e, $dade464b59c7f664$var$L.errors.NUMERIC_FAULT, n);
}
let $dade464b59c7f664$var$gr = "0";
for(; $dade464b59c7f664$var$gr.length < 256;)$dade464b59c7f664$var$gr += $dade464b59c7f664$var$gr;
function $dade464b59c7f664$var$xi(e) {
    if (typeof e != "number") try {
        e = $dade464b59c7f664$var$V.from(e).toNumber();
    } catch  {}
    return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + $dade464b59c7f664$var$gr.substring(0, e) : $dade464b59c7f664$var$Ht.throwArgumentError("invalid decimal size", "decimals", e);
}
function $dade464b59c7f664$var$Mi(e, t) {
    t == null && (t = 0);
    const r = $dade464b59c7f664$var$xi(t);
    e = $dade464b59c7f664$var$V.from(e);
    const i = e.lt($dade464b59c7f664$var$Yn);
    i && (e = e.mul($dade464b59c7f664$var$Vn));
    let n = e.mod(r).toString();
    for(; n.length < r.length - 1;)n = "0" + n;
    n = n.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const o = e.div(r).toString();
    return r.length === 1 ? e = o : e = o + "." + n, i && (e = "-" + e), e;
}
function $dade464b59c7f664$var$be(e, t) {
    t == null && (t = 0);
    const r = $dade464b59c7f664$var$xi(t);
    (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && $dade464b59c7f664$var$Ht.throwArgumentError("invalid decimal value", "value", e);
    const i = e.substring(0, 1) === "-";
    i && (e = e.substring(1)), e === "." && $dade464b59c7f664$var$Ht.throwArgumentError("missing value", "value", e);
    const n = e.split(".");
    n.length > 2 && $dade464b59c7f664$var$Ht.throwArgumentError("too many decimal points", "value", e);
    let o = n[0], h = n[1];
    for(o || (o = "0"), h || (h = "0"); h[h.length - 1] === "0";)h = h.substring(0, h.length - 1);
    for(h.length > r.length - 1 && $dade464b59c7f664$var$Wn("fractional component exceeds decimals", "underflow", "parseFixed"), h === "" && (h = "0"); h.length < r.length - 1;)h += "0";
    const p = $dade464b59c7f664$var$V.from(o), A = $dade464b59c7f664$var$V.from(h);
    let m = p.mul(r).add(A);
    return i && (m = m.mul($dade464b59c7f664$var$Vn)), m;
}
class $dade464b59c7f664$var$dr {
    constructor(t, r, i, n){
        t !== $dade464b59c7f664$var$mr && $dade464b59c7f664$var$Ht.throwError("cannot use FixedFormat constructor; use FixedFormat.from", $dade464b59c7f664$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.signed = r, this.width = i, this.decimals = n, this.name = (r ? "" : "u") + "fixed" + String(i) + "x" + String(n), this._multiplier = $dade464b59c7f664$var$xi(n), Object.freeze(this);
    }
    static from(t) {
        if (t instanceof $dade464b59c7f664$var$dr) return t;
        typeof t == "number" && (t = `fixed128x${t}`);
        let r = !0, i = 128, n = 18;
        if (typeof t == "string") {
            if (t !== "fixed") {
                if (t === "ufixed") r = !1;
                else {
                    const o = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                    o || $dade464b59c7f664$var$Ht.throwArgumentError("invalid fixed format", "format", t), r = o[1] !== "u", i = parseInt(o[2]), n = parseInt(o[3]);
                }
            }
        } else if (t) {
            const o = (h, p, A)=>t[h] == null ? A : (typeof t[h] !== p && $dade464b59c7f664$var$Ht.throwArgumentError("invalid fixed format (" + h + " not " + p + ")", "format." + h, t[h]), t[h]);
            r = o("signed", "boolean", r), i = o("width", "number", i), n = o("decimals", "number", n);
        }
        return i % 8 && $dade464b59c7f664$var$Ht.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", i), n > 80 && $dade464b59c7f664$var$Ht.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", n), new $dade464b59c7f664$var$dr($dade464b59c7f664$var$mr, r, i, n);
    }
}
class $dade464b59c7f664$var$Ut {
    constructor(t, r, i, n){
        t !== $dade464b59c7f664$var$mr && $dade464b59c7f664$var$Ht.throwError("cannot use FixedNumber constructor; use FixedNumber.from", $dade464b59c7f664$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.format = n, this._hex = r, this._value = i, this._isFixedNumber = !0, Object.freeze(this);
    }
    _checkFormat(t) {
        this.format.name !== t.format.name && $dade464b59c7f664$var$Ht.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
    }
    addUnsafe(t) {
        this._checkFormat(t);
        const r = $dade464b59c7f664$var$be(this._value, this.format.decimals), i = $dade464b59c7f664$var$be(t._value, t.format.decimals);
        return $dade464b59c7f664$var$Ut.fromValue(r.add(i), this.format.decimals, this.format);
    }
    subUnsafe(t) {
        this._checkFormat(t);
        const r = $dade464b59c7f664$var$be(this._value, this.format.decimals), i = $dade464b59c7f664$var$be(t._value, t.format.decimals);
        return $dade464b59c7f664$var$Ut.fromValue(r.sub(i), this.format.decimals, this.format);
    }
    mulUnsafe(t) {
        this._checkFormat(t);
        const r = $dade464b59c7f664$var$be(this._value, this.format.decimals), i = $dade464b59c7f664$var$be(t._value, t.format.decimals);
        return $dade464b59c7f664$var$Ut.fromValue(r.mul(i).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(t) {
        this._checkFormat(t);
        const r = $dade464b59c7f664$var$be(this._value, this.format.decimals), i = $dade464b59c7f664$var$be(t._value, t.format.decimals);
        return $dade464b59c7f664$var$Ut.fromValue(r.mul(this.format._multiplier).div(i), this.format.decimals, this.format);
    }
    floor() {
        const t = this.toString().split(".");
        t.length === 1 && t.push("0");
        let r = $dade464b59c7f664$var$Ut.from(t[0], this.format);
        const i = !t[1].match(/^(0*)$/);
        return this.isNegative() && i && (r = r.subUnsafe($dade464b59c7f664$var$Xn.toFormat(r.format))), r;
    }
    ceiling() {
        const t = this.toString().split(".");
        t.length === 1 && t.push("0");
        let r = $dade464b59c7f664$var$Ut.from(t[0], this.format);
        const i = !t[1].match(/^(0*)$/);
        return !this.isNegative() && i && (r = r.addUnsafe($dade464b59c7f664$var$Xn.toFormat(r.format))), r;
    }
    round(t) {
        t == null && (t = 0);
        const r = this.toString().split(".");
        if (r.length === 1 && r.push("0"), (t < 0 || t > 80 || t % 1) && $dade464b59c7f664$var$Ht.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t) return this;
        const i = $dade464b59c7f664$var$Ut.from("1" + $dade464b59c7f664$var$gr.substring(0, t), this.format), n = $dade464b59c7f664$var$ks.toFormat(this.format);
        return this.mulUnsafe(i).addUnsafe(n).floor().divUnsafe(i);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(t) {
        if (t == null) return this._hex;
        t % 8 && $dade464b59c7f664$var$Ht.throwArgumentError("invalid byte width", "width", t);
        const r = $dade464b59c7f664$var$V.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
        return $dade464b59c7f664$var$oe(r, t / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(t) {
        return $dade464b59c7f664$var$Ut.fromString(this._value, t);
    }
    static fromValue(t, r, i) {
        return i == null && r != null && !$dade464b59c7f664$var$Ts(r) && (i = r, r = null), r == null && (r = 0), i == null && (i = "fixed"), $dade464b59c7f664$var$Ut.fromString($dade464b59c7f664$var$Mi(t, r), $dade464b59c7f664$var$dr.from(i));
    }
    static fromString(t, r) {
        r == null && (r = "fixed");
        const i = $dade464b59c7f664$var$dr.from(r), n = $dade464b59c7f664$var$be(t, i.decimals);
        !i.signed && n.lt($dade464b59c7f664$var$Yn) && $dade464b59c7f664$var$Wn("unsigned value cannot be negative", "overflow", "value", t);
        let o = null;
        i.signed ? o = n.toTwos(i.width).toHexString() : (o = n.toHexString(), o = $dade464b59c7f664$var$oe(o, i.width / 8));
        const h = $dade464b59c7f664$var$Mi(n, i.decimals);
        return new $dade464b59c7f664$var$Ut($dade464b59c7f664$var$mr, o, h, i);
    }
    static fromBytes(t, r) {
        r == null && (r = "fixed");
        const i = $dade464b59c7f664$var$dr.from(r);
        if ($dade464b59c7f664$var$Ot(t).length > i.width / 8) throw new Error("overflow");
        let n = $dade464b59c7f664$var$V.from(t);
        i.signed && (n = n.fromTwos(i.width));
        const o = n.toTwos((i.signed ? 0 : 1) + i.width).toHexString(), h = $dade464b59c7f664$var$Mi(n, i.decimals);
        return new $dade464b59c7f664$var$Ut($dade464b59c7f664$var$mr, o, h, i);
    }
    static from(t, r) {
        if (typeof t == "string") return $dade464b59c7f664$var$Ut.fromString(t, r);
        if ($dade464b59c7f664$var$ir(t)) return $dade464b59c7f664$var$Ut.fromBytes(t, r);
        try {
            return $dade464b59c7f664$var$Ut.fromValue(t, 0, r);
        } catch (i) {
            if (i.code !== $dade464b59c7f664$var$L.errors.INVALID_ARGUMENT) throw i;
        }
        return $dade464b59c7f664$var$Ht.throwArgumentError("invalid FixedNumber value", "value", t);
    }
    static isFixedNumber(t) {
        return !!(t && t._isFixedNumber);
    }
}
const $dade464b59c7f664$var$Xn = $dade464b59c7f664$var$Ut.from(1), $dade464b59c7f664$var$ks = $dade464b59c7f664$var$Ut.from("0.5"), $dade464b59c7f664$var$qs = "strings/5.7.0", $dade464b59c7f664$var$Zn = new $dade464b59c7f664$var$L($dade464b59c7f664$var$qs);
var $dade464b59c7f664$var$Or;
(function(e) {
    e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})($dade464b59c7f664$var$Or || ($dade464b59c7f664$var$Or = {}));
var $dade464b59c7f664$var$nr;
(function(e) {
    e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})($dade464b59c7f664$var$nr || ($dade464b59c7f664$var$nr = {}));
function $dade464b59c7f664$var$Ks(e, t, r, i, n) {
    return $dade464b59c7f664$var$Zn.throwArgumentError(`invalid codepoint at offset ${t}; ${e}`, "bytes", r);
}
function $dade464b59c7f664$var$$n(e, t, r, i, n) {
    if (e === $dade464b59c7f664$var$nr.BAD_PREFIX || e === $dade464b59c7f664$var$nr.UNEXPECTED_CONTINUE) {
        let o = 0;
        for(let h = t + 1; h < r.length && r[h] >> 6 === 2; h++)o++;
        return o;
    }
    return e === $dade464b59c7f664$var$nr.OVERRUN ? r.length - t - 1 : 0;
}
function $dade464b59c7f664$var$Hs(e, t, r, i, n) {
    return e === $dade464b59c7f664$var$nr.OVERLONG ? (i.push(n), 0) : (i.push(65533), $dade464b59c7f664$var$$n(e, t, r));
}
Object.freeze({
    error: $dade464b59c7f664$var$Ks,
    ignore: $dade464b59c7f664$var$$n,
    replace: $dade464b59c7f664$var$Hs
});
function $dade464b59c7f664$var$Ei(e, t = $dade464b59c7f664$var$Or.current) {
    t != $dade464b59c7f664$var$Or.current && ($dade464b59c7f664$var$Zn.checkNormalize(), e = e.normalize(t));
    let r = [];
    for(let i = 0; i < e.length; i++){
        const n = e.charCodeAt(i);
        if (n < 128) r.push(n);
        else if (n < 2048) r.push(n >> 6 | 192), r.push(n & 63 | 128);
        else if ((n & 64512) == 55296) {
            i++;
            const o = e.charCodeAt(i);
            if (i >= e.length || (o & 64512) !== 56320) throw new Error("invalid utf-8 string");
            const h = 65536 + ((n & 1023) << 10) + (o & 1023);
            r.push(h >> 18 | 240), r.push(h >> 12 & 63 | 128), r.push(h >> 6 & 63 | 128), r.push(h & 63 | 128);
        } else r.push(n >> 12 | 224), r.push(n >> 6 & 63 | 128), r.push(n & 63 | 128);
    }
    return $dade464b59c7f664$var$Ot(r);
}
function $dade464b59c7f664$var$zs(e) {
    if (e.length % 4 !== 0) throw new Error("bad data");
    let t = [];
    for(let r = 0; r < e.length; r += 4)t.push(parseInt(e.substring(r, r + 4), 16));
    return t;
}
function $dade464b59c7f664$var$Si(e, t) {
    t || (t = function(n) {
        return [
            parseInt(n, 16)
        ];
    });
    let r = 0, i = {};
    return e.split(",").forEach((n)=>{
        let o = n.split(":");
        r += parseInt(o[0], 16), i[r] = t(o[1]);
    }), i;
}
function $dade464b59c7f664$var$tf(e) {
    let t = 0;
    return e.split(",").map((r)=>{
        let i = r.split("-");
        i.length === 1 ? i[1] = "0" : i[1] === "" && (i[1] = "1");
        let n = t + parseInt(i[0], 16);
        return t = parseInt(i[1], 16), {
            l: n,
            h: t
        };
    });
}
$dade464b59c7f664$var$tf("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((e)=>parseInt(e, 16)), $dade464b59c7f664$var$Si("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), $dade464b59c7f664$var$Si("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), $dade464b59c7f664$var$Si("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $dade464b59c7f664$var$zs), $dade464b59c7f664$var$tf("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
const $dade464b59c7f664$var$ef = "hash/5.7.0";
function $dade464b59c7f664$var$Ls(e) {
    e = atob(e);
    const t = [];
    for(let r = 0; r < e.length; r++)t.push(e.charCodeAt(r));
    return $dade464b59c7f664$var$Ot(t);
}
function $dade464b59c7f664$var$rf(e, t) {
    t == null && (t = 1);
    const r = [], i = r.forEach, n = function(o, h) {
        i.call(o, function(p) {
            h > 0 && Array.isArray(p) ? n(p, h - 1) : r.push(p);
        });
    };
    return n(e, t), r;
}
function $dade464b59c7f664$var$js(e) {
    const t = {};
    for(let r = 0; r < e.length; r++){
        const i = e[r];
        t[i[0]] = i[1];
    }
    return t;
}
function $dade464b59c7f664$var$Qs(e) {
    let t = 0;
    function r() {
        return e[t++] << 8 | e[t++];
    }
    let i = r(), n = 1, o = [
        0,
        1
    ];
    for(let H = 1; H < i; H++)o.push(n += r());
    let h = r(), p = t;
    t += h;
    let A = 0, m = 0;
    function w() {
        return A == 0 && (m = m << 8 | e[t++], A = 8), m >> --A & 1;
    }
    const y = 31, S = Math.pow(2, y), I = S >>> 1, N = I >> 1, C = S - 1;
    let F = 0;
    for(let H = 0; H < y; H++)F = F << 1 | w();
    let U = [], J = 0, Bt = S;
    for(;;){
        let H = Math.floor(((F - J + 1) * n - 1) / Bt), z = 0, Pt = i;
        for(; Pt - z > 1;){
            let Yt = z + Pt >>> 1;
            H < o[Yt] ? Pt = Yt : z = Yt;
        }
        if (z == 0) break;
        U.push(z);
        let W = J + Math.floor(Bt * o[z] / n), Rt = J + Math.floor(Bt * o[z + 1] / n) - 1;
        for(; !((W ^ Rt) & I);)F = F << 1 & C | w(), W = W << 1 & C, Rt = Rt << 1 & C | 1;
        for(; W & ~Rt & N;)F = F & I | F << 1 & C >>> 1 | w(), W = W << 1 ^ I, Rt = (Rt ^ I) << 1 | I | 1;
        J = W, Bt = 1 + Rt - W;
    }
    let G = i - 4;
    return U.map((H)=>{
        switch(H - G){
            case 3:
                return G + 65792 + (e[p++] << 16 | e[p++] << 8 | e[p++]);
            case 2:
                return G + 256 + (e[p++] << 8 | e[p++]);
            case 1:
                return G + e[p++];
            default:
                return H - 1;
        }
    });
}
function $dade464b59c7f664$var$Js(e) {
    let t = 0;
    return ()=>e[t++];
}
function $dade464b59c7f664$var$Gs(e) {
    return $dade464b59c7f664$var$Js($dade464b59c7f664$var$Qs(e));
}
function $dade464b59c7f664$var$Ys(e) {
    return e & 1 ? ~e >> 1 : e >> 1;
}
function $dade464b59c7f664$var$Vs(e, t) {
    let r = Array(e);
    for(let i = 0; i < e; i++)r[i] = 1 + t();
    return r;
}
function $dade464b59c7f664$var$nf(e, t) {
    let r = Array(e);
    for(let i = 0, n = -1; i < e; i++)r[i] = n += 1 + t();
    return r;
}
function $dade464b59c7f664$var$Ws(e, t) {
    let r = Array(e);
    for(let i = 0, n = 0; i < e; i++)r[i] = n += $dade464b59c7f664$var$Ys(t());
    return r;
}
function $dade464b59c7f664$var$Pr(e, t) {
    let r = $dade464b59c7f664$var$nf(e(), e), i = e(), n = $dade464b59c7f664$var$nf(i, e), o = $dade464b59c7f664$var$Vs(i, e);
    for(let h = 0; h < i; h++)for(let p = 0; p < o[h]; p++)r.push(n[h] + p);
    return t ? r.map((h)=>t[h]) : r;
}
function $dade464b59c7f664$var$Xs(e) {
    let t = [];
    for(;;){
        let r = e();
        if (r == 0) break;
        t.push($dade464b59c7f664$var$$s(r, e));
    }
    for(;;){
        let r = e() - 1;
        if (r < 0) break;
        t.push($dade464b59c7f664$var$t0(r, e));
    }
    return $dade464b59c7f664$var$js($dade464b59c7f664$var$rf(t));
}
function $dade464b59c7f664$var$Zs(e) {
    let t = [];
    for(;;){
        let r = e();
        if (r == 0) break;
        t.push(r);
    }
    return t;
}
function $dade464b59c7f664$var$ff(e, t, r) {
    let i = Array(e).fill(void 0).map(()=>[]);
    for(let n = 0; n < t; n++)$dade464b59c7f664$var$Ws(e, r).forEach((o, h)=>i[h].push(o));
    return i;
}
function $dade464b59c7f664$var$$s(e, t) {
    let r = 1 + t(), i = t(), n = $dade464b59c7f664$var$Zs(t), o = $dade464b59c7f664$var$ff(n.length, 1 + e, t);
    return $dade464b59c7f664$var$rf(o.map((h, p)=>{
        const A = h[0], m = h.slice(1);
        return Array(n[p]).fill(void 0).map((w, y)=>{
            let S = y * i;
            return [
                A + y * r,
                m.map((I)=>I + S)
            ];
        });
    }));
}
function $dade464b59c7f664$var$t0(e, t) {
    let r = 1 + t();
    return $dade464b59c7f664$var$ff(r, 1 + e, t).map((n)=>[
            n[0],
            n.slice(1)
        ]);
}
function $dade464b59c7f664$var$e0(e) {
    let t = $dade464b59c7f664$var$Pr(e).sort((i, n)=>i - n);
    return r();
    function r() {
        let i = [];
        for(;;){
            let m = $dade464b59c7f664$var$Pr(e, t);
            if (m.length == 0) break;
            i.push({
                set: new Set(m),
                node: r()
            });
        }
        i.sort((m, w)=>w.set.size - m.set.size);
        let n = e(), o = n % 3;
        n = n / 3 | 0;
        let h = !!(n & 1);
        n >>= 1;
        let p = n == 1, A = n == 2;
        return {
            branches: i,
            valid: o,
            fe0f: h,
            save: p,
            check: A
        };
    }
}
function $dade464b59c7f664$var$r0() {
    return $dade464b59c7f664$var$Gs($dade464b59c7f664$var$Ls("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"));
}
const $dade464b59c7f664$var$Dr = $dade464b59c7f664$var$r0();
new Set($dade464b59c7f664$var$Pr($dade464b59c7f664$var$Dr)), new Set($dade464b59c7f664$var$Pr($dade464b59c7f664$var$Dr)), $dade464b59c7f664$var$Xs($dade464b59c7f664$var$Dr), $dade464b59c7f664$var$e0($dade464b59c7f664$var$Dr), new $dade464b59c7f664$var$L($dade464b59c7f664$var$ef);
const $dade464b59c7f664$var$i0 = new Uint8Array(32);
$dade464b59c7f664$var$i0.fill(0);
const $dade464b59c7f664$var$n0 = `Ethereum Signed Message:
`;
function $dade464b59c7f664$var$of(e) {
    return typeof e == "string" && (e = $dade464b59c7f664$var$Ei(e)), $dade464b59c7f664$var$yi($dade464b59c7f664$var$Cs([
        $dade464b59c7f664$var$Ei($dade464b59c7f664$var$n0),
        $dade464b59c7f664$var$Ei(String(e.length)),
        e
    ]));
}
const $dade464b59c7f664$var$f0 = "rlp/5.7.0";
new $dade464b59c7f664$var$L($dade464b59c7f664$var$f0);
const $dade464b59c7f664$var$o0 = "address/5.7.0", $dade464b59c7f664$var$Ar = new $dade464b59c7f664$var$L($dade464b59c7f664$var$o0);
function $dade464b59c7f664$var$sf(e) {
    $dade464b59c7f664$var$Qt(e, 20) || $dade464b59c7f664$var$Ar.throwArgumentError("invalid address", "address", e), e = e.toLowerCase();
    const t = e.substring(2).split(""), r = new Uint8Array(40);
    for(let n = 0; n < 40; n++)r[n] = t[n].charCodeAt(0);
    const i = $dade464b59c7f664$var$Ot($dade464b59c7f664$var$yi(r));
    for(let n = 0; n < 40; n += 2)i[n >> 1] >> 4 >= 8 && (t[n] = t[n].toUpperCase()), (i[n >> 1] & 15) >= 8 && (t[n + 1] = t[n + 1].toUpperCase());
    return "0x" + t.join("");
}
const $dade464b59c7f664$var$s0 = 9007199254740991;
function $dade464b59c7f664$var$a0(e) {
    return Math.log10 ? Math.log10(e) : Math.log(e) / Math.LN10;
}
const $dade464b59c7f664$var$Ni = {};
for(let e = 0; e < 10; e++)$dade464b59c7f664$var$Ni[String(e)] = String(e);
for(let e = 0; e < 26; e++)$dade464b59c7f664$var$Ni[String.fromCharCode(65 + e)] = String(10 + e);
const $dade464b59c7f664$var$af = Math.floor($dade464b59c7f664$var$a0($dade464b59c7f664$var$s0));
function $dade464b59c7f664$var$u0(e) {
    e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
    let t = e.split("").map((i)=>$dade464b59c7f664$var$Ni[i]).join("");
    for(; t.length >= $dade464b59c7f664$var$af;){
        let i = t.substring(0, $dade464b59c7f664$var$af);
        t = parseInt(i, 10) % 97 + t.substring(i.length);
    }
    let r = String(98 - parseInt(t, 10) % 97);
    for(; r.length < 2;)r = "0" + r;
    return r;
}
function $dade464b59c7f664$var$h0(e) {
    let t = null;
    if (typeof e != "string" && $dade464b59c7f664$var$Ar.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) e.substring(0, 2) !== "0x" && (e = "0x" + e), t = $dade464b59c7f664$var$sf(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && $dade464b59c7f664$var$Ar.throwArgumentError("bad address checksum", "address", e);
    else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        for(e.substring(2, 4) !== $dade464b59c7f664$var$u0(e) && $dade464b59c7f664$var$Ar.throwArgumentError("bad icap checksum", "address", e), t = $dade464b59c7f664$var$Us(e.substring(4)); t.length < 40;)t = "0" + t;
        t = $dade464b59c7f664$var$sf("0x" + t);
    } else $dade464b59c7f664$var$Ar.throwArgumentError("invalid address", "address", e);
    return t;
}
const $dade464b59c7f664$var$c0 = "properties/5.7.0";
new $dade464b59c7f664$var$L($dade464b59c7f664$var$c0);
function $dade464b59c7f664$var$br(e, t, r) {
    Object.defineProperty(e, t, {
        enumerable: !0,
        value: r,
        writable: !1
    });
}
new $dade464b59c7f664$var$L($dade464b59c7f664$var$ef);
const $dade464b59c7f664$var$l0 = new Uint8Array(32);
$dade464b59c7f664$var$l0.fill(0), $dade464b59c7f664$var$V.from(-1);
const $dade464b59c7f664$var$d0 = $dade464b59c7f664$var$V.from(0), $dade464b59c7f664$var$p0 = $dade464b59c7f664$var$V.from(1);
$dade464b59c7f664$var$V.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), $dade464b59c7f664$var$oe($dade464b59c7f664$var$p0.toHexString(), 32), $dade464b59c7f664$var$oe($dade464b59c7f664$var$d0.toHexString(), 32);
var $dade464b59c7f664$var$se = {}, $dade464b59c7f664$var$Q = {}, $dade464b59c7f664$var$yr = $dade464b59c7f664$var$uf;
function $dade464b59c7f664$var$uf(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$dade464b59c7f664$var$uf.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $dade464b59c7f664$var$Ii = {
    exports: {}
};
typeof Object.create == "function" ? $dade464b59c7f664$var$Ii.exports = function(t, r) {
    r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
        constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }));
} : $dade464b59c7f664$var$Ii.exports = function(t, r) {
    if (r) {
        t.super_ = r;
        var i = function() {};
        i.prototype = r.prototype, t.prototype = new i, t.prototype.constructor = t;
    }
};
var $dade464b59c7f664$var$v0 = $dade464b59c7f664$var$yr, $dade464b59c7f664$var$m0 = $dade464b59c7f664$var$Ii.exports;
$dade464b59c7f664$var$Q.inherits = $dade464b59c7f664$var$m0;
function $dade464b59c7f664$var$g0(e, t) {
    return (e.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= e.length ? !1 : (e.charCodeAt(t + 1) & 64512) === 56320;
}
function $dade464b59c7f664$var$A0(e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var r = [];
    if (typeof e == "string") {
        if (t) {
            if (t === "hex") for(e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
        } else for(var i = 0, n = 0; n < e.length; n++){
            var o = e.charCodeAt(n);
            o < 128 ? r[i++] = o : o < 2048 ? (r[i++] = o >> 6 | 192, r[i++] = o & 63 | 128) : $dade464b59c7f664$var$g0(e, n) ? (o = 65536 + ((o & 1023) << 10) + (e.charCodeAt(++n) & 1023), r[i++] = o >> 18 | 240, r[i++] = o >> 12 & 63 | 128, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128) : (r[i++] = o >> 12 | 224, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128);
        }
    } else for(n = 0; n < e.length; n++)r[n] = e[n] | 0;
    return r;
}
$dade464b59c7f664$var$Q.toArray = $dade464b59c7f664$var$A0;
function $dade464b59c7f664$var$b0(e) {
    for(var t = "", r = 0; r < e.length; r++)t += $dade464b59c7f664$var$cf(e[r].toString(16));
    return t;
}
$dade464b59c7f664$var$Q.toHex = $dade464b59c7f664$var$b0;
function $dade464b59c7f664$var$hf(e) {
    var t = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
    return t >>> 0;
}
$dade464b59c7f664$var$Q.htonl = $dade464b59c7f664$var$hf;
function $dade464b59c7f664$var$y0(e, t) {
    for(var r = "", i = 0; i < e.length; i++){
        var n = e[i];
        t === "little" && (n = $dade464b59c7f664$var$hf(n)), r += $dade464b59c7f664$var$lf(n.toString(16));
    }
    return r;
}
$dade464b59c7f664$var$Q.toHex32 = $dade464b59c7f664$var$y0;
function $dade464b59c7f664$var$cf(e) {
    return e.length === 1 ? "0" + e : e;
}
$dade464b59c7f664$var$Q.zero2 = $dade464b59c7f664$var$cf;
function $dade464b59c7f664$var$lf(e) {
    return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
$dade464b59c7f664$var$Q.zero8 = $dade464b59c7f664$var$lf;
function $dade464b59c7f664$var$w0(e, t, r, i) {
    var n = r - t;
    $dade464b59c7f664$var$v0(n % 4 === 0);
    for(var o = new Array(n / 4), h = 0, p = t; h < o.length; h++, p += 4){
        var A;
        i === "big" ? A = e[p] << 24 | e[p + 1] << 16 | e[p + 2] << 8 | e[p + 3] : A = e[p + 3] << 24 | e[p + 2] << 16 | e[p + 1] << 8 | e[p], o[h] = A >>> 0;
    }
    return o;
}
$dade464b59c7f664$var$Q.join32 = $dade464b59c7f664$var$w0;
function $dade464b59c7f664$var$x0(e, t) {
    for(var r = new Array(e.length * 4), i = 0, n = 0; i < e.length; i++, n += 4){
        var o = e[i];
        t === "big" ? (r[n] = o >>> 24, r[n + 1] = o >>> 16 & 255, r[n + 2] = o >>> 8 & 255, r[n + 3] = o & 255) : (r[n + 3] = o >>> 24, r[n + 2] = o >>> 16 & 255, r[n + 1] = o >>> 8 & 255, r[n] = o & 255);
    }
    return r;
}
$dade464b59c7f664$var$Q.split32 = $dade464b59c7f664$var$x0;
function $dade464b59c7f664$var$M0(e, t) {
    return e >>> t | e << 32 - t;
}
$dade464b59c7f664$var$Q.rotr32 = $dade464b59c7f664$var$M0;
function $dade464b59c7f664$var$E0(e, t) {
    return e << t | e >>> 32 - t;
}
$dade464b59c7f664$var$Q.rotl32 = $dade464b59c7f664$var$E0;
function $dade464b59c7f664$var$S0(e, t) {
    return e + t >>> 0;
}
$dade464b59c7f664$var$Q.sum32 = $dade464b59c7f664$var$S0;
function $dade464b59c7f664$var$N0(e, t, r) {
    return e + t + r >>> 0;
}
$dade464b59c7f664$var$Q.sum32_3 = $dade464b59c7f664$var$N0;
function $dade464b59c7f664$var$I0(e, t, r, i) {
    return e + t + r + i >>> 0;
}
$dade464b59c7f664$var$Q.sum32_4 = $dade464b59c7f664$var$I0;
function $dade464b59c7f664$var$_0(e, t, r, i, n) {
    return e + t + r + i + n >>> 0;
}
$dade464b59c7f664$var$Q.sum32_5 = $dade464b59c7f664$var$_0;
function $dade464b59c7f664$var$B0(e, t, r, i) {
    var n = e[t], o = e[t + 1], h = i + o >>> 0, p = (h < i ? 1 : 0) + r + n;
    e[t] = p >>> 0, e[t + 1] = h;
}
$dade464b59c7f664$var$Q.sum64 = $dade464b59c7f664$var$B0;
function $dade464b59c7f664$var$C0(e, t, r, i) {
    var n = t + i >>> 0, o = (n < t ? 1 : 0) + e + r;
    return o >>> 0;
}
$dade464b59c7f664$var$Q.sum64_hi = $dade464b59c7f664$var$C0;
function $dade464b59c7f664$var$R0(e, t, r, i) {
    var n = t + i;
    return n >>> 0;
}
$dade464b59c7f664$var$Q.sum64_lo = $dade464b59c7f664$var$R0;
function $dade464b59c7f664$var$O0(e, t, r, i, n, o, h, p) {
    var A = 0, m = t;
    m = m + i >>> 0, A += m < t ? 1 : 0, m = m + o >>> 0, A += m < o ? 1 : 0, m = m + p >>> 0, A += m < p ? 1 : 0;
    var w = e + r + n + h + A;
    return w >>> 0;
}
$dade464b59c7f664$var$Q.sum64_4_hi = $dade464b59c7f664$var$O0;
function $dade464b59c7f664$var$P0(e, t, r, i, n, o, h, p) {
    var A = t + i + o + p;
    return A >>> 0;
}
$dade464b59c7f664$var$Q.sum64_4_lo = $dade464b59c7f664$var$P0;
function $dade464b59c7f664$var$D0(e, t, r, i, n, o, h, p, A, m) {
    var w = 0, y = t;
    y = y + i >>> 0, w += y < t ? 1 : 0, y = y + o >>> 0, w += y < o ? 1 : 0, y = y + p >>> 0, w += y < p ? 1 : 0, y = y + m >>> 0, w += y < m ? 1 : 0;
    var S = e + r + n + h + A + w;
    return S >>> 0;
}
$dade464b59c7f664$var$Q.sum64_5_hi = $dade464b59c7f664$var$D0;
function $dade464b59c7f664$var$F0(e, t, r, i, n, o, h, p, A, m) {
    var w = t + i + o + p + m;
    return w >>> 0;
}
$dade464b59c7f664$var$Q.sum64_5_lo = $dade464b59c7f664$var$F0;
function $dade464b59c7f664$var$T0(e, t, r) {
    var i = t << 32 - r | e >>> r;
    return i >>> 0;
}
$dade464b59c7f664$var$Q.rotr64_hi = $dade464b59c7f664$var$T0;
function $dade464b59c7f664$var$U0(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$dade464b59c7f664$var$Q.rotr64_lo = $dade464b59c7f664$var$U0;
function $dade464b59c7f664$var$k0(e, t, r) {
    return e >>> r;
}
$dade464b59c7f664$var$Q.shr64_hi = $dade464b59c7f664$var$k0;
function $dade464b59c7f664$var$q0(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$dade464b59c7f664$var$Q.shr64_lo = $dade464b59c7f664$var$q0;
var $dade464b59c7f664$var$fr = {}, $dade464b59c7f664$var$df = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$K0 = $dade464b59c7f664$var$yr;
function $dade464b59c7f664$var$Fr() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
$dade464b59c7f664$var$fr.BlockHash = $dade464b59c7f664$var$Fr, $dade464b59c7f664$var$Fr.prototype.update = function(t, r) {
    if (t = $dade464b59c7f664$var$df.toArray(t, r), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
        t = this.pending;
        var i = t.length % this._delta8;
        this.pending = t.slice(t.length - i, t.length), this.pending.length === 0 && (this.pending = null), t = $dade464b59c7f664$var$df.join32(t, 0, t.length - i, this.endian);
        for(var n = 0; n < t.length; n += this._delta32)this._update(t, n, n + this._delta32);
    }
    return this;
}, $dade464b59c7f664$var$Fr.prototype.digest = function(t) {
    return this.update(this._pad()), $dade464b59c7f664$var$K0(this.pending === null), this._digest(t);
}, $dade464b59c7f664$var$Fr.prototype._pad = function() {
    var t = this.pendingTotal, r = this._delta8, i = r - (t + this.padLength) % r, n = new Array(i + this.padLength);
    n[0] = 128;
    for(var o = 1; o < i; o++)n[o] = 0;
    if (t <<= 3, this.endian === "big") {
        for(var h = 8; h < this.padLength; h++)n[o++] = 0;
        n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = t >>> 24 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 8 & 255, n[o++] = t & 255;
    } else for(n[o++] = t & 255, n[o++] = t >>> 8 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 24 & 255, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, h = 8; h < this.padLength; h++)n[o++] = 0;
    return n;
};
var $dade464b59c7f664$var$or = {}, $dade464b59c7f664$var$ae = {}, $dade464b59c7f664$var$H0 = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$ue = $dade464b59c7f664$var$H0.rotr32;
function $dade464b59c7f664$var$z0(e, t, r, i) {
    if (e === 0) return $dade464b59c7f664$var$pf(t, r, i);
    if (e === 1 || e === 3) return $dade464b59c7f664$var$mf(t, r, i);
    if (e === 2) return $dade464b59c7f664$var$vf(t, r, i);
}
$dade464b59c7f664$var$ae.ft_1 = $dade464b59c7f664$var$z0;
function $dade464b59c7f664$var$pf(e, t, r) {
    return e & t ^ ~e & r;
}
$dade464b59c7f664$var$ae.ch32 = $dade464b59c7f664$var$pf;
function $dade464b59c7f664$var$vf(e, t, r) {
    return e & t ^ e & r ^ t & r;
}
$dade464b59c7f664$var$ae.maj32 = $dade464b59c7f664$var$vf;
function $dade464b59c7f664$var$mf(e, t, r) {
    return e ^ t ^ r;
}
$dade464b59c7f664$var$ae.p32 = $dade464b59c7f664$var$mf;
function $dade464b59c7f664$var$L0(e) {
    return $dade464b59c7f664$var$ue(e, 2) ^ $dade464b59c7f664$var$ue(e, 13) ^ $dade464b59c7f664$var$ue(e, 22);
}
$dade464b59c7f664$var$ae.s0_256 = $dade464b59c7f664$var$L0;
function $dade464b59c7f664$var$j0(e) {
    return $dade464b59c7f664$var$ue(e, 6) ^ $dade464b59c7f664$var$ue(e, 11) ^ $dade464b59c7f664$var$ue(e, 25);
}
$dade464b59c7f664$var$ae.s1_256 = $dade464b59c7f664$var$j0;
function $dade464b59c7f664$var$Q0(e) {
    return $dade464b59c7f664$var$ue(e, 7) ^ $dade464b59c7f664$var$ue(e, 18) ^ e >>> 3;
}
$dade464b59c7f664$var$ae.g0_256 = $dade464b59c7f664$var$Q0;
function $dade464b59c7f664$var$J0(e) {
    return $dade464b59c7f664$var$ue(e, 17) ^ $dade464b59c7f664$var$ue(e, 19) ^ e >>> 10;
}
$dade464b59c7f664$var$ae.g1_256 = $dade464b59c7f664$var$J0;
var $dade464b59c7f664$var$sr = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$G0 = $dade464b59c7f664$var$fr, $dade464b59c7f664$var$Y0 = $dade464b59c7f664$var$ae, $dade464b59c7f664$var$_i = $dade464b59c7f664$var$sr.rotl32, $dade464b59c7f664$var$wr = $dade464b59c7f664$var$sr.sum32, $dade464b59c7f664$var$V0 = $dade464b59c7f664$var$sr.sum32_5, $dade464b59c7f664$var$W0 = $dade464b59c7f664$var$Y0.ft_1, $dade464b59c7f664$var$gf = $dade464b59c7f664$var$G0.BlockHash, $dade464b59c7f664$var$X0 = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
];
function $dade464b59c7f664$var$he() {
    if (!(this instanceof $dade464b59c7f664$var$he)) return new $dade464b59c7f664$var$he;
    $dade464b59c7f664$var$gf.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.W = new Array(80);
}
$dade464b59c7f664$var$sr.inherits($dade464b59c7f664$var$he, $dade464b59c7f664$var$gf);
var $dade464b59c7f664$var$Z0 = $dade464b59c7f664$var$he;
$dade464b59c7f664$var$he.blockSize = 512, $dade464b59c7f664$var$he.outSize = 160, $dade464b59c7f664$var$he.hmacStrength = 80, $dade464b59c7f664$var$he.padLength = 64, $dade464b59c7f664$var$he.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $dade464b59c7f664$var$_i(i[n - 3] ^ i[n - 8] ^ i[n - 14] ^ i[n - 16], 1);
    var o = this.h[0], h = this.h[1], p = this.h[2], A = this.h[3], m = this.h[4];
    for(n = 0; n < i.length; n++){
        var w = ~~(n / 20), y = $dade464b59c7f664$var$V0($dade464b59c7f664$var$_i(o, 5), $dade464b59c7f664$var$W0(w, h, p, A), m, i[n], $dade464b59c7f664$var$X0[w]);
        m = A, A = p, p = $dade464b59c7f664$var$_i(h, 30), h = o, o = y;
    }
    this.h[0] = $dade464b59c7f664$var$wr(this.h[0], o), this.h[1] = $dade464b59c7f664$var$wr(this.h[1], h), this.h[2] = $dade464b59c7f664$var$wr(this.h[2], p), this.h[3] = $dade464b59c7f664$var$wr(this.h[3], A), this.h[4] = $dade464b59c7f664$var$wr(this.h[4], m);
}, $dade464b59c7f664$var$he.prototype._digest = function(t) {
    return t === "hex" ? $dade464b59c7f664$var$sr.toHex32(this.h, "big") : $dade464b59c7f664$var$sr.split32(this.h, "big");
};
var $dade464b59c7f664$var$ar = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$$0 = $dade464b59c7f664$var$fr, $dade464b59c7f664$var$ur = $dade464b59c7f664$var$ae, $dade464b59c7f664$var$ta = $dade464b59c7f664$var$yr, $dade464b59c7f664$var$ie = $dade464b59c7f664$var$ar.sum32, $dade464b59c7f664$var$ea = $dade464b59c7f664$var$ar.sum32_4, $dade464b59c7f664$var$ra = $dade464b59c7f664$var$ar.sum32_5, $dade464b59c7f664$var$ia = $dade464b59c7f664$var$ur.ch32, $dade464b59c7f664$var$na = $dade464b59c7f664$var$ur.maj32, $dade464b59c7f664$var$fa = $dade464b59c7f664$var$ur.s0_256, $dade464b59c7f664$var$oa = $dade464b59c7f664$var$ur.s1_256, $dade464b59c7f664$var$sa = $dade464b59c7f664$var$ur.g0_256, $dade464b59c7f664$var$aa = $dade464b59c7f664$var$ur.g1_256, $dade464b59c7f664$var$Af = $dade464b59c7f664$var$$0.BlockHash, $dade464b59c7f664$var$ua = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
];
function $dade464b59c7f664$var$ce() {
    if (!(this instanceof $dade464b59c7f664$var$ce)) return new $dade464b59c7f664$var$ce;
    $dade464b59c7f664$var$Af.call(this), this.h = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ], this.k = $dade464b59c7f664$var$ua, this.W = new Array(64);
}
$dade464b59c7f664$var$ar.inherits($dade464b59c7f664$var$ce, $dade464b59c7f664$var$Af);
var $dade464b59c7f664$var$bf = $dade464b59c7f664$var$ce;
$dade464b59c7f664$var$ce.blockSize = 512, $dade464b59c7f664$var$ce.outSize = 256, $dade464b59c7f664$var$ce.hmacStrength = 192, $dade464b59c7f664$var$ce.padLength = 64, $dade464b59c7f664$var$ce.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $dade464b59c7f664$var$ea($dade464b59c7f664$var$aa(i[n - 2]), i[n - 7], $dade464b59c7f664$var$sa(i[n - 15]), i[n - 16]);
    var o = this.h[0], h = this.h[1], p = this.h[2], A = this.h[3], m = this.h[4], w = this.h[5], y = this.h[6], S = this.h[7];
    for($dade464b59c7f664$var$ta(this.k.length === i.length), n = 0; n < i.length; n++){
        var I = $dade464b59c7f664$var$ra(S, $dade464b59c7f664$var$oa(m), $dade464b59c7f664$var$ia(m, w, y), this.k[n], i[n]), N = $dade464b59c7f664$var$ie($dade464b59c7f664$var$fa(o), $dade464b59c7f664$var$na(o, h, p));
        S = y, y = w, w = m, m = $dade464b59c7f664$var$ie(A, I), A = p, p = h, h = o, o = $dade464b59c7f664$var$ie(I, N);
    }
    this.h[0] = $dade464b59c7f664$var$ie(this.h[0], o), this.h[1] = $dade464b59c7f664$var$ie(this.h[1], h), this.h[2] = $dade464b59c7f664$var$ie(this.h[2], p), this.h[3] = $dade464b59c7f664$var$ie(this.h[3], A), this.h[4] = $dade464b59c7f664$var$ie(this.h[4], m), this.h[5] = $dade464b59c7f664$var$ie(this.h[5], w), this.h[6] = $dade464b59c7f664$var$ie(this.h[6], y), this.h[7] = $dade464b59c7f664$var$ie(this.h[7], S);
}, $dade464b59c7f664$var$ce.prototype._digest = function(t) {
    return t === "hex" ? $dade464b59c7f664$var$ar.toHex32(this.h, "big") : $dade464b59c7f664$var$ar.split32(this.h, "big");
};
var $dade464b59c7f664$var$Bi = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$yf = $dade464b59c7f664$var$bf;
function $dade464b59c7f664$var$ye() {
    if (!(this instanceof $dade464b59c7f664$var$ye)) return new $dade464b59c7f664$var$ye;
    $dade464b59c7f664$var$yf.call(this), this.h = [
        3238371032,
        914150663,
        812702999,
        4144912697,
        4290775857,
        1750603025,
        1694076839,
        3204075428
    ];
}
$dade464b59c7f664$var$Bi.inherits($dade464b59c7f664$var$ye, $dade464b59c7f664$var$yf);
var $dade464b59c7f664$var$ha = $dade464b59c7f664$var$ye;
$dade464b59c7f664$var$ye.blockSize = 512, $dade464b59c7f664$var$ye.outSize = 224, $dade464b59c7f664$var$ye.hmacStrength = 192, $dade464b59c7f664$var$ye.padLength = 64, $dade464b59c7f664$var$ye.prototype._digest = function(t) {
    return t === "hex" ? $dade464b59c7f664$var$Bi.toHex32(this.h.slice(0, 7), "big") : $dade464b59c7f664$var$Bi.split32(this.h.slice(0, 7), "big");
};
var $dade464b59c7f664$var$jt = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$ca = $dade464b59c7f664$var$fr, $dade464b59c7f664$var$la = $dade464b59c7f664$var$yr, $dade464b59c7f664$var$le = $dade464b59c7f664$var$jt.rotr64_hi, $dade464b59c7f664$var$de = $dade464b59c7f664$var$jt.rotr64_lo, $dade464b59c7f664$var$wf = $dade464b59c7f664$var$jt.shr64_hi, $dade464b59c7f664$var$xf = $dade464b59c7f664$var$jt.shr64_lo, $dade464b59c7f664$var$Be = $dade464b59c7f664$var$jt.sum64, $dade464b59c7f664$var$Ci = $dade464b59c7f664$var$jt.sum64_hi, $dade464b59c7f664$var$Ri = $dade464b59c7f664$var$jt.sum64_lo, $dade464b59c7f664$var$da = $dade464b59c7f664$var$jt.sum64_4_hi, $dade464b59c7f664$var$pa = $dade464b59c7f664$var$jt.sum64_4_lo, $dade464b59c7f664$var$va = $dade464b59c7f664$var$jt.sum64_5_hi, $dade464b59c7f664$var$ma = $dade464b59c7f664$var$jt.sum64_5_lo, $dade464b59c7f664$var$Mf = $dade464b59c7f664$var$ca.BlockHash, $dade464b59c7f664$var$ga = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
];
function $dade464b59c7f664$var$ne() {
    if (!(this instanceof $dade464b59c7f664$var$ne)) return new $dade464b59c7f664$var$ne;
    $dade464b59c7f664$var$Mf.call(this), this.h = [
        1779033703,
        4089235720,
        3144134277,
        2227873595,
        1013904242,
        4271175723,
        2773480762,
        1595750129,
        1359893119,
        2917565137,
        2600822924,
        725511199,
        528734635,
        4215389547,
        1541459225,
        327033209
    ], this.k = $dade464b59c7f664$var$ga, this.W = new Array(160);
}
$dade464b59c7f664$var$jt.inherits($dade464b59c7f664$var$ne, $dade464b59c7f664$var$Mf);
var $dade464b59c7f664$var$Ef = $dade464b59c7f664$var$ne;
$dade464b59c7f664$var$ne.blockSize = 1024, $dade464b59c7f664$var$ne.outSize = 512, $dade464b59c7f664$var$ne.hmacStrength = 192, $dade464b59c7f664$var$ne.padLength = 128, $dade464b59c7f664$var$ne.prototype._prepareBlock = function(t, r) {
    for(var i = this.W, n = 0; n < 32; n++)i[n] = t[r + n];
    for(; n < i.length; n += 2){
        var o = $dade464b59c7f664$var$_a(i[n - 4], i[n - 3]), h = $dade464b59c7f664$var$Ba(i[n - 4], i[n - 3]), p = i[n - 14], A = i[n - 13], m = $dade464b59c7f664$var$Na(i[n - 30], i[n - 29]), w = $dade464b59c7f664$var$Ia(i[n - 30], i[n - 29]), y = i[n - 32], S = i[n - 31];
        i[n] = $dade464b59c7f664$var$da(o, h, p, A, m, w, y, S), i[n + 1] = $dade464b59c7f664$var$pa(o, h, p, A, m, w, y, S);
    }
}, $dade464b59c7f664$var$ne.prototype._update = function(t, r) {
    this._prepareBlock(t, r);
    var i = this.W, n = this.h[0], o = this.h[1], h = this.h[2], p = this.h[3], A = this.h[4], m = this.h[5], w = this.h[6], y = this.h[7], S = this.h[8], I = this.h[9], N = this.h[10], C = this.h[11], F = this.h[12], U = this.h[13], J = this.h[14], Bt = this.h[15];
    $dade464b59c7f664$var$la(this.k.length === i.length);
    for(var G = 0; G < i.length; G += 2){
        var H = J, z = Bt, Pt = $dade464b59c7f664$var$Ea(S, I), W = $dade464b59c7f664$var$Sa(S, I), Rt = $dade464b59c7f664$var$Aa(S, I, N, C, F), Yt = $dade464b59c7f664$var$ba(S, I, N, C, F, U), Y = this.k[G], Vt = this.k[G + 1], b = i[G], f = i[G + 1], a = $dade464b59c7f664$var$va(H, z, Pt, W, Rt, Yt, Y, Vt, b, f), c = $dade464b59c7f664$var$ma(H, z, Pt, W, Rt, Yt, Y, Vt, b, f);
        H = $dade464b59c7f664$var$xa(n, o), z = $dade464b59c7f664$var$Ma(n, o), Pt = $dade464b59c7f664$var$ya(n, o, h, p, A), W = $dade464b59c7f664$var$wa(n, o, h, p, A, m);
        var d = $dade464b59c7f664$var$Ci(H, z, Pt, W), g = $dade464b59c7f664$var$Ri(H, z, Pt, W);
        J = F, Bt = U, F = N, U = C, N = S, C = I, S = $dade464b59c7f664$var$Ci(w, y, a, c), I = $dade464b59c7f664$var$Ri(y, y, a, c), w = A, y = m, A = h, m = p, h = n, p = o, n = $dade464b59c7f664$var$Ci(a, c, d, g), o = $dade464b59c7f664$var$Ri(a, c, d, g);
    }
    $dade464b59c7f664$var$Be(this.h, 0, n, o), $dade464b59c7f664$var$Be(this.h, 2, h, p), $dade464b59c7f664$var$Be(this.h, 4, A, m), $dade464b59c7f664$var$Be(this.h, 6, w, y), $dade464b59c7f664$var$Be(this.h, 8, S, I), $dade464b59c7f664$var$Be(this.h, 10, N, C), $dade464b59c7f664$var$Be(this.h, 12, F, U), $dade464b59c7f664$var$Be(this.h, 14, J, Bt);
}, $dade464b59c7f664$var$ne.prototype._digest = function(t) {
    return t === "hex" ? $dade464b59c7f664$var$jt.toHex32(this.h, "big") : $dade464b59c7f664$var$jt.split32(this.h, "big");
};
function $dade464b59c7f664$var$Aa(e, t, r, i, n) {
    var o = e & r ^ ~e & n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$ba(e, t, r, i, n, o) {
    var h = t & i ^ ~t & o;
    return h < 0 && (h += 4294967296), h;
}
function $dade464b59c7f664$var$ya(e, t, r, i, n) {
    var o = e & r ^ e & n ^ r & n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$wa(e, t, r, i, n, o) {
    var h = t & i ^ t & o ^ i & o;
    return h < 0 && (h += 4294967296), h;
}
function $dade464b59c7f664$var$xa(e, t) {
    var r = $dade464b59c7f664$var$le(e, t, 28), i = $dade464b59c7f664$var$le(t, e, 2), n = $dade464b59c7f664$var$le(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$Ma(e, t) {
    var r = $dade464b59c7f664$var$de(e, t, 28), i = $dade464b59c7f664$var$de(t, e, 2), n = $dade464b59c7f664$var$de(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$Ea(e, t) {
    var r = $dade464b59c7f664$var$le(e, t, 14), i = $dade464b59c7f664$var$le(e, t, 18), n = $dade464b59c7f664$var$le(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$Sa(e, t) {
    var r = $dade464b59c7f664$var$de(e, t, 14), i = $dade464b59c7f664$var$de(e, t, 18), n = $dade464b59c7f664$var$de(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$Na(e, t) {
    var r = $dade464b59c7f664$var$le(e, t, 1), i = $dade464b59c7f664$var$le(e, t, 8), n = $dade464b59c7f664$var$wf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$Ia(e, t) {
    var r = $dade464b59c7f664$var$de(e, t, 1), i = $dade464b59c7f664$var$de(e, t, 8), n = $dade464b59c7f664$var$xf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$_a(e, t) {
    var r = $dade464b59c7f664$var$le(e, t, 19), i = $dade464b59c7f664$var$le(t, e, 29), n = $dade464b59c7f664$var$wf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $dade464b59c7f664$var$Ba(e, t) {
    var r = $dade464b59c7f664$var$de(e, t, 19), i = $dade464b59c7f664$var$de(t, e, 29), n = $dade464b59c7f664$var$xf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
var $dade464b59c7f664$var$Oi = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$Sf = $dade464b59c7f664$var$Ef;
function $dade464b59c7f664$var$we() {
    if (!(this instanceof $dade464b59c7f664$var$we)) return new $dade464b59c7f664$var$we;
    $dade464b59c7f664$var$Sf.call(this), this.h = [
        3418070365,
        3238371032,
        1654270250,
        914150663,
        2438529370,
        812702999,
        355462360,
        4144912697,
        1731405415,
        4290775857,
        2394180231,
        1750603025,
        3675008525,
        1694076839,
        1203062813,
        3204075428
    ];
}
$dade464b59c7f664$var$Oi.inherits($dade464b59c7f664$var$we, $dade464b59c7f664$var$Sf);
var $dade464b59c7f664$var$Ca = $dade464b59c7f664$var$we;
$dade464b59c7f664$var$we.blockSize = 1024, $dade464b59c7f664$var$we.outSize = 384, $dade464b59c7f664$var$we.hmacStrength = 192, $dade464b59c7f664$var$we.padLength = 128, $dade464b59c7f664$var$we.prototype._digest = function(t) {
    return t === "hex" ? $dade464b59c7f664$var$Oi.toHex32(this.h.slice(0, 12), "big") : $dade464b59c7f664$var$Oi.split32(this.h.slice(0, 12), "big");
}, $dade464b59c7f664$var$or.sha1 = $dade464b59c7f664$var$Z0, $dade464b59c7f664$var$or.sha224 = $dade464b59c7f664$var$ha, $dade464b59c7f664$var$or.sha256 = $dade464b59c7f664$var$bf, $dade464b59c7f664$var$or.sha384 = $dade464b59c7f664$var$Ca, $dade464b59c7f664$var$or.sha512 = $dade464b59c7f664$var$Ef;
var $dade464b59c7f664$var$Nf = {}, $dade464b59c7f664$var$Xe = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$Ra = $dade464b59c7f664$var$fr, $dade464b59c7f664$var$Tr = $dade464b59c7f664$var$Xe.rotl32, $dade464b59c7f664$var$If = $dade464b59c7f664$var$Xe.sum32, $dade464b59c7f664$var$xr = $dade464b59c7f664$var$Xe.sum32_3, $dade464b59c7f664$var$_f = $dade464b59c7f664$var$Xe.sum32_4, $dade464b59c7f664$var$Bf = $dade464b59c7f664$var$Ra.BlockHash;
function $dade464b59c7f664$var$pe() {
    if (!(this instanceof $dade464b59c7f664$var$pe)) return new $dade464b59c7f664$var$pe;
    $dade464b59c7f664$var$Bf.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.endian = "little";
}
$dade464b59c7f664$var$Xe.inherits($dade464b59c7f664$var$pe, $dade464b59c7f664$var$Bf), $dade464b59c7f664$var$Nf.ripemd160 = $dade464b59c7f664$var$pe, $dade464b59c7f664$var$pe.blockSize = 512, $dade464b59c7f664$var$pe.outSize = 160, $dade464b59c7f664$var$pe.hmacStrength = 192, $dade464b59c7f664$var$pe.padLength = 64, $dade464b59c7f664$var$pe.prototype._update = function(t, r) {
    for(var i = this.h[0], n = this.h[1], o = this.h[2], h = this.h[3], p = this.h[4], A = i, m = n, w = o, y = h, S = p, I = 0; I < 80; I++){
        var N = $dade464b59c7f664$var$If($dade464b59c7f664$var$Tr($dade464b59c7f664$var$_f(i, $dade464b59c7f664$var$Cf(I, n, o, h), t[$dade464b59c7f664$var$Da[I] + r], $dade464b59c7f664$var$Oa(I)), $dade464b59c7f664$var$Ta[I]), p);
        i = p, p = h, h = $dade464b59c7f664$var$Tr(o, 10), o = n, n = N, N = $dade464b59c7f664$var$If($dade464b59c7f664$var$Tr($dade464b59c7f664$var$_f(A, $dade464b59c7f664$var$Cf(79 - I, m, w, y), t[$dade464b59c7f664$var$Fa[I] + r], $dade464b59c7f664$var$Pa(I)), $dade464b59c7f664$var$Ua[I]), S), A = S, S = y, y = $dade464b59c7f664$var$Tr(w, 10), w = m, m = N;
    }
    N = $dade464b59c7f664$var$xr(this.h[1], o, y), this.h[1] = $dade464b59c7f664$var$xr(this.h[2], h, S), this.h[2] = $dade464b59c7f664$var$xr(this.h[3], p, A), this.h[3] = $dade464b59c7f664$var$xr(this.h[4], i, m), this.h[4] = $dade464b59c7f664$var$xr(this.h[0], n, w), this.h[0] = N;
}, $dade464b59c7f664$var$pe.prototype._digest = function(t) {
    return t === "hex" ? $dade464b59c7f664$var$Xe.toHex32(this.h, "little") : $dade464b59c7f664$var$Xe.split32(this.h, "little");
};
function $dade464b59c7f664$var$Cf(e, t, r, i) {
    return e <= 15 ? t ^ r ^ i : e <= 31 ? t & r | ~t & i : e <= 47 ? (t | ~r) ^ i : e <= 63 ? t & i | r & ~i : t ^ (r | ~i);
}
function $dade464b59c7f664$var$Oa(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function $dade464b59c7f664$var$Pa(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var $dade464b59c7f664$var$Da = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
], $dade464b59c7f664$var$Fa = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
], $dade464b59c7f664$var$Ta = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
], $dade464b59c7f664$var$Ua = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
], $dade464b59c7f664$var$ka = $dade464b59c7f664$var$Q, $dade464b59c7f664$var$qa = $dade464b59c7f664$var$yr;
function $dade464b59c7f664$var$hr(e, t, r) {
    if (!(this instanceof $dade464b59c7f664$var$hr)) return new $dade464b59c7f664$var$hr(e, t, r);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init($dade464b59c7f664$var$ka.toArray(t, r));
}
var $dade464b59c7f664$var$Ka = $dade464b59c7f664$var$hr;
$dade464b59c7f664$var$hr.prototype._init = function(t) {
    t.length > this.blockSize && (t = new this.Hash().update(t).digest()), $dade464b59c7f664$var$qa(t.length <= this.blockSize);
    for(var r = t.length; r < this.blockSize; r++)t.push(0);
    for(r = 0; r < t.length; r++)t[r] ^= 54;
    for(this.inner = new this.Hash().update(t), r = 0; r < t.length; r++)t[r] ^= 106;
    this.outer = new this.Hash().update(t);
}, $dade464b59c7f664$var$hr.prototype.update = function(t, r) {
    return this.inner.update(t, r), this;
}, $dade464b59c7f664$var$hr.prototype.digest = function(t) {
    return this.outer.update(this.inner.digest()), this.outer.digest(t);
}, function(e) {
    var t = e;
    t.utils = $dade464b59c7f664$var$Q, t.common = $dade464b59c7f664$var$fr, t.sha = $dade464b59c7f664$var$or, t.ripemd = $dade464b59c7f664$var$Nf, t.hmac = $dade464b59c7f664$var$Ka, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
}($dade464b59c7f664$var$se);
function $dade464b59c7f664$var$cr(e, t, r) {
    return r = {
        path: t,
        exports: {},
        require: function(i, n) {
            return $dade464b59c7f664$var$Ha(i, n ?? r.path);
        }
    }, e(r, r.exports), r.exports;
}
function $dade464b59c7f664$var$Ha() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $dade464b59c7f664$var$Pi = $dade464b59c7f664$var$Rf;
function $dade464b59c7f664$var$Rf(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$dade464b59c7f664$var$Rf.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $dade464b59c7f664$var$fe = $dade464b59c7f664$var$cr(function(e, t) {
    var r = t;
    function i(h, p) {
        if (Array.isArray(h)) return h.slice();
        if (!h) return [];
        var A = [];
        if (typeof h != "string") {
            for(var m = 0; m < h.length; m++)A[m] = h[m] | 0;
            return A;
        }
        if (p === "hex") {
            h = h.replace(/[^a-z0-9]+/ig, ""), h.length % 2 !== 0 && (h = "0" + h);
            for(var m = 0; m < h.length; m += 2)A.push(parseInt(h[m] + h[m + 1], 16));
        } else for(var m = 0; m < h.length; m++){
            var w = h.charCodeAt(m), y = w >> 8, S = w & 255;
            y ? A.push(y, S) : A.push(S);
        }
        return A;
    }
    r.toArray = i;
    function n(h) {
        return h.length === 1 ? "0" + h : h;
    }
    r.zero2 = n;
    function o(h) {
        for(var p = "", A = 0; A < h.length; A++)p += n(h[A].toString(16));
        return p;
    }
    r.toHex = o, r.encode = function(p, A) {
        return A === "hex" ? o(p) : p;
    };
}), $dade464b59c7f664$var$Jt = $dade464b59c7f664$var$cr(function(e, t) {
    var r = t;
    r.assert = $dade464b59c7f664$var$Pi, r.toArray = $dade464b59c7f664$var$fe.toArray, r.zero2 = $dade464b59c7f664$var$fe.zero2, r.toHex = $dade464b59c7f664$var$fe.toHex, r.encode = $dade464b59c7f664$var$fe.encode;
    function i(A, m, w) {
        var y = new Array(Math.max(A.bitLength(), w) + 1);
        y.fill(0);
        for(var S = 1 << m + 1, I = A.clone(), N = 0; N < y.length; N++){
            var C, F = I.andln(S - 1);
            I.isOdd() ? (F > (S >> 1) - 1 ? C = (S >> 1) - F : C = F, I.isubn(C)) : C = 0, y[N] = C, I.iushrn(1);
        }
        return y;
    }
    r.getNAF = i;
    function n(A, m) {
        var w = [
            [],
            []
        ];
        A = A.clone(), m = m.clone();
        for(var y = 0, S = 0, I; A.cmpn(-y) > 0 || m.cmpn(-S) > 0;){
            var N = A.andln(3) + y & 3, C = m.andln(3) + S & 3;
            N === 3 && (N = -1), C === 3 && (C = -1);
            var F;
            N & 1 ? (I = A.andln(7) + y & 7, (I === 3 || I === 5) && C === 2 ? F = -N : F = N) : F = 0, w[0].push(F);
            var U;
            C & 1 ? (I = m.andln(7) + S & 7, (I === 3 || I === 5) && N === 2 ? U = -C : U = C) : U = 0, w[1].push(U), 2 * y === F + 1 && (y = 1 - y), 2 * S === U + 1 && (S = 1 - S), A.iushrn(1), m.iushrn(1);
        }
        return w;
    }
    r.getJSF = n;
    function o(A, m, w) {
        var y = "_" + m;
        A.prototype[m] = function() {
            return this[y] !== void 0 ? this[y] : this[y] = w.call(this);
        };
    }
    r.cachedProperty = o;
    function h(A) {
        return typeof A == "string" ? r.toArray(A, "hex") : A;
    }
    r.parseBytes = h;
    function p(A) {
        return new $dade464b59c7f664$var$K(A, "hex", "le");
    }
    r.intFromLE = p;
}), $dade464b59c7f664$var$Ur = $dade464b59c7f664$var$Jt.getNAF, $dade464b59c7f664$var$za = $dade464b59c7f664$var$Jt.getJSF, $dade464b59c7f664$var$kr = $dade464b59c7f664$var$Jt.assert;
function $dade464b59c7f664$var$Ce(e, t) {
    this.type = e, this.p = new $dade464b59c7f664$var$K(t.p, 16), this.red = t.prime ? $dade464b59c7f664$var$K.red(t.prime) : $dade464b59c7f664$var$K.mont(this.p), this.zero = new $dade464b59c7f664$var$K(0).toRed(this.red), this.one = new $dade464b59c7f664$var$K(1).toRed(this.red), this.two = new $dade464b59c7f664$var$K(2).toRed(this.red), this.n = t.n && new $dade464b59c7f664$var$K(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var r = this.n && this.p.div(this.n);
    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var $dade464b59c7f664$var$Ze = $dade464b59c7f664$var$Ce;
$dade464b59c7f664$var$Ce.prototype.point = function() {
    throw new Error("Not implemented");
}, $dade464b59c7f664$var$Ce.prototype.validate = function() {
    throw new Error("Not implemented");
}, $dade464b59c7f664$var$Ce.prototype._fixedNafMul = function(t, r) {
    $dade464b59c7f664$var$kr(t.precomputed);
    var i = t._getDoubles(), n = $dade464b59c7f664$var$Ur(r, 1, this._bitLength), o = (1 << i.step + 1) - (i.step % 2 === 0 ? 2 : 1);
    o /= 3;
    var h = [], p, A;
    for(p = 0; p < n.length; p += i.step){
        A = 0;
        for(var m = p + i.step - 1; m >= p; m--)A = (A << 1) + n[m];
        h.push(A);
    }
    for(var w = this.jpoint(null, null, null), y = this.jpoint(null, null, null), S = o; S > 0; S--){
        for(p = 0; p < h.length; p++)A = h[p], A === S ? y = y.mixedAdd(i.points[p]) : A === -S && (y = y.mixedAdd(i.points[p].neg()));
        w = w.add(y);
    }
    return w.toP();
}, $dade464b59c7f664$var$Ce.prototype._wnafMul = function(t, r) {
    var i = 4, n = t._getNAFPoints(i);
    i = n.wnd;
    for(var o = n.points, h = $dade464b59c7f664$var$Ur(r, i, this._bitLength), p = this.jpoint(null, null, null), A = h.length - 1; A >= 0; A--){
        for(var m = 0; A >= 0 && h[A] === 0; A--)m++;
        if (A >= 0 && m++, p = p.dblp(m), A < 0) break;
        var w = h[A];
        $dade464b59c7f664$var$kr(w !== 0), t.type === "affine" ? w > 0 ? p = p.mixedAdd(o[w - 1 >> 1]) : p = p.mixedAdd(o[-w - 1 >> 1].neg()) : w > 0 ? p = p.add(o[w - 1 >> 1]) : p = p.add(o[-w - 1 >> 1].neg());
    }
    return t.type === "affine" ? p.toP() : p;
}, $dade464b59c7f664$var$Ce.prototype._wnafMulAdd = function(t, r, i, n, o) {
    var h = this._wnafT1, p = this._wnafT2, A = this._wnafT3, m = 0, w, y, S;
    for(w = 0; w < n; w++){
        S = r[w];
        var I = S._getNAFPoints(t);
        h[w] = I.wnd, p[w] = I.points;
    }
    for(w = n - 1; w >= 1; w -= 2){
        var N = w - 1, C = w;
        if (h[N] !== 1 || h[C] !== 1) {
            A[N] = $dade464b59c7f664$var$Ur(i[N], h[N], this._bitLength), A[C] = $dade464b59c7f664$var$Ur(i[C], h[C], this._bitLength), m = Math.max(A[N].length, m), m = Math.max(A[C].length, m);
            continue;
        }
        var F = [
            r[N],
            null,
            null,
            r[C]
        ];
        r[N].y.cmp(r[C].y) === 0 ? (F[1] = r[N].add(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg())) : r[N].y.cmp(r[C].y.redNeg()) === 0 ? (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].add(r[C].neg())) : (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg()));
        var U = [
            -3,
            -1,
            -5,
            -7,
            0,
            7,
            5,
            1,
            3
        ], J = $dade464b59c7f664$var$za(i[N], i[C]);
        for(m = Math.max(J[0].length, m), A[N] = new Array(m), A[C] = new Array(m), y = 0; y < m; y++){
            var Bt = J[0][y] | 0, G = J[1][y] | 0;
            A[N][y] = U[(Bt + 1) * 3 + (G + 1)], A[C][y] = 0, p[N] = F;
        }
    }
    var H = this.jpoint(null, null, null), z = this._wnafT4;
    for(w = m; w >= 0; w--){
        for(var Pt = 0; w >= 0;){
            var W = !0;
            for(y = 0; y < n; y++)z[y] = A[y][w] | 0, z[y] !== 0 && (W = !1);
            if (!W) break;
            Pt++, w--;
        }
        if (w >= 0 && Pt++, H = H.dblp(Pt), w < 0) break;
        for(y = 0; y < n; y++){
            var Rt = z[y];
            Rt !== 0 && (Rt > 0 ? S = p[y][Rt - 1 >> 1] : Rt < 0 && (S = p[y][-Rt - 1 >> 1].neg()), S.type === "affine" ? H = H.mixedAdd(S) : H = H.add(S));
        }
    }
    for(w = 0; w < n; w++)p[w] = null;
    return o ? H : H.toP();
};
function $dade464b59c7f664$var$Xt(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
}
$dade464b59c7f664$var$Ce.BasePoint = $dade464b59c7f664$var$Xt, $dade464b59c7f664$var$Xt.prototype.eq = function() {
    throw new Error("Not implemented");
}, $dade464b59c7f664$var$Xt.prototype.validate = function() {
    return this.curve.validate(this);
}, $dade464b59c7f664$var$Ce.prototype.decodePoint = function(t, r) {
    t = $dade464b59c7f664$var$Jt.toArray(t, r);
    var i = this.p.byteLength();
    if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * i) {
        t[0] === 6 ? $dade464b59c7f664$var$kr(t[t.length - 1] % 2 === 0) : t[0] === 7 && $dade464b59c7f664$var$kr(t[t.length - 1] % 2 === 1);
        var n = this.point(t.slice(1, 1 + i), t.slice(1 + i, 1 + 2 * i));
        return n;
    } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === i) return this.pointFromX(t.slice(1, 1 + i), t[0] === 3);
    throw new Error("Unknown point format");
}, $dade464b59c7f664$var$Xt.prototype.encodeCompressed = function(t) {
    return this.encode(t, !0);
}, $dade464b59c7f664$var$Xt.prototype._encode = function(t) {
    var r = this.curve.p.byteLength(), i = this.getX().toArray("be", r);
    return t ? [
        this.getY().isEven() ? 2 : 3
    ].concat(i) : [
        4
    ].concat(i, this.getY().toArray("be", r));
}, $dade464b59c7f664$var$Xt.prototype.encode = function(t, r) {
    return $dade464b59c7f664$var$Jt.encode(this._encode(r), t);
}, $dade464b59c7f664$var$Xt.prototype.precompute = function(t) {
    if (this.precomputed) return this;
    var r = {
        doubles: null,
        naf: null,
        beta: null
    };
    return r.naf = this._getNAFPoints(8), r.doubles = this._getDoubles(4, t), r.beta = this._getBeta(), this.precomputed = r, this;
}, $dade464b59c7f664$var$Xt.prototype._hasDoubles = function(t) {
    if (!this.precomputed) return !1;
    var r = this.precomputed.doubles;
    return r ? r.points.length >= Math.ceil((t.bitLength() + 1) / r.step) : !1;
}, $dade464b59c7f664$var$Xt.prototype._getDoubles = function(t, r) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    for(var i = [
        this
    ], n = this, o = 0; o < r; o += t){
        for(var h = 0; h < t; h++)n = n.dbl();
        i.push(n);
    }
    return {
        step: t,
        points: i
    };
}, $dade464b59c7f664$var$Xt.prototype._getNAFPoints = function(t) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    for(var r = [
        this
    ], i = (1 << t) - 1, n = i === 1 ? null : this.dbl(), o = 1; o < i; o++)r[o] = r[o - 1].add(n);
    return {
        wnd: t,
        points: r
    };
}, $dade464b59c7f664$var$Xt.prototype._getBeta = function() {
    return null;
}, $dade464b59c7f664$var$Xt.prototype.dblp = function(t) {
    for(var r = this, i = 0; i < t; i++)r = r.dbl();
    return r;
};
var $dade464b59c7f664$var$Di = $dade464b59c7f664$var$cr(function(e) {
    typeof Object.create == "function" ? e.exports = function(r, i) {
        i && (r.super_ = i, r.prototype = Object.create(i.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }));
    } : e.exports = function(r, i) {
        if (i) {
            r.super_ = i;
            var n = function() {};
            n.prototype = i.prototype, r.prototype = new n, r.prototype.constructor = r;
        }
    };
}), $dade464b59c7f664$var$La = $dade464b59c7f664$var$Jt.assert;
function $dade464b59c7f664$var$Zt(e) {
    $dade464b59c7f664$var$Ze.call(this, "short", e), this.a = new $dade464b59c7f664$var$K(e.a, 16).toRed(this.red), this.b = new $dade464b59c7f664$var$K(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
$dade464b59c7f664$var$Di($dade464b59c7f664$var$Zt, $dade464b59c7f664$var$Ze);
var $dade464b59c7f664$var$ja = $dade464b59c7f664$var$Zt;
$dade464b59c7f664$var$Zt.prototype._getEndomorphism = function(t) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
        var r, i;
        if (t.beta) r = new $dade464b59c7f664$var$K(t.beta, 16).toRed(this.red);
        else {
            var n = this._getEndoRoots(this.p);
            r = n[0].cmp(n[1]) < 0 ? n[0] : n[1], r = r.toRed(this.red);
        }
        if (t.lambda) i = new $dade464b59c7f664$var$K(t.lambda, 16);
        else {
            var o = this._getEndoRoots(this.n);
            this.g.mul(o[0]).x.cmp(this.g.x.redMul(r)) === 0 ? i = o[0] : (i = o[1], $dade464b59c7f664$var$La(this.g.mul(i).x.cmp(this.g.x.redMul(r)) === 0));
        }
        var h;
        return t.basis ? h = t.basis.map(function(p) {
            return {
                a: new $dade464b59c7f664$var$K(p.a, 16),
                b: new $dade464b59c7f664$var$K(p.b, 16)
            };
        }) : h = this._getEndoBasis(i), {
            beta: r,
            lambda: i,
            basis: h
        };
    }
}, $dade464b59c7f664$var$Zt.prototype._getEndoRoots = function(t) {
    var r = t === this.p ? this.red : $dade464b59c7f664$var$K.mont(t), i = new $dade464b59c7f664$var$K(2).toRed(r).redInvm(), n = i.redNeg(), o = new $dade464b59c7f664$var$K(3).toRed(r).redNeg().redSqrt().redMul(i), h = n.redAdd(o).fromRed(), p = n.redSub(o).fromRed();
    return [
        h,
        p
    ];
}, $dade464b59c7f664$var$Zt.prototype._getEndoBasis = function(t) {
    for(var r = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), i = t, n = this.n.clone(), o = new $dade464b59c7f664$var$K(1), h = new $dade464b59c7f664$var$K(0), p = new $dade464b59c7f664$var$K(0), A = new $dade464b59c7f664$var$K(1), m, w, y, S, I, N, C, F = 0, U, J; i.cmpn(0) !== 0;){
        var Bt = n.div(i);
        U = n.sub(Bt.mul(i)), J = p.sub(Bt.mul(o));
        var G = A.sub(Bt.mul(h));
        if (!y && U.cmp(r) < 0) m = C.neg(), w = o, y = U.neg(), S = J;
        else if (y && ++F === 2) break;
        C = U, n = i, i = U, p = o, o = J, A = h, h = G;
    }
    I = U.neg(), N = J;
    var H = y.sqr().add(S.sqr()), z = I.sqr().add(N.sqr());
    return z.cmp(H) >= 0 && (I = m, N = w), y.negative && (y = y.neg(), S = S.neg()), I.negative && (I = I.neg(), N = N.neg()), [
        {
            a: y,
            b: S
        },
        {
            a: I,
            b: N
        }
    ];
}, $dade464b59c7f664$var$Zt.prototype._endoSplit = function(t) {
    var r = this.endo.basis, i = r[0], n = r[1], o = n.b.mul(t).divRound(this.n), h = i.b.neg().mul(t).divRound(this.n), p = o.mul(i.a), A = h.mul(n.a), m = o.mul(i.b), w = h.mul(n.b), y = t.sub(p).sub(A), S = m.add(w).neg();
    return {
        k1: y,
        k2: S
    };
}, $dade464b59c7f664$var$Zt.prototype.pointFromX = function(t, r) {
    t = new $dade464b59c7f664$var$K(t, 16), t.red || (t = t.toRed(this.red));
    var i = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), n = i.redSqrt();
    if (n.redSqr().redSub(i).cmp(this.zero) !== 0) throw new Error("invalid point");
    var o = n.fromRed().isOdd();
    return (r && !o || !r && o) && (n = n.redNeg()), this.point(t, n);
}, $dade464b59c7f664$var$Zt.prototype.validate = function(t) {
    if (t.inf) return !0;
    var r = t.x, i = t.y, n = this.a.redMul(r), o = r.redSqr().redMul(r).redIAdd(n).redIAdd(this.b);
    return i.redSqr().redISub(o).cmpn(0) === 0;
}, $dade464b59c7f664$var$Zt.prototype._endoWnafMulAdd = function(t, r, i) {
    for(var n = this._endoWnafT1, o = this._endoWnafT2, h = 0; h < t.length; h++){
        var p = this._endoSplit(r[h]), A = t[h], m = A._getBeta();
        p.k1.negative && (p.k1.ineg(), A = A.neg(!0)), p.k2.negative && (p.k2.ineg(), m = m.neg(!0)), n[h * 2] = A, n[h * 2 + 1] = m, o[h * 2] = p.k1, o[h * 2 + 1] = p.k2;
    }
    for(var w = this._wnafMulAdd(1, n, o, h * 2, i), y = 0; y < h * 2; y++)n[y] = null, o[y] = null;
    return w;
};
function $dade464b59c7f664$var$Ft(e, t, r, i) {
    $dade464b59c7f664$var$Ze.BasePoint.call(this, e, "affine"), t === null && r === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new $dade464b59c7f664$var$K(t, 16), this.y = new $dade464b59c7f664$var$K(r, 16), i && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
$dade464b59c7f664$var$Di($dade464b59c7f664$var$Ft, $dade464b59c7f664$var$Ze.BasePoint), $dade464b59c7f664$var$Zt.prototype.point = function(t, r, i) {
    return new $dade464b59c7f664$var$Ft(this, t, r, i);
}, $dade464b59c7f664$var$Zt.prototype.pointFromJSON = function(t, r) {
    return $dade464b59c7f664$var$Ft.fromJSON(this, t, r);
}, $dade464b59c7f664$var$Ft.prototype._getBeta = function() {
    if (this.curve.endo) {
        var t = this.precomputed;
        if (t && t.beta) return t.beta;
        var r = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (t) {
            var i = this.curve, n = function(o) {
                return i.point(o.x.redMul(i.endo.beta), o.y);
            };
            t.beta = r, r.precomputed = {
                beta: null,
                naf: t.naf && {
                    wnd: t.naf.wnd,
                    points: t.naf.points.map(n)
                },
                doubles: t.doubles && {
                    step: t.doubles.step,
                    points: t.doubles.points.map(n)
                }
            };
        }
        return r;
    }
}, $dade464b59c7f664$var$Ft.prototype.toJSON = function() {
    return this.precomputed ? [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ] : [
        this.x,
        this.y
    ];
}, $dade464b59c7f664$var$Ft.fromJSON = function(t, r, i) {
    typeof r == "string" && (r = JSON.parse(r));
    var n = t.point(r[0], r[1], i);
    if (!r[2]) return n;
    function o(p) {
        return t.point(p[0], p[1], i);
    }
    var h = r[2];
    return n.precomputed = {
        beta: null,
        doubles: h.doubles && {
            step: h.doubles.step,
            points: [
                n
            ].concat(h.doubles.points.map(o))
        },
        naf: h.naf && {
            wnd: h.naf.wnd,
            points: [
                n
            ].concat(h.naf.points.map(o))
        }
    }, n;
}, $dade464b59c7f664$var$Ft.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
}, $dade464b59c7f664$var$Ft.prototype.isInfinity = function() {
    return this.inf;
}, $dade464b59c7f664$var$Ft.prototype.add = function(t) {
    if (this.inf) return t;
    if (t.inf) return this;
    if (this.eq(t)) return this.dbl();
    if (this.neg().eq(t)) return this.curve.point(null, null);
    if (this.x.cmp(t.x) === 0) return this.curve.point(null, null);
    var r = this.y.redSub(t.y);
    r.cmpn(0) !== 0 && (r = r.redMul(this.x.redSub(t.x).redInvm()));
    var i = r.redSqr().redISub(this.x).redISub(t.x), n = r.redMul(this.x.redSub(i)).redISub(this.y);
    return this.curve.point(i, n);
}, $dade464b59c7f664$var$Ft.prototype.dbl = function() {
    if (this.inf) return this;
    var t = this.y.redAdd(this.y);
    if (t.cmpn(0) === 0) return this.curve.point(null, null);
    var r = this.curve.a, i = this.x.redSqr(), n = t.redInvm(), o = i.redAdd(i).redIAdd(i).redIAdd(r).redMul(n), h = o.redSqr().redISub(this.x.redAdd(this.x)), p = o.redMul(this.x.redSub(h)).redISub(this.y);
    return this.curve.point(h, p);
}, $dade464b59c7f664$var$Ft.prototype.getX = function() {
    return this.x.fromRed();
}, $dade464b59c7f664$var$Ft.prototype.getY = function() {
    return this.y.fromRed();
}, $dade464b59c7f664$var$Ft.prototype.mul = function(t) {
    return t = new $dade464b59c7f664$var$K(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([
        this
    ], [
        t
    ]) : this.curve._wnafMul(this, t);
}, $dade464b59c7f664$var$Ft.prototype.mulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o) : this.curve._wnafMulAdd(1, n, o, 2);
}, $dade464b59c7f664$var$Ft.prototype.jmulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o, !0) : this.curve._wnafMulAdd(1, n, o, 2, !0);
}, $dade464b59c7f664$var$Ft.prototype.eq = function(t) {
    return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
}, $dade464b59c7f664$var$Ft.prototype.neg = function(t) {
    if (this.inf) return this;
    var r = this.curve.point(this.x, this.y.redNeg());
    if (t && this.precomputed) {
        var i = this.precomputed, n = function(o) {
            return o.neg();
        };
        r.precomputed = {
            naf: i.naf && {
                wnd: i.naf.wnd,
                points: i.naf.points.map(n)
            },
            doubles: i.doubles && {
                step: i.doubles.step,
                points: i.doubles.points.map(n)
            }
        };
    }
    return r;
}, $dade464b59c7f664$var$Ft.prototype.toJ = function() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var t = this.curve.jpoint(this.x, this.y, this.curve.one);
    return t;
};
function $dade464b59c7f664$var$Tt(e, t, r, i) {
    $dade464b59c7f664$var$Ze.BasePoint.call(this, e, "jacobian"), t === null && r === null && i === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new $dade464b59c7f664$var$K(0)) : (this.x = new $dade464b59c7f664$var$K(t, 16), this.y = new $dade464b59c7f664$var$K(r, 16), this.z = new $dade464b59c7f664$var$K(i, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
$dade464b59c7f664$var$Di($dade464b59c7f664$var$Tt, $dade464b59c7f664$var$Ze.BasePoint), $dade464b59c7f664$var$Zt.prototype.jpoint = function(t, r, i) {
    return new $dade464b59c7f664$var$Tt(this, t, r, i);
}, $dade464b59c7f664$var$Tt.prototype.toP = function() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var t = this.z.redInvm(), r = t.redSqr(), i = this.x.redMul(r), n = this.y.redMul(r).redMul(t);
    return this.curve.point(i, n);
}, $dade464b59c7f664$var$Tt.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
}, $dade464b59c7f664$var$Tt.prototype.add = function(t) {
    if (this.isInfinity()) return t;
    if (t.isInfinity()) return this;
    var r = t.z.redSqr(), i = this.z.redSqr(), n = this.x.redMul(r), o = t.x.redMul(i), h = this.y.redMul(r.redMul(t.z)), p = t.y.redMul(i.redMul(this.z)), A = n.redSub(o), m = h.redSub(p);
    if (A.cmpn(0) === 0) return m.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var w = A.redSqr(), y = w.redMul(A), S = n.redMul(w), I = m.redSqr().redIAdd(y).redISub(S).redISub(S), N = m.redMul(S.redISub(I)).redISub(h.redMul(y)), C = this.z.redMul(t.z).redMul(A);
    return this.curve.jpoint(I, N, C);
}, $dade464b59c7f664$var$Tt.prototype.mixedAdd = function(t) {
    if (this.isInfinity()) return t.toJ();
    if (t.isInfinity()) return this;
    var r = this.z.redSqr(), i = this.x, n = t.x.redMul(r), o = this.y, h = t.y.redMul(r).redMul(this.z), p = i.redSub(n), A = o.redSub(h);
    if (p.cmpn(0) === 0) return A.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var m = p.redSqr(), w = m.redMul(p), y = i.redMul(m), S = A.redSqr().redIAdd(w).redISub(y).redISub(y), I = A.redMul(y.redISub(S)).redISub(o.redMul(w)), N = this.z.redMul(p);
    return this.curve.jpoint(S, I, N);
}, $dade464b59c7f664$var$Tt.prototype.dblp = function(t) {
    if (t === 0) return this;
    if (this.isInfinity()) return this;
    if (!t) return this.dbl();
    var r;
    if (this.curve.zeroA || this.curve.threeA) {
        var i = this;
        for(r = 0; r < t; r++)i = i.dbl();
        return i;
    }
    var n = this.curve.a, o = this.curve.tinv, h = this.x, p = this.y, A = this.z, m = A.redSqr().redSqr(), w = p.redAdd(p);
    for(r = 0; r < t; r++){
        var y = h.redSqr(), S = w.redSqr(), I = S.redSqr(), N = y.redAdd(y).redIAdd(y).redIAdd(n.redMul(m)), C = h.redMul(S), F = N.redSqr().redISub(C.redAdd(C)), U = C.redISub(F), J = N.redMul(U);
        J = J.redIAdd(J).redISub(I);
        var Bt = w.redMul(A);
        r + 1 < t && (m = m.redMul(I)), h = F, A = Bt, w = J;
    }
    return this.curve.jpoint(h, w.redMul(o), A);
}, $dade464b59c7f664$var$Tt.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
}, $dade464b59c7f664$var$Tt.prototype._zeroDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var A = n.redAdd(n).redIAdd(n), m = A.redSqr().redISub(p).redISub(p), w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), t = m, r = A.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.x.redSqr(), S = this.y.redSqr(), I = S.redSqr(), N = this.x.redAdd(S).redSqr().redISub(y).redISub(I);
        N = N.redIAdd(N);
        var C = y.redAdd(y).redIAdd(y), F = C.redSqr(), U = I.redIAdd(I);
        U = U.redIAdd(U), U = U.redIAdd(U), t = F.redISub(N).redISub(N), r = C.redMul(N.redISub(t)).redISub(U), i = this.y.redMul(this.z), i = i.redIAdd(i);
    }
    return this.curve.jpoint(t, r, i);
}, $dade464b59c7f664$var$Tt.prototype._threeDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var A = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), m = A.redSqr().redISub(p).redISub(p);
        t = m;
        var w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), r = A.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.z.redSqr(), S = this.y.redSqr(), I = this.x.redMul(S), N = this.x.redSub(y).redMul(this.x.redAdd(y));
        N = N.redAdd(N).redIAdd(N);
        var C = I.redIAdd(I);
        C = C.redIAdd(C);
        var F = C.redAdd(C);
        t = N.redSqr().redISub(F), i = this.y.redAdd(this.z).redSqr().redISub(S).redISub(y);
        var U = S.redSqr();
        U = U.redIAdd(U), U = U.redIAdd(U), U = U.redIAdd(U), r = N.redMul(C.redISub(t)).redISub(U);
    }
    return this.curve.jpoint(t, r, i);
}, $dade464b59c7f664$var$Tt.prototype._dbl = function() {
    var t = this.curve.a, r = this.x, i = this.y, n = this.z, o = n.redSqr().redSqr(), h = r.redSqr(), p = i.redSqr(), A = h.redAdd(h).redIAdd(h).redIAdd(t.redMul(o)), m = r.redAdd(r);
    m = m.redIAdd(m);
    var w = m.redMul(p), y = A.redSqr().redISub(w.redAdd(w)), S = w.redISub(y), I = p.redSqr();
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = A.redMul(S).redISub(I), C = i.redAdd(i).redMul(n);
    return this.curve.jpoint(y, N, C);
}, $dade464b59c7f664$var$Tt.prototype.trpl = function() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var t = this.x.redSqr(), r = this.y.redSqr(), i = this.z.redSqr(), n = r.redSqr(), o = t.redAdd(t).redIAdd(t), h = o.redSqr(), p = this.x.redAdd(r).redSqr().redISub(t).redISub(n);
    p = p.redIAdd(p), p = p.redAdd(p).redIAdd(p), p = p.redISub(h);
    var A = p.redSqr(), m = n.redIAdd(n);
    m = m.redIAdd(m), m = m.redIAdd(m), m = m.redIAdd(m);
    var w = o.redIAdd(p).redSqr().redISub(h).redISub(A).redISub(m), y = r.redMul(w);
    y = y.redIAdd(y), y = y.redIAdd(y);
    var S = this.x.redMul(A).redISub(y);
    S = S.redIAdd(S), S = S.redIAdd(S);
    var I = this.y.redMul(w.redMul(m.redISub(w)).redISub(p.redMul(A)));
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = this.z.redAdd(p).redSqr().redISub(i).redISub(A);
    return this.curve.jpoint(S, I, N);
}, $dade464b59c7f664$var$Tt.prototype.mul = function(t, r) {
    return t = new $dade464b59c7f664$var$K(t, r), this.curve._wnafMul(this, t);
}, $dade464b59c7f664$var$Tt.prototype.eq = function(t) {
    if (t.type === "affine") return this.eq(t.toJ());
    if (this === t) return !0;
    var r = this.z.redSqr(), i = t.z.redSqr();
    if (this.x.redMul(i).redISub(t.x.redMul(r)).cmpn(0) !== 0) return !1;
    var n = r.redMul(this.z), o = i.redMul(t.z);
    return this.y.redMul(o).redISub(t.y.redMul(n)).cmpn(0) === 0;
}, $dade464b59c7f664$var$Tt.prototype.eqXToP = function(t) {
    var r = this.z.redSqr(), i = t.toRed(this.curve.red).redMul(r);
    if (this.x.cmp(i) === 0) return !0;
    for(var n = t.clone(), o = this.curve.redN.redMul(r);;){
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (i.redIAdd(o), this.x.cmp(i) === 0) return !0;
    }
}, $dade464b59c7f664$var$Tt.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
}, $dade464b59c7f664$var$Tt.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
};
var $dade464b59c7f664$var$qr = $dade464b59c7f664$var$cr(function(e, t) {
    var r = t;
    r.base = $dade464b59c7f664$var$Ze, r.short = $dade464b59c7f664$var$ja, r.mont = null, r.edwards = null;
}), $dade464b59c7f664$var$Kr = $dade464b59c7f664$var$cr(function(e, t) {
    var r = t, i = $dade464b59c7f664$var$Jt.assert;
    function n(p) {
        p.type === "short" ? this.curve = new $dade464b59c7f664$var$qr.short(p) : p.type === "edwards" ? this.curve = new $dade464b59c7f664$var$qr.edwards(p) : this.curve = new $dade464b59c7f664$var$qr.mont(p), this.g = this.curve.g, this.n = this.curve.n, this.hash = p.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    r.PresetCurve = n;
    function o(p, A) {
        Object.defineProperty(r, p, {
            configurable: !0,
            enumerable: !0,
            get: function() {
                var m = new n(A);
                return Object.defineProperty(r, p, {
                    configurable: !0,
                    enumerable: !0,
                    value: m
                }), m;
            }
        });
    }
    o("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: $dade464b59c7f664$var$se.sha256,
        gRed: !1,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    }), o("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: $dade464b59c7f664$var$se.sha256,
        gRed: !1,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    }), o("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: $dade464b59c7f664$var$se.sha256,
        gRed: !1,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    }), o("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: $dade464b59c7f664$var$se.sha384,
        gRed: !1,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    }), o("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: $dade464b59c7f664$var$se.sha512,
        gRed: !1,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    }), o("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $dade464b59c7f664$var$se.sha256,
        gRed: !1,
        g: [
            "9"
        ]
    }), o("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $dade464b59c7f664$var$se.sha256,
        gRed: !1,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var h;
    try {
        h = null.crash();
    } catch  {
        h = void 0;
    }
    o("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: $dade464b59c7f664$var$se.sha256,
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: !1,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            h
        ]
    });
});
function $dade464b59c7f664$var$Re(e) {
    if (!(this instanceof $dade464b59c7f664$var$Re)) return new $dade464b59c7f664$var$Re(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = $dade464b59c7f664$var$fe.toArray(e.entropy, e.entropyEnc || "hex"), r = $dade464b59c7f664$var$fe.toArray(e.nonce, e.nonceEnc || "hex"), i = $dade464b59c7f664$var$fe.toArray(e.pers, e.persEnc || "hex");
    $dade464b59c7f664$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, i);
}
var $dade464b59c7f664$var$Of = $dade464b59c7f664$var$Re;
$dade464b59c7f664$var$Re.prototype._init = function(t, r, i) {
    var n = t.concat(r).concat(i);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for(var o = 0; o < this.V.length; o++)this.K[o] = 0, this.V[o] = 1;
    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
}, $dade464b59c7f664$var$Re.prototype._hmac = function() {
    return new $dade464b59c7f664$var$se.hmac(this.hash, this.K);
}, $dade464b59c7f664$var$Re.prototype._update = function(t) {
    var r = this._hmac().update(this.V).update([
        0
    ]);
    t && (r = r.update(t)), this.K = r.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([
        1
    ]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
}, $dade464b59c7f664$var$Re.prototype.reseed = function(t, r, i, n) {
    typeof r != "string" && (n = i, i = r, r = null), t = $dade464b59c7f664$var$fe.toArray(t, r), i = $dade464b59c7f664$var$fe.toArray(i, n), $dade464b59c7f664$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(t.concat(i || [])), this._reseed = 1;
}, $dade464b59c7f664$var$Re.prototype.generate = function(t, r, i, n) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    typeof r != "string" && (n = i, i = r, r = null), i && (i = $dade464b59c7f664$var$fe.toArray(i, n || "hex"), this._update(i));
    for(var o = []; o.length < t;)this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
    var h = o.slice(0, t);
    return this._update(i), this._reseed++, $dade464b59c7f664$var$fe.encode(h, r);
};
var $dade464b59c7f664$var$Fi = $dade464b59c7f664$var$Jt.assert;
function $dade464b59c7f664$var$kt(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var $dade464b59c7f664$var$Ti = $dade464b59c7f664$var$kt;
$dade464b59c7f664$var$kt.fromPublic = function(t, r, i) {
    return r instanceof $dade464b59c7f664$var$kt ? r : new $dade464b59c7f664$var$kt(t, {
        pub: r,
        pubEnc: i
    });
}, $dade464b59c7f664$var$kt.fromPrivate = function(t, r, i) {
    return r instanceof $dade464b59c7f664$var$kt ? r : new $dade464b59c7f664$var$kt(t, {
        priv: r,
        privEnc: i
    });
}, $dade464b59c7f664$var$kt.prototype.validate = function() {
    var t = this.getPublic();
    return t.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
    } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
    } : {
        result: !1,
        reason: "Public key * N != O"
    } : {
        result: !1,
        reason: "Public key is not a point"
    };
}, $dade464b59c7f664$var$kt.prototype.getPublic = function(t, r) {
    return typeof t == "string" && (r = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), r ? this.pub.encode(r, t) : this.pub;
}, $dade464b59c7f664$var$kt.prototype.getPrivate = function(t) {
    return t === "hex" ? this.priv.toString(16, 2) : this.priv;
}, $dade464b59c7f664$var$kt.prototype._importPrivate = function(t, r) {
    this.priv = new $dade464b59c7f664$var$K(t, r || 16), this.priv = this.priv.umod(this.ec.curve.n);
}, $dade464b59c7f664$var$kt.prototype._importPublic = function(t, r) {
    if (t.x || t.y) {
        this.ec.curve.type === "mont" ? $dade464b59c7f664$var$Fi(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && $dade464b59c7f664$var$Fi(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(t, r);
}, $dade464b59c7f664$var$kt.prototype.derive = function(t) {
    return t.validate() || $dade464b59c7f664$var$Fi(t.validate(), "public point not validated"), t.mul(this.priv).getX();
}, $dade464b59c7f664$var$kt.prototype.sign = function(t, r, i) {
    return this.ec.sign(t, this, r, i);
}, $dade464b59c7f664$var$kt.prototype.verify = function(t, r) {
    return this.ec.verify(t, r, this);
}, $dade464b59c7f664$var$kt.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var $dade464b59c7f664$var$Qa = $dade464b59c7f664$var$Jt.assert;
function $dade464b59c7f664$var$Hr(e, t) {
    if (e instanceof $dade464b59c7f664$var$Hr) return e;
    this._importDER(e, t) || ($dade464b59c7f664$var$Qa(e.r && e.s, "Signature without r or s"), this.r = new $dade464b59c7f664$var$K(e.r, 16), this.s = new $dade464b59c7f664$var$K(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var $dade464b59c7f664$var$zr = $dade464b59c7f664$var$Hr;
function $dade464b59c7f664$var$Ja() {
    this.place = 0;
}
function $dade464b59c7f664$var$Ui(e, t) {
    var r = e[t.place++];
    if (!(r & 128)) return r;
    var i = r & 15;
    if (i === 0 || i > 4) return !1;
    for(var n = 0, o = 0, h = t.place; o < i; o++, h++)n <<= 8, n |= e[h], n >>>= 0;
    return n <= 127 ? !1 : (t.place = h, n);
}
function $dade464b59c7f664$var$Pf(e) {
    for(var t = 0, r = e.length - 1; !e[t] && !(e[t + 1] & 128) && t < r;)t++;
    return t === 0 ? e : e.slice(t);
}
$dade464b59c7f664$var$Hr.prototype._importDER = function(t, r) {
    t = $dade464b59c7f664$var$Jt.toArray(t, r);
    var i = new $dade464b59c7f664$var$Ja;
    if (t[i.place++] !== 48) return !1;
    var n = $dade464b59c7f664$var$Ui(t, i);
    if (n === !1 || n + i.place !== t.length || t[i.place++] !== 2) return !1;
    var o = $dade464b59c7f664$var$Ui(t, i);
    if (o === !1) return !1;
    var h = t.slice(i.place, o + i.place);
    if (i.place += o, t[i.place++] !== 2) return !1;
    var p = $dade464b59c7f664$var$Ui(t, i);
    if (p === !1 || t.length !== p + i.place) return !1;
    var A = t.slice(i.place, p + i.place);
    if (h[0] === 0) {
        if (h[1] & 128) h = h.slice(1);
        else return !1;
    }
    if (A[0] === 0) {
        if (A[1] & 128) A = A.slice(1);
        else return !1;
    }
    return this.r = new $dade464b59c7f664$var$K(h), this.s = new $dade464b59c7f664$var$K(A), this.recoveryParam = null, !0;
};
function $dade464b59c7f664$var$ki(e, t) {
    if (t < 128) {
        e.push(t);
        return;
    }
    var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
    for(e.push(r | 128); --r;)e.push(t >>> (r << 3) & 255);
    e.push(t);
}
$dade464b59c7f664$var$Hr.prototype.toDER = function(t) {
    var r = this.r.toArray(), i = this.s.toArray();
    for(r[0] & 128 && (r = [
        0
    ].concat(r)), i[0] & 128 && (i = [
        0
    ].concat(i)), r = $dade464b59c7f664$var$Pf(r), i = $dade464b59c7f664$var$Pf(i); !i[0] && !(i[1] & 128);)i = i.slice(1);
    var n = [
        2
    ];
    $dade464b59c7f664$var$ki(n, r.length), n = n.concat(r), n.push(2), $dade464b59c7f664$var$ki(n, i.length);
    var o = n.concat(i), h = [
        48
    ];
    return $dade464b59c7f664$var$ki(h, o.length), h = h.concat(o), $dade464b59c7f664$var$Jt.encode(h, t);
};
var $dade464b59c7f664$var$Ga = function() {
    throw new Error("unsupported");
}, $dade464b59c7f664$var$Df = $dade464b59c7f664$var$Jt.assert;
function $dade464b59c7f664$var$$t(e) {
    if (!(this instanceof $dade464b59c7f664$var$$t)) return new $dade464b59c7f664$var$$t(e);
    typeof e == "string" && ($dade464b59c7f664$var$Df(Object.prototype.hasOwnProperty.call($dade464b59c7f664$var$Kr, e), "Unknown curve " + e), e = $dade464b59c7f664$var$Kr[e]), e instanceof $dade464b59c7f664$var$Kr.PresetCurve && (e = {
        curve: e
    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
}
var $dade464b59c7f664$var$Ya = $dade464b59c7f664$var$$t;
$dade464b59c7f664$var$$t.prototype.keyPair = function(t) {
    return new $dade464b59c7f664$var$Ti(this, t);
}, $dade464b59c7f664$var$$t.prototype.keyFromPrivate = function(t, r) {
    return $dade464b59c7f664$var$Ti.fromPrivate(this, t, r);
}, $dade464b59c7f664$var$$t.prototype.keyFromPublic = function(t, r) {
    return $dade464b59c7f664$var$Ti.fromPublic(this, t, r);
}, $dade464b59c7f664$var$$t.prototype.genKeyPair = function(t) {
    t || (t = {});
    for(var r = new $dade464b59c7f664$var$Of({
        hash: this.hash,
        pers: t.pers,
        persEnc: t.persEnc || "utf8",
        entropy: t.entropy || $dade464b59c7f664$var$Ga(this.hash.hmacStrength),
        entropyEnc: t.entropy && t.entropyEnc || "utf8",
        nonce: this.n.toArray()
    }), i = this.n.byteLength(), n = this.n.sub(new $dade464b59c7f664$var$K(2));;){
        var o = new $dade464b59c7f664$var$K(r.generate(i));
        if (!(o.cmp(n) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
    }
}, $dade464b59c7f664$var$$t.prototype._truncateToN = function(t, r) {
    var i = t.byteLength() * 8 - this.n.bitLength();
    return i > 0 && (t = t.ushrn(i)), !r && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
}, $dade464b59c7f664$var$$t.prototype.sign = function(t, r, i, n) {
    typeof i == "object" && (n = i, i = null), n || (n = {}), r = this.keyFromPrivate(r, i), t = this._truncateToN(new $dade464b59c7f664$var$K(t, 16));
    for(var o = this.n.byteLength(), h = r.getPrivate().toArray("be", o), p = t.toArray("be", o), A = new $dade464b59c7f664$var$Of({
        hash: this.hash,
        entropy: h,
        nonce: p,
        pers: n.pers,
        persEnc: n.persEnc || "utf8"
    }), m = this.n.sub(new $dade464b59c7f664$var$K(1)), w = 0;; w++){
        var y = n.k ? n.k(w) : new $dade464b59c7f664$var$K(A.generate(this.n.byteLength()));
        if (y = this._truncateToN(y, !0), !(y.cmpn(1) <= 0 || y.cmp(m) >= 0)) {
            var S = this.g.mul(y);
            if (!S.isInfinity()) {
                var I = S.getX(), N = I.umod(this.n);
                if (N.cmpn(0) !== 0) {
                    var C = y.invm(this.n).mul(N.mul(r.getPrivate()).iadd(t));
                    if (C = C.umod(this.n), C.cmpn(0) !== 0) {
                        var F = (S.getY().isOdd() ? 1 : 0) | (I.cmp(N) !== 0 ? 2 : 0);
                        return n.canonical && C.cmp(this.nh) > 0 && (C = this.n.sub(C), F ^= 1), new $dade464b59c7f664$var$zr({
                            r: N,
                            s: C,
                            recoveryParam: F
                        });
                    }
                }
            }
        }
    }
}, $dade464b59c7f664$var$$t.prototype.verify = function(t, r, i, n) {
    t = this._truncateToN(new $dade464b59c7f664$var$K(t, 16)), i = this.keyFromPublic(i, n), r = new $dade464b59c7f664$var$zr(r, "hex");
    var o = r.r, h = r.s;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0 || h.cmpn(1) < 0 || h.cmp(this.n) >= 0) return !1;
    var p = h.invm(this.n), A = p.mul(t).umod(this.n), m = p.mul(o).umod(this.n), w;
    return this.curve._maxwellTrick ? (w = this.g.jmulAdd(A, i.getPublic(), m), w.isInfinity() ? !1 : w.eqXToP(o)) : (w = this.g.mulAdd(A, i.getPublic(), m), w.isInfinity() ? !1 : w.getX().umod(this.n).cmp(o) === 0);
}, $dade464b59c7f664$var$$t.prototype.recoverPubKey = function(e, t, r, i) {
    $dade464b59c7f664$var$Df((3 & r) === r, "The recovery param is more than two bits"), t = new $dade464b59c7f664$var$zr(t, i);
    var n = this.n, o = new $dade464b59c7f664$var$K(e), h = t.r, p = t.s, A = r & 1, m = r >> 1;
    if (h.cmp(this.curve.p.umod(this.curve.n)) >= 0 && m) throw new Error("Unable to find sencond key candinate");
    m ? h = this.curve.pointFromX(h.add(this.curve.n), A) : h = this.curve.pointFromX(h, A);
    var w = t.r.invm(n), y = n.sub(o).mul(w).umod(n), S = p.mul(w).umod(n);
    return this.g.mulAdd(y, h, S);
}, $dade464b59c7f664$var$$t.prototype.getKeyRecoveryParam = function(e, t, r, i) {
    if (t = new $dade464b59c7f664$var$zr(t, i), t.recoveryParam !== null) return t.recoveryParam;
    for(var n = 0; n < 4; n++){
        var o;
        try {
            o = this.recoverPubKey(e, t, n);
        } catch  {
            continue;
        }
        if (o.eq(r)) return n;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $dade464b59c7f664$var$Va = $dade464b59c7f664$var$cr(function(e, t) {
    var r = t;
    r.version = "6.5.4", r.utils = $dade464b59c7f664$var$Jt, r.rand = function() {
        throw new Error("unsupported");
    }, r.curve = $dade464b59c7f664$var$qr, r.curves = $dade464b59c7f664$var$Kr, r.ec = $dade464b59c7f664$var$Ya, r.eddsa = null;
}), $dade464b59c7f664$var$Wa = $dade464b59c7f664$var$Va.ec;
const $dade464b59c7f664$var$Xa = "signing-key/5.7.0", $dade464b59c7f664$var$qi = new $dade464b59c7f664$var$L($dade464b59c7f664$var$Xa);
let $dade464b59c7f664$var$Ki = null;
function $dade464b59c7f664$var$ve() {
    return $dade464b59c7f664$var$Ki || ($dade464b59c7f664$var$Ki = new $dade464b59c7f664$var$Wa("secp256k1")), $dade464b59c7f664$var$Ki;
}
class $dade464b59c7f664$var$Za {
    constructor(t){
        $dade464b59c7f664$var$br(this, "curve", "secp256k1"), $dade464b59c7f664$var$br(this, "privateKey", $dade464b59c7f664$var$Kt(t)), $dade464b59c7f664$var$Os(this.privateKey) !== 32 && $dade464b59c7f664$var$qi.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const r = $dade464b59c7f664$var$ve().keyFromPrivate($dade464b59c7f664$var$Ot(this.privateKey));
        $dade464b59c7f664$var$br(this, "publicKey", "0x" + r.getPublic(!1, "hex")), $dade464b59c7f664$var$br(this, "compressedPublicKey", "0x" + r.getPublic(!0, "hex")), $dade464b59c7f664$var$br(this, "_isSigningKey", !0);
    }
    _addPoint(t) {
        const r = $dade464b59c7f664$var$ve().keyFromPublic($dade464b59c7f664$var$Ot(this.publicKey)), i = $dade464b59c7f664$var$ve().keyFromPublic($dade464b59c7f664$var$Ot(t));
        return "0x" + r.pub.add(i.pub).encodeCompressed("hex");
    }
    signDigest(t) {
        const r = $dade464b59c7f664$var$ve().keyFromPrivate($dade464b59c7f664$var$Ot(this.privateKey)), i = $dade464b59c7f664$var$Ot(t);
        i.length !== 32 && $dade464b59c7f664$var$qi.throwArgumentError("bad digest length", "digest", t);
        const n = r.sign(i, {
            canonical: !0
        });
        return $dade464b59c7f664$var$Ln({
            recoveryParam: n.recoveryParam,
            r: $dade464b59c7f664$var$oe("0x" + n.r.toString(16), 32),
            s: $dade464b59c7f664$var$oe("0x" + n.s.toString(16), 32)
        });
    }
    computeSharedSecret(t) {
        const r = $dade464b59c7f664$var$ve().keyFromPrivate($dade464b59c7f664$var$Ot(this.privateKey)), i = $dade464b59c7f664$var$ve().keyFromPublic($dade464b59c7f664$var$Ot($dade464b59c7f664$var$Ff(t)));
        return $dade464b59c7f664$var$oe("0x" + r.derive(i.getPublic()).toString(16), 32);
    }
    static isSigningKey(t) {
        return !!(t && t._isSigningKey);
    }
}
function $dade464b59c7f664$var$$a(e, t) {
    const r = $dade464b59c7f664$var$Ln(t), i = {
        r: $dade464b59c7f664$var$Ot(r.r),
        s: $dade464b59c7f664$var$Ot(r.s)
    };
    return "0x" + $dade464b59c7f664$var$ve().recoverPubKey($dade464b59c7f664$var$Ot(e), i, r.recoveryParam).encode("hex", !1);
}
function $dade464b59c7f664$var$Ff(e, t) {
    const r = $dade464b59c7f664$var$Ot(e);
    if (r.length === 32) {
        const i = new $dade464b59c7f664$var$Za(r);
        return t ? "0x" + $dade464b59c7f664$var$ve().keyFromPrivate(r).getPublic(!0, "hex") : i.publicKey;
    } else {
        if (r.length === 33) return t ? $dade464b59c7f664$var$Kt(r) : "0x" + $dade464b59c7f664$var$ve().keyFromPublic(r).getPublic(!1, "hex");
        if (r.length === 65) return t ? "0x" + $dade464b59c7f664$var$ve().keyFromPublic(r).getPublic(!0, "hex") : $dade464b59c7f664$var$Kt(r);
    }
    return $dade464b59c7f664$var$qi.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
const $dade464b59c7f664$var$tu = "transactions/5.7.0";
new $dade464b59c7f664$var$L($dade464b59c7f664$var$tu);
var $dade464b59c7f664$var$Tf;
(function(e) {
    e[e.legacy = 0] = "legacy", e[e.eip2930 = 1] = "eip2930", e[e.eip1559 = 2] = "eip1559";
})($dade464b59c7f664$var$Tf || ($dade464b59c7f664$var$Tf = {}));
function $dade464b59c7f664$var$eu(e) {
    const t = $dade464b59c7f664$var$Ff(e);
    return $dade464b59c7f664$var$h0($dade464b59c7f664$var$zn($dade464b59c7f664$var$yi($dade464b59c7f664$var$zn(t, 1)), 12));
}
function $dade464b59c7f664$var$ru(e, t) {
    return $dade464b59c7f664$var$eu($dade464b59c7f664$var$$a($dade464b59c7f664$var$Ot(e), t));
}
const $dade464b59c7f664$var$iu = "https://rpc.walletconnect.com/v1";
async function $dade464b59c7f664$export$ab54e47fdf2903bb(e, t, r, i, n, o) {
    switch(r.t){
        case "eip191":
            return $dade464b59c7f664$export$b5da105d64914e5a(e, t, r.s);
        case "eip1271":
            return await $dade464b59c7f664$export$9bffe3330373b76b(e, t, r.s, i, n, o);
        default:
            throw new Error(`verifySignature failed: Attempted to verify CacaoSignature with unknown type: ${r.t}`);
    }
}
function $dade464b59c7f664$export$b5da105d64914e5a(e, t, r) {
    return $dade464b59c7f664$var$ru($dade464b59c7f664$var$of(t), r).toLowerCase() === e.toLowerCase();
}
async function $dade464b59c7f664$export$9bffe3330373b76b(e, t, r, i, n, o) {
    try {
        const h = "0x1626ba7e", p = "0000000000000000000000000000000000000000000000000000000000000040", A = "0000000000000000000000000000000000000000000000000000000000000041", m = r.substring(2), w = $dade464b59c7f664$var$of(t).substring(2), y = h + w + p + A + m, S = await fetch(`${o || $dade464b59c7f664$var$iu}/?chainId=${i}&projectId=${n}`, {
            method: "POST",
            body: JSON.stringify({
                id: $dade464b59c7f664$var$nu(),
                jsonrpc: "2.0",
                method: "eth_call",
                params: [
                    {
                        to: e,
                        data: y
                    },
                    "latest"
                ]
            })
        }), { result: I } = await S.json();
        return I ? I.slice(0, h.length).toLowerCase() === h.toLowerCase() : !1;
    } catch (h) {
        return console.error("isValidEip1271Signature: ", h), !1;
    }
}
function $dade464b59c7f664$var$nu() {
    return Date.now() + Math.floor(Math.random() * 1e3);
}
var $dade464b59c7f664$var$fu = Object.defineProperty, $dade464b59c7f664$var$ou = Object.defineProperties, $dade464b59c7f664$var$su = Object.getOwnPropertyDescriptors, $dade464b59c7f664$var$Kf = Object.getOwnPropertySymbols, $dade464b59c7f664$var$au = Object.prototype.hasOwnProperty, $dade464b59c7f664$var$uu = Object.prototype.propertyIsEnumerable, $dade464b59c7f664$var$Hf = (e, t, r)=>t in e ? $dade464b59c7f664$var$fu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $dade464b59c7f664$var$Hi = (e, t)=>{
    for(var r in t || (t = {}))$dade464b59c7f664$var$au.call(t, r) && $dade464b59c7f664$var$Hf(e, r, t[r]);
    if ($dade464b59c7f664$var$Kf) for (var r of $dade464b59c7f664$var$Kf(t))$dade464b59c7f664$var$uu.call(t, r) && $dade464b59c7f664$var$Hf(e, r, t[r]);
    return e;
}, $dade464b59c7f664$var$zf = (e, t)=>$dade464b59c7f664$var$ou(e, $dade464b59c7f664$var$su(t));
const $dade464b59c7f664$var$hu = "did:pkh:", $dade464b59c7f664$export$a524ae552db7912 = (e)=>e?.split(":"), $dade464b59c7f664$export$85f23c05c80b194 = (e)=>{
    const t = e && $dade464b59c7f664$export$a524ae552db7912(e);
    if (t) return e.includes($dade464b59c7f664$var$hu) ? t[3] : t[1];
}, $dade464b59c7f664$export$a8b149927aef7051 = (e)=>{
    const t = e && $dade464b59c7f664$export$a524ae552db7912(e);
    if (t) return t[2] + ":" + t[3];
}, $dade464b59c7f664$export$bf43cfbb4bd95de9 = (e)=>{
    const t = e && $dade464b59c7f664$export$a524ae552db7912(e);
    if (t) return t.pop();
};
async function $dade464b59c7f664$export$b7d566fce8e2b970(e) {
    const { cacao: t, projectId: r } = e, { s: i, p: n } = t, o = $dade464b59c7f664$export$25868d1e8e76735f(n, n.iss), h = $dade464b59c7f664$export$bf43cfbb4bd95de9(n.iss);
    return await $dade464b59c7f664$export$ab54e47fdf2903bb(h, o, i, $dade464b59c7f664$export$85f23c05c80b194(n.iss), r);
}
const $dade464b59c7f664$export$25868d1e8e76735f = (e, t)=>{
    const r = `${e.domain} wants you to sign in with your Ethereum account:`, i = $dade464b59c7f664$export$bf43cfbb4bd95de9(t);
    if (!e.aud && !e.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
    let n = e.statement || void 0;
    const o = `URI: ${e.aud || e.uri}`, h = `Version: ${e.version}`, p = `Chain ID: ${$dade464b59c7f664$export$85f23c05c80b194(t)}`, A = `Nonce: ${e.nonce}`, m = `Issued At: ${e.iat}`, w = e.exp ? `Expiration Time: ${e.exp}` : void 0, y = e.nbf ? `Not Before: ${e.nbf}` : void 0, S = e.requestId ? `Request ID: ${e.requestId}` : void 0, I = e.resources ? `Resources:${e.resources.map((C)=>`
- ${C}`).join("")}` : void 0, N = $dade464b59c7f664$export$3bb18ae0fb9a9fa9(e.resources);
    if (N) {
        const C = $dade464b59c7f664$export$d34522c9e5a1aed1(N);
        n = $dade464b59c7f664$export$51673931d3a8308d(n, C);
    }
    return [
        r,
        i,
        "",
        n,
        "",
        o,
        h,
        p,
        A,
        m,
        w,
        y,
        S,
        I
    ].filter((C)=>C != null).join(`
`);
};
function $dade464b59c7f664$export$905974078a05d5f9(e, t, r) {
    return r.includes("did:pkh:") || (r = `did:pkh:${r}`), {
        h: {
            t: "caip122"
        },
        p: {
            iss: r,
            domain: e.domain,
            aud: e.aud,
            version: e.version,
            nonce: e.nonce,
            iat: e.iat,
            statement: e.statement,
            requestId: e.requestId,
            resources: e.resources,
            nbf: e.nbf,
            exp: e.exp
        },
        s: t
    };
}
function $dade464b59c7f664$export$2bfa2ac7d9bc193c(e) {
    var t;
    const { authPayload: r, chains: i, methods: n } = e, o = r.statement || "";
    if (!(i != null && i.length)) return r;
    const h = r.chains, p = $dade464b59c7f664$export$f8aaf09178dd8b96(h, i);
    if (!(p != null && p.length)) throw new Error("No supported chains");
    const A = $dade464b59c7f664$export$8db308c294c84efd(r.resources);
    if (!A) return r;
    $dade464b59c7f664$export$ae8075c482503f32(A);
    const m = $dade464b59c7f664$export$9595a56724061288(A, "eip155");
    let w = r?.resources || [];
    if (m != null && m.length) {
        const y = $dade464b59c7f664$export$e1a9af3d61db3b68(m), S = $dade464b59c7f664$export$f8aaf09178dd8b96(y, n);
        if (!(S != null && S.length)) throw new Error(`Supported methods don't satisfy the requested: ${JSON.stringify(y)}, supported: ${JSON.stringify(n)}`);
        const I = $dade464b59c7f664$export$987cafd76db78dd1("request", S, {
            chains: p
        }), N = $dade464b59c7f664$export$317cb0007b0867c1(A, "eip155", I);
        w = ((t = r?.resources) == null ? void 0 : t.slice(0, -1)) || [], w.push($dade464b59c7f664$export$79a538532b4f11f7(N));
    }
    return $dade464b59c7f664$var$zf($dade464b59c7f664$var$Hi({}, r), {
        statement: $dade464b59c7f664$export$fb351782bc6f001e(o, $dade464b59c7f664$export$3bb18ae0fb9a9fa9(w)),
        chains: p,
        resources: r != null && r.resources || w.length > 0 ? w : void 0
    });
}
function $dade464b59c7f664$export$8db308c294c84efd(e) {
    const t = $dade464b59c7f664$export$3bb18ae0fb9a9fa9(e);
    if (t && $dade464b59c7f664$export$d9f11bd9fec5a64(t)) return $dade464b59c7f664$export$d34522c9e5a1aed1(t);
}
function $dade464b59c7f664$export$771534f1eaa353c(e, t) {
    var r;
    return (r = e?.att) == null ? void 0 : r.hasOwnProperty(t);
}
function $dade464b59c7f664$export$9595a56724061288(e, t) {
    var r, i;
    return (r = e?.att) != null && r[t] ? Object.keys((i = e?.att) == null ? void 0 : i[t]) : [];
}
function $dade464b59c7f664$export$d4548b739f9dafe(e) {
    return e?.map((t)=>Object.keys(t)) || [];
}
function $dade464b59c7f664$export$e1a9af3d61db3b68(e) {
    return e?.map((t)=>{
        var r;
        return (r = t.split("/")) == null ? void 0 : r[1];
    }) || [];
}
function $dade464b59c7f664$export$e510a73ee562749(e) {
    return $dade464b59c7f664$require$Buffer.from(JSON.stringify(e)).toString("base64");
}
function $dade464b59c7f664$export$c62426fdd000a97e(e) {
    return JSON.parse($dade464b59c7f664$require$Buffer.from(e, "base64").toString("utf-8"));
}
function $dade464b59c7f664$export$ae8075c482503f32(e) {
    if (!e) throw new Error("No recap provided, value is undefined");
    if (!e.att) throw new Error("No `att` property found");
    const t = Object.keys(e.att);
    if (!(t != null && t.length)) throw new Error("No resources found in `att` property");
    t.forEach((r)=>{
        const i = e.att[r];
        if (Array.isArray(i)) throw new Error(`Resource must be an object: ${r}`);
        if (typeof i != "object") throw new Error(`Resource must be an object: ${r}`);
        if (!Object.keys(i).length) throw new Error(`Resource object is empty: ${r}`);
        Object.keys(i).forEach((n)=>{
            const o = i[n];
            if (!Array.isArray(o)) throw new Error(`Ability limits ${n} must be an array of objects, found: ${o}`);
            if (!o.length) throw new Error(`Value of ${n} is empty array, must be an array with objects`);
            o.forEach((h)=>{
                if (typeof h != "object") throw new Error(`Ability limits (${n}) must be an array of objects, found: ${h}`);
            });
        });
    });
}
function $dade464b59c7f664$export$eea18a04b33506ed(e, t, r, i = {}) {
    return r?.sort((n, o)=>n.localeCompare(o)), {
        att: {
            [e]: $dade464b59c7f664$export$987cafd76db78dd1(t, r, i)
        }
    };
}
function $dade464b59c7f664$export$317cb0007b0867c1(e, t, r) {
    var i;
    return e.att[t] = $dade464b59c7f664$var$Hi({}, r), ((i = Object.keys(e.att)) == null ? void 0 : i.sort((n, o)=>n.localeCompare(o))).reduce((n, o)=>(n.att[o] = e.att[o], n), {
        att: {}
    });
}
function $dade464b59c7f664$export$987cafd76db78dd1(e, t, r = {}) {
    t = t?.sort((n, o)=>n.localeCompare(o));
    const i = t.map((n)=>({
            [`${e}/${n}`]: [
                r
            ]
        }));
    return Object.assign({}, ...i);
}
function $dade464b59c7f664$export$79a538532b4f11f7(e) {
    return $dade464b59c7f664$export$ae8075c482503f32(e), `urn:recap:${$dade464b59c7f664$export$e510a73ee562749(e).replace(/=/g, "")}`;
}
function $dade464b59c7f664$export$d34522c9e5a1aed1(e) {
    const t = $dade464b59c7f664$export$c62426fdd000a97e(e.replace("urn:recap:", ""));
    return $dade464b59c7f664$export$ae8075c482503f32(t), t;
}
function $dade464b59c7f664$export$2bc35d2a08a09ad5(e, t, r) {
    const i = $dade464b59c7f664$export$eea18a04b33506ed(e, t, r);
    return $dade464b59c7f664$export$79a538532b4f11f7(i);
}
function $dade464b59c7f664$export$d9f11bd9fec5a64(e) {
    return e && e.includes("urn:recap:");
}
function $dade464b59c7f664$export$c7a40c552af428b5(e, t) {
    const r = $dade464b59c7f664$export$d34522c9e5a1aed1(e), i = $dade464b59c7f664$export$d34522c9e5a1aed1(t), n = $dade464b59c7f664$export$2445df2492ef2cbd(r, i);
    return $dade464b59c7f664$export$79a538532b4f11f7(n);
}
function $dade464b59c7f664$export$2445df2492ef2cbd(e, t) {
    $dade464b59c7f664$export$ae8075c482503f32(e), $dade464b59c7f664$export$ae8075c482503f32(t);
    const r = Object.keys(e.att).concat(Object.keys(t.att)).sort((n, o)=>n.localeCompare(o)), i = {
        att: {}
    };
    return r.forEach((n)=>{
        var o, h;
        Object.keys(((o = e.att) == null ? void 0 : o[n]) || {}).concat(Object.keys(((h = t.att) == null ? void 0 : h[n]) || {})).sort((p, A)=>p.localeCompare(A)).forEach((p)=>{
            var A, m;
            i.att[n] = $dade464b59c7f664$var$zf($dade464b59c7f664$var$Hi({}, i.att[n]), {
                [p]: ((A = e.att[n]) == null ? void 0 : A[p]) || ((m = t.att[n]) == null ? void 0 : m[p])
            });
        });
    }), i;
}
function $dade464b59c7f664$export$51673931d3a8308d(e = "", t) {
    $dade464b59c7f664$export$ae8075c482503f32(t);
    const r = "I further authorize the stated URI to perform the following actions on my behalf: ";
    if (e.includes(r)) return e;
    const i = [];
    let n = 0;
    Object.keys(t.att).forEach((p)=>{
        const A = Object.keys(t.att[p]).map((y)=>({
                ability: y.split("/")[0],
                action: y.split("/")[1]
            }));
        A.sort((y, S)=>y.action.localeCompare(S.action));
        const m = {};
        A.forEach((y)=>{
            m[y.ability] || (m[y.ability] = []), m[y.ability].push(y.action);
        });
        const w = Object.keys(m).map((y)=>(n++, `(${n}) '${y}': '${m[y].join("', '")}' for '${p}'.`));
        i.push(w.join(", ").replace(".,", "."));
    });
    const o = i.join(" "), h = `${r}${o}`;
    return `${e ? e + " " : ""}${h}`;
}
function $dade464b59c7f664$export$d6c6a43d36418efe(e) {
    var t;
    const r = $dade464b59c7f664$export$d34522c9e5a1aed1(e);
    $dade464b59c7f664$export$ae8075c482503f32(r);
    const i = (t = r.att) == null ? void 0 : t.eip155;
    return i ? Object.keys(i).map((n)=>n.split("/")[1]) : [];
}
function $dade464b59c7f664$export$372f88051a611988(e) {
    const t = $dade464b59c7f664$export$d34522c9e5a1aed1(e);
    $dade464b59c7f664$export$ae8075c482503f32(t);
    const r = [];
    return Object.values(t.att).forEach((i)=>{
        Object.values(i).forEach((n)=>{
            var o;
            (o = n?.[0]) != null && o.chains && r.push(n[0].chains);
        });
    }), [
        ...new Set(r.flat())
    ];
}
function $dade464b59c7f664$export$fb351782bc6f001e(e, t) {
    if (!t) return e;
    const r = $dade464b59c7f664$export$d34522c9e5a1aed1(t);
    return $dade464b59c7f664$export$ae8075c482503f32(r), $dade464b59c7f664$export$51673931d3a8308d(e, r);
}
function $dade464b59c7f664$export$3bb18ae0fb9a9fa9(e) {
    if (!e) return;
    const t = e?.[e.length - 1];
    return $dade464b59c7f664$export$d9f11bd9fec5a64(t) ? t : void 0;
}
var $dade464b59c7f664$var$wu = Object.defineProperty, $dade464b59c7f664$var$xu = Object.defineProperties, $dade464b59c7f664$var$Mu = Object.getOwnPropertyDescriptors, $dade464b59c7f664$var$$f = Object.getOwnPropertySymbols, $dade464b59c7f664$var$Eu = Object.prototype.hasOwnProperty, $dade464b59c7f664$var$Su = Object.prototype.propertyIsEnumerable, $dade464b59c7f664$var$to = (e, t, r)=>t in e ? $dade464b59c7f664$var$wu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $dade464b59c7f664$var$Nu = (e, t)=>{
    for(var r in t || (t = {}))$dade464b59c7f664$var$Eu.call(t, r) && $dade464b59c7f664$var$to(e, r, t[r]);
    if ($dade464b59c7f664$var$$f) for (var r of $dade464b59c7f664$var$$f(t))$dade464b59c7f664$var$Su.call(t, r) && $dade464b59c7f664$var$to(e, r, t[r]);
    return e;
}, $dade464b59c7f664$var$Iu = (e, t)=>$dade464b59c7f664$var$xu(e, $dade464b59c7f664$var$Mu(t));
const $dade464b59c7f664$export$f7403969428298bd = "base10", $dade464b59c7f664$export$49eb910ab2518105 = "base16", $dade464b59c7f664$export$9bff723d552e6bcf = "base64pad", $dade464b59c7f664$export$9560dad2a83e4f04 = "utf8", $dade464b59c7f664$export$3425bd336a9673d8 = 0, $dade464b59c7f664$export$406e97c329f0f3d4 = 1, $dade464b59c7f664$var$_u = 0, $dade464b59c7f664$var$eo = 1, $dade464b59c7f664$var$Vi = 12, $dade464b59c7f664$var$Wi = 32;
function $dade464b59c7f664$export$a949d36eab55b41f() {
    const e = $lzf2X.generateKeyPair();
    return {
        privateKey: (0, $5t5tf.toString)(e.secretKey, $dade464b59c7f664$export$49eb910ab2518105),
        publicKey: (0, $5t5tf.toString)(e.publicKey, $dade464b59c7f664$export$49eb910ab2518105)
    };
}
function $dade464b59c7f664$export$d15a28e4f1821243() {
    const e = (0, $aftW8.randomBytes)($dade464b59c7f664$var$Wi);
    return (0, $5t5tf.toString)(e, $dade464b59c7f664$export$49eb910ab2518105);
}
function $dade464b59c7f664$export$f8378f68e053f5c6(e, t) {
    const r = $lzf2X.sharedKey((0, $50fYI.fromString)(e, $dade464b59c7f664$export$49eb910ab2518105), (0, $50fYI.fromString)(t, $dade464b59c7f664$export$49eb910ab2518105), !0), i = new (0, $bNsWC.HKDF)((0, $41Mfc.SHA256), r).expand($dade464b59c7f664$var$Wi);
    return (0, $5t5tf.toString)(i, $dade464b59c7f664$export$49eb910ab2518105);
}
function $dade464b59c7f664$export$1e87d19d4aab5805(e) {
    const t = (0, $41Mfc.hash)((0, $50fYI.fromString)(e, $dade464b59c7f664$export$49eb910ab2518105));
    return (0, $5t5tf.toString)(t, $dade464b59c7f664$export$49eb910ab2518105);
}
function $dade464b59c7f664$export$d4c241cec96564c1(e) {
    const t = (0, $41Mfc.hash)((0, $50fYI.fromString)(e, $dade464b59c7f664$export$9560dad2a83e4f04));
    return (0, $5t5tf.toString)(t, $dade464b59c7f664$export$49eb910ab2518105);
}
function $dade464b59c7f664$export$e9d2f9ba70428fb6(e) {
    return (0, $50fYI.fromString)(`${e}`, $dade464b59c7f664$export$f7403969428298bd);
}
function $dade464b59c7f664$export$7547a514ee29b9d4(e) {
    return Number((0, $5t5tf.toString)(e, $dade464b59c7f664$export$f7403969428298bd));
}
function $dade464b59c7f664$export$5b0f6292f11d1d18(e) {
    const t = $dade464b59c7f664$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $dade464b59c7f664$export$3425bd336a9673d8);
    if ($dade464b59c7f664$export$7547a514ee29b9d4(t) === $dade464b59c7f664$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const r = typeof e.senderPublicKey < "u" ? (0, $50fYI.fromString)(e.senderPublicKey, $dade464b59c7f664$export$49eb910ab2518105) : void 0, i = typeof e.iv < "u" ? (0, $50fYI.fromString)(e.iv, $dade464b59c7f664$export$49eb910ab2518105) : (0, $aftW8.randomBytes)($dade464b59c7f664$var$Vi), n = new (0, $1YStM.ChaCha20Poly1305)((0, $50fYI.fromString)(e.symKey, $dade464b59c7f664$export$49eb910ab2518105)).seal(i, (0, $50fYI.fromString)(e.message, $dade464b59c7f664$export$9560dad2a83e4f04));
    return $dade464b59c7f664$export$dfdc1655ccc5b9cb({
        type: t,
        sealed: n,
        iv: i,
        senderPublicKey: r
    });
}
function $dade464b59c7f664$export$e85a0c9a1067c5d3(e) {
    const t = new (0, $1YStM.ChaCha20Poly1305)((0, $50fYI.fromString)(e.symKey, $dade464b59c7f664$export$49eb910ab2518105)), { sealed: r, iv: i } = $dade464b59c7f664$export$efcd34ab6248d3cd(e.encoded), n = t.open(i, r);
    if (n === null) throw new Error("Failed to decrypt");
    return (0, $5t5tf.toString)(n, $dade464b59c7f664$export$9560dad2a83e4f04);
}
function $dade464b59c7f664$export$dfdc1655ccc5b9cb(e) {
    if ($dade464b59c7f664$export$7547a514ee29b9d4(e.type) === $dade464b59c7f664$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $5t5tf.toString)((0, $7GAet.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $dade464b59c7f664$export$9bff723d552e6bcf);
    }
    return (0, $5t5tf.toString)((0, $7GAet.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $dade464b59c7f664$export$9bff723d552e6bcf);
}
function $dade464b59c7f664$export$efcd34ab6248d3cd(e) {
    const t = (0, $50fYI.fromString)(e, $dade464b59c7f664$export$9bff723d552e6bcf), r = t.slice($dade464b59c7f664$var$_u, $dade464b59c7f664$var$eo), i = $dade464b59c7f664$var$eo;
    if ($dade464b59c7f664$export$7547a514ee29b9d4(r) === $dade464b59c7f664$export$406e97c329f0f3d4) {
        const p = i + $dade464b59c7f664$var$Wi, A = p + $dade464b59c7f664$var$Vi, m = t.slice(i, p), w = t.slice(p, A), y = t.slice(A);
        return {
            type: r,
            sealed: y,
            iv: w,
            senderPublicKey: m
        };
    }
    const n = i + $dade464b59c7f664$var$Vi, o = t.slice(i, n), h = t.slice(n);
    return {
        type: r,
        sealed: h,
        iv: o
    };
}
function $dade464b59c7f664$export$177f3e316562333d(e, t) {
    const r = $dade464b59c7f664$export$efcd34ab6248d3cd(e);
    return $dade464b59c7f664$export$7949f60f2444aef2({
        type: $dade464b59c7f664$export$7547a514ee29b9d4(r.type),
        senderPublicKey: typeof r.senderPublicKey < "u" ? (0, $5t5tf.toString)(r.senderPublicKey, $dade464b59c7f664$export$49eb910ab2518105) : void 0,
        receiverPublicKey: t?.receiverPublicKey
    });
}
function $dade464b59c7f664$export$7949f60f2444aef2(e) {
    const t = e?.type || $dade464b59c7f664$export$3425bd336a9673d8;
    if (t === $dade464b59c7f664$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: t,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $dade464b59c7f664$export$8c165704db2d5c15(e) {
    return e.type === $dade464b59c7f664$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
function $dade464b59c7f664$export$63aed4db4cd72ee8(e) {
    return new (0, $hYa4V.ec)("p256").keyFromPublic({
        x: $dade464b59c7f664$require$Buffer.from(e.x, "base64").toString("hex"),
        y: $dade464b59c7f664$require$Buffer.from(e.y, "base64").toString("hex")
    }, "hex");
}
function $dade464b59c7f664$var$ku(e) {
    let t = e.replace(/-/g, "+").replace(/_/g, "/");
    const r = t.length % 4;
    return r > 0 && (t += "=".repeat(4 - r)), t;
}
function $dade464b59c7f664$var$qu(e) {
    return $dade464b59c7f664$require$Buffer.from($dade464b59c7f664$var$ku(e), "base64");
}
function $dade464b59c7f664$export$f65520390041ee33(e, t) {
    const [r, i, n] = e.split("."), o = $dade464b59c7f664$var$qu(n);
    if (o.length !== 64) throw new Error("Invalid signature length");
    const h = o.slice(0, 32).toString("hex"), p = o.slice(32, 64).toString("hex"), A = `${r}.${i}`, m = new (0, $41Mfc.SHA256)().update($dade464b59c7f664$require$Buffer.from(A)).digest(), w = $dade464b59c7f664$export$63aed4db4cd72ee8(t), y = $dade464b59c7f664$require$Buffer.from(m).toString("hex"), S = w.verify(y, {
        r: h,
        s: p
    });
    if (!S) throw new Error("Invalid signature");
    const I = (0, $i4OlP.decodeJWT)(e);
    return $dade464b59c7f664$var$Iu($dade464b59c7f664$var$Nu({}, I.payload), {
        isVerified: S
    });
}
const $dade464b59c7f664$export$822d0bd1635d5360 = "irn";
function $dade464b59c7f664$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $dade464b59c7f664$export$822d0bd1635d5360
    };
}
function $dade464b59c7f664$export$604e3deb95e1b734(e) {
    const t = (0, $7Dl6y.RELAY_JSONRPC)[e];
    if (typeof t > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return t;
}
var $dade464b59c7f664$var$Lu = Object.defineProperty, $dade464b59c7f664$var$ju = Object.defineProperties, $dade464b59c7f664$var$Qu = Object.getOwnPropertyDescriptors, $dade464b59c7f664$var$so = Object.getOwnPropertySymbols, $dade464b59c7f664$var$Ju = Object.prototype.hasOwnProperty, $dade464b59c7f664$var$Gu = Object.prototype.propertyIsEnumerable, $dade464b59c7f664$var$ao = (e, t, r)=>t in e ? $dade464b59c7f664$var$Lu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $dade464b59c7f664$var$uo = (e, t)=>{
    for(var r in t || (t = {}))$dade464b59c7f664$var$Ju.call(t, r) && $dade464b59c7f664$var$ao(e, r, t[r]);
    if ($dade464b59c7f664$var$so) for (var r of $dade464b59c7f664$var$so(t))$dade464b59c7f664$var$Gu.call(t, r) && $dade464b59c7f664$var$ao(e, r, t[r]);
    return e;
}, $dade464b59c7f664$var$Yu = (e, t)=>$dade464b59c7f664$var$ju(e, $dade464b59c7f664$var$Qu(t));
function $dade464b59c7f664$export$3d24f408c2ac468a(e, t = "-") {
    const r = {}, i = "relay" + t;
    return Object.keys(e).forEach((n)=>{
        if (n.startsWith(i)) {
            const o = n.replace(i, ""), h = e[n];
            r[o] = h;
        }
    }), r;
}
function $dade464b59c7f664$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const t = e.indexOf(":"), r = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, i = e.substring(0, t), n = e.substring(t + 1, r).split("@"), o = typeof r < "u" ? e.substring(r) : "", h = $ezpuP.parse(o), p = typeof h.methods == "string" ? h.methods.split(",") : void 0;
    return {
        protocol: i,
        topic: $dade464b59c7f664$export$5ddc9ebef1d00f28(n[0]),
        version: parseInt(n[1], 10),
        symKey: h.symKey,
        relay: $dade464b59c7f664$export$3d24f408c2ac468a(h),
        methods: p,
        expiryTimestamp: h.expiryTimestamp ? parseInt(h.expiryTimestamp, 10) : void 0
    };
}
function $dade464b59c7f664$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $dade464b59c7f664$export$65c55c7ccd19bb8f(e, t = "-") {
    const r = "relay", i = {};
    return Object.keys(e).forEach((n)=>{
        const o = r + t + n;
        e[n] && (i[o] = e[n]);
    }), i;
}
function $dade464b59c7f664$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $ezpuP.stringify($dade464b59c7f664$var$uo($dade464b59c7f664$var$Yu($dade464b59c7f664$var$uo({
        symKey: e.symKey
    }, $dade464b59c7f664$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }), e.methods ? {
        methods: e.methods.join(",")
    } : {}));
}
var $dade464b59c7f664$var$Xu = Object.defineProperty, $dade464b59c7f664$var$Zu = Object.defineProperties, $dade464b59c7f664$var$$u = Object.getOwnPropertyDescriptors, $dade464b59c7f664$var$po = Object.getOwnPropertySymbols, $dade464b59c7f664$var$th = Object.prototype.hasOwnProperty, $dade464b59c7f664$var$eh = Object.prototype.propertyIsEnumerable, $dade464b59c7f664$var$vo = (e, t, r)=>t in e ? $dade464b59c7f664$var$Xu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $dade464b59c7f664$var$rh = (e, t)=>{
    for(var r in t || (t = {}))$dade464b59c7f664$var$th.call(t, r) && $dade464b59c7f664$var$vo(e, r, t[r]);
    if ($dade464b59c7f664$var$po) for (var r of $dade464b59c7f664$var$po(t))$dade464b59c7f664$var$eh.call(t, r) && $dade464b59c7f664$var$vo(e, r, t[r]);
    return e;
}, $dade464b59c7f664$var$ih = (e, t)=>$dade464b59c7f664$var$Zu(e, $dade464b59c7f664$var$$u(t));
function $dade464b59c7f664$export$d46695d9c3664fe9(e) {
    const t = [];
    return e.forEach((r)=>{
        const [i, n] = r.split(":");
        t.push(`${i}:${n}`);
    }), t;
}
function $dade464b59c7f664$export$fb6db6038e742b14(e) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        t.push(...$dade464b59c7f664$export$d46695d9c3664fe9(r.accounts));
    }), t;
}
function $dade464b59c7f664$export$7dcf4808e17b15ac(e, t) {
    const r = [];
    return Object.values(e).forEach((i)=>{
        $dade464b59c7f664$export$d46695d9c3664fe9(i.accounts).includes(t) && r.push(...i.methods);
    }), r;
}
function $dade464b59c7f664$export$94ee6d00e384a22(e, t) {
    const r = [];
    return Object.values(e).forEach((i)=>{
        $dade464b59c7f664$export$d46695d9c3664fe9(i.accounts).includes(t) && r.push(...i.events);
    }), r;
}
function $dade464b59c7f664$export$a8daa26a7c60ef90(e, t) {
    const r = $dade464b59c7f664$export$93f7b81dc815a714(e, t);
    if (r) throw new Error(r.message);
    const i = {};
    for (const [n, o] of Object.entries(e))i[n] = {
        methods: o.methods,
        events: o.events,
        chains: o.accounts.map((h)=>`${h.split(":")[0]}:${h.split(":")[1]}`)
    };
    return i;
}
function $dade464b59c7f664$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: t, optionalNamespaces: r = {} }, supportedNamespaces: i } = e, n = $dade464b59c7f664$export$2994550cda701c96(t), o = $dade464b59c7f664$export$2994550cda701c96(r), h = {};
    Object.keys(i).forEach((m)=>{
        const w = i[m].chains, y = i[m].methods, S = i[m].events, I = i[m].accounts;
        w.forEach((N)=>{
            if (!I.some((C)=>C.includes(N))) throw new Error(`No accounts provided for chain ${N} in namespace ${m}`);
        }), h[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    });
    const p = $dade464b59c7f664$export$ba5b0a4b585cd1b4(t, h, "approve()");
    if (p) throw new Error(p.message);
    const A = {};
    return !Object.keys(t).length && !Object.keys(r).length ? h : (Object.keys(n).forEach((m)=>{
        const w = i[m].chains.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.chains) == null ? void 0 : F.includes(N);
        }), y = i[m].methods.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.methods) == null ? void 0 : F.includes(N);
        }), S = i[m].events.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.events) == null ? void 0 : F.includes(N);
        }), I = w.map((N)=>i[m].accounts.filter((C)=>C.includes(`${N}:`))).flat();
        A[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    }), Object.keys(o).forEach((m)=>{
        var w, y, S, I, N, C;
        if (!i[m]) return;
        const F = (y = (w = o[m]) == null ? void 0 : w.chains) == null ? void 0 : y.filter((G)=>i[m].chains.includes(G)), U = i[m].methods.filter((G)=>{
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.methods) == null ? void 0 : z.includes(G);
        }), J = i[m].events.filter((G)=>{
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.events) == null ? void 0 : z.includes(G);
        }), Bt = F?.map((G)=>i[m].accounts.filter((H)=>H.includes(`${G}:`))).flat();
        A[m] = {
            chains: $dade464b59c7f664$export$9826fe7ad3921016((S = A[m]) == null ? void 0 : S.chains, F),
            methods: $dade464b59c7f664$export$9826fe7ad3921016((I = A[m]) == null ? void 0 : I.methods, U),
            events: $dade464b59c7f664$export$9826fe7ad3921016((N = A[m]) == null ? void 0 : N.events, J),
            accounts: $dade464b59c7f664$export$9826fe7ad3921016((C = A[m]) == null ? void 0 : C.accounts, Bt)
        };
    }), A);
}
function $dade464b59c7f664$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $dade464b59c7f664$export$dd404c96fbbb1ff8(e) {
    return $dade464b59c7f664$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $dade464b59c7f664$export$2994550cda701c96(e) {
    var t, r, i;
    const n = {};
    if (!$dade464b59c7f664$export$16a0268bc22b47b0(e)) return n;
    for (const [o, h] of Object.entries(e)){
        const p = $dade464b59c7f664$export$e03e993df4723bde(o) ? [
            o
        ] : h.chains, A = h.methods || [], m = h.events || [], w = $dade464b59c7f664$export$dd404c96fbbb1ff8(o);
        n[w] = $dade464b59c7f664$var$ih($dade464b59c7f664$var$rh({}, n[w]), {
            chains: $dade464b59c7f664$export$9826fe7ad3921016(p, (t = n[w]) == null ? void 0 : t.chains),
            methods: $dade464b59c7f664$export$9826fe7ad3921016(A, (r = n[w]) == null ? void 0 : r.methods),
            events: $dade464b59c7f664$export$9826fe7ad3921016(m, (i = n[w]) == null ? void 0 : i.events)
        });
    }
    return n;
}
function $dade464b59c7f664$export$293459f1cc8d700(e) {
    const t = {};
    return e?.forEach((r)=>{
        const [i, n] = r.split(":");
        t[i] || (t[i] = {
            accounts: [],
            chains: [],
            events: []
        }), t[i].accounts.push(r), t[i].chains.push(`${i}:${n}`);
    }), t;
}
function $dade464b59c7f664$export$b5744b1c39447540(e, t) {
    t = t.map((i)=>i.replace("did:pkh:", ""));
    const r = $dade464b59c7f664$export$293459f1cc8d700(t);
    for (const [i, n] of Object.entries(r))n.methods ? n.methods = $dade464b59c7f664$export$9826fe7ad3921016(n.methods, e) : n.methods = e, n.events = [
        "chainChanged",
        "accountsChanged"
    ];
    return r;
}
const $dade464b59c7f664$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $dade464b59c7f664$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $dade464b59c7f664$export$500d4c4a8fafe35(e, t) {
    const { message: r, code: i } = $dade464b59c7f664$export$77b3faa414a0ce61[e];
    return {
        message: t ? `${r} ${t}` : r,
        code: i
    };
}
function $dade464b59c7f664$export$8203ef1531c8b5b5(e, t) {
    const { message: r, code: i } = $dade464b59c7f664$export$990de0b632caca05[e];
    return {
        message: t ? `${r} ${t}` : r,
        code: i
    };
}
function $dade464b59c7f664$export$41dd3d480aac4a71(e, t) {
    return Array.isArray(e) ? typeof t < "u" && e.length ? e.every(t) : !0 : !1;
}
function $dade464b59c7f664$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $dade464b59c7f664$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $dade464b59c7f664$export$ee898ca48ab56c74(e, t) {
    return t && $dade464b59c7f664$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $dade464b59c7f664$export$d6781b696a0576d1(e, t) {
    return t && $dade464b59c7f664$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $dade464b59c7f664$export$6fc4971bf8f326a(e, t) {
    const { requiredNamespaces: r } = t, i = Object.keys(e.namespaces), n = Object.keys(r);
    let o = !0;
    return $dade464b59c7f664$export$1468a49de573f7f9(n, i) ? (i.forEach((h)=>{
        const { accounts: p, methods: A, events: m } = e.namespaces[h], w = $dade464b59c7f664$export$d46695d9c3664fe9(p), y = r[h];
        (!$dade464b59c7f664$export$1468a49de573f7f9($dade464b59c7f664$export$376384387cd15b27(h, y), w) || !$dade464b59c7f664$export$1468a49de573f7f9(y.methods, A) || !$dade464b59c7f664$export$1468a49de573f7f9(y.events, m)) && (o = !1);
    }), o) : !1;
}
function $dade464b59c7f664$export$e544b39f0a22e47a(e) {
    return $dade464b59c7f664$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $dade464b59c7f664$export$49e4a5b6862e3c71(e) {
    if ($dade464b59c7f664$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const t = e.split(":");
        if (t.length === 3) {
            const r = t[0] + ":" + t[1];
            return !!t[2] && $dade464b59c7f664$export$e544b39f0a22e47a(r);
        }
    }
    return !1;
}
function $dade464b59c7f664$export$bef94a5618bf18bf(e) {
    if ($dade464b59c7f664$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $dade464b59c7f664$export$f657f7976bb2769d(e) {
    var t;
    return (t = e?.proposer) == null ? void 0 : t.publicKey;
}
function $dade464b59c7f664$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $dade464b59c7f664$export$5e1c5c89613c213f(e, t) {
    let r = null;
    return $dade464b59c7f664$export$ee898ca48ab56c74(e?.publicKey, !1) || (r = $dade464b59c7f664$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t} controller public key should be a string`)), r;
}
function $dade464b59c7f664$export$c12fced8176774f3(e) {
    let t = !0;
    return $dade464b59c7f664$export$41dd3d480aac4a71(e) ? e.length && (t = e.every((r)=>$dade464b59c7f664$export$ee898ca48ab56c74(r, !1))) : t = !1, t;
}
function $dade464b59c7f664$export$df46c123d7e298ce(e, t, r) {
    let i = null;
    return $dade464b59c7f664$export$41dd3d480aac4a71(t) && t.length ? t.forEach((n)=>{
        i || $dade464b59c7f664$export$e544b39f0a22e47a(n) || (i = $dade464b59c7f664$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${r}, chain ${n} should be a string and conform to "namespace:chainId" format`));
    }) : $dade464b59c7f664$export$e544b39f0a22e47a(e) || (i = $dade464b59c7f664$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${r}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), i;
}
function $dade464b59c7f664$export$94ae96fb66f29e08(e, t, r) {
    let i = null;
    return Object.entries(e).forEach(([n, o])=>{
        if (i) return;
        const h = $dade464b59c7f664$export$df46c123d7e298ce(n, $dade464b59c7f664$export$376384387cd15b27(n, o), `${t} ${r}`);
        h && (i = h);
    }), i;
}
function $dade464b59c7f664$export$d5644026aaffb9e7(e, t) {
    let r = null;
    return $dade464b59c7f664$export$41dd3d480aac4a71(e) ? e.forEach((i)=>{
        r || $dade464b59c7f664$export$49e4a5b6862e3c71(i) || (r = $dade464b59c7f664$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${t}, account ${i} should be a string and conform to "namespace:chainId:address" format`));
    }) : r = $dade464b59c7f664$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${t}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), r;
}
function $dade464b59c7f664$export$2a2012e7bfa1cfb4(e, t) {
    let r = null;
    return Object.values(e).forEach((i)=>{
        if (r) return;
        const n = $dade464b59c7f664$export$d5644026aaffb9e7(i?.accounts, `${t} namespace`);
        n && (r = n);
    }), r;
}
function $dade464b59c7f664$export$b32541d63753af56(e, t) {
    let r = null;
    return $dade464b59c7f664$export$c12fced8176774f3(e?.methods) ? $dade464b59c7f664$export$c12fced8176774f3(e?.events) || (r = $dade464b59c7f664$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${t}, events should be an array of strings or empty array for no events`)) : r = $dade464b59c7f664$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${t}, methods should be an array of strings or empty array for no methods`), r;
}
function $dade464b59c7f664$export$27682c78deeca9d7(e, t) {
    let r = null;
    return Object.values(e).forEach((i)=>{
        if (r) return;
        const n = $dade464b59c7f664$export$b32541d63753af56(i, `${t}, namespace`);
        n && (r = n);
    }), r;
}
function $dade464b59c7f664$export$9e2b2cae22c6a8b3(e, t, r) {
    let i = null;
    if (e && $dade464b59c7f664$export$16a0268bc22b47b0(e)) {
        const n = $dade464b59c7f664$export$27682c78deeca9d7(e, t);
        n && (i = n);
        const o = $dade464b59c7f664$export$94ae96fb66f29e08(e, t, r);
        o && (i = o);
    } else i = $dade464b59c7f664$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t}, ${r} should be an object with data`);
    return i;
}
function $dade464b59c7f664$export$93f7b81dc815a714(e, t) {
    let r = null;
    if (e && $dade464b59c7f664$export$16a0268bc22b47b0(e)) {
        const i = $dade464b59c7f664$export$27682c78deeca9d7(e, t);
        i && (r = i);
        const n = $dade464b59c7f664$export$2a2012e7bfa1cfb4(e, t);
        n && (r = n);
    } else r = $dade464b59c7f664$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t}, namespaces should be an object with data`);
    return r;
}
function $dade464b59c7f664$export$1b3fc298be8c9a7b(e) {
    return $dade464b59c7f664$export$ee898ca48ab56c74(e.protocol, !0);
}
function $dade464b59c7f664$export$6294c30b976bd21e(e, t) {
    let r = !1;
    return t && !e ? r = !0 : e && $dade464b59c7f664$export$41dd3d480aac4a71(e) && e.length && e.forEach((i)=>{
        r = $dade464b59c7f664$export$1b3fc298be8c9a7b(i);
    }), r;
}
function $dade464b59c7f664$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $dade464b59c7f664$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $dade464b59c7f664$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$dade464b59c7f664$export$d6781b696a0576d1(e.code, !1) || !e.message || !$dade464b59c7f664$export$ee898ca48ab56c74(e.message, !1));
}
function $dade464b59c7f664$export$1a2af3c017fb6d42(e) {
    return !($dade464b59c7f664$export$fce6876652108ab(e) || !$dade464b59c7f664$export$ee898ca48ab56c74(e.method, !1));
}
function $dade464b59c7f664$export$1ae38cf0a848f651(e) {
    return !($dade464b59c7f664$export$fce6876652108ab(e) || $dade464b59c7f664$export$fce6876652108ab(e.result) && $dade464b59c7f664$export$fce6876652108ab(e.error) || !$dade464b59c7f664$export$d6781b696a0576d1(e.id, !1) || !$dade464b59c7f664$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $dade464b59c7f664$export$cbe4cdc5960cfa11(e) {
    return !($dade464b59c7f664$export$fce6876652108ab(e) || !$dade464b59c7f664$export$ee898ca48ab56c74(e.name, !1));
}
function $dade464b59c7f664$export$144fc36610eb6522(e, t) {
    return !(!$dade464b59c7f664$export$e544b39f0a22e47a(t) || !$dade464b59c7f664$export$fb6db6038e742b14(e).includes(t));
}
function $dade464b59c7f664$export$8db4804e3a6de711(e, t, r) {
    return $dade464b59c7f664$export$ee898ca48ab56c74(r, !1) ? $dade464b59c7f664$export$7dcf4808e17b15ac(e, t).includes(r) : !1;
}
function $dade464b59c7f664$export$df2c67ef8baad16b(e, t, r) {
    return $dade464b59c7f664$export$ee898ca48ab56c74(r, !1) ? $dade464b59c7f664$export$94ee6d00e384a22(e, t).includes(r) : !1;
}
function $dade464b59c7f664$export$ba5b0a4b585cd1b4(e, t, r) {
    let i = null;
    const n = $dade464b59c7f664$var$Mh(e), o = $dade464b59c7f664$var$Eh(t), h = Object.keys(n), p = Object.keys(o), A = $dade464b59c7f664$var$Oo(Object.keys(e)), m = $dade464b59c7f664$var$Oo(Object.keys(t)), w = A.filter((y)=>!m.includes(y));
    return w.length && (i = $dade464b59c7f664$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces keys don't satisfy requiredNamespaces.
      Required: ${w.toString()}
      Received: ${Object.keys(t).toString()}`)), $dade464b59c7f664$export$1468a49de573f7f9(h, p) || (i = $dade464b59c7f664$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces chains don't satisfy required namespaces.
      Required: ${h.toString()}
      Approved: ${p.toString()}`)), Object.keys(t).forEach((y)=>{
        if (!y.includes(":") || i) return;
        const S = $dade464b59c7f664$export$d46695d9c3664fe9(t[y].accounts);
        S.includes(y) || (i = $dade464b59c7f664$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces accounts don't satisfy namespace accounts for ${y}
        Required: ${y}
        Approved: ${S.toString()}`));
    }), h.forEach((y)=>{
        i || ($dade464b59c7f664$export$1468a49de573f7f9(n[y].methods, o[y].methods) ? $dade464b59c7f664$export$1468a49de573f7f9(n[y].events, o[y].events) || (i = $dade464b59c7f664$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces events don't satisfy namespace events for ${y}`)) : i = $dade464b59c7f664$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces methods don't satisfy namespace methods for ${y}`));
    }), i;
}
function $dade464b59c7f664$var$Mh(e) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        var i;
        r.includes(":") ? t[r] = e[r] : (i = e[r].chains) == null || i.forEach((n)=>{
            t[n] = {
                methods: e[r].methods,
                events: e[r].events
            };
        });
    }), t;
}
function $dade464b59c7f664$var$Oo(e) {
    return [
        ...new Set(e.map((t)=>t.includes(":") ? t.split(":")[0] : t))
    ];
}
function $dade464b59c7f664$var$Eh(e) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        if (r.includes(":")) t[r] = e[r];
        else {
            const i = $dade464b59c7f664$export$d46695d9c3664fe9(e[r].accounts);
            i?.forEach((n)=>{
                t[n] = {
                    accounts: e[r].accounts.filter((o)=>o.includes(`${n}:`)),
                    methods: e[r].methods,
                    events: e[r].events
                };
            });
        }
    }), t;
}
function $dade464b59c7f664$export$59fba2af1ac782b(e, t) {
    return $dade464b59c7f664$export$d6781b696a0576d1(e, !1) && e <= t.max && e >= t.min;
}
function $dade464b59c7f664$export$53c2fd0173ad2b80() {
    const e = $dade464b59c7f664$export$57570b1603cf6adb();
    return new Promise((t)=>{
        switch(e){
            case $dade464b59c7f664$export$86b1301a63b15dd9.browser:
                t($dade464b59c7f664$export$2f147c609a999e49());
                break;
            case $dade464b59c7f664$export$86b1301a63b15dd9.reactNative:
                t($dade464b59c7f664$export$1444c95b1570bd12());
                break;
            case $dade464b59c7f664$export$86b1301a63b15dd9.node:
                t($dade464b59c7f664$export$aec5b2d627eec500());
                break;
            default:
                t(!0);
        }
    });
}
function $dade464b59c7f664$export$2f147c609a999e49() {
    return $dade464b59c7f664$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $dade464b59c7f664$export$1444c95b1570bd12() {
    if ($dade464b59c7f664$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $dade464b59c7f664$export$aec5b2d627eec500() {
    return !0;
}
function $dade464b59c7f664$export$600a1ee4bc680996(e) {
    switch($dade464b59c7f664$export$57570b1603cf6adb()){
        case $dade464b59c7f664$export$86b1301a63b15dd9.browser:
            $dade464b59c7f664$export$d32b24f18d96c5f2(e);
            break;
        case $dade464b59c7f664$export$86b1301a63b15dd9.reactNative:
            $dade464b59c7f664$export$904edb1c18ec91c7(e);
            break;
        case $dade464b59c7f664$export$86b1301a63b15dd9.node:
            break;
    }
}
function $dade464b59c7f664$export$d32b24f18d96c5f2(e) {
    !$dade464b59c7f664$export$f7a1e23e542d38e3() && $dade464b59c7f664$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $dade464b59c7f664$export$904edb1c18ec91c7(e) {
    $dade464b59c7f664$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((t)=>e(t?.isConnected));
}
const $dade464b59c7f664$var$rn = {};
class $dade464b59c7f664$export$b72d712fed4d036d {
    static get(t) {
        return $dade464b59c7f664$var$rn[t];
    }
    static set(t, r) {
        $dade464b59c7f664$var$rn[t] = r;
    }
    static delete(t) {
        delete $dade464b59c7f664$var$rn[t];
    }
}

});
parcelRegister("f3fVd", function(module, exports) {

$parcel$export(module.exports, "detect", function () { return $af537c963328d4a4$export$17b446b869dad473; });

var $eSBMZ = parcelRequire("eSBMZ");
var $af537c963328d4a4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $af537c963328d4a4$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $af537c963328d4a4$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $eSBMZ.platform;
    }
    return NodeInfo;
}();
var $af537c963328d4a4$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $af537c963328d4a4$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $af537c963328d4a4$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $af537c963328d4a4$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $af537c963328d4a4$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $af537c963328d4a4$var$REQUIRED_VERSION_PARTS = 3;
var $af537c963328d4a4$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $af537c963328d4a4$var$SEARCHBOX_UA_REGEX
    ]
];
var $af537c963328d4a4$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $af537c963328d4a4$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $af537c963328d4a4$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $af537c963328d4a4$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $af537c963328d4a4$export$1184956100eddc3c(navigator.userAgent);
    return $af537c963328d4a4$export$bf2c6630ab904918();
}
function $af537c963328d4a4$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $af537c963328d4a4$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $af537c963328d4a4$export$89ca9f8ca1a50fd5(ua) {
    var data = $af537c963328d4a4$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $af537c963328d4a4$export$1184956100eddc3c(ua) {
    var matchedRule = $af537c963328d4a4$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $af537c963328d4a4$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $af537c963328d4a4$var$REQUIRED_VERSION_PARTS) versionParts = $af537c963328d4a4$var$__spreadArray($af537c963328d4a4$var$__spreadArray([], versionParts, true), $af537c963328d4a4$var$createVersionParts($af537c963328d4a4$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $af537c963328d4a4$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $af537c963328d4a4$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $af537c963328d4a4$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $af537c963328d4a4$export$8fa985da04a86f0(name, version, os);
}
function $af537c963328d4a4$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $af537c963328d4a4$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $af537c963328d4a4$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $af537c963328d4a4$export$bf2c6630ab904918() {
    var isNode = typeof $eSBMZ !== "undefined" && $eSBMZ.version;
    return isNode ? new $af537c963328d4a4$export$62457c674e0167c0($eSBMZ.version.slice(1)) : null;
}
function $af537c963328d4a4$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

});
parcelRegister("eSBMZ", function(module, exports) {
// shim for using process in browser
var $ad536bfce0513606$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ad536bfce0513606$var$cachedSetTimeout;
var $ad536bfce0513606$var$cachedClearTimeout;
function $ad536bfce0513606$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ad536bfce0513606$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ad536bfce0513606$var$cachedSetTimeout = setTimeout;
        else $ad536bfce0513606$var$cachedSetTimeout = $ad536bfce0513606$var$defaultSetTimout;
    } catch (e) {
        $ad536bfce0513606$var$cachedSetTimeout = $ad536bfce0513606$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ad536bfce0513606$var$cachedClearTimeout = clearTimeout;
        else $ad536bfce0513606$var$cachedClearTimeout = $ad536bfce0513606$var$defaultClearTimeout;
    } catch (e) {
        $ad536bfce0513606$var$cachedClearTimeout = $ad536bfce0513606$var$defaultClearTimeout;
    }
})();
function $ad536bfce0513606$var$runTimeout(fun) {
    if ($ad536bfce0513606$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ad536bfce0513606$var$cachedSetTimeout === $ad536bfce0513606$var$defaultSetTimout || !$ad536bfce0513606$var$cachedSetTimeout) && setTimeout) {
        $ad536bfce0513606$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ad536bfce0513606$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ad536bfce0513606$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ad536bfce0513606$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ad536bfce0513606$var$runClearTimeout(marker) {
    if ($ad536bfce0513606$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ad536bfce0513606$var$cachedClearTimeout === $ad536bfce0513606$var$defaultClearTimeout || !$ad536bfce0513606$var$cachedClearTimeout) && clearTimeout) {
        $ad536bfce0513606$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ad536bfce0513606$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ad536bfce0513606$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ad536bfce0513606$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ad536bfce0513606$var$queue = [];
var $ad536bfce0513606$var$draining = false;
var $ad536bfce0513606$var$currentQueue;
var $ad536bfce0513606$var$queueIndex = -1;
function $ad536bfce0513606$var$cleanUpNextTick() {
    if (!$ad536bfce0513606$var$draining || !$ad536bfce0513606$var$currentQueue) return;
    $ad536bfce0513606$var$draining = false;
    if ($ad536bfce0513606$var$currentQueue.length) $ad536bfce0513606$var$queue = $ad536bfce0513606$var$currentQueue.concat($ad536bfce0513606$var$queue);
    else $ad536bfce0513606$var$queueIndex = -1;
    if ($ad536bfce0513606$var$queue.length) $ad536bfce0513606$var$drainQueue();
}
function $ad536bfce0513606$var$drainQueue() {
    if ($ad536bfce0513606$var$draining) return;
    var timeout = $ad536bfce0513606$var$runTimeout($ad536bfce0513606$var$cleanUpNextTick);
    $ad536bfce0513606$var$draining = true;
    var len = $ad536bfce0513606$var$queue.length;
    while(len){
        $ad536bfce0513606$var$currentQueue = $ad536bfce0513606$var$queue;
        $ad536bfce0513606$var$queue = [];
        while(++$ad536bfce0513606$var$queueIndex < len)if ($ad536bfce0513606$var$currentQueue) $ad536bfce0513606$var$currentQueue[$ad536bfce0513606$var$queueIndex].run();
        $ad536bfce0513606$var$queueIndex = -1;
        len = $ad536bfce0513606$var$queue.length;
    }
    $ad536bfce0513606$var$currentQueue = null;
    $ad536bfce0513606$var$draining = false;
    $ad536bfce0513606$var$runClearTimeout(timeout);
}
$ad536bfce0513606$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ad536bfce0513606$var$queue.push(new $ad536bfce0513606$var$Item(fun, args));
    if ($ad536bfce0513606$var$queue.length === 1 && !$ad536bfce0513606$var$draining) $ad536bfce0513606$var$runTimeout($ad536bfce0513606$var$drainQueue);
};
// v8 likes predictible objects
function $ad536bfce0513606$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ad536bfce0513606$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ad536bfce0513606$var$process.title = "browser";
$ad536bfce0513606$var$process.browser = true;
$ad536bfce0513606$var$process.env = {};
$ad536bfce0513606$var$process.argv = [];
$ad536bfce0513606$var$process.version = ""; // empty string to avoid regexp issues
$ad536bfce0513606$var$process.versions = {};
function $ad536bfce0513606$var$noop() {}
$ad536bfce0513606$var$process.on = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.addListener = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.once = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.off = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.removeListener = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.removeAllListeners = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.emit = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.prependListener = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.prependOnceListener = $ad536bfce0513606$var$noop;
$ad536bfce0513606$var$process.listeners = function(name) {
    return [];
};
$ad536bfce0513606$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ad536bfce0513606$var$process.cwd = function() {
    return "/";
};
$ad536bfce0513606$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ad536bfce0513606$var$process.umask = function() {
    return 0;
};

});


parcelRegister("iNdL8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $nLPsB = parcelRequire("nLPsB");

$nLPsB.__exportStar((parcelRequire("gnxLH")), module.exports);

$nLPsB.__exportStar((parcelRequire("4IMuV")), module.exports);

$nLPsB.__exportStar((parcelRequire("cz4TJ")), module.exports);

$nLPsB.__exportStar((parcelRequire("j9NOa")), module.exports);

});
parcelRegister("nLPsB", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $04773ff0ebbb21bd$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $04773ff0ebbb21bd$var$extendStatics = function(d, b) {
    $04773ff0ebbb21bd$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $04773ff0ebbb21bd$var$extendStatics(d, b);
};
function $04773ff0ebbb21bd$export$a8ba968b8961cb8a(d, b) {
    $04773ff0ebbb21bd$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $04773ff0ebbb21bd$export$18ce0697a983be9b = function() {
    $04773ff0ebbb21bd$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $04773ff0ebbb21bd$export$18ce0697a983be9b.apply(this, arguments);
};
function $04773ff0ebbb21bd$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $04773ff0ebbb21bd$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $04773ff0ebbb21bd$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $04773ff0ebbb21bd$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $04773ff0ebbb21bd$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $04773ff0ebbb21bd$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $04773ff0ebbb21bd$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $04773ff0ebbb21bd$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $04773ff0ebbb21bd$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $04773ff0ebbb21bd$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $04773ff0ebbb21bd$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($04773ff0ebbb21bd$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $04773ff0ebbb21bd$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $04773ff0ebbb21bd$export$10c90e4f7922046c(v) {
    return this instanceof $04773ff0ebbb21bd$export$10c90e4f7922046c ? (this.v = v, this) : new $04773ff0ebbb21bd$export$10c90e4f7922046c(v);
}
function $04773ff0ebbb21bd$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $04773ff0ebbb21bd$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $04773ff0ebbb21bd$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $04773ff0ebbb21bd$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $04773ff0ebbb21bd$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $04773ff0ebbb21bd$export$19a8beecd37a4c45 === "function" ? $04773ff0ebbb21bd$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $04773ff0ebbb21bd$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $04773ff0ebbb21bd$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $04773ff0ebbb21bd$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $04773ff0ebbb21bd$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $04773ff0ebbb21bd$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("gnxLH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $nLPsB = parcelRequire("nLPsB");

$nLPsB.__exportStar((parcelRequire("2sGiY")), module.exports);

$nLPsB.__exportStar((parcelRequire("3KylA")), module.exports);

});
parcelRegister("2sGiY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $1caf0334a57e4e02$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $1caf0334a57e4e02$var$delay;

});

parcelRegister("3KylA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $j9NOa = parcelRequire("j9NOa");
function $2bb04f9b895bffd0$var$toMiliseconds(seconds) {
    return seconds * $j9NOa.ONE_THOUSAND;
}
module.exports.toMiliseconds = $2bb04f9b895bffd0$var$toMiliseconds;
function $2bb04f9b895bffd0$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $j9NOa.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $2bb04f9b895bffd0$var$fromMiliseconds;

});
parcelRegister("j9NOa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $nLPsB = parcelRequire("nLPsB");

$nLPsB.__exportStar((parcelRequire("dYuww")), module.exports);

$nLPsB.__exportStar((parcelRequire("k3b1j")), module.exports);

});
parcelRegister("dYuww", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("k3b1j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("4IMuV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $3700e426363c8770$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $3700e426363c8770$var$Watch;
module.exports.default = $3700e426363c8770$var$Watch;

});

parcelRegister("cz4TJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $nLPsB = parcelRequire("nLPsB");

$nLPsB.__exportStar((parcelRequire("6xV6Q")), module.exports);

});
parcelRegister("6xV6Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $4c421fe230dd3b72$var$IWatch {
}
module.exports.IWatch = $4c421fe230dd3b72$var$IWatch;

});



parcelRegister("89XCI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocalStorage = module.exports.getLocalStorageOrThrow = module.exports.getCrypto = module.exports.getCryptoOrThrow = module.exports.getLocation = module.exports.getLocationOrThrow = module.exports.getNavigator = module.exports.getNavigatorOrThrow = module.exports.getDocument = module.exports.getDocumentOrThrow = module.exports.getFromWindowOrThrow = module.exports.getFromWindow = void 0;
function $5f0d69f5b207b054$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
module.exports.getFromWindow = $5f0d69f5b207b054$var$getFromWindow;
function $5f0d69f5b207b054$var$getFromWindowOrThrow(name) {
    const res = $5f0d69f5b207b054$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
module.exports.getFromWindowOrThrow = $5f0d69f5b207b054$var$getFromWindowOrThrow;
function $5f0d69f5b207b054$var$getDocumentOrThrow() {
    return $5f0d69f5b207b054$var$getFromWindowOrThrow("document");
}
module.exports.getDocumentOrThrow = $5f0d69f5b207b054$var$getDocumentOrThrow;
function $5f0d69f5b207b054$var$getDocument() {
    return $5f0d69f5b207b054$var$getFromWindow("document");
}
module.exports.getDocument = $5f0d69f5b207b054$var$getDocument;
function $5f0d69f5b207b054$var$getNavigatorOrThrow() {
    return $5f0d69f5b207b054$var$getFromWindowOrThrow("navigator");
}
module.exports.getNavigatorOrThrow = $5f0d69f5b207b054$var$getNavigatorOrThrow;
function $5f0d69f5b207b054$var$getNavigator() {
    return $5f0d69f5b207b054$var$getFromWindow("navigator");
}
module.exports.getNavigator = $5f0d69f5b207b054$var$getNavigator;
function $5f0d69f5b207b054$var$getLocationOrThrow() {
    return $5f0d69f5b207b054$var$getFromWindowOrThrow("location");
}
module.exports.getLocationOrThrow = $5f0d69f5b207b054$var$getLocationOrThrow;
function $5f0d69f5b207b054$var$getLocation() {
    return $5f0d69f5b207b054$var$getFromWindow("location");
}
module.exports.getLocation = $5f0d69f5b207b054$var$getLocation;
function $5f0d69f5b207b054$var$getCryptoOrThrow() {
    return $5f0d69f5b207b054$var$getFromWindowOrThrow("crypto");
}
module.exports.getCryptoOrThrow = $5f0d69f5b207b054$var$getCryptoOrThrow;
function $5f0d69f5b207b054$var$getCrypto() {
    return $5f0d69f5b207b054$var$getFromWindow("crypto");
}
module.exports.getCrypto = $5f0d69f5b207b054$var$getCrypto;
function $5f0d69f5b207b054$var$getLocalStorageOrThrow() {
    return $5f0d69f5b207b054$var$getFromWindowOrThrow("localStorage");
}
module.exports.getLocalStorageOrThrow = $5f0d69f5b207b054$var$getLocalStorageOrThrow;
function $5f0d69f5b207b054$var$getLocalStorage() {
    return $5f0d69f5b207b054$var$getFromWindow("localStorage");
}
module.exports.getLocalStorage = $5f0d69f5b207b054$var$getLocalStorage;

});

parcelRegister("8lDxr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWindowMetadata = void 0;

var $89XCI = parcelRequire("89XCI");
function $613ef466f7d15e00$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $89XCI.getDocumentOrThrow();
        loc = $89XCI.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
module.exports.getWindowMetadata = $613ef466f7d15e00$var$getWindowMetadata;

});

parcelRegister("ezpuP", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $02bcc6a7a5f4a347$export$f9380c9a627682d3; }, function (v) { return $02bcc6a7a5f4a347$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $02bcc6a7a5f4a347$export$98e6a39c04603d36; }, function (v) { return $02bcc6a7a5f4a347$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $02bcc6a7a5f4a347$export$fac44ee5b035f737; }, function (v) { return $02bcc6a7a5f4a347$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $02bcc6a7a5f4a347$export$7a5253c0f62e0150; }, function (v) { return $02bcc6a7a5f4a347$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $02bcc6a7a5f4a347$export$a8c1621ea79325d3; }, function (v) { return $02bcc6a7a5f4a347$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $02bcc6a7a5f4a347$export$357523c63a2253b9; }, function (v) { return $02bcc6a7a5f4a347$export$357523c63a2253b9 = v; });
var $02bcc6a7a5f4a347$export$f9380c9a627682d3;
var $02bcc6a7a5f4a347$export$98e6a39c04603d36;
var $02bcc6a7a5f4a347$export$fac44ee5b035f737;
var $02bcc6a7a5f4a347$export$7a5253c0f62e0150;
var $02bcc6a7a5f4a347$export$a8c1621ea79325d3;
var $02bcc6a7a5f4a347$export$357523c63a2253b9;
var $02bcc6a7a5f4a347$export$44c361b8ec72ef7f;
"use strict";

var $4zmpK = parcelRequire("4zmpK");

var $164VW = parcelRequire("164VW");

var $hLHiY = parcelRequire("hLHiY");

var $8OWdu = parcelRequire("8OWdu");
const $02bcc6a7a5f4a347$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $02bcc6a7a5f4a347$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $02bcc6a7a5f4a347$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $02bcc6a7a5f4a347$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $02bcc6a7a5f4a347$var$encode(key, options),
                            "[",
                            $02bcc6a7a5f4a347$var$encode(index, options),
                            "]=",
                            $02bcc6a7a5f4a347$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $02bcc6a7a5f4a347$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $02bcc6a7a5f4a347$var$encode(key, options),
                            "[]=",
                            $02bcc6a7a5f4a347$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $02bcc6a7a5f4a347$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $02bcc6a7a5f4a347$var$encode(key, options),
                            ":list=",
                            $02bcc6a7a5f4a347$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $02bcc6a7a5f4a347$var$encode(key, options),
                                keyValueSep,
                                $02bcc6a7a5f4a347$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $02bcc6a7a5f4a347$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $02bcc6a7a5f4a347$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $02bcc6a7a5f4a347$var$encode(key, options),
                            "=",
                            $02bcc6a7a5f4a347$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $02bcc6a7a5f4a347$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $02bcc6a7a5f4a347$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $02bcc6a7a5f4a347$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$02bcc6a7a5f4a347$var$decode(item, options)) : value === null ? value : $02bcc6a7a5f4a347$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $02bcc6a7a5f4a347$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$02bcc6a7a5f4a347$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $02bcc6a7a5f4a347$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $02bcc6a7a5f4a347$var$encode(value, options) {
    if (options.encode) return options.strict ? $4zmpK(value) : encodeURIComponent(value);
    return value;
}
function $02bcc6a7a5f4a347$var$decode(value, options) {
    if (options.decode) return $164VW(value);
    return value;
}
function $02bcc6a7a5f4a347$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $02bcc6a7a5f4a347$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $02bcc6a7a5f4a347$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $02bcc6a7a5f4a347$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $02bcc6a7a5f4a347$var$extract(input) {
    input = $02bcc6a7a5f4a347$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $02bcc6a7a5f4a347$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $02bcc6a7a5f4a347$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $02bcc6a7a5f4a347$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $02bcc6a7a5f4a347$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $hLHiY(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $02bcc6a7a5f4a347$var$decode(value, options);
        formatter($02bcc6a7a5f4a347$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $02bcc6a7a5f4a347$var$parseValue(value[k], options);
        else ret[key] = $02bcc6a7a5f4a347$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $02bcc6a7a5f4a347$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$02bcc6a7a5f4a347$export$f9380c9a627682d3 = $02bcc6a7a5f4a347$var$extract;
$02bcc6a7a5f4a347$export$98e6a39c04603d36 = $02bcc6a7a5f4a347$var$parse;
$02bcc6a7a5f4a347$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $02bcc6a7a5f4a347$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $02bcc6a7a5f4a347$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $02bcc6a7a5f4a347$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $02bcc6a7a5f4a347$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $02bcc6a7a5f4a347$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $02bcc6a7a5f4a347$var$encode(key, options) + "=" + $02bcc6a7a5f4a347$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$02bcc6a7a5f4a347$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $hLHiY(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $02bcc6a7a5f4a347$var$parse($02bcc6a7a5f4a347$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $02bcc6a7a5f4a347$var$decode(hash, options)
    } : {});
};
$02bcc6a7a5f4a347$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$02bcc6a7a5f4a347$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $02bcc6a7a5f4a347$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $02bcc6a7a5f4a347$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $02bcc6a7a5f4a347$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $02bcc6a7a5f4a347$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $02bcc6a7a5f4a347$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$02bcc6a7a5f4a347$var$encodeFragmentIdentifier] ? $02bcc6a7a5f4a347$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$02bcc6a7a5f4a347$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$02bcc6a7a5f4a347$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $02bcc6a7a5f4a347$export$7a5253c0f62e0150(input, options);
    return $02bcc6a7a5f4a347$export$a8c1621ea79325d3({
        url: url,
        query: $8OWdu(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$02bcc6a7a5f4a347$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $02bcc6a7a5f4a347$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("4zmpK", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("164VW", function(module, exports) {
"use strict";
var $0cca2db46a154421$var$token = "%[a-f0-9]{2}";
var $0cca2db46a154421$var$singleMatcher = new RegExp("(" + $0cca2db46a154421$var$token + ")|([^%]+?)", "gi");
var $0cca2db46a154421$var$multiMatcher = new RegExp("(" + $0cca2db46a154421$var$token + ")+", "gi");
function $0cca2db46a154421$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $0cca2db46a154421$var$decodeComponents(left), $0cca2db46a154421$var$decodeComponents(right));
}
function $0cca2db46a154421$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($0cca2db46a154421$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $0cca2db46a154421$var$decodeComponents(tokens, i).join("");
            tokens = input.match($0cca2db46a154421$var$singleMatcher) || [];
        }
        return input;
    }
}
function $0cca2db46a154421$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $0cca2db46a154421$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $0cca2db46a154421$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $0cca2db46a154421$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $0cca2db46a154421$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("hLHiY", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("8OWdu", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("1YStM", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9ZgbY = parcelRequire("9ZgbY");

var $3upCR = parcelRequire("3upCR");

var $iOcd0 = parcelRequire("iOcd0");

var $lURlJ = parcelRequire("lURlJ");

var $fbSAb = parcelRequire("fbSAb");
module.exports.KEY_LENGTH = 32;
module.exports.NONCE_LENGTH = 12;
module.exports.TAG_LENGTH = 16;
var $1715a784cfe83a0f$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $1715a784cfe83a0f$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = module.exports.NONCE_LENGTH;
        this.tagLength = module.exports.TAG_LENGTH;
        if (key.length !== module.exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $9ZgbY.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $9ZgbY.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $iOcd0.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $9ZgbY.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$fbSAb.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $9ZgbY.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $iOcd0.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $iOcd0.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $3upCR.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($1715a784cfe83a0f$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($1715a784cfe83a0f$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $lURlJ.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $lURlJ.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $iOcd0.wipe(tag);
        $iOcd0.wipe(length);
    };
    return ChaCha20Poly1305;
}();
module.exports.ChaCha20Poly1305 = $1715a784cfe83a0f$var$ChaCha20Poly1305;

});
parcelRegister("9ZgbY", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lURlJ = parcelRequire("lURlJ");

var $iOcd0 = parcelRequire("iOcd0");
// Number of ChaCha rounds (ChaCha20).
var $74565effe9530836$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $74565effe9530836$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $74565effe9530836$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $lURlJ.writeUint32LE(x0 + j0 | 0, out, 0);
    $lURlJ.writeUint32LE(x1 + j1 | 0, out, 4);
    $lURlJ.writeUint32LE(x2 + j2 | 0, out, 8);
    $lURlJ.writeUint32LE(x3 + j3 | 0, out, 12);
    $lURlJ.writeUint32LE(x4 + j4 | 0, out, 16);
    $lURlJ.writeUint32LE(x5 + j5 | 0, out, 20);
    $lURlJ.writeUint32LE(x6 + j6 | 0, out, 24);
    $lURlJ.writeUint32LE(x7 + j7 | 0, out, 28);
    $lURlJ.writeUint32LE(x8 + j8 | 0, out, 32);
    $lURlJ.writeUint32LE(x9 + j9 | 0, out, 36);
    $lURlJ.writeUint32LE(x10 + j10 | 0, out, 40);
    $lURlJ.writeUint32LE(x11 + j11 | 0, out, 44);
    $lURlJ.writeUint32LE(x12 + j12 | 0, out, 48);
    $lURlJ.writeUint32LE(x13 + j13 | 0, out, 52);
    $lURlJ.writeUint32LE(x14 + j14 | 0, out, 56);
    $lURlJ.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $74565effe9530836$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $74565effe9530836$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $74565effe9530836$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $iOcd0.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $iOcd0.wipe(nc);
    return dst;
}
module.exports.streamXOR = $74565effe9530836$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $74565effe9530836$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $iOcd0.wipe(dst);
    return $74565effe9530836$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
module.exports.stream = $74565effe9530836$var$stream;
function $74565effe9530836$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}

});
parcelRegister("lURlJ", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $B1V2b = parcelRequire("B1V2b");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $ff483603bd76f01a$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
module.exports.readInt16BE = $ff483603bd76f01a$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $ff483603bd76f01a$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
module.exports.readUint16BE = $ff483603bd76f01a$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $ff483603bd76f01a$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
module.exports.readInt16LE = $ff483603bd76f01a$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $ff483603bd76f01a$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint16LE = $ff483603bd76f01a$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
module.exports.writeUint16BE = $ff483603bd76f01a$var$writeUint16BE;
module.exports.writeInt16BE = $ff483603bd76f01a$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
module.exports.writeUint16LE = $ff483603bd76f01a$var$writeUint16LE;
module.exports.writeInt16LE = $ff483603bd76f01a$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $ff483603bd76f01a$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
module.exports.readInt32BE = $ff483603bd76f01a$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $ff483603bd76f01a$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
module.exports.readUint32BE = $ff483603bd76f01a$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $ff483603bd76f01a$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
module.exports.readInt32LE = $ff483603bd76f01a$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $ff483603bd76f01a$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint32LE = $ff483603bd76f01a$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
module.exports.writeUint32BE = $ff483603bd76f01a$var$writeUint32BE;
module.exports.writeInt32BE = $ff483603bd76f01a$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
module.exports.writeUint32LE = $ff483603bd76f01a$var$writeUint32LE;
module.exports.writeInt32LE = $ff483603bd76f01a$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ff483603bd76f01a$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ff483603bd76f01a$var$readInt32BE(array, offset);
    var lo = $ff483603bd76f01a$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64BE = $ff483603bd76f01a$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ff483603bd76f01a$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ff483603bd76f01a$var$readUint32BE(array, offset);
    var lo = $ff483603bd76f01a$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64BE = $ff483603bd76f01a$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ff483603bd76f01a$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ff483603bd76f01a$var$readInt32LE(array, offset);
    var hi = $ff483603bd76f01a$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64LE = $ff483603bd76f01a$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ff483603bd76f01a$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ff483603bd76f01a$var$readUint32LE(array, offset);
    var hi = $ff483603bd76f01a$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64LE = $ff483603bd76f01a$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ff483603bd76f01a$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $ff483603bd76f01a$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64BE = $ff483603bd76f01a$var$writeUint64BE;
module.exports.writeInt64BE = $ff483603bd76f01a$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ff483603bd76f01a$var$writeUint32LE(value >>> 0, out, offset);
    $ff483603bd76f01a$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64LE = $ff483603bd76f01a$var$writeUint64LE;
module.exports.writeInt64LE = $ff483603bd76f01a$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ff483603bd76f01a$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintBE = $ff483603bd76f01a$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ff483603bd76f01a$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintLE = $ff483603bd76f01a$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$B1V2b.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintBE = $ff483603bd76f01a$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$B1V2b.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintLE = $ff483603bd76f01a$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $ff483603bd76f01a$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
module.exports.readFloat32BE = $ff483603bd76f01a$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $ff483603bd76f01a$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
module.exports.readFloat32LE = $ff483603bd76f01a$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ff483603bd76f01a$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
module.exports.readFloat64BE = $ff483603bd76f01a$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ff483603bd76f01a$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
module.exports.readFloat64LE = $ff483603bd76f01a$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
module.exports.writeFloat32BE = $ff483603bd76f01a$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
module.exports.writeFloat32LE = $ff483603bd76f01a$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
module.exports.writeFloat64BE = $ff483603bd76f01a$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ff483603bd76f01a$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
module.exports.writeFloat64LE = $ff483603bd76f01a$var$writeFloat64LE;

});
parcelRegister("B1V2b", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $06f4f1dedf34b6aa$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
module.exports.mul = Math.imul || $06f4f1dedf34b6aa$var$imulShim;
/** 32-bit integer addition.  */ function $06f4f1dedf34b6aa$var$add(a, b) {
    return a + b | 0;
}
module.exports.add = $06f4f1dedf34b6aa$var$add;
/**  32-bit integer subtraction.  */ function $06f4f1dedf34b6aa$var$sub(a, b) {
    return a - b | 0;
}
module.exports.sub = $06f4f1dedf34b6aa$var$sub;
/** 32-bit integer left rotation */ function $06f4f1dedf34b6aa$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
module.exports.rotl = $06f4f1dedf34b6aa$var$rotl;
/** 32-bit integer left rotation */ function $06f4f1dedf34b6aa$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
module.exports.rotr = $06f4f1dedf34b6aa$var$rotr;
function $06f4f1dedf34b6aa$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ module.exports.isInteger = Number.isInteger || $06f4f1dedf34b6aa$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ module.exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ module.exports.isSafeInteger = function(n) {
    return module.exports.isInteger(n) && n >= -module.exports.MAX_SAFE_INTEGER && n <= module.exports.MAX_SAFE_INTEGER;
};

});


parcelRegister("iOcd0", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $db165de79061beb9$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
module.exports.wipe = $db165de79061beb9$var$wipe;

});


parcelRegister("3upCR", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fbSAb = parcelRequire("fbSAb");

var $iOcd0 = parcelRequire("iOcd0");
module.exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $28a80d304dae79af$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = module.exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $iOcd0.wipe(this._buffer);
        $iOcd0.wipe(this._r);
        $iOcd0.wipe(this._h);
        $iOcd0.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
module.exports.Poly1305 = $28a80d304dae79af$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $28a80d304dae79af$var$oneTimeAuth(key, data) {
    var h = new $28a80d304dae79af$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.oneTimeAuth = $28a80d304dae79af$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $28a80d304dae79af$var$equal(a, b) {
    if (a.length !== module.exports.DIGEST_LENGTH || b.length !== module.exports.DIGEST_LENGTH) return false;
    return $fbSAb.equal(a, b);
}
module.exports.equal = $28a80d304dae79af$var$equal;

});
parcelRegister("fbSAb", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $b0f2390f3d46773e$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
module.exports.select = $b0f2390f3d46773e$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $b0f2390f3d46773e$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
module.exports.lessOrEqual = $b0f2390f3d46773e$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $b0f2390f3d46773e$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
module.exports.compare = $b0f2390f3d46773e$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $b0f2390f3d46773e$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $b0f2390f3d46773e$var$compare(a, b) !== 0;
}
module.exports.equal = $b0f2390f3d46773e$var$equal;

});



parcelRegister("bNsWC", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFQl = parcelRequire("3VFQl");

var $iOcd0 = parcelRequire("iOcd0");
/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $896ab91af2aaf0e9$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $3VFQl.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $3VFQl.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $iOcd0.wipe(this._buffer);
        $iOcd0.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
module.exports.HKDF = $896ab91af2aaf0e9$var$HKDF; // TODO(dchest): maybe implement deriveKey?

});
parcelRegister("3VFQl", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $48nuH = parcelRequire("48nuH");

var $fbSAb = parcelRequire("fbSAb");

var $iOcd0 = parcelRequire("iOcd0");
/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $2dc7272a3f17e330$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($48nuH.isSerializableHash(this._inner) && $48nuH.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $iOcd0.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$48nuH.isSerializableHash(this._inner) || !$48nuH.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($48nuH.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($48nuH.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$48nuH.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$48nuH.isSerializableHash(this._inner) || !$48nuH.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$48nuH.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
module.exports.HMAC = $2dc7272a3f17e330$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $2dc7272a3f17e330$var$hmac(hash, key, data) {
    var h = new $2dc7272a3f17e330$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hmac = $2dc7272a3f17e330$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ module.exports.equal = $fbSAb.equal;

});
parcelRegister("48nuH", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $302a223cf5a0cdb4$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
module.exports.isSerializableHash = $302a223cf5a0cdb4$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.

});



parcelRegister("aftW8", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomStringForEntropy = module.exports.randomString = module.exports.randomUint32 = module.exports.randomBytes = module.exports.defaultRandomSource = void 0;

var $lRO5p = parcelRequire("lRO5p");

var $lURlJ = parcelRequire("lURlJ");

var $iOcd0 = parcelRequire("iOcd0");
module.exports.defaultRandomSource = new $lRO5p.SystemRandomSource();
function $776286e72cf18fe7$var$randomBytes(length, prng = module.exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
module.exports.randomBytes = $776286e72cf18fe7$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $776286e72cf18fe7$var$randomUint32(prng = module.exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $776286e72cf18fe7$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $lURlJ.readUint32LE)(buf);
    // Clean the buffer.
    (0, $iOcd0.wipe)(buf);
    return result;
}
module.exports.randomUint32 = $776286e72cf18fe7$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $776286e72cf18fe7$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $776286e72cf18fe7$var$randomString(length, charset = $776286e72cf18fe7$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $776286e72cf18fe7$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $iOcd0.wipe)(buf);
    }
    return out;
}
module.exports.randomString = $776286e72cf18fe7$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $776286e72cf18fe7$var$randomStringForEntropy(bits, charset = $776286e72cf18fe7$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $776286e72cf18fe7$var$randomString(length, charset, prng);
}
module.exports.randomStringForEntropy = $776286e72cf18fe7$var$randomStringForEntropy;

});
parcelRegister("lRO5p", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemRandomSource = void 0;

var $2VOUi = parcelRequire("2VOUi");

var $9YLDI = parcelRequire("9YLDI");
class $feb56647c10083e0$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $2VOUi.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $9YLDI.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
module.exports.SystemRandomSource = $feb56647c10083e0$var$SystemRandomSource;

});
parcelRegister("2VOUi", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRandomSource = void 0;
const $222864b949439b4d$var$QUOTA = 65536;
class $222864b949439b4d$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $222864b949439b4d$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $222864b949439b4d$var$QUOTA)));
        return out;
    }
}
module.exports.BrowserRandomSource = $222864b949439b4d$var$BrowserRandomSource;

});

parcelRegister("9YLDI", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeRandomSource = void 0;

var $iOcd0 = parcelRequire("iOcd0");

class $743eabdab5030c99$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("6AuhB"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $iOcd0.wipe)(buffer);
        return out;
    }
}
module.exports.NodeRandomSource = $743eabdab5030c99$var$NodeRandomSource;

});
parcelRegister("6AuhB", function(module, exports) {
"use strict";

});




parcelRegister("41Mfc", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lURlJ = parcelRequire("lURlJ");

var $iOcd0 = parcelRequire("iOcd0");
module.exports.DIGEST_LENGTH = 32;
module.exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $2eecadba9cc0d693$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $iOcd0.wipe(this._buffer);
        $iOcd0.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $2eecadba9cc0d693$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $2eecadba9cc0d693$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $lURlJ.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $lURlJ.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $2eecadba9cc0d693$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$lURlJ.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $iOcd0.wipe(savedState.state);
        if (savedState.buffer) $iOcd0.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
module.exports.SHA256 = $2eecadba9cc0d693$var$SHA256;
// Constants
var $2eecadba9cc0d693$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $2eecadba9cc0d693$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $lURlJ.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($2eecadba9cc0d693$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $2eecadba9cc0d693$var$hash(data) {
    var h = new $2eecadba9cc0d693$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $2eecadba9cc0d693$var$hash;

});

parcelRegister("lzf2X", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sharedKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.scalarMultBase = module.exports.scalarMult = module.exports.SHARED_KEY_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = void 0;

var $aftW8 = parcelRequire("aftW8");

var $iOcd0 = parcelRequire("iOcd0");
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 32;
module.exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $fb3889d52c2e0c71$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $fb3889d52c2e0c71$var$_9 = new Uint8Array(32);
$fb3889d52c2e0c71$var$_9[0] = 9;
const $fb3889d52c2e0c71$var$_121665 = $fb3889d52c2e0c71$var$gf([
    0xdb41,
    1
]);
function $fb3889d52c2e0c71$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $fb3889d52c2e0c71$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $fb3889d52c2e0c71$var$pack25519(o, n) {
    const m = $fb3889d52c2e0c71$var$gf();
    const t = $fb3889d52c2e0c71$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $fb3889d52c2e0c71$var$car25519(t);
    $fb3889d52c2e0c71$var$car25519(t);
    $fb3889d52c2e0c71$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $fb3889d52c2e0c71$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $fb3889d52c2e0c71$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $fb3889d52c2e0c71$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $fb3889d52c2e0c71$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $fb3889d52c2e0c71$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $fb3889d52c2e0c71$var$square(o, a) {
    $fb3889d52c2e0c71$var$mul(o, a, a);
}
function $fb3889d52c2e0c71$var$inv25519(o, inp) {
    const c = $fb3889d52c2e0c71$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $fb3889d52c2e0c71$var$square(c, c);
        if (i !== 2 && i !== 4) $fb3889d52c2e0c71$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $fb3889d52c2e0c71$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $fb3889d52c2e0c71$var$gf(), b = $fb3889d52c2e0c71$var$gf(), c = $fb3889d52c2e0c71$var$gf(), d = $fb3889d52c2e0c71$var$gf(), e = $fb3889d52c2e0c71$var$gf(), f = $fb3889d52c2e0c71$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $fb3889d52c2e0c71$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $fb3889d52c2e0c71$var$sel25519(a, b, r);
        $fb3889d52c2e0c71$var$sel25519(c, d, r);
        $fb3889d52c2e0c71$var$add(e, a, c);
        $fb3889d52c2e0c71$var$sub(a, a, c);
        $fb3889d52c2e0c71$var$add(c, b, d);
        $fb3889d52c2e0c71$var$sub(b, b, d);
        $fb3889d52c2e0c71$var$square(d, e);
        $fb3889d52c2e0c71$var$square(f, a);
        $fb3889d52c2e0c71$var$mul(a, c, a);
        $fb3889d52c2e0c71$var$mul(c, b, e);
        $fb3889d52c2e0c71$var$add(e, a, c);
        $fb3889d52c2e0c71$var$sub(a, a, c);
        $fb3889d52c2e0c71$var$square(b, a);
        $fb3889d52c2e0c71$var$sub(c, d, f);
        $fb3889d52c2e0c71$var$mul(a, c, $fb3889d52c2e0c71$var$_121665);
        $fb3889d52c2e0c71$var$add(a, a, d);
        $fb3889d52c2e0c71$var$mul(c, c, a);
        $fb3889d52c2e0c71$var$mul(a, d, f);
        $fb3889d52c2e0c71$var$mul(d, b, x);
        $fb3889d52c2e0c71$var$square(b, e);
        $fb3889d52c2e0c71$var$sel25519(a, b, r);
        $fb3889d52c2e0c71$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $fb3889d52c2e0c71$var$inv25519(x32, x32);
    $fb3889d52c2e0c71$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $fb3889d52c2e0c71$var$pack25519(q, x16);
    return q;
}
module.exports.scalarMult = $fb3889d52c2e0c71$var$scalarMult;
function $fb3889d52c2e0c71$var$scalarMultBase(n) {
    return $fb3889d52c2e0c71$var$scalarMult(n, $fb3889d52c2e0c71$var$_9);
}
module.exports.scalarMultBase = $fb3889d52c2e0c71$var$scalarMultBase;
function $fb3889d52c2e0c71$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${module.exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $fb3889d52c2e0c71$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $fb3889d52c2e0c71$var$generateKeyPairFromSeed;
function $fb3889d52c2e0c71$var$generateKeyPair(prng) {
    const seed = (0, $aftW8.randomBytes)(32, prng);
    const result = $fb3889d52c2e0c71$var$generateKeyPairFromSeed(seed);
    (0, $iOcd0.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $fb3889d52c2e0c71$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $fb3889d52c2e0c71$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $fb3889d52c2e0c71$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
module.exports.sharedKey = $fb3889d52c2e0c71$var$sharedKey;

});

parcelRegister("lgSQS", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return (parcelRequire("7GAet")).concat; });
$parcel$export(module.exports, "fromString", function () { return (parcelRequire("50fYI")).fromString; });
$parcel$export(module.exports, "toString", function () { return (parcelRequire("5t5tf")).toString; });

var $inFB7 = parcelRequire("inFB7");

var $7GAet = parcelRequire("7GAet");

var $314je = parcelRequire("314je");

var $50fYI = parcelRequire("50fYI");

var $5t5tf = parcelRequire("5t5tf");

var $d1g2A = parcelRequire("d1g2A");

});
parcelRegister("inFB7", function(module, exports) {
function $d61aa46a6c6c0e85$export$398604a469f7de9a(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}

});

parcelRegister("7GAet", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $59888fae7bf94b46$export$ee1b3e54f0441b22; });

var $kvkQK = parcelRequire("kvkQK");
function $59888fae7bf94b46$export$ee1b3e54f0441b22(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = (0, $kvkQK.allocUnsafe)(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}

});
parcelRegister("kvkQK", function(module, exports) {

$parcel$export(module.exports, "allocUnsafe", function () { return $eed6e038006fca5a$export$19833a56117fe205; });
function $eed6e038006fca5a$export$2de70f21292aac9e(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return globalThis.Buffer.alloc(size);
    return new Uint8Array(size);
}
function $eed6e038006fca5a$export$19833a56117fe205(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return globalThis.Buffer.allocUnsafe(size);
    return new Uint8Array(size);
}

});


parcelRegister("314je", function(module, exports) {
function $2324ced32ba9e099$export$e9bab7fafb253603(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}

});

parcelRegister("50fYI", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $3a4958d095f08985$export$3004f64547af360e; });

var $7q9y5 = parcelRequire("7q9y5");
function $3a4958d095f08985$export$3004f64547af360e(string, encoding = "utf8") {
    const base = (0, $7q9y5.default)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(string, "utf8");
    return base.decoder.decode(`${base.prefix}${string}`);
}

});
parcelRegister("7q9y5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56725e494782a8ef$export$2e2bcd8739ae039; });

var $4mFJI = parcelRequire("4mFJI");

var $kvkQK = parcelRequire("kvkQK");
function $56725e494782a8ef$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $56725e494782a8ef$var$string = $56725e494782a8ef$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $56725e494782a8ef$var$ascii = $56725e494782a8ef$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = (0, $kvkQK.allocUnsafe)(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $56725e494782a8ef$var$BASES = {
    utf8: $56725e494782a8ef$var$string,
    "utf-8": $56725e494782a8ef$var$string,
    hex: (0, $4mFJI.bases).base16,
    latin1: $56725e494782a8ef$var$ascii,
    ascii: $56725e494782a8ef$var$ascii,
    binary: $56725e494782a8ef$var$ascii,
    ...(0, $4mFJI.bases)
};
var $56725e494782a8ef$export$2e2bcd8739ae039 = $56725e494782a8ef$var$BASES;

});
parcelRegister("4mFJI", function(module, exports) {

$parcel$export(module.exports, "bases", function () { return $32d9977d35083dda$export$196f613671eb7dd9; });

var $7XVaE = parcelRequire("7XVaE");

var $fVyY3 = parcelRequire("fVyY3");

var $7acOu = parcelRequire("7acOu");

var $2iX4Q = parcelRequire("2iX4Q");

var $3YEi2 = parcelRequire("3YEi2");

var $2JTH5 = parcelRequire("2JTH5");

var $9xJkP = parcelRequire("9xJkP");

var $wPCh5 = parcelRequire("wPCh5");

var $dd76V = parcelRequire("dd76V");

var $86dgi = parcelRequire("86dgi");

var $dngBx = parcelRequire("dngBx");

var $a37Bz = parcelRequire("a37Bz");

var $eJOCk = parcelRequire("eJOCk");

var $hTY9y = parcelRequire("hTY9y");
parcelRequire("1yNAc");
var $lEYQh = parcelRequire("lEYQh");
var $5G2pl = parcelRequire("5G2pl");
var $1AzRd = parcelRequire("1AzRd");
var $82xVS = parcelRequire("82xVS");
var $csHON = parcelRequire("csHON");
const $32d9977d35083dda$export$196f613671eb7dd9 = {
    ...$7XVaE,
    ...$fVyY3,
    ...$7acOu,
    ...$2iX4Q,
    ...$3YEi2,
    ...$2JTH5,
    ...$9xJkP,
    ...$wPCh5,
    ...$dd76V,
    ...$86dgi
};
const $32d9977d35083dda$export$cff071c6f82b8944 = {
    ...$dngBx,
    ...$a37Bz
};
const $32d9977d35083dda$export$b2c6ab3b27d60531 = {
    raw: $eJOCk,
    json: $hTY9y
};

});
parcelRegister("7XVaE", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $5cca6405af57c7ba$export$f0954fd7d5368655; });

var $1VaUr = parcelRequire("1VaUr");

var $csHON = parcelRequire("csHON");
const $5cca6405af57c7ba$export$f0954fd7d5368655 = (0, $1VaUr.from)({
    prefix: "\0",
    name: "identity",
    encode: (buf)=>(0, $csHON.toString)(buf),
    decode: (str)=>(0, $csHON.fromString)(str)
});

});
parcelRegister("1VaUr", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $166393b382b68a13$export$6788812c4e6611e6; });
$parcel$export(module.exports, "baseX", function () { return $166393b382b68a13$export$180c73aedea7f385; });
$parcel$export(module.exports, "rfc4648", function () { return $166393b382b68a13$export$fa9dde04c7d2f31a; });

var $f6mLE = parcelRequire("f6mLE");

var $csHON = parcelRequire("csHON");
class $166393b382b68a13$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $166393b382b68a13$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $166393b382b68a13$export$252bb8b3bbdf6749(this, decoder);
    }
}
class $166393b382b68a13$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $166393b382b68a13$export$252bb8b3bbdf6749(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $166393b382b68a13$export$252bb8b3bbdf6749 = (left, right)=>new $166393b382b68a13$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $166393b382b68a13$export$a111e9ced3f1d2d0 {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $166393b382b68a13$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $166393b382b68a13$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $166393b382b68a13$export$6788812c4e6611e6 = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $166393b382b68a13$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
const $166393b382b68a13$export$180c73aedea7f385 = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = (0, $f6mLE.default)(alphabet, name);
    return $166393b382b68a13$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>(0, $csHON.coerce)(decode(text))
    });
};
const $166393b382b68a13$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $166393b382b68a13$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $166393b382b68a13$export$fa9dde04c7d2f31a = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $166393b382b68a13$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode (input) {
            return $166393b382b68a13$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $166393b382b68a13$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};

});
parcelRegister("f6mLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe913bd51e2da54$export$2e2bcd8739ae039; });
function $afe913bd51e2da54$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $afe913bd51e2da54$var$src = $afe913bd51e2da54$var$base;
var $afe913bd51e2da54$var$_brrp__multiformats_scope_baseX = $afe913bd51e2da54$var$src;
var $afe913bd51e2da54$export$2e2bcd8739ae039 = $afe913bd51e2da54$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("csHON", function(module, exports) {

$parcel$export(module.exports, "equals", function () { return $912a16fb7088b7d4$export$e9bab7fafb253603; });
$parcel$export(module.exports, "coerce", function () { return $912a16fb7088b7d4$export$8c14e57e778d3873; });
$parcel$export(module.exports, "fromString", function () { return $912a16fb7088b7d4$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $912a16fb7088b7d4$export$f84e8e69fd4488a5; });
const $912a16fb7088b7d4$export$6e22c362a0406a2c = new Uint8Array(0);
const $912a16fb7088b7d4$export$7ea66e3774a60b67 = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $912a16fb7088b7d4$export$1a8ceedbd5845648 = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $912a16fb7088b7d4$export$6e22c362a0406a2c;
};
const $912a16fb7088b7d4$export$e9bab7fafb253603 = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $912a16fb7088b7d4$export$8c14e57e778d3873 = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $912a16fb7088b7d4$export$37488ff1135b1696 = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $912a16fb7088b7d4$export$3004f64547af360e = (str)=>new TextEncoder().encode(str);
const $912a16fb7088b7d4$export$f84e8e69fd4488a5 = (b)=>new TextDecoder().decode(b);

});



parcelRegister("fVyY3", function(module, exports) {

$parcel$export(module.exports, "base2", function () { return $b9874dbe76e80c3f$export$ed5f7917e37e31aa; });

var $1VaUr = parcelRequire("1VaUr");
const $b9874dbe76e80c3f$export$ed5f7917e37e31aa = (0, $1VaUr.rfc4648)({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});

});

parcelRegister("7acOu", function(module, exports) {

$parcel$export(module.exports, "base8", function () { return $5373680ccb0a4967$export$43b580ac9deb5b96; });

var $1VaUr = parcelRequire("1VaUr");
const $5373680ccb0a4967$export$43b580ac9deb5b96 = (0, $1VaUr.rfc4648)({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});

});

parcelRegister("2iX4Q", function(module, exports) {

$parcel$export(module.exports, "base10", function () { return $1adb16b95119db4e$export$63d6a7de0ff813cc; });

var $1VaUr = parcelRequire("1VaUr");
const $1adb16b95119db4e$export$63d6a7de0ff813cc = (0, $1VaUr.baseX)({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});

});

parcelRegister("3YEi2", function(module, exports) {

$parcel$export(module.exports, "base16", function () { return $2e563a7022daf8ce$export$586f61c71cb02fe4; });
$parcel$export(module.exports, "base16upper", function () { return $2e563a7022daf8ce$export$2d835b8dd4032b62; });

var $1VaUr = parcelRequire("1VaUr");
const $2e563a7022daf8ce$export$586f61c71cb02fe4 = (0, $1VaUr.rfc4648)({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $2e563a7022daf8ce$export$2d835b8dd4032b62 = (0, $1VaUr.rfc4648)({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});

});

parcelRegister("2JTH5", function(module, exports) {

$parcel$export(module.exports, "base32", function () { return $1feafc6794b06b61$export$4a4d5965e2738b2a; });
$parcel$export(module.exports, "base32upper", function () { return $1feafc6794b06b61$export$fbaa3bbbd754def4; });
$parcel$export(module.exports, "base32pad", function () { return $1feafc6794b06b61$export$e194fa100d329365; });
$parcel$export(module.exports, "base32padupper", function () { return $1feafc6794b06b61$export$3a9fc48d294dce32; });
$parcel$export(module.exports, "base32hex", function () { return $1feafc6794b06b61$export$c57d6760d519c8ac; });
$parcel$export(module.exports, "base32hexupper", function () { return $1feafc6794b06b61$export$8cf4640df3165d29; });
$parcel$export(module.exports, "base32hexpad", function () { return $1feafc6794b06b61$export$8c6a05c08ec7d456; });
$parcel$export(module.exports, "base32hexpadupper", function () { return $1feafc6794b06b61$export$29f73c6a744e639f; });
$parcel$export(module.exports, "base32z", function () { return $1feafc6794b06b61$export$fdad9af4bdc05e3; });

var $1VaUr = parcelRequire("1VaUr");
const $1feafc6794b06b61$export$4a4d5965e2738b2a = (0, $1VaUr.rfc4648)({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $1feafc6794b06b61$export$fbaa3bbbd754def4 = (0, $1VaUr.rfc4648)({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $1feafc6794b06b61$export$e194fa100d329365 = (0, $1VaUr.rfc4648)({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $1feafc6794b06b61$export$3a9fc48d294dce32 = (0, $1VaUr.rfc4648)({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $1feafc6794b06b61$export$c57d6760d519c8ac = (0, $1VaUr.rfc4648)({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $1feafc6794b06b61$export$8cf4640df3165d29 = (0, $1VaUr.rfc4648)({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $1feafc6794b06b61$export$8c6a05c08ec7d456 = (0, $1VaUr.rfc4648)({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $1feafc6794b06b61$export$29f73c6a744e639f = (0, $1VaUr.rfc4648)({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $1feafc6794b06b61$export$fdad9af4bdc05e3 = (0, $1VaUr.rfc4648)({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});

});

parcelRegister("9xJkP", function(module, exports) {

$parcel$export(module.exports, "base36", function () { return $6f2a5cb134f90470$export$95b61e7c39ae893a; });
$parcel$export(module.exports, "base36upper", function () { return $6f2a5cb134f90470$export$bab7c9bdb963afd; });

var $1VaUr = parcelRequire("1VaUr");
const $6f2a5cb134f90470$export$95b61e7c39ae893a = (0, $1VaUr.baseX)({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $6f2a5cb134f90470$export$bab7c9bdb963afd = (0, $1VaUr.baseX)({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});

});

parcelRegister("wPCh5", function(module, exports) {

$parcel$export(module.exports, "base58btc", function () { return $062b0733cbc25bb8$export$65c61748a9b98a2c; });
$parcel$export(module.exports, "base58flickr", function () { return $062b0733cbc25bb8$export$c6a7baed2941aad2; });

var $1VaUr = parcelRequire("1VaUr");
const $062b0733cbc25bb8$export$65c61748a9b98a2c = (0, $1VaUr.baseX)({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $062b0733cbc25bb8$export$c6a7baed2941aad2 = (0, $1VaUr.baseX)({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});

});

parcelRegister("dd76V", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $99e2014a7bcc58a9$export$b3b2de96497acc47; });
$parcel$export(module.exports, "base64pad", function () { return $99e2014a7bcc58a9$export$a9c086fc40b4563c; });
$parcel$export(module.exports, "base64url", function () { return $99e2014a7bcc58a9$export$7d21597c7bc64465; });
$parcel$export(module.exports, "base64urlpad", function () { return $99e2014a7bcc58a9$export$e87ddc9183aa53c9; });

var $1VaUr = parcelRequire("1VaUr");
const $99e2014a7bcc58a9$export$b3b2de96497acc47 = (0, $1VaUr.rfc4648)({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $99e2014a7bcc58a9$export$a9c086fc40b4563c = (0, $1VaUr.rfc4648)({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $99e2014a7bcc58a9$export$7d21597c7bc64465 = (0, $1VaUr.rfc4648)({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $99e2014a7bcc58a9$export$e87ddc9183aa53c9 = (0, $1VaUr.rfc4648)({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});

});

parcelRegister("86dgi", function(module, exports) {

$parcel$export(module.exports, "base256emoji", function () { return $5e592bceb8660e35$export$6a5d4ab6075d2779; });

var $1VaUr = parcelRequire("1VaUr");
const $5e592bceb8660e35$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $5e592bceb8660e35$var$alphabetBytesToChars = $5e592bceb8660e35$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $5e592bceb8660e35$var$alphabetCharsToBytes = $5e592bceb8660e35$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $5e592bceb8660e35$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $5e592bceb8660e35$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $5e592bceb8660e35$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $5e592bceb8660e35$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $5e592bceb8660e35$export$6a5d4ab6075d2779 = (0, $1VaUr.from)({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $5e592bceb8660e35$var$encode,
    decode: $5e592bceb8660e35$var$decode
});

});

parcelRegister("dngBx", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $9bca4da72d9f987b$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $9bca4da72d9f987b$export$a888d2532e6dc7bb; });

var $5G2pl = parcelRequire("5G2pl");
const $9bca4da72d9f987b$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $9bca4da72d9f987b$export$bced8d2aada2d1c9 = (0, $5G2pl.from)({
    name: "sha2-256",
    code: 18,
    encode: $9bca4da72d9f987b$var$sha("SHA-256")
});
const $9bca4da72d9f987b$export$a888d2532e6dc7bb = (0, $5G2pl.from)({
    name: "sha2-512",
    code: 19,
    encode: $9bca4da72d9f987b$var$sha("SHA-512")
});

});
parcelRegister("5G2pl", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $4222be2254095905$export$6788812c4e6611e6; });

var $1AzRd = parcelRequire("1AzRd");
const $4222be2254095905$export$6788812c4e6611e6 = ({ name: name, code: code, encode: encode })=>new $4222be2254095905$export$df06eed23808f4d0(name, code, encode);
class $4222be2254095905$export$df06eed23808f4d0 {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $1AzRd.create(this.code, result) : result.then((digest)=>$1AzRd.create(this.code, digest));
        } else throw Error("Unknown type, must be binary type");
    }
}

});
parcelRegister("1AzRd", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $1284f7ba766495f1$export$185802fd694ee1f5; });
$parcel$export(module.exports, "Digest", function () { return $1284f7ba766495f1$export$d67a82ff561eff43; });
$parcel$export(module.exports, "decode", function () { return $1284f7ba766495f1$export$2f872c0f2117be69; });
$parcel$export(module.exports, "equals", function () { return $1284f7ba766495f1$export$e9bab7fafb253603; });

var $csHON = parcelRequire("csHON");

var $82xVS = parcelRequire("82xVS");
const $1284f7ba766495f1$export$185802fd694ee1f5 = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $82xVS.encodingLength(code);
    const digestOffset = sizeOffset + $82xVS.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $82xVS.encodeTo(code, bytes, 0);
    $82xVS.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $1284f7ba766495f1$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $1284f7ba766495f1$export$2f872c0f2117be69 = (multihash)=>{
    const bytes = (0, $csHON.coerce)(multihash);
    const [code, sizeOffset] = $82xVS.decode(bytes);
    const [size, digestOffset] = $82xVS.decode(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $1284f7ba766495f1$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $1284f7ba766495f1$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $csHON.equals)(a.bytes, b.bytes);
};
class $1284f7ba766495f1$export$d67a82ff561eff43 {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}

});
parcelRegister("82xVS", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $5da8d4ea1d8aa442$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encodeTo", function () { return $5da8d4ea1d8aa442$export$8512cbe4228de3b3; });
$parcel$export(module.exports, "encodingLength", function () { return $5da8d4ea1d8aa442$export$cbee51f25f0626d7; });

var $DgfAz = parcelRequire("DgfAz");
const $5da8d4ea1d8aa442$export$2f872c0f2117be69 = (data, offset = 0)=>{
    const code = (0, $DgfAz.default).decode(data, offset);
    return [
        code,
        (0, $DgfAz.default).decode.bytes
    ];
};
const $5da8d4ea1d8aa442$export$8512cbe4228de3b3 = (int, target, offset = 0)=>{
    (0, $DgfAz.default).encode(int, target, offset);
    return target;
};
const $5da8d4ea1d8aa442$export$cbee51f25f0626d7 = (int)=>{
    return (0, $DgfAz.default).encodingLength(int);
};

});
parcelRegister("DgfAz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07603fa15806e06b$export$2e2bcd8739ae039; });
var $07603fa15806e06b$var$encode_1 = $07603fa15806e06b$var$encode;
var $07603fa15806e06b$var$MSB = 128, $07603fa15806e06b$var$REST = 127, $07603fa15806e06b$var$MSBALL = ~$07603fa15806e06b$var$REST, $07603fa15806e06b$var$INT = Math.pow(2, 31);
function $07603fa15806e06b$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $07603fa15806e06b$var$INT){
        out[offset++] = num & 255 | $07603fa15806e06b$var$MSB;
        num /= 128;
    }
    while(num & $07603fa15806e06b$var$MSBALL){
        out[offset++] = num & 255 | $07603fa15806e06b$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $07603fa15806e06b$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $07603fa15806e06b$var$decode = $07603fa15806e06b$var$read;
var $07603fa15806e06b$var$MSB$1 = 128, $07603fa15806e06b$var$REST$1 = 127;
function $07603fa15806e06b$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $07603fa15806e06b$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $07603fa15806e06b$var$REST$1) << shift : (b & $07603fa15806e06b$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $07603fa15806e06b$var$MSB$1);
    $07603fa15806e06b$var$read.bytes = counter - offset;
    return res;
}
var $07603fa15806e06b$var$N1 = Math.pow(2, 7);
var $07603fa15806e06b$var$N2 = Math.pow(2, 14);
var $07603fa15806e06b$var$N3 = Math.pow(2, 21);
var $07603fa15806e06b$var$N4 = Math.pow(2, 28);
var $07603fa15806e06b$var$N5 = Math.pow(2, 35);
var $07603fa15806e06b$var$N6 = Math.pow(2, 42);
var $07603fa15806e06b$var$N7 = Math.pow(2, 49);
var $07603fa15806e06b$var$N8 = Math.pow(2, 56);
var $07603fa15806e06b$var$N9 = Math.pow(2, 63);
var $07603fa15806e06b$var$length = function(value) {
    return value < $07603fa15806e06b$var$N1 ? 1 : value < $07603fa15806e06b$var$N2 ? 2 : value < $07603fa15806e06b$var$N3 ? 3 : value < $07603fa15806e06b$var$N4 ? 4 : value < $07603fa15806e06b$var$N5 ? 5 : value < $07603fa15806e06b$var$N6 ? 6 : value < $07603fa15806e06b$var$N7 ? 7 : value < $07603fa15806e06b$var$N8 ? 8 : value < $07603fa15806e06b$var$N9 ? 9 : 10;
};
var $07603fa15806e06b$var$varint = {
    encode: $07603fa15806e06b$var$encode_1,
    decode: $07603fa15806e06b$var$decode,
    encodingLength: $07603fa15806e06b$var$length
};
var $07603fa15806e06b$var$_brrp_varint = $07603fa15806e06b$var$varint;
var $07603fa15806e06b$export$2e2bcd8739ae039 = $07603fa15806e06b$var$_brrp_varint;

});





parcelRegister("a37Bz", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $751015623e593e86$export$f0954fd7d5368655; });

var $csHON = parcelRequire("csHON");

var $1AzRd = parcelRequire("1AzRd");
const $751015623e593e86$var$code = 0;
const $751015623e593e86$var$name = "identity";
const $751015623e593e86$var$encode = (0, $csHON.coerce);
const $751015623e593e86$var$digest = (input)=>$1AzRd.create($751015623e593e86$var$code, $751015623e593e86$var$encode(input));
const $751015623e593e86$export$f0954fd7d5368655 = {
    code: $751015623e593e86$var$code,
    name: $751015623e593e86$var$name,
    encode: $751015623e593e86$var$encode,
    digest: $751015623e593e86$var$digest
};

});

parcelRegister("eJOCk", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $abac88330afad887$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $abac88330afad887$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $abac88330afad887$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $abac88330afad887$export$2f872c0f2117be69; });

var $csHON = parcelRequire("csHON");
const $abac88330afad887$export$a8ff84c12d48cfa6 = "raw";
const $abac88330afad887$export$6565f9f03506010b = 85;
const $abac88330afad887$export$c564cdbbe6da493 = (node)=>(0, $csHON.coerce)(node);
const $abac88330afad887$export$2f872c0f2117be69 = (data)=>(0, $csHON.coerce)(data);

});

parcelRegister("hTY9y", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $d0863bdec017cb8e$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $d0863bdec017cb8e$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $d0863bdec017cb8e$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $d0863bdec017cb8e$export$2f872c0f2117be69; });
const $d0863bdec017cb8e$var$textEncoder = new TextEncoder();
const $d0863bdec017cb8e$var$textDecoder = new TextDecoder();
const $d0863bdec017cb8e$export$a8ff84c12d48cfa6 = "json";
const $d0863bdec017cb8e$export$6565f9f03506010b = 512;
const $d0863bdec017cb8e$export$c564cdbbe6da493 = (node)=>$d0863bdec017cb8e$var$textEncoder.encode(JSON.stringify(node));
const $d0863bdec017cb8e$export$2f872c0f2117be69 = (data)=>JSON.parse($d0863bdec017cb8e$var$textDecoder.decode(data));

});

parcelRegister("1yNAc", function(module, exports) {

var $lEYQh = parcelRequire("lEYQh");

var $82xVS = parcelRequire("82xVS");

var $csHON = parcelRequire("csHON");

var $5G2pl = parcelRequire("5G2pl");

var $1AzRd = parcelRequire("1AzRd");

});
parcelRegister("lEYQh", function(module, exports) {

var $82xVS = parcelRequire("82xVS");

var $1AzRd = parcelRequire("1AzRd");

var $wPCh5 = parcelRequire("wPCh5");

var $2JTH5 = parcelRequire("2JTH5");

var $csHON = parcelRequire("csHON");
class $fc4c87679a8b37bf$export$12d863fcef3f6aa {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $fc4c87679a8b37bf$var$hidden,
            byteLength: $fc4c87679a8b37bf$var$hidden,
            code: $fc4c87679a8b37bf$var$readonly,
            version: $fc4c87679a8b37bf$var$readonly,
            multihash: $fc4c87679a8b37bf$var$readonly,
            bytes: $fc4c87679a8b37bf$var$readonly,
            _baseCache: $fc4c87679a8b37bf$var$hidden,
            asCID: $fc4c87679a8b37bf$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $fc4c87679a8b37bf$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $fc4c87679a8b37bf$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $fc4c87679a8b37bf$export$12d863fcef3f6aa.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest } = this.multihash;
                    const multihash = $1AzRd.create(code, digest);
                    return $fc4c87679a8b37bf$export$12d863fcef3f6aa.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $1AzRd.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $fc4c87679a8b37bf$var$toStringV0(bytes, _baseCache, base || (0, $wPCh5.base58btc).encoder);
            default:
                return $fc4c87679a8b37bf$var$toStringV1(bytes, _baseCache, base || (0, $2JTH5.base32).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $fc4c87679a8b37bf$var$deprecate(/^0\.0/, $fc4c87679a8b37bf$var$IS_CID_DEPRECATION);
        return !!(value && (value[$fc4c87679a8b37bf$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $fc4c87679a8b37bf$export$12d863fcef3f6aa) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $fc4c87679a8b37bf$export$12d863fcef3f6aa(version, code, multihash, bytes || $fc4c87679a8b37bf$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$fc4c87679a8b37bf$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest = $1AzRd.decode(multihash);
            return $fc4c87679a8b37bf$export$12d863fcef3f6aa.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $fc4c87679a8b37bf$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$fc4c87679a8b37bf$var$DAG_PB_CODE}) block encoding`);
                else return new $fc4c87679a8b37bf$export$12d863fcef3f6aa(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $fc4c87679a8b37bf$var$encodeCID(version, code, digest.bytes);
                    return new $fc4c87679a8b37bf$export$12d863fcef3f6aa(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $fc4c87679a8b37bf$export$12d863fcef3f6aa.create(0, $fc4c87679a8b37bf$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $fc4c87679a8b37bf$export$12d863fcef3f6aa.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $fc4c87679a8b37bf$export$12d863fcef3f6aa.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = $fc4c87679a8b37bf$export$12d863fcef3f6aa.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, $csHON.coerce)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new $1AzRd.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $fc4c87679a8b37bf$export$12d863fcef3f6aa.createV0(digest) : $fc4c87679a8b37bf$export$12d863fcef3f6aa.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $82xVS.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $fc4c87679a8b37bf$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $fc4c87679a8b37bf$var$parseCIDtoBytes(source, base);
        const cid = $fc4c87679a8b37bf$export$12d863fcef3f6aa.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $fc4c87679a8b37bf$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || (0, $wPCh5.base58btc);
                return [
                    (0, $wPCh5.base58btc).prefix,
                    decoder.decode(`${(0, $wPCh5.base58btc).prefix}${source}`)
                ];
            }
        case (0, $wPCh5.base58btc).prefix:
            {
                const decoder = base || (0, $wPCh5.base58btc);
                return [
                    (0, $wPCh5.base58btc).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, $2JTH5.base32).prefix:
            {
                const decoder = base || (0, $2JTH5.base32);
                return [
                    (0, $2JTH5.base32).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $fc4c87679a8b37bf$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== (0, $wPCh5.base58btc).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $fc4c87679a8b37bf$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $fc4c87679a8b37bf$var$DAG_PB_CODE = 112;
const $fc4c87679a8b37bf$var$SHA_256_CODE = 18;
const $fc4c87679a8b37bf$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $82xVS.encodingLength(version);
    const hashOffset = codeOffset + $82xVS.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $82xVS.encodeTo(version, bytes, 0);
    $82xVS.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $fc4c87679a8b37bf$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $fc4c87679a8b37bf$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $fc4c87679a8b37bf$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $fc4c87679a8b37bf$var$version = "0.0.0-dev";
const $fc4c87679a8b37bf$var$deprecate = (range, message)=>{
    if (range.test($fc4c87679a8b37bf$var$version)) console.warn(message);
    else throw new Error(message);
};
const $fc4c87679a8b37bf$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;

});





parcelRegister("5t5tf", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $3fb3e792e710e4d0$export$f84e8e69fd4488a5; });

var $7q9y5 = parcelRequire("7q9y5");
function $3fb3e792e710e4d0$export$f84e8e69fd4488a5(array, encoding = "utf8") {
    const base = (0, $7q9y5.default)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}

});

parcelRegister("d1g2A", function(module, exports) {

var $kvkQK = parcelRequire("kvkQK");
function $97a7cfb7a0994118$export$6444ef5cd411280c(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = (0, $kvkQK.allocUnsafe)(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}

});


parcelRegister("hYa4V", function(module, exports) {
"use strict";
var $d14fdb9dd31166c0$var$elliptic = module.exports;

$d14fdb9dd31166c0$var$elliptic.version = (parcelRequire("eDP8J")).version;

$d14fdb9dd31166c0$var$elliptic.utils = (parcelRequire("fbJKm"));

$d14fdb9dd31166c0$var$elliptic.rand = (parcelRequire("9NWyt"));

$d14fdb9dd31166c0$var$elliptic.curve = (parcelRequire("cNTZX"));

$d14fdb9dd31166c0$var$elliptic.curves = (parcelRequire("gSCXD"));

// Protocols
$d14fdb9dd31166c0$var$elliptic.ec = (parcelRequire("httWt"));

$d14fdb9dd31166c0$var$elliptic.eddsa = (parcelRequire("4dIOI"));

});
parcelRegister("eDP8J", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.7","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("fbJKm", function(module, exports) {
"use strict";
var $b0eb5e735c4b2fe4$var$utils = module.exports;

var $4EH0Y = parcelRequire("4EH0Y");

var $6Dc6S = parcelRequire("6Dc6S");

var $l5KyF = parcelRequire("l5KyF");
$b0eb5e735c4b2fe4$var$utils.assert = $6Dc6S;
$b0eb5e735c4b2fe4$var$utils.toArray = $l5KyF.toArray;
$b0eb5e735c4b2fe4$var$utils.zero2 = $l5KyF.zero2;
$b0eb5e735c4b2fe4$var$utils.toHex = $l5KyF.toHex;
$b0eb5e735c4b2fe4$var$utils.encode = $l5KyF.encode;
// Represent num in a w-NAF form
function $b0eb5e735c4b2fe4$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$b0eb5e735c4b2fe4$var$utils.getNAF = $b0eb5e735c4b2fe4$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $b0eb5e735c4b2fe4$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$b0eb5e735c4b2fe4$var$utils.getJSF = $b0eb5e735c4b2fe4$var$getJSF;
function $b0eb5e735c4b2fe4$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$b0eb5e735c4b2fe4$var$utils.cachedProperty = $b0eb5e735c4b2fe4$var$cachedProperty;
function $b0eb5e735c4b2fe4$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $b0eb5e735c4b2fe4$var$utils.toArray(bytes, "hex") : bytes;
}
$b0eb5e735c4b2fe4$var$utils.parseBytes = $b0eb5e735c4b2fe4$var$parseBytes;
function $b0eb5e735c4b2fe4$var$intFromLE(bytes) {
    return new $4EH0Y(bytes, "hex", "le");
}
$b0eb5e735c4b2fe4$var$utils.intFromLE = $b0eb5e735c4b2fe4$var$intFromLE;

});
parcelRegister("4EH0Y", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("6AuhB")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("6Dc6S", function(module, exports) {
module.exports = $4d3fc7609ca4a43f$var$assert;
function $4d3fc7609ca4a43f$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$4d3fc7609ca4a43f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("l5KyF", function(module, exports) {
"use strict";
var $f5ae2e0fcc7761bf$var$utils = module.exports;
function $f5ae2e0fcc7761bf$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$f5ae2e0fcc7761bf$var$utils.toArray = $f5ae2e0fcc7761bf$var$toArray;
function $f5ae2e0fcc7761bf$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$f5ae2e0fcc7761bf$var$utils.zero2 = $f5ae2e0fcc7761bf$var$zero2;
function $f5ae2e0fcc7761bf$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $f5ae2e0fcc7761bf$var$zero2(msg[i].toString(16));
    return res;
}
$f5ae2e0fcc7761bf$var$utils.toHex = $f5ae2e0fcc7761bf$var$toHex;
$f5ae2e0fcc7761bf$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $f5ae2e0fcc7761bf$var$toHex(arr);
    else return arr;
};

});


parcelRegister("9NWyt", function(module, exports) {
var $72361c785c9be1a0$var$r;
module.exports = function rand(len) {
    if (!$72361c785c9be1a0$var$r) $72361c785c9be1a0$var$r = new $72361c785c9be1a0$var$Rand(null);
    return $72361c785c9be1a0$var$r.generate(len);
};
function $72361c785c9be1a0$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $72361c785c9be1a0$var$Rand;
$72361c785c9be1a0$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$72361c785c9be1a0$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $72361c785c9be1a0$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $72361c785c9be1a0$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $72361c785c9be1a0$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $72361c785c9be1a0$var$crypto = (parcelRequire("6AuhB"));
    if (typeof $72361c785c9be1a0$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $72361c785c9be1a0$var$Rand.prototype._rand = function _rand(n) {
        return $72361c785c9be1a0$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("cNTZX", function(module, exports) {
"use strict";
var $95257fc2d8035f70$var$curve = module.exports;

$95257fc2d8035f70$var$curve.base = (parcelRequire("3JuEO"));

$95257fc2d8035f70$var$curve.short = (parcelRequire("ej7hp"));

$95257fc2d8035f70$var$curve.mont = (parcelRequire("49aKi"));

$95257fc2d8035f70$var$curve.edwards = (parcelRequire("jDKgQ"));

});
parcelRegister("3JuEO", function(module, exports) {
"use strict";

var $4EH0Y = parcelRequire("4EH0Y");

var $fbJKm = parcelRequire("fbJKm");
var $2b7d5af89e23f241$var$getNAF = $fbJKm.getNAF;
var $2b7d5af89e23f241$var$getJSF = $fbJKm.getJSF;
var $2b7d5af89e23f241$var$assert = $fbJKm.assert;
function $2b7d5af89e23f241$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $4EH0Y(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $4EH0Y.red(conf.prime) : $4EH0Y.mont(this.p);
    // Useful for many curves
    this.zero = new $4EH0Y(0).toRed(this.red);
    this.one = new $4EH0Y(1).toRed(this.red);
    this.two = new $4EH0Y(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $4EH0Y(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $2b7d5af89e23f241$var$BaseCurve;
$2b7d5af89e23f241$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$2b7d5af89e23f241$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$2b7d5af89e23f241$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2b7d5af89e23f241$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2b7d5af89e23f241$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2b7d5af89e23f241$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2b7d5af89e23f241$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2b7d5af89e23f241$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$2b7d5af89e23f241$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2b7d5af89e23f241$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2b7d5af89e23f241$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2b7d5af89e23f241$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2b7d5af89e23f241$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2b7d5af89e23f241$var$BaseCurve.BasePoint = $2b7d5af89e23f241$var$BasePoint;
$2b7d5af89e23f241$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$2b7d5af89e23f241$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2b7d5af89e23f241$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $fbJKm.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2b7d5af89e23f241$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2b7d5af89e23f241$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$2b7d5af89e23f241$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2b7d5af89e23f241$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$2b7d5af89e23f241$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $fbJKm.encode(this._encode(compact), enc);
};
$2b7d5af89e23f241$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2b7d5af89e23f241$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2b7d5af89e23f241$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2b7d5af89e23f241$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2b7d5af89e23f241$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2b7d5af89e23f241$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("ej7hp", function(module, exports) {
"use strict";

var $fbJKm = parcelRequire("fbJKm");

var $4EH0Y = parcelRequire("4EH0Y");

var $ktTkY = parcelRequire("ktTkY");

var $3JuEO = parcelRequire("3JuEO");
var $a6a87cad3aa4c892$var$assert = $fbJKm.assert;
function $a6a87cad3aa4c892$var$ShortCurve(conf) {
    $3JuEO.call(this, "short", conf);
    this.a = new $4EH0Y(conf.a, 16).toRed(this.red);
    this.b = new $4EH0Y(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$ktTkY($a6a87cad3aa4c892$var$ShortCurve, $3JuEO);
module.exports = $a6a87cad3aa4c892$var$ShortCurve;
$a6a87cad3aa4c892$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $4EH0Y(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $4EH0Y(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $a6a87cad3aa4c892$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $4EH0Y(vec.a, 16),
            b: new $4EH0Y(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$a6a87cad3aa4c892$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $4EH0Y.mont(num);
    var tinv = new $4EH0Y(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $4EH0Y(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$a6a87cad3aa4c892$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $4EH0Y(1);
    var y1 = new $4EH0Y(0);
    var x2 = new $4EH0Y(0);
    var y2 = new $4EH0Y(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$a6a87cad3aa4c892$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$a6a87cad3aa4c892$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $4EH0Y(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$a6a87cad3aa4c892$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$a6a87cad3aa4c892$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $a6a87cad3aa4c892$var$Point(curve, x, y, isRed) {
    $3JuEO.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $4EH0Y(x, 16);
        this.y = new $4EH0Y(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$ktTkY($a6a87cad3aa4c892$var$Point, $3JuEO.BasePoint);
$a6a87cad3aa4c892$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $a6a87cad3aa4c892$var$Point(this, x, y, isRed);
};
$a6a87cad3aa4c892$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $a6a87cad3aa4c892$var$Point.fromJSON(this, obj, red);
};
$a6a87cad3aa4c892$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$a6a87cad3aa4c892$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$a6a87cad3aa4c892$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$a6a87cad3aa4c892$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$a6a87cad3aa4c892$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$a6a87cad3aa4c892$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$a6a87cad3aa4c892$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$a6a87cad3aa4c892$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$a6a87cad3aa4c892$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$a6a87cad3aa4c892$var$Point.prototype.mul = function mul(k) {
    k = new $4EH0Y(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$a6a87cad3aa4c892$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$a6a87cad3aa4c892$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$a6a87cad3aa4c892$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$a6a87cad3aa4c892$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$a6a87cad3aa4c892$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $a6a87cad3aa4c892$var$JPoint(curve, x, y, z) {
    $3JuEO.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $4EH0Y(0);
    } else {
        this.x = new $4EH0Y(x, 16);
        this.y = new $4EH0Y(y, 16);
        this.z = new $4EH0Y(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$ktTkY($a6a87cad3aa4c892$var$JPoint, $3JuEO.BasePoint);
$a6a87cad3aa4c892$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $a6a87cad3aa4c892$var$JPoint(this, x, y, z);
};
$a6a87cad3aa4c892$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$a6a87cad3aa4c892$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$a6a87cad3aa4c892$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$a6a87cad3aa4c892$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$a6a87cad3aa4c892$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$a6a87cad3aa4c892$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$a6a87cad3aa4c892$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$a6a87cad3aa4c892$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$a6a87cad3aa4c892$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$a6a87cad3aa4c892$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$a6a87cad3aa4c892$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $4EH0Y(k, kbase);
    return this.curve._wnafMul(this, k);
};
$a6a87cad3aa4c892$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$a6a87cad3aa4c892$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$a6a87cad3aa4c892$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$a6a87cad3aa4c892$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});
parcelRegister("ktTkY", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("49aKi", function(module, exports) {
"use strict";

var $4EH0Y = parcelRequire("4EH0Y");

var $ktTkY = parcelRequire("ktTkY");

var $3JuEO = parcelRequire("3JuEO");

var $fbJKm = parcelRequire("fbJKm");
function $30505694681c7a1d$var$MontCurve(conf) {
    $3JuEO.call(this, "mont", conf);
    this.a = new $4EH0Y(conf.a, 16).toRed(this.red);
    this.b = new $4EH0Y(conf.b, 16).toRed(this.red);
    this.i4 = new $4EH0Y(4).toRed(this.red).redInvm();
    this.two = new $4EH0Y(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$ktTkY($30505694681c7a1d$var$MontCurve, $3JuEO);
module.exports = $30505694681c7a1d$var$MontCurve;
$30505694681c7a1d$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $30505694681c7a1d$var$Point(curve, x, z) {
    $3JuEO.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $4EH0Y(x, 16);
        this.z = new $4EH0Y(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$ktTkY($30505694681c7a1d$var$Point, $3JuEO.BasePoint);
$30505694681c7a1d$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($fbJKm.toArray(bytes, enc), 1);
};
$30505694681c7a1d$var$MontCurve.prototype.point = function point(x, z) {
    return new $30505694681c7a1d$var$Point(this, x, z);
};
$30505694681c7a1d$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $30505694681c7a1d$var$Point.fromJSON(this, obj);
};
$30505694681c7a1d$var$Point.prototype.precompute = function precompute() {
// No-op
};
$30505694681c7a1d$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$30505694681c7a1d$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $30505694681c7a1d$var$Point(curve, obj[0], obj[1] || curve.one);
};
$30505694681c7a1d$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$30505694681c7a1d$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$30505694681c7a1d$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$30505694681c7a1d$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$30505694681c7a1d$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$30505694681c7a1d$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$30505694681c7a1d$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$30505694681c7a1d$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$30505694681c7a1d$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$30505694681c7a1d$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$30505694681c7a1d$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("jDKgQ", function(module, exports) {
"use strict";

var $fbJKm = parcelRequire("fbJKm");

var $4EH0Y = parcelRequire("4EH0Y");

var $ktTkY = parcelRequire("ktTkY");

var $3JuEO = parcelRequire("3JuEO");
var $e4c58d3efb4c6abd$var$assert = $fbJKm.assert;
function $e4c58d3efb4c6abd$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $3JuEO.call(this, "edwards", conf);
    this.a = new $4EH0Y(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $4EH0Y(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $4EH0Y(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $e4c58d3efb4c6abd$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$ktTkY($e4c58d3efb4c6abd$var$EdwardsCurve, $3JuEO);
module.exports = $e4c58d3efb4c6abd$var$EdwardsCurve;
$e4c58d3efb4c6abd$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$e4c58d3efb4c6abd$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$e4c58d3efb4c6abd$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$e4c58d3efb4c6abd$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $4EH0Y(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$e4c58d3efb4c6abd$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $4EH0Y(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$e4c58d3efb4c6abd$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $e4c58d3efb4c6abd$var$Point(curve, x, y, z, t) {
    $3JuEO.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $4EH0Y(x, 16);
        this.y = new $4EH0Y(y, 16);
        this.z = z ? new $4EH0Y(z, 16) : this.curve.one;
        this.t = t && new $4EH0Y(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$ktTkY($e4c58d3efb4c6abd$var$Point, $3JuEO.BasePoint);
$e4c58d3efb4c6abd$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $e4c58d3efb4c6abd$var$Point.fromJSON(this, obj);
};
$e4c58d3efb4c6abd$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $e4c58d3efb4c6abd$var$Point(this, x, y, z, t);
};
$e4c58d3efb4c6abd$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $e4c58d3efb4c6abd$var$Point(curve, obj[0], obj[1], obj[2]);
};
$e4c58d3efb4c6abd$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$e4c58d3efb4c6abd$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$e4c58d3efb4c6abd$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$e4c58d3efb4c6abd$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$e4c58d3efb4c6abd$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$e4c58d3efb4c6abd$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$e4c58d3efb4c6abd$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$e4c58d3efb4c6abd$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$e4c58d3efb4c6abd$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$e4c58d3efb4c6abd$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$e4c58d3efb4c6abd$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$e4c58d3efb4c6abd$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$e4c58d3efb4c6abd$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$e4c58d3efb4c6abd$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$e4c58d3efb4c6abd$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$e4c58d3efb4c6abd$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$e4c58d3efb4c6abd$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$e4c58d3efb4c6abd$var$Point.prototype.toP = $e4c58d3efb4c6abd$var$Point.prototype.normalize;
$e4c58d3efb4c6abd$var$Point.prototype.mixedAdd = $e4c58d3efb4c6abd$var$Point.prototype.add;

});


parcelRegister("gSCXD", function(module, exports) {
"use strict";
var $032bde9a083b6f9d$var$curves = module.exports;

var $6ichd = parcelRequire("6ichd");

var $cNTZX = parcelRequire("cNTZX");

var $fbJKm = parcelRequire("fbJKm");
var $032bde9a083b6f9d$var$assert = $fbJKm.assert;
function $032bde9a083b6f9d$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cNTZX.short(options);
    else if (options.type === "edwards") this.curve = new $cNTZX.edwards(options);
    else this.curve = new $cNTZX.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $032bde9a083b6f9d$var$assert(this.g.validate(), "Invalid curve");
    $032bde9a083b6f9d$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$032bde9a083b6f9d$var$curves.PresetCurve = $032bde9a083b6f9d$var$PresetCurve;
function $032bde9a083b6f9d$var$defineCurve(name, options) {
    Object.defineProperty($032bde9a083b6f9d$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $032bde9a083b6f9d$var$PresetCurve(options);
            Object.defineProperty($032bde9a083b6f9d$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$032bde9a083b6f9d$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $6ichd.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$032bde9a083b6f9d$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $6ichd.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$032bde9a083b6f9d$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $6ichd.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$032bde9a083b6f9d$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $6ichd.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$032bde9a083b6f9d$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $6ichd.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$032bde9a083b6f9d$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $6ichd.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$032bde9a083b6f9d$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $6ichd.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $032bde9a083b6f9d$var$pre;

try {
    $032bde9a083b6f9d$var$pre = (parcelRequire("eg8Tz"));
} catch (e) {
    $032bde9a083b6f9d$var$pre = undefined;
}
$032bde9a083b6f9d$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $6ichd.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $032bde9a083b6f9d$var$pre
    ]
});

});
parcelRegister("6ichd", function(module, exports) {
var $494df2640116f7d1$var$hash = module.exports;

$494df2640116f7d1$var$hash.utils = (parcelRequire("6CuVQ"));

$494df2640116f7d1$var$hash.common = (parcelRequire("2pZHr"));

$494df2640116f7d1$var$hash.sha = (parcelRequire("fjfcU"));

$494df2640116f7d1$var$hash.ripemd = (parcelRequire("3r1bD"));

$494df2640116f7d1$var$hash.hmac = (parcelRequire("4DCDS"));
// Proxy hash functions to the main object
$494df2640116f7d1$var$hash.sha1 = $494df2640116f7d1$var$hash.sha.sha1;
$494df2640116f7d1$var$hash.sha256 = $494df2640116f7d1$var$hash.sha.sha256;
$494df2640116f7d1$var$hash.sha224 = $494df2640116f7d1$var$hash.sha.sha224;
$494df2640116f7d1$var$hash.sha384 = $494df2640116f7d1$var$hash.sha.sha384;
$494df2640116f7d1$var$hash.sha512 = $494df2640116f7d1$var$hash.sha.sha512;
$494df2640116f7d1$var$hash.ripemd160 = $494df2640116f7d1$var$hash.ripemd.ripemd160;

});
parcelRegister("6CuVQ", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $4d1e49265ba035b4$export$69f1b2dcda23c5f8; }, function (v) { return $4d1e49265ba035b4$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $4d1e49265ba035b4$export$45b10814cc054894; }, function (v) { return $4d1e49265ba035b4$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $4d1e49265ba035b4$export$7ea66e3774a60b67; }, function (v) { return $4d1e49265ba035b4$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $4d1e49265ba035b4$export$34a52f00f601f6f1; }, function (v) { return $4d1e49265ba035b4$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $4d1e49265ba035b4$export$812b0cbd5e8a72ab; }, function (v) { return $4d1e49265ba035b4$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $4d1e49265ba035b4$export$f24f9e11d63bb314; }, function (v) { return $4d1e49265ba035b4$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $4d1e49265ba035b4$export$b71357c7e07ca1f1; }, function (v) { return $4d1e49265ba035b4$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $4d1e49265ba035b4$export$2e58a4b541fdcbe8; }, function (v) { return $4d1e49265ba035b4$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $4d1e49265ba035b4$export$183b950bde9faab8; }, function (v) { return $4d1e49265ba035b4$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $4d1e49265ba035b4$export$4785c77169fea59e; }, function (v) { return $4d1e49265ba035b4$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $4d1e49265ba035b4$export$242a185dfcffac5b; }, function (v) { return $4d1e49265ba035b4$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $4d1e49265ba035b4$export$58c04ae0ae31877d; }, function (v) { return $4d1e49265ba035b4$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $4d1e49265ba035b4$export$d058ca695f8c6f11; }, function (v) { return $4d1e49265ba035b4$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $4d1e49265ba035b4$export$a1efd7fc3e986367; }, function (v) { return $4d1e49265ba035b4$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $4d1e49265ba035b4$export$bbfea4a2b5abaab4; }, function (v) { return $4d1e49265ba035b4$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $4d1e49265ba035b4$export$97ad4afc7de86152; }, function (v) { return $4d1e49265ba035b4$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $4d1e49265ba035b4$export$ce4673d9a79f6a4b; }, function (v) { return $4d1e49265ba035b4$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $4d1e49265ba035b4$export$786cc99fc6eedc0b; }, function (v) { return $4d1e49265ba035b4$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $4d1e49265ba035b4$export$45c59b9a1848dd0; }, function (v) { return $4d1e49265ba035b4$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $4d1e49265ba035b4$export$50d8f613e76d3034; }, function (v) { return $4d1e49265ba035b4$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $4d1e49265ba035b4$export$b8e83683c60ee162; }, function (v) { return $4d1e49265ba035b4$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $4d1e49265ba035b4$export$aeeb51790d1bcc4a; }, function (v) { return $4d1e49265ba035b4$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $4d1e49265ba035b4$export$bb7c616f719ad9c; }, function (v) { return $4d1e49265ba035b4$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $4d1e49265ba035b4$export$4d63290824f9d7df; }, function (v) { return $4d1e49265ba035b4$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $4d1e49265ba035b4$export$2f64ceb90ef28ea1; }, function (v) { return $4d1e49265ba035b4$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $4d1e49265ba035b4$export$8d2089d465f6d10d; }, function (v) { return $4d1e49265ba035b4$export$8d2089d465f6d10d = v; });
var $4d1e49265ba035b4$export$69f1b2dcda23c5f8;
var $4d1e49265ba035b4$export$45b10814cc054894;
var $4d1e49265ba035b4$export$7ea66e3774a60b67;
var $4d1e49265ba035b4$export$34a52f00f601f6f1;
var $4d1e49265ba035b4$export$812b0cbd5e8a72ab;
var $4d1e49265ba035b4$export$f24f9e11d63bb314;
var $4d1e49265ba035b4$export$b71357c7e07ca1f1;
var $4d1e49265ba035b4$export$2e58a4b541fdcbe8;
var $4d1e49265ba035b4$export$183b950bde9faab8;
var $4d1e49265ba035b4$export$4785c77169fea59e;
var $4d1e49265ba035b4$export$242a185dfcffac5b;
var $4d1e49265ba035b4$export$58c04ae0ae31877d;
var $4d1e49265ba035b4$export$d058ca695f8c6f11;
var $4d1e49265ba035b4$export$a1efd7fc3e986367;
var $4d1e49265ba035b4$export$bbfea4a2b5abaab4;
var $4d1e49265ba035b4$export$97ad4afc7de86152;
var $4d1e49265ba035b4$export$ce4673d9a79f6a4b;
var $4d1e49265ba035b4$export$786cc99fc6eedc0b;
var $4d1e49265ba035b4$export$45c59b9a1848dd0;
var $4d1e49265ba035b4$export$50d8f613e76d3034;
var $4d1e49265ba035b4$export$b8e83683c60ee162;
var $4d1e49265ba035b4$export$aeeb51790d1bcc4a;
var $4d1e49265ba035b4$export$bb7c616f719ad9c;
var $4d1e49265ba035b4$export$4d63290824f9d7df;
var $4d1e49265ba035b4$export$2f64ceb90ef28ea1;
var $4d1e49265ba035b4$export$8d2089d465f6d10d;
"use strict";

var $6Dc6S = parcelRequire("6Dc6S");

var $ktTkY = parcelRequire("ktTkY");
$4d1e49265ba035b4$export$69f1b2dcda23c5f8 = $ktTkY;
function $4d1e49265ba035b4$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $4d1e49265ba035b4$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($4d1e49265ba035b4$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$4d1e49265ba035b4$export$45b10814cc054894 = $4d1e49265ba035b4$var$toArray;
function $4d1e49265ba035b4$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $4d1e49265ba035b4$var$zero2(msg[i].toString(16));
    return res;
}
$4d1e49265ba035b4$export$7ea66e3774a60b67 = $4d1e49265ba035b4$var$toHex;
function $4d1e49265ba035b4$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$4d1e49265ba035b4$export$34a52f00f601f6f1 = $4d1e49265ba035b4$var$htonl;
function $4d1e49265ba035b4$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $4d1e49265ba035b4$var$htonl(w);
        res += $4d1e49265ba035b4$var$zero8(w.toString(16));
    }
    return res;
}
$4d1e49265ba035b4$export$812b0cbd5e8a72ab = $4d1e49265ba035b4$var$toHex32;
function $4d1e49265ba035b4$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$4d1e49265ba035b4$export$f24f9e11d63bb314 = $4d1e49265ba035b4$var$zero2;
function $4d1e49265ba035b4$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$4d1e49265ba035b4$export$b71357c7e07ca1f1 = $4d1e49265ba035b4$var$zero8;
function $4d1e49265ba035b4$var$join32(msg, start, end, endian) {
    var len = end - start;
    $6Dc6S(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$4d1e49265ba035b4$export$2e58a4b541fdcbe8 = $4d1e49265ba035b4$var$join32;
function $4d1e49265ba035b4$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$4d1e49265ba035b4$export$183b950bde9faab8 = $4d1e49265ba035b4$var$split32;
function $4d1e49265ba035b4$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$4d1e49265ba035b4$export$4785c77169fea59e = $4d1e49265ba035b4$var$rotr32;
function $4d1e49265ba035b4$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$4d1e49265ba035b4$export$242a185dfcffac5b = $4d1e49265ba035b4$var$rotl32;
function $4d1e49265ba035b4$var$sum32(a, b) {
    return a + b >>> 0;
}
$4d1e49265ba035b4$export$58c04ae0ae31877d = $4d1e49265ba035b4$var$sum32;
function $4d1e49265ba035b4$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$4d1e49265ba035b4$export$d058ca695f8c6f11 = $4d1e49265ba035b4$var$sum32_3;
function $4d1e49265ba035b4$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$4d1e49265ba035b4$export$a1efd7fc3e986367 = $4d1e49265ba035b4$var$sum32_4;
function $4d1e49265ba035b4$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$4d1e49265ba035b4$export$bbfea4a2b5abaab4 = $4d1e49265ba035b4$var$sum32_5;
function $4d1e49265ba035b4$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$4d1e49265ba035b4$export$97ad4afc7de86152 = $4d1e49265ba035b4$var$sum64;
function $4d1e49265ba035b4$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$4d1e49265ba035b4$export$ce4673d9a79f6a4b = $4d1e49265ba035b4$var$sum64_hi;
function $4d1e49265ba035b4$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$4d1e49265ba035b4$export$786cc99fc6eedc0b = $4d1e49265ba035b4$var$sum64_lo;
function $4d1e49265ba035b4$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$4d1e49265ba035b4$export$45c59b9a1848dd0 = $4d1e49265ba035b4$var$sum64_4_hi;
function $4d1e49265ba035b4$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$4d1e49265ba035b4$export$50d8f613e76d3034 = $4d1e49265ba035b4$var$sum64_4_lo;
function $4d1e49265ba035b4$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$4d1e49265ba035b4$export$b8e83683c60ee162 = $4d1e49265ba035b4$var$sum64_5_hi;
function $4d1e49265ba035b4$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$4d1e49265ba035b4$export$aeeb51790d1bcc4a = $4d1e49265ba035b4$var$sum64_5_lo;
function $4d1e49265ba035b4$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$4d1e49265ba035b4$export$bb7c616f719ad9c = $4d1e49265ba035b4$var$rotr64_hi;
function $4d1e49265ba035b4$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$4d1e49265ba035b4$export$4d63290824f9d7df = $4d1e49265ba035b4$var$rotr64_lo;
function $4d1e49265ba035b4$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$4d1e49265ba035b4$export$2f64ceb90ef28ea1 = $4d1e49265ba035b4$var$shr64_hi;
function $4d1e49265ba035b4$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$4d1e49265ba035b4$export$8d2089d465f6d10d = $4d1e49265ba035b4$var$shr64_lo;

});

parcelRegister("2pZHr", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $1c2dc6d04a3889e8$export$8687658379b577e6; }, function (v) { return $1c2dc6d04a3889e8$export$8687658379b577e6 = v; });
var $1c2dc6d04a3889e8$export$8687658379b577e6;
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");

var $6Dc6S = parcelRequire("6Dc6S");
function $1c2dc6d04a3889e8$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$1c2dc6d04a3889e8$export$8687658379b577e6 = $1c2dc6d04a3889e8$var$BlockHash;
$1c2dc6d04a3889e8$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $6CuVQ.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $6CuVQ.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$1c2dc6d04a3889e8$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $6Dc6S(this.pending === null);
    return this._digest(enc);
};
$1c2dc6d04a3889e8$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("fjfcU", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $b2546d30a729accc$export$5091bdda49ba90f5; }, function (v) { return $b2546d30a729accc$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $b2546d30a729accc$export$97b70509d4e397ea; }, function (v) { return $b2546d30a729accc$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $b2546d30a729accc$export$bced8d2aada2d1c9; }, function (v) { return $b2546d30a729accc$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $b2546d30a729accc$export$612d47d55dedde45; }, function (v) { return $b2546d30a729accc$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $b2546d30a729accc$export$a888d2532e6dc7bb; }, function (v) { return $b2546d30a729accc$export$a888d2532e6dc7bb = v; });
var $b2546d30a729accc$export$5091bdda49ba90f5;
var $b2546d30a729accc$export$97b70509d4e397ea;
var $b2546d30a729accc$export$bced8d2aada2d1c9;
var $b2546d30a729accc$export$612d47d55dedde45;
var $b2546d30a729accc$export$a888d2532e6dc7bb;
"use strict";

$b2546d30a729accc$export$5091bdda49ba90f5 = (parcelRequire("1ocgn"));

$b2546d30a729accc$export$97b70509d4e397ea = (parcelRequire("cBwP5"));

$b2546d30a729accc$export$bced8d2aada2d1c9 = (parcelRequire("2GA47"));

$b2546d30a729accc$export$612d47d55dedde45 = (parcelRequire("9jryw"));

$b2546d30a729accc$export$a888d2532e6dc7bb = (parcelRequire("gle0C"));

});
parcelRegister("1ocgn", function(module, exports) {
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");

var $2pZHr = parcelRequire("2pZHr");

var $4OYgd = parcelRequire("4OYgd");
var $10318b8896d28376$var$rotl32 = $6CuVQ.rotl32;
var $10318b8896d28376$var$sum32 = $6CuVQ.sum32;
var $10318b8896d28376$var$sum32_5 = $6CuVQ.sum32_5;
var $10318b8896d28376$var$ft_1 = $4OYgd.ft_1;
var $10318b8896d28376$var$BlockHash = $2pZHr.BlockHash;
var $10318b8896d28376$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $10318b8896d28376$var$SHA1() {
    if (!(this instanceof $10318b8896d28376$var$SHA1)) return new $10318b8896d28376$var$SHA1();
    $10318b8896d28376$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$6CuVQ.inherits($10318b8896d28376$var$SHA1, $10318b8896d28376$var$BlockHash);
module.exports = $10318b8896d28376$var$SHA1;
$10318b8896d28376$var$SHA1.blockSize = 512;
$10318b8896d28376$var$SHA1.outSize = 160;
$10318b8896d28376$var$SHA1.hmacStrength = 80;
$10318b8896d28376$var$SHA1.padLength = 64;
$10318b8896d28376$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $10318b8896d28376$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $10318b8896d28376$var$sum32_5($10318b8896d28376$var$rotl32(a, 5), $10318b8896d28376$var$ft_1(s, b, c, d), e, W[i], $10318b8896d28376$var$sha1_K[s]);
        e = d;
        d = c;
        c = $10318b8896d28376$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $10318b8896d28376$var$sum32(this.h[0], a);
    this.h[1] = $10318b8896d28376$var$sum32(this.h[1], b);
    this.h[2] = $10318b8896d28376$var$sum32(this.h[2], c);
    this.h[3] = $10318b8896d28376$var$sum32(this.h[3], d);
    this.h[4] = $10318b8896d28376$var$sum32(this.h[4], e);
};
$10318b8896d28376$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6CuVQ.toHex32(this.h, "big");
    else return $6CuVQ.split32(this.h, "big");
};

});
parcelRegister("4OYgd", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $382a936f0092577f$export$5a92649d7ddb9f63; }, function (v) { return $382a936f0092577f$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $382a936f0092577f$export$c6d0d020c3a6269; }, function (v) { return $382a936f0092577f$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $382a936f0092577f$export$eb90c27fca05f956; }, function (v) { return $382a936f0092577f$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $382a936f0092577f$export$14a4a98e063b1999; }, function (v) { return $382a936f0092577f$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $382a936f0092577f$export$d20cecfa1564c686; }, function (v) { return $382a936f0092577f$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $382a936f0092577f$export$44fd472a12fc6db; }, function (v) { return $382a936f0092577f$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $382a936f0092577f$export$1ed238bb6ea1dd47; }, function (v) { return $382a936f0092577f$export$1ed238bb6ea1dd47 = v; });
var $382a936f0092577f$export$5a92649d7ddb9f63;
var $382a936f0092577f$export$c6d0d020c3a6269;
var $382a936f0092577f$export$eb90c27fca05f956;
var $382a936f0092577f$export$cc992891a14496a1;
var $382a936f0092577f$export$14a4a98e063b1999;
var $382a936f0092577f$export$d20cecfa1564c686;
var $382a936f0092577f$export$44fd472a12fc6db;
var $382a936f0092577f$export$1ed238bb6ea1dd47;
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");
var $382a936f0092577f$var$rotr32 = $6CuVQ.rotr32;
function $382a936f0092577f$var$ft_1(s, x, y, z) {
    if (s === 0) return $382a936f0092577f$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $382a936f0092577f$var$p32(x, y, z);
    if (s === 2) return $382a936f0092577f$var$maj32(x, y, z);
}
$382a936f0092577f$export$5a92649d7ddb9f63 = $382a936f0092577f$var$ft_1;
function $382a936f0092577f$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$382a936f0092577f$export$c6d0d020c3a6269 = $382a936f0092577f$var$ch32;
function $382a936f0092577f$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$382a936f0092577f$export$eb90c27fca05f956 = $382a936f0092577f$var$maj32;
function $382a936f0092577f$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$382a936f0092577f$export$cc992891a14496a1 = $382a936f0092577f$var$p32;
function $382a936f0092577f$var$s0_256(x) {
    return $382a936f0092577f$var$rotr32(x, 2) ^ $382a936f0092577f$var$rotr32(x, 13) ^ $382a936f0092577f$var$rotr32(x, 22);
}
$382a936f0092577f$export$14a4a98e063b1999 = $382a936f0092577f$var$s0_256;
function $382a936f0092577f$var$s1_256(x) {
    return $382a936f0092577f$var$rotr32(x, 6) ^ $382a936f0092577f$var$rotr32(x, 11) ^ $382a936f0092577f$var$rotr32(x, 25);
}
$382a936f0092577f$export$d20cecfa1564c686 = $382a936f0092577f$var$s1_256;
function $382a936f0092577f$var$g0_256(x) {
    return $382a936f0092577f$var$rotr32(x, 7) ^ $382a936f0092577f$var$rotr32(x, 18) ^ x >>> 3;
}
$382a936f0092577f$export$44fd472a12fc6db = $382a936f0092577f$var$g0_256;
function $382a936f0092577f$var$g1_256(x) {
    return $382a936f0092577f$var$rotr32(x, 17) ^ $382a936f0092577f$var$rotr32(x, 19) ^ x >>> 10;
}
$382a936f0092577f$export$1ed238bb6ea1dd47 = $382a936f0092577f$var$g1_256;

});


parcelRegister("cBwP5", function(module, exports) {
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");

var $2GA47 = parcelRequire("2GA47");
function $92d266b0e78e77e7$var$SHA224() {
    if (!(this instanceof $92d266b0e78e77e7$var$SHA224)) return new $92d266b0e78e77e7$var$SHA224();
    $2GA47.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$6CuVQ.inherits($92d266b0e78e77e7$var$SHA224, $2GA47);
module.exports = $92d266b0e78e77e7$var$SHA224;
$92d266b0e78e77e7$var$SHA224.blockSize = 512;
$92d266b0e78e77e7$var$SHA224.outSize = 224;
$92d266b0e78e77e7$var$SHA224.hmacStrength = 192;
$92d266b0e78e77e7$var$SHA224.padLength = 64;
$92d266b0e78e77e7$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $6CuVQ.toHex32(this.h.slice(0, 7), "big");
    else return $6CuVQ.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("2GA47", function(module, exports) {
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");

var $2pZHr = parcelRequire("2pZHr");

var $4OYgd = parcelRequire("4OYgd");

var $6Dc6S = parcelRequire("6Dc6S");
var $1f4b7ad873c64ff7$var$sum32 = $6CuVQ.sum32;
var $1f4b7ad873c64ff7$var$sum32_4 = $6CuVQ.sum32_4;
var $1f4b7ad873c64ff7$var$sum32_5 = $6CuVQ.sum32_5;
var $1f4b7ad873c64ff7$var$ch32 = $4OYgd.ch32;
var $1f4b7ad873c64ff7$var$maj32 = $4OYgd.maj32;
var $1f4b7ad873c64ff7$var$s0_256 = $4OYgd.s0_256;
var $1f4b7ad873c64ff7$var$s1_256 = $4OYgd.s1_256;
var $1f4b7ad873c64ff7$var$g0_256 = $4OYgd.g0_256;
var $1f4b7ad873c64ff7$var$g1_256 = $4OYgd.g1_256;
var $1f4b7ad873c64ff7$var$BlockHash = $2pZHr.BlockHash;
var $1f4b7ad873c64ff7$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $1f4b7ad873c64ff7$var$SHA256() {
    if (!(this instanceof $1f4b7ad873c64ff7$var$SHA256)) return new $1f4b7ad873c64ff7$var$SHA256();
    $1f4b7ad873c64ff7$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $1f4b7ad873c64ff7$var$sha256_K;
    this.W = new Array(64);
}
$6CuVQ.inherits($1f4b7ad873c64ff7$var$SHA256, $1f4b7ad873c64ff7$var$BlockHash);
module.exports = $1f4b7ad873c64ff7$var$SHA256;
$1f4b7ad873c64ff7$var$SHA256.blockSize = 512;
$1f4b7ad873c64ff7$var$SHA256.outSize = 256;
$1f4b7ad873c64ff7$var$SHA256.hmacStrength = 192;
$1f4b7ad873c64ff7$var$SHA256.padLength = 64;
$1f4b7ad873c64ff7$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $1f4b7ad873c64ff7$var$sum32_4($1f4b7ad873c64ff7$var$g1_256(W[i - 2]), W[i - 7], $1f4b7ad873c64ff7$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $6Dc6S(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $1f4b7ad873c64ff7$var$sum32_5(h, $1f4b7ad873c64ff7$var$s1_256(e), $1f4b7ad873c64ff7$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $1f4b7ad873c64ff7$var$sum32($1f4b7ad873c64ff7$var$s0_256(a), $1f4b7ad873c64ff7$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $1f4b7ad873c64ff7$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $1f4b7ad873c64ff7$var$sum32(T1, T2);
    }
    this.h[0] = $1f4b7ad873c64ff7$var$sum32(this.h[0], a);
    this.h[1] = $1f4b7ad873c64ff7$var$sum32(this.h[1], b);
    this.h[2] = $1f4b7ad873c64ff7$var$sum32(this.h[2], c);
    this.h[3] = $1f4b7ad873c64ff7$var$sum32(this.h[3], d);
    this.h[4] = $1f4b7ad873c64ff7$var$sum32(this.h[4], e);
    this.h[5] = $1f4b7ad873c64ff7$var$sum32(this.h[5], f);
    this.h[6] = $1f4b7ad873c64ff7$var$sum32(this.h[6], g);
    this.h[7] = $1f4b7ad873c64ff7$var$sum32(this.h[7], h);
};
$1f4b7ad873c64ff7$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6CuVQ.toHex32(this.h, "big");
    else return $6CuVQ.split32(this.h, "big");
};

});


parcelRegister("9jryw", function(module, exports) {
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");

var $gle0C = parcelRequire("gle0C");
function $6c7b437019bea8cd$var$SHA384() {
    if (!(this instanceof $6c7b437019bea8cd$var$SHA384)) return new $6c7b437019bea8cd$var$SHA384();
    $gle0C.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$6CuVQ.inherits($6c7b437019bea8cd$var$SHA384, $gle0C);
module.exports = $6c7b437019bea8cd$var$SHA384;
$6c7b437019bea8cd$var$SHA384.blockSize = 1024;
$6c7b437019bea8cd$var$SHA384.outSize = 384;
$6c7b437019bea8cd$var$SHA384.hmacStrength = 192;
$6c7b437019bea8cd$var$SHA384.padLength = 128;
$6c7b437019bea8cd$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6CuVQ.toHex32(this.h.slice(0, 12), "big");
    else return $6CuVQ.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("gle0C", function(module, exports) {
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");

var $2pZHr = parcelRequire("2pZHr");

var $6Dc6S = parcelRequire("6Dc6S");
var $be597961d63a6711$var$rotr64_hi = $6CuVQ.rotr64_hi;
var $be597961d63a6711$var$rotr64_lo = $6CuVQ.rotr64_lo;
var $be597961d63a6711$var$shr64_hi = $6CuVQ.shr64_hi;
var $be597961d63a6711$var$shr64_lo = $6CuVQ.shr64_lo;
var $be597961d63a6711$var$sum64 = $6CuVQ.sum64;
var $be597961d63a6711$var$sum64_hi = $6CuVQ.sum64_hi;
var $be597961d63a6711$var$sum64_lo = $6CuVQ.sum64_lo;
var $be597961d63a6711$var$sum64_4_hi = $6CuVQ.sum64_4_hi;
var $be597961d63a6711$var$sum64_4_lo = $6CuVQ.sum64_4_lo;
var $be597961d63a6711$var$sum64_5_hi = $6CuVQ.sum64_5_hi;
var $be597961d63a6711$var$sum64_5_lo = $6CuVQ.sum64_5_lo;
var $be597961d63a6711$var$BlockHash = $2pZHr.BlockHash;
var $be597961d63a6711$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $be597961d63a6711$var$SHA512() {
    if (!(this instanceof $be597961d63a6711$var$SHA512)) return new $be597961d63a6711$var$SHA512();
    $be597961d63a6711$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $be597961d63a6711$var$sha512_K;
    this.W = new Array(160);
}
$6CuVQ.inherits($be597961d63a6711$var$SHA512, $be597961d63a6711$var$BlockHash);
module.exports = $be597961d63a6711$var$SHA512;
$be597961d63a6711$var$SHA512.blockSize = 1024;
$be597961d63a6711$var$SHA512.outSize = 512;
$be597961d63a6711$var$SHA512.hmacStrength = 192;
$be597961d63a6711$var$SHA512.padLength = 128;
$be597961d63a6711$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $be597961d63a6711$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $be597961d63a6711$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $be597961d63a6711$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $be597961d63a6711$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $be597961d63a6711$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $be597961d63a6711$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$be597961d63a6711$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $6Dc6S(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $be597961d63a6711$var$s1_512_hi(eh, el);
        var c1_lo = $be597961d63a6711$var$s1_512_lo(eh, el);
        var c2_hi = $be597961d63a6711$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $be597961d63a6711$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $be597961d63a6711$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $be597961d63a6711$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $be597961d63a6711$var$s0_512_hi(ah, al);
        c0_lo = $be597961d63a6711$var$s0_512_lo(ah, al);
        c1_hi = $be597961d63a6711$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $be597961d63a6711$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $be597961d63a6711$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $be597961d63a6711$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $be597961d63a6711$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $be597961d63a6711$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $be597961d63a6711$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $be597961d63a6711$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $be597961d63a6711$var$sum64(this.h, 0, ah, al);
    $be597961d63a6711$var$sum64(this.h, 2, bh, bl);
    $be597961d63a6711$var$sum64(this.h, 4, ch, cl);
    $be597961d63a6711$var$sum64(this.h, 6, dh, dl);
    $be597961d63a6711$var$sum64(this.h, 8, eh, el);
    $be597961d63a6711$var$sum64(this.h, 10, fh, fl);
    $be597961d63a6711$var$sum64(this.h, 12, gh, gl);
    $be597961d63a6711$var$sum64(this.h, 14, hh, hl);
};
$be597961d63a6711$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6CuVQ.toHex32(this.h, "big");
    else return $6CuVQ.split32(this.h, "big");
};
function $be597961d63a6711$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$s0_512_hi(xh, xl) {
    var c0_hi = $be597961d63a6711$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $be597961d63a6711$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $be597961d63a6711$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$s0_512_lo(xh, xl) {
    var c0_lo = $be597961d63a6711$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $be597961d63a6711$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $be597961d63a6711$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$s1_512_hi(xh, xl) {
    var c0_hi = $be597961d63a6711$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $be597961d63a6711$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $be597961d63a6711$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$s1_512_lo(xh, xl) {
    var c0_lo = $be597961d63a6711$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $be597961d63a6711$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $be597961d63a6711$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$g0_512_hi(xh, xl) {
    var c0_hi = $be597961d63a6711$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $be597961d63a6711$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $be597961d63a6711$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$g0_512_lo(xh, xl) {
    var c0_lo = $be597961d63a6711$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $be597961d63a6711$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $be597961d63a6711$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$g1_512_hi(xh, xl) {
    var c0_hi = $be597961d63a6711$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $be597961d63a6711$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $be597961d63a6711$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $be597961d63a6711$var$g1_512_lo(xh, xl) {
    var c0_lo = $be597961d63a6711$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $be597961d63a6711$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $be597961d63a6711$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("3r1bD", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $2804d0577b34d4ab$export$d1cea0ee4e3f0d3e; }, function (v) { return $2804d0577b34d4ab$export$d1cea0ee4e3f0d3e = v; });
var $2804d0577b34d4ab$export$d1cea0ee4e3f0d3e;
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");

var $2pZHr = parcelRequire("2pZHr");
var $2804d0577b34d4ab$var$rotl32 = $6CuVQ.rotl32;
var $2804d0577b34d4ab$var$sum32 = $6CuVQ.sum32;
var $2804d0577b34d4ab$var$sum32_3 = $6CuVQ.sum32_3;
var $2804d0577b34d4ab$var$sum32_4 = $6CuVQ.sum32_4;
var $2804d0577b34d4ab$var$BlockHash = $2pZHr.BlockHash;
function $2804d0577b34d4ab$var$RIPEMD160() {
    if (!(this instanceof $2804d0577b34d4ab$var$RIPEMD160)) return new $2804d0577b34d4ab$var$RIPEMD160();
    $2804d0577b34d4ab$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$6CuVQ.inherits($2804d0577b34d4ab$var$RIPEMD160, $2804d0577b34d4ab$var$BlockHash);
$2804d0577b34d4ab$export$d1cea0ee4e3f0d3e = $2804d0577b34d4ab$var$RIPEMD160;
$2804d0577b34d4ab$var$RIPEMD160.blockSize = 512;
$2804d0577b34d4ab$var$RIPEMD160.outSize = 160;
$2804d0577b34d4ab$var$RIPEMD160.hmacStrength = 192;
$2804d0577b34d4ab$var$RIPEMD160.padLength = 64;
$2804d0577b34d4ab$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $2804d0577b34d4ab$var$sum32($2804d0577b34d4ab$var$rotl32($2804d0577b34d4ab$var$sum32_4(A, $2804d0577b34d4ab$var$f(j, B, C, D), msg[$2804d0577b34d4ab$var$r[j] + start], $2804d0577b34d4ab$var$K(j)), $2804d0577b34d4ab$var$s[j]), E);
        A = E;
        E = D;
        D = $2804d0577b34d4ab$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $2804d0577b34d4ab$var$sum32($2804d0577b34d4ab$var$rotl32($2804d0577b34d4ab$var$sum32_4(Ah, $2804d0577b34d4ab$var$f(79 - j, Bh, Ch, Dh), msg[$2804d0577b34d4ab$var$rh[j] + start], $2804d0577b34d4ab$var$Kh(j)), $2804d0577b34d4ab$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $2804d0577b34d4ab$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $2804d0577b34d4ab$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $2804d0577b34d4ab$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $2804d0577b34d4ab$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $2804d0577b34d4ab$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $2804d0577b34d4ab$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$2804d0577b34d4ab$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6CuVQ.toHex32(this.h, "little");
    else return $6CuVQ.split32(this.h, "little");
};
function $2804d0577b34d4ab$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $2804d0577b34d4ab$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $2804d0577b34d4ab$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $2804d0577b34d4ab$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $2804d0577b34d4ab$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $2804d0577b34d4ab$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $2804d0577b34d4ab$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("4DCDS", function(module, exports) {
"use strict";

var $6CuVQ = parcelRequire("6CuVQ");

var $6Dc6S = parcelRequire("6Dc6S");
function $3608c77944323b13$var$Hmac(hash, key, enc) {
    if (!(this instanceof $3608c77944323b13$var$Hmac)) return new $3608c77944323b13$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($6CuVQ.toArray(key, enc));
}
module.exports = $3608c77944323b13$var$Hmac;
$3608c77944323b13$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $6Dc6S(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$3608c77944323b13$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$3608c77944323b13$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("eg8Tz", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("httWt", function(module, exports) {
"use strict";

var $4EH0Y = parcelRequire("4EH0Y");

var $40ye2 = parcelRequire("40ye2");

var $fbJKm = parcelRequire("fbJKm");

var $gSCXD = parcelRequire("gSCXD");

var $9NWyt = parcelRequire("9NWyt");
var $cb8c5efc981e30c8$var$assert = $fbJKm.assert;

var $4qs39 = parcelRequire("4qs39");

var $8Ad7f = parcelRequire("8Ad7f");
function $cb8c5efc981e30c8$var$EC(options) {
    if (!(this instanceof $cb8c5efc981e30c8$var$EC)) return new $cb8c5efc981e30c8$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $cb8c5efc981e30c8$var$assert(Object.prototype.hasOwnProperty.call($gSCXD, options), "Unknown curve " + options);
        options = $gSCXD[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $gSCXD.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $cb8c5efc981e30c8$var$EC;
$cb8c5efc981e30c8$var$EC.prototype.keyPair = function keyPair(options) {
    return new $4qs39(this, options);
};
$cb8c5efc981e30c8$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $4qs39.fromPrivate(this, priv, enc);
};
$cb8c5efc981e30c8$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $4qs39.fromPublic(this, pub, enc);
};
$cb8c5efc981e30c8$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $40ye2({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $9NWyt(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $4EH0Y(2));
    for(;;){
        var priv = new $4EH0Y(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$cb8c5efc981e30c8$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$cb8c5efc981e30c8$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $4EH0Y(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $40ye2({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $4EH0Y(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $4EH0Y(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $8Ad7f({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$cb8c5efc981e30c8$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $4EH0Y(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $8Ad7f(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$cb8c5efc981e30c8$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $cb8c5efc981e30c8$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $8Ad7f(signature, enc);
    var n = this.n;
    var e = new $4EH0Y(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$cb8c5efc981e30c8$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $8Ad7f(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("40ye2", function(module, exports) {
"use strict";

var $6ichd = parcelRequire("6ichd");

var $l5KyF = parcelRequire("l5KyF");

var $6Dc6S = parcelRequire("6Dc6S");
function $2eb1b5fddcb1436e$var$HmacDRBG(options) {
    if (!(this instanceof $2eb1b5fddcb1436e$var$HmacDRBG)) return new $2eb1b5fddcb1436e$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $l5KyF.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $l5KyF.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $l5KyF.toArray(options.pers, options.persEnc || "hex");
    $6Dc6S(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $2eb1b5fddcb1436e$var$HmacDRBG;
$2eb1b5fddcb1436e$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$2eb1b5fddcb1436e$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $6ichd.hmac(this.hash, this.K);
};
$2eb1b5fddcb1436e$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$2eb1b5fddcb1436e$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $l5KyF.toArray(entropy, entropyEnc);
    add = $l5KyF.toArray(add, addEnc);
    $6Dc6S(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$2eb1b5fddcb1436e$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $l5KyF.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $l5KyF.encode(res, enc);
};

});

parcelRegister("4qs39", function(module, exports) {
"use strict";

var $4EH0Y = parcelRequire("4EH0Y");

var $fbJKm = parcelRequire("fbJKm");
var $338f5939ad289d82$var$assert = $fbJKm.assert;
function $338f5939ad289d82$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $338f5939ad289d82$var$KeyPair;
$338f5939ad289d82$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $338f5939ad289d82$var$KeyPair) return pub;
    return new $338f5939ad289d82$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$338f5939ad289d82$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $338f5939ad289d82$var$KeyPair) return priv;
    return new $338f5939ad289d82$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$338f5939ad289d82$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$338f5939ad289d82$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$338f5939ad289d82$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$338f5939ad289d82$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $4EH0Y(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$338f5939ad289d82$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $338f5939ad289d82$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $338f5939ad289d82$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$338f5939ad289d82$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $338f5939ad289d82$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$338f5939ad289d82$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$338f5939ad289d82$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$338f5939ad289d82$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("8Ad7f", function(module, exports) {
"use strict";

var $4EH0Y = parcelRequire("4EH0Y");

var $fbJKm = parcelRequire("fbJKm");
var $63fbdc137307ac78$var$assert = $fbJKm.assert;
function $63fbdc137307ac78$var$Signature(options, enc) {
    if (options instanceof $63fbdc137307ac78$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $63fbdc137307ac78$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $4EH0Y(options.r, 16);
    this.s = new $4EH0Y(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $63fbdc137307ac78$var$Signature;
function $63fbdc137307ac78$var$Position() {
    this.place = 0;
}
function $63fbdc137307ac78$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $63fbdc137307ac78$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$63fbdc137307ac78$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $fbJKm.toArray(data, enc);
    var p = new $63fbdc137307ac78$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $63fbdc137307ac78$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $63fbdc137307ac78$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $63fbdc137307ac78$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $4EH0Y(r);
    this.s = new $4EH0Y(s);
    this.recoveryParam = null;
    return true;
};
function $63fbdc137307ac78$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$63fbdc137307ac78$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $63fbdc137307ac78$var$rmPadding(r);
    s = $63fbdc137307ac78$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $63fbdc137307ac78$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $63fbdc137307ac78$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $63fbdc137307ac78$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $fbJKm.encode(res, enc);
};

});


parcelRegister("4dIOI", function(module, exports) {
"use strict";

var $6ichd = parcelRequire("6ichd");

var $gSCXD = parcelRequire("gSCXD");

var $fbJKm = parcelRequire("fbJKm");
var $312b240a7faaf935$var$assert = $fbJKm.assert;
var $312b240a7faaf935$var$parseBytes = $fbJKm.parseBytes;

var $8nNiA = parcelRequire("8nNiA");

var $7YTXE = parcelRequire("7YTXE");
function $312b240a7faaf935$var$EDDSA(curve) {
    $312b240a7faaf935$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $312b240a7faaf935$var$EDDSA)) return new $312b240a7faaf935$var$EDDSA(curve);
    curve = $gSCXD[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $6ichd.sha512;
}
module.exports = $312b240a7faaf935$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $312b240a7faaf935$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $312b240a7faaf935$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $312b240a7faaf935$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $312b240a7faaf935$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$312b240a7faaf935$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $fbJKm.intFromLE(hash.digest()).umod(this.curve.n);
};
$312b240a7faaf935$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $8nNiA.fromPublic(this, pub);
};
$312b240a7faaf935$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $8nNiA.fromSecret(this, secret);
};
$312b240a7faaf935$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7YTXE) return sig;
    return new $7YTXE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $312b240a7faaf935$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$312b240a7faaf935$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $fbJKm.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $fbJKm.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$312b240a7faaf935$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$312b240a7faaf935$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $fbJKm.intFromLE(bytes);
};
$312b240a7faaf935$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("8nNiA", function(module, exports) {
"use strict";

var $fbJKm = parcelRequire("fbJKm");
var $61a6b670288f11c9$var$assert = $fbJKm.assert;
var $61a6b670288f11c9$var$parseBytes = $fbJKm.parseBytes;
var $61a6b670288f11c9$var$cachedProperty = $fbJKm.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $61a6b670288f11c9$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $61a6b670288f11c9$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $61a6b670288f11c9$var$parseBytes(params.pub);
}
$61a6b670288f11c9$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $61a6b670288f11c9$var$KeyPair) return pub;
    return new $61a6b670288f11c9$var$KeyPair(eddsa, {
        pub: pub
    });
};
$61a6b670288f11c9$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $61a6b670288f11c9$var$KeyPair) return secret;
    return new $61a6b670288f11c9$var$KeyPair(eddsa, {
        secret: secret
    });
};
$61a6b670288f11c9$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$61a6b670288f11c9$var$cachedProperty($61a6b670288f11c9$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$61a6b670288f11c9$var$cachedProperty($61a6b670288f11c9$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$61a6b670288f11c9$var$cachedProperty($61a6b670288f11c9$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$61a6b670288f11c9$var$cachedProperty($61a6b670288f11c9$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$61a6b670288f11c9$var$cachedProperty($61a6b670288f11c9$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$61a6b670288f11c9$var$cachedProperty($61a6b670288f11c9$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$61a6b670288f11c9$var$KeyPair.prototype.sign = function sign(message) {
    $61a6b670288f11c9$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$61a6b670288f11c9$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$61a6b670288f11c9$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $61a6b670288f11c9$var$assert(this._secret, "KeyPair is public only");
    return $fbJKm.encode(this.secret(), enc);
};
$61a6b670288f11c9$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $fbJKm.encode(this.pubBytes(), enc);
};
module.exports = $61a6b670288f11c9$var$KeyPair;

});

parcelRegister("7YTXE", function(module, exports) {
"use strict";

var $4EH0Y = parcelRequire("4EH0Y");

var $fbJKm = parcelRequire("fbJKm");
var $5cf98bb5990429a3$var$assert = $fbJKm.assert;
var $5cf98bb5990429a3$var$cachedProperty = $fbJKm.cachedProperty;
var $5cf98bb5990429a3$var$parseBytes = $fbJKm.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5cf98bb5990429a3$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5cf98bb5990429a3$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $5cf98bb5990429a3$var$assert(sig.length === eddsa.encodingLength * 2, "Signature has invalid size");
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $5cf98bb5990429a3$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $4EH0Y) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5cf98bb5990429a3$var$cachedProperty($5cf98bb5990429a3$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5cf98bb5990429a3$var$cachedProperty($5cf98bb5990429a3$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5cf98bb5990429a3$var$cachedProperty($5cf98bb5990429a3$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5cf98bb5990429a3$var$cachedProperty($5cf98bb5990429a3$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5cf98bb5990429a3$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5cf98bb5990429a3$var$Signature.prototype.toHex = function toHex() {
    return $fbJKm.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5cf98bb5990429a3$var$Signature;

});



parcelRegister("fjT6R", function(module, exports) {
$parcel$export(module.exports, "generateKeyPair", function () { return (parcelRequire("hSpoa")).generateKeyPair; });
$parcel$export(module.exports, "signJWT", function () { return (parcelRequire("hSpoa")).signJWT; });
$parcel$export(module.exports, "decodeJWT", function () { return (parcelRequire("i4OlP")).decodeJWT; });
$parcel$export(module.exports, "encodeIss", function () { return (parcelRequire("i4OlP")).encodeIss; });
parcelRequire("hSpoa");
parcelRequire("6MGrD");

var $60BI8 = parcelRequire("60BI8");
parcelRequire("i4OlP");
$parcel$exportWildcard(module.exports, $60BI8);

});
parcelRegister("hSpoa", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", function () { return $d03b2c7dd1191e0b$export$a949d36eab55b41f; });
$parcel$export(module.exports, "signJWT", function () { return $d03b2c7dd1191e0b$export$a8dda30659d36d45; });

var $cFVAw = parcelRequire("cFVAw");

var $aftW8 = parcelRequire("aftW8");

var $iNdL8 = parcelRequire("iNdL8");

var $6MGrD = parcelRequire("6MGrD");

var $i4OlP = parcelRequire("i4OlP");
function $d03b2c7dd1191e0b$export$a949d36eab55b41f(seed = (0, $aftW8.randomBytes)((0, $6MGrD.KEY_PAIR_SEED_LENGTH))) {
    return $cFVAw.generateKeyPairFromSeed(seed);
}
async function $d03b2c7dd1191e0b$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $iNdL8.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $6MGrD.JWT_IRIDIUM_ALG),
        typ: (0, $6MGrD.JWT_IRIDIUM_TYP)
    };
    const iss = (0, $i4OlP.encodeIss)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $i4OlP.encodeData)({
        header: header,
        payload: payload
    });
    const signature = $cFVAw.sign(keyPair.secretKey, data);
    return (0, $i4OlP.encodeJWT)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $d03b2c7dd1191e0b$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $i4OlP.decodeJWT)(jwt);
    if (header.alg !== (0, $6MGrD.JWT_IRIDIUM_ALG) || header.typ !== (0, $6MGrD.JWT_IRIDIUM_TYP)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $i4OlP.decodeIss)(payload.iss);
    return $cFVAw.verify(publicKey, data, signature);
}

});
parcelRegister("cFVAw", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertSecretKeyToX25519 = module.exports.convertPublicKeyToX25519 = module.exports.verify = module.exports.sign = module.exports.extractPublicKeyFromSecretKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.SEED_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = module.exports.SIGNATURE_LENGTH = void 0;

var $aftW8 = parcelRequire("aftW8");

var $9weib = parcelRequire("9weib");

var $iOcd0 = parcelRequire("iOcd0");
module.exports.SIGNATURE_LENGTH = 64;
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 64;
module.exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $93a5fc248d09c321$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $93a5fc248d09c321$var$_9 = new Uint8Array(32);
$93a5fc248d09c321$var$_9[0] = 9;
const $93a5fc248d09c321$var$gf0 = $93a5fc248d09c321$var$gf();
const $93a5fc248d09c321$var$gf1 = $93a5fc248d09c321$var$gf([
    1
]);
const $93a5fc248d09c321$var$D = $93a5fc248d09c321$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $93a5fc248d09c321$var$D2 = $93a5fc248d09c321$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $93a5fc248d09c321$var$X = $93a5fc248d09c321$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $93a5fc248d09c321$var$Y = $93a5fc248d09c321$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $93a5fc248d09c321$var$I = $93a5fc248d09c321$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $93a5fc248d09c321$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $93a5fc248d09c321$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $93a5fc248d09c321$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $93a5fc248d09c321$var$pack25519(o, n) {
    const m = $93a5fc248d09c321$var$gf();
    const t = $93a5fc248d09c321$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $93a5fc248d09c321$var$car25519(t);
    $93a5fc248d09c321$var$car25519(t);
    $93a5fc248d09c321$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $93a5fc248d09c321$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $93a5fc248d09c321$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $93a5fc248d09c321$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $93a5fc248d09c321$var$pack25519(c, a);
    $93a5fc248d09c321$var$pack25519(d, b);
    return $93a5fc248d09c321$var$verify32(c, d);
}
function $93a5fc248d09c321$var$par25519(a) {
    const d = new Uint8Array(32);
    $93a5fc248d09c321$var$pack25519(d, a);
    return d[0] & 1;
}
function $93a5fc248d09c321$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $93a5fc248d09c321$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $93a5fc248d09c321$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $93a5fc248d09c321$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $93a5fc248d09c321$var$square(o, a) {
    $93a5fc248d09c321$var$mul(o, a, a);
}
function $93a5fc248d09c321$var$inv25519(o, i) {
    const c = $93a5fc248d09c321$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $93a5fc248d09c321$var$square(c, c);
        if (a !== 2 && a !== 4) $93a5fc248d09c321$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $93a5fc248d09c321$var$pow2523(o, i) {
    const c = $93a5fc248d09c321$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $93a5fc248d09c321$var$square(c, c);
        if (a !== 1) $93a5fc248d09c321$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $93a5fc248d09c321$var$edadd(p, q) {
    const a = $93a5fc248d09c321$var$gf(), b = $93a5fc248d09c321$var$gf(), c = $93a5fc248d09c321$var$gf(), d = $93a5fc248d09c321$var$gf(), e = $93a5fc248d09c321$var$gf(), f = $93a5fc248d09c321$var$gf(), g = $93a5fc248d09c321$var$gf(), h = $93a5fc248d09c321$var$gf(), t = $93a5fc248d09c321$var$gf();
    $93a5fc248d09c321$var$sub(a, p[1], p[0]);
    $93a5fc248d09c321$var$sub(t, q[1], q[0]);
    $93a5fc248d09c321$var$mul(a, a, t);
    $93a5fc248d09c321$var$add(b, p[0], p[1]);
    $93a5fc248d09c321$var$add(t, q[0], q[1]);
    $93a5fc248d09c321$var$mul(b, b, t);
    $93a5fc248d09c321$var$mul(c, p[3], q[3]);
    $93a5fc248d09c321$var$mul(c, c, $93a5fc248d09c321$var$D2);
    $93a5fc248d09c321$var$mul(d, p[2], q[2]);
    $93a5fc248d09c321$var$add(d, d, d);
    $93a5fc248d09c321$var$sub(e, b, a);
    $93a5fc248d09c321$var$sub(f, d, c);
    $93a5fc248d09c321$var$add(g, d, c);
    $93a5fc248d09c321$var$add(h, b, a);
    $93a5fc248d09c321$var$mul(p[0], e, f);
    $93a5fc248d09c321$var$mul(p[1], h, g);
    $93a5fc248d09c321$var$mul(p[2], g, f);
    $93a5fc248d09c321$var$mul(p[3], e, h);
}
function $93a5fc248d09c321$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$93a5fc248d09c321$var$sel25519(p[i], q[i], b);
}
function $93a5fc248d09c321$var$pack(r, p) {
    const tx = $93a5fc248d09c321$var$gf(), ty = $93a5fc248d09c321$var$gf(), zi = $93a5fc248d09c321$var$gf();
    $93a5fc248d09c321$var$inv25519(zi, p[2]);
    $93a5fc248d09c321$var$mul(tx, p[0], zi);
    $93a5fc248d09c321$var$mul(ty, p[1], zi);
    $93a5fc248d09c321$var$pack25519(r, ty);
    r[31] ^= $93a5fc248d09c321$var$par25519(tx) << 7;
}
function $93a5fc248d09c321$var$scalarmult(p, q, s) {
    $93a5fc248d09c321$var$set25519(p[0], $93a5fc248d09c321$var$gf0);
    $93a5fc248d09c321$var$set25519(p[1], $93a5fc248d09c321$var$gf1);
    $93a5fc248d09c321$var$set25519(p[2], $93a5fc248d09c321$var$gf1);
    $93a5fc248d09c321$var$set25519(p[3], $93a5fc248d09c321$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $93a5fc248d09c321$var$cswap(p, q, b);
        $93a5fc248d09c321$var$edadd(q, p);
        $93a5fc248d09c321$var$edadd(p, p);
        $93a5fc248d09c321$var$cswap(p, q, b);
    }
}
function $93a5fc248d09c321$var$scalarbase(p, s) {
    const q = [
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf()
    ];
    $93a5fc248d09c321$var$set25519(q[0], $93a5fc248d09c321$var$X);
    $93a5fc248d09c321$var$set25519(q[1], $93a5fc248d09c321$var$Y);
    $93a5fc248d09c321$var$set25519(q[2], $93a5fc248d09c321$var$gf1);
    $93a5fc248d09c321$var$mul(q[3], $93a5fc248d09c321$var$X, $93a5fc248d09c321$var$Y);
    $93a5fc248d09c321$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $93a5fc248d09c321$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${module.exports.SEED_LENGTH} bytes`);
    const d = (0, $9weib.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf()
    ];
    $93a5fc248d09c321$var$scalarbase(p, d);
    $93a5fc248d09c321$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $93a5fc248d09c321$var$generateKeyPairFromSeed;
function $93a5fc248d09c321$var$generateKeyPair(prng) {
    const seed = (0, $aftW8.randomBytes)(32, prng);
    const result = $93a5fc248d09c321$var$generateKeyPairFromSeed(seed);
    (0, $iOcd0.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $93a5fc248d09c321$var$generateKeyPair;
function $93a5fc248d09c321$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== module.exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${module.exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
module.exports.extractPublicKeyFromSecretKey = $93a5fc248d09c321$var$extractPublicKeyFromSecretKey;
const $93a5fc248d09c321$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $93a5fc248d09c321$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $93a5fc248d09c321$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $93a5fc248d09c321$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $93a5fc248d09c321$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $93a5fc248d09c321$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $93a5fc248d09c321$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $93a5fc248d09c321$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf()
    ];
    const d = (0, $9weib.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $9weib.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $93a5fc248d09c321$var$reduce(r);
    $93a5fc248d09c321$var$scalarbase(p, r);
    $93a5fc248d09c321$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $93a5fc248d09c321$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $93a5fc248d09c321$var$modL(signature.subarray(32), x);
    return signature;
}
module.exports.sign = $93a5fc248d09c321$var$sign;
function $93a5fc248d09c321$var$unpackneg(r, p) {
    const t = $93a5fc248d09c321$var$gf(), chk = $93a5fc248d09c321$var$gf(), num = $93a5fc248d09c321$var$gf(), den = $93a5fc248d09c321$var$gf(), den2 = $93a5fc248d09c321$var$gf(), den4 = $93a5fc248d09c321$var$gf(), den6 = $93a5fc248d09c321$var$gf();
    $93a5fc248d09c321$var$set25519(r[2], $93a5fc248d09c321$var$gf1);
    $93a5fc248d09c321$var$unpack25519(r[1], p);
    $93a5fc248d09c321$var$square(num, r[1]);
    $93a5fc248d09c321$var$mul(den, num, $93a5fc248d09c321$var$D);
    $93a5fc248d09c321$var$sub(num, num, r[2]);
    $93a5fc248d09c321$var$add(den, r[2], den);
    $93a5fc248d09c321$var$square(den2, den);
    $93a5fc248d09c321$var$square(den4, den2);
    $93a5fc248d09c321$var$mul(den6, den4, den2);
    $93a5fc248d09c321$var$mul(t, den6, num);
    $93a5fc248d09c321$var$mul(t, t, den);
    $93a5fc248d09c321$var$pow2523(t, t);
    $93a5fc248d09c321$var$mul(t, t, num);
    $93a5fc248d09c321$var$mul(t, t, den);
    $93a5fc248d09c321$var$mul(t, t, den);
    $93a5fc248d09c321$var$mul(r[0], t, den);
    $93a5fc248d09c321$var$square(chk, r[0]);
    $93a5fc248d09c321$var$mul(chk, chk, den);
    if ($93a5fc248d09c321$var$neq25519(chk, num)) $93a5fc248d09c321$var$mul(r[0], r[0], $93a5fc248d09c321$var$I);
    $93a5fc248d09c321$var$square(chk, r[0]);
    $93a5fc248d09c321$var$mul(chk, chk, den);
    if ($93a5fc248d09c321$var$neq25519(chk, num)) return -1;
    if ($93a5fc248d09c321$var$par25519(r[0]) === p[31] >> 7) $93a5fc248d09c321$var$sub(r[0], $93a5fc248d09c321$var$gf0, r[0]);
    $93a5fc248d09c321$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $93a5fc248d09c321$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf()
    ];
    const q = [
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf()
    ];
    if (signature.length !== module.exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${module.exports.SIGNATURE_LENGTH} bytes`);
    if ($93a5fc248d09c321$var$unpackneg(q, publicKey)) return false;
    const hs = new $9weib.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $93a5fc248d09c321$var$reduce(h);
    $93a5fc248d09c321$var$scalarmult(p, q, h);
    $93a5fc248d09c321$var$scalarbase(q, signature.subarray(32));
    $93a5fc248d09c321$var$edadd(p, q);
    $93a5fc248d09c321$var$pack(t, p);
    if ($93a5fc248d09c321$var$verify32(signature, t)) return false;
    return true;
}
module.exports.verify = $93a5fc248d09c321$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $93a5fc248d09c321$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf(),
        $93a5fc248d09c321$var$gf()
    ];
    if ($93a5fc248d09c321$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $93a5fc248d09c321$var$gf();
    let b = $93a5fc248d09c321$var$gf();
    let y = q[1];
    $93a5fc248d09c321$var$add(a, $93a5fc248d09c321$var$gf1, y);
    $93a5fc248d09c321$var$sub(b, $93a5fc248d09c321$var$gf1, y);
    $93a5fc248d09c321$var$inv25519(b, b);
    $93a5fc248d09c321$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $93a5fc248d09c321$var$pack25519(z, a);
    return z;
}
module.exports.convertPublicKeyToX25519 = $93a5fc248d09c321$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $93a5fc248d09c321$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $9weib.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $iOcd0.wipe)(d);
    return o;
}
module.exports.convertSecretKeyToX25519 = $93a5fc248d09c321$var$convertSecretKeyToX25519;

});
parcelRegister("9weib", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lURlJ = parcelRequire("lURlJ");

var $iOcd0 = parcelRequire("iOcd0");
module.exports.DIGEST_LENGTH = 64;
module.exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $6ee230630be61078$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $iOcd0.wipe(this._buffer);
        $iOcd0.wipe(this._tempHi);
        $iOcd0.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < module.exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $6ee230630be61078$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $6ee230630be61078$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $lURlJ.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $lURlJ.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $6ee230630be61078$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $lURlJ.writeUint32BE(this._stateHi[i], out, i * 8);
            $lURlJ.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $iOcd0.wipe(savedState.stateHi);
        $iOcd0.wipe(savedState.stateLo);
        if (savedState.buffer) $iOcd0.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
module.exports.SHA512 = $6ee230630be61078$var$SHA512;
// Constants
var $6ee230630be61078$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $6ee230630be61078$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $lURlJ.readUint32BE(m, j);
            wl[i] = $lURlJ.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $6ee230630be61078$var$K[i * 2];
            l = $6ee230630be61078$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $6ee230630be61078$var$hash(data) {
    var h = new $6ee230630be61078$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $6ee230630be61078$var$hash;

});


parcelRegister("6MGrD", function(module, exports) {

$parcel$export(module.exports, "JWT_IRIDIUM_ALG", function () { return $4f08266a7ccd1331$export$51745f7832485c34; });
$parcel$export(module.exports, "JWT_IRIDIUM_TYP", function () { return $4f08266a7ccd1331$export$f51b45e220f2ba98; });
$parcel$export(module.exports, "JWT_DELIMITER", function () { return $4f08266a7ccd1331$export$a3e35a0f952eb3ef; });
$parcel$export(module.exports, "JWT_ENCODING", function () { return $4f08266a7ccd1331$export$d2e6fe38c55f8e23; });
$parcel$export(module.exports, "JSON_ENCODING", function () { return $4f08266a7ccd1331$export$c09c2801e10a2b95; });
$parcel$export(module.exports, "DATA_ENCODING", function () { return $4f08266a7ccd1331$export$1e9219c0b91a4257; });
$parcel$export(module.exports, "DID_DELIMITER", function () { return $4f08266a7ccd1331$export$d4057275de9d060b; });
$parcel$export(module.exports, "DID_PREFIX", function () { return $4f08266a7ccd1331$export$acf13c61a1a0ccf3; });
$parcel$export(module.exports, "DID_METHOD", function () { return $4f08266a7ccd1331$export$b908fe81ccf30934; });
$parcel$export(module.exports, "MULTICODEC_ED25519_ENCODING", function () { return $4f08266a7ccd1331$export$7bd18b7a7a4d0471; });
$parcel$export(module.exports, "MULTICODEC_ED25519_BASE", function () { return $4f08266a7ccd1331$export$6d6d3d2e39be8d68; });
$parcel$export(module.exports, "MULTICODEC_ED25519_HEADER", function () { return $4f08266a7ccd1331$export$9902a33a5776d1fc; });
$parcel$export(module.exports, "MULTICODEC_ED25519_LENGTH", function () { return $4f08266a7ccd1331$export$ca477e91394a742a; });
$parcel$export(module.exports, "KEY_PAIR_SEED_LENGTH", function () { return $4f08266a7ccd1331$export$f09ad228919f26fb; });
const $4f08266a7ccd1331$export$51745f7832485c34 = "EdDSA";
const $4f08266a7ccd1331$export$f51b45e220f2ba98 = "JWT";
const $4f08266a7ccd1331$export$a3e35a0f952eb3ef = ".";
const $4f08266a7ccd1331$export$d2e6fe38c55f8e23 = "base64url";
const $4f08266a7ccd1331$export$c09c2801e10a2b95 = "utf8";
const $4f08266a7ccd1331$export$1e9219c0b91a4257 = "utf8";
const $4f08266a7ccd1331$export$d4057275de9d060b = ":";
const $4f08266a7ccd1331$export$acf13c61a1a0ccf3 = "did";
const $4f08266a7ccd1331$export$b908fe81ccf30934 = "key";
const $4f08266a7ccd1331$export$7bd18b7a7a4d0471 = "base58btc";
const $4f08266a7ccd1331$export$6d6d3d2e39be8d68 = "z";
const $4f08266a7ccd1331$export$9902a33a5776d1fc = "K36";
const $4f08266a7ccd1331$export$ca477e91394a742a = 32;
const $4f08266a7ccd1331$export$f09ad228919f26fb = 32;

});

parcelRegister("i4OlP", function(module, exports) {

$parcel$export(module.exports, "encodeIss", function () { return $d28fa868e263188a$export$1b29ef9371459e10; });
$parcel$export(module.exports, "decodeIss", function () { return $d28fa868e263188a$export$86ac046d72244356; });
$parcel$export(module.exports, "encodeData", function () { return $d28fa868e263188a$export$cfdd1f2478131e3d; });
$parcel$export(module.exports, "encodeJWT", function () { return $d28fa868e263188a$export$1b70f4551c751d68; });
$parcel$export(module.exports, "decodeJWT", function () { return $d28fa868e263188a$export$9a62e6c0a30e00bc; });

var $7GAet = parcelRequire("7GAet");

var $5t5tf = parcelRequire("5t5tf");

var $50fYI = parcelRequire("50fYI");

var $6mXg5 = parcelRequire("6mXg5");

var $6MGrD = parcelRequire("6MGrD");
function $d28fa868e263188a$export$2030d1af6cd0ef93(str) {
    return (0, $6mXg5.safeJsonParse)((0, $5t5tf.toString)((0, $50fYI.fromString)(str, (0, $6MGrD.JWT_ENCODING)), (0, $6MGrD.JSON_ENCODING)));
}
function $d28fa868e263188a$export$84046f8082657cdf(val) {
    return (0, $5t5tf.toString)((0, $50fYI.fromString)((0, $6mXg5.safeJsonStringify)(val), (0, $6MGrD.JSON_ENCODING)), (0, $6MGrD.JWT_ENCODING));
}
function $d28fa868e263188a$export$1b29ef9371459e10(publicKey) {
    const header = (0, $50fYI.fromString)((0, $6MGrD.MULTICODEC_ED25519_HEADER), (0, $6MGrD.MULTICODEC_ED25519_ENCODING));
    const multicodec = (0, $6MGrD.MULTICODEC_ED25519_BASE) + (0, $5t5tf.toString)((0, $7GAet.concat)([
        header,
        publicKey
    ]), (0, $6MGrD.MULTICODEC_ED25519_ENCODING));
    return [
        (0, $6MGrD.DID_PREFIX),
        (0, $6MGrD.DID_METHOD),
        multicodec
    ].join((0, $6MGrD.DID_DELIMITER));
}
function $d28fa868e263188a$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $6MGrD.DID_DELIMITER));
    if (prefix !== (0, $6MGrD.DID_PREFIX) || method !== (0, $6MGrD.DID_METHOD)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $6MGrD.MULTICODEC_ED25519_BASE)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $50fYI.fromString)(multicodec.slice(1), (0, $6MGrD.MULTICODEC_ED25519_ENCODING));
    const type = (0, $5t5tf.toString)(bytes.slice(0, 2), (0, $6MGrD.MULTICODEC_ED25519_ENCODING));
    if (type !== (0, $6MGrD.MULTICODEC_ED25519_HEADER)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $6MGrD.MULTICODEC_ED25519_LENGTH)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $d28fa868e263188a$export$d9746ef301b2089b(bytes) {
    return (0, $5t5tf.toString)(bytes, (0, $6MGrD.JWT_ENCODING));
}
function $d28fa868e263188a$export$c37aeb372ac07c0e(encoded) {
    return (0, $50fYI.fromString)(encoded, (0, $6MGrD.JWT_ENCODING));
}
function $d28fa868e263188a$export$cfdd1f2478131e3d(params) {
    return (0, $50fYI.fromString)([
        $d28fa868e263188a$export$84046f8082657cdf(params.header),
        $d28fa868e263188a$export$84046f8082657cdf(params.payload)
    ].join((0, $6MGrD.JWT_DELIMITER)), (0, $6MGrD.DATA_ENCODING));
}
function $d28fa868e263188a$export$13923bea59211b58(data) {
    const params = (0, $5t5tf.toString)(data, (0, $6MGrD.DATA_ENCODING)).split((0, $6MGrD.JWT_DELIMITER));
    const header = $d28fa868e263188a$export$2030d1af6cd0ef93(params[0]);
    const payload = $d28fa868e263188a$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $d28fa868e263188a$export$1b70f4551c751d68(params) {
    return [
        $d28fa868e263188a$export$84046f8082657cdf(params.header),
        $d28fa868e263188a$export$84046f8082657cdf(params.payload),
        $d28fa868e263188a$export$d9746ef301b2089b(params.signature)
    ].join((0, $6MGrD.JWT_DELIMITER));
}
function $d28fa868e263188a$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $6MGrD.JWT_DELIMITER));
    const header = $d28fa868e263188a$export$2030d1af6cd0ef93(params[0]);
    const payload = $d28fa868e263188a$export$2030d1af6cd0ef93(params[1]);
    const signature = $d28fa868e263188a$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $50fYI.fromString)(params.slice(0, 2).join((0, $6MGrD.JWT_DELIMITER)), (0, $6MGrD.DATA_ENCODING));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}

});


parcelRegister("60BI8", function(module, exports) {

});


parcelRegister("7Dl6y", function(module, exports) {

$parcel$export(module.exports, "RELAY_JSONRPC", function () { return $58ec8be2a907d1e2$export$af490b3b9a6de00f; });
function $58ec8be2a907d1e2$var$e(s, r, i = "string") {
    if (!s[r] || typeof s[r] !== i) throw new Error(`Missing or invalid "${r}" param`);
}
function $58ec8be2a907d1e2$var$l(s, r) {
    let i = !0;
    return r.forEach((t)=>{
        t in s || (i = !1);
    }), i;
}
function $58ec8be2a907d1e2$var$f(s, r) {
    return Array.isArray(s) ? s.length === r : Object.keys(s).length === r;
}
function $58ec8be2a907d1e2$var$w(s, r) {
    return Array.isArray(s) ? s.length >= r : Object.keys(s).length >= r;
}
function $58ec8be2a907d1e2$var$u(s, r, i) {
    return (i.length ? $58ec8be2a907d1e2$var$w(s, r.length) : $58ec8be2a907d1e2$var$f(s, r.length)) ? $58ec8be2a907d1e2$var$l(s, r) : !1;
}
function $58ec8be2a907d1e2$var$n(s, r, i = "_") {
    const t = s.split(i);
    return t[t.length - 1].trim().toLowerCase() === r.trim().toLowerCase();
}
function $58ec8be2a907d1e2$export$c75580565fa025bd(s) {
    return $58ec8be2a907d1e2$export$f576347163de0984(s.method) && $58ec8be2a907d1e2$export$dae2311546d43680(s.params);
}
function $58ec8be2a907d1e2$export$f576347163de0984(s) {
    return $58ec8be2a907d1e2$var$n(s, "subscribe");
}
function $58ec8be2a907d1e2$export$dae2311546d43680(s) {
    return $58ec8be2a907d1e2$var$u(s, [
        "topic"
    ], []);
}
function $58ec8be2a907d1e2$export$8fa7cf76b41caee0(s) {
    return $58ec8be2a907d1e2$export$71d4d33ac7f7a269(s.method) && $58ec8be2a907d1e2$export$71e8d1aa48c3e86f(s.params);
}
function $58ec8be2a907d1e2$export$71d4d33ac7f7a269(s) {
    return $58ec8be2a907d1e2$var$n(s, "publish");
}
function $58ec8be2a907d1e2$export$71e8d1aa48c3e86f(s) {
    return $58ec8be2a907d1e2$var$u(s, [
        "message",
        "topic",
        "ttl"
    ], [
        "prompt",
        "tag"
    ]);
}
function $58ec8be2a907d1e2$export$83e292763180b41b(s) {
    return $58ec8be2a907d1e2$export$568d956f39536025(s.method) && $58ec8be2a907d1e2$export$cbc597c53c3b4f80(s.params);
}
function $58ec8be2a907d1e2$export$568d956f39536025(s) {
    return $58ec8be2a907d1e2$var$n(s, "unsubscribe");
}
function $58ec8be2a907d1e2$export$cbc597c53c3b4f80(s) {
    return $58ec8be2a907d1e2$var$u(s, [
        "id",
        "topic"
    ], []);
}
function $58ec8be2a907d1e2$export$43cf4100d6287b8e(s) {
    return $58ec8be2a907d1e2$export$3cb4ad320e3a46a4(s.method) && $58ec8be2a907d1e2$export$6366ff9a39f2da4c(s.params);
}
function $58ec8be2a907d1e2$export$3cb4ad320e3a46a4(s) {
    return $58ec8be2a907d1e2$var$n(s, "subscription");
}
function $58ec8be2a907d1e2$export$6366ff9a39f2da4c(s) {
    return $58ec8be2a907d1e2$var$u(s, [
        "id",
        "data"
    ], []);
}
function $58ec8be2a907d1e2$export$abdf96c288cb375(s) {
    if (!$58ec8be2a907d1e2$export$f576347163de0984(s.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!$58ec8be2a907d1e2$export$dae2311546d43680(s.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const r = s.params;
    return $58ec8be2a907d1e2$var$e(r, "topic"), r;
}
function $58ec8be2a907d1e2$export$eac3e45ac5c5c9fa(s) {
    if (!$58ec8be2a907d1e2$export$71d4d33ac7f7a269(s.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!$58ec8be2a907d1e2$export$71e8d1aa48c3e86f(s.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const r = s.params;
    return $58ec8be2a907d1e2$var$e(r, "topic"), $58ec8be2a907d1e2$var$e(r, "message"), $58ec8be2a907d1e2$var$e(r, "ttl", "number"), r;
}
function $58ec8be2a907d1e2$export$78baa72f78156594(s) {
    if (!$58ec8be2a907d1e2$export$568d956f39536025(s.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!$58ec8be2a907d1e2$export$cbc597c53c3b4f80(s.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const r = s.params;
    return $58ec8be2a907d1e2$var$e(r, "id"), r;
}
function $58ec8be2a907d1e2$export$4d5822edd41f3b48(s) {
    if (!$58ec8be2a907d1e2$export$3cb4ad320e3a46a4(s.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!$58ec8be2a907d1e2$export$6366ff9a39f2da4c(s.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const r = s.params;
    return $58ec8be2a907d1e2$var$e(r, "id"), $58ec8be2a907d1e2$var$e(r, "data"), r;
}
const $58ec8be2a907d1e2$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe",
        batchFetchMessages: "waku_batchFetchMessages"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe",
        batchFetchMessages: "irn_batchFetchMessages"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe",
        batchFetchMessages: "iridium_batchFetchMessages"
    }
};

});


parcelRegister("9nUAO", function(module, exports) {

$parcel$export(module.exports, "UniversalProvider", function () { return $6d522931de1c17ec$export$63bc40680ab52599; });

var $9USum = parcelRequire("9USum");

var $iN1TF = parcelRequire("iN1TF");

var $GVAyr = parcelRequire("GVAyr");
var $6rVbn = parcelRequire("6rVbn");

var $3KLgK = parcelRequire("3KLgK");

var $kUdYz = parcelRequire("kUdYz");

var $jMGWz = parcelRequire("jMGWz");
parcelRequire("6bXmq");
var $eS6BO = parcelRequire("eS6BO");
const $6d522931de1c17ec$var$ya = "error", $6d522931de1c17ec$var$Kg = "wss://relay.walletconnect.com", $6d522931de1c17ec$var$Jg = "wc", $6d522931de1c17ec$var$Yg = "universal_provider", $6d522931de1c17ec$var$Sa = `${$6d522931de1c17ec$var$Jg}@2:${$6d522931de1c17ec$var$Yg}:`, $6d522931de1c17ec$var$Zg = "https://rpc.walletconnect.com/v1/", $6d522931de1c17ec$var$Kn = "generic", $6d522931de1c17ec$var$Tt = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed"
};
var $6d522931de1c17ec$var$_e = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $6d522931de1c17ec$var$Ui = {
    exports: {}
}; /**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
(function(P, s) {
    (function() {
        var i, p = "4.17.21", w = 200, x = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", O = "Expected a function", k = "Invalid `variable` option passed into `_.template`", tn = "__lodash_hash_undefined__", Jn = 500, xn = "__lodash_placeholder__", Ht = 1, Mt = 2, En = 4, yn = 1, me = 2, vt = 1, ln = 2, Gi = 4, Dt = 8, Sn = 16, Nt = 32, On = 64, Bt = 128, Yn = 256, gr = 512, Wa = 30, Ma = "...", Ba = 800, Ga = 16, zi = 1, za = 2, Ka = 3, pn = 1 / 0, nn = 9007199254740991, Ja = 17976931348623157e292, we = 0 / 0, $t = 4294967295, Ya = $t - 1, Za = $t >>> 1, Xa = [
            [
                "ary",
                Bt
            ],
            [
                "bind",
                vt
            ],
            [
                "bindKey",
                ln
            ],
            [
                "curry",
                Dt
            ],
            [
                "curryRight",
                Sn
            ],
            [
                "flip",
                gr
            ],
            [
                "partial",
                Nt
            ],
            [
                "partialRight",
                On
            ],
            [
                "rearg",
                Yn
            ]
        ], Rn = "[object Arguments]", Pe = "[object Array]", Qa = "[object AsyncFunction]", Zn = "[object Boolean]", Xn = "[object Date]", Va = "[object DOMException]", Ce = "[object Error]", Ae = "[object Function]", Ki = "[object GeneratorFunction]", Et = "[object Map]", Qn = "[object Number]", ka = "[object Null]", Gt = "[object Object]", Ji = "[object Promise]", ja = "[object Proxy]", Vn = "[object RegExp]", yt = "[object Set]", kn = "[object String]", Ie = "[object Symbol]", to = "[object Undefined]", jn = "[object WeakMap]", no = "[object WeakSet]", te = "[object ArrayBuffer]", bn = "[object DataView]", vr = "[object Float32Array]", _r = "[object Float64Array]", mr = "[object Int8Array]", wr = "[object Int16Array]", Pr = "[object Int32Array]", Cr = "[object Uint8Array]", Ar = "[object Uint8ClampedArray]", Ir = "[object Uint16Array]", xr = "[object Uint32Array]", eo = /\b__p \+= '';/g, ro = /\b(__p \+=) '' \+/g, io = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Yi = /&(?:amp|lt|gt|quot|#39);/g, Zi = /[&<>"']/g, so = RegExp(Yi.source), uo = RegExp(Zi.source), ao = /<%-([\s\S]+?)%>/g, oo = /<%([\s\S]+?)%>/g, Xi = /<%=([\s\S]+?)%>/g, fo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, co = /^\w*$/, ho = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Er = /[\\^$.*+?()[\]{}|]/g, lo = RegExp(Er.source), yr = /^\s+/, po = /\s/, go = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, vo = /\{\n\/\* \[wrapped with (.+)\] \*/, _o = /,? & /, mo = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, wo = /[()=,{}\[\]\/\s]/, Po = /\\(\\)?/g, Co = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Qi = /\w*$/, Ao = /^[-+]0x[0-9a-f]+$/i, Io = /^0b[01]+$/i, xo = /^\[object .+?Constructor\]$/, Eo = /^0o[0-7]+$/i, yo = /^(?:0|[1-9]\d*)$/, So = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, xe = /($^)/, Oo = /['\n\r\u2028\u2029\\]/g, Ee = "\ud800-\udfff", Ro = "\\u0300-\\u036f", bo = "\\ufe20-\\ufe2f", To = "\\u20d0-\\u20ff", Vi = Ro + bo + To, ki = "\\u2700-\\u27bf", ji = "a-z\\xdf-\\xf6\\xf8-\\xff", Lo = "\\xac\\xb1\\xd7\\xf7", Ho = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Do = "\\u2000-\\u206f", No = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ts = "A-Z\\xc0-\\xd6\\xd8-\\xde", ns = "\\ufe0e\\ufe0f", es = Lo + Ho + Do + No, Sr = "['\u2019]", $o = "[" + Ee + "]", rs = "[" + es + "]", ye = "[" + Vi + "]", is = "\\d+", qo = "[" + ki + "]", ss = "[" + ji + "]", us = "[^" + Ee + es + is + ki + ji + ts + "]", Or = "\ud83c[\udffb-\udfff]", Uo = "(?:" + ye + "|" + Or + ")", as = "[^" + Ee + "]", Rr = "(?:\ud83c[\udde6-\uddff]){2}", br = "[\ud800-\udbff][\udc00-\udfff]", Tn = "[" + ts + "]", os = "\\u200d", fs = "(?:" + ss + "|" + us + ")", Fo = "(?:" + Tn + "|" + us + ")", cs = "(?:" + Sr + "(?:d|ll|m|re|s|t|ve))?", hs = "(?:" + Sr + "(?:D|LL|M|RE|S|T|VE))?", ls = Uo + "?", ps = "[" + ns + "]?", Wo = "(?:" + os + "(?:" + [
            as,
            Rr,
            br
        ].join("|") + ")" + ps + ls + ")*", Mo = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Bo = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ds = ps + ls + Wo, Go = "(?:" + [
            qo,
            Rr,
            br
        ].join("|") + ")" + ds, zo = "(?:" + [
            as + ye + "?",
            ye,
            Rr,
            br,
            $o
        ].join("|") + ")", Ko = RegExp(Sr, "g"), Jo = RegExp(ye, "g"), Tr = RegExp(Or + "(?=" + Or + ")|" + zo + ds, "g"), Yo = RegExp([
            Tn + "?" + ss + "+" + cs + "(?=" + [
                rs,
                Tn,
                "$"
            ].join("|") + ")",
            Fo + "+" + hs + "(?=" + [
                rs,
                Tn + fs,
                "$"
            ].join("|") + ")",
            Tn + "?" + fs + "+" + cs,
            Tn + "+" + hs,
            Bo,
            Mo,
            is,
            Go
        ].join("|"), "g"), Zo = RegExp("[" + os + Ee + Vi + ns + "]"), Xo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Qo = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], Vo = -1, G = {};
        G[vr] = G[_r] = G[mr] = G[wr] = G[Pr] = G[Cr] = G[Ar] = G[Ir] = G[xr] = !0, G[Rn] = G[Pe] = G[te] = G[Zn] = G[bn] = G[Xn] = G[Ce] = G[Ae] = G[Et] = G[Qn] = G[Gt] = G[Vn] = G[yt] = G[kn] = G[jn] = !1;
        var B = {};
        B[Rn] = B[Pe] = B[te] = B[bn] = B[Zn] = B[Xn] = B[vr] = B[_r] = B[mr] = B[wr] = B[Pr] = B[Et] = B[Qn] = B[Gt] = B[Vn] = B[yt] = B[kn] = B[Ie] = B[Cr] = B[Ar] = B[Ir] = B[xr] = !0, B[Ce] = B[Ae] = B[jn] = !1;
        var ko = {
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "A",
            "\xc5": "A",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "a",
            "\xe5": "a",
            "\xc7": "C",
            "\xe7": "c",
            "\xd0": "D",
            "\xf0": "d",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xd1": "N",
            "\xf1": "n",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "O",
            "\xd8": "O",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "o",
            "\xf8": "o",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "U",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "u",
            "\xdd": "Y",
            "\xfd": "y",
            "\xff": "y",
            "\xc6": "Ae",
            "\xe6": "ae",
            "\xde": "Th",
            "\xfe": "th",
            "\xdf": "ss",
            \u0100: "A",
            \u0102: "A",
            \u0104: "A",
            \u0101: "a",
            \u0103: "a",
            \u0105: "a",
            \u0106: "C",
            \u0108: "C",
            \u010A: "C",
            \u010C: "C",
            \u0107: "c",
            \u0109: "c",
            \u010B: "c",
            \u010D: "c",
            \u010E: "D",
            \u0110: "D",
            \u010F: "d",
            \u0111: "d",
            \u0112: "E",
            \u0114: "E",
            \u0116: "E",
            \u0118: "E",
            \u011A: "E",
            \u0113: "e",
            \u0115: "e",
            \u0117: "e",
            \u0119: "e",
            \u011B: "e",
            \u011C: "G",
            \u011E: "G",
            \u0120: "G",
            \u0122: "G",
            \u011D: "g",
            \u011F: "g",
            \u0121: "g",
            \u0123: "g",
            \u0124: "H",
            \u0126: "H",
            \u0125: "h",
            \u0127: "h",
            \u0128: "I",
            \u012A: "I",
            \u012C: "I",
            \u012E: "I",
            \u0130: "I",
            \u0129: "i",
            \u012B: "i",
            \u012D: "i",
            \u012F: "i",
            \u0131: "i",
            \u0134: "J",
            \u0135: "j",
            \u0136: "K",
            \u0137: "k",
            \u0138: "k",
            \u0139: "L",
            \u013B: "L",
            \u013D: "L",
            \u013F: "L",
            \u0141: "L",
            \u013A: "l",
            \u013C: "l",
            \u013E: "l",
            \u0140: "l",
            \u0142: "l",
            \u0143: "N",
            \u0145: "N",
            \u0147: "N",
            \u014A: "N",
            \u0144: "n",
            \u0146: "n",
            \u0148: "n",
            \u014B: "n",
            \u014C: "O",
            \u014E: "O",
            \u0150: "O",
            \u014D: "o",
            \u014F: "o",
            \u0151: "o",
            \u0154: "R",
            \u0156: "R",
            \u0158: "R",
            \u0155: "r",
            \u0157: "r",
            \u0159: "r",
            \u015A: "S",
            \u015C: "S",
            \u015E: "S",
            \u0160: "S",
            \u015B: "s",
            \u015D: "s",
            \u015F: "s",
            \u0161: "s",
            \u0162: "T",
            \u0164: "T",
            \u0166: "T",
            \u0163: "t",
            \u0165: "t",
            \u0167: "t",
            \u0168: "U",
            \u016A: "U",
            \u016C: "U",
            \u016E: "U",
            \u0170: "U",
            \u0172: "U",
            \u0169: "u",
            \u016B: "u",
            \u016D: "u",
            \u016F: "u",
            \u0171: "u",
            \u0173: "u",
            \u0174: "W",
            \u0175: "w",
            \u0176: "Y",
            \u0177: "y",
            \u0178: "Y",
            \u0179: "Z",
            \u017B: "Z",
            \u017D: "Z",
            \u017A: "z",
            \u017C: "z",
            \u017E: "z",
            \u0132: "IJ",
            \u0133: "ij",
            \u0152: "Oe",
            \u0153: "oe",
            \u0149: "'n",
            \u017F: "s"
        }, jo = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, tf = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }, nf = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, ef = parseFloat, rf = parseInt, gs = typeof $6d522931de1c17ec$var$_e == "object" && $6d522931de1c17ec$var$_e && $6d522931de1c17ec$var$_e.Object === Object && $6d522931de1c17ec$var$_e, sf = typeof self == "object" && self && self.Object === Object && self, j = gs || sf || Function("return this")(), Lr = s && !s.nodeType && s, dn = Lr && !0 && P && !P.nodeType && P, vs = dn && dn.exports === Lr, Hr = vs && gs.process, _t = function() {
            try {
                var h = dn && dn.require && dn.require("util").types;
                return h || Hr && Hr.binding && Hr.binding("util");
            } catch  {}
        }(), _s = _t && _t.isArrayBuffer, ms = _t && _t.isDate, ws = _t && _t.isMap, Ps = _t && _t.isRegExp, Cs = _t && _t.isSet, As = _t && _t.isTypedArray;
        function ct(h, g, d) {
            switch(d.length){
                case 0:
                    return h.call(g);
                case 1:
                    return h.call(g, d[0]);
                case 2:
                    return h.call(g, d[0], d[1]);
                case 3:
                    return h.call(g, d[0], d[1], d[2]);
            }
            return h.apply(g, d);
        }
        function uf(h, g, d, A) {
            for(var R = -1, q = h == null ? 0 : h.length; ++R < q;){
                var X = h[R];
                g(A, X, d(X), h);
            }
            return A;
        }
        function mt(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length; ++d < A && g(h[d], d, h) !== !1;);
            return h;
        }
        function af(h, g) {
            for(var d = h == null ? 0 : h.length; d-- && g(h[d], d, h) !== !1;);
            return h;
        }
        function Is(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length; ++d < A;)if (!g(h[d], d, h)) return !1;
            return !0;
        }
        function en(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length, R = 0, q = []; ++d < A;){
                var X = h[d];
                g(X, d, h) && (q[R++] = X);
            }
            return q;
        }
        function Se(h, g) {
            var d = h == null ? 0 : h.length;
            return !!d && Ln(h, g, 0) > -1;
        }
        function Dr(h, g, d) {
            for(var A = -1, R = h == null ? 0 : h.length; ++A < R;)if (d(g, h[A])) return !0;
            return !1;
        }
        function z(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length, R = Array(A); ++d < A;)R[d] = g(h[d], d, h);
            return R;
        }
        function rn(h, g) {
            for(var d = -1, A = g.length, R = h.length; ++d < A;)h[R + d] = g[d];
            return h;
        }
        function Nr(h, g, d, A) {
            var R = -1, q = h == null ? 0 : h.length;
            for(A && q && (d = h[++R]); ++R < q;)d = g(d, h[R], R, h);
            return d;
        }
        function of(h, g, d, A) {
            var R = h == null ? 0 : h.length;
            for(A && R && (d = h[--R]); R--;)d = g(d, h[R], R, h);
            return d;
        }
        function $r(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length; ++d < A;)if (g(h[d], d, h)) return !0;
            return !1;
        }
        var ff = qr("length");
        function cf(h) {
            return h.split("");
        }
        function hf(h) {
            return h.match(mo) || [];
        }
        function xs(h, g, d) {
            var A;
            return d(h, function(R, q, X) {
                if (g(R, q, X)) return A = q, !1;
            }), A;
        }
        function Oe(h, g, d, A) {
            for(var R = h.length, q = d + (A ? 1 : -1); A ? q-- : ++q < R;)if (g(h[q], q, h)) return q;
            return -1;
        }
        function Ln(h, g, d) {
            return g === g ? If(h, g, d) : Oe(h, Es, d);
        }
        function lf(h, g, d, A) {
            for(var R = d - 1, q = h.length; ++R < q;)if (A(h[R], g)) return R;
            return -1;
        }
        function Es(h) {
            return h !== h;
        }
        function ys(h, g) {
            var d = h == null ? 0 : h.length;
            return d ? Fr(h, g) / d : we;
        }
        function qr(h) {
            return function(g) {
                return g == null ? i : g[h];
            };
        }
        function Ur(h) {
            return function(g) {
                return h == null ? i : h[g];
            };
        }
        function Ss(h, g, d, A, R) {
            return R(h, function(q, X, M) {
                d = A ? (A = !1, q) : g(d, q, X, M);
            }), d;
        }
        function pf(h, g) {
            var d = h.length;
            for(h.sort(g); d--;)h[d] = h[d].value;
            return h;
        }
        function Fr(h, g) {
            for(var d, A = -1, R = h.length; ++A < R;){
                var q = g(h[A]);
                q !== i && (d = d === i ? q : d + q);
            }
            return d;
        }
        function Wr(h, g) {
            for(var d = -1, A = Array(h); ++d < h;)A[d] = g(d);
            return A;
        }
        function df(h, g) {
            return z(g, function(d) {
                return [
                    d,
                    h[d]
                ];
            });
        }
        function Os(h) {
            return h && h.slice(0, Ls(h) + 1).replace(yr, "");
        }
        function ht(h) {
            return function(g) {
                return h(g);
            };
        }
        function Mr(h, g) {
            return z(g, function(d) {
                return h[d];
            });
        }
        function ne(h, g) {
            return h.has(g);
        }
        function Rs(h, g) {
            for(var d = -1, A = h.length; ++d < A && Ln(g, h[d], 0) > -1;);
            return d;
        }
        function bs(h, g) {
            for(var d = h.length; d-- && Ln(g, h[d], 0) > -1;);
            return d;
        }
        function gf(h, g) {
            for(var d = h.length, A = 0; d--;)h[d] === g && ++A;
            return A;
        }
        var vf = Ur(ko), _f = Ur(jo);
        function mf(h) {
            return "\\" + nf[h];
        }
        function wf(h, g) {
            return h == null ? i : h[g];
        }
        function Hn(h) {
            return Zo.test(h);
        }
        function Pf(h) {
            return Xo.test(h);
        }
        function Cf(h) {
            for(var g, d = []; !(g = h.next()).done;)d.push(g.value);
            return d;
        }
        function Br(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(A, R) {
                d[++g] = [
                    R,
                    A
                ];
            }), d;
        }
        function Ts(h, g) {
            return function(d) {
                return h(g(d));
            };
        }
        function sn(h, g) {
            for(var d = -1, A = h.length, R = 0, q = []; ++d < A;){
                var X = h[d];
                (X === g || X === xn) && (h[d] = xn, q[R++] = d);
            }
            return q;
        }
        function Re(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(A) {
                d[++g] = A;
            }), d;
        }
        function Af(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(A) {
                d[++g] = [
                    A,
                    A
                ];
            }), d;
        }
        function If(h, g, d) {
            for(var A = d - 1, R = h.length; ++A < R;)if (h[A] === g) return A;
            return -1;
        }
        function xf(h, g, d) {
            for(var A = d + 1; A--;)if (h[A] === g) return A;
            return A;
        }
        function Dn(h) {
            return Hn(h) ? yf(h) : ff(h);
        }
        function St(h) {
            return Hn(h) ? Sf(h) : cf(h);
        }
        function Ls(h) {
            for(var g = h.length; g-- && po.test(h.charAt(g)););
            return g;
        }
        var Ef = Ur(tf);
        function yf(h) {
            for(var g = Tr.lastIndex = 0; Tr.test(h);)++g;
            return g;
        }
        function Sf(h) {
            return h.match(Tr) || [];
        }
        function Of(h) {
            return h.match(Yo) || [];
        }
        var Rf = function h(g) {
            g = g == null ? j : Nn.defaults(j.Object(), g, Nn.pick(j, Qo));
            var d = g.Array, A = g.Date, R = g.Error, q = g.Function, X = g.Math, M = g.Object, Gr = g.RegExp, bf = g.String, wt = g.TypeError, be = d.prototype, Tf = q.prototype, $n = M.prototype, Te = g["__core-js_shared__"], Le = Tf.toString, W = $n.hasOwnProperty, Lf = 0, Hs = function() {
                var t = /[^.]+$/.exec(Te && Te.keys && Te.keys.IE_PROTO || "");
                return t ? "Symbol(src)_1." + t : "";
            }(), He = $n.toString, Hf = Le.call(M), Df = j._, Nf = Gr("^" + Le.call(W).replace(Er, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), De = vs ? g.Buffer : i, un = g.Symbol, Ne = g.Uint8Array, Ds = De ? De.allocUnsafe : i, $e = Ts(M.getPrototypeOf, M), Ns = M.create, $s = $n.propertyIsEnumerable, qe = be.splice, qs = un ? un.isConcatSpreadable : i, ee = un ? un.iterator : i, gn = un ? un.toStringTag : i, Ue = function() {
                try {
                    var t = Pn(M, "defineProperty");
                    return t({}, "", {}), t;
                } catch  {}
            }(), $f = g.clearTimeout !== j.clearTimeout && g.clearTimeout, qf = A && A.now !== j.Date.now && A.now, Uf = g.setTimeout !== j.setTimeout && g.setTimeout, Fe = X.ceil, We = X.floor, zr = M.getOwnPropertySymbols, Ff = De ? De.isBuffer : i, Us = g.isFinite, Wf = be.join, Mf = Ts(M.keys, M), Q = X.max, nt = X.min, Bf = A.now, Gf = g.parseInt, Fs = X.random, zf = be.reverse, Kr = Pn(g, "DataView"), re = Pn(g, "Map"), Jr = Pn(g, "Promise"), qn = Pn(g, "Set"), ie = Pn(g, "WeakMap"), se = Pn(M, "create"), Me = ie && new ie, Un = {}, Kf = Cn(Kr), Jf = Cn(re), Yf = Cn(Jr), Zf = Cn(qn), Xf = Cn(ie), Be = un ? un.prototype : i, ue = Be ? Be.valueOf : i, Ws = Be ? Be.toString : i;
            function a(t) {
                if (J(t) && !b(t) && !(t instanceof N)) {
                    if (t instanceof Pt) return t;
                    if (W.call(t, "__wrapped__")) return Mu(t);
                }
                return new Pt(t);
            }
            var Fn = function() {
                function t() {}
                return function(n) {
                    if (!K(n)) return {};
                    if (Ns) return Ns(n);
                    t.prototype = n;
                    var e = new t;
                    return t.prototype = i, e;
                };
            }();
            function Ge() {}
            function Pt(t, n) {
                this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = i;
            }
            a.templateSettings = {
                escape: ao,
                evaluate: oo,
                interpolate: Xi,
                variable: "",
                imports: {
                    _: a
                }
            }, a.prototype = Ge.prototype, a.prototype.constructor = a, Pt.prototype = Fn(Ge.prototype), Pt.prototype.constructor = Pt;
            function N(t) {
                this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = $t, this.__views__ = [];
            }
            function Qf() {
                var t = new N(this.__wrapped__);
                return t.__actions__ = ut(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = ut(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = ut(this.__views__), t;
            }
            function Vf() {
                if (this.__filtered__) {
                    var t = new N(this);
                    t.__dir__ = -1, t.__filtered__ = !0;
                } else t = this.clone(), t.__dir__ *= -1;
                return t;
            }
            function kf() {
                var t = this.__wrapped__.value(), n = this.__dir__, e = b(t), r = n < 0, u = e ? t.length : 0, o = ch(0, u, this.__views__), f = o.start, c = o.end, l = c - f, v = r ? c : f - 1, _ = this.__iteratees__, m = _.length, C = 0, I = nt(l, this.__takeCount__);
                if (!e || !r && u == l && I == l) return cu(t, this.__actions__);
                var y = [];
                t: for(; l-- && C < I;){
                    v += n;
                    for(var L = -1, S = t[v]; ++L < m;){
                        var D = _[L], $ = D.iteratee, dt = D.type, st = $(S);
                        if (dt == za) S = st;
                        else if (!st) {
                            if (dt == zi) continue t;
                            break t;
                        }
                    }
                    y[C++] = S;
                }
                return y;
            }
            N.prototype = Fn(Ge.prototype), N.prototype.constructor = N;
            function vn(t) {
                var n = -1, e = t == null ? 0 : t.length;
                for(this.clear(); ++n < e;){
                    var r = t[n];
                    this.set(r[0], r[1]);
                }
            }
            function jf() {
                this.__data__ = se ? se(null) : {}, this.size = 0;
            }
            function tc(t) {
                var n = this.has(t) && delete this.__data__[t];
                return this.size -= n ? 1 : 0, n;
            }
            function nc(t) {
                var n = this.__data__;
                if (se) {
                    var e = n[t];
                    return e === tn ? i : e;
                }
                return W.call(n, t) ? n[t] : i;
            }
            function ec(t) {
                var n = this.__data__;
                return se ? n[t] !== i : W.call(n, t);
            }
            function rc(t, n) {
                var e = this.__data__;
                return this.size += this.has(t) ? 0 : 1, e[t] = se && n === i ? tn : n, this;
            }
            vn.prototype.clear = jf, vn.prototype.delete = tc, vn.prototype.get = nc, vn.prototype.has = ec, vn.prototype.set = rc;
            function zt(t) {
                var n = -1, e = t == null ? 0 : t.length;
                for(this.clear(); ++n < e;){
                    var r = t[n];
                    this.set(r[0], r[1]);
                }
            }
            function ic() {
                this.__data__ = [], this.size = 0;
            }
            function sc(t) {
                var n = this.__data__, e = ze(n, t);
                if (e < 0) return !1;
                var r = n.length - 1;
                return e == r ? n.pop() : qe.call(n, e, 1), --this.size, !0;
            }
            function uc(t) {
                var n = this.__data__, e = ze(n, t);
                return e < 0 ? i : n[e][1];
            }
            function ac(t) {
                return ze(this.__data__, t) > -1;
            }
            function oc(t, n) {
                var e = this.__data__, r = ze(e, t);
                return r < 0 ? (++this.size, e.push([
                    t,
                    n
                ])) : e[r][1] = n, this;
            }
            zt.prototype.clear = ic, zt.prototype.delete = sc, zt.prototype.get = uc, zt.prototype.has = ac, zt.prototype.set = oc;
            function Kt(t) {
                var n = -1, e = t == null ? 0 : t.length;
                for(this.clear(); ++n < e;){
                    var r = t[n];
                    this.set(r[0], r[1]);
                }
            }
            function fc() {
                this.size = 0, this.__data__ = {
                    hash: new vn,
                    map: new (re || zt),
                    string: new vn
                };
            }
            function cc(t) {
                var n = er(this, t).delete(t);
                return this.size -= n ? 1 : 0, n;
            }
            function hc(t) {
                return er(this, t).get(t);
            }
            function lc(t) {
                return er(this, t).has(t);
            }
            function pc(t, n) {
                var e = er(this, t), r = e.size;
                return e.set(t, n), this.size += e.size == r ? 0 : 1, this;
            }
            Kt.prototype.clear = fc, Kt.prototype.delete = cc, Kt.prototype.get = hc, Kt.prototype.has = lc, Kt.prototype.set = pc;
            function _n(t) {
                var n = -1, e = t == null ? 0 : t.length;
                for(this.__data__ = new Kt; ++n < e;)this.add(t[n]);
            }
            function dc(t) {
                return this.__data__.set(t, tn), this;
            }
            function gc(t) {
                return this.__data__.has(t);
            }
            _n.prototype.add = _n.prototype.push = dc, _n.prototype.has = gc;
            function Ot(t) {
                var n = this.__data__ = new zt(t);
                this.size = n.size;
            }
            function vc() {
                this.__data__ = new zt, this.size = 0;
            }
            function _c(t) {
                var n = this.__data__, e = n.delete(t);
                return this.size = n.size, e;
            }
            function mc(t) {
                return this.__data__.get(t);
            }
            function wc(t) {
                return this.__data__.has(t);
            }
            function Pc(t, n) {
                var e = this.__data__;
                if (e instanceof zt) {
                    var r = e.__data__;
                    if (!re || r.length < w - 1) return r.push([
                        t,
                        n
                    ]), this.size = ++e.size, this;
                    e = this.__data__ = new Kt(r);
                }
                return e.set(t, n), this.size = e.size, this;
            }
            Ot.prototype.clear = vc, Ot.prototype.delete = _c, Ot.prototype.get = mc, Ot.prototype.has = wc, Ot.prototype.set = Pc;
            function Ms(t, n) {
                var e = b(t), r = !e && An(t), u = !e && !r && hn(t), o = !e && !r && !u && Gn(t), f = e || r || u || o, c = f ? Wr(t.length, bf) : [], l = c.length;
                for(var v in t)(n || W.call(t, v)) && !(f && (v == "length" || u && (v == "offset" || v == "parent") || o && (v == "buffer" || v == "byteLength" || v == "byteOffset") || Xt(v, l))) && c.push(v);
                return c;
            }
            function Bs(t) {
                var n = t.length;
                return n ? t[ri(0, n - 1)] : i;
            }
            function Cc(t, n) {
                return rr(ut(t), mn(n, 0, t.length));
            }
            function Ac(t) {
                return rr(ut(t));
            }
            function Yr(t, n, e) {
                (e !== i && !Rt(t[n], e) || e === i && !(n in t)) && Jt(t, n, e);
            }
            function ae(t, n, e) {
                var r = t[n];
                (!(W.call(t, n) && Rt(r, e)) || e === i && !(n in t)) && Jt(t, n, e);
            }
            function ze(t, n) {
                for(var e = t.length; e--;)if (Rt(t[e][0], n)) return e;
                return -1;
            }
            function Ic(t, n, e, r) {
                return an(t, function(u, o, f) {
                    n(r, u, e(u), f);
                }), r;
            }
            function Gs(t, n) {
                return t && Ut(n, V(n), t);
            }
            function xc(t, n) {
                return t && Ut(n, ot(n), t);
            }
            function Jt(t, n, e) {
                n == "__proto__" && Ue ? Ue(t, n, {
                    configurable: !0,
                    enumerable: !0,
                    value: e,
                    writable: !0
                }) : t[n] = e;
            }
            function Zr(t, n) {
                for(var e = -1, r = n.length, u = d(r), o = t == null; ++e < r;)u[e] = o ? i : Oi(t, n[e]);
                return u;
            }
            function mn(t, n, e) {
                return t === t && (e !== i && (t = t <= e ? t : e), n !== i && (t = t >= n ? t : n)), t;
            }
            function Ct(t, n, e, r, u, o) {
                var f, c = n & Ht, l = n & Mt, v = n & En;
                if (e && (f = u ? e(t, r, u, o) : e(t)), f !== i) return f;
                if (!K(t)) return t;
                var _ = b(t);
                if (_) {
                    if (f = lh(t), !c) return ut(t, f);
                } else {
                    var m = et(t), C = m == Ae || m == Ki;
                    if (hn(t)) return pu(t, c);
                    if (m == Gt || m == Rn || C && !u) {
                        if (f = l || C ? {} : Lu(t), !c) return l ? nh(t, xc(f, t)) : th(t, Gs(f, t));
                    } else {
                        if (!B[m]) return u ? t : {};
                        f = ph(t, m, c);
                    }
                }
                o || (o = new Ot);
                var I = o.get(t);
                if (I) return I;
                o.set(t, f), aa(t) ? t.forEach(function(S) {
                    f.add(Ct(S, n, e, S, t, o));
                }) : sa(t) && t.forEach(function(S, D) {
                    f.set(D, Ct(S, n, e, D, t, o));
                });
                var y = v ? l ? di : pi : l ? ot : V, L = _ ? i : y(t);
                return mt(L || t, function(S, D) {
                    L && (D = S, S = t[D]), ae(f, D, Ct(S, n, e, D, t, o));
                }), f;
            }
            function Ec(t) {
                var n = V(t);
                return function(e) {
                    return zs(e, t, n);
                };
            }
            function zs(t, n, e) {
                var r = e.length;
                if (t == null) return !r;
                for(t = M(t); r--;){
                    var u = e[r], o = n[u], f = t[u];
                    if (f === i && !(u in t) || !o(f)) return !1;
                }
                return !0;
            }
            function Ks(t, n, e) {
                if (typeof t != "function") throw new wt(O);
                return de(function() {
                    t.apply(i, e);
                }, n);
            }
            function oe(t, n, e, r) {
                var u = -1, o = Se, f = !0, c = t.length, l = [], v = n.length;
                if (!c) return l;
                e && (n = z(n, ht(e))), r ? (o = Dr, f = !1) : n.length >= w && (o = ne, f = !1, n = new _n(n));
                t: for(; ++u < c;){
                    var _ = t[u], m = e == null ? _ : e(_);
                    if (_ = r || _ !== 0 ? _ : 0, f && m === m) {
                        for(var C = v; C--;)if (n[C] === m) continue t;
                        l.push(_);
                    } else o(n, m, r) || l.push(_);
                }
                return l;
            }
            var an = mu(qt), Js = mu(Qr, !0);
            function yc(t, n) {
                var e = !0;
                return an(t, function(r, u, o) {
                    return e = !!n(r, u, o), e;
                }), e;
            }
            function Ke(t, n, e) {
                for(var r = -1, u = t.length; ++r < u;){
                    var o = t[r], f = n(o);
                    if (f != null && (c === i ? f === f && !pt(f) : e(f, c))) var c = f, l = o;
                }
                return l;
            }
            function Sc(t, n, e, r) {
                var u = t.length;
                for(e = T(e), e < 0 && (e = -e > u ? 0 : u + e), r = r === i || r > u ? u : T(r), r < 0 && (r += u), r = e > r ? 0 : fa(r); e < r;)t[e++] = n;
                return t;
            }
            function Ys(t, n) {
                var e = [];
                return an(t, function(r, u, o) {
                    n(r, u, o) && e.push(r);
                }), e;
            }
            function tt(t, n, e, r, u) {
                var o = -1, f = t.length;
                for(e || (e = gh), u || (u = []); ++o < f;){
                    var c = t[o];
                    n > 0 && e(c) ? n > 1 ? tt(c, n - 1, e, r, u) : rn(u, c) : r || (u[u.length] = c);
                }
                return u;
            }
            var Xr = wu(), Zs = wu(!0);
            function qt(t, n) {
                return t && Xr(t, n, V);
            }
            function Qr(t, n) {
                return t && Zs(t, n, V);
            }
            function Je(t, n) {
                return en(n, function(e) {
                    return Qt(t[e]);
                });
            }
            function wn(t, n) {
                n = fn(n, t);
                for(var e = 0, r = n.length; t != null && e < r;)t = t[Ft(n[e++])];
                return e && e == r ? t : i;
            }
            function Xs(t, n, e) {
                var r = n(t);
                return b(t) ? r : rn(r, e(t));
            }
            function rt(t) {
                return t == null ? t === i ? to : ka : gn && gn in M(t) ? fh(t) : Ah(t);
            }
            function Vr(t, n) {
                return t > n;
            }
            function Oc(t, n) {
                return t != null && W.call(t, n);
            }
            function Rc(t, n) {
                return t != null && n in M(t);
            }
            function bc(t, n, e) {
                return t >= nt(n, e) && t < Q(n, e);
            }
            function kr(t, n, e) {
                for(var r = e ? Dr : Se, u = t[0].length, o = t.length, f = o, c = d(o), l = 1 / 0, v = []; f--;){
                    var _ = t[f];
                    f && n && (_ = z(_, ht(n))), l = nt(_.length, l), c[f] = !e && (n || u >= 120 && _.length >= 120) ? new _n(f && _) : i;
                }
                _ = t[0];
                var m = -1, C = c[0];
                t: for(; ++m < u && v.length < l;){
                    var I = _[m], y = n ? n(I) : I;
                    if (I = e || I !== 0 ? I : 0, !(C ? ne(C, y) : r(v, y, e))) {
                        for(f = o; --f;){
                            var L = c[f];
                            if (!(L ? ne(L, y) : r(t[f], y, e))) continue t;
                        }
                        C && C.push(y), v.push(I);
                    }
                }
                return v;
            }
            function Tc(t, n, e, r) {
                return qt(t, function(u, o, f) {
                    n(r, e(u), o, f);
                }), r;
            }
            function fe(t, n, e) {
                n = fn(n, t), t = $u(t, n);
                var r = t == null ? t : t[Ft(It(n))];
                return r == null ? i : ct(r, t, e);
            }
            function Qs(t) {
                return J(t) && rt(t) == Rn;
            }
            function Lc(t) {
                return J(t) && rt(t) == te;
            }
            function Hc(t) {
                return J(t) && rt(t) == Xn;
            }
            function ce(t, n, e, r, u) {
                return t === n ? !0 : t == null || n == null || !J(t) && !J(n) ? t !== t && n !== n : Dc(t, n, e, r, ce, u);
            }
            function Dc(t, n, e, r, u, o) {
                var f = b(t), c = b(n), l = f ? Pe : et(t), v = c ? Pe : et(n);
                l = l == Rn ? Gt : l, v = v == Rn ? Gt : v;
                var _ = l == Gt, m = v == Gt, C = l == v;
                if (C && hn(t)) {
                    if (!hn(n)) return !1;
                    f = !0, _ = !1;
                }
                if (C && !_) return o || (o = new Ot), f || Gn(t) ? Ru(t, n, e, r, u, o) : ah(t, n, l, e, r, u, o);
                if (!(e & yn)) {
                    var I = _ && W.call(t, "__wrapped__"), y = m && W.call(n, "__wrapped__");
                    if (I || y) {
                        var L = I ? t.value() : t, S = y ? n.value() : n;
                        return o || (o = new Ot), u(L, S, e, r, o);
                    }
                }
                return C ? (o || (o = new Ot), oh(t, n, e, r, u, o)) : !1;
            }
            function Nc(t) {
                return J(t) && et(t) == Et;
            }
            function jr(t, n, e, r) {
                var u = e.length, o = u, f = !r;
                if (t == null) return !o;
                for(t = M(t); u--;){
                    var c = e[u];
                    if (f && c[2] ? c[1] !== t[c[0]] : !(c[0] in t)) return !1;
                }
                for(; ++u < o;){
                    c = e[u];
                    var l = c[0], v = t[l], _ = c[1];
                    if (f && c[2]) {
                        if (v === i && !(l in t)) return !1;
                    } else {
                        var m = new Ot;
                        if (r) var C = r(v, _, l, t, n, m);
                        if (!(C === i ? ce(_, v, yn | me, r, m) : C)) return !1;
                    }
                }
                return !0;
            }
            function Vs(t) {
                if (!K(t) || _h(t)) return !1;
                var n = Qt(t) ? Nf : xo;
                return n.test(Cn(t));
            }
            function $c(t) {
                return J(t) && rt(t) == Vn;
            }
            function qc(t) {
                return J(t) && et(t) == yt;
            }
            function Uc(t) {
                return J(t) && fr(t.length) && !!G[rt(t)];
            }
            function ks(t) {
                return typeof t == "function" ? t : t == null ? ft : typeof t == "object" ? b(t) ? nu(t[0], t[1]) : tu(t) : Pa(t);
            }
            function ti(t) {
                if (!pe(t)) return Mf(t);
                var n = [];
                for(var e in M(t))W.call(t, e) && e != "constructor" && n.push(e);
                return n;
            }
            function Fc(t) {
                if (!K(t)) return Ch(t);
                var n = pe(t), e = [];
                for(var r in t)r == "constructor" && (n || !W.call(t, r)) || e.push(r);
                return e;
            }
            function ni(t, n) {
                return t < n;
            }
            function js(t, n) {
                var e = -1, r = at(t) ? d(t.length) : [];
                return an(t, function(u, o, f) {
                    r[++e] = n(u, o, f);
                }), r;
            }
            function tu(t) {
                var n = vi(t);
                return n.length == 1 && n[0][2] ? Du(n[0][0], n[0][1]) : function(e) {
                    return e === t || jr(e, t, n);
                };
            }
            function nu(t, n) {
                return mi(t) && Hu(n) ? Du(Ft(t), n) : function(e) {
                    var r = Oi(e, t);
                    return r === i && r === n ? Ri(e, t) : ce(n, r, yn | me);
                };
            }
            function Ye(t, n, e, r, u) {
                t !== n && Xr(n, function(o, f) {
                    if (u || (u = new Ot), K(o)) Wc(t, n, f, e, Ye, r, u);
                    else {
                        var c = r ? r(Pi(t, f), o, f + "", t, n, u) : i;
                        c === i && (c = o), Yr(t, f, c);
                    }
                }, ot);
            }
            function Wc(t, n, e, r, u, o, f) {
                var c = Pi(t, e), l = Pi(n, e), v = f.get(l);
                if (v) {
                    Yr(t, e, v);
                    return;
                }
                var _ = o ? o(c, l, e + "", t, n, f) : i, m = _ === i;
                if (m) {
                    var C = b(l), I = !C && hn(l), y = !C && !I && Gn(l);
                    _ = l, C || I || y ? b(c) ? _ = c : Y(c) ? _ = ut(c) : I ? (m = !1, _ = pu(l, !0)) : y ? (m = !1, _ = du(l, !0)) : _ = [] : ge(l) || An(l) ? (_ = c, An(c) ? _ = ca(c) : (!K(c) || Qt(c)) && (_ = Lu(l))) : m = !1;
                }
                m && (f.set(l, _), u(_, l, r, o, f), f.delete(l)), Yr(t, e, _);
            }
            function eu(t, n) {
                var e = t.length;
                if (e) return n += n < 0 ? e : 0, Xt(n, e) ? t[n] : i;
            }
            function ru(t, n, e) {
                n.length ? n = z(n, function(o) {
                    return b(o) ? function(f) {
                        return wn(f, o.length === 1 ? o[0] : o);
                    } : o;
                }) : n = [
                    ft
                ];
                var r = -1;
                n = z(n, ht(E()));
                var u = js(t, function(o, f, c) {
                    var l = z(n, function(v) {
                        return v(o);
                    });
                    return {
                        criteria: l,
                        index: ++r,
                        value: o
                    };
                });
                return pf(u, function(o, f) {
                    return jc(o, f, e);
                });
            }
            function Mc(t, n) {
                return iu(t, n, function(e, r) {
                    return Ri(t, r);
                });
            }
            function iu(t, n, e) {
                for(var r = -1, u = n.length, o = {}; ++r < u;){
                    var f = n[r], c = wn(t, f);
                    e(c, f) && he(o, fn(f, t), c);
                }
                return o;
            }
            function Bc(t) {
                return function(n) {
                    return wn(n, t);
                };
            }
            function ei(t, n, e, r) {
                var u = r ? lf : Ln, o = -1, f = n.length, c = t;
                for(t === n && (n = ut(n)), e && (c = z(t, ht(e))); ++o < f;)for(var l = 0, v = n[o], _ = e ? e(v) : v; (l = u(c, _, l, r)) > -1;)c !== t && qe.call(c, l, 1), qe.call(t, l, 1);
                return t;
            }
            function su(t, n) {
                for(var e = t ? n.length : 0, r = e - 1; e--;){
                    var u = n[e];
                    if (e == r || u !== o) {
                        var o = u;
                        Xt(u) ? qe.call(t, u, 1) : ui(t, u);
                    }
                }
                return t;
            }
            function ri(t, n) {
                return t + We(Fs() * (n - t + 1));
            }
            function Gc(t, n, e, r) {
                for(var u = -1, o = Q(Fe((n - t) / (e || 1)), 0), f = d(o); o--;)f[r ? o : ++u] = t, t += e;
                return f;
            }
            function ii(t, n) {
                var e = "";
                if (!t || n < 1 || n > nn) return e;
                do n % 2 && (e += t), n = We(n / 2), n && (t += t);
                while (n);
                return e;
            }
            function H(t, n) {
                return Ci(Nu(t, n, ft), t + "");
            }
            function zc(t) {
                return Bs(zn(t));
            }
            function Kc(t, n) {
                var e = zn(t);
                return rr(e, mn(n, 0, e.length));
            }
            function he(t, n, e, r) {
                if (!K(t)) return t;
                n = fn(n, t);
                for(var u = -1, o = n.length, f = o - 1, c = t; c != null && ++u < o;){
                    var l = Ft(n[u]), v = e;
                    if (l === "__proto__" || l === "constructor" || l === "prototype") return t;
                    if (u != f) {
                        var _ = c[l];
                        v = r ? r(_, l, c) : i, v === i && (v = K(_) ? _ : Xt(n[u + 1]) ? [] : {});
                    }
                    ae(c, l, v), c = c[l];
                }
                return t;
            }
            var uu = Me ? function(t, n) {
                return Me.set(t, n), t;
            } : ft, Jc = Ue ? function(t, n) {
                return Ue(t, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: Ti(n),
                    writable: !0
                });
            } : ft;
            function Yc(t) {
                return rr(zn(t));
            }
            function At(t, n, e) {
                var r = -1, u = t.length;
                n < 0 && (n = -n > u ? 0 : u + n), e = e > u ? u : e, e < 0 && (e += u), u = n > e ? 0 : e - n >>> 0, n >>>= 0;
                for(var o = d(u); ++r < u;)o[r] = t[r + n];
                return o;
            }
            function Zc(t, n) {
                var e;
                return an(t, function(r, u, o) {
                    return e = n(r, u, o), !e;
                }), !!e;
            }
            function Ze(t, n, e) {
                var r = 0, u = t == null ? r : t.length;
                if (typeof n == "number" && n === n && u <= Za) {
                    for(; r < u;){
                        var o = r + u >>> 1, f = t[o];
                        f !== null && !pt(f) && (e ? f <= n : f < n) ? r = o + 1 : u = o;
                    }
                    return u;
                }
                return si(t, n, ft, e);
            }
            function si(t, n, e, r) {
                var u = 0, o = t == null ? 0 : t.length;
                if (o === 0) return 0;
                n = e(n);
                for(var f = n !== n, c = n === null, l = pt(n), v = n === i; u < o;){
                    var _ = We((u + o) / 2), m = e(t[_]), C = m !== i, I = m === null, y = m === m, L = pt(m);
                    if (f) var S = r || y;
                    else v ? S = y && (r || C) : c ? S = y && C && (r || !I) : l ? S = y && C && !I && (r || !L) : I || L ? S = !1 : S = r ? m <= n : m < n;
                    S ? u = _ + 1 : o = _;
                }
                return nt(o, Ya);
            }
            function au(t, n) {
                for(var e = -1, r = t.length, u = 0, o = []; ++e < r;){
                    var f = t[e], c = n ? n(f) : f;
                    if (!e || !Rt(c, l)) {
                        var l = c;
                        o[u++] = f === 0 ? 0 : f;
                    }
                }
                return o;
            }
            function ou(t) {
                return typeof t == "number" ? t : pt(t) ? we : +t;
            }
            function lt(t) {
                if (typeof t == "string") return t;
                if (b(t)) return z(t, lt) + "";
                if (pt(t)) return Ws ? Ws.call(t) : "";
                var n = t + "";
                return n == "0" && 1 / t == -pn ? "-0" : n;
            }
            function on(t, n, e) {
                var r = -1, u = Se, o = t.length, f = !0, c = [], l = c;
                if (e) f = !1, u = Dr;
                else if (o >= w) {
                    var v = n ? null : sh(t);
                    if (v) return Re(v);
                    f = !1, u = ne, l = new _n;
                } else l = n ? [] : c;
                t: for(; ++r < o;){
                    var _ = t[r], m = n ? n(_) : _;
                    if (_ = e || _ !== 0 ? _ : 0, f && m === m) {
                        for(var C = l.length; C--;)if (l[C] === m) continue t;
                        n && l.push(m), c.push(_);
                    } else u(l, m, e) || (l !== c && l.push(m), c.push(_));
                }
                return c;
            }
            function ui(t, n) {
                return n = fn(n, t), t = $u(t, n), t == null || delete t[Ft(It(n))];
            }
            function fu(t, n, e, r) {
                return he(t, n, e(wn(t, n)), r);
            }
            function Xe(t, n, e, r) {
                for(var u = t.length, o = r ? u : -1; (r ? o-- : ++o < u) && n(t[o], o, t););
                return e ? At(t, r ? 0 : o, r ? o + 1 : u) : At(t, r ? o + 1 : 0, r ? u : o);
            }
            function cu(t, n) {
                var e = t;
                return e instanceof N && (e = e.value()), Nr(n, function(r, u) {
                    return u.func.apply(u.thisArg, rn([
                        r
                    ], u.args));
                }, e);
            }
            function ai(t, n, e) {
                var r = t.length;
                if (r < 2) return r ? on(t[0]) : [];
                for(var u = -1, o = d(r); ++u < r;)for(var f = t[u], c = -1; ++c < r;)c != u && (o[u] = oe(o[u] || f, t[c], n, e));
                return on(tt(o, 1), n, e);
            }
            function hu(t, n, e) {
                for(var r = -1, u = t.length, o = n.length, f = {}; ++r < u;){
                    var c = r < o ? n[r] : i;
                    e(f, t[r], c);
                }
                return f;
            }
            function oi(t) {
                return Y(t) ? t : [];
            }
            function fi(t) {
                return typeof t == "function" ? t : ft;
            }
            function fn(t, n) {
                return b(t) ? t : mi(t, n) ? [
                    t
                ] : Wu(U(t));
            }
            var Xc = H;
            function cn(t, n, e) {
                var r = t.length;
                return e = e === i ? r : e, !n && e >= r ? t : At(t, n, e);
            }
            var lu = $f || function(t) {
                return j.clearTimeout(t);
            };
            function pu(t, n) {
                if (n) return t.slice();
                var e = t.length, r = Ds ? Ds(e) : new t.constructor(e);
                return t.copy(r), r;
            }
            function ci(t) {
                var n = new t.constructor(t.byteLength);
                return new Ne(n).set(new Ne(t)), n;
            }
            function Qc(t, n) {
                var e = n ? ci(t.buffer) : t.buffer;
                return new t.constructor(e, t.byteOffset, t.byteLength);
            }
            function Vc(t) {
                var n = new t.constructor(t.source, Qi.exec(t));
                return n.lastIndex = t.lastIndex, n;
            }
            function kc(t) {
                return ue ? M(ue.call(t)) : {};
            }
            function du(t, n) {
                var e = n ? ci(t.buffer) : t.buffer;
                return new t.constructor(e, t.byteOffset, t.length);
            }
            function gu(t, n) {
                if (t !== n) {
                    var e = t !== i, r = t === null, u = t === t, o = pt(t), f = n !== i, c = n === null, l = n === n, v = pt(n);
                    if (!c && !v && !o && t > n || o && f && l && !c && !v || r && f && l || !e && l || !u) return 1;
                    if (!r && !o && !v && t < n || v && e && u && !r && !o || c && e && u || !f && u || !l) return -1;
                }
                return 0;
            }
            function jc(t, n, e) {
                for(var r = -1, u = t.criteria, o = n.criteria, f = u.length, c = e.length; ++r < f;){
                    var l = gu(u[r], o[r]);
                    if (l) {
                        if (r >= c) return l;
                        var v = e[r];
                        return l * (v == "desc" ? -1 : 1);
                    }
                }
                return t.index - n.index;
            }
            function vu(t, n, e, r) {
                for(var u = -1, o = t.length, f = e.length, c = -1, l = n.length, v = Q(o - f, 0), _ = d(l + v), m = !r; ++c < l;)_[c] = n[c];
                for(; ++u < f;)(m || u < o) && (_[e[u]] = t[u]);
                for(; v--;)_[c++] = t[u++];
                return _;
            }
            function _u(t, n, e, r) {
                for(var u = -1, o = t.length, f = -1, c = e.length, l = -1, v = n.length, _ = Q(o - c, 0), m = d(_ + v), C = !r; ++u < _;)m[u] = t[u];
                for(var I = u; ++l < v;)m[I + l] = n[l];
                for(; ++f < c;)(C || u < o) && (m[I + e[f]] = t[u++]);
                return m;
            }
            function ut(t, n) {
                var e = -1, r = t.length;
                for(n || (n = d(r)); ++e < r;)n[e] = t[e];
                return n;
            }
            function Ut(t, n, e, r) {
                var u = !e;
                e || (e = {});
                for(var o = -1, f = n.length; ++o < f;){
                    var c = n[o], l = r ? r(e[c], t[c], c, e, t) : i;
                    l === i && (l = t[c]), u ? Jt(e, c, l) : ae(e, c, l);
                }
                return e;
            }
            function th(t, n) {
                return Ut(t, _i(t), n);
            }
            function nh(t, n) {
                return Ut(t, bu(t), n);
            }
            function Qe(t, n) {
                return function(e, r) {
                    var u = b(e) ? uf : Ic, o = n ? n() : {};
                    return u(e, t, E(r, 2), o);
                };
            }
            function Wn(t) {
                return H(function(n, e) {
                    var r = -1, u = e.length, o = u > 1 ? e[u - 1] : i, f = u > 2 ? e[2] : i;
                    for(o = t.length > 3 && typeof o == "function" ? (u--, o) : i, f && it(e[0], e[1], f) && (o = u < 3 ? i : o, u = 1), n = M(n); ++r < u;){
                        var c = e[r];
                        c && t(n, c, r, o);
                    }
                    return n;
                });
            }
            function mu(t, n) {
                return function(e, r) {
                    if (e == null) return e;
                    if (!at(e)) return t(e, r);
                    for(var u = e.length, o = n ? u : -1, f = M(e); (n ? o-- : ++o < u) && r(f[o], o, f) !== !1;);
                    return e;
                };
            }
            function wu(t) {
                return function(n, e, r) {
                    for(var u = -1, o = M(n), f = r(n), c = f.length; c--;){
                        var l = f[t ? c : ++u];
                        if (e(o[l], l, o) === !1) break;
                    }
                    return n;
                };
            }
            function eh(t, n, e) {
                var r = n & vt, u = le(t);
                function o() {
                    var f = this && this !== j && this instanceof o ? u : t;
                    return f.apply(r ? e : this, arguments);
                }
                return o;
            }
            function Pu(t) {
                return function(n) {
                    n = U(n);
                    var e = Hn(n) ? St(n) : i, r = e ? e[0] : n.charAt(0), u = e ? cn(e, 1).join("") : n.slice(1);
                    return r[t]() + u;
                };
            }
            function Mn(t) {
                return function(n) {
                    return Nr(ma(_a(n).replace(Ko, "")), t, "");
                };
            }
            function le(t) {
                return function() {
                    var n = arguments;
                    switch(n.length){
                        case 0:
                            return new t;
                        case 1:
                            return new t(n[0]);
                        case 2:
                            return new t(n[0], n[1]);
                        case 3:
                            return new t(n[0], n[1], n[2]);
                        case 4:
                            return new t(n[0], n[1], n[2], n[3]);
                        case 5:
                            return new t(n[0], n[1], n[2], n[3], n[4]);
                        case 6:
                            return new t(n[0], n[1], n[2], n[3], n[4], n[5]);
                        case 7:
                            return new t(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
                    }
                    var e = Fn(t.prototype), r = t.apply(e, n);
                    return K(r) ? r : e;
                };
            }
            function rh(t, n, e) {
                var r = le(t);
                function u() {
                    for(var o = arguments.length, f = d(o), c = o, l = Bn(u); c--;)f[c] = arguments[c];
                    var v = o < 3 && f[0] !== l && f[o - 1] !== l ? [] : sn(f, l);
                    if (o -= v.length, o < e) return Eu(t, n, Ve, u.placeholder, i, f, v, i, i, e - o);
                    var _ = this && this !== j && this instanceof u ? r : t;
                    return ct(_, this, f);
                }
                return u;
            }
            function Cu(t) {
                return function(n, e, r) {
                    var u = M(n);
                    if (!at(n)) {
                        var o = E(e, 3);
                        n = V(n), e = function(c) {
                            return o(u[c], c, u);
                        };
                    }
                    var f = t(n, e, r);
                    return f > -1 ? u[o ? n[f] : f] : i;
                };
            }
            function Au(t) {
                return Zt(function(n) {
                    var e = n.length, r = e, u = Pt.prototype.thru;
                    for(t && n.reverse(); r--;){
                        var o = n[r];
                        if (typeof o != "function") throw new wt(O);
                        if (u && !f && nr(o) == "wrapper") var f = new Pt([], !0);
                    }
                    for(r = f ? r : e; ++r < e;){
                        o = n[r];
                        var c = nr(o), l = c == "wrapper" ? gi(o) : i;
                        l && wi(l[0]) && l[1] == (Bt | Dt | Nt | Yn) && !l[4].length && l[9] == 1 ? f = f[nr(l[0])].apply(f, l[3]) : f = o.length == 1 && wi(o) ? f[c]() : f.thru(o);
                    }
                    return function() {
                        var v = arguments, _ = v[0];
                        if (f && v.length == 1 && b(_)) return f.plant(_).value();
                        for(var m = 0, C = e ? n[m].apply(this, v) : _; ++m < e;)C = n[m].call(this, C);
                        return C;
                    };
                });
            }
            function Ve(t, n, e, r, u, o, f, c, l, v) {
                var _ = n & Bt, m = n & vt, C = n & ln, I = n & (Dt | Sn), y = n & gr, L = C ? i : le(t);
                function S() {
                    for(var D = arguments.length, $ = d(D), dt = D; dt--;)$[dt] = arguments[dt];
                    if (I) var st = Bn(S), gt = gf($, st);
                    if (r && ($ = vu($, r, u, I)), o && ($ = _u($, o, f, I)), D -= gt, I && D < v) {
                        var Z = sn($, st);
                        return Eu(t, n, Ve, S.placeholder, e, $, Z, c, l, v - D);
                    }
                    var bt = m ? e : this, kt = C ? bt[t] : t;
                    return D = $.length, c ? $ = Ih($, c) : y && D > 1 && $.reverse(), _ && l < D && ($.length = l), this && this !== j && this instanceof S && (kt = L || le(kt)), kt.apply(bt, $);
                }
                return S;
            }
            function Iu(t, n) {
                return function(e, r) {
                    return Tc(e, t, n(r), {});
                };
            }
            function ke(t, n) {
                return function(e, r) {
                    var u;
                    if (e === i && r === i) return n;
                    if (e !== i && (u = e), r !== i) {
                        if (u === i) return r;
                        typeof e == "string" || typeof r == "string" ? (e = lt(e), r = lt(r)) : (e = ou(e), r = ou(r)), u = t(e, r);
                    }
                    return u;
                };
            }
            function hi(t) {
                return Zt(function(n) {
                    return n = z(n, ht(E())), H(function(e) {
                        var r = this;
                        return t(n, function(u) {
                            return ct(u, r, e);
                        });
                    });
                });
            }
            function je(t, n) {
                n = n === i ? " " : lt(n);
                var e = n.length;
                if (e < 2) return e ? ii(n, t) : n;
                var r = ii(n, Fe(t / Dn(n)));
                return Hn(n) ? cn(St(r), 0, t).join("") : r.slice(0, t);
            }
            function ih(t, n, e, r) {
                var u = n & vt, o = le(t);
                function f() {
                    for(var c = -1, l = arguments.length, v = -1, _ = r.length, m = d(_ + l), C = this && this !== j && this instanceof f ? o : t; ++v < _;)m[v] = r[v];
                    for(; l--;)m[v++] = arguments[++c];
                    return ct(C, u ? e : this, m);
                }
                return f;
            }
            function xu(t) {
                return function(n, e, r) {
                    return r && typeof r != "number" && it(n, e, r) && (e = r = i), n = Vt(n), e === i ? (e = n, n = 0) : e = Vt(e), r = r === i ? n < e ? 1 : -1 : Vt(r), Gc(n, e, r, t);
                };
            }
            function tr(t) {
                return function(n, e) {
                    return typeof n == "string" && typeof e == "string" || (n = xt(n), e = xt(e)), t(n, e);
                };
            }
            function Eu(t, n, e, r, u, o, f, c, l, v) {
                var _ = n & Dt, m = _ ? f : i, C = _ ? i : f, I = _ ? o : i, y = _ ? i : o;
                n |= _ ? Nt : On, n &= ~(_ ? On : Nt), n & Gi || (n &= ~(vt | ln));
                var L = [
                    t,
                    n,
                    u,
                    I,
                    m,
                    y,
                    C,
                    c,
                    l,
                    v
                ], S = e.apply(i, L);
                return wi(t) && qu(S, L), S.placeholder = r, Uu(S, t, n);
            }
            function li(t) {
                var n = X[t];
                return function(e, r) {
                    if (e = xt(e), r = r == null ? 0 : nt(T(r), 292), r && Us(e)) {
                        var u = (U(e) + "e").split("e"), o = n(u[0] + "e" + (+u[1] + r));
                        return u = (U(o) + "e").split("e"), +(u[0] + "e" + (+u[1] - r));
                    }
                    return n(e);
                };
            }
            var sh = qn && 1 / Re(new qn([
                ,
                -0
            ]))[1] == pn ? function(t) {
                return new qn(t);
            } : Di;
            function yu(t) {
                return function(n) {
                    var e = et(n);
                    return e == Et ? Br(n) : e == yt ? Af(n) : df(n, t(n));
                };
            }
            function Yt(t, n, e, r, u, o, f, c) {
                var l = n & ln;
                if (!l && typeof t != "function") throw new wt(O);
                var v = r ? r.length : 0;
                if (v || (n &= ~(Nt | On), r = u = i), f = f === i ? f : Q(T(f), 0), c = c === i ? c : T(c), v -= u ? u.length : 0, n & On) {
                    var _ = r, m = u;
                    r = u = i;
                }
                var C = l ? i : gi(t), I = [
                    t,
                    n,
                    e,
                    r,
                    u,
                    _,
                    m,
                    o,
                    f,
                    c
                ];
                if (C && Ph(I, C), t = I[0], n = I[1], e = I[2], r = I[3], u = I[4], c = I[9] = I[9] === i ? l ? 0 : t.length : Q(I[9] - v, 0), !c && n & (Dt | Sn) && (n &= ~(Dt | Sn)), !n || n == vt) var y = eh(t, n, e);
                else n == Dt || n == Sn ? y = rh(t, n, c) : (n == Nt || n == (vt | Nt)) && !u.length ? y = ih(t, n, e, r) : y = Ve.apply(i, I);
                var L = C ? uu : qu;
                return Uu(L(y, I), t, n);
            }
            function Su(t, n, e, r) {
                return t === i || Rt(t, $n[e]) && !W.call(r, e) ? n : t;
            }
            function Ou(t, n, e, r, u, o) {
                return K(t) && K(n) && (o.set(n, t), Ye(t, n, i, Ou, o), o.delete(n)), t;
            }
            function uh(t) {
                return ge(t) ? i : t;
            }
            function Ru(t, n, e, r, u, o) {
                var f = e & yn, c = t.length, l = n.length;
                if (c != l && !(f && l > c)) return !1;
                var v = o.get(t), _ = o.get(n);
                if (v && _) return v == n && _ == t;
                var m = -1, C = !0, I = e & me ? new _n : i;
                for(o.set(t, n), o.set(n, t); ++m < c;){
                    var y = t[m], L = n[m];
                    if (r) var S = f ? r(L, y, m, n, t, o) : r(y, L, m, t, n, o);
                    if (S !== i) {
                        if (S) continue;
                        C = !1;
                        break;
                    }
                    if (I) {
                        if (!$r(n, function(D, $) {
                            if (!ne(I, $) && (y === D || u(y, D, e, r, o))) return I.push($);
                        })) {
                            C = !1;
                            break;
                        }
                    } else if (!(y === L || u(y, L, e, r, o))) {
                        C = !1;
                        break;
                    }
                }
                return o.delete(t), o.delete(n), C;
            }
            function ah(t, n, e, r, u, o, f) {
                switch(e){
                    case bn:
                        if (t.byteLength != n.byteLength || t.byteOffset != n.byteOffset) return !1;
                        t = t.buffer, n = n.buffer;
                    case te:
                        return !(t.byteLength != n.byteLength || !o(new Ne(t), new Ne(n)));
                    case Zn:
                    case Xn:
                    case Qn:
                        return Rt(+t, +n);
                    case Ce:
                        return t.name == n.name && t.message == n.message;
                    case Vn:
                    case kn:
                        return t == n + "";
                    case Et:
                        var c = Br;
                    case yt:
                        var l = r & yn;
                        if (c || (c = Re), t.size != n.size && !l) return !1;
                        var v = f.get(t);
                        if (v) return v == n;
                        r |= me, f.set(t, n);
                        var _ = Ru(c(t), c(n), r, u, o, f);
                        return f.delete(t), _;
                    case Ie:
                        if (ue) return ue.call(t) == ue.call(n);
                }
                return !1;
            }
            function oh(t, n, e, r, u, o) {
                var f = e & yn, c = pi(t), l = c.length, v = pi(n), _ = v.length;
                if (l != _ && !f) return !1;
                for(var m = l; m--;){
                    var C = c[m];
                    if (!(f ? C in n : W.call(n, C))) return !1;
                }
                var I = o.get(t), y = o.get(n);
                if (I && y) return I == n && y == t;
                var L = !0;
                o.set(t, n), o.set(n, t);
                for(var S = f; ++m < l;){
                    C = c[m];
                    var D = t[C], $ = n[C];
                    if (r) var dt = f ? r($, D, C, n, t, o) : r(D, $, C, t, n, o);
                    if (!(dt === i ? D === $ || u(D, $, e, r, o) : dt)) {
                        L = !1;
                        break;
                    }
                    S || (S = C == "constructor");
                }
                if (L && !S) {
                    var st = t.constructor, gt = n.constructor;
                    st != gt && "constructor" in t && "constructor" in n && !(typeof st == "function" && st instanceof st && typeof gt == "function" && gt instanceof gt) && (L = !1);
                }
                return o.delete(t), o.delete(n), L;
            }
            function Zt(t) {
                return Ci(Nu(t, i, zu), t + "");
            }
            function pi(t) {
                return Xs(t, V, _i);
            }
            function di(t) {
                return Xs(t, ot, bu);
            }
            var gi = Me ? function(t) {
                return Me.get(t);
            } : Di;
            function nr(t) {
                for(var n = t.name + "", e = Un[n], r = W.call(Un, n) ? e.length : 0; r--;){
                    var u = e[r], o = u.func;
                    if (o == null || o == t) return u.name;
                }
                return n;
            }
            function Bn(t) {
                var n = W.call(a, "placeholder") ? a : t;
                return n.placeholder;
            }
            function E() {
                var t = a.iteratee || Li;
                return t = t === Li ? ks : t, arguments.length ? t(arguments[0], arguments[1]) : t;
            }
            function er(t, n) {
                var e = t.__data__;
                return vh(n) ? e[typeof n == "string" ? "string" : "hash"] : e.map;
            }
            function vi(t) {
                for(var n = V(t), e = n.length; e--;){
                    var r = n[e], u = t[r];
                    n[e] = [
                        r,
                        u,
                        Hu(u)
                    ];
                }
                return n;
            }
            function Pn(t, n) {
                var e = wf(t, n);
                return Vs(e) ? e : i;
            }
            function fh(t) {
                var n = W.call(t, gn), e = t[gn];
                try {
                    t[gn] = i;
                    var r = !0;
                } catch  {}
                var u = He.call(t);
                return r && (n ? t[gn] = e : delete t[gn]), u;
            }
            var _i = zr ? function(t) {
                return t == null ? [] : (t = M(t), en(zr(t), function(n) {
                    return $s.call(t, n);
                }));
            } : Ni, bu = zr ? function(t) {
                for(var n = []; t;)rn(n, _i(t)), t = $e(t);
                return n;
            } : Ni, et = rt;
            (Kr && et(new Kr(new ArrayBuffer(1))) != bn || re && et(new re) != Et || Jr && et(Jr.resolve()) != Ji || qn && et(new qn) != yt || ie && et(new ie) != jn) && (et = function(t) {
                var n = rt(t), e = n == Gt ? t.constructor : i, r = e ? Cn(e) : "";
                if (r) switch(r){
                    case Kf:
                        return bn;
                    case Jf:
                        return Et;
                    case Yf:
                        return Ji;
                    case Zf:
                        return yt;
                    case Xf:
                        return jn;
                }
                return n;
            });
            function ch(t, n, e) {
                for(var r = -1, u = e.length; ++r < u;){
                    var o = e[r], f = o.size;
                    switch(o.type){
                        case "drop":
                            t += f;
                            break;
                        case "dropRight":
                            n -= f;
                            break;
                        case "take":
                            n = nt(n, t + f);
                            break;
                        case "takeRight":
                            t = Q(t, n - f);
                            break;
                    }
                }
                return {
                    start: t,
                    end: n
                };
            }
            function hh(t) {
                var n = t.match(vo);
                return n ? n[1].split(_o) : [];
            }
            function Tu(t, n, e) {
                n = fn(n, t);
                for(var r = -1, u = n.length, o = !1; ++r < u;){
                    var f = Ft(n[r]);
                    if (!(o = t != null && e(t, f))) break;
                    t = t[f];
                }
                return o || ++r != u ? o : (u = t == null ? 0 : t.length, !!u && fr(u) && Xt(f, u) && (b(t) || An(t)));
            }
            function lh(t) {
                var n = t.length, e = new t.constructor(n);
                return n && typeof t[0] == "string" && W.call(t, "index") && (e.index = t.index, e.input = t.input), e;
            }
            function Lu(t) {
                return typeof t.constructor == "function" && !pe(t) ? Fn($e(t)) : {};
            }
            function ph(t, n, e) {
                var r = t.constructor;
                switch(n){
                    case te:
                        return ci(t);
                    case Zn:
                    case Xn:
                        return new r(+t);
                    case bn:
                        return Qc(t, e);
                    case vr:
                    case _r:
                    case mr:
                    case wr:
                    case Pr:
                    case Cr:
                    case Ar:
                    case Ir:
                    case xr:
                        return du(t, e);
                    case Et:
                        return new r;
                    case Qn:
                    case kn:
                        return new r(t);
                    case Vn:
                        return Vc(t);
                    case yt:
                        return new r;
                    case Ie:
                        return kc(t);
                }
            }
            function dh(t, n) {
                var e = n.length;
                if (!e) return t;
                var r = e - 1;
                return n[r] = (e > 1 ? "& " : "") + n[r], n = n.join(e > 2 ? ", " : " "), t.replace(go, `{
/* [wrapped with ` + n + `] */
`);
            }
            function gh(t) {
                return b(t) || An(t) || !!(qs && t && t[qs]);
            }
            function Xt(t, n) {
                var e = typeof t;
                return n = n ?? nn, !!n && (e == "number" || e != "symbol" && yo.test(t)) && t > -1 && t % 1 == 0 && t < n;
            }
            function it(t, n, e) {
                if (!K(e)) return !1;
                var r = typeof n;
                return (r == "number" ? at(e) && Xt(n, e.length) : r == "string" && n in e) ? Rt(e[n], t) : !1;
            }
            function mi(t, n) {
                if (b(t)) return !1;
                var e = typeof t;
                return e == "number" || e == "symbol" || e == "boolean" || t == null || pt(t) ? !0 : co.test(t) || !fo.test(t) || n != null && t in M(n);
            }
            function vh(t) {
                var n = typeof t;
                return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
            }
            function wi(t) {
                var n = nr(t), e = a[n];
                if (typeof e != "function" || !(n in N.prototype)) return !1;
                if (t === e) return !0;
                var r = gi(e);
                return !!r && t === r[0];
            }
            function _h(t) {
                return !!Hs && Hs in t;
            }
            var mh = Te ? Qt : $i;
            function pe(t) {
                var n = t && t.constructor, e = typeof n == "function" && n.prototype || $n;
                return t === e;
            }
            function Hu(t) {
                return t === t && !K(t);
            }
            function Du(t, n) {
                return function(e) {
                    return e == null ? !1 : e[t] === n && (n !== i || t in M(e));
                };
            }
            function wh(t) {
                var n = ar(t, function(r) {
                    return e.size === Jn && e.clear(), r;
                }), e = n.cache;
                return n;
            }
            function Ph(t, n) {
                var e = t[1], r = n[1], u = e | r, o = u < (vt | ln | Bt), f = r == Bt && e == Dt || r == Bt && e == Yn && t[7].length <= n[8] || r == (Bt | Yn) && n[7].length <= n[8] && e == Dt;
                if (!(o || f)) return t;
                r & vt && (t[2] = n[2], u |= e & vt ? 0 : Gi);
                var c = n[3];
                if (c) {
                    var l = t[3];
                    t[3] = l ? vu(l, c, n[4]) : c, t[4] = l ? sn(t[3], xn) : n[4];
                }
                return c = n[5], c && (l = t[5], t[5] = l ? _u(l, c, n[6]) : c, t[6] = l ? sn(t[5], xn) : n[6]), c = n[7], c && (t[7] = c), r & Bt && (t[8] = t[8] == null ? n[8] : nt(t[8], n[8])), t[9] == null && (t[9] = n[9]), t[0] = n[0], t[1] = u, t;
            }
            function Ch(t) {
                var n = [];
                if (t != null) for(var e in M(t))n.push(e);
                return n;
            }
            function Ah(t) {
                return He.call(t);
            }
            function Nu(t, n, e) {
                return n = Q(n === i ? t.length - 1 : n, 0), function() {
                    for(var r = arguments, u = -1, o = Q(r.length - n, 0), f = d(o); ++u < o;)f[u] = r[n + u];
                    u = -1;
                    for(var c = d(n + 1); ++u < n;)c[u] = r[u];
                    return c[n] = e(f), ct(t, this, c);
                };
            }
            function $u(t, n) {
                return n.length < 2 ? t : wn(t, At(n, 0, -1));
            }
            function Ih(t, n) {
                for(var e = t.length, r = nt(n.length, e), u = ut(t); r--;){
                    var o = n[r];
                    t[r] = Xt(o, e) ? u[o] : i;
                }
                return t;
            }
            function Pi(t, n) {
                if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__") return t[n];
            }
            var qu = Fu(uu), de = Uf || function(t, n) {
                return j.setTimeout(t, n);
            }, Ci = Fu(Jc);
            function Uu(t, n, e) {
                var r = n + "";
                return Ci(t, dh(r, xh(hh(r), e)));
            }
            function Fu(t) {
                var n = 0, e = 0;
                return function() {
                    var r = Bf(), u = Ga - (r - e);
                    if (e = r, u > 0) {
                        if (++n >= Ba) return arguments[0];
                    } else n = 0;
                    return t.apply(i, arguments);
                };
            }
            function rr(t, n) {
                var e = -1, r = t.length, u = r - 1;
                for(n = n === i ? r : n; ++e < n;){
                    var o = ri(e, u), f = t[o];
                    t[o] = t[e], t[e] = f;
                }
                return t.length = n, t;
            }
            var Wu = wh(function(t) {
                var n = [];
                return t.charCodeAt(0) === 46 && n.push(""), t.replace(ho, function(e, r, u, o) {
                    n.push(u ? o.replace(Po, "$1") : r || e);
                }), n;
            });
            function Ft(t) {
                if (typeof t == "string" || pt(t)) return t;
                var n = t + "";
                return n == "0" && 1 / t == -pn ? "-0" : n;
            }
            function Cn(t) {
                if (t != null) {
                    try {
                        return Le.call(t);
                    } catch  {}
                    try {
                        return t + "";
                    } catch  {}
                }
                return "";
            }
            function xh(t, n) {
                return mt(Xa, function(e) {
                    var r = "_." + e[0];
                    n & e[1] && !Se(t, r) && t.push(r);
                }), t.sort();
            }
            function Mu(t) {
                if (t instanceof N) return t.clone();
                var n = new Pt(t.__wrapped__, t.__chain__);
                return n.__actions__ = ut(t.__actions__), n.__index__ = t.__index__, n.__values__ = t.__values__, n;
            }
            function Eh(t, n, e) {
                (e ? it(t, n, e) : n === i) ? n = 1 : n = Q(T(n), 0);
                var r = t == null ? 0 : t.length;
                if (!r || n < 1) return [];
                for(var u = 0, o = 0, f = d(Fe(r / n)); u < r;)f[o++] = At(t, u, u += n);
                return f;
            }
            function yh(t) {
                for(var n = -1, e = t == null ? 0 : t.length, r = 0, u = []; ++n < e;){
                    var o = t[n];
                    o && (u[r++] = o);
                }
                return u;
            }
            function Sh() {
                var t = arguments.length;
                if (!t) return [];
                for(var n = d(t - 1), e = arguments[0], r = t; r--;)n[r - 1] = arguments[r];
                return rn(b(e) ? ut(e) : [
                    e
                ], tt(n, 1));
            }
            var Oh = H(function(t, n) {
                return Y(t) ? oe(t, tt(n, 1, Y, !0)) : [];
            }), Rh = H(function(t, n) {
                var e = It(n);
                return Y(e) && (e = i), Y(t) ? oe(t, tt(n, 1, Y, !0), E(e, 2)) : [];
            }), bh = H(function(t, n) {
                var e = It(n);
                return Y(e) && (e = i), Y(t) ? oe(t, tt(n, 1, Y, !0), i, e) : [];
            });
            function Th(t, n, e) {
                var r = t == null ? 0 : t.length;
                return r ? (n = e || n === i ? 1 : T(n), At(t, n < 0 ? 0 : n, r)) : [];
            }
            function Lh(t, n, e) {
                var r = t == null ? 0 : t.length;
                return r ? (n = e || n === i ? 1 : T(n), n = r - n, At(t, 0, n < 0 ? 0 : n)) : [];
            }
            function Hh(t, n) {
                return t && t.length ? Xe(t, E(n, 3), !0, !0) : [];
            }
            function Dh(t, n) {
                return t && t.length ? Xe(t, E(n, 3), !0) : [];
            }
            function Nh(t, n, e, r) {
                var u = t == null ? 0 : t.length;
                return u ? (e && typeof e != "number" && it(t, n, e) && (e = 0, r = u), Sc(t, n, e, r)) : [];
            }
            function Bu(t, n, e) {
                var r = t == null ? 0 : t.length;
                if (!r) return -1;
                var u = e == null ? 0 : T(e);
                return u < 0 && (u = Q(r + u, 0)), Oe(t, E(n, 3), u);
            }
            function Gu(t, n, e) {
                var r = t == null ? 0 : t.length;
                if (!r) return -1;
                var u = r - 1;
                return e !== i && (u = T(e), u = e < 0 ? Q(r + u, 0) : nt(u, r - 1)), Oe(t, E(n, 3), u, !0);
            }
            function zu(t) {
                var n = t == null ? 0 : t.length;
                return n ? tt(t, 1) : [];
            }
            function $h(t) {
                var n = t == null ? 0 : t.length;
                return n ? tt(t, pn) : [];
            }
            function qh(t, n) {
                var e = t == null ? 0 : t.length;
                return e ? (n = n === i ? 1 : T(n), tt(t, n)) : [];
            }
            function Uh(t) {
                for(var n = -1, e = t == null ? 0 : t.length, r = {}; ++n < e;){
                    var u = t[n];
                    r[u[0]] = u[1];
                }
                return r;
            }
            function Ku(t) {
                return t && t.length ? t[0] : i;
            }
            function Fh(t, n, e) {
                var r = t == null ? 0 : t.length;
                if (!r) return -1;
                var u = e == null ? 0 : T(e);
                return u < 0 && (u = Q(r + u, 0)), Ln(t, n, u);
            }
            function Wh(t) {
                var n = t == null ? 0 : t.length;
                return n ? At(t, 0, -1) : [];
            }
            var Mh = H(function(t) {
                var n = z(t, oi);
                return n.length && n[0] === t[0] ? kr(n) : [];
            }), Bh = H(function(t) {
                var n = It(t), e = z(t, oi);
                return n === It(e) ? n = i : e.pop(), e.length && e[0] === t[0] ? kr(e, E(n, 2)) : [];
            }), Gh = H(function(t) {
                var n = It(t), e = z(t, oi);
                return n = typeof n == "function" ? n : i, n && e.pop(), e.length && e[0] === t[0] ? kr(e, i, n) : [];
            });
            function zh(t, n) {
                return t == null ? "" : Wf.call(t, n);
            }
            function It(t) {
                var n = t == null ? 0 : t.length;
                return n ? t[n - 1] : i;
            }
            function Kh(t, n, e) {
                var r = t == null ? 0 : t.length;
                if (!r) return -1;
                var u = r;
                return e !== i && (u = T(e), u = u < 0 ? Q(r + u, 0) : nt(u, r - 1)), n === n ? xf(t, n, u) : Oe(t, Es, u, !0);
            }
            function Jh(t, n) {
                return t && t.length ? eu(t, T(n)) : i;
            }
            var Yh = H(Ju);
            function Ju(t, n) {
                return t && t.length && n && n.length ? ei(t, n) : t;
            }
            function Zh(t, n, e) {
                return t && t.length && n && n.length ? ei(t, n, E(e, 2)) : t;
            }
            function Xh(t, n, e) {
                return t && t.length && n && n.length ? ei(t, n, i, e) : t;
            }
            var Qh = Zt(function(t, n) {
                var e = t == null ? 0 : t.length, r = Zr(t, n);
                return su(t, z(n, function(u) {
                    return Xt(u, e) ? +u : u;
                }).sort(gu)), r;
            });
            function Vh(t, n) {
                var e = [];
                if (!(t && t.length)) return e;
                var r = -1, u = [], o = t.length;
                for(n = E(n, 3); ++r < o;){
                    var f = t[r];
                    n(f, r, t) && (e.push(f), u.push(r));
                }
                return su(t, u), e;
            }
            function Ai(t) {
                return t == null ? t : zf.call(t);
            }
            function kh(t, n, e) {
                var r = t == null ? 0 : t.length;
                return r ? (e && typeof e != "number" && it(t, n, e) ? (n = 0, e = r) : (n = n == null ? 0 : T(n), e = e === i ? r : T(e)), At(t, n, e)) : [];
            }
            function jh(t, n) {
                return Ze(t, n);
            }
            function tl(t, n, e) {
                return si(t, n, E(e, 2));
            }
            function nl(t, n) {
                var e = t == null ? 0 : t.length;
                if (e) {
                    var r = Ze(t, n);
                    if (r < e && Rt(t[r], n)) return r;
                }
                return -1;
            }
            function el(t, n) {
                return Ze(t, n, !0);
            }
            function rl(t, n, e) {
                return si(t, n, E(e, 2), !0);
            }
            function il(t, n) {
                var e = t == null ? 0 : t.length;
                if (e) {
                    var r = Ze(t, n, !0) - 1;
                    if (Rt(t[r], n)) return r;
                }
                return -1;
            }
            function sl(t) {
                return t && t.length ? au(t) : [];
            }
            function ul(t, n) {
                return t && t.length ? au(t, E(n, 2)) : [];
            }
            function al(t) {
                var n = t == null ? 0 : t.length;
                return n ? At(t, 1, n) : [];
            }
            function ol(t, n, e) {
                return t && t.length ? (n = e || n === i ? 1 : T(n), At(t, 0, n < 0 ? 0 : n)) : [];
            }
            function fl(t, n, e) {
                var r = t == null ? 0 : t.length;
                return r ? (n = e || n === i ? 1 : T(n), n = r - n, At(t, n < 0 ? 0 : n, r)) : [];
            }
            function cl(t, n) {
                return t && t.length ? Xe(t, E(n, 3), !1, !0) : [];
            }
            function hl(t, n) {
                return t && t.length ? Xe(t, E(n, 3)) : [];
            }
            var ll = H(function(t) {
                return on(tt(t, 1, Y, !0));
            }), pl = H(function(t) {
                var n = It(t);
                return Y(n) && (n = i), on(tt(t, 1, Y, !0), E(n, 2));
            }), dl = H(function(t) {
                var n = It(t);
                return n = typeof n == "function" ? n : i, on(tt(t, 1, Y, !0), i, n);
            });
            function gl(t) {
                return t && t.length ? on(t) : [];
            }
            function vl(t, n) {
                return t && t.length ? on(t, E(n, 2)) : [];
            }
            function _l(t, n) {
                return n = typeof n == "function" ? n : i, t && t.length ? on(t, i, n) : [];
            }
            function Ii(t) {
                if (!(t && t.length)) return [];
                var n = 0;
                return t = en(t, function(e) {
                    if (Y(e)) return n = Q(e.length, n), !0;
                }), Wr(n, function(e) {
                    return z(t, qr(e));
                });
            }
            function Yu(t, n) {
                if (!(t && t.length)) return [];
                var e = Ii(t);
                return n == null ? e : z(e, function(r) {
                    return ct(n, i, r);
                });
            }
            var ml = H(function(t, n) {
                return Y(t) ? oe(t, n) : [];
            }), wl = H(function(t) {
                return ai(en(t, Y));
            }), Pl = H(function(t) {
                var n = It(t);
                return Y(n) && (n = i), ai(en(t, Y), E(n, 2));
            }), Cl = H(function(t) {
                var n = It(t);
                return n = typeof n == "function" ? n : i, ai(en(t, Y), i, n);
            }), Al = H(Ii);
            function Il(t, n) {
                return hu(t || [], n || [], ae);
            }
            function xl(t, n) {
                return hu(t || [], n || [], he);
            }
            var El = H(function(t) {
                var n = t.length, e = n > 1 ? t[n - 1] : i;
                return e = typeof e == "function" ? (t.pop(), e) : i, Yu(t, e);
            });
            function Zu(t) {
                var n = a(t);
                return n.__chain__ = !0, n;
            }
            function yl(t, n) {
                return n(t), t;
            }
            function ir(t, n) {
                return n(t);
            }
            var Sl = Zt(function(t) {
                var n = t.length, e = n ? t[0] : 0, r = this.__wrapped__, u = function(o) {
                    return Zr(o, t);
                };
                return n > 1 || this.__actions__.length || !(r instanceof N) || !Xt(e) ? this.thru(u) : (r = r.slice(e, +e + (n ? 1 : 0)), r.__actions__.push({
                    func: ir,
                    args: [
                        u
                    ],
                    thisArg: i
                }), new Pt(r, this.__chain__).thru(function(o) {
                    return n && !o.length && o.push(i), o;
                }));
            });
            function Ol() {
                return Zu(this);
            }
            function Rl() {
                return new Pt(this.value(), this.__chain__);
            }
            function bl() {
                this.__values__ === i && (this.__values__ = oa(this.value()));
                var t = this.__index__ >= this.__values__.length, n = t ? i : this.__values__[this.__index__++];
                return {
                    done: t,
                    value: n
                };
            }
            function Tl() {
                return this;
            }
            function Ll(t) {
                for(var n, e = this; e instanceof Ge;){
                    var r = Mu(e);
                    r.__index__ = 0, r.__values__ = i, n ? u.__wrapped__ = r : n = r;
                    var u = r;
                    e = e.__wrapped__;
                }
                return u.__wrapped__ = t, n;
            }
            function Hl() {
                var t = this.__wrapped__;
                if (t instanceof N) {
                    var n = t;
                    return this.__actions__.length && (n = new N(this)), n = n.reverse(), n.__actions__.push({
                        func: ir,
                        args: [
                            Ai
                        ],
                        thisArg: i
                    }), new Pt(n, this.__chain__);
                }
                return this.thru(Ai);
            }
            function Dl() {
                return cu(this.__wrapped__, this.__actions__);
            }
            var Nl = Qe(function(t, n, e) {
                W.call(t, e) ? ++t[e] : Jt(t, e, 1);
            });
            function $l(t, n, e) {
                var r = b(t) ? Is : yc;
                return e && it(t, n, e) && (n = i), r(t, E(n, 3));
            }
            function ql(t, n) {
                var e = b(t) ? en : Ys;
                return e(t, E(n, 3));
            }
            var Ul = Cu(Bu), Fl = Cu(Gu);
            function Wl(t, n) {
                return tt(sr(t, n), 1);
            }
            function Ml(t, n) {
                return tt(sr(t, n), pn);
            }
            function Bl(t, n, e) {
                return e = e === i ? 1 : T(e), tt(sr(t, n), e);
            }
            function Xu(t, n) {
                var e = b(t) ? mt : an;
                return e(t, E(n, 3));
            }
            function Qu(t, n) {
                var e = b(t) ? af : Js;
                return e(t, E(n, 3));
            }
            var Gl = Qe(function(t, n, e) {
                W.call(t, e) ? t[e].push(n) : Jt(t, e, [
                    n
                ]);
            });
            function zl(t, n, e, r) {
                t = at(t) ? t : zn(t), e = e && !r ? T(e) : 0;
                var u = t.length;
                return e < 0 && (e = Q(u + e, 0)), cr(t) ? e <= u && t.indexOf(n, e) > -1 : !!u && Ln(t, n, e) > -1;
            }
            var Kl = H(function(t, n, e) {
                var r = -1, u = typeof n == "function", o = at(t) ? d(t.length) : [];
                return an(t, function(f) {
                    o[++r] = u ? ct(n, f, e) : fe(f, n, e);
                }), o;
            }), Jl = Qe(function(t, n, e) {
                Jt(t, e, n);
            });
            function sr(t, n) {
                var e = b(t) ? z : js;
                return e(t, E(n, 3));
            }
            function Yl(t, n, e, r) {
                return t == null ? [] : (b(n) || (n = n == null ? [] : [
                    n
                ]), e = r ? i : e, b(e) || (e = e == null ? [] : [
                    e
                ]), ru(t, n, e));
            }
            var Zl = Qe(function(t, n, e) {
                t[e ? 0 : 1].push(n);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function Xl(t, n, e) {
                var r = b(t) ? Nr : Ss, u = arguments.length < 3;
                return r(t, E(n, 4), e, u, an);
            }
            function Ql(t, n, e) {
                var r = b(t) ? of : Ss, u = arguments.length < 3;
                return r(t, E(n, 4), e, u, Js);
            }
            function Vl(t, n) {
                var e = b(t) ? en : Ys;
                return e(t, or(E(n, 3)));
            }
            function kl(t) {
                var n = b(t) ? Bs : zc;
                return n(t);
            }
            function jl(t, n, e) {
                (e ? it(t, n, e) : n === i) ? n = 1 : n = T(n);
                var r = b(t) ? Cc : Kc;
                return r(t, n);
            }
            function tp(t) {
                var n = b(t) ? Ac : Yc;
                return n(t);
            }
            function np(t) {
                if (t == null) return 0;
                if (at(t)) return cr(t) ? Dn(t) : t.length;
                var n = et(t);
                return n == Et || n == yt ? t.size : ti(t).length;
            }
            function ep(t, n, e) {
                var r = b(t) ? $r : Zc;
                return e && it(t, n, e) && (n = i), r(t, E(n, 3));
            }
            var rp = H(function(t, n) {
                if (t == null) return [];
                var e = n.length;
                return e > 1 && it(t, n[0], n[1]) ? n = [] : e > 2 && it(n[0], n[1], n[2]) && (n = [
                    n[0]
                ]), ru(t, tt(n, 1), []);
            }), ur = qf || function() {
                return j.Date.now();
            };
            function ip(t, n) {
                if (typeof n != "function") throw new wt(O);
                return t = T(t), function() {
                    if (--t < 1) return n.apply(this, arguments);
                };
            }
            function Vu(t, n, e) {
                return n = e ? i : n, n = t && n == null ? t.length : n, Yt(t, Bt, i, i, i, i, n);
            }
            function ku(t, n) {
                var e;
                if (typeof n != "function") throw new wt(O);
                return t = T(t), function() {
                    return --t > 0 && (e = n.apply(this, arguments)), t <= 1 && (n = i), e;
                };
            }
            var xi = H(function(t, n, e) {
                var r = vt;
                if (e.length) {
                    var u = sn(e, Bn(xi));
                    r |= Nt;
                }
                return Yt(t, r, n, e, u);
            }), ju = H(function(t, n, e) {
                var r = vt | ln;
                if (e.length) {
                    var u = sn(e, Bn(ju));
                    r |= Nt;
                }
                return Yt(n, r, t, e, u);
            });
            function ta(t, n, e) {
                n = e ? i : n;
                var r = Yt(t, Dt, i, i, i, i, i, n);
                return r.placeholder = ta.placeholder, r;
            }
            function na(t, n, e) {
                n = e ? i : n;
                var r = Yt(t, Sn, i, i, i, i, i, n);
                return r.placeholder = na.placeholder, r;
            }
            function ea(t, n, e) {
                var r, u, o, f, c, l, v = 0, _ = !1, m = !1, C = !0;
                if (typeof t != "function") throw new wt(O);
                n = xt(n) || 0, K(e) && (_ = !!e.leading, m = "maxWait" in e, o = m ? Q(xt(e.maxWait) || 0, n) : o, C = "trailing" in e ? !!e.trailing : C);
                function I(Z) {
                    var bt = r, kt = u;
                    return r = u = i, v = Z, f = t.apply(kt, bt), f;
                }
                function y(Z) {
                    return v = Z, c = de(D, n), _ ? I(Z) : f;
                }
                function L(Z) {
                    var bt = Z - l, kt = Z - v, Ca = n - bt;
                    return m ? nt(Ca, o - kt) : Ca;
                }
                function S(Z) {
                    var bt = Z - l, kt = Z - v;
                    return l === i || bt >= n || bt < 0 || m && kt >= o;
                }
                function D() {
                    var Z = ur();
                    if (S(Z)) return $(Z);
                    c = de(D, L(Z));
                }
                function $(Z) {
                    return c = i, C && r ? I(Z) : (r = u = i, f);
                }
                function dt() {
                    c !== i && lu(c), v = 0, r = l = u = c = i;
                }
                function st() {
                    return c === i ? f : $(ur());
                }
                function gt() {
                    var Z = ur(), bt = S(Z);
                    if (r = arguments, u = this, l = Z, bt) {
                        if (c === i) return y(l);
                        if (m) return lu(c), c = de(D, n), I(l);
                    }
                    return c === i && (c = de(D, n)), f;
                }
                return gt.cancel = dt, gt.flush = st, gt;
            }
            var sp = H(function(t, n) {
                return Ks(t, 1, n);
            }), up = H(function(t, n, e) {
                return Ks(t, xt(n) || 0, e);
            });
            function ap(t) {
                return Yt(t, gr);
            }
            function ar(t, n) {
                if (typeof t != "function" || n != null && typeof n != "function") throw new wt(O);
                var e = function() {
                    var r = arguments, u = n ? n.apply(this, r) : r[0], o = e.cache;
                    if (o.has(u)) return o.get(u);
                    var f = t.apply(this, r);
                    return e.cache = o.set(u, f) || o, f;
                };
                return e.cache = new (ar.Cache || Kt), e;
            }
            ar.Cache = Kt;
            function or(t) {
                if (typeof t != "function") throw new wt(O);
                return function() {
                    var n = arguments;
                    switch(n.length){
                        case 0:
                            return !t.call(this);
                        case 1:
                            return !t.call(this, n[0]);
                        case 2:
                            return !t.call(this, n[0], n[1]);
                        case 3:
                            return !t.call(this, n[0], n[1], n[2]);
                    }
                    return !t.apply(this, n);
                };
            }
            function op(t) {
                return ku(2, t);
            }
            var fp = Xc(function(t, n) {
                n = n.length == 1 && b(n[0]) ? z(n[0], ht(E())) : z(tt(n, 1), ht(E()));
                var e = n.length;
                return H(function(r) {
                    for(var u = -1, o = nt(r.length, e); ++u < o;)r[u] = n[u].call(this, r[u]);
                    return ct(t, this, r);
                });
            }), Ei = H(function(t, n) {
                var e = sn(n, Bn(Ei));
                return Yt(t, Nt, i, n, e);
            }), ra = H(function(t, n) {
                var e = sn(n, Bn(ra));
                return Yt(t, On, i, n, e);
            }), cp = Zt(function(t, n) {
                return Yt(t, Yn, i, i, i, n);
            });
            function hp(t, n) {
                if (typeof t != "function") throw new wt(O);
                return n = n === i ? n : T(n), H(t, n);
            }
            function lp(t, n) {
                if (typeof t != "function") throw new wt(O);
                return n = n == null ? 0 : Q(T(n), 0), H(function(e) {
                    var r = e[n], u = cn(e, 0, n);
                    return r && rn(u, r), ct(t, this, u);
                });
            }
            function pp(t, n, e) {
                var r = !0, u = !0;
                if (typeof t != "function") throw new wt(O);
                return K(e) && (r = "leading" in e ? !!e.leading : r, u = "trailing" in e ? !!e.trailing : u), ea(t, n, {
                    leading: r,
                    maxWait: n,
                    trailing: u
                });
            }
            function dp(t) {
                return Vu(t, 1);
            }
            function gp(t, n) {
                return Ei(fi(n), t);
            }
            function vp() {
                if (!arguments.length) return [];
                var t = arguments[0];
                return b(t) ? t : [
                    t
                ];
            }
            function _p(t) {
                return Ct(t, En);
            }
            function mp(t, n) {
                return n = typeof n == "function" ? n : i, Ct(t, En, n);
            }
            function wp(t) {
                return Ct(t, Ht | En);
            }
            function Pp(t, n) {
                return n = typeof n == "function" ? n : i, Ct(t, Ht | En, n);
            }
            function Cp(t, n) {
                return n == null || zs(t, n, V(n));
            }
            function Rt(t, n) {
                return t === n || t !== t && n !== n;
            }
            var Ap = tr(Vr), Ip = tr(function(t, n) {
                return t >= n;
            }), An = Qs(function() {
                return arguments;
            }()) ? Qs : function(t) {
                return J(t) && W.call(t, "callee") && !$s.call(t, "callee");
            }, b = d.isArray, xp = _s ? ht(_s) : Lc;
            function at(t) {
                return t != null && fr(t.length) && !Qt(t);
            }
            function Y(t) {
                return J(t) && at(t);
            }
            function Ep(t) {
                return t === !0 || t === !1 || J(t) && rt(t) == Zn;
            }
            var hn = Ff || $i, yp = ms ? ht(ms) : Hc;
            function Sp(t) {
                return J(t) && t.nodeType === 1 && !ge(t);
            }
            function Op(t) {
                if (t == null) return !0;
                if (at(t) && (b(t) || typeof t == "string" || typeof t.splice == "function" || hn(t) || Gn(t) || An(t))) return !t.length;
                var n = et(t);
                if (n == Et || n == yt) return !t.size;
                if (pe(t)) return !ti(t).length;
                for(var e in t)if (W.call(t, e)) return !1;
                return !0;
            }
            function Rp(t, n) {
                return ce(t, n);
            }
            function bp(t, n, e) {
                e = typeof e == "function" ? e : i;
                var r = e ? e(t, n) : i;
                return r === i ? ce(t, n, i, e) : !!r;
            }
            function yi(t) {
                if (!J(t)) return !1;
                var n = rt(t);
                return n == Ce || n == Va || typeof t.message == "string" && typeof t.name == "string" && !ge(t);
            }
            function Tp(t) {
                return typeof t == "number" && Us(t);
            }
            function Qt(t) {
                if (!K(t)) return !1;
                var n = rt(t);
                return n == Ae || n == Ki || n == Qa || n == ja;
            }
            function ia(t) {
                return typeof t == "number" && t == T(t);
            }
            function fr(t) {
                return typeof t == "number" && t > -1 && t % 1 == 0 && t <= nn;
            }
            function K(t) {
                var n = typeof t;
                return t != null && (n == "object" || n == "function");
            }
            function J(t) {
                return t != null && typeof t == "object";
            }
            var sa = ws ? ht(ws) : Nc;
            function Lp(t, n) {
                return t === n || jr(t, n, vi(n));
            }
            function Hp(t, n, e) {
                return e = typeof e == "function" ? e : i, jr(t, n, vi(n), e);
            }
            function Dp(t) {
                return ua(t) && t != +t;
            }
            function Np(t) {
                if (mh(t)) throw new R(x);
                return Vs(t);
            }
            function $p(t) {
                return t === null;
            }
            function qp(t) {
                return t == null;
            }
            function ua(t) {
                return typeof t == "number" || J(t) && rt(t) == Qn;
            }
            function ge(t) {
                if (!J(t) || rt(t) != Gt) return !1;
                var n = $e(t);
                if (n === null) return !0;
                var e = W.call(n, "constructor") && n.constructor;
                return typeof e == "function" && e instanceof e && Le.call(e) == Hf;
            }
            var Si = Ps ? ht(Ps) : $c;
            function Up(t) {
                return ia(t) && t >= -nn && t <= nn;
            }
            var aa = Cs ? ht(Cs) : qc;
            function cr(t) {
                return typeof t == "string" || !b(t) && J(t) && rt(t) == kn;
            }
            function pt(t) {
                return typeof t == "symbol" || J(t) && rt(t) == Ie;
            }
            var Gn = As ? ht(As) : Uc;
            function Fp(t) {
                return t === i;
            }
            function Wp(t) {
                return J(t) && et(t) == jn;
            }
            function Mp(t) {
                return J(t) && rt(t) == no;
            }
            var Bp = tr(ni), Gp = tr(function(t, n) {
                return t <= n;
            });
            function oa(t) {
                if (!t) return [];
                if (at(t)) return cr(t) ? St(t) : ut(t);
                if (ee && t[ee]) return Cf(t[ee]());
                var n = et(t), e = n == Et ? Br : n == yt ? Re : zn;
                return e(t);
            }
            function Vt(t) {
                if (!t) return t === 0 ? t : 0;
                if (t = xt(t), t === pn || t === -pn) {
                    var n = t < 0 ? -1 : 1;
                    return n * Ja;
                }
                return t === t ? t : 0;
            }
            function T(t) {
                var n = Vt(t), e = n % 1;
                return n === n ? e ? n - e : n : 0;
            }
            function fa(t) {
                return t ? mn(T(t), 0, $t) : 0;
            }
            function xt(t) {
                if (typeof t == "number") return t;
                if (pt(t)) return we;
                if (K(t)) {
                    var n = typeof t.valueOf == "function" ? t.valueOf() : t;
                    t = K(n) ? n + "" : n;
                }
                if (typeof t != "string") return t === 0 ? t : +t;
                t = Os(t);
                var e = Io.test(t);
                return e || Eo.test(t) ? rf(t.slice(2), e ? 2 : 8) : Ao.test(t) ? we : +t;
            }
            function ca(t) {
                return Ut(t, ot(t));
            }
            function zp(t) {
                return t ? mn(T(t), -nn, nn) : t === 0 ? t : 0;
            }
            function U(t) {
                return t == null ? "" : lt(t);
            }
            var Kp = Wn(function(t, n) {
                if (pe(n) || at(n)) {
                    Ut(n, V(n), t);
                    return;
                }
                for(var e in n)W.call(n, e) && ae(t, e, n[e]);
            }), ha = Wn(function(t, n) {
                Ut(n, ot(n), t);
            }), hr = Wn(function(t, n, e, r) {
                Ut(n, ot(n), t, r);
            }), Jp = Wn(function(t, n, e, r) {
                Ut(n, V(n), t, r);
            }), Yp = Zt(Zr);
            function Zp(t, n) {
                var e = Fn(t);
                return n == null ? e : Gs(e, n);
            }
            var Xp = H(function(t, n) {
                t = M(t);
                var e = -1, r = n.length, u = r > 2 ? n[2] : i;
                for(u && it(n[0], n[1], u) && (r = 1); ++e < r;)for(var o = n[e], f = ot(o), c = -1, l = f.length; ++c < l;){
                    var v = f[c], _ = t[v];
                    (_ === i || Rt(_, $n[v]) && !W.call(t, v)) && (t[v] = o[v]);
                }
                return t;
            }), Qp = H(function(t) {
                return t.push(i, Ou), ct(la, i, t);
            });
            function Vp(t, n) {
                return xs(t, E(n, 3), qt);
            }
            function kp(t, n) {
                return xs(t, E(n, 3), Qr);
            }
            function jp(t, n) {
                return t == null ? t : Xr(t, E(n, 3), ot);
            }
            function td(t, n) {
                return t == null ? t : Zs(t, E(n, 3), ot);
            }
            function nd(t, n) {
                return t && qt(t, E(n, 3));
            }
            function ed(t, n) {
                return t && Qr(t, E(n, 3));
            }
            function rd(t) {
                return t == null ? [] : Je(t, V(t));
            }
            function id(t) {
                return t == null ? [] : Je(t, ot(t));
            }
            function Oi(t, n, e) {
                var r = t == null ? i : wn(t, n);
                return r === i ? e : r;
            }
            function sd(t, n) {
                return t != null && Tu(t, n, Oc);
            }
            function Ri(t, n) {
                return t != null && Tu(t, n, Rc);
            }
            var ud = Iu(function(t, n, e) {
                n != null && typeof n.toString != "function" && (n = He.call(n)), t[n] = e;
            }, Ti(ft)), ad = Iu(function(t, n, e) {
                n != null && typeof n.toString != "function" && (n = He.call(n)), W.call(t, n) ? t[n].push(e) : t[n] = [
                    e
                ];
            }, E), od = H(fe);
            function V(t) {
                return at(t) ? Ms(t) : ti(t);
            }
            function ot(t) {
                return at(t) ? Ms(t, !0) : Fc(t);
            }
            function fd(t, n) {
                var e = {};
                return n = E(n, 3), qt(t, function(r, u, o) {
                    Jt(e, n(r, u, o), r);
                }), e;
            }
            function cd(t, n) {
                var e = {};
                return n = E(n, 3), qt(t, function(r, u, o) {
                    Jt(e, u, n(r, u, o));
                }), e;
            }
            var hd = Wn(function(t, n, e) {
                Ye(t, n, e);
            }), la = Wn(function(t, n, e, r) {
                Ye(t, n, e, r);
            }), ld = Zt(function(t, n) {
                var e = {};
                if (t == null) return e;
                var r = !1;
                n = z(n, function(o) {
                    return o = fn(o, t), r || (r = o.length > 1), o;
                }), Ut(t, di(t), e), r && (e = Ct(e, Ht | Mt | En, uh));
                for(var u = n.length; u--;)ui(e, n[u]);
                return e;
            });
            function pd(t, n) {
                return pa(t, or(E(n)));
            }
            var dd = Zt(function(t, n) {
                return t == null ? {} : Mc(t, n);
            });
            function pa(t, n) {
                if (t == null) return {};
                var e = z(di(t), function(r) {
                    return [
                        r
                    ];
                });
                return n = E(n), iu(t, e, function(r, u) {
                    return n(r, u[0]);
                });
            }
            function gd(t, n, e) {
                n = fn(n, t);
                var r = -1, u = n.length;
                for(u || (u = 1, t = i); ++r < u;){
                    var o = t == null ? i : t[Ft(n[r])];
                    o === i && (r = u, o = e), t = Qt(o) ? o.call(t) : o;
                }
                return t;
            }
            function vd(t, n, e) {
                return t == null ? t : he(t, n, e);
            }
            function _d(t, n, e, r) {
                return r = typeof r == "function" ? r : i, t == null ? t : he(t, n, e, r);
            }
            var da = yu(V), ga = yu(ot);
            function md(t, n, e) {
                var r = b(t), u = r || hn(t) || Gn(t);
                if (n = E(n, 4), e == null) {
                    var o = t && t.constructor;
                    u ? e = r ? new o : [] : K(t) ? e = Qt(o) ? Fn($e(t)) : {} : e = {};
                }
                return (u ? mt : qt)(t, function(f, c, l) {
                    return n(e, f, c, l);
                }), e;
            }
            function wd(t, n) {
                return t == null ? !0 : ui(t, n);
            }
            function Pd(t, n, e) {
                return t == null ? t : fu(t, n, fi(e));
            }
            function Cd(t, n, e, r) {
                return r = typeof r == "function" ? r : i, t == null ? t : fu(t, n, fi(e), r);
            }
            function zn(t) {
                return t == null ? [] : Mr(t, V(t));
            }
            function Ad(t) {
                return t == null ? [] : Mr(t, ot(t));
            }
            function Id(t, n, e) {
                return e === i && (e = n, n = i), e !== i && (e = xt(e), e = e === e ? e : 0), n !== i && (n = xt(n), n = n === n ? n : 0), mn(xt(t), n, e);
            }
            function xd(t, n, e) {
                return n = Vt(n), e === i ? (e = n, n = 0) : e = Vt(e), t = xt(t), bc(t, n, e);
            }
            function Ed(t, n, e) {
                if (e && typeof e != "boolean" && it(t, n, e) && (n = e = i), e === i && (typeof n == "boolean" ? (e = n, n = i) : typeof t == "boolean" && (e = t, t = i)), t === i && n === i ? (t = 0, n = 1) : (t = Vt(t), n === i ? (n = t, t = 0) : n = Vt(n)), t > n) {
                    var r = t;
                    t = n, n = r;
                }
                if (e || t % 1 || n % 1) {
                    var u = Fs();
                    return nt(t + u * (n - t + ef("1e-" + ((u + "").length - 1))), n);
                }
                return ri(t, n);
            }
            var yd = Mn(function(t, n, e) {
                return n = n.toLowerCase(), t + (e ? va(n) : n);
            });
            function va(t) {
                return bi(U(t).toLowerCase());
            }
            function _a(t) {
                return t = U(t), t && t.replace(So, vf).replace(Jo, "");
            }
            function Sd(t, n, e) {
                t = U(t), n = lt(n);
                var r = t.length;
                e = e === i ? r : mn(T(e), 0, r);
                var u = e;
                return e -= n.length, e >= 0 && t.slice(e, u) == n;
            }
            function Od(t) {
                return t = U(t), t && uo.test(t) ? t.replace(Zi, _f) : t;
            }
            function Rd(t) {
                return t = U(t), t && lo.test(t) ? t.replace(Er, "\\$&") : t;
            }
            var bd = Mn(function(t, n, e) {
                return t + (e ? "-" : "") + n.toLowerCase();
            }), Td = Mn(function(t, n, e) {
                return t + (e ? " " : "") + n.toLowerCase();
            }), Ld = Pu("toLowerCase");
            function Hd(t, n, e) {
                t = U(t), n = T(n);
                var r = n ? Dn(t) : 0;
                if (!n || r >= n) return t;
                var u = (n - r) / 2;
                return je(We(u), e) + t + je(Fe(u), e);
            }
            function Dd(t, n, e) {
                t = U(t), n = T(n);
                var r = n ? Dn(t) : 0;
                return n && r < n ? t + je(n - r, e) : t;
            }
            function Nd(t, n, e) {
                t = U(t), n = T(n);
                var r = n ? Dn(t) : 0;
                return n && r < n ? je(n - r, e) + t : t;
            }
            function $d(t, n, e) {
                return e || n == null ? n = 0 : n && (n = +n), Gf(U(t).replace(yr, ""), n || 0);
            }
            function qd(t, n, e) {
                return (e ? it(t, n, e) : n === i) ? n = 1 : n = T(n), ii(U(t), n);
            }
            function Ud() {
                var t = arguments, n = U(t[0]);
                return t.length < 3 ? n : n.replace(t[1], t[2]);
            }
            var Fd = Mn(function(t, n, e) {
                return t + (e ? "_" : "") + n.toLowerCase();
            });
            function Wd(t, n, e) {
                return e && typeof e != "number" && it(t, n, e) && (n = e = i), e = e === i ? $t : e >>> 0, e ? (t = U(t), t && (typeof n == "string" || n != null && !Si(n)) && (n = lt(n), !n && Hn(t)) ? cn(St(t), 0, e) : t.split(n, e)) : [];
            }
            var Md = Mn(function(t, n, e) {
                return t + (e ? " " : "") + bi(n);
            });
            function Bd(t, n, e) {
                return t = U(t), e = e == null ? 0 : mn(T(e), 0, t.length), n = lt(n), t.slice(e, e + n.length) == n;
            }
            function Gd(t, n, e) {
                var r = a.templateSettings;
                e && it(t, n, e) && (n = i), t = U(t), n = hr({}, n, r, Su);
                var u = hr({}, n.imports, r.imports, Su), o = V(u), f = Mr(u, o), c, l, v = 0, _ = n.interpolate || xe, m = "__p += '", C = Gr((n.escape || xe).source + "|" + _.source + "|" + (_ === Xi ? Co : xe).source + "|" + (n.evaluate || xe).source + "|$", "g"), I = "//# sourceURL=" + (W.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Vo + "]") + `
`;
                t.replace(C, function(S, D, $, dt, st, gt) {
                    return $ || ($ = dt), m += t.slice(v, gt).replace(Oo, mf), D && (c = !0, m += `' +
__e(` + D + `) +
'`), st && (l = !0, m += `';
` + st + `;
__p += '`), $ && (m += `' +
((__t = (` + $ + `)) == null ? '' : __t) +
'`), v = gt + S.length, S;
                }), m += `';
`;
                var y = W.call(n, "variable") && n.variable;
                if (!y) m = `with (obj) {
` + m + `
}
`;
                else if (wo.test(y)) throw new R(k);
                m = (l ? m.replace(eo, "") : m).replace(ro, "$1").replace(io, "$1;"), m = "function(" + (y || "obj") + `) {
` + (y ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + m + `return __p
}`;
                var L = wa(function() {
                    return q(o, I + "return " + m).apply(i, f);
                });
                if (L.source = m, yi(L)) throw L;
                return L;
            }
            function zd(t) {
                return U(t).toLowerCase();
            }
            function Kd(t) {
                return U(t).toUpperCase();
            }
            function Jd(t, n, e) {
                if (t = U(t), t && (e || n === i)) return Os(t);
                if (!t || !(n = lt(n))) return t;
                var r = St(t), u = St(n), o = Rs(r, u), f = bs(r, u) + 1;
                return cn(r, o, f).join("");
            }
            function Yd(t, n, e) {
                if (t = U(t), t && (e || n === i)) return t.slice(0, Ls(t) + 1);
                if (!t || !(n = lt(n))) return t;
                var r = St(t), u = bs(r, St(n)) + 1;
                return cn(r, 0, u).join("");
            }
            function Zd(t, n, e) {
                if (t = U(t), t && (e || n === i)) return t.replace(yr, "");
                if (!t || !(n = lt(n))) return t;
                var r = St(t), u = Rs(r, St(n));
                return cn(r, u).join("");
            }
            function Xd(t, n) {
                var e = Wa, r = Ma;
                if (K(n)) {
                    var u = "separator" in n ? n.separator : u;
                    e = "length" in n ? T(n.length) : e, r = "omission" in n ? lt(n.omission) : r;
                }
                t = U(t);
                var o = t.length;
                if (Hn(t)) {
                    var f = St(t);
                    o = f.length;
                }
                if (e >= o) return t;
                var c = e - Dn(r);
                if (c < 1) return r;
                var l = f ? cn(f, 0, c).join("") : t.slice(0, c);
                if (u === i) return l + r;
                if (f && (c += l.length - c), Si(u)) {
                    if (t.slice(c).search(u)) {
                        var v, _ = l;
                        for(u.global || (u = Gr(u.source, U(Qi.exec(u)) + "g")), u.lastIndex = 0; v = u.exec(_);)var m = v.index;
                        l = l.slice(0, m === i ? c : m);
                    }
                } else if (t.indexOf(lt(u), c) != c) {
                    var C = l.lastIndexOf(u);
                    C > -1 && (l = l.slice(0, C));
                }
                return l + r;
            }
            function Qd(t) {
                return t = U(t), t && so.test(t) ? t.replace(Yi, Ef) : t;
            }
            var Vd = Mn(function(t, n, e) {
                return t + (e ? " " : "") + n.toUpperCase();
            }), bi = Pu("toUpperCase");
            function ma(t, n, e) {
                return t = U(t), n = e ? i : n, n === i ? Pf(t) ? Of(t) : hf(t) : t.match(n) || [];
            }
            var wa = H(function(t, n) {
                try {
                    return ct(t, i, n);
                } catch (e) {
                    return yi(e) ? e : new R(e);
                }
            }), kd = Zt(function(t, n) {
                return mt(n, function(e) {
                    e = Ft(e), Jt(t, e, xi(t[e], t));
                }), t;
            });
            function jd(t) {
                var n = t == null ? 0 : t.length, e = E();
                return t = n ? z(t, function(r) {
                    if (typeof r[1] != "function") throw new wt(O);
                    return [
                        e(r[0]),
                        r[1]
                    ];
                }) : [], H(function(r) {
                    for(var u = -1; ++u < n;){
                        var o = t[u];
                        if (ct(o[0], this, r)) return ct(o[1], this, r);
                    }
                });
            }
            function tg(t) {
                return Ec(Ct(t, Ht));
            }
            function Ti(t) {
                return function() {
                    return t;
                };
            }
            function ng(t, n) {
                return t == null || t !== t ? n : t;
            }
            var eg = Au(), rg = Au(!0);
            function ft(t) {
                return t;
            }
            function Li(t) {
                return ks(typeof t == "function" ? t : Ct(t, Ht));
            }
            function ig(t) {
                return tu(Ct(t, Ht));
            }
            function sg(t, n) {
                return nu(t, Ct(n, Ht));
            }
            var ug = H(function(t, n) {
                return function(e) {
                    return fe(e, t, n);
                };
            }), ag = H(function(t, n) {
                return function(e) {
                    return fe(t, e, n);
                };
            });
            function Hi(t, n, e) {
                var r = V(n), u = Je(n, r);
                e == null && !(K(n) && (u.length || !r.length)) && (e = n, n = t, t = this, u = Je(n, V(n)));
                var o = !(K(e) && "chain" in e) || !!e.chain, f = Qt(t);
                return mt(u, function(c) {
                    var l = n[c];
                    t[c] = l, f && (t.prototype[c] = function() {
                        var v = this.__chain__;
                        if (o || v) {
                            var _ = t(this.__wrapped__), m = _.__actions__ = ut(this.__actions__);
                            return m.push({
                                func: l,
                                args: arguments,
                                thisArg: t
                            }), _.__chain__ = v, _;
                        }
                        return l.apply(t, rn([
                            this.value()
                        ], arguments));
                    });
                }), t;
            }
            function og() {
                return j._ === this && (j._ = Df), this;
            }
            function Di() {}
            function fg(t) {
                return t = T(t), H(function(n) {
                    return eu(n, t);
                });
            }
            var cg = hi(z), hg = hi(Is), lg = hi($r);
            function Pa(t) {
                return mi(t) ? qr(Ft(t)) : Bc(t);
            }
            function pg(t) {
                return function(n) {
                    return t == null ? i : wn(t, n);
                };
            }
            var dg = xu(), gg = xu(!0);
            function Ni() {
                return [];
            }
            function $i() {
                return !1;
            }
            function vg() {
                return {};
            }
            function _g() {
                return "";
            }
            function mg() {
                return !0;
            }
            function wg(t, n) {
                if (t = T(t), t < 1 || t > nn) return [];
                var e = $t, r = nt(t, $t);
                n = E(n), t -= $t;
                for(var u = Wr(r, n); ++e < t;)n(e);
                return u;
            }
            function Pg(t) {
                return b(t) ? z(t, Ft) : pt(t) ? [
                    t
                ] : ut(Wu(U(t)));
            }
            function Cg(t) {
                var n = ++Lf;
                return U(t) + n;
            }
            var Ag = ke(function(t, n) {
                return t + n;
            }, 0), Ig = li("ceil"), xg = ke(function(t, n) {
                return t / n;
            }, 1), Eg = li("floor");
            function yg(t) {
                return t && t.length ? Ke(t, ft, Vr) : i;
            }
            function Sg(t, n) {
                return t && t.length ? Ke(t, E(n, 2), Vr) : i;
            }
            function Og(t) {
                return ys(t, ft);
            }
            function Rg(t, n) {
                return ys(t, E(n, 2));
            }
            function bg(t) {
                return t && t.length ? Ke(t, ft, ni) : i;
            }
            function Tg(t, n) {
                return t && t.length ? Ke(t, E(n, 2), ni) : i;
            }
            var Lg = ke(function(t, n) {
                return t * n;
            }, 1), Hg = li("round"), Dg = ke(function(t, n) {
                return t - n;
            }, 0);
            function Ng(t) {
                return t && t.length ? Fr(t, ft) : 0;
            }
            function $g(t, n) {
                return t && t.length ? Fr(t, E(n, 2)) : 0;
            }
            return a.after = ip, a.ary = Vu, a.assign = Kp, a.assignIn = ha, a.assignInWith = hr, a.assignWith = Jp, a.at = Yp, a.before = ku, a.bind = xi, a.bindAll = kd, a.bindKey = ju, a.castArray = vp, a.chain = Zu, a.chunk = Eh, a.compact = yh, a.concat = Sh, a.cond = jd, a.conforms = tg, a.constant = Ti, a.countBy = Nl, a.create = Zp, a.curry = ta, a.curryRight = na, a.debounce = ea, a.defaults = Xp, a.defaultsDeep = Qp, a.defer = sp, a.delay = up, a.difference = Oh, a.differenceBy = Rh, a.differenceWith = bh, a.drop = Th, a.dropRight = Lh, a.dropRightWhile = Hh, a.dropWhile = Dh, a.fill = Nh, a.filter = ql, a.flatMap = Wl, a.flatMapDeep = Ml, a.flatMapDepth = Bl, a.flatten = zu, a.flattenDeep = $h, a.flattenDepth = qh, a.flip = ap, a.flow = eg, a.flowRight = rg, a.fromPairs = Uh, a.functions = rd, a.functionsIn = id, a.groupBy = Gl, a.initial = Wh, a.intersection = Mh, a.intersectionBy = Bh, a.intersectionWith = Gh, a.invert = ud, a.invertBy = ad, a.invokeMap = Kl, a.iteratee = Li, a.keyBy = Jl, a.keys = V, a.keysIn = ot, a.map = sr, a.mapKeys = fd, a.mapValues = cd, a.matches = ig, a.matchesProperty = sg, a.memoize = ar, a.merge = hd, a.mergeWith = la, a.method = ug, a.methodOf = ag, a.mixin = Hi, a.negate = or, a.nthArg = fg, a.omit = ld, a.omitBy = pd, a.once = op, a.orderBy = Yl, a.over = cg, a.overArgs = fp, a.overEvery = hg, a.overSome = lg, a.partial = Ei, a.partialRight = ra, a.partition = Zl, a.pick = dd, a.pickBy = pa, a.property = Pa, a.propertyOf = pg, a.pull = Yh, a.pullAll = Ju, a.pullAllBy = Zh, a.pullAllWith = Xh, a.pullAt = Qh, a.range = dg, a.rangeRight = gg, a.rearg = cp, a.reject = Vl, a.remove = Vh, a.rest = hp, a.reverse = Ai, a.sampleSize = jl, a.set = vd, a.setWith = _d, a.shuffle = tp, a.slice = kh, a.sortBy = rp, a.sortedUniq = sl, a.sortedUniqBy = ul, a.split = Wd, a.spread = lp, a.tail = al, a.take = ol, a.takeRight = fl, a.takeRightWhile = cl, a.takeWhile = hl, a.tap = yl, a.throttle = pp, a.thru = ir, a.toArray = oa, a.toPairs = da, a.toPairsIn = ga, a.toPath = Pg, a.toPlainObject = ca, a.transform = md, a.unary = dp, a.union = ll, a.unionBy = pl, a.unionWith = dl, a.uniq = gl, a.uniqBy = vl, a.uniqWith = _l, a.unset = wd, a.unzip = Ii, a.unzipWith = Yu, a.update = Pd, a.updateWith = Cd, a.values = zn, a.valuesIn = Ad, a.without = ml, a.words = ma, a.wrap = gp, a.xor = wl, a.xorBy = Pl, a.xorWith = Cl, a.zip = Al, a.zipObject = Il, a.zipObjectDeep = xl, a.zipWith = El, a.entries = da, a.entriesIn = ga, a.extend = ha, a.extendWith = hr, Hi(a, a), a.add = Ag, a.attempt = wa, a.camelCase = yd, a.capitalize = va, a.ceil = Ig, a.clamp = Id, a.clone = _p, a.cloneDeep = wp, a.cloneDeepWith = Pp, a.cloneWith = mp, a.conformsTo = Cp, a.deburr = _a, a.defaultTo = ng, a.divide = xg, a.endsWith = Sd, a.eq = Rt, a.escape = Od, a.escapeRegExp = Rd, a.every = $l, a.find = Ul, a.findIndex = Bu, a.findKey = Vp, a.findLast = Fl, a.findLastIndex = Gu, a.findLastKey = kp, a.floor = Eg, a.forEach = Xu, a.forEachRight = Qu, a.forIn = jp, a.forInRight = td, a.forOwn = nd, a.forOwnRight = ed, a.get = Oi, a.gt = Ap, a.gte = Ip, a.has = sd, a.hasIn = Ri, a.head = Ku, a.identity = ft, a.includes = zl, a.indexOf = Fh, a.inRange = xd, a.invoke = od, a.isArguments = An, a.isArray = b, a.isArrayBuffer = xp, a.isArrayLike = at, a.isArrayLikeObject = Y, a.isBoolean = Ep, a.isBuffer = hn, a.isDate = yp, a.isElement = Sp, a.isEmpty = Op, a.isEqual = Rp, a.isEqualWith = bp, a.isError = yi, a.isFinite = Tp, a.isFunction = Qt, a.isInteger = ia, a.isLength = fr, a.isMap = sa, a.isMatch = Lp, a.isMatchWith = Hp, a.isNaN = Dp, a.isNative = Np, a.isNil = qp, a.isNull = $p, a.isNumber = ua, a.isObject = K, a.isObjectLike = J, a.isPlainObject = ge, a.isRegExp = Si, a.isSafeInteger = Up, a.isSet = aa, a.isString = cr, a.isSymbol = pt, a.isTypedArray = Gn, a.isUndefined = Fp, a.isWeakMap = Wp, a.isWeakSet = Mp, a.join = zh, a.kebabCase = bd, a.last = It, a.lastIndexOf = Kh, a.lowerCase = Td, a.lowerFirst = Ld, a.lt = Bp, a.lte = Gp, a.max = yg, a.maxBy = Sg, a.mean = Og, a.meanBy = Rg, a.min = bg, a.minBy = Tg, a.stubArray = Ni, a.stubFalse = $i, a.stubObject = vg, a.stubString = _g, a.stubTrue = mg, a.multiply = Lg, a.nth = Jh, a.noConflict = og, a.noop = Di, a.now = ur, a.pad = Hd, a.padEnd = Dd, a.padStart = Nd, a.parseInt = $d, a.random = Ed, a.reduce = Xl, a.reduceRight = Ql, a.repeat = qd, a.replace = Ud, a.result = gd, a.round = Hg, a.runInContext = h, a.sample = kl, a.size = np, a.snakeCase = Fd, a.some = ep, a.sortedIndex = jh, a.sortedIndexBy = tl, a.sortedIndexOf = nl, a.sortedLastIndex = el, a.sortedLastIndexBy = rl, a.sortedLastIndexOf = il, a.startCase = Md, a.startsWith = Bd, a.subtract = Dg, a.sum = Ng, a.sumBy = $g, a.template = Gd, a.times = wg, a.toFinite = Vt, a.toInteger = T, a.toLength = fa, a.toLower = zd, a.toNumber = xt, a.toSafeInteger = zp, a.toString = U, a.toUpper = Kd, a.trim = Jd, a.trimEnd = Yd, a.trimStart = Zd, a.truncate = Xd, a.unescape = Qd, a.uniqueId = Cg, a.upperCase = Vd, a.upperFirst = bi, a.each = Xu, a.eachRight = Qu, a.first = Ku, Hi(a, function() {
                var t = {};
                return qt(a, function(n, e) {
                    W.call(a.prototype, e) || (t[e] = n);
                }), t;
            }(), {
                chain: !1
            }), a.VERSION = p, mt([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(t) {
                a[t].placeholder = a;
            }), mt([
                "drop",
                "take"
            ], function(t, n) {
                N.prototype[t] = function(e) {
                    e = e === i ? 1 : Q(T(e), 0);
                    var r = this.__filtered__ && !n ? new N(this) : this.clone();
                    return r.__filtered__ ? r.__takeCount__ = nt(e, r.__takeCount__) : r.__views__.push({
                        size: nt(e, $t),
                        type: t + (r.__dir__ < 0 ? "Right" : "")
                    }), r;
                }, N.prototype[t + "Right"] = function(e) {
                    return this.reverse()[t](e).reverse();
                };
            }), mt([
                "filter",
                "map",
                "takeWhile"
            ], function(t, n) {
                var e = n + 1, r = e == zi || e == Ka;
                N.prototype[t] = function(u) {
                    var o = this.clone();
                    return o.__iteratees__.push({
                        iteratee: E(u, 3),
                        type: e
                    }), o.__filtered__ = o.__filtered__ || r, o;
                };
            }), mt([
                "head",
                "last"
            ], function(t, n) {
                var e = "take" + (n ? "Right" : "");
                N.prototype[t] = function() {
                    return this[e](1).value()[0];
                };
            }), mt([
                "initial",
                "tail"
            ], function(t, n) {
                var e = "drop" + (n ? "" : "Right");
                N.prototype[t] = function() {
                    return this.__filtered__ ? new N(this) : this[e](1);
                };
            }), N.prototype.compact = function() {
                return this.filter(ft);
            }, N.prototype.find = function(t) {
                return this.filter(t).head();
            }, N.prototype.findLast = function(t) {
                return this.reverse().find(t);
            }, N.prototype.invokeMap = H(function(t, n) {
                return typeof t == "function" ? new N(this) : this.map(function(e) {
                    return fe(e, t, n);
                });
            }), N.prototype.reject = function(t) {
                return this.filter(or(E(t)));
            }, N.prototype.slice = function(t, n) {
                t = T(t);
                var e = this;
                return e.__filtered__ && (t > 0 || n < 0) ? new N(e) : (t < 0 ? e = e.takeRight(-t) : t && (e = e.drop(t)), n !== i && (n = T(n), e = n < 0 ? e.dropRight(-n) : e.take(n - t)), e);
            }, N.prototype.takeRightWhile = function(t) {
                return this.reverse().takeWhile(t).reverse();
            }, N.prototype.toArray = function() {
                return this.take($t);
            }, qt(N.prototype, function(t, n) {
                var e = /^(?:filter|find|map|reject)|While$/.test(n), r = /^(?:head|last)$/.test(n), u = a[r ? "take" + (n == "last" ? "Right" : "") : n], o = r || /^find/.test(n);
                u && (a.prototype[n] = function() {
                    var f = this.__wrapped__, c = r ? [
                        1
                    ] : arguments, l = f instanceof N, v = c[0], _ = l || b(f), m = function(D) {
                        var $ = u.apply(a, rn([
                            D
                        ], c));
                        return r && C ? $[0] : $;
                    };
                    _ && e && typeof v == "function" && v.length != 1 && (l = _ = !1);
                    var C = this.__chain__, I = !!this.__actions__.length, y = o && !C, L = l && !I;
                    if (!o && _) {
                        f = L ? f : new N(this);
                        var S = t.apply(f, c);
                        return S.__actions__.push({
                            func: ir,
                            args: [
                                m
                            ],
                            thisArg: i
                        }), new Pt(S, C);
                    }
                    return y && L ? t.apply(this, c) : (S = this.thru(m), y ? r ? S.value()[0] : S.value() : S);
                });
            }), mt([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(t) {
                var n = be[t], e = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(t);
                a.prototype[t] = function() {
                    var u = arguments;
                    if (r && !this.__chain__) {
                        var o = this.value();
                        return n.apply(b(o) ? o : [], u);
                    }
                    return this[e](function(f) {
                        return n.apply(b(f) ? f : [], u);
                    });
                };
            }), qt(N.prototype, function(t, n) {
                var e = a[n];
                if (e) {
                    var r = e.name + "";
                    W.call(Un, r) || (Un[r] = []), Un[r].push({
                        name: n,
                        func: e
                    });
                }
            }), Un[Ve(i, ln).name] = [
                {
                    name: "wrapper",
                    func: i
                }
            ], N.prototype.clone = Qf, N.prototype.reverse = Vf, N.prototype.value = kf, a.prototype.at = Sl, a.prototype.chain = Ol, a.prototype.commit = Rl, a.prototype.next = bl, a.prototype.plant = Ll, a.prototype.reverse = Hl, a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = Dl, a.prototype.first = a.prototype.head, ee && (a.prototype[ee] = Tl), a;
        }, Nn = Rf();
        dn ? ((dn.exports = Nn)._ = Nn, Lr._ = Nn) : j._ = Nn;
    }).call($6d522931de1c17ec$var$_e);
})($6d522931de1c17ec$var$Ui, $6d522931de1c17ec$var$Ui.exports);
var $6d522931de1c17ec$var$Xg = Object.defineProperty, $6d522931de1c17ec$var$Qg = Object.defineProperties, $6d522931de1c17ec$var$Vg = Object.getOwnPropertyDescriptors, $6d522931de1c17ec$var$Oa = Object.getOwnPropertySymbols, $6d522931de1c17ec$var$kg = Object.prototype.hasOwnProperty, $6d522931de1c17ec$var$jg = Object.prototype.propertyIsEnumerable, $6d522931de1c17ec$var$Ra = (P, s, i)=>s in P ? $6d522931de1c17ec$var$Xg(P, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : P[s] = i, $6d522931de1c17ec$var$lr = (P, s)=>{
    for(var i in s || (s = {}))$6d522931de1c17ec$var$kg.call(s, i) && $6d522931de1c17ec$var$Ra(P, i, s[i]);
    if ($6d522931de1c17ec$var$Oa) for (var i of $6d522931de1c17ec$var$Oa(s))$6d522931de1c17ec$var$jg.call(s, i) && $6d522931de1c17ec$var$Ra(P, i, s[i]);
    return P;
}, $6d522931de1c17ec$var$tv = (P, s)=>$6d522931de1c17ec$var$Qg(P, $6d522931de1c17ec$var$Vg(s));
function $6d522931de1c17ec$var$Lt(P, s, i) {
    var p;
    const w = (0, $iN1TF.parseChainId)(P);
    return ((p = s.rpcMap) == null ? void 0 : p[w.reference]) || `${$6d522931de1c17ec$var$Zg}?chainId=${w.namespace}:${w.reference}&projectId=${i}`;
}
function $6d522931de1c17ec$var$In(P) {
    return P.includes(":") ? P.split(":")[1] : P;
}
function $6d522931de1c17ec$var$ba(P) {
    return P.map((s)=>`${s.split(":")[0]}:${s.split(":")[1]}`);
}
function $6d522931de1c17ec$var$nv(P, s) {
    const i = Object.keys(s.namespaces).filter((w)=>w.includes(P));
    if (!i.length) return [];
    const p = [];
    return i.forEach((w)=>{
        const x = s.namespaces[w].accounts;
        p.push(...x);
    }), p;
}
function $6d522931de1c17ec$var$Fi(P = {}, s = {}) {
    const i = $6d522931de1c17ec$var$Ta(P), p = $6d522931de1c17ec$var$Ta(s);
    return $6d522931de1c17ec$var$Ui.exports.merge(i, p);
}
function $6d522931de1c17ec$var$Ta(P) {
    var s, i, p, w;
    const x = {};
    if (!(0, $iN1TF.isValidObject)(P)) return x;
    for (const [O, k] of Object.entries(P)){
        const tn = (0, $iN1TF.isCaipNamespace)(O) ? [
            O
        ] : k.chains, Jn = k.methods || [], xn = k.events || [], Ht = k.rpcMap || {}, Mt = (0, $iN1TF.parseNamespaceKey)(O);
        x[Mt] = $6d522931de1c17ec$var$tv($6d522931de1c17ec$var$lr($6d522931de1c17ec$var$lr({}, x[Mt]), k), {
            chains: (0, $iN1TF.mergeArrays)(tn, (s = x[Mt]) == null ? void 0 : s.chains),
            methods: (0, $iN1TF.mergeArrays)(Jn, (i = x[Mt]) == null ? void 0 : i.methods),
            events: (0, $iN1TF.mergeArrays)(xn, (p = x[Mt]) == null ? void 0 : p.events),
            rpcMap: $6d522931de1c17ec$var$lr($6d522931de1c17ec$var$lr({}, Ht), (w = x[Mt]) == null ? void 0 : w.rpcMap)
        });
    }
    return x;
}
function $6d522931de1c17ec$var$ev(P) {
    return P.includes(":") ? P.split(":")[2] : P;
}
function $6d522931de1c17ec$var$La(P) {
    const s = {};
    for (const [i, p] of Object.entries(P)){
        const w = p.methods || [], x = p.events || [], O = p.accounts || [], k = (0, $iN1TF.isCaipNamespace)(i) ? [
            i
        ] : p.chains ? p.chains : $6d522931de1c17ec$var$ba(p.accounts);
        s[i] = {
            chains: k,
            methods: w,
            events: x,
            accounts: O
        };
    }
    return s;
}
function $6d522931de1c17ec$var$Wi(P) {
    return typeof P == "number" ? P : P.includes("0x") ? parseInt(P, 16) : (P = P.includes(":") ? P.split(":")[1] : P, isNaN(Number(P)) ? P : Number(P));
}
const $6d522931de1c17ec$var$Ha = {}, $6d522931de1c17ec$var$F = (P)=>$6d522931de1c17ec$var$Ha[P], $6d522931de1c17ec$var$Mi = (P, s)=>{
    $6d522931de1c17ec$var$Ha[P] = s;
};
class $6d522931de1c17ec$var$rv {
    constructor(s){
        this.name = "polkadot", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    setDefaultChain(s, i) {
        this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${s}`);
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $6d522931de1c17ec$var$In(i);
            s[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), s;
    }
    getHttpProvider() {
        const s = `${this.name}:${this.chainId}`, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(s, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
        return new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
var $6d522931de1c17ec$var$iv = Object.defineProperty, $6d522931de1c17ec$var$sv = Object.defineProperties, $6d522931de1c17ec$var$uv = Object.getOwnPropertyDescriptors, $6d522931de1c17ec$var$Da = Object.getOwnPropertySymbols, $6d522931de1c17ec$var$av = Object.prototype.hasOwnProperty, $6d522931de1c17ec$var$ov = Object.prototype.propertyIsEnumerable, $6d522931de1c17ec$var$Na = (P, s, i)=>s in P ? $6d522931de1c17ec$var$iv(P, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : P[s] = i, $6d522931de1c17ec$var$$a = (P, s)=>{
    for(var i in s || (s = {}))$6d522931de1c17ec$var$av.call(s, i) && $6d522931de1c17ec$var$Na(P, i, s[i]);
    if ($6d522931de1c17ec$var$Da) for (var i of $6d522931de1c17ec$var$Da(s))$6d522931de1c17ec$var$ov.call(s, i) && $6d522931de1c17ec$var$Na(P, i, s[i]);
    return P;
}, $6d522931de1c17ec$var$qa = (P, s)=>$6d522931de1c17ec$var$sv(P, $6d522931de1c17ec$var$uv(s));
class $6d522931de1c17ec$var$fv {
    constructor(s){
        this.name = "eip155", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
    }
    async request(s) {
        switch(s.request.method){
            case "eth_requestAccounts":
                return this.getAccounts();
            case "eth_accounts":
                return this.getAccounts();
            case "wallet_switchEthereumChain":
                return await this.handleSwitchChain(s);
            case "eth_chainId":
                return parseInt(this.getDefaultChain());
            case "wallet_getCapabilities":
                return await this.getCapabilities(s);
        }
        return this.namespace.methods.includes(s.request.method) ? await this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    setDefaultChain(s, i) {
        this.httpProviders[s] || this.setHttpProvider(parseInt(s), i), this.chainId = parseInt(s), this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${s}`);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId.toString();
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(`${this.name}:${s}`, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
        return new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.HttpConnection)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = parseInt($6d522931de1c17ec$var$In(i));
            s[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), s;
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? [
            ...new Set(s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    getHttpProvider() {
        const s = this.chainId, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    async handleSwitchChain(s) {
        var i, p;
        let w = s.request.params ? (i = s.request.params[0]) == null ? void 0 : i.chainId : "0x0";
        w = w.startsWith("0x") ? w : `0x${w}`;
        const x = parseInt(w, 16);
        if (this.isChainApproved(x)) this.setDefaultChain(`${x}`);
        else if (this.namespace.methods.includes("wallet_switchEthereumChain")) await this.client.request({
            topic: s.topic,
            request: {
                method: s.request.method,
                params: [
                    {
                        chainId: w
                    }
                ]
            },
            chainId: (p = this.namespace.chains) == null ? void 0 : p[0]
        }), this.setDefaultChain(`${x}`);
        else throw new Error(`Failed to switch to chain 'eip155:${x}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
        return null;
    }
    isChainApproved(s) {
        return this.namespace.chains.includes(`${this.name}:${s}`);
    }
    async getCapabilities(s) {
        var i, p, w;
        const x = (p = (i = s.request) == null ? void 0 : i.params) == null ? void 0 : p[0];
        if (!x) throw new Error("Missing address parameter in `wallet_getCapabilities` request");
        const O = this.client.session.get(s.topic), k = ((w = O?.sessionProperties) == null ? void 0 : w.capabilities) || {};
        if (k != null && k[x]) return k?.[x];
        const tn = await this.client.request(s);
        try {
            await this.client.session.update(s.topic, {
                sessionProperties: $6d522931de1c17ec$var$qa($6d522931de1c17ec$var$$a({}, O.sessionProperties || {}), {
                    capabilities: $6d522931de1c17ec$var$qa($6d522931de1c17ec$var$$a({}, k || {}), {
                        [x]: tn
                    })
                })
            });
        } catch (Jn) {
            console.warn("Failed to update session with capabilities", Jn);
        }
        return tn;
    }
}
class $6d522931de1c17ec$var$cv {
    constructor(s){
        this.name = "solana", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    setDefaultChain(s, i) {
        this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${s}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? [
            ...new Set(s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $6d522931de1c17ec$var$In(i);
            s[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), s;
    }
    getHttpProvider() {
        const s = `${this.name}:${this.chainId}`, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(s, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
        return new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
class $6d522931de1c17ec$var$hv {
    constructor(s){
        this.name = "cosmos", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    setDefaultChain(s, i) {
        this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? [
            ...new Set(s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $6d522931de1c17ec$var$In(i);
            s[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), s;
    }
    getHttpProvider() {
        const s = `${this.name}:${this.chainId}`, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(s, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
        return new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
class $6d522931de1c17ec$var$lv {
    constructor(s){
        this.name = "algorand", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    setDefaultChain(s, i) {
        if (!this.httpProviders[s]) {
            const p = i || $6d522931de1c17ec$var$Lt(`${this.name}:${s}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
            this.setHttpProvider(s, p);
        }
        this.chainId = s, this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? [
            ...new Set(s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            s[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), s;
    }
    getHttpProvider() {
        const s = `${this.name}:${this.chainId}`, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(s, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
class $6d522931de1c17ec$var$pv {
    constructor(s){
        this.name = "cip34", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    setDefaultChain(s, i) {
        this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? [
            ...new Set(s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            const p = this.getCardanoRPCUrl(i), w = $6d522931de1c17ec$var$In(i);
            s[w] = this.createHttpProvider(w, p);
        }), s;
    }
    getHttpProvider() {
        const s = `${this.name}:${this.chainId}`, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    getCardanoRPCUrl(s) {
        const i = this.namespace.rpcMap;
        if (i) return i[s];
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || this.getCardanoRPCUrl(s);
        if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
        return new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
class $6d522931de1c17ec$var$dv {
    constructor(s){
        this.name = "elrond", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    setDefaultChain(s, i) {
        this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${s}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? [
            ...new Set(s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $6d522931de1c17ec$var$In(i);
            s[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), s;
    }
    getHttpProvider() {
        const s = `${this.name}:${this.chainId}`, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(s, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
        return new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
class $6d522931de1c17ec$var$gv {
    constructor(s){
        this.name = "multiversx", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    setDefaultChain(s, i) {
        this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${s}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? [
            ...new Set(s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $6d522931de1c17ec$var$In(i);
            s[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), s;
    }
    getHttpProvider() {
        const s = `${this.name}:${this.chainId}`, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(s, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
        return new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
class $6d522931de1c17ec$var$vv {
    constructor(s){
        this.name = "near", this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace = Object.assign(this.namespace, s);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
    }
    setDefaultChain(s, i) {
        if (this.chainId = s, !this.httpProviders[s]) {
            const p = i || $6d522931de1c17ec$var$Lt(`${this.name}:${s}`, this.namespace);
            if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
            this.setHttpProvider(s, p);
        }
        this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const s = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            s[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), s;
    }
    getHttpProvider() {
        const s = `${this.name}:${this.chainId}`, i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(s, this.namespace);
        return typeof p > "u" ? void 0 : new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
class $6d522931de1c17ec$var$_v {
    constructor(s){
        this.name = $6d522931de1c17ec$var$Kn, this.namespace = s.namespace, this.events = $6d522931de1c17ec$var$F("events"), this.client = $6d522931de1c17ec$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(s) {
        this.namespace.chains = [
            ...new Set((this.namespace.chains || []).concat(s.chains || []))
        ], this.namespace.accounts = [
            ...new Set((this.namespace.accounts || []).concat(s.accounts || []))
        ], this.namespace.methods = [
            ...new Set((this.namespace.methods || []).concat(s.methods || []))
        ], this.namespace.events = [
            ...new Set((this.namespace.events || []).concat(s.events || []))
        ], this.httpProviders = this.createHttpProviders();
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(s) {
        return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider(s.chainId).request(s.request);
    }
    setDefaultChain(s, i) {
        this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${s}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const s = this.namespace.chains[0];
        if (!s) throw new Error("ChainId not found");
        return s.split(":")[1];
    }
    getAccounts() {
        const s = this.namespace.accounts;
        return s ? [
            ...new Set(s.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        var s, i;
        const p = {};
        return (i = (s = this.namespace) == null ? void 0 : s.accounts) == null || i.forEach((w)=>{
            const x = (0, $iN1TF.parseChainId)(w);
            p[`${x.namespace}:${x.reference}`] = this.createHttpProvider(w);
        }), p;
    }
    getHttpProvider(s) {
        const i = this.httpProviders[s];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${s} not found`);
        return i;
    }
    setHttpProvider(s, i) {
        const p = this.createHttpProvider(s, i);
        p && (this.httpProviders[s] = p);
    }
    createHttpProvider(s, i) {
        const p = i || $6d522931de1c17ec$var$Lt(s, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${s}`);
        return new (0, $kUdYz.JsonRpcProvider)(new (0, $3KLgK.default)(p, $6d522931de1c17ec$var$F("disableProviderPing")));
    }
}
var $6d522931de1c17ec$var$mv = Object.defineProperty, $6d522931de1c17ec$var$wv = Object.defineProperties, $6d522931de1c17ec$var$Pv = Object.getOwnPropertyDescriptors, $6d522931de1c17ec$var$Ua = Object.getOwnPropertySymbols, $6d522931de1c17ec$var$Cv = Object.prototype.hasOwnProperty, $6d522931de1c17ec$var$Av = Object.prototype.propertyIsEnumerable, $6d522931de1c17ec$var$Fa = (P, s, i)=>s in P ? $6d522931de1c17ec$var$mv(P, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : P[s] = i, $6d522931de1c17ec$var$pr = (P, s)=>{
    for(var i in s || (s = {}))$6d522931de1c17ec$var$Cv.call(s, i) && $6d522931de1c17ec$var$Fa(P, i, s[i]);
    if ($6d522931de1c17ec$var$Ua) for (var i of $6d522931de1c17ec$var$Ua(s))$6d522931de1c17ec$var$Av.call(s, i) && $6d522931de1c17ec$var$Fa(P, i, s[i]);
    return P;
}, $6d522931de1c17ec$var$Bi = (P, s)=>$6d522931de1c17ec$var$wv(P, $6d522931de1c17ec$var$Pv(s));
class $6d522931de1c17ec$export$2e2bcd8739ae039 {
    constructor(s){
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($jMGWz))), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = s, this.logger = typeof s?.logger < "u" && typeof s?.logger != "string" ? s.logger : (0, (/*@__PURE__*/$parcel$interopDefault($6rVbn)))((0, $GVAyr.getDefaultLoggerOptions)({
            level: s?.logger || $6d522931de1c17ec$var$ya
        })), this.disableProviderPing = s?.disableProviderPing || !1;
    }
    static async init(s) {
        const i = new $6d522931de1c17ec$export$2e2bcd8739ae039(s);
        return await i.initialize(), i;
    }
    async request(s, i, p) {
        const [w, x] = this.validateChain(i);
        if (!this.session) throw new Error("Please call connect() before request()");
        return await this.getProvider(w).request({
            request: $6d522931de1c17ec$var$pr({}, s),
            chainId: `${w}:${x}`,
            topic: this.session.topic,
            expiry: p
        });
    }
    sendAsync(s, i, p, w) {
        const x = new Date().getTime();
        this.request(s, p, w).then((O)=>i(null, (0, $eS6BO.formatJsonRpcResult)(x, O))).catch((O)=>i(O, void 0));
    }
    async enable() {
        if (!this.client) throw new Error("Sign Client not initialized");
        return this.session || await this.connect({
            namespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties
        }), await this.requestAccounts();
    }
    async disconnect() {
        var s;
        if (!this.session) throw new Error("Please call connect() before enable()");
        await this.client.disconnect({
            topic: (s = this.session) == null ? void 0 : s.topic,
            reason: (0, $iN1TF.getSdkError)("USER_DISCONNECTED")
        }), await this.cleanup();
    }
    async connect(s) {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (this.setNamespaces(s), await this.cleanupPendingPairings(), !s.skipPairing) return await this.pair(s.pairingTopic);
    }
    async authenticate(s) {
        if (!this.client) throw new Error("Sign Client not initialized");
        this.setNamespaces(s), await this.cleanupPendingPairings();
        const { uri: i, response: p } = await this.client.authenticate(s);
        i && (this.uri = i, this.events.emit("display_uri", i));
        const w = await p();
        if (this.session = w.session, this.session) {
            const x = $6d522931de1c17ec$var$La(this.session.namespaces);
            this.namespaces = $6d522931de1c17ec$var$Fi(this.namespaces, x), this.persist("namespaces", this.namespaces), this.onConnect();
        }
        return w;
    }
    on(s, i) {
        this.events.on(s, i);
    }
    once(s, i) {
        this.events.once(s, i);
    }
    removeListener(s, i) {
        this.events.removeListener(s, i);
    }
    off(s, i) {
        this.events.off(s, i);
    }
    get isWalletConnect() {
        return !0;
    }
    async pair(s) {
        this.shouldAbortPairingAttempt = !1;
        let i = 0;
        do {
            if (this.shouldAbortPairingAttempt) throw new Error("Pairing aborted");
            if (i >= this.maxPairingAttempts) throw new Error("Max auto pairing attempts reached");
            const { uri: p, approval: w } = await this.client.connect({
                pairingTopic: s,
                requiredNamespaces: this.namespaces,
                optionalNamespaces: this.optionalNamespaces,
                sessionProperties: this.sessionProperties
            });
            p && (this.uri = p, this.events.emit("display_uri", p)), await w().then((x)=>{
                this.session = x;
                const O = $6d522931de1c17ec$var$La(x.namespaces);
                this.namespaces = $6d522931de1c17ec$var$Fi(this.namespaces, O), this.persist("namespaces", this.namespaces);
            }).catch((x)=>{
                if (x.message !== (0, $9USum.PROPOSAL_EXPIRY_MESSAGE)) throw x;
                i++;
            });
        }while (!this.session);
        return this.onConnect(), this.session;
    }
    setDefaultChain(s, i) {
        try {
            if (!this.session) return;
            const [p, w] = this.validateChain(s), x = this.getProvider(p);
            x.name === $6d522931de1c17ec$var$Kn ? x.setDefaultChain(`${p}:${w}`, i) : x.setDefaultChain(w, i);
        } catch (p) {
            if (!/Please call connect/.test(p.message)) throw p;
        }
    }
    async cleanupPendingPairings(s = {}) {
        this.logger.info("Cleaning up inactive pairings...");
        const i = this.client.pairing.getAll();
        if ((0, $iN1TF.isValidArray)(i)) {
            for (const p of i)s.deletePairings ? this.client.core.expirer.set(p.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(p.topic);
            this.logger.info(`Inactive pairings cleared: ${i.length}`);
        }
    }
    abortPairingAttempt() {
        this.shouldAbortPairingAttempt = !0;
    }
    async checkStorage() {
        if (this.namespaces = await this.getFromStore("namespaces"), this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.client.session.length) {
            const s = this.client.session.keys.length - 1;
            this.session = this.client.session.get(this.client.session.keys[s]), this.createProviders();
        }
    }
    async initialize() {
        this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
    }
    async createClient() {
        this.client = this.providerOpts.client || await (0, $9USum.default).init({
            core: this.providerOpts.core,
            logger: this.providerOpts.logger || $6d522931de1c17ec$var$ya,
            relayUrl: this.providerOpts.relayUrl || $6d522931de1c17ec$var$Kg,
            projectId: this.providerOpts.projectId,
            metadata: this.providerOpts.metadata,
            storageOptions: this.providerOpts.storageOptions,
            storage: this.providerOpts.storage,
            name: this.providerOpts.name,
            customStoragePrefix: this.providerOpts.customStoragePrefix,
            telemetryEnabled: this.providerOpts.telemetryEnabled
        }), this.logger.trace("SignClient Initialized");
    }
    createProviders() {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
        const s = [
            ...new Set(Object.keys(this.session.namespaces).map((i)=>(0, $iN1TF.parseNamespaceKey)(i)))
        ];
        $6d522931de1c17ec$var$Mi("client", this.client), $6d522931de1c17ec$var$Mi("events", this.events), $6d522931de1c17ec$var$Mi("disableProviderPing", this.disableProviderPing), s.forEach((i)=>{
            if (!this.session) return;
            const p = $6d522931de1c17ec$var$nv(i, this.session), w = $6d522931de1c17ec$var$ba(p), x = $6d522931de1c17ec$var$Fi(this.namespaces, this.optionalNamespaces), O = $6d522931de1c17ec$var$Bi($6d522931de1c17ec$var$pr({}, x[i]), {
                accounts: p,
                chains: w
            });
            switch(i){
                case "eip155":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$fv({
                        namespace: O
                    });
                    break;
                case "algorand":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$lv({
                        namespace: O
                    });
                    break;
                case "solana":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$cv({
                        namespace: O
                    });
                    break;
                case "cosmos":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$hv({
                        namespace: O
                    });
                    break;
                case "polkadot":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$rv({
                        namespace: O
                    });
                    break;
                case "cip34":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$pv({
                        namespace: O
                    });
                    break;
                case "elrond":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$dv({
                        namespace: O
                    });
                    break;
                case "multiversx":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$gv({
                        namespace: O
                    });
                    break;
                case "near":
                    this.rpcProviders[i] = new $6d522931de1c17ec$var$vv({
                        namespace: O
                    });
                    break;
                default:
                    this.rpcProviders[$6d522931de1c17ec$var$Kn] ? this.rpcProviders[$6d522931de1c17ec$var$Kn].updateNamespace(O) : this.rpcProviders[$6d522931de1c17ec$var$Kn] = new $6d522931de1c17ec$var$_v({
                        namespace: O
                    });
            }
        });
    }
    registerEventListeners() {
        if (typeof this.client > "u") throw new Error("Sign Client is not initialized");
        this.client.on("session_ping", (s)=>{
            this.events.emit("session_ping", s);
        }), this.client.on("session_event", (s)=>{
            const { params: i } = s, { event: p } = i;
            if (p.name === "accountsChanged") {
                const w = p.data;
                w && (0, $iN1TF.isValidArray)(w) && this.events.emit("accountsChanged", w.map($6d522931de1c17ec$var$ev));
            } else if (p.name === "chainChanged") {
                const w = i.chainId, x = i.event.data, O = (0, $iN1TF.parseNamespaceKey)(w), k = $6d522931de1c17ec$var$Wi(w) !== $6d522931de1c17ec$var$Wi(x) ? `${O}:${$6d522931de1c17ec$var$Wi(x)}` : w;
                this.onChainChanged(k);
            } else this.events.emit(p.name, p.data);
            this.events.emit("session_event", s);
        }), this.client.on("session_update", ({ topic: s, params: i })=>{
            var p;
            const { namespaces: w } = i, x = (p = this.client) == null ? void 0 : p.session.get(s);
            this.session = $6d522931de1c17ec$var$Bi($6d522931de1c17ec$var$pr({}, x), {
                namespaces: w
            }), this.onSessionUpdate(), this.events.emit("session_update", {
                topic: s,
                params: i
            });
        }), this.client.on("session_delete", async (s)=>{
            await this.cleanup(), this.events.emit("session_delete", s), this.events.emit("disconnect", $6d522931de1c17ec$var$Bi($6d522931de1c17ec$var$pr({}, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")), {
                data: s.topic
            }));
        }), this.on($6d522931de1c17ec$var$Tt.DEFAULT_CHAIN_CHANGED, (s)=>{
            this.onChainChanged(s, !0);
        });
    }
    getProvider(s) {
        return this.rpcProviders[s] || this.rpcProviders[$6d522931de1c17ec$var$Kn];
    }
    onSessionUpdate() {
        Object.keys(this.rpcProviders).forEach((s)=>{
            var i;
            this.getProvider(s).updateNamespace((i = this.session) == null ? void 0 : i.namespaces[s]);
        });
    }
    setNamespaces(s) {
        const { namespaces: i, optionalNamespaces: p, sessionProperties: w } = s;
        i && Object.keys(i).length && (this.namespaces = i), p && Object.keys(p).length && (this.optionalNamespaces = p), this.sessionProperties = w, this.persist("namespaces", i), this.persist("optionalNamespaces", p);
    }
    validateChain(s) {
        const [i, p] = s?.split(":") || [
            "",
            ""
        ];
        if (!this.namespaces || !Object.keys(this.namespaces).length) return [
            i,
            p
        ];
        if (i && !Object.keys(this.namespaces || {}).map((O)=>(0, $iN1TF.parseNamespaceKey)(O)).includes(i)) throw new Error(`Namespace '${i}' is not configured. Please call connect() first with namespace config.`);
        if (i && p) return [
            i,
            p
        ];
        const w = (0, $iN1TF.parseNamespaceKey)(Object.keys(this.namespaces)[0]), x = this.rpcProviders[w].getDefaultChain();
        return [
            w,
            x
        ];
    }
    async requestAccounts() {
        const [s] = this.validateChain();
        return await this.getProvider(s).requestAccounts();
    }
    onChainChanged(s, i = !1) {
        if (!this.namespaces) return;
        const [p, w] = this.validateChain(s);
        w && (i || this.getProvider(p).setDefaultChain(w), this.namespaces[p] ? this.namespaces[p].defaultChain = w : this.namespaces[`${p}:${w}`] ? this.namespaces[`${p}:${w}`].defaultChain = w : this.namespaces[`${p}:${w}`] = {
            defaultChain: w
        }, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", w));
    }
    onConnect() {
        this.createProviders(), this.events.emit("connect", {
            session: this.session
        });
    }
    async cleanup() {
        this.session = void 0, this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, this.persist("namespaces", void 0), this.persist("optionalNamespaces", void 0), this.persist("sessionProperties", void 0), await this.cleanupPendingPairings({
            deletePairings: !0
        });
    }
    persist(s, i) {
        this.client.core.storage.setItem(`${$6d522931de1c17ec$var$Sa}/${s}`, i);
    }
    async getFromStore(s) {
        return await this.client.core.storage.getItem(`${$6d522931de1c17ec$var$Sa}/${s}`);
    }
}
const $6d522931de1c17ec$export$63bc40680ab52599 = $6d522931de1c17ec$export$2e2bcd8739ae039;

});
parcelRegister("9USum", function(module, exports) {

$parcel$export(module.exports, "PROPOSAL_EXPIRY_MESSAGE", function () { return $73839c57d19ee815$export$1e6a4dc5172f4830; });
$parcel$export(module.exports, "default", function () { return $73839c57d19ee815$export$2e2bcd8739ae039; });

var $jSQmq = parcelRequire("jSQmq");

var $GVAyr = parcelRequire("GVAyr");
var $6rVbn = parcelRequire("6rVbn");

var $evwHH = parcelRequire("evwHH");

var $iN1TF = parcelRequire("iN1TF");

var $jMGWz = parcelRequire("jMGWz");

var $iNdL8 = parcelRequire("iNdL8");
parcelRequire("6bXmq");
var $eS6BO = parcelRequire("eS6BO");
var $bNBqy = parcelRequire("bNBqy");
const $73839c57d19ee815$export$4fa962fc67384e02 = "wc", $73839c57d19ee815$export$61085c48796ff049 = 2, $73839c57d19ee815$export$94715592c220319a = "client", $73839c57d19ee815$export$7fa6f9ee1e2cab96 = `${$73839c57d19ee815$export$4fa962fc67384e02}@${$73839c57d19ee815$export$61085c48796ff049}:${$73839c57d19ee815$export$94715592c220319a}:`, $73839c57d19ee815$export$8dffb3242f2c5f72 = {
    name: $73839c57d19ee815$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $73839c57d19ee815$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_authenticate: "session_authenticate",
    session_request_expire: "session_request_expire"
}, $73839c57d19ee815$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $73839c57d19ee815$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $73839c57d19ee815$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $73839c57d19ee815$export$160142c73cb99dc3 = "history", $73839c57d19ee815$export$8eba9ce85616c607 = "0.3", $73839c57d19ee815$export$ae6c7a4f7ed730a1 = "proposal", $73839c57d19ee815$export$6db28e89b135a53c = (0, $iNdL8.THIRTY_DAYS), $73839c57d19ee815$export$1e6a4dc5172f4830 = "Proposal expired", $73839c57d19ee815$export$a069e98a8dfeec1e = "session", $73839c57d19ee815$export$84b1b9dbcdea0475 = (0, $iNdL8.SEVEN_DAYS), $73839c57d19ee815$export$2db42d5151ad6eb8 = "engine", $73839c57d19ee815$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        },
        reject: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1120
        },
        autoReject: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1121
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1115
        }
    },
    wc_sessionAuthenticate: {
        req: {
            ttl: (0, $iNdL8.ONE_HOUR),
            prompt: !0,
            tag: 1116
        },
        res: {
            ttl: (0, $iNdL8.ONE_HOUR),
            prompt: !1,
            tag: 1117
        },
        reject: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1118
        },
        autoReject: {
            ttl: (0, $iNdL8.FIVE_MINUTES),
            prompt: !1,
            tag: 1119
        }
    }
}, $73839c57d19ee815$export$409f0c0a13a1b7c6 = {
    min: (0, $iNdL8.FIVE_MINUTES),
    max: (0, $iNdL8.SEVEN_DAYS)
}, $73839c57d19ee815$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $73839c57d19ee815$export$40b296af21bd38a4 = "request", $73839c57d19ee815$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest",
    "wc_sessionAuthenticate"
], $73839c57d19ee815$export$e24c518fa7fc04c = "wc", $73839c57d19ee815$export$af233b4aa2e30834 = 1.5, $73839c57d19ee815$export$e8b9bbdca3ac0ed = "auth", $73839c57d19ee815$export$ab815cb37981e7e0 = "authKeys", $73839c57d19ee815$export$5d9af9e20f678626 = "pairingTopics", $73839c57d19ee815$export$3643b3579d091159 = "requests", $73839c57d19ee815$export$323ba3ebb8028ed0 = `${$73839c57d19ee815$export$e24c518fa7fc04c}@${1.5}:${$73839c57d19ee815$export$e8b9bbdca3ac0ed}:`, $73839c57d19ee815$export$efef74cb455ac30f = `${$73839c57d19ee815$export$323ba3ebb8028ed0}:PUB_KEY`;
var $73839c57d19ee815$var$Zt = Object.defineProperty, $73839c57d19ee815$var$es = Object.defineProperties, $73839c57d19ee815$var$ts = Object.getOwnPropertyDescriptors, $73839c57d19ee815$var$tt = Object.getOwnPropertySymbols, $73839c57d19ee815$var$ss = Object.prototype.hasOwnProperty, $73839c57d19ee815$var$is = Object.prototype.propertyIsEnumerable, $73839c57d19ee815$var$st = (I, n, t)=>n in I ? $73839c57d19ee815$var$Zt(I, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : I[n] = t, $73839c57d19ee815$var$E = (I, n)=>{
    for(var t in n || (n = {}))$73839c57d19ee815$var$ss.call(n, t) && $73839c57d19ee815$var$st(I, t, n[t]);
    if ($73839c57d19ee815$var$tt) for (var t of $73839c57d19ee815$var$tt(n))$73839c57d19ee815$var$is.call(n, t) && $73839c57d19ee815$var$st(I, t, n[t]);
    return I;
}, $73839c57d19ee815$var$j = (I, n)=>$73839c57d19ee815$var$es(I, $73839c57d19ee815$var$ts(n));
class $73839c57d19ee815$var$rs extends (0, $evwHH.IEngine) {
    constructor(n){
        super(n), this.name = $73839c57d19ee815$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($jMGWz))), this.initialized = !1, this.requestQueue = {
            state: $73839c57d19ee815$export$8602b201748df21a.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: $73839c57d19ee815$export$8602b201748df21a.idle,
            queue: []
        }, this.requestQueueDelay = (0, $iNdL8.ONE_SECOND), this.expectedPairingMethodMap = new Map, this.recentlyDeletedMap = new Map, this.recentlyDeletedLimit = 200, this.relayMessageCache = [], this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({
                methods: Object.keys($73839c57d19ee815$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $iNdL8.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (t)=>{
            await this.isInitialized();
            const e = $73839c57d19ee815$var$j($73839c57d19ee815$var$E({}, t), {
                requiredNamespaces: t.requiredNamespaces || {},
                optionalNamespaces: t.optionalNamespaces || {}
            });
            await this.isValidConnect(e);
            const { pairingTopic: s, requiredNamespaces: i, optionalNamespaces: r, sessionProperties: o, relays: a } = e;
            let c = s, h, l = !1;
            try {
                c && (l = this.client.core.pairing.pairings.get(c).active);
            } catch (y) {
                throw this.client.logger.error(`connect() -> pairing.get(${c}) failed`), y;
            }
            if (!c || !l) {
                const { topic: y, uri: R } = await this.client.core.pairing.create();
                c = y, h = R;
            }
            if (!c) {
                const { message: y } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(y);
            }
            const g = await this.client.core.crypto.generateKeyPair(), d = $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $iNdL8.FIVE_MINUTES), u = (0, $iN1TF.calcExpiry)(d), _ = $73839c57d19ee815$var$E({
                requiredNamespaces: i,
                optionalNamespaces: r,
                relays: a ?? [
                    {
                        protocol: (0, $jSQmq.RELAYER_DEFAULT_PROTOCOL)
                    }
                ],
                proposer: {
                    publicKey: g,
                    metadata: this.client.metadata
                },
                expiryTimestamp: u,
                pairingTopic: c
            }, o && {
                sessionProperties: o
            }), { reject: q, resolve: m, done: O } = (0, $iN1TF.createDelayedPromise)(d, $73839c57d19ee815$export$1e6a4dc5172f4830);
            this.events.once((0, $iN1TF.engineEvent)("session_connect"), async ({ error: y, session: R })=>{
                if (y) q(y);
                else if (R) {
                    R.self.publicKey = g;
                    const K = $73839c57d19ee815$var$j($73839c57d19ee815$var$E({}, R), {
                        pairingTopic: _.pairingTopic,
                        requiredNamespaces: _.requiredNamespaces,
                        optionalNamespaces: _.optionalNamespaces
                    });
                    await this.client.session.set(R.topic, K), await this.setExpiry(R.topic, R.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: R.peer.metadata
                    }), this.cleanupDuplicatePairings(K), m(K);
                }
            });
            const D = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: _,
                throwOnFailedPublish: !0
            });
            return await this.setProposal(D, $73839c57d19ee815$var$E({
                id: D
            }, _)), {
                uri: h,
                approval: O
            };
        }, this.pair = async (t)=>{
            await this.isInitialized();
            try {
                return await this.client.core.pairing.pair(t);
            } catch (e) {
                throw this.client.logger.error("pair() failed"), e;
            }
        }, this.approve = async (t)=>{
            var e, s, i;
            const r = this.client.core.eventClient.createEvent({
                properties: {
                    topic: (e = t?.id) == null ? void 0 : e.toString(),
                    trace: [
                        (0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).session_approve_started
                    ]
                }
            });
            try {
                await this.isInitialized();
            } catch (f) {
                throw r.setError((0, $jSQmq.EVENT_CLIENT_SESSION_ERRORS).no_internet_connection), f;
            }
            try {
                await this.isValidProposalId(t?.id);
            } catch (f) {
                throw this.client.logger.error(`approve() -> proposal.get(${t?.id}) failed`), r.setError((0, $jSQmq.EVENT_CLIENT_SESSION_ERRORS).proposal_not_found), f;
            }
            try {
                await this.isValidApprove(t);
            } catch (f) {
                throw this.client.logger.error("approve() -> isValidApprove() failed"), r.setError((0, $jSQmq.EVENT_CLIENT_SESSION_ERRORS).session_approve_namespace_validation_failure), f;
            }
            const { id: o, relayProtocol: a, namespaces: c, sessionProperties: h, sessionConfig: l } = t, g = this.client.proposal.get(o);
            this.client.core.eventClient.deleteEvent({
                eventId: r.eventId
            });
            const { pairingTopic: d, proposer: u, requiredNamespaces: _, optionalNamespaces: q } = g;
            let m = (s = this.client.core.eventClient) == null ? void 0 : s.getEvent({
                topic: d
            });
            m || (m = (i = this.client.core.eventClient) == null ? void 0 : i.createEvent({
                type: (0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).session_approve_started,
                properties: {
                    topic: d,
                    trace: [
                        (0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).session_approve_started,
                        (0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).session_namespaces_validation_success
                    ]
                }
            }));
            const O = await this.client.core.crypto.generateKeyPair(), D = u.publicKey, y = await this.client.core.crypto.generateSharedKey(O, D), R = $73839c57d19ee815$var$E($73839c57d19ee815$var$E({
                relay: {
                    protocol: a ?? "irn"
                },
                namespaces: c,
                controller: {
                    publicKey: O,
                    metadata: this.client.metadata
                },
                expiry: (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$84b1b9dbcdea0475)
            }, h && {
                sessionProperties: h
            }), l && {
                sessionConfig: l
            });
            m.addTrace((0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).subscribing_session_topic);
            try {
                await this.client.core.relayer.subscribe(y);
            } catch (f) {
                throw m.setError((0, $jSQmq.EVENT_CLIENT_SESSION_ERRORS).subscribe_session_topic_failure), f;
            }
            m.addTrace((0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).subscribe_session_topic_success);
            const K = $73839c57d19ee815$var$j($73839c57d19ee815$var$E({}, R), {
                topic: y,
                requiredNamespaces: _,
                optionalNamespaces: q,
                pairingTopic: d,
                acknowledged: !1,
                self: R.controller,
                peer: {
                    publicKey: u.publicKey,
                    metadata: u.metadata
                },
                controller: O
            });
            await this.client.session.set(y, K), m.addTrace((0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).store_session);
            try {
                m.addTrace((0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).publishing_session_settle), await this.sendRequest({
                    topic: y,
                    method: "wc_sessionSettle",
                    params: R,
                    throwOnFailedPublish: !0
                }).catch((f)=>{
                    throw m?.setError((0, $jSQmq.EVENT_CLIENT_SESSION_ERRORS).session_settle_publish_failure), f;
                }), m.addTrace((0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).session_settle_publish_success), m.addTrace((0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).publishing_session_approve), await this.sendResult({
                    id: o,
                    topic: d,
                    result: {
                        relay: {
                            protocol: a ?? "irn"
                        },
                        responderPublicKey: O
                    },
                    throwOnFailedPublish: !0
                }).catch((f)=>{
                    throw m?.setError((0, $jSQmq.EVENT_CLIENT_SESSION_ERRORS).session_approve_publish_failure), f;
                }), m.addTrace((0, $jSQmq.EVENT_CLIENT_SESSION_TRACES).session_approve_publish_success);
            } catch (f) {
                throw this.client.logger.error(f), this.client.session.delete(y, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(y), f;
            }
            return this.client.core.eventClient.deleteEvent({
                eventId: m.eventId
            }), await this.client.core.pairing.updateMetadata({
                topic: d,
                metadata: u.metadata
            }), await this.client.proposal.delete(o, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: d
            }), await this.setExpiry(y, (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$84b1b9dbcdea0475)), {
                topic: y,
                acknowledged: ()=>Promise.resolve(this.client.session.get(y))
            };
        }, this.reject = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidReject(t);
            } catch (r) {
                throw this.client.logger.error("reject() -> isValidReject() failed"), r;
            }
            const { id: e, reason: s } = t;
            let i;
            try {
                i = this.client.proposal.get(e).pairingTopic;
            } catch (r) {
                throw this.client.logger.error(`reject() -> proposal.get(${e}) failed`), r;
            }
            i && (await this.sendError({
                id: e,
                topic: i,
                error: s,
                rpcOpts: $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionPropose.reject
            }), await this.client.proposal.delete(e, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")));
        }, this.update = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidUpdate(t);
            } catch (l) {
                throw this.client.logger.error("update() -> isValidUpdate() failed"), l;
            }
            const { topic: e, namespaces: s } = t, { done: i, resolve: r, reject: o } = (0, $iN1TF.createDelayedPromise)(), a = (0, $eS6BO.payloadId)(), c = (0, $eS6BO.getBigIntRpcId)().toString(), h = this.client.session.get(e).namespaces;
            return this.events.once((0, $iN1TF.engineEvent)("session_update", a), ({ error: l })=>{
                l ? o(l) : r();
            }), await this.client.session.update(e, {
                namespaces: s
            }), await this.sendRequest({
                topic: e,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: s
                },
                throwOnFailedPublish: !0,
                clientRpcId: a,
                relayRpcId: c
            }).catch((l)=>{
                this.client.logger.error(l), this.client.session.update(e, {
                    namespaces: h
                }), o(l);
            }), {
                acknowledged: i
            };
        }, this.extend = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidExtend(t);
            } catch (a) {
                throw this.client.logger.error("extend() -> isValidExtend() failed"), a;
            }
            const { topic: e } = t, s = (0, $eS6BO.payloadId)(), { done: i, resolve: r, reject: o } = (0, $iN1TF.createDelayedPromise)();
            return this.events.once((0, $iN1TF.engineEvent)("session_extend", s), ({ error: a })=>{
                a ? o(a) : r();
            }), await this.setExpiry(e, (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$84b1b9dbcdea0475)), this.sendRequest({
                topic: e,
                method: "wc_sessionExtend",
                params: {},
                clientRpcId: s,
                throwOnFailedPublish: !0
            }).catch((a)=>{
                o(a);
            }), {
                acknowledged: i
            };
        }, this.request = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidRequest(t);
            } catch (d) {
                throw this.client.logger.error("request() -> isValidRequest() failed"), d;
            }
            const { chainId: e, request: s, topic: i, expiry: r = $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = t, o = this.client.session.get(i), a = (0, $eS6BO.payloadId)(), c = (0, $eS6BO.getBigIntRpcId)().toString(), { done: h, resolve: l, reject: g } = (0, $iN1TF.createDelayedPromise)(r, "Request expired. Please try again.");
            return this.events.once((0, $iN1TF.engineEvent)("session_request", a), ({ error: d, result: u })=>{
                d ? g(d) : l(u);
            }), await Promise.all([
                new Promise(async (d)=>{
                    await this.sendRequest({
                        clientRpcId: a,
                        relayRpcId: c,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: $73839c57d19ee815$var$j($73839c57d19ee815$var$E({}, s), {
                                expiryTimestamp: (0, $iN1TF.calcExpiry)(r)
                            }),
                            chainId: e
                        },
                        expiry: r,
                        throwOnFailedPublish: !0
                    }).catch((u)=>g(u)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: s,
                        chainId: e,
                        id: a
                    }), d();
                }),
                new Promise(async (d)=>{
                    var u;
                    if (!((u = o.sessionConfig) != null && u.disableDeepLink)) {
                        const _ = await (0, $iN1TF.getDeepLink)(this.client.core.storage, $73839c57d19ee815$export$a26ccd6441b7d638);
                        (0, $iN1TF.handleDeeplinkRedirect)({
                            id: a,
                            topic: i,
                            wcDeepLink: _
                        });
                    }
                    d();
                }),
                h()
            ]).then((d)=>d[2]);
        }, this.respond = async (t)=>{
            await this.isInitialized(), await this.isValidRespond(t);
            const { topic: e, response: s } = t, { id: i } = s;
            (0, $bNBqy.isJsonRpcResult)(s) ? await this.sendResult({
                id: i,
                topic: e,
                result: s.result,
                throwOnFailedPublish: !0
            }) : (0, $bNBqy.isJsonRpcError)(s) && await this.sendError({
                id: i,
                topic: e,
                error: s.error
            }), this.cleanupAfterResponse(t);
        }, this.ping = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidPing(t);
            } catch (s) {
                throw this.client.logger.error("ping() -> isValidPing() failed"), s;
            }
            const { topic: e } = t;
            if (this.client.session.keys.includes(e)) {
                const s = (0, $eS6BO.payloadId)(), i = (0, $eS6BO.getBigIntRpcId)().toString(), { done: r, resolve: o, reject: a } = (0, $iN1TF.createDelayedPromise)();
                this.events.once((0, $iN1TF.engineEvent)("session_ping", s), ({ error: c })=>{
                    c ? a(c) : o();
                }), await Promise.all([
                    this.sendRequest({
                        topic: e,
                        method: "wc_sessionPing",
                        params: {},
                        throwOnFailedPublish: !0,
                        clientRpcId: s,
                        relayRpcId: i
                    }),
                    r()
                ]);
            } else this.client.core.pairing.pairings.keys.includes(e) && await this.client.core.pairing.ping({
                topic: e
            });
        }, this.emit = async (t)=>{
            await this.isInitialized(), await this.isValidEmit(t);
            const { topic: e, event: s, chainId: i } = t, r = (0, $eS6BO.getBigIntRpcId)().toString();
            await this.sendRequest({
                topic: e,
                method: "wc_sessionEvent",
                params: {
                    event: s,
                    chainId: i
                },
                throwOnFailedPublish: !0,
                relayRpcId: r
            });
        }, this.disconnect = async (t)=>{
            await this.isInitialized(), await this.isValidDisconnect(t);
            const { topic: e } = t;
            if (this.client.session.keys.includes(e)) await this.sendRequest({
                topic: e,
                method: "wc_sessionDelete",
                params: (0, $iN1TF.getSdkError)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: e,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(e)) await this.client.core.pairing.disconnect({
                topic: e
            });
            else {
                const { message: s } = (0, $iN1TF.getInternalError)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${e}`);
                throw new Error(s);
            }
        }, this.find = (t)=>(this.isInitialized(), this.client.session.getAll().filter((e)=>(0, $iN1TF.isSessionCompatible)(e, t))), this.getPendingSessionRequests = ()=>this.client.pendingRequest.getAll(), this.authenticate = async (t)=>{
            this.isInitialized(), this.isValidAuthenticate(t);
            const { chains: e, statement: s = "", uri: i, domain: r, nonce: o, type: a, exp: c, nbf: h, methods: l = [], expiry: g } = t, d = [
                ...t.resources || []
            ], { topic: u, uri: _ } = await this.client.core.pairing.create({
                methods: [
                    "wc_sessionAuthenticate"
                ]
            });
            this.client.logger.info({
                message: "Generated new pairing",
                pairing: {
                    topic: u,
                    uri: _
                }
            });
            const q = await this.client.core.crypto.generateKeyPair(), m = (0, $iN1TF.hashKey)(q);
            if (await Promise.all([
                this.client.auth.authKeys.set($73839c57d19ee815$export$efef74cb455ac30f, {
                    responseTopic: m,
                    publicKey: q
                }),
                this.client.auth.pairingTopics.set(m, {
                    topic: m,
                    pairingTopic: u
                })
            ]), await this.client.core.relayer.subscribe(m), this.client.logger.info(`sending request to new pairing topic: ${u}`), l.length > 0) {
                const { namespace: A } = (0, $iN1TF.parseChainId)(e[0]);
                let v = (0, $iN1TF.createEncodedRecap)(A, "request", l);
                (0, $iN1TF.getRecapFromResources)(d) && (v = (0, $iN1TF.mergeEncodedRecaps)(v, d.pop())), d.push(v);
            }
            const O = g && g > $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl ? g : $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl, D = {
                authPayload: {
                    type: a ?? "caip122",
                    chains: e,
                    statement: s,
                    aud: i,
                    domain: r,
                    version: "1",
                    nonce: o,
                    iat: new Date().toISOString(),
                    exp: c,
                    nbf: h,
                    resources: d
                },
                requester: {
                    publicKey: q,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $iN1TF.calcExpiry)(O)
            }, y = {
                eip155: {
                    chains: e,
                    methods: [
                        ...new Set([
                            "personal_sign",
                            ...l
                        ])
                    ],
                    events: [
                        "chainChanged",
                        "accountsChanged"
                    ]
                }
            }, R = {
                requiredNamespaces: {},
                optionalNamespaces: y,
                relays: [
                    {
                        protocol: "irn"
                    }
                ],
                pairingTopic: u,
                proposer: {
                    publicKey: q,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)
            }, { done: K, resolve: f, reject: de } = (0, $iN1TF.createDelayedPromise)(O, "Request expired"), re = async ({ error: A, session: v })=>{
                if (this.events.off((0, $iN1TF.engineEvent)("session_request", F), ue), A) de(A);
                else if (v) {
                    v.self.publicKey = q, await this.client.session.set(v.topic, v), await this.setExpiry(v.topic, v.expiry), u && await this.client.core.pairing.updateMetadata({
                        topic: u,
                        metadata: v.peer.metadata
                    });
                    const Q = this.client.session.get(v.topic);
                    await this.deleteProposal(B), f({
                        session: Q
                    });
                }
            }, ue = async (A)=>{
                if (await this.deletePendingAuthRequest(F, {
                    message: "fulfilled",
                    code: 0
                }), A.error) {
                    const W = (0, $iN1TF.getSdkError)("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
                    return A.error.code === W.code ? void 0 : (this.events.off((0, $iN1TF.engineEvent)("session_connect"), re), de(A.error.message));
                }
                await this.deleteProposal(B), this.events.off((0, $iN1TF.engineEvent)("session_connect"), re);
                const { cacaos: v, responder: Q } = A.result, ge = [], Te = [];
                for (const W of v){
                    await (0, $iN1TF.validateSignedCacao)({
                        cacao: W,
                        projectId: this.client.core.projectId
                    }) || (this.client.logger.error(W, "Signature verification failed"), de((0, $iN1TF.getSdkError)("SESSION_SETTLEMENT_FAILED", "Signature verification failed")));
                    const { p: we } = W, ye = (0, $iN1TF.getRecapFromResources)(we.resources), Oe = [
                        (0, $iN1TF.getNamespacedDidChainId)(we.iss)
                    ], rt = (0, $iN1TF.getDidAddress)(we.iss);
                    if (ye) {
                        const me = (0, $iN1TF.getMethodsFromRecap)(ye), nt = (0, $iN1TF.getChainsFromRecap)(ye);
                        ge.push(...me), Oe.push(...nt);
                    }
                    for (const me of Oe)Te.push(`${me}:${rt}`);
                }
                const ne = await this.client.core.crypto.generateSharedKey(q, Q.publicKey);
                let oe;
                ge.length > 0 && (oe = {
                    topic: ne,
                    acknowledged: !0,
                    self: {
                        publicKey: q,
                        metadata: this.client.metadata
                    },
                    peer: Q,
                    controller: Q.publicKey,
                    expiry: (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$84b1b9dbcdea0475),
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: u,
                    namespaces: (0, $iN1TF.buildNamespacesFromAuth)([
                        ...new Set(ge)
                    ], [
                        ...new Set(Te)
                    ])
                }, await this.client.core.relayer.subscribe(ne), await this.client.session.set(ne, oe), u && await this.client.core.pairing.updateMetadata({
                    topic: u,
                    metadata: Q.metadata
                }), oe = this.client.session.get(ne)), f({
                    auths: v,
                    session: oe
                });
            }, F = (0, $eS6BO.payloadId)(), B = (0, $eS6BO.payloadId)();
            this.events.once((0, $iN1TF.engineEvent)("session_connect"), re), this.events.once((0, $iN1TF.engineEvent)("session_request", F), ue);
            try {
                await Promise.all([
                    this.sendRequest({
                        topic: u,
                        method: "wc_sessionAuthenticate",
                        params: D,
                        expiry: t.expiry,
                        throwOnFailedPublish: !0,
                        clientRpcId: F
                    }),
                    this.sendRequest({
                        topic: u,
                        method: "wc_sessionPropose",
                        params: R,
                        expiry: $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionPropose.req.ttl,
                        throwOnFailedPublish: !0,
                        clientRpcId: B
                    })
                ]);
            } catch (A) {
                throw this.events.off((0, $iN1TF.engineEvent)("session_connect"), re), this.events.off((0, $iN1TF.engineEvent)("session_request", F), ue), A;
            }
            return await this.setProposal(B, $73839c57d19ee815$var$E({
                id: B
            }, R)), await this.setAuthRequest(F, {
                request: $73839c57d19ee815$var$j($73839c57d19ee815$var$E({}, D), {
                    verifyContext: {}
                }),
                pairingTopic: u
            }), {
                uri: _,
                response: K
            };
        }, this.approveSessionAuthenticate = async (t)=>{
            const { id: e, auths: s } = t, i = this.client.core.eventClient.createEvent({
                properties: {
                    topic: e.toString(),
                    trace: [
                        (0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_TRACES).authenticated_session_approve_started
                    ]
                }
            });
            try {
                this.isInitialized();
            } catch (_) {
                throw i.setError((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_ERRORS).no_internet_connection), _;
            }
            const r = this.getPendingAuthRequest(e);
            if (!r) throw i.setError((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_ERRORS).authenticated_session_pending_request_not_found), new Error(`Could not find pending auth request with id ${e}`);
            const o = r.requester.publicKey, a = await this.client.core.crypto.generateKeyPair(), c = (0, $iN1TF.hashKey)(o), h = {
                type: (0, $iN1TF.TYPE_1),
                receiverPublicKey: o,
                senderPublicKey: a
            }, l = [], g = [];
            for (const _ of s){
                if (!await (0, $iN1TF.validateSignedCacao)({
                    cacao: _,
                    projectId: this.client.core.projectId
                })) {
                    i.setError((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_ERRORS).invalid_cacao);
                    const y = (0, $iN1TF.getSdkError)("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
                    throw await this.sendError({
                        id: e,
                        topic: c,
                        error: y,
                        encodeOpts: h
                    }), new Error(y.message);
                }
                i.addTrace((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_TRACES).cacaos_verified);
                const { p: q } = _, m = (0, $iN1TF.getRecapFromResources)(q.resources), O = [
                    (0, $iN1TF.getNamespacedDidChainId)(q.iss)
                ], D = (0, $iN1TF.getDidAddress)(q.iss);
                if (m) {
                    const y = (0, $iN1TF.getMethodsFromRecap)(m), R = (0, $iN1TF.getChainsFromRecap)(m);
                    l.push(...y), O.push(...R);
                }
                for (const y of O)g.push(`${y}:${D}`);
            }
            const d = await this.client.core.crypto.generateSharedKey(a, o);
            i.addTrace((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_TRACES).create_authenticated_session_topic);
            let u;
            if (l?.length > 0) {
                u = {
                    topic: d,
                    acknowledged: !0,
                    self: {
                        publicKey: a,
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o,
                        metadata: r.requester.metadata
                    },
                    controller: o,
                    expiry: (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$84b1b9dbcdea0475),
                    authentication: s,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: r.pairingTopic,
                    namespaces: (0, $iN1TF.buildNamespacesFromAuth)([
                        ...new Set(l)
                    ], [
                        ...new Set(g)
                    ])
                }, i.addTrace((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_TRACES).subscribing_authenticated_session_topic);
                try {
                    await this.client.core.relayer.subscribe(d);
                } catch (_) {
                    throw i.setError((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_ERRORS).subscribe_authenticated_session_topic_failure), _;
                }
                i.addTrace((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_TRACES).subscribe_authenticated_session_topic_success), await this.client.session.set(d, u), i.addTrace((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_TRACES).store_authenticated_session), await this.client.core.pairing.updateMetadata({
                    topic: r.pairingTopic,
                    metadata: r.requester.metadata
                });
            }
            i.addTrace((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_TRACES).publishing_authenticated_session_approve);
            try {
                await this.sendResult({
                    topic: c,
                    id: e,
                    result: {
                        cacaos: s,
                        responder: {
                            publicKey: a,
                            metadata: this.client.metadata
                        }
                    },
                    encodeOpts: h,
                    throwOnFailedPublish: !0
                });
            } catch (_) {
                throw i.setError((0, $jSQmq.EVENT_CLIENT_AUTHENTICATE_ERRORS).authenticated_session_approve_publish_failure), _;
            }
            return await this.client.auth.requests.delete(e, {
                message: "fulfilled",
                code: 0
            }), await this.client.core.pairing.activate({
                topic: r.pairingTopic
            }), this.client.core.eventClient.deleteEvent({
                eventId: i.eventId
            }), {
                session: u
            };
        }, this.rejectSessionAuthenticate = async (t)=>{
            await this.isInitialized();
            const { id: e, reason: s } = t, i = this.getPendingAuthRequest(e);
            if (!i) throw new Error(`Could not find pending auth request with id ${e}`);
            const r = i.requester.publicKey, o = await this.client.core.crypto.generateKeyPair(), a = (0, $iN1TF.hashKey)(r), c = {
                type: (0, $iN1TF.TYPE_1),
                receiverPublicKey: r,
                senderPublicKey: o
            };
            await this.sendError({
                id: e,
                topic: a,
                error: s,
                encodeOpts: c,
                rpcOpts: $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionAuthenticate.reject
            }), await this.client.auth.requests.delete(e, {
                message: "rejected",
                code: 0
            }), await this.client.proposal.delete(e, (0, $iN1TF.getSdkError)("USER_DISCONNECTED"));
        }, this.formatAuthMessage = (t)=>{
            this.isInitialized();
            const { request: e, iss: s } = t;
            return (0, $iN1TF.formatMessage)(e, s);
        }, this.processRelayMessageCache = ()=>{
            setTimeout(async ()=>{
                if (this.relayMessageCache.length !== 0) for(; this.relayMessageCache.length > 0;)try {
                    const t = this.relayMessageCache.shift();
                    t && await this.onRelayMessage(t);
                } catch (t) {
                    this.client.logger.error(t);
                }
            }, 50);
        }, this.cleanupDuplicatePairings = async (t)=>{
            if (t.pairingTopic) try {
                const e = this.client.core.pairing.pairings.get(t.pairingTopic), s = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var r, o;
                    return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === t.peer.metadata.url && i.topic && i.topic !== e.topic;
                });
                if (s.length === 0) return;
                this.client.logger.info(`Cleaning up ${s.length} duplicate pairing(s)`), await Promise.all(s.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (e) {
                this.client.logger.error(e);
            }
        }, this.deleteSession = async (t)=>{
            var e;
            const { topic: s, expirerHasDeleted: i = !1, emitEvent: r = !0, id: o = 0 } = t, { self: a } = this.client.session.get(s);
            await this.client.core.relayer.unsubscribe(s), await this.client.session.delete(s, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")), this.addToRecentlyDeleted(s, "session"), this.client.core.crypto.keychain.has(a.publicKey) && await this.client.core.crypto.deleteKeyPair(a.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), i || this.client.core.expirer.del(s), this.client.core.storage.removeItem($73839c57d19ee815$export$a26ccd6441b7d638).catch((c)=>this.client.logger.warn(c)), this.getPendingSessionRequests().forEach((c)=>{
                c.topic === s && this.deletePendingSessionRequest(c.id, (0, $iN1TF.getSdkError)("USER_DISCONNECTED"));
            }), s === ((e = this.sessionRequestQueue.queue[0]) == null ? void 0 : e.topic) && (this.sessionRequestQueue.state = $73839c57d19ee815$export$8602b201748df21a.idle), r && this.client.events.emit("session_delete", {
                id: o,
                topic: s
            });
        }, this.deleteProposal = async (t, e)=>{
            if (e) try {
                const s = this.client.proposal.get(t), i = this.client.core.eventClient.getEvent({
                    topic: s.pairingTopic
                });
                i?.setError((0, $jSQmq.EVENT_CLIENT_SESSION_ERRORS).proposal_expired);
            } catch  {}
            await Promise.all([
                this.client.proposal.delete(t, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")),
                e ? Promise.resolve() : this.client.core.expirer.del(t)
            ]), this.addToRecentlyDeleted(t, "proposal");
        }, this.deletePendingSessionRequest = async (t, e, s = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(t, e),
                s ? Promise.resolve() : this.client.core.expirer.del(t)
            ]), this.addToRecentlyDeleted(t, "request"), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== t), s && (this.sessionRequestQueue.state = $73839c57d19ee815$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: t
            }));
        }, this.deletePendingAuthRequest = async (t, e, s = !1)=>{
            await Promise.all([
                this.client.auth.requests.delete(t, e),
                s ? Promise.resolve() : this.client.core.expirer.del(t)
            ]);
        }, this.setExpiry = async (t, e)=>{
            this.client.session.keys.includes(t) && (this.client.core.expirer.set(t, e), await this.client.session.update(t, {
                expiry: e
            }));
        }, this.setProposal = async (t, e)=>{
            this.client.core.expirer.set(t, (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)), await this.client.proposal.set(t, e);
        }, this.setAuthRequest = async (t, e)=>{
            const { request: s, pairingTopic: i } = e;
            this.client.core.expirer.set(t, s.expiryTimestamp), await this.client.auth.requests.set(t, {
                authPayload: s.authPayload,
                requester: s.requester,
                expiryTimestamp: s.expiryTimestamp,
                id: t,
                pairingTopic: i,
                verifyContext: s.verifyContext
            });
        }, this.setPendingSessionRequest = async (t)=>{
            const { id: e, topic: s, params: i, verifyContext: r } = t, o = i.request.expiryTimestamp || (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            this.client.core.expirer.set(e, o), await this.client.pendingRequest.set(e, {
                id: e,
                topic: s,
                params: i,
                verifyContext: r
            });
        }, this.sendRequest = async (t)=>{
            const { topic: e, method: s, params: i, expiry: r, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: c } = t, h = (0, $eS6BO.formatJsonRpcRequest)(s, i, a);
            let l;
            try {
                l = await this.client.core.crypto.encode(e, h);
            } catch (u) {
                throw await this.cleanup(), this.client.logger.error(`sendRequest() -> core.crypto.encode() for topic ${e} failed`), u;
            }
            let g;
            if ($73839c57d19ee815$export$63c37d8ae5931ad5.includes(s)) {
                const u = (0, $iN1TF.hashMessage)(JSON.stringify(h)), _ = (0, $iN1TF.hashMessage)(l);
                g = await this.client.core.verify.register({
                    id: _,
                    decryptedId: u
                });
            }
            const d = $73839c57d19ee815$export$4edb1ca37014192d[s].req;
            return d.attestation = g, r && (d.ttl = r), o && (d.id = o), this.client.core.history.set(e, h), c ? (d.internal = $73839c57d19ee815$var$j($73839c57d19ee815$var$E({}, d.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(e, l, d)) : this.client.core.relayer.publish(e, l, d).catch((u)=>this.client.logger.error(u)), h.id;
        }, this.sendResult = async (t)=>{
            const { id: e, topic: s, result: i, throwOnFailedPublish: r, encodeOpts: o } = t, a = (0, $eS6BO.formatJsonRpcResult)(e, i);
            let c;
            try {
                c = await this.client.core.crypto.encode(s, a, o);
            } catch (g) {
                throw await this.cleanup(), this.client.logger.error(`sendResult() -> core.crypto.encode() for topic ${s} failed`), g;
            }
            let h;
            try {
                h = await this.client.core.history.get(s, e);
            } catch (g) {
                throw this.client.logger.error(`sendResult() -> history.get(${s}, ${e}) failed`), g;
            }
            const l = $73839c57d19ee815$export$4edb1ca37014192d[h.request.method].res;
            r ? (l.internal = $73839c57d19ee815$var$j($73839c57d19ee815$var$E({}, l.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(s, c, l)) : this.client.core.relayer.publish(s, c, l).catch((g)=>this.client.logger.error(g)), await this.client.core.history.resolve(a);
        }, this.sendError = async (t)=>{
            const { id: e, topic: s, error: i, encodeOpts: r, rpcOpts: o } = t, a = (0, $eS6BO.formatJsonRpcError)(e, i);
            let c;
            try {
                c = await this.client.core.crypto.encode(s, a, r);
            } catch (g) {
                throw await this.cleanup(), this.client.logger.error(`sendError() -> core.crypto.encode() for topic ${s} failed`), g;
            }
            let h;
            try {
                h = await this.client.core.history.get(s, e);
            } catch (g) {
                throw this.client.logger.error(`sendError() -> history.get(${s}, ${e}) failed`), g;
            }
            const l = o || $73839c57d19ee815$export$4edb1ca37014192d[h.request.method].res;
            this.client.core.relayer.publish(s, c, l), await this.client.core.history.resolve(a);
        }, this.cleanup = async ()=>{
            const t = [], e = [];
            this.client.session.getAll().forEach((s)=>{
                let i = !1;
                (0, $iN1TF.isExpired)(s.expiry) && (i = !0), this.client.core.crypto.keychain.has(s.topic) || (i = !0), i && t.push(s.topic);
            }), this.client.proposal.getAll().forEach((s)=>{
                (0, $iN1TF.isExpired)(s.expiryTimestamp) && e.push(s.id);
            }), await Promise.all([
                ...t.map((s)=>this.deleteSession({
                        topic: s
                    })),
                ...e.map((s)=>this.deleteProposal(s))
            ]);
        }, this.onRelayEventRequest = async (t)=>{
            this.requestQueue.queue.push(t), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === $73839c57d19ee815$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $73839c57d19ee815$export$8602b201748df21a.active;
                const t = this.requestQueue.queue.shift();
                if (t) try {
                    await this.processRequest(t);
                } catch (e) {
                    this.client.logger.warn(e);
                }
            }
            this.requestQueue.state = $73839c57d19ee815$export$8602b201748df21a.idle;
        }, this.processRequest = async (t)=>{
            const { topic: e, payload: s, attestation: i, encryptedId: r } = t, o = s.method;
            if (!this.shouldIgnorePairingRequest({
                topic: e,
                requestMethod: o
            })) switch(o){
                case "wc_sessionPropose":
                    return await this.onSessionProposeRequest({
                        topic: e,
                        payload: s,
                        attestation: i,
                        encryptedId: r
                    });
                case "wc_sessionSettle":
                    return await this.onSessionSettleRequest(e, s);
                case "wc_sessionUpdate":
                    return await this.onSessionUpdateRequest(e, s);
                case "wc_sessionExtend":
                    return await this.onSessionExtendRequest(e, s);
                case "wc_sessionPing":
                    return await this.onSessionPingRequest(e, s);
                case "wc_sessionDelete":
                    return await this.onSessionDeleteRequest(e, s);
                case "wc_sessionRequest":
                    return await this.onSessionRequest({
                        topic: e,
                        payload: s,
                        attestation: i,
                        encryptedId: r
                    });
                case "wc_sessionEvent":
                    return await this.onSessionEventRequest(e, s);
                case "wc_sessionAuthenticate":
                    return await this.onSessionAuthenticateRequest({
                        topic: e,
                        payload: s,
                        attestation: i,
                        encryptedId: r
                    });
                default:
                    return this.client.logger.info(`Unsupported request method ${o}`);
            }
        }, this.onRelayEventResponse = async (t)=>{
            const { topic: e, payload: s } = t, i = (await this.client.core.history.get(e, s.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(e, s);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(e, s);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(e, s);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(e, s);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(e, s);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(e, s);
                case "wc_sessionAuthenticate":
                    return this.onSessionAuthenticateResponse(e, s);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (t)=>{
            const { topic: e } = t, { message: s } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `Decoded payload on topic ${e} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(s);
        }, this.shouldIgnorePairingRequest = (t)=>{
            const { topic: e, requestMethod: s } = t, i = this.expectedPairingMethodMap.get(e);
            return !i || i.includes(s) ? !1 : !!(i.includes("wc_sessionAuthenticate") && this.client.events.listenerCount("session_authenticate") > 0);
        }, this.onSessionProposeRequest = async (t)=>{
            const { topic: e, payload: s, attestation: i, encryptedId: r } = t, { params: o, id: a } = s;
            try {
                const c = this.client.core.eventClient.getEvent({
                    topic: e
                });
                this.isValidConnect($73839c57d19ee815$var$E({}, s.params));
                const h = o.expiryTimestamp || (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), l = $73839c57d19ee815$var$E({
                    id: a,
                    pairingTopic: e,
                    expiryTimestamp: h
                }, o);
                await this.setProposal(a, l);
                const g = await this.getVerifyContext({
                    attestationId: i,
                    hash: (0, $iN1TF.hashMessage)(JSON.stringify(s)),
                    encryptedId: r,
                    metadata: l.proposer.metadata
                });
                this.client.events.listenerCount("session_proposal") === 0 && (console.warn("No listener for session_proposal event"), c?.setError((0, $jSQmq.EVENT_CLIENT_PAIRING_ERRORS).proposal_listener_not_found)), c?.addTrace((0, $jSQmq.EVENT_CLIENT_PAIRING_TRACES).emit_session_proposal), this.client.events.emit("session_proposal", {
                    id: a,
                    params: l,
                    verifyContext: g
                });
            } catch (c) {
                await this.sendError({
                    id: a,
                    topic: e,
                    error: c,
                    rpcOpts: $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionPropose.autoReject
                }), this.client.logger.error(c);
            }
        }, this.onSessionProposeResponse = async (t, e)=>{
            const { id: s } = e;
            if ((0, $bNBqy.isJsonRpcResult)(e)) {
                const { result: i } = e;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const r = this.client.proposal.get(s);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: r
                });
                const o = r.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const c = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: c
                });
                const h = await this.client.core.relayer.subscribe(c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: h
                }), await this.client.core.pairing.activate({
                    topic: t
                });
            } else if ((0, $bNBqy.isJsonRpcError)(e)) {
                await this.client.proposal.delete(s, (0, $iN1TF.getSdkError)("USER_DISCONNECTED"));
                const i = (0, $iN1TF.engineEvent)("session_connect");
                if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners, 954`);
                this.events.emit((0, $iN1TF.engineEvent)("session_connect"), {
                    error: e.error
                });
            }
        }, this.onSessionSettleRequest = async (t, e)=>{
            const { id: s, params: i } = e;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: r, controller: o, expiry: a, namespaces: c, sessionProperties: h, sessionConfig: l } = e.params, g = $73839c57d19ee815$var$E($73839c57d19ee815$var$E({
                    topic: t,
                    relay: r,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: "",
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, h && {
                    sessionProperties: h
                }), l && {
                    sessionConfig: l
                }), d = (0, $iN1TF.engineEvent)("session_connect");
                if (this.events.listenerCount(d) === 0) throw new Error(`emitting ${d} without any listeners 997`);
                this.events.emit((0, $iN1TF.engineEvent)("session_connect"), {
                    session: g
                }), await this.sendResult({
                    id: e.id,
                    topic: t,
                    result: !0,
                    throwOnFailedPublish: !0
                });
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: t,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.onSessionSettleResponse = async (t, e)=>{
            const { id: s } = e;
            (0, $bNBqy.isJsonRpcResult)(e) ? (await this.client.session.update(t, {
                acknowledged: !0
            }), this.events.emit((0, $iN1TF.engineEvent)("session_approve", s), {})) : (0, $bNBqy.isJsonRpcError)(e) && (await this.client.session.delete(t, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")), this.events.emit((0, $iN1TF.engineEvent)("session_approve", s), {
                error: e.error
            }));
        }, this.onSessionUpdateRequest = async (t, e)=>{
            const { params: s, id: i } = e;
            try {
                const r = `${t}_session_update`, o = (0, $iN1TF.MemoryStore).get(r);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.info(`Discarding out of sync request - ${i}`), this.sendError({
                        id: i,
                        topic: t,
                        error: (0, $iN1TF.getSdkError)("INVALID_UPDATE_REQUEST")
                    });
                    return;
                }
                this.isValidUpdate($73839c57d19ee815$var$E({
                    topic: t
                }, s));
                try {
                    (0, $iN1TF.MemoryStore).set(r, i), await this.client.session.update(t, {
                        namespaces: s.namespaces
                    }), await this.sendResult({
                        id: i,
                        topic: t,
                        result: !0,
                        throwOnFailedPublish: !0
                    });
                } catch (a) {
                    throw (0, $iN1TF.MemoryStore).delete(r), a;
                }
                this.client.events.emit("session_update", {
                    id: i,
                    topic: t,
                    params: s
                });
            } catch (r) {
                await this.sendError({
                    id: i,
                    topic: t,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.isRequestOutOfSync = (t, e)=>parseInt(e.toString().slice(0, -3)) <= parseInt(t.toString().slice(0, -3)), this.onSessionUpdateResponse = (t, e)=>{
            const { id: s } = e, i = (0, $iN1TF.engineEvent)("session_update", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $bNBqy.isJsonRpcResult)(e) ? this.events.emit((0, $iN1TF.engineEvent)("session_update", s), {}) : (0, $bNBqy.isJsonRpcError)(e) && this.events.emit((0, $iN1TF.engineEvent)("session_update", s), {
                error: e.error
            });
        }, this.onSessionExtendRequest = async (t, e)=>{
            const { id: s } = e;
            try {
                this.isValidExtend({
                    topic: t
                }), await this.setExpiry(t, (0, $iN1TF.calcExpiry)($73839c57d19ee815$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: s,
                    topic: t,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_extend", {
                    id: s,
                    topic: t
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: t,
                    error: i
                }), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (t, e)=>{
            const { id: s } = e, i = (0, $iN1TF.engineEvent)("session_extend", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $bNBqy.isJsonRpcResult)(e) ? this.events.emit((0, $iN1TF.engineEvent)("session_extend", s), {}) : (0, $bNBqy.isJsonRpcError)(e) && this.events.emit((0, $iN1TF.engineEvent)("session_extend", s), {
                error: e.error
            });
        }, this.onSessionPingRequest = async (t, e)=>{
            const { id: s } = e;
            try {
                this.isValidPing({
                    topic: t
                }), await this.sendResult({
                    id: s,
                    topic: t,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_ping", {
                    id: s,
                    topic: t
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: t,
                    error: i
                }), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (t, e)=>{
            const { id: s } = e, i = (0, $iN1TF.engineEvent)("session_ping", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            setTimeout(()=>{
                (0, $bNBqy.isJsonRpcResult)(e) ? this.events.emit((0, $iN1TF.engineEvent)("session_ping", s), {}) : (0, $bNBqy.isJsonRpcError)(e) && this.events.emit((0, $iN1TF.engineEvent)("session_ping", s), {
                    error: e.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (t, e)=>{
            const { id: s } = e;
            try {
                this.isValidDisconnect({
                    topic: t,
                    reason: e.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $jSQmq.RELAYER_EVENTS).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: t,
                                id: s
                            }));
                        });
                    }),
                    this.sendResult({
                        id: s,
                        topic: t,
                        result: !0,
                        throwOnFailedPublish: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: t,
                        error: (0, $iN1TF.getSdkError)("USER_DISCONNECTED")
                    })
                ]);
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (t)=>{
            var e;
            const { topic: s, payload: i, attestation: r, encryptedId: o } = t, { id: a, params: c } = i;
            try {
                await this.isValidRequest($73839c57d19ee815$var$E({
                    topic: s
                }, c));
                const h = this.client.session.get(s), l = await this.getVerifyContext({
                    attestationId: r,
                    hash: (0, $iN1TF.hashMessage)(JSON.stringify((0, $eS6BO.formatJsonRpcRequest)("wc_sessionRequest", c, a))),
                    encryptedId: o,
                    metadata: h.peer.metadata
                }), g = {
                    id: a,
                    topic: s,
                    params: c,
                    verifyContext: l
                };
                await this.setPendingSessionRequest(g), (e = this.client.signConfig) != null && e.disableRequestQueue ? this.emitSessionRequest(g) : (this.addSessionRequestToSessionRequestQueue(g), this.processSessionRequestQueue());
            } catch (h) {
                await this.sendError({
                    id: a,
                    topic: s,
                    error: h
                }), this.client.logger.error(h);
            }
        }, this.onSessionRequestResponse = (t, e)=>{
            const { id: s } = e, i = (0, $iN1TF.engineEvent)("session_request", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $bNBqy.isJsonRpcResult)(e) ? this.events.emit((0, $iN1TF.engineEvent)("session_request", s), {
                result: e.result
            }) : (0, $bNBqy.isJsonRpcError)(e) && this.events.emit((0, $iN1TF.engineEvent)("session_request", s), {
                error: e.error
            });
        }, this.onSessionEventRequest = async (t, e)=>{
            const { id: s, params: i } = e;
            try {
                const r = `${t}_session_event_${i.event.name}`, o = (0, $iN1TF.MemoryStore).get(r);
                if (o && this.isRequestOutOfSync(o, s)) {
                    this.client.logger.info(`Discarding out of sync request - ${s}`);
                    return;
                }
                this.isValidEmit($73839c57d19ee815$var$E({
                    topic: t
                }, i)), this.client.events.emit("session_event", {
                    id: s,
                    topic: t,
                    params: i
                }), (0, $iN1TF.MemoryStore).set(r, s);
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: t,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.onSessionAuthenticateResponse = (t, e)=>{
            const { id: s } = e;
            this.client.logger.trace({
                type: "method",
                method: "onSessionAuthenticateResponse",
                topic: t,
                payload: e
            }), (0, $bNBqy.isJsonRpcResult)(e) ? this.events.emit((0, $iN1TF.engineEvent)("session_request", s), {
                result: e.result
            }) : (0, $bNBqy.isJsonRpcError)(e) && this.events.emit((0, $iN1TF.engineEvent)("session_request", s), {
                error: e.error
            });
        }, this.onSessionAuthenticateRequest = async (t)=>{
            const { topic: e, payload: s, attestation: i, encryptedId: r } = t;
            try {
                const { requester: o, authPayload: a, expiryTimestamp: c } = s.params, h = await this.getVerifyContext({
                    attestationId: i,
                    hash: (0, $iN1TF.hashMessage)(JSON.stringify(s)),
                    encryptedId: r,
                    metadata: this.client.metadata
                }), l = {
                    requester: o,
                    pairingTopic: e,
                    id: s.id,
                    authPayload: a,
                    verifyContext: h,
                    expiryTimestamp: c
                };
                await this.setAuthRequest(s.id, {
                    request: l,
                    pairingTopic: e
                }), this.client.events.emit("session_authenticate", {
                    topic: e,
                    params: s.params,
                    id: s.id,
                    verifyContext: h
                });
            } catch (o) {
                this.client.logger.error(o);
                const a = s.params.requester.publicKey, c = await this.client.core.crypto.generateKeyPair(), h = {
                    type: (0, $iN1TF.TYPE_1),
                    receiverPublicKey: a,
                    senderPublicKey: c
                };
                await this.sendError({
                    id: s.id,
                    topic: e,
                    error: o,
                    encodeOpts: h,
                    rpcOpts: $73839c57d19ee815$export$4edb1ca37014192d.wc_sessionAuthenticate.autoReject
                });
            }
        }, this.addSessionRequestToSessionRequestQueue = (t)=>{
            this.sessionRequestQueue.queue.push(t);
        }, this.cleanupAfterResponse = (t)=>{
            this.deletePendingSessionRequest(t.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $73839c57d19ee815$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $iNdL8.toMiliseconds)(this.requestQueueDelay));
        }, this.cleanupPendingSentRequestsForTopic = ({ topic: t, error: e })=>{
            const s = this.client.core.history.pending;
            s.length > 0 && s.filter((i)=>i.topic === t && i.request.method === "wc_sessionRequest").forEach((i)=>{
                const r = i.request.id, o = (0, $iN1TF.engineEvent)("session_request", r);
                if (this.events.listenerCount(o) === 0) throw new Error(`emitting ${o} without any listeners`);
                this.events.emit((0, $iN1TF.engineEvent)("session_request", i.request.id), {
                    error: e
                });
            });
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === $73839c57d19ee815$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const t = this.sessionRequestQueue.queue[0];
            if (!t) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $73839c57d19ee815$export$8602b201748df21a.active, this.emitSessionRequest(t);
            } catch (e) {
                this.client.logger.error(e);
            }
        }, this.emitSessionRequest = (t)=>{
            this.client.events.emit("session_request", t);
        }, this.onPairingCreated = (t)=>{
            if (t.methods && this.expectedPairingMethodMap.set(t.topic, t.methods), t.active) return;
            const e = this.client.proposal.getAll().find((s)=>s.pairingTopic === t.topic);
            e && this.onSessionProposeRequest({
                topic: t.topic,
                payload: (0, $eS6BO.formatJsonRpcRequest)("wc_sessionPropose", {
                    requiredNamespaces: e.requiredNamespaces,
                    optionalNamespaces: e.optionalNamespaces,
                    relays: e.relays,
                    proposer: e.proposer,
                    sessionProperties: e.sessionProperties
                }, e.id)
            });
        }, this.isValidConnect = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            const { pairingTopic: e, requiredNamespaces: s, optionalNamespaces: i, sessionProperties: r, relays: o } = t;
            if ((0, $iN1TF.isUndefined)(e) || await this.isValidPairingTopic(e), !(0, $iN1TF.isValidRelays)(o, !0)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $iN1TF.isUndefined)(s) && (0, $iN1TF.isValidObject)(s) !== 0 && this.validateNamespaces(s, "requiredNamespaces"), !(0, $iN1TF.isUndefined)(i) && (0, $iN1TF.isValidObject)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $iN1TF.isUndefined)(r) || this.validateSessionProps(r, "sessionProperties");
        }, this.validateNamespaces = (t, e)=>{
            const s = (0, $iN1TF.isValidRequiredNamespaces)(t, "connect()", e);
            if (s) throw new Error(s.message);
        }, this.isValidApprove = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) throw new Error((0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `approve() params: ${t}`).message);
            const { id: e, namespaces: s, relayProtocol: i, sessionProperties: r } = t;
            this.checkRecentlyDeleted(e), await this.isValidProposalId(e);
            const o = this.client.proposal.get(e), a = (0, $iN1TF.isValidNamespaces)(s, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, $iN1TF.isConformingNamespaces)(o.requiredNamespaces, s, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, $iN1TF.isValidString)(i, !0)) {
                const { message: h } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(h);
            }
            (0, $iN1TF.isUndefined)(r) || this.validateSessionProps(r, "sessionProperties");
        }, this.isValidReject = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: i } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `reject() params: ${t}`);
                throw new Error(i);
            }
            const { id: e, reason: s } = t;
            if (this.checkRecentlyDeleted(e), await this.isValidProposalId(e), !(0, $iN1TF.isValidErrorReason)(s)) {
                const { message: i } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(s)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: c } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${t}`);
                throw new Error(c);
            }
            const { relay: e, controller: s, namespaces: i, expiry: r } = t;
            if (!(0, $iN1TF.isValidRelay)(e)) {
                const { message: c } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const o = (0, $iN1TF.isValidController)(s, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $iN1TF.isValidNamespaces)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $iN1TF.isExpired)(r)) {
                const { message: c } = (0, $iN1TF.getInternalError)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `update() params: ${t}`);
                throw new Error(a);
            }
            const { topic: e, namespaces: s } = t;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
            const i = this.client.session.get(e), r = (0, $iN1TF.isValidNamespaces)(s, "update()");
            if (r) throw new Error(r.message);
            const o = (0, $iN1TF.isConformingNamespaces)(i.requiredNamespaces, s, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: s } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `extend() params: ${t}`);
                throw new Error(s);
            }
            const { topic: e } = t;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
        }, this.isValidRequest = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `request() params: ${t}`);
                throw new Error(a);
            }
            const { topic: e, request: s, chainId: i, expiry: r } = t;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
            const { namespaces: o } = this.client.session.get(e);
            if (!(0, $iN1TF.isValidNamespacesChainId)(o, i)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $iN1TF.isValidRequest)(s)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `request() ${JSON.stringify(s)}`);
                throw new Error(a);
            }
            if (!(0, $iN1TF.isValidNamespacesRequest)(o, i, s.method)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `request() method: ${s.method}`);
                throw new Error(a);
            }
            if (r && !(0, $iN1TF.isValidRequestExpiry)(r, $73839c57d19ee815$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `request() expiry: ${r}. Expiry must be a number (in seconds) between ${$73839c57d19ee815$export$409f0c0a13a1b7c6.min} and ${$73839c57d19ee815$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (t)=>{
            var e;
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: r } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `respond() params: ${t}`);
                throw new Error(r);
            }
            const { topic: s, response: i } = t;
            try {
                await this.isValidSessionTopic(s);
            } catch (r) {
                throw (e = t?.response) != null && e.id && this.cleanupAfterResponse(t), r;
            }
            if (!(0, $iN1TF.isValidResponse)(i)) {
                const { message: r } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(r);
            }
        }, this.isValidPing = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: s } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `ping() params: ${t}`);
                throw new Error(s);
            }
            const { topic: e } = t;
            await this.isValidSessionOrPairingTopic(e);
        }, this.isValidEmit = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: o } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `emit() params: ${t}`);
                throw new Error(o);
            }
            const { topic: e, event: s, chainId: i } = t;
            await this.isValidSessionTopic(e);
            const { namespaces: r } = this.client.session.get(e);
            if (!(0, $iN1TF.isValidNamespacesChainId)(r, i)) {
                const { message: o } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $iN1TF.isValidEvent)(s)) {
                const { message: o } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(o);
            }
            if (!(0, $iN1TF.isValidNamespacesEvent)(r, i, s.name)) {
                const { message: o } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (t)=>{
            if (!(0, $iN1TF.isValidParams)(t)) {
                const { message: s } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${t}`);
                throw new Error(s);
            }
            const { topic: e } = t;
            await this.isValidSessionOrPairingTopic(e);
        }, this.isValidAuthenticate = (t)=>{
            const { chains: e, uri: s, domain: i, nonce: r } = t;
            if (!Array.isArray(e) || e.length === 0) throw new Error("chains is required and must be a non-empty array");
            if (!(0, $iN1TF.isValidString)(s, !1)) throw new Error("uri is required parameter");
            if (!(0, $iN1TF.isValidString)(i, !1)) throw new Error("domain is required parameter");
            if (!(0, $iN1TF.isValidString)(r, !1)) throw new Error("nonce is required parameter");
            if ([
                ...new Set(e.map((a)=>(0, $iN1TF.parseChainId)(a).namespace))
            ].length > 1) throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
            const { namespace: o } = (0, $iN1TF.parseChainId)(e[0]);
            if (o !== "eip155") throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
        }, this.getVerifyContext = async (t)=>{
            const { attestationId: e, hash: s, encryptedId: i, metadata: r } = t, o = {
                verified: {
                    verifyUrl: r.verifyUrl || (0, $jSQmq.VERIFY_SERVER),
                    validation: "UNKNOWN",
                    origin: r.url || ""
                }
            };
            try {
                const a = await this.client.core.verify.resolve({
                    attestationId: e,
                    hash: s,
                    encryptedId: i,
                    verifyUrl: r.verifyUrl
                });
                a && (o.verified.origin = a.origin, o.verified.isScam = a.isScam, o.verified.validation = a.origin === new URL(r.url).origin ? "VALID" : "INVALID");
            } catch (a) {
                this.client.logger.warn(a);
            }
            return this.client.logger.debug(`Verify context: ${JSON.stringify(o)}`), o;
        }, this.validateSessionProps = (t, e)=>{
            Object.values(t).forEach((s)=>{
                if (!(0, $iN1TF.isValidString)(s, !1)) {
                    const { message: i } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `${e} must be in Record<string, string> format. Received: ${JSON.stringify(s)}`);
                    throw new Error(i);
                }
            });
        }, this.getPendingAuthRequest = (t)=>{
            const e = this.client.auth.requests.get(t);
            return typeof e == "object" ? e : void 0;
        }, this.addToRecentlyDeleted = (t, e)=>{
            if (this.recentlyDeletedMap.set(t, e), this.recentlyDeletedMap.size >= this.recentlyDeletedLimit) {
                let s = 0;
                const i = this.recentlyDeletedLimit / 2;
                for (const r of this.recentlyDeletedMap.keys()){
                    if (s++ >= i) break;
                    this.recentlyDeletedMap.delete(r);
                }
            }
        }, this.checkRecentlyDeleted = (t)=>{
            const e = this.recentlyDeletedMap.get(t);
            if (e) {
                const { message: s } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `Record was recently deleted - ${e}: ${t}`);
                throw new Error(s);
            }
        };
    }
    async isInitialized() {
        if (!this.initialized) {
            const { message: n } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(n);
        }
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $jSQmq.RELAYER_EVENTS).message, (n)=>{
            !this.initialized || this.relayMessageCache.length > 0 ? this.relayMessageCache.push(n) : this.onRelayMessage(n);
        });
    }
    async onRelayMessage(n) {
        const { topic: t, message: e, attestation: s } = n, { publicKey: i } = this.client.auth.authKeys.keys.includes($73839c57d19ee815$export$efef74cb455ac30f) ? this.client.auth.authKeys.get($73839c57d19ee815$export$efef74cb455ac30f) : {
            responseTopic: void 0,
            publicKey: void 0
        }, r = await this.client.core.crypto.decode(t, e, {
            receiverPublicKey: i
        });
        try {
            (0, $bNBqy.isJsonRpcRequest)(r) ? (this.client.core.history.set(t, r), this.onRelayEventRequest({
                topic: t,
                payload: r,
                attestation: s,
                encryptedId: (0, $iN1TF.hashMessage)(e)
            })) : (0, $bNBqy.isJsonRpcResponse)(r) ? (await this.client.core.history.resolve(r), await this.onRelayEventResponse({
                topic: t,
                payload: r
            }), this.client.core.history.delete(t, r.id)) : this.onRelayEventUnknownPayload({
                topic: t,
                payload: r
            });
        } catch (o) {
            this.client.logger.error(o);
        }
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $jSQmq.EXPIRER_EVENTS).expired, async (n)=>{
            const { topic: t, id: e } = (0, $iN1TF.parseExpirerTarget)(n.target);
            if (e && this.client.pendingRequest.keys.includes(e)) return await this.deletePendingSessionRequest(e, (0, $iN1TF.getInternalError)("EXPIRED"), !0);
            if (e && this.client.auth.requests.keys.includes(e)) return await this.deletePendingAuthRequest(e, (0, $iN1TF.getInternalError)("EXPIRED"), !0);
            t ? this.client.session.keys.includes(t) && (await this.deleteSession({
                topic: t,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: t
            })) : e && (await this.deleteProposal(e, !0), this.client.events.emit("proposal_expire", {
                id: e
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $jSQmq.PAIRING_EVENTS).create, (n)=>this.onPairingCreated(n)), this.client.core.pairing.events.on((0, $jSQmq.PAIRING_EVENTS).delete, (n)=>{
            this.addToRecentlyDeleted(n.topic, "pairing");
        });
    }
    isValidPairingTopic(n) {
        if (!(0, $iN1TF.isValidString)(n, !1)) {
            const { message: t } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${n}`);
            throw new Error(t);
        }
        if (!this.client.core.pairing.pairings.keys.includes(n)) {
            const { message: t } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${n}`);
            throw new Error(t);
        }
        if ((0, $iN1TF.isExpired)(this.client.core.pairing.pairings.get(n).expiry)) {
            const { message: t } = (0, $iN1TF.getInternalError)("EXPIRED", `pairing topic: ${n}`);
            throw new Error(t);
        }
    }
    async isValidSessionTopic(n) {
        if (!(0, $iN1TF.isValidString)(n, !1)) {
            const { message: t } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `session topic should be a string: ${n}`);
            throw new Error(t);
        }
        if (this.checkRecentlyDeleted(n), !this.client.session.keys.includes(n)) {
            const { message: t } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `session topic doesn't exist: ${n}`);
            throw new Error(t);
        }
        if ((0, $iN1TF.isExpired)(this.client.session.get(n).expiry)) {
            await this.deleteSession({
                topic: n
            });
            const { message: t } = (0, $iN1TF.getInternalError)("EXPIRED", `session topic: ${n}`);
            throw new Error(t);
        }
        if (!this.client.core.crypto.keychain.has(n)) {
            const { message: t } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${n}`);
            throw await this.deleteSession({
                topic: n
            }), new Error(t);
        }
    }
    async isValidSessionOrPairingTopic(n) {
        if (this.checkRecentlyDeleted(n), this.client.session.keys.includes(n)) await this.isValidSessionTopic(n);
        else if (this.client.core.pairing.pairings.keys.includes(n)) this.isValidPairingTopic(n);
        else if ((0, $iN1TF.isValidString)(n, !1)) {
            const { message: t } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${n}`);
            throw new Error(t);
        } else {
            const { message: t } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${n}`);
            throw new Error(t);
        }
    }
    async isValidProposalId(n) {
        if (!(0, $iN1TF.isValidId)(n)) {
            const { message: t } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `proposal id should be a number: ${n}`);
            throw new Error(t);
        }
        if (!this.client.proposal.keys.includes(n)) {
            const { message: t } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `proposal id doesn't exist: ${n}`);
            throw new Error(t);
        }
        if ((0, $iN1TF.isExpired)(this.client.proposal.get(n).expiryTimestamp)) {
            await this.deleteProposal(n);
            const { message: t } = (0, $iN1TF.getInternalError)("EXPIRED", `proposal id: ${n}`);
            throw new Error(t);
        }
    }
}
class $73839c57d19ee815$var$ns extends (0, $jSQmq.Store) {
    constructor(n, t){
        super(n, t, $73839c57d19ee815$export$ae6c7a4f7ed730a1, $73839c57d19ee815$export$7fa6f9ee1e2cab96), this.core = n, this.logger = t;
    }
}
class $73839c57d19ee815$var$it extends (0, $jSQmq.Store) {
    constructor(n, t){
        super(n, t, $73839c57d19ee815$export$a069e98a8dfeec1e, $73839c57d19ee815$export$7fa6f9ee1e2cab96), this.core = n, this.logger = t;
    }
}
class $73839c57d19ee815$var$os extends (0, $jSQmq.Store) {
    constructor(n, t){
        super(n, t, $73839c57d19ee815$export$40b296af21bd38a4, $73839c57d19ee815$export$7fa6f9ee1e2cab96, (e)=>e.id), this.core = n, this.logger = t;
    }
}
class $73839c57d19ee815$var$as extends (0, $jSQmq.Store) {
    constructor(n, t){
        super(n, t, $73839c57d19ee815$export$ab815cb37981e7e0, $73839c57d19ee815$export$323ba3ebb8028ed0, ()=>$73839c57d19ee815$export$efef74cb455ac30f), this.core = n, this.logger = t;
    }
}
class $73839c57d19ee815$var$cs extends (0, $jSQmq.Store) {
    constructor(n, t){
        super(n, t, $73839c57d19ee815$export$5d9af9e20f678626, $73839c57d19ee815$export$323ba3ebb8028ed0), this.core = n, this.logger = t;
    }
}
class $73839c57d19ee815$var$ls extends (0, $jSQmq.Store) {
    constructor(n, t){
        super(n, t, $73839c57d19ee815$export$3643b3579d091159, $73839c57d19ee815$export$323ba3ebb8028ed0, (e)=>e.id), this.core = n, this.logger = t;
    }
}
class $73839c57d19ee815$var$hs {
    constructor(n, t){
        this.core = n, this.logger = t, this.authKeys = new $73839c57d19ee815$var$as(this.core, this.logger), this.pairingTopics = new $73839c57d19ee815$var$cs(this.core, this.logger), this.requests = new $73839c57d19ee815$var$ls(this.core, this.logger);
    }
    async init() {
        await this.authKeys.init(), await this.pairingTopics.init(), await this.requests.init();
    }
}
class $73839c57d19ee815$export$2e2bcd8739ae039 extends (0, $evwHH.ISignClient) {
    constructor(n){
        super(n), this.protocol = $73839c57d19ee815$export$4fa962fc67384e02, this.version = $73839c57d19ee815$export$61085c48796ff049, this.name = $73839c57d19ee815$export$8dffb3242f2c5f72.name, this.events = new (0, $jMGWz.EventEmitter), this.on = (e, s)=>this.events.on(e, s), this.once = (e, s)=>this.events.once(e, s), this.off = (e, s)=>this.events.off(e, s), this.removeListener = (e, s)=>this.events.removeListener(e, s), this.removeAllListeners = (e)=>this.events.removeAllListeners(e), this.connect = async (e)=>{
            try {
                return await this.engine.connect(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.pair = async (e)=>{
            try {
                return await this.engine.pair(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.approve = async (e)=>{
            try {
                return await this.engine.approve(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.reject = async (e)=>{
            try {
                return await this.engine.reject(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.update = async (e)=>{
            try {
                return await this.engine.update(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.extend = async (e)=>{
            try {
                return await this.engine.extend(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.request = async (e)=>{
            try {
                return await this.engine.request(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.respond = async (e)=>{
            try {
                return await this.engine.respond(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.ping = async (e)=>{
            try {
                return await this.engine.ping(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.emit = async (e)=>{
            try {
                return await this.engine.emit(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.disconnect = async (e)=>{
            try {
                return await this.engine.disconnect(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.find = (e)=>{
            try {
                return this.engine.find(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (e) {
                throw this.logger.error(e.message), e;
            }
        }, this.authenticate = async (e)=>{
            try {
                return await this.engine.authenticate(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.formatAuthMessage = (e)=>{
            try {
                return this.engine.formatAuthMessage(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.approveSessionAuthenticate = async (e)=>{
            try {
                return await this.engine.approveSessionAuthenticate(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.rejectSessionAuthenticate = async (e)=>{
            try {
                return await this.engine.rejectSessionAuthenticate(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = n?.name || $73839c57d19ee815$export$8dffb3242f2c5f72.name, this.metadata = n?.metadata || (0, $iN1TF.getAppMetadata)(), this.signConfig = n?.signConfig;
        const t = typeof n?.logger < "u" && typeof n?.logger != "string" ? n.logger : (0, (/*@__PURE__*/$parcel$interopDefault($6rVbn)))((0, $GVAyr.getDefaultLoggerOptions)({
            level: n?.logger || $73839c57d19ee815$export$8dffb3242f2c5f72.logger
        }));
        this.core = n?.core || new (0, $jSQmq.Core)(n), this.logger = (0, $GVAyr.generateChildLogger)(t, this.name), this.session = new $73839c57d19ee815$var$it(this.core, this.logger), this.proposal = new $73839c57d19ee815$var$ns(this.core, this.logger), this.pendingRequest = new $73839c57d19ee815$var$os(this.core, this.logger), this.engine = new $73839c57d19ee815$var$rs(this), this.auth = new $73839c57d19ee815$var$hs(this.core, this.logger);
    }
    static async init(n) {
        const t = new $73839c57d19ee815$export$2e2bcd8739ae039(n);
        return await t.initialize(), t;
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), await this.auth.init(), this.logger.info("SignClient Initialization Success"), this.engine.processRelayMessageCache();
        } catch (n) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(n.message), n;
        }
    }
}
const $73839c57d19ee815$export$90b8cff65c105172 = $73839c57d19ee815$var$it, $73839c57d19ee815$export$bdf4ba258ec679dc = $73839c57d19ee815$export$2e2bcd8739ae039;

});
parcelRegister("jSQmq", function(module, exports) {

$parcel$export(module.exports, "RELAYER_DEFAULT_PROTOCOL", function () { return $e79bad377ed788e9$export$822d0bd1635d5360; });
$parcel$export(module.exports, "RELAYER_EVENTS", function () { return $e79bad377ed788e9$export$d56245796e2837d; });
$parcel$export(module.exports, "PAIRING_EVENTS", function () { return $e79bad377ed788e9$export$ca3c0b962acf7b75; });
$parcel$export(module.exports, "EXPIRER_EVENTS", function () { return $e79bad377ed788e9$export$9013719d9206b0c1; });
$parcel$export(module.exports, "VERIFY_SERVER", function () { return $e79bad377ed788e9$export$7e3b1a28ddecdbaa; });
$parcel$export(module.exports, "EVENT_CLIENT_PAIRING_TRACES", function () { return $e79bad377ed788e9$export$6736f9bb609b5d34; });
$parcel$export(module.exports, "EVENT_CLIENT_PAIRING_ERRORS", function () { return $e79bad377ed788e9$export$e1dc85b7b7495247; });
$parcel$export(module.exports, "EVENT_CLIENT_SESSION_TRACES", function () { return $e79bad377ed788e9$export$16ed3f27a411eba0; });
$parcel$export(module.exports, "EVENT_CLIENT_SESSION_ERRORS", function () { return $e79bad377ed788e9$export$bc50109885e83402; });
$parcel$export(module.exports, "EVENT_CLIENT_AUTHENTICATE_TRACES", function () { return $e79bad377ed788e9$export$6540f02663742dde; });
$parcel$export(module.exports, "EVENT_CLIENT_AUTHENTICATE_ERRORS", function () { return $e79bad377ed788e9$export$aca4f34441e6cd3a; });
$parcel$export(module.exports, "Store", function () { return $e79bad377ed788e9$export$390f32400eaf98c9; });
$parcel$export(module.exports, "Core", function () { return $e79bad377ed788e9$export$4143ab5b91744744; });

var $jMGWz = parcelRequire("jMGWz");

var $a5MFc = parcelRequire("a5MFc");

var $ahj4I = parcelRequire("ahj4I");

var $GVAyr = parcelRequire("GVAyr");
var $6rVbn = parcelRequire("6rVbn");

var $evwHH = parcelRequire("evwHH");

var $6mXg5 = parcelRequire("6mXg5");
parcelRequire("fjT6R");
var $i4OlP = parcelRequire("i4OlP");
var $hSpoa = parcelRequire("hSpoa");

var $iN1TF = parcelRequire("iN1TF");
parcelRequire("lgSQS");
var $5t5tf = parcelRequire("5t5tf");

var $iNdL8 = parcelRequire("iNdL8");

var $kUdYz = parcelRequire("kUdYz");
parcelRequire("6bXmq");
var $eS6BO = parcelRequire("eS6BO");
var $bNBqy = parcelRequire("bNBqy");

var $5u48b = parcelRequire("5u48b");

var $42iJY = parcelRequire("42iJY");
function $e79bad377ed788e9$var$us(o, e) {
    if (o.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), s = 0; s < t.length; s++)t[s] = 255;
    for(var i = 0; i < o.length; i++){
        var r = o.charAt(i), n = r.charCodeAt(0);
        if (t[n] !== 255) throw new TypeError(r + " is ambiguous");
        t[n] = i;
    }
    var a = o.length, h = o.charAt(0), c = Math.log(a) / Math.log(256), d = Math.log(256) / Math.log(a);
    function g(l) {
        if (l instanceof Uint8Array || (ArrayBuffer.isView(l) ? l = new Uint8Array(l.buffer, l.byteOffset, l.byteLength) : Array.isArray(l) && (l = Uint8Array.from(l))), !(l instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (l.length === 0) return "";
        for(var p = 0, _ = 0, D = 0, E = l.length; D !== E && l[D] === 0;)D++, p++;
        for(var N = (E - D) * d + 1 >>> 0, T = new Uint8Array(N); D !== E;){
            for(var z = l[D], U = 0, x = N - 1; (z !== 0 || U < _) && x !== -1; x--, U++)z += 256 * T[x] >>> 0, T[x] = z % a >>> 0, z = z / a >>> 0;
            if (z !== 0) throw new Error("Non-zero carry");
            _ = U, D++;
        }
        for(var $ = N - _; $ !== N && T[$] === 0;)$++;
        for(var Q = h.repeat(p); $ < N; ++$)Q += o.charAt(T[$]);
        return Q;
    }
    function b(l) {
        if (typeof l != "string") throw new TypeError("Expected String");
        if (l.length === 0) return new Uint8Array;
        var p = 0;
        if (l[p] !== " ") {
            for(var _ = 0, D = 0; l[p] === h;)_++, p++;
            for(var E = (l.length - p) * c + 1 >>> 0, N = new Uint8Array(E); l[p];){
                var T = t[l.charCodeAt(p)];
                if (T === 255) return;
                for(var z = 0, U = E - 1; (T !== 0 || z < D) && U !== -1; U--, z++)T += a * N[U] >>> 0, N[U] = T % 256 >>> 0, T = T / 256 >>> 0;
                if (T !== 0) throw new Error("Non-zero carry");
                D = z, p++;
            }
            if (l[p] !== " ") {
                for(var x = E - D; x !== E && N[x] === 0;)x++;
                for(var $ = new Uint8Array(_ + (E - x)), Q = _; x !== E;)$[Q++] = N[x++];
                return $;
            }
        }
    }
    function m(l) {
        var p = b(l);
        if (p) return p;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: g,
        decodeUnsafe: b,
        decode: m
    };
}
var $e79bad377ed788e9$var$ds = $e79bad377ed788e9$var$us, $e79bad377ed788e9$var$gs = $e79bad377ed788e9$var$ds;
const $e79bad377ed788e9$var$Ve = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $e79bad377ed788e9$var$ps = (o)=>new TextEncoder().encode(o), $e79bad377ed788e9$var$ys = (o)=>new TextDecoder().decode(o);
class $e79bad377ed788e9$var$Ds {
    constructor(e, t, s){
        this.name = e, this.prefix = t, this.baseEncode = s;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $e79bad377ed788e9$var$bs {
    constructor(e, t, s){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = s;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $e79bad377ed788e9$var$je(this, e);
    }
}
class $e79bad377ed788e9$var$ms {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $e79bad377ed788e9$var$je(this, e);
    }
    decode(e) {
        const t = e[0], s = this.decoders[t];
        if (s) return s.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $e79bad377ed788e9$var$je = (o, e)=>new $e79bad377ed788e9$var$ms({
        ...o.decoders || {
            [o.prefix]: o
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $e79bad377ed788e9$var$fs {
    constructor(e, t, s, i){
        this.name = e, this.prefix = t, this.baseEncode = s, this.baseDecode = i, this.encoder = new $e79bad377ed788e9$var$Ds(e, t, s), this.decoder = new $e79bad377ed788e9$var$bs(e, t, i);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $e79bad377ed788e9$var$re = ({ name: o, prefix: e, encode: t, decode: s })=>new $e79bad377ed788e9$var$fs(o, e, t, s), $e79bad377ed788e9$var$Y = ({ prefix: o, name: e, alphabet: t })=>{
    const { encode: s, decode: i } = $e79bad377ed788e9$var$gs(t, e);
    return $e79bad377ed788e9$var$re({
        prefix: o,
        name: e,
        encode: s,
        decode: (r)=>$e79bad377ed788e9$var$Ve(i(r))
    });
}, $e79bad377ed788e9$var$_s = (o, e, t, s)=>{
    const i = {};
    for(let d = 0; d < e.length; ++d)i[e[d]] = d;
    let r = o.length;
    for(; o[r - 1] === "=";)--r;
    const n = new Uint8Array(r * t / 8 | 0);
    let a = 0, h = 0, c = 0;
    for(let d = 0; d < r; ++d){
        const g = i[o[d]];
        if (g === void 0) throw new SyntaxError(`Non-${s} character`);
        h = h << t | g, a += t, a >= 8 && (a -= 8, n[c++] = 255 & h >> a);
    }
    if (a >= t || 255 & h << 8 - a) throw new SyntaxError("Unexpected end of data");
    return n;
}, $e79bad377ed788e9$var$Es = (o, e, t)=>{
    const s = e[e.length - 1] === "=", i = (1 << t) - 1;
    let r = "", n = 0, a = 0;
    for(let h = 0; h < o.length; ++h)for(a = a << 8 | o[h], n += 8; n > t;)n -= t, r += e[i & a >> n];
    if (n && (r += e[i & a << t - n]), s) for(; r.length * t & 7;)r += "=";
    return r;
}, $e79bad377ed788e9$var$f = ({ name: o, prefix: e, bitsPerChar: t, alphabet: s })=>$e79bad377ed788e9$var$re({
        prefix: e,
        name: o,
        encode (i) {
            return $e79bad377ed788e9$var$Es(i, s, t);
        },
        decode (i) {
            return $e79bad377ed788e9$var$_s(i, s, t, o);
        }
    }), $e79bad377ed788e9$var$vs = $e79bad377ed788e9$var$re({
    prefix: "\0",
    name: "identity",
    encode: (o)=>$e79bad377ed788e9$var$ys(o),
    decode: (o)=>$e79bad377ed788e9$var$ps(o)
});
var $e79bad377ed788e9$var$ws = Object.freeze({
    __proto__: null,
    identity: $e79bad377ed788e9$var$vs
});
const $e79bad377ed788e9$var$Is = $e79bad377ed788e9$var$f({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $e79bad377ed788e9$var$Ts = Object.freeze({
    __proto__: null,
    base2: $e79bad377ed788e9$var$Is
});
const $e79bad377ed788e9$var$Cs = $e79bad377ed788e9$var$f({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $e79bad377ed788e9$var$Ss = Object.freeze({
    __proto__: null,
    base8: $e79bad377ed788e9$var$Cs
});
const $e79bad377ed788e9$var$Ps = $e79bad377ed788e9$var$Y({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $e79bad377ed788e9$var$Rs = Object.freeze({
    __proto__: null,
    base10: $e79bad377ed788e9$var$Ps
});
const $e79bad377ed788e9$var$xs = $e79bad377ed788e9$var$f({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $e79bad377ed788e9$var$Os = $e79bad377ed788e9$var$f({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $e79bad377ed788e9$var$As = Object.freeze({
    __proto__: null,
    base16: $e79bad377ed788e9$var$xs,
    base16upper: $e79bad377ed788e9$var$Os
});
const $e79bad377ed788e9$var$Ns = $e79bad377ed788e9$var$f({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $e79bad377ed788e9$var$zs = $e79bad377ed788e9$var$f({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $e79bad377ed788e9$var$Ls = $e79bad377ed788e9$var$f({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $e79bad377ed788e9$var$$s = $e79bad377ed788e9$var$f({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $e79bad377ed788e9$var$Fs = $e79bad377ed788e9$var$f({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $e79bad377ed788e9$var$Us = $e79bad377ed788e9$var$f({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $e79bad377ed788e9$var$Ks = $e79bad377ed788e9$var$f({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $e79bad377ed788e9$var$Ms = $e79bad377ed788e9$var$f({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $e79bad377ed788e9$var$ks = $e79bad377ed788e9$var$f({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $e79bad377ed788e9$var$Bs = Object.freeze({
    __proto__: null,
    base32: $e79bad377ed788e9$var$Ns,
    base32upper: $e79bad377ed788e9$var$zs,
    base32pad: $e79bad377ed788e9$var$Ls,
    base32padupper: $e79bad377ed788e9$var$$s,
    base32hex: $e79bad377ed788e9$var$Fs,
    base32hexupper: $e79bad377ed788e9$var$Us,
    base32hexpad: $e79bad377ed788e9$var$Ks,
    base32hexpadupper: $e79bad377ed788e9$var$Ms,
    base32z: $e79bad377ed788e9$var$ks
});
const $e79bad377ed788e9$var$Vs = $e79bad377ed788e9$var$Y({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $e79bad377ed788e9$var$js = $e79bad377ed788e9$var$Y({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $e79bad377ed788e9$var$qs = Object.freeze({
    __proto__: null,
    base36: $e79bad377ed788e9$var$Vs,
    base36upper: $e79bad377ed788e9$var$js
});
const $e79bad377ed788e9$var$Gs = $e79bad377ed788e9$var$Y({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $e79bad377ed788e9$var$Hs = $e79bad377ed788e9$var$Y({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $e79bad377ed788e9$var$Ys = Object.freeze({
    __proto__: null,
    base58btc: $e79bad377ed788e9$var$Gs,
    base58flickr: $e79bad377ed788e9$var$Hs
});
const $e79bad377ed788e9$var$Js = $e79bad377ed788e9$var$f({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $e79bad377ed788e9$var$Ws = $e79bad377ed788e9$var$f({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $e79bad377ed788e9$var$Xs = $e79bad377ed788e9$var$f({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $e79bad377ed788e9$var$Zs = $e79bad377ed788e9$var$f({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $e79bad377ed788e9$var$Qs = Object.freeze({
    __proto__: null,
    base64: $e79bad377ed788e9$var$Js,
    base64pad: $e79bad377ed788e9$var$Ws,
    base64url: $e79bad377ed788e9$var$Xs,
    base64urlpad: $e79bad377ed788e9$var$Zs
});
const $e79bad377ed788e9$var$qe = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $e79bad377ed788e9$var$er = $e79bad377ed788e9$var$qe.reduce((o, e, t)=>(o[t] = e, o), []), $e79bad377ed788e9$var$tr = $e79bad377ed788e9$var$qe.reduce((o, e, t)=>(o[e.codePointAt(0)] = t, o), []);
function $e79bad377ed788e9$var$ir(o) {
    return o.reduce((e, t)=>(e += $e79bad377ed788e9$var$er[t], e), "");
}
function $e79bad377ed788e9$var$sr(o) {
    const e = [];
    for (const t of o){
        const s = $e79bad377ed788e9$var$tr[t.codePointAt(0)];
        if (s === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(s);
    }
    return new Uint8Array(e);
}
const $e79bad377ed788e9$var$rr = $e79bad377ed788e9$var$re({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $e79bad377ed788e9$var$ir,
    decode: $e79bad377ed788e9$var$sr
});
var $e79bad377ed788e9$var$nr = Object.freeze({
    __proto__: null,
    base256emoji: $e79bad377ed788e9$var$rr
}), $e79bad377ed788e9$var$or = $e79bad377ed788e9$var$He, $e79bad377ed788e9$var$Ge = 128, $e79bad377ed788e9$var$ar = 127, $e79bad377ed788e9$var$hr = ~$e79bad377ed788e9$var$ar, $e79bad377ed788e9$var$cr = Math.pow(2, 31);
function $e79bad377ed788e9$var$He(o, e, t) {
    e = e || [], t = t || 0;
    for(var s = t; o >= $e79bad377ed788e9$var$cr;)e[t++] = o & 255 | $e79bad377ed788e9$var$Ge, o /= 128;
    for(; o & $e79bad377ed788e9$var$hr;)e[t++] = o & 255 | $e79bad377ed788e9$var$Ge, o >>>= 7;
    return e[t] = o | 0, $e79bad377ed788e9$var$He.bytes = t - s + 1, e;
}
var $e79bad377ed788e9$var$lr = $e79bad377ed788e9$var$De, $e79bad377ed788e9$var$ur = 128, $e79bad377ed788e9$var$Ye = 127;
function $e79bad377ed788e9$var$De(o, s) {
    var t = 0, s = s || 0, i = 0, r = s, n, a = o.length;
    do {
        if (r >= a) throw $e79bad377ed788e9$var$De.bytes = 0, new RangeError("Could not decode varint");
        n = o[r++], t += i < 28 ? (n & $e79bad377ed788e9$var$Ye) << i : (n & $e79bad377ed788e9$var$Ye) * Math.pow(2, i), i += 7;
    }while (n >= $e79bad377ed788e9$var$ur);
    return $e79bad377ed788e9$var$De.bytes = r - s, t;
}
var $e79bad377ed788e9$var$dr = Math.pow(2, 7), $e79bad377ed788e9$var$gr = Math.pow(2, 14), $e79bad377ed788e9$var$pr = Math.pow(2, 21), $e79bad377ed788e9$var$yr = Math.pow(2, 28), $e79bad377ed788e9$var$Dr = Math.pow(2, 35), $e79bad377ed788e9$var$br = Math.pow(2, 42), $e79bad377ed788e9$var$mr = Math.pow(2, 49), $e79bad377ed788e9$var$fr = Math.pow(2, 56), $e79bad377ed788e9$var$_r = Math.pow(2, 63), $e79bad377ed788e9$var$Er = function(o) {
    return o < $e79bad377ed788e9$var$dr ? 1 : o < $e79bad377ed788e9$var$gr ? 2 : o < $e79bad377ed788e9$var$pr ? 3 : o < $e79bad377ed788e9$var$yr ? 4 : o < $e79bad377ed788e9$var$Dr ? 5 : o < $e79bad377ed788e9$var$br ? 6 : o < $e79bad377ed788e9$var$mr ? 7 : o < $e79bad377ed788e9$var$fr ? 8 : o < $e79bad377ed788e9$var$_r ? 9 : 10;
}, $e79bad377ed788e9$var$vr = {
    encode: $e79bad377ed788e9$var$or,
    decode: $e79bad377ed788e9$var$lr,
    encodingLength: $e79bad377ed788e9$var$Er
}, $e79bad377ed788e9$var$Je = $e79bad377ed788e9$var$vr;
const $e79bad377ed788e9$var$We = (o, e, t = 0)=>($e79bad377ed788e9$var$Je.encode(o, e, t), e), $e79bad377ed788e9$var$Xe = (o)=>$e79bad377ed788e9$var$Je.encodingLength(o), $e79bad377ed788e9$var$be = (o, e)=>{
    const t = e.byteLength, s = $e79bad377ed788e9$var$Xe(o), i = s + $e79bad377ed788e9$var$Xe(t), r = new Uint8Array(i + t);
    return $e79bad377ed788e9$var$We(o, r, 0), $e79bad377ed788e9$var$We(t, r, s), r.set(e, i), new $e79bad377ed788e9$var$wr(o, t, e, r);
};
class $e79bad377ed788e9$var$wr {
    constructor(e, t, s, i){
        this.code = e, this.size = t, this.digest = s, this.bytes = i;
    }
}
const $e79bad377ed788e9$var$Ze = ({ name: o, code: e, encode: t })=>new $e79bad377ed788e9$var$Ir(o, e, t);
class $e79bad377ed788e9$var$Ir {
    constructor(e, t, s){
        this.name = e, this.code = t, this.encode = s;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $e79bad377ed788e9$var$be(this.code, t) : t.then((s)=>$e79bad377ed788e9$var$be(this.code, s));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $e79bad377ed788e9$var$Qe = (o)=>async (e)=>new Uint8Array(await crypto.subtle.digest(o, e)), $e79bad377ed788e9$var$Tr = $e79bad377ed788e9$var$Ze({
    name: "sha2-256",
    code: 18,
    encode: $e79bad377ed788e9$var$Qe("SHA-256")
}), $e79bad377ed788e9$var$Cr = $e79bad377ed788e9$var$Ze({
    name: "sha2-512",
    code: 19,
    encode: $e79bad377ed788e9$var$Qe("SHA-512")
});
var $e79bad377ed788e9$var$Sr = Object.freeze({
    __proto__: null,
    sha256: $e79bad377ed788e9$var$Tr,
    sha512: $e79bad377ed788e9$var$Cr
});
const $e79bad377ed788e9$var$et = 0, $e79bad377ed788e9$var$Pr = "identity", $e79bad377ed788e9$var$tt = $e79bad377ed788e9$var$Ve, $e79bad377ed788e9$var$Rr = (o)=>$e79bad377ed788e9$var$be($e79bad377ed788e9$var$et, $e79bad377ed788e9$var$tt(o)), $e79bad377ed788e9$var$xr = {
    code: $e79bad377ed788e9$var$et,
    name: $e79bad377ed788e9$var$Pr,
    encode: $e79bad377ed788e9$var$tt,
    digest: $e79bad377ed788e9$var$Rr
};
var $e79bad377ed788e9$var$Or = Object.freeze({
    __proto__: null,
    identity: $e79bad377ed788e9$var$xr
});
new TextEncoder, new TextDecoder;
const $e79bad377ed788e9$var$it = {
    ...$e79bad377ed788e9$var$ws,
    ...$e79bad377ed788e9$var$Ts,
    ...$e79bad377ed788e9$var$Ss,
    ...$e79bad377ed788e9$var$Rs,
    ...$e79bad377ed788e9$var$As,
    ...$e79bad377ed788e9$var$Bs,
    ...$e79bad377ed788e9$var$qs,
    ...$e79bad377ed788e9$var$Ys,
    ...$e79bad377ed788e9$var$Qs,
    ...$e79bad377ed788e9$var$nr
};
({
    ...$e79bad377ed788e9$var$Sr,
    ...$e79bad377ed788e9$var$Or
});
function $e79bad377ed788e9$var$Ar(o = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? globalThis.Buffer.allocUnsafe(o) : new Uint8Array(o);
}
function $e79bad377ed788e9$var$st(o, e, t, s) {
    return {
        name: o,
        prefix: e,
        encoder: {
            name: o,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: s
        }
    };
}
const $e79bad377ed788e9$var$rt = $e79bad377ed788e9$var$st("utf8", "u", (o)=>"u" + new TextDecoder("utf8").decode(o), (o)=>new TextEncoder().encode(o.substring(1))), $e79bad377ed788e9$var$me = $e79bad377ed788e9$var$st("ascii", "a", (o)=>{
    let e = "a";
    for(let t = 0; t < o.length; t++)e += String.fromCharCode(o[t]);
    return e;
}, (o)=>{
    o = o.substring(1);
    const e = $e79bad377ed788e9$var$Ar(o.length);
    for(let t = 0; t < o.length; t++)e[t] = o.charCodeAt(t);
    return e;
}), $e79bad377ed788e9$var$Nr = {
    utf8: $e79bad377ed788e9$var$rt,
    "utf-8": $e79bad377ed788e9$var$rt,
    hex: $e79bad377ed788e9$var$it.base16,
    latin1: $e79bad377ed788e9$var$me,
    ascii: $e79bad377ed788e9$var$me,
    binary: $e79bad377ed788e9$var$me,
    ...$e79bad377ed788e9$var$it
};
function $e79bad377ed788e9$var$zr(o, e = "utf8") {
    const t = $e79bad377ed788e9$var$Nr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(o, "utf8") : t.decoder.decode(`${t.prefix}${o}`);
}
const $e79bad377ed788e9$export$51b1c900ac262bdf = "wc", $e79bad377ed788e9$export$f30bd3c8747cdfbe = 2, $e79bad377ed788e9$export$d47601f9de5ee22b = "core", $e79bad377ed788e9$export$f258d29ae5e3d545 = `${$e79bad377ed788e9$export$51b1c900ac262bdf}@2:${$e79bad377ed788e9$export$d47601f9de5ee22b}:`, $e79bad377ed788e9$export$db0fdb6d486555c2 = {
    name: $e79bad377ed788e9$export$d47601f9de5ee22b,
    logger: "error"
}, $e79bad377ed788e9$export$ba920abfe854b85d = {
    database: ":memory:"
}, $e79bad377ed788e9$export$92a79f21481c803d = "crypto", $e79bad377ed788e9$export$3613aa6e652146e4 = "client_ed25519_seed", $e79bad377ed788e9$export$c4bc5e31a4d0ec78 = (0, $iNdL8.ONE_DAY), $e79bad377ed788e9$export$9d7218f72e8dc49b = "keychain", $e79bad377ed788e9$export$34f82f4ba0c3d769 = "0.3", $e79bad377ed788e9$export$9662bbc7d10cf481 = "messages", $e79bad377ed788e9$export$19dfd1896412c038 = "0.3", $e79bad377ed788e9$export$8ddbe6611b67d926 = (0, $iNdL8.SIX_HOURS), $e79bad377ed788e9$export$9d92662178f2abd1 = "publisher", $e79bad377ed788e9$export$822d0bd1635d5360 = "irn", $e79bad377ed788e9$export$5176ffa6778d6637 = "error", $e79bad377ed788e9$export$a68061e6c48f332a = "wss://relay.walletconnect.org", $e79bad377ed788e9$export$602d6e27611c3fcb = "relayer", $e79bad377ed788e9$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $e79bad377ed788e9$export$119b4645f6b233c8 = "_subscription", $e79bad377ed788e9$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $e79bad377ed788e9$export$11ccd39be2c57d6 = .1, $e79bad377ed788e9$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $e79bad377ed788e9$export$5f30917a6f8c9025 = "2.15.2", $e79bad377ed788e9$export$fb3eab7adf12329d = 1e4, $e79bad377ed788e9$export$629a342182ba24b = "0.3", $e79bad377ed788e9$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $e79bad377ed788e9$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $e79bad377ed788e9$export$9d35d0a6a3599be = (0, $iNdL8.THIRTY_DAYS), $e79bad377ed788e9$export$9c3a96bb670cddb8 = "subscription", $e79bad377ed788e9$export$fb57e03bef4c4cea = "0.3", $e79bad377ed788e9$export$9a2ddbfe54f8af77 = (0, $iNdL8.FIVE_SECONDS) * 1e3, $e79bad377ed788e9$export$390360ea476c6145 = "pairing", $e79bad377ed788e9$export$5593ec74b27d1b18 = "0.3", $e79bad377ed788e9$export$ee4b1978d0aedfad = (0, $iNdL8.THIRTY_DAYS), $e79bad377ed788e9$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $iNdL8.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $iNdL8.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $iNdL8.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $e79bad377ed788e9$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $e79bad377ed788e9$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $e79bad377ed788e9$export$160142c73cb99dc3 = "history", $e79bad377ed788e9$export$8eba9ce85616c607 = "0.3", $e79bad377ed788e9$export$4ddf883392bbc828 = "expirer", $e79bad377ed788e9$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $e79bad377ed788e9$export$717295846191925d = "0.3", $e79bad377ed788e9$export$3cfe73d6765db74 = (0, $iNdL8.ONE_DAY), $e79bad377ed788e9$export$3b58f2450f2297e3 = "verify-api", $e79bad377ed788e9$var$Kr = "https://verify.walletconnect.com", $e79bad377ed788e9$var$Nt = "https://verify.walletconnect.org", $e79bad377ed788e9$export$7e3b1a28ddecdbaa = $e79bad377ed788e9$var$Nt, $e79bad377ed788e9$export$412739528655ee2f = `${$e79bad377ed788e9$export$7e3b1a28ddecdbaa}/v3`, $e79bad377ed788e9$export$be24df03c4baa778 = [
    $e79bad377ed788e9$var$Kr,
    $e79bad377ed788e9$var$Nt
], $e79bad377ed788e9$export$40c022d2cffe0adc = "echo", $e79bad377ed788e9$export$3c48c4faab79aab1 = "https://echo.walletconnect.com", $e79bad377ed788e9$export$2f94b15ed52f7de9 = "event-client", $e79bad377ed788e9$export$6736f9bb609b5d34 = {
    pairing_started: "pairing_started",
    pairing_uri_validation_success: "pairing_uri_validation_success",
    pairing_uri_not_expired: "pairing_uri_not_expired",
    store_new_pairing: "store_new_pairing",
    subscribing_pairing_topic: "subscribing_pairing_topic",
    subscribe_pairing_topic_success: "subscribe_pairing_topic_success",
    existing_pairing: "existing_pairing",
    pairing_not_expired: "pairing_not_expired",
    emit_inactive_pairing: "emit_inactive_pairing",
    emit_session_proposal: "emit_session_proposal",
    subscribing_to_pairing_topic: "subscribing_to_pairing_topic"
}, $e79bad377ed788e9$export$e1dc85b7b7495247 = {
    no_wss_connection: "no_wss_connection",
    no_internet_connection: "no_internet_connection",
    malformed_pairing_uri: "malformed_pairing_uri",
    active_pairing_already_exists: "active_pairing_already_exists",
    subscribe_pairing_topic_failure: "subscribe_pairing_topic_failure",
    pairing_expired: "pairing_expired",
    proposal_expired: "proposal_expired",
    proposal_listener_not_found: "proposal_listener_not_found"
}, $e79bad377ed788e9$export$16ed3f27a411eba0 = {
    session_approve_started: "session_approve_started",
    proposal_not_expired: "proposal_not_expired",
    session_namespaces_validation_success: "session_namespaces_validation_success",
    create_session_topic: "create_session_topic",
    subscribing_session_topic: "subscribing_session_topic",
    subscribe_session_topic_success: "subscribe_session_topic_success",
    publishing_session_approve: "publishing_session_approve",
    session_approve_publish_success: "session_approve_publish_success",
    store_session: "store_session",
    publishing_session_settle: "publishing_session_settle",
    session_settle_publish_success: "session_settle_publish_success"
}, $e79bad377ed788e9$export$bc50109885e83402 = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    proposal_expired: "proposal_expired",
    subscribe_session_topic_failure: "subscribe_session_topic_failure",
    session_approve_publish_failure: "session_approve_publish_failure",
    session_settle_publish_failure: "session_settle_publish_failure",
    session_approve_namespace_validation_failure: "session_approve_namespace_validation_failure",
    proposal_not_found: "proposal_not_found"
}, $e79bad377ed788e9$export$6540f02663742dde = {
    authenticated_session_approve_started: "authenticated_session_approve_started",
    authenticated_session_not_expired: "authenticated_session_not_expired",
    chains_caip2_compliant: "chains_caip2_compliant",
    chains_evm_compliant: "chains_evm_compliant",
    create_authenticated_session_topic: "create_authenticated_session_topic",
    cacaos_verified: "cacaos_verified",
    store_authenticated_session: "store_authenticated_session",
    subscribing_authenticated_session_topic: "subscribing_authenticated_session_topic",
    subscribe_authenticated_session_topic_success: "subscribe_authenticated_session_topic_success",
    publishing_authenticated_session_approve: "publishing_authenticated_session_approve",
    authenticated_session_approve_publish_success: "authenticated_session_approve_publish_success"
}, $e79bad377ed788e9$export$aca4f34441e6cd3a = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    missing_session_authenticate_request: "missing_session_authenticate_request",
    session_authenticate_request_expired: "session_authenticate_request_expired",
    chains_caip2_compliant_failure: "chains_caip2_compliant_failure",
    chains_evm_compliant_failure: "chains_evm_compliant_failure",
    invalid_cacao: "invalid_cacao",
    subscribe_authenticated_session_topic_failure: "subscribe_authenticated_session_topic_failure",
    authenticated_session_approve_publish_failure: "authenticated_session_approve_publish_failure",
    authenticated_session_pending_request_not_found: "authenticated_session_pending_request_not_found"
}, $e79bad377ed788e9$export$c73857c3a3d16b1c = .1, $e79bad377ed788e9$export$e020229e09910965 = "event-client", $e79bad377ed788e9$export$79348045429687e2 = 86400, $e79bad377ed788e9$export$bb6a8925f3cb1ca = "https://pulse.walletconnect.com/batch";
class $e79bad377ed788e9$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $e79bad377ed788e9$export$9d7218f72e8dc49b, this.version = $e79bad377ed788e9$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const s = await this.getKeyChain();
                typeof s < "u" && (this.keychain = s), this.initialized = !0;
            }
        }, this.has = (s)=>(this.isInitialized(), this.keychain.has(s)), this.set = async (s, i)=>{
            this.isInitialized(), this.keychain.set(s, i), await this.persist();
        }, this.get = (s)=>{
            this.isInitialized();
            const i = this.keychain.get(s);
            if (typeof i > "u") {
                const { message: r } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${s}`);
                throw new Error(r);
            }
            return i;
        }, this.del = async (s)=>{
            this.isInitialized(), this.keychain.delete(s), await this.persist();
        }, this.core = e, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $iN1TF.mapToObj)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $iN1TF.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e79bad377ed788e9$export$8ac8b6291b7ccf24 {
    constructor(e, t, s){
        this.core = e, this.logger = t, this.name = $e79bad377ed788e9$export$92a79f21481c803d, this.randomSessionIdentifier = (0, $iN1TF.generateRandomBytes32)(), this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (i)=>(this.isInitialized(), this.keychain.has(i)), this.getClientId = async ()=>{
            this.isInitialized();
            const i = await this.getClientSeed(), r = $hSpoa.generateKeyPair(i);
            return $i4OlP.encodeIss(r.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const i = (0, $iN1TF.generateKeyPair)();
            return this.setPrivateKey(i.publicKey, i.privateKey);
        }, this.signJWT = async (i)=>{
            this.isInitialized();
            const r = await this.getClientSeed(), n = $hSpoa.generateKeyPair(r), a = this.randomSessionIdentifier, h = $e79bad377ed788e9$export$c4bc5e31a4d0ec78;
            return await $hSpoa.signJWT(a, i, h, n);
        }, this.generateSharedKey = (i, r, n)=>{
            this.isInitialized();
            const a = this.getPrivateKey(i), h = (0, $iN1TF.deriveSymKey)(a, r);
            return this.setSymKey(h, n);
        }, this.setSymKey = async (i, r)=>{
            this.isInitialized();
            const n = r || (0, $iN1TF.hashKey)(i);
            return await this.keychain.set(n, i), n;
        }, this.deleteKeyPair = async (i)=>{
            this.isInitialized(), await this.keychain.del(i);
        }, this.deleteSymKey = async (i)=>{
            this.isInitialized(), await this.keychain.del(i);
        }, this.encode = async (i, r, n)=>{
            this.isInitialized();
            const a = (0, $iN1TF.validateEncoding)(n), h = (0, $6mXg5.safeJsonStringify)(r);
            if ((0, $iN1TF.isTypeOneEnvelope)(a)) {
                const b = a.senderPublicKey, m = a.receiverPublicKey;
                i = await this.generateSharedKey(b, m);
            }
            const c = this.getSymKey(i), { type: d, senderPublicKey: g } = a;
            return (0, $iN1TF.encrypt)({
                type: d,
                symKey: c,
                message: h,
                senderPublicKey: g
            });
        }, this.decode = async (i, r, n)=>{
            this.isInitialized();
            const a = (0, $iN1TF.validateDecoding)(r, n);
            if ((0, $iN1TF.isTypeOneEnvelope)(a)) {
                const h = a.receiverPublicKey, c = a.senderPublicKey;
                i = await this.generateSharedKey(h, c);
            }
            try {
                const h = this.getSymKey(i), c = (0, $iN1TF.decrypt)({
                    symKey: h,
                    encoded: r
                });
                return (0, $6mXg5.safeJsonParse)(c);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${i}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (i)=>{
            const r = (0, $iN1TF.deserialize)(i);
            return (0, $iN1TF.decodeTypeByte)(r.type);
        }, this.getPayloadSenderPublicKey = (i)=>{
            const r = (0, $iN1TF.deserialize)(i);
            return r.senderPublicKey ? (0, $5t5tf.toString)(r.senderPublicKey, (0, $iN1TF.BASE16)) : void 0;
        }, this.core = e, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name), this.keychain = s || new $e79bad377ed788e9$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($e79bad377ed788e9$export$3613aa6e652146e4);
        } catch  {
            e = (0, $iN1TF.generateRandomBytes32)(), await this.keychain.set($e79bad377ed788e9$export$3613aa6e652146e4, e);
        }
        return $e79bad377ed788e9$var$zr(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e79bad377ed788e9$export$4a2542d0790ac2fd extends (0, $evwHH.IMessageTracker) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $e79bad377ed788e9$export$9662bbc7d10cf481, this.version = $e79bad377ed788e9$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const s = await this.getRelayerMessages();
                    typeof s < "u" && (this.messages = s), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (s) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(s);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (s, i)=>{
            this.isInitialized();
            const r = (0, $iN1TF.hashMessage)(i);
            let n = this.messages.get(s);
            return typeof n > "u" && (n = {}), typeof n[r] < "u" || (n[r] = i, this.messages.set(s, n), await this.persist()), r;
        }, this.get = (s)=>{
            this.isInitialized();
            let i = this.messages.get(s);
            return typeof i > "u" && (i = {}), i;
        }, this.has = (s, i)=>{
            this.isInitialized();
            const r = this.get(s), n = (0, $iN1TF.hashMessage)(i);
            return typeof r[n] < "u";
        }, this.del = async (s)=>{
            this.isInitialized(), this.messages.delete(s), await this.persist();
        }, this.logger = (0, $GVAyr.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $iN1TF.mapToObj)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $iN1TF.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e79bad377ed788e9$var$qr extends (0, $evwHH.IPublisher) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $jMGWz.EventEmitter), this.name = $e79bad377ed788e9$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $iNdL8.toMiliseconds)((0, $iNdL8.ONE_MINUTE)), this.failedPublishTimeout = (0, $iNdL8.toMiliseconds)((0, $iNdL8.ONE_SECOND)), this.needsTransportRestart = !1, this.publish = async (s, i, r)=>{
            var n;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: s,
                    message: i,
                    opts: r
                }
            });
            const a = r?.ttl || $e79bad377ed788e9$export$8ddbe6611b67d926, h = (0, $iN1TF.getRelayProtocolName)(r), c = r?.prompt || !1, d = r?.tag || 0, g = r?.id || (0, $eS6BO.getBigIntRpcId)().toString(), b = {
                topic: s,
                message: i,
                opts: {
                    ttl: a,
                    relay: h,
                    prompt: c,
                    tag: d,
                    id: g,
                    attestation: r?.attestation
                }
            }, m = `Failed to publish payload, please try again. id:${g} tag:${d}`, l = Date.now();
            let p, _ = 1;
            try {
                for(; p === void 0;){
                    if (Date.now() - l > this.publishTimeout) throw new Error(m);
                    this.logger.trace({
                        id: g,
                        attempts: _
                    }, `publisher.publish - attempt ${_}`), p = await await (0, $iN1TF.createExpiringPromise)(this.rpcPublish(s, i, a, h, c, d, g, r?.attestation).catch((D)=>this.logger.warn(D)), this.publishTimeout, m), _++, p || await new Promise((D)=>setTimeout(D, this.failedPublishTimeout));
                }
                this.relayer.events.emit($e79bad377ed788e9$export$d56245796e2837d.publish, b), this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        id: g,
                        topic: s,
                        message: i,
                        opts: r
                    }
                });
            } catch (D) {
                if (this.logger.debug("Failed to Publish Payload"), this.logger.error(D), (n = r?.internal) != null && n.throwOnFailedPublish) throw D;
                this.queue.set(g, b);
            }
        }, this.on = (s, i)=>{
            this.events.on(s, i);
        }, this.once = (s, i)=>{
            this.events.once(s, i);
        }, this.off = (s, i)=>{
            this.events.off(s, i);
        }, this.removeListener = (s, i)=>{
            this.events.removeListener(s, i);
        }, this.relayer = e, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, s, i, r, n, a, h) {
        var c, d, g, b;
        const m = {
            method: (0, $iN1TF.getRelayProtocolApi)(i.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: s,
                prompt: r,
                tag: n,
                attestation: h
            },
            id: a
        };
        return (0, $iN1TF.isUndefined)((c = m.params) == null ? void 0 : c.prompt) && ((d = m.params) == null || delete d.prompt), (0, $iN1TF.isUndefined)((g = m.params) == null ? void 0 : g.tag) && ((b = m.params) == null || delete b.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: m
        }), this.relayer.request(m);
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: s, opts: i } = e;
            await this.publish(t, s, i);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $ahj4I.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($e79bad377ed788e9$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($e79bad377ed788e9$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class $e79bad377ed788e9$var$Gr {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const s = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...s,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const s = this.get(e);
            if (!this.exists(e, t)) return;
            const i = s.filter((r)=>r !== t);
            if (!i.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, i);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $e79bad377ed788e9$var$Hr = Object.defineProperty, $e79bad377ed788e9$var$Yr = Object.defineProperties, $e79bad377ed788e9$var$Jr = Object.getOwnPropertyDescriptors, $e79bad377ed788e9$var$qt = Object.getOwnPropertySymbols, $e79bad377ed788e9$var$Wr = Object.prototype.hasOwnProperty, $e79bad377ed788e9$var$Xr = Object.prototype.propertyIsEnumerable, $e79bad377ed788e9$var$Gt = (o, e, t)=>e in o ? $e79bad377ed788e9$var$Hr(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e79bad377ed788e9$var$X = (o, e)=>{
    for(var t in e || (e = {}))$e79bad377ed788e9$var$Wr.call(e, t) && $e79bad377ed788e9$var$Gt(o, t, e[t]);
    if ($e79bad377ed788e9$var$qt) for (var t of $e79bad377ed788e9$var$qt(e))$e79bad377ed788e9$var$Xr.call(e, t) && $e79bad377ed788e9$var$Gt(o, t, e[t]);
    return o;
}, $e79bad377ed788e9$var$Ie = (o, e)=>$e79bad377ed788e9$var$Yr(o, $e79bad377ed788e9$var$Jr(e));
class $e79bad377ed788e9$export$60959659b2c22881 extends (0, $evwHH.ISubscriber) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $e79bad377ed788e9$var$Gr, this.events = new (0, $jMGWz.EventEmitter), this.name = $e79bad377ed788e9$export$9c3a96bb670cddb8, this.version = $e79bad377ed788e9$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.subscribeTimeout = (0, $iNdL8.toMiliseconds)((0, $iNdL8.ONE_MINUTE)), this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.pendingBatchMessages = [], this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (s, i)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: s,
                    opts: i
                }
            });
            try {
                const r = (0, $iN1TF.getRelayProtocolName)(i), n = {
                    topic: s,
                    relay: r
                };
                this.pending.set(s, n);
                const a = await this.rpcSubscribe(s, r);
                return typeof a == "string" && (this.onSubscribe(a, n), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: s,
                        opts: i
                    }
                })), a;
            } catch (r) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(r), r;
            }
        }, this.unsubscribe = async (s, i)=>{
            await this.restartToComplete(), this.isInitialized(), typeof i?.id < "u" ? await this.unsubscribeById(s, i.id, i) : await this.unsubscribeByTopic(s, i);
        }, this.isSubscribed = async (s)=>{
            if (this.topics.includes(s)) return !0;
            const i = `${this.pendingSubscriptionWatchLabel}_${s}`;
            return await new Promise((r, n)=>{
                const a = new (0, $iNdL8.Watch);
                a.start(i);
                const h = setInterval(()=>{
                    !this.pending.has(s) && this.topics.includes(s) && (clearInterval(h), a.stop(i), r(!0)), a.elapsed(i) >= $e79bad377ed788e9$export$9a2ddbfe54f8af77 && (clearInterval(h), a.stop(i), n(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1);
        }, this.on = (s, i)=>{
            this.events.on(s, i);
        }, this.once = (s, i)=>{
            this.events.once(s, i);
        }, this.off = (s, i)=>{
            this.events.off(s, i);
        }, this.removeListener = (s, i)=>{
            this.events.removeListener(s, i);
        }, this.start = async ()=>{
            await this.onConnect();
        }, this.stop = async ()=>{
            await this.onDisconnect();
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let s = !1;
        try {
            s = this.getSubscription(e).topic === t;
        } catch  {}
        return s;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const s = this.topicMap.get(e);
        await Promise.all(s.map(async (i)=>await this.unsubscribeById(e, i, t)));
    }
    async unsubscribeById(e, t, s) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: s
            }
        });
        try {
            const i = (0, $iN1TF.getRelayProtocolName)(s);
            await this.rpcUnsubscribe(e, t, i);
            const r = (0, $iN1TF.getSdkError)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, r), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: s
                }
            });
        } catch (i) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(i), i;
        }
    }
    async rpcSubscribe(e, t) {
        const s = {
            method: (0, $iN1TF.getRelayProtocolApi)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        });
        try {
            return await await (0, $iN1TF.createExpiringPromise)(this.relayer.request(s).catch((i)=>this.logger.warn(i)), this.subscribeTimeout) ? (0, $iN1TF.hashMessage)(e + this.clientId) : null;
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($e79bad377ed788e9$export$d56245796e2837d.connection_stalled);
        }
        return null;
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, s = {
            method: (0, $iN1TF.getRelayProtocolApi)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((i)=>i.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        });
        try {
            return await await (0, $iN1TF.createExpiringPromise)(this.relayer.request(s).catch((i)=>this.logger.warn(i)), this.subscribeTimeout);
        } catch  {
            this.relayer.events.emit($e79bad377ed788e9$export$d56245796e2837d.connection_stalled);
        }
    }
    async rpcBatchFetchMessages(e) {
        if (!e.length) return;
        const t = e[0].relay, s = {
            method: (0, $iN1TF.getRelayProtocolApi)(t.protocol).batchFetchMessages,
            params: {
                topics: e.map((r)=>r.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        });
        let i;
        try {
            i = await await (0, $iN1TF.createExpiringPromise)(this.relayer.request(s).catch((r)=>this.logger.warn(r)), this.subscribeTimeout);
        } catch  {
            this.relayer.events.emit($e79bad377ed788e9$export$d56245796e2837d.connection_stalled);
        }
        return i;
    }
    rpcUnsubscribe(e, t, s) {
        const i = {
            method: (0, $iN1TF.getRelayProtocolApi)(s.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        }), this.relayer.request(i);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $e79bad377ed788e9$var$Ie($e79bad377ed788e9$var$X({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $e79bad377ed788e9$var$X({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, s) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, s), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t);
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $e79bad377ed788e9$var$X({}, t)), this.topicMap.set(t.topic, e), this.events.emit($e79bad377ed788e9$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: s } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(s);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const s = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(s.topic, e), this.events.emit($e79bad377ed788e9$export$24ff3e54e94ef413.deleted, $e79bad377ed788e9$var$Ie($e79bad377ed788e9$var$X({}, s), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($e79bad377ed788e9$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const s = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchFetchMessages(s), await this.batchSubscribe(s);
            }
        }
        this.events.emit($e79bad377ed788e9$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $iN1TF.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $iN1TF.isValidArray)(t) && this.onBatchSubscribe(t.map((s, i)=>$e79bad377ed788e9$var$Ie($e79bad377ed788e9$var$X({}, e[i]), {
                id: s
            })));
    }
    async batchFetchMessages(e) {
        if (!e.length) return;
        this.logger.trace(`Fetching batch messages for ${e.length} subscriptions`);
        const t = await this.rpcBatchFetchMessages(e);
        t && t.messages && (this.pendingBatchMessages = this.pendingBatchMessages.concat(t.messages));
    }
    async onConnect() {
        await this.restart(), this.onEnable();
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (!this.initialized || !this.relayer.connected) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e), this.pendingBatchMessages.length && (await this.relayer.handleBatchMessageEvents(this.pendingBatchMessages), this.pendingBatchMessages = []);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $ahj4I.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.events.on($e79bad377ed788e9$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $e79bad377ed788e9$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($e79bad377ed788e9$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $e79bad377ed788e9$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $e79bad377ed788e9$var$Zr = Object.defineProperty, $e79bad377ed788e9$var$Yt = Object.getOwnPropertySymbols, $e79bad377ed788e9$var$Qr = Object.prototype.hasOwnProperty, $e79bad377ed788e9$var$en = Object.prototype.propertyIsEnumerable, $e79bad377ed788e9$var$Jt = (o, e, t)=>e in o ? $e79bad377ed788e9$var$Zr(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e79bad377ed788e9$var$tn = (o, e)=>{
    for(var t in e || (e = {}))$e79bad377ed788e9$var$Qr.call(e, t) && $e79bad377ed788e9$var$Jt(o, t, e[t]);
    if ($e79bad377ed788e9$var$Yt) for (var t of $e79bad377ed788e9$var$Yt(e))$e79bad377ed788e9$var$en.call(e, t) && $e79bad377ed788e9$var$Jt(o, t, e[t]);
    return o;
};
class $e79bad377ed788e9$export$70e73aa29a3d4407 extends (0, $evwHH.IRelayer) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $jMGWz.EventEmitter), this.name = $e79bad377ed788e9$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "stalled",
            "interrupted"
        ], this.hasExperiencedNetworkDisruption = !1, this.requestsInFlight = new Map, this.heartBeatTimeout = (0, $iNdL8.toMiliseconds)((0, $iNdL8.THIRTY_SECONDS) + (0, $iNdL8.ONE_SECOND)), this.request = async (t)=>{
            var s, i;
            this.logger.debug("Publishing Request Payload");
            const r = t.id || (0, $eS6BO.getBigIntRpcId)().toString();
            await this.toEstablishConnection();
            try {
                const n = this.provider.request(t);
                this.requestsInFlight.set(r, {
                    promise: n,
                    request: t
                }), this.logger.trace({
                    id: r,
                    method: t.method,
                    topic: (s = t.params) == null ? void 0 : s.topic
                }, "relayer.request - attempt to publish...");
                const a = await new Promise(async (h, c)=>{
                    const d = ()=>{
                        c(new Error(`relayer.request - publish interrupted, id: ${r}`));
                    };
                    this.provider.on($e79bad377ed788e9$export$58062acf2f31ddf8.disconnect, d);
                    const g = await n;
                    this.provider.off($e79bad377ed788e9$export$58062acf2f31ddf8.disconnect, d), h(g);
                });
                return this.logger.trace({
                    id: r,
                    method: t.method,
                    topic: (i = t.params) == null ? void 0 : i.topic
                }, "relayer.request - published"), a;
            } catch (n) {
                throw this.logger.debug(`Failed to Publish Request: ${r}`), n;
            } finally{
                this.requestsInFlight.delete(r);
            }
        }, this.resetPingTimeout = ()=>{
            if ((0, $iN1TF.isNode)()) try {
                clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(()=>{
                    var t, s, i;
                    (i = (s = (t = this.provider) == null ? void 0 : t.connection) == null ? void 0 : s.socket) == null || i.terminate();
                }, this.heartBeatTimeout);
            } catch (t) {
                this.logger.warn(t);
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t), this.resetPingTimeout();
        }, this.onConnectHandler = ()=>{
            this.logger.trace("relayer connected"), this.startPingTimeout(), this.events.emit($e79bad377ed788e9$export$d56245796e2837d.connect);
        }, this.onDisconnectHandler = ()=>{
            this.logger.trace("relayer disconnected"), this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.error(t), this.events.emit($e79bad377ed788e9$export$d56245796e2837d.error, t), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on($e79bad377ed788e9$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($e79bad377ed788e9$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($e79bad377ed788e9$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($e79bad377ed788e9$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $GVAyr.generateChildLogger)(e.logger, this.name) : (0, (/*@__PURE__*/$parcel$interopDefault($6rVbn)))((0, $GVAyr.getDefaultLoggerOptions)({
            level: e.logger || $e79bad377ed788e9$export$5176ffa6778d6637
        })), this.messages = new $e79bad377ed788e9$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $e79bad377ed788e9$export$60959659b2c22881(this, this.logger), this.publisher = new $e79bad377ed788e9$var$qr(this, this.logger), this.relayUrl = e?.relayUrl || $e79bad377ed788e9$export$a68061e6c48f332a, this.projectId = e.projectId, this.bundleId = (0, $iN1TF.getBundleId)(), this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), this.registerEventListeners(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]), await this.transportOpen(), this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && this.subscriber.pending.size === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $e79bad377ed788e9$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    get connected() {
        var e, t, s;
        return ((s = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : s.readyState) === 1;
    }
    get connecting() {
        var e, t, s;
        return ((s = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : s.readyState) === 0;
    }
    async publish(e, t, s) {
        this.isInitialized(), await this.publisher.publish(e, t, s), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var s;
        this.isInitialized();
        let i = ((s = this.subscriber.topicMap.get(e)) == null ? void 0 : s[0]) || "", r;
        const n = (a)=>{
            a.topic === e && (this.subscriber.off($e79bad377ed788e9$export$24ff3e54e94ef413.created, n), r());
        };
        return await Promise.all([
            new Promise((a)=>{
                r = a, this.subscriber.on($e79bad377ed788e9$export$24ff3e54e94ef413.created, n);
            }),
            new Promise(async (a)=>{
                i = await this.subscriber.subscribe(e, t) || i, a();
            })
        ]), i;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportDisconnect() {
        if (!this.hasExperiencedNetworkDisruption && this.connected && this.requestsInFlight.size > 0) try {
            await Promise.all(Array.from(this.requestsInFlight.values()).map((e)=>e.promise));
        } catch (e) {
            this.logger.warn(e);
        }
        this.hasExperiencedNetworkDisruption || this.connected ? await (0, $iN1TF.createExpiringPromise)(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.onProviderDisconnect();
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, await this.transportDisconnect();
    }
    async transportOpen(e) {
        await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect()), await this.createProvider(), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
        try {
            await new Promise(async (t, s)=>{
                const i = ()=>{
                    this.provider.off($e79bad377ed788e9$export$58062acf2f31ddf8.disconnect, i), s(new Error("Connection interrupted while trying to subscribe"));
                };
                this.provider.on($e79bad377ed788e9$export$58062acf2f31ddf8.disconnect, i), await (0, $iN1TF.createExpiringPromise)(this.provider.connect(), (0, $iNdL8.toMiliseconds)((0, $iNdL8.ONE_MINUTE)), `Socket stalled when trying to connect to ${this.relayUrl}`).catch((r)=>{
                    s(r);
                }).finally(()=>{
                    clearTimeout(this.reconnectTimeout), this.reconnectTimeout = void 0;
                }), this.subscriber.start().catch((r)=>{
                    this.logger.error(r), this.onDisconnectHandler();
                }), this.hasExperiencedNetworkDisruption = !1, t();
            });
        } catch (t) {
            this.logger.error(t);
            const s = t;
            if (this.hasExperiencedNetworkDisruption = !0, !this.isConnectionStalled(s.message)) throw t;
        } finally{
            this.connectionAttemptInProgress = !1;
        }
    }
    async restartTransport(e) {
        this.connectionAttemptInProgress || (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $iN1TF.isOnline)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    async handleBatchMessageEvents(e) {
        if (e?.length === 0) {
            this.logger.trace("Batch message events is empty. Ignoring...");
            return;
        }
        const t = e.sort((s, i)=>s.publishedAt - i.publishedAt);
        this.logger.trace(`Batch of ${t.length} message events sorted`);
        for (const s of t)try {
            await this.onMessageEvent(s);
        } catch (i) {
            this.logger.warn(i);
        }
        this.logger.trace(`Batch of ${t.length} message events processed`);
    }
    startPingTimeout() {
        var e, t, s, i, r;
        if ((0, $iN1TF.isNode)()) try {
            (t = (e = this.provider) == null ? void 0 : e.connection) != null && t.socket && ((r = (i = (s = this.provider) == null ? void 0 : s.connection) == null ? void 0 : i.socket) == null || r.once("ping", ()=>{
                this.resetPingTimeout();
            })), this.resetPingTimeout();
        } catch (n) {
            this.logger.warn(n);
        }
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $kUdYz.JsonRpcProvider)(new (0, $5u48b.default)((0, $iN1TF.formatRelayRpcUrl)({
            sdkVersion: $e79bad377ed788e9$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: s } = e;
        await this.messages.set(t, s);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: s } = e;
        if (!s || s.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${s}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const i = this.messages.has(t, s);
        return i && this.logger.debug(`Ignoring duplicate message: ${s}`), i;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $bNBqy.isJsonRpcRequest)(e)) {
            if (!e.method.endsWith($e79bad377ed788e9$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: s, message: i, publishedAt: r, attestation: n } = t.data, a = {
                topic: s,
                message: i,
                publishedAt: r,
                attestation: n
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($e79bad377ed788e9$var$tn({
                type: "event",
                event: t.id
            }, a)), this.events.emit(t.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
        } else (0, $bNBqy.isJsonRpcResponse)(e) && this.events.emit($e79bad377ed788e9$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($e79bad377ed788e9$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $eS6BO.formatJsonRpcResult)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($e79bad377ed788e9$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($e79bad377ed788e9$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($e79bad377ed788e9$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($e79bad377ed788e9$export$58062acf2f31ddf8.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
    }
    async registerEventListeners() {
        let e = await (0, $iN1TF.isOnline)();
        (0, $iN1TF.subscribeToNetworkChange)(async (t)=>{
            e !== t && (e = t, t ? await this.restartTransport().catch((s)=>this.logger.error(s)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
        });
    }
    async onProviderDisconnect() {
        await this.subscriber.stop(), this.requestsInFlight.clear(), clearTimeout(this.pingTimeout), this.events.emit($e79bad377ed788e9$export$d56245796e2837d.disconnect), this.connectionAttemptInProgress = !1, !this.transportExplicitlyClosed && (this.reconnectTimeout || (this.reconnectTimeout = setTimeout(async ()=>{
            await this.transportOpen().catch((e)=>this.logger.error(e));
        }, (0, $iNdL8.toMiliseconds)($e79bad377ed788e9$export$11ccd39be2c57d6))));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        await this.confirmOnlineStateOrThrow(), !this.connected && (this.connectionAttemptInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.connected && (clearInterval(t), e());
            }, this.connectionStatusPollingInterval);
        }), await this.transportOpen());
    }
}
var $e79bad377ed788e9$var$sn = Object.defineProperty, $e79bad377ed788e9$var$Xt = Object.getOwnPropertySymbols, $e79bad377ed788e9$var$rn = Object.prototype.hasOwnProperty, $e79bad377ed788e9$var$nn = Object.prototype.propertyIsEnumerable, $e79bad377ed788e9$var$Zt = (o, e, t)=>e in o ? $e79bad377ed788e9$var$sn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e79bad377ed788e9$var$Qt = (o, e)=>{
    for(var t in e || (e = {}))$e79bad377ed788e9$var$rn.call(e, t) && $e79bad377ed788e9$var$Zt(o, t, e[t]);
    if ($e79bad377ed788e9$var$Xt) for (var t of $e79bad377ed788e9$var$Xt(e))$e79bad377ed788e9$var$nn.call(e, t) && $e79bad377ed788e9$var$Zt(o, t, e[t]);
    return o;
};
class $e79bad377ed788e9$export$390f32400eaf98c9 extends (0, $evwHH.IStore) {
    constructor(e, t, s, i = $e79bad377ed788e9$export$f258d29ae5e3d545, r){
        super(e, t, s, i), this.core = e, this.logger = t, this.name = s, this.map = new Map, this.version = $e79bad377ed788e9$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.recentlyDeleted = [], this.recentlyDeletedLimit = 200, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((n)=>{
                this.getKey && n !== null && !(0, $iN1TF.isUndefined)(n) ? this.map.set(this.getKey(n), n) : (0, $iN1TF.isProposalStruct)(n) ? this.map.set(n.id, n) : (0, $iN1TF.isSessionStruct)(n) && this.map.set(n.topic, n);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (n, a)=>{
            this.isInitialized(), this.map.has(n) ? await this.update(n, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: n,
                value: a
            }), this.map.set(n, a), await this.persist());
        }, this.get = (n)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: n
            }), this.getData(n)), this.getAll = (n)=>(this.isInitialized(), n ? this.values.filter((a)=>Object.keys(n).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($42iJY)))(a[h], n[h]))) : this.values), this.update = async (n, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: n,
                update: a
            });
            const h = $e79bad377ed788e9$var$Qt($e79bad377ed788e9$var$Qt({}, this.getData(n)), a);
            this.map.set(n, h), await this.persist();
        }, this.delete = async (n, a)=>{
            this.isInitialized(), this.map.has(n) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: n,
                reason: a
            }), this.map.delete(n), this.addToRecentlyDeleted(n), await this.persist());
        }, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name), this.storagePrefix = i, this.getKey = r;
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    addToRecentlyDeleted(e) {
        this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            if (this.recentlyDeleted.includes(e)) {
                const { message: i } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
                throw this.logger.error(i), new Error(i);
            }
            const { message: s } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(s), new Error(s);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $iN1TF.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e79bad377ed788e9$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $e79bad377ed788e9$export$390360ea476c6145, this.version = $e79bad377ed788e9$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($jMGWz))), this.initialized = !1, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $iN1TF.TYPE_1)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: s })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...s
                ])
            ];
        }, this.create = async (s)=>{
            this.isInitialized();
            const i = (0, $iN1TF.generateRandomBytes32)(), r = await this.core.crypto.setSymKey(i), n = (0, $iN1TF.calcExpiry)((0, $iNdL8.FIVE_MINUTES)), a = {
                protocol: $e79bad377ed788e9$export$822d0bd1635d5360
            }, h = {
                topic: r,
                expiry: n,
                relay: a,
                active: !1
            }, c = (0, $iN1TF.formatUri)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: r,
                symKey: i,
                relay: a,
                expiryTimestamp: n,
                methods: s?.methods
            });
            return this.core.expirer.set(r, n), await this.pairings.set(r, h), await this.core.relayer.subscribe(r), {
                topic: r,
                uri: c
            };
        }, this.pair = async (s)=>{
            this.isInitialized();
            const i = this.core.eventClient.createEvent({
                properties: {
                    topic: s?.uri,
                    trace: [
                        $e79bad377ed788e9$export$6736f9bb609b5d34.pairing_started
                    ]
                }
            });
            this.isValidPair(s, i);
            const { topic: r, symKey: n, relay: a, expiryTimestamp: h, methods: c } = (0, $iN1TF.parseUri)(s.uri);
            i.props.properties.topic = r, i.addTrace($e79bad377ed788e9$export$6736f9bb609b5d34.pairing_uri_validation_success), i.addTrace($e79bad377ed788e9$export$6736f9bb609b5d34.pairing_uri_not_expired);
            let d;
            if (this.pairings.keys.includes(r)) {
                if (d = this.pairings.get(r), i.addTrace($e79bad377ed788e9$export$6736f9bb609b5d34.existing_pairing), d.active) throw i.setError($e79bad377ed788e9$export$e1dc85b7b7495247.active_pairing_already_exists), new Error(`Pairing already exists: ${r}. Please try again with a new connection URI.`);
                i.addTrace($e79bad377ed788e9$export$6736f9bb609b5d34.pairing_not_expired);
            }
            const g = h || (0, $iN1TF.calcExpiry)((0, $iNdL8.FIVE_MINUTES)), b = {
                topic: r,
                relay: a,
                expiry: g,
                active: !1,
                methods: c
            };
            this.core.expirer.set(r, g), await this.pairings.set(r, b), i.addTrace($e79bad377ed788e9$export$6736f9bb609b5d34.store_new_pairing), s.activatePairing && await this.activate({
                topic: r
            }), this.events.emit($e79bad377ed788e9$export$ca3c0b962acf7b75.create, b), i.addTrace($e79bad377ed788e9$export$6736f9bb609b5d34.emit_inactive_pairing), this.core.crypto.keychain.has(r) || await this.core.crypto.setSymKey(n, r), i.addTrace($e79bad377ed788e9$export$6736f9bb609b5d34.subscribing_pairing_topic);
            try {
                await this.core.relayer.confirmOnlineStateOrThrow();
            } catch  {
                i.setError($e79bad377ed788e9$export$e1dc85b7b7495247.no_internet_connection);
            }
            try {
                await this.core.relayer.subscribe(r, {
                    relay: a
                });
            } catch (m) {
                throw i.setError($e79bad377ed788e9$export$e1dc85b7b7495247.subscribe_pairing_topic_failure), m;
            }
            return i.addTrace($e79bad377ed788e9$export$6736f9bb609b5d34.subscribe_pairing_topic_success), b;
        }, this.activate = async ({ topic: s })=>{
            this.isInitialized();
            const i = (0, $iN1TF.calcExpiry)((0, $iNdL8.THIRTY_DAYS));
            this.core.expirer.set(s, i), await this.pairings.update(s, {
                active: !0,
                expiry: i
            });
        }, this.ping = async (s)=>{
            this.isInitialized(), await this.isValidPing(s);
            const { topic: i } = s;
            if (this.pairings.keys.includes(i)) {
                const r = await this.sendRequest(i, "wc_pairingPing", {}), { done: n, resolve: a, reject: h } = (0, $iN1TF.createDelayedPromise)();
                this.events.once((0, $iN1TF.engineEvent)("pairing_ping", r), ({ error: c })=>{
                    c ? h(c) : a();
                }), await n();
            }
        }, this.updateExpiry = async ({ topic: s, expiry: i })=>{
            this.isInitialized(), await this.pairings.update(s, {
                expiry: i
            });
        }, this.updateMetadata = async ({ topic: s, metadata: i })=>{
            this.isInitialized(), await this.pairings.update(s, {
                peerMetadata: i
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (s)=>{
            this.isInitialized(), await this.isValidDisconnect(s);
            const { topic: i } = s;
            this.pairings.keys.includes(i) && (await this.sendRequest(i, "wc_pairingDelete", (0, $iN1TF.getSdkError)("USER_DISCONNECTED")), await this.deletePairing(i));
        }, this.sendRequest = async (s, i, r)=>{
            const n = (0, $eS6BO.formatJsonRpcRequest)(i, r), a = await this.core.crypto.encode(s, n), h = $e79bad377ed788e9$export$d94d6986a8185883[i].req;
            return this.core.history.set(s, n), this.core.relayer.publish(s, a, h), n.id;
        }, this.sendResult = async (s, i, r)=>{
            const n = (0, $eS6BO.formatJsonRpcResult)(s, r), a = await this.core.crypto.encode(i, n), h = await this.core.history.get(i, s), c = $e79bad377ed788e9$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(i, a, c), await this.core.history.resolve(n);
        }, this.sendError = async (s, i, r)=>{
            const n = (0, $eS6BO.formatJsonRpcError)(s, r), a = await this.core.crypto.encode(i, n), h = await this.core.history.get(i, s), c = $e79bad377ed788e9$export$d94d6986a8185883[h.request.method] ? $e79bad377ed788e9$export$d94d6986a8185883[h.request.method].res : $e79bad377ed788e9$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(i, a, c), await this.core.history.resolve(n);
        }, this.deletePairing = async (s, i)=>{
            await this.core.relayer.unsubscribe(s), await Promise.all([
                this.pairings.delete(s, (0, $iN1TF.getSdkError)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(s),
                i ? Promise.resolve() : this.core.expirer.del(s)
            ]);
        }, this.cleanup = async ()=>{
            const s = this.pairings.getAll().filter((i)=>(0, $iN1TF.isExpired)(i.expiry));
            await Promise.all(s.map((i)=>this.deletePairing(i.topic)));
        }, this.onRelayEventRequest = (s)=>{
            const { topic: i, payload: r } = s;
            switch(r.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(i, r);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(i, r);
                default:
                    return this.onUnknownRpcMethodRequest(i, r);
            }
        }, this.onRelayEventResponse = async (s)=>{
            const { topic: i, payload: r } = s, n = (await this.core.history.get(i, r.id)).request.method;
            switch(n){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(i, r);
                default:
                    return this.onUnknownRpcMethodResponse(n);
            }
        }, this.onPairingPingRequest = async (s, i)=>{
            const { id: r } = i;
            try {
                this.isValidPing({
                    topic: s
                }), await this.sendResult(r, s, !0), this.events.emit($e79bad377ed788e9$export$ca3c0b962acf7b75.ping, {
                    id: r,
                    topic: s
                });
            } catch (n) {
                await this.sendError(r, s, n), this.logger.error(n);
            }
        }, this.onPairingPingResponse = (s, i)=>{
            const { id: r } = i;
            setTimeout(()=>{
                (0, $bNBqy.isJsonRpcResult)(i) ? this.events.emit((0, $iN1TF.engineEvent)("pairing_ping", r), {}) : (0, $bNBqy.isJsonRpcError)(i) && this.events.emit((0, $iN1TF.engineEvent)("pairing_ping", r), {
                    error: i.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (s, i)=>{
            const { id: r } = i;
            try {
                this.isValidDisconnect({
                    topic: s
                }), await this.deletePairing(s), this.events.emit($e79bad377ed788e9$export$ca3c0b962acf7b75.delete, {
                    id: r,
                    topic: s
                });
            } catch (n) {
                await this.sendError(r, s, n), this.logger.error(n);
            }
        }, this.onUnknownRpcMethodRequest = async (s, i)=>{
            const { id: r, method: n } = i;
            try {
                if (this.registeredMethods.includes(n)) return;
                const a = (0, $iN1TF.getSdkError)("WC_METHOD_UNSUPPORTED", n);
                await this.sendError(r, s, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(r, s, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodResponse = (s)=>{
            this.registeredMethods.includes(s) || this.logger.error((0, $iN1TF.getSdkError)("WC_METHOD_UNSUPPORTED", s));
        }, this.isValidPair = (s, i)=>{
            var r;
            if (!(0, $iN1TF.isValidParams)(s)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `pair() params: ${s}`);
                throw i.setError($e79bad377ed788e9$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(0, $iN1TF.isValidUrl)(s.uri)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `pair() uri: ${s.uri}`);
                throw i.setError($e79bad377ed788e9$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            const n = (0, $iN1TF.parseUri)(s?.uri);
            if (!((r = n?.relay) != null && r.protocol)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw i.setError($e79bad377ed788e9$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(n != null && n.symKey)) {
                const { message: a } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw i.setError($e79bad377ed788e9$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (n != null && n.expiryTimestamp && (0, $iNdL8.toMiliseconds)(n?.expiryTimestamp) < Date.now()) {
                i.setError($e79bad377ed788e9$export$e1dc85b7b7495247.pairing_expired);
                const { message: a } = (0, $iN1TF.getInternalError)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(a);
            }
        }, this.isValidPing = async (s)=>{
            if (!(0, $iN1TF.isValidParams)(s)) {
                const { message: r } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `ping() params: ${s}`);
                throw new Error(r);
            }
            const { topic: i } = s;
            await this.isValidPairingTopic(i);
        }, this.isValidDisconnect = async (s)=>{
            if (!(0, $iN1TF.isValidParams)(s)) {
                const { message: r } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${s}`);
                throw new Error(r);
            }
            const { topic: i } = s;
            await this.isValidPairingTopic(i);
        }, this.isValidPairingTopic = async (s)=>{
            if (!(0, $iN1TF.isValidString)(s, !1)) {
                const { message: i } = (0, $iN1TF.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${s}`);
                throw new Error(i);
            }
            if (!this.pairings.keys.includes(s)) {
                const { message: i } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${s}`);
                throw new Error(i);
            }
            if ((0, $iN1TF.isExpired)(this.pairings.get(s).expiry)) {
                await this.deletePairing(s);
                const { message: i } = (0, $iN1TF.getInternalError)("EXPIRED", `pairing topic: ${s}`);
                throw new Error(i);
            }
        }, this.core = e, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name), this.pairings = new $e79bad377ed788e9$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($e79bad377ed788e9$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: s } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(s))) return;
            const i = await this.core.crypto.decode(t, s);
            try {
                (0, $bNBqy.isJsonRpcRequest)(i) ? (this.core.history.set(t, i), this.onRelayEventRequest({
                    topic: t,
                    payload: i
                })) : (0, $bNBqy.isJsonRpcResponse)(i) && (await this.core.history.resolve(i), await this.onRelayEventResponse({
                    topic: t,
                    payload: i
                }), this.core.history.delete(t, i.id));
            } catch (r) {
                this.logger.error(r);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($e79bad377ed788e9$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $iN1TF.parseExpirerTarget)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($e79bad377ed788e9$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
class $e79bad377ed788e9$export$eeb4f10f25d479cb extends (0, $evwHH.IJsonRpcHistory) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $jMGWz.EventEmitter), this.name = $e79bad377ed788e9$export$160142c73cb99dc3, this.version = $e79bad377ed788e9$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((s)=>this.records.set(s.id, s)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (s, i, r)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: s,
                request: i,
                chainId: r
            }), this.records.has(i.id)) return;
            const n = {
                id: i.id,
                topic: s,
                request: {
                    method: i.method,
                    params: i.params || null
                },
                chainId: r,
                expiry: (0, $iN1TF.calcExpiry)((0, $iNdL8.THIRTY_DAYS))
            };
            this.records.set(n.id, n), this.persist(), this.events.emit($e79bad377ed788e9$export$a682338b5ffca937.created, n);
        }, this.resolve = async (s)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: s
            }), !this.records.has(s.id)) return;
            const i = await this.getRecord(s.id);
            typeof i.response > "u" && (i.response = (0, $bNBqy.isJsonRpcError)(s) ? {
                error: s.error
            } : {
                result: s.result
            }, this.records.set(i.id, i), this.persist(), this.events.emit($e79bad377ed788e9$export$a682338b5ffca937.updated, i));
        }, this.get = async (s, i)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: s,
                id: i
            }), await this.getRecord(i)), this.delete = (s, i)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: i
            }), this.values.forEach((r)=>{
                if (r.topic === s) {
                    if (typeof i < "u" && r.id !== i) return;
                    this.records.delete(r.id), this.events.emit($e79bad377ed788e9$export$a682338b5ffca937.deleted, r);
                }
            }), this.persist();
        }, this.exists = async (s, i)=>(this.isInitialized(), this.records.has(i) ? (await this.getRecord(i)).topic === s : !1), this.on = (s, i)=>{
            this.events.on(s, i);
        }, this.once = (s, i)=>{
            this.events.once(s, i);
        }, this.off = (s, i)=>{
            this.events.off(s, i);
        }, this.removeListener = (s, i)=>{
            this.events.removeListener(s, i);
        }, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const s = {
                topic: t.topic,
                request: (0, $eS6BO.formatJsonRpcRequest)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(s);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: s } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(s);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($e79bad377ed788e9$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $iN1TF.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($e79bad377ed788e9$export$a682338b5ffca937.created, (e)=>{
            const t = $e79bad377ed788e9$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($e79bad377ed788e9$export$a682338b5ffca937.updated, (e)=>{
            const t = $e79bad377ed788e9$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($e79bad377ed788e9$export$a682338b5ffca937.deleted, (e)=>{
            const t = $e79bad377ed788e9$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.core.heartbeat.on((0, $ahj4I.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.isInitialized();
            let e = !1;
            this.records.forEach((t)=>{
                (0, $iNdL8.toMiliseconds)(t.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${t.id}`), this.records.delete(t.id), this.events.emit($e79bad377ed788e9$export$a682338b5ffca937.deleted, t, !1), e = !0);
            }), e && this.persist();
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e79bad377ed788e9$export$e76805ce609031cb extends (0, $evwHH.IExpirer) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $jMGWz.EventEmitter), this.name = $e79bad377ed788e9$export$4ddf883392bbc828, this.version = $e79bad377ed788e9$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((s)=>this.expirations.set(s.target, s)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (s)=>{
            try {
                const i = this.formatTarget(s);
                return typeof this.getExpiration(i) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (s, i)=>{
            this.isInitialized();
            const r = this.formatTarget(s), n = {
                target: r,
                expiry: i
            };
            this.expirations.set(r, n), this.checkExpiry(r, n), this.events.emit($e79bad377ed788e9$export$9013719d9206b0c1.created, {
                target: r,
                expiration: n
            });
        }, this.get = (s)=>{
            this.isInitialized();
            const i = this.formatTarget(s);
            return this.getExpiration(i);
        }, this.del = (s)=>{
            if (this.isInitialized(), this.has(s)) {
                const i = this.formatTarget(s), r = this.getExpiration(i);
                this.expirations.delete(i), this.events.emit($e79bad377ed788e9$export$9013719d9206b0c1.deleted, {
                    target: i,
                    expiration: r
                });
            }
        }, this.on = (s, i)=>{
            this.events.on(s, i);
        }, this.once = (s, i)=>{
            this.events.once(s, i);
        }, this.off = (s, i)=>{
            this.events.off(s, i);
        }, this.removeListener = (s, i)=>{
            this.events.removeListener(s, i);
        }, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $iN1TF.formatTopicTarget)(e);
        if (typeof e == "number") return (0, $iN1TF.formatIdTarget)(e);
        const { message: t } = (0, $iN1TF.getInternalError)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($e79bad377ed788e9$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $iN1TF.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: s } = (0, $iN1TF.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.warn(s), new Error(s);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: s } = t;
        (0, $iNdL8.toMiliseconds)(s) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($e79bad377ed788e9$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $ahj4I.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($e79bad377ed788e9$export$9013719d9206b0c1.created, (e)=>{
            const t = $e79bad377ed788e9$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e79bad377ed788e9$export$9013719d9206b0c1.expired, (e)=>{
            const t = $e79bad377ed788e9$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e79bad377ed788e9$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $e79bad377ed788e9$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $iN1TF.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
var $e79bad377ed788e9$var$y = {};
Object.defineProperty($e79bad377ed788e9$var$y, "__esModule", {
    value: !0
}), $e79bad377ed788e9$var$y.getLocalStorage = $e79bad377ed788e9$var$y.getLocalStorageOrThrow = $e79bad377ed788e9$var$y.getCrypto = $e79bad377ed788e9$var$y.getCryptoOrThrow = $e79bad377ed788e9$var$y.getLocation = $e79bad377ed788e9$var$y.getLocationOrThrow = $e79bad377ed788e9$var$y.getNavigator = $e79bad377ed788e9$var$y.getNavigatorOrThrow = $e79bad377ed788e9$var$ri = $e79bad377ed788e9$var$y.getDocument = $e79bad377ed788e9$var$y.getDocumentOrThrow = $e79bad377ed788e9$var$y.getFromWindowOrThrow = $e79bad377ed788e9$var$y.getFromWindow = void 0;
function $e79bad377ed788e9$var$K(o) {
    let e;
    return typeof window < "u" && typeof window[o] < "u" && (e = window[o]), e;
}
$e79bad377ed788e9$var$y.getFromWindow = $e79bad377ed788e9$var$K;
function $e79bad377ed788e9$var$j(o) {
    const e = $e79bad377ed788e9$var$K(o);
    if (!e) throw new Error(`${o} is not defined in Window`);
    return e;
}
$e79bad377ed788e9$var$y.getFromWindowOrThrow = $e79bad377ed788e9$var$j;
function $e79bad377ed788e9$var$on() {
    return $e79bad377ed788e9$var$j("document");
}
$e79bad377ed788e9$var$y.getDocumentOrThrow = $e79bad377ed788e9$var$on;
function $e79bad377ed788e9$var$an() {
    return $e79bad377ed788e9$var$K("document");
}
var $e79bad377ed788e9$var$ri = $e79bad377ed788e9$var$y.getDocument = $e79bad377ed788e9$var$an;
function $e79bad377ed788e9$var$hn() {
    return $e79bad377ed788e9$var$j("navigator");
}
$e79bad377ed788e9$var$y.getNavigatorOrThrow = $e79bad377ed788e9$var$hn;
function $e79bad377ed788e9$var$cn() {
    return $e79bad377ed788e9$var$K("navigator");
}
$e79bad377ed788e9$var$y.getNavigator = $e79bad377ed788e9$var$cn;
function $e79bad377ed788e9$var$ln() {
    return $e79bad377ed788e9$var$j("location");
}
$e79bad377ed788e9$var$y.getLocationOrThrow = $e79bad377ed788e9$var$ln;
function $e79bad377ed788e9$var$un() {
    return $e79bad377ed788e9$var$K("location");
}
$e79bad377ed788e9$var$y.getLocation = $e79bad377ed788e9$var$un;
function $e79bad377ed788e9$var$dn() {
    return $e79bad377ed788e9$var$j("crypto");
}
$e79bad377ed788e9$var$y.getCryptoOrThrow = $e79bad377ed788e9$var$dn;
function $e79bad377ed788e9$var$gn() {
    return $e79bad377ed788e9$var$K("crypto");
}
$e79bad377ed788e9$var$y.getCrypto = $e79bad377ed788e9$var$gn;
function $e79bad377ed788e9$var$pn() {
    return $e79bad377ed788e9$var$j("localStorage");
}
$e79bad377ed788e9$var$y.getLocalStorageOrThrow = $e79bad377ed788e9$var$pn;
function $e79bad377ed788e9$var$yn() {
    return $e79bad377ed788e9$var$K("localStorage");
}
$e79bad377ed788e9$var$y.getLocalStorage = $e79bad377ed788e9$var$yn;
class $e79bad377ed788e9$export$91a8e56769aeb334 extends (0, $evwHH.IVerify) {
    constructor(e, t, s){
        super(e, t, s), this.core = e, this.logger = t, this.store = s, this.name = $e79bad377ed788e9$export$3b58f2450f2297e3, this.verifyUrlV3 = $e79bad377ed788e9$export$412739528655ee2f, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.version = $e79bad377ed788e9$export$f30bd3c8747cdfbe, this.init = async ()=>{
            var i;
            this.isDevEnv || (this.publicKey = await this.store.getItem(this.storeKey), this.publicKey && (0, $iNdL8.toMiliseconds)((i = this.publicKey) == null ? void 0 : i.expiresAt) < Date.now() && (this.logger.debug("verify v2 public key expired"), await this.removePublicKey()), this.publicKey || await this.fetchAndPersistPublicKey());
        }, this.register = async (i)=>{
            if (!(0, $iN1TF.isBrowser)() || this.isDevEnv) return;
            const r = window.location.origin, { id: n, decryptedId: a } = i, h = `${this.verifyUrlV3}/attestation?projectId=${this.core.projectId}&origin=${r}&id=${n}&decryptedId=${a}`;
            try {
                const c = $e79bad377ed788e9$var$ri(), d = this.startAbortTimer((0, $iNdL8.ONE_SECOND) * 5), g = await new Promise((b, m)=>{
                    const l = ()=>{
                        window.removeEventListener("message", _), c.body.removeChild(p), m("attestation aborted");
                    };
                    this.abortController.signal.addEventListener("abort", l);
                    const p = c.createElement("iframe");
                    p.src = h, p.style.display = "none", p.addEventListener("error", l, {
                        signal: this.abortController.signal
                    });
                    const _ = (D)=>{
                        if (!D.data) return;
                        const E = JSON.parse(D.data);
                        if (E.type === "verify_attestation") {
                            if ((0, $i4OlP.decodeJWT)(E.attestation).payload.id !== n) return;
                            clearInterval(d), c.body.removeChild(p), this.abortController.signal.removeEventListener("abort", l), window.removeEventListener("message", _), b(E.attestation === null ? "" : E.attestation);
                        }
                    };
                    c.body.appendChild(p), window.addEventListener("message", _, {
                        signal: this.abortController.signal
                    });
                });
                return this.logger.debug("jwt attestation", g), g;
            } catch (c) {
                this.logger.warn(c);
            }
            return "";
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const { attestationId: r, hash: n, encryptedId: a } = i;
            if (r === "") {
                this.logger.debug("resolve: attestationId is empty, skipping");
                return;
            }
            if (r) {
                if ((0, $i4OlP.decodeJWT)(r).payload.id !== a) return;
                const c = await this.isValidJwtAttestation(r);
                if (c) return c;
            }
            if (!n) return;
            const h = this.getVerifyUrl(i?.verifyUrl);
            return this.fetchAttestation(n, h);
        }, this.fetchAttestation = async (i, r)=>{
            this.logger.debug(`resolving attestation: ${i} from url: ${r}`);
            const n = this.startAbortTimer((0, $iNdL8.ONE_SECOND) * 5), a = await fetch(`${r}/attestation/${i}?v2Supported=true`, {
                signal: this.abortController.signal
            });
            return clearTimeout(n), a.status === 200 ? await a.json() : void 0;
        }, this.getVerifyUrl = (i)=>{
            let r = i || $e79bad377ed788e9$export$7e3b1a28ddecdbaa;
            return $e79bad377ed788e9$export$be24df03c4baa778.includes(r) || (this.logger.info(`verify url: ${r}, not included in trusted list, assigning default: ${$e79bad377ed788e9$export$7e3b1a28ddecdbaa}`), r = $e79bad377ed788e9$export$7e3b1a28ddecdbaa), r;
        }, this.fetchPublicKey = async ()=>{
            try {
                this.logger.debug(`fetching public key from: ${this.verifyUrlV3}`);
                const i = this.startAbortTimer((0, $iNdL8.FIVE_SECONDS)), r = await fetch(`${this.verifyUrlV3}/public-key`, {
                    signal: this.abortController.signal
                });
                return clearTimeout(i), await r.json();
            } catch (i) {
                this.logger.warn(i);
            }
        }, this.persistPublicKey = async (i)=>{
            this.logger.debug("persisting public key to local storage", i), await this.store.setItem(this.storeKey, i), this.publicKey = i;
        }, this.removePublicKey = async ()=>{
            this.logger.debug("removing verify v2 public key from storage"), await this.store.removeItem(this.storeKey), this.publicKey = void 0;
        }, this.isValidJwtAttestation = async (i)=>{
            const r = await this.getPublicKey();
            try {
                if (r) return this.validateAttestation(i, r);
            } catch (a) {
                this.logger.error(a), this.logger.warn("error validating attestation");
            }
            const n = await this.fetchAndPersistPublicKey();
            try {
                if (n) return this.validateAttestation(i, n);
            } catch (a) {
                this.logger.error(a), this.logger.warn("error validating attestation");
            }
        }, this.getPublicKey = async ()=>this.publicKey ? this.publicKey : await this.fetchAndPersistPublicKey(), this.fetchAndPersistPublicKey = async ()=>{
            if (this.fetchPromise) return await this.fetchPromise, this.publicKey;
            this.fetchPromise = new Promise(async (r)=>{
                const n = await this.fetchPublicKey();
                n && (await this.persistPublicKey(n), r(n));
            });
            const i = await this.fetchPromise;
            return this.fetchPromise = void 0, i;
        }, this.validateAttestation = (i, r)=>{
            const n = (0, $iN1TF.verifyP256Jwt)(i, r.publicKey), a = {
                hasExpired: (0, $iNdL8.toMiliseconds)(n.exp) < Date.now(),
                payload: n
            };
            if (a.hasExpired) throw this.logger.warn("resolve: jwt attestation expired"), new Error("JWT attestation expired");
            return {
                origin: a.payload.origin,
                isScam: a.payload.isScam
            };
        }, this.logger = (0, $GVAyr.generateChildLogger)(t, this.name), this.abortController = new AbortController, this.isDevEnv = (0, $iN1TF.isNode)() && undefined, this.init();
    }
    get storeKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//verify:public:key";
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $iNdL8.toMiliseconds)(e));
    }
}
class $e79bad377ed788e9$export$c393c48c5b0cf59a extends (0, $evwHH.IEchoClient) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.context = $e79bad377ed788e9$export$40c022d2cffe0adc, this.registerDeviceToken = async (s)=>{
            const { clientId: i, token: r, notificationType: n, enableEncrypted: a = !1 } = s, h = `${$e79bad377ed788e9$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await fetch(h, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: i,
                    type: n,
                    token: r,
                    always_raw: a
                })
            });
        }, this.logger = (0, $GVAyr.generateChildLogger)(t, this.context);
    }
}
var $e79bad377ed788e9$var$Dn = Object.defineProperty, $e79bad377ed788e9$var$ai = Object.getOwnPropertySymbols, $e79bad377ed788e9$var$bn = Object.prototype.hasOwnProperty, $e79bad377ed788e9$var$mn = Object.prototype.propertyIsEnumerable, $e79bad377ed788e9$var$hi = (o, e, t)=>e in o ? $e79bad377ed788e9$var$Dn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e79bad377ed788e9$var$Z = (o, e)=>{
    for(var t in e || (e = {}))$e79bad377ed788e9$var$bn.call(e, t) && $e79bad377ed788e9$var$hi(o, t, e[t]);
    if ($e79bad377ed788e9$var$ai) for (var t of $e79bad377ed788e9$var$ai(e))$e79bad377ed788e9$var$mn.call(e, t) && $e79bad377ed788e9$var$hi(o, t, e[t]);
    return o;
};
class $e79bad377ed788e9$export$f4a30e909fe70796 extends (0, $evwHH.IEventClient) {
    constructor(e, t, s = !0){
        super(e, t, s), this.core = e, this.logger = t, this.context = $e79bad377ed788e9$export$e020229e09910965, this.storagePrefix = $e79bad377ed788e9$export$f258d29ae5e3d545, this.storageVersion = $e79bad377ed788e9$export$c73857c3a3d16b1c, this.events = new Map, this.shouldPersist = !1, this.createEvent = (i)=>{
            const { event: r = "ERROR", type: n = "", properties: { topic: a, trace: h } } = i, c = (0, $iN1TF.uuidv4)(), d = this.core.projectId || "", g = Date.now(), b = $e79bad377ed788e9$var$Z({
                eventId: c,
                bundleId: d,
                timestamp: g,
                props: {
                    event: r,
                    type: n,
                    properties: {
                        topic: a,
                        trace: h
                    }
                }
            }, this.setMethods(c));
            return this.telemetryEnabled && (this.events.set(c, b), this.shouldPersist = !0), b;
        }, this.getEvent = (i)=>{
            const { eventId: r, topic: n } = i;
            if (r) return this.events.get(r);
            const a = Array.from(this.events.values()).find((h)=>h.props.properties.topic === n);
            if (a) return $e79bad377ed788e9$var$Z($e79bad377ed788e9$var$Z({}, a), this.setMethods(a.eventId));
        }, this.deleteEvent = (i)=>{
            const { eventId: r } = i;
            this.events.delete(r), this.shouldPersist = !0;
        }, this.setEventListeners = ()=>{
            this.core.heartbeat.on((0, $ahj4I.HEARTBEAT_EVENTS).pulse, async ()=>{
                this.shouldPersist && await this.persist(), this.events.forEach((i)=>{
                    (0, $iNdL8.fromMiliseconds)(Date.now()) - (0, $iNdL8.fromMiliseconds)(i.timestamp) > $e79bad377ed788e9$export$79348045429687e2 && (this.events.delete(i.eventId), this.shouldPersist = !0);
                });
            });
        }, this.setMethods = (i)=>({
                addTrace: (r)=>this.addTrace(i, r),
                setError: (r)=>this.setError(i, r)
            }), this.addTrace = (i, r)=>{
            const n = this.events.get(i);
            n && (n.props.properties.trace.push(r), this.events.set(i, n), this.shouldPersist = !0);
        }, this.setError = (i, r)=>{
            const n = this.events.get(i);
            n && (n.props.type = r, n.timestamp = Date.now(), this.events.set(i, n), this.shouldPersist = !0);
        }, this.persist = async ()=>{
            await this.core.storage.setItem(this.storageKey, Array.from(this.events.values())), this.shouldPersist = !1;
        }, this.restore = async ()=>{
            try {
                const i = await this.core.storage.getItem(this.storageKey) || [];
                if (!i.length) return;
                i.forEach((r)=>{
                    this.events.set(r.eventId, $e79bad377ed788e9$var$Z($e79bad377ed788e9$var$Z({}, r), this.setMethods(r.eventId)));
                });
            } catch (i) {
                this.logger.warn(i);
            }
        }, this.submit = async ()=>{
            if (!this.telemetryEnabled || this.events.size === 0) return;
            const i = [];
            for (const [r, n] of this.events)n.props.type && i.push(n);
            if (i.length !== 0) try {
                if ((await fetch(`${$e79bad377ed788e9$export$bb6a8925f3cb1ca}?projectId=${this.core.projectId}&st=events_sdk&sv=js-${$e79bad377ed788e9$export$5f30917a6f8c9025}`, {
                    method: "POST",
                    body: JSON.stringify(i)
                })).ok) for (const r of i)this.events.delete(r.eventId), this.shouldPersist = !0;
            } catch (r) {
                this.logger.warn(r);
            }
        }, this.logger = (0, $GVAyr.generateChildLogger)(t, this.context), s ? this.restore().then(async ()=>{
            await this.submit(), this.setEventListeners();
        }) : this.persist();
    }
    get storageKey() {
        return this.storagePrefix + this.storageVersion + this.core.customStoragePrefix + "//" + this.context;
    }
}
var $e79bad377ed788e9$var$fn = Object.defineProperty, $e79bad377ed788e9$var$li = Object.getOwnPropertySymbols, $e79bad377ed788e9$var$_n = Object.prototype.hasOwnProperty, $e79bad377ed788e9$var$En = Object.prototype.propertyIsEnumerable, $e79bad377ed788e9$var$ui = (o, e, t)=>e in o ? $e79bad377ed788e9$var$fn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $e79bad377ed788e9$var$di = (o, e)=>{
    for(var t in e || (e = {}))$e79bad377ed788e9$var$_n.call(e, t) && $e79bad377ed788e9$var$ui(o, t, e[t]);
    if ($e79bad377ed788e9$var$li) for (var t of $e79bad377ed788e9$var$li(e))$e79bad377ed788e9$var$En.call(e, t) && $e79bad377ed788e9$var$ui(o, t, e[t]);
    return o;
};
class $e79bad377ed788e9$export$2e2bcd8739ae039 extends (0, $evwHH.ICore) {
    constructor(e){
        var t;
        super(e), this.protocol = $e79bad377ed788e9$export$51b1c900ac262bdf, this.version = $e79bad377ed788e9$export$f30bd3c8747cdfbe, this.name = $e79bad377ed788e9$export$d47601f9de5ee22b, this.events = new (0, $jMGWz.EventEmitter), this.initialized = !1, this.on = (n, a)=>this.events.on(n, a), this.once = (n, a)=>this.events.once(n, a), this.off = (n, a)=>this.events.off(n, a), this.removeListener = (n, a)=>this.events.removeListener(n, a), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $e79bad377ed788e9$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const s = (0, $GVAyr.getDefaultLoggerOptions)({
            level: typeof e?.logger == "string" && e.logger ? e.logger : $e79bad377ed788e9$export$db0fdb6d486555c2.logger
        }), { logger: i, chunkLoggerController: r } = (0, $GVAyr.generatePlatformLogger)({
            opts: s,
            maxSizeInBytes: e?.maxLogBlobSizeInBytes,
            loggerOverride: e?.logger
        });
        this.logChunkController = r, (t = this.logChunkController) != null && t.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = async ()=>{
            var n, a;
            (n = this.logChunkController) != null && n.downloadLogsBlobInBrowser && ((a = this.logChunkController) == null || a.downloadLogsBlobInBrowser({
                clientId: await this.crypto.getClientId()
            }));
        }), this.logger = (0, $GVAyr.generateChildLogger)(i, this.name), this.heartbeat = new (0, $ahj4I.HeartBeat), this.crypto = new $e79bad377ed788e9$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $e79bad377ed788e9$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $e79bad377ed788e9$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $a5MFc.default)($e79bad377ed788e9$var$di($e79bad377ed788e9$var$di({}, $e79bad377ed788e9$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $e79bad377ed788e9$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $e79bad377ed788e9$export$3370ee24730992a3(this, this.logger), this.verify = new $e79bad377ed788e9$export$91a8e56769aeb334(this, this.logger, this.storage), this.echoClient = new $e79bad377ed788e9$export$c393c48c5b0cf59a(this.projectId || "", this.logger), this.eventClient = new $e79bad377ed788e9$export$f4a30e909fe70796(this, this.logger, e?.telemetryEnabled);
    }
    static async init(e) {
        const t = new $e79bad377ed788e9$export$2e2bcd8739ae039(e);
        await t.initialize();
        const s = await t.crypto.getClientId();
        return await t.storage.setItem($e79bad377ed788e9$export$9e4ca561755938da, s), t;
    }
    get context() {
        return (0, $GVAyr.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async getLogsBlob() {
        var e;
        return (e = this.logChunkController) == null ? void 0 : e.logsToBlob({
            clientId: await this.crypto.getClientId()
        });
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $e79bad377ed788e9$export$4143ab5b91744744 = $e79bad377ed788e9$export$2e2bcd8739ae039;

});
parcelRegister("a5MFc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75901e94aa2b92d8$export$8536778e426ddf92; });

var $7xX2O = parcelRequire("7xX2O");

var $4oi3G = parcelRequire("4oi3G");

var $6mXg5 = parcelRequire("6mXg5");
function $75901e94aa2b92d8$var$C(i) {
    return i;
}
const $75901e94aa2b92d8$var$x = "idb-keyval";
var $75901e94aa2b92d8$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $4oi3G.createStore)(i.dbName, i.storeName)), {
        name: $75901e94aa2b92d8$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $4oi3G.get)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $4oi3G.get)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $4oi3G.set)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $4oi3G.del)(e(s), n);
        },
        getKeys () {
            return (0, $4oi3G.keys)(n);
        },
        clear () {
            return (0, $4oi3G.clear)(n);
        }
    };
};
const $75901e94aa2b92d8$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $75901e94aa2b92d8$var$E = "keyvaluestorage";
class $75901e94aa2b92d8$var$_ {
    constructor(){
        this.indexedDb = (0, $7xX2O.createStorage)({
            driver: $75901e94aa2b92d8$var$z({
                dbName: $75901e94aa2b92d8$var$D,
                storeName: $75901e94aa2b92d8$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $6mXg5.safeJsonStringify)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $75901e94aa2b92d8$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $75901e94aa2b92d8$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $75901e94aa2b92d8$var$l < "u" && $75901e94aa2b92d8$var$l.localStorage ? $75901e94aa2b92d8$var$c.exports = $75901e94aa2b92d8$var$l.localStorage : typeof window < "u" && window.localStorage ? $75901e94aa2b92d8$var$c.exports = window.localStorage : $75901e94aa2b92d8$var$c.exports = new t;
})();
function $75901e94aa2b92d8$var$k(i) {
    var t;
    return [
        i[0],
        (0, $6mXg5.safeJsonParse)((t = i[1]) != null ? t : "")
    ];
}
class $75901e94aa2b92d8$var$K {
    constructor(){
        this.localStorage = $75901e94aa2b92d8$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($75901e94aa2b92d8$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $6mXg5.safeJsonParse)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $6mXg5.safeJsonStringify)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $75901e94aa2b92d8$var$N = "wc_storage_version", $75901e94aa2b92d8$var$y = 1, $75901e94aa2b92d8$var$O = async (i, t, e)=>{
    const n = $75901e94aa2b92d8$var$N, s = await t.getItem(n);
    if (s && s >= $75901e94aa2b92d8$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $75901e94aa2b92d8$var$y), e(t), $75901e94aa2b92d8$var$j(i, m);
}, $75901e94aa2b92d8$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $75901e94aa2b92d8$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $75901e94aa2b92d8$var$K;
        this.storage = t;
        try {
            const e = new $75901e94aa2b92d8$var$_;
            $75901e94aa2b92d8$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}

});
parcelRegister("7xX2O", function(module, exports) {

$parcel$export(module.exports, "createStorage", function () { return $8530f792b194e22a$export$d184a47a971dd4b9; });

var $28MqZ = parcelRequire("28MqZ");

var $1XKyX = parcelRequire("1XKyX");
function $8530f792b194e22a$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $8530f792b194e22a$var$DRIVER_NAME = "memory";
const $8530f792b194e22a$var$memory = $8530f792b194e22a$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $8530f792b194e22a$var$DRIVER_NAME,
        options: {},
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return Array.from(data.keys());
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $8530f792b194e22a$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $8530f792b194e22a$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $1XKyX.a)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $8530f792b194e22a$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $1XKyX.a)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $1XKyX.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $1XKyX.b)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $1XKyX.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $1XKyX.b)(driver.getItem, relativeKey, opts).then((value)=>(0, $28MqZ.default)(value));
        },
        getItems (items, commonOptions) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $1XKyX.b)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $1XKyX.j)(batch.base, item.key),
                            value: (0, $28MqZ.default)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $1XKyX.b)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $28MqZ.default)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $1XKyX.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $1XKyX.b)(driver.getItemRaw, relativeKey, opts);
            return (0, $1XKyX.b)(driver.getItem, relativeKey, opts).then((value)=>(0, $1XKyX.d)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $1XKyX.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $1XKyX.b)(driver.setItem, relativeKey, (0, $1XKyX.s)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) return (0, $1XKyX.b)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $1XKyX.s)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $1XKyX.b)(batch.driver.setItem, item.relativeKey, (0, $1XKyX.s)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $1XKyX.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $1XKyX.b)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $1XKyX.b)(driver.setItem, relativeKey, (0, $1XKyX.c)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $1XKyX.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $1XKyX.b)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $1XKyX.b)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $1XKyX.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $1XKyX.b)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $1XKyX.b)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $28MqZ.default)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $1XKyX.n)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            for (const mount of mounts){
                const rawKeys = await (0, $1XKyX.b)(mount.driver.getKeys, mount.relativeBase, opts);
                const keys = rawKeys.map((key)=>mount.mountpoint + (0, $1XKyX.a)(key)).filter((key)=>!maskedMounts.some((p)=>key.startsWith(p)));
                allKeys.push(...keys);
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            return base ? allKeys.filter((key)=>key.startsWith(base) && !key.endsWith("$")) : allKeys.filter((key)=>!key.endsWith("$"));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $1XKyX.n)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $1XKyX.b)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$8530f792b194e22a$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $1XKyX.n)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($8530f792b194e22a$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $1XKyX.n)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
            }
            if (_dispose) await $8530f792b194e22a$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $1XKyX.a)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $1XKyX.a)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        }
    };
    return storage;
}
async function $8530f792b194e22a$export$b8801ea43165ed7d(storage, base) {
    base = (0, $1XKyX.n)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $8530f792b194e22a$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $1XKyX.n)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $8530f792b194e22a$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $8530f792b194e22a$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $1XKyX.b)(driver.dispose);
}
const $8530f792b194e22a$export$108bed33247a8bd7 = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};

});
parcelRegister("28MqZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06bacb514fd1f253$export$2e2bcd8739ae039; });
const $06bacb514fd1f253$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $06bacb514fd1f253$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $06bacb514fd1f253$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $06bacb514fd1f253$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $06bacb514fd1f253$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $06bacb514fd1f253$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $06bacb514fd1f253$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    const _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.endsWith('"') && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        const _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!$06bacb514fd1f253$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($06bacb514fd1f253$var$suspectProtoRx.test(value) || $06bacb514fd1f253$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $06bacb514fd1f253$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $06bacb514fd1f253$export$4b2a7c187ff4b28c(value, options = {}) {
    return $06bacb514fd1f253$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}

});

parcelRegister("1XKyX", function(module, exports) {

$parcel$export(module.exports, "b", function () { return $6aba046486b33b85$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "s", function () { return $6aba046486b33b85$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "c", function () { return $6aba046486b33b85$export$db3b6bfb95261072; });
$parcel$export(module.exports, "d", function () { return $6aba046486b33b85$export$4368d992c4eafac0; });
$parcel$export(module.exports, "n", function () { return $6aba046486b33b85$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "a", function () { return $6aba046486b33b85$export$407448d2b89b1813; });
$parcel$export(module.exports, "j", function () { return $6aba046486b33b85$export$35e795649ee09318; });

var $fxkLe = parcelRequire("fxkLe");
var $6aba046486b33b85$require$Buffer = $fxkLe.Buffer;
function $6aba046486b33b85$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $6aba046486b33b85$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $6aba046486b33b85$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $6aba046486b33b85$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $6aba046486b33b85$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $6aba046486b33b85$export$2408f22a0fab9ae5(value) {
    if ($6aba046486b33b85$var$isPrimitive(value)) return String(value);
    if ($6aba046486b33b85$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $6aba046486b33b85$export$2408f22a0fab9ae5(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function $6aba046486b33b85$var$checkBufferSupport() {}
const $6aba046486b33b85$var$BASE64_PREFIX = "base64:";
function $6aba046486b33b85$export$db3b6bfb95261072(value) {
    if (typeof value === "string") return value;
    $6aba046486b33b85$var$checkBufferSupport();
    const base64 = $6aba046486b33b85$require$Buffer.from(value).toString("base64");
    return $6aba046486b33b85$var$BASE64_PREFIX + base64;
}
function $6aba046486b33b85$export$4368d992c4eafac0(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($6aba046486b33b85$var$BASE64_PREFIX)) return value;
    $6aba046486b33b85$var$checkBufferSupport();
    return $6aba046486b33b85$require$Buffer.from(value.slice($6aba046486b33b85$var$BASE64_PREFIX.length), "base64");
}
const $6aba046486b33b85$var$storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $6aba046486b33b85$export$ffb5f4729a158638(storage, base) {
    base = $6aba046486b33b85$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $6aba046486b33b85$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    return nsStorage;
}
function $6aba046486b33b85$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function $6aba046486b33b85$export$35e795649ee09318(...keys) {
    return $6aba046486b33b85$export$407448d2b89b1813(keys.join(":"));
}
function $6aba046486b33b85$export$7ccc53e8f1e7dfc5(base) {
    base = $6aba046486b33b85$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}

});


parcelRegister("4oi3G", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $3327695861e6a85b$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "get", function () { return $3327695861e6a85b$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $3327695861e6a85b$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "del", function () { return $3327695861e6a85b$export$1d2f21e549771e67; });
$parcel$export(module.exports, "clear", function () { return $3327695861e6a85b$export$42ffd38884aecdac; });
$parcel$export(module.exports, "keys", function () { return $3327695861e6a85b$export$ed97f33186d4b816; });
function $3327695861e6a85b$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $3327695861e6a85b$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $3327695861e6a85b$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $3327695861e6a85b$var$defaultGetStoreFunc;
function $3327695861e6a85b$var$defaultGetStore() {
    if (!$3327695861e6a85b$var$defaultGetStoreFunc) $3327695861e6a85b$var$defaultGetStoreFunc = $3327695861e6a85b$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $3327695861e6a85b$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$3988ae62b71be9a3(key, customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readonly", (store)=>$3327695861e6a85b$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$adaa4cf7ef1b65be(key, value, customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.put(value, key);
        return $3327695861e6a85b$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$daa0a5170277c7a8(entries, customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $3327695861e6a85b$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$5df405cccea42673(keys, customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readonly", (store)=>Promise.all(keys.map((key)=>$3327695861e6a85b$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$722fbec263ad908a(key, updater, customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($3327695861e6a85b$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$1d2f21e549771e67(key, customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.delete(key);
        return $3327695861e6a85b$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$c8aa84257229cac8(keys, customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $3327695861e6a85b$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$42ffd38884aecdac(customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.clear();
        return $3327695861e6a85b$export$b327150396135fe7(store.transaction);
    });
}
function $3327695861e6a85b$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $3327695861e6a85b$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$ed97f33186d4b816(customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $3327695861e6a85b$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $3327695861e6a85b$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$68c286be0e7e55b7(customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $3327695861e6a85b$export$b327150396135fe7(store.getAll());
        const items = [];
        return $3327695861e6a85b$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $3327695861e6a85b$export$3e9f948b41964866(customStore = $3327695861e6a85b$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $3327695861e6a85b$export$b327150396135fe7(store.getAllKeys()),
            $3327695861e6a85b$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore("readonly", (store)=>$3327695861e6a85b$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});


parcelRegister("ahj4I", function(module, exports) {

$parcel$export(module.exports, "HEARTBEAT_EVENTS", function () { return $77ba49cdd1e7a991$export$f3340c1af6bee4b5; });
$parcel$export(module.exports, "HeartBeat", function () { return $77ba49cdd1e7a991$export$996c9b2cd7645b55; });

var $jMGWz = parcelRequire("jMGWz");

var $iNdL8 = parcelRequire("iNdL8");
parcelRequire("eh0F2");
var $7W3pH = parcelRequire("7W3pH");
class $77ba49cdd1e7a991$export$d31d5212998928bd extends (0, $7W3pH.IEvents) {
    constructor(e){
        super();
    }
}
const $77ba49cdd1e7a991$export$31c453b5fe09788d = (0, $iNdL8.FIVE_SECONDS), $77ba49cdd1e7a991$export$f3340c1af6bee4b5 = {
    pulse: "heartbeat_pulse"
};
class $77ba49cdd1e7a991$export$996c9b2cd7645b55 extends $77ba49cdd1e7a991$export$d31d5212998928bd {
    constructor(e){
        super(e), this.events = new (0, $jMGWz.EventEmitter), this.interval = $77ba49cdd1e7a991$export$31c453b5fe09788d, this.interval = e?.interval || $77ba49cdd1e7a991$export$31c453b5fe09788d;
    }
    static async init(e) {
        const t = new $77ba49cdd1e7a991$export$996c9b2cd7645b55(e);
        return await t.init(), t;
    }
    async init() {
        await this.initialize();
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async initialize() {
        this.intervalRef = setInterval(()=>this.pulse(), (0, $iNdL8.toMiliseconds)(this.interval));
    }
    pulse() {
        this.events.emit($77ba49cdd1e7a991$export$f3340c1af6bee4b5.pulse);
    }
}

});
parcelRegister("eh0F2", function(module, exports) {
$parcel$export(module.exports, "IEvents", function () { return (parcelRequire("7W3pH")).IEvents; });
parcelRequire("7W3pH");

});
parcelRegister("7W3pH", function(module, exports) {

$parcel$export(module.exports, "IEvents", function () { return $5c7099086b7282ec$export$ab429ec7e240e546; });
class $5c7099086b7282ec$export$ab429ec7e240e546 {
}

});



parcelRegister("evwHH", function(module, exports) {

$parcel$export(module.exports, "ICore", function () { return $a8fd543b6edfc9fe$export$ed533416df113881; });
$parcel$export(module.exports, "IJsonRpcHistory", function () { return $a8fd543b6edfc9fe$export$45b2c2643615b67; });
$parcel$export(module.exports, "IMessageTracker", function () { return $a8fd543b6edfc9fe$export$e67570fe0a885c47; });
$parcel$export(module.exports, "IPublisher", function () { return $a8fd543b6edfc9fe$export$3b0872bbd7e675a2; });
$parcel$export(module.exports, "IRelayer", function () { return $a8fd543b6edfc9fe$export$9a0f755fd4f79434; });
$parcel$export(module.exports, "IStore", function () { return $a8fd543b6edfc9fe$export$a7f17ba6c54777e7; });
$parcel$export(module.exports, "ISubscriber", function () { return $a8fd543b6edfc9fe$export$300eed987e764b57; });
$parcel$export(module.exports, "IExpirer", function () { return $a8fd543b6edfc9fe$export$41aaa3c39f6f2861; });
$parcel$export(module.exports, "IVerify", function () { return $a8fd543b6edfc9fe$export$873b0b865d85ddb6; });
$parcel$export(module.exports, "IEchoClient", function () { return $a8fd543b6edfc9fe$export$7db533fb638f979d; });
$parcel$export(module.exports, "IEventClient", function () { return $a8fd543b6edfc9fe$export$4264a8ec567679e5; });
$parcel$export(module.exports, "ISignClient", function () { return $a8fd543b6edfc9fe$export$2ebcf6eeacedad44; });
$parcel$export(module.exports, "IEngine", function () { return $a8fd543b6edfc9fe$export$87df43c730effa30; });
parcelRequire("eh0F2");
var $7W3pH = parcelRequire("7W3pH");

var $jMGWz = parcelRequire("jMGWz");
class $a8fd543b6edfc9fe$export$ed533416df113881 extends (0, $7W3pH.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $a8fd543b6edfc9fe$export$a4e7e56f03915894 {
    constructor(s, t, e){
        this.core = s, this.logger = t;
    }
}
class $a8fd543b6edfc9fe$export$45b2c2643615b67 extends (0, $7W3pH.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $a8fd543b6edfc9fe$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $a8fd543b6edfc9fe$export$3b0872bbd7e675a2 extends (0, $7W3pH.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $a8fd543b6edfc9fe$export$9a0f755fd4f79434 extends (0, $7W3pH.IEvents) {
    constructor(s){
        super();
    }
}
class $a8fd543b6edfc9fe$export$a7f17ba6c54777e7 {
    constructor(s, t, e, f){
        this.core = s, this.logger = t, this.name = e;
    }
}
class $a8fd543b6edfc9fe$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $a8fd543b6edfc9fe$export$300eed987e764b57 extends (0, $7W3pH.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $a8fd543b6edfc9fe$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $a8fd543b6edfc9fe$export$41aaa3c39f6f2861 extends (0, $7W3pH.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $a8fd543b6edfc9fe$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $a8fd543b6edfc9fe$export$873b0b865d85ddb6 {
    constructor(s, t, e){
        this.core = s, this.logger = t, this.store = e;
    }
}
class $a8fd543b6edfc9fe$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $a8fd543b6edfc9fe$export$4264a8ec567679e5 {
    constructor(s, t, e){
        this.core = s, this.logger = t, this.telemetryEnabled = e;
    }
}
class $a8fd543b6edfc9fe$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($jMGWz))) {
    constructor(){
        super();
    }
}
class $a8fd543b6edfc9fe$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $a8fd543b6edfc9fe$export$623dd0f793f15643 extends (0, $jMGWz.EventEmitter) {
    constructor(){
        super();
    }
}
class $a8fd543b6edfc9fe$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}

});

parcelRegister("kUdYz", function(module, exports) {

$parcel$export(module.exports, "JsonRpcProvider", function () { return $f383e0f5ec32b538$export$da28308012bf6748; });

var $jMGWz = parcelRequire("jMGWz");
parcelRequire("6bXmq");
var $eS6BO = parcelRequire("eS6BO");
var $61dpN = parcelRequire("61dpN");
var $bNBqy = parcelRequire("bNBqy");
class $f383e0f5ec32b538$export$da28308012bf6748 extends (0, $61dpN.IJsonRpcProvider) {
    constructor(t){
        super(t), this.events = new (0, $jMGWz.EventEmitter), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(t), this.connection.connected && this.registerEventListeners();
    }
    async connect(t = this.connection) {
        await this.open(t);
    }
    async disconnect() {
        await this.close();
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async request(t, e) {
        return this.requestStrict((0, $eS6BO.formatJsonRpcRequest)(t.method, t.params || [], t.id || (0, $eS6BO.getBigIntRpcId)().toString()), e);
    }
    async requestStrict(t, e) {
        return new Promise(async (i, s)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (n) {
                s(n);
            }
            this.events.on(`${t.id}`, (n)=>{
                (0, $bNBqy.isJsonRpcError)(n) ? s(n.error) : i(n.result);
            });
            try {
                await this.connection.send(t, e);
            } catch (n) {
                s(n);
            }
        });
    }
    setConnection(t = this.connection) {
        return t;
    }
    onPayload(t) {
        this.events.emit("payload", t), (0, $bNBqy.isJsonRpcResponse)(t) ? this.events.emit(`${t.id}`, t) : this.events.emit("message", {
            type: t.method,
            data: t.params
        });
    }
    onClose(t) {
        t && t.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${t.code} ${t.reason ? `(${t.reason})` : ""}`)), this.events.emit("disconnect");
    }
    async open(t = this.connection) {
        this.connection === t && this.connection.connected || (this.connection.connected && this.close(), typeof t == "string" && (await this.connection.open(t), t = this.connection), this.connection = this.setConnection(t), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        this.hasRegisteredEventListeners || (this.connection.on("payload", (t)=>this.onPayload(t)), this.connection.on("close", (t)=>this.onClose(t)), this.connection.on("error", (t)=>this.events.emit("error", t)), this.connection.on("register_error", (t)=>this.onClose()), this.hasRegisteredEventListeners = !0);
    }
}

});
parcelRegister("6bXmq", function(module, exports) {
$parcel$export(module.exports, "parseConnectionError", function () { return (parcelRequire("14MEn")).parseConnectionError; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return (parcelRequire("cB0SO")).formatJsonRpcError; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return (parcelRequire("cB0SO")).formatJsonRpcRequest; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return (parcelRequire("cB0SO")).formatJsonRpcResult; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return (parcelRequire("cB0SO")).getBigIntRpcId; });
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("cB0SO")).IJsonRpcProvider; });
$parcel$export(module.exports, "isHttpUrl", function () { return (parcelRequire("cB0SO")).isHttpUrl; });
$parcel$export(module.exports, "isJsonRpcError", function () { return (parcelRequire("cB0SO")).isJsonRpcError; });
$parcel$export(module.exports, "isJsonRpcRequest", function () { return (parcelRequire("cB0SO")).isJsonRpcRequest; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return (parcelRequire("cB0SO")).isJsonRpcResponse; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return (parcelRequire("cB0SO")).isJsonRpcResult; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return (parcelRequire("cB0SO")).isLocalhostUrl; });
$parcel$export(module.exports, "isReactNative", function () { return (parcelRequire("cB0SO")).isReactNative; });
$parcel$export(module.exports, "isWsUrl", function () { return (parcelRequire("cB0SO")).isWsUrl; });
$parcel$export(module.exports, "parseConnectionError", function () { return (parcelRequire("cB0SO")).parseConnectionError; });
$parcel$export(module.exports, "payloadId", function () { return (parcelRequire("cB0SO")).payloadId; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return (parcelRequire("eS6BO")).formatJsonRpcError; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return (parcelRequire("eS6BO")).formatJsonRpcRequest; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return (parcelRequire("eS6BO")).formatJsonRpcResult; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return (parcelRequire("eS6BO")).getBigIntRpcId; });
$parcel$export(module.exports, "payloadId", function () { return (parcelRequire("eS6BO")).payloadId; });
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("61dpN")).IJsonRpcProvider; });
$parcel$export(module.exports, "isHttpUrl", function () { return (parcelRequire("cKs3B")).isHttpUrl; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return (parcelRequire("cKs3B")).isLocalhostUrl; });
$parcel$export(module.exports, "isWsUrl", function () { return (parcelRequire("cKs3B")).isWsUrl; });
$parcel$export(module.exports, "isJsonRpcError", function () { return (parcelRequire("bNBqy")).isJsonRpcError; });
$parcel$export(module.exports, "isJsonRpcRequest", function () { return (parcelRequire("bNBqy")).isJsonRpcRequest; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return (parcelRequire("bNBqy")).isJsonRpcResponse; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return (parcelRequire("bNBqy")).isJsonRpcResult; });
parcelRequire("hnQdz");
parcelRequire("14MEn");
parcelRequire("iJL02");
parcelRequire("eS6BO");
parcelRequire("kk0T0");
parcelRequire("6xS6I");
parcelRequire("cKs3B");
parcelRequire("bNBqy");

});
parcelRegister("hnQdz", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_ERROR", function () { return $ca7d170c591f9726$export$f6e3abf3038d348f; });
$parcel$export(module.exports, "SERVER_ERROR", function () { return $ca7d170c591f9726$export$125ebd30471ac25c; });
$parcel$export(module.exports, "RESERVED_ERROR_CODES", function () { return $ca7d170c591f9726$export$af84821b5448ca78; });
$parcel$export(module.exports, "SERVER_ERROR_CODE_RANGE", function () { return $ca7d170c591f9726$export$fff5b44b15c75f69; });
$parcel$export(module.exports, "STANDARD_ERROR_MAP", function () { return $ca7d170c591f9726$export$cca5387ab287e1ae; });
$parcel$export(module.exports, "DEFAULT_ERROR", function () { return $ca7d170c591f9726$export$d166979eca925bce; });
const $ca7d170c591f9726$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $ca7d170c591f9726$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $ca7d170c591f9726$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $ca7d170c591f9726$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $ca7d170c591f9726$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $ca7d170c591f9726$export$125ebd30471ac25c = "SERVER_ERROR";
const $ca7d170c591f9726$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $ca7d170c591f9726$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $ca7d170c591f9726$export$cca5387ab287e1ae = {
    [$ca7d170c591f9726$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$ca7d170c591f9726$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$ca7d170c591f9726$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$ca7d170c591f9726$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$ca7d170c591f9726$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$ca7d170c591f9726$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $ca7d170c591f9726$export$d166979eca925bce = $ca7d170c591f9726$export$125ebd30471ac25c;

});

parcelRegister("14MEn", function(module, exports) {

$parcel$export(module.exports, "isReservedErrorCode", function () { return $0c8be710800fa982$export$2ae0ec6393ab16c3; });
$parcel$export(module.exports, "getError", function () { return $0c8be710800fa982$export$e1599abf47b5b568; });
$parcel$export(module.exports, "getErrorByCode", function () { return $0c8be710800fa982$export$60a3bac005957e12; });
$parcel$export(module.exports, "parseConnectionError", function () { return $0c8be710800fa982$export$f555d7d8f922e407; });

var $hnQdz = parcelRequire("hnQdz");
function $0c8be710800fa982$export$e463129eb4bc487f(code) {
    return code <= (0, $hnQdz.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, $hnQdz.SERVER_ERROR_CODE_RANGE)[1];
}
function $0c8be710800fa982$export$2ae0ec6393ab16c3(code) {
    return (0, $hnQdz.RESERVED_ERROR_CODES).includes(code);
}
function $0c8be710800fa982$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $0c8be710800fa982$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $hnQdz.STANDARD_ERROR_MAP)).includes(type)) return (0, $hnQdz.STANDARD_ERROR_MAP)[0, $hnQdz.DEFAULT_ERROR];
    return (0, $hnQdz.STANDARD_ERROR_MAP)[type];
}
function $0c8be710800fa982$export$60a3bac005957e12(code) {
    const match = Object.values((0, $hnQdz.STANDARD_ERROR_MAP)).find((e)=>e.code === code);
    if (!match) return (0, $hnQdz.STANDARD_ERROR_MAP)[0, $hnQdz.DEFAULT_ERROR];
    return match;
}
function $0c8be710800fa982$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$0c8be710800fa982$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($0c8be710800fa982$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $0c8be710800fa982$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $hnQdz.STANDARD_ERROR_MAP)[0, $hnQdz.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $0c8be710800fa982$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}

});

parcelRegister("iJL02", function(module, exports) {

var $cB0SO = parcelRequire("cB0SO");
const $03852cf40730cb5c$export$d1694901a048d7c8 = (0, $cB0SO.isNode);
$parcel$exportWildcard(module.exports, $cB0SO);

});
parcelRegister("cB0SO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $nLPsB = parcelRequire("nLPsB");

$nLPsB.__exportStar((parcelRequire("33jHJ")), module.exports);

$nLPsB.__exportStar((parcelRequire("hceYF")), module.exports);

});
parcelRegister("33jHJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $2390efc614f7f1d6$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $2390efc614f7f1d6$var$getBrowerCrypto;
function $2390efc614f7f1d6$var$getSubtleCrypto() {
    const browserCrypto = $2390efc614f7f1d6$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $2390efc614f7f1d6$var$getSubtleCrypto;
function $2390efc614f7f1d6$var$isBrowserCryptoAvailable() {
    return !!$2390efc614f7f1d6$var$getBrowerCrypto() && !!$2390efc614f7f1d6$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $2390efc614f7f1d6$var$isBrowserCryptoAvailable;

});

parcelRegister("hceYF", function(module, exports) {

var $eSBMZ = parcelRequire("eSBMZ");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $c84f2ce541ebb5c1$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $c84f2ce541ebb5c1$var$isReactNative;
function $c84f2ce541ebb5c1$var$isNode() {
    return typeof $eSBMZ !== "undefined" && typeof $eSBMZ.versions !== "undefined" && typeof $eSBMZ.versions.node !== "undefined";
}
module.exports.isNode = $c84f2ce541ebb5c1$var$isNode;
function $c84f2ce541ebb5c1$var$isBrowser() {
    return !$c84f2ce541ebb5c1$var$isReactNative() && !$c84f2ce541ebb5c1$var$isNode();
}
module.exports.isBrowser = $c84f2ce541ebb5c1$var$isBrowser;

});



parcelRegister("eS6BO", function(module, exports) {

$parcel$export(module.exports, "payloadId", function () { return $ad3b3c3bc9aa9ad3$export$2f5364a5d4b80251; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return $ad3b3c3bc9aa9ad3$export$799a3db5df197877; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return $ad3b3c3bc9aa9ad3$export$11d081ebb32d4398; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return $ad3b3c3bc9aa9ad3$export$478fdea01c2a3198; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return $ad3b3c3bc9aa9ad3$export$9f7302ae26c3f77; });

var $14MEn = parcelRequire("14MEn");

var $hnQdz = parcelRequire("hnQdz");
function $ad3b3c3bc9aa9ad3$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $ad3b3c3bc9aa9ad3$export$799a3db5df197877(entropy = 6) {
    return BigInt($ad3b3c3bc9aa9ad3$export$2f5364a5d4b80251(entropy));
}
function $ad3b3c3bc9aa9ad3$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $ad3b3c3bc9aa9ad3$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $ad3b3c3bc9aa9ad3$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $ad3b3c3bc9aa9ad3$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $ad3b3c3bc9aa9ad3$export$5201d50a34753d71(error, data)
    };
}
function $ad3b3c3bc9aa9ad3$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $14MEn.getError)((0, $hnQdz.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $14MEn.getError)((0, $hnQdz.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $14MEn.isReservedErrorCode)(error.code)) error = (0, $14MEn.getErrorByCode)(error.code);
    return error;
}

});

parcelRegister("kk0T0", function(module, exports) {
function $ecb65ce4e0b7ce65$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $ecb65ce4e0b7ce65$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $ecb65ce4e0b7ce65$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $ecb65ce4e0b7ce65$export$8e8b9bea55b56df2(route) {
    if ($ecb65ce4e0b7ce65$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $ecb65ce4e0b7ce65$export$2d48faaafcc8fbdc(route) {
    return !$ecb65ce4e0b7ce65$export$c7e2040809cad2c4(route) && $ecb65ce4e0b7ce65$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $ecb65ce4e0b7ce65$export$be298a4710fab756(route) {
    return !$ecb65ce4e0b7ce65$export$c7e2040809cad2c4(route) && $ecb65ce4e0b7ce65$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}

});

parcelRegister("6xS6I", function(module, exports) {
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("61dpN")).IJsonRpcProvider; });
parcelRequire("61dpN");

});
parcelRegister("61dpN", function(module, exports) {

$parcel$export(module.exports, "IJsonRpcProvider", function () { return $461d3e0aedf8435f$export$46957420a688a16d; });
class $461d3e0aedf8435f$export$ab429ec7e240e546 {
}
class $461d3e0aedf8435f$export$77d426dd89724fbe extends $461d3e0aedf8435f$export$ab429ec7e240e546 {
    constructor(c){
        super();
    }
}
class $461d3e0aedf8435f$export$cb916a2eed49af33 extends $461d3e0aedf8435f$export$ab429ec7e240e546 {
    constructor(){
        super();
    }
}
class $461d3e0aedf8435f$export$46957420a688a16d extends $461d3e0aedf8435f$export$cb916a2eed49af33 {
    constructor(c){
        super();
    }
}

});


parcelRegister("cKs3B", function(module, exports) {

$parcel$export(module.exports, "isHttpUrl", function () { return $947f8b775dd64603$export$206c3129b8bb1b4f; });
$parcel$export(module.exports, "isWsUrl", function () { return $947f8b775dd64603$export$4e4463e75eccf20c; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return $947f8b775dd64603$export$8eb4a0a481601f29; });
const $947f8b775dd64603$var$HTTP_REGEX = "^https?:";
const $947f8b775dd64603$var$WS_REGEX = "^wss?:";
function $947f8b775dd64603$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $947f8b775dd64603$var$matchRegexProtocol(url, regex) {
    const protocol = $947f8b775dd64603$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $947f8b775dd64603$export$206c3129b8bb1b4f(url) {
    return $947f8b775dd64603$var$matchRegexProtocol(url, $947f8b775dd64603$var$HTTP_REGEX);
}
function $947f8b775dd64603$export$4e4463e75eccf20c(url) {
    return $947f8b775dd64603$var$matchRegexProtocol(url, $947f8b775dd64603$var$WS_REGEX);
}
function $947f8b775dd64603$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

});

parcelRegister("bNBqy", function(module, exports) {

$parcel$export(module.exports, "isJsonRpcRequest", function () { return $89714d9dab22b7c6$export$f6e4034abe07d2a5; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return $89714d9dab22b7c6$export$308ba927de2bcbe8; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return $89714d9dab22b7c6$export$cb3d3b20e3223d77; });
$parcel$export(module.exports, "isJsonRpcError", function () { return $89714d9dab22b7c6$export$5662a1047b4d1d15; });
function $89714d9dab22b7c6$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $89714d9dab22b7c6$export$f6e4034abe07d2a5(payload) {
    return $89714d9dab22b7c6$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $89714d9dab22b7c6$export$308ba927de2bcbe8(payload) {
    return $89714d9dab22b7c6$export$bf3617e9fafa893f(payload) && ($89714d9dab22b7c6$export$cb3d3b20e3223d77(payload) || $89714d9dab22b7c6$export$5662a1047b4d1d15(payload));
}
function $89714d9dab22b7c6$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $89714d9dab22b7c6$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $89714d9dab22b7c6$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}

});



parcelRegister("5u48b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fe2f56d96f50034$export$ea0df116fa892998; });

var $jMGWz = parcelRequire("jMGWz");

var $6mXg5 = parcelRequire("6mXg5");
parcelRequire("6bXmq");
var $eS6BO = parcelRequire("eS6BO");
var $cKs3B = parcelRequire("cKs3B");
var $cB0SO = parcelRequire("cB0SO");
var $14MEn = parcelRequire("14MEn");

const $3fe2f56d96f50034$var$w = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("65XB5")), $3fe2f56d96f50034$var$b = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $3fe2f56d96f50034$var$a = (c)=>c.split("?")[0], $3fe2f56d96f50034$var$h = 10, $3fe2f56d96f50034$var$S = $3fe2f56d96f50034$var$w();
class $3fe2f56d96f50034$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $jMGWz.EventEmitter), this.registering = !1, !(0, $cKs3B.isWsUrl)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $6mXg5.safeJsonStringify)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $cKs3B.isWsUrl)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, o)=>{
                this.events.once("register_error", (s)=>{
                    this.resetMaxListeners(), o(s);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return o(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const o = new URLSearchParams(e).get("origin"), s = (0, $cB0SO.isReactNative)() ? {
                headers: {
                    origin: o
                }
            } : {
                rejectUnauthorized: !(0, $cKs3B.isLocalhostUrl)(e)
            }, i = new $3fe2f56d96f50034$var$S(e, [], s);
            $3fe2f56d96f50034$var$b() ? i.onerror = (r)=>{
                const l = r;
                n(this.emitError(l.error));
            } : i.on("error", (r)=>{
                n(this.emitError(r));
            }), i.onopen = ()=>{
                this.onOpen(i), t(i);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $6mXg5.safeJsonParse)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), o = n.message || n.toString(), s = (0, $eS6BO.formatJsonRpcError)(e, o);
        this.events.emit("payload", s);
    }
    parseError(e, t = this.url) {
        return (0, $14MEn.parseConnectionError)(e, $3fe2f56d96f50034$var$a(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $3fe2f56d96f50034$var$h && this.events.setMaxListeners($3fe2f56d96f50034$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$3fe2f56d96f50034$var$a(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}

});
parcelRegister("65XB5", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});


parcelRegister("42iJY", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});



parcelRegister("3KLgK", function(module, exports) {

$parcel$export(module.exports, "HttpConnection", function () { return $2bba559ea61508f5$export$13c1f9cf8a283575; });
$parcel$export(module.exports, "default", function () { return $2bba559ea61508f5$export$13c1f9cf8a283575; });

var $jMGWz = parcelRequire("jMGWz");

var $ht43S = parcelRequire("ht43S");

var $6mXg5 = parcelRequire("6mXg5");
parcelRequire("6bXmq");
var $eS6BO = parcelRequire("eS6BO");
var $cKs3B = parcelRequire("cKs3B");
var $14MEn = parcelRequire("14MEn");
var $2bba559ea61508f5$var$P = Object.defineProperty, $2bba559ea61508f5$var$w = Object.defineProperties, $2bba559ea61508f5$var$E = Object.getOwnPropertyDescriptors, $2bba559ea61508f5$var$c = Object.getOwnPropertySymbols, $2bba559ea61508f5$var$L = Object.prototype.hasOwnProperty, $2bba559ea61508f5$var$O = Object.prototype.propertyIsEnumerable, $2bba559ea61508f5$var$l = (r, t, e)=>t in r ? $2bba559ea61508f5$var$P(r, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[t] = e, $2bba559ea61508f5$var$p = (r, t)=>{
    for(var e in t || (t = {}))$2bba559ea61508f5$var$L.call(t, e) && $2bba559ea61508f5$var$l(r, e, t[e]);
    if ($2bba559ea61508f5$var$c) for (var e of $2bba559ea61508f5$var$c(t))$2bba559ea61508f5$var$O.call(t, e) && $2bba559ea61508f5$var$l(r, e, t[e]);
    return r;
}, $2bba559ea61508f5$var$v = (r, t)=>$2bba559ea61508f5$var$w(r, $2bba559ea61508f5$var$E(t));
const $2bba559ea61508f5$var$j = {
    Accept: "application/json",
    "Content-Type": "application/json"
}, $2bba559ea61508f5$var$T = "POST", $2bba559ea61508f5$var$d = {
    headers: $2bba559ea61508f5$var$j,
    method: $2bba559ea61508f5$var$T
}, $2bba559ea61508f5$var$g = 10;
class $2bba559ea61508f5$export$13c1f9cf8a283575 {
    constructor(t, e = !1){
        if (this.url = t, this.disableProviderPing = e, this.events = new (0, $jMGWz.EventEmitter), this.isAvailable = !1, this.registering = !1, !(0, $cKs3B.isHttpUrl)(t)) throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);
        this.url = t, this.disableProviderPing = e;
    }
    get connected() {
        return this.isAvailable;
    }
    get connecting() {
        return this.registering;
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async open(t = this.url) {
        await this.register(t);
    }
    async close() {
        if (!this.isAvailable) throw new Error("Connection already closed");
        this.onClose();
    }
    async send(t) {
        this.isAvailable || await this.register();
        try {
            const e = (0, $6mXg5.safeJsonStringify)(t), s = await (await (0, (/*@__PURE__*/$parcel$interopDefault($ht43S)))(this.url, $2bba559ea61508f5$var$v($2bba559ea61508f5$var$p({}, $2bba559ea61508f5$var$d), {
                body: e
            }))).json();
            this.onPayload({
                data: s
            });
        } catch (e) {
            this.onError(t.id, e);
        }
    }
    async register(t = this.url) {
        if (!(0, $cKs3B.isHttpUrl)(t)) throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);
        if (this.registering) {
            const e = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= e || this.events.listenerCount("open") >= e) && this.events.setMaxListeners(e + 1), new Promise((s, i)=>{
                this.events.once("register_error", (n)=>{
                    this.resetMaxListeners(), i(n);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.isAvailable > "u") return i(new Error("HTTP connection is missing or invalid"));
                    s();
                });
            });
        }
        this.url = t, this.registering = !0;
        try {
            if (!this.disableProviderPing) {
                const e = (0, $6mXg5.safeJsonStringify)({
                    id: 1,
                    jsonrpc: "2.0",
                    method: "test",
                    params: []
                });
                await (0, (/*@__PURE__*/$parcel$interopDefault($ht43S)))(t, $2bba559ea61508f5$var$v($2bba559ea61508f5$var$p({}, $2bba559ea61508f5$var$d), {
                    body: e
                }));
            }
            this.onOpen();
        } catch (e) {
            const s = this.parseError(e);
            throw this.events.emit("register_error", s), this.onClose(), s;
        }
    }
    onOpen() {
        this.isAvailable = !0, this.registering = !1, this.events.emit("open");
    }
    onClose() {
        this.isAvailable = !1, this.registering = !1, this.events.emit("close");
    }
    onPayload(t) {
        if (typeof t.data > "u") return;
        const e = typeof t.data == "string" ? (0, $6mXg5.safeJsonParse)(t.data) : t.data;
        this.events.emit("payload", e);
    }
    onError(t, e) {
        const s = this.parseError(e), i = s.message || s.toString(), n = (0, $eS6BO.formatJsonRpcError)(t, i);
        this.events.emit("payload", n);
    }
    parseError(t, e = this.url) {
        return (0, $14MEn.parseConnectionError)(t, e, "HTTP");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $2bba559ea61508f5$var$g && this.events.setMaxListeners($2bba559ea61508f5$var$g);
    }
}

});
parcelRegister("ht43S", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});



parcelRegister("dK4kP", function(module, exports) {


module.exports = (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("6jSKq")).then(()=>parcelRequire("9QZPR"));

});


parcelRegister("gzjWc", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $c0ff616b7a46365c$export$a490eb03cb7a0a5e; });

var $jjAo8 = parcelRequire("jjAo8");
let $c0ff616b7a46365c$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = "", docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? "https://viem.sh"}${docsPath}${docsSlug ? `#${docsSlug}` : ""}` : undefined,
    version: $jjAo8.version
};
function $c0ff616b7a46365c$export$4ac109df0c5244e9(config) {
    $c0ff616b7a46365c$var$errorConfig = config;
}
class $c0ff616b7a46365c$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $c0ff616b7a46365c$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $c0ff616b7a46365c$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $c0ff616b7a46365c$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$c0ff616b7a46365c$var$errorConfig.version ? [
                `Version: ${$c0ff616b7a46365c$var$errorConfig.version}`
            ] : []
        ].join("\n");
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $jjAo8.version);
    }
    walk(fn) {
        return $c0ff616b7a46365c$var$walk(this, fn);
    }
}
function $c0ff616b7a46365c$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err) return $c0ff616b7a46365c$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("jjAo8", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e0fc049adc9ac953$export$83d89fbfd8236492; });
const $e0fc049adc9ac953$export$83d89fbfd8236492 = "2.21.0";

});


parcelRegister("c9lDF", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", function () { return $8d871c54c4b3df8b$export$66c44d927ffead98; });

var $gzjWc = parcelRequire("gzjWc");
class $8d871c54c4b3df8b$export$66c44d927ffead98 extends (0, $gzjWc.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                "- Address must be a hex value of 20 bytes (40 hex characters).",
                "- Address must match its checksum counterpart."
            ],
            name: "InvalidAddressError"
        });
    }
}

});

parcelRegister("2ZAyo", function(module, exports) {

$parcel$export(module.exports, "isHex", function () { return $22dda21b0308f5c2$export$8a9b6341a7c96bc; });
function $22dda21b0308f5c2$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});

parcelRegister("9BL5M", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $6fec194eaf765830$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $6fec194eaf765830$export$b3317979f9250576; });
$parcel$export(module.exports, "hash", function () { return $6fec194eaf765830$export$d6af199866bfb566; });
$parcel$export(module.exports, "exists", function () { return $6fec194eaf765830$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $6fec194eaf765830$export$c789db2c85949867; });
function $6fec194eaf765830$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $6fec194eaf765830$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
function $6fec194eaf765830$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $6fec194eaf765830$export$b3317979f9250576(b, ...lengths) {
    if (!$6fec194eaf765830$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $6fec194eaf765830$export$d6af199866bfb566(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $6fec194eaf765830$export$98e628dec113755e(h.outputLen);
    $6fec194eaf765830$export$98e628dec113755e(h.blockLen);
}
function $6fec194eaf765830$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $6fec194eaf765830$export$c789db2c85949867(out, instance) {
    $6fec194eaf765830$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $6fec194eaf765830$var$assert = {
    number: $6fec194eaf765830$export$98e628dec113755e,
    bool: $6fec194eaf765830$export$87b259aa03e3d267,
    bytes: $6fec194eaf765830$export$b3317979f9250576,
    hash: $6fec194eaf765830$export$d6af199866bfb566,
    exists: $6fec194eaf765830$export$f7e9f41ea797a17,
    output: $6fec194eaf765830$export$c789db2c85949867
};
var $6fec194eaf765830$export$2e2bcd8739ae039 = $6fec194eaf765830$var$assert;

});

parcelRegister("jKNV0", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $e61908f4e02c8ab9$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $e61908f4e02c8ab9$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $e61908f4e02c8ab9$export$466993d7d0d272aa; });
$parcel$export(module.exports, "isLE", function () { return $e61908f4e02c8ab9$export$a0f88e38d4cf9577; });
$parcel$export(module.exports, "byteSwap32", function () { return $e61908f4e02c8ab9$export$97b40fc37f25d711; });
$parcel$export(module.exports, "toBytes", function () { return $e61908f4e02c8ab9$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $e61908f4e02c8ab9$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $e61908f4e02c8ab9$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $e61908f4e02c8ab9$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $e61908f4e02c8ab9$export$e18964dbd6e083c1; });
$parcel$export(module.exports, "randomBytes", function () { return $e61908f4e02c8ab9$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $h9KpM = parcelRequire("h9KpM");

var $9BL5M = parcelRequire("9BL5M");
function $e61908f4e02c8ab9$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
const $e61908f4e02c8ab9$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $e61908f4e02c8ab9$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $e61908f4e02c8ab9$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $e61908f4e02c8ab9$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $e61908f4e02c8ab9$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $e61908f4e02c8ab9$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $e61908f4e02c8ab9$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $e61908f4e02c8ab9$export$4a0a88cc2d284e7f = $e61908f4e02c8ab9$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$e61908f4e02c8ab9$export$a4170f7f8be47425(n);
function $e61908f4e02c8ab9$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $e61908f4e02c8ab9$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $e61908f4e02c8ab9$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $e61908f4e02c8ab9$export$58b867e287a802c8(bytes) {
    (0, $9BL5M.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $e61908f4e02c8ab9$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $e61908f4e02c8ab9$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $e61908f4e02c8ab9$var$asciiToBase16(char) {
    if (char >= $e61908f4e02c8ab9$var$asciis._0 && char <= $e61908f4e02c8ab9$var$asciis._9) return char - $e61908f4e02c8ab9$var$asciis._0;
    if (char >= $e61908f4e02c8ab9$var$asciis._A && char <= $e61908f4e02c8ab9$var$asciis._F) return char - ($e61908f4e02c8ab9$var$asciis._A - 10);
    if (char >= $e61908f4e02c8ab9$var$asciis._a && char <= $e61908f4e02c8ab9$var$asciis._f) return char - ($e61908f4e02c8ab9$var$asciis._a - 10);
    return;
}
function $e61908f4e02c8ab9$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $e61908f4e02c8ab9$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $e61908f4e02c8ab9$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $e61908f4e02c8ab9$export$bdd553fddd433dcb = async ()=>{};
async function $e61908f4e02c8ab9$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $e61908f4e02c8ab9$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $e61908f4e02c8ab9$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $e61908f4e02c8ab9$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $e61908f4e02c8ab9$export$3df70a15530b5e81(data);
    (0, $9BL5M.bytes)(data);
    return data;
}
function $e61908f4e02c8ab9$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $9BL5M.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $e61908f4e02c8ab9$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $e61908f4e02c8ab9$var$toStr = {}.toString;
function $e61908f4e02c8ab9$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $e61908f4e02c8ab9$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $e61908f4e02c8ab9$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($e61908f4e02c8ab9$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $e61908f4e02c8ab9$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($e61908f4e02c8ab9$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $e61908f4e02c8ab9$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($e61908f4e02c8ab9$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $e61908f4e02c8ab9$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $h9KpM.crypto) && typeof (0, $h9KpM.crypto).getRandomValues === "function") return (0, $h9KpM.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("h9KpM", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $c7d747ecb5be4fa8$export$7effb53edfc7fa2d; });
const $c7d747ecb5be4fa8$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});


parcelRegister("ca1JH", function(module, exports) {

$parcel$export(module.exports, "isAddress", function () { return $8da7c3f8379b4513$export$977e255126d763d6; });

var $8wRaD = parcelRequire("8wRaD");

var $9vguw = parcelRequire("9vguw");
const $8da7c3f8379b4513$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $8da7c3f8379b4513$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $8wRaD.LruMap)(8192);
function $8da7c3f8379b4513$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($8da7c3f8379b4513$export$ef83598cc5072ce.has(cacheKey)) return $8da7c3f8379b4513$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$8da7c3f8379b4513$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $9vguw.checksumAddress)(address) === address;
        return true;
    })();
    $8da7c3f8379b4513$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});
parcelRegister("8wRaD", function(module, exports) {

$parcel$export(module.exports, "LruMap", function () { return $635a8e6d5c028dfa$export$fcb3b6cad79d7e3a; });
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $635a8e6d5c028dfa$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) this.delete(this.keys().next().value);
        return this;
    }
}

});

parcelRegister("9vguw", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", function () { return $6eb3cd2300754856$export$9ff46e8f6df13548; });
$parcel$export(module.exports, "getAddress", function () { return $6eb3cd2300754856$export$88411125f012957a; });

var $c9lDF = parcelRequire("c9lDF");

var $2JRke = parcelRequire("2JRke");

var $iffkR = parcelRequire("iffkR");

var $8wRaD = parcelRequire("8wRaD");

var $ca1JH = parcelRequire("ca1JH");
const $6eb3cd2300754856$var$checksumAddressCache = /*#__PURE__*/ new (0, $8wRaD.LruMap)(8192);
function $6eb3cd2300754856$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($6eb3cd2300754856$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $6eb3cd2300754856$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $iffkR.keccak256)((0, $2JRke.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join("")}`;
    $6eb3cd2300754856$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $6eb3cd2300754856$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $ca1JH.isAddress)(address, {
        strict: false
    })) throw new (0, $c9lDF.InvalidAddressError)({
        address: address
    });
    return $6eb3cd2300754856$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("2JRke", function(module, exports) {

$parcel$export(module.exports, "toBytes", function () { return $1fe9260c53fcc64f$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "hexToBytes", function () { return $1fe9260c53fcc64f$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "stringToBytes", function () { return $1fe9260c53fcc64f$export$c8dd6bc66a63753c; });

var $gzjWc = parcelRequire("gzjWc");

var $2ZAyo = parcelRequire("2ZAyo");

var $9m6jZ = parcelRequire("9m6jZ");

var $dZgT6 = parcelRequire("dZgT6");

var $8syAN = parcelRequire("8syAN");
const $1fe9260c53fcc64f$var$encoder = /*#__PURE__*/ new TextEncoder();
function $1fe9260c53fcc64f$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $1fe9260c53fcc64f$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $1fe9260c53fcc64f$export$771517697a68241(value, opts);
    if ((0, $2ZAyo.isHex)(value)) return $1fe9260c53fcc64f$export$31c96b9df38bc8d4(value, opts);
    return $1fe9260c53fcc64f$export$c8dd6bc66a63753c(value, opts);
}
function $1fe9260c53fcc64f$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $dZgT6.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $9m6jZ.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $1fe9260c53fcc64f$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $1fe9260c53fcc64f$var$charCodeToBase16(char) {
    if (char >= $1fe9260c53fcc64f$var$charCodeMap.zero && char <= $1fe9260c53fcc64f$var$charCodeMap.nine) return char - $1fe9260c53fcc64f$var$charCodeMap.zero;
    if (char >= $1fe9260c53fcc64f$var$charCodeMap.A && char <= $1fe9260c53fcc64f$var$charCodeMap.F) return char - ($1fe9260c53fcc64f$var$charCodeMap.A - 10);
    if (char >= $1fe9260c53fcc64f$var$charCodeMap.a && char <= $1fe9260c53fcc64f$var$charCodeMap.f) return char - ($1fe9260c53fcc64f$var$charCodeMap.a - 10);
    return undefined;
}
function $1fe9260c53fcc64f$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $dZgT6.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $9m6jZ.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $1fe9260c53fcc64f$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $1fe9260c53fcc64f$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $gzjWc.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $1fe9260c53fcc64f$export$49ad9be85c347998(value, opts) {
    const hex = (0, $8syAN.numberToHex)(value, opts);
    return $1fe9260c53fcc64f$export$31c96b9df38bc8d4(hex);
}
function $1fe9260c53fcc64f$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $1fe9260c53fcc64f$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $dZgT6.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $9m6jZ.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("9m6jZ", function(module, exports) {

$parcel$export(module.exports, "pad", function () { return $6cfb126a233acb7f$export$5d04458e2a6c373e; });
$parcel$export(module.exports, "padHex", function () { return $6cfb126a233acb7f$export$1bcd51c0fce8ee55; });

var $k4fDS = parcelRequire("k4fDS");
function $6cfb126a233acb7f$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $6cfb126a233acb7f$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $6cfb126a233acb7f$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $6cfb126a233acb7f$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $k4fDS.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $6cfb126a233acb7f$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $k4fDS.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("k4fDS", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", function () { return $e9c05094e34b742a$export$cfcd41bba8b36dbd; });
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", function () { return $e9c05094e34b742a$export$70445dc308a7f3d5; });
$parcel$export(module.exports, "InvalidBytesLengthError", function () { return $e9c05094e34b742a$export$8a5469becf223114; });

var $gzjWc = parcelRequire("gzjWc");
class $e9c05094e34b742a$export$cfcd41bba8b36dbd extends (0, $gzjWc.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $e9c05094e34b742a$export$70445dc308a7f3d5 extends (0, $gzjWc.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: "SizeExceedsPaddingSizeError"
        });
    }
}
class $e9c05094e34b742a$export$8a5469becf223114 extends (0, $gzjWc.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: "InvalidBytesLengthError"
        });
    }
}

});


parcelRegister("dZgT6", function(module, exports) {

$parcel$export(module.exports, "assertSize", function () { return $a2ee12697e4adc1c$export$2af489edb7fa35fe; });
$parcel$export(module.exports, "hexToNumber", function () { return $a2ee12697e4adc1c$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBigInt", function () { return $a2ee12697e4adc1c$export$92a44656ec81b584; });
$parcel$export(module.exports, "hexToString", function () { return $a2ee12697e4adc1c$export$f4bc7e46f3eb3ac3; });

var $g0DNu = parcelRequire("g0DNu");

var $1TQIz = parcelRequire("1TQIz");

var $54zaP = parcelRequire("54zaP");

var $2JRke = parcelRequire("2JRke");
function $a2ee12697e4adc1c$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $1TQIz.size)(hexOrBytes) > size) throw new (0, $g0DNu.SizeOverflowError)({
        givenSize: (0, $1TQIz.size)(hexOrBytes),
        maxSize: size
    });
}
function $a2ee12697e4adc1c$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $a2ee12697e4adc1c$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $a2ee12697e4adc1c$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $a2ee12697e4adc1c$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $a2ee12697e4adc1c$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $2JRke.hexToBytes)(hex, opts);
}
function $a2ee12697e4adc1c$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $a2ee12697e4adc1c$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $a2ee12697e4adc1c$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $a2ee12697e4adc1c$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $54zaP.trim)(hex);
    }
    if ((0, $54zaP.trim)(hex) === "0x00") return false;
    if ((0, $54zaP.trim)(hex) === "0x01") return true;
    throw new (0, $g0DNu.InvalidHexBooleanError)(hex);
}
function $a2ee12697e4adc1c$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($a2ee12697e4adc1c$export$92a44656ec81b584(hex, opts));
}
function $a2ee12697e4adc1c$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $2JRke.hexToBytes)(hex);
    if (opts.size) {
        $a2ee12697e4adc1c$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $54zaP.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("g0DNu", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", function () { return $ba7b845648f3cff6$export$47d164a8071229a9; });
$parcel$export(module.exports, "InvalidBytesBooleanError", function () { return $ba7b845648f3cff6$export$52fc62e5266c8838; });
$parcel$export(module.exports, "InvalidHexBooleanError", function () { return $ba7b845648f3cff6$export$f574ac54e35514c; });
$parcel$export(module.exports, "SizeOverflowError", function () { return $ba7b845648f3cff6$export$beb44ed4f8747d0e; });

var $gzjWc = parcelRequire("gzjWc");
class $ba7b845648f3cff6$export$47d164a8071229a9 extends (0, $gzjWc.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: "IntegerOutOfRangeError"
        });
    }
}
class $ba7b845648f3cff6$export$52fc62e5266c8838 extends (0, $gzjWc.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: "InvalidBytesBooleanError"
        });
    }
}
class $ba7b845648f3cff6$export$f574ac54e35514c extends (0, $gzjWc.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: "InvalidHexBooleanError"
        });
    }
}
class $ba7b845648f3cff6$export$ef05eafd11dd4a83 extends (0, $gzjWc.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: "InvalidHexValueError"
        });
    }
}
class $ba7b845648f3cff6$export$beb44ed4f8747d0e extends (0, $gzjWc.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: "SizeOverflowError"
        });
    }
}

});

parcelRegister("1TQIz", function(module, exports) {

$parcel$export(module.exports, "size", function () { return $1623d230bb3f4490$export$346677f925de839c; });

var $2ZAyo = parcelRequire("2ZAyo");
function $1623d230bb3f4490$export$346677f925de839c(value) {
    if ((0, $2ZAyo.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});

parcelRegister("54zaP", function(module, exports) {

$parcel$export(module.exports, "trim", function () { return $3b189c3bd1fc468c$export$87c2784dc9fc4ab; });
function $3b189c3bd1fc468c$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});


parcelRegister("8syAN", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $628bc5962501dbbd$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "numberToHex", function () { return $628bc5962501dbbd$export$4e87185b7ecfeec4; });
$parcel$export(module.exports, "stringToHex", function () { return $628bc5962501dbbd$export$551c48dea6f88e6d; });
$parcel$export(module.exports, "boolToHex", function () { return $628bc5962501dbbd$export$b5c95dec4f62ef7a; });
$parcel$export(module.exports, "bytesToHex", function () { return $628bc5962501dbbd$export$58b867e287a802c8; });

var $g0DNu = parcelRequire("g0DNu");

var $9m6jZ = parcelRequire("9m6jZ");

var $dZgT6 = parcelRequire("dZgT6");
const $628bc5962501dbbd$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $628bc5962501dbbd$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $628bc5962501dbbd$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $628bc5962501dbbd$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $628bc5962501dbbd$export$b5c95dec4f62ef7a(value, opts);
    return $628bc5962501dbbd$export$58b867e287a802c8(value, opts);
}
function $628bc5962501dbbd$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $dZgT6.assertSize)(hex, {
            size: opts.size
        });
        return (0, $9m6jZ.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $628bc5962501dbbd$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $628bc5962501dbbd$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $dZgT6.assertSize)(hex, {
            size: opts.size
        });
        return (0, $9m6jZ.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $628bc5962501dbbd$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $g0DNu.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $9m6jZ.pad)(hex, {
        size: size
    });
    return hex;
}
const $628bc5962501dbbd$var$encoder = /*#__PURE__*/ new TextEncoder();
function $628bc5962501dbbd$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $628bc5962501dbbd$var$encoder.encode(value_);
    return $628bc5962501dbbd$export$58b867e287a802c8(value, opts);
}

});


parcelRegister("iffkR", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $d4858608d330e575$export$f8151fce47ad1c35; });

var $5nH06 = parcelRequire("5nH06");

var $2ZAyo = parcelRequire("2ZAyo");

var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");
function $d4858608d330e575$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $5nH06.keccak_256)((0, $2ZAyo.isHex)(value, {
        strict: false
    }) ? (0, $2JRke.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $8syAN.toHex)(bytes);
}

});
parcelRegister("5nH06", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $3eb074c0fa088f70$export$860ddaa9ca84a66d; });

var $9BL5M = parcelRequire("9BL5M");

var $joXj6 = parcelRequire("joXj6");

var $jKNV0 = parcelRequire("jKNV0");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $3eb074c0fa088f70$var$SHA3_PI = [];
const $3eb074c0fa088f70$var$SHA3_ROTL = [];
const $3eb074c0fa088f70$var$_SHA3_IOTA = [];
const $3eb074c0fa088f70$var$_0n = /* @__PURE__ */ BigInt(0);
const $3eb074c0fa088f70$var$_1n = /* @__PURE__ */ BigInt(1);
const $3eb074c0fa088f70$var$_2n = /* @__PURE__ */ BigInt(2);
const $3eb074c0fa088f70$var$_7n = /* @__PURE__ */ BigInt(7);
const $3eb074c0fa088f70$var$_256n = /* @__PURE__ */ BigInt(256);
const $3eb074c0fa088f70$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $3eb074c0fa088f70$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $3eb074c0fa088f70$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $3eb074c0fa088f70$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $3eb074c0fa088f70$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $3eb074c0fa088f70$var$_1n ^ (R >> $3eb074c0fa088f70$var$_7n) * $3eb074c0fa088f70$var$_0x71n) % $3eb074c0fa088f70$var$_256n;
        if (R & $3eb074c0fa088f70$var$_2n) t ^= $3eb074c0fa088f70$var$_1n << ($3eb074c0fa088f70$var$_1n << /* @__PURE__ */ BigInt(j)) - $3eb074c0fa088f70$var$_1n;
    }
    $3eb074c0fa088f70$var$_SHA3_IOTA.push(t);
}
const [$3eb074c0fa088f70$var$SHA3_IOTA_H, $3eb074c0fa088f70$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $joXj6.split)($3eb074c0fa088f70$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $3eb074c0fa088f70$var$rotlH = (h, l, s)=>s > 32 ? (0, $joXj6.rotlBH)(h, l, s) : (0, $joXj6.rotlSH)(h, l, s);
const $3eb074c0fa088f70$var$rotlL = (h, l, s)=>s > 32 ? (0, $joXj6.rotlBL)(h, l, s) : (0, $joXj6.rotlSL)(h, l, s);
function $3eb074c0fa088f70$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $3eb074c0fa088f70$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $3eb074c0fa088f70$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $3eb074c0fa088f70$var$SHA3_ROTL[t];
            const Th = $3eb074c0fa088f70$var$rotlH(curH, curL, shift);
            const Tl = $3eb074c0fa088f70$var$rotlL(curH, curL, shift);
            const PI = $3eb074c0fa088f70$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $3eb074c0fa088f70$var$SHA3_IOTA_H[round];
        s[1] ^= $3eb074c0fa088f70$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $3eb074c0fa088f70$export$f7374b8b4498bc2e extends (0, $jKNV0.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $9BL5M.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $jKNV0.u32)(this.state);
    }
    keccak() {
        if (!(0, $jKNV0.isLE)) (0, $jKNV0.byteSwap32)(this.state32);
        $3eb074c0fa088f70$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $jKNV0.isLE)) (0, $jKNV0.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $9BL5M.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $jKNV0.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $9BL5M.exists)(this, false);
        (0, $9BL5M.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $9BL5M.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $9BL5M.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $3eb074c0fa088f70$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $3eb074c0fa088f70$var$gen = (suffix, blockLen, outputLen)=>(0, $jKNV0.wrapConstructor)(()=>new $3eb074c0fa088f70$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $3eb074c0fa088f70$export$fe6c2b96a79338e9 = /* @__PURE__ */ $3eb074c0fa088f70$var$gen(0x06, 144, 28);
const $3eb074c0fa088f70$export$76e19b6966813b14 = /* @__PURE__ */ $3eb074c0fa088f70$var$gen(0x06, 136, 32);
const $3eb074c0fa088f70$export$a58509fa80f30d15 = /* @__PURE__ */ $3eb074c0fa088f70$var$gen(0x06, 104, 48);
const $3eb074c0fa088f70$export$20ed324dbdf09b7c = /* @__PURE__ */ $3eb074c0fa088f70$var$gen(0x06, 72, 64);
const $3eb074c0fa088f70$export$2f7fb3c6fac246bc = /* @__PURE__ */ $3eb074c0fa088f70$var$gen(0x01, 144, 28);
const $3eb074c0fa088f70$export$860ddaa9ca84a66d = /* @__PURE__ */ $3eb074c0fa088f70$var$gen(0x01, 136, 32);
const $3eb074c0fa088f70$export$46fcdeb4c5686552 = /* @__PURE__ */ $3eb074c0fa088f70$var$gen(0x01, 104, 48);
const $3eb074c0fa088f70$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $3eb074c0fa088f70$var$gen(0x01, 72, 64);
const $3eb074c0fa088f70$var$genShake = (suffix, blockLen, outputLen)=>(0, $jKNV0.wrapXOFConstructorWithOpts)((opts = {})=>new $3eb074c0fa088f70$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $3eb074c0fa088f70$export$f43dc3bb86efbba2 = /* @__PURE__ */ $3eb074c0fa088f70$var$genShake(0x1f, 168, 16);
const $3eb074c0fa088f70$export$c240d011f1520440 = /* @__PURE__ */ $3eb074c0fa088f70$var$genShake(0x1f, 136, 32);

});
parcelRegister("joXj6", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $e1fe435a1ef8fdda$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $e1fe435a1ef8fdda$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $e1fe435a1ef8fdda$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $e1fe435a1ef8fdda$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $e1fe435a1ef8fdda$export$5d12cc1da441323f; });
const $e1fe435a1ef8fdda$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $e1fe435a1ef8fdda$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $e1fe435a1ef8fdda$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $e1fe435a1ef8fdda$var$U32_MASK64),
        l: Number(n >> $e1fe435a1ef8fdda$var$_32n & $e1fe435a1ef8fdda$var$U32_MASK64)
    };
    return {
        h: Number(n >> $e1fe435a1ef8fdda$var$_32n & $e1fe435a1ef8fdda$var$U32_MASK64) | 0,
        l: Number(n & $e1fe435a1ef8fdda$var$U32_MASK64) | 0
    };
}
function $e1fe435a1ef8fdda$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $e1fe435a1ef8fdda$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $e1fe435a1ef8fdda$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $e1fe435a1ef8fdda$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $e1fe435a1ef8fdda$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $e1fe435a1ef8fdda$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $e1fe435a1ef8fdda$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $e1fe435a1ef8fdda$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $e1fe435a1ef8fdda$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $e1fe435a1ef8fdda$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $e1fe435a1ef8fdda$export$a088d44bd387d2a3 = (_h, l)=>l;
const $e1fe435a1ef8fdda$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $e1fe435a1ef8fdda$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $e1fe435a1ef8fdda$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $e1fe435a1ef8fdda$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $e1fe435a1ef8fdda$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $e1fe435a1ef8fdda$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $e1fe435a1ef8fdda$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $e1fe435a1ef8fdda$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $e1fe435a1ef8fdda$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $e1fe435a1ef8fdda$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $e1fe435a1ef8fdda$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $e1fe435a1ef8fdda$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $e1fe435a1ef8fdda$var$u64 = {
    fromBig: $e1fe435a1ef8fdda$export$9625d4333cb56c3f,
    split: $e1fe435a1ef8fdda$export$65980d18b75784e2,
    toBig: $e1fe435a1ef8fdda$export$30f78adcaaa2eb7,
    shrSH: $e1fe435a1ef8fdda$export$75aa78dc5bd52853,
    shrSL: $e1fe435a1ef8fdda$export$a0225ff0aee14e25,
    rotrSH: $e1fe435a1ef8fdda$export$97f812dfd830ca87,
    rotrSL: $e1fe435a1ef8fdda$export$60987e30e2c9d9d,
    rotrBH: $e1fe435a1ef8fdda$export$af9c7fbac44dcb76,
    rotrBL: $e1fe435a1ef8fdda$export$f619171d6d5ac414,
    rotr32H: $e1fe435a1ef8fdda$export$a088d44bd387d2a3,
    rotr32L: $e1fe435a1ef8fdda$export$8415aae4d1f69577,
    rotlSH: $e1fe435a1ef8fdda$export$4b80a2917447870e,
    rotlSL: $e1fe435a1ef8fdda$export$20652918a7b63b3,
    rotlBH: $e1fe435a1ef8fdda$export$a52f14bf902f9977,
    rotlBL: $e1fe435a1ef8fdda$export$5d12cc1da441323f,
    add: $e1fe435a1ef8fdda$export$e16d8520af44a096,
    add3L: $e1fe435a1ef8fdda$export$c0c22b91f08911f,
    add3H: $e1fe435a1ef8fdda$export$ef7b26044977a8ec,
    add4L: $e1fe435a1ef8fdda$export$2f4e199c560f545d,
    add4H: $e1fe435a1ef8fdda$export$e909220d675a7741,
    add5H: $e1fe435a1ef8fdda$export$b45ee8d78c965098,
    add5L: $e1fe435a1ef8fdda$export$d732b061fe9c9ae4
};
var $e1fe435a1ef8fdda$export$2e2bcd8739ae039 = $e1fe435a1ef8fdda$var$u64;

});





parcelRegister("gUoDq", function(module, exports) {


module.exports = (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("8ROEP")).then(()=>parcelRequire("72jBF"));

});

parcelRegister("fwEJN", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $b4d971d7f9e5283c$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatHex", function () { return $b4d971d7f9e5283c$export$f6cc0b64b5a999af; });
function $b4d971d7f9e5283c$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $b4d971d7f9e5283c$export$f6cc0b64b5a999af(values);
    return $b4d971d7f9e5283c$export$287dd7971339c972(values);
}
function $b4d971d7f9e5283c$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $b4d971d7f9e5283c$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}

});

parcelRegister("aMZh2", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", function () { return $7dadeaca89d4fba8$export$715ba3385e9f2cf0; });
$parcel$export(module.exports, "RpcRequestError", function () { return $7dadeaca89d4fba8$export$a823590631c47261; });
$parcel$export(module.exports, "TimeoutError", function () { return $7dadeaca89d4fba8$export$66d311bf29d5c89c; });

var $6nOtb = parcelRequire("6nOtb");

var $gzjWc = parcelRequire("gzjWc");

var $4oCKZ = parcelRequire("4oCKZ");
class $7dadeaca89d4fba8$export$715ba3385e9f2cf0 extends (0, $gzjWc.BaseError) {
    constructor({ body: body, cause: cause, details: details, headers: headers, status: status, url: url }){
        super("HTTP request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${(0, $4oCKZ.getUrl)(url)}`,
                body && `Request body: ${(0, $6nOtb.stringify)(body)}`
            ].filter(Boolean),
            name: "HttpRequestError"
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class $7dadeaca89d4fba8$export$e1d72a3a26ed1bc extends (0, $gzjWc.BaseError) {
    constructor({ body: body, cause: cause, details: details, url: url }){
        super("WebSocket request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                `URL: ${(0, $4oCKZ.getUrl)(url)}`,
                body && `Request body: ${(0, $6nOtb.stringify)(body)}`
            ].filter(Boolean),
            name: "WebSocketRequestError"
        });
    }
}
class $7dadeaca89d4fba8$export$a823590631c47261 extends (0, $gzjWc.BaseError) {
    constructor({ body: body, error: error, url: url }){
        super("RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${(0, $4oCKZ.getUrl)(url)}`,
                `Request body: ${(0, $6nOtb.stringify)(body)}`
            ],
            name: "RpcRequestError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
    }
}
class $7dadeaca89d4fba8$export$a52f6cfb6f69ff4d extends (0, $gzjWc.BaseError) {
    constructor({ url: url } = {}){
        super("The socket has been closed.", {
            metaMessages: [
                url && `URL: ${(0, $4oCKZ.getUrl)(url)}`
            ].filter(Boolean),
            name: "SocketClosedError"
        });
    }
}
class $7dadeaca89d4fba8$export$66d311bf29d5c89c extends (0, $gzjWc.BaseError) {
    constructor({ body: body, url: url }){
        super("The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [
                `URL: ${(0, $4oCKZ.getUrl)(url)}`,
                `Request body: ${(0, $6nOtb.stringify)(body)}`
            ],
            name: "TimeoutError"
        });
    }
}

});
parcelRegister("6nOtb", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $4a5c0a46de19b71d$export$fac44ee5b035f737; });
const $4a5c0a46de19b71d$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, value) : value;
    }, space);

});

parcelRegister("4oCKZ", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", function () { return $3337779f62fbfc9e$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getUrl", function () { return $3337779f62fbfc9e$export$94df0e59ebebf4a7; });
const $3337779f62fbfc9e$export$b7fbffef12272e40 = (address)=>address;
const $3337779f62fbfc9e$export$94df0e59ebebf4a7 = (url)=>url;

});


parcelRegister("4KDKO", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $375a4b9a5972e743$export$bced8d2aada2d1c9; });

var $d7a8k = parcelRequire("d7a8k");

var $jKNV0 = parcelRequire("jKNV0");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $375a4b9a5972e743$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $375a4b9a5972e743$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $375a4b9a5972e743$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $375a4b9a5972e743$var$SHA256 extends (0, $d7a8k.HashMD) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $375a4b9a5972e743$var$SHA256_IV[0] | 0;
        this.B = $375a4b9a5972e743$var$SHA256_IV[1] | 0;
        this.C = $375a4b9a5972e743$var$SHA256_IV[2] | 0;
        this.D = $375a4b9a5972e743$var$SHA256_IV[3] | 0;
        this.E = $375a4b9a5972e743$var$SHA256_IV[4] | 0;
        this.F = $375a4b9a5972e743$var$SHA256_IV[5] | 0;
        this.G = $375a4b9a5972e743$var$SHA256_IV[6] | 0;
        this.H = $375a4b9a5972e743$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$375a4b9a5972e743$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $375a4b9a5972e743$var$SHA256_W[i - 15];
            const W2 = $375a4b9a5972e743$var$SHA256_W[i - 2];
            const s0 = (0, $jKNV0.rotr)(W15, 7) ^ (0, $jKNV0.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $jKNV0.rotr)(W2, 17) ^ (0, $jKNV0.rotr)(W2, 19) ^ W2 >>> 10;
            $375a4b9a5972e743$var$SHA256_W[i] = s1 + $375a4b9a5972e743$var$SHA256_W[i - 7] + s0 + $375a4b9a5972e743$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $jKNV0.rotr)(E, 6) ^ (0, $jKNV0.rotr)(E, 11) ^ (0, $jKNV0.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $d7a8k.Chi)(E, F, G) + $375a4b9a5972e743$var$SHA256_K[i] + $375a4b9a5972e743$var$SHA256_W[i] | 0;
            const sigma0 = (0, $jKNV0.rotr)(A, 2) ^ (0, $jKNV0.rotr)(A, 13) ^ (0, $jKNV0.rotr)(A, 22);
            const T2 = sigma0 + (0, $d7a8k.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $375a4b9a5972e743$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $375a4b9a5972e743$var$SHA224 extends $375a4b9a5972e743$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $375a4b9a5972e743$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $jKNV0.wrapConstructor)(()=>new $375a4b9a5972e743$var$SHA256());
const $375a4b9a5972e743$export$97b70509d4e397ea = /* @__PURE__ */ (0, $jKNV0.wrapConstructor)(()=>new $375a4b9a5972e743$var$SHA224());

});
parcelRegister("d7a8k", function(module, exports) {

$parcel$export(module.exports, "Chi", function () { return $98c3ca1930c28e40$export$d0d97f016526eaf0; });
$parcel$export(module.exports, "Maj", function () { return $98c3ca1930c28e40$export$8b1d810b1bd30adf; });
$parcel$export(module.exports, "HashMD", function () { return $98c3ca1930c28e40$export$f9f830659f932cb2; });

var $9BL5M = parcelRequire("9BL5M");

var $jKNV0 = parcelRequire("jKNV0");
// Polyfill for Safari 14
function $98c3ca1930c28e40$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
const $98c3ca1930c28e40$export$d0d97f016526eaf0 = (a, b, c)=>a & b ^ ~a & c;
const $98c3ca1930c28e40$export$8b1d810b1bd30adf = (a, b, c)=>a & b ^ a & c ^ b & c;
class $98c3ca1930c28e40$export$f9f830659f932cb2 extends (0, $jKNV0.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $jKNV0.createView)(this.buffer);
    }
    update(data) {
        (0, $9BL5M.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $jKNV0.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $jKNV0.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $9BL5M.exists)(this);
        (0, $9BL5M.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $98c3ca1930c28e40$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $jKNV0.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});


parcelRegister("kSxVm", function(module, exports) {

$parcel$export(module.exports, "decodeErrorResult", function () { return $f3332a7076966640$export$8f7898b7bcae6080; });

var $8hnaT = parcelRequire("8hnaT");

var $ckWn0 = parcelRequire("ckWn0");

var $kmzms = parcelRequire("kmzms");

var $eiFaQ = parcelRequire("eiFaQ");

var $024z9 = parcelRequire("024z9");

var $3Q81D = parcelRequire("3Q81D");
function $f3332a7076966640$export$8f7898b7bcae6080(parameters) {
    const { abi: abi, data: data } = parameters;
    const signature = (0, $kmzms.slice)(data, 0, 4);
    if (signature === "0x") throw new (0, $ckWn0.AbiDecodingZeroDataError)();
    const abi_ = [
        ...abi || [],
        (0, $8hnaT.solidityError),
        (0, $8hnaT.solidityPanic)
    ];
    const abiItem = abi_.find((x)=>x.type === "error" && signature === (0, $eiFaQ.toFunctionSelector)((0, $3Q81D.formatAbiItem)(x)));
    if (!abiItem) throw new (0, $ckWn0.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: "/docs/contract/decodeErrorResult"
    });
    return {
        abiItem: abiItem,
        args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $024z9.decodeAbiParameters)(abiItem.inputs, (0, $kmzms.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}

});
parcelRegister("8hnaT", function(module, exports) {

$parcel$export(module.exports, "panicReasons", function () { return $6071e34be4e189bd$export$a618024566d3d221; });
$parcel$export(module.exports, "solidityError", function () { return $6071e34be4e189bd$export$730e9cc7aaa8ca20; });
$parcel$export(module.exports, "solidityPanic", function () { return $6071e34be4e189bd$export$e45b3aea1c5b33e6; });
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const $6071e34be4e189bd$export$a618024566d3d221 = {
    1: "An `assert` condition failed.",
    17: "Arithmetic operation resulted in underflow or overflow.",
    18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
    33: "Attempted to convert to an invalid type.",
    34: "Attempted to access a storage byte array that is incorrectly encoded.",
    49: "Performed `.pop()` on an empty array",
    50: "Array index is out of bounds.",
    65: "Allocated too much memory or created an array which is too large.",
    81: "Attempted to call a zero-initialized variable of internal function type."
};
const $6071e34be4e189bd$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: "message",
            type: "string"
        }
    ],
    name: "Error",
    type: "error"
};
const $6071e34be4e189bd$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: "reason",
            type: "uint256"
        }
    ],
    name: "Panic",
    type: "error"
};

});

parcelRegister("ckWn0", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", function () { return $8fb4a15b0da8c75b$export$efa723f306cf6168; });
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", function () { return $8fb4a15b0da8c75b$export$4faec14323ef9c47; });
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", function () { return $8fb4a15b0da8c75b$export$7a409e433c5f3a8c; });
$parcel$export(module.exports, "AbiDecodingZeroDataError", function () { return $8fb4a15b0da8c75b$export$a063cde4013f1935; });
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", function () { return $8fb4a15b0da8c75b$export$a851da9bf50b557; });
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", function () { return $8fb4a15b0da8c75b$export$19c281dc8e23a2ea; });
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", function () { return $8fb4a15b0da8c75b$export$20737d495bb13c2d; });
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", function () { return $8fb4a15b0da8c75b$export$8959cb729fefe1ea; });
$parcel$export(module.exports, "AbiFunctionNotFoundError", function () { return $8fb4a15b0da8c75b$export$c4faa308ea7f9b2; });
$parcel$export(module.exports, "AbiFunctionOutputsNotFoundError", function () { return $8fb4a15b0da8c75b$export$26f2edb605108b34; });
$parcel$export(module.exports, "AbiItemAmbiguityError", function () { return $8fb4a15b0da8c75b$export$fdbba54ba15f2c2d; });
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", function () { return $8fb4a15b0da8c75b$export$53ed98b886965f49; });
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", function () { return $8fb4a15b0da8c75b$export$cf94ccff0ff97c65; });
$parcel$export(module.exports, "InvalidArrayError", function () { return $8fb4a15b0da8c75b$export$710dd6d4f78cc47e; });
$parcel$export(module.exports, "InvalidDefinitionTypeError", function () { return $8fb4a15b0da8c75b$export$81781a0fcfb9ed95; });

var $3Q81D = parcelRequire("3Q81D");

var $1TQIz = parcelRequire("1TQIz");

var $gzjWc = parcelRequire("gzjWc");
class $8fb4a15b0da8c75b$export$efa723f306cf6168 extends (0, $gzjWc.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$4faec14323ef9c47 extends (0, $gzjWc.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$68a7b570091cba69 extends (0, $gzjWc.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $8fb4a15b0da8c75b$export$7a409e433c5f3a8c extends (0, $gzjWc.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $3Q81D.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $8fb4a15b0da8c75b$export$a063cde4013f1935 extends (0, $gzjWc.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: "AbiDecodingZeroDataError"
        });
    }
}
class $8fb4a15b0da8c75b$export$a851da9bf50b557 extends (0, $gzjWc.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $8fb4a15b0da8c75b$export$19c281dc8e23a2ea extends (0, $gzjWc.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $1TQIz.size)(value)}) does not match expected size (bytes${expectedSize}).`, {
            name: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $8fb4a15b0da8c75b$export$20737d495bb13c2d extends (0, $gzjWc.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingLengthMismatchError"
        });
    }
}
class $8fb4a15b0da8c75b$export$d47cf5ef47eda817 extends (0, $gzjWc.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorInputsNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$86b719574b683f04 extends (0, $gzjWc.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$8959cb729fefe1ea extends (0, $gzjWc.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $8fb4a15b0da8c75b$export$f83210ce5f9b901f extends (0, $gzjWc.BaseError) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath,
            name: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $8fb4a15b0da8c75b$export$3b44baeac92e4d3a extends (0, $gzjWc.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventSignatureNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$c7be62baad13b157 extends (0, $gzjWc.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$c4faa308ea7f9b2 extends (0, $gzjWc.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$26f2edb605108b34 extends (0, $gzjWc.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$14373147a0e60810 extends (0, $gzjWc.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $8fb4a15b0da8c75b$export$fdbba54ba15f2c2d extends (0, $gzjWc.BaseError) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $3Q81D.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $3Q81D.formatAbiItem)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ],
            name: "AbiItemAmbiguityError"
        });
    }
}
class $8fb4a15b0da8c75b$export$a0eb884ede5c87eb extends (0, $gzjWc.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: "BytesSizeMismatchError"
        });
    }
}
class $8fb4a15b0da8c75b$export$3978f86c08fc8c25 extends (0, $gzjWc.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $3Q81D.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $8fb4a15b0da8c75b$export$6d7c6f419cf52377 extends (0, $gzjWc.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $3Q81D.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"), {
            name: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $8fb4a15b0da8c75b$export$53ed98b886965f49 extends (0, $gzjWc.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiEncodingType"
        });
    }
}
class $8fb4a15b0da8c75b$export$cf94ccff0ff97c65 extends (0, $gzjWc.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiDecodingType"
        });
    }
}
class $8fb4a15b0da8c75b$export$710dd6d4f78cc47e extends (0, $gzjWc.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"), {
            name: "InvalidArrayError"
        });
    }
}
class $8fb4a15b0da8c75b$export$81781a0fcfb9ed95 extends (0, $gzjWc.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"), {
            name: "InvalidDefinitionTypeError"
        });
    }
}
class $8fb4a15b0da8c75b$export$a16541e2fe420ef1 extends (0, $gzjWc.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: "UnsupportedPackedAbiType"
        });
    }
}

});
parcelRegister("3Q81D", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $2cbc74198539cef9$export$dc5d0ff4fc2fdee1; });
$parcel$export(module.exports, "formatAbiParams", function () { return $2cbc74198539cef9$export$849e499971de75b3; });

var $ckWn0 = parcelRequire("ckWn0");
function $2cbc74198539cef9$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $ckWn0.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$2cbc74198539cef9$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $2cbc74198539cef9$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$2cbc74198539cef9$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $2cbc74198539cef9$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$2cbc74198539cef9$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

});


parcelRegister("kmzms", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $ed314abaef6c8f39$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "sliceBytes", function () { return $ed314abaef6c8f39$export$8bac03c8c1da551; });

var $k4fDS = parcelRequire("k4fDS");

var $2ZAyo = parcelRequire("2ZAyo");

var $1TQIz = parcelRequire("1TQIz");
function $ed314abaef6c8f39$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $2ZAyo.isHex)(value, {
        strict: false
    })) return $ed314abaef6c8f39$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $ed314abaef6c8f39$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $ed314abaef6c8f39$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $1TQIz.size)(value) - 1) throw new (0, $k4fDS.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $1TQIz.size)(value)
    });
}
function $ed314abaef6c8f39$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $1TQIz.size)(value) !== end - start) throw new (0, $k4fDS.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $1TQIz.size)(value)
    });
}
function $ed314abaef6c8f39$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $ed314abaef6c8f39$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $ed314abaef6c8f39$var$assertEndOffset(value, start, end);
    return value;
}
function $ed314abaef6c8f39$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $ed314abaef6c8f39$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $ed314abaef6c8f39$var$assertEndOffset(value, start, end);
    return value;
}

});

parcelRegister("eiFaQ", function(module, exports) {

$parcel$export(module.exports, "toFunctionSelector", function () { return $a692af6ce85943e6$export$e2442488533809cb; });

var $kmzms = parcelRequire("kmzms");

var $bfIVS = parcelRequire("bfIVS");
const $a692af6ce85943e6$export$e2442488533809cb = (fn)=>(0, $kmzms.slice)((0, $bfIVS.toSignatureHash)(fn), 0, 4);

});
parcelRegister("bfIVS", function(module, exports) {

$parcel$export(module.exports, "toSignatureHash", function () { return $8313f311c36a88c6$export$d809beebc9c913db; });

var $4ZpYt = parcelRequire("4ZpYt");

var $8QAOa = parcelRequire("8QAOa");
function $8313f311c36a88c6$export$d809beebc9c913db(fn) {
    return (0, $4ZpYt.hashSignature)((0, $8QAOa.toSignature)(fn));
}

});
parcelRegister("4ZpYt", function(module, exports) {

$parcel$export(module.exports, "hashSignature", function () { return $3a2101eaba088a3f$export$77bbcd7aaec17976; });

var $2JRke = parcelRequire("2JRke");

var $iffkR = parcelRequire("iffkR");
const $3a2101eaba088a3f$var$hash = (value)=>(0, $iffkR.keccak256)((0, $2JRke.toBytes)(value));
function $3a2101eaba088a3f$export$77bbcd7aaec17976(sig) {
    return $3a2101eaba088a3f$var$hash(sig);
}

});

parcelRegister("8QAOa", function(module, exports) {

$parcel$export(module.exports, "toSignature", function () { return $670fbb605fb8d218$export$d075a2fd83e0ecb; });

var $7jszX = parcelRequire("7jszX");

var $eWUUq = parcelRequire("eWUUq");
const $670fbb605fb8d218$export$d075a2fd83e0ecb = (def)=>{
    const def_ = (()=>{
        if (typeof def === "string") return def;
        return (0, $7jszX.formatAbiItem)(def);
    })();
    return (0, $eWUUq.normalizeSignature)(def_);
};

});
parcelRegister("7jszX", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $553079ed7a21eb3a$export$dc5d0ff4fc2fdee1; });

var $8rQFz = parcelRequire("8rQFz");
function $553079ed7a21eb3a$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $8rQFz.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs.length ? ` returns (${(0, $8rQFz.formatAbiParameters)(abiItem.outputs)})` : ""}`;
    if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $8rQFz.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $8rQFz.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "constructor") return `constructor(${(0, $8rQFz.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    if (abiItem.type === "fallback") return "fallback()";
    return "receive() external payable";
}

});
parcelRegister("8rQFz", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", function () { return $6269b3659e75f30f$export$c55dbda1a081631e; });

var $ihm2M = parcelRequire("ihm2M");
function $6269b3659e75f30f$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $ihm2M.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("ihm2M", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", function () { return $d4eae9f77a67585b$export$c75e01ebc733dc6b; });

var $fgtVV = parcelRequire("fgtVV");
// https://regexr.com/7f7rv
const $d4eae9f77a67585b$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $d4eae9f77a67585b$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($d4eae9f77a67585b$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $d4eae9f77a67585b$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $fgtVV.execTyped)($d4eae9f77a67585b$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $d4eae9f77a67585b$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("fgtVV", function(module, exports) {

$parcel$export(module.exports, "execTyped", function () { return $b1cf91c5525c94cb$export$1cca4755fb17f5bd; });
$parcel$export(module.exports, "bytesRegex", function () { return $b1cf91c5525c94cb$export$94d7303c0d9f263a; });
$parcel$export(module.exports, "integerRegex", function () { return $b1cf91c5525c94cb$export$45902cc189596eef; });
$parcel$export(module.exports, "isTupleRegex", function () { return $b1cf91c5525c94cb$export$5c1628af1434aed0; });
// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $b1cf91c5525c94cb$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $b1cf91c5525c94cb$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $b1cf91c5525c94cb$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $b1cf91c5525c94cb$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("eWUUq", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", function () { return $ae22a06f933243fb$export$5cba87ebe4d0307a; });

var $gzjWc = parcelRequire("gzjWc");
function $ae22a06f933243fb$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $gzjWc.BaseError)("Unable to normalize signature.");
    return result;
}

});




parcelRegister("024z9", function(module, exports) {

$parcel$export(module.exports, "decodeAbiParameters", function () { return $0063bab4f0b6d543$export$84d51ac2fffabd56; });

var $ckWn0 = parcelRequire("ckWn0");

var $9vguw = parcelRequire("9vguw");

var $4uT2F = parcelRequire("4uT2F");

var $1TQIz = parcelRequire("1TQIz");

var $kmzms = parcelRequire("kmzms");

var $54zaP = parcelRequire("54zaP");

var $cdtLk = parcelRequire("cdtLk");

var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");

var $hFEYz = parcelRequire("hFEYz");
function $0063bab4f0b6d543$export$84d51ac2fffabd56(params, data) {
    const bytes = typeof data === "string" ? (0, $2JRke.hexToBytes)(data) : data;
    const cursor = (0, $4uT2F.createCursor)(bytes);
    if ((0, $1TQIz.size)(bytes) === 0 && params.length > 0) throw new (0, $ckWn0.AbiDecodingZeroDataError)();
    if ((0, $1TQIz.size)(data) && (0, $1TQIz.size)(data) < 32) throw new (0, $ckWn0.AbiDecodingDataSizeTooSmallError)({
        data: typeof data === "string" ? data : (0, $8syAN.bytesToHex)(data),
        params: params,
        size: (0, $1TQIz.size)(data)
    });
    let consumed = 0;
    const values = [];
    for(let i = 0; i < params.length; ++i){
        const param = params[i];
        cursor.setPosition(consumed);
        const [data, consumed_] = $0063bab4f0b6d543$var$decodeParameter(cursor, param, {
            staticPosition: 0
        });
        consumed += consumed_;
        values.push(data);
    }
    return values;
}
function $0063bab4f0b6d543$var$decodeParameter(cursor, param, { staticPosition: staticPosition }) {
    const arrayComponents = (0, $hFEYz.getArrayComponents)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $0063bab4f0b6d543$var$decodeArray(cursor, {
            ...param,
            type: type
        }, {
            length: length,
            staticPosition: staticPosition
        });
    }
    if (param.type === "tuple") return $0063bab4f0b6d543$var$decodeTuple(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type === "address") return $0063bab4f0b6d543$var$decodeAddress(cursor);
    if (param.type === "bool") return $0063bab4f0b6d543$var$decodeBool(cursor);
    if (param.type.startsWith("bytes")) return $0063bab4f0b6d543$var$decodeBytes(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $0063bab4f0b6d543$var$decodeNumber(cursor, param);
    if (param.type === "string") return $0063bab4f0b6d543$var$decodeString(cursor, {
        staticPosition: staticPosition
    });
    throw new (0, $ckWn0.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
////////////////////////////////////////////////////////////////////
// Type Decoders
const $0063bab4f0b6d543$var$sizeOfLength = 32;
const $0063bab4f0b6d543$var$sizeOfOffset = 32;
function $0063bab4f0b6d543$var$decodeAddress(cursor) {
    const value = cursor.readBytes(32);
    return [
        (0, $9vguw.checksumAddress)((0, $8syAN.bytesToHex)((0, $kmzms.sliceBytes)(value, -20))),
        32
    ];
}
function $0063bab4f0b6d543$var$decodeArray(cursor, param, { length: length, staticPosition: staticPosition }) {
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        const offset = (0, $cdtLk.bytesToNumber)(cursor.readBytes($0063bab4f0b6d543$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const startOfData = start + $0063bab4f0b6d543$var$sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        const length = (0, $cdtLk.bytesToNumber)(cursor.readBytes($0063bab4f0b6d543$var$sizeOfLength));
        // Check if the array has any dynamic children.
        const dynamicChild = $0063bab4f0b6d543$var$hasDynamicChild(param);
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            const [data, consumed_] = $0063bab4f0b6d543$var$decodeParameter(cursor, param, {
                staticPosition: startOfData
            });
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($0063bab4f0b6d543$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        const offset = (0, $cdtLk.bytesToNumber)(cursor.readBytes($0063bab4f0b6d543$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const value = [];
        for(let i = 0; i < length; ++i){
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start + i * 32);
            const [data] = $0063bab4f0b6d543$var$decodeParameter(cursor, param, {
                staticPosition: start
            });
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const [data, consumed_] = $0063bab4f0b6d543$var$decodeParameter(cursor, param, {
            staticPosition: staticPosition + consumed
        });
        consumed += consumed_;
        value.push(data);
    }
    return [
        value,
        consumed
    ];
}
function $0063bab4f0b6d543$var$decodeBool(cursor) {
    return [
        (0, $cdtLk.bytesToBool)(cursor.readBytes(32), {
            size: 32
        }),
        32
    ];
}
function $0063bab4f0b6d543$var$decodeBytes(cursor, param, { staticPosition: staticPosition }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        const offset = (0, $cdtLk.bytesToNumber)(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        const length = (0, $cdtLk.bytesToNumber)(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return [
                "0x",
                32
            ];
        }
        const data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            (0, $8syAN.bytesToHex)(data),
            32
        ];
    }
    const value = (0, $8syAN.bytesToHex)(cursor.readBytes(Number.parseInt(size), 32));
    return [
        value,
        32
    ];
}
function $0063bab4f0b6d543$var$decodeNumber(cursor, param) {
    const signed = param.type.startsWith("int");
    const size = Number.parseInt(param.type.split("int")[1] || "256");
    const value = cursor.readBytes(32);
    return [
        size > 48 ? (0, $cdtLk.bytesToBigInt)(value, {
            signed: signed
        }) : (0, $cdtLk.bytesToNumber)(value, {
            signed: signed
        }),
        32
    ];
}
function $0063bab4f0b6d543$var$decodeTuple(cursor, param, { staticPosition: staticPosition }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($0063bab4f0b6d543$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        const offset = (0, $cdtLk.bytesToNumber)(cursor.readBytes($0063bab4f0b6d543$var$sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        const start = staticPosition + offset;
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            cursor.setPosition(start + consumed);
            const [data, consumed_] = $0063bab4f0b6d543$var$decodeParameter(cursor, component, {
                staticPosition: start
            });
            consumed += consumed_;
            value[hasUnnamedChild ? i : component?.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const [data, consumed_] = $0063bab4f0b6d543$var$decodeParameter(cursor, component, {
            staticPosition: staticPosition
        });
        value[hasUnnamedChild ? i : component?.name] = data;
        consumed += consumed_;
    }
    return [
        value,
        consumed
    ];
}
function $0063bab4f0b6d543$var$decodeString(cursor, { staticPosition: staticPosition }) {
    // Get offset to start of string data.
    const offset = (0, $cdtLk.bytesToNumber)(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    const start = staticPosition + offset;
    cursor.setPosition(start);
    const length = (0, $cdtLk.bytesToNumber)(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return [
            "",
            32
        ];
    }
    const data = cursor.readBytes(length, 32);
    const value = (0, $cdtLk.bytesToString)((0, $54zaP.trim)(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [
        value,
        32
    ];
}
function $0063bab4f0b6d543$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($0063bab4f0b6d543$var$hasDynamicChild);
    const arrayComponents = (0, $hFEYz.getArrayComponents)(param.type);
    if (arrayComponents && $0063bab4f0b6d543$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}

});
parcelRegister("4uT2F", function(module, exports) {

$parcel$export(module.exports, "createCursor", function () { return $3464a8f218aee6a9$export$fb542681b7c0dc55; });

var $1mpnF = parcelRequire("1mpnF");
const $3464a8f218aee6a9$var$staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit () {
        if (this.recursiveReadCount >= this.recursiveReadLimit) throw new (0, $1mpnF.RecursiveReadLimitExceededError)({
            count: this.recursiveReadCount + 1,
            limit: this.recursiveReadLimit
        });
    },
    assertPosition (position) {
        if (position < 0 || position > this.bytes.length - 1) throw new (0, $1mpnF.PositionOutOfBoundsError)({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition (offset) {
        if (offset < 0) throw new (0, $1mpnF.NegativeOffsetError)({
            offset: offset
        });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount (position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition (offset) {
        if (offset < 0) throw new (0, $1mpnF.NegativeOffsetError)({
            offset: offset
        });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes (length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte (byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes (bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8 (value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16 (value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24 (value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32 (value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes (length, size) {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectBytes(length);
        this.position += size ?? length;
        return value;
    },
    readUint8 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining () {
        return this.bytes.length - this.position;
    },
    setPosition (position) {
        const oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return ()=>this.position = oldPosition;
    },
    _touch () {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY) return;
        const count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0) this.recursiveReadCount++;
    }
};
function $3464a8f218aee6a9$export$fb542681b7c0dc55(bytes, { recursiveReadLimit: recursiveReadLimit = 8192 } = {}) {
    const cursor = Object.create($3464a8f218aee6a9$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}

});
parcelRegister("1mpnF", function(module, exports) {

$parcel$export(module.exports, "NegativeOffsetError", function () { return $0fdb8897b3fcd369$export$4741ff085e62ac19; });
$parcel$export(module.exports, "PositionOutOfBoundsError", function () { return $0fdb8897b3fcd369$export$72dcc4230cbf50ba; });
$parcel$export(module.exports, "RecursiveReadLimitExceededError", function () { return $0fdb8897b3fcd369$export$4952f5c6336a7cc7; });

var $gzjWc = parcelRequire("gzjWc");
class $0fdb8897b3fcd369$export$4741ff085e62ac19 extends (0, $gzjWc.BaseError) {
    constructor({ offset: offset }){
        super(`Offset \`${offset}\` cannot be negative.`, {
            name: "NegativeOffsetError"
        });
    }
}
class $0fdb8897b3fcd369$export$72dcc4230cbf50ba extends (0, $gzjWc.BaseError) {
    constructor({ length: length, position: position }){
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`, {
            name: "PositionOutOfBoundsError"
        });
    }
}
class $0fdb8897b3fcd369$export$4952f5c6336a7cc7 extends (0, $gzjWc.BaseError) {
    constructor({ count: count, limit: limit }){
        super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`, {
            name: "RecursiveReadLimitExceededError"
        });
    }
}

});


parcelRegister("cdtLk", function(module, exports) {

$parcel$export(module.exports, "bytesToNumber", function () { return $8e4dc9242fffc7b9$export$c0cca17bcf674749; });
$parcel$export(module.exports, "bytesToBigInt", function () { return $8e4dc9242fffc7b9$export$2a52511e4f35930a; });
$parcel$export(module.exports, "bytesToBool", function () { return $8e4dc9242fffc7b9$export$aa06fda122958d5d; });
$parcel$export(module.exports, "bytesToString", function () { return $8e4dc9242fffc7b9$export$7c746b75f47c9c7d; });

var $g0DNu = parcelRequire("g0DNu");

var $54zaP = parcelRequire("54zaP");

var $dZgT6 = parcelRequire("dZgT6");

var $8syAN = parcelRequire("8syAN");
function $8e4dc9242fffc7b9$export$de2da3025c30316c(bytes, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $8e4dc9242fffc7b9$export$c0cca17bcf674749(bytes, opts);
    if (to === "bigint") return $8e4dc9242fffc7b9$export$2a52511e4f35930a(bytes, opts);
    if (to === "boolean") return $8e4dc9242fffc7b9$export$aa06fda122958d5d(bytes, opts);
    if (to === "string") return $8e4dc9242fffc7b9$export$7c746b75f47c9c7d(bytes, opts);
    return (0, $8syAN.bytesToHex)(bytes, opts);
}
function $8e4dc9242fffc7b9$export$2a52511e4f35930a(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $dZgT6.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $8syAN.bytesToHex)(bytes, opts);
    return (0, $dZgT6.hexToBigInt)(hex, opts);
}
function $8e4dc9242fffc7b9$export$aa06fda122958d5d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $dZgT6.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $54zaP.trim)(bytes);
    }
    if (bytes.length > 1 || bytes[0] > 1) throw new (0, $g0DNu.InvalidBytesBooleanError)(bytes);
    return Boolean(bytes[0]);
}
function $8e4dc9242fffc7b9$export$c0cca17bcf674749(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $dZgT6.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $8syAN.bytesToHex)(bytes, opts);
    return (0, $dZgT6.hexToNumber)(hex, opts);
}
function $8e4dc9242fffc7b9$export$7c746b75f47c9c7d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $dZgT6.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $54zaP.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});

parcelRegister("hFEYz", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", function () { return $cdd60cf710b1c5bf$export$448ea0950d6dd7d7; });
$parcel$export(module.exports, "getArrayComponents", function () { return $cdd60cf710b1c5bf$export$ab502cfdbb1a0d07; });

var $ckWn0 = parcelRequire("ckWn0");

var $c9lDF = parcelRequire("c9lDF");

var $gzjWc = parcelRequire("gzjWc");

var $ca1JH = parcelRequire("ca1JH");

var $fwEJN = parcelRequire("fwEJN");

var $9m6jZ = parcelRequire("9m6jZ");

var $1TQIz = parcelRequire("1TQIz");

var $kmzms = parcelRequire("kmzms");

var $8syAN = parcelRequire("8syAN");
function $cdd60cf710b1c5bf$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $ckWn0.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $cdd60cf710b1c5bf$var$prepareParams({
        params: params,
        values: values
    });
    const data = $cdd60cf710b1c5bf$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $cdd60cf710b1c5bf$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($cdd60cf710b1c5bf$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $cdd60cf710b1c5bf$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $cdd60cf710b1c5bf$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $cdd60cf710b1c5bf$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $cdd60cf710b1c5bf$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $cdd60cf710b1c5bf$var$encodeAddress(value);
    if (param.type === "bool") return $cdd60cf710b1c5bf$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        return $cdd60cf710b1c5bf$var$encodeNumber(value, {
            signed: signed
        });
    }
    if (param.type.startsWith("bytes")) return $cdd60cf710b1c5bf$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $cdd60cf710b1c5bf$var$encodeString(value);
    throw new (0, $ckWn0.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $cdd60cf710b1c5bf$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $1TQIz.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $8syAN.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $1TQIz.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $fwEJN.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $cdd60cf710b1c5bf$var$encodeAddress(value) {
    if (!(0, $ca1JH.isAddress)(value)) throw new (0, $c9lDF.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $9m6jZ.padHex)(value.toLowerCase())
    };
}
function $cdd60cf710b1c5bf$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $ckWn0.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $ckWn0.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $cdd60cf710b1c5bf$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $cdd60cf710b1c5bf$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $8syAN.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $fwEJN.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $fwEJN.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $cdd60cf710b1c5bf$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $1TQIz.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $9m6jZ.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $fwEJN.concat)([
                (0, $9m6jZ.padHex)((0, $8syAN.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize)) throw new (0, $ckWn0.AbiEncodingBytesSizeMismatchError)({
        expectedSize: Number.parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $9m6jZ.padHex)(value, {
            dir: "right"
        })
    };
}
function $cdd60cf710b1c5bf$var$encodeBool(value) {
    if (typeof value !== "boolean") throw new (0, $gzjWc.BaseError)(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: (0, $9m6jZ.padHex)((0, $8syAN.boolToHex)(value))
    };
}
function $cdd60cf710b1c5bf$var$encodeNumber(value, { signed: signed }) {
    return {
        dynamic: false,
        encoded: (0, $8syAN.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $cdd60cf710b1c5bf$var$encodeString(value) {
    const hexValue = (0, $8syAN.stringToHex)(value);
    const partsLength = Math.ceil((0, $1TQIz.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $9m6jZ.padHex)((0, $kmzms.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $fwEJN.concat)([
            (0, $9m6jZ.padHex)((0, $8syAN.numberToHex)((0, $1TQIz.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $cdd60cf710b1c5bf$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $cdd60cf710b1c5bf$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $cdd60cf710b1c5bf$var$encodeParams(preparedParams) : (0, $fwEJN.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $cdd60cf710b1c5bf$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});



parcelRegister("6P18x", function(module, exports) {

$parcel$export(module.exports, "call", function () { return $4f78633cb63c98fa$export$848feb93d8f32b9b; });

var $kVda1 = parcelRequire("kVda1");

var $bsCQg = parcelRequire("bsCQg");

var $jOWIL = parcelRequire("jOWIL");

var $iopTA = parcelRequire("iopTA");

var $j0j3E = parcelRequire("j0j3E");

var $gzjWc = parcelRequire("gzjWc");

var $jOG4f = parcelRequire("jOG4f");

var $69Kmp = parcelRequire("69Kmp");

var $1DT5P = parcelRequire("1DT5P");

var $dvHq1 = parcelRequire("dvHq1");

var $cA21A = parcelRequire("cA21A");

var $1oOKa = parcelRequire("1oOKa");

var $8syAN = parcelRequire("8syAN");

var $2bj53 = parcelRequire("2bj53");

var $36Zbp = parcelRequire("36Zbp");

var $cdG5Y = parcelRequire("cdG5Y");

var $fNXI0 = parcelRequire("fNXI0");

var $2Pi5m = parcelRequire("2Pi5m");

var $ea0OJ = parcelRequire("ea0OJ");

async function $4f78633cb63c98fa$export$848feb93d8f32b9b(client, args) {
    const { account: account_ = client.account, batch: batch = Boolean(client.batch?.multicall), blockNumber: blockNumber, blockTag: blockTag = "latest", accessList: accessList, blobs: blobs, code: code, data: data_, factory: factory, factoryData: factoryData, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride, ...rest } = args;
    const account = account_ ? (0, $bsCQg.parseAccount)(account_) : undefined;
    if (code && (factory || factoryData)) throw new (0, $gzjWc.BaseError)("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
    if (code && to) throw new (0, $gzjWc.BaseError)("Cannot provide both `code` & `to` as parameters.");
    // Check if the call is deployless via bytecode.
    const deploylessCallViaBytecode = code && data_;
    // Check if the call is deployless via a factory.
    const deploylessCallViaFactory = factory && factoryData && to && data_;
    const deploylessCall = deploylessCallViaBytecode || deploylessCallViaFactory;
    const data = (()=>{
        if (deploylessCallViaBytecode) return $4f78633cb63c98fa$var$toDeploylessCallViaBytecodeData({
            code: code,
            data: data_
        });
        if (deploylessCallViaFactory) return $4f78633cb63c98fa$var$toDeploylessCallViaFactoryData({
            data: data_,
            factory: factory,
            factoryData: factoryData,
            to: to
        });
        return data_;
    })();
    try {
        (0, $ea0OJ.assertRequest)(args);
        const blockNumberHex = blockNumber ? (0, $8syAN.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = (0, $2Pi5m.serializeStateOverride)(stateOverride);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $cdG5Y.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $36Zbp.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            blobs: blobs,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: deploylessCall ? undefined : to,
            value: value
        });
        if (batch && $4f78633cb63c98fa$var$shouldPerformMulticall({
            request: request
        }) && !rpcStateOverride) try {
            return await $4f78633cb63c98fa$var$scheduleMulticall(client, {
                ...request,
                blockNumber: blockNumber,
                blockTag: blockTag
            });
        } catch (err) {
            if (!(err instanceof (0, $jOG4f.ClientChainNotConfiguredError)) && !(err instanceof (0, $jOG4f.ChainDoesNotSupportContract))) throw err;
        }
        const response = await client.request({
            method: "eth_call",
            params: rpcStateOverride ? [
                request,
                block,
                rpcStateOverride
            ] : [
                request,
                block
            ]
        });
        if (response === "0x") return {
            data: undefined
        };
        return {
            data: response
        };
    } catch (err) {
        const data = $4f78633cb63c98fa$export$6ef1a527f868ca75(err);
        // Check for CCIP-Read offchain lookup signature.
        const { offchainLookup: offchainLookup, offchainLookupSignature: offchainLookupSignature } = await (parcelRequire("iiC41"));
        if (client.ccipRead !== false && data?.slice(0, 10) === offchainLookupSignature && to) return {
            data: await offchainLookup(client, {
                data: data,
                to: to
            })
        };
        // Check for counterfactual deployment error.
        if (deploylessCall && data?.slice(0, 10) === "0x101bb98d") throw new (0, $69Kmp.CounterfactualDeploymentFailedError)({
            factory: factory
        });
        throw (0, $2bj53.getCallError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function $4f78633cb63c98fa$var$shouldPerformMulticall({ request: request }) {
    const { data: data, to: to, ...request_ } = request;
    if (!data) return false;
    if (data.startsWith((0, $iopTA.aggregate3Signature))) return false;
    if (!to) return false;
    if (Object.values(request_).filter((x)=>typeof x !== "undefined").length > 0) return false;
    return true;
}
async function $4f78633cb63c98fa$var$scheduleMulticall(client, args) {
    const { batchSize: batchSize = 1024, wait: wait = 0 } = typeof client.batch?.multicall === "object" ? client.batch.multicall : {};
    const { blockNumber: blockNumber, blockTag: blockTag = "latest", data: data, multicallAddress: multicallAddress_, to: to } = args;
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new (0, $jOG4f.ClientChainNotConfiguredError)();
        multicallAddress = (0, $1oOKa.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const blockNumberHex = blockNumber ? (0, $8syAN.numberToHex)(blockNumber) : undefined;
    const block = blockNumberHex || blockTag;
    const { schedule: schedule } = (0, $fNXI0.createBatchScheduler)({
        id: `${client.uid}.${block}`,
        wait: wait,
        shouldSplitBatch (args) {
            const size = args.reduce((size, { data: data })=>size + (data.length - 2), 0);
            return size > batchSize * 2;
        },
        fn: async (requests)=>{
            const calls = requests.map((request)=>({
                    allowFailure: true,
                    callData: request.data,
                    target: request.to
                }));
            const calldata = (0, $cA21A.encodeFunctionData)({
                abi: (0, $jOWIL.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3"
            });
            const data = await client.request({
                method: "eth_call",
                params: [
                    {
                        data: calldata,
                        to: multicallAddress
                    },
                    block
                ]
            });
            return (0, $1DT5P.decodeFunctionResult)({
                abi: (0, $jOWIL.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3",
                data: data || "0x"
            });
        }
    });
    const [{ returnData: returnData, success: success }] = await schedule({
        data: data,
        to: to
    });
    if (!success) throw new (0, $69Kmp.RawContractError)({
        data: returnData
    });
    if (returnData === "0x") return {
        data: undefined
    };
    return {
        data: returnData
    };
}
function $4f78633cb63c98fa$var$toDeploylessCallViaBytecodeData(parameters) {
    const { code: code, data: data } = parameters;
    return (0, $dvHq1.encodeDeployData)({
        abi: (0, $kVda1.parseAbi)([
            "constructor(bytes, bytes)"
        ]),
        bytecode: (0, $j0j3E.deploylessCallViaBytecodeBytecode),
        args: [
            code,
            data
        ]
    });
}
function $4f78633cb63c98fa$var$toDeploylessCallViaFactoryData(parameters) {
    const { data: data, factory: factory, factoryData: factoryData, to: to } = parameters;
    return (0, $dvHq1.encodeDeployData)({
        abi: (0, $kVda1.parseAbi)([
            "constructor(address, bytes, address, bytes)"
        ]),
        bytecode: (0, $j0j3E.deploylessCallViaFactoryBytecode),
        args: [
            to,
            data,
            factory,
            factoryData
        ]
    });
}
function $4f78633cb63c98fa$export$6ef1a527f868ca75(err) {
    if (!(err instanceof (0, $gzjWc.BaseError))) return undefined;
    const error = err.walk();
    return typeof error?.data === "object" ? error.data?.data : error.data;
}

});
parcelRegister("kVda1", function(module, exports) {

$parcel$export(module.exports, "parseAbi", function () { return $f3b356efcd7fdb6f$export$4ab3f466fb8f069; });

var $loGRP = parcelRequire("loGRP");

var $aVolx = parcelRequire("aVolx");

var $79ABt = parcelRequire("79ABt");
function $f3b356efcd7fdb6f$export$4ab3f466fb8f069(signatures) {
    const structs = (0, $aVolx.parseStructs)(signatures);
    const abi = [];
    const length = signatures.length;
    for(let i = 0; i < length; i++){
        const signature = signatures[i];
        if ((0, $loGRP.isStructSignature)(signature)) continue;
        abi.push((0, $79ABt.parseSignature)(signature, structs));
    }
    return abi;
}

});
parcelRegister("loGRP", function(module, exports) {

$parcel$export(module.exports, "isErrorSignature", function () { return $f93d176aed36e49d$export$33be303020ecaff5; });
$parcel$export(module.exports, "execErrorSignature", function () { return $f93d176aed36e49d$export$a8b67e842e5c116d; });
$parcel$export(module.exports, "isEventSignature", function () { return $f93d176aed36e49d$export$7912f33b3b4526ca; });
$parcel$export(module.exports, "execEventSignature", function () { return $f93d176aed36e49d$export$87d5ec49338ff6f; });
$parcel$export(module.exports, "isFunctionSignature", function () { return $f93d176aed36e49d$export$fa8ae1a8bca33200; });
$parcel$export(module.exports, "execFunctionSignature", function () { return $f93d176aed36e49d$export$8a14253893829398; });
$parcel$export(module.exports, "isStructSignature", function () { return $f93d176aed36e49d$export$130f77ea18c25fb8; });
$parcel$export(module.exports, "execStructSignature", function () { return $f93d176aed36e49d$export$432f3b6c467d7b70; });
$parcel$export(module.exports, "isConstructorSignature", function () { return $f93d176aed36e49d$export$7ec9623fe58e8638; });
$parcel$export(module.exports, "execConstructorSignature", function () { return $f93d176aed36e49d$export$4713f9c79c855460; });
$parcel$export(module.exports, "isFallbackSignature", function () { return $f93d176aed36e49d$export$f99ebae7027f9f2f; });
$parcel$export(module.exports, "isReceiveSignature", function () { return $f93d176aed36e49d$export$555d9bfe0f07ab3d; });
$parcel$export(module.exports, "eventModifiers", function () { return $f93d176aed36e49d$export$e4045f69b6b17e16; });
$parcel$export(module.exports, "functionModifiers", function () { return $f93d176aed36e49d$export$d304f1652f422b6b; });

var $fgtVV = parcelRequire("fgtVV");
// https://regexr.com/7gmok
const $f93d176aed36e49d$var$errorSignatureRegex = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $f93d176aed36e49d$export$33be303020ecaff5(signature) {
    return $f93d176aed36e49d$var$errorSignatureRegex.test(signature);
}
function $f93d176aed36e49d$export$a8b67e842e5c116d(signature) {
    return (0, $fgtVV.execTyped)($f93d176aed36e49d$var$errorSignatureRegex, signature);
}
// https://regexr.com/7gmoq
const $f93d176aed36e49d$var$eventSignatureRegex = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $f93d176aed36e49d$export$7912f33b3b4526ca(signature) {
    return $f93d176aed36e49d$var$eventSignatureRegex.test(signature);
}
function $f93d176aed36e49d$export$87d5ec49338ff6f(signature) {
    return (0, $fgtVV.execTyped)($f93d176aed36e49d$var$eventSignatureRegex, signature);
}
// https://regexr.com/7gmot
const $f93d176aed36e49d$var$functionSignatureRegex = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function $f93d176aed36e49d$export$fa8ae1a8bca33200(signature) {
    return $f93d176aed36e49d$var$functionSignatureRegex.test(signature);
}
function $f93d176aed36e49d$export$8a14253893829398(signature) {
    return (0, $fgtVV.execTyped)($f93d176aed36e49d$var$functionSignatureRegex, signature);
}
// https://regexr.com/7gmp3
const $f93d176aed36e49d$var$structSignatureRegex = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function $f93d176aed36e49d$export$130f77ea18c25fb8(signature) {
    return $f93d176aed36e49d$var$structSignatureRegex.test(signature);
}
function $f93d176aed36e49d$export$432f3b6c467d7b70(signature) {
    return (0, $fgtVV.execTyped)($f93d176aed36e49d$var$structSignatureRegex, signature);
}
// https://regexr.com/78u01
const $f93d176aed36e49d$var$constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function $f93d176aed36e49d$export$7ec9623fe58e8638(signature) {
    return $f93d176aed36e49d$var$constructorSignatureRegex.test(signature);
}
function $f93d176aed36e49d$export$4713f9c79c855460(signature) {
    return (0, $fgtVV.execTyped)($f93d176aed36e49d$var$constructorSignatureRegex, signature);
}
// https://regexr.com/7srtn
const $f93d176aed36e49d$var$fallbackSignatureRegex = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function $f93d176aed36e49d$export$f99ebae7027f9f2f(signature) {
    return $f93d176aed36e49d$var$fallbackSignatureRegex.test(signature);
}
// https://regexr.com/78u1k
const $f93d176aed36e49d$var$receiveSignatureRegex = /^receive\(\) external payable$/;
function $f93d176aed36e49d$export$555d9bfe0f07ab3d(signature) {
    return $f93d176aed36e49d$var$receiveSignatureRegex.test(signature);
}
const $f93d176aed36e49d$export$c2f15f629432a51d = new Set([
    "memory",
    "indexed",
    "storage",
    "calldata"
]);
const $f93d176aed36e49d$export$e4045f69b6b17e16 = new Set([
    "indexed"
]);
const $f93d176aed36e49d$export$d304f1652f422b6b = new Set([
    "calldata",
    "memory",
    "storage"
]);

});

parcelRegister("aVolx", function(module, exports) {

$parcel$export(module.exports, "parseStructs", function () { return $7f421cf0d9ec29a9$export$6e5e6f927c48b857; });

var $fgtVV = parcelRequire("fgtVV");

var $WSBr9 = parcelRequire("WSBr9");

var $jiYAd = parcelRequire("jiYAd");

var $8e5YC = parcelRequire("8e5YC");

var $bYWqJ = parcelRequire("bYWqJ");

var $loGRP = parcelRequire("loGRP");

var $79ABt = parcelRequire("79ABt");
function $7f421cf0d9ec29a9$export$6e5e6f927c48b857(signatures) {
    // Create "shallow" version of each struct (and filter out non-structs or invalid structs)
    const shallowStructs = {};
    const signaturesLength = signatures.length;
    for(let i = 0; i < signaturesLength; i++){
        const signature = signatures[i];
        if (!(0, $loGRP.isStructSignature)(signature)) continue;
        const match = (0, $loGRP.execStructSignature)(signature);
        if (!match) throw new (0, $8e5YC.InvalidSignatureError)({
            signature: signature,
            type: "struct"
        });
        const properties = match.properties.split(";");
        const components = [];
        const propertiesLength = properties.length;
        for(let k = 0; k < propertiesLength; k++){
            const property = properties[k];
            const trimmed = property.trim();
            if (!trimmed) continue;
            const abiParameter = (0, $79ABt.parseAbiParameter)(trimmed, {
                type: "struct"
            });
            components.push(abiParameter);
        }
        if (!components.length) throw new (0, $8e5YC.InvalidStructSignatureError)({
            signature: signature
        });
        shallowStructs[match.name] = components;
    }
    // Resolve nested structs inside each parameter
    const resolvedStructs = {};
    const entries = Object.entries(shallowStructs);
    const entriesLength = entries.length;
    for(let i = 0; i < entriesLength; i++){
        const [name, parameters] = entries[i];
        resolvedStructs[name] = $7f421cf0d9ec29a9$var$resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
}
const $7f421cf0d9ec29a9$var$typeWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function $7f421cf0d9ec29a9$var$resolveStructs(abiParameters, structs, ancestors = new Set()) {
    const components = [];
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        const isTuple = (0, $fgtVV.isTupleRegex).test(abiParameter.type);
        if (isTuple) components.push(abiParameter);
        else {
            const match = (0, $fgtVV.execTyped)($7f421cf0d9ec29a9$var$typeWithoutTupleRegex, abiParameter.type);
            if (!match?.type) throw new (0, $jiYAd.InvalidAbiTypeParameterError)({
                abiParameter: abiParameter
            });
            const { array: array, type: type } = match;
            if (type in structs) {
                if (ancestors.has(type)) throw new (0, $bYWqJ.CircularReferenceError)({
                    type: type
                });
                components.push({
                    ...abiParameter,
                    type: `tuple${array ?? ""}`,
                    components: $7f421cf0d9ec29a9$var$resolveStructs(structs[type] ?? [], structs, new Set([
                        ...ancestors,
                        type
                    ]))
                });
            } else {
                if ((0, $79ABt.isSolidityType)(type)) components.push(abiParameter);
                else throw new (0, $WSBr9.UnknownTypeError)({
                    type: type
                });
            }
        }
    }
    return components;
}

});
parcelRegister("WSBr9", function(module, exports) {

$parcel$export(module.exports, "UnknownTypeError", function () { return $0b0fc5e09ad2e31c$export$9e77a92da3bcd5ca; });
$parcel$export(module.exports, "UnknownSolidityTypeError", function () { return $0b0fc5e09ad2e31c$export$5a36348a2ac471a3; });

var $33mXL = parcelRequire("33mXL");
class $0b0fc5e09ad2e31c$export$a4e0854b60f599b6 extends (0, $33mXL.BaseError) {
    constructor({ signature: signature }){
        super("Failed to parse ABI item.", {
            details: `parseAbiItem(${JSON.stringify(signature, null, 2)})`,
            docsPath: "/api/human#parseabiitem-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiItemError"
        });
    }
}
class $0b0fc5e09ad2e31c$export$9e77a92da3bcd5ca extends (0, $33mXL.BaseError) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownTypeError"
        });
    }
}
class $0b0fc5e09ad2e31c$export$5a36348a2ac471a3 extends (0, $33mXL.BaseError) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSolidityTypeError"
        });
    }
}

});
parcelRegister("33mXL", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $239376e4ee194a16$export$a490eb03cb7a0a5e; });

var $jB2XO = parcelRequire("jB2XO");
class $239376e4ee194a16$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = args.cause instanceof $239376e4ee194a16$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $239376e4ee194a16$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://abitype.dev${docsPath}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: abitype@${(0, $jB2XO.version)}`
        ].join("\n");
        super(message);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiTypeError"
        });
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
}

});
parcelRegister("jB2XO", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e443c58fd34809f8$export$83d89fbfd8236492; });
const $e443c58fd34809f8$export$83d89fbfd8236492 = "1.0.5";

});



parcelRegister("jiYAd", function(module, exports) {

$parcel$export(module.exports, "InvalidParameterError", function () { return $e0deb14fad48d6c5$export$e569b97a5d46005c; });
$parcel$export(module.exports, "SolidityProtectedKeywordError", function () { return $e0deb14fad48d6c5$export$58697cc8f790f211; });
$parcel$export(module.exports, "InvalidModifierError", function () { return $e0deb14fad48d6c5$export$f837e6b0dee0e468; });
$parcel$export(module.exports, "InvalidFunctionModifierError", function () { return $e0deb14fad48d6c5$export$7afd0f25b8fdbbd8; });
$parcel$export(module.exports, "InvalidAbiTypeParameterError", function () { return $e0deb14fad48d6c5$export$b5451545b6c52dc8; });

var $33mXL = parcelRequire("33mXL");
class $e0deb14fad48d6c5$export$bdcd4054531f5b35 extends (0, $33mXL.BaseError) {
    constructor({ param: param }){
        super("Failed to parse ABI parameter.", {
            details: `parseAbiParameter(${JSON.stringify(param, null, 2)})`,
            docsPath: "/api/human#parseabiparameter-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParameterError"
        });
    }
}
class $e0deb14fad48d6c5$export$f35df31806e96ff extends (0, $33mXL.BaseError) {
    constructor({ params: params }){
        super("Failed to parse ABI parameters.", {
            details: `parseAbiParameters(${JSON.stringify(params, null, 2)})`,
            docsPath: "/api/human#parseabiparameters-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParametersError"
        });
    }
}
class $e0deb14fad48d6c5$export$e569b97a5d46005c extends (0, $33mXL.BaseError) {
    constructor({ param: param }){
        super("Invalid ABI parameter.", {
            details: param
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParameterError"
        });
    }
}
class $e0deb14fad48d6c5$export$58697cc8f790f211 extends (0, $33mXL.BaseError) {
    constructor({ param: param, name: name }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `"${name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SolidityProtectedKeywordError"
        });
    }
}
class $e0deb14fad48d6c5$export$f837e6b0dee0e468 extends (0, $33mXL.BaseError) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidModifierError"
        });
    }
}
class $e0deb14fad48d6c5$export$7afd0f25b8fdbbd8 extends (0, $33mXL.BaseError) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`,
                `Data location can only be specified for array, struct, or mapping types, but "${modifier}" was given.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidFunctionModifierError"
        });
    }
}
class $e0deb14fad48d6c5$export$b5451545b6c52dc8 extends (0, $33mXL.BaseError) {
    constructor({ abiParameter: abiParameter }){
        super("Invalid ABI parameter.", {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: [
                "ABI parameter type is invalid."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiTypeParameterError"
        });
    }
}

});

parcelRegister("8e5YC", function(module, exports) {

$parcel$export(module.exports, "InvalidSignatureError", function () { return $5fd444649de6b5d3$export$ccc2f68ef106615a; });
$parcel$export(module.exports, "UnknownSignatureError", function () { return $5fd444649de6b5d3$export$3727c00c40963d37; });
$parcel$export(module.exports, "InvalidStructSignatureError", function () { return $5fd444649de6b5d3$export$769955518e5ea753; });

var $33mXL = parcelRequire("33mXL");
class $5fd444649de6b5d3$export$ccc2f68ef106615a extends (0, $33mXL.BaseError) {
    constructor({ signature: signature, type: type }){
        super(`Invalid ${type} signature.`, {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSignatureError"
        });
    }
}
class $5fd444649de6b5d3$export$3727c00c40963d37 extends (0, $33mXL.BaseError) {
    constructor({ signature: signature }){
        super("Unknown signature.", {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSignatureError"
        });
    }
}
class $5fd444649de6b5d3$export$769955518e5ea753 extends (0, $33mXL.BaseError) {
    constructor({ signature: signature }){
        super("Invalid struct signature.", {
            details: signature,
            metaMessages: [
                "No properties exist."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStructSignatureError"
        });
    }
}

});

parcelRegister("bYWqJ", function(module, exports) {

$parcel$export(module.exports, "CircularReferenceError", function () { return $8b929f4eb7c1d756$export$3b7cb2315fb6b103; });

var $33mXL = parcelRequire("33mXL");
class $8b929f4eb7c1d756$export$3b7cb2315fb6b103 extends (0, $33mXL.BaseError) {
    constructor({ type: type }){
        super("Circular reference detected.", {
            metaMessages: [
                `Struct "${type}" is a circular reference.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CircularReferenceError"
        });
    }
}

});

parcelRegister("79ABt", function(module, exports) {

$parcel$export(module.exports, "parseSignature", function () { return $5355c45cc3f53da2$export$dc1dc22ccf24efef; });
$parcel$export(module.exports, "parseAbiParameter", function () { return $5355c45cc3f53da2$export$357229f9e2d85552; });
$parcel$export(module.exports, "isSolidityType", function () { return $5355c45cc3f53da2$export$640ecc6f40db6417; });

var $fgtVV = parcelRequire("fgtVV");

var $WSBr9 = parcelRequire("WSBr9");

var $jiYAd = parcelRequire("jiYAd");

var $8e5YC = parcelRequire("8e5YC");

var $f7heB = parcelRequire("f7heB");

var $ihjQx = parcelRequire("ihjQx");

var $loGRP = parcelRequire("loGRP");
function $5355c45cc3f53da2$export$dc1dc22ccf24efef(signature, structs = {}) {
    if ((0, $loGRP.isFunctionSignature)(signature)) {
        const match = (0, $loGRP.execFunctionSignature)(signature);
        if (!match) throw new (0, $8e5YC.InvalidSignatureError)({
            signature: signature,
            type: "function"
        });
        const inputParams = $5355c45cc3f53da2$export$8350908b11ff5aef(match.parameters);
        const inputs = [];
        const inputLength = inputParams.length;
        for(let i = 0; i < inputLength; i++)inputs.push($5355c45cc3f53da2$export$357229f9e2d85552(inputParams[i], {
            modifiers: (0, $loGRP.functionModifiers),
            structs: structs,
            type: "function"
        }));
        const outputs = [];
        if (match.returns) {
            const outputParams = $5355c45cc3f53da2$export$8350908b11ff5aef(match.returns);
            const outputLength = outputParams.length;
            for(let i = 0; i < outputLength; i++)outputs.push($5355c45cc3f53da2$export$357229f9e2d85552(outputParams[i], {
                modifiers: (0, $loGRP.functionModifiers),
                structs: structs,
                type: "function"
            }));
        }
        return {
            name: match.name,
            type: "function",
            stateMutability: match.stateMutability ?? "nonpayable",
            inputs: inputs,
            outputs: outputs
        };
    }
    if ((0, $loGRP.isEventSignature)(signature)) {
        const match = (0, $loGRP.execEventSignature)(signature);
        if (!match) throw new (0, $8e5YC.InvalidSignatureError)({
            signature: signature,
            type: "event"
        });
        const params = $5355c45cc3f53da2$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($5355c45cc3f53da2$export$357229f9e2d85552(params[i], {
            modifiers: (0, $loGRP.eventModifiers),
            structs: structs,
            type: "event"
        }));
        return {
            name: match.name,
            type: "event",
            inputs: abiParameters
        };
    }
    if ((0, $loGRP.isErrorSignature)(signature)) {
        const match = (0, $loGRP.execErrorSignature)(signature);
        if (!match) throw new (0, $8e5YC.InvalidSignatureError)({
            signature: signature,
            type: "error"
        });
        const params = $5355c45cc3f53da2$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($5355c45cc3f53da2$export$357229f9e2d85552(params[i], {
            structs: structs,
            type: "error"
        }));
        return {
            name: match.name,
            type: "error",
            inputs: abiParameters
        };
    }
    if ((0, $loGRP.isConstructorSignature)(signature)) {
        const match = (0, $loGRP.execConstructorSignature)(signature);
        if (!match) throw new (0, $8e5YC.InvalidSignatureError)({
            signature: signature,
            type: "constructor"
        });
        const params = $5355c45cc3f53da2$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($5355c45cc3f53da2$export$357229f9e2d85552(params[i], {
            structs: structs,
            type: "constructor"
        }));
        return {
            type: "constructor",
            stateMutability: match.stateMutability ?? "nonpayable",
            inputs: abiParameters
        };
    }
    if ((0, $loGRP.isFallbackSignature)(signature)) return {
        type: "fallback"
    };
    if ((0, $loGRP.isReceiveSignature)(signature)) return {
        type: "receive",
        stateMutability: "payable"
    };
    throw new (0, $8e5YC.UnknownSignatureError)({
        signature: signature
    });
}
const $5355c45cc3f53da2$var$abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $5355c45cc3f53da2$var$abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $5355c45cc3f53da2$var$dynamicIntegerRegex = /^u?int$/;
function $5355c45cc3f53da2$export$357229f9e2d85552(param, options) {
    // optional namespace cache by `type`
    const parameterCacheKey = (0, $ihjQx.getParameterCacheKey)(param, options?.type);
    if ((0, $ihjQx.parameterCache).has(parameterCacheKey)) return (0, $ihjQx.parameterCache).get(parameterCacheKey);
    const isTuple = (0, $fgtVV.isTupleRegex).test(param);
    const match = (0, $fgtVV.execTyped)(isTuple ? $5355c45cc3f53da2$var$abiParameterWithTupleRegex : $5355c45cc3f53da2$var$abiParameterWithoutTupleRegex, param);
    if (!match) throw new (0, $jiYAd.InvalidParameterError)({
        param: param
    });
    if (match.name && $5355c45cc3f53da2$export$d83e1b8970d84409(match.name)) throw new (0, $jiYAd.SolidityProtectedKeywordError)({
        param: param,
        name: match.name
    });
    const name = match.name ? {
        name: match.name
    } : {};
    const indexed = match.modifier === "indexed" ? {
        indexed: true
    } : {};
    const structs = options?.structs ?? {};
    let type;
    let components = {};
    if (isTuple) {
        type = "tuple";
        const params = $5355c45cc3f53da2$export$8350908b11ff5aef(match.type);
        const components_ = [];
        const length = params.length;
        for(let i = 0; i < length; i++)// remove `modifiers` from `options` to prevent from being added to tuple components
        components_.push($5355c45cc3f53da2$export$357229f9e2d85552(params[i], {
            structs: structs
        }));
        components = {
            components: components_
        };
    } else if (match.type in structs) {
        type = "tuple";
        components = {
            components: structs[match.type]
        };
    } else if ($5355c45cc3f53da2$var$dynamicIntegerRegex.test(match.type)) type = `${match.type}256`;
    else {
        type = match.type;
        if (!(options?.type === "struct") && !$5355c45cc3f53da2$export$640ecc6f40db6417(type)) throw new (0, $WSBr9.UnknownSolidityTypeError)({
            type: type
        });
    }
    if (match.modifier) {
        // Check if modifier exists, but is not allowed (e.g. `indexed` in `functionModifiers`)
        if (!options?.modifiers?.has?.(match.modifier)) throw new (0, $jiYAd.InvalidModifierError)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
        // Check if resolved `type` is valid if there is a function modifier
        if ((0, $loGRP.functionModifiers).has(match.modifier) && !$5355c45cc3f53da2$export$7265528696368a9(type, !!match.array)) throw new (0, $jiYAd.InvalidFunctionModifierError)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
    }
    const abiParameter = {
        type: `${type}${match.array ?? ""}`,
        ...name,
        ...indexed,
        ...components
    };
    (0, $ihjQx.parameterCache).set(parameterCacheKey, abiParameter);
    return abiParameter;
}
function $5355c45cc3f53da2$export$8350908b11ff5aef(params, result = [], current = "", depth = 0) {
    const length = params.trim().length;
    // biome-ignore lint/correctness/noUnreachable: recursive
    for(let i = 0; i < length; i++){
        const char = params[i];
        const tail = params.slice(i + 1);
        switch(char){
            case ",":
                return depth === 0 ? $5355c45cc3f53da2$export$8350908b11ff5aef(tail, [
                    ...result,
                    current.trim()
                ]) : $5355c45cc3f53da2$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
            case "(":
                return $5355c45cc3f53da2$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth + 1);
            case ")":
                return $5355c45cc3f53da2$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth - 1);
            default:
                return $5355c45cc3f53da2$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
        }
    }
    if (current === "") return result;
    if (depth !== 0) throw new (0, $f7heB.InvalidParenthesisError)({
        current: current,
        depth: depth
    });
    result.push(current.trim());
    return result;
}
function $5355c45cc3f53da2$export$640ecc6f40db6417(type) {
    return type === "address" || type === "bool" || type === "function" || type === "string" || (0, $fgtVV.bytesRegex).test(type) || (0, $fgtVV.integerRegex).test(type);
}
const $5355c45cc3f53da2$var$protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function $5355c45cc3f53da2$export$d83e1b8970d84409(name) {
    return name === "address" || name === "bool" || name === "function" || name === "string" || name === "tuple" || (0, $fgtVV.bytesRegex).test(name) || (0, $fgtVV.integerRegex).test(name) || $5355c45cc3f53da2$var$protectedKeywordsRegex.test(name);
}
function $5355c45cc3f53da2$export$7265528696368a9(type, isArray) {
    return isArray || type === "bytes" || type === "string" || type === "tuple";
}

});
parcelRegister("f7heB", function(module, exports) {

$parcel$export(module.exports, "InvalidParenthesisError", function () { return $b014e0dc0cfbb8bb$export$a13d6673dbe1ad6e; });

var $33mXL = parcelRequire("33mXL");
class $b014e0dc0cfbb8bb$export$a13d6673dbe1ad6e extends (0, $33mXL.BaseError) {
    constructor({ current: current, depth: depth }){
        super("Unbalanced parentheses.", {
            metaMessages: [
                `"${current.trim()}" has too many ${depth > 0 ? "opening" : "closing"} parentheses.`
            ],
            details: `Depth "${depth}"`
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParenthesisError"
        });
    }
}

});

parcelRegister("ihjQx", function(module, exports) {

$parcel$export(module.exports, "getParameterCacheKey", function () { return $d4e935994788527c$export$516f1eedf0355404; });
$parcel$export(module.exports, "parameterCache", function () { return $d4e935994788527c$export$da1654d628010643; });
/**
 * Gets {@link parameterCache} cache key namespaced by {@link type}. This prevents parameters from being accessible to types that don't allow them (e.g. `string indexed foo` not allowed outside of `type: 'event'`).
 * @param param ABI parameter string
 * @param type ABI parameter type
 * @returns Cache key for {@link parameterCache}
 */ function $d4e935994788527c$export$516f1eedf0355404(param, type) {
    if (type) return `${type}:${param}`;
    return param;
}
const $d4e935994788527c$export$da1654d628010643 = new Map([
    // Unnamed
    [
        "address",
        {
            type: "address"
        }
    ],
    [
        "bool",
        {
            type: "bool"
        }
    ],
    [
        "bytes",
        {
            type: "bytes"
        }
    ],
    [
        "bytes32",
        {
            type: "bytes32"
        }
    ],
    [
        "int",
        {
            type: "int256"
        }
    ],
    [
        "int256",
        {
            type: "int256"
        }
    ],
    [
        "string",
        {
            type: "string"
        }
    ],
    [
        "uint",
        {
            type: "uint256"
        }
    ],
    [
        "uint8",
        {
            type: "uint8"
        }
    ],
    [
        "uint16",
        {
            type: "uint16"
        }
    ],
    [
        "uint24",
        {
            type: "uint24"
        }
    ],
    [
        "uint32",
        {
            type: "uint32"
        }
    ],
    [
        "uint64",
        {
            type: "uint64"
        }
    ],
    [
        "uint96",
        {
            type: "uint96"
        }
    ],
    [
        "uint112",
        {
            type: "uint112"
        }
    ],
    [
        "uint160",
        {
            type: "uint160"
        }
    ],
    [
        "uint192",
        {
            type: "uint192"
        }
    ],
    [
        "uint256",
        {
            type: "uint256"
        }
    ],
    // Named
    [
        "address owner",
        {
            type: "address",
            name: "owner"
        }
    ],
    [
        "address to",
        {
            type: "address",
            name: "to"
        }
    ],
    [
        "bool approved",
        {
            type: "bool",
            name: "approved"
        }
    ],
    [
        "bytes _data",
        {
            type: "bytes",
            name: "_data"
        }
    ],
    [
        "bytes data",
        {
            type: "bytes",
            name: "data"
        }
    ],
    [
        "bytes signature",
        {
            type: "bytes",
            name: "signature"
        }
    ],
    [
        "bytes32 hash",
        {
            type: "bytes32",
            name: "hash"
        }
    ],
    [
        "bytes32 r",
        {
            type: "bytes32",
            name: "r"
        }
    ],
    [
        "bytes32 root",
        {
            type: "bytes32",
            name: "root"
        }
    ],
    [
        "bytes32 s",
        {
            type: "bytes32",
            name: "s"
        }
    ],
    [
        "string name",
        {
            type: "string",
            name: "name"
        }
    ],
    [
        "string symbol",
        {
            type: "string",
            name: "symbol"
        }
    ],
    [
        "string tokenURI",
        {
            type: "string",
            name: "tokenURI"
        }
    ],
    [
        "uint tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint8 v",
        {
            type: "uint8",
            name: "v"
        }
    ],
    [
        "uint256 balance",
        {
            type: "uint256",
            name: "balance"
        }
    ],
    [
        "uint256 tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint256 value",
        {
            type: "uint256",
            name: "value"
        }
    ],
    // Indexed
    [
        "event:address indexed from",
        {
            type: "address",
            name: "from",
            indexed: true
        }
    ],
    [
        "event:address indexed to",
        {
            type: "address",
            name: "to",
            indexed: true
        }
    ],
    [
        "event:uint indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ],
    [
        "event:uint256 indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ]
]);

});




parcelRegister("bsCQg", function(module, exports) {

$parcel$export(module.exports, "parseAccount", function () { return $8580707087a6ab4e$export$11027cbf6cf15da2; });
function $8580707087a6ab4e$export$11027cbf6cf15da2(account) {
    if (typeof account === "string") return {
        address: account,
        type: "json-rpc"
    };
    return account;
}

});

parcelRegister("jOWIL", function(module, exports) {

$parcel$export(module.exports, "multicall3Abi", function () { return $e6e03c96bec38d87$export$4e233219477ffb48; });
$parcel$export(module.exports, "universalResolverResolveAbi", function () { return $e6e03c96bec38d87$export$400f1d40cf4f98fe; });
$parcel$export(module.exports, "universalResolverReverseAbi", function () { return $e6e03c96bec38d87$export$fd0db820daeebac9; });
$parcel$export(module.exports, "textResolverAbi", function () { return $e6e03c96bec38d87$export$4e6990b9fd834e88; });
$parcel$export(module.exports, "addressResolverAbi", function () { return $e6e03c96bec38d87$export$4c61cc2994c5d90b; });
/* [Multicall3](https://github.com/mds1/multicall) */ const $e6e03c96bec38d87$export$4e233219477ffb48 = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "allowFailure",
                        type: "bool"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate3",
        outputs: [
            {
                components: [
                    {
                        name: "success",
                        type: "bool"
                    },
                    {
                        name: "returnData",
                        type: "bytes"
                    }
                ],
                name: "returnData",
                type: "tuple[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $e6e03c96bec38d87$var$universalResolverErrors = [
    {
        inputs: [],
        name: "ResolverNotFound",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverWildcardNotSupported",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverNotContract",
        type: "error"
    },
    {
        inputs: [
            {
                name: "returnData",
                type: "bytes"
            }
        ],
        name: "ResolverError",
        type: "error"
    },
    {
        inputs: [
            {
                components: [
                    {
                        name: "status",
                        type: "uint16"
                    },
                    {
                        name: "message",
                        type: "string"
                    }
                ],
                name: "errors",
                type: "tuple[]"
            }
        ],
        name: "HttpError",
        type: "error"
    }
];
const $e6e03c96bec38d87$export$400f1d40cf4f98fe = [
    ...$e6e03c96bec38d87$var$universalResolverErrors,
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    },
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            },
            {
                name: "gateways",
                type: "string[]"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    }
];
const $e6e03c96bec38d87$export$fd0db820daeebac9 = [
    ...$e6e03c96bec38d87$var$universalResolverErrors,
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    },
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            },
            {
                type: "string[]",
                name: "gateways"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    }
];
const $e6e03c96bec38d87$export$4e6990b9fd834e88 = [
    {
        name: "text",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "key",
                type: "string"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    }
];
const $e6e03c96bec38d87$export$4c61cc2994c5d90b = [
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "coinType",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            }
        ]
    }
];
const $e6e03c96bec38d87$export$429a705aa5b352c0 = [
    {
        name: "isValidSignature",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "hash",
                type: "bytes32"
            },
            {
                name: "signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes4"
            }
        ]
    }
];
const $e6e03c96bec38d87$export$b10682c3fa53fbd1 = [
    {
        inputs: [
            {
                name: "_signer",
                type: "address"
            },
            {
                name: "_hash",
                type: "bytes32"
            },
            {
                name: "_signature",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    }
];
const $e6e03c96bec38d87$export$891152826cc2370a = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
const $e6e03c96bec38d87$export$1c8d119bf9c799eb = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
const $e6e03c96bec38d87$export$da6511eb7df6e9f8 = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                name: "approved",
                type: "bool"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "payable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "getApproved",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "isApprovedForAll",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "operator",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "ownerOf",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "owner",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "id",
                type: "uint256"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "setApprovalForAll",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "operator",
                type: "address"
            },
            {
                name: "approved",
                type: "bool"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenURI",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "tokeId",
                type: "uint256"
            }
        ],
        outputs: []
    }
];
const $e6e03c96bec38d87$export$82934a3bb3a99370 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                name: "assetTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxDeposit",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxMint",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxRedeem",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxWithdraw",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewDeposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewMint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewRedeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewWithdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                name: "totalManagedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];

});

parcelRegister("iopTA", function(module, exports) {

$parcel$export(module.exports, "aggregate3Signature", function () { return $d63e8e2dab612cf3$export$25fd9a7ba13a8409; });
const $d63e8e2dab612cf3$export$25fd9a7ba13a8409 = "0x82ad56cb";

});

parcelRegister("j0j3E", function(module, exports) {

$parcel$export(module.exports, "deploylessCallViaBytecodeBytecode", function () { return $dd5ccceda8e3315d$export$b8650f6504de1536; });
$parcel$export(module.exports, "deploylessCallViaFactoryBytecode", function () { return $dd5ccceda8e3315d$export$b03493bdbcb80605; });
const $dd5ccceda8e3315d$export$b8650f6504de1536 = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe";
const $dd5ccceda8e3315d$export$b03493bdbcb80605 = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe";
const $dd5ccceda8e3315d$export$76c7202cd92b9dbb = "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";

});

parcelRegister("jOG4f", function(module, exports) {

$parcel$export(module.exports, "ChainDoesNotSupportContract", function () { return $e6d3518cfb7c558f$export$f2b2bfa70417796b; });
$parcel$export(module.exports, "ChainMismatchError", function () { return $e6d3518cfb7c558f$export$535d82255cc17992; });
$parcel$export(module.exports, "ChainNotFoundError", function () { return $e6d3518cfb7c558f$export$b7f33b26fea1ae0b; });
$parcel$export(module.exports, "ClientChainNotConfiguredError", function () { return $e6d3518cfb7c558f$export$64807f0e18658482; });

var $gzjWc = parcelRequire("gzjWc");
class $e6d3518cfb7c558f$export$f2b2bfa70417796b extends (0, $gzjWc.BaseError) {
    constructor({ blockNumber: blockNumber, chain: chain, contract: contract }){
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                "This could be due to any of the following:",
                ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                    `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
                ] : [
                    `- The chain does not have the contract "${contract.name}" configured.`
                ]
            ],
            name: "ChainDoesNotSupportContract"
        });
    }
}
class $e6d3518cfb7c558f$export$535d82255cc17992 extends (0, $gzjWc.BaseError) {
    constructor({ chain: chain, currentChainId: currentChainId }){
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u{2013} ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} \u{2013} ${chain.name}`
            ],
            name: "ChainMismatchError"
        });
    }
}
class $e6d3518cfb7c558f$export$b7f33b26fea1ae0b extends (0, $gzjWc.BaseError) {
    constructor(){
        super([
            "No chain was provided to the request.",
            "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
        ].join("\n"), {
            name: "ChainNotFoundError"
        });
    }
}
class $e6d3518cfb7c558f$export$64807f0e18658482 extends (0, $gzjWc.BaseError) {
    constructor(){
        super("No chain was provided to the Client.", {
            name: "ClientChainNotConfiguredError"
        });
    }
}
class $e6d3518cfb7c558f$export$4836eb835ffca5b2 extends (0, $gzjWc.BaseError) {
    constructor({ chainId: chainId }){
        super(typeof chainId === "number" ? `Chain ID "${chainId}" is invalid.` : "Chain ID is invalid.", {
            name: "InvalidChainIdError"
        });
    }
}

});

parcelRegister("69Kmp", function(module, exports) {

$parcel$export(module.exports, "CallExecutionError", function () { return $47b78b8e67175d55$export$e67b04e2cd29b7d; });
$parcel$export(module.exports, "ContractFunctionExecutionError", function () { return $47b78b8e67175d55$export$399e62fddbe24423; });
$parcel$export(module.exports, "ContractFunctionRevertedError", function () { return $47b78b8e67175d55$export$b3a6b9663001535f; });
$parcel$export(module.exports, "ContractFunctionZeroDataError", function () { return $47b78b8e67175d55$export$46f5208cdcd5a621; });
$parcel$export(module.exports, "CounterfactualDeploymentFailedError", function () { return $47b78b8e67175d55$export$4fec38f081e68d02; });
$parcel$export(module.exports, "RawContractError", function () { return $47b78b8e67175d55$export$5b877bc4d7d9d460; });

var $bsCQg = parcelRequire("bsCQg");

var $8hnaT = parcelRequire("8hnaT");

var $kSxVm = parcelRequire("kSxVm");

var $3Q81D = parcelRequire("3Q81D");

var $gNG7V = parcelRequire("gNG7V");

var $83D0b = parcelRequire("83D0b");

var $ag3Uj = parcelRequire("ag3Uj");

var $a6AVd = parcelRequire("a6AVd");

var $ckWn0 = parcelRequire("ckWn0");

var $gzjWc = parcelRequire("gzjWc");

var $2fVPr = parcelRequire("2fVPr");

var $kIOz8 = parcelRequire("kIOz8");

var $4oCKZ = parcelRequire("4oCKZ");
class $47b78b8e67175d55$export$e67b04e2cd29b7d extends (0, $gzjWc.BaseError) {
    constructor(cause, { account: account_, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride }){
        const account = account_ ? (0, $bsCQg.parseAccount)(account_) : undefined;
        let prettyArgs = (0, $kIOz8.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $ag3Uj.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $a6AVd.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $a6AVd.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $a6AVd.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        if (stateOverride) prettyArgs += `\n${(0, $2fVPr.prettyStateOverride)(stateOverride)}`;
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Raw Call Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "CallExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $47b78b8e67175d55$export$399e62fddbe24423 extends (0, $gzjWc.BaseError) {
    constructor(cause, { abi: abi, args: args, contractAddress: contractAddress, docsPath: docsPath, functionName: functionName, sender: sender }){
        const abiItem = (0, $83D0b.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        const formattedArgs = abiItem ? (0, $gNG7V.formatAbiItemWithArgs)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        const functionWithParams = abiItem ? (0, $3Q81D.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        const prettyArgs = (0, $kIOz8.prettyPrint)({
            address: contractAddress && (0, $4oCKZ.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== "()" && `${[
                ...Array(functionName?.length ?? 0).keys()
            ].map(()=>" ").join("")}${formattedArgs}`,
            sender: sender
        });
        super(cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                prettyArgs && "Contract Call:",
                prettyArgs
            ].filter(Boolean),
            name: "ContractFunctionExecutionError"
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class $47b78b8e67175d55$export$b3a6b9663001535f extends (0, $gzjWc.BaseError) {
    constructor({ abi: abi, data: data, functionName: functionName, message: message }){
        let cause;
        let decodedData = undefined;
        let metaMessages;
        let reason;
        if (data && data !== "0x") try {
            decodedData = (0, $kSxVm.decodeErrorResult)({
                abi: abi,
                data: data
            });
            const { abiItem: abiItem, errorName: errorName, args: errorArgs } = decodedData;
            if (errorName === "Error") reason = errorArgs[0];
            else if (errorName === "Panic") {
                const [firstArg] = errorArgs;
                reason = (0, $8hnaT.panicReasons)[firstArg];
            } else {
                const errorWithParams = abiItem ? (0, $3Q81D.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                const formattedArgs = abiItem && errorArgs ? (0, $gNG7V.formatAbiItemWithArgs)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                metaMessages = [
                    errorWithParams ? `Error: ${errorWithParams}` : "",
                    formattedArgs && formattedArgs !== "()" ? `       ${[
                        ...Array(errorName?.length ?? 0).keys()
                    ].map(()=>" ").join("")}${formattedArgs}` : ""
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        let signature;
        if (cause instanceof (0, $ckWn0.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                "Make sure you are using the correct ABI and that the error exists on it.",
                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
            ];
        }
        super(reason && reason !== "execution reverted" || signature ? [
            `The contract function "${functionName}" reverted with the following ${signature ? "signature" : "reason"}:`,
            reason || signature
        ].join("\n") : `The contract function "${functionName}" reverted.`, {
            cause: cause,
            metaMessages: metaMessages,
            name: "ContractFunctionRevertedError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.reason = reason;
        this.signature = signature;
    }
}
class $47b78b8e67175d55$export$46f5208cdcd5a621 extends (0, $gzjWc.BaseError) {
    constructor({ functionName: functionName }){
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                "This could be due to any of the following:",
                `  - The contract does not have the function "${functionName}",`,
                "  - The parameters passed to the contract function may be invalid, or",
                "  - The address is not a contract."
            ],
            name: "ContractFunctionZeroDataError"
        });
    }
}
class $47b78b8e67175d55$export$4fec38f081e68d02 extends (0, $gzjWc.BaseError) {
    constructor({ factory: factory }){
        super(`Deployment for counterfactual contract call failed${factory ? ` for factory "${factory}".` : ""}`, {
            metaMessages: [
                "Please ensure:",
                "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
                "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
            ],
            name: "CounterfactualDeploymentFailedError"
        });
    }
}
class $47b78b8e67175d55$export$5b877bc4d7d9d460 extends (0, $gzjWc.BaseError) {
    constructor({ data: data, message: message }){
        super(message || "", {
            name: "RawContractError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}

});
parcelRegister("gNG7V", function(module, exports) {

$parcel$export(module.exports, "formatAbiItemWithArgs", function () { return $c3b1e67925ef3083$export$5266ec2b0e3e9205; });

var $6nOtb = parcelRequire("6nOtb");
function $c3b1e67925ef3083$export$5266ec2b0e3e9205({ abiItem: abiItem, args: args, includeFunctionName: includeFunctionName = true, includeName: includeName = false }) {
    if (!("name" in abiItem)) return;
    if (!("inputs" in abiItem)) return;
    if (!abiItem.inputs) return;
    return `${includeFunctionName ? abiItem.name : ""}(${abiItem.inputs.map((input, i)=>`${includeName && input.name ? `${input.name}: ` : ""}${typeof args[i] === "object" ? (0, $6nOtb.stringify)(args[i]) : args[i]}`).join(", ")})`;
}

});

parcelRegister("83D0b", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", function () { return $5ddcdb87ae326aa2$export$99b134cd177e9574; });

var $ckWn0 = parcelRequire("ckWn0");

var $2ZAyo = parcelRequire("2ZAyo");

var $ca1JH = parcelRequire("ca1JH");

var $jM1NN = parcelRequire("jM1NN");

var $eiFaQ = parcelRequire("eiFaQ");
function $5ddcdb87ae326aa2$export$99b134cd177e9574(parameters) {
    const { abi: abi, args: args = [], name: name } = parameters;
    const isSelector = (0, $2ZAyo.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $eiFaQ.toFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $jM1NN.toEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $5ddcdb87ae326aa2$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $5ddcdb87ae326aa2$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $ckWn0.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $5ddcdb87ae326aa2$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $ca1JH.isAddress)(arg, {
                strict: false
            });
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $5ddcdb87ae326aa2$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$5ddcdb87ae326aa2$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $5ddcdb87ae326aa2$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $5ddcdb87ae326aa2$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $ca1JH.isAddress)(args[parameterIndex], {
                strict: false
            });
            if (types.includes("address") && types.includes("bytes")) return (0, $ca1JH.isAddress)(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("jM1NN", function(module, exports) {

$parcel$export(module.exports, "toEventSelector", function () { return $e653e5e9b60624c4$export$351f40ec61b2972; });

var $bfIVS = parcelRequire("bfIVS");
const $e653e5e9b60624c4$export$351f40ec61b2972 = (0, $bfIVS.toSignatureHash);

});


parcelRegister("ag3Uj", function(module, exports) {

$parcel$export(module.exports, "formatEther", function () { return $777e6de5755fa2cd$export$11bc63b4c03ea518; });

var $ceSUN = parcelRequire("ceSUN");

var $94Fzw = parcelRequire("94Fzw");
function $777e6de5755fa2cd$export$11bc63b4c03ea518(wei, unit = "wei") {
    return (0, $94Fzw.formatUnits)(wei, (0, $ceSUN.etherUnits)[unit]);
}

});
parcelRegister("ceSUN", function(module, exports) {

$parcel$export(module.exports, "etherUnits", function () { return $8e9163d96f43583f$export$5bbd813111ed9646; });
$parcel$export(module.exports, "gweiUnits", function () { return $8e9163d96f43583f$export$a26120bf8be88528; });
$parcel$export(module.exports, "weiUnits", function () { return $8e9163d96f43583f$export$b959b3594ea07183; });
const $8e9163d96f43583f$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $8e9163d96f43583f$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $8e9163d96f43583f$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("94Fzw", function(module, exports) {

$parcel$export(module.exports, "formatUnits", function () { return $69b4bc1a9569d727$export$bd39b96f71da1885; });
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $69b4bc1a9569d727$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, "");
    return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

});


parcelRegister("a6AVd", function(module, exports) {

$parcel$export(module.exports, "formatGwei", function () { return $75b71acee5ffc2d2$export$a716d64a7f646b61; });

var $ceSUN = parcelRequire("ceSUN");

var $94Fzw = parcelRequire("94Fzw");
function $75b71acee5ffc2d2$export$a716d64a7f646b61(wei, unit = "wei") {
    return (0, $94Fzw.formatUnits)(wei, (0, $ceSUN.gweiUnits)[unit]);
}

});

parcelRegister("2fVPr", function(module, exports) {

$parcel$export(module.exports, "AccountStateConflictError", function () { return $1a49d70ad3d68881$export$eb92af66de2d34c1; });
$parcel$export(module.exports, "StateAssignmentConflictError", function () { return $1a49d70ad3d68881$export$3f829f5a43fdcc2e; });
$parcel$export(module.exports, "prettyStateOverride", function () { return $1a49d70ad3d68881$export$d08c47f9c4a87c67; });

var $gzjWc = parcelRequire("gzjWc");
class $1a49d70ad3d68881$export$eb92af66de2d34c1 extends (0, $gzjWc.BaseError) {
    constructor({ address: address }){
        super(`State for account "${address}" is set multiple times.`, {
            name: "AccountStateConflictError"
        });
    }
}
class $1a49d70ad3d68881$export$3f829f5a43fdcc2e extends (0, $gzjWc.BaseError) {
    constructor(){
        super("state and stateDiff are set on the same account.", {
            name: "StateAssignmentConflictError"
        });
    }
}
function $1a49d70ad3d68881$export$4afb15becff191ad(stateMapping) {
    return stateMapping.reduce((pretty, { slot: slot, value: value })=>{
        return `${pretty}        ${slot}: ${value}\n`;
    }, "");
}
function $1a49d70ad3d68881$export$d08c47f9c4a87c67(stateOverride) {
    return stateOverride.reduce((pretty, { address: address, ...state })=>{
        let val = `${pretty}    ${address}:\n`;
        if (state.nonce) val += `      nonce: ${state.nonce}\n`;
        if (state.balance) val += `      balance: ${state.balance}\n`;
        if (state.code) val += `      code: ${state.code}\n`;
        if (state.state) {
            val += "      state:\n";
            val += $1a49d70ad3d68881$export$4afb15becff191ad(state.state);
        }
        if (state.stateDiff) {
            val += "      stateDiff:\n";
            val += $1a49d70ad3d68881$export$4afb15becff191ad(state.stateDiff);
        }
        return val;
    }, "  State Override:\n").slice(0, -1);
}

});

parcelRegister("kIOz8", function(module, exports) {

$parcel$export(module.exports, "prettyPrint", function () { return $f15f23fa9263dc2b$export$cde3d1388a9feac3; });
$parcel$export(module.exports, "FeeConflictError", function () { return $f15f23fa9263dc2b$export$4e13f9693b10724d; });
$parcel$export(module.exports, "InvalidSerializableTransactionError", function () { return $f15f23fa9263dc2b$export$f2282ba9c8899971; });
$parcel$export(module.exports, "TransactionExecutionError", function () { return $f15f23fa9263dc2b$export$17fc407b5aeb1e96; });
$parcel$export(module.exports, "TransactionNotFoundError", function () { return $f15f23fa9263dc2b$export$23c42bc218867b7c; });
$parcel$export(module.exports, "TransactionReceiptNotFoundError", function () { return $f15f23fa9263dc2b$export$df65591684d92652; });
$parcel$export(module.exports, "WaitForTransactionReceiptTimeoutError", function () { return $f15f23fa9263dc2b$export$69578a09754f4b33; });

var $ag3Uj = parcelRequire("ag3Uj");

var $a6AVd = parcelRequire("a6AVd");

var $gzjWc = parcelRequire("gzjWc");
function $f15f23fa9263dc2b$export$cde3d1388a9feac3(args) {
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
class $f15f23fa9263dc2b$export$4e13f9693b10724d extends (0, $gzjWc.BaseError) {
    constructor(){
        super([
            "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
            "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
        ].join("\n"), {
            name: "FeeConflictError"
        });
    }
}
class $f15f23fa9263dc2b$export$8ffce3f13fa2ade4 extends (0, $gzjWc.BaseError) {
    constructor({ v: v }){
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`, {
            name: "InvalidLegacyVError"
        });
    }
}
class $f15f23fa9263dc2b$export$f2282ba9c8899971 extends (0, $gzjWc.BaseError) {
    constructor({ transaction: transaction }){
        super("Cannot infer a transaction type from provided transaction.", {
            metaMessages: [
                "Provided Transaction:",
                "{",
                $f15f23fa9263dc2b$export$cde3d1388a9feac3(transaction),
                "}",
                "",
                "To infer the type, either provide:",
                "- a `type` to the Transaction, or",
                "- an EIP-1559 Transaction with `maxFeePerGas`, or",
                "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
                "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
                "- an EIP-7702 Transaction with `authorizationList`, or",
                "- a Legacy Transaction with `gasPrice`"
            ],
            name: "InvalidSerializableTransactionError"
        });
    }
}
class $f15f23fa9263dc2b$export$e410925d6bb07863 extends (0, $gzjWc.BaseError) {
    constructor({ serializedType: serializedType }){
        super(`Serialized transaction type "${serializedType}" is invalid.`, {
            name: "InvalidSerializedTransactionType"
        });
        Object.defineProperty(this, "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedType = serializedType;
    }
}
class $f15f23fa9263dc2b$export$75fa267d8b74b3b9 extends (0, $gzjWc.BaseError) {
    constructor({ attributes: attributes, serializedTransaction: serializedTransaction, type: type }){
        const missing = Object.entries(attributes).map(([key, value])=>typeof value === "undefined" ? key : undefined).filter(Boolean);
        super(`Invalid serialized transaction of type "${type}" was provided.`, {
            metaMessages: [
                `Serialized Transaction: "${serializedTransaction}"`,
                missing.length > 0 ? `Missing Attributes: ${missing.join(", ")}` : ""
            ].filter(Boolean),
            name: "InvalidSerializedTransactionError"
        });
        Object.defineProperty(this, "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedTransaction = serializedTransaction;
        this.type = type;
    }
}
class $f15f23fa9263dc2b$export$f5e370fd7cd91580 extends (0, $gzjWc.BaseError) {
    constructor({ storageKey: storageKey }){
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`, {
            name: "InvalidStorageKeySizeError"
        });
    }
}
class $f15f23fa9263dc2b$export$17fc407b5aeb1e96 extends (0, $gzjWc.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = $f15f23fa9263dc2b$export$cde3d1388a9feac3({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $ag3Uj.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $a6AVd.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $a6AVd.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $a6AVd.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Request Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "TransactionExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $f15f23fa9263dc2b$export$23c42bc218867b7c extends (0, $gzjWc.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, hash: hash, index: index }){
        let identifier = "Transaction";
        if (blockTag && index !== undefined) identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined) identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined) identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash) identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`, {
            name: "TransactionNotFoundError"
        });
    }
}
class $f15f23fa9263dc2b$export$df65591684d92652 extends (0, $gzjWc.BaseError) {
    constructor({ hash: hash }){
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`, {
            name: "TransactionReceiptNotFoundError"
        });
    }
}
class $f15f23fa9263dc2b$export$69578a09754f4b33 extends (0, $gzjWc.BaseError) {
    constructor({ hash: hash }){
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`, {
            name: "WaitForTransactionReceiptTimeoutError"
        });
    }
}

});


parcelRegister("1DT5P", function(module, exports) {

$parcel$export(module.exports, "decodeFunctionResult", function () { return $13242b4c9a432e24$export$3a05a90c230f925; });

var $ckWn0 = parcelRequire("ckWn0");

var $024z9 = parcelRequire("024z9");

var $83D0b = parcelRequire("83D0b");
const $13242b4c9a432e24$var$docsPath = "/docs/contract/decodeFunctionResult";
function $13242b4c9a432e24$export$3a05a90c230f925(parameters) {
    const { abi: abi, args: args, functionName: functionName, data: data } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $83D0b.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $ckWn0.AbiFunctionNotFoundError)(functionName, {
            docsPath: $13242b4c9a432e24$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $ckWn0.AbiFunctionNotFoundError)(undefined, {
        docsPath: $13242b4c9a432e24$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $ckWn0.AbiFunctionOutputsNotFoundError)(abiItem.name, {
        docsPath: $13242b4c9a432e24$var$docsPath
    });
    const values = (0, $024z9.decodeAbiParameters)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}

});

parcelRegister("dvHq1", function(module, exports) {

$parcel$export(module.exports, "encodeDeployData", function () { return $9d5fd9a7779a36b2$export$d7a7276006273fbd; });

var $ckWn0 = parcelRequire("ckWn0");

var $fwEJN = parcelRequire("fwEJN");

var $hFEYz = parcelRequire("hFEYz");
const $9d5fd9a7779a36b2$var$docsPath = "/docs/contract/encodeDeployData";
function $9d5fd9a7779a36b2$export$d7a7276006273fbd(parameters) {
    const { abi: abi, args: args, bytecode: bytecode } = parameters;
    if (!args || args.length === 0) return bytecode;
    const description = abi.find((x)=>"type" in x && x.type === "constructor");
    if (!description) throw new (0, $ckWn0.AbiConstructorNotFoundError)({
        docsPath: $9d5fd9a7779a36b2$var$docsPath
    });
    if (!("inputs" in description)) throw new (0, $ckWn0.AbiConstructorParamsNotFoundError)({
        docsPath: $9d5fd9a7779a36b2$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $ckWn0.AbiConstructorParamsNotFoundError)({
        docsPath: $9d5fd9a7779a36b2$var$docsPath
    });
    const data = (0, $hFEYz.encodeAbiParameters)(description.inputs, args);
    return (0, $fwEJN.concatHex)([
        bytecode,
        data
    ]);
}

});

parcelRegister("cA21A", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", function () { return $928a6ae378cecbae$export$f4ee15df45da9f03; });

var $fwEJN = parcelRequire("fwEJN");

var $hFEYz = parcelRequire("hFEYz");

var $xGWsp = parcelRequire("xGWsp");
function $928a6ae378cecbae$export$f4ee15df45da9f03(parameters) {
    const { args: args } = parameters;
    const { abi: abi, functionName: functionName } = (()=>{
        if (parameters.abi.length === 1 && parameters.functionName?.startsWith("0x")) return parameters;
        return (0, $xGWsp.prepareEncodeFunctionData)(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $hFEYz.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $fwEJN.concatHex)([
        signature,
        data ?? "0x"
    ]);
}

});
parcelRegister("xGWsp", function(module, exports) {

$parcel$export(module.exports, "prepareEncodeFunctionData", function () { return $0654648a7b3835e8$export$bb3e0a434581ff8; });

var $ckWn0 = parcelRequire("ckWn0");

var $eiFaQ = parcelRequire("eiFaQ");

var $3Q81D = parcelRequire("3Q81D");

var $83D0b = parcelRequire("83D0b");
const $0654648a7b3835e8$var$docsPath = "/docs/contract/encodeFunctionData";
function $0654648a7b3835e8$export$bb3e0a434581ff8(parameters) {
    const { abi: abi, args: args, functionName: functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $83D0b.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $ckWn0.AbiFunctionNotFoundError)(functionName, {
            docsPath: $0654648a7b3835e8$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $ckWn0.AbiFunctionNotFoundError)(undefined, {
        docsPath: $0654648a7b3835e8$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $eiFaQ.toFunctionSelector)((0, $3Q81D.formatAbiItem)(abiItem))
    };
}

});


parcelRegister("1oOKa", function(module, exports) {

$parcel$export(module.exports, "getChainContractAddress", function () { return $104f64f660e98658$export$cf4414608a078996; });

var $jOG4f = parcelRequire("jOG4f");
function $104f64f660e98658$export$cf4414608a078996({ blockNumber: blockNumber, chain: chain, contract: name }) {
    const contract = chain?.contracts?.[name];
    if (!contract) throw new (0, $jOG4f.ChainDoesNotSupportContract)({
        chain: chain,
        contract: {
            name: name
        }
    });
    if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new (0, $jOG4f.ChainDoesNotSupportContract)({
        blockNumber: blockNumber,
        chain: chain,
        contract: {
            name: name,
            blockCreated: contract.blockCreated
        }
    });
    return contract.address;
}

});

parcelRegister("2bj53", function(module, exports) {

$parcel$export(module.exports, "getCallError", function () { return $196b68d27064cb7a$export$7a3a4dfb724485e1; });

var $69Kmp = parcelRequire("69Kmp");

var $lpgkb = parcelRequire("lpgkb");

var $leBvp = parcelRequire("leBvp");
function $196b68d27064cb7a$export$7a3a4dfb724485e1(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $leBvp.getNodeError)(err, args);
        if (cause instanceof (0, $lpgkb.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $69Kmp.CallExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("lpgkb", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", function () { return $f9589879453c7e56$export$a558573a20f90d54; });
$parcel$export(module.exports, "FeeCapTooHighError", function () { return $f9589879453c7e56$export$63c545de2a2ec844; });
$parcel$export(module.exports, "FeeCapTooLowError", function () { return $f9589879453c7e56$export$dbd5936ae1758966; });
$parcel$export(module.exports, "NonceTooHighError", function () { return $f9589879453c7e56$export$6147426561fdc965; });
$parcel$export(module.exports, "NonceTooLowError", function () { return $f9589879453c7e56$export$2bb6d6395b589b3b; });
$parcel$export(module.exports, "NonceMaxValueError", function () { return $f9589879453c7e56$export$71cf1d500f9be262; });
$parcel$export(module.exports, "InsufficientFundsError", function () { return $f9589879453c7e56$export$b276096bbba16879; });
$parcel$export(module.exports, "IntrinsicGasTooHighError", function () { return $f9589879453c7e56$export$7ad883b4998b9615; });
$parcel$export(module.exports, "IntrinsicGasTooLowError", function () { return $f9589879453c7e56$export$813ccdcce0428bcf; });
$parcel$export(module.exports, "TransactionTypeNotSupportedError", function () { return $f9589879453c7e56$export$a20c52a8beca5c20; });
$parcel$export(module.exports, "TipAboveFeeCapError", function () { return $f9589879453c7e56$export$6ef9dd5e2f836046; });
$parcel$export(module.exports, "UnknownNodeError", function () { return $f9589879453c7e56$export$d6085363229de344; });

var $a6AVd = parcelRequire("a6AVd");

var $gzjWc = parcelRequire("gzjWc");
class $f9589879453c7e56$export$a558573a20f90d54 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, message: message } = {}){
        const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
        super(`Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`, {
            cause: cause,
            name: "ExecutionRevertedError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($f9589879453c7e56$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
class $f9589879453c7e56$export$63c545de2a2ec844 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $a6AVd.formatGwei)(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause: cause,
            name: "FeeCapTooHighError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class $f9589879453c7e56$export$dbd5936ae1758966 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $a6AVd.formatGwei)(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`, {
            cause: cause,
            name: "FeeCapTooLowError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $f9589879453c7e56$export$6147426561fdc965 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`, {
            cause: cause,
            name: "NonceTooHighError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class $f9589879453c7e56$export$2bb6d6395b589b3b extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
            "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
        ].join("\n"), {
            cause: cause,
            name: "NonceTooLowError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class $f9589879453c7e56$export$71cf1d500f9be262 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`, {
            cause: cause,
            name: "NonceMaxValueError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
class $f9589879453c7e56$export$b276096bbba16879 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause } = {}){
        super([
            "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
        ].join("\n"), {
            cause: cause,
            metaMessages: [
                "This error could arise when the account does not have enough funds to:",
                " - pay for the total gas fee,",
                " - pay for the value to send.",
                " ",
                "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
                " - `gas` is the amount of gas needed for transaction to execute,",
                " - `gas fee` is the gas fee,",
                " - `value` is the amount of ether to send to the recipient."
            ],
            name: "InsufficientFundsError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds|exceeds transaction sender account balance/
});
class $f9589879453c7e56$export$7ad883b4998b9615 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
            cause: cause,
            name: "IntrinsicGasTooHighError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class $f9589879453c7e56$export$813ccdcce0428bcf extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`, {
            cause: cause,
            name: "IntrinsicGasTooLowError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class $f9589879453c7e56$export$a20c52a8beca5c20 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause }){
        super("The transaction type is not supported for this chain.", {
            cause: cause,
            name: "TransactionTypeNotSupportedError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class $f9589879453c7e56$export$6ef9dd5e2f836046 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas } = {}){
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${(0, $a6AVd.formatGwei)(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $a6AVd.formatGwei)(maxFeePerGas)} gwei` : ""}).`
        ].join("\n"), {
            cause: cause,
            name: "TipAboveFeeCapError"
        });
    }
}
Object.defineProperty($f9589879453c7e56$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class $f9589879453c7e56$export$d6085363229de344 extends (0, $gzjWc.BaseError) {
    constructor({ cause: cause }){
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause: cause,
            name: "UnknownNodeError"
        });
    }
}

});

parcelRegister("leBvp", function(module, exports) {

$parcel$export(module.exports, "getNodeError", function () { return $f757ff97c6456e22$export$218ee3a1c831c34e; });

var $gzjWc = parcelRequire("gzjWc");

var $lpgkb = parcelRequire("lpgkb");

var $aMZh2 = parcelRequire("aMZh2");

var $b9XBB = parcelRequire("b9XBB");
function $f757ff97c6456e22$export$620efda101db5601(err) {
    return err instanceof (0, $b9XBB.TransactionRejectedRpcError) || err instanceof (0, $b9XBB.InvalidInputRpcError) || err instanceof (0, $aMZh2.RpcRequestError) && err.code === (0, $lpgkb.ExecutionRevertedError).code;
}
function $f757ff97c6456e22$export$218ee3a1c831c34e(err, args) {
    const message = (err.details || "").toLowerCase();
    const executionRevertedError = err instanceof (0, $gzjWc.BaseError) ? err.walk((e)=>e.code === (0, $lpgkb.ExecutionRevertedError).code) : err;
    if (executionRevertedError instanceof (0, $gzjWc.BaseError)) return new (0, $lpgkb.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $lpgkb.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $lpgkb.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $lpgkb.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $lpgkb.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $lpgkb.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $lpgkb.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $lpgkb.NonceTooHighError).nodeMessage.test(message)) return new (0, $lpgkb.NonceTooHighError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $lpgkb.NonceTooLowError).nodeMessage.test(message)) return new (0, $lpgkb.NonceTooLowError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $lpgkb.NonceMaxValueError).nodeMessage.test(message)) return new (0, $lpgkb.NonceMaxValueError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $lpgkb.InsufficientFundsError).nodeMessage.test(message)) return new (0, $lpgkb.InsufficientFundsError)({
        cause: err
    });
    if ((0, $lpgkb.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $lpgkb.IntrinsicGasTooHighError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $lpgkb.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $lpgkb.IntrinsicGasTooLowError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $lpgkb.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $lpgkb.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $lpgkb.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $lpgkb.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas,
        maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
    return new (0, $lpgkb.UnknownNodeError)({
        cause: err
    });
}

});
parcelRegister("b9XBB", function(module, exports) {

$parcel$export(module.exports, "ParseRpcError", function () { return $81fec55ef86ca2d5$export$aa31e6432f136746; });
$parcel$export(module.exports, "InvalidRequestRpcError", function () { return $81fec55ef86ca2d5$export$ff7b9f15f3eb8d4d; });
$parcel$export(module.exports, "MethodNotFoundRpcError", function () { return $81fec55ef86ca2d5$export$4c4044ac99c8d2d3; });
$parcel$export(module.exports, "InvalidParamsRpcError", function () { return $81fec55ef86ca2d5$export$c600faffd3cbd390; });
$parcel$export(module.exports, "InternalRpcError", function () { return $81fec55ef86ca2d5$export$4e62fafb20e19fd7; });
$parcel$export(module.exports, "InvalidInputRpcError", function () { return $81fec55ef86ca2d5$export$3ba2994324ab015e; });
$parcel$export(module.exports, "ResourceNotFoundRpcError", function () { return $81fec55ef86ca2d5$export$466772c50c6d6751; });
$parcel$export(module.exports, "ResourceUnavailableRpcError", function () { return $81fec55ef86ca2d5$export$270451347568a637; });
$parcel$export(module.exports, "TransactionRejectedRpcError", function () { return $81fec55ef86ca2d5$export$f714565c9176e28; });
$parcel$export(module.exports, "MethodNotSupportedRpcError", function () { return $81fec55ef86ca2d5$export$b106fe05a02d89c5; });
$parcel$export(module.exports, "LimitExceededRpcError", function () { return $81fec55ef86ca2d5$export$2c6f5ab73129d9d7; });
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", function () { return $81fec55ef86ca2d5$export$662f3764fa426a13; });
$parcel$export(module.exports, "UserRejectedRequestError", function () { return $81fec55ef86ca2d5$export$4af5b080d9e9e1a6; });
$parcel$export(module.exports, "UnauthorizedProviderError", function () { return $81fec55ef86ca2d5$export$cc1057a5779c7ffa; });
$parcel$export(module.exports, "UnsupportedProviderMethodError", function () { return $81fec55ef86ca2d5$export$6a557500ae315a49; });
$parcel$export(module.exports, "ProviderDisconnectedError", function () { return $81fec55ef86ca2d5$export$abb104bf1dd9c38b; });
$parcel$export(module.exports, "ChainDisconnectedError", function () { return $81fec55ef86ca2d5$export$ef186cf1cda0444; });
$parcel$export(module.exports, "SwitchChainError", function () { return $81fec55ef86ca2d5$export$d4ddb31968a9d366; });
$parcel$export(module.exports, "UnknownRpcError", function () { return $81fec55ef86ca2d5$export$bfc830e1ec76e31b; });

var $gzjWc = parcelRequire("gzjWc");

var $aMZh2 = parcelRequire("aMZh2");
const $81fec55ef86ca2d5$var$unknownErrorCode = -1;
class $81fec55ef86ca2d5$export$5460eff990f31920 extends (0, $gzjWc.BaseError) {
    constructor(cause, { code: code, docsPath: docsPath, metaMessages: metaMessages, name: name, shortMessage: shortMessage }){
        super(shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || cause?.metaMessages,
            name: name || "RpcError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name || cause.name;
        this.code = cause instanceof (0, $aMZh2.RpcRequestError) ? cause.code : code ?? $81fec55ef86ca2d5$var$unknownErrorCode;
    }
}
class $81fec55ef86ca2d5$export$417589b978208a8f extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause, options){
        super(cause, options);
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class $81fec55ef86ca2d5$export$aa31e6432f136746 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$aa31e6432f136746.code,
            name: "ParseRpcError",
            shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class $81fec55ef86ca2d5$export$ff7b9f15f3eb8d4d extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$ff7b9f15f3eb8d4d.code,
            name: "InvalidRequestRpcError",
            shortMessage: "JSON is not a valid request object."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class $81fec55ef86ca2d5$export$4c4044ac99c8d2d3 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $81fec55ef86ca2d5$export$4c4044ac99c8d2d3.code,
            name: "MethodNotFoundRpcError",
            shortMessage: `The method${method ? ` "${method}"` : ""} does not exist / is not available.`
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class $81fec55ef86ca2d5$export$c600faffd3cbd390 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$c600faffd3cbd390.code,
            name: "InvalidParamsRpcError",
            shortMessage: [
                "Invalid parameters were provided to the RPC method.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class $81fec55ef86ca2d5$export$4e62fafb20e19fd7 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$4e62fafb20e19fd7.code,
            name: "InternalRpcError",
            shortMessage: "An internal error was received."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class $81fec55ef86ca2d5$export$3ba2994324ab015e extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$3ba2994324ab015e.code,
            name: "InvalidInputRpcError",
            shortMessage: [
                "Missing or invalid parameters.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
class $81fec55ef86ca2d5$export$466772c50c6d6751 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$466772c50c6d6751.code,
            name: "ResourceNotFoundRpcError",
            shortMessage: "Requested resource not found."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceNotFoundRpcError"
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class $81fec55ef86ca2d5$export$270451347568a637 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$270451347568a637.code,
            name: "ResourceUnavailableRpcError",
            shortMessage: "Requested resource not available."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class $81fec55ef86ca2d5$export$f714565c9176e28 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$f714565c9176e28.code,
            name: "TransactionRejectedRpcError",
            shortMessage: "Transaction creation failed."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class $81fec55ef86ca2d5$export$b106fe05a02d89c5 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $81fec55ef86ca2d5$export$b106fe05a02d89c5.code,
            name: "MethodNotSupportedRpcError",
            shortMessage: `Method${method ? ` "${method}"` : ""} is not implemented.`
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class $81fec55ef86ca2d5$export$2c6f5ab73129d9d7 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$2c6f5ab73129d9d7.code,
            name: "LimitExceededRpcError",
            shortMessage: "Request exceeds defined limit."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class $81fec55ef86ca2d5$export$662f3764fa426a13 extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$662f3764fa426a13.code,
            name: "JsonRpcVersionUnsupportedError",
            shortMessage: "Version of JSON-RPC protocol is not supported."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
class $81fec55ef86ca2d5$export$4af5b080d9e9e1a6 extends $81fec55ef86ca2d5$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$4af5b080d9e9e1a6.code,
            name: "UserRejectedRequestError",
            shortMessage: "User rejected the request."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class $81fec55ef86ca2d5$export$cc1057a5779c7ffa extends $81fec55ef86ca2d5$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$cc1057a5779c7ffa.code,
            name: "UnauthorizedProviderError",
            shortMessage: "The requested method and/or account has not been authorized by the user."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class $81fec55ef86ca2d5$export$6a557500ae315a49 extends $81fec55ef86ca2d5$export$417589b978208a8f {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $81fec55ef86ca2d5$export$6a557500ae315a49.code,
            name: "UnsupportedProviderMethodError",
            shortMessage: `The Provider does not support the requested method${method ? ` " ${method}"` : ""}.`
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class $81fec55ef86ca2d5$export$abb104bf1dd9c38b extends $81fec55ef86ca2d5$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$abb104bf1dd9c38b.code,
            name: "ProviderDisconnectedError",
            shortMessage: "The Provider is disconnected from all chains."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class $81fec55ef86ca2d5$export$ef186cf1cda0444 extends $81fec55ef86ca2d5$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$ef186cf1cda0444.code,
            name: "ChainDisconnectedError",
            shortMessage: "The Provider is not connected to the requested chain."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class $81fec55ef86ca2d5$export$d4ddb31968a9d366 extends $81fec55ef86ca2d5$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $81fec55ef86ca2d5$export$d4ddb31968a9d366.code,
            name: "SwitchChainError",
            shortMessage: "An error occurred when attempting to switch chain."
        });
    }
}
Object.defineProperty($81fec55ef86ca2d5$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class $81fec55ef86ca2d5$export$bfc830e1ec76e31b extends $81fec55ef86ca2d5$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            name: "UnknownRpcError",
            shortMessage: "An unknown RPC error occurred."
        });
    }
}

});



parcelRegister("36Zbp", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $24416451910af665$export$f9380c9a627682d3; });
/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $24416451910af665$export$f9380c9a627682d3(value_, { format: format }) {
    if (!format) return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys){
            if (key in value_) value[key] = value_[key];
            if (formatted[key] && typeof formatted[key] === "object" && !Array.isArray(formatted[key])) extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

});

parcelRegister("cdG5Y", function(module, exports) {

$parcel$export(module.exports, "formatTransactionRequest", function () { return $8e575a30f4a882f7$export$d23fcba447c86a8e; });

var $8syAN = parcelRequire("8syAN");

var $9A1yP = parcelRequire("9A1yP");
const $8e575a30f4a882f7$export$b2a848539dcbb25f = {
    legacy: "0x0",
    eip2930: "0x1",
    eip1559: "0x2",
    eip4844: "0x3",
    eip7702: "0x4"
};
function $8e575a30f4a882f7$export$d23fcba447c86a8e(request) {
    const rpcRequest = {};
    if (typeof request.authorizationList !== "undefined") rpcRequest.authorizationList = $8e575a30f4a882f7$var$formatAuthorizationList(request.authorizationList);
    if (typeof request.accessList !== "undefined") rpcRequest.accessList = request.accessList;
    if (typeof request.blobVersionedHashes !== "undefined") rpcRequest.blobVersionedHashes = request.blobVersionedHashes;
    if (typeof request.blobs !== "undefined") {
        if (typeof request.blobs[0] !== "string") rpcRequest.blobs = request.blobs.map((x)=>(0, $8syAN.bytesToHex)(x));
        else rpcRequest.blobs = request.blobs;
    }
    if (typeof request.data !== "undefined") rpcRequest.data = request.data;
    if (typeof request.from !== "undefined") rpcRequest.from = request.from;
    if (typeof request.gas !== "undefined") rpcRequest.gas = (0, $8syAN.numberToHex)(request.gas);
    if (typeof request.gasPrice !== "undefined") rpcRequest.gasPrice = (0, $8syAN.numberToHex)(request.gasPrice);
    if (typeof request.maxFeePerBlobGas !== "undefined") rpcRequest.maxFeePerBlobGas = (0, $8syAN.numberToHex)(request.maxFeePerBlobGas);
    if (typeof request.maxFeePerGas !== "undefined") rpcRequest.maxFeePerGas = (0, $8syAN.numberToHex)(request.maxFeePerGas);
    if (typeof request.maxPriorityFeePerGas !== "undefined") rpcRequest.maxPriorityFeePerGas = (0, $8syAN.numberToHex)(request.maxPriorityFeePerGas);
    if (typeof request.nonce !== "undefined") rpcRequest.nonce = (0, $8syAN.numberToHex)(request.nonce);
    if (typeof request.to !== "undefined") rpcRequest.to = request.to;
    if (typeof request.type !== "undefined") rpcRequest.type = $8e575a30f4a882f7$export$b2a848539dcbb25f[request.type];
    if (typeof request.value !== "undefined") rpcRequest.value = (0, $8syAN.numberToHex)(request.value);
    return rpcRequest;
}
const $8e575a30f4a882f7$export$aba208618cee26e3 = /*#__PURE__*/ (0, $9A1yP.defineFormatter)("transactionRequest", $8e575a30f4a882f7$export$d23fcba447c86a8e);
//////////////////////////////////////////////////////////////////////////////
function $8e575a30f4a882f7$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            address: authorization.contractAddress,
            r: authorization.r,
            s: authorization.s,
            chainId: (0, $8syAN.numberToHex)(authorization.chainId),
            nonce: (0, $8syAN.numberToHex)(authorization.nonce),
            ...typeof authorization.yParity !== "undefined" ? {
                yParity: (0, $8syAN.numberToHex)(authorization.yParity)
            } : {},
            ...typeof authorization.v !== "undefined" && typeof authorization.yParity === "undefined" ? {
                v: (0, $8syAN.numberToHex)(authorization.v)
            } : {}
        }));
}

});
parcelRegister("9A1yP", function(module, exports) {

$parcel$export(module.exports, "defineFormatter", function () { return $6f98afc49b81576d$export$5d08535cc975931a; });
function $6f98afc49b81576d$export$5d08535cc975931a(type, format) {
    return ({ exclude: exclude, format: overrides })=>{
        return {
            exclude: exclude,
            format: (args)=>{
                const formatted = format(args);
                if (exclude) for (const key of exclude)delete formatted[key];
                return {
                    ...formatted,
                    ...overrides(args)
                };
            },
            type: type
        };
    };
}

});


parcelRegister("fNXI0", function(module, exports) {

$parcel$export(module.exports, "createBatchScheduler", function () { return $b819bf8c21a9ccd6$export$24d3fde68b7c4167; });
const $b819bf8c21a9ccd6$var$schedulerCache = /*#__PURE__*/ new Map();
function $b819bf8c21a9ccd6$export$24d3fde68b7c4167({ fn: fn, id: id, shouldSplitBatch: shouldSplitBatch, wait: wait = 0, sort: sort }) {
    const exec = async ()=>{
        const scheduler = getScheduler();
        flush();
        const args = scheduler.map(({ args: args })=>args);
        if (args.length === 0) return;
        fn(args).then((data)=>{
            if (sort && Array.isArray(data)) data.sort(sort);
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.resolve?.([
                    data[i],
                    data
                ]);
            }
        }).catch((err)=>{
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.reject?.(err);
            }
        });
    };
    const flush = ()=>$b819bf8c21a9ccd6$var$schedulerCache.delete(id);
    const getBatchedArgs = ()=>getScheduler().map(({ args: args })=>args);
    const getScheduler = ()=>$b819bf8c21a9ccd6$var$schedulerCache.get(id) || [];
    const setScheduler = (item)=>$b819bf8c21a9ccd6$var$schedulerCache.set(id, [
            ...getScheduler(),
            item
        ]);
    return {
        flush: flush,
        async schedule (args) {
            const pendingPromise = {};
            const promise = new Promise((resolve, reject)=>{
                pendingPromise.resolve = resolve;
                pendingPromise.reject = reject;
            });
            const split = shouldSplitBatch?.([
                ...getBatchedArgs(),
                args
            ]);
            if (split) exec();
            const hasActiveScheduler = getScheduler().length > 0;
            if (hasActiveScheduler) {
                setScheduler({
                    args: args,
                    pendingPromise: pendingPromise
                });
                return promise;
            }
            setScheduler({
                args: args,
                pendingPromise: pendingPromise
            });
            setTimeout(exec, wait);
            return promise;
        }
    };
}

});

parcelRegister("2Pi5m", function(module, exports) {

$parcel$export(module.exports, "serializeStateOverride", function () { return $20ee5f9657a070f6$export$f6da3c954eb711d6; });

var $c9lDF = parcelRequire("c9lDF");

var $k4fDS = parcelRequire("k4fDS");

var $2fVPr = parcelRequire("2fVPr");

var $ca1JH = parcelRequire("ca1JH");

var $8syAN = parcelRequire("8syAN");
function $20ee5f9657a070f6$export$29e73cd11b306a76(stateMapping) {
    if (!stateMapping || stateMapping.length === 0) return undefined;
    return stateMapping.reduce((acc, { slot: slot, value: value })=>{
        if (slot.length !== 66) throw new (0, $k4fDS.InvalidBytesLengthError)({
            size: slot.length,
            targetSize: 66,
            type: "hex"
        });
        if (value.length !== 66) throw new (0, $k4fDS.InvalidBytesLengthError)({
            size: value.length,
            targetSize: 66,
            type: "hex"
        });
        acc[slot] = value;
        return acc;
    }, {});
}
function $20ee5f9657a070f6$export$ff6c86decd3de345(parameters) {
    const { balance: balance, nonce: nonce, state: state, stateDiff: stateDiff, code: code } = parameters;
    const rpcAccountStateOverride = {};
    if (code !== undefined) rpcAccountStateOverride.code = code;
    if (balance !== undefined) rpcAccountStateOverride.balance = (0, $8syAN.numberToHex)(balance);
    if (nonce !== undefined) rpcAccountStateOverride.nonce = (0, $8syAN.numberToHex)(nonce);
    if (state !== undefined) rpcAccountStateOverride.state = $20ee5f9657a070f6$export$29e73cd11b306a76(state);
    if (stateDiff !== undefined) {
        if (rpcAccountStateOverride.state) throw new (0, $2fVPr.StateAssignmentConflictError)();
        rpcAccountStateOverride.stateDiff = $20ee5f9657a070f6$export$29e73cd11b306a76(stateDiff);
    }
    return rpcAccountStateOverride;
}
function $20ee5f9657a070f6$export$f6da3c954eb711d6(parameters) {
    if (!parameters) return undefined;
    const rpcStateOverride = {};
    for (const { address: address, ...accountState } of parameters){
        if (!(0, $ca1JH.isAddress)(address, {
            strict: false
        })) throw new (0, $c9lDF.InvalidAddressError)({
            address: address
        });
        if (rpcStateOverride[address]) throw new (0, $2fVPr.AccountStateConflictError)({
            address: address
        });
        rpcStateOverride[address] = $20ee5f9657a070f6$export$ff6c86decd3de345(accountState);
    }
    return rpcStateOverride;
}

});

parcelRegister("ea0OJ", function(module, exports) {

$parcel$export(module.exports, "assertRequest", function () { return $a4f2a224cf0cc3d6$export$5378021d985ceaf8; });

var $bsCQg = parcelRequire("bsCQg");

var $c9lDF = parcelRequire("c9lDF");

var $lpgkb = parcelRequire("lpgkb");

var $kIOz8 = parcelRequire("kIOz8");

var $ca1JH = parcelRequire("ca1JH");
function $a4f2a224cf0cc3d6$export$5378021d985ceaf8(args) {
    const { account: account_, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to } = args;
    const account = account_ ? (0, $bsCQg.parseAccount)(account_) : undefined;
    if (account && !(0, $ca1JH.isAddress)(account.address)) throw new (0, $c9lDF.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $ca1JH.isAddress)(to)) throw new (0, $c9lDF.InvalidAddressError)({
        address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new (0, $kIOz8.FeeConflictError)();
    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n) throw new (0, $lpgkb.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $lpgkb.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}

});

parcelRegister("iiC41", function(module, exports) {


module.exports = (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("712AS")).then(()=>parcelRequire("eNQ98"));

});


parcelRegister("8fINO", function(module, exports) {
"use strict";
var $60227a4a647a3475$var$has = Object.prototype.hasOwnProperty, $60227a4a647a3475$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $60227a4a647a3475$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $60227a4a647a3475$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $60227a4a647a3475$var$Events().__proto__) $60227a4a647a3475$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $60227a4a647a3475$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $60227a4a647a3475$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $60227a4a647a3475$var$EE(fn, context || emitter, once), evt = $60227a4a647a3475$var$prefix ? $60227a4a647a3475$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $60227a4a647a3475$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $60227a4a647a3475$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $60227a4a647a3475$var$EventEmitter() {
    this._events = new $60227a4a647a3475$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $60227a4a647a3475$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($60227a4a647a3475$var$has.call(events, name)) names.push($60227a4a647a3475$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $60227a4a647a3475$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $60227a4a647a3475$var$prefix ? $60227a4a647a3475$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $60227a4a647a3475$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $60227a4a647a3475$var$prefix ? $60227a4a647a3475$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $60227a4a647a3475$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $60227a4a647a3475$var$prefix ? $60227a4a647a3475$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $60227a4a647a3475$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $60227a4a647a3475$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $60227a4a647a3475$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $60227a4a647a3475$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $60227a4a647a3475$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $60227a4a647a3475$var$prefix ? $60227a4a647a3475$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $60227a4a647a3475$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $60227a4a647a3475$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $60227a4a647a3475$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $60227a4a647a3475$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $60227a4a647a3475$var$prefix ? $60227a4a647a3475$var$prefix + event : event;
        if (this._events[evt]) $60227a4a647a3475$var$clearEvent(this, evt);
    } else {
        this._events = new $60227a4a647a3475$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$60227a4a647a3475$var$EventEmitter.prototype.off = $60227a4a647a3475$var$EventEmitter.prototype.removeListener;
$60227a4a647a3475$var$EventEmitter.prototype.addListener = $60227a4a647a3475$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$60227a4a647a3475$var$EventEmitter.prefixed = $60227a4a647a3475$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$60227a4a647a3475$var$EventEmitter.EventEmitter = $60227a4a647a3475$var$EventEmitter;
module.exports = $60227a4a647a3475$var$EventEmitter;

});

parcelRegister("5AWy6", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("gGQKo")),
    (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("jXDuE"))
]).then(()=>parcelRequire("gERYg"));

});

parcelRegister("4dD0Q", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("gGQKo")),
    (parcelRequire("4GIuy"))((parcelRequire("Zsba3")).resolve("1owdM"))
]).then(()=>parcelRequire("6Hfwp"));

});

const $7acb69a91c2b4ceb$export$aafe1f751f1bc52a = {
    WALLET_CONNECT_CONNECTOR_ID: "walletConnect",
    INJECTED_CONNECTOR_ID: "injected",
    WALLET_STANDARD_CONNECTOR_ID: "announced",
    COINBASE_CONNECTOR_ID: "coinbaseWallet",
    COINBASE_SDK_CONNECTOR_ID: "coinbaseWalletSDK",
    SAFE_CONNECTOR_ID: "safe",
    LEDGER_CONNECTOR_ID: "ledger",
    EIP6963_CONNECTOR_ID: "eip6963",
    AUTH_CONNECTOR_ID: "w3mAuth",
    EIP155: "eip155",
    ADD_CHAIN_METHOD: "wallet_addEthereumChain",
    EIP6963_ANNOUNCE_EVENT: "eip6963:announceProvider",
    EIP6963_REQUEST_EVENT: "eip6963:requestProvider",
    CONNECTOR_RDNS_MAP: {
        coinbaseWallet: "com.coinbase.wallet",
        coinbaseWalletSDK: "com.coinbase.wallet"
    },
    VERSION: "5.1.4"
};



const $aa7460a2eaf4ba4c$export$fd35d6514357600 = {
    ConnectorExplorerIds: {
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID]: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927"
    },
    EIP155NetworkImageIds: {
        1: "ba0ba0cd-17c6-4806-ad93-f9d174f17900",
        42161: "3bff954d-5cb0-47a0-9a23-d20192e74600",
        43114: "30c46e53-e989-45fb-4549-be3bd4eb3b00",
        56: "93564157-2e8e-4ce7-81df-b264dbee9b00",
        250: "06b26297-fe0c-4733-5d6b-ffa5498aac00",
        10: "ab9c186a-c52f-464b-2906-ca59d760a400",
        137: "41d04d42-da3b-4453-8506-668cc0727900",
        100: "02b53f6a-e3d4-479e-1cb4-21178987d100",
        9001: "f926ff41-260d-4028-635e-91913fc28e00",
        324: "b310f07f-4ef7-49f3-7073-2a0a39685800",
        314: "5a73b3dd-af74-424e-cae0-0de859ee9400",
        4689: "34e68754-e536-40da-c153-6ef2e7188a00",
        1088: "3897a66d-40b9-4833-162f-a2c90531c900",
        1284: "161038da-44ae-4ec7-1208-0ea569454b00",
        1285: "f1d73bb6-5450-4e18-38f7-fb6484264a00",
        7777777: "845c60df-d429-4991-e687-91ae45791600",
        42220: "ab781bbc-ccc6-418d-d32d-789b15da1f00",
        8453: "7289c336-3981-4081-c5f4-efc26ac64a00",
        1313161554: "3ff73439-a619-4894-9262-4470c773a100",
        2020: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00",
        2021: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00",
        "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp": "a1b58899-f671-4276-6a5e-56ca5bd59700",
        "4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z": "a1b58899-f671-4276-6a5e-56ca5bd59700",
        EtWTRABZaYq6iMfeYKouRu166VU2xqa1: "a1b58899-f671-4276-6a5e-56ca5bd59700"
    },
    ConnectorImageIds: {
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "461db637-8616-43ce-035a-d89b8a1d5800",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "54a1aa77-d202-4f8d-0fb2-5d2bb6db0300",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "ef1a1fcf-7fe8-4d69-bd6d-fda1345b4400",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "07ba87ed-43aa-4adf-4540-9e6a2b9cae00"
    },
    ConnectorNamesMap: {
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "Browser Wallet",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "WalletConnect",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "Coinbase",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID]: "Coinbase",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "Ledger",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "Safe"
    },
    ConnectorTypesMap: {
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "INJECTED",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "WALLET_CONNECT",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID]: "ANNOUNCED",
        [(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID]: "AUTH"
    },
    WalletConnectRpcChainIds: [
        1,
        5,
        11155111,
        10,
        420,
        42161,
        421613,
        137,
        80001,
        42220,
        1313161554,
        1313161555,
        56,
        97,
        43114,
        43113,
        100,
        8453,
        84531,
        7777777,
        999,
        324,
        280
    ]
};



const $642418818623159c$export$518f198897991e39 = {
    getCaipTokens (tokens) {
        if (!tokens) return undefined;
        const caipTokens = {};
        Object.entries(tokens).forEach(([id, token])=>{
            caipTokens[`${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155}:${id}`] = token;
        });
        return caipTokens;
    }
};


var $655e84b374468e2f$export$d69f2df2005140cd;
(function(SocialProviderEnum) {
    SocialProviderEnum["Google"] = "google";
    SocialProviderEnum["Github"] = "github";
    SocialProviderEnum["Apple"] = "apple";
    SocialProviderEnum["Facebook"] = "facebook";
    SocialProviderEnum["X"] = "x";
    SocialProviderEnum["Discord"] = "discord";
    SocialProviderEnum["Farcaster"] = "farcaster";
})($655e84b374468e2f$export$d69f2df2005140cd || ($655e84b374468e2f$export$d69f2df2005140cd = {}));




parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $hxXs8 = parcelRequire("hxXs8");
var $d94Xg = parcelRequire("d94Xg");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $4DSpJ = parcelRequire("4DSpJ");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
var $8BVTM = parcelRequire("8BVTM");
var $1DdOF = parcelRequire("1DdOF");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
var $3Sg6l = parcelRequire("3Sg6l");
parcelRequire("kbczO");
var $jVNMm = parcelRequire("jVNMm");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
let $edee1d43f6d87414$var$isInitialized = false;



class $edee1d43f6d87414$export$fc94c40ea502fa4c {
    constructor(options){
        this.initPromise = undefined;
        this.setIsConnected = (isConnected, chain)=>{
            (0, $f7IXw.AccountController).setIsConnected(isConnected, chain);
        };
        this.getIsConnectedState = ()=>(0, $f7IXw.AccountController).state.isConnected;
        this.setAllAccounts = (addresses, chain)=>{
            (0, $f7IXw.AccountController).setAllAccounts(addresses, chain);
            (0, $8BVTM.OptionsController).setHasMultipleAddresses(addresses?.length > 1);
        };
        this.addAddressLabel = (address, label, chain)=>{
            (0, $f7IXw.AccountController).addAddressLabel(address, label, chain);
        };
        this.removeAddressLabel = (address, chain)=>{
            (0, $f7IXw.AccountController).removeAddressLabel(address, chain);
        };
        this.getCaipAddress = ()=>(0, $f7IXw.AccountController).state.caipAddress;
        this.setCaipAddress = (caipAddress, chain)=>{
            (0, $f7IXw.AccountController).setCaipAddress(caipAddress, chain);
        };
        this.setBalance = (balance, balanceSymbol, chain)=>{
            (0, $f7IXw.AccountController).setBalance(balance, balanceSymbol, chain);
        };
        this.setProfileName = (profileName, chain)=>{
            (0, $f7IXw.AccountController).setProfileName(profileName, chain);
        };
        this.setProfileImage = (profileImage, chain)=>{
            (0, $f7IXw.AccountController).setProfileImage(profileImage, chain);
        };
        this.resetAccount = (chain)=>{
            (0, $f7IXw.AccountController).resetAccount(chain);
        };
        this.setCaipNetwork = (caipNetwork)=>{
            (0, $jbD0z.NetworkController).setCaipNetwork(caipNetwork);
        };
        this.getCaipNetwork = ()=>(0, $jbD0z.NetworkController).state.caipNetwork;
        this.setRequestedCaipNetworks = (requestedCaipNetworks, chain)=>{
            (0, $jbD0z.NetworkController).setRequestedCaipNetworks(requestedCaipNetworks, chain);
        };
        this.getApprovedCaipNetworkIds = ()=>(0, $jbD0z.NetworkController).getApprovedCaipNetworkIds();
        this.setApprovedCaipNetworksData = (chain)=>(0, $jbD0z.NetworkController).setApprovedCaipNetworksData(chain);
        this.resetNetwork = ()=>{
            (0, $jbD0z.NetworkController).resetNetwork();
        };
        this.setConnectors = (connectors)=>{
            (0, $7Xn6F.ConnectorController).setConnectors(connectors);
        };
        this.addConnector = (connector)=>{
            (0, $7Xn6F.ConnectorController).addConnector(connector);
        };
        this.getConnectors = ()=>(0, $7Xn6F.ConnectorController).getConnectors();
        this.resetWcConnection = ()=>{
            (0, $hlVrM.ConnectionController).resetWcConnection();
        };
        this.fetchIdentity = (request)=>(0, $hxXs8.BlockchainApiController).fetchIdentity(request);
        this.setAddressExplorerUrl = (addressExplorerUrl, chain)=>{
            (0, $f7IXw.AccountController).setAddressExplorerUrl(addressExplorerUrl, chain);
        };
        this.setSmartAccountDeployed = (isDeployed, chain)=>{
            (0, $f7IXw.AccountController).setSmartAccountDeployed(isDeployed, chain);
        };
        this.setConnectedWalletInfo = (connectedWalletInfo, chain)=>{
            (0, $f7IXw.AccountController).setConnectedWalletInfo(connectedWalletInfo, chain);
        };
        this.setSmartAccountEnabledNetworks = (smartAccountEnabledNetworks, chain)=>{
            (0, $jbD0z.NetworkController).setSmartAccountEnabledNetworks(smartAccountEnabledNetworks, chain);
        };
        this.setPreferredAccountType = (preferredAccountType, chain)=>{
            (0, $f7IXw.AccountController).setPreferredAccountType(preferredAccountType, chain);
        };
        this.getWalletConnectName = (address)=>(0, $4DSpJ.EnsController).getNamesForAddress(address);
        this.resolveWalletConnectName = async (name)=>{
            const trimmedName = name.replace((0, $1VCt9.ConstantsUtil).WC_NAME_SUFFIX, "");
            const wcNameAddress = await (0, $4DSpJ.EnsController).resolveName(trimmedName);
            const networkNameAddresses = Object.values(wcNameAddress?.addresses) || [];
            return networkNameAddresses[0]?.address || false;
        };
        this.setEIP6963Enabled = (enabled)=>{
            (0, $8BVTM.OptionsController).setEIP6963Enabled(enabled);
        };
        this.setClientId = (clientId)=>{
            (0, $hxXs8.BlockchainApiController).setClientId(clientId);
        };
        this.getConnectorImage = (connector)=>(0, $eOULk.AssetUtil).getConnectorImage(connector);
        this.initControllers(options);
        this.initOrContinue();
    }
    static getInstance() {
        return this.instance;
    }
    async open(options) {
        await this.initOrContinue();
        (0, $ib7WC.ModalController).open(options);
    }
    async close() {
        await this.initOrContinue();
        (0, $ib7WC.ModalController).close();
    }
    setLoading(loading) {
        (0, $ib7WC.ModalController).setLoading(loading);
    }
    getThemeMode() {
        return (0, $3Sg6l.ThemeController).state.themeMode;
    }
    getThemeVariables() {
        return (0, $3Sg6l.ThemeController).state.themeVariables;
    }
    setThemeMode(themeMode) {
        (0, $3Sg6l.ThemeController).setThemeMode(themeMode);
        (0, $jVNMm.setColorTheme)((0, $3Sg6l.ThemeController).state.themeMode);
    }
    setThemeVariables(themeVariables) {
        (0, $3Sg6l.ThemeController).setThemeVariables(themeVariables);
        (0, $jVNMm.setThemeVariables)((0, $3Sg6l.ThemeController).state.themeVariables);
    }
    subscribeTheme(callback) {
        return (0, $3Sg6l.ThemeController).subscribe(callback);
    }
    getWalletInfo() {
        return (0, $f7IXw.AccountController).state.connectedWalletInfo;
    }
    subscribeWalletInfo(callback) {
        return (0, $f7IXw.AccountController).subscribeKey("connectedWalletInfo", callback);
    }
    subscribeShouldUpdateToAddress(callback) {
        (0, $f7IXw.AccountController).subscribeKey("shouldUpdateToAddress", callback);
    }
    subscribeCaipNetworkChange(callback) {
        (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", callback);
    }
    getState() {
        return (0, $1DdOF.PublicStateController).state;
    }
    subscribeState(callback) {
        return (0, $1DdOF.PublicStateController).subscribe(callback);
    }
    showErrorMessage(message) {
        (0, $br7WV.SnackController).showError(message);
    }
    showSuccessMessage(message) {
        (0, $br7WV.SnackController).showSuccess(message);
    }
    getEvent() {
        return {
            ...(0, $6m17w.EventsController).state
        };
    }
    subscribeEvents(callback) {
        return (0, $6m17w.EventsController).subscribe(callback);
    }
    replace(route) {
        (0, $6mRzS.RouterController).replace(route);
    }
    redirect(route) {
        (0, $6mRzS.RouterController).push(route);
    }
    popTransactionStack(cancel) {
        (0, $6mRzS.RouterController).popTransactionStack(cancel);
    }
    isOpen() {
        return (0, $ib7WC.ModalController).state.open;
    }
    isTransactionStackEmpty() {
        return (0, $6mRzS.RouterController).state.transactionStack.length === 0;
    }
    isTransactionShouldReplaceView() {
        return (0, $6mRzS.RouterController).state.transactionStack[(0, $6mRzS.RouterController).state.transactionStack.length - 1]?.replace;
    }
    async initControllers(options) {
        (0, $8BVTM.OptionsController).setProjectId(options.projectId);
        (0, $8BVTM.OptionsController).setSdkVersion(options.sdkVersion);
        (0, $d94Xg.ChainController).initialize(options.adapters || []);
        options.adapters?.forEach((adapter)=>{
            adapter.construct?.(this, options);
            (0, $jbD0z.NetworkController).setAllowUnsupportedChain(options.allowUnsupportedChain, adapter.chain);
            (0, $jbD0z.NetworkController).setDefaultCaipNetwork(options.defaultChain);
        });
        (0, $8BVTM.OptionsController).setAllWallets(options.allWallets);
        (0, $8BVTM.OptionsController).setIncludeWalletIds(options.includeWalletIds);
        (0, $8BVTM.OptionsController).setExcludeWalletIds(options.excludeWalletIds);
        (0, $8BVTM.OptionsController).setFeaturedWalletIds(options.featuredWalletIds);
        (0, $8BVTM.OptionsController).setTokens(options.tokens);
        (0, $8BVTM.OptionsController).setTermsConditionsUrl(options.termsConditionsUrl);
        (0, $8BVTM.OptionsController).setPrivacyPolicyUrl(options.privacyPolicyUrl);
        (0, $8BVTM.OptionsController).setCustomWallets(options.customWallets);
        (0, $8BVTM.OptionsController).setEnableAnalytics(options.enableAnalytics);
        (0, $8BVTM.OptionsController).setOnrampEnabled(options.enableOnramp !== false);
        (0, $8BVTM.OptionsController).setEnableSwaps(options.enableSwaps !== false);
        if (options.metadata) (0, $8BVTM.OptionsController).setMetadata(options.metadata);
        if (options.themeMode) (0, $3Sg6l.ThemeController).setThemeMode(options.themeMode);
        if (options.themeVariables) (0, $3Sg6l.ThemeController).setThemeVariables(options.themeVariables);
        if (options.disableAppend) (0, $8BVTM.OptionsController).setDisableAppend(Boolean(options.disableAppend));
        const evmAdapter = options.adapters?.find((adapter)=>adapter.chain === (0, $1VCt9.ConstantsUtil).CHAIN.EVM);
        if (evmAdapter) {
            if (options.siweConfig) {
                const { SIWEController: SIWEController } = await (parcelRequire("XE6yD"));
                SIWEController.setSIWEClient(options.siweConfig);
            }
        }
    }
    async initOrContinue() {
        if (!this.initPromise && !$edee1d43f6d87414$var$isInitialized && (0, $c4rfq.CoreHelperUtil).isClient()) {
            $edee1d43f6d87414$var$isInitialized = true;
            this.initPromise = new Promise(async (resolve)=>{
                await Promise.all([
                    Promise.resolve((parcelRequire("kbczO"))),
                    (parcelRequire("2qiOA"))
                ]);
                const modal = document.createElement("w3m-modal");
                if (!(0, $8BVTM.OptionsController).state.disableAppend) document.body.insertAdjacentElement("beforeend", modal);
                resolve();
            });
        }
        return this.initPromise;
    }
}


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $c4rfq = parcelRequire("c4rfq");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");

var $aTf3K = parcelRequire("aTf3K");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $607c39376ad0c184$export$f68dd208b5df064d = (t)=>t ?? (0, $aTf3K.nothing);




var $aa54194ae474ff42$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $aa54194ae474ff42$export$f039a2838669d98e = class W3mAccountButton extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.balance = "show";
        this.charsStart = 4;
        this.charsEnd = 6;
        this.address = (0, $f7IXw.AccountController).state.address;
        this.balanceVal = (0, $f7IXw.AccountController).state.balance;
        this.balanceSymbol = (0, $f7IXw.AccountController).state.balanceSymbol;
        this.profileName = (0, $f7IXw.AccountController).state.profileName;
        this.profileImage = (0, $f7IXw.AccountController).state.profileImage;
        this.network = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.isUnsupportedChain = (0, $jbD0z.NetworkController).state.isUnsupportedChain;
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribe((val)=>{
                if (val.isConnected) {
                    this.address = val.address;
                    this.balanceVal = val.balance;
                    this.profileName = val.profileName;
                    this.profileImage = val.profileImage;
                    this.balanceSymbol = val.balanceSymbol;
                } else {
                    this.address = "";
                    this.balanceVal = "";
                    this.profileName = "";
                    this.profileImage = "";
                    this.balanceSymbol = "";
                }
            }),
            (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (val)=>{
                this.network = val;
            }),
            (0, $jbD0z.NetworkController).subscribeKey("isUnsupportedChain", (val)=>{
                this.isUnsupportedChain = val;
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const networkImage = (0, $eOULk.AssetUtil).getNetworkImage(this.network);
        const showBalance = this.balance === "show";
        return (0, $aTf3K.html)`
      <wui-account-button
        .disabled=${Boolean(this.disabled)}
        .isUnsupportedChain=${this.isUnsupportedChain}
        address=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.address)}
        profileName=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.profileName)}
        networkSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(networkImage)}
        avatarSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.profileImage)}
        balance=${showBalance ? (0, $c4rfq.CoreHelperUtil).formatBalance(this.balanceVal, this.balanceSymbol) : ""}
        @click=${this.onClick.bind(this)}
        data-testid="account-button"
        .charsStart=${this.charsStart}
        .charsEnd=${this.charsEnd}
      >
      </wui-account-button>
    `;
    }
    onClick() {
        if (this.isUnsupportedChain) (0, $ib7WC.ModalController).open({
            view: "UnsupportedChain"
        });
        else (0, $ib7WC.ModalController).open();
    }
};
$aa54194ae474ff42$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "disabled", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $jJP2r.property)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "balance", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $jJP2r.property)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "charsStart", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $jJP2r.property)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "charsEnd", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $faUle.state)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "address", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $faUle.state)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "balanceVal", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $faUle.state)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "balanceSymbol", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $faUle.state)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "profileName", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $faUle.state)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "profileImage", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $faUle.state)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "network", void 0);
$aa54194ae474ff42$var$__decorate([
    (0, $faUle.state)()
], $aa54194ae474ff42$export$f039a2838669d98e.prototype, "isUnsupportedChain", void 0);
$aa54194ae474ff42$export$f039a2838669d98e = $aa54194ae474ff42$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-button")
], $aa54194ae474ff42$export$f039a2838669d98e);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $ib7WC = parcelRequire("ib7WC");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $3d30317d4c91e4c0$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    display: block;
    width: max-content;
  }
`;


var $154e24e7c3121680$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $154e24e7c3121680$export$857f19a8cabe3497 = class W3mButton extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.unsubscribe = [];
        this.disabled = false;
        this.balance = undefined;
        this.size = undefined;
        this.label = undefined;
        this.loadingLabel = undefined;
        this.charsStart = 4;
        this.charsEnd = 6;
        this.isAccount = (0, $f7IXw.AccountController).state.isConnected;
        this.isLoading = (0, $ib7WC.ModalController).state.loading;
    }
    firstUpdated() {
        this.unsubscribe.push((0, $f7IXw.AccountController).subscribe((val)=>{
            this.isAccount = val.isConnected;
        }), (0, $ib7WC.ModalController).subscribeKey("loading", (val)=>{
            this.isLoading = val;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return this.isAccount && !this.isLoading ? (0, $aTf3K.html)`
          <w3m-account-button
            .disabled=${Boolean(this.disabled)}
            balance=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.balance)}
            .charsStart=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.charsStart)}
            .charsEnd=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.charsEnd)}
          >
          </w3m-account-button>
        ` : (0, $aTf3K.html)`
          <w3m-connect-button
            size=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.size)}
            label=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.label)}
            loadingLabel=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.loadingLabel)}
          ></w3m-connect-button>
        `;
    }
};
$154e24e7c3121680$export$857f19a8cabe3497.styles = (0, $3d30317d4c91e4c0$export$2e2bcd8739ae039);
$154e24e7c3121680$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "disabled", void 0);
$154e24e7c3121680$var$__decorate([
    (0, $jJP2r.property)()
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "balance", void 0);
$154e24e7c3121680$var$__decorate([
    (0, $jJP2r.property)()
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "size", void 0);
$154e24e7c3121680$var$__decorate([
    (0, $jJP2r.property)()
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "label", void 0);
$154e24e7c3121680$var$__decorate([
    (0, $jJP2r.property)()
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "loadingLabel", void 0);
$154e24e7c3121680$var$__decorate([
    (0, $jJP2r.property)()
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "charsStart", void 0);
$154e24e7c3121680$var$__decorate([
    (0, $jJP2r.property)()
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "charsEnd", void 0);
$154e24e7c3121680$var$__decorate([
    (0, $faUle.state)()
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "isAccount", void 0);
$154e24e7c3121680$var$__decorate([
    (0, $faUle.state)()
], $154e24e7c3121680$export$857f19a8cabe3497.prototype, "isLoading", void 0);
$154e24e7c3121680$export$857f19a8cabe3497 = $154e24e7c3121680$var$__decorate([
    (0, $ailZp.customElement)("w3m-button")
], $154e24e7c3121680$export$857f19a8cabe3497);


parcelRequire("eNJDH");
var $ib7WC = parcelRequire("ib7WC");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");

var $10cbc3309cfe1307$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $10cbc3309cfe1307$export$277240c185e0322e = class W3mConnectButton extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.size = "md";
        this.label = "Connect Wallet";
        this.loadingLabel = "Connecting...";
        this.open = (0, $ib7WC.ModalController).state.open;
        this.loading = (0, $ib7WC.ModalController).state.loading;
        this.unsubscribe.push((0, $ib7WC.ModalController).subscribe((val)=>{
            this.open = val.open;
            this.loading = val.loading;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const isLoading = this.loading || this.open;
        return (0, $aTf3K.html)`
      <wui-connect-button
        size=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.size)}
        .loading=${isLoading}
        @click=${this.onClick.bind(this)}
        data-testid="connect-button"
      >
        ${isLoading ? this.loadingLabel : this.label}
      </wui-connect-button>
    `;
    }
    onClick() {
        if (this.open) (0, $ib7WC.ModalController).close();
        else if (!this.loading) (0, $ib7WC.ModalController).open();
    }
};
$10cbc3309cfe1307$var$__decorate([
    (0, $jJP2r.property)()
], $10cbc3309cfe1307$export$277240c185e0322e.prototype, "size", void 0);
$10cbc3309cfe1307$var$__decorate([
    (0, $jJP2r.property)()
], $10cbc3309cfe1307$export$277240c185e0322e.prototype, "label", void 0);
$10cbc3309cfe1307$var$__decorate([
    (0, $jJP2r.property)()
], $10cbc3309cfe1307$export$277240c185e0322e.prototype, "loadingLabel", void 0);
$10cbc3309cfe1307$var$__decorate([
    (0, $faUle.state)()
], $10cbc3309cfe1307$export$277240c185e0322e.prototype, "open", void 0);
$10cbc3309cfe1307$var$__decorate([
    (0, $faUle.state)()
], $10cbc3309cfe1307$export$277240c185e0322e.prototype, "loading", void 0);
$10cbc3309cfe1307$export$277240c185e0322e = $10cbc3309cfe1307$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-button")
], $10cbc3309cfe1307$export$277240c185e0322e);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $0313a843ca898c4e$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    display: block;
    width: max-content;
  }
`;


var $a73ca8cb77cc9bdd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a73ca8cb77cc9bdd$export$28375bf34267491c = class W3mNetworkButton extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.unsubscribe = [];
        this.disabled = false;
        this.network = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.connected = (0, $f7IXw.AccountController).state.isConnected;
        this.loading = (0, $ib7WC.ModalController).state.loading;
        this.isUnsupportedChain = (0, $jbD0z.NetworkController).state.isUnsupportedChain;
    }
    firstUpdated() {
        this.unsubscribe.push(...[
            (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val),
            (0, $f7IXw.AccountController).subscribeKey("isConnected", (val)=>this.connected = val),
            (0, $ib7WC.ModalController).subscribeKey("loading", (val)=>this.loading = val),
            (0, $jbD0z.NetworkController).subscribeKey("isUnsupportedChain", (val)=>this.isUnsupportedChain = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-network-button
        data-testid="wui-network-button"
        .disabled=${Boolean(this.disabled || this.loading)}
        .isUnsupportedChain=${this.isUnsupportedChain}
        imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getNetworkImage(this.network))}
        @click=${this.onClick.bind(this)}
      >
        ${this.getLabel()}
        <slot></slot>
      </wui-network-button>
    `;
    }
    getLabel() {
        if (this.label) return this.label;
        if (this.isUnsupportedChain) return "Switch Network";
        if (this.network) return this.network.name;
        if (this.connected) return "Unknown Network";
        return "Select Network";
    }
    onClick() {
        if (!this.loading) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "CLICK_NETWORKS"
            });
            (0, $ib7WC.ModalController).open({
                view: "Networks"
            });
        }
    }
};
$a73ca8cb77cc9bdd$export$28375bf34267491c.styles = (0, $0313a843ca898c4e$export$2e2bcd8739ae039);
$a73ca8cb77cc9bdd$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $a73ca8cb77cc9bdd$export$28375bf34267491c.prototype, "disabled", void 0);
$a73ca8cb77cc9bdd$var$__decorate([
    (0, $jJP2r.property)({
        type: String
    })
], $a73ca8cb77cc9bdd$export$28375bf34267491c.prototype, "label", void 0);
$a73ca8cb77cc9bdd$var$__decorate([
    (0, $faUle.state)()
], $a73ca8cb77cc9bdd$export$28375bf34267491c.prototype, "network", void 0);
$a73ca8cb77cc9bdd$var$__decorate([
    (0, $faUle.state)()
], $a73ca8cb77cc9bdd$export$28375bf34267491c.prototype, "connected", void 0);
$a73ca8cb77cc9bdd$var$__decorate([
    (0, $faUle.state)()
], $a73ca8cb77cc9bdd$export$28375bf34267491c.prototype, "loading", void 0);
$a73ca8cb77cc9bdd$var$__decorate([
    (0, $faUle.state)()
], $a73ca8cb77cc9bdd$export$28375bf34267491c.prototype, "isUnsupportedChain", void 0);
$a73ca8cb77cc9bdd$export$28375bf34267491c = $a73ca8cb77cc9bdd$var$__decorate([
    (0, $ailZp.customElement)("w3m-network-button")
], $a73ca8cb77cc9bdd$export$28375bf34267491c);


parcelRequire("eNJDH");
var $6mRzS = parcelRequire("6mRzS");
var $vBowO = parcelRequire("vBowO");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $3af7156458943b57$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    --prev-height: 0px;
    --new-height: 0px;
    display: block;
  }

  div.w3m-router-container {
    transform: translateY(0);
    opacity: 1;
  }

  div.w3m-router-container[view-direction='prev'] {
    animation:
      slide-left-out 150ms forwards ease,
      slide-left-in 150ms forwards ease;
    animation-delay: 0ms, 200ms;
  }

  div.w3m-router-container[view-direction='next'] {
    animation:
      slide-right-out 150ms forwards ease,
      slide-right-in 150ms forwards ease;
    animation-delay: 0ms, 200ms;
  }

  @keyframes slide-left-out {
    from {
      transform: translateX(0px);
      opacity: 1;
    }
    to {
      transform: translateX(10px);
      opacity: 0;
    }
  }

  @keyframes slide-left-in {
    from {
      transform: translateX(-10px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slide-right-out {
    from {
      transform: translateX(0px);
      opacity: 1;
    }
    to {
      transform: translateX(-10px);
      opacity: 0;
    }
  }

  @keyframes slide-right-in {
    from {
      transform: translateX(10px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;


const $0a65cf42ecb45995$export$aafe1f751f1bc52a = {
    ACCOUNT_TABS: [
        {
            label: "Tokens"
        },
        {
            label: "NFTs"
        },
        {
            label: "Activity"
        }
    ],
    SECURE_SITE_ORIGIN: "https://secure.walletconnect.org",
    VIEW_DIRECTION: {
        Next: "next",
        Prev: "prev"
    },
    ANIMATION_DURATIONS: {
        HeaderText: 120,
        ModalHeight: 150,
        ViewTransition: 150
    }
};


var $c1a9eace451460bd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c1a9eace451460bd$export$ccc15c9e32141a55 = class W3mRouter extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.resizeObserver = undefined;
        this.prevHeight = "0px";
        this.prevHistoryLength = 1;
        this.unsubscribe = [];
        this.view = (0, $6mRzS.RouterController).state.view;
        this.viewDirection = "";
        this.unsubscribe.push((0, $6mRzS.RouterController).subscribeKey("view", (val)=>this.onViewChange(val)));
    }
    firstUpdated() {
        this.resizeObserver = new ResizeObserver(([content])=>{
            const height = `${content?.contentRect.height}px`;
            if (this.prevHeight !== "0px") {
                this.style.setProperty("--prev-height", this.prevHeight);
                this.style.setProperty("--new-height", height);
                this.style.animation = "w3m-view-height 150ms forwards ease";
                this.style.height = "auto";
            }
            setTimeout(()=>{
                this.prevHeight = height;
                this.style.animation = "unset";
            }, (0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).ANIMATION_DURATIONS.ModalHeight);
        });
        this.resizeObserver.observe(this.getWrapper());
    }
    disconnectedCallback() {
        this.resizeObserver?.unobserve(this.getWrapper());
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`<div class="w3m-router-container" view-direction="${this.viewDirection}">
      ${this.viewTemplate()}
    </div>`;
    }
    viewTemplate() {
        switch(this.view){
            case "AccountSettings":
                return (0, $aTf3K.html)`<w3m-account-settings-view></w3m-account-settings-view>`;
            case "Account":
                return (0, $aTf3K.html)`<w3m-account-view></w3m-account-view>`;
            case "AllWallets":
                return (0, $aTf3K.html)`<w3m-all-wallets-view></w3m-all-wallets-view>`;
            case "ApproveTransaction":
                return (0, $aTf3K.html)`<w3m-approve-transaction-view></w3m-approve-transaction-view>`;
            case "BuyInProgress":
                return (0, $aTf3K.html)`<w3m-buy-in-progress-view></w3m-buy-in-progress-view>`;
            case "ChooseAccountName":
                return (0, $aTf3K.html)`<w3m-choose-account-name-view></w3m-choose-account-name-view>`;
            case "Connect":
                return (0, $aTf3K.html)`<w3m-connect-view></w3m-connect-view>`;
            case "ConnectingWalletConnect":
                return (0, $aTf3K.html)`<w3m-connecting-wc-view></w3m-connecting-wc-view>`;
            case "ConnectingExternal":
                return (0, $aTf3K.html)`<w3m-connecting-external-view></w3m-connecting-external-view>`;
            case "ConnectingSiwe":
                return (0, $aTf3K.html)`<w3m-connecting-siwe-view></w3m-connecting-siwe-view>`;
            case "ConnectWallets":
                return (0, $aTf3K.html)`<w3m-connect-wallets-view></w3m-connect-wallets-view>`;
            case "ConnectSocials":
                return (0, $aTf3K.html)`<w3m-connect-socials-view></w3m-connect-socials-view>`;
            case "ConnectingSocial":
                return (0, $aTf3K.html)`<w3m-connecting-social-view></w3m-connecting-social-view>`;
            case "Downloads":
                return (0, $aTf3K.html)`<w3m-downloads-view></w3m-downloads-view>`;
            case "EmailVerifyOtp":
                return (0, $aTf3K.html)`<w3m-email-verify-otp-view></w3m-email-verify-otp-view>`;
            case "EmailVerifyDevice":
                return (0, $aTf3K.html)`<w3m-email-verify-device-view></w3m-email-verify-device-view>`;
            case "GetWallet":
                return (0, $aTf3K.html)`<w3m-get-wallet-view></w3m-get-wallet-view>`;
            case "Networks":
                return (0, $aTf3K.html)`<w3m-networks-view></w3m-networks-view>`;
            case "SwitchNetwork":
                return (0, $aTf3K.html)`<w3m-network-switch-view></w3m-network-switch-view>`;
            case "Profile":
                return (0, $aTf3K.html)`<w3m-profile-view></w3m-profile-view>`;
            case "SelectAddresses":
                return (0, $aTf3K.html)`<w3m-select-addresses-view></w3m-select-addresses-view>`;
            case "SwitchAddress":
                return (0, $aTf3K.html)`<w3m-switch-address-view></w3m-switch-address-view>`;
            case "Transactions":
                return (0, $aTf3K.html)`<w3m-transactions-view></w3m-transactions-view>`;
            case "OnRampProviders":
                return (0, $aTf3K.html)`<w3m-onramp-providers-view></w3m-onramp-providers-view>`;
            case "OnRampActivity":
                return (0, $aTf3K.html)`<w3m-onramp-activity-view></w3m-onramp-activity-view>`;
            case "OnRampTokenSelect":
                return (0, $aTf3K.html)`<w3m-onramp-token-select-view></w3m-onramp-token-select-view>`;
            case "OnRampFiatSelect":
                return (0, $aTf3K.html)`<w3m-onramp-fiat-select-view></w3m-onramp-fiat-select-view>`;
            case "UpgradeEmailWallet":
                return (0, $aTf3K.html)`<w3m-upgrade-wallet-view></w3m-upgrade-wallet-view>`;
            case "UpgradeToSmartAccount":
                return (0, $aTf3K.html)`<w3m-upgrade-to-smart-account-view></w3m-upgrade-to-smart-account-view>`;
            case "UpdateEmailWallet":
                return (0, $aTf3K.html)`<w3m-update-email-wallet-view></w3m-update-email-wallet-view>`;
            case "UpdateEmailPrimaryOtp":
                return (0, $aTf3K.html)`<w3m-update-email-primary-otp-view></w3m-update-email-primary-otp-view>`;
            case "UpdateEmailSecondaryOtp":
                return (0, $aTf3K.html)`<w3m-update-email-secondary-otp-view></w3m-update-email-secondary-otp-view>`;
            case "UnsupportedChain":
                return (0, $aTf3K.html)`<w3m-unsupported-chain-view></w3m-unsupported-chain-view>`;
            case "Swap":
                return (0, $aTf3K.html)`<w3m-swap-view></w3m-swap-view>`;
            case "SwapSelectToken":
                return (0, $aTf3K.html)`<w3m-swap-select-token-view></w3m-swap-select-token-view>`;
            case "SwapPreview":
                return (0, $aTf3K.html)`<w3m-swap-preview-view></w3m-swap-preview-view>`;
            case "WalletSend":
                return (0, $aTf3K.html)`<w3m-wallet-send-view></w3m-wallet-send-view>`;
            case "WalletSendSelectToken":
                return (0, $aTf3K.html)`<w3m-wallet-send-select-token-view></w3m-wallet-send-select-token-view>`;
            case "WalletSendPreview":
                return (0, $aTf3K.html)`<w3m-wallet-send-preview-view></w3m-wallet-send-preview-view>`;
            case "WhatIsABuy":
                return (0, $aTf3K.html)`<w3m-what-is-a-buy-view></w3m-what-is-a-buy-view>`;
            case "WalletReceive":
                return (0, $aTf3K.html)`<w3m-wallet-receive-view></w3m-wallet-receive-view>`;
            case "WalletCompatibleNetworks":
                return (0, $aTf3K.html)`<w3m-wallet-compatible-networks-view></w3m-wallet-compatible-networks-view>`;
            case "WhatIsAWallet":
                return (0, $aTf3K.html)`<w3m-what-is-a-wallet-view></w3m-what-is-a-wallet-view>`;
            case "ConnectingMultiChain":
                return (0, $aTf3K.html)`<w3m-connecting-multi-chain-view></w3m-connecting-multi-chain-view>`;
            case "WhatIsANetwork":
                return (0, $aTf3K.html)`<w3m-what-is-a-network-view></w3m-what-is-a-network-view>`;
            case "ConnectingFarcaster":
                return (0, $aTf3K.html)`<w3m-connecting-farcaster-view></w3m-connecting-farcaster-view>`;
            case "SwitchActiveChain":
                return (0, $aTf3K.html)`<w3m-switch-active-chain-view></w3m-switch-active-chain-view>`;
            case "RegisterAccountName":
                return (0, $aTf3K.html)`<w3m-register-account-name-view></w3m-register-account-name-view>`;
            case "RegisterAccountNameSuccess":
                return (0, $aTf3K.html)`<w3m-register-account-name-success-view></w3m-register-account-name-success-view>`;
            default:
                return (0, $aTf3K.html)`<w3m-connect-view></w3m-connect-view>`;
        }
    }
    onViewChange(newView) {
        (0, $vBowO.TooltipController).hide();
        let direction = (0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).VIEW_DIRECTION.Next;
        const { history: history } = (0, $6mRzS.RouterController).state;
        if (history.length < this.prevHistoryLength) direction = (0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).VIEW_DIRECTION.Prev;
        this.prevHistoryLength = history.length;
        this.viewDirection = direction;
        setTimeout(()=>{
            this.view = newView;
        }, (0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).ANIMATION_DURATIONS.ViewTransition);
    }
    getWrapper() {
        return this.shadowRoot?.querySelector("div");
    }
};
$c1a9eace451460bd$export$ccc15c9e32141a55.styles = (0, $3af7156458943b57$export$2e2bcd8739ae039);
$c1a9eace451460bd$var$__decorate([
    (0, $faUle.state)()
], $c1a9eace451460bd$export$ccc15c9e32141a55.prototype, "view", void 0);
$c1a9eace451460bd$var$__decorate([
    (0, $faUle.state)()
], $c1a9eace451460bd$export$ccc15c9e32141a55.prototype, "viewDirection", void 0);
$c1a9eace451460bd$export$ccc15c9e32141a55 = $c1a9eace451460bd$var$__decorate([
    (0, $ailZp.customElement)("w3m-router")
], $c1a9eace451460bd$export$ccc15c9e32141a55);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $ib7WC = parcelRequire("ib7WC");
var $jM3Wq = parcelRequire("jM3Wq");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $d532264fc55edbe3$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex {
    width: 100%;
    max-width: 360px;
  }

  :host > wui-flex > wui-flex {
    border-radius: var(--wui-border-radius-l);
    width: 100%;
  }

  .amounts-container {
    width: 100%;
  }
`;


var $f6ee10809bf4895a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $f6ee10809bf4895a$var$PAYMENT_CURRENCY_SYMBOLS = {
    USD: "$",
    EUR: "\u20AC",
    GBP: "\xa3"
};
const $f6ee10809bf4895a$var$BUY_PRESET_AMOUNTS = [
    100,
    250,
    500,
    1000
];
let $f6ee10809bf4895a$export$33bc4f3e369ccb5f = class W3mOnrampWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.connected = (0, $f7IXw.AccountController).state.isConnected;
        this.loading = (0, $ib7WC.ModalController).state.loading;
        this.paymentCurrency = (0, $jM3Wq.OnRampController).state.paymentCurrency;
        this.paymentAmount = (0, $jM3Wq.OnRampController).state.paymentAmount;
        this.purchaseAmount = (0, $jM3Wq.OnRampController).state.purchaseAmount;
        this.quoteLoading = (0, $jM3Wq.OnRampController).state.quotesLoading;
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribeKey("isConnected", (val)=>{
                this.connected = val;
            }),
            (0, $ib7WC.ModalController).subscribeKey("loading", (val)=>{
                this.loading = val;
            }),
            (0, $jM3Wq.OnRampController).subscribe((val)=>{
                this.paymentCurrency = val.paymentCurrency;
                this.paymentAmount = val.paymentAmount;
                this.purchaseAmount = val.purchaseAmount;
                this.quoteLoading = val.quotesLoading;
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" justifyContent="center" alignItems="center">
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <w3m-onramp-input
            type="Fiat"
            @inputChange=${this.onPaymentAmountChange.bind(this)}
            .value=${this.paymentAmount || 0}
          ></w3m-onramp-input>
          <w3m-onramp-input
            type="Token"
            .value=${this.purchaseAmount || 0}
            .loading=${this.quoteLoading}
          ></w3m-onramp-input>
          <wui-flex justifyContent="space-evenly" class="amounts-container" gap="xs">
            ${$f6ee10809bf4895a$var$BUY_PRESET_AMOUNTS.map((amount)=>(0, $aTf3K.html)`<wui-button
                  variant=${this.paymentAmount === amount ? "accent" : "neutral"}
                  size="md"
                  textVariant="paragraph-600"
                  fullWidth
                  @click=${()=>this.selectPresetAmount(amount)}
                  >${`${$f6ee10809bf4895a$var$PAYMENT_CURRENCY_SYMBOLS[this.paymentCurrency?.id || "USD"]} ${amount}`}</wui-button
                >`)}
          </wui-flex>
          ${this.templateButton()}
        </wui-flex>
      </wui-flex>
    `;
    }
    templateButton() {
        return this.connected ? (0, $aTf3K.html)`<wui-button
          @click=${this.getQuotes.bind(this)}
          variant="main"
          fullWidth
          size="lg"
          borderRadius="xs"
        >
          Get quotes
        </wui-button>` : (0, $aTf3K.html)`<wui-button
          @click=${this.openModal.bind(this)}
          variant="accent"
          fullWidth
          size="lg"
          borderRadius="xs"
        >
          Connect wallet
        </wui-button>`;
    }
    getQuotes() {
        if (!this.loading) (0, $ib7WC.ModalController).open({
            view: "OnRampProviders"
        });
    }
    openModal() {
        (0, $ib7WC.ModalController).open({
            view: "Connect"
        });
    }
    async onPaymentAmountChange(event) {
        (0, $jM3Wq.OnRampController).setPaymentAmount(Number(event.detail));
        await (0, $jM3Wq.OnRampController).getQuote();
    }
    async selectPresetAmount(amount) {
        (0, $jM3Wq.OnRampController).setPaymentAmount(amount);
        await (0, $jM3Wq.OnRampController).getQuote();
    }
};
$f6ee10809bf4895a$export$33bc4f3e369ccb5f.styles = (0, $d532264fc55edbe3$export$2e2bcd8739ae039);
$f6ee10809bf4895a$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $f6ee10809bf4895a$export$33bc4f3e369ccb5f.prototype, "disabled", void 0);
$f6ee10809bf4895a$var$__decorate([
    (0, $faUle.state)()
], $f6ee10809bf4895a$export$33bc4f3e369ccb5f.prototype, "connected", void 0);
$f6ee10809bf4895a$var$__decorate([
    (0, $faUle.state)()
], $f6ee10809bf4895a$export$33bc4f3e369ccb5f.prototype, "loading", void 0);
$f6ee10809bf4895a$var$__decorate([
    (0, $faUle.state)()
], $f6ee10809bf4895a$export$33bc4f3e369ccb5f.prototype, "paymentCurrency", void 0);
$f6ee10809bf4895a$var$__decorate([
    (0, $faUle.state)()
], $f6ee10809bf4895a$export$33bc4f3e369ccb5f.prototype, "paymentAmount", void 0);
$f6ee10809bf4895a$var$__decorate([
    (0, $faUle.state)()
], $f6ee10809bf4895a$export$33bc4f3e369ccb5f.prototype, "purchaseAmount", void 0);
$f6ee10809bf4895a$var$__decorate([
    (0, $faUle.state)()
], $f6ee10809bf4895a$export$33bc4f3e369ccb5f.prototype, "quoteLoading", void 0);
$f6ee10809bf4895a$export$33bc4f3e369ccb5f = $f6ee10809bf4895a$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-widget")
], $f6ee10809bf4895a$export$33bc4f3e369ccb5f);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $zKxbI = parcelRequire("zKxbI");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $6AwK8 = parcelRequire("6AwK8");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
var $3BhS7 = parcelRequire("3BhS7");
var $br7WV = parcelRequire("br7WV");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $7f5e067110d94890$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7f5e067110d94890$export$b2168ecfa4cbc2f8 = class W3mAccountSettingsView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.usubscribe = [];
        this.networkImages = (0, $zKxbI.AssetController).state.networkImages;
        this.address = (0, $f7IXw.AccountController).state.address;
        this.profileImage = (0, $f7IXw.AccountController).state.profileImage;
        this.profileName = (0, $f7IXw.AccountController).state.profileName;
        this.network = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.preferredAccountType = (0, $f7IXw.AccountController).state.preferredAccountType;
        this.disconnecting = false;
        this.loading = false;
        this.switched = false;
        this.text = "";
        this.usubscribe.push(...[
            (0, $f7IXw.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileImage = val.profileImage;
                    this.profileName = val.profileName;
                    this.preferredAccountType = val.preferredAccountType;
                } else (0, $ib7WC.ModalController).close();
            }),
            (0, $f7IXw.AccountController).subscribeKey("preferredAccountType", (val)=>this.preferredAccountType = val),
            (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (val)=>{
                if (val?.id) this.network = val;
            })
        ]);
    }
    disconnectedCallback() {
        this.usubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-account-settings-view: No account provided");
        const networkImage = this.networkImages[this.network?.imageId ?? ""];
        const name = this.profileName?.split(".")[0];
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        gap="l"
        .padding=${[
            "0",
            "xl",
            "m",
            "xl"
        ]}
      >
        <wui-avatar
          alt=${this.address}
          address=${this.address}
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.profileImage)}
          size="2lg"
        ></wui-avatar>
        <wui-flex flexDirection="column" alignItems="center">
          <wui-flex gap="3xs" alignItems="center" justifyContent="center">
            <wui-text variant="title-6-600" color="fg-100" data-testid="account-settings-address">
              ${name ? (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: name,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: 4,
            charsEnd: 6,
            truncate: "middle"
        })}
            </wui-text>
            <wui-icon-link
              size="md"
              icon="copy"
              iconColor="fg-200"
              @click=${this.onCopyAddress}
            ></wui-icon-link>
          </wui-flex>
        </wui-flex>
      </wui-flex>
      <wui-flex flexDirection="column" gap="m">
        <wui-flex flexDirection="column" gap="xs" .padding=${[
            "0",
            "l",
            "m",
            "l"
        ]}>
          ${this.authCardTemplate()}
          <w3m-account-auth-button></w3m-account-auth-button>
          <wui-list-item
            .variant=${networkImage ? "image" : "icon"}
            iconVariant="overlay"
            icon="networkPlaceholder"
            imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(networkImage)}
            ?chevron=${this.isAllowedNetworkSwitch()}
            @click=${this.onNetworks.bind(this)}
            data-testid="account-switch-network-button"
          >
            <wui-text variant="paragraph-500" color="fg-100">
              ${this.network?.name ?? "Unknown"}
            </wui-text>
          </wui-list-item>
          ${this.togglePreferredAccountBtnTemplate()} ${this.chooseNameButtonTemplate()}
          <wui-list-item
            variant="icon"
            iconVariant="overlay"
            icon="disconnect"
            ?chevron=${false}
            .loading=${this.disconnecting}
            @click=${this.onDisconnect.bind(this)}
            data-testid="disconnect-button"
          >
            <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
          </wui-list-item>
        </wui-flex>
      </wui-flex>
    `;
    }
    chooseNameButtonTemplate() {
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (!authConnector || type !== "AUTH" || this.profileName) return null;
        return (0, $aTf3K.html)`
      <wui-list-item
        variant="icon"
        iconVariant="overlay"
        icon="id"
        iconSize="sm"
        ?chevron=${true}
        @click=${this.onChooseName.bind(this)}
        data-testid="account-choose-name-button"
      >
        <wui-text variant="paragraph-500" color="fg-100">Choose account name </wui-text>
      </wui-list-item>
    `;
    }
    authCardTemplate() {
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        const { origin: origin } = location;
        if (!authConnector || type !== "AUTH" || origin.includes((0, $6AwK8.ConstantsUtil).SECURE_SITE)) return null;
        return (0, $aTf3K.html)`
      <wui-notice-card
        @click=${this.onGoToUpgradeView.bind(this)}
        label="Upgrade your wallet"
        description="Transition to a self-custodial wallet"
        icon="wallet"
        data-testid="w3m-wallet-upgrade-card"
      ></wui-notice-card>
    `;
    }
    isAllowedNetworkSwitch() {
        const requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        const isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
        const isValidNetwork = requestedCaipNetworks?.find(({ id: id })=>id === this.network?.id);
        return isMultiNetwork || !isValidNetwork;
    }
    onCopyAddress() {
        try {
            if (this.profileName) {
                (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.profileName);
                (0, $br7WV.SnackController).showSuccess("Name copied");
            } else if (this.address) {
                (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.address);
                (0, $br7WV.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $br7WV.SnackController).showError("Failed to copy");
        }
    }
    togglePreferredAccountBtnTemplate() {
        const networkEnabled = (0, $jbD0z.NetworkController).checkIfSmartAccountEnabled();
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (!authConnector || type !== "AUTH" || !networkEnabled) return null;
        if (!this.switched) this.text = this.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT ? "Switch to your EOA" : "Switch to your smart account";
        return (0, $aTf3K.html)`
      <wui-list-item
        variant="icon"
        iconVariant="overlay"
        icon="swapHorizontalBold"
        iconSize="sm"
        ?chevron=${true}
        ?loading=${this.loading}
        @click=${this.changePreferredAccountType.bind(this)}
        data-testid="account-toggle-preferred-account-type"
      >
        <wui-text variant="paragraph-500" color="fg-100">${this.text}</wui-text>
      </wui-list-item>
    `;
    }
    onChooseName() {
        (0, $6mRzS.RouterController).push("ChooseAccountName");
    }
    async changePreferredAccountType() {
        const smartAccountEnabled = (0, $jbD0z.NetworkController).checkIfSmartAccountEnabled();
        const accountTypeTarget = this.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT || !smartAccountEnabled ? (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA : (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT;
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (!authConnector) return;
        this.loading = true;
        await (0, $hlVrM.ConnectionController).setPreferredAccountType(accountTypeTarget);
        this.text = accountTypeTarget === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT ? "Switch to your EOA" : "Switch to your smart account";
        this.switched = true;
        (0, $3BhS7.SendController).resetSend();
        this.loading = false;
        this.requestUpdate();
    }
    onNetworks() {
        if (this.isAllowedNetworkSwitch()) (0, $6mRzS.RouterController).push("Networks");
    }
    async onDisconnect() {
        try {
            this.disconnecting = true;
            await (0, $hlVrM.ConnectionController).disconnect();
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $ib7WC.ModalController).close();
        } catch  {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $br7WV.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconnecting = false;
        }
    }
    onGoToUpgradeView() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_UPGRADE_FROM_MODAL"
        });
        (0, $6mRzS.RouterController).push("UpgradeEmailWallet");
    }
};
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "address", void 0);
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "profileImage", void 0);
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "profileName", void 0);
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "network", void 0);
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "preferredAccountType", void 0);
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "disconnecting", void 0);
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "loading", void 0);
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "switched", void 0);
$7f5e067110d94890$var$__decorate([
    (0, $faUle.state)()
], $7f5e067110d94890$export$b2168ecfa4cbc2f8.prototype, "text", void 0);
$7f5e067110d94890$export$b2168ecfa4cbc2f8 = $7f5e067110d94890$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-settings-view")
], $7f5e067110d94890$export$b2168ecfa4cbc2f8);


parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
var $aed8ca7de3fdf333$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $aed8ca7de3fdf333$export$fb2cfdfbb483d2ac = class W3mAccountView extends (0, $g305D.LitElement) {
    render() {
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        return (0, $aTf3K.html)`
      ${authConnector?.walletFeatures && type === "AUTH" ? this.walletFeaturesTemplate() : this.defaultTemplate()}
    `;
    }
    walletFeaturesTemplate() {
        return (0, $aTf3K.html)`<w3m-account-wallet-features-widget></w3m-account-wallet-features-widget>`;
    }
    defaultTemplate() {
        return (0, $aTf3K.html)`<w3m-account-default-widget></w3m-account-default-widget>`;
    }
};
$aed8ca7de3fdf333$export$fb2cfdfbb483d2ac = $aed8ca7de3fdf333$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-view")
], $aed8ca7de3fdf333$export$fb2cfdfbb483d2ac);


parcelRequire("eNJDH");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $783dd13299ee9957$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $783dd13299ee9957$export$88f35657f4e64778 = class W3mAllWalletsView extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.search = "";
        this.onDebouncedSearch = (0, $c4rfq.CoreHelperUtil).debounce((value)=>{
            this.search = value;
        });
    }
    render() {
        const isSearch = this.search.length >= 2;
        return (0, $aTf3K.html)`
      <wui-flex .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]} gap="s">
        <wui-search-bar @inputChange=${this.onInputChange.bind(this)}></wui-search-bar>
        ${this.qrButtonTemplate()}
      </wui-flex>
      ${isSearch ? (0, $aTf3K.html)`<w3m-all-wallets-search query=${this.search}></w3m-all-wallets-search>` : (0, $aTf3K.html)`<w3m-all-wallets-list></w3m-all-wallets-list>`}
    `;
    }
    onInputChange(event) {
        this.onDebouncedSearch(event.detail);
    }
    qrButtonTemplate() {
        if ((0, $c4rfq.CoreHelperUtil).isMobile()) return (0, $aTf3K.html)`
        <wui-icon-box
          size="lg"
          iconSize="xl"
          iconColor="accent-100"
          backgroundColor="accent-100"
          icon="qrCode"
          background="transparent"
          border
          borderColor="wui-accent-glass-010"
          @click=${this.onWalletConnectQr.bind(this)}
        ></wui-icon-box>
      `;
        return null;
    }
    onWalletConnectQr() {
        (0, $6mRzS.RouterController).push("ConnectingWalletConnect");
    }
};
$783dd13299ee9957$var$__decorate([
    (0, $faUle.state)()
], $783dd13299ee9957$export$88f35657f4e64778.prototype, "search", void 0);
$783dd13299ee9957$export$88f35657f4e64778 = $783dd13299ee9957$var$__decorate([
    (0, $ailZp.customElement)("w3m-all-wallets-view")
], $783dd13299ee9957$export$88f35657f4e64778);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $hxXs8 = parcelRequire("hxXs8");
var $hlVrM = parcelRequire("hlVrM");
var $c4rfq = parcelRequire("c4rfq");
var $jM3Wq = parcelRequire("jM3Wq");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
var $3Sg6l = parcelRequire("3Sg6l");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $140d2b523c0c41f0$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-visual {
    width: var(--wui-wallet-image-size-lg);
    height: var(--wui-wallet-image-size-lg);
    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));
    position: relative;
    overflow: hidden;
  }

  wui-visual::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition:
      opacity var(--wui-ease-out-power-2) var(--wui-duration-lg),
      transform var(--wui-ease-out-power-2) var(--wui-duration-lg);
    will-change: opacity, transform;
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }

  wui-link {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
  }
`;


var $8bec4d40076c94b1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8bec4d40076c94b1$export$e0ca4e8f314f5325 = class W3mBuyInProgressView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedOnRampProvider = (0, $jM3Wq.OnRampController).state.selectedProvider;
        this.uri = (0, $hlVrM.ConnectionController).state.wcUri;
        this.ready = false;
        this.showRetry = false;
        this.buffering = false;
        this.error = false;
        this.startTime = null;
        this.isMobile = false;
        this.onRetry = undefined;
        this.unsubscribe.push(...[
            (0, $jM3Wq.OnRampController).subscribeKey("selectedProvider", (val)=>{
                this.selectedOnRampProvider = val;
            })
        ]);
        this.watchTransactions();
    }
    disconnectedCallback() {
        if (this.intervalId) clearInterval(this.intervalId);
    }
    render() {
        let label = "Continue in external window";
        if (this.error) label = "Buy failed";
        else if (this.selectedOnRampProvider) label = `Buy in ${this.selectedOnRampProvider?.label}`;
        const subLabel = this.error ? "Buy can be declined from your side or due to and error on the provider app" : `We\u{2019}ll notify you once your Buy is processed`;
        return (0, $aTf3K.html)`
      <wui-flex
        data-error=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.error)}
        data-retry=${this.showRetry}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-visual
            name=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.selectedOnRampProvider?.name)}
            size="lg"
            class="provider-image"
          >
          </wui-visual>

          ${this.error ? null : this.loaderTemplate()}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text variant="paragraph-500" color=${this.error ? "error-100" : "fg-100"}>
            ${label}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        ${this.error ? this.tryAgainTemplate() : null}
      </wui-flex>

      <wui-flex .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]} justifyContent="center">
        <wui-link @click=${this.onCopyUri} color="fg-200">
          <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
          Copy link
        </wui-link>
      </wui-flex>
    `;
    }
    watchTransactions() {
        if (!this.selectedOnRampProvider) return;
        switch(this.selectedOnRampProvider.name){
            case "coinbase":
                this.startTime = Date.now();
                this.initializeCoinbaseTransactions();
                break;
            default:
                break;
        }
    }
    async initializeCoinbaseTransactions() {
        await this.watchCoinbaseTransactions();
        this.intervalId = setInterval(()=>this.watchCoinbaseTransactions(), 4000);
    }
    async watchCoinbaseTransactions() {
        try {
            const address = (0, $f7IXw.AccountController).state.address;
            const projectId = (0, $8BVTM.OptionsController).state.projectId;
            if (!address) throw new Error("No address found");
            const coinbaseResponse = await (0, $hxXs8.BlockchainApiController).fetchTransactions({
                account: address,
                onramp: "coinbase",
                projectId: projectId
            });
            const newTransactions = coinbaseResponse.data.filter((tx)=>new Date(tx.metadata.minedAt) > new Date(this.startTime) || tx.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS");
            if (newTransactions.length) {
                clearInterval(this.intervalId);
                (0, $6mRzS.RouterController).replace("OnRampActivity");
            } else if (this.startTime && Date.now() - this.startTime >= 180000) {
                clearInterval(this.intervalId);
                this.error = true;
            }
        } catch (error) {
            (0, $br7WV.SnackController).showError(error);
        }
    }
    onTryAgain() {
        if (!this.selectedOnRampProvider) return;
        this.error = false;
        (0, $c4rfq.CoreHelperUtil).openHref(this.selectedOnRampProvider.url, "popupWindow", "width=600,height=800,scrollbars=yes");
    }
    tryAgainTemplate() {
        if (!this.selectedOnRampProvider?.url) return null;
        return (0, $aTf3K.html)`<wui-button size="md" variant="accent" @click=${this.onTryAgain.bind(this)}>
      <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>
      Try again
    </wui-button>`;
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $3Sg6l.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $aTf3K.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    onCopyUri() {
        if (!this.selectedOnRampProvider?.url) {
            (0, $br7WV.SnackController).showError("No link found");
            (0, $6mRzS.RouterController).goBack();
            return;
        }
        try {
            (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.selectedOnRampProvider.url);
            (0, $br7WV.SnackController).showSuccess("Link copied");
        } catch  {
            (0, $br7WV.SnackController).showError("Failed to copy");
        }
    }
};
$8bec4d40076c94b1$export$e0ca4e8f314f5325.styles = (0, $140d2b523c0c41f0$export$2e2bcd8739ae039);
$8bec4d40076c94b1$var$__decorate([
    (0, $faUle.state)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "intervalId", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $faUle.state)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "selectedOnRampProvider", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $faUle.state)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "uri", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $faUle.state)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "ready", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $faUle.state)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "showRetry", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $faUle.state)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "buffering", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $faUle.state)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "error", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $faUle.state)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "startTime", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "isMobile", void 0);
$8bec4d40076c94b1$var$__decorate([
    (0, $jJP2r.property)()
], $8bec4d40076c94b1$export$e0ca4e8f314f5325.prototype, "onRetry", void 0);
$8bec4d40076c94b1$export$e0ca4e8f314f5325 = $8bec4d40076c94b1$var$__decorate([
    (0, $ailZp.customElement)("w3m-buy-in-progress-view")
], $8bec4d40076c94b1$export$e0ca4e8f314f5325);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $1df0dcb837739f04$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    scrollbar-width: none;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  :host > wui-flex::-webkit-scrollbar {
    display: none;
  }

  .all-wallets {
    flex-flow: column;
  }
`;


parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("faUle");


var $faUle = parcelRequire("faUle");
var $418b5ec85487cc65$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $418b5ec85487cc65$export$b7220f3d0ae9dbca = class W3mConnectView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "3xs",
            "s",
            "s",
            "s"
        ]}>
        <w3m-email-login-widget></w3m-email-login-widget>
        <w3m-social-login-widget></w3m-social-login-widget>
        ${this.walletListTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    walletListTemplate() {
        const authConnector = this.connectors.find((c)=>c.type === "AUTH");
        if (authConnector?.socials) {
            if (authConnector?.showWallets) return (0, $aTf3K.html)`
          <wui-flex flexDirection="column" gap="xs" .margin=${[
                "xs",
                "0",
                "0",
                "0"
            ]}>
            <w3m-connector-list></w3m-connector-list>
            <wui-flex class="all-wallets">
              <w3m-all-wallets-widget></w3m-all-wallets-widget>
            </wui-flex>
          </wui-flex>
        `;
            return (0, $aTf3K.html)`<wui-list-button
        @click=${this.onContinueWalletClick.bind(this)}
        text="Continue with a wallet"
      ></wui-list-button>`;
        }
        return (0, $aTf3K.html)`<w3m-wallet-login-list></w3m-wallet-login-list>`;
    }
    onContinueWalletClick() {
        (0, $6mRzS.RouterController).push("ConnectWallets");
    }
};
$418b5ec85487cc65$export$b7220f3d0ae9dbca.styles = (0, $1df0dcb837739f04$export$2e2bcd8739ae039);
$418b5ec85487cc65$var$__decorate([
    (0, $faUle.state)()
], $418b5ec85487cc65$export$b7220f3d0ae9dbca.prototype, "connectors", void 0);
$418b5ec85487cc65$export$b7220f3d0ae9dbca = $418b5ec85487cc65$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-view")
], $418b5ec85487cc65$export$b7220f3d0ae9dbca);


parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");

parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $hlVrM = parcelRequire("hlVrM");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
var $3Sg6l = parcelRequire("3Sg6l");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $f5ac93199cb9a723$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition-property: opacity, transform;
    transition-duration: var(--wui-duration-lg);
    transition-timing-function: var(--wui-ease-out-power-2);
    will-change: opacity, transform;
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }
`;


var $45650b9021d7e0f4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $45650b9021d7e0f4$export$902e3cfa9f67689d extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.wallet = (0, $6mRzS.RouterController).state.data?.wallet;
        this.connector = (0, $6mRzS.RouterController).state.data?.connector;
        this.timeout = undefined;
        this.secondaryBtnLabel = "Try again";
        this.secondaryBtnIcon = "refresh";
        this.secondaryLabel = "Accept connection request in the wallet";
        this.onConnect = undefined;
        this.onRender = undefined;
        this.onAutoConnect = undefined;
        this.isWalletConnect = true;
        this.unsubscribe = [];
        this.imageSrc = (0, $eOULk.AssetUtil).getWalletImage(this.wallet) ?? (0, $eOULk.AssetUtil).getConnectorImage(this.connector);
        this.name = this.wallet?.name ?? this.connector?.name ?? "Wallet";
        this.isRetrying = false;
        this.uri = (0, $hlVrM.ConnectionController).state.wcUri;
        this.error = (0, $hlVrM.ConnectionController).state.wcError;
        this.ready = false;
        this.showRetry = false;
        this.buffering = false;
        this.isMobile = false;
        this.onRetry = undefined;
        this.unsubscribe.push(...[
            (0, $hlVrM.ConnectionController).subscribeKey("wcUri", (val)=>{
                this.uri = val;
                if (this.isRetrying && this.onRetry) {
                    this.isRetrying = false;
                    this.onConnect?.();
                }
            }),
            (0, $hlVrM.ConnectionController).subscribeKey("wcError", (val)=>this.error = val),
            (0, $hlVrM.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val)
        ]);
    }
    firstUpdated() {
        this.onAutoConnect?.();
        this.showRetry = !this.onAutoConnect;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        clearTimeout(this.timeout);
    }
    render() {
        this.onRender?.();
        this.onShowRetry();
        const subLabel = this.error ? "Connection can be declined if a previous request is still active" : this.secondaryLabel;
        let label = `Continue in ${this.name}`;
        if (this.buffering) label = "Connecting...";
        if (this.error) label = "Connection declined";
        return (0, $aTf3K.html)`
      <wui-flex
        data-error=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.error)}
        data-retry=${this.showRetry}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-wallet-image size="lg" imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.imageSrc)}></wui-wallet-image>

          ${this.error ? null : this.loaderTemplate()}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text variant="paragraph-500" color=${this.error ? "error-100" : "fg-100"}>
            ${label}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        <wui-button
          variant="accent"
          size="md"
          ?disabled=${!this.error && this.buffering}
          @click=${this.onTryAgain.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name=${this.secondaryBtnIcon}></wui-icon>
          ${this.secondaryBtnLabel}
        </wui-button>
      </wui-flex>

      ${this.isWalletConnect ? (0, $aTf3K.html)`
            <wui-flex .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]} justifyContent="center">
              <wui-link @click=${this.onCopyUri} color="fg-200">
                <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
                Copy link
              </wui-link>
            </wui-flex>
          ` : null}

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
    onShowRetry() {
        if (this.error && !this.showRetry) {
            this.showRetry = true;
            const retryButton = this.shadowRoot?.querySelector("wui-button");
            retryButton?.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    onTryAgain() {
        if (!this.buffering) {
            (0, $hlVrM.ConnectionController).setWcError(false);
            if (this.onRetry) {
                this.isRetrying = true;
                this.onRetry?.();
            } else this.onConnect?.();
        }
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $3Sg6l.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $aTf3K.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    onCopyUri() {
        try {
            if (this.uri) {
                (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.uri);
                (0, $br7WV.SnackController).showSuccess("Link copied");
            }
        } catch  {
            (0, $br7WV.SnackController).showError("Failed to copy");
        }
    }
}
$45650b9021d7e0f4$export$902e3cfa9f67689d.styles = (0, $f5ac93199cb9a723$export$2e2bcd8739ae039);
$45650b9021d7e0f4$var$__decorate([
    (0, $faUle.state)()
], $45650b9021d7e0f4$export$902e3cfa9f67689d.prototype, "uri", void 0);
$45650b9021d7e0f4$var$__decorate([
    (0, $faUle.state)()
], $45650b9021d7e0f4$export$902e3cfa9f67689d.prototype, "error", void 0);
$45650b9021d7e0f4$var$__decorate([
    (0, $faUle.state)()
], $45650b9021d7e0f4$export$902e3cfa9f67689d.prototype, "ready", void 0);
$45650b9021d7e0f4$var$__decorate([
    (0, $faUle.state)()
], $45650b9021d7e0f4$export$902e3cfa9f67689d.prototype, "showRetry", void 0);
$45650b9021d7e0f4$var$__decorate([
    (0, $faUle.state)()
], $45650b9021d7e0f4$export$902e3cfa9f67689d.prototype, "buffering", void 0);
$45650b9021d7e0f4$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $45650b9021d7e0f4$export$902e3cfa9f67689d.prototype, "isMobile", void 0);
$45650b9021d7e0f4$var$__decorate([
    (0, $jJP2r.property)()
], $45650b9021d7e0f4$export$902e3cfa9f67689d.prototype, "onRetry", void 0);


var $9ca694d6358cc88f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9ca694d6358cc88f$export$1d20b0281d81b1fd = class W3mConnectingExternalView extends (0, $45650b9021d7e0f4$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.connector) throw new Error("w3m-connecting-view: No connector provided");
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.connector.name ?? "Unknown",
                platform: "browser"
            }
        });
        this.onConnect = this.onConnectProxy.bind(this);
        this.onAutoConnect = this.onConnectProxy.bind(this);
        this.isWalletConnect = false;
    }
    async onConnectProxy() {
        try {
            this.error = false;
            if (this.connector) {
                if (this.connector.id !== (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID || !this.error) {
                    await (0, $hlVrM.ConnectionController).connectExternal(this.connector, this.connector.chain);
                    if ((0, $8BVTM.OptionsController).state.isSiweEnabled) (0, $6mRzS.RouterController).push("ConnectingSiwe");
                    else (0, $ib7WC.ModalController).close();
                    (0, $6m17w.EventsController).sendEvent({
                        type: "track",
                        event: "CONNECT_SUCCESS",
                        properties: {
                            method: "browser",
                            name: this.connector.name || "Unknown"
                        }
                    });
                }
            }
        } catch (error) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            this.error = true;
        }
    }
};
$9ca694d6358cc88f$export$1d20b0281d81b1fd = $9ca694d6358cc88f$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-external-view")
], $9ca694d6358cc88f$export$1d20b0281d81b1fd);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $d94Xg = parcelRequire("d94Xg");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $a8b7b0b86ee6e88e$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex,
  wui-list-wallet {
    width: 100%;
  }
`;


var $ed52533572a411f8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ed52533572a411f8$export$4df72daec743eb3c = class W3mConnectingMultiChainView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.activeConnector = (0, $d94Xg.ChainController).state.activeConnector;
        this.unsubscribe.push(...[
            (0, $d94Xg.ChainController).subscribeKey("activeConnector", (val)=>this.activeConnector = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "m",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-wallet-image
            size="lg"
            imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getConnectorImage(this.activeConnector))}
          ></wui-wallet-image>
        </wui-flex>
        <wui-flex
          flexDirection="column"
          alignItems="center"
          gap="xs"
          .padding=${[
            "0",
            "s",
            "0",
            "s"
        ]}
        >
          <wui-text variant="paragraph-500" color="fg-100">
            Select Chain for ${this.activeConnector?.name}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200"
            >Select which chain to connect to your multi chain wallet</wui-text
          >
        </wui-flex>
        <wui-flex
          flexGrow="1"
          flexDirection="column"
          alignItems="center"
          gap="xs"
          .padding=${[
            "xs",
            "0",
            "xs",
            "0"
        ]}
        >
          ${this.networksTemplate()}
        </wui-flex>
      </wui-flex>
    `;
    }
    networksTemplate() {
        return this.activeConnector?.providers?.map((provider)=>(0, $aTf3K.html)`
        <wui-list-wallet
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getChainImage(provider.chain))}
          name=${provider.name}
          @click=${()=>this.onConnector(provider)}
        ></wui-list-wallet>
      `);
    }
    onConnector(provider) {
        (0, $d94Xg.ChainController).setActiveChain(provider.chain);
        const connector = this.activeConnector?.providers?.find((p)=>p.chain === provider.chain);
        if (!connector) {
            (0, $br7WV.SnackController).showError("Failed to find connector");
            return;
        }
        if (connector.type === "WALLET_CONNECT") {
            if ((0, $c4rfq.CoreHelperUtil).isMobile()) (0, $6mRzS.RouterController).push("AllWallets");
            else (0, $6mRzS.RouterController).push("ConnectingWalletConnect");
        } else (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
    }
};
$ed52533572a411f8$export$4df72daec743eb3c.styles = (0, $a8b7b0b86ee6e88e$export$2e2bcd8739ae039);
$ed52533572a411f8$var$__decorate([
    (0, $faUle.state)()
], $ed52533572a411f8$export$4df72daec743eb3c.prototype, "activeConnector", void 0);
$ed52533572a411f8$export$4df72daec743eb3c = $ed52533572a411f8$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-multi-chain-view")
], $ed52533572a411f8$export$4df72daec743eb3c);


parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
var $6AwK8 = parcelRequire("6AwK8");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $860a3feca90c16a3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

let $860a3feca90c16a3$export$749260f2a44cfead = class W3mConnectingWcView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.interval = undefined;
        this.lastRetry = Date.now();
        this.wallet = (0, $6mRzS.RouterController).state.data?.wallet;
        this.platform = undefined;
        this.platforms = [];
        this.initializeConnection();
        this.interval = setInterval(this.initializeConnection.bind(this), (0, $6AwK8.ConstantsUtil).TEN_SEC_MS);
    }
    disconnectedCallback() {
        clearTimeout(this.interval);
    }
    render() {
        if (!this.wallet) return (0, $aTf3K.html)`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
        this.determinePlatforms();
        return (0, $aTf3K.html)`
      ${this.headerTemplate()}
      <div>${this.platformTemplate()}</div>
    `;
    }
    async initializeConnection(retry = false) {
        try {
            const { wcPairingExpiry: wcPairingExpiry } = (0, $hlVrM.ConnectionController).state;
            if (retry || (0, $c4rfq.CoreHelperUtil).isPairingExpired(wcPairingExpiry)) {
                await (0, $hlVrM.ConnectionController).connectWalletConnect();
                this.finalizeConnection();
                if ((0, $hdC6E.StorageUtil).getConnectedConnector() === "AUTH" && (0, $8BVTM.OptionsController).state.hasMultipleAddresses) (0, $6mRzS.RouterController).push("SelectAddresses");
                else if ((0, $8BVTM.OptionsController).state.isSiweEnabled) {
                    const { SIWEController: SIWEController } = await (parcelRequire("XE6yD"));
                    if (SIWEController.state.status === "success") (0, $ib7WC.ModalController).close();
                    else (0, $6mRzS.RouterController).push("ConnectingSiwe");
                } else (0, $ib7WC.ModalController).close();
            }
        } catch (error) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            (0, $hlVrM.ConnectionController).setWcError(true);
            if ((0, $c4rfq.CoreHelperUtil).isAllowedRetry(this.lastRetry)) {
                (0, $br7WV.SnackController).showError("Declined");
                this.lastRetry = Date.now();
                this.initializeConnection(true);
            }
        }
    }
    finalizeConnection() {
        const { wcLinking: wcLinking, recentWallet: recentWallet } = (0, $hlVrM.ConnectionController).state;
        if (wcLinking) (0, $hdC6E.StorageUtil).setWalletConnectDeepLink(wcLinking);
        if (recentWallet) (0, $hdC6E.StorageUtil).setWeb3ModalRecent(recentWallet);
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "CONNECT_SUCCESS",
            properties: {
                method: wcLinking ? "mobile" : "qrcode",
                name: this.wallet?.name || "Unknown"
            }
        });
    }
    determinePlatforms() {
        if (!this.wallet) throw new Error("w3m-connecting-wc-view:determinePlatforms No wallet");
        if (this.platform) return;
        const { mobile_link: mobile_link, desktop_link: desktop_link, webapp_link: webapp_link, injected: injected, rdns: rdns } = this.wallet;
        const injectedIds = injected?.map(({ injected_id: injected_id })=>injected_id).filter(Boolean);
        const browserIds = rdns ? [
            rdns
        ] : injectedIds ?? [];
        const isBrowser = (0, $8BVTM.OptionsController).state.isUniversalProvider ? false : browserIds.length;
        const isMobileWc = mobile_link;
        const isWebWc = webapp_link;
        const isBrowserInstalled = (0, $hlVrM.ConnectionController).checkInstalled(browserIds);
        const isBrowserWc = isBrowser && isBrowserInstalled;
        const isDesktopWc = desktop_link && !(0, $c4rfq.CoreHelperUtil).isMobile();
        if (isBrowserWc) this.platforms.push("browser");
        if (isMobileWc) this.platforms.push((0, $c4rfq.CoreHelperUtil).isMobile() ? "mobile" : "qrcode");
        if (isWebWc) this.platforms.push("web");
        if (isDesktopWc) this.platforms.push("desktop");
        if (!isBrowserWc && isBrowser) this.platforms.push("unsupported");
        this.platform = this.platforms[0];
    }
    platformTemplate() {
        switch(this.platform){
            case "browser":
                return (0, $aTf3K.html)`<w3m-connecting-wc-browser></w3m-connecting-wc-browser>`;
            case "desktop":
                return (0, $aTf3K.html)`
          <w3m-connecting-wc-desktop .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-desktop>
        `;
            case "web":
                return (0, $aTf3K.html)`
          <w3m-connecting-wc-web .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-web>
        `;
            case "mobile":
                return (0, $aTf3K.html)`
          <w3m-connecting-wc-mobile isMobile .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-mobile>
        `;
            case "qrcode":
                return (0, $aTf3K.html)`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
            default:
                return (0, $aTf3K.html)`<w3m-connecting-wc-unsupported></w3m-connecting-wc-unsupported>`;
        }
    }
    headerTemplate() {
        const multiPlatform = this.platforms.length > 1;
        if (!multiPlatform) return null;
        return (0, $aTf3K.html)`
      <w3m-connecting-header
        .platforms=${this.platforms}
        .onSelectPlatfrom=${this.onSelectPlatform.bind(this)}
      >
      </w3m-connecting-header>
    `;
    }
    async onSelectPlatform(platform) {
        const container = this.shadowRoot?.querySelector("div");
        if (container) {
            await container.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.platform = platform;
            container.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
};
$860a3feca90c16a3$var$__decorate([
    (0, $faUle.state)()
], $860a3feca90c16a3$export$749260f2a44cfead.prototype, "platform", void 0);
$860a3feca90c16a3$var$__decorate([
    (0, $faUle.state)()
], $860a3feca90c16a3$export$749260f2a44cfead.prototype, "platforms", void 0);
$860a3feca90c16a3$export$749260f2a44cfead = $860a3feca90c16a3$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-wc-view")
], $860a3feca90c16a3$export$749260f2a44cfead);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $14c4fe953a7378f2$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  .continue-button-container {
    width: 100%;
  }
`;


parcelRequire("ikDNi");
var $jgvE4 = parcelRequire("jgvE4");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $2e00a27002579017$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2e00a27002579017$export$8697ba8a32799bc3 = class W3mChooseAccountNameView extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.loading = false;
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        gap="xxl"
        .padding=${[
            "0",
            "0",
            "l",
            "0"
        ]}
      >
        ${this.onboardingTemplate()} ${this.buttonsTemplate()}
        <wui-link
          @click=${()=>{
            (0, $c4rfq.CoreHelperUtil).openHref((0, $jgvE4.NavigationUtil).URLS.FAQ, "_blank");
        }}
        >
          Learn more about names
          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>
        </wui-link>
      </wui-flex>
    `;
    }
    onboardingTemplate() {
        return (0, $aTf3K.html)` <wui-flex
      flexDirection="column"
      gap="xxl"
      alignItems="center"
      .padding=${[
            "0",
            "xxl",
            "0",
            "xxl"
        ]}
    >
      <wui-flex gap="s" alignItems="center" justifyContent="center">
        <wui-icon-box
          icon="id"
          size="xl"
          iconSize="xxl"
          iconColor="fg-200"
          backgroundColor="fg-200"
        ></wui-icon-box>
      </wui-flex>
      <wui-flex flexDirection="column" alignItems="center" gap="s">
        <wui-text align="center" variant="medium-600" color="fg-100">
          Choose your account name
        </wui-text>
        <wui-text align="center" variant="paragraph-400" color="fg-100">
          Finally say goodbye to 0x addresses, name your account to make it easier to exchange
          assets
        </wui-text>
      </wui-flex>
    </wui-flex>`;
    }
    buttonsTemplate() {
        return (0, $aTf3K.html)`<wui-flex
      .padding=${[
            "0",
            "2l",
            "0",
            "2l"
        ]}
      gap="s"
      class="continue-button-container"
    >
      <wui-button
        fullWidth
        .loading=${this.loading}
        size="lg"
        borderRadius="xs"
        @click=${this.handleContinue.bind(this)}
        >Choose name
      </wui-button>
    </wui-flex>`;
    }
    handleContinue() {
        (0, $6mRzS.RouterController).push("RegisterAccountName");
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "OPEN_ENS_FLOW",
            properties: {
                isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
            }
        });
    }
};
$2e00a27002579017$export$8697ba8a32799bc3.styles = (0, $14c4fe953a7378f2$export$2e2bcd8739ae039);
$2e00a27002579017$var$__decorate([
    (0, $faUle.state)()
], $2e00a27002579017$export$8697ba8a32799bc3.prototype, "loading", void 0);
$2e00a27002579017$export$8697ba8a32799bc3 = $2e00a27002579017$var$__decorate([
    (0, $ailZp.customElement)("w3m-choose-account-name-view")
], $2e00a27002579017$export$8697ba8a32799bc3);


parcelRequire("eNJDH");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
var $891d01e8d67dec84$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $891d01e8d67dec84$export$72485cd62e8c17e7 = class W3mDownloadsView extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.wallet = (0, $6mRzS.RouterController).state.data?.wallet;
    }
    render() {
        if (!this.wallet) throw new Error("w3m-downloads-view");
        return (0, $aTf3K.html)`
      <wui-flex gap="xs" flexDirection="column" .padding=${[
            "s",
            "s",
            "l",
            "s"
        ]}>
        ${this.chromeTemplate()} ${this.iosTemplate()} ${this.androidTemplate()}
        ${this.homepageTemplate()}
      </wui-flex>
    `;
    }
    chromeTemplate() {
        if (!this.wallet?.chrome_store) return null;
        return (0, $aTf3K.html)`<wui-list-item
      variant="icon"
      icon="chromeStore"
      iconVariant="square"
      @click=${this.onChromeStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Chrome Extension</wui-text>
    </wui-list-item>`;
    }
    iosTemplate() {
        if (!this.wallet?.app_store) return null;
        return (0, $aTf3K.html)`<wui-list-item
      variant="icon"
      icon="appStore"
      iconVariant="square"
      @click=${this.onAppStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">iOS App</wui-text>
    </wui-list-item>`;
    }
    androidTemplate() {
        if (!this.wallet?.play_store) return null;
        return (0, $aTf3K.html)`<wui-list-item
      variant="icon"
      icon="playStore"
      iconVariant="square"
      @click=${this.onPlayStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Android App</wui-text>
    </wui-list-item>`;
    }
    homepageTemplate() {
        if (!this.wallet?.homepage) return null;
        return (0, $aTf3K.html)`
      <wui-list-item
        variant="icon"
        icon="browser"
        iconVariant="square-blue"
        @click=${this.onHomePage.bind(this)}
        chevron
      >
        <wui-text variant="paragraph-500" color="fg-100">Website</wui-text>
      </wui-list-item>
    `;
    }
    onChromeStore() {
        if (this.wallet?.chrome_store) (0, $c4rfq.CoreHelperUtil).openHref(this.wallet.chrome_store, "_blank");
    }
    onAppStore() {
        if (this.wallet?.app_store) (0, $c4rfq.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
    }
    onPlayStore() {
        if (this.wallet?.play_store) (0, $c4rfq.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
    }
    onHomePage() {
        if (this.wallet?.homepage) (0, $c4rfq.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
    }
};
$891d01e8d67dec84$export$72485cd62e8c17e7 = $891d01e8d67dec84$var$__decorate([
    (0, $ailZp.customElement)("w3m-downloads-view")
], $891d01e8d67dec84$export$72485cd62e8c17e7);


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $eOULk = parcelRequire("eOULk");
var $c4rfq = parcelRequire("c4rfq");
var $8BVTM = parcelRequire("8BVTM");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");

var $0249a4cb5446820a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $0249a4cb5446820a$var$EXPLORER = "https://walletconnect.com/explorer";
let $0249a4cb5446820a$export$24ca15e036ec0442 = class W3mGetWalletView extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]} gap="xs">
        ${this.recommendedWalletsTemplate()}
        <wui-list-wallet
          name="Explore all"
          showAllWallets
          walletIcon="allWallets"
          icon="externalLink"
          @click=${()=>{
            (0, $c4rfq.CoreHelperUtil).openHref("https://walletconnect.com/explorer?type=wallet", "_blank");
        }}
        ></wui-list-wallet>
      </wui-flex>
    `;
    }
    recommendedWalletsTemplate() {
        const { recommended: recommended, featured: featured } = (0, $g4s8N.ApiController).state;
        const { customWallets: customWallets } = (0, $8BVTM.OptionsController).state;
        const wallets = [
            ...featured,
            ...customWallets ?? [],
            ...recommended
        ].slice(0, 4);
        return wallets.map((wallet)=>(0, $aTf3K.html)`
        <wui-list-wallet
          name=${wallet.name ?? "Unknown"}
          tagVariant="main"
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getWalletImage(wallet))}
          @click=${()=>{
                (0, $c4rfq.CoreHelperUtil).openHref(wallet.homepage ?? $0249a4cb5446820a$var$EXPLORER, "_blank");
            }}
        ></wui-list-wallet>
      `);
    }
};
$0249a4cb5446820a$export$24ca15e036ec0442 = $0249a4cb5446820a$var$__decorate([
    (0, $ailZp.customElement)("w3m-get-wallet-view")
], $0249a4cb5446820a$export$24ca15e036ec0442);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $cbbdd2a0ea82bb43$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex {
    width: 100%;
  }

  .suggestion {
    background: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }

  .suggestion:hover {
    background-color: var(--wui-color-gray-glass-005);
    cursor: pointer;
  }

  .suggested-name {
    max-width: 75%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  form {
    width: 100%;
  }

  wui-icon-link {
    position: absolute;
    right: 20px;
    transform: translateY(11px);
  }
`;



var $aTf3K = parcelRequire("aTf3K");

var $aTf3K = parcelRequire("aTf3K");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $5e1d9bc85940a93a$var$et } = (0, $aTf3K._$LH), $5e1d9bc85940a93a$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $5e1d9bc85940a93a$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $5e1d9bc85940a93a$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $5e1d9bc85940a93a$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $5e1d9bc85940a93a$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $5e1d9bc85940a93a$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $5e1d9bc85940a93a$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $5e1d9bc85940a93a$var$lt = ()=>document.createComment(""), $5e1d9bc85940a93a$export$291b2338ad9b0b30 = (o, t, i)=>{
    const n = o._$AA.parentNode, e = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = n.insertBefore($5e1d9bc85940a93a$var$lt(), e), l = n.insertBefore($5e1d9bc85940a93a$var$lt(), e);
        i = new $5e1d9bc85940a93a$var$et(t, l, o, o.options);
    } else {
        const t = i._$AB.nextSibling, l = i._$AM, c = l !== o;
        if (c) {
            let t;
            i._$AQ?.(o), i._$AM = o, void 0 !== i._$AP && (t = o._$AU) !== l._$AU && i._$AP(t);
        }
        if (t !== e || c) {
            let o = i._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                n.insertBefore(o, e), o = t;
            }
        }
    }
    return i;
}, $5e1d9bc85940a93a$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $5e1d9bc85940a93a$var$ht = {}, $5e1d9bc85940a93a$export$ea70d9dd5965b1c8 = (o, t = $5e1d9bc85940a93a$var$ht)=>o._$AH = t, $5e1d9bc85940a93a$export$59e9bce518cde500 = (o)=>o._$AH, $5e1d9bc85940a93a$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $5e1d9bc85940a93a$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $552f764fd91759bf$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $552f764fd91759bf$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $552f764fd91759bf$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f0d2111edb9c9c9a$var$mt = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $f0d2111edb9c9c9a$var$mt(i, t);
    return !0;
}, $f0d2111edb9c9c9a$var$_t = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $f0d2111edb9c9c9a$var$wt = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $f0d2111edb9c9c9a$var$gt(t);
    }
};
function $f0d2111edb9c9c9a$var$bt(i) {
    void 0 !== this._$AN ? ($f0d2111edb9c9c9a$var$_t(this), this._$AM = i, $f0d2111edb9c9c9a$var$wt(this)) : this._$AM = i;
}
function $f0d2111edb9c9c9a$var$yt(i, t = !1, e = 0) {
    const s = this._$AH, o = this._$AN;
    if (void 0 !== o && 0 !== o.size) {
        if (t) {
            if (Array.isArray(s)) for(let i = e; i < s.length; i++)$f0d2111edb9c9c9a$var$mt(s[i], !1), $f0d2111edb9c9c9a$var$_t(s[i]);
            else null != s && ($f0d2111edb9c9c9a$var$mt(s, !1), $f0d2111edb9c9c9a$var$_t(s));
        } else $f0d2111edb9c9c9a$var$mt(this, i);
    }
}
const $f0d2111edb9c9c9a$var$gt = (i)=>{
    i.type == (0, $552f764fd91759bf$export$9ba3b3f20a85bfa).CHILD && (i._$AP ??= $f0d2111edb9c9c9a$var$yt, i._$AQ ??= $f0d2111edb9c9c9a$var$bt);
};
class $f0d2111edb9c9c9a$export$7d025501802325e extends (0, $552f764fd91759bf$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $f0d2111edb9c9c9a$var$wt(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($f0d2111edb9c9c9a$var$mt(this, i), $f0d2111edb9c9c9a$var$_t(this));
    }
    setValue(i) {
        if ((0, $5e1d9bc85940a93a$export$7f431ad0fff82fd9)(this.t)) this.t._$AI(i, this);
        else {
            const t = [
                ...this.t._$AH
            ];
            t[this.i] = i, this.t._$AI(t, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8fa5b8d3f98eecf3$export$7d1e3a5e95ceca43 = ()=>new $8fa5b8d3f98eecf3$var$Zt;
class $8fa5b8d3f98eecf3$var$Zt {
}
const $8fa5b8d3f98eecf3$var$qt = new WeakMap, $8fa5b8d3f98eecf3$export$eff4d24c3ff7876e = (0, $552f764fd91759bf$export$99b43ad1ed32e735)(class extends (0, $f0d2111edb9c9c9a$export$7d025501802325e) {
    render(t) {
        return 0, $aTf3K.nothing;
    }
    update(t, [i]) {
        const s = i !== this.Y;
        return s && void 0 !== this.Y && this.rt(void 0), (s || this.lt !== this.ct) && (this.Y = i, this.ht = t.options?.host, this.rt(this.ct = t.element)), $aTf3K.nothing;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $8fa5b8d3f98eecf3$var$qt.get(i);
            void 0 === s && (s = new WeakMap, $8fa5b8d3f98eecf3$var$qt.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $8fa5b8d3f98eecf3$var$qt.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});




parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $c4rfq = parcelRequire("c4rfq");
var $4DSpJ = parcelRequire("4DSpJ");
var $6m17w = parcelRequire("6m17w");
var $br7WV = parcelRequire("br7WV");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $913fb8c6f6ef1be9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $913fb8c6f6ef1be9$export$4bdeb34003c74fa7 = class W3mRegisterAccountNameView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.formRef = (0, $8fa5b8d3f98eecf3$export$7d1e3a5e95ceca43)();
        this.usubscribe = [];
        this.name = "";
        this.error = "";
        this.loading = (0, $4DSpJ.EnsController).state.loading;
        this.suggestions = (0, $4DSpJ.EnsController).state.suggestions;
        this.registered = false;
        this.profileName = (0, $f7IXw.AccountController).state.profileName;
        this.onDebouncedNameInputChange = (0, $c4rfq.CoreHelperUtil).debounce((value)=>{
            if ((0, $4DSpJ.EnsController).validateName(value)) {
                this.error = "";
                this.name = value;
                (0, $4DSpJ.EnsController).getSuggestions(value);
                (0, $4DSpJ.EnsController).isNameRegistered(value).then((registered)=>{
                    this.registered = registered;
                });
            } else if (value.length < 4) this.error = "Name must be at least 4 characters long";
            else this.error = "Can only contain letters, numbers and - characters";
        });
        this.usubscribe.push(...[
            (0, $4DSpJ.EnsController).subscribe((val)=>{
                this.suggestions = val.suggestions;
                this.loading = val.loading;
            }),
            (0, $f7IXw.AccountController).subscribeKey("profileName", (val)=>{
                this.profileName = val;
                if (val) this.error = "You already own a name";
            })
        ]);
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", this.onEnterKey.bind(this));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.usubscribe.forEach((unsub)=>unsub());
        this.formRef.value?.removeEventListener("keydown", this.onEnterKey.bind(this));
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        gap="m"
        .padding=${[
            "0",
            "s",
            "m",
            "s"
        ]}
      >
        <form ${(0, $8fa5b8d3f98eecf3$export$eff4d24c3ff7876e)(this.formRef)} @submit=${this.onSubmitName.bind(this)}>
          <wui-ens-input
            @inputChange=${this.onNameInputChange.bind(this)}
            .errorMessage=${this.error}
            .value=${this.name}
          >
          </wui-ens-input>
          ${this.submitButtonTemplate()}
          <input type="submit" hidden />
        </form>
        ${this.templateSuggestions()}
      </wui-flex>
    `;
    }
    submitButtonTemplate() {
        const showSubmit = this.isAllowedToSubmit();
        return showSubmit ? (0, $aTf3K.html)`
          <wui-icon-link
            size="sm"
            icon="chevronRight"
            iconcolor="accent-100"
            @click=${this.onSubmitName.bind(this)}
          >
          </wui-icon-link>
        ` : null;
    }
    onSelectSuggestion(name) {
        return ()=>{
            this.name = name;
            this.registered = false;
            this.requestUpdate();
        };
    }
    onNameInputChange(event) {
        this.onDebouncedNameInputChange(event.detail);
    }
    nameSuggestionTagTemplate() {
        if (this.loading) return (0, $aTf3K.html)`<wui-loading-spinner size="lg" color="fg-100"></wui-loading-spinner>`;
        return this.registered ? (0, $aTf3K.html)`<wui-tag variant="shade" size="lg">Registered</wui-tag>` : (0, $aTf3K.html)`<wui-tag variant="success" size="lg">Available</wui-tag>`;
    }
    templateSuggestions() {
        if (!this.name || this.name.length < 4 || this.error) return null;
        const suggestions = this.registered ? this.suggestions.filter((s)=>s.name !== this.name) : [];
        return (0, $aTf3K.html)`<wui-flex flexDirection="column" gap="xxs" alignItems="center">
      <wui-flex
        data-testid="account-name-suggestion"
        .padding=${[
            "m",
            "m",
            "m",
            "m"
        ]}
        justifyContent="space-between"
        class="suggestion"
      >
        <wui-text color="fg-100" variant="paragraph-400" class="suggested-name">
          ${this.name}</wui-text
        >${this.nameSuggestionTagTemplate()}
      </wui-flex>
      ${suggestions.map((suggestion)=>this.availableNameTemplate(suggestion.name))}
    </wui-flex>`;
    }
    availableNameTemplate(suggestion) {
        return (0, $aTf3K.html)` <wui-flex
      data-testid="account-name-suggestion"
      .padding=${[
            "m",
            "m",
            "m",
            "m"
        ]}
      justifyContent="space-between"
      class="suggestion"
      @click=${this.onSelectSuggestion(suggestion)}
    >
      <wui-text color="fg-100" variant="paragraph-400" class="suggested-name">
        ${suggestion}
      </wui-text>
      <wui-tag variant="success" size="lg">Available</wui-tag>
    </wui-flex>`;
    }
    isAllowedToSubmit() {
        return !this.loading && !this.registered && !this.error && !this.profileName && (0, $4DSpJ.EnsController).validateName(this.name);
    }
    async onSubmitName() {
        try {
            if (!this.isAllowedToSubmit()) return;
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "REGISTER_NAME_INITIATED",
                properties: {
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    ensName: this.name
                }
            });
            await (0, $4DSpJ.EnsController).registerName(this.name);
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "REGISTER_NAME_SUCCESS",
                properties: {
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    ensName: this.name
                }
            });
        } catch (error) {
            (0, $br7WV.SnackController).showError(error.message);
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "REGISTER_NAME_ERROR",
                properties: {
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    ensName: this.name,
                    error: error?.message || "Unknown error"
                }
            });
        }
    }
    onEnterKey(event) {
        if (event.key === "Enter" && this.isAllowedToSubmit()) this.onSubmitName();
    }
};
$913fb8c6f6ef1be9$export$4bdeb34003c74fa7.styles = (0, $cbbdd2a0ea82bb43$export$2e2bcd8739ae039);
$913fb8c6f6ef1be9$var$__decorate([
    (0, $jJP2r.property)()
], $913fb8c6f6ef1be9$export$4bdeb34003c74fa7.prototype, "errorMessage", void 0);
$913fb8c6f6ef1be9$var$__decorate([
    (0, $faUle.state)()
], $913fb8c6f6ef1be9$export$4bdeb34003c74fa7.prototype, "name", void 0);
$913fb8c6f6ef1be9$var$__decorate([
    (0, $faUle.state)()
], $913fb8c6f6ef1be9$export$4bdeb34003c74fa7.prototype, "error", void 0);
$913fb8c6f6ef1be9$var$__decorate([
    (0, $faUle.state)()
], $913fb8c6f6ef1be9$export$4bdeb34003c74fa7.prototype, "loading", void 0);
$913fb8c6f6ef1be9$var$__decorate([
    (0, $faUle.state)()
], $913fb8c6f6ef1be9$export$4bdeb34003c74fa7.prototype, "suggestions", void 0);
$913fb8c6f6ef1be9$var$__decorate([
    (0, $faUle.state)()
], $913fb8c6f6ef1be9$export$4bdeb34003c74fa7.prototype, "registered", void 0);
$913fb8c6f6ef1be9$var$__decorate([
    (0, $faUle.state)()
], $913fb8c6f6ef1be9$export$4bdeb34003c74fa7.prototype, "profileName", void 0);
$913fb8c6f6ef1be9$export$4bdeb34003c74fa7 = $913fb8c6f6ef1be9$var$__decorate([
    (0, $ailZp.customElement)("w3m-register-account-name-view")
], $913fb8c6f6ef1be9$export$4bdeb34003c74fa7);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("eNJDH");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $38745ad289649d01$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  .continue-button-container {
    width: 100%;
  }
`;


parcelRequire("ikDNi");
var $jgvE4 = parcelRequire("jgvE4");
var $036ec12a9444c4b7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $036ec12a9444c4b7$export$ee9fc061481b900a = class W3mRegisterAccountNameSuccess extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        gap="xxl"
        .padding=${[
            "0",
            "0",
            "l",
            "0"
        ]}
      >
        ${this.onboardingTemplate()} ${this.buttonsTemplate()}
        <wui-link
          @click=${()=>{
            (0, $c4rfq.CoreHelperUtil).openHref((0, $jgvE4.NavigationUtil).URLS.FAQ, "_blank");
        }}
        >
          Learn more
          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>
        </wui-link>
      </wui-flex>
    `;
    }
    onboardingTemplate() {
        return (0, $aTf3K.html)` <wui-flex
      flexDirection="column"
      gap="xxl"
      alignItems="center"
      .padding=${[
            "0",
            "xxl",
            "0",
            "xxl"
        ]}
    >
      <wui-flex gap="s" alignItems="center" justifyContent="center">
        <wui-icon-box
          size="xl"
          iconcolor="success-100"
          backgroundcolor="success-100"
          icon="checkmark"
          background="opaque"
        ></wui-icon-box>
      </wui-flex>
      <wui-flex flexDirection="column" alignItems="center" gap="s">
        <wui-text align="center" variant="medium-600" color="fg-100">
          Account name chosen successfully
        </wui-text>
        <wui-text align="center" variant="paragraph-400" color="fg-100">
          You can now fund your account and trade crypto
        </wui-text>
      </wui-flex>
    </wui-flex>`;
    }
    buttonsTemplate() {
        return (0, $aTf3K.html)`<wui-flex
      .padding=${[
            "0",
            "2l",
            "0",
            "2l"
        ]}
      gap="s"
      class="continue-button-container"
    >
      <wui-button fullWidth size="lg" borderRadius="xs" @click=${this.redirectToAccount.bind(this)}
        >Let's Go!
      </wui-button>
    </wui-flex>`;
    }
    redirectToAccount() {
        (0, $6mRzS.RouterController).replace("Account");
    }
};
$036ec12a9444c4b7$export$ee9fc061481b900a.styles = (0, $38745ad289649d01$export$2e2bcd8739ae039);
$036ec12a9444c4b7$export$ee9fc061481b900a = $036ec12a9444c4b7$var$__decorate([
    (0, $ailZp.customElement)("w3m-register-account-name-success-view")
], $036ec12a9444c4b7$export$ee9fc061481b900a);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $7Xn6F = parcelRequire("7Xn6F");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $2cfc2f88b295560a$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-hexagon {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: 4px;
    bottom: 0;
    opacity: 0;
    transform: scale(0.5);
    z-index: 1;
  }

  wui-button {
    display: none;
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  wui-button[data-retry='true'] {
    display: block;
    opacity: 1;
  }
`;


parcelRequire("eNJDH");
var $8BVTM = parcelRequire("8BVTM");
var $bmR1U = parcelRequire("bmR1U");

const $9512bcc8a1d25c7a$export$79d00c05833eff69 = {
    onNetworkChange: async ()=>{
        if ((0, $8BVTM.OptionsController).state.isSiweEnabled) {
            const { SIWEController: SIWEController } = await (parcelRequire("XE6yD"));
            if (SIWEController.state._client?.options?.signOutOnNetworkChange) await SIWEController.signOut();
            else (0, $bmR1U.RouterUtil).navigateAfterNetworkSwitch();
        } else (0, $bmR1U.RouterUtil).navigateAfterNetworkSwitch();
    }
};


var $bfeb5d80723f625e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bfeb5d80723f625e$export$d124f6a585588d61 = class W3mNetworkSwitchView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.network = (0, $6mRzS.RouterController).state.data?.network;
        this.unsubscribe = [];
        this.showRetry = false;
        this.error = false;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    firstUpdated() {
        this.onSwitchNetwork();
    }
    render() {
        if (!this.network) throw new Error("w3m-network-switch-view: No network provided");
        this.onShowRetry();
        const label = this.getLabel();
        const subLabel = this.getSubLabel();
        return (0, $aTf3K.html)`
      <wui-flex
        data-error=${this.error}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "3xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-network-image
            size="lg"
            imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getNetworkImage(this.network))}
          ></wui-network-image>

          ${this.error ? null : (0, $aTf3K.html)`<wui-loading-hexagon></wui-loading-hexagon>`}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            ?border=${true}
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100">${label}</wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        <wui-button
          data-retry=${this.showRetry}
          variant="accent"
          size="md"
          .disabled=${!this.error}
          @click=${this.onSwitchNetwork.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>
          Try again
        </wui-button>
      </wui-flex>
    `;
    }
    getSubLabel() {
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (authConnector && type === "AUTH") return "";
        return this.error ? "Switch can be declined if chain is not supported by a wallet or previous request is still active" : "Accept connection request in your wallet";
    }
    getLabel() {
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (authConnector && type === "AUTH") return `Switching to ${this.network?.name ?? "Unknown"} network...`;
        return this.error ? "Switch declined" : "Approve in wallet";
    }
    onShowRetry() {
        if (this.error && !this.showRetry) {
            this.showRetry = true;
            const retryButton = this.shadowRoot?.querySelector("wui-button");
            retryButton?.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    async onSwitchNetwork() {
        try {
            this.error = false;
            if (this.network) {
                await (0, $jbD0z.NetworkController).switchActiveNetwork(this.network);
                await (0, $9512bcc8a1d25c7a$export$79d00c05833eff69).onNetworkChange();
            }
        } catch  {
            this.error = true;
        }
    }
};
$bfeb5d80723f625e$export$d124f6a585588d61.styles = (0, $2cfc2f88b295560a$export$2e2bcd8739ae039);
$bfeb5d80723f625e$var$__decorate([
    (0, $faUle.state)()
], $bfeb5d80723f625e$export$d124f6a585588d61.prototype, "showRetry", void 0);
$bfeb5d80723f625e$var$__decorate([
    (0, $faUle.state)()
], $bfeb5d80723f625e$export$d124f6a585588d61.prototype, "error", void 0);
$bfeb5d80723f625e$export$d124f6a585588d61 = $bfeb5d80723f625e$var$__decorate([
    (0, $ailZp.customElement)("w3m-network-switch-view")
], $bfeb5d80723f625e$export$d124f6a585588d61);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $d94Xg = parcelRequire("d94Xg");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $3ba7140f143a250a$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  .container {
    max-height: 360px;
    overflow: auto;
  }

  .container::-webkit-scrollbar {
    display: none;
  }
`;



var $91d418abb7c72aeb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $91d418abb7c72aeb$export$ff1f854e9d8d99b2 = class W3mNetworksView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.network = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        this.search = "";
        this.onDebouncedSearch = (0, $c4rfq.CoreHelperUtil).debounce((value)=>{
            this.search = value;
        }, 100);
        this.unsubscribe.push((0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      ${this.templateSearchInput()}
      <wui-flex
        class="container"
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        flexDirection="column"
        gap="xs"
      >
        ${this.networksTemplate()}
      </wui-flex>

      <wui-separator></wui-separator>

      <wui-flex padding="s" flexDirection="column" gap="m" alignItems="center">
        <wui-text variant="small-400" color="fg-300" align="center">
          Your connected wallet may not support some of the networks available for this dApp
        </wui-text>
        <wui-link @click=${this.onNetworkHelp.bind(this)}>
          <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>
          What is a network
        </wui-link>
      </wui-flex>
    `;
    }
    templateSearchInput() {
        return (0, $aTf3K.html)`
      <wui-flex gap="xs" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}>
        <wui-input-text
          @inputChange=${this.onInputChange.bind(this)}
          class="network-search-input"
          size="md"
          placeholder="Search network"
          icon="search"
        ></wui-input-text>
      </wui-flex>
    `;
    }
    onInputChange(event) {
        this.onDebouncedSearch(event.detail);
    }
    onNetworkHelp() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "CLICK_NETWORK_HELP"
        });
        (0, $6mRzS.RouterController).push("WhatIsANetwork");
    }
    networksTemplate() {
        const requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        const approvedCaipNetworkIds = (0, $jbD0z.NetworkController).state.approvedCaipNetworkIds;
        const supportsAllNetworks = (0, $jbD0z.NetworkController).state.supportsAllNetworks;
        const sortedNetworks = (0, $c4rfq.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
        if (this.search) this.filteredNetworks = sortedNetworks?.filter((network)=>network?.name?.toLowerCase().includes(this.search.toLowerCase()));
        else this.filteredNetworks = sortedNetworks;
        return this.filteredNetworks?.map((network)=>(0, $aTf3K.html)`
        <wui-list-network
          .selected=${this.network?.id === network.id}
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getNetworkImage(network))}
          type="network"
          name=${network.name ?? network.id}
          @click=${()=>this.onSwitchNetwork(network)}
          .disabled=${!supportsAllNetworks && !approvedCaipNetworkIds?.includes(network.id) && network.chain === (0, $d94Xg.ChainController).state.activeChain}
          data-testid=${`w3m-network-switch-${network.name ?? network.id}`}
        ></wui-list-network>
      `);
    }
    async onSwitchNetwork(network) {
        const isConnected = (0, $f7IXw.AccountController).state.isConnected;
        const isNetworkChainConnected = (0, $f7IXw.AccountController).getChainIsConnected(network.chain);
        const approvedCaipNetworkIds = (0, $jbD0z.NetworkController).state.approvedCaipNetworkIds;
        const supportsAllNetworks = (0, $jbD0z.NetworkController).state.supportsAllNetworks;
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        const routerData = (0, $6mRzS.RouterController).state.data;
        if (isConnected && caipNetwork?.id !== network.id) {
            if (!isNetworkChainConnected) {
                (0, $6mRzS.RouterController).push("SwitchActiveChain", {
                    switchToChain: network.chain,
                    navigateTo: "Connect",
                    navigateWithReplace: true
                });
                return;
            }
            if (approvedCaipNetworkIds?.includes(network.id)) {
                await (0, $jbD0z.NetworkController).switchActiveNetwork(network);
                await (0, $9512bcc8a1d25c7a$export$79d00c05833eff69).onNetworkChange();
            } else if (supportsAllNetworks) (0, $6mRzS.RouterController).push("SwitchNetwork", {
                ...routerData,
                network: network
            });
        } else if (!isConnected) {
            (0, $jbD0z.NetworkController).setActiveCaipNetwork(network);
            if (!isNetworkChainConnected) (0, $6mRzS.RouterController).push("Connect");
        }
    }
};
$91d418abb7c72aeb$export$ff1f854e9d8d99b2.styles = (0, $3ba7140f143a250a$export$2e2bcd8739ae039);
$91d418abb7c72aeb$var$__decorate([
    (0, $faUle.state)()
], $91d418abb7c72aeb$export$ff1f854e9d8d99b2.prototype, "network", void 0);
$91d418abb7c72aeb$var$__decorate([
    (0, $faUle.state)()
], $91d418abb7c72aeb$export$ff1f854e9d8d99b2.prototype, "requestedCaipNetworks", void 0);
$91d418abb7c72aeb$var$__decorate([
    (0, $faUle.state)()
], $91d418abb7c72aeb$export$ff1f854e9d8d99b2.prototype, "filteredNetworks", void 0);
$91d418abb7c72aeb$var$__decorate([
    (0, $faUle.state)()
], $91d418abb7c72aeb$export$ff1f854e9d8d99b2.prototype, "search", void 0);
$91d418abb7c72aeb$export$ff1f854e9d8d99b2 = $91d418abb7c72aeb$var$__decorate([
    (0, $ailZp.customElement)("w3m-networks-view")
], $91d418abb7c72aeb$export$ff1f854e9d8d99b2);


parcelRequire("ikDNi");
var $5kBvB = parcelRequire("5kBvB");
parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $zKxbI = parcelRequire("zKxbI");
var $jM3Wq = parcelRequire("jM3Wq");
var $8BVTM = parcelRequire("8BVTM");
var $i2wHx = parcelRequire("i2wHx");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $6emWt = parcelRequire("6emWt");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $607aaea92b1510ea$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    padding: var(--wui-spacing-m);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  :host > wui-flex::-webkit-scrollbar {
    display: none;
  }

  :host > wui-flex > wui-flex {
    width: 100%;
  }

  wui-transaction-list-item-loader {
    width: 100%;
  }
`;



var $99e31f0271762d88$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $99e31f0271762d88$var$LOADING_ITEM_COUNT = 7;
let $99e31f0271762d88$export$4a0b241548ecf9e5 = class W3mOnRampActivityView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedOnRampProvider = (0, $jM3Wq.OnRampController).state.selectedProvider;
        this.loading = false;
        this.coinbaseTransactions = (0, $i2wHx.TransactionsController).state.coinbaseTransactions;
        this.tokenImages = (0, $zKxbI.AssetController).state.tokenImages;
        this.unsubscribe.push(...[
            (0, $jM3Wq.OnRampController).subscribeKey("selectedProvider", (val)=>{
                this.selectedOnRampProvider = val;
            }),
            (0, $zKxbI.AssetController).subscribeKey("tokenImages", (val)=>this.tokenImages = val),
            ()=>{
                clearTimeout(this.refetchTimeout);
            },
            (0, $i2wHx.TransactionsController).subscribe((val)=>{
                this.coinbaseTransactions = {
                    ...val.coinbaseTransactions
                };
            })
        ]);
        (0, $i2wHx.TransactionsController).clearCursor();
        this.fetchTransactions();
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]} gap="xs">
        ${this.loading ? this.templateLoading() : this.templateTransactionsByYear()}
      </wui-flex>
    `;
    }
    templateTransactions(transactions) {
        return transactions?.map((transaction)=>{
            const date = (0, $5kBvB.DateUtil).formatDate(transaction?.metadata?.minedAt);
            const transfer = transaction.transfers[0];
            const fungibleInfo = transfer?.fungible_info;
            if (!fungibleInfo) return null;
            const icon = fungibleInfo?.icon?.url || this.tokenImages?.[fungibleInfo.symbol || ""];
            return (0, $aTf3K.html)`
        <w3m-onramp-activity-item
          label="Bought"
          .completed=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_SUCCESS"}
          .inProgress=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS"}
          .failed=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_FAILED"}
          purchaseCurrency=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(fungibleInfo.symbol)}
          purchaseValue=${transfer.quantity.numeric}
          date=${date}
          icon=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(icon)}
          symbol=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(fungibleInfo.symbol)}
        ></w3m-onramp-activity-item>
      `;
        });
    }
    templateTransactionsByYear() {
        const sortedYearKeys = Object.keys(this.coinbaseTransactions).sort().reverse();
        return sortedYearKeys.map((year)=>{
            const yearInt = parseInt(year, 10);
            const sortedMonthIndexes = new Array(12).fill(null).map((_, idx)=>idx).reverse();
            return sortedMonthIndexes.map((month)=>{
                const groupTitle = (0, $6emWt.TransactionUtil).getTransactionGroupTitle(yearInt, month);
                const transactions = this.coinbaseTransactions[yearInt]?.[month];
                if (!transactions) return null;
                return (0, $aTf3K.html)`
          <wui-flex flexDirection="column">
            <wui-flex
              alignItems="center"
              flexDirection="row"
              .padding=${[
                    "xs",
                    "s",
                    "s",
                    "s"
                ]}
            >
              <wui-text variant="paragraph-500" color="fg-200">${groupTitle}</wui-text>
            </wui-flex>
            <wui-flex flexDirection="column" gap="xs">
              ${this.templateTransactions(transactions)}
            </wui-flex>
          </wui-flex>
        `;
            });
        });
    }
    async fetchTransactions() {
        const provider = "coinbase";
        if (provider === "coinbase") await this.fetchCoinbaseTransactions();
    }
    async fetchCoinbaseTransactions() {
        const address = (0, $f7IXw.AccountController).state.address;
        const projectId = (0, $8BVTM.OptionsController).state.projectId;
        if (!address) throw new Error("No address found");
        if (!projectId) throw new Error("No projectId found");
        this.loading = true;
        await (0, $i2wHx.TransactionsController).fetchTransactions(address, "coinbase");
        this.loading = false;
        this.refetchLoadingTransactions();
    }
    refetchLoadingTransactions() {
        const today = new Date();
        const currentMonthTxs = this.coinbaseTransactions[today.getFullYear()]?.[today.getMonth()] || [];
        const loadingTransactions = currentMonthTxs.filter((transaction)=>transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS");
        if (loadingTransactions.length === 0) {
            clearTimeout(this.refetchTimeout);
            return;
        }
        this.refetchTimeout = setTimeout(async ()=>{
            const address = (0, $f7IXw.AccountController).state.address;
            await (0, $i2wHx.TransactionsController).fetchTransactions(address, "coinbase");
            this.refetchLoadingTransactions();
        }, 3000);
    }
    templateLoading() {
        return Array($99e31f0271762d88$var$LOADING_ITEM_COUNT).fill((0, $aTf3K.html)` <wui-transaction-list-item-loader></wui-transaction-list-item-loader> `).map((item)=>item);
    }
};
$99e31f0271762d88$export$4a0b241548ecf9e5.styles = (0, $607aaea92b1510ea$export$2e2bcd8739ae039);
$99e31f0271762d88$var$__decorate([
    (0, $faUle.state)()
], $99e31f0271762d88$export$4a0b241548ecf9e5.prototype, "selectedOnRampProvider", void 0);
$99e31f0271762d88$var$__decorate([
    (0, $faUle.state)()
], $99e31f0271762d88$export$4a0b241548ecf9e5.prototype, "loading", void 0);
$99e31f0271762d88$var$__decorate([
    (0, $faUle.state)()
], $99e31f0271762d88$export$4a0b241548ecf9e5.prototype, "coinbaseTransactions", void 0);
$99e31f0271762d88$var$__decorate([
    (0, $faUle.state)()
], $99e31f0271762d88$export$4a0b241548ecf9e5.prototype, "tokenImages", void 0);
$99e31f0271762d88$export$4a0b241548ecf9e5 = $99e31f0271762d88$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-activity-view")
], $99e31f0271762d88$export$4a0b241548ecf9e5);


parcelRequire("eNJDH");
var $zKxbI = parcelRequire("zKxbI");
var $ib7WC = parcelRequire("ib7WC");
var $jM3Wq = parcelRequire("jM3Wq");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $3721d1b3ad4f7fcd$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;



var $4cf3a3f8222df1ad$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4cf3a3f8222df1ad$export$d8e2d72354b51198 = class W3mOnrampFiatSelectView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedCurrency = (0, $jM3Wq.OnRampController).state.paymentCurrency;
        this.currencies = (0, $jM3Wq.OnRampController).state.paymentCurrencies;
        this.currencyImages = (0, $zKxbI.AssetController).state.currencyImages;
        this.unsubscribe.push(...[
            (0, $jM3Wq.OnRampController).subscribe((val)=>{
                this.selectedCurrency = val.paymentCurrency;
                this.currencies = val.paymentCurrencies;
            }),
            (0, $zKxbI.AssetController).subscribeKey("currencyImages", (val)=>this.currencyImages = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]} gap="xs">
        ${this.currenciesTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    currenciesTemplate() {
        return this.currencies.map((currency)=>(0, $aTf3K.html)`
        <wui-list-item
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.currencyImages?.[currency.id])}
          @click=${()=>this.selectCurrency(currency)}
          variant="image"
        >
          <wui-text variant="paragraph-500" color="fg-100">${currency.id}</wui-text>
        </wui-list-item>
      `);
    }
    selectCurrency(currency) {
        if (!currency) return;
        (0, $jM3Wq.OnRampController).setPaymentCurrency(currency);
        (0, $ib7WC.ModalController).close();
    }
};
$4cf3a3f8222df1ad$export$d8e2d72354b51198.styles = (0, $3721d1b3ad4f7fcd$export$2e2bcd8739ae039);
$4cf3a3f8222df1ad$var$__decorate([
    (0, $faUle.state)()
], $4cf3a3f8222df1ad$export$d8e2d72354b51198.prototype, "selectedCurrency", void 0);
$4cf3a3f8222df1ad$var$__decorate([
    (0, $faUle.state)()
], $4cf3a3f8222df1ad$export$d8e2d72354b51198.prototype, "currencies", void 0);
$4cf3a3f8222df1ad$var$__decorate([
    (0, $faUle.state)()
], $4cf3a3f8222df1ad$export$d8e2d72354b51198.prototype, "currencyImages", void 0);
$4cf3a3f8222df1ad$export$d8e2d72354b51198 = $4cf3a3f8222df1ad$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-fiat-select-view")
], $4cf3a3f8222df1ad$export$d8e2d72354b51198);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $hxXs8 = parcelRequire("hxXs8");
var $6AwK8 = parcelRequire("6AwK8");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $jbD0z = parcelRequire("jbD0z");
var $jM3Wq = parcelRequire("jM3Wq");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $1d144c8b681c1dbe$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1d144c8b681c1dbe$export$59a62e1add0f780c = class W3mOnRampProvidersView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.providers = (0, $jM3Wq.OnRampController).state.providers;
        this.unsubscribe.push(...[
            (0, $jM3Wq.OnRampController).subscribeKey("providers", (val)=>{
                this.providers = val;
            })
        ]);
    }
    firstUpdated() {
        const urlPromises = this.providers.map(async (provider)=>{
            if (provider.name === "coinbase") return await this.getCoinbaseOnRampURL();
            return Promise.resolve(provider?.url);
        });
        Promise.all(urlPromises).then((urls)=>{
            this.providers = this.providers.map((provider, index)=>({
                    ...provider,
                    url: urls[index] || ""
                }));
        });
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]} gap="xs">
        ${this.onRampProvidersTemplate()}
      </wui-flex>
      <w3m-onramp-providers-footer></w3m-onramp-providers-footer>
    `;
    }
    onRampProvidersTemplate() {
        return this.providers.map((provider)=>(0, $aTf3K.html)`
        <w3m-onramp-provider-item
          label=${provider.label}
          name=${provider.name}
          feeRange=${provider.feeRange}
          @click=${()=>{
                this.onClickProvider(provider);
            }}
          ?disabled=${!provider.url}
        ></w3m-onramp-provider-item>
      `);
    }
    onClickProvider(provider) {
        (0, $jM3Wq.OnRampController).setSelectedProvider(provider);
        (0, $6mRzS.RouterController).push("BuyInProgress");
        (0, $c4rfq.CoreHelperUtil).openHref(provider.url, "popupWindow", "width=600,height=800,scrollbars=yes");
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_BUY_PROVIDER",
            properties: {
                provider: provider.name,
                isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
            }
        });
    }
    async getCoinbaseOnRampURL() {
        const address = (0, $f7IXw.AccountController).state.address;
        const network = (0, $jbD0z.NetworkController).state.caipNetwork;
        if (!address) throw new Error("No address found");
        if (!network?.name) throw new Error("No network found");
        const defaultNetwork = (0, $6AwK8.ConstantsUtil).WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP[network.name] ?? (0, $6AwK8.ConstantsUtil).WC_COINBASE_PAY_SDK_FALLBACK_CHAIN;
        const purchaseCurrency = (0, $jM3Wq.OnRampController).state.purchaseCurrency;
        const assets = purchaseCurrency ? [
            purchaseCurrency.symbol
        ] : (0, $jM3Wq.OnRampController).state.purchaseCurrencies.map((currency)=>currency.symbol);
        return await (0, $hxXs8.BlockchainApiController).generateOnRampURL({
            defaultNetwork: defaultNetwork,
            destinationWallets: [
                {
                    address: address,
                    blockchains: (0, $6AwK8.ConstantsUtil).WC_COINBASE_PAY_SDK_CHAINS,
                    assets: assets
                }
            ],
            partnerUserId: address,
            purchaseAmount: (0, $jM3Wq.OnRampController).state.purchaseAmount
        });
    }
};
$1d144c8b681c1dbe$var$__decorate([
    (0, $faUle.state)()
], $1d144c8b681c1dbe$export$59a62e1add0f780c.prototype, "providers", void 0);
$1d144c8b681c1dbe$export$59a62e1add0f780c = $1d144c8b681c1dbe$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-providers-view")
], $1d144c8b681c1dbe$export$59a62e1add0f780c);


parcelRequire("eNJDH");
var $zKxbI = parcelRequire("zKxbI");
var $ib7WC = parcelRequire("ib7WC");
var $jM3Wq = parcelRequire("jM3Wq");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $ea9bb302cd345c29$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;



var $e12673326947796f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e12673326947796f$export$97f0fa712fa488a5 = class W3mOnrampTokensView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedCurrency = (0, $jM3Wq.OnRampController).state.purchaseCurrencies;
        this.tokens = (0, $jM3Wq.OnRampController).state.purchaseCurrencies;
        this.tokenImages = (0, $zKxbI.AssetController).state.tokenImages;
        this.unsubscribe.push(...[
            (0, $jM3Wq.OnRampController).subscribe((val)=>{
                this.selectedCurrency = val.purchaseCurrencies;
                this.tokens = val.purchaseCurrencies;
            }),
            (0, $zKxbI.AssetController).subscribeKey("tokenImages", (val)=>this.tokenImages = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]} gap="xs">
        ${this.currenciesTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    currenciesTemplate() {
        return this.tokens.map((token)=>(0, $aTf3K.html)`
        <wui-list-item
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.tokenImages?.[token.symbol])}
          @click=${()=>this.selectToken(token)}
          variant="image"
        >
          <wui-flex gap="3xs" alignItems="center">
            <wui-text variant="paragraph-500" color="fg-100">${token.name}</wui-text>
            <wui-text variant="small-400" color="fg-200">${token.symbol}</wui-text>
          </wui-flex>
        </wui-list-item>
      `);
    }
    selectToken(currency) {
        if (!currency) return;
        (0, $jM3Wq.OnRampController).setPurchaseCurrency(currency);
        (0, $ib7WC.ModalController).close();
    }
};
$e12673326947796f$export$97f0fa712fa488a5.styles = (0, $ea9bb302cd345c29$export$2e2bcd8739ae039);
$e12673326947796f$var$__decorate([
    (0, $faUle.state)()
], $e12673326947796f$export$97f0fa712fa488a5.prototype, "selectedCurrency", void 0);
$e12673326947796f$var$__decorate([
    (0, $faUle.state)()
], $e12673326947796f$export$97f0fa712fa488a5.prototype, "tokens", void 0);
$e12673326947796f$var$__decorate([
    (0, $faUle.state)()
], $e12673326947796f$export$97f0fa712fa488a5.prototype, "tokenImages", void 0);
$e12673326947796f$export$97f0fa712fa488a5 = $e12673326947796f$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-token-select-view")
], $e12673326947796f$export$97f0fa712fa488a5);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $6461f6fb86606d86$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex:first-child {
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }

  :host > wui-flex:first-child::-webkit-scrollbar {
    display: none;
  }

  wui-loading-hexagon {
    position: absolute;
  }

  .action-button {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
  }

  .action-button:disabled {
    border-color: 1px solid var(--wui-color-gray-glass-005);
  }

  .swap-inputs-container {
    position: relative;
  }

  .replace-tokens-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    gap: var(--wui-spacing-1xs);
    border-radius: var(--wui-border-radius-xs);
    background-color: var(--wui-color-modal-bg-base);
    padding: var(--wui-spacing-xxs);
  }

  .replace-tokens-button-container > button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    padding: var(--wui-spacing-xs);
    border: none;
    border-radius: var(--wui-border-radius-xxs);
    background: var(--wui-color-gray-glass-002);
    transition: background-color var(--wui-duration-md) var(--wui-ease-out-power-1);
    will-change: background-color;
    z-index: 20;
  }

  .replace-tokens-button-container > button:hover {
    background: var(--wui-color-gray-glass-005);
  }

  .details-container > wui-flex {
    background: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xxs);
    width: 100%;
  }

  .details-container > wui-flex > button {
    border: none;
    background: none;
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);
    transition: background 0.2s linear;
  }

  .details-container > wui-flex > button:hover {
    background: var(--wui-color-gray-glass-002);
  }

  .details-content-container {
    padding: var(--wui-spacing-1xs);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .details-content-container > wui-flex {
    width: 100%;
  }

  .details-row {
    width: 100%;
    padding: var(--wui-spacing-s) var(--wui-spacing-xl);
    border-radius: var(--wui-border-radius-xxs);
    background: var(--wui-color-gray-glass-002);
  }
`;


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $6AwK8 = parcelRequire("6AwK8");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
var $89gde = parcelRequire("89gde");
parcelRequire("ikDNi");
var $l2EhC = parcelRequire("l2EhC");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $b282a6bb9ac14980$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b282a6bb9ac14980$export$9cc2509453f936aa = class W3mSwapView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.detailsOpen = false;
        this.caipNetworkId = (0, $jbD0z.NetworkController).state.caipNetwork?.id;
        this.initialized = (0, $89gde.SwapController).state.initialized;
        this.loadingQuote = (0, $89gde.SwapController).state.loadingQuote;
        this.loadingPrices = (0, $89gde.SwapController).state.loadingPrices;
        this.loadingTransaction = (0, $89gde.SwapController).state.loadingTransaction;
        this.sourceToken = (0, $89gde.SwapController).state.sourceToken;
        this.sourceTokenAmount = (0, $89gde.SwapController).state.sourceTokenAmount;
        this.sourceTokenPriceInUSD = (0, $89gde.SwapController).state.sourceTokenPriceInUSD;
        this.toToken = (0, $89gde.SwapController).state.toToken;
        this.toTokenAmount = (0, $89gde.SwapController).state.toTokenAmount;
        this.toTokenPriceInUSD = (0, $89gde.SwapController).state.toTokenPriceInUSD;
        this.inputError = (0, $89gde.SwapController).state.inputError;
        this.gasPriceInUSD = (0, $89gde.SwapController).state.gasPriceInUSD;
        this.fetchError = (0, $89gde.SwapController).state.fetchError;
        this.onDebouncedGetSwapCalldata = (0, $c4rfq.CoreHelperUtil).debounce(async ()=>{
            await (0, $89gde.SwapController).swapTokens();
        }, 200);
        (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (newCaipNetwork)=>{
            if (this.caipNetworkId !== newCaipNetwork?.id) {
                this.caipNetworkId = newCaipNetwork?.id;
                (0, $89gde.SwapController).resetState();
                (0, $89gde.SwapController).initializeState();
            }
        });
        this.unsubscribe.push(...[
            (0, $ib7WC.ModalController).subscribeKey("open", (isOpen)=>{
                if (!isOpen) (0, $89gde.SwapController).resetState();
            }),
            (0, $6mRzS.RouterController).subscribeKey("view", (newRoute)=>{
                if (!newRoute.includes("Swap")) (0, $89gde.SwapController).resetValues();
            }),
            (0, $89gde.SwapController).subscribe((newState)=>{
                this.initialized = newState.initialized;
                this.loadingQuote = newState.loadingQuote;
                this.loadingPrices = newState.loadingPrices;
                this.loadingTransaction = newState.loadingTransaction;
                this.sourceToken = newState.sourceToken;
                this.sourceTokenAmount = newState.sourceTokenAmount;
                this.sourceTokenPriceInUSD = newState.sourceTokenPriceInUSD;
                this.toToken = newState.toToken;
                this.toTokenAmount = newState.toTokenAmount;
                this.toTokenPriceInUSD = newState.toTokenPriceInUSD;
                this.inputError = newState.inputError;
                this.gasPriceInUSD = newState.gasPriceInUSD;
                this.fetchError = newState.fetchError;
            })
        ]);
    }
    firstUpdated() {
        (0, $89gde.SwapController).initializeState();
        this.watchTokensAndValues();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe?.());
        clearInterval(this.interval);
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "0",
            "l",
            "l",
            "l"
        ]} gap="s">
        ${this.initialized ? this.templateSwap() : this.templateLoading()}
      </wui-flex>
    `;
    }
    watchTokensAndValues() {
        this.interval = setInterval(()=>{
            (0, $89gde.SwapController).getNetworkTokenPrice();
            (0, $89gde.SwapController).getMyTokensWithBalance();
            (0, $89gde.SwapController).swapTokens();
        }, 10000);
    }
    templateSwap() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="s">
        <wui-flex flexDirection="column" alignItems="center" gap="xs" class="swap-inputs-container">
          ${this.templateTokenInput("sourceToken", this.sourceToken)}
          ${this.templateTokenInput("toToken", this.toToken)} ${this.templateReplaceTokensButton()}
        </wui-flex>
        ${this.templateDetails()} ${this.templateActionButton()}
      </wui-flex>
    `;
    }
    actionButtonLabel() {
        if (this.fetchError) return "Swap";
        if (!this.sourceToken || !this.toToken) return "Select token";
        if (!this.sourceTokenAmount) return "Enter amount";
        if (this.inputError) return this.inputError;
        return "Review swap";
    }
    templateReplaceTokensButton() {
        return (0, $aTf3K.html)`
      <wui-flex class="replace-tokens-button-container">
        <button @click=${this.onSwitchTokens.bind(this)}>
          <wui-icon name="recycleHorizontal" color="fg-250" size="lg"></wui-icon>
        </button>
      </wui-flex>
    `;
    }
    templateLoading() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="l">
        <wui-flex flexDirection="column" alignItems="center" gap="xs" class="swap-inputs-container">
          <w3m-swap-input-skeleton target="sourceToken"></w3m-swap-input-skeleton>
          <w3m-swap-input-skeleton target="toToken"></w3m-swap-input-skeleton>
          ${this.templateReplaceTokensButton()}
        </wui-flex>
        ${this.templateActionButton()}
      </wui-flex>
    `;
    }
    templateTokenInput(target, token) {
        const myToken = (0, $89gde.SwapController).state.myTokensWithBalance?.find((ct)=>ct?.address === token?.address);
        const amount = target === "toToken" ? this.toTokenAmount : this.sourceTokenAmount;
        const price = target === "toToken" ? this.toTokenPriceInUSD : this.sourceTokenPriceInUSD;
        let value = parseFloat(amount) * price;
        if (target === "toToken") value -= this.gasPriceInUSD || 0;
        return (0, $aTf3K.html)`<w3m-swap-input
      .value=${target === "toToken" ? this.toTokenAmount : this.sourceTokenAmount}
      ?disabled=${this.loadingQuote && target === "toToken"}
      .onSetAmount=${this.handleChangeAmount.bind(this)}
      target=${target}
      .token=${token}
      .balance=${myToken?.quantity?.numeric}
      .price=${myToken?.price}
      .marketValue=${value}
      .onSetMaxValue=${this.onSetMaxValue.bind(this)}
    ></w3m-swap-input>`;
    }
    onSetMaxValue(target, balance) {
        const token = target === "sourceToken" ? this.sourceToken : this.toToken;
        const isNetworkToken = token?.address === (0, $6AwK8.ConstantsUtil).NATIVE_TOKEN_ADDRESS;
        let value = "0";
        if (!balance) {
            value = "0";
            this.handleChangeAmount(target, value);
            return;
        }
        if (!this.gasPriceInUSD) {
            value = balance;
            this.handleChangeAmount(target, value);
            return;
        }
        const amountOfTokenGasRequires = (0, $l2EhC.NumberUtil).bigNumber(this.gasPriceInUSD.toFixed(5)).dividedBy(this.sourceTokenPriceInUSD);
        const maxValue = isNetworkToken ? (0, $l2EhC.NumberUtil).bigNumber(balance).minus(amountOfTokenGasRequires) : (0, $l2EhC.NumberUtil).bigNumber(balance);
        this.handleChangeAmount(target, maxValue.isGreaterThan(0) ? maxValue.toFixed(20) : "0");
    }
    templateDetails() {
        if (!this.sourceToken || !this.toToken || this.inputError) return null;
        return (0, $aTf3K.html)`<w3m-swap-details .detailsOpen=${this.detailsOpen}></w3m-swap-details>`;
    }
    handleChangeAmount(target, value) {
        (0, $89gde.SwapController).clearError();
        if (target === "sourceToken") (0, $89gde.SwapController).setSourceTokenAmount(value);
        else (0, $89gde.SwapController).setToTokenAmount(value);
        this.onDebouncedGetSwapCalldata();
    }
    templateActionButton() {
        const haveNoTokenSelected = !this.toToken || !this.sourceToken;
        const haveNoAmount = !this.sourceTokenAmount;
        const loading = this.loadingQuote || this.loadingPrices || this.loadingTransaction;
        const disabled = loading || haveNoTokenSelected || haveNoAmount || this.inputError;
        return (0, $aTf3K.html)` <wui-flex gap="xs">
      <wui-button
        data-testid="swap-action-button"
        class="action-button"
        fullWidth
        size="lg"
        borderRadius="xs"
        variant=${haveNoTokenSelected ? "neutral" : "main"}
        .loading=${loading}
        .disabled=${disabled}
        @click=${this.onSwapPreview.bind(this)}
      >
        ${this.actionButtonLabel()}
      </wui-button>
    </wui-flex>`;
    }
    onSwitchTokens() {
        (0, $89gde.SwapController).switchTokens();
    }
    onSwapPreview() {
        if (this.fetchError) {
            (0, $89gde.SwapController).swapTokens();
            return;
        }
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "INITIATE_SWAP",
            properties: {
                network: this.caipNetworkId || "",
                swapFromToken: this.sourceToken?.symbol || "",
                swapToToken: this.toToken?.symbol || "",
                swapFromAmount: this.sourceTokenAmount || "",
                swapToAmount: this.toTokenAmount || "",
                isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
            }
        });
        (0, $6mRzS.RouterController).push("SwapPreview");
    }
};
$b282a6bb9ac14980$export$9cc2509453f936aa.styles = (0, $6461f6fb86606d86$export$2e2bcd8739ae039);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "interval", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "detailsOpen", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "caipNetworkId", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "initialized", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "loadingQuote", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "loadingPrices", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "loadingTransaction", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "sourceToken", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "sourceTokenAmount", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "sourceTokenPriceInUSD", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "toToken", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "toTokenAmount", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "toTokenPriceInUSD", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "inputError", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "gasPriceInUSD", void 0);
$b282a6bb9ac14980$var$__decorate([
    (0, $faUle.state)()
], $b282a6bb9ac14980$export$9cc2509453f936aa.prototype, "fetchError", void 0);
$b282a6bb9ac14980$export$9cc2509453f936aa = $b282a6bb9ac14980$var$__decorate([
    (0, $ailZp.customElement)("w3m-swap-view")
], $b282a6bb9ac14980$export$9cc2509453f936aa);


parcelRequire("eNJDH");
var $d94Xg = parcelRequire("d94Xg");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $b8ee0a73dc40b8ba$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-visual {
    width: var(--wui-wallet-image-size-lg);
    height: var(--wui-wallet-image-size-lg);
    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));
    position: relative;
    overflow: hidden;
  }

  wui-visual::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition:
      opacity var(--wui-ease-out-power-2) var(--wui-duration-lg),
      transform var(--wui-ease-out-power-2) var(--wui-duration-lg);
    will-change: opacity, transform;
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }

  wui-link {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
  }
`;


parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $7d37405fdd6399db$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7d37405fdd6399db$export$4ce390738fa2ca0d = class W3mSwitchActiveChainView extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.unsubscribe = [];
        this.switchToChain = (0, $6mRzS.RouterController).state.data?.switchToChain;
        this.navigateTo = (0, $6mRzS.RouterController).state.data?.navigateTo;
        this.navigateWithReplace = (0, $6mRzS.RouterController).state.data?.navigateWithReplace;
        this.activeChain = (0, $d94Xg.ChainController).state.activeChain;
    }
    firstUpdated() {
        this.unsubscribe.push((0, $d94Xg.ChainController).subscribeKey("activeChain", (val)=>this.activeChain = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const chainNameString = this.activeChain ? (0, $1VCt9.ConstantsUtil).CHAIN_NAME_MAP[this.activeChain] : "current";
        const switchedChainNameString = this.switchToChain ? (0, $1VCt9.ConstantsUtil).CHAIN_NAME_MAP[this.switchToChain] : "supported";
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" flexDirection="column" alignItems="center" gap="xl">
          <wui-visual name="eth"></wui-visual>
          <wui-text variant="paragraph-500" color="fg-100" align="center">Switch to EVM</wui-text>
          <wui-text variant="small-400" color="fg-200" align="center">
            This feature is not supported on the ${chainNameString} chain. Switch to
            ${switchedChainNameString} chain to proceed using it.
          </wui-text>
          <wui-button size="md" @click=${this.switchActiveChain.bind(this)}>Switch</wui-button>
        </wui-flex>
      </wui-flex>
    `;
    }
    switchActiveChain() {
        if (!this.switchToChain) return;
        (0, $d94Xg.ChainController).setActiveChain(this.switchToChain);
        if (this.navigateTo) {
            if (this.navigateWithReplace) (0, $6mRzS.RouterController).replace(this.navigateTo);
            else (0, $6mRzS.RouterController).push(this.navigateTo);
        } else (0, $6mRzS.RouterController).goBack();
    }
};
$7d37405fdd6399db$export$4ce390738fa2ca0d.styles = (0, $b8ee0a73dc40b8ba$export$2e2bcd8739ae039);
$7d37405fdd6399db$var$__decorate([
    (0, $jJP2r.property)()
], $7d37405fdd6399db$export$4ce390738fa2ca0d.prototype, "activeChain", void 0);
$7d37405fdd6399db$export$4ce390738fa2ca0d = $7d37405fdd6399db$var$__decorate([
    (0, $ailZp.customElement)("w3m-switch-active-chain-view")
], $7d37405fdd6399db$export$4ce390738fa2ca0d);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $a10e293339d4ec39$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex:first-child {
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }

  :host > wui-flex:first-child::-webkit-scrollbar {
    display: none;
  }

  .preview-container,
  .details-container {
    width: 100%;
  }

  .token-image {
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);
    border-radius: 12px;
  }

  wui-loading-hexagon {
    position: absolute;
  }

  .token-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--wui-spacing-xxs);
    padding: var(--wui-spacing-xs);
    height: 40px;
    border: none;
    border-radius: 80px;
    background: var(--wui-color-gray-glass-002);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);
    cursor: pointer;
    transition: background 0.2s linear;
  }

  .token-item:hover {
    background: var(--wui-color-gray-glass-005);
  }

  .preview-token-details-container {
    width: 100%;
  }

  .details-row {
    width: 100%;
    padding: var(--wui-spacing-s) var(--wui-spacing-xl);
    border-radius: var(--wui-border-radius-xxs);
    background: var(--wui-color-gray-glass-002);
  }

  .action-buttons-container {
    width: 100%;
    gap: var(--wui-spacing-xs);
  }

  .action-buttons-container > button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    height: 48px;
    border-radius: var(--wui-border-radius-xs);
    border: none;
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }

  .action-buttons-container > button:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }

  .action-button > wui-loading-spinner {
    display: inline-block;
  }

  .cancel-button:hover,
  .action-button:hover {
    cursor: pointer;
  }

  .action-buttons-container > wui-button.cancel-button {
    flex: 2;
  }

  .action-buttons-container > wui-button.action-button {
    flex: 4;
  }

  .action-buttons-container > button.action-button > wui-text {
    color: white;
  }

  .details-container > wui-flex {
    background: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xxs);
    width: 100%;
  }

  .details-container > wui-flex > button {
    border: none;
    background: none;
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);
    transition: background 0.2s linear;
  }

  .details-container > wui-flex > button:hover {
    background: var(--wui-color-gray-glass-002);
  }

  .details-content-container {
    padding: var(--wui-spacing-1xs);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .details-content-container > wui-flex {
    width: 100%;
  }

  .details-row {
    width: 100%;
    padding: var(--wui-spacing-s) var(--wui-spacing-xl);
    border-radius: var(--wui-border-radius-xxs);
    background: var(--wui-color-gray-glass-002);
  }
`;


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
var $89gde = parcelRequire("89gde");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $bbcc5a20bdc705aa$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d = class W3mSwapPreviewView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.detailsOpen = true;
        this.approvalTransaction = (0, $89gde.SwapController).state.approvalTransaction;
        this.swapTransaction = (0, $89gde.SwapController).state.swapTransaction;
        this.sourceToken = (0, $89gde.SwapController).state.sourceToken;
        this.sourceTokenAmount = (0, $89gde.SwapController).state.sourceTokenAmount ?? "";
        this.sourceTokenPriceInUSD = (0, $89gde.SwapController).state.sourceTokenPriceInUSD;
        this.toToken = (0, $89gde.SwapController).state.toToken;
        this.toTokenAmount = (0, $89gde.SwapController).state.toTokenAmount ?? "";
        this.toTokenPriceInUSD = (0, $89gde.SwapController).state.toTokenPriceInUSD;
        this.caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.balanceSymbol = (0, $f7IXw.AccountController).state.balanceSymbol;
        this.gasPriceInUSD = (0, $89gde.SwapController).state.gasPriceInUSD;
        this.inputError = (0, $89gde.SwapController).state.inputError;
        this.loadingQuote = (0, $89gde.SwapController).state.loadingQuote;
        this.loadingApprovalTransaction = (0, $89gde.SwapController).state.loadingApprovalTransaction;
        this.loadingBuildTransaction = (0, $89gde.SwapController).state.loadingBuildTransaction;
        this.loadingTransaction = (0, $89gde.SwapController).state.loadingTransaction;
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribeKey("balanceSymbol", (newBalanceSymbol)=>{
                if (this.balanceSymbol !== newBalanceSymbol) (0, $6mRzS.RouterController).goBack();
            }),
            (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (newCaipNetwork)=>{
                if (this.caipNetwork !== newCaipNetwork) this.caipNetwork = newCaipNetwork;
            }),
            (0, $89gde.SwapController).subscribe((newState)=>{
                this.approvalTransaction = newState.approvalTransaction;
                this.swapTransaction = newState.swapTransaction;
                this.sourceToken = newState.sourceToken;
                this.gasPriceInUSD = newState.gasPriceInUSD;
                this.toToken = newState.toToken;
                this.gasPriceInUSD = newState.gasPriceInUSD;
                this.toTokenPriceInUSD = newState.toTokenPriceInUSD;
                this.sourceTokenAmount = newState.sourceTokenAmount ?? "";
                this.toTokenAmount = newState.toTokenAmount ?? "";
                this.inputError = newState.inputError;
                if (newState.inputError) (0, $6mRzS.RouterController).goBack();
                this.loadingQuote = newState.loadingQuote;
                this.loadingApprovalTransaction = newState.loadingApprovalTransaction;
                this.loadingBuildTransaction = newState.loadingBuildTransaction;
                this.loadingTransaction = newState.loadingTransaction;
            })
        ]);
    }
    firstUpdated() {
        (0, $89gde.SwapController).getTransaction();
        this.refreshTransaction();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe?.());
        clearInterval(this.interval);
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "0",
            "l",
            "l",
            "l"
        ]} gap="s">
        ${this.templateSwap()}
      </wui-flex>
    `;
    }
    refreshTransaction() {
        this.interval = setInterval(()=>{
            if (!(0, $89gde.SwapController).getApprovalLoadingState()) (0, $89gde.SwapController).getTransaction();
        }, 10000);
    }
    templateSwap() {
        const sourceTokenText = `${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(parseFloat(this.sourceTokenAmount))} ${this.sourceToken?.symbol}`;
        const toTokenText = `${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(parseFloat(this.toTokenAmount))} ${this.toToken?.symbol}`;
        const sourceTokenValue = parseFloat(this.sourceTokenAmount) * this.sourceTokenPriceInUSD;
        const toTokenValue = parseFloat(this.toTokenAmount) * this.toTokenPriceInUSD - (this.gasPriceInUSD || 0);
        const sentPrice = (0, $fIDM4.UiHelperUtil).formatNumberToLocalString(sourceTokenValue);
        const receivePrice = (0, $fIDM4.UiHelperUtil).formatNumberToLocalString(toTokenValue);
        const loading = this.loadingQuote || this.loadingBuildTransaction || this.loadingTransaction || this.loadingApprovalTransaction;
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="l">
        <wui-flex class="preview-container" flexDirection="column" alignItems="flex-start" gap="l">
          <wui-flex
            class="preview-token-details-container"
            alignItems="center"
            justifyContent="space-between"
            gap="l"
          >
            <wui-flex flexDirection="column" alignItems="flex-start" gap="4xs">
              <wui-text variant="small-400" color="fg-150">Send</wui-text>
              <wui-text variant="paragraph-400" color="fg-100">$${sentPrice}</wui-text>
            </wui-flex>
            <wui-token-button
              flexDirection="row-reverse"
              text=${sourceTokenText}
              imageSrc=${this.sourceToken?.logoUri}
            >
            </wui-token-button>
          </wui-flex>
          <wui-icon name="recycleHorizontal" color="fg-200" size="md"></wui-icon>
          <wui-flex
            class="preview-token-details-container"
            alignItems="center"
            justifyContent="space-between"
            gap="l"
          >
            <wui-flex flexDirection="column" alignItems="flex-start" gap="4xs">
              <wui-text variant="small-400" color="fg-150">Receive</wui-text>
              <wui-text variant="paragraph-400" color="fg-100">$${receivePrice}</wui-text>
            </wui-flex>
            <wui-token-button
              flexDirection="row-reverse"
              text=${toTokenText}
              imageSrc=${this.toToken?.logoUri}
            >
            </wui-token-button>
          </wui-flex>
        </wui-flex>

        ${this.templateDetails()}

        <wui-flex flexDirection="row" alignItems="center" justifyContent="center" gap="xs">
          <wui-icon size="sm" color="fg-200" name="infoCircle"></wui-icon>
          <wui-text variant="small-400" color="fg-200">Review transaction carefully</wui-text>
        </wui-flex>

        <wui-flex
          class="action-buttons-container"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap="xs"
        >
          <wui-button
            class="cancel-button"
            fullWidth
            size="lg"
            borderRadius="xs"
            variant="neutral"
            @click=${this.onCancelTransaction.bind(this)}
          >
            <wui-text variant="paragraph-600" color="fg-200">Cancel</wui-text>
          </wui-button>
          <wui-button
            class="action-button"
            fullWidth
            size="lg"
            borderRadius="xs"
            variant="main"
            ?loading=${loading}
            ?disabled=${loading}
            @click=${this.onSendTransaction.bind(this)}
          >
            <wui-text variant="paragraph-600" color="inverse-100">
              ${this.actionButtonLabel()}
            </wui-text>
          </wui-button>
        </wui-flex>
      </wui-flex>
    `;
    }
    templateDetails() {
        if (!this.sourceToken || !this.toToken || this.inputError) return null;
        return (0, $aTf3K.html)`<w3m-swap-details .detailsOpen=${this.detailsOpen}></w3m-swap-details>`;
    }
    actionButtonLabel() {
        if (this.loadingApprovalTransaction) return "Approving...";
        if (this.approvalTransaction) return "Approve";
        return "Swap";
    }
    onCancelTransaction() {
        (0, $6mRzS.RouterController).goBack();
    }
    onSendTransaction() {
        if (this.approvalTransaction) (0, $89gde.SwapController).sendTransactionForApproval(this.approvalTransaction);
        else (0, $89gde.SwapController).sendTransactionForSwap(this.swapTransaction);
    }
};
$bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.styles = (0, $a10e293339d4ec39$export$2e2bcd8739ae039);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "interval", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "detailsOpen", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "approvalTransaction", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "swapTransaction", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "sourceToken", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "sourceTokenAmount", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "sourceTokenPriceInUSD", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "toToken", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "toTokenAmount", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "toTokenPriceInUSD", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "caipNetwork", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "balanceSymbol", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "gasPriceInUSD", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "inputError", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "loadingQuote", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "loadingApprovalTransaction", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "loadingBuildTransaction", void 0);
$bbcc5a20bdc705aa$var$__decorate([
    (0, $faUle.state)()
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d.prototype, "loadingTransaction", void 0);
$bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d = $bbcc5a20bdc705aa$var$__decorate([
    (0, $ailZp.customElement)("w3m-swap-preview-view")
], $bbcc5a20bdc705aa$export$2b6fdf515f2cfc8d);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $iazuc = parcelRequire("iazuc");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $3e84f004811080d2$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    --tokens-scroll--top-opacity: 0;
    --tokens-scroll--bottom-opacity: 1;
    --suggested-tokens-scroll--left-opacity: 0;
    --suggested-tokens-scroll--right-opacity: 1;
  }

  :host > wui-flex:first-child {
    overflow-y: hidden;
    overflow-x: hidden;
    scrollbar-width: none;
    scrollbar-height: none;
  }

  :host > wui-flex:first-child::-webkit-scrollbar {
    display: none;
  }

  wui-loading-hexagon {
    position: absolute;
  }

  .suggested-tokens-container {
    overflow-x: auto;
    mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, calc(1 - var(--suggested-tokens-scroll--left-opacity))) 0px,
      rgba(200, 200, 200, calc(1 - var(--suggested-tokens-scroll--left-opacity))) 1px,
      black 50px,
      black 90px,
      black calc(100% - 90px),
      black calc(100% - 50px),
      rgba(155, 155, 155, calc(1 - var(--suggested-tokens-scroll--right-opacity))) calc(100% - 1px),
      rgba(0, 0, 0, calc(1 - var(--suggested-tokens-scroll--right-opacity))) 100%
    );
  }

  .suggested-tokens-container::-webkit-scrollbar {
    display: none;
  }

  .tokens-container {
    border-top: 1px solid var(--wui-color-gray-glass-005);
    height: 100%;
    max-height: 390px;
  }

  .tokens {
    width: 100%;
    overflow-y: auto;
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, calc(1 - var(--tokens-scroll--top-opacity))) 0px,
      rgba(200, 200, 200, calc(1 - var(--tokens-scroll--top-opacity))) 1px,
      black 50px,
      black 90px,
      black calc(100% - 90px),
      black calc(100% - 50px),
      rgba(155, 155, 155, calc(1 - var(--tokens-scroll--bottom-opacity))) calc(100% - 1px),
      rgba(0, 0, 0, calc(1 - var(--tokens-scroll--bottom-opacity))) 100%
    );
  }

  .network-search-input,
  .select-network-button {
    height: 40px;
  }

  .select-network-button {
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: var(--wui-spacing-xs);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
    background-color: transparent;
    border-radius: var(--wui-border-radius-xxs);
    padding: var(--wui-spacing-xs);
    align-items: center;
    transition: background-color 0.2s linear;
  }

  .select-network-button:hover {
    background-color: var(--wui-color-gray-glass-002);
  }

  .select-network-button > wui-image {
    width: 26px;
    height: 26px;
    border-radius: var(--wui-border-radius-xs);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);
  }
`;


parcelRequire("eNJDH");
var $6mRzS = parcelRequire("6mRzS");
var $89gde = parcelRequire("89gde");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $dd9efefacefb484f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dd9efefacefb484f$export$f787d9978790b696 = class W3mSwapSelectTokenView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.targetToken = (0, $6mRzS.RouterController).state.data?.target;
        this.sourceToken = (0, $89gde.SwapController).state.sourceToken;
        this.sourceTokenAmount = (0, $89gde.SwapController).state.sourceTokenAmount;
        this.toToken = (0, $89gde.SwapController).state.toToken;
        this.myTokensWithBalance = (0, $89gde.SwapController).state.myTokensWithBalance;
        this.popularTokens = (0, $89gde.SwapController).state.popularTokens;
        this.searchValue = "";
        this.unsubscribe.push(...[
            (0, $89gde.SwapController).subscribe((newState)=>{
                this.sourceToken = newState.sourceToken;
                this.toToken = newState.toToken;
                this.myTokensWithBalance = newState.myTokensWithBalance;
            })
        ]);
    }
    updated() {
        const suggestedTokensContainer = this.renderRoot?.querySelector(".suggested-tokens-container");
        suggestedTokensContainer?.addEventListener("scroll", this.handleSuggestedTokensScroll.bind(this));
        const tokensList = this.renderRoot?.querySelector(".tokens");
        tokensList?.addEventListener("scroll", this.handleTokenListScroll.bind(this));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        const suggestedTokensContainer = this.renderRoot?.querySelector(".suggested-tokens-container");
        const tokensList = this.renderRoot?.querySelector(".tokens");
        suggestedTokensContainer?.removeEventListener("scroll", this.handleSuggestedTokensScroll.bind(this));
        tokensList?.removeEventListener("scroll", this.handleTokenListScroll.bind(this));
        clearInterval(this.interval);
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="s">
        ${this.templateSearchInput()} ${this.templateSuggestedTokens()} ${this.templateTokens()}
      </wui-flex>
    `;
    }
    onSelectToken(token) {
        if (this.targetToken === "sourceToken") (0, $89gde.SwapController).setSourceToken(token);
        else {
            (0, $89gde.SwapController).setToToken(token);
            if (this.sourceToken && this.sourceTokenAmount) (0, $89gde.SwapController).swapTokens();
        }
        (0, $6mRzS.RouterController).goBack();
    }
    templateSearchInput() {
        return (0, $aTf3K.html)`
      <wui-flex .padding=${[
            "3xs",
            "s",
            "0",
            "s"
        ]} gap="xs">
        <wui-input-text
          data-testid="swap-select-token-search-input"
          class="network-search-input"
          size="sm"
          placeholder="Search token"
          icon="search"
          .value=${this.searchValue}
          @inputChange=${this.onSearchInputChange.bind(this)}
        ></wui-input-text>
      </wui-flex>
    `;
    }
    templateTokens() {
        const yourTokens = this.myTokensWithBalance ? Object.values(this.myTokensWithBalance) : [];
        const tokens = this.popularTokens ? this.popularTokens : [];
        const filteredYourTokens = this.filterTokensWithText(yourTokens, this.searchValue);
        const filteredTokens = this.filterTokensWithText(tokens, this.searchValue);
        return (0, $aTf3K.html)`
      <wui-flex class="tokens-container">
        <wui-flex class="tokens" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]} flexDirection="column">
          ${filteredYourTokens?.length > 0 ? (0, $aTf3K.html)`
                <wui-flex justifyContent="flex-start" padding="s">
                  <wui-text variant="paragraph-500" color="fg-200">Your tokens</wui-text>
                </wui-flex>
                ${filteredYourTokens.map((token)=>{
            const selected = token.symbol === this.sourceToken?.symbol || token.symbol === this.toToken?.symbol;
            return (0, $aTf3K.html)`
                    <wui-token-list-item
                      data-testid="swap-select-token-item-${token.symbol}"
                      name=${token.name}
                      ?disabled=${selected}
                      symbol=${token.symbol}
                      price=${token?.price}
                      amount=${token?.quantity?.numeric}
                      imageSrc=${token.logoUri}
                      @click=${()=>{
                if (!selected) this.onSelectToken(token);
            }}
                    >
                    </wui-token-list-item>
                  `;
        })}
              ` : null}

          <wui-flex justifyContent="flex-start" padding="s">
            <wui-text variant="paragraph-500" color="fg-200">Tokens</wui-text>
          </wui-flex>
          ${filteredTokens?.length > 0 ? filteredTokens.map((token)=>(0, $aTf3K.html)`
                  <wui-token-list-item
                    data-testid="swap-select-token-item-${token.symbol}"
                    name=${token.name}
                    symbol=${token.symbol}
                    imageSrc=${token.logoUri}
                    @click=${()=>this.onSelectToken(token)}
                  >
                  </wui-token-list-item>
                `) : null}
        </wui-flex>
      </wui-flex>
    `;
    }
    templateSuggestedTokens() {
        const tokens = (0, $89gde.SwapController).state.suggestedTokens ? (0, $89gde.SwapController).state.suggestedTokens.slice(0, 8) : null;
        if (!tokens) return null;
        return (0, $aTf3K.html)`
      <wui-flex class="suggested-tokens-container" .padding=${[
            "0",
            "s",
            "0",
            "s"
        ]} gap="xs">
        ${tokens.map((token)=>(0, $aTf3K.html)`
            <wui-token-button
              text=${token.symbol}
              imageSrc=${token.logoUri}
              @click=${()=>this.onSelectToken(token)}
            >
            </wui-token-button>
          `)}
      </wui-flex>
    `;
    }
    onSearchInputChange(event) {
        this.searchValue = event.detail;
    }
    handleSuggestedTokensScroll() {
        const container = this.renderRoot?.querySelector(".suggested-tokens-container");
        if (!container) return;
        container.style.setProperty("--suggested-tokens-scroll--left-opacity", (0, $iazuc.MathUtil).interpolate([
            0,
            100
        ], [
            0,
            1
        ], container.scrollLeft).toString());
        container.style.setProperty("--suggested-tokens-scroll--right-opacity", (0, $iazuc.MathUtil).interpolate([
            0,
            100
        ], [
            0,
            1
        ], container.scrollWidth - container.scrollLeft - container.offsetWidth).toString());
    }
    handleTokenListScroll() {
        const container = this.renderRoot?.querySelector(".tokens");
        if (!container) return;
        container.style.setProperty("--tokens-scroll--top-opacity", (0, $iazuc.MathUtil).interpolate([
            0,
            100
        ], [
            0,
            1
        ], container.scrollTop).toString());
        container.style.setProperty("--tokens-scroll--bottom-opacity", (0, $iazuc.MathUtil).interpolate([
            0,
            100
        ], [
            0,
            1
        ], container.scrollHeight - container.scrollTop - container.offsetHeight).toString());
    }
    filterTokensWithText(tokens, text) {
        return tokens.filter((token)=>`${token.symbol} ${token.name} ${token.address}`.toLowerCase().includes(text.toLowerCase()));
    }
};
$dd9efefacefb484f$export$f787d9978790b696.styles = (0, $3e84f004811080d2$export$2e2bcd8739ae039);
$dd9efefacefb484f$var$__decorate([
    (0, $faUle.state)()
], $dd9efefacefb484f$export$f787d9978790b696.prototype, "interval", void 0);
$dd9efefacefb484f$var$__decorate([
    (0, $faUle.state)()
], $dd9efefacefb484f$export$f787d9978790b696.prototype, "targetToken", void 0);
$dd9efefacefb484f$var$__decorate([
    (0, $faUle.state)()
], $dd9efefacefb484f$export$f787d9978790b696.prototype, "sourceToken", void 0);
$dd9efefacefb484f$var$__decorate([
    (0, $faUle.state)()
], $dd9efefacefb484f$export$f787d9978790b696.prototype, "sourceTokenAmount", void 0);
$dd9efefacefb484f$var$__decorate([
    (0, $faUle.state)()
], $dd9efefacefb484f$export$f787d9978790b696.prototype, "toToken", void 0);
$dd9efefacefb484f$var$__decorate([
    (0, $faUle.state)()
], $dd9efefacefb484f$export$f787d9978790b696.prototype, "myTokensWithBalance", void 0);
$dd9efefacefb484f$var$__decorate([
    (0, $faUle.state)()
], $dd9efefacefb484f$export$f787d9978790b696.prototype, "popularTokens", void 0);
$dd9efefacefb484f$var$__decorate([
    (0, $faUle.state)()
], $dd9efefacefb484f$export$f787d9978790b696.prototype, "searchValue", void 0);
$dd9efefacefb484f$export$f787d9978790b696 = $dd9efefacefb484f$var$__decorate([
    (0, $ailZp.customElement)("w3m-swap-select-token-view")
], $dd9efefacefb484f$export$f787d9978790b696);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $7caac4924089d9a0$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex:first-child {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }

  :host > wui-flex:first-child::-webkit-scrollbar {
    display: none;
  }
`;


var $f99b9168b6aad51f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f99b9168b6aad51f$export$5b9982998ebc2231 = class W3mTransactionsView extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" .padding=${[
            "0",
            "m",
            "m",
            "m"
        ]} gap="s">
        <w3m-activity-list page="activity"></w3m-activity-list>
      </wui-flex>
    `;
    }
};
$f99b9168b6aad51f$export$5b9982998ebc2231.styles = (0, $7caac4924089d9a0$export$2e2bcd8739ae039);
$f99b9168b6aad51f$export$5b9982998ebc2231 = $f99b9168b6aad51f$var$__decorate([
    (0, $ailZp.customElement)("w3m-transactions-view")
], $f99b9168b6aad51f$export$5b9982998ebc2231);


parcelRequire("eNJDH");
var $c4rfq = parcelRequire("c4rfq");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
var $494cddfbf0bb2a16$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $494cddfbf0bb2a16$var$data = [
    {
        images: [
            "network",
            "layers",
            "system"
        ],
        title: "The system\u2019s nuts and bolts",
        text: "A network is what brings the blockchain to life, as this technical infrastructure allows apps to access the ledger and smart contract services."
    },
    {
        images: [
            "noun",
            "defiAlt",
            "dao"
        ],
        title: "Designed for different uses",
        text: "Each network is designed differently, and may therefore suit certain apps and experiences."
    }
];
let $494cddfbf0bb2a16$export$e747cd062ecb4580 = class W3mWhatIsANetworkView extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "xl",
            "xl",
            "xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${$494cddfbf0bb2a16$var$data}></w3m-help-widget>
        <wui-button
          variant="main"
          size="md"
          @click=${()=>{
            (0, $c4rfq.CoreHelperUtil).openHref("https://ethereum.org/en/developers/docs/networks/", "_blank");
        }}
        >
          Learn more
          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
    }
};
$494cddfbf0bb2a16$export$e747cd062ecb4580 = $494cddfbf0bb2a16$var$__decorate([
    (0, $ailZp.customElement)("w3m-what-is-a-network-view")
], $494cddfbf0bb2a16$export$e747cd062ecb4580);


parcelRequire("eNJDH");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
var $c85f21c012e0a4f6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $c85f21c012e0a4f6$var$data = [
    {
        images: [
            "login",
            "profile",
            "lock"
        ],
        title: "One login for all of web3",
        text: "Log in to any app by connecting your wallet. Say goodbye to countless passwords!"
    },
    {
        images: [
            "defi",
            "nft",
            "eth"
        ],
        title: "A home for your digital assets",
        text: "A wallet lets you store, send and receive digital assets like cryptocurrencies and NFTs."
    },
    {
        images: [
            "browser",
            "noun",
            "dao"
        ],
        title: "Your gateway to a new web",
        text: "With your wallet, you can explore and interact with DeFi, NFTs, DAOs, and much more."
    }
];
let $c85f21c012e0a4f6$export$16ac3b6705a4e652 = class W3mWhatIsAWalletView extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "xl",
            "xl",
            "xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${$c85f21c012e0a4f6$var$data}></w3m-help-widget>
        <wui-button variant="main" size="md" @click=${this.onGetWallet.bind(this)}>
          <wui-icon color="inherit" slot="iconLeft" name="wallet"></wui-icon>
          Get a wallet
        </wui-button>
      </wui-flex>
    `;
    }
    onGetWallet() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "CLICK_GET_WALLET"
        });
        (0, $6mRzS.RouterController).push("GetWallet");
    }
};
$c85f21c012e0a4f6$export$16ac3b6705a4e652 = $c85f21c012e0a4f6$var$__decorate([
    (0, $ailZp.customElement)("w3m-what-is-a-wallet-view")
], $c85f21c012e0a4f6$export$16ac3b6705a4e652);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("eNJDH");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
var $8d5c031250ed6e87$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8d5c031250ed6e87$export$c63d73b9361e157e = class W3mWhatIsABuyView extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "3xl",
            "xl",
            "3xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <wui-visual name="onrampCard"></wui-visual>
        <wui-flex flexDirection="column" gap="xs" alignItems="center">
          <wui-text align="center" variant="paragraph-500" color="fg-100">
            Quickly and easily buy digital assets!
          </wui-text>
          <wui-text align="center" variant="small-400" color="fg-200">
            Simply select your preferred onramp provider and add digital assets to your account
            using your credit card or bank transfer
          </wui-text>
        </wui-flex>
        <wui-button @click=${(0, $6mRzS.RouterController).goBack}>
          <wui-icon size="sm" color="inherit" name="add" slot="iconLeft"></wui-icon>
          Buy
        </wui-button>
      </wui-flex>
    `;
    }
};
$8d5c031250ed6e87$export$c63d73b9361e157e = $8d5c031250ed6e87$var$__decorate([
    (0, $ailZp.customElement)("w3m-what-is-a-buy-view")
], $8d5c031250ed6e87$export$c63d73b9361e157e);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $338854b64126bef1$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-loading-spinner {
    margin: 9px auto;
  }

  .email-display,
  .email-display wui-text {
    max-width: 100%;
  }
`;


parcelRequire("dUH6N");
var $l0IQQ = parcelRequire("l0IQQ");
var $4ec92f6f4c25ad38$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $4ec92f6f4c25ad38$var$OTP_LENGTH = 6;
let $4ec92f6f4c25ad38$export$84443566fe241bc9 = class W3mEmailOtpWidget extends (0, $g305D.LitElement) {
    firstUpdated() {
        this.startOTPTimeout();
    }
    disconnectedCallback() {
        clearTimeout(this.OTPTimeout);
    }
    constructor(){
        super();
        this.loading = false;
        this.timeoutTimeLeft = (0, $l0IQQ.W3mFrameHelpers).getTimeToNextEmailLogin();
        this.error = "";
        this.otp = "";
        this.email = (0, $6mRzS.RouterController).state.data?.email;
        this.authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
    }
    render() {
        if (!this.email) throw new Error("w3m-email-otp-widget: No email provided");
        const isResendDisabled = Boolean(this.timeoutTimeLeft);
        const footerLabels = this.getFooterLabels(isResendDisabled);
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "l",
            "0",
            "l",
            "0"
        ]}
        gap="l"
      >
        <wui-flex
          class="email-display"
          flexDirection="column"
          alignItems="center"
          .padding=${[
            "0",
            "xl",
            "0",
            "xl"
        ]}
        >
          <wui-text variant="paragraph-400" color="fg-100" align="center">
            Enter the code we sent to
          </wui-text>
          <wui-text variant="paragraph-500" color="fg-100" lineClamp="1" align="center">
            ${this.email}
          </wui-text>
        </wui-flex>

        <wui-text variant="small-400" color="fg-200">The code expires in 20 minutes</wui-text>

        ${this.loading ? (0, $aTf3K.html)`<wui-loading-spinner size="xl" color="accent-100"></wui-loading-spinner>` : (0, $aTf3K.html)` <wui-flex flexDirection="column" alignItems="center" gap="xs">
              <wui-otp
                dissabled
                length="6"
                @inputChange=${this.onOtpInputChange.bind(this)}
                .otp=${this.otp}
              ></wui-otp>
              ${this.error ? (0, $aTf3K.html)`
                    <wui-text variant="small-400" align="center" color="error-100">
                      ${this.error}. Try Again
                    </wui-text>
                  ` : null}
            </wui-flex>`}

        <wui-flex alignItems="center" gap="xs">
          <wui-text variant="small-400" color="fg-200">${footerLabels.title}</wui-text>
          <wui-link @click=${this.onResendCode.bind(this)} .disabled=${isResendDisabled}>
            ${footerLabels.action}
          </wui-link>
        </wui-flex>
      </wui-flex>
    `;
    }
    startOTPTimeout() {
        this.timeoutTimeLeft = (0, $l0IQQ.W3mFrameHelpers).getTimeToNextEmailLogin();
        this.OTPTimeout = setInterval(()=>{
            if (this.timeoutTimeLeft > 0) this.timeoutTimeLeft = (0, $l0IQQ.W3mFrameHelpers).getTimeToNextEmailLogin();
            else clearInterval(this.OTPTimeout);
        }, 1000);
    }
    async onOtpInputChange(event) {
        try {
            if (!this.loading) {
                this.otp = event.detail;
                if (this.authConnector && this.otp.length === $4ec92f6f4c25ad38$var$OTP_LENGTH) {
                    this.loading = true;
                    await this.onOtpSubmit?.(this.otp);
                }
            }
        } catch (error) {
            this.error = (0, $c4rfq.CoreHelperUtil).parseError(error);
            this.loading = false;
        }
    }
    async onResendCode() {
        try {
            if (this.onOtpResend) {
                if (!this.loading && !this.timeoutTimeLeft) {
                    this.error = "";
                    this.otp = "";
                    const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
                    if (!authConnector || !this.email) throw new Error("w3m-email-otp-widget: Unable to resend email");
                    this.loading = true;
                    await this.onOtpResend(this.email);
                    this.startOTPTimeout();
                    (0, $br7WV.SnackController).showSuccess("Code email resent");
                }
            } else if (this.onStartOver) this.onStartOver();
        } catch (error) {
            (0, $br7WV.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
    getFooterLabels(isResendDisabled) {
        if (this.onStartOver) return {
            title: "Something wrong?",
            action: `Try again ${isResendDisabled ? `in ${this.timeoutTimeLeft}s` : ""}`
        };
        return {
            title: `Didn't receive it?`,
            action: `Resend ${isResendDisabled ? `in ${this.timeoutTimeLeft}s` : "Code"}`
        };
    }
};
$4ec92f6f4c25ad38$export$84443566fe241bc9.styles = (0, $338854b64126bef1$export$2e2bcd8739ae039);
$4ec92f6f4c25ad38$var$__decorate([
    (0, $faUle.state)()
], $4ec92f6f4c25ad38$export$84443566fe241bc9.prototype, "loading", void 0);
$4ec92f6f4c25ad38$var$__decorate([
    (0, $faUle.state)()
], $4ec92f6f4c25ad38$export$84443566fe241bc9.prototype, "timeoutTimeLeft", void 0);
$4ec92f6f4c25ad38$var$__decorate([
    (0, $faUle.state)()
], $4ec92f6f4c25ad38$export$84443566fe241bc9.prototype, "error", void 0);
$4ec92f6f4c25ad38$export$84443566fe241bc9 = $4ec92f6f4c25ad38$var$__decorate([
    (0, $ailZp.customElement)("w3m-email-otp-widget")
], $4ec92f6f4c25ad38$export$84443566fe241bc9);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $hlVrM = parcelRequire("hlVrM");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $21ea0ee0a9590bbd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $21ea0ee0a9590bbd$export$cf0da95883710edd = class W3mEmailVerifyOtpView extends (0, $4ec92f6f4c25ad38$export$84443566fe241bc9) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.smartAccountDeployed = (0, $f7IXw.AccountController).state.smartAccountDeployed;
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.authConnector) {
                    const smartAccountEnabled = (0, $jbD0z.NetworkController).checkIfSmartAccountEnabled();
                    await this.authConnector.provider.connectOtp({
                        otp: otp
                    });
                    (0, $6m17w.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    await (0, $hlVrM.ConnectionController).connectExternal(this.authConnector, this.authConnector.chain);
                    (0, $6m17w.EventsController).sendEvent({
                        type: "track",
                        event: "CONNECT_SUCCESS",
                        properties: {
                            method: "email",
                            name: this.authConnector.name || "Unknown"
                        }
                    });
                    if ((0, $f7IXw.AccountController).state.allAccounts.length > 1) (0, $6mRzS.RouterController).push("SelectAddresses");
                    else if (smartAccountEnabled && !this.smartAccountDeployed) (0, $6mRzS.RouterController).push("UpgradeToSmartAccount");
                    else (0, $ib7WC.ModalController).close();
                }
            } catch (error) {
                (0, $6m17w.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onOtpResend = async (email)=>{
            if (this.authConnector) {
                await this.authConnector.provider.connectEmail({
                    email: email
                });
                (0, $6m17w.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_SENT"
                });
            }
        };
        this.unsubscribe.push((0, $f7IXw.AccountController).subscribeKey("smartAccountDeployed", (val)=>{
            this.smartAccountDeployed = val;
        }));
    }
};
$21ea0ee0a9590bbd$var$__decorate([
    (0, $faUle.state)()
], $21ea0ee0a9590bbd$export$cf0da95883710edd.prototype, "smartAccountDeployed", void 0);
$21ea0ee0a9590bbd$export$cf0da95883710edd = $21ea0ee0a9590bbd$var$__decorate([
    (0, $ailZp.customElement)("w3m-email-verify-otp-view")
], $21ea0ee0a9590bbd$export$cf0da95883710edd);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $e5e69a85c52393da$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-icon-box {
    height: var(--wui-icon-box-size-xl);
    width: var(--wui-icon-box-size-xl);
  }
`;


parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $8db66833f859df69$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8db66833f859df69$export$442e575aa1acbb10 = class W3mEmailVerifyDeviceView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.email = (0, $6mRzS.RouterController).state.data?.email;
        this.authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        this.loading = false;
        this.listenForDeviceApproval();
    }
    render() {
        if (!this.email) throw new Error("w3m-email-verify-device-view: No email provided");
        if (!this.authConnector) throw new Error("w3m-email-verify-device-view: No auth connector provided");
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "xxl",
            "s",
            "xxl",
            "s"
        ]}
        gap="l"
      >
        <wui-icon-box
          size="xl"
          iconcolor="accent-100"
          backgroundcolor="accent-100"
          icon="verify"
          background="opaque"
        ></wui-icon-box>

        <wui-flex flexDirection="column" alignItems="center" gap="s">
          <wui-flex flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-400" color="fg-100">
              Approve the login link we sent to
            </wui-text>
            <wui-text variant="paragraph-400" color="fg-100"><b>${this.email}</b></wui-text>
          </wui-flex>

          <wui-text variant="small-400" color="fg-200" align="center">
            The code expires in 20 minutes
          </wui-text>

          <wui-flex alignItems="center" id="w3m-resend-section" gap="xs">
            <wui-text variant="small-400" color="fg-100" align="center">
              Didn't receive it?
            </wui-text>
            <wui-link @click=${this.onResendCode.bind(this)} .disabled=${this.loading}>
              Resend email
            </wui-link>
          </wui-flex>
        </wui-flex>
      </wui-flex>
    `;
    }
    async listenForDeviceApproval() {
        if (this.authConnector) try {
            await this.authConnector.provider.connectDevice();
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "DEVICE_REGISTERED_FOR_EMAIL"
            });
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_VERIFICATION_CODE_SENT"
            });
            (0, $6mRzS.RouterController).replace("EmailVerifyOtp", {
                email: this.email
            });
        } catch (error) {
            (0, $6mRzS.RouterController).goBack();
        }
    }
    async onResendCode() {
        try {
            if (!this.loading) {
                if (!this.authConnector || !this.email) throw new Error("w3m-email-login-widget: Unable to resend email");
                this.loading = true;
                await this.authConnector.provider.connectEmail({
                    email: this.email
                });
                this.listenForDeviceApproval();
                (0, $br7WV.SnackController).showSuccess("Code email resent");
            }
        } catch (error) {
            (0, $br7WV.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
};
$8db66833f859df69$export$442e575aa1acbb10.styles = (0, $e5e69a85c52393da$export$2e2bcd8739ae039);
$8db66833f859df69$var$__decorate([
    (0, $faUle.state)()
], $8db66833f859df69$export$442e575aa1acbb10.prototype, "loading", void 0);
$8db66833f859df69$export$442e575aa1acbb10 = $8db66833f859df69$var$__decorate([
    (0, $ailZp.customElement)("w3m-email-verify-device-view")
], $8db66833f859df69$export$442e575aa1acbb10);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $d510b6aedd07e1c5$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  div {
    width: 100%;
    height: 400px;
  }

  [data-ready='false'] {
    transform: scale(1.05);
  }

  @media (max-width: 430px) {
    [data-ready='false'] {
      transform: translateY(-50px);
    }
  }
`;


parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
var $ib7WC = parcelRequire("ib7WC");
var $6mRzS = parcelRequire("6mRzS");
var $3Sg6l = parcelRequire("3Sg6l");
parcelRequire("ikDNi");
var $5OPHH = parcelRequire("5OPHH");
var $0ca455ccd4ab23c3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $0ca455ccd4ab23c3$var$PAGE_HEIGHT = 400;
const $0ca455ccd4ab23c3$var$PAGE_WIDTH = 360;
const $0ca455ccd4ab23c3$var$HEADER_HEIGHT = 64;
let $0ca455ccd4ab23c3$export$ab9ab0bd09f8f225 = class W3mApproveTransactionView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.bodyObserver = undefined;
        this.unsubscribe = [];
        this.iframe = document.getElementById("w3m-iframe");
        this.ready = false;
        this.unsubscribe.push(...[
            (0, $ib7WC.ModalController).subscribeKey("open", (isOpen)=>{
                if (!isOpen) {
                    this.onHideIframe();
                    (0, $6mRzS.RouterController).popTransactionStack();
                }
            }),
            (0, $ib7WC.ModalController).subscribeKey("shake", (val)=>{
                if (val) this.iframe.style.animation = `w3m-shake 500ms var(--wui-ease-out-power-2)`;
                else this.iframe.style.animation = "none";
            })
        ]);
    }
    disconnectedCallback() {
        this.onHideIframe();
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.bodyObserver?.unobserve(window.document.body);
    }
    async firstUpdated() {
        await this.syncTheme();
        this.iframe.style.display = "block";
        this.bodyObserver = new ResizeObserver((entries)=>{
            const contentBoxSize = entries?.[0]?.contentBoxSize;
            const width = contentBoxSize?.[0]?.inlineSize;
            this.iframe.style.height = `${$0ca455ccd4ab23c3$var$PAGE_HEIGHT}px`;
            if (width && width <= 430) {
                this.iframe.style.width = "100%";
                this.iframe.style.left = "0px";
                this.iframe.style.bottom = "0px";
                this.iframe.style.top = "unset";
            } else {
                this.iframe.style.width = `${$0ca455ccd4ab23c3$var$PAGE_WIDTH}px`;
                this.iframe.style.left = `calc(50% - ${$0ca455ccd4ab23c3$var$PAGE_WIDTH / 2}px)`;
                this.iframe.style.top = `calc(50% - ${$0ca455ccd4ab23c3$var$PAGE_HEIGHT / 2}px + ${$0ca455ccd4ab23c3$var$HEADER_HEIGHT / 2}px)`;
                this.iframe.style.bottom = "unset";
            }
            this.ready = true;
            this.onShowIframe();
        });
        this.bodyObserver.observe(window.document.body);
    }
    render() {
        return (0, $aTf3K.html)`<div data-ready=${this.ready}></div>`;
    }
    onShowIframe() {
        const isMobile = window.innerWidth <= 430;
        this.iframe.style.animation = isMobile ? "w3m-iframe-zoom-in-mobile 200ms var(--wui-ease-out-power-2)" : "w3m-iframe-zoom-in 200ms var(--wui-ease-out-power-2)";
    }
    onHideIframe() {
        this.iframe.style.display = "none";
        this.iframe.style.animation = "w3m-iframe-fade-out 200ms var(--wui-ease-out-power-2)";
    }
    async syncTheme() {
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (authConnector) {
            const themeMode = (0, $3Sg6l.ThemeController).getSnapshot().themeMode;
            const themeVariables = (0, $3Sg6l.ThemeController).getSnapshot().themeVariables;
            await authConnector.provider.syncTheme({
                themeVariables: themeVariables,
                w3mThemeVariables: (0, $5OPHH.getW3mThemeVariables)(themeVariables, themeMode)
            });
        }
    }
};
$0ca455ccd4ab23c3$export$ab9ab0bd09f8f225.styles = (0, $d510b6aedd07e1c5$export$2e2bcd8739ae039);
$0ca455ccd4ab23c3$var$__decorate([
    (0, $faUle.state)()
], $0ca455ccd4ab23c3$export$ab9ab0bd09f8f225.prototype, "ready", void 0);
$0ca455ccd4ab23c3$export$ab9ab0bd09f8f225 = $0ca455ccd4ab23c3$var$__decorate([
    (0, $ailZp.customElement)("w3m-approve-transaction-view")
], $0ca455ccd4ab23c3$export$ab9ab0bd09f8f225);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("eNJDH");
var $6AwK8 = parcelRequire("6AwK8");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
var $215636adc8830db2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $215636adc8830db2$export$a1f0d947f01e8672 = class W3mUpgradeWalletView extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="xl" padding="xl">
        <wui-text variant="paragraph-400" color="fg-100">Follow the instructions on</wui-text>
        <wui-chip
          icon="externalLink"
          variant="fill"
          href=${(0, $6AwK8.ConstantsUtil).SECURE_SITE_DASHBOARD}
          imageSrc=${(0, $6AwK8.ConstantsUtil).SECURE_SITE_FAVICON}
          data-testid="w3m-secure-website-button"
        >
        </wui-chip>
        <wui-text variant="small-400" color="fg-200">
          You will have to reconnect for security reasons
        </wui-text>
      </wui-flex>
    `;
    }
};
$215636adc8830db2$export$a1f0d947f01e8672 = $215636adc8830db2$var$__decorate([
    (0, $ailZp.customElement)("w3m-upgrade-wallet-view")
], $215636adc8830db2$export$a1f0d947f01e8672);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
var $bmR1U = parcelRequire("bmR1U");
var $br7WV = parcelRequire("br7WV");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
parcelRequire("ikDNi");
var $jgvE4 = parcelRequire("jgvE4");
var $dc2ad88645d0b0da$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dc2ad88645d0b0da$export$5ea49ea5c855ab18 = class W3mUpgradeToSmartAccountView extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        this.loading = false;
        this.setPreferSmartAccount = async ()=>{
            if (this.authConnector) try {
                this.loading = true;
                await (0, $hlVrM.ConnectionController).setPreferredAccountType((0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT);
                this.loading = false;
                (0, $bmR1U.RouterUtil).navigateAfterPreferredAccountTypeSelect();
            } catch (e) {
                (0, $br7WV.SnackController).showError("Error upgrading to smart account");
            }
        };
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        gap="xxl"
        .padding=${[
            "0",
            "0",
            "l",
            "0"
        ]}
      >
        ${this.onboardingTemplate()} ${this.buttonsTemplate()}
        <wui-link
          @click=${()=>{
            (0, $c4rfq.CoreHelperUtil).openHref((0, $jgvE4.NavigationUtil).URLS.FAQ, "_blank");
        }}
        >
          Learn more
          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>
        </wui-link>
      </wui-flex>
    `;
    }
    onboardingTemplate() {
        return (0, $aTf3K.html)` <wui-flex
      flexDirection="column"
      gap="xxl"
      alignItems="center"
      .padding=${[
            "0",
            "xxl",
            "0",
            "xxl"
        ]}
    >
      <wui-flex gap="s" alignItems="center" justifyContent="center">
        <wui-visual name="google"></wui-visual>
        <wui-visual name="pencil"></wui-visual>
        <wui-visual name="lightbulb"></wui-visual>
      </wui-flex>
      <wui-flex flexDirection="column" alignItems="center" gap="s">
        <wui-text align="center" variant="medium-600" color="fg-100">
          Discover Smart Accounts
        </wui-text>
        <wui-text align="center" variant="paragraph-400" color="fg-100">
          Access advanced features such as username, social login, improved security and a smoother
          user experience!
        </wui-text>
      </wui-flex>
    </wui-flex>`;
    }
    buttonsTemplate() {
        return (0, $aTf3K.html)`<wui-flex .padding=${[
            "0",
            "2l",
            "0",
            "2l"
        ]} gap="s">
      <wui-button
        variant="accent"
        @click=${this.redirectToAccount.bind(this)}
        size="lg"
        borderRadius="xs"
      >
        Do it later
      </wui-button>
      <wui-button
        .loading=${this.loading}
        size="lg"
        borderRadius="xs"
        @click=${this.setPreferSmartAccount.bind(this)}
        >Continue
      </wui-button>
    </wui-flex>`;
    }
    redirectToAccount() {
        (0, $6mRzS.RouterController).push("Account");
    }
};
$dc2ad88645d0b0da$var$__decorate([
    (0, $faUle.state)()
], $dc2ad88645d0b0da$export$5ea49ea5c855ab18.prototype, "authConnector", void 0);
$dc2ad88645d0b0da$var$__decorate([
    (0, $faUle.state)()
], $dc2ad88645d0b0da$export$5ea49ea5c855ab18.prototype, "loading", void 0);
$dc2ad88645d0b0da$export$5ea49ea5c855ab18 = $dc2ad88645d0b0da$var$__decorate([
    (0, $ailZp.customElement)("w3m-upgrade-to-smart-account-view")
], $dc2ad88645d0b0da$export$5ea49ea5c855ab18);


parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $c931c9350ca3f258$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }
`;


var $0166a425e26518a0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0166a425e26518a0$export$6814d6aff4948a0 = class W3mUpdateEmailWalletView extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.formRef = (0, $8fa5b8d3f98eecf3$export$7d1e3a5e95ceca43)();
        this.initialEmail = (0, $6mRzS.RouterController).state.data?.email ?? "";
        this.email = "";
        this.loading = false;
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.onSubmitEmail(event);
        });
    }
    render() {
        const showSubmit = !this.loading && this.email.length > 3 && this.email !== this.initialEmail;
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" padding="m" gap="m">
        <form ${(0, $8fa5b8d3f98eecf3$export$eff4d24c3ff7876e)(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
          <wui-email-input
            value=${this.initialEmail}
            .disabled=${this.loading}
            @inputChange=${this.onEmailInputChange.bind(this)}
          >
          </wui-email-input>
          <input type="submit" hidden />
        </form>

        <wui-flex gap="s">
          <wui-button size="md" variant="neutral" fullWidth @click=${(0, $6mRzS.RouterController).goBack}>
            Cancel
          </wui-button>

          <wui-button
            size="md"
            variant="main"
            fullWidth
            @click=${this.onSubmitEmail.bind(this)}
            .disabled=${!showSubmit}
            .loading=${this.loading}
          >
            Save
          </wui-button>
        </wui-flex>
      </wui-flex>
    `;
    }
    onEmailInputChange(event) {
        this.email = event.detail;
    }
    async onSubmitEmail(event) {
        try {
            if (this.loading) return;
            this.loading = true;
            event.preventDefault();
            const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
            if (!authConnector) throw new Error("w3m-update-email-wallet: Auth connector not found");
            const response = await authConnector.provider.updateEmail({
                email: this.email
            });
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_EDIT"
            });
            if (response.action === "VERIFY_SECONDARY_OTP") (0, $6mRzS.RouterController).push("UpdateEmailSecondaryOtp", {
                email: this.initialEmail,
                newEmail: this.email
            });
            else (0, $6mRzS.RouterController).push("UpdateEmailPrimaryOtp", {
                email: this.initialEmail,
                newEmail: this.email
            });
        } catch (error) {
            (0, $br7WV.SnackController).showError(error);
            this.loading = false;
        }
    }
};
$0166a425e26518a0$export$6814d6aff4948a0.styles = (0, $c931c9350ca3f258$export$2e2bcd8739ae039);
$0166a425e26518a0$var$__decorate([
    (0, $faUle.state)()
], $0166a425e26518a0$export$6814d6aff4948a0.prototype, "email", void 0);
$0166a425e26518a0$var$__decorate([
    (0, $faUle.state)()
], $0166a425e26518a0$export$6814d6aff4948a0.prototype, "loading", void 0);
$0166a425e26518a0$export$6814d6aff4948a0 = $0166a425e26518a0$var$__decorate([
    (0, $ailZp.customElement)("w3m-update-email-wallet-view")
], $0166a425e26518a0$export$6814d6aff4948a0);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");

parcelRequire("eNJDH");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
var $a696ad3f010db89d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a696ad3f010db89d$export$f089084b6501bc5 = class W3mUpdateEmailPrimaryOtpView extends (0, $4ec92f6f4c25ad38$export$84443566fe241bc9) {
    constructor(){
        super();
        this.email = (0, $6mRzS.RouterController).state.data?.email;
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.authConnector) {
                    await this.authConnector.provider.updateEmailPrimaryOtp({
                        otp: otp
                    });
                    (0, $6m17w.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    (0, $6mRzS.RouterController).replace("UpdateEmailSecondaryOtp", (0, $6mRzS.RouterController).state.data);
                }
            } catch (error) {
                (0, $6m17w.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onStartOver = ()=>{
            (0, $6mRzS.RouterController).replace("UpdateEmailWallet", (0, $6mRzS.RouterController).state.data);
        };
    }
};
$a696ad3f010db89d$export$f089084b6501bc5 = $a696ad3f010db89d$var$__decorate([
    (0, $ailZp.customElement)("w3m-update-email-primary-otp-view")
], $a696ad3f010db89d$export$f089084b6501bc5);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");

parcelRequire("eNJDH");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
var $8eac22ef6a35c832$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8eac22ef6a35c832$export$627b68ac942cb0d6 = class W3mUpdateEmailSecondaryOtpView extends (0, $4ec92f6f4c25ad38$export$84443566fe241bc9) {
    constructor(){
        super();
        this.email = (0, $6mRzS.RouterController).state.data?.newEmail;
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.authConnector) {
                    await this.authConnector.provider.updateEmailSecondaryOtp({
                        otp: otp
                    });
                    (0, $6m17w.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    (0, $6mRzS.RouterController).reset("Account");
                }
            } catch (error) {
                (0, $6m17w.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onStartOver = ()=>{
            (0, $6mRzS.RouterController).replace("UpdateEmailWallet", (0, $6mRzS.RouterController).state.data);
        };
    }
};
$8eac22ef6a35c832$export$627b68ac942cb0d6 = $8eac22ef6a35c832$var$__decorate([
    (0, $ailZp.customElement)("w3m-update-email-secondary-otp-view")
], $8eac22ef6a35c832$export$627b68ac942cb0d6);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $hlVrM = parcelRequire("hlVrM");
var $6AwK8 = parcelRequire("6AwK8");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $f64ed6b56c52b6d2$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }

  :host > wui-flex::-webkit-scrollbar {
    display: none;
  }
`;



var $4088df1a8d6ca060$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4088df1a8d6ca060$export$db1b0c4a50057bc8 = class W3mUnsupportedChainView extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.swapUnsupportedChain = (0, $6mRzS.RouterController).state.data?.swapUnsupportedChain;
        this.disconecting = false;
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex class="container" flexDirection="column" gap="0">
        <wui-flex
          class="container"
          flexDirection="column"
          .padding=${[
            "m",
            "xl",
            "xs",
            "xl"
        ]}
          alignItems="center"
          gap="xl"
        >
          ${this.descriptionTemplate()}
        </wui-flex>

        <wui-flex flexDirection="column" padding="s" gap="xs">
          ${this.networksTemplate()}
        </wui-flex>

        <wui-separator text="or"></wui-separator>
        <wui-flex flexDirection="column" padding="s" gap="xs">
          <wui-list-item
            variant="icon"
            iconVariant="overlay"
            icon="disconnect"
            ?chevron=${false}
            .loading=${this.disconecting}
            @click=${this.onDisconnect.bind(this)}
            data-testid="disconnect-button"
          >
            <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
          </wui-list-item>
        </wui-flex>
      </wui-flex>
    `;
    }
    descriptionTemplate() {
        if (this.swapUnsupportedChain) return (0, $aTf3K.html)`
        <wui-text variant="small-400" color="fg-200" align="center">
          The swap feature doesn’t support your current network. Switch to an available option to
          continue.
        </wui-text>
      `;
        return (0, $aTf3K.html)`
      <wui-text variant="small-400" color="fg-200" align="center">
        This app doesn’t support your current network. Switch to an available option to continue.
      </wui-text>
    `;
    }
    networksTemplate() {
        const requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        const approvedCaipNetworkIds = (0, $jbD0z.NetworkController).state.approvedCaipNetworkIds;
        const sortedNetworks = (0, $c4rfq.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
        const filteredNetworks = this.swapUnsupportedChain ? sortedNetworks.filter((network)=>(0, $6AwK8.ConstantsUtil).SWAP_SUPPORTED_NETWORKS.includes(network.id)) : sortedNetworks;
        return filteredNetworks.map((network)=>(0, $aTf3K.html)`
        <wui-list-network
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getNetworkImage(network))}
          name=${network.name ?? "Unknown"}
          @click=${()=>this.onSwitchNetwork(network)}
        >
        </wui-list-network>
      `);
    }
    async onDisconnect() {
        try {
            this.disconecting = true;
            await (0, $hlVrM.ConnectionController).disconnect();
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $ib7WC.ModalController).close();
        } catch  {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $br7WV.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconecting = false;
        }
    }
    async onSwitchNetwork(network) {
        const isConnected = (0, $f7IXw.AccountController).state.isConnected;
        const approvedCaipNetworkIds = (0, $jbD0z.NetworkController).state.approvedCaipNetworkIds;
        const supportsAllNetworks = (0, $jbD0z.NetworkController).state.supportsAllNetworks;
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        const routerData = (0, $6mRzS.RouterController).state.data;
        if (isConnected && caipNetwork?.id !== network.id) {
            if (approvedCaipNetworkIds?.includes(network.id)) {
                await (0, $jbD0z.NetworkController).switchActiveNetwork(network);
                await (0, $9512bcc8a1d25c7a$export$79d00c05833eff69).onNetworkChange();
            } else if (supportsAllNetworks) (0, $6mRzS.RouterController).push("SwitchNetwork", {
                ...routerData,
                network: network
            });
        } else if (!isConnected) {
            (0, $jbD0z.NetworkController).setActiveCaipNetwork(network);
            (0, $6mRzS.RouterController).push("Connect");
        }
    }
};
$4088df1a8d6ca060$export$db1b0c4a50057bc8.styles = (0, $f64ed6b56c52b6d2$export$2e2bcd8739ae039);
$4088df1a8d6ca060$var$__decorate([
    (0, $faUle.state)()
], $4088df1a8d6ca060$export$db1b0c4a50057bc8.prototype, "disconecting", void 0);
$4088df1a8d6ca060$export$db1b0c4a50057bc8 = $4088df1a8d6ca060$var$__decorate([
    (0, $ailZp.customElement)("w3m-unsupported-chain-view")
], $4088df1a8d6ca060$export$db1b0c4a50057bc8);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $c4rfq = parcelRequire("c4rfq");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
var $3Sg6l = parcelRequire("3Sg6l");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $c7a9a8bf4f463e5c$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-compatible-network {
    margin-top: var(--wui-spacing-l);
  }
`;


parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $460dd14983304bb3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $460dd14983304bb3$export$98052df59169e23d = class W3mWalletReceiveView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.address = (0, $f7IXw.AccountController).state.address;
        this.profileName = (0, $f7IXw.AccountController).state.profileName;
        this.network = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.preferredAccountType = (0, $f7IXw.AccountController).state.preferredAccountType;
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileName = val.profileName;
                    this.preferredAccountType = val.preferredAccountType;
                } else (0, $br7WV.SnackController).showError("Account not found");
            })
        ], (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (val)=>{
            if (val?.id) this.network = val;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-wallet-receive-view: No account provided");
        const networkImage = (0, $eOULk.AssetUtil).getNetworkImage(this.network);
        return (0, $aTf3K.html)` <wui-flex
      flexDirection="column"
      .padding=${[
            "0",
            "l",
            "l",
            "l"
        ]}
      alignItems="center"
    >
      <wui-chip-button
        data-testid="receive-address-copy-button"
        @click=${this.onCopyClick.bind(this)}
        text=${(0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.profileName || this.address || "",
            charsStart: this.profileName ? 18 : 4,
            charsEnd: this.profileName ? 0 : 4,
            truncate: this.profileName ? "end" : "middle"
        })}
        icon="copy"
        size="sm"
        imageSrc=${networkImage ? networkImage : ""}
        variant="gray"
      ></wui-chip-button>
      <wui-flex
        flexDirection="column"
        .padding=${[
            "l",
            "0",
            "0",
            "0"
        ]}
        alignItems="center"
        gap="s"
      >
        <wui-qr-code
          size=${232}
          theme=${(0, $3Sg6l.ThemeController).state.themeMode}
          uri=${this.address}
          ?arenaClear=${true}
          data-testid="wui-qr-code"
        ></wui-qr-code>
        <wui-text variant="paragraph-500" color="fg-100" align="center">
          Copy your address or scan this QR code
        </wui-text>
      </wui-flex>
      ${this.networkTemplate()}
    </wui-flex>`;
    }
    networkTemplate() {
        const requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        const isNetworkEnabledForSmartAccounts = (0, $jbD0z.NetworkController).checkIfSmartAccountEnabled();
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        if (this.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT && isNetworkEnabledForSmartAccounts) {
            if (!caipNetwork) return null;
            return (0, $aTf3K.html)`<wui-compatible-network
        @click=${this.onReceiveClick.bind(this)}
        text="Only receive assets on this network"
        .networkImages=${[
                (0, $eOULk.AssetUtil).getNetworkImage(caipNetwork) ?? ""
            ]}
      ></wui-compatible-network>`;
        }
        const slicedNetworks = requestedCaipNetworks?.filter((network)=>network?.imageId)?.slice(0, 5);
        const imagesArray = slicedNetworks.map((0, $eOULk.AssetUtil).getNetworkImage).filter(Boolean);
        return (0, $aTf3K.html)`<wui-compatible-network
      @click=${this.onReceiveClick.bind(this)}
      text="Only receive assets on these networks"
      .networkImages=${imagesArray}
    ></wui-compatible-network>`;
    }
    onReceiveClick() {
        (0, $6mRzS.RouterController).push("WalletCompatibleNetworks");
    }
    onCopyClick() {
        try {
            if (this.address) {
                (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.address);
                (0, $br7WV.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $br7WV.SnackController).showError("Failed to copy");
        }
    }
};
$460dd14983304bb3$export$98052df59169e23d.styles = (0, $c7a9a8bf4f463e5c$export$2e2bcd8739ae039);
$460dd14983304bb3$var$__decorate([
    (0, $faUle.state)()
], $460dd14983304bb3$export$98052df59169e23d.prototype, "address", void 0);
$460dd14983304bb3$var$__decorate([
    (0, $faUle.state)()
], $460dd14983304bb3$export$98052df59169e23d.prototype, "profileName", void 0);
$460dd14983304bb3$var$__decorate([
    (0, $faUle.state)()
], $460dd14983304bb3$export$98052df59169e23d.prototype, "network", void 0);
$460dd14983304bb3$var$__decorate([
    (0, $faUle.state)()
], $460dd14983304bb3$export$98052df59169e23d.prototype, "preferredAccountType", void 0);
$460dd14983304bb3$export$98052df59169e23d = $460dd14983304bb3$var$__decorate([
    (0, $ailZp.customElement)("w3m-wallet-receive-view")
], $460dd14983304bb3$export$98052df59169e23d);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $c4rfq = parcelRequire("c4rfq");
var $jbD0z = parcelRequire("jbD0z");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $efbb414ed5d11e91$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }

  :host > wui-flex::-webkit-scrollbar {
    display: none;
  }
`;


parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $bd7e56e86d9adb91$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bd7e56e86d9adb91$export$b80248a7d70a36d4 = class W3mWalletCompatibleNetworksView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.preferredAccountType = (0, $f7IXw.AccountController).state.preferredAccountType;
        this.unsubscribe.push((0, $f7IXw.AccountController).subscribeKey("preferredAccountType", (val)=>{
            this.preferredAccountType = val;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)` <wui-flex
      flexDirection="column"
      .padding=${[
            "xs",
            "s",
            "m",
            "s"
        ]}
      gap="xs"
    >
      <wui-banner
        icon="warningCircle"
        text="You can only receive assets on these networks"
      ></wui-banner>
      ${this.networkTemplate()}
    </wui-flex>`;
    }
    networkTemplate() {
        const requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        const approvedCaipNetworkIds = (0, $jbD0z.NetworkController).state.approvedCaipNetworkIds;
        const caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        const isNetworkEnabledForSmartAccounts = (0, $jbD0z.NetworkController).checkIfSmartAccountEnabled();
        let sortedNetworks = (0, $c4rfq.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
        if (isNetworkEnabledForSmartAccounts && this.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT) {
            if (!caipNetwork) return null;
            sortedNetworks = [
                caipNetwork
            ];
        }
        return sortedNetworks.map((network)=>(0, $aTf3K.html)`
        <wui-list-network
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getNetworkImage(network))}
          name=${network.name ?? "Unknown"}
          ?transparent=${true}
        >
        </wui-list-network>
      `);
    }
};
$bd7e56e86d9adb91$export$b80248a7d70a36d4.styles = (0, $efbb414ed5d11e91$export$2e2bcd8739ae039);
$bd7e56e86d9adb91$var$__decorate([
    (0, $faUle.state)()
], $bd7e56e86d9adb91$export$b80248a7d70a36d4.prototype, "preferredAccountType", void 0);
$bd7e56e86d9adb91$export$b80248a7d70a36d4 = $bd7e56e86d9adb91$var$__decorate([
    (0, $ailZp.customElement)("w3m-wallet-compatible-networks-view")
], $bd7e56e86d9adb91$export$b80248a7d70a36d4);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $a63427cfa20af210$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    display: block;
  }

  wui-flex {
    position: relative;
  }

  wui-icon-box {
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-xs) !important;
    border: 5px solid var(--wui-color-bg-125);
    background: var(--wui-color-bg-175);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  wui-button {
    --local-border-radius: var(--wui-border-radius-xs) !important;
  }

  .inputContainer {
    height: fit-content;
  }
`;


parcelRequire("eNJDH");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
var $3BhS7 = parcelRequire("3BhS7");
var $89gde = parcelRequire("89gde");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $bb757161b2f95b42$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bb757161b2f95b42$export$d2da0955648ac29b = class W3mWalletSendView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.token = (0, $3BhS7.SendController).state.token;
        this.sendTokenAmount = (0, $3BhS7.SendController).state.sendTokenAmount;
        this.receiverAddress = (0, $3BhS7.SendController).state.receiverAddress;
        this.receiverProfileName = (0, $3BhS7.SendController).state.receiverProfileName;
        this.loading = (0, $3BhS7.SendController).state.loading;
        this.gasPriceInUSD = (0, $3BhS7.SendController).state.gasPriceInUSD;
        this.message = "Preview Send";
        this.fetchNetworkPrice();
        this.unsubscribe.push(...[
            (0, $3BhS7.SendController).subscribe((val)=>{
                this.token = val.token;
                this.sendTokenAmount = val.sendTokenAmount;
                this.receiverAddress = val.receiverAddress;
                this.gasPriceInUSD = val.gasPriceInUSD;
                this.receiverProfileName = val.receiverProfileName;
                this.loading = val.loading;
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        this.getMessage();
        return (0, $aTf3K.html)` <wui-flex flexDirection="column" .padding=${[
            "0",
            "l",
            "l",
            "l"
        ]}>
      <wui-flex class="inputContainer" gap="xs" flexDirection="column">
        <w3m-input-token
          .token=${this.token}
          .sendTokenAmount=${this.sendTokenAmount}
          .gasPriceInUSD=${this.gasPriceInUSD}
        ></w3m-input-token>
        <wui-icon-box
          size="inherit"
          backgroundColor="fg-300"
          iconSize="lg"
          iconColor="fg-250"
          background="opaque"
          icon="arrowBottom"
        ></wui-icon-box>
        <w3m-input-address
          .value=${this.receiverProfileName ? this.receiverProfileName : this.receiverAddress}
        ></w3m-input-address>
      </wui-flex>
      <wui-flex .margin=${[
            "l",
            "0",
            "0",
            "0"
        ]}>
        <wui-button
          @click=${this.onButtonClick.bind(this)}
          ?disabled=${!this.message.startsWith("Preview Send")}
          size="lg"
          variant="main"
          ?loading=${this.loading}
          fullWidth
        >
          ${this.message}
        </wui-button>
      </wui-flex>
    </wui-flex>`;
    }
    async fetchNetworkPrice() {
        await (0, $89gde.SwapController).getNetworkTokenPrice();
        const gas = await (0, $89gde.SwapController).getInitialGasPrice();
        if (gas?.gasPrice && gas?.gasPriceInUSD) {
            (0, $3BhS7.SendController).setGasPrice(gas.gasPrice);
            (0, $3BhS7.SendController).setGasPriceInUsd(gas.gasPriceInUSD);
        }
    }
    onButtonClick() {
        (0, $6mRzS.RouterController).push("WalletSendPreview");
    }
    getMessage() {
        this.message = "Preview Send";
        if (this.receiverAddress && !(0, $c4rfq.CoreHelperUtil).isAddress(this.receiverAddress)) this.message = "Invalid Address";
        if (!this.receiverAddress) this.message = "Add Address";
        if (this.sendTokenAmount && this.token && this.sendTokenAmount > Number(this.token.quantity.numeric)) this.message = "Insufficient Funds";
        if (!this.sendTokenAmount) this.message = "Add Amount";
        if (this.sendTokenAmount && this.token?.price) {
            const value = this.sendTokenAmount * this.token.price;
            if (!value) this.message = "Incorrect Value";
        }
        if (!this.token) this.message = "Select Token";
    }
};
$bb757161b2f95b42$export$d2da0955648ac29b.styles = (0, $a63427cfa20af210$export$2e2bcd8739ae039);
$bb757161b2f95b42$var$__decorate([
    (0, $faUle.state)()
], $bb757161b2f95b42$export$d2da0955648ac29b.prototype, "token", void 0);
$bb757161b2f95b42$var$__decorate([
    (0, $faUle.state)()
], $bb757161b2f95b42$export$d2da0955648ac29b.prototype, "sendTokenAmount", void 0);
$bb757161b2f95b42$var$__decorate([
    (0, $faUle.state)()
], $bb757161b2f95b42$export$d2da0955648ac29b.prototype, "receiverAddress", void 0);
$bb757161b2f95b42$var$__decorate([
    (0, $faUle.state)()
], $bb757161b2f95b42$export$d2da0955648ac29b.prototype, "receiverProfileName", void 0);
$bb757161b2f95b42$var$__decorate([
    (0, $faUle.state)()
], $bb757161b2f95b42$export$d2da0955648ac29b.prototype, "loading", void 0);
$bb757161b2f95b42$var$__decorate([
    (0, $faUle.state)()
], $bb757161b2f95b42$export$d2da0955648ac29b.prototype, "gasPriceInUSD", void 0);
$bb757161b2f95b42$var$__decorate([
    (0, $faUle.state)()
], $bb757161b2f95b42$export$d2da0955648ac29b.prototype, "message", void 0);
$bb757161b2f95b42$export$d2da0955648ac29b = $bb757161b2f95b42$var$__decorate([
    (0, $ailZp.customElement)("w3m-wallet-send-view")
], $bb757161b2f95b42$export$d2da0955648ac29b);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $7d7d1c4b80476195$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  .contentContainer {
    height: 440px;
    overflow: scroll;
    scrollbar-width: none;
  }

  .contentContainer::-webkit-scrollbar {
    display: none;
  }

  wui-icon-box {
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-xxs);
  }
`;


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $c4rfq = parcelRequire("c4rfq");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
var $3BhS7 = parcelRequire("3BhS7");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $7b39ee3902cd67ef$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7b39ee3902cd67ef$export$90e27946f1ab834e = class W3mSendSelectTokenView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.tokenBalance = (0, $f7IXw.AccountController).state.tokenBalance;
        this.search = "";
        this.onDebouncedSearch = (0, $c4rfq.CoreHelperUtil).debounce((value)=>{
            this.search = value;
        });
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribe((val)=>{
                this.tokenBalance = val.tokenBalance;
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column">
        ${this.templateSearchInput()} <wui-separator></wui-separator> ${this.templateTokens()}
      </wui-flex>
    `;
    }
    templateSearchInput() {
        return (0, $aTf3K.html)`
      <wui-flex gap="xs" padding="s">
        <wui-input-text
          @inputChange=${this.onInputChange.bind(this)}
          class="network-search-input"
          size="sm"
          placeholder="Search token"
          icon="search"
        ></wui-input-text>
      </wui-flex>
    `;
    }
    templateTokens() {
        this.tokens = this.tokenBalance?.filter((token)=>token.chainId === (0, $jbD0z.NetworkController).state.caipNetwork?.id);
        if (this.search) this.filteredTokens = this.tokenBalance?.filter((token)=>token.name.toLowerCase().includes(this.search.toLowerCase()));
        else this.filteredTokens = this.tokens;
        return (0, $aTf3K.html)`
      <wui-flex
        class="contentContainer"
        flexDirection="column"
        .padding=${[
            "0",
            "s",
            "0",
            "s"
        ]}
      >
        <wui-flex justifyContent="flex-start" .padding=${[
            "m",
            "s",
            "s",
            "s"
        ]}>
          <wui-text variant="paragraph-500" color="fg-200">Your tokens</wui-text>
        </wui-flex>
        <wui-flex flexDirection="column" gap="xs">
          ${this.filteredTokens && this.filteredTokens.length > 0 ? this.filteredTokens.map((token)=>(0, $aTf3K.html)`<wui-list-token
                    @click=${this.handleTokenClick.bind(this, token)}
                    ?clickable=${true}
                    tokenName=${token.name}
                    tokenImageUrl=${token.iconUrl}
                    tokenAmount=${token.quantity.numeric}
                    tokenValue=${token.value}
                    tokenCurrency=${token.symbol}
                  ></wui-list-token>`) : (0, $aTf3K.html)`<wui-flex
                .padding=${[
            "4xl",
            "0",
            "0",
            "0"
        ]}
                alignItems="center"
                flexDirection="column"
                gap="l"
              >
                <wui-icon-box
                  icon="coinPlaceholder"
                  size="inherit"
                  iconColor="fg-200"
                  backgroundColor="fg-200"
                  iconSize="lg"
                ></wui-icon-box>
                <wui-flex
                  class="textContent"
                  gap="xs"
                  flexDirection="column"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <wui-text variant="paragraph-500" align="center" color="fg-100"
                    >No tokens found</wui-text
                  >
                  <wui-text variant="small-400" align="center" color="fg-200"
                    >Your tokens will appear here</wui-text
                  >
                </wui-flex>
                <wui-link @click=${this.onBuyClick.bind(this)}>Buy</wui-link>
              </wui-flex>`}
        </wui-flex>
      </wui-flex>
    `;
    }
    onBuyClick() {
        (0, $6mRzS.RouterController).push("OnRampProviders");
    }
    onInputChange(event) {
        this.onDebouncedSearch(event.detail);
    }
    handleTokenClick(token) {
        (0, $3BhS7.SendController).setToken(token);
        (0, $3BhS7.SendController).setTokenAmount(undefined);
        (0, $6mRzS.RouterController).goBack();
    }
};
$7b39ee3902cd67ef$export$90e27946f1ab834e.styles = (0, $7d7d1c4b80476195$export$2e2bcd8739ae039);
$7b39ee3902cd67ef$var$__decorate([
    (0, $faUle.state)()
], $7b39ee3902cd67ef$export$90e27946f1ab834e.prototype, "tokenBalance", void 0);
$7b39ee3902cd67ef$var$__decorate([
    (0, $faUle.state)()
], $7b39ee3902cd67ef$export$90e27946f1ab834e.prototype, "tokens", void 0);
$7b39ee3902cd67ef$var$__decorate([
    (0, $faUle.state)()
], $7b39ee3902cd67ef$export$90e27946f1ab834e.prototype, "filteredTokens", void 0);
$7b39ee3902cd67ef$var$__decorate([
    (0, $faUle.state)()
], $7b39ee3902cd67ef$export$90e27946f1ab834e.prototype, "search", void 0);
$7b39ee3902cd67ef$export$90e27946f1ab834e = $7b39ee3902cd67ef$var$__decorate([
    (0, $ailZp.customElement)("w3m-wallet-send-select-token-view")
], $7b39ee3902cd67ef$export$90e27946f1ab834e);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $46f2e299575ad698$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-avatar,
  wui-image {
    display: ruby;
    width: 32px;
    height: 32px;
    border-radius: var(--wui-border-radius-3xl);
  }

  .sendButton {
    width: 70%;
    --local-width: 100% !important;
    --local-border-radius: var(--wui-border-radius-xs) !important;
  }

  .cancelButton {
    width: 30%;
    --local-width: 100% !important;
    --local-border-radius: var(--wui-border-radius-xs) !important;
  }
`;


parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("eNJDH");
var $jbD0z = parcelRequire("jbD0z");
var $6mRzS = parcelRequire("6mRzS");
var $3BhS7 = parcelRequire("3BhS7");
var $4622efce9fbe3c88$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4622efce9fbe3c88$export$3308935d6e923da1 = class W3mWalletSendPreviewView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.token = (0, $3BhS7.SendController).state.token;
        this.sendTokenAmount = (0, $3BhS7.SendController).state.sendTokenAmount;
        this.receiverAddress = (0, $3BhS7.SendController).state.receiverAddress;
        this.receiverProfileName = (0, $3BhS7.SendController).state.receiverProfileName;
        this.receiverProfileImageUrl = (0, $3BhS7.SendController).state.receiverProfileImageUrl;
        this.gasPriceInUSD = (0, $3BhS7.SendController).state.gasPriceInUSD;
        this.caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.unsubscribe.push(...[
            (0, $3BhS7.SendController).subscribe((val)=>{
                this.token = val.token;
                this.sendTokenAmount = val.sendTokenAmount;
                this.receiverAddress = val.receiverAddress;
                this.gasPriceInUSD = val.gasPriceInUSD;
                this.receiverProfileName = val.receiverProfileName;
                this.receiverProfileImageUrl = val.receiverProfileImageUrl;
            }),
            (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (val)=>this.caipNetwork = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)` <wui-flex flexDirection="column" .padding=${[
            "0",
            "l",
            "l",
            "l"
        ]}>
      <wui-flex gap="xs" flexDirection="column" .padding=${[
            "0",
            "xs",
            "0",
            "xs"
        ]}>
        <wui-flex alignItems="center" justifyContent="space-between">
          <wui-flex flexDirection="column" gap="4xs">
            <wui-text variant="small-400" color="fg-150">Send</wui-text>
            ${this.sendValueTemplate()}
          </wui-flex>
          <wui-preview-item
            text="${this.sendTokenAmount ? (0, $fIDM4.UiHelperUtil).roundNumber(this.sendTokenAmount, 6, 5) : "unknown"} ${this.token?.symbol}"
            .imageSrc=${this.token?.iconUrl}
          ></wui-preview-item>
        </wui-flex>
        <wui-flex>
          <wui-icon color="fg-200" size="md" name="arrowBottom"></wui-icon>
        </wui-flex>
        <wui-flex alignItems="center" justifyContent="space-between">
          <wui-text variant="small-400" color="fg-150">To</wui-text>
          <wui-preview-item
            text="${this.receiverProfileName ? (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.receiverProfileName,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.receiverAddress ? this.receiverAddress : "",
            charsStart: 4,
            charsEnd: 4,
            truncate: "middle"
        })}"
            address=${this.receiverAddress ?? ""}
            .imageSrc=${this.receiverProfileImageUrl ?? undefined}
            .isAddress=${true}
          ></wui-preview-item>
        </wui-flex>
      </wui-flex>
      <wui-flex flexDirection="column" .padding=${[
            "xxl",
            "0",
            "0",
            "0"
        ]}>
        <w3m-wallet-send-details
          .caipNetwork=${this.caipNetwork}
          .receiverAddress=${this.receiverAddress}
          .networkFee=${this.gasPriceInUSD}
        ></w3m-wallet-send-details>
        <wui-flex justifyContent="center" gap="xxs" .padding=${[
            "s",
            "0",
            "0",
            "0"
        ]}>
          <wui-icon size="sm" color="fg-200" name="warningCircle"></wui-icon>
          <wui-text variant="small-400" color="fg-200">Review transaction carefully</wui-text>
        </wui-flex>
        <wui-flex justifyContent="center" gap="s" .padding=${[
            "l",
            "0",
            "0",
            "0"
        ]}>
          <wui-button
            class="cancelButton"
            @click=${this.onCancelClick.bind(this)}
            size="lg"
            variant="neutral"
          >
            Cancel
          </wui-button>
          <wui-button
            class="sendButton"
            @click=${this.onSendClick.bind(this)}
            size="lg"
            variant="main"
          >
            Send
          </wui-button>
        </wui-flex>
      </wui-flex></wui-flex
    >`;
    }
    sendValueTemplate() {
        if (this.token && this.sendTokenAmount) {
            const price = this.token.price;
            const totalValue = price * this.sendTokenAmount;
            return (0, $aTf3K.html)`<wui-text variant="paragraph-400" color="fg-100"
        >$${totalValue.toFixed(2)}</wui-text
      >`;
        }
        return null;
    }
    onSendClick() {
        (0, $3BhS7.SendController).sendToken();
    }
    onCancelClick() {
        (0, $6mRzS.RouterController).goBack();
    }
};
$4622efce9fbe3c88$export$3308935d6e923da1.styles = (0, $46f2e299575ad698$export$2e2bcd8739ae039);
$4622efce9fbe3c88$var$__decorate([
    (0, $faUle.state)()
], $4622efce9fbe3c88$export$3308935d6e923da1.prototype, "token", void 0);
$4622efce9fbe3c88$var$__decorate([
    (0, $faUle.state)()
], $4622efce9fbe3c88$export$3308935d6e923da1.prototype, "sendTokenAmount", void 0);
$4622efce9fbe3c88$var$__decorate([
    (0, $faUle.state)()
], $4622efce9fbe3c88$export$3308935d6e923da1.prototype, "receiverAddress", void 0);
$4622efce9fbe3c88$var$__decorate([
    (0, $faUle.state)()
], $4622efce9fbe3c88$export$3308935d6e923da1.prototype, "receiverProfileName", void 0);
$4622efce9fbe3c88$var$__decorate([
    (0, $faUle.state)()
], $4622efce9fbe3c88$export$3308935d6e923da1.prototype, "receiverProfileImageUrl", void 0);
$4622efce9fbe3c88$var$__decorate([
    (0, $faUle.state)()
], $4622efce9fbe3c88$export$3308935d6e923da1.prototype, "gasPriceInUSD", void 0);
$4622efce9fbe3c88$var$__decorate([
    (0, $faUle.state)()
], $4622efce9fbe3c88$export$3308935d6e923da1.prototype, "caipNetwork", void 0);
$4622efce9fbe3c88$export$3308935d6e923da1 = $4622efce9fbe3c88$var$__decorate([
    (0, $ailZp.customElement)("w3m-wallet-send-preview-view")
], $4622efce9fbe3c88$export$3308935d6e923da1);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $2abcb13228fa97a9$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }
  wui-flex::-webkit-scrollbar {
    display: none;
  }
`;


var $7a3d4ffc65971d3e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7a3d4ffc65971d3e$export$68b068a6fe91a465 = class W3mConnectWalletsView extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        <w3m-wallet-login-list></w3m-wallet-login-list>
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
};
$7a3d4ffc65971d3e$export$68b068a6fe91a465.styles = (0, $2abcb13228fa97a9$export$2e2bcd8739ae039);
$7a3d4ffc65971d3e$export$68b068a6fe91a465 = $7a3d4ffc65971d3e$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-wallets-view")
], $7a3d4ffc65971d3e$export$68b068a6fe91a465);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $2432d33d638b5bcf$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }
  wui-flex::-webkit-scrollbar {
    display: none;
  }
`;


var $e352368825083e13$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e352368825083e13$export$fc46f8619085b31 = class W3mConnectSocialsView extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        <w3m-social-login-list></w3m-social-login-list>
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
};
$e352368825083e13$export$fc46f8619085b31.styles = (0, $2432d33d638b5bcf$export$2e2bcd8739ae039);
$e352368825083e13$export$fc46f8619085b31 = $e352368825083e13$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-socials-view")
], $e352368825083e13$export$fc46f8619085b31);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $d94Xg = parcelRequire("d94Xg");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
var $hdC6E = parcelRequire("hdC6E");
var $3Sg6l = parcelRequire("3Sg6l");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $cc2a5fee58526c99$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-logo {
    width: 80px;
    height: 80px;
    border-radius: var(--wui-border-radius-m);
  }
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }
  wui-flex:first-child:not(:only-child) {
    position: relative;
  }
  wui-loading-thumbnail {
    position: absolute;
  }
  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }
  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }
  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }
  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }
  .capitalize {
    text-transform: capitalize;
  }
`;



var $93d7ada934d47675$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $93d7ada934d47675$export$d35a2e38563913c4 = class W3mConnectingSocialView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.socialProvider = (0, $f7IXw.AccountController).state.socialProvider;
        this.socialWindow = (0, $f7IXw.AccountController).state.socialWindow;
        this.error = false;
        this.connecting = false;
        this.message = "Connect in the provider window";
        this.authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        this.handleSocialConnection = async (event)=>{
            if (event.data?.resultUri) {
                if (event.origin === (0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).SECURE_SITE_ORIGIN) {
                    window.removeEventListener("message", this.handleSocialConnection, false);
                    try {
                        if (this.authConnector && !this.connecting) {
                            if (this.socialWindow) {
                                this.socialWindow.close();
                                (0, $f7IXw.AccountController).setSocialWindow(undefined, (0, $d94Xg.ChainController).state.activeChain);
                            }
                            this.connecting = true;
                            this.updateMessage();
                            const uri = event.data.resultUri;
                            await this.authConnector.provider.connectSocial(uri);
                            if (this.socialProvider) {
                                (0, $hdC6E.StorageUtil).setConnectedSocialProvider(this.socialProvider);
                                await (0, $hlVrM.ConnectionController).connectExternal(this.authConnector, this.authConnector.chain);
                                (0, $6m17w.EventsController).sendEvent({
                                    type: "track",
                                    event: "SOCIAL_LOGIN_SUCCESS",
                                    properties: {
                                        provider: this.socialProvider
                                    }
                                });
                            }
                        }
                    } catch (error) {
                        this.error = true;
                        this.updateMessage();
                        if (this.socialProvider) (0, $6m17w.EventsController).sendEvent({
                            type: "track",
                            event: "SOCIAL_LOGIN_ERROR",
                            properties: {
                                provider: this.socialProvider
                            }
                        });
                    }
                } else {
                    (0, $6mRzS.RouterController).goBack();
                    (0, $br7WV.SnackController).showError("Untrusted Origin");
                    if (this.socialProvider) (0, $6m17w.EventsController).sendEvent({
                        type: "track",
                        event: "SOCIAL_LOGIN_ERROR",
                        properties: {
                            provider: this.socialProvider
                        }
                    });
                }
            }
        };
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribe((val)=>{
                if (val.socialProvider) this.socialProvider = val.socialProvider;
                if (val.socialWindow) this.socialWindow = val.socialWindow;
                if (val.address) {
                    if ((0, $ib7WC.ModalController).state.open) (0, $ib7WC.ModalController).close();
                }
            })
        ]);
        if (this.authConnector) this.connectSocial();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        window.removeEventListener("message", this.handleSocialConnection, false);
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        data-error=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.error)}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-logo logo=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.socialProvider)}></wui-logo>
          ${this.error ? null : this.loaderTemplate()}
          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100"
            >Log in with
            <span class="capitalize">${this.socialProvider ?? "Social"}</span></wui-text
          >
          <wui-text align="center" variant="small-400" color=${this.error ? "error-100" : "fg-200"}
            >${this.message}</wui-text
          ></wui-flex
        >
      </wui-flex>
    `;
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $3Sg6l.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $aTf3K.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    connectSocial() {
        const interval = setInterval(()=>{
            if (this.socialWindow?.closed) {
                if (!this.connecting && (0, $6mRzS.RouterController).state.view === "ConnectingSocial") (0, $6mRzS.RouterController).goBack();
                clearInterval(interval);
            }
        }, 1000);
        window.addEventListener("message", this.handleSocialConnection, false);
    }
    updateMessage() {
        if (this.error) this.message = "Something went wrong";
        else if (this.connecting) this.message = "Retrieving user data";
        else this.message = "Connect in the provider window";
    }
};
$93d7ada934d47675$export$d35a2e38563913c4.styles = (0, $cc2a5fee58526c99$export$2e2bcd8739ae039);
$93d7ada934d47675$var$__decorate([
    (0, $faUle.state)()
], $93d7ada934d47675$export$d35a2e38563913c4.prototype, "socialProvider", void 0);
$93d7ada934d47675$var$__decorate([
    (0, $faUle.state)()
], $93d7ada934d47675$export$d35a2e38563913c4.prototype, "socialWindow", void 0);
$93d7ada934d47675$var$__decorate([
    (0, $faUle.state)()
], $93d7ada934d47675$export$d35a2e38563913c4.prototype, "error", void 0);
$93d7ada934d47675$var$__decorate([
    (0, $faUle.state)()
], $93d7ada934d47675$export$d35a2e38563913c4.prototype, "connecting", void 0);
$93d7ada934d47675$var$__decorate([
    (0, $faUle.state)()
], $93d7ada934d47675$export$d35a2e38563913c4.prototype, "message", void 0);
$93d7ada934d47675$export$d35a2e38563913c4 = $93d7ada934d47675$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-social-view")
], $93d7ada934d47675$export$d35a2e38563913c4);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $d94Xg = parcelRequire("d94Xg");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $ib7WC = parcelRequire("ib7WC");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $2c2e8325926576ef$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex {
    width: 100%;
  }

  wui-icon-link {
    margin-right: calc(var(--wui-icon-box-size-md) * -1);
  }

  .account-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .account-links wui-flex {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: red;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 10px;
    flex: 1 0 0;

    border-radius: var(--XS, 16px);
    border: 1px solid var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    background: var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: background-color;
  }

  .account-links wui-flex:hover {
    background: var(--dark-accent-glass-015, rgba(71, 161, 255, 0.15));
  }

  .account-links wui-flex wui-icon {
    width: var(--S, 20px);
    height: var(--S, 20px);
  }

  .account-links wui-flex wui-icon svg path {
    stroke: #47a1ff;
  }

  .account-settings-button {
    padding: calc(var(--wui-spacing-m) - 1px) var(--wui-spacing-2l);
    height: 40px;
    border-radius: var(--wui-border-radius-xxs);
    border: 1px solid var(--wui-color-gray-glass-002);
    background: var(--wui-color-gray-glass-002);
    cursor: pointer;
  }

  .account-settings-button:hover {
    background: var(--wui-color-gray-glass-005);
  }
`;


var $7781cdb34b1e36ce$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7781cdb34b1e36ce$export$dd89179375aa519e = class W3mProfileView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.usubscribe = [];
        this.address = (0, $f7IXw.AccountController).state.address;
        this.profileImage = (0, $f7IXw.AccountController).state.profileImage;
        this.profileName = (0, $f7IXw.AccountController).state.profileName;
        this.accounts = (0, $f7IXw.AccountController).state.allAccounts;
        this.usubscribe.push((0, $f7IXw.AccountController).subscribeKey("address", (address)=>{
            if (address) this.address = address;
            else (0, $ib7WC.ModalController).close();
        }));
        this.usubscribe.push((0, $f7IXw.AccountController).subscribeKey("profileImage", (profileImage)=>{
            this.profileImage = profileImage;
        }));
        this.usubscribe.push((0, $f7IXw.AccountController).subscribeKey("profileName", (profileName)=>{
            this.profileName = profileName;
        }));
    }
    disconnectedCallback() {
        this.usubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-profile-view: No account provided");
        const name = this.profileName?.split(".")[0];
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="l" .padding=${[
            "0",
            "xl",
            "m",
            "xl"
        ]}>
        <wui-flex flexDirection="column" alignItems="center" gap="l">
          <wui-avatar
            alt=${this.address}
            address=${this.address}
            imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.profileImage)}
            size="2lg"
          ></wui-avatar>
          <wui-flex flexDirection="column" alignItems="center">
            <wui-flex gap="3xs" alignItems="center" justifyContent="center">
              <wui-text variant="title-6-600" color="fg-100" data-testid="account-settings-address">
                ${name ? (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: name,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: 4,
            charsEnd: 6,
            truncate: "middle"
        })}
              </wui-text>
              <wui-icon-link
                size="md"
                icon="copy"
                iconColor="fg-200"
                @click=${this.onCopyAddress}
              ></wui-icon-link>
            </wui-flex>
          </wui-flex>
        </wui-flex>
        <wui-flex
          data-testid="account-settings-button"
          justifyContent="center"
          alignItems="center"
          class="account-settings-button"
          @click=${()=>(0, $6mRzS.RouterController).push("AccountSettings")}
        >
          <wui-text variant="paragraph-500" color="fg-100">Account Settings</wui-text>
        </wui-flex>
        ${this.accountsTemplate()}
      </wui-flex>
    `;
    }
    accountsTemplate() {
        return (0, $aTf3K.html)`<wui-flex flexDirection="column">
      <wui-flex .padding=${[
            "3xs",
            "m",
            "s",
            "s"
        ]}>
        <wui-text color="fg-200" variant="paragraph-400">Your accounts</wui-text>
      </wui-flex>
      <wui-flex flexDirection="column" gap="xxs">
        ${this.accounts.map((account)=>this.accountTemplate(account))}
      </wui-flex>
    </wui-flex>`;
    }
    async onSwitchAccount(account) {
        (0, $f7IXw.AccountController).setShouldUpdateToAddress(account.address, (0, $d94Xg.ChainController).state.activeChain);
        const emailConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (!emailConnector) return;
        await emailConnector.provider.setPreferredAccount(account.type);
        await emailConnector.provider.connect();
    }
    accountTemplate(account) {
        return (0, $aTf3K.html)`<wui-list-account accountAddress=${account.address} accountType=${account.type}>
      ${account.address === this.address ? "" : (0, $aTf3K.html)`<wui-button
            slot="action"
            textVariant="small-600"
            size="sm"
            variant="accent"
            @click=${()=>this.onSwitchAccount(account)}
            >Switch</wui-button
          >`}
    </wui-list-account>`;
    }
    onCopyAddress() {
        try {
            if (this.profileName) {
                (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.profileName);
                (0, $br7WV.SnackController).showSuccess("Name copied");
            } else if (this.address) {
                (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.address);
                (0, $br7WV.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $br7WV.SnackController).showError("Failed to copy");
        }
    }
};
$7781cdb34b1e36ce$export$dd89179375aa519e.styles = (0, $2c2e8325926576ef$export$2e2bcd8739ae039);
$7781cdb34b1e36ce$var$__decorate([
    (0, $faUle.state)()
], $7781cdb34b1e36ce$export$dd89179375aa519e.prototype, "address", void 0);
$7781cdb34b1e36ce$var$__decorate([
    (0, $faUle.state)()
], $7781cdb34b1e36ce$export$dd89179375aa519e.prototype, "profileImage", void 0);
$7781cdb34b1e36ce$var$__decorate([
    (0, $faUle.state)()
], $7781cdb34b1e36ce$export$dd89179375aa519e.prototype, "profileName", void 0);
$7781cdb34b1e36ce$var$__decorate([
    (0, $faUle.state)()
], $7781cdb34b1e36ce$export$dd89179375aa519e.prototype, "accounts", void 0);
$7781cdb34b1e36ce$export$dd89179375aa519e = $7781cdb34b1e36ce$var$__decorate([
    (0, $ailZp.customElement)("w3m-profile-view")
], $7781cdb34b1e36ce$export$dd89179375aa519e);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $d94Xg = parcelRequire("d94Xg");
var $hlVrM = parcelRequire("hlVrM");
var $ib7WC = parcelRequire("ib7WC");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $8d160daccc3b4b36$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  input[type='checkbox'] {
    all: revert;
    width: var(--wui-spacing-xl);
    height: var(--wui-spacing-xl);
    accent-color: var(--wui-color-accent-100);
  }
`;


var $9b1acf57a367798e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9b1acf57a367798e$export$61dfe1ba29fc5d9d = class W3mSelectAddressesView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.metadata = (0, $8BVTM.OptionsController).state.metadata;
        this.allAccounts = (0, $f7IXw.AccountController).state.allAccounts;
        this.selectedAccounts = (0, $f7IXw.AccountController).state.allAccounts;
        this.selectAll = true;
        this.approved = false;
        this.isApproving = false;
        this.getAddressTemplate = (account)=>{
            const checked = this.selectedAccounts.some((_account)=>_account.address === account.address);
            return (0, $aTf3K.html)`<wui-list-account accountAddress="${account.address}" accountType="${account.type}">
      <input
        id="${account.address}"
        slot="action"
        type="checkbox"
        .checked="${checked}"
        @change="${this.handleClick(account)}"
      />
    </wui-list-account>`;
        };
        this.onSelectAll = (event)=>{
            const checked = event.target.checked;
            this.selectAll = this.selectedAccounts.length === this.allAccounts.length;
            this.allAccounts.forEach((account)=>{
                this.onSelect(account, checked);
            });
        };
        this.onSelect = (account, add)=>{
            if (add) this.selectedAccounts.push(account);
            else this.selectedAccounts = this.selectedAccounts.filter((a)=>a.address !== account.address);
            if (this.selectedAccounts.length > 0) this.selectAll = this.selectedAccounts.length === this.allAccounts.length;
        };
        (0, $f7IXw.AccountController).subscribeKey("allAccounts", (allAccounts)=>{
            this.allAccounts = allAccounts;
        });
    }
    render() {
        return (0, $aTf3K.html)`
    <wui-flex justifyContent="center" .padding=${[
            "xl",
            "0",
            "xl",
            "0"
        ]}>
      <wui-banner-img imageSrc="${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.metadata?.icons[0])}" text="${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.metadata?.url)}" size="sm"></wui-banner>
    </wui-flex>
    <wui-flex .padding=${[
            "0",
            "xl",
            "0",
            "xl"
        ]} flexDirection="row" justifyContent="space-between">
        <wui-text variant="paragraph-400" color="fg-200">Select all</wui-text>
        <input type="checkbox" .checked=${this.selectAll}  @click=${this.onSelectAll.bind(this)} />
    </wui-flex>
      <wui-flex flexDirection="column" .padding=${[
            "l",
            "xl",
            "xl",
            "xl"
        ]}>
        ${this.allAccounts.map((account)=>this.getAddressTemplate(account))}
      </wui-flex>
      <wui-flex .padding=${[
            "l",
            "xl",
            "xl",
            "xl"
        ]} gap="s" justifyContent="space-between">
        <wui-button
          size="md"
          ?fullwidth=${true}
          variant="neutral"
          @click=${this.onCancel.bind(this)}
          data-testid="w3m-connecting-siwe-cancel"
        >
          Cancel
        </wui-button>
        <wui-button
          size="md"
          ?fullwidth=${true}
          variant="main"
          .disabled=${this.selectedAccounts.length === 0}
          @click=${this.onContinue.bind(this)}
          ?loading=${this.isApproving}
        >
          ${this.isApproving ? "Signing..." : "Continue"}
        </wui-button>
      </wui-flex>
    `;
    }
    handleClick(account) {
        return (event)=>{
            const target = event.target;
            this.onSelect?.({
                ...account
            }, target?.checked);
        };
    }
    onContinue() {
        if (this.selectedAccounts.length > 0) {
            this.isApproving = true;
            (0, $f7IXw.AccountController).setAllAccounts(this.selectedAccounts, (0, $d94Xg.ChainController).state.activeChain);
            (0, $f7IXw.AccountController).setShouldUpdateToAddress(this.selectedAccounts[0]?.address ?? "", (0, $d94Xg.ChainController).state.activeChain);
            this.approved = true;
            this.isApproving = false;
            (0, $ib7WC.ModalController).close();
        } else this.onCancel();
    }
    async onCancel() {
        const { isConnected: isConnected } = (0, $f7IXw.AccountController).state;
        if (isConnected) {
            await (0, $hlVrM.ConnectionController).disconnect();
            (0, $ib7WC.ModalController).close();
        } else (0, $6mRzS.RouterController).push("Connect");
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (!this.approved) this.onCancel();
    }
};
$9b1acf57a367798e$export$61dfe1ba29fc5d9d.styles = (0, $8d160daccc3b4b36$export$2e2bcd8739ae039);
$9b1acf57a367798e$var$__decorate([
    (0, $faUle.state)()
], $9b1acf57a367798e$export$61dfe1ba29fc5d9d.prototype, "allAccounts", void 0);
$9b1acf57a367798e$var$__decorate([
    (0, $faUle.state)()
], $9b1acf57a367798e$export$61dfe1ba29fc5d9d.prototype, "selectedAccounts", void 0);
$9b1acf57a367798e$var$__decorate([
    (0, $faUle.state)()
], $9b1acf57a367798e$export$61dfe1ba29fc5d9d.prototype, "selectAll", void 0);
$9b1acf57a367798e$var$__decorate([
    (0, $faUle.state)()
], $9b1acf57a367798e$export$61dfe1ba29fc5d9d.prototype, "approved", void 0);
$9b1acf57a367798e$var$__decorate([
    (0, $faUle.state)()
], $9b1acf57a367798e$export$61dfe1ba29fc5d9d.prototype, "isApproving", void 0);
$9b1acf57a367798e$export$61dfe1ba29fc5d9d = $9b1acf57a367798e$var$__decorate([
    (0, $ailZp.customElement)("w3m-select-addresses-view")
], $9b1acf57a367798e$export$61dfe1ba29fc5d9d);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $hxXs8 = parcelRequire("hxXs8");
var $d94Xg = parcelRequire("d94Xg");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
var $8BVTM = parcelRequire("8BVTM");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $5165af4a1a24e026$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-avatar {
    width: var(--wui-spacing-3xl);
    height: var(--wui-spacing-3xl);
    box-shadow: 0 0 0 0;
  }

  wui-icon-box {
    position: relative;
    right: 15px;
    top: 15px;
    border: 2px solid var(--wui-color-bg-150);
    background-color: var(--wui-color-bg-125);
  }
`;



var $1bbd75bedff96caf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1bbd75bedff96caf$export$7ff6a3b4aced362e = class W3mSwitchAddressView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.metadata = (0, $8BVTM.OptionsController).state.metadata;
        this.allAccounts = (0, $f7IXw.AccountController).state.allAccounts || [];
        this.balances = {};
        this.labels = (0, $f7IXw.AccountController).state.addressLabels;
        this.currentAddress = (0, $f7IXw.AccountController).state.address || "";
        this.connectedConnector = (0, $hdC6E.StorageUtil).getConnectedConnector();
        this.shouldShowIcon = this.connectedConnector === "AUTH";
        this.caipNetwork = (0, $jbD0z.NetworkController).state.caipNetwork;
        (0, $f7IXw.AccountController).subscribeKey("allAccounts", (allAccounts)=>{
            this.allAccounts = allAccounts;
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.allAccounts.forEach((account)=>{
            (0, $hxXs8.BlockchainApiController).getBalance(account.address, this.caipNetwork?.id).then((response)=>{
                let total = this.balances[account.address] || 0;
                if (response.balances.length > 0) total = response.balances.reduce((acc, balance)=>acc + (balance?.value || 0), 0);
                this.balances[account.address] = total;
                this.requestUpdate();
            });
        });
    }
    getAddressIcon(type) {
        if (type === "smartAccount") return "lightbulb";
        return "mail";
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex justifyContent="center" .padding=${[
            "xl",
            "0",
            "xl",
            "0"
        ]}>
        <wui-banner-img
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.metadata?.icons[0])}
          text=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.metadata?.url)}
          size="sm"
        ></wui-banner-img>
      </wui-flex>
      <wui-flex flexDirection="column" gap="xxl" .padding=${[
            "l",
            "xl",
            "xl",
            "xl"
        ]}>
        ${this.allAccounts.map((account, index)=>this.getAddressTemplate(account, index))}
      </wui-flex>
    `;
    }
    getAddressTemplate(account, index) {
        const label = this.labels?.get(account.address);
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="row"
        justifyContent="space-between"
        data-testid="switch-address-item"
      >
        <wui-flex alignItems="center">
          <wui-avatar address=${account.address}></wui-avatar>
          ${this.shouldShowIcon ? (0, $aTf3K.html)`<wui-icon-box
                size="sm"
                iconcolor="fg-200"
                backgroundcolor="glass-002"
                background="gray"
                icon="${this.getAddressIcon(account.type)}"
                ?border=${true}
              ></wui-icon-box>` : (0, $aTf3K.html)`<wui-flex .padding="${[
            "0",
            "0",
            "0",
            "s"
        ]}"></wui-flex>`}
          <wui-flex flexDirection="column">
            <wui-text class="address" variant="paragraph-500" color="fg-100"
              >${label ? label : (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: account.address,
            charsStart: 4,
            charsEnd: 6,
            truncate: "middle"
        })}</wui-text
            >
            <wui-text class="address-description" variant="small-400">
              ${typeof this.balances[account.address] === "number" ? `$${this.balances[account.address]?.toFixed(2)}` : (0, $aTf3K.html)`<wui-loading-spinner size="sm" color="accent-100"></wui-loading-spinner>`}
            </wui-text>
          </wui-flex>
        </wui-flex>
        <wui-flex gap="s" alignItems="center">
          ${account.address?.toLowerCase() === this.currentAddress?.toLowerCase() ? "" : (0, $aTf3K.html)`
                <wui-button
                  data-testid=${`w3m-switch-address-button-${index}`}
                  textVariant="small-600"
                  size="md"
                  variant="accent"
                  @click=${()=>this.onSwitchAddress(account.address)}
                  >Switch to</wui-button
                >
              `}
        </wui-flex>
      </wui-flex>
    `;
    }
    onSwitchAddress(address) {
        (0, $f7IXw.AccountController).setShouldUpdateToAddress(address, (0, $d94Xg.ChainController).state.activeChain);
        (0, $ib7WC.ModalController).close();
    }
};
$1bbd75bedff96caf$export$7ff6a3b4aced362e.styles = (0, $5165af4a1a24e026$export$2e2bcd8739ae039);
$1bbd75bedff96caf$var$__decorate([
    (0, $faUle.state)()
], $1bbd75bedff96caf$export$7ff6a3b4aced362e.prototype, "allAccounts", void 0);
$1bbd75bedff96caf$var$__decorate([
    (0, $faUle.state)()
], $1bbd75bedff96caf$export$7ff6a3b4aced362e.prototype, "balances", void 0);
$1bbd75bedff96caf$export$7ff6a3b4aced362e = $1bbd75bedff96caf$var$__decorate([
    (0, $ailZp.customElement)("w3m-switch-address-view")
], $1bbd75bedff96caf$export$7ff6a3b4aced362e);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $ib7WC = parcelRequire("ib7WC");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
var $hdC6E = parcelRequire("hdC6E");
var $3Sg6l = parcelRequire("3Sg6l");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $fb554e140cb5105d$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  wui-shimmer {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px) !important;
  }

  wui-qr-code {
    opacity: 0;
    animation-duration: 200ms;
    animation-timing-function: ease;
    animation-name: fadein;
    animation-fill-mode: forwards;
  }

  wui-logo {
    width: 80px;
    height: 80px;
    border-radius: var(--wui-border-radius-m);
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }
  wui-loading-thumbnail {
    position: absolute;
  }
  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }
`;


var $9b836164586f27bc$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9b836164586f27bc$export$cf5e35f91724cbaf = class W3mConnectingFarcasterView extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.timeout = undefined;
        this.socialProvider = (0, $f7IXw.AccountController).state.socialProvider;
        this.uri = (0, $f7IXw.AccountController).state.farcasterUrl;
        this.ready = false;
        this.loading = false;
        this.authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        this.forceUpdate = ()=>{
            this.requestUpdate();
        };
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribeKey("farcasterUrl", (val)=>{
                if (val) {
                    this.uri = val;
                    this.connectFarcaster();
                }
            }),
            (0, $f7IXw.AccountController).subscribeKey("socialProvider", (val)=>{
                if (val) this.socialProvider = val;
            })
        ]);
        window.addEventListener("resize", this.forceUpdate);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        clearTimeout(this.timeout);
        window.removeEventListener("resize", this.forceUpdate);
    }
    render() {
        this.onRenderProxy();
        return (0, $aTf3K.html)`${this.platformTemplate()}`;
    }
    platformTemplate() {
        if ((0, $c4rfq.CoreHelperUtil).isMobile()) return (0, $aTf3K.html)`${this.mobileTemplate()}`;
        return (0, $aTf3K.html)`${this.desktopTemplate()}`;
    }
    desktopTemplate() {
        if (this.loading) return (0, $aTf3K.html)`${this.loadingTemplate()}`;
        return (0, $aTf3K.html)`${this.qrTemplate()}`;
    }
    qrTemplate() {
        return (0, $aTf3K.html)` <wui-flex
      flexDirection="column"
      alignItems="center"
      .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]}
      gap="xl"
    >
      <wui-shimmer borderRadius="l" width="100%"> ${this.qrCodeTemplate()} </wui-shimmer>

      <wui-text variant="paragraph-500" color="fg-100">
        Scan this QR Code with your phone
      </wui-text>
      ${this.copyTemplate()}
    </wui-flex>`;
    }
    loadingTemplate() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-logo logo="farcaster"></wui-logo>
          ${this.loaderTemplate()}
          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100">
            Loading user data
          </wui-text>
          <wui-text align="center" variant="small-400" color="fg-200">
            Please wait a moment while we load your data.
          </wui-text>
        </wui-flex>
      </wui-flex>
    `;
    }
    mobileTemplate() {
        return (0, $aTf3K.html)` <wui-flex
      flexDirection="column"
      alignItems="center"
      .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
      gap="xl"
    >
      <wui-flex justifyContent="center" alignItems="center">
        <wui-logo logo="farcaster"></wui-logo>
        ${this.loaderTemplate()}
        <wui-icon-box
          backgroundColor="error-100"
          background="opaque"
          iconColor="error-100"
          icon="close"
          size="sm"
          border
          borderColor="wui-color-bg-125"
        ></wui-icon-box>
      </wui-flex>
      <wui-flex flexDirection="column" alignItems="center" gap="xs">
        <wui-text align="center" variant="paragraph-500" color="fg-100"
          >Continue in Farcaster</span></wui-text
        >
        <wui-text align="center" variant="small-400" color="fg-200"
          >Accept connection request in the app</wui-text
        ></wui-flex
      >
      ${this.mobileLinkTemplate()}
    </wui-flex>`;
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $3Sg6l.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $aTf3K.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    async connectFarcaster() {
        if (this.authConnector) try {
            await this.authConnector?.provider.connectFarcaster();
            if (this.socialProvider) (0, $hdC6E.StorageUtil).setConnectedSocialProvider(this.socialProvider);
            this.loading = true;
            await (0, $hlVrM.ConnectionController).connectExternal(this.authConnector, this.authConnector.chain);
            this.loading = false;
            (0, $ib7WC.ModalController).close();
        } catch (error) {
            (0, $6mRzS.RouterController).goBack();
            (0, $br7WV.SnackController).showError(error);
        }
    }
    mobileLinkTemplate() {
        return (0, $aTf3K.html)`<wui-button
      size="md"
      ?loading=${this.loading}
      ?disabled=${!this.uri || this.loading}
      @click=${()=>{
            if (this.uri) (0, $c4rfq.CoreHelperUtil).openHref(this.uri, "_blank");
        }}
    >
      Open farcaster</wui-button
    >`;
    }
    onRenderProxy() {
        if (!this.ready && this.uri) this.timeout = setTimeout(()=>{
            this.ready = true;
        }, 0);
    }
    qrCodeTemplate() {
        if (!this.uri || !this.ready) return null;
        const size = this.getBoundingClientRect().width - 40;
        return (0, $aTf3K.html)` <wui-qr-code
      size=${size}
      theme=${(0, $3Sg6l.ThemeController).state.themeMode}
      uri=${this.uri}
      ?farcaster=${true}
      data-testid="wui-qr-code"
    ></wui-qr-code>`;
    }
    copyTemplate() {
        const inactive = !this.uri || !this.ready;
        return (0, $aTf3K.html)`<wui-link
      .disabled=${inactive}
      @click=${this.onCopyUri}
      color="fg-200"
      data-testid="copy-wc2-uri"
    >
      <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
      Copy link
    </wui-link>`;
    }
    onCopyUri() {
        try {
            if (this.uri) {
                (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.uri);
                (0, $br7WV.SnackController).showSuccess("Link copied");
            }
        } catch  {
            (0, $br7WV.SnackController).showError("Failed to copy");
        }
    }
};
$9b836164586f27bc$export$cf5e35f91724cbaf.styles = (0, $fb554e140cb5105d$export$2e2bcd8739ae039);
$9b836164586f27bc$var$__decorate([
    (0, $faUle.state)()
], $9b836164586f27bc$export$cf5e35f91724cbaf.prototype, "socialProvider", void 0);
$9b836164586f27bc$var$__decorate([
    (0, $faUle.state)()
], $9b836164586f27bc$export$cf5e35f91724cbaf.prototype, "uri", void 0);
$9b836164586f27bc$var$__decorate([
    (0, $faUle.state)()
], $9b836164586f27bc$export$cf5e35f91724cbaf.prototype, "ready", void 0);
$9b836164586f27bc$var$__decorate([
    (0, $faUle.state)()
], $9b836164586f27bc$export$cf5e35f91724cbaf.prototype, "loading", void 0);
$9b836164586f27bc$export$cf5e35f91724cbaf = $9b836164586f27bc$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-farcaster-view")
], $9b836164586f27bc$export$cf5e35f91724cbaf);


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $7Xn6F = parcelRequire("7Xn6F");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $8b60cd2d4be50832$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-grid {
    max-height: clamp(360px, 400px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
    grid-template-columns: repeat(auto-fill, 76px);
  }

  @media (max-width: 435px) {
    wui-grid {
      grid-template-columns: repeat(auto-fill, 77px);
    }
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    justify-content: center;
    grid-column: 1 / span 4;
  }
`;


parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
function $ea10a820172f8592$export$cffc81df24a1f1f1(wallets) {
    const { connectors: connectors } = (0, $7Xn6F.ConnectorController).state;
    const installedConnectors = connectors.filter((c)=>c.type === "ANNOUNCED").reduce((acum, val)=>{
        if (!val.info?.rdns) return acum;
        acum[val.info.rdns] = true;
        return acum;
    }, {});
    const walletsWithInstalled = wallets.map((wallet)=>({
            ...wallet,
            installed: Boolean(wallet.rdns) && Boolean(installedConnectors[wallet.rdns ?? ""])
        }));
    const sortedWallets = walletsWithInstalled.sort((a, b)=>Number(b.installed) - Number(a.installed));
    return sortedWallets;
}


var $484a20aa186d2b71$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $484a20aa186d2b71$var$PAGINATOR_ID = "local-paginator";
let $484a20aa186d2b71$export$f39175f9037ce7d2 = class W3mAllWalletsList extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.paginationObserver = undefined;
        this.initial = !(0, $g4s8N.ApiController).state.wallets.length;
        this.wallets = (0, $g4s8N.ApiController).state.wallets;
        this.recommended = (0, $g4s8N.ApiController).state.recommended;
        this.featured = (0, $g4s8N.ApiController).state.featured;
        this.unsubscribe.push(...[
            (0, $g4s8N.ApiController).subscribeKey("wallets", (val)=>this.wallets = val),
            (0, $g4s8N.ApiController).subscribeKey("recommended", (val)=>this.recommended = val),
            (0, $g4s8N.ApiController).subscribeKey("featured", (val)=>this.featured = val)
        ]);
    }
    firstUpdated() {
        this.initialFetch();
        this.createPaginationObserver();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.paginationObserver?.disconnect();
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-grid
        data-scroll=${!this.initial}
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        columnGap="xxs"
        rowGap="l"
        justifyContent="space-between"
      >
        ${this.initial ? this.shimmerTemplate(16) : this.walletsTemplate()}
        ${this.paginationLoaderTemplate()}
      </wui-grid>
    `;
    }
    async initialFetch() {
        const gridEl = this.shadowRoot?.querySelector("wui-grid");
        if (this.initial && gridEl) {
            await (0, $g4s8N.ApiController).fetchWallets({
                page: 1
            });
            await gridEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.initial = false;
            gridEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    shimmerTemplate(items, id) {
        return [
            ...Array(items)
        ].map(()=>(0, $aTf3K.html)`
        <wui-card-select-loader type="wallet" id=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(id)}></wui-card-select-loader>
      `);
    }
    walletsTemplate() {
        const wallets = [
            ...this.featured,
            ...this.recommended,
            ...this.wallets
        ];
        const walletsWithInstalled = (0, $ea10a820172f8592$export$cffc81df24a1f1f1)(wallets);
        return walletsWithInstalled.map((wallet)=>(0, $aTf3K.html)`
        <w3m-all-wallets-list-item
          @click=${()=>this.onConnectWallet(wallet)}
          .wallet=${wallet}
        ></w3m-all-wallets-list-item>
      `);
    }
    paginationLoaderTemplate() {
        const { wallets: wallets, recommended: recommended, featured: featured, count: count } = (0, $g4s8N.ApiController).state;
        const columns = window.innerWidth < 352 ? 3 : 4;
        const currentWallets = wallets.length + recommended.length;
        const minimumRows = Math.ceil(currentWallets / columns);
        let shimmerCount = minimumRows * columns - currentWallets + columns;
        shimmerCount -= wallets.length ? featured.length % columns : 0;
        if (count === 0 && featured.length > 0) return null;
        if (count === 0 || [
            ...featured,
            ...wallets,
            ...recommended
        ].length < count) return this.shimmerTemplate(shimmerCount, $484a20aa186d2b71$var$PAGINATOR_ID);
        return null;
    }
    createPaginationObserver() {
        const loaderEl = this.shadowRoot?.querySelector(`#${$484a20aa186d2b71$var$PAGINATOR_ID}`);
        if (loaderEl) {
            this.paginationObserver = new IntersectionObserver(([element])=>{
                if (element?.isIntersecting && !this.initial) {
                    const { page: page, count: count, wallets: wallets } = (0, $g4s8N.ApiController).state;
                    if (wallets.length < count) (0, $g4s8N.ApiController).fetchWallets({
                        page: page + 1
                    });
                }
            });
            this.paginationObserver.observe(loaderEl);
        }
    }
    onConnectWallet(wallet) {
        const connector = (0, $7Xn6F.ConnectorController).getConnector(wallet.id, wallet.rdns);
        if (connector) (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $6mRzS.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$484a20aa186d2b71$export$f39175f9037ce7d2.styles = (0, $8b60cd2d4be50832$export$2e2bcd8739ae039);
$484a20aa186d2b71$var$__decorate([
    (0, $faUle.state)()
], $484a20aa186d2b71$export$f39175f9037ce7d2.prototype, "initial", void 0);
$484a20aa186d2b71$var$__decorate([
    (0, $faUle.state)()
], $484a20aa186d2b71$export$f39175f9037ce7d2.prototype, "wallets", void 0);
$484a20aa186d2b71$var$__decorate([
    (0, $faUle.state)()
], $484a20aa186d2b71$export$f39175f9037ce7d2.prototype, "recommended", void 0);
$484a20aa186d2b71$var$__decorate([
    (0, $faUle.state)()
], $484a20aa186d2b71$export$f39175f9037ce7d2.prototype, "featured", void 0);
$484a20aa186d2b71$export$f39175f9037ce7d2 = $484a20aa186d2b71$var$__decorate([
    (0, $ailZp.customElement)("w3m-all-wallets-list")
], $484a20aa186d2b71$export$f39175f9037ce7d2);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");

parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $62825949e1099514$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) var(--wui-spacing-0);
    background-color: var(--wui-color-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
    will-change: background-color, color;
    outline: none;
    border: none;
  }

  button > wui-text {
    color: var(--wui-color-fg-100);
    max-width: var(--wui-icon-box-size-xl);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: center;
  }

  button:hover:enabled {
    background-color: var(--wui-color-gray-glass-005);
  }

  button:disabled > wui-text {
    color: var(--wui-color-gray-glass-015);
  }

  [data-selected='true'] {
    background-color: var(--wui-color-accent-glass-020);
  }

  @media (hover: hover) and (pointer: fine) {
    [data-selected='true']:hover:enabled {
      background-color: var(--wui-color-accent-glass-015);
    }
  }

  [data-selected='true']:active:enabled {
    background-color: var(--wui-color-accent-glass-010);
  }
`;


var $ca6cae054193b243$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ca6cae054193b243$export$77cea17ccfc04f35 = class W3mAllWalletsListItem extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.observer = new IntersectionObserver(()=>undefined);
        this.visible = false;
        this.imageSrc = undefined;
        this.imageLoading = false;
        this.wallet = undefined;
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    this.visible = true;
                    this.fetchImageSrc();
                } else this.visible = false;
            });
        }, {
            threshold: 0.01
        });
    }
    firstUpdated() {
        this.observer.observe(this);
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    render() {
        return (0, $aTf3K.html)`
      <button ontouchstart>
        ${this.imageTemplate()}
        <wui-text variant="tiny-500" color="inherit">${this.wallet?.name}</wui-text>
      </button>
    `;
    }
    imageTemplate() {
        if (!this.visible && !this.imageSrc || this.imageLoading) return this.shimmerTemplate();
        return (0, $aTf3K.html)`
      <wui-wallet-image
        size="md"
        imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.imageSrc)}
        name=${this.wallet?.name}
        .installed=${this.wallet?.installed}
        badgeSize="sm"
      >
      </wui-wallet-image>
    `;
    }
    shimmerTemplate() {
        return (0, $aTf3K.html)`<wui-shimmer width="56px" height="56px" borderRadius="xs"></wui-shimmer>`;
    }
    async fetchImageSrc() {
        if (!this.wallet) return;
        this.imageSrc = (0, $eOULk.AssetUtil).getWalletImage(this.wallet);
        if (this.imageSrc) return;
        this.imageLoading = true;
        this.imageSrc = await (0, $eOULk.AssetUtil).fetchWalletImage(this.wallet.image_id);
        this.imageLoading = false;
    }
};
$ca6cae054193b243$export$77cea17ccfc04f35.styles = (0, $62825949e1099514$export$2e2bcd8739ae039);
$ca6cae054193b243$var$__decorate([
    (0, $faUle.state)()
], $ca6cae054193b243$export$77cea17ccfc04f35.prototype, "visible", void 0);
$ca6cae054193b243$var$__decorate([
    (0, $faUle.state)()
], $ca6cae054193b243$export$77cea17ccfc04f35.prototype, "imageSrc", void 0);
$ca6cae054193b243$var$__decorate([
    (0, $faUle.state)()
], $ca6cae054193b243$export$77cea17ccfc04f35.prototype, "imageLoading", void 0);
$ca6cae054193b243$var$__decorate([
    (0, $jJP2r.property)()
], $ca6cae054193b243$export$77cea17ccfc04f35.prototype, "wallet", void 0);
$ca6cae054193b243$export$77cea17ccfc04f35 = $ca6cae054193b243$var$__decorate([
    (0, $ailZp.customElement)("w3m-all-wallets-list-item")
], $ca6cae054193b243$export$77cea17ccfc04f35);


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $7Xn6F = parcelRequire("7Xn6F");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $f227beb6e91209a4$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-grid,
  wui-loading-spinner,
  wui-flex {
    height: 360px;
  }

  wui-grid {
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    justify-content: center;
    align-items: center;
  }
`;



var $bd80b00fa1e2e169$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bd80b00fa1e2e169$export$65a744e48142d5af = class W3mAllWalletsSearch extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.prevQuery = "";
        this.loading = true;
        this.query = "";
    }
    render() {
        this.onSearch();
        return this.loading ? (0, $aTf3K.html)`<wui-loading-spinner color="accent-100"></wui-loading-spinner>` : this.walletsTemplate();
    }
    async onSearch() {
        if (this.query.trim() !== this.prevQuery.trim()) {
            this.prevQuery = this.query;
            this.loading = true;
            await (0, $g4s8N.ApiController).searchWallet({
                search: this.query
            });
            this.loading = false;
        }
    }
    walletsTemplate() {
        const { search: search } = (0, $g4s8N.ApiController).state;
        const wallets = (0, $ea10a820172f8592$export$cffc81df24a1f1f1)(search);
        if (!search.length) return (0, $aTf3K.html)`
        <wui-flex justifyContent="center" alignItems="center" gap="s" flexDirection="column">
          <wui-icon-box
            size="lg"
            iconColor="fg-200"
            backgroundColor="fg-300"
            icon="wallet"
            background="transparent"
          ></wui-icon-box>
          <wui-text color="fg-200" variant="paragraph-500">No Wallet found</wui-text>
        </wui-flex>
      `;
        return (0, $aTf3K.html)`
      <wui-grid
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        gridTemplateColumns="repeat(4, 1fr)"
        rowGap="l"
        columnGap="xs"
      >
        ${wallets.map((wallet)=>(0, $aTf3K.html)`
            <w3m-all-wallets-list-item
              @click=${()=>this.onConnectWallet(wallet)}
              .wallet=${wallet}
            ></w3m-all-wallets-list-item>
          `)}
      </wui-grid>
    `;
    }
    onConnectWallet(wallet) {
        const connector = (0, $7Xn6F.ConnectorController).getConnector(wallet.id, wallet.rdns);
        if (connector) (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $6mRzS.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$bd80b00fa1e2e169$export$65a744e48142d5af.styles = (0, $f227beb6e91209a4$export$2e2bcd8739ae039);
$bd80b00fa1e2e169$var$__decorate([
    (0, $faUle.state)()
], $bd80b00fa1e2e169$export$65a744e48142d5af.prototype, "loading", void 0);
$bd80b00fa1e2e169$var$__decorate([
    (0, $jJP2r.property)()
], $bd80b00fa1e2e169$export$65a744e48142d5af.prototype, "query", void 0);
$bd80b00fa1e2e169$export$65a744e48142d5af = $bd80b00fa1e2e169$var$__decorate([
    (0, $ailZp.customElement)("w3m-all-wallets-search")
], $bd80b00fa1e2e169$export$65a744e48142d5af);


parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");
var $924b33e3c13537e0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $924b33e3c13537e0$export$994bb77f05fbbbde = class W3mConnectingHeader extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.platformTabs = [];
        this.unsubscribe = [];
        this.platforms = [];
        this.onSelectPlatfrom = undefined;
        this.buffering = false;
        this.unsubscribe.push((0, $hlVrM.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val));
    }
    disconnectCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const tabs = this.generateTabs();
        return (0, $aTf3K.html)`
      <wui-flex justifyContent="center" .padding=${[
            "0",
            "0",
            "l",
            "0"
        ]}>
        <wui-tabs
          ?disabled=${this.buffering}
          .tabs=${tabs}
          .onTabChange=${this.onTabChange.bind(this)}
        ></wui-tabs>
      </wui-flex>
    `;
    }
    generateTabs() {
        const tabs = this.platforms.map((platform)=>{
            if (platform === "browser") return {
                label: "Browser",
                icon: "extension",
                platform: "browser"
            };
            else if (platform === "mobile") return {
                label: "Mobile",
                icon: "mobile",
                platform: "mobile"
            };
            else if (platform === "qrcode") return {
                label: "Mobile",
                icon: "mobile",
                platform: "qrcode"
            };
            else if (platform === "web") return {
                label: "Webapp",
                icon: "browser",
                platform: "web"
            };
            else if (platform === "desktop") return {
                label: "Desktop",
                icon: "desktop",
                platform: "desktop"
            };
            return {
                label: "Browser",
                icon: "extension",
                platform: "unsupported"
            };
        });
        this.platformTabs = tabs.map(({ platform: platform })=>platform);
        return tabs;
    }
    onTabChange(index) {
        const tab = this.platformTabs[index];
        if (tab) this.onSelectPlatfrom?.(tab);
    }
};
$924b33e3c13537e0$var$__decorate([
    (0, $jJP2r.property)({
        type: Array
    })
], $924b33e3c13537e0$export$994bb77f05fbbbde.prototype, "platforms", void 0);
$924b33e3c13537e0$var$__decorate([
    (0, $jJP2r.property)()
], $924b33e3c13537e0$export$994bb77f05fbbbde.prototype, "onSelectPlatfrom", void 0);
$924b33e3c13537e0$var$__decorate([
    (0, $faUle.state)()
], $924b33e3c13537e0$export$994bb77f05fbbbde.prototype, "buffering", void 0);
$924b33e3c13537e0$export$994bb77f05fbbbde = $924b33e3c13537e0$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-header")
], $924b33e3c13537e0$export$994bb77f05fbbbde);


parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");

var $a90727f57344ae66$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a90727f57344ae66$export$f6b6073753ecd240 = class W3mConnectingWcBrowser extends (0, $45650b9021d7e0f4$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-browser: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onAutoConnect = this.onConnectProxy.bind(this);
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "browser"
            }
        });
    }
    async onConnectProxy() {
        try {
            this.error = false;
            const { connectors: connectors } = (0, $7Xn6F.ConnectorController).state;
            const announcedConnector = connectors.find((c)=>c.type === "ANNOUNCED" && c.info?.rdns === this.wallet?.rdns);
            const injectedConnector = connectors.find((c)=>c.type === "INJECTED");
            if (announcedConnector) await (0, $hlVrM.ConnectionController).connectExternal(announcedConnector, announcedConnector.chain);
            else if (injectedConnector) await (0, $hlVrM.ConnectionController).connectExternal(injectedConnector, injectedConnector.chain);
            (0, $ib7WC.ModalController).close();
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_SUCCESS",
                properties: {
                    method: "browser",
                    name: this.wallet?.name || "Unknown"
                }
            });
        } catch (error) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            this.error = true;
        }
    }
};
$a90727f57344ae66$export$f6b6073753ecd240 = $a90727f57344ae66$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-wc-browser")
], $a90727f57344ae66$export$f6b6073753ecd240);


parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");

var $afa86720d0efa879$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $afa86720d0efa879$export$99d24518d9937f53 = class W3mConnectingWcDesktop extends (0, $45650b9021d7e0f4$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-desktop: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onRender = this.onRenderProxy.bind(this);
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "desktop"
            }
        });
    }
    onRenderProxy() {
        if (!this.ready && this.uri) {
            this.ready = true;
            this.onConnect?.();
        }
    }
    onConnectProxy() {
        if (this.wallet?.desktop_link && this.uri) try {
            this.error = false;
            const { desktop_link: desktop_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $c4rfq.CoreHelperUtil).formatNativeUrl(desktop_link, this.uri);
            (0, $hlVrM.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $hlVrM.ConnectionController).setRecentWallet(this.wallet);
            (0, $c4rfq.CoreHelperUtil).openHref(redirect, "_blank");
        } catch  {
            this.error = true;
        }
    }
};
$afa86720d0efa879$export$99d24518d9937f53 = $afa86720d0efa879$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-wc-desktop")
], $afa86720d0efa879$export$99d24518d9937f53);


parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");

var $5b17c868be8f82d3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5b17c868be8f82d3$export$bde153011a6b26 = class W3mConnectingWcMobile extends (0, $45650b9021d7e0f4$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-mobile: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onRender = this.onRenderProxy.bind(this);
        document.addEventListener("visibilitychange", this.onBuffering.bind(this));
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "mobile"
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("visibilitychange", this.onBuffering.bind(this));
    }
    onRenderProxy() {
        if (!this.ready && this.uri) {
            this.ready = true;
            this.onConnect?.();
        }
    }
    onConnectProxy() {
        if (this.wallet?.mobile_link && this.uri) try {
            this.error = false;
            const { mobile_link: mobile_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $c4rfq.CoreHelperUtil).formatNativeUrl(mobile_link, this.uri);
            (0, $hlVrM.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $hlVrM.ConnectionController).setRecentWallet(this.wallet);
            (0, $c4rfq.CoreHelperUtil).openHref(redirect, "_self");
        } catch  {
            this.error = true;
        }
    }
    onBuffering() {
        const isIos = (0, $c4rfq.CoreHelperUtil).isIos();
        if (document?.visibilityState === "visible" && !this.error && isIos) {
            (0, $hlVrM.ConnectionController).setBuffering(true);
            setTimeout(()=>{
                (0, $hlVrM.ConnectionController).setBuffering(false);
            }, 5000);
        }
    }
};
$5b17c868be8f82d3$export$bde153011a6b26 = $5b17c868be8f82d3$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-wc-mobile")
], $5b17c868be8f82d3$export$bde153011a6b26);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $hlVrM = parcelRequire("hlVrM");
var $6m17w = parcelRequire("6m17w");
var $3Sg6l = parcelRequire("3Sg6l");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");


parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $4d812bf452df1044$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  wui-shimmer {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px) !important;
  }

  wui-qr-code {
    opacity: 0;
    animation-duration: 200ms;
    animation-timing-function: ease;
    animation-name: fadein;
    animation-fill-mode: forwards;
  }
`;


var $d6565dad0d2b8953$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d6565dad0d2b8953$export$d4369b1b68d9b78a = class W3mConnectingWcQrcode extends (0, $45650b9021d7e0f4$export$902e3cfa9f67689d) {
    constructor(){
        super();
        this.forceUpdate = ()=>{
            this.requestUpdate();
        };
        window.addEventListener("resize", this.forceUpdate);
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet?.name ?? "WalletConnect",
                platform: "qrcode"
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("resize", this.forceUpdate);
    }
    render() {
        this.onRenderProxy();
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-shimmer borderRadius="l" width="100%"> ${this.qrCodeTemplate()} </wui-shimmer>

        <wui-text variant="paragraph-500" color="fg-100">
          Scan this QR Code with your phone
        </wui-text>
        ${this.copyTemplate()}
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
    onRenderProxy() {
        if (!this.ready && this.uri) this.timeout = setTimeout(()=>{
            this.ready = true;
        }, 0);
    }
    qrCodeTemplate() {
        if (!this.uri || !this.ready) return null;
        const size = this.getBoundingClientRect().width - 40;
        const alt = this.wallet ? this.wallet.name : undefined;
        (0, $hlVrM.ConnectionController).setWcLinking(undefined);
        (0, $hlVrM.ConnectionController).setRecentWallet(this.wallet);
        return (0, $aTf3K.html)` <wui-qr-code
      size=${size}
      theme=${(0, $3Sg6l.ThemeController).state.themeMode}
      uri=${this.uri}
      imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getWalletImage(this.wallet))}
      alt=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(alt)}
      data-testid="wui-qr-code"
    ></wui-qr-code>`;
    }
    copyTemplate() {
        const inactive = !this.uri || !this.ready;
        return (0, $aTf3K.html)`<wui-link
      .disabled=${inactive}
      @click=${this.onCopyUri}
      color="fg-200"
      data-testid="copy-wc2-uri"
    >
      <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
      Copy link
    </wui-link>`;
    }
};
$d6565dad0d2b8953$export$d4369b1b68d9b78a.styles = (0, $4d812bf452df1044$export$2e2bcd8739ae039);
$d6565dad0d2b8953$export$d4369b1b68d9b78a = $d6565dad0d2b8953$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-wc-qrcode")
], $d6565dad0d2b8953$export$d4369b1b68d9b78a);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");

var $4c345af02b52fe0d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4c345af02b52fe0d$export$8ced6ff0971fe41b = class W3mConnectingWcUnsupported extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.wallet = (0, $6mRzS.RouterController).state.data?.wallet;
        if (!this.wallet) throw new Error("w3m-connecting-wc-unsupported: No wallet provided");
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "browser"
            }
        });
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-wallet-image
          size="lg"
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getWalletImage(this.wallet))}
        ></wui-wallet-image>

        <wui-text variant="paragraph-500" color="fg-100">Not Detected</wui-text>
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
};
$4c345af02b52fe0d$export$8ced6ff0971fe41b = $4c345af02b52fe0d$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-wc-unsupported")
], $4c345af02b52fe0d$export$8ced6ff0971fe41b);


parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");

var $1871a9a16a76b095$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1871a9a16a76b095$export$bdfe677b483cfd66 = class W3mConnectingWcWeb extends (0, $45650b9021d7e0f4$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-web: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.secondaryBtnLabel = "Open";
        this.secondaryLabel = "Open and continue in a new browser tab";
        this.secondaryBtnIcon = "externalLink";
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "web"
            }
        });
    }
    onConnectProxy() {
        if (this.wallet?.webapp_link && this.uri) try {
            this.error = false;
            const { webapp_link: webapp_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $c4rfq.CoreHelperUtil).formatUniversalUrl(webapp_link, this.uri);
            (0, $hlVrM.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $hlVrM.ConnectionController).setRecentWallet(this.wallet);
            (0, $c4rfq.CoreHelperUtil).openHref(redirect, "_blank");
        } catch  {
            this.error = true;
        }
    }
};
$1871a9a16a76b095$export$bdfe677b483cfd66 = $1871a9a16a76b095$var$__decorate([
    (0, $ailZp.customElement)("w3m-connecting-wc-web")
], $1871a9a16a76b095$export$bdfe677b483cfd66);


parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $4971a496d655954b$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
  }

  .details-container > wui-flex {
    background: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xxs);
    width: 100%;
  }

  .details-container > wui-flex > button {
    border: none;
    background: none;
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);
    cursor: pointer;
  }

  .details-content-container {
    padding: var(--wui-spacing-1xs);
    padding-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .details-content-container > wui-flex {
    width: 100%;
  }

  .details-row {
    width: 100%;
    padding: var(--wui-spacing-s);
    padding-left: var(--wui-spacing-s);
    padding-right: var(--wui-spacing-1xs);
    border-radius: calc(var(--wui-border-radius-5xs) + var(--wui-border-radius-4xs));
    background: var(--wui-color-gray-glass-002);
  }

  .details-row-title {
    white-space: nowrap;
  }

  .details-row.provider-free-row {
    padding-right: var(--wui-spacing-xs);
  }
`;


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("ikDNi");
var $l2EhC = parcelRequire("l2EhC");
parcelRequire("eNJDH");
var $6AwK8 = parcelRequire("6AwK8");
var $jbD0z = parcelRequire("jbD0z");
var $89gde = parcelRequire("89gde");
var $3d69889d097f13ff$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $3d69889d097f13ff$var$slippageRate = (0, $6AwK8.ConstantsUtil).CONVERT_SLIPPAGE_TOLERANCE;
let $3d69889d097f13ff$export$a5d884fb6b8316b8 = class WuiSwapDetails extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.networkName = (0, $jbD0z.NetworkController).state.caipNetwork?.name;
        this.detailsOpen = false;
        this.sourceToken = (0, $89gde.SwapController).state.sourceToken;
        this.toToken = (0, $89gde.SwapController).state.toToken;
        this.toTokenAmount = (0, $89gde.SwapController).state.toTokenAmount;
        this.sourceTokenPriceInUSD = (0, $89gde.SwapController).state.sourceTokenPriceInUSD;
        this.toTokenPriceInUSD = (0, $89gde.SwapController).state.toTokenPriceInUSD;
        this.gasPriceInUSD = (0, $89gde.SwapController).state.gasPriceInUSD;
        this.priceImpact = (0, $89gde.SwapController).state.priceImpact;
        this.maxSlippage = (0, $89gde.SwapController).state.maxSlippage;
        this.networkTokenSymbol = (0, $89gde.SwapController).state.networkTokenSymbol;
        this.inputError = (0, $89gde.SwapController).state.inputError;
        this.unsubscribe.push(...[
            (0, $89gde.SwapController).subscribe((newState)=>{
                this.sourceToken = newState.sourceToken;
                this.toToken = newState.toToken;
                this.toTokenAmount = newState.toTokenAmount;
                this.gasPriceInUSD = newState.gasPriceInUSD;
                this.priceImpact = newState.priceImpact;
                this.maxSlippage = newState.maxSlippage;
                this.sourceTokenPriceInUSD = newState.sourceTokenPriceInUSD;
                this.toTokenPriceInUSD = newState.toTokenPriceInUSD;
                this.inputError = newState.inputError;
            })
        ]);
    }
    render() {
        const minReceivedAmount = this.toTokenAmount && this.maxSlippage ? (0, $l2EhC.NumberUtil).bigNumber(this.toTokenAmount).minus(this.maxSlippage).toString() : null;
        if (!this.sourceToken || !this.toToken || this.inputError) return null;
        const toTokenSwappedAmount = this.sourceTokenPriceInUSD && this.toTokenPriceInUSD ? 1 / this.toTokenPriceInUSD * this.sourceTokenPriceInUSD : 0;
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="1xs" class="details-container">
        <wui-flex flexDirection="column">
          <button @click=${this.toggleDetails.bind(this)}>
            <wui-flex justifyContent="space-between" .padding=${[
            "0",
            "xs",
            "0",
            "xs"
        ]}>
              <wui-flex justifyContent="flex-start" flexGrow="1" gap="xs">
                <wui-text variant="small-400" color="fg-100">
                  1 ${this.sourceToken.symbol} =
                  ${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(toTokenSwappedAmount, 3)}
                  ${this.toToken.symbol}
                </wui-text>
                <wui-text variant="small-400" color="fg-200">
                  $${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.sourceTokenPriceInUSD)}
                </wui-text>
              </wui-flex>
              <wui-icon name="chevronBottom"></wui-icon>
            </wui-flex>
          </button>
          ${this.detailsOpen ? (0, $aTf3K.html)`
                <wui-flex flexDirection="column" gap="xs" class="details-content-container">
                  <wui-flex flexDirection="column" gap="xs">
                    <wui-flex
                      justifyContent="space-between"
                      alignItems="center"
                      class="details-row"
                    >
                      <wui-flex alignItems="center" gap="xs">
                        <wui-text class="details-row-title" variant="small-400" color="fg-150">
                          Network cost
                        </wui-text>
                        <w3m-tooltip-trigger
                          text=${`Network cost is paid in ${this.networkTokenSymbol} on the ${this.networkName} network in order to execute transaction.`}
                        >
                          <wui-icon size="xs" color="fg-250" name="infoCircle"></wui-icon>
                        </w3m-tooltip-trigger>
                      </wui-flex>
                      <wui-text variant="small-400" color="fg-100">
                        $${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.gasPriceInUSD, 3)}
                      </wui-text>
                    </wui-flex>
                  </wui-flex>
                  ${this.priceImpact ? (0, $aTf3K.html)` <wui-flex flexDirection="column" gap="xs">
                        <wui-flex
                          justifyContent="space-between"
                          alignItems="center"
                          class="details-row"
                        >
                          <wui-flex alignItems="center" gap="xs">
                            <wui-text class="details-row-title" variant="small-400" color="fg-150">
                              Price impact
                            </wui-text>
                            <w3m-tooltip-trigger
                              text="Price impact reflects the change in market price due to your trade"
                            >
                              <wui-icon size="xs" color="fg-250" name="infoCircle"></wui-icon>
                            </w3m-tooltip-trigger>
                          </wui-flex>
                          <wui-flex>
                            <wui-text variant="small-400" color="fg-200">
                              ${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.priceImpact, 3)}%
                            </wui-text>
                          </wui-flex>
                        </wui-flex>
                      </wui-flex>` : null}
                  ${this.maxSlippage && this.sourceToken.symbol ? (0, $aTf3K.html)`<wui-flex flexDirection="column" gap="xs">
                        <wui-flex
                          justifyContent="space-between"
                          alignItems="center"
                          class="details-row"
                        >
                          <wui-flex alignItems="center" gap="xs">
                            <wui-text class="details-row-title" variant="small-400" color="fg-150">
                              Max. slippage
                            </wui-text>
                            <w3m-tooltip-trigger
                              text=${`Max slippage sets the minimum amount you must receive for the transaction to proceed. ${minReceivedAmount ? `Transaction will be reversed if you receive less than ${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(minReceivedAmount, 6)} ${this.toToken.symbol} due to price changes.` : ""}`}
                            >
                              <wui-icon size="xs" color="fg-250" name="infoCircle"></wui-icon>
                            </w3m-tooltip-trigger>
                          </wui-flex>
                          <wui-flex>
                            <wui-text variant="small-400" color="fg-200">
                              ${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.maxSlippage, 6)}
                              ${this.toToken.symbol} ${$3d69889d097f13ff$var$slippageRate}%
                            </wui-text>
                          </wui-flex>
                        </wui-flex>
                      </wui-flex>` : null}
                  <wui-flex flexDirection="column" gap="xs">
                    <wui-flex
                      justifyContent="space-between"
                      alignItems="center"
                      class="details-row provider-free-row"
                    >
                      <wui-flex alignItems="center" gap="xs">
                        <wui-text class="details-row-title" variant="small-400" color="fg-150">
                          Provider fee
                        </wui-text>
                      </wui-flex>
                      <wui-flex>
                        <wui-text variant="small-400" color="fg-200">0.85%</wui-text>
                      </wui-flex>
                    </wui-flex>
                  </wui-flex>
                </wui-flex>
              ` : null}
        </wui-flex>
      </wui-flex>
    `;
    }
    toggleDetails() {
        this.detailsOpen = !this.detailsOpen;
    }
};
$3d69889d097f13ff$export$a5d884fb6b8316b8.styles = [
    (0, $4971a496d655954b$export$2e2bcd8739ae039)
];
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "networkName", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $jJP2r.property)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "detailsOpen", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "sourceToken", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "toToken", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "toTokenAmount", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "sourceTokenPriceInUSD", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "toTokenPriceInUSD", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "gasPriceInUSD", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "priceImpact", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "maxSlippage", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "networkTokenSymbol", void 0);
$3d69889d097f13ff$var$__decorate([
    (0, $faUle.state)()
], $3d69889d097f13ff$export$a5d884fb6b8316b8.prototype, "inputError", void 0);
$3d69889d097f13ff$export$a5d884fb6b8316b8 = $3d69889d097f13ff$var$__decorate([
    (0, $ailZp.customElement)("w3m-swap-details")
], $3d69889d097f13ff$export$a5d884fb6b8316b8);


parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
parcelRequire("eNJDH");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("ikDNi");
var $4DADY = parcelRequire("4DADY");
var $l2EhC = parcelRequire("l2EhC");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $c3bf4b4449eff57b$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: var(--wui-border-radius-s);
    background-color: var(--wui-color-gray-glass-002);
    padding: var(--wui-spacing-xl);
    padding-right: var(--wui-spacing-s);
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    box-shadow: inset 0px 0px 0px 1px var(--wui-color-gray-glass-002);
    position: relative;
    transition: box-shadow var(--wui-ease-out-power-1) var(--wui-duration-lg);
    will-change: background-color;
  }

  :host wui-flex.focus {
    box-shadow: inset 0px 0px 0px 1px var(--wui-color-gray-glass-005);
  }

  :host > wui-flex .swap-input,
  :host > wui-flex .swap-token-button {
    z-index: 10;
  }

  :host > wui-flex .swap-input {
    -webkit-mask-image: linear-gradient(
      270deg,
      transparent 0px,
      transparent 8px,
      black 24px,
      black 25px,
      black 32px,
      black 100%
    );
    mask-image: linear-gradient(
      270deg,
      transparent 0px,
      transparent 8px,
      black 24px,
      black 25px,
      black 32px,
      black 100%
    );
  }

  :host > wui-flex .swap-input input {
    background: none;
    border: none;
    height: 42px;
    width: 100%;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: -1.28px;
    outline: none;
    caret-color: var(--wui-color-accent-100);
    color: var(--wui-color-fg-100);
    padding: 0px;
  }

  :host > wui-flex .swap-input input:focus-visible {
    outline: none;
  }

  :host > wui-flex .swap-input input::-webkit-outer-spin-button,
  :host > wui-flex .swap-input input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .max-value-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: var(--wui-color-gray-glass-020);
    padding-left: 0px;
  }

  .market-value {
    min-height: 18px;
  }
`;


var $dc8721c638749b92$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $dc8721c638749b92$var$MINIMUM_USD_VALUE_TO_CONVERT = 0.00005;
let $dc8721c638749b92$export$9ede572f30521f7c = class W3mSwapInput extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.focused = false;
        this.price = 0;
        this.target = "sourceToken";
        this.onSetAmount = null;
        this.onSetMaxValue = null;
    }
    render() {
        const marketValue = this.marketValue || "0";
        const isMarketValueGreaterThanZero = (0, $l2EhC.NumberUtil).bigNumber(marketValue).isGreaterThan("0");
        return (0, $aTf3K.html)`
      <wui-flex class="${this.focused ? "focus" : ""}" justifyContent="space-between">
        <wui-flex
          flex="1"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
          class="swap-input"
        >
          <input
            data-testid="swap-input-${this.target}"
            @focusin=${()=>this.onFocusChange(true)}
            @focusout=${()=>this.onFocusChange(false)}
            ?disabled=${this.disabled}
            .value=${this.value}
            @input=${this.dispatchInputChangeEvent}
            @keydown=${this.handleKeydown}
            placeholder="0"
            type="text"
            inputmode="decimal"
          />
          <wui-text class="market-value" variant="small-400" color="fg-200">
            ${isMarketValueGreaterThanZero ? `$${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.marketValue, 3)}` : null}
          </wui-text>
        </wui-flex>
        ${this.templateTokenSelectButton()}
      </wui-flex>
    `;
    }
    handleKeydown(event) {
        return (0, $4DADY.InputUtil).numericInputKeyDown(event, this.value, (value)=>this.onSetAmount?.(this.target, value));
    }
    dispatchInputChangeEvent(event) {
        if (!this.onSetAmount) return;
        const value = event.target.value.replace(/[^0-9.]/gu, "");
        if (value === "," || value === ".") this.onSetAmount(this.target, "0.");
        else if (value.endsWith(",")) this.onSetAmount(this.target, value.replace(",", "."));
        else this.onSetAmount(this.target, value);
    }
    setMaxValueToInput() {
        this.onSetMaxValue?.(this.target, this.balance);
    }
    templateTokenSelectButton() {
        if (!this.token) return (0, $aTf3K.html)` <wui-button
        data-testid="swap-select-token-button-${this.target}"
        class="swap-token-button"
        size="md"
        variant="accent"
        @click=${this.onSelectToken.bind(this)}
      >
        Select token
      </wui-button>`;
        return (0, $aTf3K.html)`
      <wui-flex
        class="swap-token-button"
        flexDirection="column"
        alignItems="flex-end"
        justifyContent="center"
        gap="xxs"
      >
        <wui-token-button
          data-testid="swap-input-token-${this.target}"
          text=${this.token.symbol}
          imageSrc=${this.token.logoUri}
          @click=${this.onSelectToken.bind(this)}
        >
        </wui-token-button>
        <wui-flex alignItems="center" gap="xxs"> ${this.tokenBalanceTemplate()} </wui-flex>
      </wui-flex>
    `;
    }
    tokenBalanceTemplate() {
        const balanceValueInUSD = (0, $l2EhC.NumberUtil).multiply(this.balance, this.price);
        const haveBalance = balanceValueInUSD ? balanceValueInUSD?.isGreaterThan($dc8721c638749b92$var$MINIMUM_USD_VALUE_TO_CONVERT) : false;
        return (0, $aTf3K.html)`
      ${haveBalance ? (0, $aTf3K.html)`<wui-text variant="small-400" color="fg-200">
            ${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.balance, 3)}
          </wui-text>` : null}
      ${this.target === "sourceToken" ? this.tokenActionButtonTemplate(haveBalance) : null}
    `;
    }
    tokenActionButtonTemplate(haveBalance) {
        if (haveBalance) return (0, $aTf3K.html)` <button class="max-value-button" @click=${this.setMaxValueToInput.bind(this)}>
        <wui-text color="accent-100" variant="small-600">Max</wui-text>
      </button>`;
        return (0, $aTf3K.html)` <button class="max-value-button" @click=${this.onBuyToken.bind(this)}>
      <wui-text color="accent-100" variant="small-600">Buy</wui-text>
    </button>`;
    }
    onFocusChange(state) {
        this.focused = state;
    }
    onSelectToken() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "CLICK_SELECT_TOKEN_TO_SWAP"
        });
        (0, $6mRzS.RouterController).push("SwapSelectToken", {
            target: this.target
        });
    }
    onBuyToken() {
        (0, $6mRzS.RouterController).push("OnRampProviders");
    }
};
$dc8721c638749b92$export$9ede572f30521f7c.styles = [
    (0, $c3bf4b4449eff57b$export$2e2bcd8739ae039)
];
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "focused", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "balance", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "value", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "price", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "marketValue", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "disabled", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "target", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "token", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "onSetAmount", void 0);
$dc8721c638749b92$var$__decorate([
    (0, $jJP2r.property)()
], $dc8721c638749b92$export$9ede572f30521f7c.prototype, "onSetMaxValue", void 0);
$dc8721c638749b92$export$9ede572f30521f7c = $dc8721c638749b92$var$__decorate([
    (0, $ailZp.customElement)("w3m-swap-input")
], $dc8721c638749b92$export$9ede572f30521f7c);


parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
parcelRequire("eNJDH");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $9f088ecc1c27cda5$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
  }

  :host > wui-flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: var(--wui-border-radius-s);
    padding: var(--wui-spacing-xl);
    padding-right: var(--wui-spacing-s);
    background-color: var(--wui-color-gray-glass-002);
    box-shadow: inset 0px 0px 0px 1px var(--wui-color-gray-glass-002);
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    position: relative;
  }

  wui-shimmer.market-value {
    opacity: 0;
  }

  :host > wui-flex > svg.input_mask {
    position: absolute;
    inset: 0;
    z-index: 5;
  }

  :host wui-flex .input_mask__border,
  :host wui-flex .input_mask__background {
    transition: fill var(--wui-duration-md) var(--wui-ease-out-power-1);
    will-change: fill;
  }

  :host wui-flex .input_mask__border {
    fill: var(--wui-color-gray-glass-020);
  }

  :host wui-flex .input_mask__background {
    fill: var(--wui-color-gray-glass-002);
  }
`;


var $9ab23002b67e559e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9ab23002b67e559e$export$3b3c1d28340eee2c = class W3mSwapInputSkeleton extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.target = "sourceToken";
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex class justifyContent="space-between">
        <wui-flex
          flex="1"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
          class="swap-input"
          gap="xxs"
        >
          <wui-shimmer width="80px" height="40px" borderRadius="xxs" variant="light"></wui-shimmer>
        </wui-flex>
        ${this.templateTokenSelectButton()}
      </wui-flex>
    `;
    }
    templateTokenSelectButton() {
        return (0, $aTf3K.html)`
      <wui-flex
        class="swap-token-button"
        flexDirection="column"
        alignItems="flex-end"
        justifyContent="center"
        gap="xxs"
      >
        <wui-shimmer width="80px" height="40px" borderRadius="3xl" variant="light"></wui-shimmer>
      </wui-flex>
    `;
    }
};
$9ab23002b67e559e$export$3b3c1d28340eee2c.styles = [
    (0, $9f088ecc1c27cda5$export$2e2bcd8739ae039)
];
$9ab23002b67e559e$var$__decorate([
    (0, $jJP2r.property)()
], $9ab23002b67e559e$export$3b3c1d28340eee2c.prototype, "target", void 0);
$9ab23002b67e559e$export$3b3c1d28340eee2c = $9ab23002b67e559e$var$__decorate([
    (0, $ailZp.customElement)("w3m-swap-input-skeleton")
], $9ab23002b67e559e$export$3b3c1d28340eee2c);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $5fe74dbb953d2109$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    height: 64px;
  }

  wui-text {
    text-transform: capitalize;
  }

  wui-flex.w3m-header-title {
    transform: translateY(0);
    opacity: 1;
  }

  wui-flex.w3m-header-title[view-direction='prev'] {
    animation:
      slide-down-out 120ms forwards var(--wui-ease-out-power-2),
      slide-down-in 120ms forwards var(--wui-ease-out-power-2);
    animation-delay: 0ms, 200ms;
  }

  wui-flex.w3m-header-title[view-direction='next'] {
    animation:
      slide-up-out 120ms forwards var(--wui-ease-out-power-2),
      slide-up-in 120ms forwards var(--wui-ease-out-power-2);
    animation-delay: 0ms, 200ms;
  }

  wui-icon-link[data-hidden='true'] {
    opacity: 0 !important;
    pointer-events: none;
  }

  @keyframes slide-up-out {
    from {
      transform: translateY(0px);
      opacity: 1;
    }
    to {
      transform: translateY(3px);
      opacity: 0;
    }
  }

  @keyframes slide-up-in {
    from {
      transform: translateY(-3px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-down-out {
    from {
      transform: translateY(0px);
      opacity: 1;
    }
    to {
      transform: translateY(-3px);
      opacity: 0;
    }
  }

  @keyframes slide-down-in {
    from {
      transform: translateY(3px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;




var $8f5f479012298ef1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $8f5f479012298ef1$var$BETA_SCREENS = [
    "Swap",
    "SwapSelectToken",
    "SwapPreview"
];
function $8f5f479012298ef1$var$headings() {
    const connectorName = (0, $6mRzS.RouterController).state.data?.connector?.name;
    const walletName = (0, $6mRzS.RouterController).state.data?.wallet?.name;
    const networkName = (0, $6mRzS.RouterController).state.data?.network?.name;
    const name = walletName ?? connectorName;
    const connectors = (0, $7Xn6F.ConnectorController).getConnectors();
    const isEmail = connectors.length === 1 && connectors[0]?.id === "w3m-email";
    return {
        Connect: `Connect ${isEmail ? "Email" : ""} Wallet`,
        ChooseAccountName: undefined,
        Account: undefined,
        AccountSettings: undefined,
        AllWallets: "All Wallets",
        ApproveTransaction: "Approve Transaction",
        BuyInProgress: "Buy",
        ConnectingExternal: name ?? "Connect Wallet",
        ConnectingWalletConnect: name ?? "WalletConnect",
        ConnectingSiwe: "Sign In",
        Convert: "Convert",
        ConvertSelectToken: "Select token",
        ConvertPreview: "Preview convert",
        Downloads: name ? `Get ${name}` : "Downloads",
        EmailVerifyOtp: "Confirm Email",
        EmailVerifyDevice: "Register Device",
        GetWallet: "Get a wallet",
        Networks: "Choose Network",
        OnRampProviders: "Choose Provider",
        OnRampActivity: "Activity",
        OnRampTokenSelect: "Select Token",
        OnRampFiatSelect: "Select Currency",
        Profile: undefined,
        SelectAddresses: "Select accounts",
        SwitchNetwork: networkName ?? "Switch Network",
        SwitchAddress: "Switch Address",
        Transactions: "Activity",
        UnsupportedChain: "Switch Network",
        UpgradeEmailWallet: "Upgrade your Wallet",
        UpgradeToSmartAccount: undefined,
        UpdateEmailWallet: "Edit Email",
        UpdateEmailPrimaryOtp: "Confirm Current Email",
        UpdateEmailSecondaryOtp: "Confirm New Email",
        WhatIsABuy: "What is Buy?",
        RegisterAccountName: "Choose name",
        RegisterAccountNameSuccess: "",
        WalletReceive: "Receive",
        WalletCompatibleNetworks: "Compatible Networks",
        Swap: "Swap",
        SwapSelectToken: "Select token",
        SwapPreview: "Preview swap",
        WalletSend: "Send",
        WalletSendPreview: "Review send",
        WalletSendSelectToken: "Select Token",
        WhatIsANetwork: "What is a network?",
        WhatIsAWallet: "What is a wallet?",
        ConnectWallets: "Connect wallet",
        ConnectSocials: "All socials",
        ConnectingSocial: (0, $f7IXw.AccountController).state.socialProvider ? (0, $f7IXw.AccountController).state.socialProvider : "Connect Social",
        ConnectingMultiChain: "Select chain",
        ConnectingFarcaster: "Farcaster",
        SwitchActiveChain: "Switch chain"
    };
}

let $8f5f479012298ef1$export$c6714271d9f13670 = class W3mHeader extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.heading = $8f5f479012298ef1$var$headings()[(0, $6mRzS.RouterController).state.view];
        this.network = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.buffering = false;
        this.showBack = false;
        this.isSiweEnabled = (0, $8BVTM.OptionsController).state.isSiweEnabled;
        this.prevHistoryLength = 1;
        this.view = (0, $6mRzS.RouterController).state.view;
        this.viewDirection = "";
        this.headerText = $8f5f479012298ef1$var$headings()[(0, $6mRzS.RouterController).state.view];
        this.unsubscribe.push((0, $6mRzS.RouterController).subscribeKey("view", (val)=>{
            setTimeout(()=>{
                this.view = val;
                this.headerText = $8f5f479012298ef1$var$headings()[val];
            }, (0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).ANIMATION_DURATIONS.HeaderText);
            this.onViewChange();
            this.onHistoryChange();
        }), (0, $hlVrM.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val), (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val));
    }
    disconnectCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex .padding=${this.getPadding()} justifyContent="space-between" alignItems="center">
        ${this.dynamicButtonTemplate()} ${this.titleTemplate()} ${this.closeButtonTemplate()}
      </wui-flex>
    `;
    }
    onWalletHelp() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "CLICK_WALLET_HELP"
        });
        (0, $6mRzS.RouterController).push("WhatIsAWallet");
    }
    async onClose() {
        if (this.isSiweEnabled) {
            const { SIWEController: SIWEController } = await (parcelRequire("XE6yD"));
            const isApproveSignScreen = (0, $6mRzS.RouterController).state.view === "ApproveTransaction";
            const isUnauthenticated = SIWEController.state.status !== "success";
            if (isUnauthenticated && isApproveSignScreen) (0, $6mRzS.RouterController).popTransactionStack(true);
            else (0, $ib7WC.ModalController).close();
        } else (0, $ib7WC.ModalController).close();
    }
    closeButtonTemplate() {
        const isSiweSignScreen = (0, $6mRzS.RouterController).state.view === "ConnectingSiwe";
        if (this.isSiweEnabled && isSiweSignScreen) return (0, $aTf3K.html)`<div style="width:40px" />`;
        return (0, $aTf3K.html)`
      <wui-icon-link
        ?disabled=${this.buffering}
        icon="close"
        @click=${this.onClose.bind(this)}
        data-testid="w3m-header-close"
      ></wui-icon-link>
    `;
    }
    titleTemplate() {
        const isBeta = $8f5f479012298ef1$var$BETA_SCREENS.includes(this.view);
        return (0, $aTf3K.html)`
      <wui-flex
        view-direction="${this.viewDirection}"
        class="w3m-header-title"
        alignItems="center"
        gap="xs"
      >
        <wui-text variant="paragraph-700" color="fg-100">${this.headerText}</wui-text>
        ${isBeta ? (0, $aTf3K.html)`<wui-tag variant="main">Beta</wui-tag>` : null}
      </wui-flex>
    `;
    }
    dynamicButtonTemplate() {
        const { view: view } = (0, $6mRzS.RouterController).state;
        const isConnectHelp = view === "Connect";
        const isApproveTransaction = view === "ApproveTransaction";
        const isUpgradeToSmartAccounts = view === "UpgradeToSmartAccount";
        const isConnectingSIWEView = view === "ConnectingSiwe";
        const isAccountView = view === "Account";
        const shouldHideBack = isApproveTransaction || isUpgradeToSmartAccounts || isConnectingSIWEView;
        if (isAccountView) return (0, $aTf3K.html)`<wui-select
        id="dynamic"
        data-testid="w3m-account-select-network"
        active-network=${this.network?.name}
        @click=${this.onNetworks.bind(this)}
        imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getNetworkImage(this.network))}
      ></wui-select>`;
        if (this.showBack && !shouldHideBack) return (0, $aTf3K.html)`<wui-icon-link
        id="dynamic"
        icon="chevronLeft"
        ?disabled=${this.buffering}
        @click=${this.onGoBack.bind(this)}
      ></wui-icon-link>`;
        return (0, $aTf3K.html)`<wui-icon-link
      data-hidden=${!isConnectHelp}
      id="dynamic"
      icon="helpCircle"
      @click=${this.onWalletHelp.bind(this)}
    ></wui-icon-link>`;
    }
    onNetworks() {
        if (this.isAllowedNetworkSwitch()) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "CLICK_NETWORKS"
            });
            (0, $6mRzS.RouterController).push("Networks");
        }
    }
    isAllowedNetworkSwitch() {
        const requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        const isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
        const isValidNetwork = requestedCaipNetworks?.find(({ id: id })=>id === this.network?.id);
        return isMultiNetwork || !isValidNetwork;
    }
    getPadding() {
        if (this.heading) return [
            "l",
            "2l",
            "l",
            "2l"
        ];
        return [
            "0",
            "2l",
            "0",
            "2l"
        ];
    }
    onViewChange() {
        const { history: history } = (0, $6mRzS.RouterController).state;
        let direction = (0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).VIEW_DIRECTION.Next;
        if (history.length < this.prevHistoryLength) direction = (0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).VIEW_DIRECTION.Prev;
        this.prevHistoryLength = history.length;
        this.viewDirection = direction;
    }
    async onHistoryChange() {
        const { history: history } = (0, $6mRzS.RouterController).state;
        const buttonEl = this.shadowRoot?.querySelector("#dynamic");
        if (history.length > 1 && !this.showBack && buttonEl) {
            await buttonEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.showBack = true;
            buttonEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        } else if (history.length <= 1 && this.showBack && buttonEl) {
            await buttonEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.showBack = false;
            buttonEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    onGoBack() {
        (0, $6mRzS.RouterController).goBack();
    }
};
$8f5f479012298ef1$export$c6714271d9f13670.styles = (0, $5fe74dbb953d2109$export$2e2bcd8739ae039);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "heading", void 0);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "network", void 0);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "buffering", void 0);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "showBack", void 0);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "isSiweEnabled", void 0);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "prevHistoryLength", void 0);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "view", void 0);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "viewDirection", void 0);
$8f5f479012298ef1$var$__decorate([
    (0, $faUle.state)()
], $8f5f479012298ef1$export$c6714271d9f13670.prototype, "headerText", void 0);
$8f5f479012298ef1$export$c6714271d9f13670 = $8f5f479012298ef1$var$__decorate([
    (0, $ailZp.customElement)("w3m-header")
], $8f5f479012298ef1$export$c6714271d9f13670);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $8ae31701f0904057$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8ae31701f0904057$export$c95abd0ceed44b88 = class W3mHelpWidget extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.data = [];
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="l">
        ${this.data.map((item)=>(0, $aTf3K.html)`
            <wui-flex flexDirection="column" alignItems="center" gap="xl">
              <wui-flex flexDirection="row" justifyContent="center" gap="1xs">
                ${item.images.map((image)=>(0, $aTf3K.html)`<wui-visual name=${image}></wui-visual>`)}
              </wui-flex>
            </wui-flex>
            <wui-flex flexDirection="column" alignItems="center" gap="xxs">
              <wui-text variant="paragraph-500" color="fg-100" align="center">
                ${item.title}
              </wui-text>
              <wui-text variant="small-500" color="fg-200" align="center">${item.text}</wui-text>
            </wui-flex>
          `)}
      </wui-flex>
    `;
    }
};
$8ae31701f0904057$var$__decorate([
    (0, $jJP2r.property)({
        type: Array
    })
], $8ae31701f0904057$export$c95abd0ceed44b88.prototype, "data", void 0);
$8ae31701f0904057$export$c95abd0ceed44b88 = $8ae31701f0904057$var$__decorate([
    (0, $ailZp.customElement)("w3m-help-widget")
], $8ae31701f0904057$export$c95abd0ceed44b88);


parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $fecbd78171d53c49$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
  }

  :host > wui-flex {
    width: 100%;
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xs);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--wui-spacing-s);
  }

  :host > wui-flex:hover {
    background-color: var(--wui-color-gray-glass-002);
  }

  .purchase-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: var(--wui-icon-box-size-lg);
    height: var(--wui-icon-box-size-lg);
  }

  .purchase-image-container wui-image {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: calc(var(--wui-icon-box-size-lg) / 2);
  }

  .purchase-image-container wui-image::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-icon-box-size-lg) / 2);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
  }

  .purchase-image-container wui-icon-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
  }
`;


var $923fa887f673741f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $923fa887f673741f$export$73a3d63470374c46 = class W3mOnRampActivityItem extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
        this.label = "Bought";
        this.purchaseValue = "";
        this.purchaseCurrency = "";
        this.date = "";
        this.completed = false;
        this.inProgress = false;
        this.failed = false;
        this.onClick = null;
        this.symbol = "";
    }
    firstUpdated() {
        if (!this.icon) this.fetchTokenImage();
    }
    render() {
        return (0, $aTf3K.html)`
      <wui-flex>
        ${this.imageTemplate()}
        <wui-flex flexDirection="column" gap="4xs" flexGrow="1">
          <wui-flex gap="xxs" alignItems="center" justifyContent="flex-start">
            ${this.statusIconTemplate()}
            <wui-text variant="paragraph-500" color="fg-100"> ${this.label}</wui-text>
          </wui-flex>
          <wui-text variant="small-400" color="fg-200">
            + ${this.purchaseValue} ${this.purchaseCurrency}
          </wui-text>
        </wui-flex>
        ${this.inProgress ? (0, $aTf3K.html)`<wui-loading-spinner color="fg-200" size="md"></wui-loading-spinner>` : (0, $aTf3K.html)`<wui-text variant="micro-700" color="fg-300"><span>${this.date}</span></wui-text>`}
      </wui-flex>
    `;
    }
    async fetchTokenImage() {
        await (0, $g4s8N.ApiController)._fetchTokenImage(this.purchaseCurrency);
    }
    statusIconTemplate() {
        if (this.inProgress) return null;
        return this.completed ? this.boughtIconTemplate() : this.errorIconTemplate();
    }
    errorIconTemplate() {
        return (0, $aTf3K.html)`<wui-icon-box
      size="xxs"
      iconColor="error-100"
      backgroundColor="error-100"
      background="opaque"
      icon="close"
      borderColor="wui-color-bg-125"
    ></wui-icon-box>`;
    }
    imageTemplate() {
        const icon = this.icon || `https://avatar.vercel.sh/andrew.svg?size=50&text=${this.symbol}`;
        return (0, $aTf3K.html)`<wui-flex class="purchase-image-container">
      <wui-image src=${icon}></wui-image>
    </wui-flex>`;
    }
    boughtIconTemplate() {
        return (0, $aTf3K.html)`<wui-icon-box
      size="xxs"
      iconColor="success-100"
      backgroundColor="success-100"
      background="opaque"
      icon="arrowBottom"
      borderColor="wui-color-bg-125"
    ></wui-icon-box>`;
    }
};
$923fa887f673741f$export$73a3d63470374c46.styles = [
    (0, $fecbd78171d53c49$export$2e2bcd8739ae039)
];
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $923fa887f673741f$export$73a3d63470374c46.prototype, "disabled", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)()
], $923fa887f673741f$export$73a3d63470374c46.prototype, "color", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)()
], $923fa887f673741f$export$73a3d63470374c46.prototype, "label", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)()
], $923fa887f673741f$export$73a3d63470374c46.prototype, "purchaseValue", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)()
], $923fa887f673741f$export$73a3d63470374c46.prototype, "purchaseCurrency", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)()
], $923fa887f673741f$export$73a3d63470374c46.prototype, "date", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $923fa887f673741f$export$73a3d63470374c46.prototype, "completed", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $923fa887f673741f$export$73a3d63470374c46.prototype, "inProgress", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $923fa887f673741f$export$73a3d63470374c46.prototype, "failed", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)()
], $923fa887f673741f$export$73a3d63470374c46.prototype, "onClick", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)()
], $923fa887f673741f$export$73a3d63470374c46.prototype, "symbol", void 0);
$923fa887f673741f$var$__decorate([
    (0, $jJP2r.property)()
], $923fa887f673741f$export$73a3d63470374c46.prototype, "icon", void 0);
$923fa887f673741f$export$73a3d63470374c46 = $923fa887f673741f$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-activity-item")
], $923fa887f673741f$export$73a3d63470374c46);


parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");

parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $ec38552d3f0877b4$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
  }

  wui-loading-spinner {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }

  .currency-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: var(--wui-spacing-1xs);
    height: 40px;
    padding: var(--wui-spacing-xs) var(--wui-spacing-1xs) var(--wui-spacing-xs)
      var(--wui-spacing-xs);
    min-width: 95px;
    border-radius: var(--FULL, 1000px);
    border: 1px solid var(--wui-color-gray-glass-002);
    background: var(--wui-color-gray-glass-002);
    cursor: pointer;
  }

  .currency-container > wui-image {
    height: 24px;
    width: 24px;
    border-radius: 50%;
  }
`;


parcelRequire("eNJDH");
var $zKxbI = parcelRequire("zKxbI");
var $ib7WC = parcelRequire("ib7WC");
var $jM3Wq = parcelRequire("jM3Wq");
var $67c2ffa0a8e35ab3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $67c2ffa0a8e35ab3$export$8c7f6376138a05de = class W3mInputCurrency extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.type = "Token";
        this.value = 0;
        this.currencies = [];
        this.selectedCurrency = this.currencies?.[0];
        this.currencyImages = (0, $zKxbI.AssetController).state.currencyImages;
        this.tokenImages = (0, $zKxbI.AssetController).state.tokenImages;
        this.unsubscribe.push((0, $jM3Wq.OnRampController).subscribeKey("purchaseCurrency", (val)=>{
            if (!val || this.type === "Fiat") return;
            this.selectedCurrency = this.formatPurchaseCurrency(val);
        }), (0, $jM3Wq.OnRampController).subscribeKey("paymentCurrency", (val)=>{
            if (!val || this.type === "Token") return;
            this.selectedCurrency = this.formatPaymentCurrency(val);
        }), (0, $jM3Wq.OnRampController).subscribe((val)=>{
            if (this.type === "Fiat") this.currencies = val.purchaseCurrencies.map(this.formatPurchaseCurrency);
            else this.currencies = val.paymentCurrencies.map(this.formatPaymentCurrency);
        }), (0, $zKxbI.AssetController).subscribe((val)=>{
            this.currencyImages = {
                ...val.currencyImages
            };
            this.tokenImages = {
                ...val.tokenImages
            };
        }));
    }
    firstUpdated() {
        (0, $jM3Wq.OnRampController).getAvailableCurrencies();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const symbol = this.selectedCurrency?.symbol || "";
        const image = this.currencyImages[symbol] || this.tokenImages[symbol];
        return (0, $aTf3K.html)`<wui-input-text type="number" size="lg" value=${this.value}>
      ${this.selectedCurrency ? (0, $aTf3K.html)` <wui-flex
            class="currency-container"
            justifyContent="space-between"
            alignItems="center"
            gap="xxs"
            @click=${()=>(0, $ib7WC.ModalController).open({
                view: `OnRamp${this.type}Select`
            })}
          >
            <wui-image src=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(image)}></wui-image>
            <wui-text color="fg-100">${this.selectedCurrency.symbol}</wui-text>
          </wui-flex>` : (0, $aTf3K.html)`<wui-loading-spinner></wui-loading-spinner>`}
    </wui-input-text>`;
    }
    formatPaymentCurrency(currency) {
        return {
            name: currency.id,
            symbol: currency.id
        };
    }
    formatPurchaseCurrency(currency) {
        return {
            name: currency.name,
            symbol: currency.symbol
        };
    }
};
$67c2ffa0a8e35ab3$export$8c7f6376138a05de.styles = (0, $ec38552d3f0877b4$export$2e2bcd8739ae039);
$67c2ffa0a8e35ab3$var$__decorate([
    (0, $jJP2r.property)({
        type: String
    })
], $67c2ffa0a8e35ab3$export$8c7f6376138a05de.prototype, "type", void 0);
$67c2ffa0a8e35ab3$var$__decorate([
    (0, $jJP2r.property)({
        type: Number
    })
], $67c2ffa0a8e35ab3$export$8c7f6376138a05de.prototype, "value", void 0);
$67c2ffa0a8e35ab3$var$__decorate([
    (0, $faUle.state)()
], $67c2ffa0a8e35ab3$export$8c7f6376138a05de.prototype, "currencies", void 0);
$67c2ffa0a8e35ab3$var$__decorate([
    (0, $faUle.state)()
], $67c2ffa0a8e35ab3$export$8c7f6376138a05de.prototype, "selectedCurrency", void 0);
$67c2ffa0a8e35ab3$var$__decorate([
    (0, $faUle.state)()
], $67c2ffa0a8e35ab3$export$8c7f6376138a05de.prototype, "currencyImages", void 0);
$67c2ffa0a8e35ab3$var$__decorate([
    (0, $faUle.state)()
], $67c2ffa0a8e35ab3$export$8c7f6376138a05de.prototype, "tokenImages", void 0);
$67c2ffa0a8e35ab3$export$8c7f6376138a05de = $67c2ffa0a8e35ab3$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-input")
], $67c2ffa0a8e35ab3$export$8c7f6376138a05de);


parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");

parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $jbD0z = parcelRequire("jbD0z");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $850db5a64dce306f$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  button {
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xs);
    border: none;
    outline: none;
    background-color: var(--wui-color-gray-glass-002);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--wui-spacing-s);
    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: background-color;
  }

  button:hover {
    background-color: var(--wui-color-gray-glass-005);
  }

  .provider-image {
    width: var(--wui-spacing-3xl);
    min-width: var(--wui-spacing-3xl);
    height: var(--wui-spacing-3xl);
    border-radius: calc(var(--wui-border-radius-xs) - calc(var(--wui-spacing-s) / 2));
    position: relative;
    overflow: hidden;
  }

  .provider-image::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-border-radius-xs) - calc(var(--wui-spacing-s) / 2));
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);
  }

  .network-icon {
    width: var(--wui-spacing-m);
    height: var(--wui-spacing-m);
    border-radius: calc(var(--wui-spacing-m) / 2);
    overflow: hidden;
    box-shadow:
      0 0 0 3px var(--wui-color-gray-glass-002),
      0 0 0 3px var(--wui-color-modal-bg);
    transition: box-shadow var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: box-shadow;
  }

  button:hover .network-icon {
    box-shadow:
      0 0 0 3px var(--wui-color-gray-glass-005),
      0 0 0 3px var(--wui-color-modal-bg);
  }
`;


var $c6e35fb574bcfbcf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425 = class W3mOnRampProviderItem extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
        this.label = "";
        this.feeRange = "";
        this.loading = false;
        this.onClick = null;
    }
    render() {
        return (0, $aTf3K.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-visual name=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.name)} class="provider-image"></wui-visual>
        <wui-flex flexDirection="column" gap="4xs">
          <wui-text variant="paragraph-500" color="fg-100">${this.label}</wui-text>
          <wui-flex alignItems="center" justifyContent="flex-start" gap="l">
            <wui-text variant="tiny-500" color="fg-100">
              <wui-text variant="tiny-400" color="fg-200">Fees</wui-text>
              ${this.feeRange}
            </wui-text>
            <wui-flex gap="xxs">
              <wui-icon name="bank" size="xs" color="fg-150"></wui-icon>
              <wui-icon name="card" size="xs" color="fg-150"></wui-icon>
            </wui-flex>
            ${this.networksTemplate()}
          </wui-flex>
        </wui-flex>
        ${this.loading ? (0, $aTf3K.html)`<wui-loading-spinner color="fg-200" size="md"></wui-loading-spinner>` : (0, $aTf3K.html)`<wui-icon name="chevronRight" color="fg-200" size="sm"></wui-icon>`}
      </button>
    `;
    }
    networksTemplate() {
        const requestedCaipNetworks = (0, $jbD0z.NetworkController).getRequestedCaipNetworks();
        const slicedNetworks = requestedCaipNetworks?.filter((network)=>network?.imageId)?.slice(0, 5);
        return (0, $aTf3K.html)`
      <wui-flex class="networks">
        ${slicedNetworks?.map((network)=>(0, $aTf3K.html)`
            <wui-flex class="network-icon">
              <wui-image src=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getNetworkImage(network))}></wui-image>
            </wui-flex>
          `)}
      </wui-flex>
    `;
    }
};
$c6e35fb574bcfbcf$export$b88f5e2e0c9c5425.styles = [
    (0, $850db5a64dce306f$export$2e2bcd8739ae039)
];
$c6e35fb574bcfbcf$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425.prototype, "disabled", void 0);
$c6e35fb574bcfbcf$var$__decorate([
    (0, $jJP2r.property)()
], $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425.prototype, "color", void 0);
$c6e35fb574bcfbcf$var$__decorate([
    (0, $jJP2r.property)()
], $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425.prototype, "name", void 0);
$c6e35fb574bcfbcf$var$__decorate([
    (0, $jJP2r.property)()
], $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425.prototype, "label", void 0);
$c6e35fb574bcfbcf$var$__decorate([
    (0, $jJP2r.property)()
], $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425.prototype, "feeRange", void 0);
$c6e35fb574bcfbcf$var$__decorate([
    (0, $jJP2r.property)({
        type: Boolean
    })
], $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425.prototype, "loading", void 0);
$c6e35fb574bcfbcf$var$__decorate([
    (0, $jJP2r.property)()
], $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425.prototype, "onClick", void 0);
$c6e35fb574bcfbcf$export$b88f5e2e0c9c5425 = $c6e35fb574bcfbcf$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-provider-item")
], $c6e35fb574bcfbcf$export$b88f5e2e0c9c5425);


parcelRequire("eNJDH");
var $8BVTM = parcelRequire("8BVTM");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $dcc6566d0d6ccb6c$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex {
    background-color: var(--wui-color-gray-glass-005);
  }

  a {
    text-decoration: none;
    color: var(--wui-color-fg-175);
    font-weight: 500;
  }
`;


var $79bed1533c746a97$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $79bed1533c746a97$export$c463b51fb31743f5 = class W3mLegalFooter extends (0, $g305D.LitElement) {
    render() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $8BVTM.OptionsController).state;
        if (!termsConditionsUrl && !privacyPolicyUrl) return null;
        return (0, $aTf3K.html)`
      <wui-flex .padding=${[
            "m",
            "s",
            "s",
            "s"
        ]} justifyContent="center">
        <wui-text color="fg-250" variant="small-400" align="center">
          By connecting your wallet, you agree to our <br />
          ${this.termsTemplate()} ${this.andTemplate()} ${this.privacyTemplate()}
        </wui-text>
      </wui-flex>
    `;
    }
    andTemplate() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $8BVTM.OptionsController).state;
        return termsConditionsUrl && privacyPolicyUrl ? "and" : "";
    }
    termsTemplate() {
        const { termsConditionsUrl: termsConditionsUrl } = (0, $8BVTM.OptionsController).state;
        if (!termsConditionsUrl) return null;
        return (0, $aTf3K.html)`<a href=${termsConditionsUrl}>Terms of Service</a>`;
    }
    privacyTemplate() {
        const { privacyPolicyUrl: privacyPolicyUrl } = (0, $8BVTM.OptionsController).state;
        if (!privacyPolicyUrl) return null;
        return (0, $aTf3K.html)`<a href=${privacyPolicyUrl}>Privacy Policy</a>`;
    }
};
$79bed1533c746a97$export$c463b51fb31743f5.styles = [
    (0, $dcc6566d0d6ccb6c$export$2e2bcd8739ae039)
];
$79bed1533c746a97$export$c463b51fb31743f5 = $79bed1533c746a97$var$__decorate([
    (0, $ailZp.customElement)("w3m-legal-footer")
], $79bed1533c746a97$export$c463b51fb31743f5);


parcelRequire("eNJDH");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $0012f26eba18ced4$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    display: block;
    padding: 0 var(--wui-spacing-xl) var(--wui-spacing-xl);
  }
`;


var $785a96ae43a24642$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $785a96ae43a24642$export$eabbdf5c2372470b = class W3mMobileDownloadLinks extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.wallet = undefined;
    }
    render() {
        if (!this.wallet) {
            this.style.display = "none";
            return null;
        }
        const { name: name, app_store: app_store, play_store: play_store, chrome_store: chrome_store, homepage: homepage } = this.wallet;
        const isMobile = (0, $c4rfq.CoreHelperUtil).isMobile();
        const isIos = (0, $c4rfq.CoreHelperUtil).isIos();
        const isAndroid = (0, $c4rfq.CoreHelperUtil).isAndroid();
        const isMultiple = [
            app_store,
            play_store,
            homepage,
            chrome_store
        ].filter(Boolean).length > 1;
        const shortName = (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: name,
            charsStart: 12,
            charsEnd: 0,
            truncate: "end"
        });
        if (isMultiple && !isMobile) return (0, $aTf3K.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${()=>(0, $6mRzS.RouterController).push("Downloads", {
                wallet: this.wallet
            })}
        ></wui-cta-button>
      `;
        if (!isMultiple && homepage) return (0, $aTf3K.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onHomePage.bind(this)}
        ></wui-cta-button>
      `;
        if (app_store && isIos) return (0, $aTf3K.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onAppStore.bind(this)}
        ></wui-cta-button>
      `;
        if (play_store && isAndroid) return (0, $aTf3K.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onPlayStore.bind(this)}
        ></wui-cta-button>
      `;
        this.style.display = "none";
        return null;
    }
    onAppStore() {
        if (this.wallet?.app_store) (0, $c4rfq.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
    }
    onPlayStore() {
        if (this.wallet?.play_store) (0, $c4rfq.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
    }
    onHomePage() {
        if (this.wallet?.homepage) (0, $c4rfq.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
    }
};
$785a96ae43a24642$export$eabbdf5c2372470b.styles = [
    (0, $0012f26eba18ced4$export$2e2bcd8739ae039)
];
$785a96ae43a24642$var$__decorate([
    (0, $jJP2r.property)({
        type: Object
    })
], $785a96ae43a24642$export$eabbdf5c2372470b.prototype, "wallet", void 0);
$785a96ae43a24642$export$eabbdf5c2372470b = $785a96ae43a24642$var$__decorate([
    (0, $ailZp.customElement)("w3m-mobile-download-links")
], $785a96ae43a24642$export$eabbdf5c2372470b);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $6m17w = parcelRequire("6m17w");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $ac1a8aba9d5d55b0$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex {
    border-top: 1px solid var(--wui-color-gray-glass-005);
  }

  a {
    text-decoration: none;
    color: var(--wui-color-fg-175);
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--wui-spacing-3xs);
  }
`;


parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $0e3e787fdc9a1e1e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0e3e787fdc9a1e1e$export$1877b66553939a5b = class W3mOnRampProvidersFooter extends (0, $g305D.LitElement) {
    render() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $8BVTM.OptionsController).state;
        if (!termsConditionsUrl && !privacyPolicyUrl) return null;
        return (0, $aTf3K.html)`
      <wui-flex
        .padding=${[
            "m",
            "s",
            "s",
            "s"
        ]}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="s"
      >
        <wui-text color="fg-250" variant="small-400" align="center">
          We work with the best providers to give you the lowest fees and best support. More options
          coming soon!
        </wui-text>

        ${this.howDoesItWorkTemplate()}
      </wui-flex>
    `;
    }
    howDoesItWorkTemplate() {
        return (0, $aTf3K.html)` <wui-link @click=${this.onWhatIsBuy.bind(this)}>
      <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>
      How does it work?
    </wui-link>`;
    }
    onWhatIsBuy() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WHAT_IS_A_BUY",
            properties: {
                isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
            }
        });
        (0, $6mRzS.RouterController).push("WhatIsABuy");
    }
};
$0e3e787fdc9a1e1e$export$1877b66553939a5b.styles = [
    (0, $ac1a8aba9d5d55b0$export$2e2bcd8739ae039)
];
$0e3e787fdc9a1e1e$export$1877b66553939a5b = $0e3e787fdc9a1e1e$var$__decorate([
    (0, $ailZp.customElement)("w3m-onramp-providers-footer")
], $0e3e787fdc9a1e1e$export$1877b66553939a5b);


parcelRequire("eNJDH");
var $br7WV = parcelRequire("br7WV");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $ba13c9ede4237f94$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    display: block;
    position: absolute;
    opacity: 0;
    pointer-events: none;
    top: 11px;
    left: 50%;
    width: max-content;
  }
`;


var $3dc67a2680ba6a7d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $3dc67a2680ba6a7d$var$presets = {
    loading: undefined,
    success: {
        backgroundColor: "success-100",
        iconColor: "success-100",
        icon: "checkmark"
    },
    error: {
        backgroundColor: "error-100",
        iconColor: "error-100",
        icon: "close"
    }
};
let $3dc67a2680ba6a7d$export$a84538312ac1ab9d = class W3mSnackBar extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.timeout = undefined;
        this.open = (0, $br7WV.SnackController).state.open;
        this.unsubscribe.push((0, $br7WV.SnackController).subscribeKey("open", (val)=>{
            this.open = val;
            this.onOpen();
        }));
    }
    disconnectedCallback() {
        clearTimeout(this.timeout);
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const { message: message, variant: variant } = (0, $br7WV.SnackController).state;
        const preset = $3dc67a2680ba6a7d$var$presets[variant];
        return (0, $aTf3K.html)`
      <wui-snackbar
        message=${message}
        backgroundColor=${preset?.backgroundColor}
        iconColor=${preset?.iconColor}
        icon=${preset?.icon}
        .loading=${variant === "loading"}
      ></wui-snackbar>
    `;
    }
    onOpen() {
        clearTimeout(this.timeout);
        if (this.open) {
            this.animate([
                {
                    opacity: 0,
                    transform: "translateX(-50%) scale(0.85)"
                },
                {
                    opacity: 1,
                    transform: "translateX(-50%) scale(1)"
                }
            ], {
                duration: 150,
                fill: "forwards",
                easing: "ease"
            });
            this.timeout = setTimeout(()=>(0, $br7WV.SnackController).hide(), 2500);
        } else this.animate([
            {
                opacity: 1,
                transform: "translateX(-50%) scale(1)"
            },
            {
                opacity: 0,
                transform: "translateX(-50%) scale(0.85)"
            }
        ], {
            duration: 150,
            fill: "forwards",
            easing: "ease"
        });
    }
};
$3dc67a2680ba6a7d$export$a84538312ac1ab9d.styles = (0, $ba13c9ede4237f94$export$2e2bcd8739ae039);
$3dc67a2680ba6a7d$var$__decorate([
    (0, $faUle.state)()
], $3dc67a2680ba6a7d$export$a84538312ac1ab9d.prototype, "open", void 0);
$3dc67a2680ba6a7d$export$a84538312ac1ab9d = $3dc67a2680ba6a7d$var$__decorate([
    (0, $ailZp.customElement)("w3m-snackbar")
], $3dc67a2680ba6a7d$export$a84538312ac1ab9d);


parcelRequire("eNJDH");
var $d94Xg = parcelRequire("d94Xg");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $00218b6570d43983$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-separator {
    margin: var(--wui-spacing-s) calc(var(--wui-spacing-s) * -1);
    width: calc(100% + var(--wui-spacing-s) * 2);
  }

  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }

  wui-icon-link,
  wui-loading-spinner {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  wui-icon-link {
    right: var(--wui-spacing-xs);
  }

  wui-loading-spinner {
    right: var(--wui-spacing-m);
  }
`;


parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
var $7d5ec5f8ff8df1cf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7d5ec5f8ff8df1cf$export$73f53e8345d3576d = class W3mEmailLoginWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.formRef = (0, $8fa5b8d3f98eecf3$export$7d1e3a5e95ceca43)();
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.email = "";
        this.loading = false;
        this.error = "";
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.onSubmitEmail(event);
        });
    }
    render() {
        const connector = this.connectors.find((c)=>c.type === "AUTH");
        const multipleConnectors = this.connectors.length > 1;
        if (!connector?.email) return null;
        return (0, $aTf3K.html)`
      <form ${(0, $8fa5b8d3f98eecf3$export$eff4d24c3ff7876e)(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
        <wui-email-input
          @focus=${this.onFocusEvent.bind(this)}
          .disabled=${this.loading}
          @inputChange=${this.onEmailInputChange.bind(this)}
          .errorMessage=${this.error}
        >
        </wui-email-input>

        ${this.submitButtonTemplate()}${this.loadingTemplate()}
        <input type="submit" hidden />
      </form>

      ${connector.socials || !multipleConnectors ? null : (0, $aTf3K.html)`<wui-flex .padding=${[
            "xxs",
            "0",
            "0",
            "0"
        ]}>
            <wui-separator text="or"></wui-separator>
          </wui-flex>`}
    `;
    }
    submitButtonTemplate() {
        const showSubmit = !this.loading && this.email.length > 3;
        return showSubmit ? (0, $aTf3K.html)`
          <wui-icon-link
            size="sm"
            icon="chevronRight"
            iconcolor="accent-100"
            @click=${this.onSubmitEmail.bind(this)}
          >
          </wui-icon-link>
        ` : null;
    }
    loadingTemplate() {
        return this.loading ? (0, $aTf3K.html)`<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>` : null;
    }
    onEmailInputChange(event) {
        this.email = event.detail.trim();
        this.error = "";
    }
    async onSubmitEmail(event) {
        const availableChains = [
            (0, $1VCt9.ConstantsUtil).CHAIN.EVM,
            (0, $1VCt9.ConstantsUtil).CHAIN.SOLANA
        ];
        const isAvailableChain = availableChains.find((chain)=>chain === (0, $d94Xg.ChainController).state.activeChain);
        if (!isAvailableChain) {
            (0, $6mRzS.RouterController).push("SwitchActiveChain", {
                switchToChain: (0, $1VCt9.ConstantsUtil).CHAIN.EVM
            });
            return;
        }
        try {
            if (this.loading) return;
            this.loading = true;
            event.preventDefault();
            const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
            if (!authConnector) throw new Error("w3m-email-login-widget: Auth connector not found");
            const { action: action } = await authConnector.provider.connectEmail({
                email: this.email
            });
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_SUBMITTED"
            });
            if (action === "VERIFY_OTP") {
                (0, $6m17w.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_SENT"
                });
                (0, $6mRzS.RouterController).push("EmailVerifyOtp", {
                    email: this.email
                });
            } else if (action === "VERIFY_DEVICE") (0, $6mRzS.RouterController).push("EmailVerifyDevice", {
                email: this.email
            });
        } catch (error) {
            const parsedError = (0, $c4rfq.CoreHelperUtil).parseError(error);
            if (parsedError?.includes("Invalid email")) this.error = "Invalid email. Try again.";
            else (0, $br7WV.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
    onFocusEvent() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_LOGIN_SELECTED"
        });
    }
};
$7d5ec5f8ff8df1cf$export$73f53e8345d3576d.styles = (0, $00218b6570d43983$export$2e2bcd8739ae039);
$7d5ec5f8ff8df1cf$var$__decorate([
    (0, $faUle.state)()
], $7d5ec5f8ff8df1cf$export$73f53e8345d3576d.prototype, "connectors", void 0);
$7d5ec5f8ff8df1cf$var$__decorate([
    (0, $faUle.state)()
], $7d5ec5f8ff8df1cf$export$73f53e8345d3576d.prototype, "email", void 0);
$7d5ec5f8ff8df1cf$var$__decorate([
    (0, $faUle.state)()
], $7d5ec5f8ff8df1cf$export$73f53e8345d3576d.prototype, "loading", void 0);
$7d5ec5f8ff8df1cf$var$__decorate([
    (0, $faUle.state)()
], $7d5ec5f8ff8df1cf$export$73f53e8345d3576d.prototype, "error", void 0);
$7d5ec5f8ff8df1cf$export$73f53e8345d3576d = $7d5ec5f8ff8df1cf$var$__decorate([
    (0, $ailZp.customElement)("w3m-email-login-widget")
], $7d5ec5f8ff8df1cf$export$73f53e8345d3576d);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $d94Xg = parcelRequire("d94Xg");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $6AwK8 = parcelRequire("6AwK8");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $06d568f596950958$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex {
    width: 100%;
  }

  :host > wui-flex:first-child {
    transform: translateY(calc(var(--wui-spacing-xxs) * -1));
  }

  wui-icon-link {
    margin-right: calc(var(--wui-icon-box-size-md) * -1);
  }

  wui-notice-card {
    margin-bottom: var(--wui-spacing-3xs);
  }

  wui-list-item > wui-text {
    flex: 1;
  }

  w3m-transactions-view {
    max-height: 200px;
  }

  .tab-content-container {
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }

  .tab-content-container::-webkit-scrollbar {
    display: none;
  }

  .account-button {
    width: auto;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--wui-spacing-s);
    height: 48px;
    padding: var(--wui-spacing-xs);
    padding-right: var(--wui-spacing-s);
    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);
    background-color: var(--wui-color-gray-glass-002);
    border-radius: 24px;
    transition: background-color 0.2s linear;
  }

  .account-button:hover {
    background-color: var(--wui-color-gray-glass-005);
  }

  .avatar-container {
    position: relative;
  }

  wui-avatar.avatar {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);
  }

  wui-avatar.network-avatar {
    width: 16px;
    height: 16px;
    position: absolute;
    left: 100%;
    top: 100%;
    transform: translate(-75%, -75%);
    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);
  }

  .account-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .account-links wui-flex {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: red;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 10px;
    flex: 1 0 0;
    border-radius: var(--XS, 16px);
    border: 1px solid var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    background: var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    transition:
      background-color var(--wui-ease-out-power-1) var(--wui-duration-md),
      opacity var(--wui-ease-out-power-1) var(--wui-duration-md);
    will-change: background-color, opacity;
  }

  .account-links wui-flex:hover {
    background: var(--dark-accent-glass-015, rgba(71, 161, 255, 0.15));
  }

  .account-links wui-flex wui-icon {
    width: var(--S, 20px);
    height: var(--S, 20px);
  }

  .account-links wui-flex wui-icon svg path {
    stroke: #667dff;
  }
`;


var $e67eafda891c6ec2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e67eafda891c6ec2$export$6c58fb2c5893d9b3 = class W3mAccountDefaultWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.address = (0, $f7IXw.AccountController).state.address;
        this.profileImage = (0, $f7IXw.AccountController).state.profileImage;
        this.profileName = (0, $f7IXw.AccountController).state.profileName;
        this.disconnecting = false;
        this.balance = (0, $f7IXw.AccountController).state.balance;
        this.balanceSymbol = (0, $f7IXw.AccountController).state.balanceSymbol;
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileImage = val.profileImage;
                    this.profileName = val.profileName;
                    this.balance = val.balance;
                    this.balanceSymbol = val.balanceSymbol;
                } else if (!this.disconnecting) (0, $br7WV.SnackController).showError("Account not found");
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-account-view: No account provided");
        return (0, $aTf3K.html)`<wui-flex
        flexDirection="column"
        .padding=${[
            "0",
            "xl",
            "m",
            "xl"
        ]}
        alignItems="center"
        gap="l"
      >
        ${(0, $d94Xg.ChainController).state.activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.EVM ? this.multiAccountTemplate() : this.singleAccountTemplate()}
        <wui-flex flexDirection="column" alignItems="center">
          <wui-text variant="paragraph-500" color="fg-200">
            ${(0, $c4rfq.CoreHelperUtil).formatBalance(this.balance, this.balanceSymbol)}
          </wui-text>
        </wui-flex>
        ${this.explorerBtnTemplate()}
      </wui-flex>

      <wui-flex flexDirection="column" gap="xs" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}>
        ${this.authCardTemplate()} <w3m-account-auth-button></w3m-account-auth-button>
        ${this.onrampTemplate()} ${this.swapsTemplate()} ${this.activityTemplate()}
        <wui-list-item
          variant="icon"
          iconVariant="overlay"
          icon="disconnect"
          ?chevron=${false}
          .loading=${this.disconnecting}
          @click=${this.onDisconnect.bind(this)}
          data-testid="disconnect-button"
        >
          <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
        </wui-list-item>
      </wui-flex>`;
    }
    onrampTemplate() {
        const { enableOnramp: enableOnramp } = (0, $8BVTM.OptionsController).state;
        const isSolana = (0, $d94Xg.ChainController).state.activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.SOLANA;
        if (!enableOnramp || isSolana) return null;
        return (0, $aTf3K.html)`
      <wui-list-item
        data-testid="w3m-account-default-onramp-button"
        iconVariant="blue"
        icon="card"
        ?chevron=${true}
        @click=${this.handleClickPay.bind(this)}
      >
        <wui-text variant="paragraph-500" color="fg-100">Buy crypto</wui-text>
      </wui-list-item>
    `;
    }
    activityTemplate() {
        const isSolana = (0, $d94Xg.ChainController).state.activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.SOLANA;
        return (0, $aTf3K.html)` <wui-list-item
      iconVariant="blue"
      icon="clock"
      iconSize="sm"
      ?chevron=${!isSolana}
      ?disabled=${isSolana}
      @click=${this.onTransactions.bind(this)}
    >
      <wui-text variant="paragraph-500" color="fg-100" ?disabled=${isSolana}> Activity </wui-text>
      ${isSolana ? (0, $aTf3K.html)`<wui-tag variant="main">Coming soon</wui-tag>` : ""}
    </wui-list-item>`;
    }
    swapsTemplate() {
        const { enableSwaps: enableSwaps } = (0, $8BVTM.OptionsController).state;
        if (!enableSwaps || (0, $d94Xg.ChainController).state.activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.SOLANA) return null;
        return (0, $aTf3K.html)`
      <wui-list-item
        iconVariant="blue"
        icon="recycleHorizontal"
        ?chevron=${true}
        @click=${this.handleClickSwap.bind(this)}
      >
        <wui-text variant="paragraph-500" color="fg-100">Swap</wui-text>
      </wui-list-item>
    `;
    }
    authCardTemplate() {
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        const { origin: origin } = location;
        if (!authConnector || type !== "AUTH" || origin.includes((0, $6AwK8.ConstantsUtil).SECURE_SITE)) return null;
        return (0, $aTf3K.html)`
      <wui-notice-card
        @click=${this.onGoToUpgradeView.bind(this)}
        label="Upgrade your wallet"
        description="Transition to a self-custodial wallet"
        icon="wallet"
        data-testid="w3m-wallet-upgrade-card"
      ></wui-notice-card>
    `;
    }
    handleSwitchAccountsView() {
        (0, $6mRzS.RouterController).push("SwitchAddress");
    }
    handleClickPay() {
        (0, $6mRzS.RouterController).push("OnRampProviders");
    }
    handleClickSwap() {
        (0, $6mRzS.RouterController).push("Swap");
    }
    explorerBtnTemplate() {
        const addressExplorerUrl = (0, $f7IXw.AccountController).state.addressExplorerUrl;
        if (!addressExplorerUrl) return null;
        return (0, $aTf3K.html)`
      <wui-button size="md" variant="neutral" @click=${this.onExplorer.bind(this)}>
        <wui-icon size="sm" color="inherit" slot="iconLeft" name="compass"></wui-icon>
        Block Explorer
        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink"></wui-icon>
      </wui-button>
    `;
    }
    singleAccountTemplate() {
        return (0, $aTf3K.html)`
      <wui-avatar
        alt=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.address)}
        address=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.address)}
        imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.profileImage === null ? undefined : this.profileImage)}
      ></wui-avatar>
      <wui-flex flexDirection="column" alignItems="center">
        <wui-flex gap="3xs" alignItems="center" justifyContent="center">
          <wui-text variant="large-600" color="fg-100">
            ${this.profileName ? (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.profileName,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.address ? this.address : "",
            charsStart: 4,
            charsEnd: 4,
            truncate: "middle"
        })}
          </wui-text>
          <wui-icon-link
            size="md"
            icon="copy"
            iconColor="fg-200"
            @click=${this.onCopyAddress}
          ></wui-icon-link> </wui-flex
      ></wui-flex>
    `;
    }
    multiAccountTemplate() {
        if (!this.address) throw new Error("w3m-account-view: No account provided");
        const account = (0, $f7IXw.AccountController).state.allAccounts?.find((acc)=>acc.address === this.address);
        const label = (0, $f7IXw.AccountController).state.addressLabels.get(this.address);
        return (0, $aTf3K.html)`
      <wui-profile-button-v2
        .onProfileClick=${this.handleSwitchAccountsView.bind(this)}
        address=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.address)}
        icon="${account?.type === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT && (0, $d94Xg.ChainController).state.activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.EVM ? "lightbulb" : "mail"}"
        avatarSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.profileImage ? this.profileImage : undefined)}
        profileName=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(label ? label : this.profileName)}
        .onCopyClick=${this.onCopyAddress.bind(this)}
      ></wui-profile-button-v2>
    `;
    }
    onCopyAddress() {
        try {
            if (this.address) {
                (0, $c4rfq.CoreHelperUtil).copyToClopboard(this.address);
                (0, $br7WV.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $br7WV.SnackController).showError("Failed to copy");
        }
    }
    onTransactions() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "CLICK_TRANSACTIONS",
            properties: {
                isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
            }
        });
        (0, $6mRzS.RouterController).push("Transactions");
    }
    async onDisconnect() {
        try {
            this.disconnecting = true;
            await (0, $hlVrM.ConnectionController).disconnect();
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $ib7WC.ModalController).close();
        } catch  {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $br7WV.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconnecting = false;
        }
    }
    onExplorer() {
        const addressExplorerUrl = (0, $f7IXw.AccountController).state.addressExplorerUrl;
        if (addressExplorerUrl) (0, $c4rfq.CoreHelperUtil).openHref(addressExplorerUrl, "_blank");
    }
    onGoToUpgradeView() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_UPGRADE_FROM_MODAL"
        });
        (0, $6mRzS.RouterController).push("UpgradeEmailWallet");
    }
};
$e67eafda891c6ec2$export$6c58fb2c5893d9b3.styles = (0, $06d568f596950958$export$2e2bcd8739ae039);
$e67eafda891c6ec2$var$__decorate([
    (0, $faUle.state)()
], $e67eafda891c6ec2$export$6c58fb2c5893d9b3.prototype, "address", void 0);
$e67eafda891c6ec2$var$__decorate([
    (0, $faUle.state)()
], $e67eafda891c6ec2$export$6c58fb2c5893d9b3.prototype, "profileImage", void 0);
$e67eafda891c6ec2$var$__decorate([
    (0, $faUle.state)()
], $e67eafda891c6ec2$export$6c58fb2c5893d9b3.prototype, "profileName", void 0);
$e67eafda891c6ec2$var$__decorate([
    (0, $faUle.state)()
], $e67eafda891c6ec2$export$6c58fb2c5893d9b3.prototype, "disconnecting", void 0);
$e67eafda891c6ec2$var$__decorate([
    (0, $faUle.state)()
], $e67eafda891c6ec2$export$6c58fb2c5893d9b3.prototype, "balance", void 0);
$e67eafda891c6ec2$var$__decorate([
    (0, $faUle.state)()
], $e67eafda891c6ec2$export$6c58fb2c5893d9b3.prototype, "balanceSymbol", void 0);
$e67eafda891c6ec2$export$6c58fb2c5893d9b3 = $e67eafda891c6ec2$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-default-widget")
], $e67eafda891c6ec2$export$6c58fb2c5893d9b3);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $eOULk = parcelRequire("eOULk");
var $6AwK8 = parcelRequire("6AwK8");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $jbD0z = parcelRequire("jbD0z");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $f260375e0a543384$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  wui-flex {
    width: 100%;
  }

  wui-promo {
    position: absolute;
    top: -32px;
  }

  wui-profile-button {
    margin-top: calc(-1 * var(--wui-spacing-2l));
  }

  wui-promo + wui-profile-button {
    margin-top: var(--wui-spacing-2l);
  }

  wui-tabs {
    width: 100%;
  }

  .contentContainer {
    height: 280px;
  }

  .contentContainer > wui-icon-box {
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-xxs);
  }

  .contentContainer > .textContent {
    width: 65%;
  }
`;



parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $6aac3072f8dc585e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $6aac3072f8dc585e$var$TABS = 3;
const $6aac3072f8dc585e$var$TABS_PADDING = 48;
const $6aac3072f8dc585e$var$MODAL_MOBILE_VIEW_PX = 430;
let $6aac3072f8dc585e$export$40fe2014a0a05eaf = class W3mAccountWalletFeaturesWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.address = (0, $f7IXw.AccountController).state.address;
        this.profileImage = (0, $f7IXw.AccountController).state.profileImage;
        this.profileName = (0, $f7IXw.AccountController).state.profileName;
        this.smartAccountDeployed = (0, $f7IXw.AccountController).state.smartAccountDeployed;
        this.network = (0, $jbD0z.NetworkController).state.caipNetwork;
        this.currentTab = (0, $f7IXw.AccountController).state.currentTab;
        this.tokenBalance = (0, $f7IXw.AccountController).state.tokenBalance;
        this.preferredAccountType = (0, $f7IXw.AccountController).state.preferredAccountType;
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileImage = val.profileImage;
                    this.profileName = val.profileName;
                    this.currentTab = val.currentTab;
                    this.tokenBalance = val.tokenBalance;
                    this.smartAccountDeployed = val.smartAccountDeployed;
                    this.preferredAccountType = val.preferredAccountType;
                } else (0, $ib7WC.ModalController).close();
            })
        ], (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", (val)=>{
            this.network = val;
        }));
        this.watchSwapValues();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        clearInterval(this.watchTokenBalance);
    }
    firstUpdated() {
        (0, $f7IXw.AccountController).fetchTokenBalance();
    }
    render() {
        if (!this.address) throw new Error("w3m-account-view: No account provided");
        const networkImage = (0, $eOULk.AssetUtil).getNetworkImage(this.network);
        return (0, $aTf3K.html)`<wui-flex
      flexDirection="column"
      .padding=${[
            "0",
            "xl",
            "m",
            "xl"
        ]}
      alignItems="center"
      gap="m"
    >
      ${this.network && (0, $aTf3K.html)`<wui-network-icon .network=${this.network}></wui-network-icon>`}
      ${this.activateAccountTemplate()}
      <wui-profile-button
        @click=${this.onProfileButtonClick.bind(this)}
        address=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.address)}
        networkSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(networkImage)}
        icon="chevronBottom"
        avatarSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.profileImage ? this.profileImage : undefined)}
        profileName=${this.profileName}
        data-testid="w3m-profile-button"
      ></wui-profile-button>
      ${this.tokenBalanceTemplate()}
      <wui-flex gap="s">
        <w3m-tooltip-trigger text="Buy">
          <wui-icon-button
            data-testid="wallet-features-onramp-button"
            @click=${this.onBuyClick.bind(this)}
            icon="card"
          ></wui-icon-button>
        </w3m-tooltip-trigger>
        ${this.swapsTemplate()}
        <w3m-tooltip-trigger text="Receive">
          <wui-icon-button
            data-testid="wallet-features-receive-button"
            @click=${this.onReceiveClick.bind(this)}
            icon="arrowBottomCircle"
          >
          </wui-icon-button>
        </w3m-tooltip-trigger>
        <w3m-tooltip-trigger text="Send">
          <wui-icon-button
            data-testid="wallet-features-send-button"
            @click=${this.onSendClick.bind(this)}
            icon="send"
          ></wui-icon-button>
        </w3m-tooltip-trigger>
      </wui-flex>

      <wui-tabs
        .onTabChange=${this.onTabChange.bind(this)}
        .activeTab=${this.currentTab}
        localTabWidth=${(0, $c4rfq.CoreHelperUtil).isMobile() && window.innerWidth < $6aac3072f8dc585e$var$MODAL_MOBILE_VIEW_PX ? `${(window.innerWidth - $6aac3072f8dc585e$var$TABS_PADDING) / $6aac3072f8dc585e$var$TABS}px` : "104px"}
        .tabs=${(0, $0a65cf42ecb45995$export$aafe1f751f1bc52a).ACCOUNT_TABS}
      ></wui-tabs>
      ${this.listContentTemplate()}
    </wui-flex>`;
    }
    swapsTemplate() {
        const { enableSwaps: enableSwaps } = (0, $8BVTM.OptionsController).state;
        if (!enableSwaps) return null;
        return (0, $aTf3K.html)`
      <w3m-tooltip-trigger text="Swap">
        <wui-icon-button
          data-testid="wallet-features-swap-button"
          @click=${this.onSwapClick.bind(this)}
          icon="recycleHorizontal"
        >
        </wui-icon-button>
      </w3m-tooltip-trigger>
    `;
    }
    watchSwapValues() {
        this.watchTokenBalance = setInterval(()=>(0, $f7IXw.AccountController).fetchTokenBalance(), 10000);
    }
    listContentTemplate() {
        if (this.currentTab === 0) return (0, $aTf3K.html)`<w3m-account-tokens-widget></w3m-account-tokens-widget>`;
        if (this.currentTab === 1) return (0, $aTf3K.html)`<w3m-account-nfts-widget></w3m-account-nfts-widget>`;
        if (this.currentTab === 2) return (0, $aTf3K.html)`<w3m-account-activity-widget></w3m-account-activity-widget>`;
        return (0, $aTf3K.html)`<w3m-account-tokens-widget></w3m-account-tokens-widget>`;
    }
    tokenBalanceTemplate() {
        if (this.tokenBalance && this.tokenBalance?.length >= 0) {
            const value = (0, $c4rfq.CoreHelperUtil).calculateBalance(this.tokenBalance);
            const { dollars: dollars = "0", pennies: pennies = "00" } = (0, $c4rfq.CoreHelperUtil).formatTokenBalance(value);
            return (0, $aTf3K.html)`<wui-balance dollars=${dollars} pennies=${pennies}></wui-balance>`;
        }
        return (0, $aTf3K.html)`<wui-balance dollars="0" pennies="00"></wui-balance>`;
    }
    activateAccountTemplate() {
        const smartAccountEnabled = (0, $jbD0z.NetworkController).checkIfSmartAccountEnabled();
        if (!smartAccountEnabled || this.preferredAccountType !== (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA || this.smartAccountDeployed) return null;
        return (0, $aTf3K.html)` <wui-promo
      text=${"Activate your account"}
      @click=${this.onUpdateToSmartAccount.bind(this)}
      data-testid="activate-smart-account-promo"
    ></wui-promo>`;
    }
    onTabChange(index) {
        (0, $f7IXw.AccountController).setCurrentTab(index);
    }
    onProfileButtonClick() {
        (0, $6mRzS.RouterController).push("Profile");
    }
    onBuyClick() {
        (0, $6mRzS.RouterController).push("OnRampProviders");
    }
    onSwapClick() {
        if (this.network?.id && !(0, $6AwK8.ConstantsUtil).SWAP_SUPPORTED_NETWORKS.includes(this.network?.id)) (0, $6mRzS.RouterController).push("UnsupportedChain", {
            swapUnsupportedChain: true
        });
        else {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "OPEN_SWAP",
                properties: {
                    network: this.network?.id || "",
                    isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                }
            });
            (0, $6mRzS.RouterController).push("Swap");
        }
    }
    onReceiveClick() {
        (0, $6mRzS.RouterController).push("WalletReceive");
    }
    onSendClick() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "OPEN_SEND",
            properties: {
                network: this.network?.id || "",
                isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
            }
        });
        (0, $6mRzS.RouterController).push("WalletSend");
    }
    onUpdateToSmartAccount() {
        (0, $6mRzS.RouterController).push("UpgradeToSmartAccount");
    }
};
$6aac3072f8dc585e$export$40fe2014a0a05eaf.styles = (0, $f260375e0a543384$export$2e2bcd8739ae039);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "watchTokenBalance", void 0);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "address", void 0);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "profileImage", void 0);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "profileName", void 0);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "smartAccountDeployed", void 0);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "network", void 0);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "currentTab", void 0);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "tokenBalance", void 0);
$6aac3072f8dc585e$var$__decorate([
    (0, $faUle.state)()
], $6aac3072f8dc585e$export$40fe2014a0a05eaf.prototype, "preferredAccountType", void 0);
$6aac3072f8dc585e$export$40fe2014a0a05eaf = $6aac3072f8dc585e$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-wallet-features-widget")
], $6aac3072f8dc585e$export$40fe2014a0a05eaf);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $942e9b9dae441ffb$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
    max-height: 280px;
    overflow: scroll;
    scrollbar-width: none;
  }

  :host::-webkit-scrollbar {
    display: none;
  }
`;


var $949c1bfe9fbb638d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $949c1bfe9fbb638d$export$703a5b3cf022b6fa = class W3mAccountActivityWidget extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`<w3m-activity-list page="account"></w3m-activity-list>`;
    }
};
$949c1bfe9fbb638d$export$703a5b3cf022b6fa.styles = (0, $942e9b9dae441ffb$export$2e2bcd8739ae039);
$949c1bfe9fbb638d$export$703a5b3cf022b6fa = $949c1bfe9fbb638d$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-activity-widget")
], $949c1bfe9fbb638d$export$703a5b3cf022b6fa);


parcelRequire("eNJDH");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $afbd7790da828604$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  .contentContainer {
    height: 280px;
  }

  .contentContainer > wui-icon-box {
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-xxs);
  }

  .contentContainer > .textContent {
    width: 65%;
  }
`;


var $265cb7ecd83b85b0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $265cb7ecd83b85b0$export$f8df4d2d7652c9e = class W3mAccountNftsWidget extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`${this.nftTemplate()}`;
    }
    nftTemplate() {
        return (0, $aTf3K.html)` <wui-flex
      class="contentContainer"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap="l"
    >
      <wui-icon-box
        icon="wallet"
        size="inherit"
        iconColor="fg-200"
        backgroundColor="fg-200"
        iconSize="lg"
      ></wui-icon-box>
      <wui-flex
        class="textContent"
        gap="xs"
        flexDirection="column"
        justifyContent="center"
        flexDirection="column"
      >
        <wui-text variant="paragraph-500" align="center" color="fg-100">Coming soon</wui-text>
        <wui-text variant="small-400" align="center" color="fg-200"
          >Stay tuned for our upcoming NFT feature</wui-text
        >
      </wui-flex>
      <wui-link @click=${this.onReceiveClick.bind(this)}>Receive funds</wui-link>
    </wui-flex>`;
    }
    onReceiveClick() {
        (0, $6mRzS.RouterController).push("WalletReceive");
    }
};
$265cb7ecd83b85b0$export$f8df4d2d7652c9e.styles = (0, $afbd7790da828604$export$2e2bcd8739ae039);
$265cb7ecd83b85b0$export$f8df4d2d7652c9e = $265cb7ecd83b85b0$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-nfts-widget")
], $265cb7ecd83b85b0$export$f8df4d2d7652c9e);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $29d7d80fbe24c7b9$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
  }

  wui-flex {
    width: 100%;
  }

  .contentContainer {
    max-height: 280px;
    overflow: scroll;
    scrollbar-width: none;
  }

  .contentContainer::-webkit-scrollbar {
    display: none;
  }
`;


parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
var $cd7c857c5d8fa553$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $cd7c857c5d8fa553$export$e09eb41ed15591bb = class W3mAccountTokensWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.tokenBalance = (0, $f7IXw.AccountController).state.tokenBalance;
        this.unsubscribe.push(...[
            (0, $f7IXw.AccountController).subscribe((val)=>{
                this.tokenBalance = val.tokenBalance;
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)`${this.tokenTemplate()}`;
    }
    tokenTemplate() {
        if (this.tokenBalance && this.tokenBalance?.length > 0) return (0, $aTf3K.html)`<wui-flex class="contentContainer" flexDirection="column" gap="xs">
        ${this.tokenItemTemplate()}
      </wui-flex>`;
        return (0, $aTf3K.html)` <wui-flex flexDirection="column" gap="xs"
      ><wui-list-description
        @click=${this.onBuyClick.bind(this)}
        text="Buy Crypto"
        description="Easy with card or bank account"
        icon="card"
        iconColor="success-100"
        iconBackgroundColor="success-100"
        tag="popular"
      ></wui-list-description
      ><wui-list-description
        @click=${this.onReceiveClick.bind(this)}
        text="Receive funds"
        description="Transfer tokens on your wallet"
        icon="arrowBottomCircle"
        iconColor="fg-200"
        iconBackgroundColor="fg-200"
      ></wui-list-description
    ></wui-flex>`;
    }
    tokenItemTemplate() {
        return this.tokenBalance?.map((token)=>(0, $aTf3K.html)`<wui-list-token
          tokenName=${token.name}
          tokenImageUrl=${token.iconUrl}
          tokenAmount=${token.quantity.numeric}
          tokenValue=${token.value}
          tokenCurrency=${token.symbol}
        ></wui-list-token>`);
    }
    onReceiveClick() {
        (0, $6mRzS.RouterController).push("WalletReceive");
    }
    onBuyClick() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "SELECT_BUY_CRYPTO",
            properties: {
                isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
            }
        });
        (0, $6mRzS.RouterController).push("OnRampProviders");
    }
};
$cd7c857c5d8fa553$export$e09eb41ed15591bb.styles = (0, $29d7d80fbe24c7b9$export$2e2bcd8739ae039);
$cd7c857c5d8fa553$var$__decorate([
    (0, $faUle.state)()
], $cd7c857c5d8fa553$export$e09eb41ed15591bb.prototype, "tokenBalance", void 0);
$cd7c857c5d8fa553$export$e09eb41ed15591bb = $cd7c857c5d8fa553$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-tokens-widget")
], $cd7c857c5d8fa553$export$e09eb41ed15591bb);


parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
var $5kBvB = parcelRequire("5kBvB");
parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $d94Xg = parcelRequire("d94Xg");
var $6m17w = parcelRequire("6m17w");
var $jbD0z = parcelRequire("jbD0z");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
var $i2wHx = parcelRequire("i2wHx");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $6emWt = parcelRequire("6emWt");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");
parcelRequire("dUH6N");
var $lr7C8 = parcelRequire("lr7C8");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $6737535b5df8b9f6$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    min-height: 100%;
  }

  .group-container[last-group='true'] {
    padding-bottom: var(--wui-spacing-m);
  }

  .contentContainer {
    height: 280px;
  }

  .contentContainer > wui-icon-box {
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-xxs);
  }

  .contentContainer > .textContent {
    width: 65%;
  }

  .emptyContainer {
    height: 100%;
  }
`;


var $eaac49ebfff0764e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $eaac49ebfff0764e$var$PAGINATOR_ID = "last-transaction";
const $eaac49ebfff0764e$var$LOADING_ITEM_COUNT = 7;
let $eaac49ebfff0764e$export$719cb0f98e6f6fef = class W3mActivityList extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.paginationObserver = undefined;
        this.page = "activity";
        this.isSolana = (0, $d94Xg.ChainController).state.activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.SOLANA;
        this.address = (0, $f7IXw.AccountController).state.address;
        this.transactionsByYear = (0, $i2wHx.TransactionsController).state.transactionsByYear;
        this.loading = (0, $i2wHx.TransactionsController).state.loading;
        this.empty = (0, $i2wHx.TransactionsController).state.empty;
        this.next = (0, $i2wHx.TransactionsController).state.next;
        (0, $i2wHx.TransactionsController).clearCursor();
        this.unsubscribe.push(...[
            (0, $d94Xg.ChainController).subscribeKey("activeChain", (activeChain)=>{
                this.isSolana = activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.SOLANA;
            }),
            (0, $f7IXw.AccountController).subscribe((val)=>{
                if (val.isConnected) {
                    if (this.address !== val.address) {
                        this.address = val.address;
                        (0, $i2wHx.TransactionsController).resetTransactions();
                        (0, $i2wHx.TransactionsController).fetchTransactions(val.address);
                    }
                }
            }),
            (0, $jbD0z.NetworkController).subscribeKey("caipNetwork", ()=>{
                this.updateTransactionView();
            }),
            (0, $i2wHx.TransactionsController).subscribe((val)=>{
                this.transactionsByYear = val.transactionsByYear;
                this.loading = val.loading;
                this.empty = val.empty;
                this.next = val.next;
            })
        ]);
    }
    firstUpdated() {
        if (this.isSolana) {
            this.loading = false;
            this.empty = true;
            return;
        }
        this.updateTransactionView();
        this.createPaginationObserver();
    }
    updated() {
        this.setPaginationObserver();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $aTf3K.html)` ${this.empty ? null : this.templateTransactionsByYear()}
    ${this.loading ? this.templateLoading() : null}
    ${!this.loading && this.empty ? this.templateEmpty() : null}`;
    }
    updateTransactionView() {
        const currentNetwork = (0, $jbD0z.NetworkController).state.caipNetwork?.id;
        const lastNetworkInView = (0, $i2wHx.TransactionsController).state.lastNetworkInView;
        if (lastNetworkInView !== currentNetwork) {
            (0, $i2wHx.TransactionsController).resetTransactions();
            (0, $i2wHx.TransactionsController).fetchTransactions(this.address);
        }
        (0, $i2wHx.TransactionsController).setLastNetworkInView(currentNetwork);
    }
    templateTransactionsByYear() {
        const sortedYearKeys = Object.keys(this.transactionsByYear).sort().reverse();
        return sortedYearKeys.map((year)=>{
            const yearInt = parseInt(year, 10);
            const sortedMonthIndexes = new Array(12).fill(null).map((_, idx)=>{
                const groupTitle = (0, $6emWt.TransactionUtil).getTransactionGroupTitle(yearInt, idx);
                const transactions = this.transactionsByYear[yearInt]?.[idx];
                return {
                    groupTitle: groupTitle,
                    transactions: transactions
                };
            }).filter(({ transactions: transactions })=>transactions).reverse();
            return sortedMonthIndexes.map(({ groupTitle: groupTitle, transactions: transactions }, index)=>{
                const isLastGroup = index === sortedMonthIndexes.length - 1;
                if (!transactions) return null;
                return (0, $aTf3K.html)`
          <wui-flex
            flexDirection="column"
            class="group-container"
            last-group="${isLastGroup ? "true" : "false"}"
          >
            <wui-flex
              alignItems="center"
              flexDirection="row"
              .padding=${[
                    "xs",
                    "s",
                    "s",
                    "s"
                ]}
            >
              <wui-text variant="paragraph-500" color="fg-200">${groupTitle}</wui-text>
            </wui-flex>
            <wui-flex flexDirection="column" gap="xs">
              ${this.templateTransactions(transactions, isLastGroup)}
            </wui-flex>
          </wui-flex>
        `;
            });
        });
    }
    templateRenderTransaction(transaction, isLastTransaction) {
        const { date: date, descriptions: descriptions, direction: direction, isAllNFT: isAllNFT, images: images, status: status, transfers: transfers, type: type } = this.getTransactionListItemProps(transaction);
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return (0, $aTf3K.html)`
        <wui-transaction-list-item
          date=${date}
          .direction=${direction}
          id=${isLastTransaction && this.next ? $eaac49ebfff0764e$var$PAGINATOR_ID : ""}
          status=${status}
          type=${type}
          .images=${images}
          .descriptions=${descriptions}
        ></wui-transaction-list-item>
      `;
        if (haveMultipleTransfers) return transfers.map((transfer, index)=>{
            const description = (0, $6emWt.TransactionUtil).getTransferDescription(transfer);
            const isLastTransfer = isLastTransaction && index === transfers.length - 1;
            return (0, $aTf3K.html)` <wui-transaction-list-item
          date=${date}
          direction=${transfer.direction}
          id=${isLastTransfer && this.next ? $eaac49ebfff0764e$var$PAGINATOR_ID : ""}
          status=${status}
          type=${type}
          .onlyDirectionIcon=${true}
          .images=${[
                images[index]
            ]}
          .descriptions=${[
                description
            ]}
        ></wui-transaction-list-item>`;
        });
        return (0, $aTf3K.html)`
      <wui-transaction-list-item
        date=${date}
        .direction=${direction}
        id=${isLastTransaction && this.next ? $eaac49ebfff0764e$var$PAGINATOR_ID : ""}
        status=${status}
        type=${type}
        .images=${images}
        .descriptions=${descriptions}
      ></wui-transaction-list-item>
    `;
    }
    templateTransactions(transactions, isLastGroup) {
        return transactions.map((transaction, index)=>{
            const isLastTransaction = isLastGroup && index === transactions.length - 1;
            return (0, $aTf3K.html)`${this.templateRenderTransaction(transaction, isLastTransaction)}`;
        });
    }
    emptyStateActivity() {
        const comingSoon = (0, $aTf3K.html)`
      <wui-text align="center" variant="paragraph-500" color="fg-100"
        >Transaction history is coming soon!</wui-text
      >
    `;
        const empty = (0, $aTf3K.html)` <wui-text align="center" variant="paragraph-500" color="fg-100"
        >No Transactions yet</wui-text
      >
      <wui-text align="center" variant="small-500" color="fg-200"
        >Start trading on dApps <br />
        to grow your wallet!</wui-text
      >`;
        return (0, $aTf3K.html)`<wui-flex
      class="emptyContainer"
      flexGrow="1"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      .padding=${[
            "3xl",
            "xl",
            "3xl",
            "xl"
        ]}
      gap="xl"
    >
      <wui-icon-box
        backgroundColor="gray-glass-005"
        background="gray"
        iconColor="fg-200"
        icon="wallet"
        size="lg"
        ?border=${true}
        borderColor="wui-color-bg-125"
      ></wui-icon-box>
      <wui-flex flexDirection="column" alignItems="center" gap="xs">
        ${this.isSolana ? comingSoon : empty}
      </wui-flex>
    </wui-flex>`;
    }
    emptyStateAccount() {
        const comingSoon = (0, $aTf3K.html)`
      <wui-text variant="paragraph-500" align="center" color="fg-100"
        >Transaction history is coming soon!</wui-text
      >
    `;
        const empty = (0, $aTf3K.html)` <wui-text variant="paragraph-500" align="center" color="fg-100"
        >No activity yet</wui-text
      >
      <wui-text variant="small-400" align="center" color="fg-200"
        >Your next transactions will appear here</wui-text
      >`;
        return (0, $aTf3K.html)`<wui-flex
      class="contentContainer"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap="l"
    >
      <wui-icon-box
        icon="swapHorizontal"
        size="inherit"
        iconColor="fg-200"
        backgroundColor="fg-200"
        iconSize="lg"
      ></wui-icon-box>
      <wui-flex
        class="textContent"
        gap="xs"
        flexDirection="column"
        justifyContent="center"
        flexDirection="column"
      >
        ${this.isSolana ? comingSoon : empty}
      </wui-flex>
      <wui-link @click=${this.onReceiveClick.bind(this)}>Trade</wui-link>
    </wui-flex>`;
    }
    templateEmpty() {
        if (this.page === "account") return (0, $aTf3K.html)`${this.emptyStateAccount()}`;
        return (0, $aTf3K.html)`${this.emptyStateActivity()}`;
    }
    templateLoading() {
        if (this.page === "activity") return Array($eaac49ebfff0764e$var$LOADING_ITEM_COUNT).fill((0, $aTf3K.html)` <wui-transaction-list-item-loader></wui-transaction-list-item-loader> `).map((item)=>item);
        return null;
    }
    onReceiveClick() {
        (0, $6mRzS.RouterController).push("WalletReceive");
    }
    createPaginationObserver() {
        const { projectId: projectId } = (0, $8BVTM.OptionsController).state;
        this.paginationObserver = new IntersectionObserver(([element])=>{
            if (element?.isIntersecting && !this.loading) {
                (0, $i2wHx.TransactionsController).fetchTransactions(this.address);
                (0, $6m17w.EventsController).sendEvent({
                    type: "track",
                    event: "LOAD_MORE_TRANSACTIONS",
                    properties: {
                        address: this.address,
                        projectId: projectId,
                        cursor: this.next,
                        isSmartAccount: (0, $f7IXw.AccountController).state.preferredAccountType === (0, $lr7C8.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                    }
                });
            }
        }, {});
        this.setPaginationObserver();
    }
    setPaginationObserver() {
        this.paginationObserver?.disconnect();
        const lastItem = this.shadowRoot?.querySelector(`#${$eaac49ebfff0764e$var$PAGINATOR_ID}`);
        if (lastItem) this.paginationObserver?.observe(lastItem);
    }
    getTransactionListItemProps(transaction) {
        const date = (0, $5kBvB.DateUtil).formatDate(transaction?.metadata?.minedAt);
        const descriptions = (0, $6emWt.TransactionUtil).getTransactionDescriptions(transaction);
        const transfers = transaction?.transfers;
        const transfer = transaction?.transfers?.[0];
        const isAllNFT = Boolean(transfer) && transaction?.transfers?.every((item)=>Boolean(item.nft_info));
        const images = (0, $6emWt.TransactionUtil).getTransactionImages(transfers);
        return {
            date: date,
            direction: transfer?.direction,
            descriptions: descriptions,
            isAllNFT: isAllNFT,
            images: images,
            status: transaction.metadata?.status,
            transfers: transfers,
            type: transaction.metadata?.operationType
        };
    }
};
$eaac49ebfff0764e$export$719cb0f98e6f6fef.styles = (0, $6737535b5df8b9f6$export$2e2bcd8739ae039);
$eaac49ebfff0764e$var$__decorate([
    (0, $jJP2r.property)()
], $eaac49ebfff0764e$export$719cb0f98e6f6fef.prototype, "page", void 0);
$eaac49ebfff0764e$var$__decorate([
    (0, $faUle.state)()
], $eaac49ebfff0764e$export$719cb0f98e6f6fef.prototype, "isSolana", void 0);
$eaac49ebfff0764e$var$__decorate([
    (0, $faUle.state)()
], $eaac49ebfff0764e$export$719cb0f98e6f6fef.prototype, "address", void 0);
$eaac49ebfff0764e$var$__decorate([
    (0, $faUle.state)()
], $eaac49ebfff0764e$export$719cb0f98e6f6fef.prototype, "transactionsByYear", void 0);
$eaac49ebfff0764e$var$__decorate([
    (0, $faUle.state)()
], $eaac49ebfff0764e$export$719cb0f98e6f6fef.prototype, "loading", void 0);
$eaac49ebfff0764e$var$__decorate([
    (0, $faUle.state)()
], $eaac49ebfff0764e$export$719cb0f98e6f6fef.prototype, "empty", void 0);
$eaac49ebfff0764e$var$__decorate([
    (0, $faUle.state)()
], $eaac49ebfff0764e$export$719cb0f98e6f6fef.prototype, "next", void 0);
$eaac49ebfff0764e$export$719cb0f98e6f6fef = $eaac49ebfff0764e$var$__decorate([
    (0, $ailZp.customElement)("w3m-activity-list")
], $eaac49ebfff0764e$export$719cb0f98e6f6fef);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $d9a8fc0928c78258$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
    height: 100px;
    border-radius: var(--wui-border-radius-s);
    border: 1px solid var(--wui-color-gray-glass-002);
    background-color: var(--wui-color-gray-glass-002);
    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-lg);
    will-change: background-color;
  }

  :host(:hover) {
    background-color: var(--wui-color-gray-glass-005);
  }

  wui-flex {
    width: 100%;
    height: fit-content;
  }

  wui-button {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  wui-input-amount {
    mask-image: linear-gradient(
      270deg,
      transparent 0px,
      transparent 8px,
      black 24px,
      black 25px,
      black 32px,
      black 100%
    );
  }

  .totalValue {
    width: 100%;
  }
`;


parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
parcelRequire("eNJDH");
var $6mRzS = parcelRequire("6mRzS");
var $3BhS7 = parcelRequire("3BhS7");
parcelRequire("ikDNi");
var $l2EhC = parcelRequire("l2EhC");
var $bd84b2df0931005b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bd84b2df0931005b$export$fd578e03b00e8696 = class W3mInputToken extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)` <wui-flex
      flexDirection="column"
      gap="4xs"
      .padding=${[
            "xl",
            "s",
            "l",
            "l"
        ]}
    >
      <wui-flex alignItems="center">
        <wui-input-amount
          @inputChange=${this.onInputChange.bind(this)}
          ?disabled=${!this.token && true}
          .value=${this.sendTokenAmount ? String(this.sendTokenAmount) : ""}
        ></wui-input-amount>
        ${this.buttonTemplate()}
      </wui-flex>
      <wui-flex alignItems="center" justifyContent="space-between">
        ${this.sendValueTemplate()}
        <wui-flex alignItems="center" gap="4xs" justifyContent="flex-end">
          ${this.maxAmountTemplate()} ${this.actionTemplate()}
        </wui-flex>
      </wui-flex>
    </wui-flex>`;
    }
    buttonTemplate() {
        if (this.token) return (0, $aTf3K.html)`<wui-token-button
        text=${this.token.symbol}
        imageSrc=${this.token.iconUrl}
        @click=${this.handleSelectButtonClick.bind(this)}
      >
      </wui-token-button>`;
        return (0, $aTf3K.html)`<wui-button
      size="md"
      variant="accent"
      @click=${this.handleSelectButtonClick.bind(this)}
      >Select token</wui-button
    >`;
    }
    handleSelectButtonClick() {
        (0, $6mRzS.RouterController).push("WalletSendSelectToken");
    }
    sendValueTemplate() {
        if (this.token && this.sendTokenAmount) {
            const price = this.token.price;
            const totalValue = price * this.sendTokenAmount;
            return (0, $aTf3K.html)`<wui-text class="totalValue" variant="small-400" color="fg-200"
        >${totalValue ? `$${(0, $fIDM4.UiHelperUtil).formatNumberToLocalString(totalValue, 2)}` : "Incorrect value"}</wui-text
      >`;
        }
        return null;
    }
    maxAmountTemplate() {
        if (this.token) {
            if (this.sendTokenAmount && this.sendTokenAmount > Number(this.token.quantity.numeric)) return (0, $aTf3K.html)` <wui-text variant="small-400" color="error-100">
          ${(0, $fIDM4.UiHelperUtil).roundNumber(Number(this.token.quantity.numeric), 6, 5)}
        </wui-text>`;
            return (0, $aTf3K.html)` <wui-text variant="small-400" color="fg-200">
        ${(0, $fIDM4.UiHelperUtil).roundNumber(Number(this.token.quantity.numeric), 6, 5)}
      </wui-text>`;
        }
        return null;
    }
    actionTemplate() {
        if (this.token) {
            if (this.sendTokenAmount && this.sendTokenAmount > Number(this.token.quantity.numeric)) return (0, $aTf3K.html)`<wui-link @click=${this.onBuyClick.bind(this)}>Buy</wui-link>`;
            return (0, $aTf3K.html)`<wui-link @click=${this.onMaxClick.bind(this)}>Max</wui-link>`;
        }
        return null;
    }
    onInputChange(event) {
        (0, $3BhS7.SendController).setTokenAmount(event.detail);
    }
    onMaxClick() {
        if (this.token && this.gasPriceInUSD) {
            const amountOfTokenGasRequires = (0, $l2EhC.NumberUtil).bigNumber(this.gasPriceInUSD.toFixed(5)).dividedBy(this.token.price);
            const isNetworkToken = this.token.address === undefined;
            const maxValue = isNetworkToken ? (0, $l2EhC.NumberUtil).bigNumber(this.token.quantity.numeric).minus(amountOfTokenGasRequires) : (0, $l2EhC.NumberUtil).bigNumber(this.token.quantity.numeric);
            (0, $3BhS7.SendController).setTokenAmount(Number(maxValue.toFixed(20)));
        }
    }
    onBuyClick() {
        (0, $6mRzS.RouterController).push("OnRampProviders");
    }
};
$bd84b2df0931005b$export$fd578e03b00e8696.styles = (0, $d9a8fc0928c78258$export$2e2bcd8739ae039);
$bd84b2df0931005b$var$__decorate([
    (0, $jJP2r.property)({
        type: Object
    })
], $bd84b2df0931005b$export$fd578e03b00e8696.prototype, "token", void 0);
$bd84b2df0931005b$var$__decorate([
    (0, $jJP2r.property)({
        type: Number
    })
], $bd84b2df0931005b$export$fd578e03b00e8696.prototype, "sendTokenAmount", void 0);
$bd84b2df0931005b$var$__decorate([
    (0, $jJP2r.property)({
        type: Number
    })
], $bd84b2df0931005b$export$fd578e03b00e8696.prototype, "gasPriceInUSD", void 0);
$bd84b2df0931005b$export$fd578e03b00e8696 = $bd84b2df0931005b$var$__decorate([
    (0, $ailZp.customElement)("w3m-input-token")
], $bd84b2df0931005b$export$fd578e03b00e8696);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $69c97294541156f8$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
    height: 100px;
    border-radius: var(--wui-border-radius-s);
    border: 1px solid var(--wui-color-gray-glass-002);
    background-color: var(--wui-color-gray-glass-002);
    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-lg);
    will-change: background-color;
    position: relative;
  }

  :host(:hover) {
    background-color: var(--wui-color-gray-glass-005);
  }

  wui-flex {
    width: 100%;
    height: fit-content;
  }

  wui-button {
    display: ruby;
    color: var(--wui-color-fg-100);
    margin: 0 var(--wui-spacing-xs);
  }

  .instruction {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .paste {
    display: inline-flex;
  }

  textarea {
    background: transparent;
    width: 100%;
    font-family: var(--w3m-font-family);
    font-size: var(--wui-font-size-medium);
    font-style: normal;
    font-weight: var(--wui-font-weight-light);
    line-height: 130%;
    letter-spacing: var(--wui-letter-spacing-medium);
    color: var(--wui-color-fg-100);
    caret-color: var(--wui-color-accent-100);
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    padding: 0px;
    border: none;
    outline: none;
    appearance: none;
    resize: none;
    overflow: hidden;
  }
`;


parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");
parcelRequire("eNJDH");
var $hlVrM = parcelRequire("hlVrM");
var $c4rfq = parcelRequire("c4rfq");
var $3BhS7 = parcelRequire("3BhS7");

var $762f55683703324e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $762f55683703324e$export$a34d851a88071b13 = class W3mInputAddress extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.inputElementRef = (0, $8fa5b8d3f98eecf3$export$7d1e3a5e95ceca43)();
        this.instructionElementRef = (0, $8fa5b8d3f98eecf3$export$7d1e3a5e95ceca43)();
        this.instructionHidden = Boolean(this.value);
        this.pasting = false;
        this.onDebouncedSearch = (0, $c4rfq.CoreHelperUtil).debounce(async (value)=>{
            const address = await (0, $hlVrM.ConnectionController).getEnsAddress(value);
            (0, $3BhS7.SendController).setLoading(false);
            if (address) {
                (0, $3BhS7.SendController).setReceiverProfileName(value);
                (0, $3BhS7.SendController).setReceiverAddress(address);
                const avatar = await (0, $hlVrM.ConnectionController).getEnsAvatar(value);
                if (avatar) (0, $3BhS7.SendController).setReceiverProfileImageUrl(avatar);
            } else {
                (0, $3BhS7.SendController).setReceiverAddress(value);
                (0, $3BhS7.SendController).setReceiverProfileName(undefined);
                (0, $3BhS7.SendController).setReceiverProfileImageUrl(undefined);
            }
        });
    }
    firstUpdated() {
        if (this.value) this.instructionHidden = true;
        this.checkHidden();
    }
    render() {
        return (0, $aTf3K.html)` <wui-flex
      @click=${this.onBoxClick.bind(this)}
      flexDirection="column"
      justifyContent="center"
      gap="4xs"
      .padding=${[
            "2xl",
            "l",
            "xl",
            "l"
        ]}
    >
      <wui-text
        ${(0, $8fa5b8d3f98eecf3$export$eff4d24c3ff7876e)(this.instructionElementRef)}
        class="instruction"
        color="fg-300"
        variant="medium-400"
      >
        Type or
        <wui-button
          class="paste"
          size="md"
          variant="neutral"
          iconLeft="copy"
          @click=${this.onPasteClick.bind(this)}
        >
          <wui-icon size="sm" color="inherit" slot="iconLeft" name="copy"></wui-icon>
          Paste
        </wui-button>
        address
      </wui-text>
      <textarea
        spellcheck="false"
        ?disabled=${!this.instructionHidden}
        ${(0, $8fa5b8d3f98eecf3$export$eff4d24c3ff7876e)(this.inputElementRef)}
        @input=${this.onInputChange.bind(this)}
        @blur=${this.onBlur.bind(this)}
        .value=${this.value ?? ""}
        autocomplete="off"
      >
${this.value ?? ""}</textarea
      >
    </wui-flex>`;
    }
    async focusInput() {
        if (this.instructionElementRef.value) {
            this.instructionHidden = true;
            await this.toggleInstructionFocus(false);
            this.instructionElementRef.value.style.pointerEvents = "none";
            this.inputElementRef.value?.focus();
            if (this.inputElementRef.value) this.inputElementRef.value.selectionStart = this.inputElementRef.value.selectionEnd = this.inputElementRef.value.value.length;
        }
    }
    async focusInstruction() {
        if (this.instructionElementRef.value) {
            this.instructionHidden = false;
            await this.toggleInstructionFocus(true);
            this.instructionElementRef.value.style.pointerEvents = "auto";
            this.inputElementRef.value?.blur();
        }
    }
    async toggleInstructionFocus(focus) {
        if (this.instructionElementRef.value) await this.instructionElementRef.value.animate([
            {
                opacity: focus ? 0 : 1
            },
            {
                opacity: focus ? 1 : 0
            }
        ], {
            duration: 100,
            easing: "ease",
            fill: "forwards"
        }).finished;
    }
    onBoxClick() {
        if (!this.value && !this.instructionHidden) this.focusInput();
    }
    onBlur() {
        if (!this.value && this.instructionHidden && !this.pasting) this.focusInstruction();
    }
    checkHidden() {
        if (this.instructionHidden) this.focusInput();
    }
    async onPasteClick() {
        this.pasting = true;
        const text = await navigator.clipboard.readText();
        (0, $3BhS7.SendController).setReceiverAddress(text);
        this.focusInput();
    }
    onInputChange(e) {
        this.pasting = false;
        const element = e.target;
        if (element.value && !this.instructionHidden) this.focusInput();
        (0, $3BhS7.SendController).setLoading(true);
        this.onDebouncedSearch(element.value);
    }
};
$762f55683703324e$export$a34d851a88071b13.styles = (0, $69c97294541156f8$export$2e2bcd8739ae039);
$762f55683703324e$var$__decorate([
    (0, $jJP2r.property)()
], $762f55683703324e$export$a34d851a88071b13.prototype, "value", void 0);
$762f55683703324e$var$__decorate([
    (0, $faUle.state)()
], $762f55683703324e$export$a34d851a88071b13.prototype, "instructionHidden", void 0);
$762f55683703324e$var$__decorate([
    (0, $faUle.state)()
], $762f55683703324e$export$a34d851a88071b13.prototype, "pasting", void 0);
$762f55683703324e$export$a34d851a88071b13 = $762f55683703324e$var$__decorate([
    (0, $ailZp.customElement)("w3m-input-address")
], $762f55683703324e$export$a34d851a88071b13);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
var $fIDM4 = parcelRequire("fIDM4");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $33af502a6f11f336$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    display: flex;
    width: auto;
    flex-direction: column;
    gap: var(--wui-border-radius-1xs);
    border-radius: var(--wui-border-radius-s);
    background: var(--wui-color-gray-glass-002);
    padding: var(--wui-spacing-s) var(--wui-spacing-1xs) var(--wui-spacing-1xs)
      var(--wui-spacing-1xs);
  }

  wui-text {
    padding: 0 var(--wui-spacing-1xs);
  }

  wui-flex {
    margin-top: var(--wui-spacing-1xs);
  }

  .network {
    cursor: pointer;
    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-lg);
    will-change: background-color;
  }

  .network:focus-visible {
    border: 1px solid var(--wui-color-accent-100);
    background-color: var(--wui-color-gray-glass-005);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  .network:hover {
    background-color: var(--wui-color-gray-glass-005);
  }

  .network:active {
    background-color: var(--wui-color-gray-glass-010);
  }
`;


parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $6mRzS = parcelRequire("6mRzS");

var $9fbe899f232d45ec$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9fbe899f232d45ec$export$bfe01ba2d6f78539 = class W3mWalletSendDetails extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)` <wui-text variant="small-400" color="fg-200">Details</wui-text>
      <wui-flex flexDirection="column" gap="xxs">
        <wui-list-content textTitle="Network cost" textValue="$${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $fIDM4.UiHelperUtil).formatNumberToLocalString(this.networkFee, 2))}"></wui-list-content></wui-list-content>
        <wui-list-content
          textTitle="Address"
          textValue=${(0, $fIDM4.UiHelperUtil).getTruncateString({
            string: this.receiverAddress ?? "",
            charsStart: 4,
            charsEnd: 4,
            truncate: "middle"
        })}
        >
        </wui-list-content>
        ${this.networkTemplate()}
      </wui-flex>`;
    }
    networkTemplate() {
        if (this.caipNetwork?.name) return (0, $aTf3K.html)` <wui-list-content
        @click=${()=>this.onNetworkClick(this.caipNetwork)}
        class="network"
        textTitle="Network"
        imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getNetworkImage(this.caipNetwork))}
      ></wui-list-content>`;
        return null;
    }
    onNetworkClick(network) {
        if (network) (0, $6mRzS.RouterController).push("Networks", {
            network: network
        });
    }
};
$9fbe899f232d45ec$export$bfe01ba2d6f78539.styles = (0, $33af502a6f11f336$export$2e2bcd8739ae039);
$9fbe899f232d45ec$var$__decorate([
    (0, $jJP2r.property)()
], $9fbe899f232d45ec$export$bfe01ba2d6f78539.prototype, "receiverAddress", void 0);
$9fbe899f232d45ec$var$__decorate([
    (0, $jJP2r.property)({
        type: Object
    })
], $9fbe899f232d45ec$export$bfe01ba2d6f78539.prototype, "caipNetwork", void 0);
$9fbe899f232d45ec$var$__decorate([
    (0, $jJP2r.property)({
        type: Number
    })
], $9fbe899f232d45ec$export$bfe01ba2d6f78539.prototype, "networkFee", void 0);
$9fbe899f232d45ec$export$bfe01ba2d6f78539 = $9fbe899f232d45ec$var$__decorate([
    (0, $ailZp.customElement)("w3m-wallet-send-details")
], $9fbe899f232d45ec$export$bfe01ba2d6f78539);


parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("eNJDH");
var $vBowO = parcelRequire("vBowO");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $e1859dcfaf5c3dbd$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    pointer-events: none;
  }

  :host > wui-flex {
    display: var(--w3m-tooltip-display);
    opacity: var(--w3m-tooltip-opacity);
    padding: 9px var(--wui-spacing-s) 10px var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);
    color: var(--wui-color-bg-100);
    position: fixed;
    top: var(--w3m-tooltip-top);
    left: var(--w3m-tooltip-left);
    transform: translate(calc(-50% + var(--w3m-tooltip-parent-width)), calc(-100% - 8px));
    max-width: calc(var(--w3m-modal-width) - var(--wui-spacing-xl));
    transition: opacity 0.2s var(--wui-ease-out-power-2);
    will-change: opacity;
  }

  :host([data-variant='shade']) > wui-flex {
    background-color: var(--wui-color-bg-150);
    border: 1px solid var(--wui-color-gray-glass-005);
  }

  :host([data-variant='shade']) > wui-flex > wui-text {
    color: var(--wui-color-fg-150);
  }

  :host([data-variant='fill']) > wui-flex {
    background-color: var(--wui-color-fg-100);
    border: none;
  }

  wui-icon {
    position: absolute;
    width: 12px !important;
    height: 4px !important;
    color: var(--wui-color-bg-150);
  }

  wui-icon[data-placement='top'] {
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 95%);
  }

  wui-icon[data-placement='bottom'] {
    top: 0;
    left: 50%;
    transform: translate(-50%, -95%) rotate(180deg);
  }

  wui-icon[data-placement='right'] {
    top: 50%;
    left: 0;
    transform: translate(-65%, -50%) rotate(90deg);
  }

  wui-icon[data-placement='left'] {
    top: 50%;
    right: 0%;
    transform: translate(65%, -50%) rotate(270deg);
  }
`;


var $cd006c8c413787e7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $cd006c8c413787e7$export$690e052e08bb9d48 = class W3mTooltip extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.open = (0, $vBowO.TooltipController).state.open;
        this.message = (0, $vBowO.TooltipController).state.message;
        this.triggerRect = (0, $vBowO.TooltipController).state.triggerRect;
        this.variant = (0, $vBowO.TooltipController).state.variant;
        this.unsubscribe.push(...[
            (0, $vBowO.TooltipController).subscribe((newState)=>{
                this.open = newState.open;
                this.message = newState.message;
                this.triggerRect = newState.triggerRect;
                this.variant = newState.variant;
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        this.dataset["variant"] = this.variant;
        const topValue = this.triggerRect.top;
        const leftValue = this.triggerRect.left;
        this.style.cssText = `
    --w3m-tooltip-top: ${topValue}px;
    --w3m-tooltip-left: ${leftValue}px;
    --w3m-tooltip-parent-width: ${this.triggerRect.width / 2}px;
    --w3m-tooltip-display: ${this.open ? "flex" : "none"};
    --w3m-tooltip-opacity: ${this.open ? 1 : 0};
    `;
        return (0, $aTf3K.html)`<wui-flex>
      <wui-icon data-placement="top" color="fg-100" size="inherit" name="cursor"></wui-icon>
      <wui-text color="inherit" variant="small-500">${this.message}</wui-text>
    </wui-flex>`;
    }
};
$cd006c8c413787e7$export$690e052e08bb9d48.styles = [
    (0, $e1859dcfaf5c3dbd$export$2e2bcd8739ae039)
];
$cd006c8c413787e7$var$__decorate([
    (0, $faUle.state)()
], $cd006c8c413787e7$export$690e052e08bb9d48.prototype, "open", void 0);
$cd006c8c413787e7$var$__decorate([
    (0, $faUle.state)()
], $cd006c8c413787e7$export$690e052e08bb9d48.prototype, "message", void 0);
$cd006c8c413787e7$var$__decorate([
    (0, $faUle.state)()
], $cd006c8c413787e7$export$690e052e08bb9d48.prototype, "triggerRect", void 0);
$cd006c8c413787e7$var$__decorate([
    (0, $faUle.state)()
], $cd006c8c413787e7$export$690e052e08bb9d48.prototype, "variant", void 0);
$cd006c8c413787e7$export$690e052e08bb9d48 = $cd006c8c413787e7$var$__decorate([
    (0, $ailZp.customElement)("w3m-tooltip")
], $cd006c8c413787e7$export$690e052e08bb9d48);


parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $jJP2r = parcelRequire("jJP2r");
var $faUle = parcelRequire("faUle");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $c8132f7773969151$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    width: 100%;
    display: block;
  }
`;


parcelRequire("eNJDH");
var $ib7WC = parcelRequire("ib7WC");
var $6mRzS = parcelRequire("6mRzS");
var $vBowO = parcelRequire("vBowO");
var $9103c7ae4a364058$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9103c7ae4a364058$export$24079ca0bc8e6c8d = class WuiTooltipTrigger extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.text = "";
        this.open = (0, $vBowO.TooltipController).state.open;
        this.unsubscribe.push((0, $6mRzS.RouterController).subscribeKey("view", ()=>{
            (0, $vBowO.TooltipController).hide();
        }), (0, $ib7WC.ModalController).subscribeKey("open", (modalOpen)=>{
            if (!modalOpen) (0, $vBowO.TooltipController).hide();
        }), (0, $vBowO.TooltipController).subscribeKey("open", (tooltipOpen)=>{
            this.open = tooltipOpen;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        (0, $vBowO.TooltipController).hide();
    }
    render() {
        return (0, $aTf3K.html)`
      <div
        @pointermove=${this.onMouseEnter.bind(this)}
        @pointerleave=${this.onMouseLeave.bind(this)}
      >
        ${this.renderChildren()}
      </div>
    `;
    }
    renderChildren() {
        return (0, $aTf3K.html)`<slot></slot> `;
    }
    onMouseEnter() {
        const rect = this.getBoundingClientRect();
        if (!this.open) (0, $vBowO.TooltipController).showTooltip({
            message: this.text,
            triggerRect: {
                width: rect.width,
                height: rect.height,
                left: rect.left,
                top: rect.top
            },
            variant: "shade"
        });
    }
    onMouseLeave(event) {
        if (!this.contains(event.relatedTarget)) (0, $vBowO.TooltipController).hide();
    }
};
$9103c7ae4a364058$export$24079ca0bc8e6c8d.styles = [
    (0, $c8132f7773969151$export$2e2bcd8739ae039)
];
$9103c7ae4a364058$var$__decorate([
    (0, $jJP2r.property)()
], $9103c7ae4a364058$export$24079ca0bc8e6c8d.prototype, "text", void 0);
$9103c7ae4a364058$var$__decorate([
    (0, $faUle.state)()
], $9103c7ae4a364058$export$24079ca0bc8e6c8d.prototype, "open", void 0);
$9103c7ae4a364058$export$24079ca0bc8e6c8d = $9103c7ae4a364058$var$__decorate([
    (0, $ailZp.customElement)("w3m-tooltip-trigger")
], $9103c7ae4a364058$export$24079ca0bc8e6c8d);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $d94Xg = parcelRequire("d94Xg");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $293225dbd3d72cc9$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host > wui-flex:first-child {
    margin-top: var(--wui-spacing-s);
  }
  wui-separator {
    margin: var(--wui-spacing-m) calc(var(--wui-spacing-m) * -1) var(--wui-spacing-m)
      calc(var(--wui-spacing-m) * -1);
    width: calc(100% + var(--wui-spacing-s) * 2);
  }
`;




var $083f3e1e7b5222c4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $083f3e1e7b5222c4$var$MAX_TOP_VIEW = 2;
const $083f3e1e7b5222c4$var$MAXIMUM_LENGTH = 6;
let $083f3e1e7b5222c4$export$eedc45ff45b02ce3 = class W3mSocialLoginWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.connector = this.connectors.find((c)=>c.type === "AUTH");
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>{
            this.connectors = val;
            this.connector = this.connectors.find((c)=>c.type === "AUTH");
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.connector?.socials) return null;
        return (0, $aTf3K.html)`
      <wui-flex
        class="container"
        flexDirection="column"
        gap="xs"
        .padding=${[
            "0",
            "0",
            "xs",
            "0"
        ]}
        data-testid="w3m-social-login-widget"
      >
        ${this.topViewTemplate()}${this.bottomViewTemplate()}
      </wui-flex>
      ${this.separatorTemplate()}
    `;
    }
    topViewTemplate() {
        if (!this.connector?.socials) return null;
        if (this.connector.socials.length === 2) return (0, $aTf3K.html)` <wui-flex gap="xs">
        ${this.connector.socials.slice(0, $083f3e1e7b5222c4$var$MAX_TOP_VIEW).map((social)=>(0, $aTf3K.html)`<wui-logo-select
              data-testid=${`social-selector-${social}`}
              @click=${()=>{
                this.onSocialClick(social);
            }}
              logo=${social}
            ></wui-logo-select>`)}
      </wui-flex>`;
        return (0, $aTf3K.html)` <wui-list-social
      data-testid=${`social-selector-${this.connector?.socials?.[0]}`}
      @click=${()=>{
            this.onSocialClick(this.connector?.socials?.[0]);
        }}
      logo=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(this.connector.socials[0])}
      align="center"
      name=${`Continue with ${this.connector.socials[0]}`}
    ></wui-list-social>`;
    }
    bottomViewTemplate() {
        if (!this.connector?.socials) return null;
        if (this.connector?.socials.length <= $083f3e1e7b5222c4$var$MAX_TOP_VIEW) return null;
        if (this.connector?.socials.length > $083f3e1e7b5222c4$var$MAXIMUM_LENGTH) return (0, $aTf3K.html)`<wui-flex gap="xs">
        ${this.connector.socials.slice(1, $083f3e1e7b5222c4$var$MAXIMUM_LENGTH - 1).map((social)=>(0, $aTf3K.html)`<wui-logo-select
              data-testid=${`social-selector-${social}`}
              @click=${()=>{
                this.onSocialClick(social);
            }}
              logo=${social}
            ></wui-logo-select>`)}
        <wui-logo-select logo="more" @click=${this.onMoreSocialsClick.bind(this)}></wui-logo-select>
      </wui-flex>`;
        return (0, $aTf3K.html)`<wui-flex gap="xs">
      ${this.connector.socials.slice(1, this.connector.socials.length).map((social)=>(0, $aTf3K.html)`<wui-logo-select
            data-testid=${`social-selector-${social}`}
            @click=${()=>{
                this.onSocialClick(social);
            }}
            logo=${social}
          ></wui-logo-select>`)}
    </wui-flex>`;
    }
    separatorTemplate() {
        const walletConnectConnector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (walletConnectConnector) return (0, $aTf3K.html)`<wui-separator text="or"></wui-separator>`;
        return null;
    }
    onMoreSocialsClick() {
        (0, $6mRzS.RouterController).push("ConnectSocials");
    }
    async onSocialClick(socialProvider) {
        if (socialProvider) {
            (0, $f7IXw.AccountController).setSocialProvider(socialProvider, (0, $d94Xg.ChainController).state.activeChain);
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "SOCIAL_LOGIN_STARTED",
                properties: {
                    provider: socialProvider
                }
            });
        }
        if (socialProvider === (0, $655e84b374468e2f$export$d69f2df2005140cd).Farcaster) {
            (0, $6mRzS.RouterController).push("ConnectingFarcaster");
            const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
            if (authConnector) {
                if (!(0, $f7IXw.AccountController).state.farcasterUrl) try {
                    const { url: url } = await authConnector.provider.getFarcasterUri();
                    (0, $f7IXw.AccountController).setFarcasterUrl(url, (0, $d94Xg.ChainController).state.activeChain);
                } catch (error) {
                    (0, $6mRzS.RouterController).goBack();
                    (0, $br7WV.SnackController).showError(error);
                }
            }
        } else {
            (0, $6mRzS.RouterController).push("ConnectingSocial");
            const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
            this.popupWindow = (0, $c4rfq.CoreHelperUtil).returnOpenHref("", "popupWindow", "width=600,height=800,scrollbars=yes");
            try {
                if (authConnector && socialProvider) {
                    const { uri: uri } = await authConnector.provider.getSocialRedirectUri({
                        provider: socialProvider
                    });
                    if (this.popupWindow && uri) {
                        (0, $f7IXw.AccountController).setSocialWindow(this.popupWindow, (0, $d94Xg.ChainController).state.activeChain);
                        this.popupWindow.location.href = uri;
                    } else {
                        this.popupWindow?.close();
                        throw new Error("Something went wrong");
                    }
                }
            } catch (error) {
                this.popupWindow?.close();
                (0, $br7WV.SnackController).showError("Something went wrong");
            }
        }
    }
};
$083f3e1e7b5222c4$export$eedc45ff45b02ce3.styles = (0, $293225dbd3d72cc9$export$2e2bcd8739ae039);
$083f3e1e7b5222c4$var$__decorate([
    (0, $faUle.state)()
], $083f3e1e7b5222c4$export$eedc45ff45b02ce3.prototype, "connectors", void 0);
$083f3e1e7b5222c4$export$eedc45ff45b02ce3 = $083f3e1e7b5222c4$var$__decorate([
    (0, $ailZp.customElement)("w3m-social-login-widget")
], $083f3e1e7b5222c4$export$eedc45ff45b02ce3);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
var $aa7d4b694e80f928$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $aa7d4b694e80f928$export$f3f7a152cb46e6bf = class W3mWalletLoginList extends (0, $g305D.LitElement) {
    render() {
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        <w3m-connector-list></w3m-connector-list>
        <w3m-all-wallets-widget></w3m-all-wallets-widget>
      </wui-flex>
    `;
    }
};
$aa7d4b694e80f928$export$f3f7a152cb46e6bf = $aa7d4b694e80f928$var$__decorate([
    (0, $ailZp.customElement)("w3m-wallet-login-list")
], $aa7d4b694e80f928$export$f3f7a152cb46e6bf);


parcelRequire("eNJDH");
var $f7IXw = parcelRequire("f7IXw");
var $d94Xg = parcelRequire("d94Xg");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $6mRzS = parcelRequire("6mRzS");
var $br7WV = parcelRequire("br7WV");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $c51cc283ad3e1df7$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    margin-top: var(--wui-spacing-3xs);
  }
  wui-separator {
    margin: var(--wui-spacing-m) calc(var(--wui-spacing-m) * -1) var(--wui-spacing-xs)
      calc(var(--wui-spacing-m) * -1);
    width: calc(100% + var(--wui-spacing-s) * 2);
  }
`;



var $7c769b55e1a1bba7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7c769b55e1a1bba7$export$ce5dbfa5d115479d = class W3mSocialLoginList extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.connector = this.connectors.find((c)=>c.type === "AUTH");
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>{
            this.connectors = val;
            this.connector = this.connectors.find((c)=>c.type === "AUTH");
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.connector?.socials) return null;
        return (0, $aTf3K.html)` <wui-flex flexDirection="column" gap="xs">
      ${this.connector.socials.map((social)=>(0, $aTf3K.html)`<wui-list-social
            @click=${()=>{
                this.onSocialClick(social);
            }}
            name=${social}
            logo=${social}
          ></wui-list-social>`)}
    </wui-flex>`;
    }
    async onSocialClick(socialProvider) {
        if (socialProvider) {
            (0, $f7IXw.AccountController).setSocialProvider(socialProvider, (0, $d94Xg.ChainController).state.activeChain);
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "SOCIAL_LOGIN_STARTED",
                properties: {
                    provider: socialProvider
                }
            });
        }
        if (socialProvider === (0, $655e84b374468e2f$export$d69f2df2005140cd).Farcaster) {
            (0, $6mRzS.RouterController).push("ConnectingFarcaster");
            const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
            if (authConnector) {
                if (!(0, $f7IXw.AccountController).state.farcasterUrl) try {
                    const { url: url } = await authConnector.provider.getFarcasterUri();
                    (0, $f7IXw.AccountController).setFarcasterUrl(url, (0, $d94Xg.ChainController).state.activeChain);
                } catch (error) {
                    (0, $6mRzS.RouterController).goBack();
                    (0, $br7WV.SnackController).showError(error);
                }
            }
        } else {
            (0, $6mRzS.RouterController).push("ConnectingSocial");
            const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
            this.popupWindow = (0, $c4rfq.CoreHelperUtil).returnOpenHref("", "popupWindow", "width=600,height=800,scrollbars=yes");
            try {
                if (authConnector && socialProvider) {
                    const { uri: uri } = await authConnector.provider.getSocialRedirectUri({
                        provider: socialProvider
                    });
                    if (this.popupWindow && uri) {
                        (0, $f7IXw.AccountController).setSocialWindow(this.popupWindow, (0, $d94Xg.ChainController).state.activeChain);
                        this.popupWindow.location.href = uri;
                    } else {
                        this.popupWindow?.close();
                        throw new Error("Something went wrong");
                    }
                }
            } catch (error) {
                this.popupWindow?.close();
                (0, $br7WV.SnackController).showError("Something went wrong");
            }
        }
    }
};
$7c769b55e1a1bba7$export$ce5dbfa5d115479d.styles = (0, $c51cc283ad3e1df7$export$2e2bcd8739ae039);
$7c769b55e1a1bba7$var$__decorate([
    (0, $faUle.state)()
], $7c769b55e1a1bba7$export$ce5dbfa5d115479d.prototype, "connectors", void 0);
$7c769b55e1a1bba7$export$ce5dbfa5d115479d = $7c769b55e1a1bba7$var$__decorate([
    (0, $ailZp.customElement)("w3m-social-login-list")
], $7c769b55e1a1bba7$export$ce5dbfa5d115479d);


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $eOULk = parcelRequire("eOULk");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

var $6a2a16c63f419c23$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6a2a16c63f419c23$export$c9a28c988ae309b = class W3mConnectAnnouncedWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const announcedConnectors = this.connectors.filter((connector)=>connector.type === "ANNOUNCED");
        if (!announcedConnectors?.length) {
            this.style.cssText = `display: none`;
            return null;
        }
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        ${announcedConnectors.map((connector)=>{
            if (connector.info?.rdns && (0, $g4s8N.ApiController).state.excludedRDNS) {
                if ((0, $g4s8N.ApiController).state.excludedRDNS.includes(connector?.info?.rdns)) return null;
            }
            return (0, $aTf3K.html)`
            <wui-list-wallet
              imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getConnectorImage(connector))}
              name=${connector.name ?? "Unknown"}
              @click=${()=>this.onConnector(connector)}
              tagVariant="success"
              tagLabel="installed"
              data-testid=${`wallet-selector-${connector.id}`}
              .installed=${true}
            >
            </wui-list-wallet>
          `;
        })}
      </wui-flex>
    `;
    }
    onConnector(connector) {
        if (connector.type === "WALLET_CONNECT") {
            if ((0, $c4rfq.CoreHelperUtil).isMobile()) (0, $6mRzS.RouterController).push("AllWallets");
            else (0, $6mRzS.RouterController).push("ConnectingWalletConnect");
        } else (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
    }
};
$6a2a16c63f419c23$var$__decorate([
    (0, $faUle.state)()
], $6a2a16c63f419c23$export$c9a28c988ae309b.prototype, "connectors", void 0);
$6a2a16c63f419c23$export$c9a28c988ae309b = $6a2a16c63f419c23$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-announced-widget")
], $6a2a16c63f419c23$export$c9a28c988ae309b);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

var $c40b1f8a47830867$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c40b1f8a47830867$export$4b0f736048e205f0 = class W3mConnectCustomWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const { customWallets: customWallets } = (0, $8BVTM.OptionsController).state;
        if (!customWallets?.length) {
            this.style.cssText = `display: none`;
            return null;
        }
        const wallets = this.filterOutDuplicateWallets(customWallets);
        return (0, $aTf3K.html)`<wui-flex flexDirection="column" gap="xs">
      ${wallets.map((wallet)=>(0, $aTf3K.html)`
          <wui-list-wallet
            imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getWalletImage(wallet))}
            name=${wallet.name ?? "Unknown"}
            @click=${()=>this.onConnectWallet(wallet)}
            data-testid=${`wallet-selector-${wallet.id}`}
          >
          </wui-list-wallet>
        `)}
    </wui-flex>`;
    }
    filterOutDuplicateWallets(wallets) {
        const recent = (0, $hdC6E.StorageUtil).getRecentWallets();
        const connectorRDNSs = this.connectors.map((connector)=>connector.info?.rdns).filter(Boolean);
        const recentRDNSs = recent.map((wallet)=>wallet.rdns).filter(Boolean);
        const allRDNSs = connectorRDNSs.concat(recentRDNSs);
        if (allRDNSs.includes("io.metamask.mobile") && (0, $c4rfq.CoreHelperUtil).isMobile()) {
            const index = allRDNSs.indexOf("io.metamask.mobile");
            allRDNSs[index] = "io.metamask";
        }
        const filtered = wallets.filter((wallet)=>!allRDNSs.includes(String(wallet?.rdns)));
        return filtered;
    }
    onConnectWallet(wallet) {
        (0, $6mRzS.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$c40b1f8a47830867$var$__decorate([
    (0, $faUle.state)()
], $c40b1f8a47830867$export$4b0f736048e205f0.prototype, "connectors", void 0);
$c40b1f8a47830867$export$4b0f736048e205f0 = $c40b1f8a47830867$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-custom-widget")
], $c40b1f8a47830867$export$4b0f736048e205f0);


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $eOULk = parcelRequire("eOULk");
var $7Xn6F = parcelRequire("7Xn6F");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");

parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $8BVTM = parcelRequire("8BVTM");
var $hdC6E = parcelRequire("hdC6E");
const $5fe51a4b7041c8f1$export$74541ed5542a8fa7 = {
    filterOutDuplicatesByRDNS (wallets) {
        const connectors = (0, $8BVTM.OptionsController).state.enableEIP6963 ? (0, $7Xn6F.ConnectorController).state.connectors : [];
        const recent = (0, $hdC6E.StorageUtil).getRecentWallets();
        const connectorRDNSs = connectors.map((connector)=>connector.info?.rdns).filter(Boolean);
        const recentRDNSs = recent.map((wallet)=>wallet.rdns).filter(Boolean);
        const allRDNSs = connectorRDNSs.concat(recentRDNSs);
        if (allRDNSs.includes("io.metamask.mobile") && (0, $c4rfq.CoreHelperUtil).isMobile()) {
            const index = allRDNSs.indexOf("io.metamask.mobile");
            allRDNSs[index] = "io.metamask";
        }
        const filtered = wallets.filter((wallet)=>!allRDNSs.includes(String(wallet?.rdns)));
        return filtered;
    },
    filterOutDuplicatesByIds (wallets) {
        const connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        const recent = (0, $hdC6E.StorageUtil).getRecentWallets();
        const connectorIds = connectors.map((connector)=>connector.explorerId);
        const recentIds = recent.map((wallet)=>wallet.id);
        const allIds = connectorIds.concat(recentIds);
        const filtered = wallets.filter((wallet)=>!allIds.includes(wallet?.id));
        return filtered;
    },
    filterOutDuplicateWallets (wallets) {
        const uniqueByRDNS = this.filterOutDuplicatesByRDNS(wallets);
        const uniqueWallets = this.filterOutDuplicatesByIds(uniqueByRDNS);
        return uniqueWallets;
    }
};


var $0ffd01ead7833a99$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0ffd01ead7833a99$export$988c4a1271f336d6 = class W3mConnectFeaturedWidget extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.unsubscribe = [];
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const { featured: featured } = (0, $g4s8N.ApiController).state;
        if (!featured.length) {
            this.style.cssText = `display: none`;
            return null;
        }
        const wallets = (0, $5fe51a4b7041c8f1$export$74541ed5542a8fa7).filterOutDuplicateWallets(featured);
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        ${wallets.map((wallet)=>(0, $aTf3K.html)`
            <wui-list-wallet
              imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getWalletImage(wallet))}
              name=${wallet.name ?? "Unknown"}
              @click=${()=>this.onConnectWallet(wallet)}
            >
            </wui-list-wallet>
          `)}
      </wui-flex>
    `;
    }
    onConnectWallet(wallet) {
        const connector = (0, $7Xn6F.ConnectorController).getConnector(wallet.id, wallet.rdns);
        if (connector) (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $6mRzS.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$0ffd01ead7833a99$export$988c4a1271f336d6 = $0ffd01ead7833a99$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-featured-widget")
], $0ffd01ead7833a99$export$988c4a1271f336d6);


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $eOULk = parcelRequire("eOULk");
var $d94Xg = parcelRequire("d94Xg");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

var $e78b59fa1ca113bf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e78b59fa1ca113bf$export$b09ba0c7d63a0bb9 = class W3mConnectInjectedWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const injectedConnectors = this.connectors.filter((connector)=>connector.type === "INJECTED");
        if (!injectedConnectors?.length || injectedConnectors.length === 1 && injectedConnectors[0]?.name === "Browser Wallet" && !(0, $c4rfq.CoreHelperUtil).isMobile()) {
            this.style.cssText = `display: none`;
            return null;
        }
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        ${injectedConnectors.map((connector)=>{
            if (!(0, $c4rfq.CoreHelperUtil).isMobile() && connector.name === "Browser Wallet") return null;
            if (!(0, $hlVrM.ConnectionController).checkInstalled(undefined, connector.chain)) {
                this.style.cssText = `display: none`;
                return null;
            }
            if (connector.info?.rdns && (0, $g4s8N.ApiController).state.excludedRDNS) {
                if ((0, $g4s8N.ApiController).state.excludedRDNS.includes(connector?.info?.rdns)) return null;
            }
            return (0, $aTf3K.html)`
            <wui-list-wallet
              imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getConnectorImage(connector))}
              .installed=${true}
              name=${connector.name ?? "Unknown"}
              tagVariant="success"
              tagLabel="installed"
              data-testid=${`wallet-selector-${connector.id}`}
              @click=${()=>this.onConnector(connector)}
            >
            </wui-list-wallet>
          `;
        })}
      </wui-flex>
    `;
    }
    onConnector(connector) {
        (0, $d94Xg.ChainController).setActiveConnector(connector);
        (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
    }
};
$e78b59fa1ca113bf$var$__decorate([
    (0, $faUle.state)()
], $e78b59fa1ca113bf$export$b09ba0c7d63a0bb9.prototype, "connectors", void 0);
$e78b59fa1ca113bf$export$b09ba0c7d63a0bb9 = $e78b59fa1ca113bf$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-injected-widget")
], $e78b59fa1ca113bf$export$b09ba0c7d63a0bb9);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $d94Xg = parcelRequire("d94Xg");
var $7Xn6F = parcelRequire("7Xn6F");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

var $1590eaf1d3d7be8a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1590eaf1d3d7be8a$export$6b9b4f1550111d67 = class W3mConnectMultiChainWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const multiChainConnectors = this.connectors.filter((connector)=>connector.type === "MULTI_CHAIN" && connector.name !== "WalletConnect");
        if (!multiChainConnectors?.length) {
            this.style.cssText = `display: none`;
            return null;
        }
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        ${multiChainConnectors.map((connector)=>(0, $aTf3K.html)`
            <wui-list-wallet
              imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getConnectorImage(connector))}
              .installed=${true}
              name=${connector.name ?? "Unknown"}
              tagVariant="shade"
              tagLabel="multichain"
              data-testid=${`wallet-selector-${connector.id}`}
              @click=${()=>this.onConnector(connector)}
            >
            </wui-list-wallet>
          `)}
      </wui-flex>
    `;
    }
    onConnector(connector) {
        (0, $d94Xg.ChainController).setActiveConnector(connector);
        (0, $6mRzS.RouterController).push("ConnectingMultiChain");
    }
};
$1590eaf1d3d7be8a$var$__decorate([
    (0, $faUle.state)()
], $1590eaf1d3d7be8a$export$6b9b4f1550111d67.prototype, "connectors", void 0);
$1590eaf1d3d7be8a$export$6b9b4f1550111d67 = $1590eaf1d3d7be8a$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-multi-chain-widget")
], $1590eaf1d3d7be8a$export$6b9b4f1550111d67);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $hlVrM = parcelRequire("hlVrM");
var $7Xn6F = parcelRequire("7Xn6F");
var $6m17w = parcelRequire("6m17w");
var $ib7WC = parcelRequire("ib7WC");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");

parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

var $71d65271e4b57a03$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $71d65271e4b57a03$export$25d176a7269bd954 = class W3mConnectCoinbaseWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const coinbaseConnector = this.connectors.find((connector)=>connector.id === "coinbaseWalletSDK");
        if (!coinbaseConnector) {
            this.style.cssText = `display: none`;
            return null;
        }
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        <wui-list-wallet
          imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getConnectorImage(coinbaseConnector))}
          .installed=${true}
          name=${(0, $607c39376ad0c184$export$f68dd208b5df064d)(coinbaseConnector.name)}
          data-testid=${`wallet-selector-${coinbaseConnector.id}`}
          @click=${()=>this.onConnector(coinbaseConnector)}
        >
        </wui-list-wallet>
      </wui-flex>
    `;
    }
    async onCoinbaseConnector(connector) {
        try {
            (0, $hlVrM.ConnectionController).setWcError(false);
            await (0, $hlVrM.ConnectionController).connectExternal(connector, connector.chain);
            if ((0, $8BVTM.OptionsController).state.isSiweEnabled) (0, $6mRzS.RouterController).push("ConnectingSiwe");
            else (0, $ib7WC.ModalController).close();
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_SUCCESS",
                properties: {
                    method: "browser",
                    name: connector.name || "Unknown"
                }
            });
        } catch (error) {
            (0, $6m17w.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            (0, $hlVrM.ConnectionController).setWcError(true);
        }
    }
    onConnector(connector) {
        (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        if (connector.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID) this.onCoinbaseConnector(connector);
    }
};
$71d65271e4b57a03$var$__decorate([
    (0, $faUle.state)()
], $71d65271e4b57a03$export$25d176a7269bd954.prototype, "connectors", void 0);
$71d65271e4b57a03$export$25d176a7269bd954 = $71d65271e4b57a03$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-coinbase-widget")
], $71d65271e4b57a03$export$25d176a7269bd954);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $7Xn6F = parcelRequire("7Xn6F");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

var $702df86b9524a5e1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $702df86b9524a5e1$export$e85be7cb330fbdd7 = class W3mConnectExternalWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const externalConnectors = this.connectors.filter((connector)=>connector.type === "EXTERNAL");
        const filteredOutCoinbaseConnectors = externalConnectors.filter((connector)=>connector.id !== "coinbaseWalletSDK");
        if (!filteredOutCoinbaseConnectors?.length) {
            this.style.cssText = `display: none`;
            return null;
        }
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        ${filteredOutCoinbaseConnectors.map((connector)=>(0, $aTf3K.html)`
            <wui-list-wallet
              imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getConnectorImage(connector))}
              .installed=${true}
              name=${connector.name ?? "Unknown"}
              data-testid=${`wallet-selector-external-${connector.id}`}
              @click=${()=>this.onConnector(connector)}
            >
            </wui-list-wallet>
          `)}
      </wui-flex>
    `;
    }
    onConnector(connector) {
        (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
    }
};
$702df86b9524a5e1$var$__decorate([
    (0, $faUle.state)()
], $702df86b9524a5e1$export$e85be7cb330fbdd7.prototype, "connectors", void 0);
$702df86b9524a5e1$export$e85be7cb330fbdd7 = $702df86b9524a5e1$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-external-widget")
], $702df86b9524a5e1$export$e85be7cb330fbdd7);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $6mRzS = parcelRequire("6mRzS");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");

var $4a0bf8e198a12f78$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4a0bf8e198a12f78$export$e1e21695d8881ac0 = class W3mConnectRecentWidget extends (0, $g305D.LitElement) {
    render() {
        const recent = (0, $hdC6E.StorageUtil).getRecentWallets();
        if (!recent?.length) {
            this.style.cssText = `display: none`;
            return null;
        }
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        ${recent.map((wallet)=>(0, $aTf3K.html)`
            <wui-list-wallet
              imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getWalletImage(wallet))}
              name=${wallet.name ?? "Unknown"}
              @click=${()=>this.onConnectWallet(wallet)}
              tagLabel="recent"
              tagVariant="shade"
            >
            </wui-list-wallet>
          `)}
      </wui-flex>
    `;
    }
    onConnectWallet(wallet) {
        (0, $6mRzS.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$4a0bf8e198a12f78$export$e1e21695d8881ac0 = $4a0bf8e198a12f78$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-recent-widget")
], $4a0bf8e198a12f78$export$e1e21695d8881ac0);


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $eOULk = parcelRequire("eOULk");
var $7Xn6F = parcelRequire("7Xn6F");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");


var $5679c19f93c3af7e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5679c19f93c3af7e$export$f5714d84d1c8cd45 = class W3mConnectRecommendedWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        const { recommended: recommended } = (0, $g4s8N.ApiController).state;
        const { customWallets: customWallets, featuredWalletIds: featuredWalletIds } = (0, $8BVTM.OptionsController).state;
        const { connectors: connectors } = (0, $7Xn6F.ConnectorController).state;
        const recent = (0, $hdC6E.StorageUtil).getRecentWallets();
        const injected = connectors.filter((c)=>c.type === "INJECTED" || c.type === "ANNOUNCED");
        const injectedWallets = injected.filter((i)=>i.name !== "Browser Wallet");
        if (featuredWalletIds || customWallets || !recommended.length) {
            this.style.cssText = `display: none`;
            return null;
        }
        const overrideLength = injectedWallets.length + recent.length;
        const maxRecommended = Math.max(0, 2 - overrideLength);
        const wallets = (0, $5fe51a4b7041c8f1$export$74541ed5542a8fa7).filterOutDuplicateWallets(recommended).slice(0, maxRecommended);
        if (!wallets.length) {
            this.style.cssText = `display: none`;
            return null;
        }
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        ${wallets.map((wallet)=>(0, $aTf3K.html)`
            <wui-list-wallet
              imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getWalletImage(wallet))}
              name=${wallet?.name ?? "Unknown"}
              @click=${()=>this.onConnectWallet(wallet)}
            >
            </wui-list-wallet>
          `)}
      </wui-flex>
    `;
    }
    onConnectWallet(wallet) {
        const connector = (0, $7Xn6F.ConnectorController).getConnector(wallet.id, wallet.rdns);
        if (connector) (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $6mRzS.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$5679c19f93c3af7e$var$__decorate([
    (0, $faUle.state)()
], $5679c19f93c3af7e$export$f5714d84d1c8cd45.prototype, "connectors", void 0);
$5679c19f93c3af7e$export$f5714d84d1c8cd45 = $5679c19f93c3af7e$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-recommended-widget")
], $5679c19f93c3af7e$export$f5714d84d1c8cd45);


parcelRequire("eNJDH");
var $eOULk = parcelRequire("eOULk");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");

var $9fc9f7426f505436$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9fc9f7426f505436$export$9691df2d71151e4c = class W3mConnectWalletConnectWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if ((0, $c4rfq.CoreHelperUtil).isMobile()) {
            this.style.cssText = `display: none`;
            return null;
        }
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) {
            this.style.cssText = `display: none`;
            return null;
        }
        return (0, $aTf3K.html)`
      <wui-list-wallet
        imageSrc=${(0, $607c39376ad0c184$export$f68dd208b5df064d)((0, $eOULk.AssetUtil).getConnectorImage(connector))}
        name=${connector.name ?? "Unknown"}
        @click=${()=>this.onConnector(connector)}
        tagLabel="qr code"
        tagVariant="main"
        data-testid="wallet-selector-walletconnect"
      >
      </wui-list-wallet>
    `;
    }
    onConnector(connector) {
        if (connector.type === "WALLET_CONNECT") {
            if ((0, $c4rfq.CoreHelperUtil).isMobile()) (0, $6mRzS.RouterController).push("AllWallets");
            else (0, $6mRzS.RouterController).push("ConnectingWalletConnect");
        } else (0, $6mRzS.RouterController).push("ConnectingExternal", {
            connector: connector
        });
    }
};
$9fc9f7426f505436$var$__decorate([
    (0, $faUle.state)()
], $9fc9f7426f505436$export$9691df2d71151e4c.prototype, "connectors", void 0);
$9fc9f7426f505436$export$9691df2d71151e4c = $9fc9f7426f505436$var$__decorate([
    (0, $ailZp.customElement)("w3m-connect-walletconnect-widget")
], $9fc9f7426f505436$export$9691df2d71151e4c);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("6uVJz");
var $7sblP = parcelRequire("7sblP");
var $7d5f4ff0a0950211$export$2e2bcd8739ae039 = (0, $7sblP.css)`
  :host {
    margin-top: var(--wui-spacing-3xs);
  }
  wui-separator {
    margin: var(--wui-spacing-m) calc(var(--wui-spacing-m) * -1) var(--wui-spacing-xs)
      calc(var(--wui-spacing-m) * -1);
    width: calc(100% + var(--wui-spacing-s) * 2);
  }
`;


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $d94Xg = parcelRequire("d94Xg");
var $7Xn6F = parcelRequire("7Xn6F");
var $8BVTM = parcelRequire("8BVTM");
var $hdC6E = parcelRequire("hdC6E");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");


var $25798019adf7d468$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $25798019adf7d468$export$6446820b0ee4da6c = class W3mConnectorList extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const { custom: custom, recent: recent, announced: announced, coinbase: coinbase, injected: injected, multiChain: multiChain, recommended: recommended, featured: featured, external: external } = this.getConnectorsByType();
        return (0, $aTf3K.html)`
      <wui-flex flexDirection="column" gap="xs">
        <w3m-connect-walletconnect-widget></w3m-connect-walletconnect-widget>
        ${recent.length ? (0, $aTf3K.html)`<w3m-connect-recent-widget></w3m-connect-recent-widget>` : null}
        ${multiChain.length ? (0, $aTf3K.html)`<w3m-connect-multi-chain-widget></w3m-connect-multi-chain-widget>` : null}
        ${announced.length ? (0, $aTf3K.html)`<w3m-connect-announced-widget></w3m-connect-announced-widget>` : null}
        ${injected.length ? (0, $aTf3K.html)`<w3m-connect-injected-widget></w3m-connect-injected-widget>` : null}
        ${featured.length ? (0, $aTf3K.html)`<w3m-connect-featured-widget></w3m-connect-featured-widget>` : null}
        ${custom?.length ? (0, $aTf3K.html)`<w3m-connect-custom-widget></w3m-connect-custom-widget>` : null}
        ${coinbase ? (0, $aTf3K.html)`<w3m-connect-coinbase-widget></w3m-connect-coinbase-widget>` : null}
        ${external.length ? (0, $aTf3K.html)`<w3m-connect-external-widget></w3m-connect-external-widget>` : null}
        ${recommended.length ? (0, $aTf3K.html)`<w3m-connect-recommended-widget></w3m-connect-recommended-widget>` : null}
      </wui-flex>
    `;
    }
    getConnectorsByType() {
        const { featured: featured, recommended: recommended } = (0, $g4s8N.ApiController).state;
        const { customWallets: custom } = (0, $8BVTM.OptionsController).state;
        const recent = (0, $hdC6E.StorageUtil).getRecentWallets();
        const filteredRecommended = (0, $5fe51a4b7041c8f1$export$74541ed5542a8fa7).filterOutDuplicateWallets(recommended);
        const filteredFeatured = (0, $5fe51a4b7041c8f1$export$74541ed5542a8fa7).filterOutDuplicateWallets(featured);
        const multiChain = this.connectors.filter((connector)=>connector.type === "MULTI_CHAIN");
        const announced = this.connectors.filter((connector)=>connector.type === "ANNOUNCED");
        const injected = this.connectors.filter((connector)=>connector.type === "INJECTED");
        const external = this.connectors.filter((connector)=>connector.type === "EXTERNAL");
        const coinbase = this.connectors.find((connector)=>connector.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID);
        const isEVM = (0, $d94Xg.ChainController).state.activeChain === (0, $1VCt9.ConstantsUtil).CHAIN.EVM;
        const includeAnnouncedAndInjected = isEVM ? (0, $8BVTM.OptionsController).state.enableEIP6963 : true;
        return {
            custom: custom,
            recent: recent,
            coinbase: coinbase,
            external: external,
            multiChain: multiChain,
            announced: includeAnnouncedAndInjected ? announced : [],
            injected: includeAnnouncedAndInjected ? injected : [],
            recommended: filteredRecommended,
            featured: filteredFeatured
        };
    }
};
$25798019adf7d468$export$6446820b0ee4da6c.styles = (0, $7d5f4ff0a0950211$export$2e2bcd8739ae039);
$25798019adf7d468$var$__decorate([
    (0, $faUle.state)()
], $25798019adf7d468$export$6446820b0ee4da6c.prototype, "connectors", void 0);
$25798019adf7d468$export$6446820b0ee4da6c = $25798019adf7d468$var$__decorate([
    (0, $ailZp.customElement)("w3m-connector-list")
], $25798019adf7d468$export$6446820b0ee4da6c);


parcelRequire("eNJDH");
var $g4s8N = parcelRequire("g4s8N");
var $7Xn6F = parcelRequire("7Xn6F");
var $c4rfq = parcelRequire("c4rfq");
var $6m17w = parcelRequire("6m17w");
var $8BVTM = parcelRequire("8BVTM");
var $6mRzS = parcelRequire("6mRzS");
parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("2HtFW");
var $faUle = parcelRequire("faUle");
var $468a602c365af002$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $468a602c365af002$export$49d950fc703ce1d8 = class W3mAllWalletsWidget extends (0, $g305D.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $7Xn6F.ConnectorController).state.connectors;
        this.count = (0, $g4s8N.ApiController).state.count;
        this.unsubscribe.push((0, $7Xn6F.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val), (0, $g4s8N.ApiController).subscribeKey("count", (val)=>this.count = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const wcConnector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        const { allWallets: allWallets } = (0, $8BVTM.OptionsController).state;
        if (!wcConnector || allWallets === "HIDE") return null;
        if (allWallets === "ONLY_MOBILE" && !(0, $c4rfq.CoreHelperUtil).isMobile()) return null;
        const featuredCount = (0, $g4s8N.ApiController).state.featured.length;
        const rawCount = this.count + featuredCount;
        const roundedCount = rawCount < 10 ? rawCount : Math.floor(rawCount / 10) * 10;
        const tagLabel = roundedCount < rawCount ? `${roundedCount}+` : `${roundedCount}`;
        return (0, $aTf3K.html)`
      <wui-list-wallet
        name="All Wallets"
        walletIcon="allWallets"
        showAllWallets
        @click=${this.onAllWallets.bind(this)}
        tagLabel=${tagLabel}
        tagVariant="shade"
        data-testid="all-wallets"
      ></wui-list-wallet>
    `;
    }
    onAllWallets() {
        (0, $6m17w.EventsController).sendEvent({
            type: "track",
            event: "CLICK_ALL_WALLETS"
        });
        (0, $6mRzS.RouterController).push("AllWallets");
    }
};
$468a602c365af002$var$__decorate([
    (0, $faUle.state)()
], $468a602c365af002$export$49d950fc703ce1d8.prototype, "connectors", void 0);
$468a602c365af002$var$__decorate([
    (0, $faUle.state)()
], $468a602c365af002$export$49d950fc703ce1d8.prototype, "count", void 0);
$468a602c365af002$export$49d950fc703ce1d8 = $468a602c365af002$var$__decorate([
    (0, $ailZp.customElement)("w3m-all-wallets-widget")
], $468a602c365af002$export$49d950fc703ce1d8);


parcelRequire("kbczO");
var $ailZp = parcelRequire("ailZp");
parcelRequire("6uVJz");
var $aTf3K = parcelRequire("aTf3K");
var $g305D = parcelRequire("g305D");
parcelRequire("eNJDH");
var $7Xn6F = parcelRequire("7Xn6F");
var $6mRzS = parcelRequire("6mRzS");
var $hdC6E = parcelRequire("hdC6E");
var $eb71b48d0f06349d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $eb71b48d0f06349d$export$ce67733292087122 = class W3mAccountAuthButton extends (0, $g305D.LitElement) {
    constructor(){
        super(...arguments);
        this.socialProvider = (0, $hdC6E.StorageUtil).getConnectedSocialProvider();
        this.socialUsername = (0, $hdC6E.StorageUtil).getConnectedSocialUsername();
    }
    render() {
        const type = (0, $hdC6E.StorageUtil).getConnectedConnector();
        const authConnector = (0, $7Xn6F.ConnectorController).getAuthConnector();
        if (!authConnector || type !== "AUTH") {
            this.style.cssText = `display: none`;
            return null;
        }
        const email = authConnector.provider.getEmail() ?? "";
        return (0, $aTf3K.html)`
      <wui-list-item
        variant="icon"
        iconVariant="overlay"
        icon=${this.socialProvider ?? "mail"}
        iconSize=${this.socialProvider ? "xxl" : "sm"}
        data-testid="w3m-account-email-update"
        ?chevron=${!this.socialProvider}
        @click=${()=>{
            this.onGoToUpdateEmail(email, this.socialProvider);
        }}
      >
        <wui-text variant="paragraph-500" color="fg-100">${this.getAuthName(email)}</wui-text>
      </wui-list-item>
    `;
    }
    onGoToUpdateEmail(email, socialProvider) {
        if (!socialProvider) (0, $6mRzS.RouterController).push("UpdateEmailWallet", {
            email: email
        });
    }
    getAuthName(email) {
        if (this.socialUsername) {
            if (this.socialProvider === "discord" && this.socialUsername.endsWith("0")) return this.socialUsername.slice(0, -1);
            return this.socialUsername;
        }
        return email.length > 30 ? `${email.slice(0, -3)}...` : email;
    }
};
$eb71b48d0f06349d$export$ce67733292087122 = $eb71b48d0f06349d$var$__decorate([
    (0, $ailZp.customElement)("w3m-account-auth-button")
], $eb71b48d0f06349d$export$ce67733292087122);




parcelRequire("eNJDH");
var $c4rfq = parcelRequire("c4rfq");
function $a0c47dbcbda0a978$export$14650d4efb17e382(options) {
    return new (0, $edee1d43f6d87414$export$fc94c40ea502fa4c)({
        ...options,
        sdkType: "w3m",
        sdkVersion: `html-multichain-${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).VERSION}`
    });
}


parcelRequire("3UUkO");

var $43P4H = parcelRequire("43P4H");
const $b2ca896600a7a3fa$export$83d89fbfd8236492 = "2.13.4";


const $00ae6e49e97981b7$export$c506eb22e615ba4a = ()=>`@wagmi/core@${0, $b2ca896600a7a3fa$export$83d89fbfd8236492}`;


var $1cab894157675a46$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $1cab894157675a46$var$_BaseError_instances, $1cab894157675a46$var$_BaseError_walk;
class $1cab894157675a46$export$a490eb03cb7a0a5e extends Error {
    get docsBaseUrl() {
        return "https://wagmi.sh/core";
    }
    get version() {
        return (0, $00ae6e49e97981b7$export$c506eb22e615ba4a)();
    }
    constructor(shortMessage, options = {}){
        super();
        $1cab894157675a46$var$_BaseError_instances.add(this);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiCoreError"
        });
        const details = options.cause instanceof $1cab894157675a46$export$a490eb03cb7a0a5e ? options.cause.details : options.cause?.message ? options.cause.message : options.details;
        const docsPath = options.cause instanceof $1cab894157675a46$export$a490eb03cb7a0a5e ? options.cause.docsPath || options.docsPath : options.docsPath;
        this.message = [
            shortMessage || "An error occurred.",
            "",
            ...options.metaMessages ? [
                ...options.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: ${this.docsBaseUrl}${docsPath}.html${options.docsSlug ? `#${options.docsSlug}` : ""}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join("\n");
        if (options.cause) this.cause = options.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = options.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $1cab894157675a46$var$__classPrivateFieldGet(this, $1cab894157675a46$var$_BaseError_instances, "m", $1cab894157675a46$var$_BaseError_walk).call(this, this, fn);
    }
}
$1cab894157675a46$var$_BaseError_instances = new WeakSet(), $1cab894157675a46$var$_BaseError_walk = function _BaseError_walk(err, fn) {
    if (fn?.(err)) return err;
    if (err.cause) return $1cab894157675a46$var$__classPrivateFieldGet(this, $1cab894157675a46$var$_BaseError_instances, "m", _BaseError_walk).call(this, err.cause, fn);
    return err;
};


class $115d9c96b0e3a6b5$export$688e5fda4b4631ed extends (0, $1cab894157675a46$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Chain not configured.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainNotConfiguredError"
        });
    }
}
class $115d9c96b0e3a6b5$export$ee7f4e50316bc4b2 extends (0, $1cab894157675a46$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector already connected.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAlreadyConnectedError"
        });
    }
}
class $115d9c96b0e3a6b5$export$d9a3828eace037a6 extends (0, $1cab894157675a46$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector not connected.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotConnectedError"
        });
    }
}
class $115d9c96b0e3a6b5$export$9f8a797207d6544e extends (0, $1cab894157675a46$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector not found.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotFoundError"
        });
    }
}
class $115d9c96b0e3a6b5$export$65c369a969e2c62e extends (0, $1cab894157675a46$export$a490eb03cb7a0a5e) {
    constructor({ address: address, connector: connector }){
        super(`Account "${address}" not found for connector "${connector.name}".`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAccountNotFoundError"
        });
    }
}
class $115d9c96b0e3a6b5$export$6f9c2f3137249d9c extends (0, $1cab894157675a46$export$a490eb03cb7a0a5e) {
    constructor({ connectionChainId: connectionChainId, connectorChainId: connectorChainId }){
        super(`The current chain of the connector (id: ${connectorChainId}) does not match the connection's chain (id: ${connectionChainId}).`, {
            metaMessages: [
                `Current Chain ID:  ${connectorChainId}`,
                `Expected Chain ID: ${connectionChainId}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorChainMismatchError"
        });
    }
}


async function $89ee8b8d60d2586c$export$64605811ab45167f(config, parameters) {
    // "Register" connector if not already created
    let connector;
    if (typeof parameters.connector === "function") connector = config._internal.connectors.setup(parameters.connector);
    else connector = parameters.connector;
    // Check if connector is already connected
    if (connector.uid === config.state.current) throw new (0, $115d9c96b0e3a6b5$export$ee7f4e50316bc4b2)();
    try {
        config.setState((x)=>({
                ...x,
                status: "connecting"
            }));
        connector.emitter.emit("message", {
            type: "connecting"
        });
        const data = await connector.connect({
            chainId: parameters.chainId
        });
        const accounts = data.accounts;
        connector.emitter.off("connect", config._internal.events.connect);
        connector.emitter.on("change", config._internal.events.change);
        connector.emitter.on("disconnect", config._internal.events.disconnect);
        await config.storage?.setItem("recentConnectorId", connector.id);
        config.setState((x)=>({
                ...x,
                connections: new Map(x.connections).set(connector.uid, {
                    accounts: accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: connector.uid,
                status: "connected"
            }));
        return {
            accounts: accounts,
            chainId: data.chainId
        };
    } catch (error) {
        config.setState((x)=>({
                ...x,
                // Keep existing connector connected in case of error
                status: x.current ? "connected" : "disconnected"
            }));
        throw error;
    }
}

/** https://wagmi.sh/core/api/actions/disconnect */ async function $cb43e43868f8b57f$export$37dfea93db2e14ed(config, parameters = {}) {
    let connector;
    if (parameters.connector) connector = parameters.connector;
    else {
        const { connections: connections, current: current } = config.state;
        const connection = connections.get(current);
        connector = connection?.connector;
    }
    const connections = config.state.connections;
    if (connector) {
        await connector.disconnect();
        connector.emitter.off("change", config._internal.events.change);
        connector.emitter.off("disconnect", config._internal.events.disconnect);
        connector.emitter.on("connect", config._internal.events.connect);
        connections.delete(connector.uid);
    }
    config.setState((x)=>{
        // if no connections exist, move to disconnected state
        if (connections.size === 0) return {
            ...x,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
        // switch over to another connection
        const nextConnection = connections.values().next().value;
        return {
            ...x,
            connections: new Map(connections),
            current: nextConnection.connector.uid
        };
    });
    // Set recent connector if exists
    {
        const current = config.state.current;
        if (!current) return;
        const connector = config.state.connections.get(current)?.connector;
        if (!connector) return;
        await config.storage?.setItem("recentConnectorId", connector.id);
    }
}


var $bsCQg = parcelRequire("bsCQg");

var $gzjWc = parcelRequire("gzjWc");

var $9vguw = parcelRequire("9vguw");

var $iffkR = parcelRequire("iffkR");
function $98d39282f68f8c70$export$462669520a9d12d1(publicKey) {
    const address = (0, $iffkR.keccak256)(`0x${publicKey.substring(4)}`).substring(26);
    return (0, $9vguw.checksumAddress)(`0x${address}`);
}



var $2ZAyo = parcelRequire("2ZAyo");

var $dZgT6 = parcelRequire("dZgT6");

var $8syAN = parcelRequire("8syAN");

async function $50a362ffdfedc2b9$export$952dd09fbe0232b7({ hash: hash, signature: signature }) {
    const hashHex = (0, $2ZAyo.isHex)(hash) ? hash : (0, $8syAN.toHex)(hash);
    const { secp256k1: secp256k1 } = await (parcelRequire("gUoDq"));
    const signature_ = (()=>{
        // typeof signature: `Signature`
        if (typeof signature === "object" && "r" in signature && "s" in signature) {
            const { r: r, s: s, v: v, yParity: yParity } = signature;
            const yParityOrV = Number(yParity ?? v);
            const recoveryBit = $50a362ffdfedc2b9$var$toRecoveryBit(yParityOrV);
            return new secp256k1.Signature((0, $dZgT6.hexToBigInt)(r), (0, $dZgT6.hexToBigInt)(s)).addRecoveryBit(recoveryBit);
        }
        // typeof signature: `Hex | ByteArray`
        const signatureHex = (0, $2ZAyo.isHex)(signature) ? signature : (0, $8syAN.toHex)(signature);
        const yParityOrV = (0, $dZgT6.hexToNumber)(`0x${signatureHex.slice(130)}`);
        const recoveryBit = $50a362ffdfedc2b9$var$toRecoveryBit(yParityOrV);
        return secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(recoveryBit);
    })();
    const publicKey = signature_.recoverPublicKey(hashHex.substring(2)).toHex(false);
    return `0x${publicKey}`;
}
function $50a362ffdfedc2b9$var$toRecoveryBit(yParityOrV) {
    if (yParityOrV === 0 || yParityOrV === 1) return yParityOrV;
    if (yParityOrV === 27) return 0;
    if (yParityOrV === 28) return 1;
    throw new Error("Invalid yParityOrV value");
}


async function $ba7bf362f0beae66$export$23cc18f96d8510e2({ hash: hash, signature: signature }) {
    return (0, $98d39282f68f8c70$export$462669520a9d12d1)(await (0, $50a362ffdfedc2b9$export$952dd09fbe0232b7)({
        hash: hash,
        signature: signature
    }));
}



var $fwEJN = parcelRequire("fwEJN");

var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");

var $gzjWc = parcelRequire("gzjWc");

var $4uT2F = parcelRequire("4uT2F");

var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");
function $3488c7a51b035c47$export$140c78e750979cda(bytes, to = "hex") {
    const encodable = $3488c7a51b035c47$var$getEncodable(bytes);
    const cursor = (0, $4uT2F.createCursor)(new Uint8Array(encodable.length));
    encodable.encode(cursor);
    if (to === "hex") return (0, $8syAN.bytesToHex)(cursor.bytes);
    return cursor.bytes;
}
function $3488c7a51b035c47$export$643d3163062ff0f3(bytes, to = "bytes") {
    return $3488c7a51b035c47$export$140c78e750979cda(bytes, to);
}
function $3488c7a51b035c47$export$e01da38311234e95(hex, to = "hex") {
    return $3488c7a51b035c47$export$140c78e750979cda(hex, to);
}
function $3488c7a51b035c47$var$getEncodable(bytes) {
    if (Array.isArray(bytes)) return $3488c7a51b035c47$var$getEncodableList(bytes.map((x)=>$3488c7a51b035c47$var$getEncodable(x)));
    return $3488c7a51b035c47$var$getEncodableBytes(bytes);
}
function $3488c7a51b035c47$var$getEncodableList(list) {
    const bodyLength = list.reduce((acc, x)=>acc + x.length, 0);
    const sizeOfBodyLength = $3488c7a51b035c47$var$getSizeOfLength(bodyLength);
    const length = (()=>{
        if (bodyLength <= 55) return 1 + bodyLength;
        return 1 + sizeOfBodyLength + bodyLength;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bodyLength <= 55) cursor.pushByte(0xc0 + bodyLength);
            else {
                cursor.pushByte(247 + sizeOfBodyLength);
                if (sizeOfBodyLength === 1) cursor.pushUint8(bodyLength);
                else if (sizeOfBodyLength === 2) cursor.pushUint16(bodyLength);
                else if (sizeOfBodyLength === 3) cursor.pushUint24(bodyLength);
                else cursor.pushUint32(bodyLength);
            }
            for (const { encode: encode } of list)encode(cursor);
        }
    };
}
function $3488c7a51b035c47$var$getEncodableBytes(bytesOrHex) {
    const bytes = typeof bytesOrHex === "string" ? (0, $2JRke.hexToBytes)(bytesOrHex) : bytesOrHex;
    const sizeOfBytesLength = $3488c7a51b035c47$var$getSizeOfLength(bytes.length);
    const length = (()=>{
        if (bytes.length === 1 && bytes[0] < 0x80) return 1;
        if (bytes.length <= 55) return 1 + bytes.length;
        return 1 + sizeOfBytesLength + bytes.length;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bytes.length === 1 && bytes[0] < 0x80) cursor.pushBytes(bytes);
            else if (bytes.length <= 55) {
                cursor.pushByte(0x80 + bytes.length);
                cursor.pushBytes(bytes);
            } else {
                cursor.pushByte(183 + sizeOfBytesLength);
                if (sizeOfBytesLength === 1) cursor.pushUint8(bytes.length);
                else if (sizeOfBytesLength === 2) cursor.pushUint16(bytes.length);
                else if (sizeOfBytesLength === 3) cursor.pushUint24(bytes.length);
                else cursor.pushUint32(bytes.length);
                cursor.pushBytes(bytes);
            }
        }
    };
}
function $3488c7a51b035c47$var$getSizeOfLength(length) {
    if (length < 256) return 1;
    if (length < 2 ** 16) return 2;
    if (length < 2 ** 24) return 3;
    if (length < 2 ** 32) return 4;
    throw new (0, $gzjWc.BaseError)("Length is too large.");
}



var $iffkR = parcelRequire("iffkR");
function $8ec3c8d904c64c8b$export$52e574e057b290dc(parameters) {
    const { chainId: chainId, contractAddress: contractAddress, nonce: nonce, to: to } = parameters;
    const hash = (0, $iffkR.keccak256)((0, $fwEJN.concatHex)([
        "0x05",
        (0, $3488c7a51b035c47$export$140c78e750979cda)([
            (0, $8syAN.numberToHex)(chainId),
            contractAddress,
            (0, $8syAN.numberToHex)(nonce)
        ])
    ]));
    if (to === "bytes") return (0, $2JRke.hexToBytes)(hash);
    return hash;
}


async function $0a3ce840373cd956$export$415d0315604a8515(parameters) {
    const { authorization: authorization, signature: signature } = parameters;
    return (0, $ba7bf362f0beae66$export$23cc18f96d8510e2)({
        hash: (0, $8ec3c8d904c64c8b$export$52e574e057b290dc)(authorization),
        signature: signature ?? authorization
    });
}



var $8syAN = parcelRequire("8syAN");

var $ag3Uj = parcelRequire("ag3Uj");

var $a6AVd = parcelRequire("a6AVd");

var $gzjWc = parcelRequire("gzjWc");

var $kIOz8 = parcelRequire("kIOz8");
class $2376487ab963ebef$export$9e393e362ab0c102 extends (0, $gzjWc.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = (0, $kIOz8.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $ag3Uj.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $a6AVd.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $a6AVd.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $a6AVd.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Estimate Gas Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "EstimateGasExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}



var $lpgkb = parcelRequire("lpgkb");

var $leBvp = parcelRequire("leBvp");
function $3429022cb5f98100$export$f201b805dbcd7c48(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $leBvp.getNodeError)(err, args);
        if (cause instanceof (0, $lpgkb.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $2376487ab963ebef$export$9e393e362ab0c102)(cause, {
        docsPath: docsPath,
        ...args
    });
}



var $36Zbp = parcelRequire("36Zbp");

var $cdG5Y = parcelRequire("cdG5Y");

var $2Pi5m = parcelRequire("2Pi5m");

var $ea0OJ = parcelRequire("ea0OJ");

var $bsCQg = parcelRequire("bsCQg");

var $a6AVd = parcelRequire("a6AVd");

var $gzjWc = parcelRequire("gzjWc");
class $912a0d4363b4bc72$export$200c092bedf29ac0 extends (0, $gzjWc.BaseError) {
    constructor(){
        super("`baseFeeMultiplier` must be greater than 1.", {
            name: "BaseFeeScalarError"
        });
    }
}
class $912a0d4363b4bc72$export$dcf53c0ae183fb46 extends (0, $gzjWc.BaseError) {
    constructor(){
        super("Chain does not support EIP-1559 fees.", {
            name: "Eip1559FeesNotSupportedError"
        });
    }
}
class $912a0d4363b4bc72$export$bcf9730904a1086f extends (0, $gzjWc.BaseError) {
    constructor({ maxPriorityFeePerGas: maxPriorityFeePerGas }){
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${(0, $a6AVd.formatGwei)(maxPriorityFeePerGas)} gwei).`, {
            name: "MaxFeePerGasTooLowError"
        });
    }
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $c66640b3f6d368dc$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return (params)=>actionFn(client, params);
}




var $dZgT6 = parcelRequire("dZgT6");


var $gzjWc = parcelRequire("gzjWc");
class $ba5a0965c3d7b739$export$f5a00468af285e38 extends (0, $gzjWc.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber }){
        let identifier = "Block";
        if (blockHash) identifier = `Block at hash "${blockHash}"`;
        if (blockNumber) identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`, {
            name: "BlockNotFoundError"
        });
    }
}



var $8syAN = parcelRequire("8syAN");

var $9A1yP = parcelRequire("9A1yP");

var $dZgT6 = parcelRequire("dZgT6");

var $9A1yP = parcelRequire("9A1yP");
const $e1557bfb53fe1c2f$export$cd5f936b62a5e91 = {
    "0x0": "legacy",
    "0x1": "eip2930",
    "0x2": "eip1559",
    "0x3": "eip4844",
    "0x4": "eip7702"
};
function $e1557bfb53fe1c2f$export$b02b16590d26dadc(transaction) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        chainId: transaction.chainId ? (0, $dZgT6.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerBlobGas: transaction.maxFeePerBlobGas ? BigInt(transaction.maxFeePerBlobGas) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $dZgT6.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $e1557bfb53fe1c2f$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    };
    if (transaction.authorizationList) transaction_.authorizationList = $e1557bfb53fe1c2f$var$formatAuthorizationList(transaction.authorizationList);
    transaction_.yParity = (()=>{
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === "bigint") {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === "legacy") {
        delete transaction_.accessList;
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === "eip2930") {
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    if (transaction_.type === "eip1559") delete transaction_.maxFeePerBlobGas;
    return transaction_;
}
const $e1557bfb53fe1c2f$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $9A1yP.defineFormatter)("transaction", $e1557bfb53fe1c2f$export$b02b16590d26dadc);
//////////////////////////////////////////////////////////////////////////////
function $e1557bfb53fe1c2f$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            contractAddress: authorization.address,
            r: authorization.r,
            s: authorization.s,
            chainId: Number(authorization.chainId),
            nonce: Number(authorization.nonce),
            ...typeof authorization.yParity !== "undefined" ? {
                yParity: Number(authorization.yParity)
            } : {},
            ...typeof authorization.v !== "undefined" && typeof authorization.yParity === "undefined" ? {
                v: Number(authorization.v)
            } : {}
        }));
}


function $f83a284476611a21$export$ba1152bc4017d62a(block) {
    const transactions = block.transactions?.map((transaction)=>{
        if (typeof transaction === "string") return transaction;
        return (0, $e1557bfb53fe1c2f$export$b02b16590d26dadc)(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        blobGasUsed: block.blobGasUsed ? BigInt(block.blobGasUsed) : undefined,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        excessBlobGas: block.excessBlobGas ? BigInt(block.excessBlobGas) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    };
}
const $f83a284476611a21$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $9A1yP.defineFormatter)("block", $f83a284476611a21$export$ba1152bc4017d62a);


async function $5f9e2cea6bd44750$export$ea0af84ed2e77902(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_ } = {}) {
    const blockTag = blockTag_ ?? "latest";
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? (0, $8syAN.numberToHex)(blockNumber) : undefined;
    let block = null;
    if (blockHash) block = await client.request({
        method: "eth_getBlockByHash",
        params: [
            blockHash,
            includeTransactions
        ]
    }, {
        dedupe: true
    });
    else block = await client.request({
        method: "eth_getBlockByNumber",
        params: [
            blockNumberHex || blockTag,
            includeTransactions
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!block) throw new (0, $ba5a0965c3d7b739$export$f5a00468af285e38)({
        blockHash: blockHash,
        blockNumber: blockNumber
    });
    const format = client.chain?.formatters?.block?.format || (0, $f83a284476611a21$export$ba1152bc4017d62a);
    return format(block);
}


/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ async function $3748032e6e882284$export$89c15b50d46d3f8c(client) {
    const gasPrice = await client.request({
        method: "eth_gasPrice"
    });
    return BigInt(gasPrice);
}


async function $73ad46c9775fc8b5$export$fd79a693887f886c(client, args) {
    return $73ad46c9775fc8b5$export$59275bafd388148(client, args);
}
async function $73ad46c9775fc8b5$export$59275bafd388148(client, args) {
    const { block: block_, chain: chain = client.chain, request: request } = args || {};
    try {
        const maxPriorityFeePerGas = chain?.fees?.maxPriorityFeePerGas ?? chain?.fees?.defaultPriorityFee;
        if (typeof maxPriorityFeePerGas === "function") {
            const block = block_ || await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $5f9e2cea6bd44750$export$ea0af84ed2e77902), "getBlock")({});
            const maxPriorityFeePerGas_ = await maxPriorityFeePerGas({
                block: block,
                client: client,
                request: request
            });
            if (maxPriorityFeePerGas_ === null) throw new Error();
            return maxPriorityFeePerGas_;
        }
        if (typeof maxPriorityFeePerGas !== "undefined") return maxPriorityFeePerGas;
        const maxPriorityFeePerGasHex = await client.request({
            method: "eth_maxPriorityFeePerGas"
        });
        return (0, $dZgT6.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch  {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_ ? Promise.resolve(block_) : (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $5f9e2cea6bd44750$export$ea0af84ed2e77902), "getBlock")({}),
            (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $3748032e6e882284$export$89c15b50d46d3f8c), "getGasPrice")({})
        ]);
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $912a0d4363b4bc72$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n) return 0n;
        return maxPriorityFeePerGas;
    }
}




async function $e38c961ed0a39317$export$8193bed8c46d2831(client, args) {
    return $e38c961ed0a39317$export$67115e8707c5a9e(client, args);
}
async function $e38c961ed0a39317$export$67115e8707c5a9e(client, args) {
    const { block: block_, chain: chain = client.chain, request: request, type: type = "eip1559" } = args || {};
    const baseFeeMultiplier = await (async ()=>{
        if (typeof chain?.fees?.baseFeeMultiplier === "function") return chain.fees.baseFeeMultiplier({
            block: block_,
            client: client,
            request: request
        });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new (0, $912a0d4363b4bc72$export$200c092bedf29ac0)();
    const decimals = baseFeeMultiplier.toString().split(".")[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base)=>base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $5f9e2cea6bd44750$export$ea0af84ed2e77902), "getBlock")({});
    if (typeof chain?.fees?.estimateFeesPerGas === "function") {
        const fees = await chain.fees.estimateFeesPerGas({
            block: block_,
            client: client,
            multiply: multiply,
            request: request,
            type: type
        });
        if (fees !== null) return fees;
    }
    if (type === "eip1559") {
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $912a0d4363b4bc72$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = typeof request?.maxPriorityFeePerGas === "bigint" ? request.maxPriorityFeePerGas : await (0, $73ad46c9775fc8b5$export$59275bafd388148)(client, {
            block: block,
            chain: chain,
            request: request
        });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $3748032e6e882284$export$89c15b50d46d3f8c), "getGasPrice")({}));
    return {
        gasPrice: gasPrice
    };
}





var $dZgT6 = parcelRequire("dZgT6");

var $8syAN = parcelRequire("8syAN");
async function $248c64c905814435$export$b18e66333ec1361e(client, { address: address, blockTag: blockTag = "latest", blockNumber: blockNumber }) {
    const count = await client.request({
        method: "eth_getTransactionCount",
        params: [
            address,
            blockNumber ? (0, $8syAN.numberToHex)(blockNumber) : blockTag
        ]
    }, {
        dedupe: Boolean(blockNumber)
    });
    return (0, $dZgT6.hexToNumber)(count);
}




var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");
function $ed89909378f75739$export$b67626aab22a659b(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
    const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x)=>(0, $2JRke.hexToBytes)(x)) : parameters.blobs;
    const commitments = [];
    for (const blob of blobs)commitments.push(Uint8Array.from(kzg.blobToKzgCommitment(blob)));
    return to === "bytes" ? commitments : commitments.map((x)=>(0, $8syAN.bytesToHex)(x));
}



var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");
function $e96d1fc8a50ae397$export$78a225f8922765eb(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
    const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x)=>(0, $2JRke.hexToBytes)(x)) : parameters.blobs;
    const commitments = typeof parameters.commitments[0] === "string" ? parameters.commitments.map((x)=>(0, $2JRke.hexToBytes)(x)) : parameters.commitments;
    const proofs = [];
    for(let i = 0; i < blobs.length; i++){
        const blob = blobs[i];
        const commitment = commitments[i];
        proofs.push(Uint8Array.from(kzg.computeBlobKzgProof(blob, commitment)));
    }
    return to === "bytes" ? proofs : proofs.map((x)=>(0, $8syAN.bytesToHex)(x));
}



var $8syAN = parcelRequire("8syAN");

var $4KDKO = parcelRequire("4KDKO");

var $2ZAyo = parcelRequire("2ZAyo");

var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");
function $4b53e4dd423e502f$export$bced8d2aada2d1c9(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $4KDKO.sha256)((0, $2ZAyo.isHex)(value, {
        strict: false
    }) ? (0, $2JRke.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $8syAN.toHex)(bytes);
}


function $188c12060a272ac4$export$7b2f762c7eb1ecea(parameters) {
    const { commitment: commitment, version: version = 1 } = parameters;
    const to = parameters.to ?? (typeof commitment === "string" ? "hex" : "bytes");
    const versionedHash = (0, $4b53e4dd423e502f$export$bced8d2aada2d1c9)(commitment, "bytes");
    versionedHash.set([
        version
    ], 0);
    return to === "bytes" ? versionedHash : (0, $8syAN.bytesToHex)(versionedHash);
}


function $083b1c243c41ca99$export$e31b3e59dda37b17(parameters) {
    const { commitments: commitments, version: version } = parameters;
    const to = parameters.to ?? (typeof commitments[0] === "string" ? "hex" : "bytes");
    const hashes = [];
    for (const commitment of commitments)hashes.push((0, $188c12060a272ac4$export$7b2f762c7eb1ecea)({
        commitment: commitment,
        to: to,
        version: version
    }));
    return hashes;
}




// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
/** Blob limit per transaction. */ const $a68af04d1184e20b$var$blobsPerTransaction = 6;
const $a68af04d1184e20b$export$a5d2a246d959344 = 32;
const $a68af04d1184e20b$export$57577a1a84b7e334 = 4096;
const $a68af04d1184e20b$export$6f30828563a6c6ef = $a68af04d1184e20b$export$a5d2a246d959344 * $a68af04d1184e20b$export$57577a1a84b7e334;
const $a68af04d1184e20b$export$b8db4e3f07d08e09 = $a68af04d1184e20b$export$6f30828563a6c6ef * $a68af04d1184e20b$var$blobsPerTransaction - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * $a68af04d1184e20b$export$57577a1a84b7e334 * $a68af04d1184e20b$var$blobsPerTransaction;


// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
const $28df4bdb031582f7$export$de38d5f871f0b1cd = 1;



var $gzjWc = parcelRequire("gzjWc");
class $429ef045de86c84d$export$4000e90bfe41caa1 extends (0, $gzjWc.BaseError) {
    constructor({ maxSize: maxSize, size: size }){
        super("Blob size is too large.", {
            metaMessages: [
                `Max: ${maxSize} bytes`,
                `Given: ${size} bytes`
            ],
            name: "BlobSizeTooLargeError"
        });
    }
}
class $429ef045de86c84d$export$d145394ceab4d1c3 extends (0, $gzjWc.BaseError) {
    constructor(){
        super("Blob data must not be empty.", {
            name: "EmptyBlobError"
        });
    }
}
class $429ef045de86c84d$export$ebd5b15dd92c680 extends (0, $gzjWc.BaseError) {
    constructor({ hash: hash, size: size }){
        super(`Versioned hash "${hash}" size is invalid.`, {
            metaMessages: [
                "Expected: 32",
                `Received: ${size}`
            ],
            name: "InvalidVersionedHashSizeError"
        });
    }
}
class $429ef045de86c84d$export$509ed1d312c500 extends (0, $gzjWc.BaseError) {
    constructor({ hash: hash, version: version }){
        super(`Versioned hash "${hash}" version is invalid.`, {
            metaMessages: [
                `Expected: ${(0, $28df4bdb031582f7$export$de38d5f871f0b1cd)}`,
                `Received: ${version}`
            ],
            name: "InvalidVersionedHashVersionError"
        });
    }
}



var $4uT2F = parcelRequire("4uT2F");

var $1TQIz = parcelRequire("1TQIz");

var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");
function $672ffcaef1fceb5b$export$7ec339bd77d6ed92(parameters) {
    const to = parameters.to ?? (typeof parameters.data === "string" ? "hex" : "bytes");
    const data = typeof parameters.data === "string" ? (0, $2JRke.hexToBytes)(parameters.data) : parameters.data;
    const size_ = (0, $1TQIz.size)(data);
    if (!size_) throw new (0, $429ef045de86c84d$export$d145394ceab4d1c3)();
    if (size_ > (0, $a68af04d1184e20b$export$b8db4e3f07d08e09)) throw new (0, $429ef045de86c84d$export$4000e90bfe41caa1)({
        maxSize: (0, $a68af04d1184e20b$export$b8db4e3f07d08e09),
        size: size_
    });
    const blobs = [];
    let active = true;
    let position = 0;
    while(active){
        const blob = (0, $4uT2F.createCursor)(new Uint8Array((0, $a68af04d1184e20b$export$6f30828563a6c6ef)));
        let size = 0;
        while(size < (0, $a68af04d1184e20b$export$57577a1a84b7e334)){
            const bytes = data.slice(position, position + ((0, $a68af04d1184e20b$export$a5d2a246d959344) - 1));
            // Push a zero byte so the field element doesn't overflow the BLS modulus.
            blob.pushByte(0x00);
            // Push the current segment of data bytes.
            blob.pushBytes(bytes);
            // If we detect that the current segment of data bytes is less than 31 bytes,
            // we can stop processing and push a terminator byte to indicate the end of the blob.
            if (bytes.length < 31) {
                blob.pushByte(0x80);
                active = false;
                break;
            }
            size++;
            position += 31;
        }
        blobs.push(blob);
    }
    return to === "bytes" ? blobs.map((x)=>x.bytes) : blobs.map((x)=>(0, $8syAN.bytesToHex)(x.bytes));
}


function $9bdfdc32bbb1e5a4$export$44960962e1c9641b(parameters) {
    const { data: data, kzg: kzg, to: to } = parameters;
    const blobs = parameters.blobs ?? (0, $672ffcaef1fceb5b$export$7ec339bd77d6ed92)({
        data: data,
        to: to
    });
    const commitments = parameters.commitments ?? (0, $ed89909378f75739$export$b67626aab22a659b)({
        blobs: blobs,
        kzg: kzg,
        to: to
    });
    const proofs = parameters.proofs ?? (0, $e96d1fc8a50ae397$export$78a225f8922765eb)({
        blobs: blobs,
        commitments: commitments,
        kzg: kzg,
        to: to
    });
    const sidecars = [];
    for(let i = 0; i < blobs.length; i++)sidecars.push({
        blob: blobs[i],
        commitment: commitments[i],
        proof: proofs[i]
    });
    return sidecars;
}




var $ea0OJ = parcelRequire("ea0OJ");

var $kIOz8 = parcelRequire("kIOz8");
function $b8d5fd687312ade7$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.authorizationList !== "undefined") return "eip7702";
    if (typeof transaction.blobs !== "undefined" || typeof transaction.blobVersionedHashes !== "undefined" || typeof transaction.maxFeePerBlobGas !== "undefined" || typeof transaction.sidecars !== "undefined") return "eip4844";
    if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") return "eip1559";
    if (typeof transaction.gasPrice !== "undefined") {
        if (typeof transaction.accessList !== "undefined") return "eip2930";
        return "legacy";
    }
    throw new (0, $kIOz8.InvalidSerializableTransactionError)({
        transaction: transaction
    });
}



var $dZgT6 = parcelRequire("dZgT6");
async function $9a7d2afa33752492$export$850fa7b3891187c(client) {
    const chainIdHex = await client.request({
        method: "eth_chainId"
    }, {
        dedupe: true
    });
    return (0, $dZgT6.hexToNumber)(chainIdHex);
}


const $9440447d591deedf$export$4f3e0c2bc77eca55 = [
    "blobVersionedHashes",
    "chainId",
    "fees",
    "gas",
    "nonce",
    "type"
];
async function $9440447d591deedf$export$2e8a9232fb815d77(client, args) {
    const { account: account_ = client.account, blobs: blobs, chain: chain, gas: gas, kzg: kzg, nonce: nonce, nonceManager: nonceManager, parameters: parameters = $9440447d591deedf$export$4f3e0c2bc77eca55, type: type } = args;
    const account = account_ ? (0, $bsCQg.parseAccount)(account_) : undefined;
    const request = {
        ...args,
        ...account ? {
            from: account?.address
        } : {}
    };
    let block;
    async function getBlock() {
        if (block) return block;
        block = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $5f9e2cea6bd44750$export$ea0af84ed2e77902), "getBlock")({
            blockTag: "latest"
        });
        return block;
    }
    let chainId;
    async function getChainId() {
        if (chainId) return chainId;
        if (chain) return chain.id;
        if (typeof args.chainId !== "undefined") return args.chainId;
        const chainId_ = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $9a7d2afa33752492$export$850fa7b3891187c), "getChainId")({});
        chainId = chainId_;
        return chainId;
    }
    if ((parameters.includes("blobVersionedHashes") || parameters.includes("sidecars")) && blobs && kzg) {
        const commitments = (0, $ed89909378f75739$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (parameters.includes("blobVersionedHashes")) {
            const versionedHashes = (0, $083b1c243c41ca99$export$e31b3e59dda37b17)({
                commitments: commitments,
                to: "hex"
            });
            request.blobVersionedHashes = versionedHashes;
        }
        if (parameters.includes("sidecars")) {
            const proofs = (0, $e96d1fc8a50ae397$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            const sidecars = (0, $9bdfdc32bbb1e5a4$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs,
                to: "hex"
            });
            request.sidecars = sidecars;
        }
    }
    if (parameters.includes("chainId")) request.chainId = await getChainId();
    if (parameters.includes("nonce") && typeof nonce === "undefined" && account) {
        if (nonceManager) {
            const chainId = await getChainId();
            request.nonce = await nonceManager.consume({
                address: account.address,
                chainId: chainId,
                client: client
            });
        } else request.nonce = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $248c64c905814435$export$b18e66333ec1361e), "getTransactionCount")({
            address: account.address,
            blockTag: "pending"
        });
    }
    if ((parameters.includes("fees") || parameters.includes("type")) && typeof type === "undefined") try {
        request.type = (0, $b8d5fd687312ade7$export$944c6678cd5a1ea8)(request);
    } catch  {
        // infer type from block
        const block = await getBlock();
        request.type = typeof block?.baseFeePerGas === "bigint" ? "eip1559" : "legacy";
    }
    if (parameters.includes("fees")) {
        // TODO(4844): derive blob base fees once https://github.com/ethereum/execution-apis/pull/486 is merged.
        if (request.type !== "legacy" && request.type !== "eip2930") // EIP-1559 fees
        {
            if (typeof request.maxFeePerGas === "undefined" || typeof request.maxPriorityFeePerGas === "undefined") {
                const block = await getBlock();
                const { maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = await (0, $e38c961ed0a39317$export$67115e8707c5a9e)(client, {
                    block: block,
                    chain: chain,
                    request: request
                });
                if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $912a0d4363b4bc72$export$bcf9730904a1086f)({
                    maxPriorityFeePerGas: maxPriorityFeePerGas
                });
                request.maxPriorityFeePerGas = maxPriorityFeePerGas;
                request.maxFeePerGas = maxFeePerGas;
            }
        } else {
            // Legacy fees
            if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new (0, $912a0d4363b4bc72$export$dcf53c0ae183fb46)();
            const block = await getBlock();
            const { gasPrice: gasPrice_ } = await (0, $e38c961ed0a39317$export$67115e8707c5a9e)(client, {
                block: block,
                chain: chain,
                request: request,
                type: "legacy"
            });
            request.gasPrice = gasPrice_;
        }
    }
    if (parameters.includes("gas") && typeof gas === "undefined") request.gas = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $78d4816ed4f36c1b$export$e0580ae1f48db848), "estimateGas")({
        ...request,
        account: account ? {
            address: account.address,
            type: "json-rpc"
        } : undefined
    });
    (0, $ea0OJ.assertRequest)(request);
    delete request.parameters;
    return request;
}



var $8syAN = parcelRequire("8syAN");
async function $b8d5769d6b70fa25$export$df96cd8d56be0ab1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber ? (0, $8syAN.numberToHex)(blockNumber) : undefined;
    const balance = await client.request({
        method: "eth_getBalance",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    return BigInt(balance);
}


async function $78d4816ed4f36c1b$export$e0580ae1f48db848(client, args) {
    const account_ = args.account ?? client.account;
    const account = account_ ? (0, $bsCQg.parseAccount)(account_) : undefined;
    try {
        const { accessList: accessList, authorizationList: authorizationList, blobs: blobs, blobVersionedHashes: blobVersionedHashes, blockNumber: blockNumber, blockTag: blockTag, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value, stateOverride: stateOverride, ...rest } = await (0, $9440447d591deedf$export$2e8a9232fb815d77)(client, {
            ...args,
            parameters: // Some RPC Providers do not compute versioned hashes from blobs. We will need
            // to compute them.
            account?.type === "local" ? undefined : [
                "blobVersionedHashes"
            ]
        });
        const blockNumberHex = blockNumber ? (0, $8syAN.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = (0, $2Pi5m.serializeStateOverride)(stateOverride);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (rest.to) return rest.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $0a3ce840373cd956$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $gzjWc.BaseError)("`to` is required. Could not infer from `authorizationList`");
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        (0, $ea0OJ.assertRequest)(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $cdG5Y.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $36Zbp.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            authorizationList: authorizationList,
            blobs: blobs,
            blobVersionedHashes: blobVersionedHashes,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        function estimateGas_rpc(parameters) {
            const { block: block, request: request, rpcStateOverride: rpcStateOverride } = parameters;
            return client.request({
                method: "eth_estimateGas",
                params: rpcStateOverride ? [
                    request,
                    block ?? "latest",
                    rpcStateOverride
                ] : block ? [
                    request,
                    block
                ] : [
                    request
                ]
            });
        }
        let estimate = BigInt(await estimateGas_rpc({
            block: block,
            request: request,
            rpcStateOverride: rpcStateOverride
        }));
        // TODO(7702): Remove this once https://github.com/ethereum/execution-apis/issues/561 is resolved.
        //       Authorization list schema is not implemented on JSON-RPC spec yet, so we need to
        //       manually estimate the gas.
        if (authorizationList) {
            const value = await (0, $b8d5769d6b70fa25$export$df96cd8d56be0ab1)(client, {
                address: request.from
            });
            const estimates = await Promise.all(authorizationList.map(async (authorization)=>{
                const { contractAddress: contractAddress } = authorization;
                const estimate = await estimateGas_rpc({
                    block: block,
                    request: {
                        authorizationList: undefined,
                        data: data,
                        from: account?.address,
                        to: contractAddress,
                        value: (0, $8syAN.numberToHex)(value)
                    },
                    rpcStateOverride: rpcStateOverride
                }).catch(()=>100000n);
                return 2n * BigInt(estimate);
            }));
            estimate += estimates.reduce((acc, curr)=>acc + curr, 0n);
        }
        return estimate;
    } catch (err) {
        throw (0, $3429022cb5f98100$export$f201b805dbcd7c48)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $16f206e6d6a76121$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return (params)=>actionFn(client, params);
}



var $bsCQg = parcelRequire("bsCQg");
const $109d73236a187822$var$size = 256;
let $109d73236a187822$var$index = $109d73236a187822$var$size;
let $109d73236a187822$var$buffer;
function $109d73236a187822$export$e2a22331486dcca0(length = 11) {
    if (!$109d73236a187822$var$buffer || $109d73236a187822$var$index + length > $109d73236a187822$var$size * 2) {
        $109d73236a187822$var$buffer = "";
        $109d73236a187822$var$index = 0;
        for(let i = 0; i < $109d73236a187822$var$size; i++)$109d73236a187822$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $109d73236a187822$var$buffer.substring($109d73236a187822$var$index, $109d73236a187822$var$index++ + length);
}


function $81f5f2ddf42262a4$export$5d730b7aed1a3eb0(parameters) {
    const { batch: batch, cacheTime: cacheTime = parameters.pollingInterval ?? 4000, ccipRead: ccipRead, key: key = "base", name: name = "Base Client", pollingInterval: pollingInterval = 4000, type: type = "base" } = parameters;
    const chain = parameters.chain;
    const account = parameters.account ? (0, $bsCQg.parseAccount)(parameters.account) : undefined;
    const { config: config, request: request, value: value } = parameters.transport({
        chain: chain,
        pollingInterval: pollingInterval
    });
    const transport = {
        ...config,
        ...value
    };
    const client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        ccipRead: ccipRead,
        chain: chain,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $109d73236a187822$export$e2a22331486dcca0)()
    };
    function extend(base) {
        return (extendFn)=>{
            const extended = extendFn(base);
            for(const key in client)delete extended[key];
            const combined = {
                ...base,
                ...extended
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}
function $81f5f2ddf42262a4$export$3db60a9e016ddd81() {
    return null;
}


var $gzjWc = parcelRequire("gzjWc");

var $aMZh2 = parcelRequire("aMZh2");

var $b9XBB = parcelRequire("b9XBB");

var $8syAN = parcelRequire("8syAN");

var $iffkR = parcelRequire("iffkR");

var $8wRaD = parcelRequire("8wRaD");
const $db589f2c63e67051$export$e89e805418f4d2c = /*#__PURE__*/ new (0, $8wRaD.LruMap)(8192);
function $db589f2c63e67051$export$387c3b0c09132fc3(fn, { enabled: enabled = true, id: id }) {
    if (!enabled || !id) return fn();
    if ($db589f2c63e67051$export$e89e805418f4d2c.get(id)) return $db589f2c63e67051$export$e89e805418f4d2c.get(id);
    const promise = fn().finally(()=>$db589f2c63e67051$export$e89e805418f4d2c.delete(id));
    $db589f2c63e67051$export$e89e805418f4d2c.set(id, promise);
    return promise;
}


async function $82df4c442695b4bf$export$5c069c93d2b7493f(time) {
    return new Promise((res)=>setTimeout(res, time));
}


function $ed552b6d0c3a055e$export$188df5ecf8e7961a(fn, { delay: delay_ = 100, retryCount: retryCount = 2, shouldRetry: shouldRetry = ()=>true } = {}) {
    return new Promise((resolve, reject)=>{
        const attemptRetry = async ({ count: count = 0 } = {})=>{
            const retry = async ({ error: error })=>{
                const delay = typeof delay_ === "function" ? delay_({
                    count: count,
                    error: error
                }) : delay_;
                if (delay) await (0, $82df4c442695b4bf$export$5c069c93d2b7493f)(delay);
                attemptRetry({
                    count: count + 1
                });
            };
            try {
                const data = await fn();
                resolve(data);
            } catch (err) {
                if (count < retryCount && await shouldRetry({
                    count: count,
                    error: err
                })) return retry({
                    error: err
                });
                reject(err);
            }
        };
        attemptRetry();
    });
}



var $6nOtb = parcelRequire("6nOtb");
function $36a2d07bb494a676$export$6c5295ef7e82f2b2(request, options = {}) {
    return async (args, overrideOptions = {})=>{
        const { dedupe: dedupe = false, retryDelay: retryDelay = 150, retryCount: retryCount = 3, uid: uid } = {
            ...options,
            ...overrideOptions
        };
        const requestId = dedupe ? (0, $iffkR.keccak256)((0, $8syAN.stringToHex)(`${uid}.${(0, $6nOtb.stringify)(args)}`)) : undefined;
        return (0, $db589f2c63e67051$export$387c3b0c09132fc3)(()=>(0, $ed552b6d0c3a055e$export$188df5ecf8e7961a)(async ()=>{
                try {
                    return await request(args);
                } catch (err_) {
                    const err = err_;
                    switch(err.code){
                        // -32700
                        case (0, $b9XBB.ParseRpcError).code:
                            throw new (0, $b9XBB.ParseRpcError)(err);
                        // -32600
                        case (0, $b9XBB.InvalidRequestRpcError).code:
                            throw new (0, $b9XBB.InvalidRequestRpcError)(err);
                        // -32601
                        case (0, $b9XBB.MethodNotFoundRpcError).code:
                            throw new (0, $b9XBB.MethodNotFoundRpcError)(err, {
                                method: args.method
                            });
                        // -32602
                        case (0, $b9XBB.InvalidParamsRpcError).code:
                            throw new (0, $b9XBB.InvalidParamsRpcError)(err);
                        // -32603
                        case (0, $b9XBB.InternalRpcError).code:
                            throw new (0, $b9XBB.InternalRpcError)(err);
                        // -32000
                        case (0, $b9XBB.InvalidInputRpcError).code:
                            throw new (0, $b9XBB.InvalidInputRpcError)(err);
                        // -32001
                        case (0, $b9XBB.ResourceNotFoundRpcError).code:
                            throw new (0, $b9XBB.ResourceNotFoundRpcError)(err);
                        // -32002
                        case (0, $b9XBB.ResourceUnavailableRpcError).code:
                            throw new (0, $b9XBB.ResourceUnavailableRpcError)(err);
                        // -32003
                        case (0, $b9XBB.TransactionRejectedRpcError).code:
                            throw new (0, $b9XBB.TransactionRejectedRpcError)(err);
                        // -32004
                        case (0, $b9XBB.MethodNotSupportedRpcError).code:
                            throw new (0, $b9XBB.MethodNotSupportedRpcError)(err, {
                                method: args.method
                            });
                        // -32005
                        case (0, $b9XBB.LimitExceededRpcError).code:
                            throw new (0, $b9XBB.LimitExceededRpcError)(err);
                        // -32006
                        case (0, $b9XBB.JsonRpcVersionUnsupportedError).code:
                            throw new (0, $b9XBB.JsonRpcVersionUnsupportedError)(err);
                        // 4001
                        case (0, $b9XBB.UserRejectedRequestError).code:
                            throw new (0, $b9XBB.UserRejectedRequestError)(err);
                        // 4100
                        case (0, $b9XBB.UnauthorizedProviderError).code:
                            throw new (0, $b9XBB.UnauthorizedProviderError)(err);
                        // 4200
                        case (0, $b9XBB.UnsupportedProviderMethodError).code:
                            throw new (0, $b9XBB.UnsupportedProviderMethodError)(err);
                        // 4900
                        case (0, $b9XBB.ProviderDisconnectedError).code:
                            throw new (0, $b9XBB.ProviderDisconnectedError)(err);
                        // 4901
                        case (0, $b9XBB.ChainDisconnectedError).code:
                            throw new (0, $b9XBB.ChainDisconnectedError)(err);
                        // 4902
                        case (0, $b9XBB.SwitchChainError).code:
                            throw new (0, $b9XBB.SwitchChainError)(err);
                        // CAIP-25: User Rejected Error
                        // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                        case 5000:
                            throw new (0, $b9XBB.UserRejectedRequestError)(err);
                        default:
                            if (err_ instanceof (0, $gzjWc.BaseError)) throw err_;
                            throw new (0, $b9XBB.UnknownRpcError)(err);
                    }
                }
            }, {
                delay: ({ count: count, error: error })=>{
                    // If we find a Retry-After header, let's retry after the given time.
                    if (error && error instanceof (0, $aMZh2.HttpRequestError)) {
                        const retryAfter = error?.headers?.get("Retry-After");
                        if (retryAfter?.match(/\d/)) return Number.parseInt(retryAfter) * 1000;
                    }
                    // Otherwise, let's retry with an exponential backoff.
                    return ~~(1 << count) * retryDelay;
                },
                retryCount: retryCount,
                shouldRetry: ({ error: error })=>$36a2d07bb494a676$export$7bfea3c3d460ecd8(error)
            }), {
            enabled: dedupe,
            id: requestId
        });
    };
}
function $36a2d07bb494a676$export$7bfea3c3d460ecd8(error) {
    if ("code" in error && typeof error.code === "number") {
        if (error.code === -1) return true; // Unknown error
        if (error.code === (0, $b9XBB.LimitExceededRpcError).code) return true;
        if (error.code === (0, $b9XBB.InternalRpcError).code) return true;
        return false;
    }
    if (error instanceof (0, $aMZh2.HttpRequestError) && error.status) {
        // Forbidden
        if (error.status === 403) return true;
        // Request Timeout
        if (error.status === 408) return true;
        // Request Entity Too Large
        if (error.status === 413) return true;
        // Too Many Requests
        if (error.status === 429) return true;
        // Internal Server Error
        if (error.status === 500) return true;
        // Bad Gateway
        if (error.status === 502) return true;
        // Service Unavailable
        if (error.status === 503) return true;
        // Gateway Timeout
        if (error.status === 504) return true;
        return false;
    }
    return true;
}



function $d48cdafdaf09bb70$export$d09f50d9ab7f7b69({ key: key, name: name, request: request, retryCount: retryCount = 3, retryDelay: retryDelay = 150, timeout: timeout, type: type }, value) {
    const uid = (0, $109d73236a187822$export$e2a22331486dcca0)();
    return {
        config: {
            key: key,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $36a2d07bb494a676$export$6c5295ef7e82f2b2)(request, {
            retryCount: retryCount,
            retryDelay: retryDelay,
            uid: uid
        }),
        value: value
    };
}


function $7a6358c7599e96f1$export$4c00f665f0d4b443(provider, config = {}) {
    const { key: key = "custom", name: name = "Custom Provider", retryDelay: retryDelay } = config;
    return ({ retryCount: defaultRetryCount })=>(0, $d48cdafdaf09bb70$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            request: provider.request.bind(provider),
            retryCount: config.retryCount ?? defaultRetryCount,
            retryDelay: retryDelay,
            type: "custom"
        });
}



var $9vguw = parcelRequire("9vguw");
var $bsCQg = parcelRequire("bsCQg");

async function $952dfb3505a236b1$export$d784801ca17b4aec(config, parameters = {}) {
    // Get connection
    let connection;
    if (parameters.connector) {
        const { connector: connector } = parameters;
        const [accounts, chainId] = await Promise.all([
            connector.getAccounts(),
            connector.getChainId()
        ]);
        connection = {
            accounts: accounts,
            chainId: chainId,
            connector: connector
        };
    } else connection = config.state.connections.get(config.state.current);
    if (!connection) throw new (0, $115d9c96b0e3a6b5$export$d9a3828eace037a6)();
    const chainId = parameters.chainId ?? connection.chainId;
    // Check connector using same chainId as connection
    const connectorChainId = await connection.connector.getChainId();
    if (connectorChainId !== connection.chainId) throw new (0, $115d9c96b0e3a6b5$export$6f9c2f3137249d9c)({
        connectionChainId: connection.chainId,
        connectorChainId: connectorChainId
    });
    const connector = connection.connector;
    if (connector.getClient) return connector.getClient({
        chainId: chainId
    });
    // Default using `custom` transport
    const account = (0, $bsCQg.parseAccount)(parameters.account ?? connection.accounts[0]);
    account.address = (0, $9vguw.getAddress)(account.address); // TODO: Checksum address as part of `parseAccount`?
    const chain = config.chains.find((chain)=>chain.id === chainId);
    const provider = await connection.connector.getProvider({
        chainId: chainId
    });
    // If account was provided, check that it exists on the connector
    if (parameters.account && !connection.accounts.some((x)=>x.toLowerCase() === account.address.toLowerCase())) throw new (0, $115d9c96b0e3a6b5$export$65c369a969e2c62e)({
        address: account.address,
        connector: connector
    });
    return (0, $81f5f2ddf42262a4$export$5d730b7aed1a3eb0)({
        account: account,
        chain: chain,
        name: "Connector Client",
        transport: (opts)=>(0, $7a6358c7599e96f1$export$4c00f665f0d4b443)(provider)({
                ...opts,
                retryCount: 0
            })
    });
}


async function $fe361212e10136a0$export$e0580ae1f48db848(config, parameters) {
    const { chainId: chainId, connector: connector, ...rest } = parameters;
    let account;
    if (parameters.account) account = parameters.account;
    else {
        const connectorClient = await (0, $952dfb3505a236b1$export$d784801ca17b4aec)(config, {
            account: parameters.account,
            chainId: chainId,
            connector: connector
        });
        account = connectorClient.account;
    }
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $78d4816ed4f36c1b$export$e0580ae1f48db848), "estimateGas");
    return action({
        ...rest,
        account: account
    });
}

/** https://wagmi.sh/core/api/actions/getAccount */ function $9bf87c5242498f44$export$4f9234baf34abd0(config) {
    const uid = config.state.current;
    const connection = config.state.connections.get(uid);
    const addresses = connection?.accounts;
    const address = addresses?.[0];
    const chain = config.chains.find((chain)=>chain.id === connection?.chainId);
    const status = config.state.status;
    switch(status){
        case "connected":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "reconnecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: !!address,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status: status
            };
        case "connecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "disconnected":
            return {
                address: undefined,
                addresses: undefined,
                chain: undefined,
                chainId: undefined,
                connector: undefined,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status: status
            };
    }
}


var $69Kmp = parcelRequire("69Kmp");
var $94Fzw = parcelRequire("94Fzw");
var $dZgT6 = parcelRequire("dZgT6");
var $54zaP = parcelRequire("54zaP");



var $ceSUN = parcelRequire("ceSUN");
function $c3acdb6afd57b44e$export$65f2564e9a9b9222(unit) {
    if (typeof unit === "number") return unit;
    if (unit === "wei") return 0;
    return Math.abs((0, $ceSUN.weiUnits)[unit]);
}



var $69Kmp = parcelRequire("69Kmp");

var $jOWIL = parcelRequire("jOWIL");

var $ckWn0 = parcelRequire("ckWn0");

var $gzjWc = parcelRequire("gzjWc");

var $69Kmp = parcelRequire("69Kmp");

var $1DT5P = parcelRequire("1DT5P");

var $cA21A = parcelRequire("cA21A");

var $1oOKa = parcelRequire("1oOKa");

var $ckWn0 = parcelRequire("ckWn0");

var $gzjWc = parcelRequire("gzjWc");

var $69Kmp = parcelRequire("69Kmp");

var $b9XBB = parcelRequire("b9XBB");
const $0edd9c663decfccb$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $0edd9c663decfccb$export$4414444aba6ddd8a(err, { abi: abi, address: address, args: args, docsPath: docsPath, functionName: functionName, sender: sender }) {
    const { code: code, data: data, message: message, shortMessage: shortMessage } = err instanceof (0, $69Kmp.RawContractError) ? err : err instanceof (0, $gzjWc.BaseError) ? err.walk((err)=>"data" in err) || err.walk() : {};
    const cause = (()=>{
        if (err instanceof (0, $ckWn0.AbiDecodingZeroDataError)) return new (0, $69Kmp.ContractFunctionZeroDataError)({
            functionName: functionName
        });
        if ([
            $0edd9c663decfccb$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $b9XBB.InternalRpcError).code
        ].includes(code) && (data || message || shortMessage)) return new (0, $69Kmp.ContractFunctionRevertedError)({
            abi: abi,
            data: typeof data === "object" ? data.data : data,
            functionName: functionName,
            message: shortMessage ?? message
        });
        return err;
    })();
    return new (0, $69Kmp.ContractFunctionExecutionError)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}




var $1DT5P = parcelRequire("1DT5P");

var $cA21A = parcelRequire("cA21A");



var $6P18x = parcelRequire("6P18x");
async function $a293332cde98d98c$export$43af7de392176737(client, parameters) {
    const { abi: abi, address: address, args: args, functionName: functionName, ...rest } = parameters;
    const calldata = (0, $cA21A.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $6P18x.call), "call")({
            ...rest,
            data: calldata,
            to: address
        });
        return (0, $1DT5P.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
    } catch (error) {
        throw (0, $0edd9c663decfccb$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/readContract",
            functionName: functionName
        });
    }
}


async function $a8e1875c84b2522c$export$60ef70589ee4f7ad(client, parameters) {
    const { allowFailure: allowFailure = true, batchSize: batchSize_, blockNumber: blockNumber, blockTag: blockTag, multicallAddress: multicallAddress_, stateOverride: stateOverride } = parameters;
    const contracts = parameters.contracts;
    const batchSize = batchSize_ ?? (typeof client.batch?.multicall === "object" && client.batch.multicall.batchSize || 1024);
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new Error("client chain not configured. multicallAddress is required.");
        multicallAddress = (0, $1oOKa.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const chunkedCalls = [
        []
    ];
    let currentChunk = 0;
    let currentChunkSize = 0;
    for(let i = 0; i < contracts.length; i++){
        const { abi: abi, address: address, args: args, functionName: functionName } = contracts[i];
        try {
            const callData = (0, $cA21A.encodeFunctionData)({
                abi: abi,
                args: args,
                functionName: functionName
            });
            currentChunkSize += (callData.length - 2) / 2;
            // Check to see if we need to create a new chunk.
            if (// Check if batching is enabled.
            batchSize > 0 && // Check if the current size of the batch exceeds the size limit.
            currentChunkSize > batchSize && // Check if the current chunk is not already empty.
            chunkedCalls[currentChunk].length > 0) {
                currentChunk++;
                currentChunkSize = (callData.length - 2) / 2;
                chunkedCalls[currentChunk] = [];
            }
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: callData,
                    target: address
                }
            ];
        } catch (err) {
            const error = (0, $0edd9c663decfccb$export$4414444aba6ddd8a)(err, {
                abi: abi,
                address: address,
                args: args,
                docsPath: "/docs/contract/multicall",
                functionName: functionName
            });
            if (!allowFailure) throw error;
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: "0x",
                    target: address
                }
            ];
        }
    }
    const aggregate3Results = await Promise.allSettled(chunkedCalls.map((calls)=>(0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $a293332cde98d98c$export$43af7de392176737), "readContract")({
            abi: (0, $jOWIL.multicall3Abi),
            address: multicallAddress,
            args: [
                calls
            ],
            blockNumber: blockNumber,
            blockTag: blockTag,
            functionName: "aggregate3",
            stateOverride: stateOverride
        })));
    const results = [];
    for(let i = 0; i < aggregate3Results.length; i++){
        const result = aggregate3Results[i];
        // If an error occurred in a `readContract` invocation (ie. network error),
        // then append the failure reason to each contract result.
        if (result.status === "rejected") {
            if (!allowFailure) throw result.reason;
            for(let j = 0; j < chunkedCalls[i].length; j++)results.push({
                status: "failure",
                error: result.reason,
                result: undefined
            });
            continue;
        }
        // If the `readContract` call was successful, then decode the results.
        const aggregate3Result = result.value;
        for(let j = 0; j < aggregate3Result.length; j++){
            // Extract the response from `readContract`
            const { returnData: returnData, success: success } = aggregate3Result[j];
            // Extract the request call data from the original call.
            const { callData: callData } = chunkedCalls[i][j];
            // Extract the contract config for this call from the `contracts` argument
            // for decoding.
            const { abi: abi, address: address, functionName: functionName, args: args } = contracts[results.length];
            try {
                if (callData === "0x") throw new (0, $ckWn0.AbiDecodingZeroDataError)();
                if (!success) throw new (0, $69Kmp.RawContractError)({
                    data: returnData
                });
                const result = (0, $1DT5P.decodeFunctionResult)({
                    abi: abi,
                    args: args,
                    data: returnData,
                    functionName: functionName
                });
                results.push(allowFailure ? {
                    result: result,
                    status: "success"
                } : result);
            } catch (err) {
                const error = (0, $0edd9c663decfccb$export$4414444aba6ddd8a)(err, {
                    abi: abi,
                    address: address,
                    args: args,
                    docsPath: "/docs/contract/multicall",
                    functionName: functionName
                });
                if (!allowFailure) throw error;
                results.push({
                    error: error,
                    result: undefined,
                    status: "failure"
                });
            }
        }
    }
    if (results.length !== contracts.length) throw new (0, $gzjWc.BaseError)("multicall results mismatch");
    return results;
}



async function $1a153ea74bf29276$export$60ef70589ee4f7ad(config, parameters) {
    const { allowFailure: allowFailure = true, chainId: chainId, contracts: contracts, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $a8e1875c84b2522c$export$60ef70589ee4f7ad), "multicall");
    return action({
        allowFailure: allowFailure,
        contracts: contracts,
        ...rest
    });
}




function $2ffff127b60e713c$export$43af7de392176737(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $a293332cde98d98c$export$43af7de392176737), "readContract");
    return action(rest);
}


async function $d9f2437eace3aa90$export$aa7cd72d27ce4a5(config, parameters) {
    const { allowFailure: allowFailure = true, blockNumber: blockNumber, blockTag: blockTag, ...rest } = parameters;
    const contracts = parameters.contracts;
    try {
        const contractsByChainId = {};
        for (const [index, contract] of contracts.entries()){
            const chainId = contract.chainId ?? config.state.chainId;
            if (!contractsByChainId[chainId]) contractsByChainId[chainId] = [];
            contractsByChainId[chainId]?.push({
                contract: contract,
                index: index
            });
        }
        const promises = ()=>Object.entries(contractsByChainId).map(([chainId, contracts])=>(0, $1a153ea74bf29276$export$60ef70589ee4f7ad)(config, {
                    ...rest,
                    allowFailure: allowFailure,
                    blockNumber: blockNumber,
                    blockTag: blockTag,
                    chainId: Number.parseInt(chainId),
                    contracts: contracts.map(({ contract: contract })=>contract)
                }));
        const multicallResults = (await Promise.all(promises())).flat();
        // Reorder the contract results back to the order they were
        // provided in.
        const resultIndexes = Object.values(contractsByChainId).flatMap((contracts)=>contracts.map(({ index: index })=>index));
        return multicallResults.reduce((results, result, index)=>{
            if (results) results[resultIndexes[index]] = result;
            return results;
        }, []);
    } catch (error) {
        if (error instanceof (0, $69Kmp.ContractFunctionExecutionError)) throw error;
        const promises = ()=>contracts.map((contract)=>(0, $2ffff127b60e713c$export$43af7de392176737)(config, {
                    ...contract,
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        if (allowFailure) return (await Promise.allSettled(promises())).map((result)=>{
            if (result.status === "fulfilled") return {
                result: result.value,
                status: "success"
            };
            return {
                error: result.reason,
                result: undefined,
                status: "failure"
            };
        });
        return await Promise.all(promises());
    }
}


async function $966d78e7c24e2cc9$export$df96cd8d56be0ab1(config, parameters) {
    const { address: address, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, token: tokenAddress, unit: unit = "ether" } = parameters;
    if (tokenAddress) try {
        return $966d78e7c24e2cc9$var$getTokenBalance(config, {
            balanceAddress: address,
            chainId: chainId,
            symbolType: "string",
            tokenAddress: tokenAddress
        });
    } catch (error) {
        // In the chance that there is an error upon decoding the contract result,
        // it could be likely that the contract data is represented as bytes32 instead
        // of a string.
        if (error instanceof (0, $69Kmp.ContractFunctionExecutionError)) {
            const balance = await $966d78e7c24e2cc9$var$getTokenBalance(config, {
                balanceAddress: address,
                chainId: chainId,
                symbolType: "bytes32",
                tokenAddress: tokenAddress
            });
            const symbol = (0, $dZgT6.hexToString)((0, $54zaP.trim)(balance.symbol, {
                dir: "right"
            }));
            return {
                ...balance,
                symbol: symbol
            };
        }
        throw error;
    }
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $b8d5769d6b70fa25$export$df96cd8d56be0ab1), "getBalance");
    const value = await action(blockNumber ? {
        address: address,
        blockNumber: blockNumber
    } : {
        address: address,
        blockTag: blockTag
    });
    const chain = config.chains.find((x)=>x.id === chainId) ?? client.chain;
    return {
        decimals: chain.nativeCurrency.decimals,
        formatted: (0, $94Fzw.formatUnits)(value, (0, $c3acdb6afd57b44e$export$65f2564e9a9b9222)(unit)),
        symbol: chain.nativeCurrency.symbol,
        value: value
    };
}
async function $966d78e7c24e2cc9$var$getTokenBalance(config, parameters) {
    const { balanceAddress: balanceAddress, chainId: chainId, symbolType: symbolType, tokenAddress: tokenAddress, unit: unit } = parameters;
    const contract = {
        abi: [
            {
                type: "function",
                name: "balanceOf",
                stateMutability: "view",
                inputs: [
                    {
                        type: "address"
                    }
                ],
                outputs: [
                    {
                        type: "uint256"
                    }
                ]
            },
            {
                type: "function",
                name: "decimals",
                stateMutability: "view",
                inputs: [],
                outputs: [
                    {
                        type: "uint8"
                    }
                ]
            },
            {
                type: "function",
                name: "symbol",
                stateMutability: "view",
                inputs: [],
                outputs: [
                    {
                        type: symbolType
                    }
                ]
            }
        ],
        address: tokenAddress
    };
    const [value, decimals, symbol] = await (0, $d9f2437eace3aa90$export$aa7cd72d27ce4a5)(config, {
        allowFailure: false,
        contracts: [
            {
                ...contract,
                functionName: "balanceOf",
                args: [
                    balanceAddress
                ],
                chainId: chainId
            },
            {
                ...contract,
                functionName: "decimals",
                chainId: chainId
            },
            {
                ...contract,
                functionName: "symbol",
                chainId: chainId
            }
        ]
    });
    const formatted = (0, $94Fzw.formatUnits)(value ?? "0", (0, $c3acdb6afd57b44e$export$65f2564e9a9b9222)(unit ?? decimals));
    return {
        decimals: decimals,
        formatted: formatted,
        symbol: symbol,
        value: value
    };
}

/** Forked from https://github.com/epoberezkin/fast-deep-equal */ function $b1bffa4f8292a3b3$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        let length;
        let i;
        if (Array.isArray(a) && Array.isArray(b)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (!$b1bffa4f8292a3b3$export$9cb4719e2e525b7a(a[i], b[i])) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key && !$b1bffa4f8292a3b3$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // biome-ignore lint/suspicious/noSelfCompare: <explanation>
    return a !== a && b !== b;
}


let $b59b87c5f0c25de5$var$previousConnections = [];
function $b59b87c5f0c25de5$export$82b9f8f75cc709b4(config) {
    const connections = [
        ...config.state.connections.values()
    ];
    if (config.state.status === "reconnecting") return $b59b87c5f0c25de5$var$previousConnections;
    if ((0, $b1bffa4f8292a3b3$export$9cb4719e2e525b7a)($b59b87c5f0c25de5$var$previousConnections, connections)) return $b59b87c5f0c25de5$var$previousConnections;
    $b59b87c5f0c25de5$var$previousConnections = connections;
    return connections;
}


var $jOWIL = parcelRequire("jOWIL");

var $1DT5P = parcelRequire("1DT5P");

var $cA21A = parcelRequire("cA21A");

var $1oOKa = parcelRequire("1oOKa");

var $54zaP = parcelRequire("54zaP");

var $8syAN = parcelRequire("8syAN");

var $8hnaT = parcelRequire("8hnaT");

var $gzjWc = parcelRequire("gzjWc");

var $69Kmp = parcelRequire("69Kmp");
function $418fac75fa6a490e$export$78f90e26b9356cd7(err, callType) {
    if (!(err instanceof (0, $gzjWc.BaseError))) return false;
    const cause = err.walk((e)=>e instanceof (0, $69Kmp.ContractFunctionRevertedError));
    if (!(cause instanceof (0, $69Kmp.ContractFunctionRevertedError))) return false;
    if (cause.data?.errorName === "ResolverNotFound") return true;
    if (cause.data?.errorName === "ResolverWildcardNotSupported") return true;
    if (cause.data?.errorName === "ResolverNotContract") return true;
    if (cause.data?.errorName === "ResolverError") return true;
    if (cause.data?.errorName === "HttpError") return true;
    // Backwards compatibility for older UniversalResolver contracts
    if (cause.reason?.includes("Wildcard on non-extended resolvers is not supported")) return true;
    // No primary name set for address.
    if (callType === "reverse" && cause.reason === (0, $8hnaT.panicReasons)[50]) return true;
    return false;
}



var $fwEJN = parcelRequire("fwEJN");

var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");

var $iffkR = parcelRequire("iffkR");

var $2ZAyo = parcelRequire("2ZAyo");
function $2b7b5a0e8402ade7$export$cbf748cac2e87c52(label) {
    if (label.length !== 66) return null;
    if (label.indexOf("[") !== 0) return null;
    if (label.indexOf("]") !== 65) return null;
    const hash = `0x${label.slice(1, 65)}`;
    if (!(0, $2ZAyo.isHex)(hash)) return null;
    return hash;
}


function $28e86ec39251eaff$export$91d651ee363e1209(name) {
    let result = new Uint8Array(32).fill(0);
    if (!name) return (0, $8syAN.bytesToHex)(result);
    const labels = name.split(".");
    // Iterate in reverse order building up hash
    for(let i = labels.length - 1; i >= 0; i -= 1){
        const hashFromEncodedLabel = (0, $2b7b5a0e8402ade7$export$cbf748cac2e87c52)(labels[i]);
        const hashed = hashFromEncodedLabel ? (0, $2JRke.toBytes)(hashFromEncodedLabel) : (0, $iffkR.keccak256)((0, $2JRke.stringToBytes)(labels[i]), "bytes");
        result = (0, $iffkR.keccak256)((0, $fwEJN.concat)([
            result,
            hashed
        ]), "bytes");
    }
    return (0, $8syAN.bytesToHex)(result);
}



var $2JRke = parcelRequire("2JRke");
function $d48425cd4a3b8520$export$c23ac52da6ff5062(hash) {
    return `[${hash.slice(2)}]`;
}



var $2JRke = parcelRequire("2JRke");

var $8syAN = parcelRequire("8syAN");

var $iffkR = parcelRequire("iffkR");

function $b20e5c9388613a6a$export$83615f6c30436a69(label) {
    const result = new Uint8Array(32).fill(0);
    if (!label) return (0, $8syAN.bytesToHex)(result);
    return (0, $2b7b5a0e8402ade7$export$cbf748cac2e87c52)(label) || (0, $iffkR.keccak256)((0, $2JRke.stringToBytes)(label));
}


function $36026d786dd14265$export$8a0899f9ded0844(packet) {
    // strip leading and trailing `.`
    const value = packet.replace(/^\.|\.$/gm, "");
    if (value.length === 0) return new Uint8Array(1);
    const bytes = new Uint8Array((0, $2JRke.stringToBytes)(value).byteLength + 2);
    let offset = 0;
    const list = value.split(".");
    for(let i = 0; i < list.length; i++){
        let encoded = (0, $2JRke.stringToBytes)(list[i]);
        // if the length is > 255, make the encoded label value a labelhash
        // this is compatible with the universal resolver
        if (encoded.byteLength > 255) encoded = (0, $2JRke.stringToBytes)((0, $d48425cd4a3b8520$export$c23ac52da6ff5062)((0, $b20e5c9388613a6a$export$83615f6c30436a69)(list[i])));
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    if (bytes.byteLength !== offset + 1) return bytes.slice(0, offset + 1);
    return bytes;
}




async function $f3ee9d9766989663$export$24b77c7e87f05b8d(client, { blockNumber: blockNumber, blockTag: blockTag, coinType: coinType, name: name, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $1oOKa.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const functionData = (0, $cA21A.encodeFunctionData)({
            abi: (0, $jOWIL.addressResolverAbi),
            functionName: "addr",
            ...coinType != null ? {
                args: [
                    (0, $28e86ec39251eaff$export$91d651ee363e1209)(name),
                    BigInt(coinType)
                ]
            } : {
                args: [
                    (0, $28e86ec39251eaff$export$91d651ee363e1209)(name)
                ]
            }
        });
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $jOWIL.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $8syAN.toHex)((0, $36026d786dd14265$export$8a0899f9ded0844)(name)),
                functionData
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $a293332cde98d98c$export$43af7de392176737), "readContract");
        const res = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (res[0] === "0x") return null;
        const address = (0, $1DT5P.decodeFunctionResult)({
            abi: (0, $jOWIL.addressResolverAbi),
            args: coinType != null ? [
                (0, $28e86ec39251eaff$export$91d651ee363e1209)(name),
                BigInt(coinType)
            ] : undefined,
            functionName: "addr",
            data: res[0]
        });
        if (address === "0x") return null;
        if ((0, $54zaP.trim)(address) === "0x00") return null;
        return address;
    } catch (err) {
        if (strict) throw err;
        if ((0, $418fac75fa6a490e$export$78f90e26b9356cd7)(err, "resolve")) return null;
        throw err;
    }
}



function $17ec56585491986a$export$24b77c7e87f05b8d(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $f3ee9d9766989663$export$24b77c7e87f05b8d), "getEnsAddress");
    return action(rest);
}



var $gzjWc = parcelRequire("gzjWc");
class $d981e56d8f43ee7c$export$3d9377558041f9cf extends (0, $gzjWc.BaseError) {
    constructor({ data: data }){
        super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
            metaMessages: [
                "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
                "",
                `Provided data: ${JSON.stringify(data)}`
            ],
            name: "EnsAvatarInvalidMetadataError"
        });
    }
}
class $d981e56d8f43ee7c$export$74a8ea52cecec305 extends (0, $gzjWc.BaseError) {
    constructor({ reason: reason }){
        super(`ENS NFT avatar URI is invalid. ${reason}`, {
            name: "EnsAvatarInvalidNftUriError"
        });
    }
}
class $d981e56d8f43ee7c$export$f202ff3d50da14eb extends (0, $gzjWc.BaseError) {
    constructor({ uri: uri }){
        super(`Unable to resolve ENS avatar URI "${uri}". The URI may be malformed, invalid, or does not respond with a valid image.`, {
            name: "EnsAvatarUriResolutionError"
        });
    }
}
class $d981e56d8f43ee7c$export$45137f20297c5e74 extends (0, $gzjWc.BaseError) {
    constructor({ namespace: namespace }){
        super(`ENS NFT avatar namespace "${namespace}" is not supported. Must be "erc721" or "erc1155".`, {
            name: "EnsAvatarUnsupportedNamespaceError"
        });
    }
}


const $269890d84a7c43dc$var$networkRegex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/;
const $269890d84a7c43dc$var$ipfsHashRegex = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/;
const $269890d84a7c43dc$var$base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
const $269890d84a7c43dc$var$dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function $269890d84a7c43dc$export$db9c123edba6463(uri) {
    try {
        const res = await fetch(uri, {
            method: "HEAD"
        });
        // retrieve content type header to check if content is image
        if (res.status === 200) {
            const contentType = res.headers.get("content-type");
            return contentType?.startsWith("image/");
        }
        return false;
    } catch (error) {
        // if error is not cors related then fail
        if (typeof error === "object" && typeof error.response !== "undefined") return false;
        // fail in NodeJS, since the error is not cors but any other network issue
        // biome-ignore lint/suspicious/noPrototypeBuiltins:
        if (!globalThis.hasOwnProperty("Image")) return false;
        // in case of cors, use image api to validate if given url is an actual image
        return new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>{
                resolve(true);
            };
            img.onerror = ()=>{
                resolve(false);
            };
            img.src = uri;
        });
    }
}
function $269890d84a7c43dc$export$90df7f536ca3f624(custom, defaultGateway) {
    if (!custom) return defaultGateway;
    if (custom.endsWith("/")) return custom.slice(0, -1);
    return custom;
}
function $269890d84a7c43dc$export$9c878106a0d8edac({ uri: uri, gatewayUrls: gatewayUrls }) {
    const isEncoded = $269890d84a7c43dc$var$base64Regex.test(uri);
    if (isEncoded) return {
        uri: uri,
        isOnChain: true,
        isEncoded: isEncoded
    };
    const ipfsGateway = $269890d84a7c43dc$export$90df7f536ca3f624(gatewayUrls?.ipfs, "https://ipfs.io");
    const arweaveGateway = $269890d84a7c43dc$export$90df7f536ca3f624(gatewayUrls?.arweave, "https://arweave.net");
    const networkRegexMatch = uri.match($269890d84a7c43dc$var$networkRegex);
    const { protocol: protocol, subpath: subpath, target: target, subtarget: subtarget = "" } = networkRegexMatch?.groups || {};
    const isIPNS = protocol === "ipns:/" || subpath === "ipns/";
    const isIPFS = protocol === "ipfs:/" || subpath === "ipfs/" || $269890d84a7c43dc$var$ipfsHashRegex.test(uri);
    if (uri.startsWith("http") && !isIPNS && !isIPFS) {
        let replacedUri = uri;
        if (gatewayUrls?.arweave) replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls?.arweave);
        return {
            uri: replacedUri,
            isOnChain: false,
            isEncoded: false
        };
    }
    if ((isIPNS || isIPFS) && target) return {
        uri: `${ipfsGateway}/${isIPNS ? "ipns" : "ipfs"}/${target}${subtarget}`,
        isOnChain: false,
        isEncoded: false
    };
    if (protocol === "ar:/" && target) return {
        uri: `${arweaveGateway}/${target}${subtarget || ""}`,
        isOnChain: false,
        isEncoded: false
    };
    let parsedUri = uri.replace($269890d84a7c43dc$var$dataURIRegex, "");
    if (parsedUri.startsWith("<svg")) // if svg, base64 encode
    parsedUri = `data:image/svg+xml;base64,${btoa(parsedUri)}`;
    if (parsedUri.startsWith("data:") || parsedUri.startsWith("{")) return {
        uri: parsedUri,
        isOnChain: true,
        isEncoded: false
    };
    throw new (0, $d981e56d8f43ee7c$export$f202ff3d50da14eb)({
        uri: uri
    });
}
function $269890d84a7c43dc$export$9be3fe34a3333ecb(data) {
    // validation check for json data, must include one of theses properties
    if (typeof data !== "object" || !("image" in data) && !("image_url" in data) && !("image_data" in data)) throw new (0, $d981e56d8f43ee7c$export$3d9377558041f9cf)({
        data: data
    });
    return data.image || data.image_url || data.image_data;
}
async function $269890d84a7c43dc$export$b9759ed161b5e3c5({ gatewayUrls: gatewayUrls, uri: uri }) {
    try {
        const res = await fetch(uri).then((res)=>res.json());
        const image = await $269890d84a7c43dc$export$1f4e569649d3a793({
            gatewayUrls: gatewayUrls,
            uri: $269890d84a7c43dc$export$9be3fe34a3333ecb(res)
        });
        return image;
    } catch  {
        throw new (0, $d981e56d8f43ee7c$export$f202ff3d50da14eb)({
            uri: uri
        });
    }
}
async function $269890d84a7c43dc$export$1f4e569649d3a793({ gatewayUrls: gatewayUrls, uri: uri }) {
    const { uri: resolvedURI, isOnChain: isOnChain } = $269890d84a7c43dc$export$9c878106a0d8edac({
        uri: uri,
        gatewayUrls: gatewayUrls
    });
    if (isOnChain) return resolvedURI;
    // check if resolvedURI is an image, if it is return the url
    const isImage = await $269890d84a7c43dc$export$db9c123edba6463(resolvedURI);
    if (isImage) return resolvedURI;
    throw new (0, $d981e56d8f43ee7c$export$f202ff3d50da14eb)({
        uri: uri
    });
}
function $269890d84a7c43dc$export$e78cf22c9d52ca8a(uri_) {
    let uri = uri_;
    // parse valid nft spec (CAIP-22/CAIP-29)
    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
    if (uri.startsWith("did:nft:")) // convert DID to CAIP
    uri = uri.replace("did:nft:", "").replace(/_/g, "/");
    const [reference, asset_namespace, tokenID] = uri.split("/");
    const [eip_namespace, chainID] = reference.split(":");
    const [erc_namespace, contractAddress] = asset_namespace.split(":");
    if (!eip_namespace || eip_namespace.toLowerCase() !== "eip155") throw new (0, $d981e56d8f43ee7c$export$74a8ea52cecec305)({
        reason: "Only EIP-155 supported"
    });
    if (!chainID) throw new (0, $d981e56d8f43ee7c$export$74a8ea52cecec305)({
        reason: "Chain ID not found"
    });
    if (!contractAddress) throw new (0, $d981e56d8f43ee7c$export$74a8ea52cecec305)({
        reason: "Contract address not found"
    });
    if (!tokenID) throw new (0, $d981e56d8f43ee7c$export$74a8ea52cecec305)({
        reason: "Token ID not found"
    });
    if (!erc_namespace) throw new (0, $d981e56d8f43ee7c$export$74a8ea52cecec305)({
        reason: "ERC namespace not found"
    });
    return {
        chainID: Number.parseInt(chainID),
        namespace: erc_namespace.toLowerCase(),
        contractAddress: contractAddress,
        tokenID: tokenID
    };
}
async function $269890d84a7c43dc$export$29b8ee2b96a1ed4f(client, { nft: nft }) {
    if (nft.namespace === "erc721") return (0, $a293332cde98d98c$export$43af7de392176737)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "tokenURI",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "tokenId",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "tokenURI",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    if (nft.namespace === "erc1155") return (0, $a293332cde98d98c$export$43af7de392176737)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "uri",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "_id",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "uri",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    throw new (0, $d981e56d8f43ee7c$export$45137f20297c5e74)({
        namespace: nft.namespace
    });
}


async function $dec2fdd0d7cab257$export$3713446b2fba5(client, { gatewayUrls: gatewayUrls, record: record }) {
    if (/eip155:/i.test(record)) return $dec2fdd0d7cab257$var$parseNftAvatarUri(client, {
        gatewayUrls: gatewayUrls,
        record: record
    });
    return (0, $269890d84a7c43dc$export$1f4e569649d3a793)({
        uri: record,
        gatewayUrls: gatewayUrls
    });
}
async function $dec2fdd0d7cab257$var$parseNftAvatarUri(client, { gatewayUrls: gatewayUrls, record: record }) {
    // parse NFT URI into properties
    const nft = (0, $269890d84a7c43dc$export$e78cf22c9d52ca8a)(record);
    // fetch tokenURI from the NFT contract
    const nftUri = await (0, $269890d84a7c43dc$export$29b8ee2b96a1ed4f)(client, {
        nft: nft
    });
    // resolve the URI from the fetched tokenURI
    const { uri: resolvedNftUri, isOnChain: isOnChain, isEncoded: isEncoded } = (0, $269890d84a7c43dc$export$9c878106a0d8edac)({
        uri: nftUri,
        gatewayUrls: gatewayUrls
    });
    // if the resolved URI is on chain, return the data
    if (isOnChain && (resolvedNftUri.includes("data:application/json;base64,") || resolvedNftUri.startsWith("{"))) {
        const encodedJson = isEncoded ? atob(resolvedNftUri.replace("data:application/json;base64,", "")) : resolvedNftUri;
        const decoded = JSON.parse(encodedJson);
        return (0, $269890d84a7c43dc$export$1f4e569649d3a793)({
            uri: (0, $269890d84a7c43dc$export$9be3fe34a3333ecb)(decoded),
            gatewayUrls: gatewayUrls
        });
    }
    let uriTokenId = nft.tokenID;
    if (nft.namespace === "erc1155") uriTokenId = uriTokenId.replace("0x", "").padStart(64, "0");
    return (0, $269890d84a7c43dc$export$b9759ed161b5e3c5)({
        gatewayUrls: gatewayUrls,
        uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId)
    });
}




var $jOWIL = parcelRequire("jOWIL");

var $1DT5P = parcelRequire("1DT5P");

var $cA21A = parcelRequire("cA21A");

var $1oOKa = parcelRequire("1oOKa");

var $8syAN = parcelRequire("8syAN");





async function $c5d33cad51fc0164$export$2b2c96dabd62b431(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, key: key, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $1oOKa.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $jOWIL.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $8syAN.toHex)((0, $36026d786dd14265$export$8a0899f9ded0844)(name)),
                (0, $cA21A.encodeFunctionData)({
                    abi: (0, $jOWIL.textResolverAbi),
                    functionName: "text",
                    args: [
                        (0, $28e86ec39251eaff$export$91d651ee363e1209)(name),
                        key
                    ]
                })
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $a293332cde98d98c$export$43af7de392176737), "readContract");
        const res = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (res[0] === "0x") return null;
        const record = (0, $1DT5P.decodeFunctionResult)({
            abi: (0, $jOWIL.textResolverAbi),
            functionName: "text",
            data: res[0]
        });
        return record === "" ? null : record;
    } catch (err) {
        if (strict) throw err;
        if ((0, $418fac75fa6a490e$export$78f90e26b9356cd7)(err, "resolve")) return null;
        throw err;
    }
}


async function $48e9f4952efd1143$export$65f1d2b9649a54e5(client, { blockNumber: blockNumber, blockTag: blockTag, assetGatewayUrls: assetGatewayUrls, name: name, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress }) {
    const record = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $c5d33cad51fc0164$export$2b2c96dabd62b431), "getEnsText")({
        blockNumber: blockNumber,
        blockTag: blockTag,
        key: "avatar",
        name: name,
        universalResolverAddress: universalResolverAddress,
        gatewayUrls: gatewayUrls,
        strict: strict
    });
    if (!record) return null;
    try {
        return await (0, $dec2fdd0d7cab257$export$3713446b2fba5)(client, {
            record: record,
            gatewayUrls: assetGatewayUrls
        });
    } catch  {
        return null;
    }
}



function $a2a6f7ca5f0b7074$export$65f1d2b9649a54e5(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $48e9f4952efd1143$export$65f1d2b9649a54e5), "getEnsAvatar");
    return action(rest);
}


var $jOWIL = parcelRequire("jOWIL");

var $1oOKa = parcelRequire("1oOKa");

var $8syAN = parcelRequire("8syAN");




async function $58dded2843cc8321$export$e1b98d9bc05a9fc2(client, { address: address, blockNumber: blockNumber, blockTag: blockTag, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $1oOKa.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const reverseNode = `${address.toLowerCase().substring(2)}.addr.reverse`;
    try {
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $jOWIL.universalResolverReverseAbi),
            functionName: "reverse",
            args: [
                (0, $8syAN.toHex)((0, $36026d786dd14265$export$8a0899f9ded0844)(reverseNode))
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $a293332cde98d98c$export$43af7de392176737), "readContract");
        const [name, resolvedAddress] = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (address.toLowerCase() !== resolvedAddress.toLowerCase()) return null;
        return name;
    } catch (err) {
        if (strict) throw err;
        if ((0, $418fac75fa6a490e$export$78f90e26b9356cd7)(err, "reverse")) return null;
        throw err;
    }
}



function $76f301218461e2ef$export$e1b98d9bc05a9fc2(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $58dded2843cc8321$export$e1b98d9bc05a9fc2), "getEnsName");
    return action(rest);
}




async function $ffe308c3010df2e8$export$2e8a9232fb815d77(config, parameters) {
    const { account: account_, chainId: chainId, ...rest } = parameters;
    const account = account_ ?? (0, $9bf87c5242498f44$export$4f9234baf34abd0)(config).address;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $9440447d591deedf$export$2e8a9232fb815d77), "prepareTransactionRequest");
    return action({
        ...rest,
        ...account ? {
            account: account
        } : {}
    });
}

let $2bf13ff4fdf3cd7b$var$isReconnecting = false;
async function $2bf13ff4fdf3cd7b$export$f0e7018a430fa792(config, parameters = {}) {
    // If already reconnecting, do nothing
    if ($2bf13ff4fdf3cd7b$var$isReconnecting) return [];
    $2bf13ff4fdf3cd7b$var$isReconnecting = true;
    config.setState((x)=>({
            ...x,
            status: x.current ? "reconnecting" : "connecting"
        }));
    const connectors = [];
    if (parameters.connectors?.length) for (const connector_ of parameters.connectors){
        let connector;
        // "Register" connector if not already created
        if (typeof connector_ === "function") connector = config._internal.connectors.setup(connector_);
        else connector = connector_;
        connectors.push(connector);
    }
    else connectors.push(...config.connectors);
    // Try recently-used connectors first
    let recentConnectorId;
    try {
        recentConnectorId = await config.storage?.getItem("recentConnectorId");
    } catch  {}
    const scores = {};
    for (const [, connection] of config.state.connections)scores[connection.connector.id] = 1;
    if (recentConnectorId) scores[recentConnectorId] = 0;
    const sorted = Object.keys(scores).length > 0 ? [
        ...connectors
    ].sort((a, b)=>(scores[a.id] ?? 10) - (scores[b.id] ?? 10)) : connectors;
    // Iterate through each connector and try to connect
    let connected = false;
    const connections = [];
    const providers = [];
    for (const connector of sorted){
        const provider = await connector.getProvider().catch(()=>undefined);
        if (!provider) continue;
        // If we already have an instance of this connector's provider,
        // then we have already checked it (ie. injected connectors can
        // share the same `window.ethereum` instance, so we don't want to
        // connect to it again).
        if (providers.some((x)=>x === provider)) continue;
        const isAuthorized = await connector.isAuthorized();
        if (!isAuthorized) continue;
        const data = await connector.connect({
            isReconnecting: true
        }).catch(()=>null);
        if (!data) continue;
        connector.emitter.off("connect", config._internal.events.connect);
        connector.emitter.on("change", config._internal.events.change);
        connector.emitter.on("disconnect", config._internal.events.disconnect);
        config.setState((x)=>{
            const connections = new Map(connected ? x.connections : new Map()).set(connector.uid, {
                accounts: data.accounts,
                chainId: data.chainId,
                connector: connector
            });
            return {
                ...x,
                current: connected ? x.current : connector.uid,
                connections: connections
            };
        });
        connections.push({
            accounts: data.accounts,
            chainId: data.chainId,
            connector: connector
        });
        providers.push(provider);
        connected = true;
    }
    // Prevent overwriting connected status from race condition
    if (config.state.status === "reconnecting" || config.state.status === "connecting") {
        // If connecting didn't succeed, set to disconnected
        if (!connected) config.setState((x)=>({
                ...x,
                connections: new Map(),
                current: null,
                status: "disconnected"
            }));
        else config.setState((x)=>({
                ...x,
                status: "connected"
            }));
    }
    $2bf13ff4fdf3cd7b$var$isReconnecting = false;
    return connections;
}


var $bsCQg = parcelRequire("bsCQg");

var $gzjWc = parcelRequire("gzjWc");
class $e2693921d16acd79$export$62ee6b05f0767f28 extends (0, $gzjWc.BaseError) {
    constructor({ docsPath: docsPath } = {}){
        super([
            "Could not find an Account to execute with this Action.",
            "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client."
        ].join("\n"), {
            docsPath: docsPath,
            docsSlug: "account",
            name: "AccountNotFoundError"
        });
    }
}
class $e2693921d16acd79$export$22c1d840ef5fbc66 extends (0, $gzjWc.BaseError) {
    constructor({ docsPath: docsPath, metaMessages: metaMessages, type: type }){
        super(`Account type "${type}" is not supported.`, {
            docsPath: docsPath,
            metaMessages: metaMessages,
            name: "AccountTypeNotSupportedError"
        });
    }
}



var $gzjWc = parcelRequire("gzjWc");


var $jOG4f = parcelRequire("jOG4f");
function $1bdcc4d224f08dfd$export$390d312ab46d0597({ chain: chain, currentChainId: currentChainId }) {
    if (!chain) throw new (0, $jOG4f.ChainNotFoundError)();
    if (currentChainId !== chain.id) throw new (0, $jOG4f.ChainMismatchError)({
        chain: chain,
        currentChainId: currentChainId
    });
}



var $lpgkb = parcelRequire("lpgkb");

var $kIOz8 = parcelRequire("kIOz8");

var $leBvp = parcelRequire("leBvp");
function $d4b7d79aa95fe572$export$da1758db1985646e(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $leBvp.getNodeError)(err, args);
        if (cause instanceof (0, $lpgkb.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $kIOz8.TransactionExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}



var $36Zbp = parcelRequire("36Zbp");

var $cdG5Y = parcelRequire("cdG5Y");


var $ea0OJ = parcelRequire("ea0OJ");


/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ async function $38556ce0cfecae69$export$4e309754b4830e29(client, { serializedTransaction: serializedTransaction }) {
    return client.request({
        method: "eth_sendRawTransaction",
        params: [
            serializedTransaction
        ]
    }, {
        retryCount: 0
    });
}


async function $99411418fa6ef5ff$export$8e0e7ffc78696d30(client, parameters) {
    const { account: account_ = client.account, chain: chain = client.chain, accessList: accessList, authorizationList: authorizationList, blobs: blobs, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value, ...rest } = parameters;
    if (!account_) throw new (0, $e2693921d16acd79$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/sendTransaction"
    });
    const account = (0, $bsCQg.parseAccount)(account_);
    try {
        (0, $ea0OJ.assertRequest)(parameters);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (parameters.to) return parameters.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $0a3ce840373cd956$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $gzjWc.BaseError)("`to` is required. Could not infer from `authorizationList`.");
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        if (account.type === "json-rpc") {
            let chainId;
            if (chain !== null) {
                chainId = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $9a7d2afa33752492$export$850fa7b3891187c), "getChainId")({});
                (0, $1bdcc4d224f08dfd$export$390d312ab46d0597)({
                    currentChainId: chainId,
                    chain: chain
                });
            }
            const chainFormat = client.chain?.formatters?.transactionRequest?.format;
            const format = chainFormat || (0, $cdG5Y.formatTransactionRequest);
            const request = format({
                // Pick out extra data that might exist on the chain's transaction request type.
                ...(0, $36Zbp.extract)(rest, {
                    format: chainFormat
                }),
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chainId: chainId,
                data: data,
                from: account.address,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                value: value
            });
            return await client.request({
                method: "eth_sendTransaction",
                params: [
                    request
                ]
            }, {
                retryCount: 0
            });
        }
        if (account.type === "local") {
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $9440447d591deedf$export$2e8a9232fb815d77), "prepareTransactionRequest")({
                account: account,
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chain: chain,
                data: data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                nonceManager: account.nonceManager,
                parameters: [
                    ...(0, $9440447d591deedf$export$4f3e0c2bc77eca55),
                    "sidecars"
                ],
                value: value,
                ...rest,
                to: to
            });
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction(request, {
                serializer: serializer
            });
            return await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $38556ce0cfecae69$export$4e309754b4830e29), "sendRawTransaction")({
                serializedTransaction: serializedTransaction
            });
        }
        if (account.type === "smart") throw new (0, $e2693921d16acd79$export$22c1d840ef5fbc66)({
            metaMessages: [
                "Consider using the `sendUserOperation` Action instead."
            ],
            docsPath: "/docs/actions/bundler/sendUserOperation",
            type: "smart"
        });
        throw new (0, $e2693921d16acd79$export$22c1d840ef5fbc66)({
            docsPath: "/docs/actions/wallet/sendTransaction",
            type: account.type
        });
    } catch (err) {
        if (err instanceof (0, $e2693921d16acd79$export$22c1d840ef5fbc66)) throw err;
        throw (0, $d4b7d79aa95fe572$export$da1758db1985646e)(err, {
            ...parameters,
            account: account,
            chain: parameters.chain || undefined
        });
    }
}





async function $84e4d6648ba6b0db$export$8e0e7ffc78696d30(config, parameters) {
    const { account: account, chainId: chainId, connector: connector, gas: gas_, ...rest } = parameters;
    let client;
    if (typeof account === "object" && account.type === "local") client = config.getClient({
        chainId: chainId
    });
    else client = await (0, $952dfb3505a236b1$export$d784801ca17b4aec)(config, {
        account: account,
        chainId: chainId,
        connector: connector
    });
    const { connector: activeConnector } = (0, $9bf87c5242498f44$export$4f9234baf34abd0)(config);
    const gas = await (async ()=>{
        // Skip gas estimation if `data` doesn't exist (not a contract interaction).
        if (!("data" in parameters) || !parameters.data) return undefined;
        // Skip gas estimation if connector supports simulation.
        if ((connector ?? activeConnector)?.supportsSimulation) return undefined;
        // Skip gas estimation if `null` is provided.
        if (gas_ === null) return undefined;
        // Run gas estimation if no value is provided.
        if (gas_ === undefined) {
            const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $78d4816ed4f36c1b$export$e0580ae1f48db848), "estimateGas");
            return action({
                ...rest,
                account: account,
                chain: chainId ? {
                    id: chainId
                } : null
            });
        }
        // Use provided gas value.
        return gas_;
    })();
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $99411418fa6ef5ff$export$8e0e7ffc78696d30), "sendTransaction");
    const hash = await action({
        ...rest,
        ...account ? {
            account: account
        } : {},
        gas: gas,
        chain: chainId ? {
            id: chainId
        } : null
    });
    return hash;
}


var $bsCQg = parcelRequire("bsCQg");


var $8syAN = parcelRequire("8syAN");
async function $e7e9d47782e531b6$export$1d9a7a8a40780de(client, { account: account_ = client.account, message: message }) {
    if (!account_) throw new (0, $e2693921d16acd79$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/signMessage"
    });
    const account = (0, $bsCQg.parseAccount)(account_);
    if (account.signMessage) return account.signMessage({
        message: message
    });
    const message_ = (()=>{
        if (typeof message === "string") return (0, $8syAN.stringToHex)(message);
        if (message.raw instanceof Uint8Array) return (0, $8syAN.toHex)(message.raw);
        return message.raw;
    })();
    return client.request({
        method: "personal_sign",
        params: [
            message_,
            account.address
        ]
    }, {
        retryCount: 0
    });
}




async function $2a16e70d89d1c4fa$export$1d9a7a8a40780de(config, parameters) {
    const { account: account, connector: connector, ...rest } = parameters;
    let client;
    if (typeof account === "object" && account.type === "local") client = config.getClient();
    else client = await (0, $952dfb3505a236b1$export$d784801ca17b4aec)(config, {
        account: account,
        connector: connector
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $e7e9d47782e531b6$export$1d9a7a8a40780de), "signMessage");
    return action({
        ...rest,
        ...account ? {
            account: account
        } : {}
    });
}


async function $3b67507949adfeec$export$9ccfa7718cb7f8b1(config, parameters) {
    const { connector: connector } = parameters;
    const connection = config.state.connections.get(connector.uid);
    if (!connection) throw new (0, $115d9c96b0e3a6b5$export$d9a3828eace037a6)();
    await config.storage?.setItem("recentConnectorId", connector.id);
    config.setState((x)=>({
            ...x,
            current: connector.uid
        }));
    return {
        accounts: connection.accounts,
        chainId: connection.chainId
    };
}



class $b99ad54a290b4e60$export$43839b3ff6336f15 extends (0, $1cab894157675a46$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Provider not found.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderNotFoundError"
        });
    }
}
class $b99ad54a290b4e60$export$a4296a4b7763e5d8 extends (0, $1cab894157675a46$export$a490eb03cb7a0a5e) {
    constructor({ connector: connector }){
        super(`"${connector.name}" does not support programmatic chain switching.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SwitchChainNotSupportedError"
        });
    }
}


async function $84fcda712a4e8b11$export$15599da40e72d2f(config, parameters) {
    const { addEthereumChainParameter: addEthereumChainParameter, chainId: chainId } = parameters;
    const connection = config.state.connections.get(parameters.connector?.uid ?? config.state.current);
    if (connection) {
        const connector = connection.connector;
        if (!connector.switchChain) throw new (0, $b99ad54a290b4e60$export$a4296a4b7763e5d8)({
            connector: connector
        });
        const chain = await connector.switchChain({
            addEthereumChainParameter: addEthereumChainParameter,
            chainId: chainId
        });
        return chain;
    }
    const chain = config.chains.find((x)=>x.id === chainId);
    if (!chain) throw new (0, $115d9c96b0e3a6b5$export$688e5fda4b4631ed)();
    config.setState((x)=>({
            ...x,
            chainId: chainId
        }));
    return chain;
}


var $dZgT6 = parcelRequire("dZgT6");

var $6P18x = parcelRequire("6P18x");
var $kIOz8 = parcelRequire("kIOz8");

var $8syAN = parcelRequire("8syAN");

async function $229509a4633c2dd6$export$ec0c6556a09b65b8(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, hash: hash, index: index }) {
    const blockTag = blockTag_ || "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $8syAN.numberToHex)(blockNumber) : undefined;
    let transaction = null;
    if (hash) transaction = await client.request({
        method: "eth_getTransactionByHash",
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    else if (blockHash) transaction = await client.request({
        method: "eth_getTransactionByBlockHashAndIndex",
        params: [
            blockHash,
            (0, $8syAN.numberToHex)(index)
        ]
    }, {
        dedupe: true
    });
    else if (blockNumberHex || blockTag) transaction = await client.request({
        method: "eth_getTransactionByBlockNumberAndIndex",
        params: [
            blockNumberHex || blockTag,
            (0, $8syAN.numberToHex)(index)
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!transaction) throw new (0, $kIOz8.TransactionNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        hash: hash,
        index: index
    });
    const format = client.chain?.formatters?.transaction?.format || (0, $e1557bfb53fe1c2f$export$b02b16590d26dadc);
    return format(transaction);
}



var $kIOz8 = parcelRequire("kIOz8");

/** @internal */ const $82e188248f87abd4$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
const $82e188248f87abd4$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
let $82e188248f87abd4$var$callbackCount = 0;
function $82e188248f87abd4$export$d1203567a167490e(observerId, callbacks, fn) {
    const callbackId = ++$82e188248f87abd4$var$callbackCount;
    const getListeners = ()=>$82e188248f87abd4$export$94ab3a05cb07971d.get(observerId) || [];
    const unsubscribe = ()=>{
        const listeners = getListeners();
        $82e188248f87abd4$export$94ab3a05cb07971d.set(observerId, listeners.filter((cb)=>cb.id !== callbackId));
    };
    const unwatch = ()=>{
        const cleanup = $82e188248f87abd4$export$b4a4aba7c5f97c17.get(observerId);
        if (getListeners().length === 1 && cleanup) cleanup();
        unsubscribe();
    };
    const listeners = getListeners();
    $82e188248f87abd4$export$94ab3a05cb07971d.set(observerId, [
        ...listeners,
        {
            id: callbackId,
            fns: callbacks
        }
    ]);
    if (listeners && listeners.length > 0) return unwatch;
    const emit = {};
    for(const key in callbacks)emit[key] = (...args)=>{
        const listeners = getListeners();
        if (listeners.length === 0) return;
        for (const listener of listeners)listener.fns[key]?.(...args);
    };
    const cleanup = fn(emit);
    if (typeof cleanup === "function") $82e188248f87abd4$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}




var $6nOtb = parcelRequire("6nOtb");



var $kIOz8 = parcelRequire("kIOz8");

var $dZgT6 = parcelRequire("dZgT6");

var $9A1yP = parcelRequire("9A1yP");
function $dd5b5a522b26df98$export$fccdbdc2b9d7893(log, { args: args, eventName: eventName } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
        ...eventName ? {
            args: args,
            eventName: eventName
        } : {}
    };
}



const $8b2e47436fdab93f$export$3f17d120ae0df04 = {
    "0x0": "reverted",
    "0x1": "success"
};
function $8b2e47436fdab93f$export$30da670e49d6fc31(transactionReceipt) {
    const receipt = {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map((log)=>(0, $dd5b5a522b26df98$export$fccdbdc2b9d7893)(log)) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $dZgT6.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $8b2e47436fdab93f$export$3f17d120ae0df04[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $e1557bfb53fe1c2f$export$cd5f936b62a5e91)[transactionReceipt.type] || transactionReceipt.type : null
    };
    if (transactionReceipt.blobGasPrice) receipt.blobGasPrice = BigInt(transactionReceipt.blobGasPrice);
    if (transactionReceipt.blobGasUsed) receipt.blobGasUsed = BigInt(transactionReceipt.blobGasUsed);
    return receipt;
}
const $8b2e47436fdab93f$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $9A1yP.defineFormatter)("transactionReceipt", $8b2e47436fdab93f$export$30da670e49d6fc31);


async function $a819fdb64a2cc2ce$export$6b1ceb3cd5f8b21f(client, { hash: hash }) {
    const receipt = await client.request({
        method: "eth_getTransactionReceipt",
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    if (!receipt) throw new (0, $kIOz8.TransactionReceiptNotFoundError)({
        hash: hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $8b2e47436fdab93f$export$30da670e49d6fc31);
    return format(receipt);
}



var $dZgT6 = parcelRequire("dZgT6");



function $6012b15eca9b2388$export$e0c10349b2c5e1d4(fn, { emitOnBegin: emitOnBegin, initialWaitTime: initialWaitTime, interval: interval }) {
    let active = true;
    const unwatch = ()=>active = false;
    const watch = async ()=>{
        let data = undefined;
        if (emitOnBegin) data = await fn({
            unpoll: unwatch
        });
        const initialWait = await initialWaitTime?.(data) ?? interval;
        await (0, $82df4c442695b4bf$export$5c069c93d2b7493f)(initialWait);
        const poll = async ()=>{
            if (!active) return;
            await fn({
                unpoll: unwatch
            });
            await (0, $82df4c442695b4bf$export$5c069c93d2b7493f)(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}



var $6nOtb = parcelRequire("6nOtb");
/** @internal */ const $c998e72c30d887ff$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
const $c998e72c30d887ff$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $c998e72c30d887ff$export$e2575ed62a2f107b(cacheKey) {
    const buildCache = (cacheKey, cache)=>({
            clear: ()=>cache.delete(cacheKey),
            get: ()=>cache.get(cacheKey),
            set: (data)=>cache.set(cacheKey, data)
        });
    const promise = buildCache(cacheKey, $c998e72c30d887ff$export$e89e805418f4d2c);
    const response = buildCache(cacheKey, $c998e72c30d887ff$export$b4c67320c85a8b9d);
    return {
        clear: ()=>{
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
async function $c998e72c30d887ff$export$33b32b3abf8170f0(fn, { cacheKey: cacheKey, cacheTime: cacheTime = Number.POSITIVE_INFINITY }) {
    const cache = $c998e72c30d887ff$export$e2575ed62a2f107b(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < cacheTime) return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({
            created: new Date(),
            data: data
        });
        return data;
    } finally{
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}


const $a8be55019372102c$var$cacheKey = (id)=>`blockNumber.${id}`;
function $a8be55019372102c$export$bc78c57a2d1b4a2b(id) {
    return (0, $c998e72c30d887ff$export$e2575ed62a2f107b)($a8be55019372102c$var$cacheKey(id));
}
async function $a8be55019372102c$export$9328b5c92c53a20e(client, { cacheTime: cacheTime = client.cacheTime } = {}) {
    const blockNumberHex = await (0, $c998e72c30d887ff$export$33b32b3abf8170f0)(()=>client.request({
            method: "eth_blockNumber"
        }), {
        cacheKey: $a8be55019372102c$var$cacheKey(client.uid),
        cacheTime: cacheTime
    });
    return BigInt(blockNumberHex);
}


function $84071a199be829d8$export$fc5f622dd0d82466(client, { emitOnBegin: emitOnBegin = false, emitMissed: emitMissed = false, onBlockNumber: onBlockNumber, onError: onError, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    let prevBlockNumber;
    const pollBlockNumber = ()=>{
        const observerId = (0, $6nOtb.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $82e188248f87abd4$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>(0, $6012b15eca9b2388$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    const blockNumber = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $a8be55019372102c$export$9328b5c92c53a20e), "getBlockNumber")({
                        cacheTime: 0
                    });
                    if (prevBlockNumber) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (blockNumber === prevBlockNumber) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (blockNumber - prevBlockNumber > 1 && emitMissed) for(let i = prevBlockNumber + 1n; i < blockNumber; i++){
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                    // If the next block number is greater than the previous,
                    // it is not in the past, and we can emit the new block number.
                    if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlockNumber = ()=>{
        const observerId = (0, $6nOtb.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed
        ]);
        return (0, $82e188248f87abd4$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>{
            let active = true;
            let unsubscribe = ()=>active = false;
            (async ()=>{
                try {
                    const transport = (()=>{
                        if (client.transport.type === "fallback") {
                            const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                            if (!transport) return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: [
                            "newHeads"
                        ],
                        onData (data) {
                            if (!active) return;
                            const blockNumber = (0, $dZgT6.hexToBigInt)(data.result?.number);
                            emit.onBlockNumber(blockNumber, prevBlockNumber);
                            prevBlockNumber = blockNumber;
                        },
                        onError (error) {
                            emit.onError?.(error);
                        }
                    });
                    unsubscribe = unsubscribe_;
                    if (!active) unsubscribe();
                } catch (err) {
                    onError?.(err);
                }
            })();
            return ()=>unsubscribe();
        });
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}


async function $6923320b64509040$export$694ec9bdf0bb55cf(client, { confirmations: confirmations = 1, hash: hash, onReplaced: onReplaced, pollingInterval: pollingInterval = client.pollingInterval, retryCount: retryCount = 6, retryDelay: retryDelay = ({ count: count })=>~~(1 << count) * 200, timeout: timeout }) {
    const observerId = (0, $6nOtb.stringify)([
        "waitForTransactionReceipt",
        client.uid,
        hash
    ]);
    let count = 0;
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    return new Promise((resolve, reject)=>{
        if (timeout) setTimeout(()=>reject(new (0, $kIOz8.WaitForTransactionReceiptTimeoutError)({
                hash: hash
            })), timeout);
        const _unobserve = (0, $82e188248f87abd4$export$d1203567a167490e)(observerId, {
            onReplaced: onReplaced,
            resolve: resolve,
            reject: reject
        }, (emit)=>{
            const _unwatch = (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $84071a199be829d8$export$fc5f622dd0d82466), "watchBlockNumber")({
                emitMissed: true,
                emitOnBegin: true,
                poll: true,
                pollingInterval: pollingInterval,
                async onBlockNumber (blockNumber_) {
                    const done = (fn)=>{
                        _unwatch();
                        fn();
                        _unobserve();
                    };
                    let blockNumber = blockNumber_;
                    if (retrying) return;
                    if (count > retryCount) done(()=>emit.reject(new (0, $kIOz8.WaitForTransactionReceiptTimeoutError)({
                            hash: hash
                        })));
                    try {
                        // If we already have a valid receipt, let's check if we have enough
                        // confirmations. If we do, then we can resolve.
                        if (receipt) {
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            done(()=>emit.resolve(receipt));
                            return;
                        }
                        // Get the transaction to check if it's been replaced.
                        // We need to retry as some RPC Providers may be slow to sync
                        // up mined transactions.
                        if (!transaction) {
                            retrying = true;
                            await (0, $ed552b6d0c3a055e$export$188df5ecf8e7961a)(async ()=>{
                                transaction = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $229509a4633c2dd6$export$ec0c6556a09b65b8), "getTransaction")({
                                    hash: hash
                                });
                                if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                            }, {
                                delay: retryDelay,
                                retryCount: retryCount
                            });
                            retrying = false;
                        }
                        // Get the receipt to check if it's been processed.
                        receipt = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $a819fdb64a2cc2ce$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                            hash: hash
                        });
                        // Check if we have enough confirmations. If not, continue polling.
                        if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                        done(()=>emit.resolve(receipt));
                    } catch (err) {
                        // If the receipt is not found, the transaction will be pending.
                        // We need to check if it has potentially been replaced.
                        if (err instanceof (0, $kIOz8.TransactionNotFoundError) || err instanceof (0, $kIOz8.TransactionReceiptNotFoundError)) {
                            if (!transaction) {
                                retrying = false;
                                return;
                            }
                            try {
                                replacedTransaction = transaction;
                                // Let's retrieve the transactions from the current block.
                                // We need to retry as some RPC Providers may be slow to sync
                                // up mined blocks.
                                retrying = true;
                                const block = await (0, $ed552b6d0c3a055e$export$188df5ecf8e7961a)(()=>(0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $5f9e2cea6bd44750$export$ea0af84ed2e77902), "getBlock")({
                                        blockNumber: blockNumber,
                                        includeTransactions: true
                                    }), {
                                    delay: retryDelay,
                                    retryCount: retryCount,
                                    shouldRetry: ({ error: error })=>error instanceof (0, $ba5a0965c3d7b739$export$f5a00468af285e38)
                                });
                                retrying = false;
                                const replacementTransaction = block.transactions.find(({ from: from, nonce: nonce })=>from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                                // If we couldn't find a replacement transaction, continue polling.
                                if (!replacementTransaction) return;
                                // If we found a replacement transaction, return it's receipt.
                                receipt = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $a819fdb64a2cc2ce$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                                    hash: replacementTransaction.hash
                                });
                                // Check if we have enough confirmations. If not, continue polling.
                                if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                                let reason = "replaced";
                                if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value) reason = "repriced";
                                else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = "cancelled";
                                done(()=>{
                                    emit.onReplaced?.({
                                        reason: reason,
                                        replacedTransaction: replacedTransaction,
                                        transaction: replacementTransaction,
                                        transactionReceipt: receipt
                                    });
                                    emit.resolve(receipt);
                                });
                            } catch (err_) {
                                done(()=>emit.reject(err_));
                            }
                        } else done(()=>emit.reject(err));
                    } finally{
                        count++;
                    }
                }
            });
        });
    });
}



async function $e62af31518118c60$export$694ec9bdf0bb55cf(config, parameters) {
    const { chainId: chainId, timeout: timeout = 0, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $6923320b64509040$export$694ec9bdf0bb55cf), "waitForTransactionReceipt");
    const receipt = await action({
        ...rest,
        timeout: timeout
    });
    if (receipt.status === "reverted") {
        const action_getTransaction = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $229509a4633c2dd6$export$ec0c6556a09b65b8), "getTransaction");
        const txn = await action_getTransaction({
            hash: receipt.transactionHash
        });
        const action_call = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $6P18x.call), "call");
        const code = await action_call({
            ...txn,
            gasPrice: txn.type !== "eip1559" ? txn.gasPrice : undefined,
            maxFeePerGas: txn.type === "eip1559" ? txn.maxFeePerGas : undefined,
            maxPriorityFeePerGas: txn.type === "eip1559" ? txn.maxPriorityFeePerGas : undefined
        });
        const reason = code?.data ? (0, $dZgT6.hexToString)(`0x${code.data.substring(138)}`) : "unknown reason";
        throw new Error(reason);
    }
    return {
        ...receipt,
        chainId: client.chain.id
    };
}



function $c030347180c4f64f$export$30c94aeff2da2ac6(config, parameters) {
    const { onChange: onChange } = parameters;
    return config.subscribe(()=>(0, $9bf87c5242498f44$export$4f9234baf34abd0)(config), onChange, {
        equalityFn (a, b) {
            const { connector: aConnector, ...aRest } = a;
            const { connector: bConnector, ...bRest } = b;
            return (0, $b1bffa4f8292a3b3$export$9cb4719e2e525b7a)(aRest, bRest) && // check connector separately
            aConnector?.id === bConnector?.id && aConnector?.uid === bConnector?.uid;
        }
    });
}

/** https://wagmi.sh/core/api/actions/watchConnectors */ function $caf5e1a20ce94acd$export$9c8eec0a0da048a0(config, parameters) {
    const { onChange: onChange } = parameters;
    return config._internal.connectors.subscribe((connectors, prevConnectors)=>{
        onChange(Object.values(connectors), prevConnectors);
    });
}


var $bsCQg = parcelRequire("bsCQg");


var $cA21A = parcelRequire("cA21A");



async function $77b6578c0bed5260$export$4c0f201bc17cbf23(client, parameters) {
    const { abi: abi, account: account_ = client.account, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...request } = parameters;
    if (!account_) throw new (0, $e2693921d16acd79$export$62ee6b05f0767f28)({
        docsPath: "/docs/contract/writeContract"
    });
    const account = (0, $bsCQg.parseAccount)(account_);
    const data = (0, $cA21A.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        return await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $99411418fa6ef5ff$export$8e0e7ffc78696d30), "sendTransaction")({
            data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            account: account,
            ...request
        });
    } catch (error) {
        throw (0, $0edd9c663decfccb$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/writeContract",
            functionName: functionName,
            sender: account.address
        });
    }
}






var $bsCQg = parcelRequire("bsCQg");

var $1DT5P = parcelRequire("1DT5P");

var $cA21A = parcelRequire("cA21A");



var $6P18x = parcelRequire("6P18x");
async function $543f6678e33773e1$export$e8798d551e27a374(client, parameters) {
    const { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...callRequest } = parameters;
    const account = callRequest.account ? (0, $bsCQg.parseAccount)(callRequest.account) : client.account;
    const calldata = (0, $cA21A.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $c66640b3f6d368dc$export$6ca3170acb89054)(client, (0, $6P18x.call), "call")({
            batch: false,
            data: `${calldata}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            ...callRequest,
            account: account
        });
        const result = (0, $1DT5P.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
        const minimizedAbi = abi.filter((abiItem)=>"name" in abiItem && abiItem.name === parameters.functionName);
        return {
            result: result,
            request: {
                abi: minimizedAbi,
                address: address,
                args: args,
                dataSuffix: dataSuffix,
                functionName: functionName,
                ...callRequest,
                account: account
            }
        };
    } catch (error) {
        throw (0, $0edd9c663decfccb$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/simulateContract",
            functionName: functionName,
            sender: account?.address
        });
    }
}




async function $15a76d92f5a0318c$export$e8798d551e27a374(config, parameters) {
    const { abi: abi, chainId: chainId, connector: connector, ...rest } = parameters;
    let account;
    if (parameters.account) account = parameters.account;
    else {
        const connectorClient = await (0, $952dfb3505a236b1$export$d784801ca17b4aec)(config, {
            chainId: chainId,
            connector: connector
        });
        account = connectorClient.account;
    }
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $543f6678e33773e1$export$e8798d551e27a374), "simulateContract");
    const { result: result, request: request } = await action({
        ...rest,
        abi: abi,
        account: account
    });
    return {
        chainId: client.chain.id,
        result: result,
        request: {
            __mode: "prepared",
            ...request,
            chainId: chainId
        }
    };
}


async function $db550b2f04051292$export$4c0f201bc17cbf23(config, parameters) {
    const { account: account, chainId: chainId, connector: connector, __mode: __mode, ...rest } = parameters;
    let client;
    if (typeof account === "object" && account.type === "local") client = config.getClient({
        chainId: chainId
    });
    else client = await (0, $952dfb3505a236b1$export$d784801ca17b4aec)(config, {
        account: account,
        chainId: chainId,
        connector: connector
    });
    const { connector: activeConnector } = (0, $9bf87c5242498f44$export$4f9234baf34abd0)(config);
    let request;
    if (__mode === "prepared" || activeConnector?.supportsSimulation) request = rest;
    else {
        const { request: simulateRequest } = await (0, $15a76d92f5a0318c$export$e8798d551e27a374)(config, {
            ...rest,
            account: account,
            chainId: chainId
        });
        request = simulateRequest;
    }
    const action = (0, $16f206e6d6a76121$export$6ca3170acb89054)(client, (0, $77b6578c0bed5260$export$4c0f201bc17cbf23), "writeContract");
    const hash = await action({
        ...request,
        ...account ? {
            account: account
        } : {},
        chain: chainId ? {
            id: chainId
        } : null
    });
    return hash;
}


function $57ffd000782ab8bb$export$b6380ff64616a4fb(chain) {
    return {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain
    };
}


const $943f0ea18d6af5d7$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $57ffd000782ab8bb$export$b6380ff64616a4fb)({
    id: 1,
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://cloudflare-eth.com"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://etherscan.io",
            apiUrl: "https://api.etherscan.io/api"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
            blockCreated: 19258213
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
});



var $94Fzw = parcelRequire("94Fzw");/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */ function $e484fe21942c6e42$export$203ae30b4f6490b3(value, decimals) {
    let [integer, fraction = "0"] = value.split(".");
    const negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim trailing zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = "";
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, "0");
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}



parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
var $1yWTt = parcelRequire("1yWTt");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");



var $f3fVd = parcelRequire("f3fVd");

var $iNdL8 = parcelRequire("iNdL8");

var $89XCI = parcelRequire("89XCI");

var $8lDxr = parcelRequire("8lDxr");

var $ezpuP = parcelRequire("ezpuP");

var $1YStM = parcelRequire("1YStM");

var $bNsWC = parcelRequire("bNsWC");

var $aftW8 = parcelRequire("aftW8");

var $41Mfc = parcelRequire("41Mfc");

var $lzf2X = parcelRequire("lzf2X");
parcelRequire("lgSQS");
var $7GAet = parcelRequire("7GAet");
var $50fYI = parcelRequire("50fYI");
var $5t5tf = parcelRequire("5t5tf");
function $c4d4cb99ea3e8904$var$e(s, r, i = "string") {
    if (!s[r] || typeof s[r] !== i) throw new Error(`Missing or invalid "${r}" param`);
}
function $c4d4cb99ea3e8904$var$l(s, r) {
    let i = !0;
    return r.forEach((t)=>{
        t in s || (i = !1);
    }), i;
}
function $c4d4cb99ea3e8904$var$f(s, r) {
    return Array.isArray(s) ? s.length === r : Object.keys(s).length === r;
}
function $c4d4cb99ea3e8904$var$w(s, r) {
    return Array.isArray(s) ? s.length >= r : Object.keys(s).length >= r;
}
function $c4d4cb99ea3e8904$var$u(s, r, i) {
    return (i.length ? $c4d4cb99ea3e8904$var$w(s, r.length) : $c4d4cb99ea3e8904$var$f(s, r.length)) ? $c4d4cb99ea3e8904$var$l(s, r) : !1;
}
function $c4d4cb99ea3e8904$var$n(s, r, i = "_") {
    const t = s.split(i);
    return t[t.length - 1].trim().toLowerCase() === r.trim().toLowerCase();
}
function $c4d4cb99ea3e8904$export$c75580565fa025bd(s) {
    return $c4d4cb99ea3e8904$export$f576347163de0984(s.method) && $c4d4cb99ea3e8904$export$dae2311546d43680(s.params);
}
function $c4d4cb99ea3e8904$export$f576347163de0984(s) {
    return $c4d4cb99ea3e8904$var$n(s, "subscribe");
}
function $c4d4cb99ea3e8904$export$dae2311546d43680(s) {
    return $c4d4cb99ea3e8904$var$u(s, [
        "topic"
    ], []);
}
function $c4d4cb99ea3e8904$export$8fa7cf76b41caee0(s) {
    return $c4d4cb99ea3e8904$export$71d4d33ac7f7a269(s.method) && $c4d4cb99ea3e8904$export$71e8d1aa48c3e86f(s.params);
}
function $c4d4cb99ea3e8904$export$71d4d33ac7f7a269(s) {
    return $c4d4cb99ea3e8904$var$n(s, "publish");
}
function $c4d4cb99ea3e8904$export$71e8d1aa48c3e86f(s) {
    return $c4d4cb99ea3e8904$var$u(s, [
        "message",
        "topic",
        "ttl"
    ], [
        "prompt",
        "tag"
    ]);
}
function $c4d4cb99ea3e8904$export$83e292763180b41b(s) {
    return $c4d4cb99ea3e8904$export$568d956f39536025(s.method) && $c4d4cb99ea3e8904$export$cbc597c53c3b4f80(s.params);
}
function $c4d4cb99ea3e8904$export$568d956f39536025(s) {
    return $c4d4cb99ea3e8904$var$n(s, "unsubscribe");
}
function $c4d4cb99ea3e8904$export$cbc597c53c3b4f80(s) {
    return $c4d4cb99ea3e8904$var$u(s, [
        "id",
        "topic"
    ], []);
}
function $c4d4cb99ea3e8904$export$43cf4100d6287b8e(s) {
    return $c4d4cb99ea3e8904$export$3cb4ad320e3a46a4(s.method) && $c4d4cb99ea3e8904$export$6366ff9a39f2da4c(s.params);
}
function $c4d4cb99ea3e8904$export$3cb4ad320e3a46a4(s) {
    return $c4d4cb99ea3e8904$var$n(s, "subscription");
}
function $c4d4cb99ea3e8904$export$6366ff9a39f2da4c(s) {
    return $c4d4cb99ea3e8904$var$u(s, [
        "id",
        "data"
    ], []);
}
function $c4d4cb99ea3e8904$export$abdf96c288cb375(s) {
    if (!$c4d4cb99ea3e8904$export$f576347163de0984(s.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!$c4d4cb99ea3e8904$export$dae2311546d43680(s.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const r = s.params;
    return $c4d4cb99ea3e8904$var$e(r, "topic"), r;
}
function $c4d4cb99ea3e8904$export$eac3e45ac5c5c9fa(s) {
    if (!$c4d4cb99ea3e8904$export$71d4d33ac7f7a269(s.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!$c4d4cb99ea3e8904$export$71e8d1aa48c3e86f(s.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const r = s.params;
    return $c4d4cb99ea3e8904$var$e(r, "topic"), $c4d4cb99ea3e8904$var$e(r, "message"), $c4d4cb99ea3e8904$var$e(r, "ttl", "number"), r;
}
function $c4d4cb99ea3e8904$export$78baa72f78156594(s) {
    if (!$c4d4cb99ea3e8904$export$568d956f39536025(s.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!$c4d4cb99ea3e8904$export$cbc597c53c3b4f80(s.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const r = s.params;
    return $c4d4cb99ea3e8904$var$e(r, "id"), r;
}
function $c4d4cb99ea3e8904$export$4d5822edd41f3b48(s) {
    if (!$c4d4cb99ea3e8904$export$3cb4ad320e3a46a4(s.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!$c4d4cb99ea3e8904$export$6366ff9a39f2da4c(s.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const r = s.params;
    return $c4d4cb99ea3e8904$var$e(r, "id"), $c4d4cb99ea3e8904$var$e(r, "data"), r;
}
const $c4d4cb99ea3e8904$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe",
        batchFetchMessages: "waku_batchFetchMessages"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe",
        batchFetchMessages: "irn_batchFetchMessages"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe",
        batchFetchMessages: "iridium_batchFetchMessages"
    }
};



var $eSBMZ = parcelRequire("eSBMZ");

var $fxkLe = parcelRequire("fxkLe");
var $23d8f6d1574ae23f$require$Buffer = $fxkLe.Buffer;
const $23d8f6d1574ae23f$var$Ir = ":";
function $23d8f6d1574ae23f$export$4764229d78de4437(e) {
    const [t, r] = e.split($23d8f6d1574ae23f$var$Ir);
    return {
        namespace: t,
        reference: r
    };
}
function $23d8f6d1574ae23f$export$a5999672e4930644(e) {
    const { namespace: t, reference: r } = e;
    return [
        t,
        r
    ].join($23d8f6d1574ae23f$var$Ir);
}
function $23d8f6d1574ae23f$export$276ab0158c66e3d(e) {
    const [t, r, i] = e.split($23d8f6d1574ae23f$var$Ir);
    return {
        namespace: t,
        reference: r,
        address: i
    };
}
function $23d8f6d1574ae23f$export$566a25328fb93a18(e) {
    const { namespace: t, reference: r, address: i } = e;
    return [
        t,
        r,
        i
    ].join($23d8f6d1574ae23f$var$Ir);
}
function $23d8f6d1574ae23f$export$d579bc26e95946b5(e, t) {
    const r = [];
    return e.forEach((i)=>{
        const n = t(i);
        r.includes(n) || r.push(n);
    }), r;
}
function $23d8f6d1574ae23f$export$2806d446053abd1d(e) {
    const { address: t } = $23d8f6d1574ae23f$export$276ab0158c66e3d(e);
    return t;
}
function $23d8f6d1574ae23f$export$93512919ec2ab555(e) {
    const { namespace: t, reference: r } = $23d8f6d1574ae23f$export$276ab0158c66e3d(e);
    return $23d8f6d1574ae23f$export$a5999672e4930644({
        namespace: t,
        reference: r
    });
}
function $23d8f6d1574ae23f$export$40283ddc77f27f6e(e, t) {
    const { namespace: r, reference: i } = $23d8f6d1574ae23f$export$4764229d78de4437(t);
    return $23d8f6d1574ae23f$export$566a25328fb93a18({
        namespace: r,
        reference: i,
        address: e
    });
}
function $23d8f6d1574ae23f$export$aa4a6b630dfcfa83(e) {
    return $23d8f6d1574ae23f$export$d579bc26e95946b5(e, $23d8f6d1574ae23f$export$2806d446053abd1d);
}
function $23d8f6d1574ae23f$export$d5ee58c6b13696e9(e) {
    return $23d8f6d1574ae23f$export$d579bc26e95946b5(e, $23d8f6d1574ae23f$export$93512919ec2ab555);
}
function $23d8f6d1574ae23f$export$23329703ad972840(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...n.accounts);
    }), r;
}
function $23d8f6d1574ae23f$export$6281ff29da5f85fe(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...$23d8f6d1574ae23f$export$d5ee58c6b13696e9(n.accounts));
    }), r;
}
function $23d8f6d1574ae23f$export$d1109eeb751412cf(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...$23d8f6d1574ae23f$export$376384387cd15b27(i, n));
    }), r;
}
function $23d8f6d1574ae23f$export$376384387cd15b27(e, t) {
    return e.includes(":") ? [
        e
    ] : t.chains || [];
}
var $23d8f6d1574ae23f$var$Qo = Object.defineProperty, $23d8f6d1574ae23f$var$bn = Object.getOwnPropertySymbols, $23d8f6d1574ae23f$var$Jo = Object.prototype.hasOwnProperty, $23d8f6d1574ae23f$var$Go = Object.prototype.propertyIsEnumerable, $23d8f6d1574ae23f$var$yn = (e, t, r)=>t in e ? $23d8f6d1574ae23f$var$Qo(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $23d8f6d1574ae23f$var$wn = (e, t)=>{
    for(var r in t || (t = {}))$23d8f6d1574ae23f$var$Jo.call(t, r) && $23d8f6d1574ae23f$var$yn(e, r, t[r]);
    if ($23d8f6d1574ae23f$var$bn) for (var r of $23d8f6d1574ae23f$var$bn(t))$23d8f6d1574ae23f$var$Go.call(t, r) && $23d8f6d1574ae23f$var$yn(e, r, t[r]);
    return e;
};
const $23d8f6d1574ae23f$export$f12873d77424d47b = "ReactNative", $23d8f6d1574ae23f$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $23d8f6d1574ae23f$export$657dee6d5648750a = " ", $23d8f6d1574ae23f$export$96c3628b3b9d2079 = ":", $23d8f6d1574ae23f$export$98238152dfccf046 = "/", $23d8f6d1574ae23f$export$7f882bb969de14a3 = 2, $23d8f6d1574ae23f$export$77baccb4c6bd5852 = 1e3, $23d8f6d1574ae23f$export$e08b61c98317d88c = "js";
function $23d8f6d1574ae23f$export$8ee0fc9ee280b4ee() {
    return typeof $eSBMZ < "u" && typeof $eSBMZ.versions < "u" && typeof $eSBMZ.versions.node < "u";
}
function $23d8f6d1574ae23f$export$f7a1e23e542d38e3() {
    return !(0, $89XCI.getDocument)() && !!(0, $89XCI.getNavigator)() && navigator.product === $23d8f6d1574ae23f$export$f12873d77424d47b;
}
function $23d8f6d1574ae23f$export$4e09c449d6c407f7() {
    return !$23d8f6d1574ae23f$export$8ee0fc9ee280b4ee() && !!(0, $89XCI.getNavigator)() && !!(0, $89XCI.getDocument)();
}
function $23d8f6d1574ae23f$export$57570b1603cf6adb() {
    return $23d8f6d1574ae23f$export$f7a1e23e542d38e3() ? $23d8f6d1574ae23f$export$86b1301a63b15dd9.reactNative : $23d8f6d1574ae23f$export$8ee0fc9ee280b4ee() ? $23d8f6d1574ae23f$export$86b1301a63b15dd9.node : $23d8f6d1574ae23f$export$4e09c449d6c407f7() ? $23d8f6d1574ae23f$export$86b1301a63b15dd9.browser : $23d8f6d1574ae23f$export$86b1301a63b15dd9.unknown;
}
function $23d8f6d1574ae23f$export$40a40f90174d197c() {
    var e;
    try {
        return $23d8f6d1574ae23f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $23d8f6d1574ae23f$export$c4147c69f6845da(e, t) {
    let r = $ezpuP.parse(e);
    return r = $23d8f6d1574ae23f$var$wn($23d8f6d1574ae23f$var$wn({}, r), t), e = $ezpuP.stringify(r), e;
}
function $23d8f6d1574ae23f$export$ba31e015127122bb() {
    return (0, $8lDxr.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $23d8f6d1574ae23f$export$6b05aa0115b6fc2d(e, t) {
    var r;
    const i = $23d8f6d1574ae23f$export$57570b1603cf6adb(), n = {
        protocol: e,
        version: t,
        env: i
    };
    return i === "browser" && (n.host = ((r = (0, $89XCI.getLocation)()) == null ? void 0 : r.host) || "unknown"), n;
}
function $23d8f6d1574ae23f$export$20d4a3cb5829b8b6() {
    if ($23d8f6d1574ae23f$export$57570b1603cf6adb() === $23d8f6d1574ae23f$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: r, Version: i } = $parcel$global.Platform;
        return [
            r,
            i
        ].join("-");
    }
    const e = (0, $f3fVd.detect)();
    if (e === null) return "unknown";
    const t = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        t,
        e.name,
        e.version
    ].join("-") : [
        t,
        e.version
    ].join("-");
}
function $23d8f6d1574ae23f$export$4389b0987726d52d() {
    var e;
    const t = $23d8f6d1574ae23f$export$57570b1603cf6adb();
    return t === $23d8f6d1574ae23f$export$86b1301a63b15dd9.browser ? [
        t,
        ((e = (0, $89XCI.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : t;
}
function $23d8f6d1574ae23f$export$b55a4c6e272b719f(e, t, r) {
    const i = $23d8f6d1574ae23f$export$20d4a3cb5829b8b6(), n = $23d8f6d1574ae23f$export$4389b0987726d52d();
    return [
        [
            e,
            t
        ].join("-"),
        [
            $23d8f6d1574ae23f$export$e08b61c98317d88c,
            r
        ].join("-"),
        i,
        n
    ].join("/");
}
function $23d8f6d1574ae23f$export$d875b3963ef774f5({ protocol: e, version: t, relayUrl: r, sdkVersion: i, auth: n, projectId: o, useOnCloseEvent: h, bundleId: p }) {
    const b = r.split("?"), m = $23d8f6d1574ae23f$export$b55a4c6e272b719f(e, t, i), w = {
        auth: n,
        ua: m,
        projectId: o,
        useOnCloseEvent: h || void 0,
        origin: p || void 0
    }, y = $23d8f6d1574ae23f$export$c4147c69f6845da(b[1] || "", w);
    return b[0] + "?" + y;
}
function $23d8f6d1574ae23f$export$ed08891a8a54eb(e) {
    let t = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const r = typeof t < "u" ? e.split("://")[1] : e;
    return t = t === "wss" ? "https" : "http", [
        t,
        r
    ].join("://");
}
function $23d8f6d1574ae23f$export$804de46662e4ac95(e, t, r) {
    if (!e[t] || typeof e[t] !== r) throw new Error(`Missing or invalid "${t}" param`);
}
function $23d8f6d1574ae23f$export$1e21530e896c0b0b(e, t = $23d8f6d1574ae23f$export$7f882bb969de14a3) {
    return $23d8f6d1574ae23f$export$7f00885504704576(e.split($23d8f6d1574ae23f$export$98238152dfccf046), t);
}
function $23d8f6d1574ae23f$export$80bffd46c37a96f6(e) {
    return $23d8f6d1574ae23f$export$1e21530e896c0b0b(e).join($23d8f6d1574ae23f$export$657dee6d5648750a);
}
function $23d8f6d1574ae23f$export$1468a49de573f7f9(e, t) {
    return e.filter((r)=>t.includes(r)).length === e.length;
}
function $23d8f6d1574ae23f$export$7f00885504704576(e, t = $23d8f6d1574ae23f$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - t, 0));
}
function $23d8f6d1574ae23f$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $23d8f6d1574ae23f$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $23d8f6d1574ae23f$export$592ef47eabb05614(e, t) {
    const r = {};
    return Object.keys(e).forEach((i)=>{
        r[i] = t(e[i]);
    }), r;
}
const $23d8f6d1574ae23f$export$85c927578394b28b = (e)=>e;
function $23d8f6d1574ae23f$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (t)=>t.toUpperCase());
}
function $23d8f6d1574ae23f$export$9a00dee1beb8f576(e) {
    return e.split($23d8f6d1574ae23f$export$657dee6d5648750a).map((t)=>$23d8f6d1574ae23f$export$e9f8fcacef3bca4b(t)).join($23d8f6d1574ae23f$export$657dee6d5648750a);
}
function $23d8f6d1574ae23f$export$cbf9e3cc9ffc85cb(e = (0, $iNdL8.FIVE_MINUTES), t) {
    const r = (0, $iNdL8.toMiliseconds)(e || (0, $iNdL8.FIVE_MINUTES));
    let i, n, o;
    return {
        resolve: (h)=>{
            o && i && (clearTimeout(o), i(h));
        },
        reject: (h)=>{
            o && n && (clearTimeout(o), n(h));
        },
        done: ()=>new Promise((h, p)=>{
                o = setTimeout(()=>{
                    p(new Error(t));
                }, r), i = h, n = p;
            })
    };
}
function $23d8f6d1574ae23f$export$3da2293b007ed708(e, t, r) {
    return new Promise(async (i, n)=>{
        const o = setTimeout(()=>n(new Error(r)), t);
        try {
            const h = await e;
            i(h);
        } catch (h) {
            n(h);
        }
        clearTimeout(o);
    });
}
function $23d8f6d1574ae23f$export$187ab6574b2ae23f(e, t) {
    if (typeof t == "string" && t.startsWith(`${e}:`)) return t;
    if (e.toLowerCase() === "topic") {
        if (typeof t != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${t}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof t != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${t}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $23d8f6d1574ae23f$export$43ab92477f8713b9(e) {
    return $23d8f6d1574ae23f$export$187ab6574b2ae23f("topic", e);
}
function $23d8f6d1574ae23f$export$bd13103c2e5cc0c3(e) {
    return $23d8f6d1574ae23f$export$187ab6574b2ae23f("id", e);
}
function $23d8f6d1574ae23f$export$93adeb0f16e8e51d(e) {
    const [t, r] = e.split(":"), i = {
        id: void 0,
        topic: void 0
    };
    if (t === "topic" && typeof r == "string") i.topic = r;
    else if (t === "id" && Number.isInteger(Number(r))) i.id = Number(r);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${t}:${r}`);
    return i;
}
function $23d8f6d1574ae23f$export$b136d03015bfc12(e, t) {
    return (0, $iNdL8.fromMiliseconds)((t || Date.now()) + (0, $iNdL8.toMiliseconds)(e));
}
function $23d8f6d1574ae23f$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $iNdL8.toMiliseconds)(e);
}
function $23d8f6d1574ae23f$export$e3eb27ce66c0f6d9(e, t) {
    return `${e}${t ? `:${t}` : ""}`;
}
function $23d8f6d1574ae23f$export$9826fe7ad3921016(e = [], t = []) {
    return [
        ...new Set([
            ...e,
            ...t
        ])
    ];
}
async function $23d8f6d1574ae23f$export$694a208c8abca99a({ id: e, topic: t, wcDeepLink: r }) {
    try {
        if (!r) return;
        const i = typeof r == "string" ? JSON.parse(r) : r;
        let n = i?.href;
        if (typeof n != "string") return;
        n.endsWith("/") && (n = n.slice(0, -1));
        const o = `${n}/wc?requestId=${e}&sessionTopic=${t}`, h = $23d8f6d1574ae23f$export$57570b1603cf6adb();
        h === $23d8f6d1574ae23f$export$86b1301a63b15dd9.browser ? o.startsWith("https://") || o.startsWith("http://") ? window.open(o, "_blank", "noreferrer noopener") : window.open(o, "_self", "noreferrer noopener") : h === $23d8f6d1574ae23f$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(o);
    } catch (i) {
        console.error(i);
    }
}
async function $23d8f6d1574ae23f$export$e55bfdac47149a32(e, t) {
    try {
        return await e.getItem(t) || ($23d8f6d1574ae23f$export$4e09c449d6c407f7() ? localStorage.getItem(t) : void 0);
    } catch (r) {
        console.error(r);
    }
}
function $23d8f6d1574ae23f$export$f8aaf09178dd8b96(e, t) {
    return e.filter((r)=>t.includes(r));
}
var $23d8f6d1574ae23f$var$On = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $23d8f6d1574ae23f$var$A0(e) {
    var t = e.default;
    if (typeof t == "function") {
        var r = function() {
            return t.apply(this, arguments);
        };
        r.prototype = t.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(i) {
        var n = Object.getOwnPropertyDescriptor(e, i);
        Object.defineProperty(r, i, n.get ? n : {
            enumerable: !0,
            get: function() {
                return e[i];
            }
        });
    }), r;
}
var $23d8f6d1574ae23f$var$Pn = {
    exports: {}
}; /**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ 
(function(e) {
    (function() {
        var t = "input is invalid type", r = "finalize already called", i = typeof window == "object", n = i ? window : {};
        n.JS_SHA3_NO_WINDOW && (i = !1);
        var o = !i && typeof self == "object", h = !n.JS_SHA3_NO_NODE_JS && typeof $eSBMZ == "object" && $eSBMZ.versions && $eSBMZ.versions.node;
        h ? n = $23d8f6d1574ae23f$var$On : o && (n = self);
        var p = !n.JS_SHA3_NO_COMMON_JS && !0 && e.exports, b = !n.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", m = "0123456789abcdef".split(""), w = [
            31,
            7936,
            2031616,
            520093696
        ], y = [
            4,
            1024,
            262144,
            67108864
        ], S = [
            1,
            256,
            65536,
            16777216
        ], I = [
            6,
            1536,
            393216,
            100663296
        ], N = [
            0,
            8,
            16,
            24
        ], C = [
            1,
            0,
            32898,
            0,
            32906,
            2147483648,
            2147516416,
            2147483648,
            32907,
            0,
            2147483649,
            0,
            2147516545,
            2147483648,
            32777,
            2147483648,
            138,
            0,
            136,
            0,
            2147516425,
            0,
            2147483658,
            0,
            2147516555,
            0,
            139,
            2147483648,
            32905,
            2147483648,
            32771,
            2147483648,
            32770,
            2147483648,
            128,
            2147483648,
            32778,
            0,
            2147483658,
            2147483648,
            2147516545,
            2147483648,
            32896,
            2147483648,
            2147483649,
            0,
            2147516424,
            2147483648
        ], F = [
            224,
            256,
            384,
            512
        ], U = [
            128,
            256
        ], J = [
            "hex",
            "buffer",
            "arrayBuffer",
            "array",
            "digest"
        ], Bt = {
            128: 168,
            256: 136
        };
        (n.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(u) {
            return Object.prototype.toString.call(u) === "[object Array]";
        }), b && (n.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(u) {
            return typeof u == "object" && u.buffer && u.buffer.constructor === ArrayBuffer;
        });
        for(var G = function(u, E, _) {
            return function(B) {
                return new s(u, E, u).update(B)[_]();
            };
        }, H = function(u, E, _) {
            return function(B, R) {
                return new s(u, E, R).update(B)[_]();
            };
        }, z = function(u, E, _) {
            return function(B, R, T, P) {
                return f["cshake" + u].update(B, R, T, P)[_]();
            };
        }, Pt = function(u, E, _) {
            return function(B, R, T, P) {
                return f["kmac" + u].update(B, R, T, P)[_]();
            };
        }, W = function(u, E, _, B) {
            for(var R = 0; R < J.length; ++R){
                var T = J[R];
                u[T] = E(_, B, T);
            }
            return u;
        }, Rt = function(u, E) {
            var _ = G(u, E, "hex");
            return _.create = function() {
                return new s(u, E, u);
            }, _.update = function(B) {
                return _.create().update(B);
            }, W(_, G, u, E);
        }, Yt = function(u, E) {
            var _ = H(u, E, "hex");
            return _.create = function(B) {
                return new s(u, E, B);
            }, _.update = function(B, R) {
                return _.create(R).update(B);
            }, W(_, H, u, E);
        }, Y = function(u, E) {
            var _ = Bt[u], B = z(u, E, "hex");
            return B.create = function(R, T, P) {
                return !T && !P ? f["shake" + u].create(R) : new s(u, E, R).bytepad([
                    T,
                    P
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(T, P, O).update(R);
            }, W(B, z, u, E);
        }, Vt = function(u, E) {
            var _ = Bt[u], B = Pt(u, E, "hex");
            return B.create = function(R, T, P) {
                return new v(u, E, T).bytepad([
                    "KMAC",
                    P
                ], _).bytepad([
                    R
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(R, P, O).update(T);
            }, W(B, Pt, u, E);
        }, A = [
            {
                name: "keccak",
                padding: S,
                bits: F,
                createMethod: Rt
            },
            {
                name: "sha3",
                padding: I,
                bits: F,
                createMethod: Rt
            },
            {
                name: "shake",
                padding: w,
                bits: U,
                createMethod: Yt
            },
            {
                name: "cshake",
                padding: y,
                bits: U,
                createMethod: Y
            },
            {
                name: "kmac",
                padding: y,
                bits: U,
                createMethod: Vt
            }
        ], f = {}, a = [], c = 0; c < A.length; ++c)for(var d = A[c], g = d.bits, x = 0; x < g.length; ++x){
            var M = d.name + "_" + g[x];
            if (a.push(M), f[M] = d.createMethod(g[x], d.padding), d.name !== "sha3") {
                var l = d.name + g[x];
                a.push(l), f[l] = f[M];
            }
        }
        function s(u, E, _) {
            this.blocks = [], this.s = [], this.padding = E, this.outputBits = _, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (u << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = _ >> 5, this.extraBytes = (_ & 31) >> 3;
            for(var B = 0; B < 50; ++B)this.s[B] = 0;
        }
        s.prototype.update = function(u) {
            if (this.finalized) throw new Error(r);
            var E, _ = typeof u;
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (b && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!b || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            for(var B = this.blocks, R = this.byteCount, T = u.length, P = this.blockCount, O = 0, Ct = this.s, D, q; O < T;){
                if (this.reset) for(this.reset = !1, B[0] = this.block, D = 1; D < P + 1; ++D)B[D] = 0;
                if (E) for(D = this.start; O < T && D < R; ++O)B[D >> 2] |= u[O] << N[D++ & 3];
                else for(D = this.start; O < T && D < R; ++O)q = u.charCodeAt(O), q < 128 ? B[D >> 2] |= q << N[D++ & 3] : q < 2048 ? (B[D >> 2] |= (192 | q >> 6) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : q < 55296 || q >= 57344 ? (B[D >> 2] |= (224 | q >> 12) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : (q = 65536 + ((q & 1023) << 10 | u.charCodeAt(++O) & 1023), B[D >> 2] |= (240 | q >> 18) << N[D++ & 3], B[D >> 2] |= (128 | q >> 12 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]);
                if (this.lastByteIndex = D, D >= R) {
                    for(this.start = D - R, this.block = B[P], D = 0; D < P; ++D)Ct[D] ^= B[D];
                    k(Ct), this.reset = !0;
                } else this.start = D;
            }
            return this;
        }, s.prototype.encode = function(u, E) {
            var _ = u & 255, B = 1, R = [
                _
            ];
            for(u = u >> 8, _ = u & 255; _ > 0;)R.unshift(_), u = u >> 8, _ = u & 255, ++B;
            return E ? R.push(B) : R.unshift(B), this.update(R), R.length;
        }, s.prototype.encodeString = function(u) {
            var E, _ = typeof u;
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (b && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!b || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            var B = 0, R = u.length;
            if (E) B = R;
            else for(var T = 0; T < u.length; ++T){
                var P = u.charCodeAt(T);
                P < 128 ? B += 1 : P < 2048 ? B += 2 : P < 55296 || P >= 57344 ? B += 3 : (P = 65536 + ((P & 1023) << 10 | u.charCodeAt(++T) & 1023), B += 4);
            }
            return B += this.encode(B * 8), this.update(u), B;
        }, s.prototype.bytepad = function(u, E) {
            for(var _ = this.encode(E), B = 0; B < u.length; ++B)_ += this.encodeString(u[B]);
            var R = E - _ % E, T = [];
            return T.length = R, this.update(T), this;
        }, s.prototype.finalize = function() {
            if (!this.finalized) {
                this.finalized = !0;
                var u = this.blocks, E = this.lastByteIndex, _ = this.blockCount, B = this.s;
                if (u[E >> 2] |= this.padding[E & 3], this.lastByteIndex === this.byteCount) for(u[0] = u[_], E = 1; E < _ + 1; ++E)u[E] = 0;
                for(u[_ - 1] |= 2147483648, E = 0; E < _; ++E)B[E] ^= u[E];
                k(B);
            }
        }, s.prototype.toString = s.prototype.hex = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = "", O; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = E[R], P += m[O >> 4 & 15] + m[O & 15] + m[O >> 12 & 15] + m[O >> 8 & 15] + m[O >> 20 & 15] + m[O >> 16 & 15] + m[O >> 28 & 15] + m[O >> 24 & 15];
                T % u === 0 && (k(E), R = 0);
            }
            return B && (O = E[R], P += m[O >> 4 & 15] + m[O & 15], B > 1 && (P += m[O >> 12 & 15] + m[O >> 8 & 15]), B > 2 && (P += m[O >> 20 & 15] + m[O >> 16 & 15])), P;
        }, s.prototype.arrayBuffer = function() {
            this.finalize();
            var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = this.outputBits >> 3, O;
            B ? O = new ArrayBuffer(_ + 1 << 2) : O = new ArrayBuffer(P);
            for(var Ct = new Uint32Array(O); T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)Ct[T] = E[R];
                T % u === 0 && k(E);
            }
            return B && (Ct[R] = E[R], O = O.slice(0, P)), O;
        }, s.prototype.buffer = s.prototype.arrayBuffer, s.prototype.digest = s.prototype.array = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = [], O, Ct; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = T << 2, Ct = E[R], P[O] = Ct & 255, P[O + 1] = Ct >> 8 & 255, P[O + 2] = Ct >> 16 & 255, P[O + 3] = Ct >> 24 & 255;
                T % u === 0 && k(E);
            }
            return B && (O = T << 2, Ct = E[R], P[O] = Ct & 255, B > 1 && (P[O + 1] = Ct >> 8 & 255), B > 2 && (P[O + 2] = Ct >> 16 & 255)), P;
        };
        function v(u, E, _) {
            s.call(this, u, E, _);
        }
        v.prototype = new s, v.prototype.finalize = function() {
            return this.encode(this.outputBits, !0), s.prototype.finalize.call(this);
        };
        var k = function(u) {
            var E, _, B, R, T, P, O, Ct, D, q, De, X, Z, Fe, $, tt, Te, et, rt, Ue, it, nt, ke, ft, ot, qe, st, at, Ke, ut, ht, He, ct, lt, ze, dt, pt, Le, vt, mt, je, gt, At, Qe, bt, yt, Je, wt, xt, Ge, Mt, Et, Ye, St, Nt, Ve, It, _t, Me, Ee, Se, Ne, Ie;
            for(B = 0; B < 48; B += 2)R = u[0] ^ u[10] ^ u[20] ^ u[30] ^ u[40], T = u[1] ^ u[11] ^ u[21] ^ u[31] ^ u[41], P = u[2] ^ u[12] ^ u[22] ^ u[32] ^ u[42], O = u[3] ^ u[13] ^ u[23] ^ u[33] ^ u[43], Ct = u[4] ^ u[14] ^ u[24] ^ u[34] ^ u[44], D = u[5] ^ u[15] ^ u[25] ^ u[35] ^ u[45], q = u[6] ^ u[16] ^ u[26] ^ u[36] ^ u[46], De = u[7] ^ u[17] ^ u[27] ^ u[37] ^ u[47], X = u[8] ^ u[18] ^ u[28] ^ u[38] ^ u[48], Z = u[9] ^ u[19] ^ u[29] ^ u[39] ^ u[49], E = X ^ (P << 1 | O >>> 31), _ = Z ^ (O << 1 | P >>> 31), u[0] ^= E, u[1] ^= _, u[10] ^= E, u[11] ^= _, u[20] ^= E, u[21] ^= _, u[30] ^= E, u[31] ^= _, u[40] ^= E, u[41] ^= _, E = R ^ (Ct << 1 | D >>> 31), _ = T ^ (D << 1 | Ct >>> 31), u[2] ^= E, u[3] ^= _, u[12] ^= E, u[13] ^= _, u[22] ^= E, u[23] ^= _, u[32] ^= E, u[33] ^= _, u[42] ^= E, u[43] ^= _, E = P ^ (q << 1 | De >>> 31), _ = O ^ (De << 1 | q >>> 31), u[4] ^= E, u[5] ^= _, u[14] ^= E, u[15] ^= _, u[24] ^= E, u[25] ^= _, u[34] ^= E, u[35] ^= _, u[44] ^= E, u[45] ^= _, E = Ct ^ (X << 1 | Z >>> 31), _ = D ^ (Z << 1 | X >>> 31), u[6] ^= E, u[7] ^= _, u[16] ^= E, u[17] ^= _, u[26] ^= E, u[27] ^= _, u[36] ^= E, u[37] ^= _, u[46] ^= E, u[47] ^= _, E = q ^ (R << 1 | T >>> 31), _ = De ^ (T << 1 | R >>> 31), u[8] ^= E, u[9] ^= _, u[18] ^= E, u[19] ^= _, u[28] ^= E, u[29] ^= _, u[38] ^= E, u[39] ^= _, u[48] ^= E, u[49] ^= _, Fe = u[0], $ = u[1], yt = u[11] << 4 | u[10] >>> 28, Je = u[10] << 4 | u[11] >>> 28, at = u[20] << 3 | u[21] >>> 29, Ke = u[21] << 3 | u[20] >>> 29, Ee = u[31] << 9 | u[30] >>> 23, Se = u[30] << 9 | u[31] >>> 23, gt = u[40] << 18 | u[41] >>> 14, At = u[41] << 18 | u[40] >>> 14, lt = u[2] << 1 | u[3] >>> 31, ze = u[3] << 1 | u[2] >>> 31, tt = u[13] << 12 | u[12] >>> 20, Te = u[12] << 12 | u[13] >>> 20, wt = u[22] << 10 | u[23] >>> 22, xt = u[23] << 10 | u[22] >>> 22, ut = u[33] << 13 | u[32] >>> 19, ht = u[32] << 13 | u[33] >>> 19, Ne = u[42] << 2 | u[43] >>> 30, Ie = u[43] << 2 | u[42] >>> 30, St = u[5] << 30 | u[4] >>> 2, Nt = u[4] << 30 | u[5] >>> 2, dt = u[14] << 6 | u[15] >>> 26, pt = u[15] << 6 | u[14] >>> 26, et = u[25] << 11 | u[24] >>> 21, rt = u[24] << 11 | u[25] >>> 21, Ge = u[34] << 15 | u[35] >>> 17, Mt = u[35] << 15 | u[34] >>> 17, He = u[45] << 29 | u[44] >>> 3, ct = u[44] << 29 | u[45] >>> 3, ft = u[6] << 28 | u[7] >>> 4, ot = u[7] << 28 | u[6] >>> 4, Ve = u[17] << 23 | u[16] >>> 9, It = u[16] << 23 | u[17] >>> 9, Le = u[26] << 25 | u[27] >>> 7, vt = u[27] << 25 | u[26] >>> 7, Ue = u[36] << 21 | u[37] >>> 11, it = u[37] << 21 | u[36] >>> 11, Et = u[47] << 24 | u[46] >>> 8, Ye = u[46] << 24 | u[47] >>> 8, Qe = u[8] << 27 | u[9] >>> 5, bt = u[9] << 27 | u[8] >>> 5, qe = u[18] << 20 | u[19] >>> 12, st = u[19] << 20 | u[18] >>> 12, _t = u[29] << 7 | u[28] >>> 25, Me = u[28] << 7 | u[29] >>> 25, mt = u[38] << 8 | u[39] >>> 24, je = u[39] << 8 | u[38] >>> 24, nt = u[48] << 14 | u[49] >>> 18, ke = u[49] << 14 | u[48] >>> 18, u[0] = Fe ^ ~tt & et, u[1] = $ ^ ~Te & rt, u[10] = ft ^ ~qe & at, u[11] = ot ^ ~st & Ke, u[20] = lt ^ ~dt & Le, u[21] = ze ^ ~pt & vt, u[30] = Qe ^ ~yt & wt, u[31] = bt ^ ~Je & xt, u[40] = St ^ ~Ve & _t, u[41] = Nt ^ ~It & Me, u[2] = tt ^ ~et & Ue, u[3] = Te ^ ~rt & it, u[12] = qe ^ ~at & ut, u[13] = st ^ ~Ke & ht, u[22] = dt ^ ~Le & mt, u[23] = pt ^ ~vt & je, u[32] = yt ^ ~wt & Ge, u[33] = Je ^ ~xt & Mt, u[42] = Ve ^ ~_t & Ee, u[43] = It ^ ~Me & Se, u[4] = et ^ ~Ue & nt, u[5] = rt ^ ~it & ke, u[14] = at ^ ~ut & He, u[15] = Ke ^ ~ht & ct, u[24] = Le ^ ~mt & gt, u[25] = vt ^ ~je & At, u[34] = wt ^ ~Ge & Et, u[35] = xt ^ ~Mt & Ye, u[44] = _t ^ ~Ee & Ne, u[45] = Me ^ ~Se & Ie, u[6] = Ue ^ ~nt & Fe, u[7] = it ^ ~ke & $, u[16] = ut ^ ~He & ft, u[17] = ht ^ ~ct & ot, u[26] = mt ^ ~gt & lt, u[27] = je ^ ~At & ze, u[36] = Ge ^ ~Et & Qe, u[37] = Mt ^ ~Ye & bt, u[46] = Ee ^ ~Ne & St, u[47] = Se ^ ~Ie & Nt, u[8] = nt ^ ~Fe & tt, u[9] = ke ^ ~$ & Te, u[18] = He ^ ~ft & qe, u[19] = ct ^ ~ot & st, u[28] = gt ^ ~lt & dt, u[29] = At ^ ~ze & pt, u[38] = Et ^ ~Qe & yt, u[39] = Ye ^ ~bt & Je, u[48] = Ne ^ ~St & Ve, u[49] = Ie ^ ~Nt & It, u[0] ^= C[B], u[1] ^= C[B + 1];
        };
        if (p) e.exports = f;
        else for(c = 0; c < a.length; ++c)n[a[c]] = f[a[c]];
    })();
})($23d8f6d1574ae23f$var$Pn);
var $23d8f6d1574ae23f$var$b0 = $23d8f6d1574ae23f$var$Pn.exports;
const $23d8f6d1574ae23f$var$y0 = "logger/5.7.0";
let $23d8f6d1574ae23f$var$Dn = !1, $23d8f6d1574ae23f$var$Fn = !1;
const $23d8f6d1574ae23f$var$Cr = {
    debug: 1,
    default: 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $23d8f6d1574ae23f$var$Tn = $23d8f6d1574ae23f$var$Cr.default, $23d8f6d1574ae23f$var$gi = null;
function $23d8f6d1574ae23f$var$w0() {
    try {
        const e = [];
        if ([
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((t)=>{
            try {
                if ("test".normalize(t) !== "test") throw new Error("bad normalize");
            } catch  {
                e.push(t);
            }
        }), e.length) throw new Error("missing " + e.join(", "));
        if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
    } catch (e) {
        return e.message;
    }
    return null;
}
const $23d8f6d1574ae23f$var$Un = $23d8f6d1574ae23f$var$w0();
var $23d8f6d1574ae23f$var$Ai;
(function(e) {
    e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})($23d8f6d1574ae23f$var$Ai || ($23d8f6d1574ae23f$var$Ai = {}));
var $23d8f6d1574ae23f$var$re;
(function(e) {
    e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})($23d8f6d1574ae23f$var$re || ($23d8f6d1574ae23f$var$re = {}));
const $23d8f6d1574ae23f$var$kn = "0123456789abcdef";
class $23d8f6d1574ae23f$var$L {
    constructor(t){
        Object.defineProperty(this, "version", {
            enumerable: !0,
            value: t,
            writable: !1
        });
    }
    _log(t, r) {
        const i = t.toLowerCase();
        $23d8f6d1574ae23f$var$Cr[i] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !($23d8f6d1574ae23f$var$Tn > $23d8f6d1574ae23f$var$Cr[i]) && console.log.apply(console, r);
    }
    debug(...t) {
        this._log($23d8f6d1574ae23f$var$L.levels.DEBUG, t);
    }
    info(...t) {
        this._log($23d8f6d1574ae23f$var$L.levels.INFO, t);
    }
    warn(...t) {
        this._log($23d8f6d1574ae23f$var$L.levels.WARNING, t);
    }
    makeError(t, r, i) {
        if ($23d8f6d1574ae23f$var$Fn) return this.makeError("censored error", r, {});
        r || (r = $23d8f6d1574ae23f$var$L.errors.UNKNOWN_ERROR), i || (i = {});
        const n = [];
        Object.keys(i).forEach((b)=>{
            const m = i[b];
            try {
                if (m instanceof Uint8Array) {
                    let w = "";
                    for(let y = 0; y < m.length; y++)w += $23d8f6d1574ae23f$var$kn[m[y] >> 4], w += $23d8f6d1574ae23f$var$kn[m[y] & 15];
                    n.push(b + "=Uint8Array(0x" + w + ")");
                } else n.push(b + "=" + JSON.stringify(m));
            } catch  {
                n.push(b + "=" + JSON.stringify(i[b].toString()));
            }
        }), n.push(`code=${r}`), n.push(`version=${this.version}`);
        const o = t;
        let h = "";
        switch(r){
            case $23d8f6d1574ae23f$var$re.NUMERIC_FAULT:
                {
                    h = "NUMERIC_FAULT";
                    const b = t;
                    switch(b){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            h += "-" + b;
                            break;
                        case "negative-power":
                        case "negative-width":
                            h += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            h += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $23d8f6d1574ae23f$var$re.CALL_EXCEPTION:
            case $23d8f6d1574ae23f$var$re.INSUFFICIENT_FUNDS:
            case $23d8f6d1574ae23f$var$re.MISSING_NEW:
            case $23d8f6d1574ae23f$var$re.NONCE_EXPIRED:
            case $23d8f6d1574ae23f$var$re.REPLACEMENT_UNDERPRICED:
            case $23d8f6d1574ae23f$var$re.TRANSACTION_REPLACED:
            case $23d8f6d1574ae23f$var$re.UNPREDICTABLE_GAS_LIMIT:
                h = r;
                break;
        }
        h && (t += " [ See: https://links.ethers.org/v5-errors-" + h + " ]"), n.length && (t += " (" + n.join(", ") + ")");
        const p = new Error(t);
        return p.reason = o, p.code = r, Object.keys(i).forEach(function(b) {
            p[b] = i[b];
        }), p;
    }
    throwError(t, r, i) {
        throw this.makeError(t, r, i);
    }
    throwArgumentError(t, r, i) {
        return this.throwError(t, $23d8f6d1574ae23f$var$L.errors.INVALID_ARGUMENT, {
            argument: r,
            value: i
        });
    }
    assert(t, r, i, n) {
        t || this.throwError(r, i, n);
    }
    assertArgument(t, r, i, n) {
        t || this.throwArgumentError(r, i, n);
    }
    checkNormalize(t) {
        $23d8f6d1574ae23f$var$Un && this.throwError("platform missing String.prototype.normalize", $23d8f6d1574ae23f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $23d8f6d1574ae23f$var$Un
        });
    }
    checkSafeUint53(t, r) {
        typeof t == "number" && (r == null && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, $23d8f6d1574ae23f$var$L.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: t
        }), t % 1 && this.throwError(r, $23d8f6d1574ae23f$var$L.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: t
        }));
    }
    checkArgumentCount(t, r, i) {
        i ? i = ": " + i : i = "", t < r && this.throwError("missing argument" + i, $23d8f6d1574ae23f$var$L.errors.MISSING_ARGUMENT, {
            count: t,
            expectedCount: r
        }), t > r && this.throwError("too many arguments" + i, $23d8f6d1574ae23f$var$L.errors.UNEXPECTED_ARGUMENT, {
            count: t,
            expectedCount: r
        });
    }
    checkNew(t, r) {
        (t === Object || t == null) && this.throwError("missing new", $23d8f6d1574ae23f$var$L.errors.MISSING_NEW, {
            name: r.name
        });
    }
    checkAbstract(t, r) {
        t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", $23d8f6d1574ae23f$var$L.errors.UNSUPPORTED_OPERATION, {
            name: t.name,
            operation: "new"
        }) : (t === Object || t == null) && this.throwError("missing new", $23d8f6d1574ae23f$var$L.errors.MISSING_NEW, {
            name: r.name
        });
    }
    static globalLogger() {
        return $23d8f6d1574ae23f$var$gi || ($23d8f6d1574ae23f$var$gi = new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$y0)), $23d8f6d1574ae23f$var$gi;
    }
    static setCensorship(t, r) {
        if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", $23d8f6d1574ae23f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        }), $23d8f6d1574ae23f$var$Dn) {
            if (!t) return;
            this.globalLogger().throwError("error censorship permanent", $23d8f6d1574ae23f$var$L.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $23d8f6d1574ae23f$var$Fn = !!t, $23d8f6d1574ae23f$var$Dn = !!r;
    }
    static setLogLevel(t) {
        const r = $23d8f6d1574ae23f$var$Cr[t.toLowerCase()];
        if (r == null) {
            $23d8f6d1574ae23f$var$L.globalLogger().warn("invalid log level - " + t);
            return;
        }
        $23d8f6d1574ae23f$var$Tn = r;
    }
    static from(t) {
        return new $23d8f6d1574ae23f$var$L(t);
    }
}
$23d8f6d1574ae23f$var$L.errors = $23d8f6d1574ae23f$var$re, $23d8f6d1574ae23f$var$L.levels = $23d8f6d1574ae23f$var$Ai;
const $23d8f6d1574ae23f$var$x0 = "bytes/5.7.0", $23d8f6d1574ae23f$var$Dt = new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$x0);
function $23d8f6d1574ae23f$var$qn(e) {
    return !!e.toHexString;
}
function $23d8f6d1574ae23f$var$rr(e) {
    return e.slice || (e.slice = function() {
        const t = Array.prototype.slice.call(arguments);
        return $23d8f6d1574ae23f$var$rr(new Uint8Array(Array.prototype.slice.apply(e, t)));
    }), e;
}
function $23d8f6d1574ae23f$var$M0(e) {
    return $23d8f6d1574ae23f$var$Qt(e) && !(e.length % 2) || $23d8f6d1574ae23f$var$ir(e);
}
function $23d8f6d1574ae23f$var$Kn(e) {
    return typeof e == "number" && e == e && e % 1 === 0;
}
function $23d8f6d1574ae23f$var$ir(e) {
    if (e == null) return !1;
    if (e.constructor === Uint8Array) return !0;
    if (typeof e == "string" || !$23d8f6d1574ae23f$var$Kn(e.length) || e.length < 0) return !1;
    for(let t = 0; t < e.length; t++){
        const r = e[t];
        if (!$23d8f6d1574ae23f$var$Kn(r) || r < 0 || r >= 256) return !1;
    }
    return !0;
}
function $23d8f6d1574ae23f$var$Ot(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $23d8f6d1574ae23f$var$Dt.checkSafeUint53(e, "invalid arrayify value");
        const r = [];
        for(; e;)r.unshift(e & 255), e = parseInt(String(e / 256));
        return r.length === 0 && r.push(0), $23d8f6d1574ae23f$var$rr(new Uint8Array(r));
    }
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $23d8f6d1574ae23f$var$qn(e) && (e = e.toHexString()), $23d8f6d1574ae23f$var$Qt(e)) {
        let r = e.substring(2);
        r.length % 2 && (t.hexPad === "left" ? r = "0" + r : t.hexPad === "right" ? r += "0" : $23d8f6d1574ae23f$var$Dt.throwArgumentError("hex data is odd-length", "value", e));
        const i = [];
        for(let n = 0; n < r.length; n += 2)i.push(parseInt(r.substring(n, n + 2), 16));
        return $23d8f6d1574ae23f$var$rr(new Uint8Array(i));
    }
    return $23d8f6d1574ae23f$var$ir(e) ? $23d8f6d1574ae23f$var$rr(new Uint8Array(e)) : $23d8f6d1574ae23f$var$Dt.throwArgumentError("invalid arrayify value", "value", e);
}
function $23d8f6d1574ae23f$var$E0(e) {
    const t = e.map((n)=>$23d8f6d1574ae23f$var$Ot(n)), r = t.reduce((n, o)=>n + o.length, 0), i = new Uint8Array(r);
    return t.reduce((n, o)=>(i.set(o, n), n + o.length), 0), $23d8f6d1574ae23f$var$rr(i);
}
function $23d8f6d1574ae23f$var$S0(e, t) {
    e = $23d8f6d1574ae23f$var$Ot(e), e.length > t && $23d8f6d1574ae23f$var$Dt.throwArgumentError("value out of range", "value", arguments[0]);
    const r = new Uint8Array(t);
    return r.set(e, t - e.length), $23d8f6d1574ae23f$var$rr(r);
}
function $23d8f6d1574ae23f$var$Qt(e, t) {
    return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
}
const $23d8f6d1574ae23f$var$bi = "0123456789abcdef";
function $23d8f6d1574ae23f$var$Kt(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $23d8f6d1574ae23f$var$Dt.checkSafeUint53(e, "invalid hexlify value");
        let r = "";
        for(; e;)r = $23d8f6d1574ae23f$var$bi[e & 15] + r, e = Math.floor(e / 16);
        return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
    }
    if (typeof e == "bigint") return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $23d8f6d1574ae23f$var$qn(e)) return e.toHexString();
    if ($23d8f6d1574ae23f$var$Qt(e)) return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : $23d8f6d1574ae23f$var$Dt.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
    if ($23d8f6d1574ae23f$var$ir(e)) {
        let r = "0x";
        for(let i = 0; i < e.length; i++){
            let n = e[i];
            r += $23d8f6d1574ae23f$var$bi[(n & 240) >> 4] + $23d8f6d1574ae23f$var$bi[n & 15];
        }
        return r;
    }
    return $23d8f6d1574ae23f$var$Dt.throwArgumentError("invalid hexlify value", "value", e);
}
function $23d8f6d1574ae23f$var$N0(e) {
    if (typeof e != "string") e = $23d8f6d1574ae23f$var$Kt(e);
    else if (!$23d8f6d1574ae23f$var$Qt(e) || e.length % 2) return null;
    return (e.length - 2) / 2;
}
function $23d8f6d1574ae23f$var$Hn(e, t, r) {
    return typeof e != "string" ? e = $23d8f6d1574ae23f$var$Kt(e) : (!$23d8f6d1574ae23f$var$Qt(e) || e.length % 2) && $23d8f6d1574ae23f$var$Dt.throwArgumentError("invalid hexData", "value", e), t = 2 + 2 * t, r != null ? "0x" + e.substring(t, 2 + 2 * r) : "0x" + e.substring(t);
}
function $23d8f6d1574ae23f$var$oe(e, t) {
    for(typeof e != "string" ? e = $23d8f6d1574ae23f$var$Kt(e) : $23d8f6d1574ae23f$var$Qt(e) || $23d8f6d1574ae23f$var$Dt.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && $23d8f6d1574ae23f$var$Dt.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2;)e = "0x0" + e.substring(2);
    return e;
}
function $23d8f6d1574ae23f$var$zn(e) {
    const t = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($23d8f6d1574ae23f$var$M0(e)) {
        let r = $23d8f6d1574ae23f$var$Ot(e);
        r.length === 64 ? (t.v = 27 + (r[32] >> 7), r[32] &= 127, t.r = $23d8f6d1574ae23f$var$Kt(r.slice(0, 32)), t.s = $23d8f6d1574ae23f$var$Kt(r.slice(32, 64))) : r.length === 65 ? (t.r = $23d8f6d1574ae23f$var$Kt(r.slice(0, 32)), t.s = $23d8f6d1574ae23f$var$Kt(r.slice(32, 64)), t.v = r[64]) : $23d8f6d1574ae23f$var$Dt.throwArgumentError("invalid signature string", "signature", e), t.v < 27 && (t.v === 0 || t.v === 1 ? t.v += 27 : $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature invalid v byte", "signature", e)), t.recoveryParam = 1 - t.v % 2, t.recoveryParam && (r[32] |= 128), t._vs = $23d8f6d1574ae23f$var$Kt(r.slice(32, 64));
    } else {
        if (t.r = e.r, t.s = e.s, t.v = e.v, t.recoveryParam = e.recoveryParam, t._vs = e._vs, t._vs != null) {
            const n = $23d8f6d1574ae23f$var$S0($23d8f6d1574ae23f$var$Ot(t._vs), 32);
            t._vs = $23d8f6d1574ae23f$var$Kt(n);
            const o = n[0] >= 128 ? 1 : 0;
            t.recoveryParam == null ? t.recoveryParam = o : t.recoveryParam !== o && $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature recoveryParam mismatch _vs", "signature", e), n[0] &= 127;
            const h = $23d8f6d1574ae23f$var$Kt(n);
            t.s == null ? t.s = h : t.s !== h && $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature v mismatch _vs", "signature", e);
        }
        if (t.recoveryParam == null) t.v == null ? $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature missing v and recoveryParam", "signature", e) : t.v === 0 || t.v === 1 ? t.recoveryParam = t.v : t.recoveryParam = 1 - t.v % 2;
        else if (t.v == null) t.v = 27 + t.recoveryParam;
        else {
            const n = t.v === 0 || t.v === 1 ? t.v : 1 - t.v % 2;
            t.recoveryParam !== n && $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature recoveryParam mismatch v", "signature", e);
        }
        t.r == null || !$23d8f6d1574ae23f$var$Qt(t.r) ? $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature missing or invalid r", "signature", e) : t.r = $23d8f6d1574ae23f$var$oe(t.r, 32), t.s == null || !$23d8f6d1574ae23f$var$Qt(t.s) ? $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature missing or invalid s", "signature", e) : t.s = $23d8f6d1574ae23f$var$oe(t.s, 32);
        const r = $23d8f6d1574ae23f$var$Ot(t.s);
        r[0] >= 128 && $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature s out of range", "signature", e), t.recoveryParam && (r[0] |= 128);
        const i = $23d8f6d1574ae23f$var$Kt(r);
        t._vs && ($23d8f6d1574ae23f$var$Qt(t._vs) || $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature invalid _vs", "signature", e), t._vs = $23d8f6d1574ae23f$var$oe(t._vs, 32)), t._vs == null ? t._vs = i : t._vs !== i && $23d8f6d1574ae23f$var$Dt.throwArgumentError("signature _vs mismatch v and s", "signature", e);
    }
    return t.yParityAndS = t._vs, t.compact = t.r + t.yParityAndS.substring(2), t;
}
function $23d8f6d1574ae23f$var$yi(e) {
    return "0x" + $23d8f6d1574ae23f$var$b0.keccak_256($23d8f6d1574ae23f$var$Ot(e));
}
var $23d8f6d1574ae23f$var$Ln = {
    exports: {}
}, $23d8f6d1574ae23f$var$I0 = {}, $23d8f6d1574ae23f$var$_0 = Object.freeze({
    __proto__: null,
    default: $23d8f6d1574ae23f$var$I0
}), $23d8f6d1574ae23f$var$B0 = $23d8f6d1574ae23f$var$A0($23d8f6d1574ae23f$var$_0);
(function(e) {
    (function(t, r) {
        function i(A, f) {
            if (!A) throw new Error(f || "Assertion failed");
        }
        function n(A, f) {
            A.super_ = f;
            var a = function() {};
            a.prototype = f.prototype, A.prototype = new a, A.prototype.constructor = A;
        }
        function o(A, f, a) {
            if (o.isBN(A)) return A;
            this.negative = 0, this.words = null, this.length = 0, this.red = null, A !== null && ((f === "le" || f === "be") && (a = f, f = 10), this._init(A || 0, f || 10, a || "be"));
        }
        typeof t == "object" ? t.exports = o : r.BN = o, o.BN = o, o.wordSize = 26;
        var h;
        try {
            typeof window < "u" && typeof window.Buffer < "u" ? h = window.Buffer : h = $23d8f6d1574ae23f$var$B0.Buffer;
        } catch  {}
        o.isBN = function(f) {
            return f instanceof o ? !0 : f !== null && typeof f == "object" && f.constructor.wordSize === o.wordSize && Array.isArray(f.words);
        }, o.max = function(f, a) {
            return f.cmp(a) > 0 ? f : a;
        }, o.min = function(f, a) {
            return f.cmp(a) < 0 ? f : a;
        }, o.prototype._init = function(f, a, c) {
            if (typeof f == "number") return this._initNumber(f, a, c);
            if (typeof f == "object") return this._initArray(f, a, c);
            a === "hex" && (a = 16), i(a === (a | 0) && a >= 2 && a <= 36), f = f.toString().replace(/\s+/g, "");
            var d = 0;
            f[0] === "-" && (d++, this.negative = 1), d < f.length && (a === 16 ? this._parseHex(f, d, c) : (this._parseBase(f, a, d), c === "le" && this._initArray(this.toArray(), a, c)));
        }, o.prototype._initNumber = function(f, a, c) {
            f < 0 && (this.negative = 1, f = -f), f < 67108864 ? (this.words = [
                f & 67108863
            ], this.length = 1) : f < 4503599627370496 ? (this.words = [
                f & 67108863,
                f / 67108864 & 67108863
            ], this.length = 2) : (i(f < 9007199254740992), this.words = [
                f & 67108863,
                f / 67108864 & 67108863,
                1
            ], this.length = 3), c === "le" && this._initArray(this.toArray(), a, c);
        }, o.prototype._initArray = function(f, a, c) {
            if (i(typeof f.length == "number"), f.length <= 0) return this.words = [
                0
            ], this.length = 1, this;
            this.length = Math.ceil(f.length / 3), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g, x, M = 0;
            if (c === "be") for(d = f.length - 1, g = 0; d >= 0; d -= 3)x = f[d] | f[d - 1] << 8 | f[d - 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            else if (c === "le") for(d = 0, g = 0; d < f.length; d += 3)x = f[d] | f[d + 1] << 8 | f[d + 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            return this._strip();
        };
        function p(A, f) {
            var a = A.charCodeAt(f);
            if (a >= 48 && a <= 57) return a - 48;
            if (a >= 65 && a <= 70) return a - 55;
            if (a >= 97 && a <= 102) return a - 87;
            i(!1, "Invalid character in " + A);
        }
        function b(A, f, a) {
            var c = p(A, a);
            return a - 1 >= f && (c |= p(A, a - 1) << 4), c;
        }
        o.prototype._parseHex = function(f, a, c) {
            this.length = Math.ceil((f.length - a) / 6), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g = 0, x = 0, M;
            if (c === "be") for(d = f.length - 1; d >= a; d -= 2)M = b(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            else {
                var l = f.length - a;
                for(d = l % 2 === 0 ? a + 1 : a; d < f.length; d += 2)M = b(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            }
            this._strip();
        };
        function m(A, f, a, c) {
            for(var d = 0, g = 0, x = Math.min(A.length, a), M = f; M < x; M++){
                var l = A.charCodeAt(M) - 48;
                d *= c, l >= 49 ? g = l - 49 + 10 : l >= 17 ? g = l - 17 + 10 : g = l, i(l >= 0 && g < c, "Invalid character"), d += g;
            }
            return d;
        }
        o.prototype._parseBase = function(f, a, c) {
            this.words = [
                0
            ], this.length = 1;
            for(var d = 0, g = 1; g <= 67108863; g *= a)d++;
            d--, g = g / a | 0;
            for(var x = f.length - c, M = x % d, l = Math.min(x, x - M) + c, s = 0, v = c; v < l; v += d)s = m(f, v, v + d, a), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            if (M !== 0) {
                var k = 1;
                for(s = m(f, v, f.length, a), v = 0; v < M; v++)k *= a;
                this.imuln(k), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            }
            this._strip();
        }, o.prototype.copy = function(f) {
            f.words = new Array(this.length);
            for(var a = 0; a < this.length; a++)f.words[a] = this.words[a];
            f.length = this.length, f.negative = this.negative, f.red = this.red;
        };
        function w(A, f) {
            A.words = f.words, A.length = f.length, A.negative = f.negative, A.red = f.red;
        }
        if (o.prototype._move = function(f) {
            w(f, this);
        }, o.prototype.clone = function() {
            var f = new o(null);
            return this.copy(f), f;
        }, o.prototype._expand = function(f) {
            for(; this.length < f;)this.words[this.length++] = 0;
            return this;
        }, o.prototype._strip = function() {
            for(; this.length > 1 && this.words[this.length - 1] === 0;)this.length--;
            return this._normSign();
        }, o.prototype._normSign = function() {
            return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
        }, typeof Symbol < "u" && typeof Symbol.for == "function") try {
            o.prototype[Symbol.for("nodejs.util.inspect.custom")] = y;
        } catch  {
            o.prototype.inspect = y;
        }
        else o.prototype.inspect = y;
        function y() {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        }
        var S = [
            "",
            "0",
            "00",
            "000",
            "0000",
            "00000",
            "000000",
            "0000000",
            "00000000",
            "000000000",
            "0000000000",
            "00000000000",
            "000000000000",
            "0000000000000",
            "00000000000000",
            "000000000000000",
            "0000000000000000",
            "00000000000000000",
            "000000000000000000",
            "0000000000000000000",
            "00000000000000000000",
            "000000000000000000000",
            "0000000000000000000000",
            "00000000000000000000000",
            "000000000000000000000000",
            "0000000000000000000000000"
        ], I = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ], N = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            1e7,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64e6,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            243e5,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        o.prototype.toString = function(f, a) {
            f = f || 10, a = a | 0 || 1;
            var c;
            if (f === 16 || f === "hex") {
                c = "";
                for(var d = 0, g = 0, x = 0; x < this.length; x++){
                    var M = this.words[x], l = ((M << d | g) & 16777215).toString(16);
                    g = M >>> 24 - d & 16777215, d += 2, d >= 26 && (d -= 26, x--), g !== 0 || x !== this.length - 1 ? c = S[6 - l.length] + l + c : c = l + c;
                }
                for(g !== 0 && (c = g.toString(16) + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            if (f === (f | 0) && f >= 2 && f <= 36) {
                var s = I[f], v = N[f];
                c = "";
                var k = this.clone();
                for(k.negative = 0; !k.isZero();){
                    var u = k.modrn(v).toString(f);
                    k = k.idivn(v), k.isZero() ? c = u + c : c = S[s - u.length] + u + c;
                }
                for(this.isZero() && (c = "0" + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            i(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function() {
            var f = this.words[0];
            return this.length === 2 ? f += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? f += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -f : f;
        }, o.prototype.toJSON = function() {
            return this.toString(16, 2);
        }, h && (o.prototype.toBuffer = function(f, a) {
            return this.toArrayLike(h, f, a);
        }), o.prototype.toArray = function(f, a) {
            return this.toArrayLike(Array, f, a);
        };
        var C = function(f, a) {
            return f.allocUnsafe ? f.allocUnsafe(a) : new f(a);
        };
        o.prototype.toArrayLike = function(f, a, c) {
            this._strip();
            var d = this.byteLength(), g = c || Math.max(1, d);
            i(d <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0");
            var x = C(f, g), M = a === "le" ? "LE" : "BE";
            return this["_toArrayLike" + M](x, d), x;
        }, o.prototype._toArrayLikeLE = function(f, a) {
            for(var c = 0, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c++] = M & 255, c < f.length && (f[c++] = M >> 8 & 255), c < f.length && (f[c++] = M >> 16 & 255), x === 6 ? (c < f.length && (f[c++] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c < f.length) for(f[c++] = d; c < f.length;)f[c++] = 0;
        }, o.prototype._toArrayLikeBE = function(f, a) {
            for(var c = f.length - 1, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c--] = M & 255, c >= 0 && (f[c--] = M >> 8 & 255), c >= 0 && (f[c--] = M >> 16 & 255), x === 6 ? (c >= 0 && (f[c--] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c >= 0) for(f[c--] = d; c >= 0;)f[c--] = 0;
        }, Math.clz32 ? o.prototype._countBits = function(f) {
            return 32 - Math.clz32(f);
        } : o.prototype._countBits = function(f) {
            var a = f, c = 0;
            return a >= 4096 && (c += 13, a >>>= 13), a >= 64 && (c += 7, a >>>= 7), a >= 8 && (c += 4, a >>>= 4), a >= 2 && (c += 2, a >>>= 2), c + a;
        }, o.prototype._zeroBits = function(f) {
            if (f === 0) return 26;
            var a = f, c = 0;
            return a & 8191 || (c += 13, a >>>= 13), a & 127 || (c += 7, a >>>= 7), a & 15 || (c += 4, a >>>= 4), a & 3 || (c += 2, a >>>= 2), a & 1 || c++, c;
        }, o.prototype.bitLength = function() {
            var f = this.words[this.length - 1], a = this._countBits(f);
            return (this.length - 1) * 26 + a;
        };
        function F(A) {
            for(var f = new Array(A.bitLength()), a = 0; a < f.length; a++){
                var c = a / 26 | 0, d = a % 26;
                f[a] = A.words[c] >>> d & 1;
            }
            return f;
        }
        o.prototype.zeroBits = function() {
            if (this.isZero()) return 0;
            for(var f = 0, a = 0; a < this.length; a++){
                var c = this._zeroBits(this.words[a]);
                if (f += c, c !== 26) break;
            }
            return f;
        }, o.prototype.byteLength = function() {
            return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function(f) {
            return this.negative !== 0 ? this.abs().inotn(f).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function(f) {
            return this.testn(f - 1) ? this.notn(f).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function() {
            return this.negative !== 0;
        }, o.prototype.neg = function() {
            return this.clone().ineg();
        }, o.prototype.ineg = function() {
            return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function(f) {
            for(; this.length < f.length;)this.words[this.length++] = 0;
            for(var a = 0; a < f.length; a++)this.words[a] = this.words[a] | f.words[a];
            return this._strip();
        }, o.prototype.ior = function(f) {
            return i((this.negative | f.negative) === 0), this.iuor(f);
        }, o.prototype.or = function(f) {
            return this.length > f.length ? this.clone().ior(f) : f.clone().ior(this);
        }, o.prototype.uor = function(f) {
            return this.length > f.length ? this.clone().iuor(f) : f.clone().iuor(this);
        }, o.prototype.iuand = function(f) {
            var a;
            this.length > f.length ? a = f : a = this;
            for(var c = 0; c < a.length; c++)this.words[c] = this.words[c] & f.words[c];
            return this.length = a.length, this._strip();
        }, o.prototype.iand = function(f) {
            return i((this.negative | f.negative) === 0), this.iuand(f);
        }, o.prototype.and = function(f) {
            return this.length > f.length ? this.clone().iand(f) : f.clone().iand(this);
        }, o.prototype.uand = function(f) {
            return this.length > f.length ? this.clone().iuand(f) : f.clone().iuand(this);
        }, o.prototype.iuxor = function(f) {
            var a, c;
            this.length > f.length ? (a = this, c = f) : (a = f, c = this);
            for(var d = 0; d < c.length; d++)this.words[d] = a.words[d] ^ c.words[d];
            if (this !== a) for(; d < a.length; d++)this.words[d] = a.words[d];
            return this.length = a.length, this._strip();
        }, o.prototype.ixor = function(f) {
            return i((this.negative | f.negative) === 0), this.iuxor(f);
        }, o.prototype.xor = function(f) {
            return this.length > f.length ? this.clone().ixor(f) : f.clone().ixor(this);
        }, o.prototype.uxor = function(f) {
            return this.length > f.length ? this.clone().iuxor(f) : f.clone().iuxor(this);
        }, o.prototype.inotn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = Math.ceil(f / 26) | 0, c = f % 26;
            this._expand(a), c > 0 && a--;
            for(var d = 0; d < a; d++)this.words[d] = ~this.words[d] & 67108863;
            return c > 0 && (this.words[d] = ~this.words[d] & 67108863 >> 26 - c), this._strip();
        }, o.prototype.notn = function(f) {
            return this.clone().inotn(f);
        }, o.prototype.setn = function(f, a) {
            i(typeof f == "number" && f >= 0);
            var c = f / 26 | 0, d = f % 26;
            return this._expand(c + 1), a ? this.words[c] = this.words[c] | 1 << d : this.words[c] = this.words[c] & ~(1 << d), this._strip();
        }, o.prototype.iadd = function(f) {
            var a;
            if (this.negative !== 0 && f.negative === 0) return this.negative = 0, a = this.isub(f), this.negative ^= 1, this._normSign();
            if (this.negative === 0 && f.negative !== 0) return f.negative = 0, a = this.isub(f), f.negative = 1, a._normSign();
            var c, d;
            this.length > f.length ? (c = this, d = f) : (c = f, d = this);
            for(var g = 0, x = 0; x < d.length; x++)a = (c.words[x] | 0) + (d.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            for(; g !== 0 && x < c.length; x++)a = (c.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            if (this.length = c.length, g !== 0) this.words[this.length] = g, this.length++;
            else if (c !== this) for(; x < c.length; x++)this.words[x] = c.words[x];
            return this;
        }, o.prototype.add = function(f) {
            var a;
            return f.negative !== 0 && this.negative === 0 ? (f.negative = 0, a = this.sub(f), f.negative ^= 1, a) : f.negative === 0 && this.negative !== 0 ? (this.negative = 0, a = f.sub(this), this.negative = 1, a) : this.length > f.length ? this.clone().iadd(f) : f.clone().iadd(this);
        }, o.prototype.isub = function(f) {
            if (f.negative !== 0) {
                f.negative = 0;
                var a = this.iadd(f);
                return f.negative = 1, a._normSign();
            } else if (this.negative !== 0) return this.negative = 0, this.iadd(f), this.negative = 1, this._normSign();
            var c = this.cmp(f);
            if (c === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            var d, g;
            c > 0 ? (d = this, g = f) : (d = f, g = this);
            for(var x = 0, M = 0; M < g.length; M++)a = (d.words[M] | 0) - (g.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            for(; x !== 0 && M < d.length; M++)a = (d.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            if (x === 0 && M < d.length && d !== this) for(; M < d.length; M++)this.words[M] = d.words[M];
            return this.length = Math.max(this.length, M), d !== this && (this.negative = 1), this._strip();
        }, o.prototype.sub = function(f) {
            return this.clone().isub(f);
        };
        function U(A, f, a) {
            a.negative = f.negative ^ A.negative;
            var c = A.length + f.length | 0;
            a.length = c, c = c - 1 | 0;
            var d = A.words[0] | 0, g = f.words[0] | 0, x = d * g, M = x & 67108863, l = x / 67108864 | 0;
            a.words[0] = M;
            for(var s = 1; s < c; s++){
                for(var v = l >>> 26, k = l & 67108863, u = Math.min(s, f.length - 1), E = Math.max(0, s - A.length + 1); E <= u; E++){
                    var _ = s - E | 0;
                    d = A.words[_] | 0, g = f.words[E] | 0, x = d * g + k, v += x / 67108864 | 0, k = x & 67108863;
                }
                a.words[s] = k | 0, l = v | 0;
            }
            return l !== 0 ? a.words[s] = l | 0 : a.length--, a._strip();
        }
        var J = function(f, a, c) {
            var d = f.words, g = a.words, x = c.words, M = 0, l, s, v, k = d[0] | 0, u = k & 8191, E = k >>> 13, _ = d[1] | 0, B = _ & 8191, R = _ >>> 13, T = d[2] | 0, P = T & 8191, O = T >>> 13, Ct = d[3] | 0, D = Ct & 8191, q = Ct >>> 13, De = d[4] | 0, X = De & 8191, Z = De >>> 13, Fe = d[5] | 0, $ = Fe & 8191, tt = Fe >>> 13, Te = d[6] | 0, et = Te & 8191, rt = Te >>> 13, Ue = d[7] | 0, it = Ue & 8191, nt = Ue >>> 13, ke = d[8] | 0, ft = ke & 8191, ot = ke >>> 13, qe = d[9] | 0, st = qe & 8191, at = qe >>> 13, Ke = g[0] | 0, ut = Ke & 8191, ht = Ke >>> 13, He = g[1] | 0, ct = He & 8191, lt = He >>> 13, ze = g[2] | 0, dt = ze & 8191, pt = ze >>> 13, Le = g[3] | 0, vt = Le & 8191, mt = Le >>> 13, je = g[4] | 0, gt = je & 8191, At = je >>> 13, Qe = g[5] | 0, bt = Qe & 8191, yt = Qe >>> 13, Je = g[6] | 0, wt = Je & 8191, xt = Je >>> 13, Ge = g[7] | 0, Mt = Ge & 8191, Et = Ge >>> 13, Ye = g[8] | 0, St = Ye & 8191, Nt = Ye >>> 13, Ve = g[9] | 0, It = Ve & 8191, _t = Ve >>> 13;
            c.negative = f.negative ^ a.negative, c.length = 19, l = Math.imul(u, ut), s = Math.imul(u, ht), s = s + Math.imul(E, ut) | 0, v = Math.imul(E, ht);
            var Me = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, l = Math.imul(B, ut), s = Math.imul(B, ht), s = s + Math.imul(R, ut) | 0, v = Math.imul(R, ht), l = l + Math.imul(u, ct) | 0, s = s + Math.imul(u, lt) | 0, s = s + Math.imul(E, ct) | 0, v = v + Math.imul(E, lt) | 0;
            var Ee = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, l = Math.imul(P, ut), s = Math.imul(P, ht), s = s + Math.imul(O, ut) | 0, v = Math.imul(O, ht), l = l + Math.imul(B, ct) | 0, s = s + Math.imul(B, lt) | 0, s = s + Math.imul(R, ct) | 0, v = v + Math.imul(R, lt) | 0, l = l + Math.imul(u, dt) | 0, s = s + Math.imul(u, pt) | 0, s = s + Math.imul(E, dt) | 0, v = v + Math.imul(E, pt) | 0;
            var Se = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, l = Math.imul(D, ut), s = Math.imul(D, ht), s = s + Math.imul(q, ut) | 0, v = Math.imul(q, ht), l = l + Math.imul(P, ct) | 0, s = s + Math.imul(P, lt) | 0, s = s + Math.imul(O, ct) | 0, v = v + Math.imul(O, lt) | 0, l = l + Math.imul(B, dt) | 0, s = s + Math.imul(B, pt) | 0, s = s + Math.imul(R, dt) | 0, v = v + Math.imul(R, pt) | 0, l = l + Math.imul(u, vt) | 0, s = s + Math.imul(u, mt) | 0, s = s + Math.imul(E, vt) | 0, v = v + Math.imul(E, mt) | 0;
            var Ne = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l = Math.imul(X, ut), s = Math.imul(X, ht), s = s + Math.imul(Z, ut) | 0, v = Math.imul(Z, ht), l = l + Math.imul(D, ct) | 0, s = s + Math.imul(D, lt) | 0, s = s + Math.imul(q, ct) | 0, v = v + Math.imul(q, lt) | 0, l = l + Math.imul(P, dt) | 0, s = s + Math.imul(P, pt) | 0, s = s + Math.imul(O, dt) | 0, v = v + Math.imul(O, pt) | 0, l = l + Math.imul(B, vt) | 0, s = s + Math.imul(B, mt) | 0, s = s + Math.imul(R, vt) | 0, v = v + Math.imul(R, mt) | 0, l = l + Math.imul(u, gt) | 0, s = s + Math.imul(u, At) | 0, s = s + Math.imul(E, gt) | 0, v = v + Math.imul(E, At) | 0;
            var Ie = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, l = Math.imul($, ut), s = Math.imul($, ht), s = s + Math.imul(tt, ut) | 0, v = Math.imul(tt, ht), l = l + Math.imul(X, ct) | 0, s = s + Math.imul(X, lt) | 0, s = s + Math.imul(Z, ct) | 0, v = v + Math.imul(Z, lt) | 0, l = l + Math.imul(D, dt) | 0, s = s + Math.imul(D, pt) | 0, s = s + Math.imul(q, dt) | 0, v = v + Math.imul(q, pt) | 0, l = l + Math.imul(P, vt) | 0, s = s + Math.imul(P, mt) | 0, s = s + Math.imul(O, vt) | 0, v = v + Math.imul(O, mt) | 0, l = l + Math.imul(B, gt) | 0, s = s + Math.imul(B, At) | 0, s = s + Math.imul(R, gt) | 0, v = v + Math.imul(R, At) | 0, l = l + Math.imul(u, bt) | 0, s = s + Math.imul(u, yt) | 0, s = s + Math.imul(E, bt) | 0, v = v + Math.imul(E, yt) | 0;
            var Wr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Wr >>> 26) | 0, Wr &= 67108863, l = Math.imul(et, ut), s = Math.imul(et, ht), s = s + Math.imul(rt, ut) | 0, v = Math.imul(rt, ht), l = l + Math.imul($, ct) | 0, s = s + Math.imul($, lt) | 0, s = s + Math.imul(tt, ct) | 0, v = v + Math.imul(tt, lt) | 0, l = l + Math.imul(X, dt) | 0, s = s + Math.imul(X, pt) | 0, s = s + Math.imul(Z, dt) | 0, v = v + Math.imul(Z, pt) | 0, l = l + Math.imul(D, vt) | 0, s = s + Math.imul(D, mt) | 0, s = s + Math.imul(q, vt) | 0, v = v + Math.imul(q, mt) | 0, l = l + Math.imul(P, gt) | 0, s = s + Math.imul(P, At) | 0, s = s + Math.imul(O, gt) | 0, v = v + Math.imul(O, At) | 0, l = l + Math.imul(B, bt) | 0, s = s + Math.imul(B, yt) | 0, s = s + Math.imul(R, bt) | 0, v = v + Math.imul(R, yt) | 0, l = l + Math.imul(u, wt) | 0, s = s + Math.imul(u, xt) | 0, s = s + Math.imul(E, wt) | 0, v = v + Math.imul(E, xt) | 0;
            var Xr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, l = Math.imul(it, ut), s = Math.imul(it, ht), s = s + Math.imul(nt, ut) | 0, v = Math.imul(nt, ht), l = l + Math.imul(et, ct) | 0, s = s + Math.imul(et, lt) | 0, s = s + Math.imul(rt, ct) | 0, v = v + Math.imul(rt, lt) | 0, l = l + Math.imul($, dt) | 0, s = s + Math.imul($, pt) | 0, s = s + Math.imul(tt, dt) | 0, v = v + Math.imul(tt, pt) | 0, l = l + Math.imul(X, vt) | 0, s = s + Math.imul(X, mt) | 0, s = s + Math.imul(Z, vt) | 0, v = v + Math.imul(Z, mt) | 0, l = l + Math.imul(D, gt) | 0, s = s + Math.imul(D, At) | 0, s = s + Math.imul(q, gt) | 0, v = v + Math.imul(q, At) | 0, l = l + Math.imul(P, bt) | 0, s = s + Math.imul(P, yt) | 0, s = s + Math.imul(O, bt) | 0, v = v + Math.imul(O, yt) | 0, l = l + Math.imul(B, wt) | 0, s = s + Math.imul(B, xt) | 0, s = s + Math.imul(R, wt) | 0, v = v + Math.imul(R, xt) | 0, l = l + Math.imul(u, Mt) | 0, s = s + Math.imul(u, Et) | 0, s = s + Math.imul(E, Mt) | 0, v = v + Math.imul(E, Et) | 0;
            var Zr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, l = Math.imul(ft, ut), s = Math.imul(ft, ht), s = s + Math.imul(ot, ut) | 0, v = Math.imul(ot, ht), l = l + Math.imul(it, ct) | 0, s = s + Math.imul(it, lt) | 0, s = s + Math.imul(nt, ct) | 0, v = v + Math.imul(nt, lt) | 0, l = l + Math.imul(et, dt) | 0, s = s + Math.imul(et, pt) | 0, s = s + Math.imul(rt, dt) | 0, v = v + Math.imul(rt, pt) | 0, l = l + Math.imul($, vt) | 0, s = s + Math.imul($, mt) | 0, s = s + Math.imul(tt, vt) | 0, v = v + Math.imul(tt, mt) | 0, l = l + Math.imul(X, gt) | 0, s = s + Math.imul(X, At) | 0, s = s + Math.imul(Z, gt) | 0, v = v + Math.imul(Z, At) | 0, l = l + Math.imul(D, bt) | 0, s = s + Math.imul(D, yt) | 0, s = s + Math.imul(q, bt) | 0, v = v + Math.imul(q, yt) | 0, l = l + Math.imul(P, wt) | 0, s = s + Math.imul(P, xt) | 0, s = s + Math.imul(O, wt) | 0, v = v + Math.imul(O, xt) | 0, l = l + Math.imul(B, Mt) | 0, s = s + Math.imul(B, Et) | 0, s = s + Math.imul(R, Mt) | 0, v = v + Math.imul(R, Et) | 0, l = l + Math.imul(u, St) | 0, s = s + Math.imul(u, Nt) | 0, s = s + Math.imul(E, St) | 0, v = v + Math.imul(E, Nt) | 0;
            var $r = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, l = Math.imul(st, ut), s = Math.imul(st, ht), s = s + Math.imul(at, ut) | 0, v = Math.imul(at, ht), l = l + Math.imul(ft, ct) | 0, s = s + Math.imul(ft, lt) | 0, s = s + Math.imul(ot, ct) | 0, v = v + Math.imul(ot, lt) | 0, l = l + Math.imul(it, dt) | 0, s = s + Math.imul(it, pt) | 0, s = s + Math.imul(nt, dt) | 0, v = v + Math.imul(nt, pt) | 0, l = l + Math.imul(et, vt) | 0, s = s + Math.imul(et, mt) | 0, s = s + Math.imul(rt, vt) | 0, v = v + Math.imul(rt, mt) | 0, l = l + Math.imul($, gt) | 0, s = s + Math.imul($, At) | 0, s = s + Math.imul(tt, gt) | 0, v = v + Math.imul(tt, At) | 0, l = l + Math.imul(X, bt) | 0, s = s + Math.imul(X, yt) | 0, s = s + Math.imul(Z, bt) | 0, v = v + Math.imul(Z, yt) | 0, l = l + Math.imul(D, wt) | 0, s = s + Math.imul(D, xt) | 0, s = s + Math.imul(q, wt) | 0, v = v + Math.imul(q, xt) | 0, l = l + Math.imul(P, Mt) | 0, s = s + Math.imul(P, Et) | 0, s = s + Math.imul(O, Mt) | 0, v = v + Math.imul(O, Et) | 0, l = l + Math.imul(B, St) | 0, s = s + Math.imul(B, Nt) | 0, s = s + Math.imul(R, St) | 0, v = v + Math.imul(R, Nt) | 0, l = l + Math.imul(u, It) | 0, s = s + Math.imul(u, _t) | 0, s = s + Math.imul(E, It) | 0, v = v + Math.imul(E, _t) | 0;
            var ti = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ti >>> 26) | 0, ti &= 67108863, l = Math.imul(st, ct), s = Math.imul(st, lt), s = s + Math.imul(at, ct) | 0, v = Math.imul(at, lt), l = l + Math.imul(ft, dt) | 0, s = s + Math.imul(ft, pt) | 0, s = s + Math.imul(ot, dt) | 0, v = v + Math.imul(ot, pt) | 0, l = l + Math.imul(it, vt) | 0, s = s + Math.imul(it, mt) | 0, s = s + Math.imul(nt, vt) | 0, v = v + Math.imul(nt, mt) | 0, l = l + Math.imul(et, gt) | 0, s = s + Math.imul(et, At) | 0, s = s + Math.imul(rt, gt) | 0, v = v + Math.imul(rt, At) | 0, l = l + Math.imul($, bt) | 0, s = s + Math.imul($, yt) | 0, s = s + Math.imul(tt, bt) | 0, v = v + Math.imul(tt, yt) | 0, l = l + Math.imul(X, wt) | 0, s = s + Math.imul(X, xt) | 0, s = s + Math.imul(Z, wt) | 0, v = v + Math.imul(Z, xt) | 0, l = l + Math.imul(D, Mt) | 0, s = s + Math.imul(D, Et) | 0, s = s + Math.imul(q, Mt) | 0, v = v + Math.imul(q, Et) | 0, l = l + Math.imul(P, St) | 0, s = s + Math.imul(P, Nt) | 0, s = s + Math.imul(O, St) | 0, v = v + Math.imul(O, Nt) | 0, l = l + Math.imul(B, It) | 0, s = s + Math.imul(B, _t) | 0, s = s + Math.imul(R, It) | 0, v = v + Math.imul(R, _t) | 0;
            var ei = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, l = Math.imul(st, dt), s = Math.imul(st, pt), s = s + Math.imul(at, dt) | 0, v = Math.imul(at, pt), l = l + Math.imul(ft, vt) | 0, s = s + Math.imul(ft, mt) | 0, s = s + Math.imul(ot, vt) | 0, v = v + Math.imul(ot, mt) | 0, l = l + Math.imul(it, gt) | 0, s = s + Math.imul(it, At) | 0, s = s + Math.imul(nt, gt) | 0, v = v + Math.imul(nt, At) | 0, l = l + Math.imul(et, bt) | 0, s = s + Math.imul(et, yt) | 0, s = s + Math.imul(rt, bt) | 0, v = v + Math.imul(rt, yt) | 0, l = l + Math.imul($, wt) | 0, s = s + Math.imul($, xt) | 0, s = s + Math.imul(tt, wt) | 0, v = v + Math.imul(tt, xt) | 0, l = l + Math.imul(X, Mt) | 0, s = s + Math.imul(X, Et) | 0, s = s + Math.imul(Z, Mt) | 0, v = v + Math.imul(Z, Et) | 0, l = l + Math.imul(D, St) | 0, s = s + Math.imul(D, Nt) | 0, s = s + Math.imul(q, St) | 0, v = v + Math.imul(q, Nt) | 0, l = l + Math.imul(P, It) | 0, s = s + Math.imul(P, _t) | 0, s = s + Math.imul(O, It) | 0, v = v + Math.imul(O, _t) | 0;
            var ri = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ri >>> 26) | 0, ri &= 67108863, l = Math.imul(st, vt), s = Math.imul(st, mt), s = s + Math.imul(at, vt) | 0, v = Math.imul(at, mt), l = l + Math.imul(ft, gt) | 0, s = s + Math.imul(ft, At) | 0, s = s + Math.imul(ot, gt) | 0, v = v + Math.imul(ot, At) | 0, l = l + Math.imul(it, bt) | 0, s = s + Math.imul(it, yt) | 0, s = s + Math.imul(nt, bt) | 0, v = v + Math.imul(nt, yt) | 0, l = l + Math.imul(et, wt) | 0, s = s + Math.imul(et, xt) | 0, s = s + Math.imul(rt, wt) | 0, v = v + Math.imul(rt, xt) | 0, l = l + Math.imul($, Mt) | 0, s = s + Math.imul($, Et) | 0, s = s + Math.imul(tt, Mt) | 0, v = v + Math.imul(tt, Et) | 0, l = l + Math.imul(X, St) | 0, s = s + Math.imul(X, Nt) | 0, s = s + Math.imul(Z, St) | 0, v = v + Math.imul(Z, Nt) | 0, l = l + Math.imul(D, It) | 0, s = s + Math.imul(D, _t) | 0, s = s + Math.imul(q, It) | 0, v = v + Math.imul(q, _t) | 0;
            var ii = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, l = Math.imul(st, gt), s = Math.imul(st, At), s = s + Math.imul(at, gt) | 0, v = Math.imul(at, At), l = l + Math.imul(ft, bt) | 0, s = s + Math.imul(ft, yt) | 0, s = s + Math.imul(ot, bt) | 0, v = v + Math.imul(ot, yt) | 0, l = l + Math.imul(it, wt) | 0, s = s + Math.imul(it, xt) | 0, s = s + Math.imul(nt, wt) | 0, v = v + Math.imul(nt, xt) | 0, l = l + Math.imul(et, Mt) | 0, s = s + Math.imul(et, Et) | 0, s = s + Math.imul(rt, Mt) | 0, v = v + Math.imul(rt, Et) | 0, l = l + Math.imul($, St) | 0, s = s + Math.imul($, Nt) | 0, s = s + Math.imul(tt, St) | 0, v = v + Math.imul(tt, Nt) | 0, l = l + Math.imul(X, It) | 0, s = s + Math.imul(X, _t) | 0, s = s + Math.imul(Z, It) | 0, v = v + Math.imul(Z, _t) | 0;
            var ni = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ni >>> 26) | 0, ni &= 67108863, l = Math.imul(st, bt), s = Math.imul(st, yt), s = s + Math.imul(at, bt) | 0, v = Math.imul(at, yt), l = l + Math.imul(ft, wt) | 0, s = s + Math.imul(ft, xt) | 0, s = s + Math.imul(ot, wt) | 0, v = v + Math.imul(ot, xt) | 0, l = l + Math.imul(it, Mt) | 0, s = s + Math.imul(it, Et) | 0, s = s + Math.imul(nt, Mt) | 0, v = v + Math.imul(nt, Et) | 0, l = l + Math.imul(et, St) | 0, s = s + Math.imul(et, Nt) | 0, s = s + Math.imul(rt, St) | 0, v = v + Math.imul(rt, Nt) | 0, l = l + Math.imul($, It) | 0, s = s + Math.imul($, _t) | 0, s = s + Math.imul(tt, It) | 0, v = v + Math.imul(tt, _t) | 0;
            var fi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (fi >>> 26) | 0, fi &= 67108863, l = Math.imul(st, wt), s = Math.imul(st, xt), s = s + Math.imul(at, wt) | 0, v = Math.imul(at, xt), l = l + Math.imul(ft, Mt) | 0, s = s + Math.imul(ft, Et) | 0, s = s + Math.imul(ot, Mt) | 0, v = v + Math.imul(ot, Et) | 0, l = l + Math.imul(it, St) | 0, s = s + Math.imul(it, Nt) | 0, s = s + Math.imul(nt, St) | 0, v = v + Math.imul(nt, Nt) | 0, l = l + Math.imul(et, It) | 0, s = s + Math.imul(et, _t) | 0, s = s + Math.imul(rt, It) | 0, v = v + Math.imul(rt, _t) | 0;
            var oi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, l = Math.imul(st, Mt), s = Math.imul(st, Et), s = s + Math.imul(at, Mt) | 0, v = Math.imul(at, Et), l = l + Math.imul(ft, St) | 0, s = s + Math.imul(ft, Nt) | 0, s = s + Math.imul(ot, St) | 0, v = v + Math.imul(ot, Nt) | 0, l = l + Math.imul(it, It) | 0, s = s + Math.imul(it, _t) | 0, s = s + Math.imul(nt, It) | 0, v = v + Math.imul(nt, _t) | 0;
            var si = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (si >>> 26) | 0, si &= 67108863, l = Math.imul(st, St), s = Math.imul(st, Nt), s = s + Math.imul(at, St) | 0, v = Math.imul(at, Nt), l = l + Math.imul(ft, It) | 0, s = s + Math.imul(ft, _t) | 0, s = s + Math.imul(ot, It) | 0, v = v + Math.imul(ot, _t) | 0;
            var ai = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, l = Math.imul(st, It), s = Math.imul(st, _t), s = s + Math.imul(at, It) | 0, v = Math.imul(at, _t);
            var ui = (M + l | 0) + ((s & 8191) << 13) | 0;
            return M = (v + (s >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, x[0] = Me, x[1] = Ee, x[2] = Se, x[3] = Ne, x[4] = Ie, x[5] = Wr, x[6] = Xr, x[7] = Zr, x[8] = $r, x[9] = ti, x[10] = ei, x[11] = ri, x[12] = ii, x[13] = ni, x[14] = fi, x[15] = oi, x[16] = si, x[17] = ai, x[18] = ui, M !== 0 && (x[19] = M, c.length++), c;
        };
        Math.imul || (J = U);
        function Bt(A, f, a) {
            a.negative = f.negative ^ A.negative, a.length = A.length + f.length;
            for(var c = 0, d = 0, g = 0; g < a.length - 1; g++){
                var x = d;
                d = 0;
                for(var M = c & 67108863, l = Math.min(g, f.length - 1), s = Math.max(0, g - A.length + 1); s <= l; s++){
                    var v = g - s, k = A.words[v] | 0, u = f.words[s] | 0, E = k * u, _ = E & 67108863;
                    x = x + (E / 67108864 | 0) | 0, _ = _ + M | 0, M = _ & 67108863, x = x + (_ >>> 26) | 0, d += x >>> 26, x &= 67108863;
                }
                a.words[g] = M, c = x, x = d;
            }
            return c !== 0 ? a.words[g] = c : a.length--, a._strip();
        }
        function G(A, f, a) {
            return Bt(A, f, a);
        }
        o.prototype.mulTo = function(f, a) {
            var c, d = this.length + f.length;
            return this.length === 10 && f.length === 10 ? c = J(this, f, a) : d < 63 ? c = U(this, f, a) : d < 1024 ? c = Bt(this, f, a) : c = G(this, f, a), c;
        }, o.prototype.mul = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), this.mulTo(f, a);
        }, o.prototype.mulf = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), G(this, f, a);
        }, o.prototype.imul = function(f) {
            return this.clone().mulTo(f, this);
        }, o.prototype.imuln = function(f) {
            var a = f < 0;
            a && (f = -f), i(typeof f == "number"), i(f < 67108864);
            for(var c = 0, d = 0; d < this.length; d++){
                var g = (this.words[d] | 0) * f, x = (g & 67108863) + (c & 67108863);
                c >>= 26, c += g / 67108864 | 0, c += x >>> 26, this.words[d] = x & 67108863;
            }
            return c !== 0 && (this.words[d] = c, this.length++), a ? this.ineg() : this;
        }, o.prototype.muln = function(f) {
            return this.clone().imuln(f);
        }, o.prototype.sqr = function() {
            return this.mul(this);
        }, o.prototype.isqr = function() {
            return this.imul(this.clone());
        }, o.prototype.pow = function(f) {
            var a = F(f);
            if (a.length === 0) return new o(1);
            for(var c = this, d = 0; d < a.length && a[d] === 0; d++, c = c.sqr());
            if (++d < a.length) for(var g = c.sqr(); d < a.length; d++, g = g.sqr())a[d] !== 0 && (c = c.mul(g));
            return c;
        }, o.prototype.iushln = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 67108863 >>> 26 - a << 26 - a, g;
            if (a !== 0) {
                var x = 0;
                for(g = 0; g < this.length; g++){
                    var M = this.words[g] & d, l = (this.words[g] | 0) - M << a;
                    this.words[g] = l | x, x = M >>> 26 - a;
                }
                x && (this.words[g] = x, this.length++);
            }
            if (c !== 0) {
                for(g = this.length - 1; g >= 0; g--)this.words[g + c] = this.words[g];
                for(g = 0; g < c; g++)this.words[g] = 0;
                this.length += c;
            }
            return this._strip();
        }, o.prototype.ishln = function(f) {
            return i(this.negative === 0), this.iushln(f);
        }, o.prototype.iushrn = function(f, a, c) {
            i(typeof f == "number" && f >= 0);
            var d;
            a ? d = (a - a % 26) / 26 : d = 0;
            var g = f % 26, x = Math.min((f - g) / 26, this.length), M = 67108863 ^ 67108863 >>> g << g, l = c;
            if (d -= x, d = Math.max(0, d), l) {
                for(var s = 0; s < x; s++)l.words[s] = this.words[s];
                l.length = x;
            }
            if (x !== 0) {
                if (this.length > x) for(this.length -= x, s = 0; s < this.length; s++)this.words[s] = this.words[s + x];
                else this.words[0] = 0, this.length = 1;
            }
            var v = 0;
            for(s = this.length - 1; s >= 0 && (v !== 0 || s >= d); s--){
                var k = this.words[s] | 0;
                this.words[s] = v << 26 - g | k >>> g, v = k & M;
            }
            return l && v !== 0 && (l.words[l.length++] = v), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
        }, o.prototype.ishrn = function(f, a, c) {
            return i(this.negative === 0), this.iushrn(f, a, c);
        }, o.prototype.shln = function(f) {
            return this.clone().ishln(f);
        }, o.prototype.ushln = function(f) {
            return this.clone().iushln(f);
        }, o.prototype.shrn = function(f) {
            return this.clone().ishrn(f);
        }, o.prototype.ushrn = function(f) {
            return this.clone().iushrn(f);
        }, o.prototype.testn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return !1;
            var g = this.words[c];
            return !!(g & d);
        }, o.prototype.imaskn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26;
            if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= c) return this;
            if (a !== 0 && c++, this.length = Math.min(c, this.length), a !== 0) {
                var d = 67108863 ^ 67108863 >>> a << a;
                this.words[this.length - 1] &= d;
            }
            return this._strip();
        }, o.prototype.maskn = function(f) {
            return this.clone().imaskn(f);
        }, o.prototype.iaddn = function(f) {
            return i(typeof f == "number"), i(f < 67108864), f < 0 ? this.isubn(-f) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= f ? (this.words[0] = f - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(f), this.negative = 1, this) : this._iaddn(f);
        }, o.prototype._iaddn = function(f) {
            this.words[0] += f;
            for(var a = 0; a < this.length && this.words[a] >= 67108864; a++)this.words[a] -= 67108864, a === this.length - 1 ? this.words[a + 1] = 1 : this.words[a + 1]++;
            return this.length = Math.max(this.length, a + 1), this;
        }, o.prototype.isubn = function(f) {
            if (i(typeof f == "number"), i(f < 67108864), f < 0) return this.iaddn(-f);
            if (this.negative !== 0) return this.negative = 0, this.iaddn(f), this.negative = 1, this;
            if (this.words[0] -= f, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
            else for(var a = 0; a < this.length && this.words[a] < 0; a++)this.words[a] += 67108864, this.words[a + 1] -= 1;
            return this._strip();
        }, o.prototype.addn = function(f) {
            return this.clone().iaddn(f);
        }, o.prototype.subn = function(f) {
            return this.clone().isubn(f);
        }, o.prototype.iabs = function() {
            return this.negative = 0, this;
        }, o.prototype.abs = function() {
            return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function(f, a, c) {
            var d = f.length + c, g;
            this._expand(d);
            var x, M = 0;
            for(g = 0; g < f.length; g++){
                x = (this.words[g + c] | 0) + M;
                var l = (f.words[g] | 0) * a;
                x -= l & 67108863, M = (x >> 26) - (l / 67108864 | 0), this.words[g + c] = x & 67108863;
            }
            for(; g < this.length - c; g++)x = (this.words[g + c] | 0) + M, M = x >> 26, this.words[g + c] = x & 67108863;
            if (M === 0) return this._strip();
            for(i(M === -1), M = 0, g = 0; g < this.length; g++)x = -(this.words[g] | 0) + M, M = x >> 26, this.words[g] = x & 67108863;
            return this.negative = 1, this._strip();
        }, o.prototype._wordDiv = function(f, a) {
            var c = this.length - f.length, d = this.clone(), g = f, x = g.words[g.length - 1] | 0, M = this._countBits(x);
            c = 26 - M, c !== 0 && (g = g.ushln(c), d.iushln(c), x = g.words[g.length - 1] | 0);
            var l = d.length - g.length, s;
            if (a !== "mod") {
                s = new o(null), s.length = l + 1, s.words = new Array(s.length);
                for(var v = 0; v < s.length; v++)s.words[v] = 0;
            }
            var k = d.clone()._ishlnsubmul(g, 1, l);
            k.negative === 0 && (d = k, s && (s.words[l] = 1));
            for(var u = l - 1; u >= 0; u--){
                var E = (d.words[g.length + u] | 0) * 67108864 + (d.words[g.length + u - 1] | 0);
                for(E = Math.min(E / x | 0, 67108863), d._ishlnsubmul(g, E, u); d.negative !== 0;)E--, d.negative = 0, d._ishlnsubmul(g, 1, u), d.isZero() || (d.negative ^= 1);
                s && (s.words[u] = E);
            }
            return s && s._strip(), d._strip(), a !== "div" && c !== 0 && d.iushrn(c), {
                div: s || null,
                mod: d
            };
        }, o.prototype.divmod = function(f, a, c) {
            if (i(!f.isZero()), this.isZero()) return {
                div: new o(0),
                mod: new o(0)
            };
            var d, g, x;
            return this.negative !== 0 && f.negative === 0 ? (x = this.neg().divmod(f, a), a !== "mod" && (d = x.div.neg()), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.iadd(f)), {
                div: d,
                mod: g
            }) : this.negative === 0 && f.negative !== 0 ? (x = this.divmod(f.neg(), a), a !== "mod" && (d = x.div.neg()), {
                div: d,
                mod: x.mod
            }) : this.negative & f.negative ? (x = this.neg().divmod(f.neg(), a), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.isub(f)), {
                div: x.div,
                mod: g
            }) : f.length > this.length || this.cmp(f) < 0 ? {
                div: new o(0),
                mod: this
            } : f.length === 1 ? a === "div" ? {
                div: this.divn(f.words[0]),
                mod: null
            } : a === "mod" ? {
                div: null,
                mod: new o(this.modrn(f.words[0]))
            } : {
                div: this.divn(f.words[0]),
                mod: new o(this.modrn(f.words[0]))
            } : this._wordDiv(f, a);
        }, o.prototype.div = function(f) {
            return this.divmod(f, "div", !1).div;
        }, o.prototype.mod = function(f) {
            return this.divmod(f, "mod", !1).mod;
        }, o.prototype.umod = function(f) {
            return this.divmod(f, "mod", !0).mod;
        }, o.prototype.divRound = function(f) {
            var a = this.divmod(f);
            if (a.mod.isZero()) return a.div;
            var c = a.div.negative !== 0 ? a.mod.isub(f) : a.mod, d = f.ushrn(1), g = f.andln(1), x = c.cmp(d);
            return x < 0 || g === 1 && x === 0 ? a.div : a.div.negative !== 0 ? a.div.isubn(1) : a.div.iaddn(1);
        }, o.prototype.modrn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 67108864 % f, d = 0, g = this.length - 1; g >= 0; g--)d = (c * d + (this.words[g] | 0)) % f;
            return a ? -d : d;
        }, o.prototype.modn = function(f) {
            return this.modrn(f);
        }, o.prototype.idivn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 0, d = this.length - 1; d >= 0; d--){
                var g = (this.words[d] | 0) + c * 67108864;
                this.words[d] = g / f | 0, c = g % f;
            }
            return this._strip(), a ? this.ineg() : this;
        }, o.prototype.divn = function(f) {
            return this.clone().idivn(f);
        }, o.prototype.egcd = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = new o(0), M = new o(1), l = 0; a.isEven() && c.isEven();)a.iushrn(1), c.iushrn(1), ++l;
            for(var s = c.clone(), v = a.clone(); !a.isZero();){
                for(var k = 0, u = 1; !(a.words[0] & u) && k < 26; ++k, u <<= 1);
                if (k > 0) for(a.iushrn(k); k-- > 0;)(d.isOdd() || g.isOdd()) && (d.iadd(s), g.isub(v)), d.iushrn(1), g.iushrn(1);
                for(var E = 0, _ = 1; !(c.words[0] & _) && E < 26; ++E, _ <<= 1);
                if (E > 0) for(c.iushrn(E); E-- > 0;)(x.isOdd() || M.isOdd()) && (x.iadd(s), M.isub(v)), x.iushrn(1), M.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(x), g.isub(M)) : (c.isub(a), x.isub(d), M.isub(g));
            }
            return {
                a: x,
                b: M,
                gcd: c.iushln(l)
            };
        }, o.prototype._invmp = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = c.clone(); a.cmpn(1) > 0 && c.cmpn(1) > 0;){
                for(var M = 0, l = 1; !(a.words[0] & l) && M < 26; ++M, l <<= 1);
                if (M > 0) for(a.iushrn(M); M-- > 0;)d.isOdd() && d.iadd(x), d.iushrn(1);
                for(var s = 0, v = 1; !(c.words[0] & v) && s < 26; ++s, v <<= 1);
                if (s > 0) for(c.iushrn(s); s-- > 0;)g.isOdd() && g.iadd(x), g.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(g)) : (c.isub(a), g.isub(d));
            }
            var k;
            return a.cmpn(1) === 0 ? k = d : k = g, k.cmpn(0) < 0 && k.iadd(f), k;
        }, o.prototype.gcd = function(f) {
            if (this.isZero()) return f.abs();
            if (f.isZero()) return this.abs();
            var a = this.clone(), c = f.clone();
            a.negative = 0, c.negative = 0;
            for(var d = 0; a.isEven() && c.isEven(); d++)a.iushrn(1), c.iushrn(1);
            do {
                for(; a.isEven();)a.iushrn(1);
                for(; c.isEven();)c.iushrn(1);
                var g = a.cmp(c);
                if (g < 0) {
                    var x = a;
                    a = c, c = x;
                } else if (g === 0 || c.cmpn(1) === 0) break;
                a.isub(c);
            }while (!0);
            return c.iushln(d);
        }, o.prototype.invm = function(f) {
            return this.egcd(f).a.umod(f);
        }, o.prototype.isEven = function() {
            return (this.words[0] & 1) === 0;
        }, o.prototype.isOdd = function() {
            return (this.words[0] & 1) === 1;
        }, o.prototype.andln = function(f) {
            return this.words[0] & f;
        }, o.prototype.bincn = function(f) {
            i(typeof f == "number");
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return this._expand(c + 1), this.words[c] |= d, this;
            for(var g = d, x = c; g !== 0 && x < this.length; x++){
                var M = this.words[x] | 0;
                M += g, g = M >>> 26, M &= 67108863, this.words[x] = M;
            }
            return g !== 0 && (this.words[x] = g, this.length++), this;
        }, o.prototype.isZero = function() {
            return this.length === 1 && this.words[0] === 0;
        }, o.prototype.cmpn = function(f) {
            var a = f < 0;
            if (this.negative !== 0 && !a) return -1;
            if (this.negative === 0 && a) return 1;
            this._strip();
            var c;
            if (this.length > 1) c = 1;
            else {
                a && (f = -f), i(f <= 67108863, "Number is too big");
                var d = this.words[0] | 0;
                c = d === f ? 0 : d < f ? -1 : 1;
            }
            return this.negative !== 0 ? -c | 0 : c;
        }, o.prototype.cmp = function(f) {
            if (this.negative !== 0 && f.negative === 0) return -1;
            if (this.negative === 0 && f.negative !== 0) return 1;
            var a = this.ucmp(f);
            return this.negative !== 0 ? -a | 0 : a;
        }, o.prototype.ucmp = function(f) {
            if (this.length > f.length) return 1;
            if (this.length < f.length) return -1;
            for(var a = 0, c = this.length - 1; c >= 0; c--){
                var d = this.words[c] | 0, g = f.words[c] | 0;
                if (d !== g) {
                    d < g ? a = -1 : d > g && (a = 1);
                    break;
                }
            }
            return a;
        }, o.prototype.gtn = function(f) {
            return this.cmpn(f) === 1;
        }, o.prototype.gt = function(f) {
            return this.cmp(f) === 1;
        }, o.prototype.gten = function(f) {
            return this.cmpn(f) >= 0;
        }, o.prototype.gte = function(f) {
            return this.cmp(f) >= 0;
        }, o.prototype.ltn = function(f) {
            return this.cmpn(f) === -1;
        }, o.prototype.lt = function(f) {
            return this.cmp(f) === -1;
        }, o.prototype.lten = function(f) {
            return this.cmpn(f) <= 0;
        }, o.prototype.lte = function(f) {
            return this.cmp(f) <= 0;
        }, o.prototype.eqn = function(f) {
            return this.cmpn(f) === 0;
        }, o.prototype.eq = function(f) {
            return this.cmp(f) === 0;
        }, o.red = function(f) {
            return new Y(f);
        }, o.prototype.toRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), f.convertTo(this)._forceRed(f);
        }, o.prototype.fromRed = function() {
            return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function(f) {
            return this.red = f, this;
        }, o.prototype.forceRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), this._forceRed(f);
        }, o.prototype.redAdd = function(f) {
            return i(this.red, "redAdd works only with red numbers"), this.red.add(this, f);
        }, o.prototype.redIAdd = function(f) {
            return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, f);
        }, o.prototype.redSub = function(f) {
            return i(this.red, "redSub works only with red numbers"), this.red.sub(this, f);
        }, o.prototype.redISub = function(f) {
            return i(this.red, "redISub works only with red numbers"), this.red.isub(this, f);
        }, o.prototype.redShl = function(f) {
            return i(this.red, "redShl works only with red numbers"), this.red.shl(this, f);
        }, o.prototype.redMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.mul(this, f);
        }, o.prototype.redIMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.imul(this, f);
        }, o.prototype.redSqr = function() {
            return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function() {
            return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function() {
            return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function() {
            return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function() {
            return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function(f) {
            return i(this.red && !f.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, f);
        };
        var H = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function z(A, f) {
            this.name = A, this.p = new o(f, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }
        z.prototype._tmp = function() {
            var f = new o(null);
            return f.words = new Array(Math.ceil(this.n / 13)), f;
        }, z.prototype.ireduce = function(f) {
            var a = f, c;
            do this.split(a, this.tmp), a = this.imulK(a), a = a.iadd(this.tmp), c = a.bitLength();
            while (c > this.n);
            var d = c < this.n ? -1 : a.ucmp(this.p);
            return d === 0 ? (a.words[0] = 0, a.length = 1) : d > 0 ? a.isub(this.p) : a.strip !== void 0 ? a.strip() : a._strip(), a;
        }, z.prototype.split = function(f, a) {
            f.iushrn(this.n, 0, a);
        }, z.prototype.imulK = function(f) {
            return f.imul(this.k);
        };
        function Pt() {
            z.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }
        n(Pt, z), Pt.prototype.split = function(f, a) {
            for(var c = 4194303, d = Math.min(f.length, 9), g = 0; g < d; g++)a.words[g] = f.words[g];
            if (a.length = d, f.length <= 9) {
                f.words[0] = 0, f.length = 1;
                return;
            }
            var x = f.words[9];
            for(a.words[a.length++] = x & c, g = 10; g < f.length; g++){
                var M = f.words[g] | 0;
                f.words[g - 10] = (M & c) << 4 | x >>> 22, x = M;
            }
            x >>>= 22, f.words[g - 10] = x, x === 0 && f.length > 10 ? f.length -= 10 : f.length -= 9;
        }, Pt.prototype.imulK = function(f) {
            f.words[f.length] = 0, f.words[f.length + 1] = 0, f.length += 2;
            for(var a = 0, c = 0; c < f.length; c++){
                var d = f.words[c] | 0;
                a += d * 977, f.words[c] = a & 67108863, a = d * 64 + (a / 67108864 | 0);
            }
            return f.words[f.length - 1] === 0 && (f.length--, f.words[f.length - 1] === 0 && f.length--), f;
        };
        function W() {
            z.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }
        n(W, z);
        function Rt() {
            z.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }
        n(Rt, z);
        function Yt() {
            z.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }
        n(Yt, z), Yt.prototype.imulK = function(f) {
            for(var a = 0, c = 0; c < f.length; c++){
                var d = (f.words[c] | 0) * 19 + a, g = d & 67108863;
                d >>>= 26, f.words[c] = g, a = d;
            }
            return a !== 0 && (f.words[f.length++] = a), f;
        }, o._prime = function(f) {
            if (H[f]) return H[f];
            var a;
            if (f === "k256") a = new Pt;
            else if (f === "p224") a = new W;
            else if (f === "p192") a = new Rt;
            else if (f === "p25519") a = new Yt;
            else throw new Error("Unknown prime " + f);
            return H[f] = a, a;
        };
        function Y(A) {
            if (typeof A == "string") {
                var f = o._prime(A);
                this.m = f.p, this.prime = f;
            } else i(A.gtn(1), "modulus must be greater than 1"), this.m = A, this.prime = null;
        }
        Y.prototype._verify1 = function(f) {
            i(f.negative === 0, "red works only with positives"), i(f.red, "red works only with red numbers");
        }, Y.prototype._verify2 = function(f, a) {
            i((f.negative | a.negative) === 0, "red works only with positives"), i(f.red && f.red === a.red, "red works only with red numbers");
        }, Y.prototype.imod = function(f) {
            return this.prime ? this.prime.ireduce(f)._forceRed(this) : (w(f, f.umod(this.m)._forceRed(this)), f);
        }, Y.prototype.neg = function(f) {
            return f.isZero() ? f.clone() : this.m.sub(f)._forceRed(this);
        }, Y.prototype.add = function(f, a) {
            this._verify2(f, a);
            var c = f.add(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c._forceRed(this);
        }, Y.prototype.iadd = function(f, a) {
            this._verify2(f, a);
            var c = f.iadd(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c;
        }, Y.prototype.sub = function(f, a) {
            this._verify2(f, a);
            var c = f.sub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c._forceRed(this);
        }, Y.prototype.isub = function(f, a) {
            this._verify2(f, a);
            var c = f.isub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c;
        }, Y.prototype.shl = function(f, a) {
            return this._verify1(f), this.imod(f.ushln(a));
        }, Y.prototype.imul = function(f, a) {
            return this._verify2(f, a), this.imod(f.imul(a));
        }, Y.prototype.mul = function(f, a) {
            return this._verify2(f, a), this.imod(f.mul(a));
        }, Y.prototype.isqr = function(f) {
            return this.imul(f, f.clone());
        }, Y.prototype.sqr = function(f) {
            return this.mul(f, f);
        }, Y.prototype.sqrt = function(f) {
            if (f.isZero()) return f.clone();
            var a = this.m.andln(3);
            if (i(a % 2 === 1), a === 3) {
                var c = this.m.add(new o(1)).iushrn(2);
                return this.pow(f, c);
            }
            for(var d = this.m.subn(1), g = 0; !d.isZero() && d.andln(1) === 0;)g++, d.iushrn(1);
            i(!d.isZero());
            var x = new o(1).toRed(this), M = x.redNeg(), l = this.m.subn(1).iushrn(1), s = this.m.bitLength();
            for(s = new o(2 * s * s).toRed(this); this.pow(s, l).cmp(M) !== 0;)s.redIAdd(M);
            for(var v = this.pow(s, d), k = this.pow(f, d.addn(1).iushrn(1)), u = this.pow(f, d), E = g; u.cmp(x) !== 0;){
                for(var _ = u, B = 0; _.cmp(x) !== 0; B++)_ = _.redSqr();
                i(B < E);
                var R = this.pow(v, new o(1).iushln(E - B - 1));
                k = k.redMul(R), v = R.redSqr(), u = u.redMul(v), E = B;
            }
            return k;
        }, Y.prototype.invm = function(f) {
            var a = f._invmp(this.m);
            return a.negative !== 0 ? (a.negative = 0, this.imod(a).redNeg()) : this.imod(a);
        }, Y.prototype.pow = function(f, a) {
            if (a.isZero()) return new o(1).toRed(this);
            if (a.cmpn(1) === 0) return f.clone();
            var c = 4, d = new Array(1 << c);
            d[0] = new o(1).toRed(this), d[1] = f;
            for(var g = 2; g < d.length; g++)d[g] = this.mul(d[g - 1], f);
            var x = d[0], M = 0, l = 0, s = a.bitLength() % 26;
            for(s === 0 && (s = 26), g = a.length - 1; g >= 0; g--){
                for(var v = a.words[g], k = s - 1; k >= 0; k--){
                    var u = v >> k & 1;
                    if (x !== d[0] && (x = this.sqr(x)), u === 0 && M === 0) {
                        l = 0;
                        continue;
                    }
                    M <<= 1, M |= u, l++, !(l !== c && (g !== 0 || k !== 0)) && (x = this.mul(x, d[M]), l = 0, M = 0);
                }
                s = 26;
            }
            return x;
        }, Y.prototype.convertTo = function(f) {
            var a = f.umod(this.m);
            return a === f ? a.clone() : a;
        }, Y.prototype.convertFrom = function(f) {
            var a = f.clone();
            return a.red = null, a;
        }, o.mont = function(f) {
            return new Vt(f);
        };
        function Vt(A) {
            Y.call(this, A), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }
        n(Vt, Y), Vt.prototype.convertTo = function(f) {
            return this.imod(f.ushln(this.shift));
        }, Vt.prototype.convertFrom = function(f) {
            var a = this.imod(f.mul(this.rinv));
            return a.red = null, a;
        }, Vt.prototype.imul = function(f, a) {
            if (f.isZero() || a.isZero()) return f.words[0] = 0, f.length = 1, f;
            var c = f.imul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.mul = function(f, a) {
            if (f.isZero() || a.isZero()) return new o(0)._forceRed(this);
            var c = f.mul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.invm = function(f) {
            var a = this.imod(f._invmp(this.m).mul(this.r2));
            return a._forceRed(this);
        };
    })(e, $23d8f6d1574ae23f$var$On);
})($23d8f6d1574ae23f$var$Ln);
var $23d8f6d1574ae23f$var$K = $23d8f6d1574ae23f$var$Ln.exports;
const $23d8f6d1574ae23f$var$jn = "bignumber/5.7.0";
var $23d8f6d1574ae23f$var$Rr = $23d8f6d1574ae23f$var$K.BN;
const $23d8f6d1574ae23f$var$Ae = new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$jn), $23d8f6d1574ae23f$var$wi = {}, $23d8f6d1574ae23f$var$Qn = 9007199254740991;
function $23d8f6d1574ae23f$var$C0(e) {
    return e != null && ($23d8f6d1574ae23f$var$V.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || $23d8f6d1574ae23f$var$Qt(e) || typeof e == "bigint" || $23d8f6d1574ae23f$var$ir(e));
}
let $23d8f6d1574ae23f$var$Jn = !1;
class $23d8f6d1574ae23f$var$V {
    constructor(t, r){
        t !== $23d8f6d1574ae23f$var$wi && $23d8f6d1574ae23f$var$Ae.throwError("cannot call constructor directly; use BigNumber.from", $23d8f6d1574ae23f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
    }
    fromTwos(t) {
        return $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).fromTwos(t));
    }
    toTwos(t) {
        return $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).toTwos(t));
    }
    abs() {
        return this._hex[0] === "-" ? $23d8f6d1574ae23f$var$V.from(this._hex.substring(1)) : this;
    }
    add(t) {
        return $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).add($23d8f6d1574ae23f$var$j(t)));
    }
    sub(t) {
        return $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).sub($23d8f6d1574ae23f$var$j(t)));
    }
    div(t) {
        return $23d8f6d1574ae23f$var$V.from(t).isZero() && $23d8f6d1574ae23f$var$Wt("division-by-zero", "div"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).div($23d8f6d1574ae23f$var$j(t)));
    }
    mul(t) {
        return $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).mul($23d8f6d1574ae23f$var$j(t)));
    }
    mod(t) {
        const r = $23d8f6d1574ae23f$var$j(t);
        return r.isNeg() && $23d8f6d1574ae23f$var$Wt("division-by-zero", "mod"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).umod(r));
    }
    pow(t) {
        const r = $23d8f6d1574ae23f$var$j(t);
        return r.isNeg() && $23d8f6d1574ae23f$var$Wt("negative-power", "pow"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).pow(r));
    }
    and(t) {
        const r = $23d8f6d1574ae23f$var$j(t);
        return (this.isNegative() || r.isNeg()) && $23d8f6d1574ae23f$var$Wt("unbound-bitwise-result", "and"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).and(r));
    }
    or(t) {
        const r = $23d8f6d1574ae23f$var$j(t);
        return (this.isNegative() || r.isNeg()) && $23d8f6d1574ae23f$var$Wt("unbound-bitwise-result", "or"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).or(r));
    }
    xor(t) {
        const r = $23d8f6d1574ae23f$var$j(t);
        return (this.isNegative() || r.isNeg()) && $23d8f6d1574ae23f$var$Wt("unbound-bitwise-result", "xor"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).xor(r));
    }
    mask(t) {
        return (this.isNegative() || t < 0) && $23d8f6d1574ae23f$var$Wt("negative-width", "mask"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).maskn(t));
    }
    shl(t) {
        return (this.isNegative() || t < 0) && $23d8f6d1574ae23f$var$Wt("negative-width", "shl"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).shln(t));
    }
    shr(t) {
        return (this.isNegative() || t < 0) && $23d8f6d1574ae23f$var$Wt("negative-width", "shr"), $23d8f6d1574ae23f$var$Lt($23d8f6d1574ae23f$var$j(this).shrn(t));
    }
    eq(t) {
        return $23d8f6d1574ae23f$var$j(this).eq($23d8f6d1574ae23f$var$j(t));
    }
    lt(t) {
        return $23d8f6d1574ae23f$var$j(this).lt($23d8f6d1574ae23f$var$j(t));
    }
    lte(t) {
        return $23d8f6d1574ae23f$var$j(this).lte($23d8f6d1574ae23f$var$j(t));
    }
    gt(t) {
        return $23d8f6d1574ae23f$var$j(this).gt($23d8f6d1574ae23f$var$j(t));
    }
    gte(t) {
        return $23d8f6d1574ae23f$var$j(this).gte($23d8f6d1574ae23f$var$j(t));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $23d8f6d1574ae23f$var$j(this).isZero();
    }
    toNumber() {
        try {
            return $23d8f6d1574ae23f$var$j(this).toNumber();
        } catch  {
            $23d8f6d1574ae23f$var$Wt("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch  {}
        return $23d8f6d1574ae23f$var$Ae.throwError("this platform does not support BigInt", $23d8f6d1574ae23f$var$L.errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        return arguments.length > 0 && (arguments[0] === 10 ? $23d8f6d1574ae23f$var$Jn || ($23d8f6d1574ae23f$var$Jn = !0, $23d8f6d1574ae23f$var$Ae.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? $23d8f6d1574ae23f$var$Ae.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", $23d8f6d1574ae23f$var$L.errors.UNEXPECTED_ARGUMENT, {}) : $23d8f6d1574ae23f$var$Ae.throwError("BigNumber.toString does not accept parameters", $23d8f6d1574ae23f$var$L.errors.UNEXPECTED_ARGUMENT, {})), $23d8f6d1574ae23f$var$j(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(t) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(t) {
        if (t instanceof $23d8f6d1574ae23f$var$V) return t;
        if (typeof t == "string") return t.match(/^-?0x[0-9a-f]+$/i) ? new $23d8f6d1574ae23f$var$V($23d8f6d1574ae23f$var$wi, $23d8f6d1574ae23f$var$vr(t)) : t.match(/^-?[0-9]+$/) ? new $23d8f6d1574ae23f$var$V($23d8f6d1574ae23f$var$wi, $23d8f6d1574ae23f$var$vr(new $23d8f6d1574ae23f$var$Rr(t))) : $23d8f6d1574ae23f$var$Ae.throwArgumentError("invalid BigNumber string", "value", t);
        if (typeof t == "number") return t % 1 && $23d8f6d1574ae23f$var$Wt("underflow", "BigNumber.from", t), (t >= $23d8f6d1574ae23f$var$Qn || t <= -$23d8f6d1574ae23f$var$Qn) && $23d8f6d1574ae23f$var$Wt("overflow", "BigNumber.from", t), $23d8f6d1574ae23f$var$V.from(String(t));
        const r = t;
        if (typeof r == "bigint") return $23d8f6d1574ae23f$var$V.from(r.toString());
        if ($23d8f6d1574ae23f$var$ir(r)) return $23d8f6d1574ae23f$var$V.from($23d8f6d1574ae23f$var$Kt(r));
        if (r) {
            if (r.toHexString) {
                const i = r.toHexString();
                if (typeof i == "string") return $23d8f6d1574ae23f$var$V.from(i);
            } else {
                let i = r._hex;
                if (i == null && r.type === "BigNumber" && (i = r.hex), typeof i == "string" && ($23d8f6d1574ae23f$var$Qt(i) || i[0] === "-" && $23d8f6d1574ae23f$var$Qt(i.substring(1)))) return $23d8f6d1574ae23f$var$V.from(i);
            }
        }
        return $23d8f6d1574ae23f$var$Ae.throwArgumentError("invalid BigNumber value", "value", t);
    }
    static isBigNumber(t) {
        return !!(t && t._isBigNumber);
    }
}
function $23d8f6d1574ae23f$var$vr(e) {
    if (typeof e != "string") return $23d8f6d1574ae23f$var$vr(e.toString(16));
    if (e[0] === "-") return e = e.substring(1), e[0] === "-" && $23d8f6d1574ae23f$var$Ae.throwArgumentError("invalid hex", "value", e), e = $23d8f6d1574ae23f$var$vr(e), e === "0x00" ? e : "-" + e;
    if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x") return "0x00";
    for(e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00";)e = "0x" + e.substring(4);
    return e;
}
function $23d8f6d1574ae23f$var$Lt(e) {
    return $23d8f6d1574ae23f$var$V.from($23d8f6d1574ae23f$var$vr(e));
}
function $23d8f6d1574ae23f$var$j(e) {
    const t = $23d8f6d1574ae23f$var$V.from(e).toHexString();
    return t[0] === "-" ? new $23d8f6d1574ae23f$var$Rr("-" + t.substring(3), 16) : new $23d8f6d1574ae23f$var$Rr(t.substring(2), 16);
}
function $23d8f6d1574ae23f$var$Wt(e, t, r) {
    const i = {
        fault: e,
        operation: t
    };
    return r != null && (i.value = r), $23d8f6d1574ae23f$var$Ae.throwError(e, $23d8f6d1574ae23f$var$L.errors.NUMERIC_FAULT, i);
}
function $23d8f6d1574ae23f$var$R0(e) {
    return new $23d8f6d1574ae23f$var$Rr(e, 36).toString(16);
}
const $23d8f6d1574ae23f$var$Ht = new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$jn), $23d8f6d1574ae23f$var$mr = {}, $23d8f6d1574ae23f$var$Gn = $23d8f6d1574ae23f$var$V.from(0), $23d8f6d1574ae23f$var$Yn = $23d8f6d1574ae23f$var$V.from(-1);
function $23d8f6d1574ae23f$var$Vn(e, t, r, i) {
    const n = {
        fault: t,
        operation: r
    };
    return i !== void 0 && (n.value = i), $23d8f6d1574ae23f$var$Ht.throwError(e, $23d8f6d1574ae23f$var$L.errors.NUMERIC_FAULT, n);
}
let $23d8f6d1574ae23f$var$gr = "0";
for(; $23d8f6d1574ae23f$var$gr.length < 256;)$23d8f6d1574ae23f$var$gr += $23d8f6d1574ae23f$var$gr;
function $23d8f6d1574ae23f$var$xi(e) {
    if (typeof e != "number") try {
        e = $23d8f6d1574ae23f$var$V.from(e).toNumber();
    } catch  {}
    return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + $23d8f6d1574ae23f$var$gr.substring(0, e) : $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid decimal size", "decimals", e);
}
function $23d8f6d1574ae23f$var$Mi(e, t) {
    t == null && (t = 0);
    const r = $23d8f6d1574ae23f$var$xi(t);
    e = $23d8f6d1574ae23f$var$V.from(e);
    const i = e.lt($23d8f6d1574ae23f$var$Gn);
    i && (e = e.mul($23d8f6d1574ae23f$var$Yn));
    let n = e.mod(r).toString();
    for(; n.length < r.length - 1;)n = "0" + n;
    n = n.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const o = e.div(r).toString();
    return r.length === 1 ? e = o : e = o + "." + n, i && (e = "-" + e), e;
}
function $23d8f6d1574ae23f$var$be(e, t) {
    t == null && (t = 0);
    const r = $23d8f6d1574ae23f$var$xi(t);
    (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid decimal value", "value", e);
    const i = e.substring(0, 1) === "-";
    i && (e = e.substring(1)), e === "." && $23d8f6d1574ae23f$var$Ht.throwArgumentError("missing value", "value", e);
    const n = e.split(".");
    n.length > 2 && $23d8f6d1574ae23f$var$Ht.throwArgumentError("too many decimal points", "value", e);
    let o = n[0], h = n[1];
    for(o || (o = "0"), h || (h = "0"); h[h.length - 1] === "0";)h = h.substring(0, h.length - 1);
    for(h.length > r.length - 1 && $23d8f6d1574ae23f$var$Vn("fractional component exceeds decimals", "underflow", "parseFixed"), h === "" && (h = "0"); h.length < r.length - 1;)h += "0";
    const p = $23d8f6d1574ae23f$var$V.from(o), b = $23d8f6d1574ae23f$var$V.from(h);
    let m = p.mul(r).add(b);
    return i && (m = m.mul($23d8f6d1574ae23f$var$Yn)), m;
}
class $23d8f6d1574ae23f$var$dr {
    constructor(t, r, i, n){
        t !== $23d8f6d1574ae23f$var$mr && $23d8f6d1574ae23f$var$Ht.throwError("cannot use FixedFormat constructor; use FixedFormat.from", $23d8f6d1574ae23f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.signed = r, this.width = i, this.decimals = n, this.name = (r ? "" : "u") + "fixed" + String(i) + "x" + String(n), this._multiplier = $23d8f6d1574ae23f$var$xi(n), Object.freeze(this);
    }
    static from(t) {
        if (t instanceof $23d8f6d1574ae23f$var$dr) return t;
        typeof t == "number" && (t = `fixed128x${t}`);
        let r = !0, i = 128, n = 18;
        if (typeof t == "string") {
            if (t !== "fixed") {
                if (t === "ufixed") r = !1;
                else {
                    const o = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                    o || $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid fixed format", "format", t), r = o[1] !== "u", i = parseInt(o[2]), n = parseInt(o[3]);
                }
            }
        } else if (t) {
            const o = (h, p, b)=>t[h] == null ? b : (typeof t[h] !== p && $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid fixed format (" + h + " not " + p + ")", "format." + h, t[h]), t[h]);
            r = o("signed", "boolean", r), i = o("width", "number", i), n = o("decimals", "number", n);
        }
        return i % 8 && $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", i), n > 80 && $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", n), new $23d8f6d1574ae23f$var$dr($23d8f6d1574ae23f$var$mr, r, i, n);
    }
}
class $23d8f6d1574ae23f$var$Ut {
    constructor(t, r, i, n){
        t !== $23d8f6d1574ae23f$var$mr && $23d8f6d1574ae23f$var$Ht.throwError("cannot use FixedNumber constructor; use FixedNumber.from", $23d8f6d1574ae23f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.format = n, this._hex = r, this._value = i, this._isFixedNumber = !0, Object.freeze(this);
    }
    _checkFormat(t) {
        this.format.name !== t.format.name && $23d8f6d1574ae23f$var$Ht.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
    }
    addUnsafe(t) {
        this._checkFormat(t);
        const r = $23d8f6d1574ae23f$var$be(this._value, this.format.decimals), i = $23d8f6d1574ae23f$var$be(t._value, t.format.decimals);
        return $23d8f6d1574ae23f$var$Ut.fromValue(r.add(i), this.format.decimals, this.format);
    }
    subUnsafe(t) {
        this._checkFormat(t);
        const r = $23d8f6d1574ae23f$var$be(this._value, this.format.decimals), i = $23d8f6d1574ae23f$var$be(t._value, t.format.decimals);
        return $23d8f6d1574ae23f$var$Ut.fromValue(r.sub(i), this.format.decimals, this.format);
    }
    mulUnsafe(t) {
        this._checkFormat(t);
        const r = $23d8f6d1574ae23f$var$be(this._value, this.format.decimals), i = $23d8f6d1574ae23f$var$be(t._value, t.format.decimals);
        return $23d8f6d1574ae23f$var$Ut.fromValue(r.mul(i).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(t) {
        this._checkFormat(t);
        const r = $23d8f6d1574ae23f$var$be(this._value, this.format.decimals), i = $23d8f6d1574ae23f$var$be(t._value, t.format.decimals);
        return $23d8f6d1574ae23f$var$Ut.fromValue(r.mul(this.format._multiplier).div(i), this.format.decimals, this.format);
    }
    floor() {
        const t = this.toString().split(".");
        t.length === 1 && t.push("0");
        let r = $23d8f6d1574ae23f$var$Ut.from(t[0], this.format);
        const i = !t[1].match(/^(0*)$/);
        return this.isNegative() && i && (r = r.subUnsafe($23d8f6d1574ae23f$var$Wn.toFormat(r.format))), r;
    }
    ceiling() {
        const t = this.toString().split(".");
        t.length === 1 && t.push("0");
        let r = $23d8f6d1574ae23f$var$Ut.from(t[0], this.format);
        const i = !t[1].match(/^(0*)$/);
        return !this.isNegative() && i && (r = r.addUnsafe($23d8f6d1574ae23f$var$Wn.toFormat(r.format))), r;
    }
    round(t) {
        t == null && (t = 0);
        const r = this.toString().split(".");
        if (r.length === 1 && r.push("0"), (t < 0 || t > 80 || t % 1) && $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t) return this;
        const i = $23d8f6d1574ae23f$var$Ut.from("1" + $23d8f6d1574ae23f$var$gr.substring(0, t), this.format), n = $23d8f6d1574ae23f$var$O0.toFormat(this.format);
        return this.mulUnsafe(i).addUnsafe(n).floor().divUnsafe(i);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(t) {
        if (t == null) return this._hex;
        t % 8 && $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid byte width", "width", t);
        const r = $23d8f6d1574ae23f$var$V.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
        return $23d8f6d1574ae23f$var$oe(r, t / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(t) {
        return $23d8f6d1574ae23f$var$Ut.fromString(this._value, t);
    }
    static fromValue(t, r, i) {
        return i == null && r != null && !$23d8f6d1574ae23f$var$C0(r) && (i = r, r = null), r == null && (r = 0), i == null && (i = "fixed"), $23d8f6d1574ae23f$var$Ut.fromString($23d8f6d1574ae23f$var$Mi(t, r), $23d8f6d1574ae23f$var$dr.from(i));
    }
    static fromString(t, r) {
        r == null && (r = "fixed");
        const i = $23d8f6d1574ae23f$var$dr.from(r), n = $23d8f6d1574ae23f$var$be(t, i.decimals);
        !i.signed && n.lt($23d8f6d1574ae23f$var$Gn) && $23d8f6d1574ae23f$var$Vn("unsigned value cannot be negative", "overflow", "value", t);
        let o = null;
        i.signed ? o = n.toTwos(i.width).toHexString() : (o = n.toHexString(), o = $23d8f6d1574ae23f$var$oe(o, i.width / 8));
        const h = $23d8f6d1574ae23f$var$Mi(n, i.decimals);
        return new $23d8f6d1574ae23f$var$Ut($23d8f6d1574ae23f$var$mr, o, h, i);
    }
    static fromBytes(t, r) {
        r == null && (r = "fixed");
        const i = $23d8f6d1574ae23f$var$dr.from(r);
        if ($23d8f6d1574ae23f$var$Ot(t).length > i.width / 8) throw new Error("overflow");
        let n = $23d8f6d1574ae23f$var$V.from(t);
        i.signed && (n = n.fromTwos(i.width));
        const o = n.toTwos((i.signed ? 0 : 1) + i.width).toHexString(), h = $23d8f6d1574ae23f$var$Mi(n, i.decimals);
        return new $23d8f6d1574ae23f$var$Ut($23d8f6d1574ae23f$var$mr, o, h, i);
    }
    static from(t, r) {
        if (typeof t == "string") return $23d8f6d1574ae23f$var$Ut.fromString(t, r);
        if ($23d8f6d1574ae23f$var$ir(t)) return $23d8f6d1574ae23f$var$Ut.fromBytes(t, r);
        try {
            return $23d8f6d1574ae23f$var$Ut.fromValue(t, 0, r);
        } catch (i) {
            if (i.code !== $23d8f6d1574ae23f$var$L.errors.INVALID_ARGUMENT) throw i;
        }
        return $23d8f6d1574ae23f$var$Ht.throwArgumentError("invalid FixedNumber value", "value", t);
    }
    static isFixedNumber(t) {
        return !!(t && t._isFixedNumber);
    }
}
const $23d8f6d1574ae23f$var$Wn = $23d8f6d1574ae23f$var$Ut.from(1), $23d8f6d1574ae23f$var$O0 = $23d8f6d1574ae23f$var$Ut.from("0.5"), $23d8f6d1574ae23f$var$P0 = "strings/5.7.0", $23d8f6d1574ae23f$var$Xn = new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$P0);
var $23d8f6d1574ae23f$var$Or;
(function(e) {
    e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})($23d8f6d1574ae23f$var$Or || ($23d8f6d1574ae23f$var$Or = {}));
var $23d8f6d1574ae23f$var$nr;
(function(e) {
    e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})($23d8f6d1574ae23f$var$nr || ($23d8f6d1574ae23f$var$nr = {}));
function $23d8f6d1574ae23f$var$D0(e, t, r, i, n) {
    return $23d8f6d1574ae23f$var$Xn.throwArgumentError(`invalid codepoint at offset ${t}; ${e}`, "bytes", r);
}
function $23d8f6d1574ae23f$var$Zn(e, t, r, i, n) {
    if (e === $23d8f6d1574ae23f$var$nr.BAD_PREFIX || e === $23d8f6d1574ae23f$var$nr.UNEXPECTED_CONTINUE) {
        let o = 0;
        for(let h = t + 1; h < r.length && r[h] >> 6 === 2; h++)o++;
        return o;
    }
    return e === $23d8f6d1574ae23f$var$nr.OVERRUN ? r.length - t - 1 : 0;
}
function $23d8f6d1574ae23f$var$F0(e, t, r, i, n) {
    return e === $23d8f6d1574ae23f$var$nr.OVERLONG ? (i.push(n), 0) : (i.push(65533), $23d8f6d1574ae23f$var$Zn(e, t, r));
}
Object.freeze({
    error: $23d8f6d1574ae23f$var$D0,
    ignore: $23d8f6d1574ae23f$var$Zn,
    replace: $23d8f6d1574ae23f$var$F0
});
function $23d8f6d1574ae23f$var$Ei(e, t = $23d8f6d1574ae23f$var$Or.current) {
    t != $23d8f6d1574ae23f$var$Or.current && ($23d8f6d1574ae23f$var$Xn.checkNormalize(), e = e.normalize(t));
    let r = [];
    for(let i = 0; i < e.length; i++){
        const n = e.charCodeAt(i);
        if (n < 128) r.push(n);
        else if (n < 2048) r.push(n >> 6 | 192), r.push(n & 63 | 128);
        else if ((n & 64512) == 55296) {
            i++;
            const o = e.charCodeAt(i);
            if (i >= e.length || (o & 64512) !== 56320) throw new Error("invalid utf-8 string");
            const h = 65536 + ((n & 1023) << 10) + (o & 1023);
            r.push(h >> 18 | 240), r.push(h >> 12 & 63 | 128), r.push(h >> 6 & 63 | 128), r.push(h & 63 | 128);
        } else r.push(n >> 12 | 224), r.push(n >> 6 & 63 | 128), r.push(n & 63 | 128);
    }
    return $23d8f6d1574ae23f$var$Ot(r);
}
function $23d8f6d1574ae23f$var$T0(e) {
    if (e.length % 4 !== 0) throw new Error("bad data");
    let t = [];
    for(let r = 0; r < e.length; r += 4)t.push(parseInt(e.substring(r, r + 4), 16));
    return t;
}
function $23d8f6d1574ae23f$var$Si(e, t) {
    t || (t = function(n) {
        return [
            parseInt(n, 16)
        ];
    });
    let r = 0, i = {};
    return e.split(",").forEach((n)=>{
        let o = n.split(":");
        r += parseInt(o[0], 16), i[r] = t(o[1]);
    }), i;
}
function $23d8f6d1574ae23f$var$$n(e) {
    let t = 0;
    return e.split(",").map((r)=>{
        let i = r.split("-");
        i.length === 1 ? i[1] = "0" : i[1] === "" && (i[1] = "1");
        let n = t + parseInt(i[0], 16);
        return t = parseInt(i[1], 16), {
            l: n,
            h: t
        };
    });
}
$23d8f6d1574ae23f$var$$n("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((e)=>parseInt(e, 16)), $23d8f6d1574ae23f$var$Si("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), $23d8f6d1574ae23f$var$Si("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), $23d8f6d1574ae23f$var$Si("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $23d8f6d1574ae23f$var$T0), $23d8f6d1574ae23f$var$$n("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
const $23d8f6d1574ae23f$var$tf = "hash/5.7.0";
function $23d8f6d1574ae23f$var$U0(e) {
    e = atob(e);
    const t = [];
    for(let r = 0; r < e.length; r++)t.push(e.charCodeAt(r));
    return $23d8f6d1574ae23f$var$Ot(t);
}
function $23d8f6d1574ae23f$var$ef(e, t) {
    t == null && (t = 1);
    const r = [], i = r.forEach, n = function(o, h) {
        i.call(o, function(p) {
            h > 0 && Array.isArray(p) ? n(p, h - 1) : r.push(p);
        });
    };
    return n(e, t), r;
}
function $23d8f6d1574ae23f$var$k0(e) {
    const t = {};
    for(let r = 0; r < e.length; r++){
        const i = e[r];
        t[i[0]] = i[1];
    }
    return t;
}
function $23d8f6d1574ae23f$var$q0(e) {
    let t = 0;
    function r() {
        return e[t++] << 8 | e[t++];
    }
    let i = r(), n = 1, o = [
        0,
        1
    ];
    for(let H = 1; H < i; H++)o.push(n += r());
    let h = r(), p = t;
    t += h;
    let b = 0, m = 0;
    function w() {
        return b == 0 && (m = m << 8 | e[t++], b = 8), m >> --b & 1;
    }
    const y = 31, S = Math.pow(2, y), I = S >>> 1, N = I >> 1, C = S - 1;
    let F = 0;
    for(let H = 0; H < y; H++)F = F << 1 | w();
    let U = [], J = 0, Bt = S;
    for(;;){
        let H = Math.floor(((F - J + 1) * n - 1) / Bt), z = 0, Pt = i;
        for(; Pt - z > 1;){
            let Yt = z + Pt >>> 1;
            H < o[Yt] ? Pt = Yt : z = Yt;
        }
        if (z == 0) break;
        U.push(z);
        let W = J + Math.floor(Bt * o[z] / n), Rt = J + Math.floor(Bt * o[z + 1] / n) - 1;
        for(; !((W ^ Rt) & I);)F = F << 1 & C | w(), W = W << 1 & C, Rt = Rt << 1 & C | 1;
        for(; W & ~Rt & N;)F = F & I | F << 1 & C >>> 1 | w(), W = W << 1 ^ I, Rt = (Rt ^ I) << 1 | I | 1;
        J = W, Bt = 1 + Rt - W;
    }
    let G = i - 4;
    return U.map((H)=>{
        switch(H - G){
            case 3:
                return G + 65792 + (e[p++] << 16 | e[p++] << 8 | e[p++]);
            case 2:
                return G + 256 + (e[p++] << 8 | e[p++]);
            case 1:
                return G + e[p++];
            default:
                return H - 1;
        }
    });
}
function $23d8f6d1574ae23f$var$K0(e) {
    let t = 0;
    return ()=>e[t++];
}
function $23d8f6d1574ae23f$var$H0(e) {
    return $23d8f6d1574ae23f$var$K0($23d8f6d1574ae23f$var$q0(e));
}
function $23d8f6d1574ae23f$var$z0(e) {
    return e & 1 ? ~e >> 1 : e >> 1;
}
function $23d8f6d1574ae23f$var$L0(e, t) {
    let r = Array(e);
    for(let i = 0; i < e; i++)r[i] = 1 + t();
    return r;
}
function $23d8f6d1574ae23f$var$rf(e, t) {
    let r = Array(e);
    for(let i = 0, n = -1; i < e; i++)r[i] = n += 1 + t();
    return r;
}
function $23d8f6d1574ae23f$var$j0(e, t) {
    let r = Array(e);
    for(let i = 0, n = 0; i < e; i++)r[i] = n += $23d8f6d1574ae23f$var$z0(t());
    return r;
}
function $23d8f6d1574ae23f$var$Pr(e, t) {
    let r = $23d8f6d1574ae23f$var$rf(e(), e), i = e(), n = $23d8f6d1574ae23f$var$rf(i, e), o = $23d8f6d1574ae23f$var$L0(i, e);
    for(let h = 0; h < i; h++)for(let p = 0; p < o[h]; p++)r.push(n[h] + p);
    return t ? r.map((h)=>t[h]) : r;
}
function $23d8f6d1574ae23f$var$Q0(e) {
    let t = [];
    for(;;){
        let r = e();
        if (r == 0) break;
        t.push($23d8f6d1574ae23f$var$G0(r, e));
    }
    for(;;){
        let r = e() - 1;
        if (r < 0) break;
        t.push($23d8f6d1574ae23f$var$Y0(r, e));
    }
    return $23d8f6d1574ae23f$var$k0($23d8f6d1574ae23f$var$ef(t));
}
function $23d8f6d1574ae23f$var$J0(e) {
    let t = [];
    for(;;){
        let r = e();
        if (r == 0) break;
        t.push(r);
    }
    return t;
}
function $23d8f6d1574ae23f$var$nf(e, t, r) {
    let i = Array(e).fill(void 0).map(()=>[]);
    for(let n = 0; n < t; n++)$23d8f6d1574ae23f$var$j0(e, r).forEach((o, h)=>i[h].push(o));
    return i;
}
function $23d8f6d1574ae23f$var$G0(e, t) {
    let r = 1 + t(), i = t(), n = $23d8f6d1574ae23f$var$J0(t), o = $23d8f6d1574ae23f$var$nf(n.length, 1 + e, t);
    return $23d8f6d1574ae23f$var$ef(o.map((h, p)=>{
        const b = h[0], m = h.slice(1);
        return Array(n[p]).fill(void 0).map((w, y)=>{
            let S = y * i;
            return [
                b + y * r,
                m.map((I)=>I + S)
            ];
        });
    }));
}
function $23d8f6d1574ae23f$var$Y0(e, t) {
    let r = 1 + t();
    return $23d8f6d1574ae23f$var$nf(r, 1 + e, t).map((n)=>[
            n[0],
            n.slice(1)
        ]);
}
function $23d8f6d1574ae23f$var$V0(e) {
    let t = $23d8f6d1574ae23f$var$Pr(e).sort((i, n)=>i - n);
    return r();
    function r() {
        let i = [];
        for(;;){
            let m = $23d8f6d1574ae23f$var$Pr(e, t);
            if (m.length == 0) break;
            i.push({
                set: new Set(m),
                node: r()
            });
        }
        i.sort((m, w)=>w.set.size - m.set.size);
        let n = e(), o = n % 3;
        n = n / 3 | 0;
        let h = !!(n & 1);
        n >>= 1;
        let p = n == 1, b = n == 2;
        return {
            branches: i,
            valid: o,
            fe0f: h,
            save: p,
            check: b
        };
    }
}
function $23d8f6d1574ae23f$var$W0() {
    return $23d8f6d1574ae23f$var$H0($23d8f6d1574ae23f$var$U0("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"));
}
const $23d8f6d1574ae23f$var$Dr = $23d8f6d1574ae23f$var$W0();
new Set($23d8f6d1574ae23f$var$Pr($23d8f6d1574ae23f$var$Dr)), new Set($23d8f6d1574ae23f$var$Pr($23d8f6d1574ae23f$var$Dr)), $23d8f6d1574ae23f$var$Q0($23d8f6d1574ae23f$var$Dr), $23d8f6d1574ae23f$var$V0($23d8f6d1574ae23f$var$Dr), new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$tf);
const $23d8f6d1574ae23f$var$X0 = new Uint8Array(32);
$23d8f6d1574ae23f$var$X0.fill(0);
const $23d8f6d1574ae23f$var$Z0 = `Ethereum Signed Message:
`;
function $23d8f6d1574ae23f$var$ff(e) {
    return typeof e == "string" && (e = $23d8f6d1574ae23f$var$Ei(e)), $23d8f6d1574ae23f$var$yi($23d8f6d1574ae23f$var$E0([
        $23d8f6d1574ae23f$var$Ei($23d8f6d1574ae23f$var$Z0),
        $23d8f6d1574ae23f$var$Ei(String(e.length)),
        e
    ]));
}
const $23d8f6d1574ae23f$var$$0 = "rlp/5.7.0";
new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$$0);
const $23d8f6d1574ae23f$var$ts = "address/5.7.0", $23d8f6d1574ae23f$var$Ar = new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$ts);
function $23d8f6d1574ae23f$var$of(e) {
    $23d8f6d1574ae23f$var$Qt(e, 20) || $23d8f6d1574ae23f$var$Ar.throwArgumentError("invalid address", "address", e), e = e.toLowerCase();
    const t = e.substring(2).split(""), r = new Uint8Array(40);
    for(let n = 0; n < 40; n++)r[n] = t[n].charCodeAt(0);
    const i = $23d8f6d1574ae23f$var$Ot($23d8f6d1574ae23f$var$yi(r));
    for(let n = 0; n < 40; n += 2)i[n >> 1] >> 4 >= 8 && (t[n] = t[n].toUpperCase()), (i[n >> 1] & 15) >= 8 && (t[n + 1] = t[n + 1].toUpperCase());
    return "0x" + t.join("");
}
const $23d8f6d1574ae23f$var$es = 9007199254740991;
function $23d8f6d1574ae23f$var$rs(e) {
    return Math.log10 ? Math.log10(e) : Math.log(e) / Math.LN10;
}
const $23d8f6d1574ae23f$var$Ni = {};
for(let e = 0; e < 10; e++)$23d8f6d1574ae23f$var$Ni[String(e)] = String(e);
for(let e = 0; e < 26; e++)$23d8f6d1574ae23f$var$Ni[String.fromCharCode(65 + e)] = String(10 + e);
const $23d8f6d1574ae23f$var$sf = Math.floor($23d8f6d1574ae23f$var$rs($23d8f6d1574ae23f$var$es));
function $23d8f6d1574ae23f$var$is(e) {
    e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
    let t = e.split("").map((i)=>$23d8f6d1574ae23f$var$Ni[i]).join("");
    for(; t.length >= $23d8f6d1574ae23f$var$sf;){
        let i = t.substring(0, $23d8f6d1574ae23f$var$sf);
        t = parseInt(i, 10) % 97 + t.substring(i.length);
    }
    let r = String(98 - parseInt(t, 10) % 97);
    for(; r.length < 2;)r = "0" + r;
    return r;
}
function $23d8f6d1574ae23f$var$ns(e) {
    let t = null;
    if (typeof e != "string" && $23d8f6d1574ae23f$var$Ar.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) e.substring(0, 2) !== "0x" && (e = "0x" + e), t = $23d8f6d1574ae23f$var$of(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && $23d8f6d1574ae23f$var$Ar.throwArgumentError("bad address checksum", "address", e);
    else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        for(e.substring(2, 4) !== $23d8f6d1574ae23f$var$is(e) && $23d8f6d1574ae23f$var$Ar.throwArgumentError("bad icap checksum", "address", e), t = $23d8f6d1574ae23f$var$R0(e.substring(4)); t.length < 40;)t = "0" + t;
        t = $23d8f6d1574ae23f$var$of("0x" + t);
    } else $23d8f6d1574ae23f$var$Ar.throwArgumentError("invalid address", "address", e);
    return t;
}
const $23d8f6d1574ae23f$var$fs = "properties/5.7.0";
new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$fs);
function $23d8f6d1574ae23f$var$br(e, t, r) {
    Object.defineProperty(e, t, {
        enumerable: !0,
        value: r,
        writable: !1
    });
}
new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$tf);
const $23d8f6d1574ae23f$var$os = new Uint8Array(32);
$23d8f6d1574ae23f$var$os.fill(0), $23d8f6d1574ae23f$var$V.from(-1);
const $23d8f6d1574ae23f$var$ss = $23d8f6d1574ae23f$var$V.from(0), $23d8f6d1574ae23f$var$as = $23d8f6d1574ae23f$var$V.from(1);
$23d8f6d1574ae23f$var$V.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), $23d8f6d1574ae23f$var$oe($23d8f6d1574ae23f$var$as.toHexString(), 32), $23d8f6d1574ae23f$var$oe($23d8f6d1574ae23f$var$ss.toHexString(), 32);
var $23d8f6d1574ae23f$var$se = {}, $23d8f6d1574ae23f$var$Q = {}, $23d8f6d1574ae23f$var$yr = $23d8f6d1574ae23f$var$af;
function $23d8f6d1574ae23f$var$af(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$23d8f6d1574ae23f$var$af.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $23d8f6d1574ae23f$var$Ii = {
    exports: {}
};
typeof Object.create == "function" ? $23d8f6d1574ae23f$var$Ii.exports = function(t, r) {
    r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
        constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }));
} : $23d8f6d1574ae23f$var$Ii.exports = function(t, r) {
    if (r) {
        t.super_ = r;
        var i = function() {};
        i.prototype = r.prototype, t.prototype = new i, t.prototype.constructor = t;
    }
};
var $23d8f6d1574ae23f$var$us = $23d8f6d1574ae23f$var$yr, $23d8f6d1574ae23f$var$hs = $23d8f6d1574ae23f$var$Ii.exports;
$23d8f6d1574ae23f$var$Q.inherits = $23d8f6d1574ae23f$var$hs;
function $23d8f6d1574ae23f$var$cs(e, t) {
    return (e.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= e.length ? !1 : (e.charCodeAt(t + 1) & 64512) === 56320;
}
function $23d8f6d1574ae23f$var$ls(e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var r = [];
    if (typeof e == "string") {
        if (t) {
            if (t === "hex") for(e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
        } else for(var i = 0, n = 0; n < e.length; n++){
            var o = e.charCodeAt(n);
            o < 128 ? r[i++] = o : o < 2048 ? (r[i++] = o >> 6 | 192, r[i++] = o & 63 | 128) : $23d8f6d1574ae23f$var$cs(e, n) ? (o = 65536 + ((o & 1023) << 10) + (e.charCodeAt(++n) & 1023), r[i++] = o >> 18 | 240, r[i++] = o >> 12 & 63 | 128, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128) : (r[i++] = o >> 12 | 224, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128);
        }
    } else for(n = 0; n < e.length; n++)r[n] = e[n] | 0;
    return r;
}
$23d8f6d1574ae23f$var$Q.toArray = $23d8f6d1574ae23f$var$ls;
function $23d8f6d1574ae23f$var$ds(e) {
    for(var t = "", r = 0; r < e.length; r++)t += $23d8f6d1574ae23f$var$hf(e[r].toString(16));
    return t;
}
$23d8f6d1574ae23f$var$Q.toHex = $23d8f6d1574ae23f$var$ds;
function $23d8f6d1574ae23f$var$uf(e) {
    var t = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
    return t >>> 0;
}
$23d8f6d1574ae23f$var$Q.htonl = $23d8f6d1574ae23f$var$uf;
function $23d8f6d1574ae23f$var$ps(e, t) {
    for(var r = "", i = 0; i < e.length; i++){
        var n = e[i];
        t === "little" && (n = $23d8f6d1574ae23f$var$uf(n)), r += $23d8f6d1574ae23f$var$cf(n.toString(16));
    }
    return r;
}
$23d8f6d1574ae23f$var$Q.toHex32 = $23d8f6d1574ae23f$var$ps;
function $23d8f6d1574ae23f$var$hf(e) {
    return e.length === 1 ? "0" + e : e;
}
$23d8f6d1574ae23f$var$Q.zero2 = $23d8f6d1574ae23f$var$hf;
function $23d8f6d1574ae23f$var$cf(e) {
    return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
$23d8f6d1574ae23f$var$Q.zero8 = $23d8f6d1574ae23f$var$cf;
function $23d8f6d1574ae23f$var$vs(e, t, r, i) {
    var n = r - t;
    $23d8f6d1574ae23f$var$us(n % 4 === 0);
    for(var o = new Array(n / 4), h = 0, p = t; h < o.length; h++, p += 4){
        var b;
        i === "big" ? b = e[p] << 24 | e[p + 1] << 16 | e[p + 2] << 8 | e[p + 3] : b = e[p + 3] << 24 | e[p + 2] << 16 | e[p + 1] << 8 | e[p], o[h] = b >>> 0;
    }
    return o;
}
$23d8f6d1574ae23f$var$Q.join32 = $23d8f6d1574ae23f$var$vs;
function $23d8f6d1574ae23f$var$ms(e, t) {
    for(var r = new Array(e.length * 4), i = 0, n = 0; i < e.length; i++, n += 4){
        var o = e[i];
        t === "big" ? (r[n] = o >>> 24, r[n + 1] = o >>> 16 & 255, r[n + 2] = o >>> 8 & 255, r[n + 3] = o & 255) : (r[n + 3] = o >>> 24, r[n + 2] = o >>> 16 & 255, r[n + 1] = o >>> 8 & 255, r[n] = o & 255);
    }
    return r;
}
$23d8f6d1574ae23f$var$Q.split32 = $23d8f6d1574ae23f$var$ms;
function $23d8f6d1574ae23f$var$gs(e, t) {
    return e >>> t | e << 32 - t;
}
$23d8f6d1574ae23f$var$Q.rotr32 = $23d8f6d1574ae23f$var$gs;
function $23d8f6d1574ae23f$var$As(e, t) {
    return e << t | e >>> 32 - t;
}
$23d8f6d1574ae23f$var$Q.rotl32 = $23d8f6d1574ae23f$var$As;
function $23d8f6d1574ae23f$var$bs(e, t) {
    return e + t >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum32 = $23d8f6d1574ae23f$var$bs;
function $23d8f6d1574ae23f$var$ys(e, t, r) {
    return e + t + r >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum32_3 = $23d8f6d1574ae23f$var$ys;
function $23d8f6d1574ae23f$var$ws(e, t, r, i) {
    return e + t + r + i >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum32_4 = $23d8f6d1574ae23f$var$ws;
function $23d8f6d1574ae23f$var$xs(e, t, r, i, n) {
    return e + t + r + i + n >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum32_5 = $23d8f6d1574ae23f$var$xs;
function $23d8f6d1574ae23f$var$Ms(e, t, r, i) {
    var n = e[t], o = e[t + 1], h = i + o >>> 0, p = (h < i ? 1 : 0) + r + n;
    e[t] = p >>> 0, e[t + 1] = h;
}
$23d8f6d1574ae23f$var$Q.sum64 = $23d8f6d1574ae23f$var$Ms;
function $23d8f6d1574ae23f$var$Es(e, t, r, i) {
    var n = t + i >>> 0, o = (n < t ? 1 : 0) + e + r;
    return o >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum64_hi = $23d8f6d1574ae23f$var$Es;
function $23d8f6d1574ae23f$var$Ss(e, t, r, i) {
    var n = t + i;
    return n >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum64_lo = $23d8f6d1574ae23f$var$Ss;
function $23d8f6d1574ae23f$var$Ns(e, t, r, i, n, o, h, p) {
    var b = 0, m = t;
    m = m + i >>> 0, b += m < t ? 1 : 0, m = m + o >>> 0, b += m < o ? 1 : 0, m = m + p >>> 0, b += m < p ? 1 : 0;
    var w = e + r + n + h + b;
    return w >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum64_4_hi = $23d8f6d1574ae23f$var$Ns;
function $23d8f6d1574ae23f$var$Is(e, t, r, i, n, o, h, p) {
    var b = t + i + o + p;
    return b >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum64_4_lo = $23d8f6d1574ae23f$var$Is;
function $23d8f6d1574ae23f$var$_s(e, t, r, i, n, o, h, p, b, m) {
    var w = 0, y = t;
    y = y + i >>> 0, w += y < t ? 1 : 0, y = y + o >>> 0, w += y < o ? 1 : 0, y = y + p >>> 0, w += y < p ? 1 : 0, y = y + m >>> 0, w += y < m ? 1 : 0;
    var S = e + r + n + h + b + w;
    return S >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum64_5_hi = $23d8f6d1574ae23f$var$_s;
function $23d8f6d1574ae23f$var$Bs(e, t, r, i, n, o, h, p, b, m) {
    var w = t + i + o + p + m;
    return w >>> 0;
}
$23d8f6d1574ae23f$var$Q.sum64_5_lo = $23d8f6d1574ae23f$var$Bs;
function $23d8f6d1574ae23f$var$Cs(e, t, r) {
    var i = t << 32 - r | e >>> r;
    return i >>> 0;
}
$23d8f6d1574ae23f$var$Q.rotr64_hi = $23d8f6d1574ae23f$var$Cs;
function $23d8f6d1574ae23f$var$Rs(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$23d8f6d1574ae23f$var$Q.rotr64_lo = $23d8f6d1574ae23f$var$Rs;
function $23d8f6d1574ae23f$var$Os(e, t, r) {
    return e >>> r;
}
$23d8f6d1574ae23f$var$Q.shr64_hi = $23d8f6d1574ae23f$var$Os;
function $23d8f6d1574ae23f$var$Ps(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$23d8f6d1574ae23f$var$Q.shr64_lo = $23d8f6d1574ae23f$var$Ps;
var $23d8f6d1574ae23f$var$fr = {}, $23d8f6d1574ae23f$var$lf = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$Ds = $23d8f6d1574ae23f$var$yr;
function $23d8f6d1574ae23f$var$Fr() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
$23d8f6d1574ae23f$var$fr.BlockHash = $23d8f6d1574ae23f$var$Fr, $23d8f6d1574ae23f$var$Fr.prototype.update = function(t, r) {
    if (t = $23d8f6d1574ae23f$var$lf.toArray(t, r), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
        t = this.pending;
        var i = t.length % this._delta8;
        this.pending = t.slice(t.length - i, t.length), this.pending.length === 0 && (this.pending = null), t = $23d8f6d1574ae23f$var$lf.join32(t, 0, t.length - i, this.endian);
        for(var n = 0; n < t.length; n += this._delta32)this._update(t, n, n + this._delta32);
    }
    return this;
}, $23d8f6d1574ae23f$var$Fr.prototype.digest = function(t) {
    return this.update(this._pad()), $23d8f6d1574ae23f$var$Ds(this.pending === null), this._digest(t);
}, $23d8f6d1574ae23f$var$Fr.prototype._pad = function() {
    var t = this.pendingTotal, r = this._delta8, i = r - (t + this.padLength) % r, n = new Array(i + this.padLength);
    n[0] = 128;
    for(var o = 1; o < i; o++)n[o] = 0;
    if (t <<= 3, this.endian === "big") {
        for(var h = 8; h < this.padLength; h++)n[o++] = 0;
        n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = t >>> 24 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 8 & 255, n[o++] = t & 255;
    } else for(n[o++] = t & 255, n[o++] = t >>> 8 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 24 & 255, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, h = 8; h < this.padLength; h++)n[o++] = 0;
    return n;
};
var $23d8f6d1574ae23f$var$or = {}, $23d8f6d1574ae23f$var$ae = {}, $23d8f6d1574ae23f$var$Fs = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$ue = $23d8f6d1574ae23f$var$Fs.rotr32;
function $23d8f6d1574ae23f$var$Ts(e, t, r, i) {
    if (e === 0) return $23d8f6d1574ae23f$var$df(t, r, i);
    if (e === 1 || e === 3) return $23d8f6d1574ae23f$var$vf(t, r, i);
    if (e === 2) return $23d8f6d1574ae23f$var$pf(t, r, i);
}
$23d8f6d1574ae23f$var$ae.ft_1 = $23d8f6d1574ae23f$var$Ts;
function $23d8f6d1574ae23f$var$df(e, t, r) {
    return e & t ^ ~e & r;
}
$23d8f6d1574ae23f$var$ae.ch32 = $23d8f6d1574ae23f$var$df;
function $23d8f6d1574ae23f$var$pf(e, t, r) {
    return e & t ^ e & r ^ t & r;
}
$23d8f6d1574ae23f$var$ae.maj32 = $23d8f6d1574ae23f$var$pf;
function $23d8f6d1574ae23f$var$vf(e, t, r) {
    return e ^ t ^ r;
}
$23d8f6d1574ae23f$var$ae.p32 = $23d8f6d1574ae23f$var$vf;
function $23d8f6d1574ae23f$var$Us(e) {
    return $23d8f6d1574ae23f$var$ue(e, 2) ^ $23d8f6d1574ae23f$var$ue(e, 13) ^ $23d8f6d1574ae23f$var$ue(e, 22);
}
$23d8f6d1574ae23f$var$ae.s0_256 = $23d8f6d1574ae23f$var$Us;
function $23d8f6d1574ae23f$var$ks(e) {
    return $23d8f6d1574ae23f$var$ue(e, 6) ^ $23d8f6d1574ae23f$var$ue(e, 11) ^ $23d8f6d1574ae23f$var$ue(e, 25);
}
$23d8f6d1574ae23f$var$ae.s1_256 = $23d8f6d1574ae23f$var$ks;
function $23d8f6d1574ae23f$var$qs(e) {
    return $23d8f6d1574ae23f$var$ue(e, 7) ^ $23d8f6d1574ae23f$var$ue(e, 18) ^ e >>> 3;
}
$23d8f6d1574ae23f$var$ae.g0_256 = $23d8f6d1574ae23f$var$qs;
function $23d8f6d1574ae23f$var$Ks(e) {
    return $23d8f6d1574ae23f$var$ue(e, 17) ^ $23d8f6d1574ae23f$var$ue(e, 19) ^ e >>> 10;
}
$23d8f6d1574ae23f$var$ae.g1_256 = $23d8f6d1574ae23f$var$Ks;
var $23d8f6d1574ae23f$var$sr = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$Hs = $23d8f6d1574ae23f$var$fr, $23d8f6d1574ae23f$var$zs = $23d8f6d1574ae23f$var$ae, $23d8f6d1574ae23f$var$_i = $23d8f6d1574ae23f$var$sr.rotl32, $23d8f6d1574ae23f$var$wr = $23d8f6d1574ae23f$var$sr.sum32, $23d8f6d1574ae23f$var$Ls = $23d8f6d1574ae23f$var$sr.sum32_5, $23d8f6d1574ae23f$var$js = $23d8f6d1574ae23f$var$zs.ft_1, $23d8f6d1574ae23f$var$mf = $23d8f6d1574ae23f$var$Hs.BlockHash, $23d8f6d1574ae23f$var$Qs = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
];
function $23d8f6d1574ae23f$var$he() {
    if (!(this instanceof $23d8f6d1574ae23f$var$he)) return new $23d8f6d1574ae23f$var$he;
    $23d8f6d1574ae23f$var$mf.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.W = new Array(80);
}
$23d8f6d1574ae23f$var$sr.inherits($23d8f6d1574ae23f$var$he, $23d8f6d1574ae23f$var$mf);
var $23d8f6d1574ae23f$var$Js = $23d8f6d1574ae23f$var$he;
$23d8f6d1574ae23f$var$he.blockSize = 512, $23d8f6d1574ae23f$var$he.outSize = 160, $23d8f6d1574ae23f$var$he.hmacStrength = 80, $23d8f6d1574ae23f$var$he.padLength = 64, $23d8f6d1574ae23f$var$he.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $23d8f6d1574ae23f$var$_i(i[n - 3] ^ i[n - 8] ^ i[n - 14] ^ i[n - 16], 1);
    var o = this.h[0], h = this.h[1], p = this.h[2], b = this.h[3], m = this.h[4];
    for(n = 0; n < i.length; n++){
        var w = ~~(n / 20), y = $23d8f6d1574ae23f$var$Ls($23d8f6d1574ae23f$var$_i(o, 5), $23d8f6d1574ae23f$var$js(w, h, p, b), m, i[n], $23d8f6d1574ae23f$var$Qs[w]);
        m = b, b = p, p = $23d8f6d1574ae23f$var$_i(h, 30), h = o, o = y;
    }
    this.h[0] = $23d8f6d1574ae23f$var$wr(this.h[0], o), this.h[1] = $23d8f6d1574ae23f$var$wr(this.h[1], h), this.h[2] = $23d8f6d1574ae23f$var$wr(this.h[2], p), this.h[3] = $23d8f6d1574ae23f$var$wr(this.h[3], b), this.h[4] = $23d8f6d1574ae23f$var$wr(this.h[4], m);
}, $23d8f6d1574ae23f$var$he.prototype._digest = function(t) {
    return t === "hex" ? $23d8f6d1574ae23f$var$sr.toHex32(this.h, "big") : $23d8f6d1574ae23f$var$sr.split32(this.h, "big");
};
var $23d8f6d1574ae23f$var$ar = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$Gs = $23d8f6d1574ae23f$var$fr, $23d8f6d1574ae23f$var$ur = $23d8f6d1574ae23f$var$ae, $23d8f6d1574ae23f$var$Ys = $23d8f6d1574ae23f$var$yr, $23d8f6d1574ae23f$var$ie = $23d8f6d1574ae23f$var$ar.sum32, $23d8f6d1574ae23f$var$Vs = $23d8f6d1574ae23f$var$ar.sum32_4, $23d8f6d1574ae23f$var$Ws = $23d8f6d1574ae23f$var$ar.sum32_5, $23d8f6d1574ae23f$var$Xs = $23d8f6d1574ae23f$var$ur.ch32, $23d8f6d1574ae23f$var$Zs = $23d8f6d1574ae23f$var$ur.maj32, $23d8f6d1574ae23f$var$$s = $23d8f6d1574ae23f$var$ur.s0_256, $23d8f6d1574ae23f$var$ta = $23d8f6d1574ae23f$var$ur.s1_256, $23d8f6d1574ae23f$var$ea = $23d8f6d1574ae23f$var$ur.g0_256, $23d8f6d1574ae23f$var$ra = $23d8f6d1574ae23f$var$ur.g1_256, $23d8f6d1574ae23f$var$gf = $23d8f6d1574ae23f$var$Gs.BlockHash, $23d8f6d1574ae23f$var$ia = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
];
function $23d8f6d1574ae23f$var$ce() {
    if (!(this instanceof $23d8f6d1574ae23f$var$ce)) return new $23d8f6d1574ae23f$var$ce;
    $23d8f6d1574ae23f$var$gf.call(this), this.h = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ], this.k = $23d8f6d1574ae23f$var$ia, this.W = new Array(64);
}
$23d8f6d1574ae23f$var$ar.inherits($23d8f6d1574ae23f$var$ce, $23d8f6d1574ae23f$var$gf);
var $23d8f6d1574ae23f$var$Af = $23d8f6d1574ae23f$var$ce;
$23d8f6d1574ae23f$var$ce.blockSize = 512, $23d8f6d1574ae23f$var$ce.outSize = 256, $23d8f6d1574ae23f$var$ce.hmacStrength = 192, $23d8f6d1574ae23f$var$ce.padLength = 64, $23d8f6d1574ae23f$var$ce.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $23d8f6d1574ae23f$var$Vs($23d8f6d1574ae23f$var$ra(i[n - 2]), i[n - 7], $23d8f6d1574ae23f$var$ea(i[n - 15]), i[n - 16]);
    var o = this.h[0], h = this.h[1], p = this.h[2], b = this.h[3], m = this.h[4], w = this.h[5], y = this.h[6], S = this.h[7];
    for($23d8f6d1574ae23f$var$Ys(this.k.length === i.length), n = 0; n < i.length; n++){
        var I = $23d8f6d1574ae23f$var$Ws(S, $23d8f6d1574ae23f$var$ta(m), $23d8f6d1574ae23f$var$Xs(m, w, y), this.k[n], i[n]), N = $23d8f6d1574ae23f$var$ie($23d8f6d1574ae23f$var$$s(o), $23d8f6d1574ae23f$var$Zs(o, h, p));
        S = y, y = w, w = m, m = $23d8f6d1574ae23f$var$ie(b, I), b = p, p = h, h = o, o = $23d8f6d1574ae23f$var$ie(I, N);
    }
    this.h[0] = $23d8f6d1574ae23f$var$ie(this.h[0], o), this.h[1] = $23d8f6d1574ae23f$var$ie(this.h[1], h), this.h[2] = $23d8f6d1574ae23f$var$ie(this.h[2], p), this.h[3] = $23d8f6d1574ae23f$var$ie(this.h[3], b), this.h[4] = $23d8f6d1574ae23f$var$ie(this.h[4], m), this.h[5] = $23d8f6d1574ae23f$var$ie(this.h[5], w), this.h[6] = $23d8f6d1574ae23f$var$ie(this.h[6], y), this.h[7] = $23d8f6d1574ae23f$var$ie(this.h[7], S);
}, $23d8f6d1574ae23f$var$ce.prototype._digest = function(t) {
    return t === "hex" ? $23d8f6d1574ae23f$var$ar.toHex32(this.h, "big") : $23d8f6d1574ae23f$var$ar.split32(this.h, "big");
};
var $23d8f6d1574ae23f$var$Bi = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$bf = $23d8f6d1574ae23f$var$Af;
function $23d8f6d1574ae23f$var$ye() {
    if (!(this instanceof $23d8f6d1574ae23f$var$ye)) return new $23d8f6d1574ae23f$var$ye;
    $23d8f6d1574ae23f$var$bf.call(this), this.h = [
        3238371032,
        914150663,
        812702999,
        4144912697,
        4290775857,
        1750603025,
        1694076839,
        3204075428
    ];
}
$23d8f6d1574ae23f$var$Bi.inherits($23d8f6d1574ae23f$var$ye, $23d8f6d1574ae23f$var$bf);
var $23d8f6d1574ae23f$var$na = $23d8f6d1574ae23f$var$ye;
$23d8f6d1574ae23f$var$ye.blockSize = 512, $23d8f6d1574ae23f$var$ye.outSize = 224, $23d8f6d1574ae23f$var$ye.hmacStrength = 192, $23d8f6d1574ae23f$var$ye.padLength = 64, $23d8f6d1574ae23f$var$ye.prototype._digest = function(t) {
    return t === "hex" ? $23d8f6d1574ae23f$var$Bi.toHex32(this.h.slice(0, 7), "big") : $23d8f6d1574ae23f$var$Bi.split32(this.h.slice(0, 7), "big");
};
var $23d8f6d1574ae23f$var$jt = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$fa = $23d8f6d1574ae23f$var$fr, $23d8f6d1574ae23f$var$oa = $23d8f6d1574ae23f$var$yr, $23d8f6d1574ae23f$var$le = $23d8f6d1574ae23f$var$jt.rotr64_hi, $23d8f6d1574ae23f$var$de = $23d8f6d1574ae23f$var$jt.rotr64_lo, $23d8f6d1574ae23f$var$yf = $23d8f6d1574ae23f$var$jt.shr64_hi, $23d8f6d1574ae23f$var$wf = $23d8f6d1574ae23f$var$jt.shr64_lo, $23d8f6d1574ae23f$var$Be = $23d8f6d1574ae23f$var$jt.sum64, $23d8f6d1574ae23f$var$Ci = $23d8f6d1574ae23f$var$jt.sum64_hi, $23d8f6d1574ae23f$var$Ri = $23d8f6d1574ae23f$var$jt.sum64_lo, $23d8f6d1574ae23f$var$sa = $23d8f6d1574ae23f$var$jt.sum64_4_hi, $23d8f6d1574ae23f$var$aa = $23d8f6d1574ae23f$var$jt.sum64_4_lo, $23d8f6d1574ae23f$var$ua = $23d8f6d1574ae23f$var$jt.sum64_5_hi, $23d8f6d1574ae23f$var$ha = $23d8f6d1574ae23f$var$jt.sum64_5_lo, $23d8f6d1574ae23f$var$xf = $23d8f6d1574ae23f$var$fa.BlockHash, $23d8f6d1574ae23f$var$ca = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
];
function $23d8f6d1574ae23f$var$ne() {
    if (!(this instanceof $23d8f6d1574ae23f$var$ne)) return new $23d8f6d1574ae23f$var$ne;
    $23d8f6d1574ae23f$var$xf.call(this), this.h = [
        1779033703,
        4089235720,
        3144134277,
        2227873595,
        1013904242,
        4271175723,
        2773480762,
        1595750129,
        1359893119,
        2917565137,
        2600822924,
        725511199,
        528734635,
        4215389547,
        1541459225,
        327033209
    ], this.k = $23d8f6d1574ae23f$var$ca, this.W = new Array(160);
}
$23d8f6d1574ae23f$var$jt.inherits($23d8f6d1574ae23f$var$ne, $23d8f6d1574ae23f$var$xf);
var $23d8f6d1574ae23f$var$Mf = $23d8f6d1574ae23f$var$ne;
$23d8f6d1574ae23f$var$ne.blockSize = 1024, $23d8f6d1574ae23f$var$ne.outSize = 512, $23d8f6d1574ae23f$var$ne.hmacStrength = 192, $23d8f6d1574ae23f$var$ne.padLength = 128, $23d8f6d1574ae23f$var$ne.prototype._prepareBlock = function(t, r) {
    for(var i = this.W, n = 0; n < 32; n++)i[n] = t[r + n];
    for(; n < i.length; n += 2){
        var o = $23d8f6d1574ae23f$var$xa(i[n - 4], i[n - 3]), h = $23d8f6d1574ae23f$var$Ma(i[n - 4], i[n - 3]), p = i[n - 14], b = i[n - 13], m = $23d8f6d1574ae23f$var$ya(i[n - 30], i[n - 29]), w = $23d8f6d1574ae23f$var$wa(i[n - 30], i[n - 29]), y = i[n - 32], S = i[n - 31];
        i[n] = $23d8f6d1574ae23f$var$sa(o, h, p, b, m, w, y, S), i[n + 1] = $23d8f6d1574ae23f$var$aa(o, h, p, b, m, w, y, S);
    }
}, $23d8f6d1574ae23f$var$ne.prototype._update = function(t, r) {
    this._prepareBlock(t, r);
    var i = this.W, n = this.h[0], o = this.h[1], h = this.h[2], p = this.h[3], b = this.h[4], m = this.h[5], w = this.h[6], y = this.h[7], S = this.h[8], I = this.h[9], N = this.h[10], C = this.h[11], F = this.h[12], U = this.h[13], J = this.h[14], Bt = this.h[15];
    $23d8f6d1574ae23f$var$oa(this.k.length === i.length);
    for(var G = 0; G < i.length; G += 2){
        var H = J, z = Bt, Pt = $23d8f6d1574ae23f$var$Aa(S, I), W = $23d8f6d1574ae23f$var$ba(S, I), Rt = $23d8f6d1574ae23f$var$la(S, I, N, C, F), Yt = $23d8f6d1574ae23f$var$da(S, I, N, C, F, U), Y = this.k[G], Vt = this.k[G + 1], A = i[G], f = i[G + 1], a = $23d8f6d1574ae23f$var$ua(H, z, Pt, W, Rt, Yt, Y, Vt, A, f), c = $23d8f6d1574ae23f$var$ha(H, z, Pt, W, Rt, Yt, Y, Vt, A, f);
        H = $23d8f6d1574ae23f$var$ma(n, o), z = $23d8f6d1574ae23f$var$ga(n, o), Pt = $23d8f6d1574ae23f$var$pa(n, o, h, p, b), W = $23d8f6d1574ae23f$var$va(n, o, h, p, b, m);
        var d = $23d8f6d1574ae23f$var$Ci(H, z, Pt, W), g = $23d8f6d1574ae23f$var$Ri(H, z, Pt, W);
        J = F, Bt = U, F = N, U = C, N = S, C = I, S = $23d8f6d1574ae23f$var$Ci(w, y, a, c), I = $23d8f6d1574ae23f$var$Ri(y, y, a, c), w = b, y = m, b = h, m = p, h = n, p = o, n = $23d8f6d1574ae23f$var$Ci(a, c, d, g), o = $23d8f6d1574ae23f$var$Ri(a, c, d, g);
    }
    $23d8f6d1574ae23f$var$Be(this.h, 0, n, o), $23d8f6d1574ae23f$var$Be(this.h, 2, h, p), $23d8f6d1574ae23f$var$Be(this.h, 4, b, m), $23d8f6d1574ae23f$var$Be(this.h, 6, w, y), $23d8f6d1574ae23f$var$Be(this.h, 8, S, I), $23d8f6d1574ae23f$var$Be(this.h, 10, N, C), $23d8f6d1574ae23f$var$Be(this.h, 12, F, U), $23d8f6d1574ae23f$var$Be(this.h, 14, J, Bt);
}, $23d8f6d1574ae23f$var$ne.prototype._digest = function(t) {
    return t === "hex" ? $23d8f6d1574ae23f$var$jt.toHex32(this.h, "big") : $23d8f6d1574ae23f$var$jt.split32(this.h, "big");
};
function $23d8f6d1574ae23f$var$la(e, t, r, i, n) {
    var o = e & r ^ ~e & n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$da(e, t, r, i, n, o) {
    var h = t & i ^ ~t & o;
    return h < 0 && (h += 4294967296), h;
}
function $23d8f6d1574ae23f$var$pa(e, t, r, i, n) {
    var o = e & r ^ e & n ^ r & n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$va(e, t, r, i, n, o) {
    var h = t & i ^ t & o ^ i & o;
    return h < 0 && (h += 4294967296), h;
}
function $23d8f6d1574ae23f$var$ma(e, t) {
    var r = $23d8f6d1574ae23f$var$le(e, t, 28), i = $23d8f6d1574ae23f$var$le(t, e, 2), n = $23d8f6d1574ae23f$var$le(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$ga(e, t) {
    var r = $23d8f6d1574ae23f$var$de(e, t, 28), i = $23d8f6d1574ae23f$var$de(t, e, 2), n = $23d8f6d1574ae23f$var$de(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$Aa(e, t) {
    var r = $23d8f6d1574ae23f$var$le(e, t, 14), i = $23d8f6d1574ae23f$var$le(e, t, 18), n = $23d8f6d1574ae23f$var$le(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$ba(e, t) {
    var r = $23d8f6d1574ae23f$var$de(e, t, 14), i = $23d8f6d1574ae23f$var$de(e, t, 18), n = $23d8f6d1574ae23f$var$de(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$ya(e, t) {
    var r = $23d8f6d1574ae23f$var$le(e, t, 1), i = $23d8f6d1574ae23f$var$le(e, t, 8), n = $23d8f6d1574ae23f$var$yf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$wa(e, t) {
    var r = $23d8f6d1574ae23f$var$de(e, t, 1), i = $23d8f6d1574ae23f$var$de(e, t, 8), n = $23d8f6d1574ae23f$var$wf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$xa(e, t) {
    var r = $23d8f6d1574ae23f$var$le(e, t, 19), i = $23d8f6d1574ae23f$var$le(t, e, 29), n = $23d8f6d1574ae23f$var$yf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $23d8f6d1574ae23f$var$Ma(e, t) {
    var r = $23d8f6d1574ae23f$var$de(e, t, 19), i = $23d8f6d1574ae23f$var$de(t, e, 29), n = $23d8f6d1574ae23f$var$wf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
var $23d8f6d1574ae23f$var$Oi = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$Ef = $23d8f6d1574ae23f$var$Mf;
function $23d8f6d1574ae23f$var$we() {
    if (!(this instanceof $23d8f6d1574ae23f$var$we)) return new $23d8f6d1574ae23f$var$we;
    $23d8f6d1574ae23f$var$Ef.call(this), this.h = [
        3418070365,
        3238371032,
        1654270250,
        914150663,
        2438529370,
        812702999,
        355462360,
        4144912697,
        1731405415,
        4290775857,
        2394180231,
        1750603025,
        3675008525,
        1694076839,
        1203062813,
        3204075428
    ];
}
$23d8f6d1574ae23f$var$Oi.inherits($23d8f6d1574ae23f$var$we, $23d8f6d1574ae23f$var$Ef);
var $23d8f6d1574ae23f$var$Ea = $23d8f6d1574ae23f$var$we;
$23d8f6d1574ae23f$var$we.blockSize = 1024, $23d8f6d1574ae23f$var$we.outSize = 384, $23d8f6d1574ae23f$var$we.hmacStrength = 192, $23d8f6d1574ae23f$var$we.padLength = 128, $23d8f6d1574ae23f$var$we.prototype._digest = function(t) {
    return t === "hex" ? $23d8f6d1574ae23f$var$Oi.toHex32(this.h.slice(0, 12), "big") : $23d8f6d1574ae23f$var$Oi.split32(this.h.slice(0, 12), "big");
}, $23d8f6d1574ae23f$var$or.sha1 = $23d8f6d1574ae23f$var$Js, $23d8f6d1574ae23f$var$or.sha224 = $23d8f6d1574ae23f$var$na, $23d8f6d1574ae23f$var$or.sha256 = $23d8f6d1574ae23f$var$Af, $23d8f6d1574ae23f$var$or.sha384 = $23d8f6d1574ae23f$var$Ea, $23d8f6d1574ae23f$var$or.sha512 = $23d8f6d1574ae23f$var$Mf;
var $23d8f6d1574ae23f$var$Sf = {}, $23d8f6d1574ae23f$var$Xe = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$Sa = $23d8f6d1574ae23f$var$fr, $23d8f6d1574ae23f$var$Tr = $23d8f6d1574ae23f$var$Xe.rotl32, $23d8f6d1574ae23f$var$Nf = $23d8f6d1574ae23f$var$Xe.sum32, $23d8f6d1574ae23f$var$xr = $23d8f6d1574ae23f$var$Xe.sum32_3, $23d8f6d1574ae23f$var$If = $23d8f6d1574ae23f$var$Xe.sum32_4, $23d8f6d1574ae23f$var$_f = $23d8f6d1574ae23f$var$Sa.BlockHash;
function $23d8f6d1574ae23f$var$pe() {
    if (!(this instanceof $23d8f6d1574ae23f$var$pe)) return new $23d8f6d1574ae23f$var$pe;
    $23d8f6d1574ae23f$var$_f.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.endian = "little";
}
$23d8f6d1574ae23f$var$Xe.inherits($23d8f6d1574ae23f$var$pe, $23d8f6d1574ae23f$var$_f), $23d8f6d1574ae23f$var$Sf.ripemd160 = $23d8f6d1574ae23f$var$pe, $23d8f6d1574ae23f$var$pe.blockSize = 512, $23d8f6d1574ae23f$var$pe.outSize = 160, $23d8f6d1574ae23f$var$pe.hmacStrength = 192, $23d8f6d1574ae23f$var$pe.padLength = 64, $23d8f6d1574ae23f$var$pe.prototype._update = function(t, r) {
    for(var i = this.h[0], n = this.h[1], o = this.h[2], h = this.h[3], p = this.h[4], b = i, m = n, w = o, y = h, S = p, I = 0; I < 80; I++){
        var N = $23d8f6d1574ae23f$var$Nf($23d8f6d1574ae23f$var$Tr($23d8f6d1574ae23f$var$If(i, $23d8f6d1574ae23f$var$Bf(I, n, o, h), t[$23d8f6d1574ae23f$var$_a[I] + r], $23d8f6d1574ae23f$var$Na(I)), $23d8f6d1574ae23f$var$Ca[I]), p);
        i = p, p = h, h = $23d8f6d1574ae23f$var$Tr(o, 10), o = n, n = N, N = $23d8f6d1574ae23f$var$Nf($23d8f6d1574ae23f$var$Tr($23d8f6d1574ae23f$var$If(b, $23d8f6d1574ae23f$var$Bf(79 - I, m, w, y), t[$23d8f6d1574ae23f$var$Ba[I] + r], $23d8f6d1574ae23f$var$Ia(I)), $23d8f6d1574ae23f$var$Ra[I]), S), b = S, S = y, y = $23d8f6d1574ae23f$var$Tr(w, 10), w = m, m = N;
    }
    N = $23d8f6d1574ae23f$var$xr(this.h[1], o, y), this.h[1] = $23d8f6d1574ae23f$var$xr(this.h[2], h, S), this.h[2] = $23d8f6d1574ae23f$var$xr(this.h[3], p, b), this.h[3] = $23d8f6d1574ae23f$var$xr(this.h[4], i, m), this.h[4] = $23d8f6d1574ae23f$var$xr(this.h[0], n, w), this.h[0] = N;
}, $23d8f6d1574ae23f$var$pe.prototype._digest = function(t) {
    return t === "hex" ? $23d8f6d1574ae23f$var$Xe.toHex32(this.h, "little") : $23d8f6d1574ae23f$var$Xe.split32(this.h, "little");
};
function $23d8f6d1574ae23f$var$Bf(e, t, r, i) {
    return e <= 15 ? t ^ r ^ i : e <= 31 ? t & r | ~t & i : e <= 47 ? (t | ~r) ^ i : e <= 63 ? t & i | r & ~i : t ^ (r | ~i);
}
function $23d8f6d1574ae23f$var$Na(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function $23d8f6d1574ae23f$var$Ia(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var $23d8f6d1574ae23f$var$_a = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
], $23d8f6d1574ae23f$var$Ba = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
], $23d8f6d1574ae23f$var$Ca = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
], $23d8f6d1574ae23f$var$Ra = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
], $23d8f6d1574ae23f$var$Oa = $23d8f6d1574ae23f$var$Q, $23d8f6d1574ae23f$var$Pa = $23d8f6d1574ae23f$var$yr;
function $23d8f6d1574ae23f$var$hr(e, t, r) {
    if (!(this instanceof $23d8f6d1574ae23f$var$hr)) return new $23d8f6d1574ae23f$var$hr(e, t, r);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init($23d8f6d1574ae23f$var$Oa.toArray(t, r));
}
var $23d8f6d1574ae23f$var$Da = $23d8f6d1574ae23f$var$hr;
$23d8f6d1574ae23f$var$hr.prototype._init = function(t) {
    t.length > this.blockSize && (t = new this.Hash().update(t).digest()), $23d8f6d1574ae23f$var$Pa(t.length <= this.blockSize);
    for(var r = t.length; r < this.blockSize; r++)t.push(0);
    for(r = 0; r < t.length; r++)t[r] ^= 54;
    for(this.inner = new this.Hash().update(t), r = 0; r < t.length; r++)t[r] ^= 106;
    this.outer = new this.Hash().update(t);
}, $23d8f6d1574ae23f$var$hr.prototype.update = function(t, r) {
    return this.inner.update(t, r), this;
}, $23d8f6d1574ae23f$var$hr.prototype.digest = function(t) {
    return this.outer.update(this.inner.digest()), this.outer.digest(t);
}, function(e) {
    var t = e;
    t.utils = $23d8f6d1574ae23f$var$Q, t.common = $23d8f6d1574ae23f$var$fr, t.sha = $23d8f6d1574ae23f$var$or, t.ripemd = $23d8f6d1574ae23f$var$Sf, t.hmac = $23d8f6d1574ae23f$var$Da, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
}($23d8f6d1574ae23f$var$se);
function $23d8f6d1574ae23f$var$cr(e, t, r) {
    return r = {
        path: t,
        exports: {},
        require: function(i, n) {
            return $23d8f6d1574ae23f$var$Fa(i, n ?? r.path);
        }
    }, e(r, r.exports), r.exports;
}
function $23d8f6d1574ae23f$var$Fa() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $23d8f6d1574ae23f$var$Pi = $23d8f6d1574ae23f$var$Cf;
function $23d8f6d1574ae23f$var$Cf(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$23d8f6d1574ae23f$var$Cf.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $23d8f6d1574ae23f$var$fe = $23d8f6d1574ae23f$var$cr(function(e, t) {
    var r = t;
    function i(h, p) {
        if (Array.isArray(h)) return h.slice();
        if (!h) return [];
        var b = [];
        if (typeof h != "string") {
            for(var m = 0; m < h.length; m++)b[m] = h[m] | 0;
            return b;
        }
        if (p === "hex") {
            h = h.replace(/[^a-z0-9]+/ig, ""), h.length % 2 !== 0 && (h = "0" + h);
            for(var m = 0; m < h.length; m += 2)b.push(parseInt(h[m] + h[m + 1], 16));
        } else for(var m = 0; m < h.length; m++){
            var w = h.charCodeAt(m), y = w >> 8, S = w & 255;
            y ? b.push(y, S) : b.push(S);
        }
        return b;
    }
    r.toArray = i;
    function n(h) {
        return h.length === 1 ? "0" + h : h;
    }
    r.zero2 = n;
    function o(h) {
        for(var p = "", b = 0; b < h.length; b++)p += n(h[b].toString(16));
        return p;
    }
    r.toHex = o, r.encode = function(p, b) {
        return b === "hex" ? o(p) : p;
    };
}), $23d8f6d1574ae23f$var$Jt = $23d8f6d1574ae23f$var$cr(function(e, t) {
    var r = t;
    r.assert = $23d8f6d1574ae23f$var$Pi, r.toArray = $23d8f6d1574ae23f$var$fe.toArray, r.zero2 = $23d8f6d1574ae23f$var$fe.zero2, r.toHex = $23d8f6d1574ae23f$var$fe.toHex, r.encode = $23d8f6d1574ae23f$var$fe.encode;
    function i(b, m, w) {
        var y = new Array(Math.max(b.bitLength(), w) + 1);
        y.fill(0);
        for(var S = 1 << m + 1, I = b.clone(), N = 0; N < y.length; N++){
            var C, F = I.andln(S - 1);
            I.isOdd() ? (F > (S >> 1) - 1 ? C = (S >> 1) - F : C = F, I.isubn(C)) : C = 0, y[N] = C, I.iushrn(1);
        }
        return y;
    }
    r.getNAF = i;
    function n(b, m) {
        var w = [
            [],
            []
        ];
        b = b.clone(), m = m.clone();
        for(var y = 0, S = 0, I; b.cmpn(-y) > 0 || m.cmpn(-S) > 0;){
            var N = b.andln(3) + y & 3, C = m.andln(3) + S & 3;
            N === 3 && (N = -1), C === 3 && (C = -1);
            var F;
            N & 1 ? (I = b.andln(7) + y & 7, (I === 3 || I === 5) && C === 2 ? F = -N : F = N) : F = 0, w[0].push(F);
            var U;
            C & 1 ? (I = m.andln(7) + S & 7, (I === 3 || I === 5) && N === 2 ? U = -C : U = C) : U = 0, w[1].push(U), 2 * y === F + 1 && (y = 1 - y), 2 * S === U + 1 && (S = 1 - S), b.iushrn(1), m.iushrn(1);
        }
        return w;
    }
    r.getJSF = n;
    function o(b, m, w) {
        var y = "_" + m;
        b.prototype[m] = function() {
            return this[y] !== void 0 ? this[y] : this[y] = w.call(this);
        };
    }
    r.cachedProperty = o;
    function h(b) {
        return typeof b == "string" ? r.toArray(b, "hex") : b;
    }
    r.parseBytes = h;
    function p(b) {
        return new $23d8f6d1574ae23f$var$K(b, "hex", "le");
    }
    r.intFromLE = p;
}), $23d8f6d1574ae23f$var$Ur = $23d8f6d1574ae23f$var$Jt.getNAF, $23d8f6d1574ae23f$var$Ta = $23d8f6d1574ae23f$var$Jt.getJSF, $23d8f6d1574ae23f$var$kr = $23d8f6d1574ae23f$var$Jt.assert;
function $23d8f6d1574ae23f$var$Ce(e, t) {
    this.type = e, this.p = new $23d8f6d1574ae23f$var$K(t.p, 16), this.red = t.prime ? $23d8f6d1574ae23f$var$K.red(t.prime) : $23d8f6d1574ae23f$var$K.mont(this.p), this.zero = new $23d8f6d1574ae23f$var$K(0).toRed(this.red), this.one = new $23d8f6d1574ae23f$var$K(1).toRed(this.red), this.two = new $23d8f6d1574ae23f$var$K(2).toRed(this.red), this.n = t.n && new $23d8f6d1574ae23f$var$K(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var r = this.n && this.p.div(this.n);
    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var $23d8f6d1574ae23f$var$Ze = $23d8f6d1574ae23f$var$Ce;
$23d8f6d1574ae23f$var$Ce.prototype.point = function() {
    throw new Error("Not implemented");
}, $23d8f6d1574ae23f$var$Ce.prototype.validate = function() {
    throw new Error("Not implemented");
}, $23d8f6d1574ae23f$var$Ce.prototype._fixedNafMul = function(t, r) {
    $23d8f6d1574ae23f$var$kr(t.precomputed);
    var i = t._getDoubles(), n = $23d8f6d1574ae23f$var$Ur(r, 1, this._bitLength), o = (1 << i.step + 1) - (i.step % 2 === 0 ? 2 : 1);
    o /= 3;
    var h = [], p, b;
    for(p = 0; p < n.length; p += i.step){
        b = 0;
        for(var m = p + i.step - 1; m >= p; m--)b = (b << 1) + n[m];
        h.push(b);
    }
    for(var w = this.jpoint(null, null, null), y = this.jpoint(null, null, null), S = o; S > 0; S--){
        for(p = 0; p < h.length; p++)b = h[p], b === S ? y = y.mixedAdd(i.points[p]) : b === -S && (y = y.mixedAdd(i.points[p].neg()));
        w = w.add(y);
    }
    return w.toP();
}, $23d8f6d1574ae23f$var$Ce.prototype._wnafMul = function(t, r) {
    var i = 4, n = t._getNAFPoints(i);
    i = n.wnd;
    for(var o = n.points, h = $23d8f6d1574ae23f$var$Ur(r, i, this._bitLength), p = this.jpoint(null, null, null), b = h.length - 1; b >= 0; b--){
        for(var m = 0; b >= 0 && h[b] === 0; b--)m++;
        if (b >= 0 && m++, p = p.dblp(m), b < 0) break;
        var w = h[b];
        $23d8f6d1574ae23f$var$kr(w !== 0), t.type === "affine" ? w > 0 ? p = p.mixedAdd(o[w - 1 >> 1]) : p = p.mixedAdd(o[-w - 1 >> 1].neg()) : w > 0 ? p = p.add(o[w - 1 >> 1]) : p = p.add(o[-w - 1 >> 1].neg());
    }
    return t.type === "affine" ? p.toP() : p;
}, $23d8f6d1574ae23f$var$Ce.prototype._wnafMulAdd = function(t, r, i, n, o) {
    var h = this._wnafT1, p = this._wnafT2, b = this._wnafT3, m = 0, w, y, S;
    for(w = 0; w < n; w++){
        S = r[w];
        var I = S._getNAFPoints(t);
        h[w] = I.wnd, p[w] = I.points;
    }
    for(w = n - 1; w >= 1; w -= 2){
        var N = w - 1, C = w;
        if (h[N] !== 1 || h[C] !== 1) {
            b[N] = $23d8f6d1574ae23f$var$Ur(i[N], h[N], this._bitLength), b[C] = $23d8f6d1574ae23f$var$Ur(i[C], h[C], this._bitLength), m = Math.max(b[N].length, m), m = Math.max(b[C].length, m);
            continue;
        }
        var F = [
            r[N],
            null,
            null,
            r[C]
        ];
        r[N].y.cmp(r[C].y) === 0 ? (F[1] = r[N].add(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg())) : r[N].y.cmp(r[C].y.redNeg()) === 0 ? (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].add(r[C].neg())) : (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg()));
        var U = [
            -3,
            -1,
            -5,
            -7,
            0,
            7,
            5,
            1,
            3
        ], J = $23d8f6d1574ae23f$var$Ta(i[N], i[C]);
        for(m = Math.max(J[0].length, m), b[N] = new Array(m), b[C] = new Array(m), y = 0; y < m; y++){
            var Bt = J[0][y] | 0, G = J[1][y] | 0;
            b[N][y] = U[(Bt + 1) * 3 + (G + 1)], b[C][y] = 0, p[N] = F;
        }
    }
    var H = this.jpoint(null, null, null), z = this._wnafT4;
    for(w = m; w >= 0; w--){
        for(var Pt = 0; w >= 0;){
            var W = !0;
            for(y = 0; y < n; y++)z[y] = b[y][w] | 0, z[y] !== 0 && (W = !1);
            if (!W) break;
            Pt++, w--;
        }
        if (w >= 0 && Pt++, H = H.dblp(Pt), w < 0) break;
        for(y = 0; y < n; y++){
            var Rt = z[y];
            Rt !== 0 && (Rt > 0 ? S = p[y][Rt - 1 >> 1] : Rt < 0 && (S = p[y][-Rt - 1 >> 1].neg()), S.type === "affine" ? H = H.mixedAdd(S) : H = H.add(S));
        }
    }
    for(w = 0; w < n; w++)p[w] = null;
    return o ? H : H.toP();
};
function $23d8f6d1574ae23f$var$Xt(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
}
$23d8f6d1574ae23f$var$Ce.BasePoint = $23d8f6d1574ae23f$var$Xt, $23d8f6d1574ae23f$var$Xt.prototype.eq = function() {
    throw new Error("Not implemented");
}, $23d8f6d1574ae23f$var$Xt.prototype.validate = function() {
    return this.curve.validate(this);
}, $23d8f6d1574ae23f$var$Ce.prototype.decodePoint = function(t, r) {
    t = $23d8f6d1574ae23f$var$Jt.toArray(t, r);
    var i = this.p.byteLength();
    if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * i) {
        t[0] === 6 ? $23d8f6d1574ae23f$var$kr(t[t.length - 1] % 2 === 0) : t[0] === 7 && $23d8f6d1574ae23f$var$kr(t[t.length - 1] % 2 === 1);
        var n = this.point(t.slice(1, 1 + i), t.slice(1 + i, 1 + 2 * i));
        return n;
    } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === i) return this.pointFromX(t.slice(1, 1 + i), t[0] === 3);
    throw new Error("Unknown point format");
}, $23d8f6d1574ae23f$var$Xt.prototype.encodeCompressed = function(t) {
    return this.encode(t, !0);
}, $23d8f6d1574ae23f$var$Xt.prototype._encode = function(t) {
    var r = this.curve.p.byteLength(), i = this.getX().toArray("be", r);
    return t ? [
        this.getY().isEven() ? 2 : 3
    ].concat(i) : [
        4
    ].concat(i, this.getY().toArray("be", r));
}, $23d8f6d1574ae23f$var$Xt.prototype.encode = function(t, r) {
    return $23d8f6d1574ae23f$var$Jt.encode(this._encode(r), t);
}, $23d8f6d1574ae23f$var$Xt.prototype.precompute = function(t) {
    if (this.precomputed) return this;
    var r = {
        doubles: null,
        naf: null,
        beta: null
    };
    return r.naf = this._getNAFPoints(8), r.doubles = this._getDoubles(4, t), r.beta = this._getBeta(), this.precomputed = r, this;
}, $23d8f6d1574ae23f$var$Xt.prototype._hasDoubles = function(t) {
    if (!this.precomputed) return !1;
    var r = this.precomputed.doubles;
    return r ? r.points.length >= Math.ceil((t.bitLength() + 1) / r.step) : !1;
}, $23d8f6d1574ae23f$var$Xt.prototype._getDoubles = function(t, r) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    for(var i = [
        this
    ], n = this, o = 0; o < r; o += t){
        for(var h = 0; h < t; h++)n = n.dbl();
        i.push(n);
    }
    return {
        step: t,
        points: i
    };
}, $23d8f6d1574ae23f$var$Xt.prototype._getNAFPoints = function(t) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    for(var r = [
        this
    ], i = (1 << t) - 1, n = i === 1 ? null : this.dbl(), o = 1; o < i; o++)r[o] = r[o - 1].add(n);
    return {
        wnd: t,
        points: r
    };
}, $23d8f6d1574ae23f$var$Xt.prototype._getBeta = function() {
    return null;
}, $23d8f6d1574ae23f$var$Xt.prototype.dblp = function(t) {
    for(var r = this, i = 0; i < t; i++)r = r.dbl();
    return r;
};
var $23d8f6d1574ae23f$var$Di = $23d8f6d1574ae23f$var$cr(function(e) {
    typeof Object.create == "function" ? e.exports = function(r, i) {
        i && (r.super_ = i, r.prototype = Object.create(i.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }));
    } : e.exports = function(r, i) {
        if (i) {
            r.super_ = i;
            var n = function() {};
            n.prototype = i.prototype, r.prototype = new n, r.prototype.constructor = r;
        }
    };
}), $23d8f6d1574ae23f$var$Ua = $23d8f6d1574ae23f$var$Jt.assert;
function $23d8f6d1574ae23f$var$Zt(e) {
    $23d8f6d1574ae23f$var$Ze.call(this, "short", e), this.a = new $23d8f6d1574ae23f$var$K(e.a, 16).toRed(this.red), this.b = new $23d8f6d1574ae23f$var$K(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
$23d8f6d1574ae23f$var$Di($23d8f6d1574ae23f$var$Zt, $23d8f6d1574ae23f$var$Ze);
var $23d8f6d1574ae23f$var$ka = $23d8f6d1574ae23f$var$Zt;
$23d8f6d1574ae23f$var$Zt.prototype._getEndomorphism = function(t) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
        var r, i;
        if (t.beta) r = new $23d8f6d1574ae23f$var$K(t.beta, 16).toRed(this.red);
        else {
            var n = this._getEndoRoots(this.p);
            r = n[0].cmp(n[1]) < 0 ? n[0] : n[1], r = r.toRed(this.red);
        }
        if (t.lambda) i = new $23d8f6d1574ae23f$var$K(t.lambda, 16);
        else {
            var o = this._getEndoRoots(this.n);
            this.g.mul(o[0]).x.cmp(this.g.x.redMul(r)) === 0 ? i = o[0] : (i = o[1], $23d8f6d1574ae23f$var$Ua(this.g.mul(i).x.cmp(this.g.x.redMul(r)) === 0));
        }
        var h;
        return t.basis ? h = t.basis.map(function(p) {
            return {
                a: new $23d8f6d1574ae23f$var$K(p.a, 16),
                b: new $23d8f6d1574ae23f$var$K(p.b, 16)
            };
        }) : h = this._getEndoBasis(i), {
            beta: r,
            lambda: i,
            basis: h
        };
    }
}, $23d8f6d1574ae23f$var$Zt.prototype._getEndoRoots = function(t) {
    var r = t === this.p ? this.red : $23d8f6d1574ae23f$var$K.mont(t), i = new $23d8f6d1574ae23f$var$K(2).toRed(r).redInvm(), n = i.redNeg(), o = new $23d8f6d1574ae23f$var$K(3).toRed(r).redNeg().redSqrt().redMul(i), h = n.redAdd(o).fromRed(), p = n.redSub(o).fromRed();
    return [
        h,
        p
    ];
}, $23d8f6d1574ae23f$var$Zt.prototype._getEndoBasis = function(t) {
    for(var r = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), i = t, n = this.n.clone(), o = new $23d8f6d1574ae23f$var$K(1), h = new $23d8f6d1574ae23f$var$K(0), p = new $23d8f6d1574ae23f$var$K(0), b = new $23d8f6d1574ae23f$var$K(1), m, w, y, S, I, N, C, F = 0, U, J; i.cmpn(0) !== 0;){
        var Bt = n.div(i);
        U = n.sub(Bt.mul(i)), J = p.sub(Bt.mul(o));
        var G = b.sub(Bt.mul(h));
        if (!y && U.cmp(r) < 0) m = C.neg(), w = o, y = U.neg(), S = J;
        else if (y && ++F === 2) break;
        C = U, n = i, i = U, p = o, o = J, b = h, h = G;
    }
    I = U.neg(), N = J;
    var H = y.sqr().add(S.sqr()), z = I.sqr().add(N.sqr());
    return z.cmp(H) >= 0 && (I = m, N = w), y.negative && (y = y.neg(), S = S.neg()), I.negative && (I = I.neg(), N = N.neg()), [
        {
            a: y,
            b: S
        },
        {
            a: I,
            b: N
        }
    ];
}, $23d8f6d1574ae23f$var$Zt.prototype._endoSplit = function(t) {
    var r = this.endo.basis, i = r[0], n = r[1], o = n.b.mul(t).divRound(this.n), h = i.b.neg().mul(t).divRound(this.n), p = o.mul(i.a), b = h.mul(n.a), m = o.mul(i.b), w = h.mul(n.b), y = t.sub(p).sub(b), S = m.add(w).neg();
    return {
        k1: y,
        k2: S
    };
}, $23d8f6d1574ae23f$var$Zt.prototype.pointFromX = function(t, r) {
    t = new $23d8f6d1574ae23f$var$K(t, 16), t.red || (t = t.toRed(this.red));
    var i = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), n = i.redSqrt();
    if (n.redSqr().redSub(i).cmp(this.zero) !== 0) throw new Error("invalid point");
    var o = n.fromRed().isOdd();
    return (r && !o || !r && o) && (n = n.redNeg()), this.point(t, n);
}, $23d8f6d1574ae23f$var$Zt.prototype.validate = function(t) {
    if (t.inf) return !0;
    var r = t.x, i = t.y, n = this.a.redMul(r), o = r.redSqr().redMul(r).redIAdd(n).redIAdd(this.b);
    return i.redSqr().redISub(o).cmpn(0) === 0;
}, $23d8f6d1574ae23f$var$Zt.prototype._endoWnafMulAdd = function(t, r, i) {
    for(var n = this._endoWnafT1, o = this._endoWnafT2, h = 0; h < t.length; h++){
        var p = this._endoSplit(r[h]), b = t[h], m = b._getBeta();
        p.k1.negative && (p.k1.ineg(), b = b.neg(!0)), p.k2.negative && (p.k2.ineg(), m = m.neg(!0)), n[h * 2] = b, n[h * 2 + 1] = m, o[h * 2] = p.k1, o[h * 2 + 1] = p.k2;
    }
    for(var w = this._wnafMulAdd(1, n, o, h * 2, i), y = 0; y < h * 2; y++)n[y] = null, o[y] = null;
    return w;
};
function $23d8f6d1574ae23f$var$Ft(e, t, r, i) {
    $23d8f6d1574ae23f$var$Ze.BasePoint.call(this, e, "affine"), t === null && r === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new $23d8f6d1574ae23f$var$K(t, 16), this.y = new $23d8f6d1574ae23f$var$K(r, 16), i && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
$23d8f6d1574ae23f$var$Di($23d8f6d1574ae23f$var$Ft, $23d8f6d1574ae23f$var$Ze.BasePoint), $23d8f6d1574ae23f$var$Zt.prototype.point = function(t, r, i) {
    return new $23d8f6d1574ae23f$var$Ft(this, t, r, i);
}, $23d8f6d1574ae23f$var$Zt.prototype.pointFromJSON = function(t, r) {
    return $23d8f6d1574ae23f$var$Ft.fromJSON(this, t, r);
}, $23d8f6d1574ae23f$var$Ft.prototype._getBeta = function() {
    if (this.curve.endo) {
        var t = this.precomputed;
        if (t && t.beta) return t.beta;
        var r = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (t) {
            var i = this.curve, n = function(o) {
                return i.point(o.x.redMul(i.endo.beta), o.y);
            };
            t.beta = r, r.precomputed = {
                beta: null,
                naf: t.naf && {
                    wnd: t.naf.wnd,
                    points: t.naf.points.map(n)
                },
                doubles: t.doubles && {
                    step: t.doubles.step,
                    points: t.doubles.points.map(n)
                }
            };
        }
        return r;
    }
}, $23d8f6d1574ae23f$var$Ft.prototype.toJSON = function() {
    return this.precomputed ? [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ] : [
        this.x,
        this.y
    ];
}, $23d8f6d1574ae23f$var$Ft.fromJSON = function(t, r, i) {
    typeof r == "string" && (r = JSON.parse(r));
    var n = t.point(r[0], r[1], i);
    if (!r[2]) return n;
    function o(p) {
        return t.point(p[0], p[1], i);
    }
    var h = r[2];
    return n.precomputed = {
        beta: null,
        doubles: h.doubles && {
            step: h.doubles.step,
            points: [
                n
            ].concat(h.doubles.points.map(o))
        },
        naf: h.naf && {
            wnd: h.naf.wnd,
            points: [
                n
            ].concat(h.naf.points.map(o))
        }
    }, n;
}, $23d8f6d1574ae23f$var$Ft.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
}, $23d8f6d1574ae23f$var$Ft.prototype.isInfinity = function() {
    return this.inf;
}, $23d8f6d1574ae23f$var$Ft.prototype.add = function(t) {
    if (this.inf) return t;
    if (t.inf) return this;
    if (this.eq(t)) return this.dbl();
    if (this.neg().eq(t)) return this.curve.point(null, null);
    if (this.x.cmp(t.x) === 0) return this.curve.point(null, null);
    var r = this.y.redSub(t.y);
    r.cmpn(0) !== 0 && (r = r.redMul(this.x.redSub(t.x).redInvm()));
    var i = r.redSqr().redISub(this.x).redISub(t.x), n = r.redMul(this.x.redSub(i)).redISub(this.y);
    return this.curve.point(i, n);
}, $23d8f6d1574ae23f$var$Ft.prototype.dbl = function() {
    if (this.inf) return this;
    var t = this.y.redAdd(this.y);
    if (t.cmpn(0) === 0) return this.curve.point(null, null);
    var r = this.curve.a, i = this.x.redSqr(), n = t.redInvm(), o = i.redAdd(i).redIAdd(i).redIAdd(r).redMul(n), h = o.redSqr().redISub(this.x.redAdd(this.x)), p = o.redMul(this.x.redSub(h)).redISub(this.y);
    return this.curve.point(h, p);
}, $23d8f6d1574ae23f$var$Ft.prototype.getX = function() {
    return this.x.fromRed();
}, $23d8f6d1574ae23f$var$Ft.prototype.getY = function() {
    return this.y.fromRed();
}, $23d8f6d1574ae23f$var$Ft.prototype.mul = function(t) {
    return t = new $23d8f6d1574ae23f$var$K(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([
        this
    ], [
        t
    ]) : this.curve._wnafMul(this, t);
}, $23d8f6d1574ae23f$var$Ft.prototype.mulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o) : this.curve._wnafMulAdd(1, n, o, 2);
}, $23d8f6d1574ae23f$var$Ft.prototype.jmulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o, !0) : this.curve._wnafMulAdd(1, n, o, 2, !0);
}, $23d8f6d1574ae23f$var$Ft.prototype.eq = function(t) {
    return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
}, $23d8f6d1574ae23f$var$Ft.prototype.neg = function(t) {
    if (this.inf) return this;
    var r = this.curve.point(this.x, this.y.redNeg());
    if (t && this.precomputed) {
        var i = this.precomputed, n = function(o) {
            return o.neg();
        };
        r.precomputed = {
            naf: i.naf && {
                wnd: i.naf.wnd,
                points: i.naf.points.map(n)
            },
            doubles: i.doubles && {
                step: i.doubles.step,
                points: i.doubles.points.map(n)
            }
        };
    }
    return r;
}, $23d8f6d1574ae23f$var$Ft.prototype.toJ = function() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var t = this.curve.jpoint(this.x, this.y, this.curve.one);
    return t;
};
function $23d8f6d1574ae23f$var$Tt(e, t, r, i) {
    $23d8f6d1574ae23f$var$Ze.BasePoint.call(this, e, "jacobian"), t === null && r === null && i === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new $23d8f6d1574ae23f$var$K(0)) : (this.x = new $23d8f6d1574ae23f$var$K(t, 16), this.y = new $23d8f6d1574ae23f$var$K(r, 16), this.z = new $23d8f6d1574ae23f$var$K(i, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
$23d8f6d1574ae23f$var$Di($23d8f6d1574ae23f$var$Tt, $23d8f6d1574ae23f$var$Ze.BasePoint), $23d8f6d1574ae23f$var$Zt.prototype.jpoint = function(t, r, i) {
    return new $23d8f6d1574ae23f$var$Tt(this, t, r, i);
}, $23d8f6d1574ae23f$var$Tt.prototype.toP = function() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var t = this.z.redInvm(), r = t.redSqr(), i = this.x.redMul(r), n = this.y.redMul(r).redMul(t);
    return this.curve.point(i, n);
}, $23d8f6d1574ae23f$var$Tt.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
}, $23d8f6d1574ae23f$var$Tt.prototype.add = function(t) {
    if (this.isInfinity()) return t;
    if (t.isInfinity()) return this;
    var r = t.z.redSqr(), i = this.z.redSqr(), n = this.x.redMul(r), o = t.x.redMul(i), h = this.y.redMul(r.redMul(t.z)), p = t.y.redMul(i.redMul(this.z)), b = n.redSub(o), m = h.redSub(p);
    if (b.cmpn(0) === 0) return m.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var w = b.redSqr(), y = w.redMul(b), S = n.redMul(w), I = m.redSqr().redIAdd(y).redISub(S).redISub(S), N = m.redMul(S.redISub(I)).redISub(h.redMul(y)), C = this.z.redMul(t.z).redMul(b);
    return this.curve.jpoint(I, N, C);
}, $23d8f6d1574ae23f$var$Tt.prototype.mixedAdd = function(t) {
    if (this.isInfinity()) return t.toJ();
    if (t.isInfinity()) return this;
    var r = this.z.redSqr(), i = this.x, n = t.x.redMul(r), o = this.y, h = t.y.redMul(r).redMul(this.z), p = i.redSub(n), b = o.redSub(h);
    if (p.cmpn(0) === 0) return b.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var m = p.redSqr(), w = m.redMul(p), y = i.redMul(m), S = b.redSqr().redIAdd(w).redISub(y).redISub(y), I = b.redMul(y.redISub(S)).redISub(o.redMul(w)), N = this.z.redMul(p);
    return this.curve.jpoint(S, I, N);
}, $23d8f6d1574ae23f$var$Tt.prototype.dblp = function(t) {
    if (t === 0) return this;
    if (this.isInfinity()) return this;
    if (!t) return this.dbl();
    var r;
    if (this.curve.zeroA || this.curve.threeA) {
        var i = this;
        for(r = 0; r < t; r++)i = i.dbl();
        return i;
    }
    var n = this.curve.a, o = this.curve.tinv, h = this.x, p = this.y, b = this.z, m = b.redSqr().redSqr(), w = p.redAdd(p);
    for(r = 0; r < t; r++){
        var y = h.redSqr(), S = w.redSqr(), I = S.redSqr(), N = y.redAdd(y).redIAdd(y).redIAdd(n.redMul(m)), C = h.redMul(S), F = N.redSqr().redISub(C.redAdd(C)), U = C.redISub(F), J = N.redMul(U);
        J = J.redIAdd(J).redISub(I);
        var Bt = w.redMul(b);
        r + 1 < t && (m = m.redMul(I)), h = F, b = Bt, w = J;
    }
    return this.curve.jpoint(h, w.redMul(o), b);
}, $23d8f6d1574ae23f$var$Tt.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
}, $23d8f6d1574ae23f$var$Tt.prototype._zeroDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var b = n.redAdd(n).redIAdd(n), m = b.redSqr().redISub(p).redISub(p), w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), t = m, r = b.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.x.redSqr(), S = this.y.redSqr(), I = S.redSqr(), N = this.x.redAdd(S).redSqr().redISub(y).redISub(I);
        N = N.redIAdd(N);
        var C = y.redAdd(y).redIAdd(y), F = C.redSqr(), U = I.redIAdd(I);
        U = U.redIAdd(U), U = U.redIAdd(U), t = F.redISub(N).redISub(N), r = C.redMul(N.redISub(t)).redISub(U), i = this.y.redMul(this.z), i = i.redIAdd(i);
    }
    return this.curve.jpoint(t, r, i);
}, $23d8f6d1574ae23f$var$Tt.prototype._threeDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var b = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), m = b.redSqr().redISub(p).redISub(p);
        t = m;
        var w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), r = b.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.z.redSqr(), S = this.y.redSqr(), I = this.x.redMul(S), N = this.x.redSub(y).redMul(this.x.redAdd(y));
        N = N.redAdd(N).redIAdd(N);
        var C = I.redIAdd(I);
        C = C.redIAdd(C);
        var F = C.redAdd(C);
        t = N.redSqr().redISub(F), i = this.y.redAdd(this.z).redSqr().redISub(S).redISub(y);
        var U = S.redSqr();
        U = U.redIAdd(U), U = U.redIAdd(U), U = U.redIAdd(U), r = N.redMul(C.redISub(t)).redISub(U);
    }
    return this.curve.jpoint(t, r, i);
}, $23d8f6d1574ae23f$var$Tt.prototype._dbl = function() {
    var t = this.curve.a, r = this.x, i = this.y, n = this.z, o = n.redSqr().redSqr(), h = r.redSqr(), p = i.redSqr(), b = h.redAdd(h).redIAdd(h).redIAdd(t.redMul(o)), m = r.redAdd(r);
    m = m.redIAdd(m);
    var w = m.redMul(p), y = b.redSqr().redISub(w.redAdd(w)), S = w.redISub(y), I = p.redSqr();
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = b.redMul(S).redISub(I), C = i.redAdd(i).redMul(n);
    return this.curve.jpoint(y, N, C);
}, $23d8f6d1574ae23f$var$Tt.prototype.trpl = function() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var t = this.x.redSqr(), r = this.y.redSqr(), i = this.z.redSqr(), n = r.redSqr(), o = t.redAdd(t).redIAdd(t), h = o.redSqr(), p = this.x.redAdd(r).redSqr().redISub(t).redISub(n);
    p = p.redIAdd(p), p = p.redAdd(p).redIAdd(p), p = p.redISub(h);
    var b = p.redSqr(), m = n.redIAdd(n);
    m = m.redIAdd(m), m = m.redIAdd(m), m = m.redIAdd(m);
    var w = o.redIAdd(p).redSqr().redISub(h).redISub(b).redISub(m), y = r.redMul(w);
    y = y.redIAdd(y), y = y.redIAdd(y);
    var S = this.x.redMul(b).redISub(y);
    S = S.redIAdd(S), S = S.redIAdd(S);
    var I = this.y.redMul(w.redMul(m.redISub(w)).redISub(p.redMul(b)));
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = this.z.redAdd(p).redSqr().redISub(i).redISub(b);
    return this.curve.jpoint(S, I, N);
}, $23d8f6d1574ae23f$var$Tt.prototype.mul = function(t, r) {
    return t = new $23d8f6d1574ae23f$var$K(t, r), this.curve._wnafMul(this, t);
}, $23d8f6d1574ae23f$var$Tt.prototype.eq = function(t) {
    if (t.type === "affine") return this.eq(t.toJ());
    if (this === t) return !0;
    var r = this.z.redSqr(), i = t.z.redSqr();
    if (this.x.redMul(i).redISub(t.x.redMul(r)).cmpn(0) !== 0) return !1;
    var n = r.redMul(this.z), o = i.redMul(t.z);
    return this.y.redMul(o).redISub(t.y.redMul(n)).cmpn(0) === 0;
}, $23d8f6d1574ae23f$var$Tt.prototype.eqXToP = function(t) {
    var r = this.z.redSqr(), i = t.toRed(this.curve.red).redMul(r);
    if (this.x.cmp(i) === 0) return !0;
    for(var n = t.clone(), o = this.curve.redN.redMul(r);;){
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (i.redIAdd(o), this.x.cmp(i) === 0) return !0;
    }
}, $23d8f6d1574ae23f$var$Tt.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
}, $23d8f6d1574ae23f$var$Tt.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
};
var $23d8f6d1574ae23f$var$qr = $23d8f6d1574ae23f$var$cr(function(e, t) {
    var r = t;
    r.base = $23d8f6d1574ae23f$var$Ze, r.short = $23d8f6d1574ae23f$var$ka, r.mont = null, r.edwards = null;
}), $23d8f6d1574ae23f$var$Kr = $23d8f6d1574ae23f$var$cr(function(e, t) {
    var r = t, i = $23d8f6d1574ae23f$var$Jt.assert;
    function n(p) {
        p.type === "short" ? this.curve = new $23d8f6d1574ae23f$var$qr.short(p) : p.type === "edwards" ? this.curve = new $23d8f6d1574ae23f$var$qr.edwards(p) : this.curve = new $23d8f6d1574ae23f$var$qr.mont(p), this.g = this.curve.g, this.n = this.curve.n, this.hash = p.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    r.PresetCurve = n;
    function o(p, b) {
        Object.defineProperty(r, p, {
            configurable: !0,
            enumerable: !0,
            get: function() {
                var m = new n(b);
                return Object.defineProperty(r, p, {
                    configurable: !0,
                    enumerable: !0,
                    value: m
                }), m;
            }
        });
    }
    o("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: $23d8f6d1574ae23f$var$se.sha256,
        gRed: !1,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    }), o("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: $23d8f6d1574ae23f$var$se.sha256,
        gRed: !1,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    }), o("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: $23d8f6d1574ae23f$var$se.sha256,
        gRed: !1,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    }), o("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: $23d8f6d1574ae23f$var$se.sha384,
        gRed: !1,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    }), o("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: $23d8f6d1574ae23f$var$se.sha512,
        gRed: !1,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    }), o("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $23d8f6d1574ae23f$var$se.sha256,
        gRed: !1,
        g: [
            "9"
        ]
    }), o("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $23d8f6d1574ae23f$var$se.sha256,
        gRed: !1,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var h;
    try {
        h = null.crash();
    } catch  {
        h = void 0;
    }
    o("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: $23d8f6d1574ae23f$var$se.sha256,
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: !1,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            h
        ]
    });
});
function $23d8f6d1574ae23f$var$Re(e) {
    if (!(this instanceof $23d8f6d1574ae23f$var$Re)) return new $23d8f6d1574ae23f$var$Re(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = $23d8f6d1574ae23f$var$fe.toArray(e.entropy, e.entropyEnc || "hex"), r = $23d8f6d1574ae23f$var$fe.toArray(e.nonce, e.nonceEnc || "hex"), i = $23d8f6d1574ae23f$var$fe.toArray(e.pers, e.persEnc || "hex");
    $23d8f6d1574ae23f$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, i);
}
var $23d8f6d1574ae23f$var$Rf = $23d8f6d1574ae23f$var$Re;
$23d8f6d1574ae23f$var$Re.prototype._init = function(t, r, i) {
    var n = t.concat(r).concat(i);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for(var o = 0; o < this.V.length; o++)this.K[o] = 0, this.V[o] = 1;
    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
}, $23d8f6d1574ae23f$var$Re.prototype._hmac = function() {
    return new $23d8f6d1574ae23f$var$se.hmac(this.hash, this.K);
}, $23d8f6d1574ae23f$var$Re.prototype._update = function(t) {
    var r = this._hmac().update(this.V).update([
        0
    ]);
    t && (r = r.update(t)), this.K = r.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([
        1
    ]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
}, $23d8f6d1574ae23f$var$Re.prototype.reseed = function(t, r, i, n) {
    typeof r != "string" && (n = i, i = r, r = null), t = $23d8f6d1574ae23f$var$fe.toArray(t, r), i = $23d8f6d1574ae23f$var$fe.toArray(i, n), $23d8f6d1574ae23f$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(t.concat(i || [])), this._reseed = 1;
}, $23d8f6d1574ae23f$var$Re.prototype.generate = function(t, r, i, n) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    typeof r != "string" && (n = i, i = r, r = null), i && (i = $23d8f6d1574ae23f$var$fe.toArray(i, n || "hex"), this._update(i));
    for(var o = []; o.length < t;)this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
    var h = o.slice(0, t);
    return this._update(i), this._reseed++, $23d8f6d1574ae23f$var$fe.encode(h, r);
};
var $23d8f6d1574ae23f$var$Fi = $23d8f6d1574ae23f$var$Jt.assert;
function $23d8f6d1574ae23f$var$kt(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var $23d8f6d1574ae23f$var$Ti = $23d8f6d1574ae23f$var$kt;
$23d8f6d1574ae23f$var$kt.fromPublic = function(t, r, i) {
    return r instanceof $23d8f6d1574ae23f$var$kt ? r : new $23d8f6d1574ae23f$var$kt(t, {
        pub: r,
        pubEnc: i
    });
}, $23d8f6d1574ae23f$var$kt.fromPrivate = function(t, r, i) {
    return r instanceof $23d8f6d1574ae23f$var$kt ? r : new $23d8f6d1574ae23f$var$kt(t, {
        priv: r,
        privEnc: i
    });
}, $23d8f6d1574ae23f$var$kt.prototype.validate = function() {
    var t = this.getPublic();
    return t.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
    } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
    } : {
        result: !1,
        reason: "Public key * N != O"
    } : {
        result: !1,
        reason: "Public key is not a point"
    };
}, $23d8f6d1574ae23f$var$kt.prototype.getPublic = function(t, r) {
    return typeof t == "string" && (r = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), r ? this.pub.encode(r, t) : this.pub;
}, $23d8f6d1574ae23f$var$kt.prototype.getPrivate = function(t) {
    return t === "hex" ? this.priv.toString(16, 2) : this.priv;
}, $23d8f6d1574ae23f$var$kt.prototype._importPrivate = function(t, r) {
    this.priv = new $23d8f6d1574ae23f$var$K(t, r || 16), this.priv = this.priv.umod(this.ec.curve.n);
}, $23d8f6d1574ae23f$var$kt.prototype._importPublic = function(t, r) {
    if (t.x || t.y) {
        this.ec.curve.type === "mont" ? $23d8f6d1574ae23f$var$Fi(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && $23d8f6d1574ae23f$var$Fi(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(t, r);
}, $23d8f6d1574ae23f$var$kt.prototype.derive = function(t) {
    return t.validate() || $23d8f6d1574ae23f$var$Fi(t.validate(), "public point not validated"), t.mul(this.priv).getX();
}, $23d8f6d1574ae23f$var$kt.prototype.sign = function(t, r, i) {
    return this.ec.sign(t, this, r, i);
}, $23d8f6d1574ae23f$var$kt.prototype.verify = function(t, r) {
    return this.ec.verify(t, r, this);
}, $23d8f6d1574ae23f$var$kt.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var $23d8f6d1574ae23f$var$qa = $23d8f6d1574ae23f$var$Jt.assert;
function $23d8f6d1574ae23f$var$Hr(e, t) {
    if (e instanceof $23d8f6d1574ae23f$var$Hr) return e;
    this._importDER(e, t) || ($23d8f6d1574ae23f$var$qa(e.r && e.s, "Signature without r or s"), this.r = new $23d8f6d1574ae23f$var$K(e.r, 16), this.s = new $23d8f6d1574ae23f$var$K(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var $23d8f6d1574ae23f$var$zr = $23d8f6d1574ae23f$var$Hr;
function $23d8f6d1574ae23f$var$Ka() {
    this.place = 0;
}
function $23d8f6d1574ae23f$var$Ui(e, t) {
    var r = e[t.place++];
    if (!(r & 128)) return r;
    var i = r & 15;
    if (i === 0 || i > 4) return !1;
    for(var n = 0, o = 0, h = t.place; o < i; o++, h++)n <<= 8, n |= e[h], n >>>= 0;
    return n <= 127 ? !1 : (t.place = h, n);
}
function $23d8f6d1574ae23f$var$Of(e) {
    for(var t = 0, r = e.length - 1; !e[t] && !(e[t + 1] & 128) && t < r;)t++;
    return t === 0 ? e : e.slice(t);
}
$23d8f6d1574ae23f$var$Hr.prototype._importDER = function(t, r) {
    t = $23d8f6d1574ae23f$var$Jt.toArray(t, r);
    var i = new $23d8f6d1574ae23f$var$Ka;
    if (t[i.place++] !== 48) return !1;
    var n = $23d8f6d1574ae23f$var$Ui(t, i);
    if (n === !1 || n + i.place !== t.length || t[i.place++] !== 2) return !1;
    var o = $23d8f6d1574ae23f$var$Ui(t, i);
    if (o === !1) return !1;
    var h = t.slice(i.place, o + i.place);
    if (i.place += o, t[i.place++] !== 2) return !1;
    var p = $23d8f6d1574ae23f$var$Ui(t, i);
    if (p === !1 || t.length !== p + i.place) return !1;
    var b = t.slice(i.place, p + i.place);
    if (h[0] === 0) {
        if (h[1] & 128) h = h.slice(1);
        else return !1;
    }
    if (b[0] === 0) {
        if (b[1] & 128) b = b.slice(1);
        else return !1;
    }
    return this.r = new $23d8f6d1574ae23f$var$K(h), this.s = new $23d8f6d1574ae23f$var$K(b), this.recoveryParam = null, !0;
};
function $23d8f6d1574ae23f$var$ki(e, t) {
    if (t < 128) {
        e.push(t);
        return;
    }
    var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
    for(e.push(r | 128); --r;)e.push(t >>> (r << 3) & 255);
    e.push(t);
}
$23d8f6d1574ae23f$var$Hr.prototype.toDER = function(t) {
    var r = this.r.toArray(), i = this.s.toArray();
    for(r[0] & 128 && (r = [
        0
    ].concat(r)), i[0] & 128 && (i = [
        0
    ].concat(i)), r = $23d8f6d1574ae23f$var$Of(r), i = $23d8f6d1574ae23f$var$Of(i); !i[0] && !(i[1] & 128);)i = i.slice(1);
    var n = [
        2
    ];
    $23d8f6d1574ae23f$var$ki(n, r.length), n = n.concat(r), n.push(2), $23d8f6d1574ae23f$var$ki(n, i.length);
    var o = n.concat(i), h = [
        48
    ];
    return $23d8f6d1574ae23f$var$ki(h, o.length), h = h.concat(o), $23d8f6d1574ae23f$var$Jt.encode(h, t);
};
var $23d8f6d1574ae23f$var$Ha = function() {
    throw new Error("unsupported");
}, $23d8f6d1574ae23f$var$Pf = $23d8f6d1574ae23f$var$Jt.assert;
function $23d8f6d1574ae23f$var$$t(e) {
    if (!(this instanceof $23d8f6d1574ae23f$var$$t)) return new $23d8f6d1574ae23f$var$$t(e);
    typeof e == "string" && ($23d8f6d1574ae23f$var$Pf(Object.prototype.hasOwnProperty.call($23d8f6d1574ae23f$var$Kr, e), "Unknown curve " + e), e = $23d8f6d1574ae23f$var$Kr[e]), e instanceof $23d8f6d1574ae23f$var$Kr.PresetCurve && (e = {
        curve: e
    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
}
var $23d8f6d1574ae23f$var$za = $23d8f6d1574ae23f$var$$t;
$23d8f6d1574ae23f$var$$t.prototype.keyPair = function(t) {
    return new $23d8f6d1574ae23f$var$Ti(this, t);
}, $23d8f6d1574ae23f$var$$t.prototype.keyFromPrivate = function(t, r) {
    return $23d8f6d1574ae23f$var$Ti.fromPrivate(this, t, r);
}, $23d8f6d1574ae23f$var$$t.prototype.keyFromPublic = function(t, r) {
    return $23d8f6d1574ae23f$var$Ti.fromPublic(this, t, r);
}, $23d8f6d1574ae23f$var$$t.prototype.genKeyPair = function(t) {
    t || (t = {});
    for(var r = new $23d8f6d1574ae23f$var$Rf({
        hash: this.hash,
        pers: t.pers,
        persEnc: t.persEnc || "utf8",
        entropy: t.entropy || $23d8f6d1574ae23f$var$Ha(this.hash.hmacStrength),
        entropyEnc: t.entropy && t.entropyEnc || "utf8",
        nonce: this.n.toArray()
    }), i = this.n.byteLength(), n = this.n.sub(new $23d8f6d1574ae23f$var$K(2));;){
        var o = new $23d8f6d1574ae23f$var$K(r.generate(i));
        if (!(o.cmp(n) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
    }
}, $23d8f6d1574ae23f$var$$t.prototype._truncateToN = function(t, r) {
    var i = t.byteLength() * 8 - this.n.bitLength();
    return i > 0 && (t = t.ushrn(i)), !r && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
}, $23d8f6d1574ae23f$var$$t.prototype.sign = function(t, r, i, n) {
    typeof i == "object" && (n = i, i = null), n || (n = {}), r = this.keyFromPrivate(r, i), t = this._truncateToN(new $23d8f6d1574ae23f$var$K(t, 16));
    for(var o = this.n.byteLength(), h = r.getPrivate().toArray("be", o), p = t.toArray("be", o), b = new $23d8f6d1574ae23f$var$Rf({
        hash: this.hash,
        entropy: h,
        nonce: p,
        pers: n.pers,
        persEnc: n.persEnc || "utf8"
    }), m = this.n.sub(new $23d8f6d1574ae23f$var$K(1)), w = 0;; w++){
        var y = n.k ? n.k(w) : new $23d8f6d1574ae23f$var$K(b.generate(this.n.byteLength()));
        if (y = this._truncateToN(y, !0), !(y.cmpn(1) <= 0 || y.cmp(m) >= 0)) {
            var S = this.g.mul(y);
            if (!S.isInfinity()) {
                var I = S.getX(), N = I.umod(this.n);
                if (N.cmpn(0) !== 0) {
                    var C = y.invm(this.n).mul(N.mul(r.getPrivate()).iadd(t));
                    if (C = C.umod(this.n), C.cmpn(0) !== 0) {
                        var F = (S.getY().isOdd() ? 1 : 0) | (I.cmp(N) !== 0 ? 2 : 0);
                        return n.canonical && C.cmp(this.nh) > 0 && (C = this.n.sub(C), F ^= 1), new $23d8f6d1574ae23f$var$zr({
                            r: N,
                            s: C,
                            recoveryParam: F
                        });
                    }
                }
            }
        }
    }
}, $23d8f6d1574ae23f$var$$t.prototype.verify = function(t, r, i, n) {
    t = this._truncateToN(new $23d8f6d1574ae23f$var$K(t, 16)), i = this.keyFromPublic(i, n), r = new $23d8f6d1574ae23f$var$zr(r, "hex");
    var o = r.r, h = r.s;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0 || h.cmpn(1) < 0 || h.cmp(this.n) >= 0) return !1;
    var p = h.invm(this.n), b = p.mul(t).umod(this.n), m = p.mul(o).umod(this.n), w;
    return this.curve._maxwellTrick ? (w = this.g.jmulAdd(b, i.getPublic(), m), w.isInfinity() ? !1 : w.eqXToP(o)) : (w = this.g.mulAdd(b, i.getPublic(), m), w.isInfinity() ? !1 : w.getX().umod(this.n).cmp(o) === 0);
}, $23d8f6d1574ae23f$var$$t.prototype.recoverPubKey = function(e, t, r, i) {
    $23d8f6d1574ae23f$var$Pf((3 & r) === r, "The recovery param is more than two bits"), t = new $23d8f6d1574ae23f$var$zr(t, i);
    var n = this.n, o = new $23d8f6d1574ae23f$var$K(e), h = t.r, p = t.s, b = r & 1, m = r >> 1;
    if (h.cmp(this.curve.p.umod(this.curve.n)) >= 0 && m) throw new Error("Unable to find sencond key candinate");
    m ? h = this.curve.pointFromX(h.add(this.curve.n), b) : h = this.curve.pointFromX(h, b);
    var w = t.r.invm(n), y = n.sub(o).mul(w).umod(n), S = p.mul(w).umod(n);
    return this.g.mulAdd(y, h, S);
}, $23d8f6d1574ae23f$var$$t.prototype.getKeyRecoveryParam = function(e, t, r, i) {
    if (t = new $23d8f6d1574ae23f$var$zr(t, i), t.recoveryParam !== null) return t.recoveryParam;
    for(var n = 0; n < 4; n++){
        var o;
        try {
            o = this.recoverPubKey(e, t, n);
        } catch  {
            continue;
        }
        if (o.eq(r)) return n;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $23d8f6d1574ae23f$var$La = $23d8f6d1574ae23f$var$cr(function(e, t) {
    var r = t;
    r.version = "6.5.4", r.utils = $23d8f6d1574ae23f$var$Jt, r.rand = function() {
        throw new Error("unsupported");
    }, r.curve = $23d8f6d1574ae23f$var$qr, r.curves = $23d8f6d1574ae23f$var$Kr, r.ec = $23d8f6d1574ae23f$var$za, r.eddsa = null;
}), $23d8f6d1574ae23f$var$ja = $23d8f6d1574ae23f$var$La.ec;
const $23d8f6d1574ae23f$var$Qa = "signing-key/5.7.0", $23d8f6d1574ae23f$var$qi = new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$Qa);
let $23d8f6d1574ae23f$var$Ki = null;
function $23d8f6d1574ae23f$var$ve() {
    return $23d8f6d1574ae23f$var$Ki || ($23d8f6d1574ae23f$var$Ki = new $23d8f6d1574ae23f$var$ja("secp256k1")), $23d8f6d1574ae23f$var$Ki;
}
class $23d8f6d1574ae23f$var$Ja {
    constructor(t){
        $23d8f6d1574ae23f$var$br(this, "curve", "secp256k1"), $23d8f6d1574ae23f$var$br(this, "privateKey", $23d8f6d1574ae23f$var$Kt(t)), $23d8f6d1574ae23f$var$N0(this.privateKey) !== 32 && $23d8f6d1574ae23f$var$qi.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const r = $23d8f6d1574ae23f$var$ve().keyFromPrivate($23d8f6d1574ae23f$var$Ot(this.privateKey));
        $23d8f6d1574ae23f$var$br(this, "publicKey", "0x" + r.getPublic(!1, "hex")), $23d8f6d1574ae23f$var$br(this, "compressedPublicKey", "0x" + r.getPublic(!0, "hex")), $23d8f6d1574ae23f$var$br(this, "_isSigningKey", !0);
    }
    _addPoint(t) {
        const r = $23d8f6d1574ae23f$var$ve().keyFromPublic($23d8f6d1574ae23f$var$Ot(this.publicKey)), i = $23d8f6d1574ae23f$var$ve().keyFromPublic($23d8f6d1574ae23f$var$Ot(t));
        return "0x" + r.pub.add(i.pub).encodeCompressed("hex");
    }
    signDigest(t) {
        const r = $23d8f6d1574ae23f$var$ve().keyFromPrivate($23d8f6d1574ae23f$var$Ot(this.privateKey)), i = $23d8f6d1574ae23f$var$Ot(t);
        i.length !== 32 && $23d8f6d1574ae23f$var$qi.throwArgumentError("bad digest length", "digest", t);
        const n = r.sign(i, {
            canonical: !0
        });
        return $23d8f6d1574ae23f$var$zn({
            recoveryParam: n.recoveryParam,
            r: $23d8f6d1574ae23f$var$oe("0x" + n.r.toString(16), 32),
            s: $23d8f6d1574ae23f$var$oe("0x" + n.s.toString(16), 32)
        });
    }
    computeSharedSecret(t) {
        const r = $23d8f6d1574ae23f$var$ve().keyFromPrivate($23d8f6d1574ae23f$var$Ot(this.privateKey)), i = $23d8f6d1574ae23f$var$ve().keyFromPublic($23d8f6d1574ae23f$var$Ot($23d8f6d1574ae23f$var$Df(t)));
        return $23d8f6d1574ae23f$var$oe("0x" + r.derive(i.getPublic()).toString(16), 32);
    }
    static isSigningKey(t) {
        return !!(t && t._isSigningKey);
    }
}
function $23d8f6d1574ae23f$var$Ga(e, t) {
    const r = $23d8f6d1574ae23f$var$zn(t), i = {
        r: $23d8f6d1574ae23f$var$Ot(r.r),
        s: $23d8f6d1574ae23f$var$Ot(r.s)
    };
    return "0x" + $23d8f6d1574ae23f$var$ve().recoverPubKey($23d8f6d1574ae23f$var$Ot(e), i, r.recoveryParam).encode("hex", !1);
}
function $23d8f6d1574ae23f$var$Df(e, t) {
    const r = $23d8f6d1574ae23f$var$Ot(e);
    if (r.length === 32) {
        const i = new $23d8f6d1574ae23f$var$Ja(r);
        return t ? "0x" + $23d8f6d1574ae23f$var$ve().keyFromPrivate(r).getPublic(!0, "hex") : i.publicKey;
    } else {
        if (r.length === 33) return t ? $23d8f6d1574ae23f$var$Kt(r) : "0x" + $23d8f6d1574ae23f$var$ve().keyFromPublic(r).getPublic(!1, "hex");
        if (r.length === 65) return t ? "0x" + $23d8f6d1574ae23f$var$ve().keyFromPublic(r).getPublic(!0, "hex") : $23d8f6d1574ae23f$var$Kt(r);
    }
    return $23d8f6d1574ae23f$var$qi.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
const $23d8f6d1574ae23f$var$Ya = "transactions/5.7.0";
new $23d8f6d1574ae23f$var$L($23d8f6d1574ae23f$var$Ya);
var $23d8f6d1574ae23f$var$Ff;
(function(e) {
    e[e.legacy = 0] = "legacy", e[e.eip2930 = 1] = "eip2930", e[e.eip1559 = 2] = "eip1559";
})($23d8f6d1574ae23f$var$Ff || ($23d8f6d1574ae23f$var$Ff = {}));
function $23d8f6d1574ae23f$var$Va(e) {
    const t = $23d8f6d1574ae23f$var$Df(e);
    return $23d8f6d1574ae23f$var$ns($23d8f6d1574ae23f$var$Hn($23d8f6d1574ae23f$var$yi($23d8f6d1574ae23f$var$Hn(t, 1)), 12));
}
function $23d8f6d1574ae23f$var$Wa(e, t) {
    return $23d8f6d1574ae23f$var$Va($23d8f6d1574ae23f$var$Ga($23d8f6d1574ae23f$var$Ot(e), t));
}
const $23d8f6d1574ae23f$var$Xa = "https://rpc.walletconnect.com/v1";
async function $23d8f6d1574ae23f$export$ab54e47fdf2903bb(e, t, r, i, n, o) {
    switch(r.t){
        case "eip191":
            return $23d8f6d1574ae23f$export$b5da105d64914e5a(e, t, r.s);
        case "eip1271":
            return await $23d8f6d1574ae23f$export$9bffe3330373b76b(e, t, r.s, i, n, o);
        default:
            throw new Error(`verifySignature failed: Attempted to verify CacaoSignature with unknown type: ${r.t}`);
    }
}
function $23d8f6d1574ae23f$export$b5da105d64914e5a(e, t, r) {
    return $23d8f6d1574ae23f$var$Wa($23d8f6d1574ae23f$var$ff(t), r).toLowerCase() === e.toLowerCase();
}
async function $23d8f6d1574ae23f$export$9bffe3330373b76b(e, t, r, i, n, o) {
    try {
        const h = "0x1626ba7e", p = "0000000000000000000000000000000000000000000000000000000000000040", b = "0000000000000000000000000000000000000000000000000000000000000041", m = r.substring(2), w = $23d8f6d1574ae23f$var$ff(t).substring(2), y = h + w + p + b + m, S = await fetch(`${o || $23d8f6d1574ae23f$var$Xa}/?chainId=${i}&projectId=${n}`, {
            method: "POST",
            body: JSON.stringify({
                id: $23d8f6d1574ae23f$var$Za(),
                jsonrpc: "2.0",
                method: "eth_call",
                params: [
                    {
                        to: e,
                        data: y
                    },
                    "latest"
                ]
            })
        }), { result: I } = await S.json();
        return I ? I.slice(0, h.length).toLowerCase() === h.toLowerCase() : !1;
    } catch (h) {
        return console.error("isValidEip1271Signature: ", h), !1;
    }
}
function $23d8f6d1574ae23f$var$Za() {
    return Date.now() + Math.floor(Math.random() * 1e3);
}
var $23d8f6d1574ae23f$var$$a = Object.defineProperty, $23d8f6d1574ae23f$var$tu = Object.defineProperties, $23d8f6d1574ae23f$var$eu = Object.getOwnPropertyDescriptors, $23d8f6d1574ae23f$var$qf = Object.getOwnPropertySymbols, $23d8f6d1574ae23f$var$ru = Object.prototype.hasOwnProperty, $23d8f6d1574ae23f$var$iu = Object.prototype.propertyIsEnumerable, $23d8f6d1574ae23f$var$Kf = (e, t, r)=>t in e ? $23d8f6d1574ae23f$var$$a(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $23d8f6d1574ae23f$var$Hi = (e, t)=>{
    for(var r in t || (t = {}))$23d8f6d1574ae23f$var$ru.call(t, r) && $23d8f6d1574ae23f$var$Kf(e, r, t[r]);
    if ($23d8f6d1574ae23f$var$qf) for (var r of $23d8f6d1574ae23f$var$qf(t))$23d8f6d1574ae23f$var$iu.call(t, r) && $23d8f6d1574ae23f$var$Kf(e, r, t[r]);
    return e;
}, $23d8f6d1574ae23f$var$Hf = (e, t)=>$23d8f6d1574ae23f$var$tu(e, $23d8f6d1574ae23f$var$eu(t));
const $23d8f6d1574ae23f$var$nu = "did:pkh:", $23d8f6d1574ae23f$export$a524ae552db7912 = (e)=>e?.split(":"), $23d8f6d1574ae23f$export$85f23c05c80b194 = (e)=>{
    const t = e && $23d8f6d1574ae23f$export$a524ae552db7912(e);
    if (t) return e.includes($23d8f6d1574ae23f$var$nu) ? t[3] : t[1];
}, $23d8f6d1574ae23f$export$a8b149927aef7051 = (e)=>{
    const t = e && $23d8f6d1574ae23f$export$a524ae552db7912(e);
    if (t) return t[2] + ":" + t[3];
}, $23d8f6d1574ae23f$export$bf43cfbb4bd95de9 = (e)=>{
    const t = e && $23d8f6d1574ae23f$export$a524ae552db7912(e);
    if (t) return t.pop();
};
async function $23d8f6d1574ae23f$export$b7d566fce8e2b970(e) {
    const { cacao: t, projectId: r } = e, { s: i, p: n } = t, o = $23d8f6d1574ae23f$export$25868d1e8e76735f(n, n.iss), h = $23d8f6d1574ae23f$export$bf43cfbb4bd95de9(n.iss);
    return await $23d8f6d1574ae23f$export$ab54e47fdf2903bb(h, o, i, $23d8f6d1574ae23f$export$85f23c05c80b194(n.iss), r);
}
const $23d8f6d1574ae23f$export$25868d1e8e76735f = (e, t)=>{
    const r = `${e.domain} wants you to sign in with your Ethereum account:`, i = $23d8f6d1574ae23f$export$bf43cfbb4bd95de9(t);
    if (!e.aud && !e.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
    let n = e.statement || void 0;
    const o = `URI: ${e.aud || e.uri}`, h = `Version: ${e.version}`, p = `Chain ID: ${$23d8f6d1574ae23f$export$85f23c05c80b194(t)}`, b = `Nonce: ${e.nonce}`, m = `Issued At: ${e.iat}`, w = e.exp ? `Expiration Time: ${e.exp}` : void 0, y = e.nbf ? `Not Before: ${e.nbf}` : void 0, S = e.requestId ? `Request ID: ${e.requestId}` : void 0, I = e.resources ? `Resources:${e.resources.map((C)=>`
- ${C}`).join("")}` : void 0, N = $23d8f6d1574ae23f$export$3bb18ae0fb9a9fa9(e.resources);
    if (N) {
        const C = $23d8f6d1574ae23f$export$d34522c9e5a1aed1(N);
        n = $23d8f6d1574ae23f$export$51673931d3a8308d(n, C);
    }
    return [
        r,
        i,
        "",
        n,
        "",
        o,
        h,
        p,
        b,
        m,
        w,
        y,
        S,
        I
    ].filter((C)=>C != null).join(`
`);
};
function $23d8f6d1574ae23f$export$905974078a05d5f9(e, t, r) {
    return r.includes("did:pkh:") || (r = `did:pkh:${r}`), {
        h: {
            t: "caip122"
        },
        p: {
            iss: r,
            domain: e.domain,
            aud: e.aud,
            version: e.version,
            nonce: e.nonce,
            iat: e.iat,
            statement: e.statement,
            requestId: e.requestId,
            resources: e.resources,
            nbf: e.nbf,
            exp: e.exp
        },
        s: t
    };
}
function $23d8f6d1574ae23f$export$2bfa2ac7d9bc193c(e) {
    var t;
    const { authPayload: r, chains: i, methods: n } = e, o = r.statement || "";
    if (!(i != null && i.length)) return r;
    const h = r.chains, p = $23d8f6d1574ae23f$export$f8aaf09178dd8b96(h, i);
    if (!(p != null && p.length)) throw new Error("No supported chains");
    const b = $23d8f6d1574ae23f$export$8db308c294c84efd(r.resources);
    if (!b) return r;
    $23d8f6d1574ae23f$export$ae8075c482503f32(b);
    const m = $23d8f6d1574ae23f$export$9595a56724061288(b, "eip155");
    let w = r?.resources || [];
    if (m != null && m.length) {
        const y = $23d8f6d1574ae23f$export$e1a9af3d61db3b68(m), S = $23d8f6d1574ae23f$export$f8aaf09178dd8b96(y, n);
        if (!(S != null && S.length)) throw new Error(`Supported methods don't satisfy the requested: ${JSON.stringify(y)}, supported: ${JSON.stringify(n)}`);
        const I = $23d8f6d1574ae23f$export$987cafd76db78dd1("request", S, {
            chains: p
        }), N = $23d8f6d1574ae23f$export$317cb0007b0867c1(b, "eip155", I);
        w = ((t = r?.resources) == null ? void 0 : t.slice(0, -1)) || [], w.push($23d8f6d1574ae23f$export$79a538532b4f11f7(N));
    }
    return $23d8f6d1574ae23f$var$Hf($23d8f6d1574ae23f$var$Hi({}, r), {
        statement: $23d8f6d1574ae23f$export$fb351782bc6f001e(o, $23d8f6d1574ae23f$export$3bb18ae0fb9a9fa9(w)),
        chains: p,
        resources: r != null && r.resources || w.length > 0 ? w : void 0
    });
}
function $23d8f6d1574ae23f$export$8db308c294c84efd(e) {
    const t = $23d8f6d1574ae23f$export$3bb18ae0fb9a9fa9(e);
    if (t && $23d8f6d1574ae23f$export$d9f11bd9fec5a64(t)) return $23d8f6d1574ae23f$export$d34522c9e5a1aed1(t);
}
function $23d8f6d1574ae23f$export$771534f1eaa353c(e, t) {
    var r;
    return (r = e?.att) == null ? void 0 : r.hasOwnProperty(t);
}
function $23d8f6d1574ae23f$export$9595a56724061288(e, t) {
    var r, i;
    return (r = e?.att) != null && r[t] ? Object.keys((i = e?.att) == null ? void 0 : i[t]) : [];
}
function $23d8f6d1574ae23f$export$d4548b739f9dafe(e) {
    return e?.map((t)=>Object.keys(t)) || [];
}
function $23d8f6d1574ae23f$export$e1a9af3d61db3b68(e) {
    return e?.map((t)=>{
        var r;
        return (r = t.split("/")) == null ? void 0 : r[1];
    }) || [];
}
function $23d8f6d1574ae23f$export$e510a73ee562749(e) {
    return $23d8f6d1574ae23f$require$Buffer.from(JSON.stringify(e)).toString("base64");
}
function $23d8f6d1574ae23f$export$c62426fdd000a97e(e) {
    return JSON.parse($23d8f6d1574ae23f$require$Buffer.from(e, "base64").toString("utf-8"));
}
function $23d8f6d1574ae23f$export$ae8075c482503f32(e) {
    if (!e) throw new Error("No recap provided, value is undefined");
    if (!e.att) throw new Error("No `att` property found");
    const t = Object.keys(e.att);
    if (!(t != null && t.length)) throw new Error("No resources found in `att` property");
    t.forEach((r)=>{
        const i = e.att[r];
        if (Array.isArray(i)) throw new Error(`Resource must be an object: ${r}`);
        if (typeof i != "object") throw new Error(`Resource must be an object: ${r}`);
        if (!Object.keys(i).length) throw new Error(`Resource object is empty: ${r}`);
        Object.keys(i).forEach((n)=>{
            const o = i[n];
            if (!Array.isArray(o)) throw new Error(`Ability limits ${n} must be an array of objects, found: ${o}`);
            if (!o.length) throw new Error(`Value of ${n} is empty array, must be an array with objects`);
            o.forEach((h)=>{
                if (typeof h != "object") throw new Error(`Ability limits (${n}) must be an array of objects, found: ${h}`);
            });
        });
    });
}
function $23d8f6d1574ae23f$export$eea18a04b33506ed(e, t, r, i = {}) {
    return r?.sort((n, o)=>n.localeCompare(o)), {
        att: {
            [e]: $23d8f6d1574ae23f$export$987cafd76db78dd1(t, r, i)
        }
    };
}
function $23d8f6d1574ae23f$export$317cb0007b0867c1(e, t, r) {
    var i;
    return e.att[t] = $23d8f6d1574ae23f$var$Hi({}, r), ((i = Object.keys(e.att)) == null ? void 0 : i.sort((n, o)=>n.localeCompare(o))).reduce((n, o)=>(n.att[o] = e.att[o], n), {
        att: {}
    });
}
function $23d8f6d1574ae23f$export$987cafd76db78dd1(e, t, r = {}) {
    t = t?.sort((n, o)=>n.localeCompare(o));
    const i = t.map((n)=>({
            [`${e}/${n}`]: [
                r
            ]
        }));
    return Object.assign({}, ...i);
}
function $23d8f6d1574ae23f$export$79a538532b4f11f7(e) {
    return $23d8f6d1574ae23f$export$ae8075c482503f32(e), `urn:recap:${$23d8f6d1574ae23f$export$e510a73ee562749(e).replace(/=/g, "")}`;
}
function $23d8f6d1574ae23f$export$d34522c9e5a1aed1(e) {
    const t = $23d8f6d1574ae23f$export$c62426fdd000a97e(e.replace("urn:recap:", ""));
    return $23d8f6d1574ae23f$export$ae8075c482503f32(t), t;
}
function $23d8f6d1574ae23f$export$2bc35d2a08a09ad5(e, t, r) {
    const i = $23d8f6d1574ae23f$export$eea18a04b33506ed(e, t, r);
    return $23d8f6d1574ae23f$export$79a538532b4f11f7(i);
}
function $23d8f6d1574ae23f$export$d9f11bd9fec5a64(e) {
    return e && e.includes("urn:recap:");
}
function $23d8f6d1574ae23f$export$c7a40c552af428b5(e, t) {
    const r = $23d8f6d1574ae23f$export$d34522c9e5a1aed1(e), i = $23d8f6d1574ae23f$export$d34522c9e5a1aed1(t), n = $23d8f6d1574ae23f$export$2445df2492ef2cbd(r, i);
    return $23d8f6d1574ae23f$export$79a538532b4f11f7(n);
}
function $23d8f6d1574ae23f$export$2445df2492ef2cbd(e, t) {
    $23d8f6d1574ae23f$export$ae8075c482503f32(e), $23d8f6d1574ae23f$export$ae8075c482503f32(t);
    const r = Object.keys(e.att).concat(Object.keys(t.att)).sort((n, o)=>n.localeCompare(o)), i = {
        att: {}
    };
    return r.forEach((n)=>{
        var o, h;
        Object.keys(((o = e.att) == null ? void 0 : o[n]) || {}).concat(Object.keys(((h = t.att) == null ? void 0 : h[n]) || {})).sort((p, b)=>p.localeCompare(b)).forEach((p)=>{
            var b, m;
            i.att[n] = $23d8f6d1574ae23f$var$Hf($23d8f6d1574ae23f$var$Hi({}, i.att[n]), {
                [p]: ((b = e.att[n]) == null ? void 0 : b[p]) || ((m = t.att[n]) == null ? void 0 : m[p])
            });
        });
    }), i;
}
function $23d8f6d1574ae23f$export$51673931d3a8308d(e = "", t) {
    $23d8f6d1574ae23f$export$ae8075c482503f32(t);
    const r = "I further authorize the stated URI to perform the following actions on my behalf: ";
    if (e.includes(r)) return e;
    const i = [];
    let n = 0;
    Object.keys(t.att).forEach((p)=>{
        const b = Object.keys(t.att[p]).map((y)=>({
                ability: y.split("/")[0],
                action: y.split("/")[1]
            }));
        b.sort((y, S)=>y.action.localeCompare(S.action));
        const m = {};
        b.forEach((y)=>{
            m[y.ability] || (m[y.ability] = []), m[y.ability].push(y.action);
        });
        const w = Object.keys(m).map((y)=>(n++, `(${n}) '${y}': '${m[y].join("', '")}' for '${p}'.`));
        i.push(w.join(", ").replace(".,", "."));
    });
    const o = i.join(" "), h = `${r}${o}`;
    return `${e ? e + " " : ""}${h}`;
}
function $23d8f6d1574ae23f$export$d6c6a43d36418efe(e) {
    var t;
    const r = $23d8f6d1574ae23f$export$d34522c9e5a1aed1(e);
    $23d8f6d1574ae23f$export$ae8075c482503f32(r);
    const i = (t = r.att) == null ? void 0 : t.eip155;
    return i ? Object.keys(i).map((n)=>n.split("/")[1]) : [];
}
function $23d8f6d1574ae23f$export$372f88051a611988(e) {
    const t = $23d8f6d1574ae23f$export$d34522c9e5a1aed1(e);
    $23d8f6d1574ae23f$export$ae8075c482503f32(t);
    const r = [];
    return Object.values(t.att).forEach((i)=>{
        Object.values(i).forEach((n)=>{
            var o;
            (o = n?.[0]) != null && o.chains && r.push(n[0].chains);
        });
    }), [
        ...new Set(r.flat())
    ];
}
function $23d8f6d1574ae23f$export$fb351782bc6f001e(e, t) {
    if (!t) return e;
    const r = $23d8f6d1574ae23f$export$d34522c9e5a1aed1(t);
    return $23d8f6d1574ae23f$export$ae8075c482503f32(r), $23d8f6d1574ae23f$export$51673931d3a8308d(e, r);
}
function $23d8f6d1574ae23f$export$3bb18ae0fb9a9fa9(e) {
    if (!e) return;
    const t = e?.[e.length - 1];
    return $23d8f6d1574ae23f$export$d9f11bd9fec5a64(t) ? t : void 0;
}
const $23d8f6d1574ae23f$export$f7403969428298bd = "base10", $23d8f6d1574ae23f$export$49eb910ab2518105 = "base16", $23d8f6d1574ae23f$export$9bff723d552e6bcf = "base64pad", $23d8f6d1574ae23f$export$9560dad2a83e4f04 = "utf8", $23d8f6d1574ae23f$export$3425bd336a9673d8 = 0, $23d8f6d1574ae23f$export$406e97c329f0f3d4 = 1, $23d8f6d1574ae23f$var$vu = 0, $23d8f6d1574ae23f$var$Zf = 1, $23d8f6d1574ae23f$var$Vi = 12, $23d8f6d1574ae23f$var$Wi = 32;
function $23d8f6d1574ae23f$export$a949d36eab55b41f() {
    const e = $lzf2X.generateKeyPair();
    return {
        privateKey: (0, $5t5tf.toString)(e.secretKey, $23d8f6d1574ae23f$export$49eb910ab2518105),
        publicKey: (0, $5t5tf.toString)(e.publicKey, $23d8f6d1574ae23f$export$49eb910ab2518105)
    };
}
function $23d8f6d1574ae23f$export$d15a28e4f1821243() {
    const e = (0, $aftW8.randomBytes)($23d8f6d1574ae23f$var$Wi);
    return (0, $5t5tf.toString)(e, $23d8f6d1574ae23f$export$49eb910ab2518105);
}
function $23d8f6d1574ae23f$export$f8378f68e053f5c6(e, t) {
    const r = $lzf2X.sharedKey((0, $50fYI.fromString)(e, $23d8f6d1574ae23f$export$49eb910ab2518105), (0, $50fYI.fromString)(t, $23d8f6d1574ae23f$export$49eb910ab2518105), !0), i = new (0, $bNsWC.HKDF)((0, $41Mfc.SHA256), r).expand($23d8f6d1574ae23f$var$Wi);
    return (0, $5t5tf.toString)(i, $23d8f6d1574ae23f$export$49eb910ab2518105);
}
function $23d8f6d1574ae23f$export$1e87d19d4aab5805(e) {
    const t = (0, $41Mfc.hash)((0, $50fYI.fromString)(e, $23d8f6d1574ae23f$export$49eb910ab2518105));
    return (0, $5t5tf.toString)(t, $23d8f6d1574ae23f$export$49eb910ab2518105);
}
function $23d8f6d1574ae23f$export$d4c241cec96564c1(e) {
    const t = (0, $41Mfc.hash)((0, $50fYI.fromString)(e, $23d8f6d1574ae23f$export$9560dad2a83e4f04));
    return (0, $5t5tf.toString)(t, $23d8f6d1574ae23f$export$49eb910ab2518105);
}
function $23d8f6d1574ae23f$export$e9d2f9ba70428fb6(e) {
    return (0, $50fYI.fromString)(`${e}`, $23d8f6d1574ae23f$export$f7403969428298bd);
}
function $23d8f6d1574ae23f$export$7547a514ee29b9d4(e) {
    return Number((0, $5t5tf.toString)(e, $23d8f6d1574ae23f$export$f7403969428298bd));
}
function $23d8f6d1574ae23f$export$5b0f6292f11d1d18(e) {
    const t = $23d8f6d1574ae23f$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $23d8f6d1574ae23f$export$3425bd336a9673d8);
    if ($23d8f6d1574ae23f$export$7547a514ee29b9d4(t) === $23d8f6d1574ae23f$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const r = typeof e.senderPublicKey < "u" ? (0, $50fYI.fromString)(e.senderPublicKey, $23d8f6d1574ae23f$export$49eb910ab2518105) : void 0, i = typeof e.iv < "u" ? (0, $50fYI.fromString)(e.iv, $23d8f6d1574ae23f$export$49eb910ab2518105) : (0, $aftW8.randomBytes)($23d8f6d1574ae23f$var$Vi), n = new (0, $1YStM.ChaCha20Poly1305)((0, $50fYI.fromString)(e.symKey, $23d8f6d1574ae23f$export$49eb910ab2518105)).seal(i, (0, $50fYI.fromString)(e.message, $23d8f6d1574ae23f$export$9560dad2a83e4f04));
    return $23d8f6d1574ae23f$export$dfdc1655ccc5b9cb({
        type: t,
        sealed: n,
        iv: i,
        senderPublicKey: r
    });
}
function $23d8f6d1574ae23f$export$e85a0c9a1067c5d3(e) {
    const t = new (0, $1YStM.ChaCha20Poly1305)((0, $50fYI.fromString)(e.symKey, $23d8f6d1574ae23f$export$49eb910ab2518105)), { sealed: r, iv: i } = $23d8f6d1574ae23f$export$efcd34ab6248d3cd(e.encoded), n = t.open(i, r);
    if (n === null) throw new Error("Failed to decrypt");
    return (0, $5t5tf.toString)(n, $23d8f6d1574ae23f$export$9560dad2a83e4f04);
}
function $23d8f6d1574ae23f$export$dfdc1655ccc5b9cb(e) {
    if ($23d8f6d1574ae23f$export$7547a514ee29b9d4(e.type) === $23d8f6d1574ae23f$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $5t5tf.toString)((0, $7GAet.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $23d8f6d1574ae23f$export$9bff723d552e6bcf);
    }
    return (0, $5t5tf.toString)((0, $7GAet.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $23d8f6d1574ae23f$export$9bff723d552e6bcf);
}
function $23d8f6d1574ae23f$export$efcd34ab6248d3cd(e) {
    const t = (0, $50fYI.fromString)(e, $23d8f6d1574ae23f$export$9bff723d552e6bcf), r = t.slice($23d8f6d1574ae23f$var$vu, $23d8f6d1574ae23f$var$Zf), i = $23d8f6d1574ae23f$var$Zf;
    if ($23d8f6d1574ae23f$export$7547a514ee29b9d4(r) === $23d8f6d1574ae23f$export$406e97c329f0f3d4) {
        const p = i + $23d8f6d1574ae23f$var$Wi, b = p + $23d8f6d1574ae23f$var$Vi, m = t.slice(i, p), w = t.slice(p, b), y = t.slice(b);
        return {
            type: r,
            sealed: y,
            iv: w,
            senderPublicKey: m
        };
    }
    const n = i + $23d8f6d1574ae23f$var$Vi, o = t.slice(i, n), h = t.slice(n);
    return {
        type: r,
        sealed: h,
        iv: o
    };
}
function $23d8f6d1574ae23f$export$177f3e316562333d(e, t) {
    const r = $23d8f6d1574ae23f$export$efcd34ab6248d3cd(e);
    return $23d8f6d1574ae23f$export$7949f60f2444aef2({
        type: $23d8f6d1574ae23f$export$7547a514ee29b9d4(r.type),
        senderPublicKey: typeof r.senderPublicKey < "u" ? (0, $5t5tf.toString)(r.senderPublicKey, $23d8f6d1574ae23f$export$49eb910ab2518105) : void 0,
        receiverPublicKey: t?.receiverPublicKey
    });
}
function $23d8f6d1574ae23f$export$7949f60f2444aef2(e) {
    const t = e?.type || $23d8f6d1574ae23f$export$3425bd336a9673d8;
    if (t === $23d8f6d1574ae23f$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: t,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $23d8f6d1574ae23f$export$8c165704db2d5c15(e) {
    return e.type === $23d8f6d1574ae23f$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
const $23d8f6d1574ae23f$export$822d0bd1635d5360 = "irn";
function $23d8f6d1574ae23f$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $23d8f6d1574ae23f$export$822d0bd1635d5360
    };
}
function $23d8f6d1574ae23f$export$604e3deb95e1b734(e) {
    const t = (0, $c4d4cb99ea3e8904$export$af490b3b9a6de00f)[e];
    if (typeof t > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return t;
}
var $23d8f6d1574ae23f$var$Iu = Object.defineProperty, $23d8f6d1574ae23f$var$_u = Object.defineProperties, $23d8f6d1574ae23f$var$Bu = Object.getOwnPropertyDescriptors, $23d8f6d1574ae23f$var$io = Object.getOwnPropertySymbols, $23d8f6d1574ae23f$var$Cu = Object.prototype.hasOwnProperty, $23d8f6d1574ae23f$var$Ru = Object.prototype.propertyIsEnumerable, $23d8f6d1574ae23f$var$no = (e, t, r)=>t in e ? $23d8f6d1574ae23f$var$Iu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $23d8f6d1574ae23f$var$fo = (e, t)=>{
    for(var r in t || (t = {}))$23d8f6d1574ae23f$var$Cu.call(t, r) && $23d8f6d1574ae23f$var$no(e, r, t[r]);
    if ($23d8f6d1574ae23f$var$io) for (var r of $23d8f6d1574ae23f$var$io(t))$23d8f6d1574ae23f$var$Ru.call(t, r) && $23d8f6d1574ae23f$var$no(e, r, t[r]);
    return e;
}, $23d8f6d1574ae23f$var$Ou = (e, t)=>$23d8f6d1574ae23f$var$_u(e, $23d8f6d1574ae23f$var$Bu(t));
function $23d8f6d1574ae23f$export$3d24f408c2ac468a(e, t = "-") {
    const r = {}, i = "relay" + t;
    return Object.keys(e).forEach((n)=>{
        if (n.startsWith(i)) {
            const o = n.replace(i, ""), h = e[n];
            r[o] = h;
        }
    }), r;
}
function $23d8f6d1574ae23f$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const t = e.indexOf(":"), r = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, i = e.substring(0, t), n = e.substring(t + 1, r).split("@"), o = typeof r < "u" ? e.substring(r) : "", h = $ezpuP.parse(o), p = typeof h.methods == "string" ? h.methods.split(",") : void 0;
    return {
        protocol: i,
        topic: $23d8f6d1574ae23f$export$5ddc9ebef1d00f28(n[0]),
        version: parseInt(n[1], 10),
        symKey: h.symKey,
        relay: $23d8f6d1574ae23f$export$3d24f408c2ac468a(h),
        methods: p,
        expiryTimestamp: h.expiryTimestamp ? parseInt(h.expiryTimestamp, 10) : void 0
    };
}
function $23d8f6d1574ae23f$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $23d8f6d1574ae23f$export$65c55c7ccd19bb8f(e, t = "-") {
    const r = "relay", i = {};
    return Object.keys(e).forEach((n)=>{
        const o = r + t + n;
        e[n] && (i[o] = e[n]);
    }), i;
}
function $23d8f6d1574ae23f$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $ezpuP.stringify($23d8f6d1574ae23f$var$fo($23d8f6d1574ae23f$var$Ou($23d8f6d1574ae23f$var$fo({
        symKey: e.symKey
    }, $23d8f6d1574ae23f$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }), e.methods ? {
        methods: e.methods.join(",")
    } : {}));
}
var $23d8f6d1574ae23f$var$Fu = Object.defineProperty, $23d8f6d1574ae23f$var$Tu = Object.defineProperties, $23d8f6d1574ae23f$var$Uu = Object.getOwnPropertyDescriptors, $23d8f6d1574ae23f$var$uo = Object.getOwnPropertySymbols, $23d8f6d1574ae23f$var$ku = Object.prototype.hasOwnProperty, $23d8f6d1574ae23f$var$qu = Object.prototype.propertyIsEnumerable, $23d8f6d1574ae23f$var$ho = (e, t, r)=>t in e ? $23d8f6d1574ae23f$var$Fu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $23d8f6d1574ae23f$var$Ku = (e, t)=>{
    for(var r in t || (t = {}))$23d8f6d1574ae23f$var$ku.call(t, r) && $23d8f6d1574ae23f$var$ho(e, r, t[r]);
    if ($23d8f6d1574ae23f$var$uo) for (var r of $23d8f6d1574ae23f$var$uo(t))$23d8f6d1574ae23f$var$qu.call(t, r) && $23d8f6d1574ae23f$var$ho(e, r, t[r]);
    return e;
}, $23d8f6d1574ae23f$var$Hu = (e, t)=>$23d8f6d1574ae23f$var$Tu(e, $23d8f6d1574ae23f$var$Uu(t));
function $23d8f6d1574ae23f$export$d46695d9c3664fe9(e) {
    const t = [];
    return e.forEach((r)=>{
        const [i, n] = r.split(":");
        t.push(`${i}:${n}`);
    }), t;
}
function $23d8f6d1574ae23f$export$fb6db6038e742b14(e) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        t.push(...$23d8f6d1574ae23f$export$d46695d9c3664fe9(r.accounts));
    }), t;
}
function $23d8f6d1574ae23f$export$7dcf4808e17b15ac(e, t) {
    const r = [];
    return Object.values(e).forEach((i)=>{
        $23d8f6d1574ae23f$export$d46695d9c3664fe9(i.accounts).includes(t) && r.push(...i.methods);
    }), r;
}
function $23d8f6d1574ae23f$export$94ee6d00e384a22(e, t) {
    const r = [];
    return Object.values(e).forEach((i)=>{
        $23d8f6d1574ae23f$export$d46695d9c3664fe9(i.accounts).includes(t) && r.push(...i.events);
    }), r;
}
function $23d8f6d1574ae23f$export$a8daa26a7c60ef90(e, t) {
    const r = $23d8f6d1574ae23f$export$93f7b81dc815a714(e, t);
    if (r) throw new Error(r.message);
    const i = {};
    for (const [n, o] of Object.entries(e))i[n] = {
        methods: o.methods,
        events: o.events,
        chains: o.accounts.map((h)=>`${h.split(":")[0]}:${h.split(":")[1]}`)
    };
    return i;
}
function $23d8f6d1574ae23f$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: t, optionalNamespaces: r = {} }, supportedNamespaces: i } = e, n = $23d8f6d1574ae23f$export$2994550cda701c96(t), o = $23d8f6d1574ae23f$export$2994550cda701c96(r), h = {};
    Object.keys(i).forEach((m)=>{
        const w = i[m].chains, y = i[m].methods, S = i[m].events, I = i[m].accounts;
        w.forEach((N)=>{
            if (!I.some((C)=>C.includes(N))) throw new Error(`No accounts provided for chain ${N} in namespace ${m}`);
        }), h[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    });
    const p = $23d8f6d1574ae23f$export$ba5b0a4b585cd1b4(t, h, "approve()");
    if (p) throw new Error(p.message);
    const b = {};
    return !Object.keys(t).length && !Object.keys(r).length ? h : (Object.keys(n).forEach((m)=>{
        const w = i[m].chains.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.chains) == null ? void 0 : F.includes(N);
        }), y = i[m].methods.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.methods) == null ? void 0 : F.includes(N);
        }), S = i[m].events.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.events) == null ? void 0 : F.includes(N);
        }), I = w.map((N)=>i[m].accounts.filter((C)=>C.includes(`${N}:`))).flat();
        b[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    }), Object.keys(o).forEach((m)=>{
        var w, y, S, I, N, C;
        if (!i[m]) return;
        const F = (y = (w = o[m]) == null ? void 0 : w.chains) == null ? void 0 : y.filter((G)=>i[m].chains.includes(G)), U = i[m].methods.filter((G)=>{
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.methods) == null ? void 0 : z.includes(G);
        }), J = i[m].events.filter((G)=>{
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.events) == null ? void 0 : z.includes(G);
        }), Bt = F?.map((G)=>i[m].accounts.filter((H)=>H.includes(`${G}:`))).flat();
        b[m] = {
            chains: $23d8f6d1574ae23f$export$9826fe7ad3921016((S = b[m]) == null ? void 0 : S.chains, F),
            methods: $23d8f6d1574ae23f$export$9826fe7ad3921016((I = b[m]) == null ? void 0 : I.methods, U),
            events: $23d8f6d1574ae23f$export$9826fe7ad3921016((N = b[m]) == null ? void 0 : N.events, J),
            accounts: $23d8f6d1574ae23f$export$9826fe7ad3921016((C = b[m]) == null ? void 0 : C.accounts, Bt)
        };
    }), b);
}
function $23d8f6d1574ae23f$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $23d8f6d1574ae23f$export$dd404c96fbbb1ff8(e) {
    return $23d8f6d1574ae23f$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $23d8f6d1574ae23f$export$2994550cda701c96(e) {
    var t, r, i;
    const n = {};
    if (!$23d8f6d1574ae23f$export$16a0268bc22b47b0(e)) return n;
    for (const [o, h] of Object.entries(e)){
        const p = $23d8f6d1574ae23f$export$e03e993df4723bde(o) ? [
            o
        ] : h.chains, b = h.methods || [], m = h.events || [], w = $23d8f6d1574ae23f$export$dd404c96fbbb1ff8(o);
        n[w] = $23d8f6d1574ae23f$var$Hu($23d8f6d1574ae23f$var$Ku({}, n[w]), {
            chains: $23d8f6d1574ae23f$export$9826fe7ad3921016(p, (t = n[w]) == null ? void 0 : t.chains),
            methods: $23d8f6d1574ae23f$export$9826fe7ad3921016(b, (r = n[w]) == null ? void 0 : r.methods),
            events: $23d8f6d1574ae23f$export$9826fe7ad3921016(m, (i = n[w]) == null ? void 0 : i.events)
        });
    }
    return n;
}
function $23d8f6d1574ae23f$export$293459f1cc8d700(e) {
    const t = {};
    return e?.forEach((r)=>{
        const [i, n] = r.split(":");
        t[i] || (t[i] = {
            accounts: [],
            chains: [],
            events: []
        }), t[i].accounts.push(r), t[i].chains.push(`${i}:${n}`);
    }), t;
}
function $23d8f6d1574ae23f$export$b5744b1c39447540(e, t) {
    t = t.map((i)=>i.replace("did:pkh:", ""));
    const r = $23d8f6d1574ae23f$export$293459f1cc8d700(t);
    for (const [i, n] of Object.entries(r))n.methods ? n.methods = $23d8f6d1574ae23f$export$9826fe7ad3921016(n.methods, e) : n.methods = e, n.events = [
        "chainChanged",
        "accountsChanged"
    ];
    return r;
}
const $23d8f6d1574ae23f$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $23d8f6d1574ae23f$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $23d8f6d1574ae23f$export$500d4c4a8fafe35(e, t) {
    const { message: r, code: i } = $23d8f6d1574ae23f$export$77b3faa414a0ce61[e];
    return {
        message: t ? `${r} ${t}` : r,
        code: i
    };
}
function $23d8f6d1574ae23f$export$8203ef1531c8b5b5(e, t) {
    const { message: r, code: i } = $23d8f6d1574ae23f$export$990de0b632caca05[e];
    return {
        message: t ? `${r} ${t}` : r,
        code: i
    };
}
function $23d8f6d1574ae23f$export$41dd3d480aac4a71(e, t) {
    return Array.isArray(e) ? typeof t < "u" && e.length ? e.every(t) : !0 : !1;
}
function $23d8f6d1574ae23f$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $23d8f6d1574ae23f$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $23d8f6d1574ae23f$export$ee898ca48ab56c74(e, t) {
    return t && $23d8f6d1574ae23f$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $23d8f6d1574ae23f$export$d6781b696a0576d1(e, t) {
    return t && $23d8f6d1574ae23f$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $23d8f6d1574ae23f$export$6fc4971bf8f326a(e, t) {
    const { requiredNamespaces: r } = t, i = Object.keys(e.namespaces), n = Object.keys(r);
    let o = !0;
    return $23d8f6d1574ae23f$export$1468a49de573f7f9(n, i) ? (i.forEach((h)=>{
        const { accounts: p, methods: b, events: m } = e.namespaces[h], w = $23d8f6d1574ae23f$export$d46695d9c3664fe9(p), y = r[h];
        (!$23d8f6d1574ae23f$export$1468a49de573f7f9($23d8f6d1574ae23f$export$376384387cd15b27(h, y), w) || !$23d8f6d1574ae23f$export$1468a49de573f7f9(y.methods, b) || !$23d8f6d1574ae23f$export$1468a49de573f7f9(y.events, m)) && (o = !1);
    }), o) : !1;
}
function $23d8f6d1574ae23f$export$e544b39f0a22e47a(e) {
    return $23d8f6d1574ae23f$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $23d8f6d1574ae23f$export$49e4a5b6862e3c71(e) {
    if ($23d8f6d1574ae23f$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const t = e.split(":");
        if (t.length === 3) {
            const r = t[0] + ":" + t[1];
            return !!t[2] && $23d8f6d1574ae23f$export$e544b39f0a22e47a(r);
        }
    }
    return !1;
}
function $23d8f6d1574ae23f$export$bef94a5618bf18bf(e) {
    if ($23d8f6d1574ae23f$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $23d8f6d1574ae23f$export$f657f7976bb2769d(e) {
    var t;
    return (t = e?.proposer) == null ? void 0 : t.publicKey;
}
function $23d8f6d1574ae23f$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $23d8f6d1574ae23f$export$5e1c5c89613c213f(e, t) {
    let r = null;
    return $23d8f6d1574ae23f$export$ee898ca48ab56c74(e?.publicKey, !1) || (r = $23d8f6d1574ae23f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t} controller public key should be a string`)), r;
}
function $23d8f6d1574ae23f$export$c12fced8176774f3(e) {
    let t = !0;
    return $23d8f6d1574ae23f$export$41dd3d480aac4a71(e) ? e.length && (t = e.every((r)=>$23d8f6d1574ae23f$export$ee898ca48ab56c74(r, !1))) : t = !1, t;
}
function $23d8f6d1574ae23f$export$df46c123d7e298ce(e, t, r) {
    let i = null;
    return $23d8f6d1574ae23f$export$41dd3d480aac4a71(t) && t.length ? t.forEach((n)=>{
        i || $23d8f6d1574ae23f$export$e544b39f0a22e47a(n) || (i = $23d8f6d1574ae23f$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${r}, chain ${n} should be a string and conform to "namespace:chainId" format`));
    }) : $23d8f6d1574ae23f$export$e544b39f0a22e47a(e) || (i = $23d8f6d1574ae23f$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${r}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), i;
}
function $23d8f6d1574ae23f$export$94ae96fb66f29e08(e, t, r) {
    let i = null;
    return Object.entries(e).forEach(([n, o])=>{
        if (i) return;
        const h = $23d8f6d1574ae23f$export$df46c123d7e298ce(n, $23d8f6d1574ae23f$export$376384387cd15b27(n, o), `${t} ${r}`);
        h && (i = h);
    }), i;
}
function $23d8f6d1574ae23f$export$d5644026aaffb9e7(e, t) {
    let r = null;
    return $23d8f6d1574ae23f$export$41dd3d480aac4a71(e) ? e.forEach((i)=>{
        r || $23d8f6d1574ae23f$export$49e4a5b6862e3c71(i) || (r = $23d8f6d1574ae23f$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${t}, account ${i} should be a string and conform to "namespace:chainId:address" format`));
    }) : r = $23d8f6d1574ae23f$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${t}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), r;
}
function $23d8f6d1574ae23f$export$2a2012e7bfa1cfb4(e, t) {
    let r = null;
    return Object.values(e).forEach((i)=>{
        if (r) return;
        const n = $23d8f6d1574ae23f$export$d5644026aaffb9e7(i?.accounts, `${t} namespace`);
        n && (r = n);
    }), r;
}
function $23d8f6d1574ae23f$export$b32541d63753af56(e, t) {
    let r = null;
    return $23d8f6d1574ae23f$export$c12fced8176774f3(e?.methods) ? $23d8f6d1574ae23f$export$c12fced8176774f3(e?.events) || (r = $23d8f6d1574ae23f$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${t}, events should be an array of strings or empty array for no events`)) : r = $23d8f6d1574ae23f$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${t}, methods should be an array of strings or empty array for no methods`), r;
}
function $23d8f6d1574ae23f$export$27682c78deeca9d7(e, t) {
    let r = null;
    return Object.values(e).forEach((i)=>{
        if (r) return;
        const n = $23d8f6d1574ae23f$export$b32541d63753af56(i, `${t}, namespace`);
        n && (r = n);
    }), r;
}
function $23d8f6d1574ae23f$export$9e2b2cae22c6a8b3(e, t, r) {
    let i = null;
    if (e && $23d8f6d1574ae23f$export$16a0268bc22b47b0(e)) {
        const n = $23d8f6d1574ae23f$export$27682c78deeca9d7(e, t);
        n && (i = n);
        const o = $23d8f6d1574ae23f$export$94ae96fb66f29e08(e, t, r);
        o && (i = o);
    } else i = $23d8f6d1574ae23f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t}, ${r} should be an object with data`);
    return i;
}
function $23d8f6d1574ae23f$export$93f7b81dc815a714(e, t) {
    let r = null;
    if (e && $23d8f6d1574ae23f$export$16a0268bc22b47b0(e)) {
        const i = $23d8f6d1574ae23f$export$27682c78deeca9d7(e, t);
        i && (r = i);
        const n = $23d8f6d1574ae23f$export$2a2012e7bfa1cfb4(e, t);
        n && (r = n);
    } else r = $23d8f6d1574ae23f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t}, namespaces should be an object with data`);
    return r;
}
function $23d8f6d1574ae23f$export$1b3fc298be8c9a7b(e) {
    return $23d8f6d1574ae23f$export$ee898ca48ab56c74(e.protocol, !0);
}
function $23d8f6d1574ae23f$export$6294c30b976bd21e(e, t) {
    let r = !1;
    return t && !e ? r = !0 : e && $23d8f6d1574ae23f$export$41dd3d480aac4a71(e) && e.length && e.forEach((i)=>{
        r = $23d8f6d1574ae23f$export$1b3fc298be8c9a7b(i);
    }), r;
}
function $23d8f6d1574ae23f$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $23d8f6d1574ae23f$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $23d8f6d1574ae23f$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$23d8f6d1574ae23f$export$d6781b696a0576d1(e.code, !1) || !e.message || !$23d8f6d1574ae23f$export$ee898ca48ab56c74(e.message, !1));
}
function $23d8f6d1574ae23f$export$1a2af3c017fb6d42(e) {
    return !($23d8f6d1574ae23f$export$fce6876652108ab(e) || !$23d8f6d1574ae23f$export$ee898ca48ab56c74(e.method, !1));
}
function $23d8f6d1574ae23f$export$1ae38cf0a848f651(e) {
    return !($23d8f6d1574ae23f$export$fce6876652108ab(e) || $23d8f6d1574ae23f$export$fce6876652108ab(e.result) && $23d8f6d1574ae23f$export$fce6876652108ab(e.error) || !$23d8f6d1574ae23f$export$d6781b696a0576d1(e.id, !1) || !$23d8f6d1574ae23f$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $23d8f6d1574ae23f$export$cbe4cdc5960cfa11(e) {
    return !($23d8f6d1574ae23f$export$fce6876652108ab(e) || !$23d8f6d1574ae23f$export$ee898ca48ab56c74(e.name, !1));
}
function $23d8f6d1574ae23f$export$144fc36610eb6522(e, t) {
    return !(!$23d8f6d1574ae23f$export$e544b39f0a22e47a(t) || !$23d8f6d1574ae23f$export$fb6db6038e742b14(e).includes(t));
}
function $23d8f6d1574ae23f$export$8db4804e3a6de711(e, t, r) {
    return $23d8f6d1574ae23f$export$ee898ca48ab56c74(r, !1) ? $23d8f6d1574ae23f$export$7dcf4808e17b15ac(e, t).includes(r) : !1;
}
function $23d8f6d1574ae23f$export$df2c67ef8baad16b(e, t, r) {
    return $23d8f6d1574ae23f$export$ee898ca48ab56c74(r, !1) ? $23d8f6d1574ae23f$export$94ee6d00e384a22(e, t).includes(r) : !1;
}
function $23d8f6d1574ae23f$export$ba5b0a4b585cd1b4(e, t, r) {
    let i = null;
    const n = $23d8f6d1574ae23f$var$sh(e), o = $23d8f6d1574ae23f$var$ah(t), h = Object.keys(n), p = Object.keys(o), b = $23d8f6d1574ae23f$var$_o(Object.keys(e)), m = $23d8f6d1574ae23f$var$_o(Object.keys(t)), w = b.filter((y)=>!m.includes(y));
    return w.length && (i = $23d8f6d1574ae23f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces keys don't satisfy requiredNamespaces.
      Required: ${w.toString()}
      Received: ${Object.keys(t).toString()}`)), $23d8f6d1574ae23f$export$1468a49de573f7f9(h, p) || (i = $23d8f6d1574ae23f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces chains don't satisfy required namespaces.
      Required: ${h.toString()}
      Approved: ${p.toString()}`)), Object.keys(t).forEach((y)=>{
        if (!y.includes(":") || i) return;
        const S = $23d8f6d1574ae23f$export$d46695d9c3664fe9(t[y].accounts);
        S.includes(y) || (i = $23d8f6d1574ae23f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces accounts don't satisfy namespace accounts for ${y}
        Required: ${y}
        Approved: ${S.toString()}`));
    }), h.forEach((y)=>{
        i || ($23d8f6d1574ae23f$export$1468a49de573f7f9(n[y].methods, o[y].methods) ? $23d8f6d1574ae23f$export$1468a49de573f7f9(n[y].events, o[y].events) || (i = $23d8f6d1574ae23f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces events don't satisfy namespace events for ${y}`)) : i = $23d8f6d1574ae23f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces methods don't satisfy namespace methods for ${y}`));
    }), i;
}
function $23d8f6d1574ae23f$var$sh(e) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        var i;
        r.includes(":") ? t[r] = e[r] : (i = e[r].chains) == null || i.forEach((n)=>{
            t[n] = {
                methods: e[r].methods,
                events: e[r].events
            };
        });
    }), t;
}
function $23d8f6d1574ae23f$var$_o(e) {
    return [
        ...new Set(e.map((t)=>t.includes(":") ? t.split(":")[0] : t))
    ];
}
function $23d8f6d1574ae23f$var$ah(e) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        if (r.includes(":")) t[r] = e[r];
        else {
            const i = $23d8f6d1574ae23f$export$d46695d9c3664fe9(e[r].accounts);
            i?.forEach((n)=>{
                t[n] = {
                    accounts: e[r].accounts.filter((o)=>o.includes(`${n}:`)),
                    methods: e[r].methods,
                    events: e[r].events
                };
            });
        }
    }), t;
}
function $23d8f6d1574ae23f$export$59fba2af1ac782b(e, t) {
    return $23d8f6d1574ae23f$export$d6781b696a0576d1(e, !1) && e <= t.max && e >= t.min;
}
function $23d8f6d1574ae23f$export$53c2fd0173ad2b80() {
    const e = $23d8f6d1574ae23f$export$57570b1603cf6adb();
    return new Promise((t)=>{
        switch(e){
            case $23d8f6d1574ae23f$export$86b1301a63b15dd9.browser:
                t($23d8f6d1574ae23f$export$2f147c609a999e49());
                break;
            case $23d8f6d1574ae23f$export$86b1301a63b15dd9.reactNative:
                t($23d8f6d1574ae23f$export$1444c95b1570bd12());
                break;
            case $23d8f6d1574ae23f$export$86b1301a63b15dd9.node:
                t($23d8f6d1574ae23f$export$aec5b2d627eec500());
                break;
            default:
                t(!0);
        }
    });
}
function $23d8f6d1574ae23f$export$2f147c609a999e49() {
    return $23d8f6d1574ae23f$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $23d8f6d1574ae23f$export$1444c95b1570bd12() {
    if ($23d8f6d1574ae23f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $23d8f6d1574ae23f$export$aec5b2d627eec500() {
    return !0;
}
function $23d8f6d1574ae23f$export$600a1ee4bc680996(e) {
    switch($23d8f6d1574ae23f$export$57570b1603cf6adb()){
        case $23d8f6d1574ae23f$export$86b1301a63b15dd9.browser:
            $23d8f6d1574ae23f$export$d32b24f18d96c5f2(e);
            break;
        case $23d8f6d1574ae23f$export$86b1301a63b15dd9.reactNative:
            $23d8f6d1574ae23f$export$904edb1c18ec91c7(e);
            break;
        case $23d8f6d1574ae23f$export$86b1301a63b15dd9.node:
            break;
    }
}
function $23d8f6d1574ae23f$export$d32b24f18d96c5f2(e) {
    !$23d8f6d1574ae23f$export$f7a1e23e542d38e3() && $23d8f6d1574ae23f$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $23d8f6d1574ae23f$export$904edb1c18ec91c7(e) {
    $23d8f6d1574ae23f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((t)=>e(t?.isConnected));
}
const $23d8f6d1574ae23f$var$rn = {};
class $23d8f6d1574ae23f$export$b72d712fed4d036d {
    static get(t) {
        return $23d8f6d1574ae23f$var$rn[t];
    }
    static set(t, r) {
        $23d8f6d1574ae23f$var$rn[t] = r;
    }
    static delete(t) {
        delete $23d8f6d1574ae23f$var$rn[t];
    }
}



var $b9XBB = parcelRequire("b9XBB");


function $babd30084af4d4ba$export$bcd1dd1f397bba12(transports_, config = {}) {
    const { key: key = "fallback", name: name = "Fallback", rank: rank = false, retryCount: retryCount, retryDelay: retryDelay } = config;
    return ({ chain: chain, pollingInterval: pollingInterval = 4000, timeout: timeout, ...rest })=>{
        let transports = transports_;
        let onResponse = ()=>{};
        const transport = (0, $d48cdafdaf09bb70$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const fetch = async (i = 0)=>{
                    const transport = transports[i]({
                        ...rest,
                        chain: chain,
                        retryCount: 0,
                        timeout: timeout
                    });
                    try {
                        const response = await transport.request({
                            method: method,
                            params: params
                        });
                        onResponse({
                            method: method,
                            params: params,
                            response: response,
                            transport: transport,
                            status: "success"
                        });
                        return response;
                    } catch (err) {
                        onResponse({
                            error: err,
                            method: method,
                            params: params,
                            transport: transport,
                            status: "error"
                        });
                        if ($babd30084af4d4ba$var$shouldThrow(err)) throw err;
                        // If we've reached the end of the fallbacks, throw the error.
                        if (i === transports.length - 1) throw err;
                        // Otherwise, try the next fallback.
                        return fetch(i + 1);
                    }
                };
                return fetch();
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            type: "fallback"
        }, {
            onResponse: (fn)=>onResponse = fn,
            transports: transports.map((fn)=>fn({
                    chain: chain,
                    retryCount: 0
                }))
        });
        if (rank) {
            const rankOptions = typeof rank === "object" ? rank : {};
            $babd30084af4d4ba$export$f2bce5ae3fda4e76({
                chain: chain,
                interval: rankOptions.interval ?? pollingInterval,
                onTransports: (transports_)=>transports = transports_,
                sampleCount: rankOptions.sampleCount,
                timeout: rankOptions.timeout,
                transports: transports,
                weights: rankOptions.weights
            });
        }
        return transport;
    };
}
function $babd30084af4d4ba$var$shouldThrow(error) {
    if ("code" in error && typeof error.code === "number") {
        if (error.code === (0, $b9XBB.TransactionRejectedRpcError).code || error.code === (0, $b9XBB.UserRejectedRequestError).code || error.code === 5000 // CAIP UserRejectedRequestError
        ) return true;
    }
    return false;
}
function $babd30084af4d4ba$export$f2bce5ae3fda4e76({ chain: chain, interval: interval = 4000, onTransports: onTransports, sampleCount: sampleCount = 10, timeout: timeout = 1000, transports: transports, weights: weights = {} }) {
    const { stability: stabilityWeight = 0.7, latency: latencyWeight = 0.3 } = weights;
    const samples = [];
    const rankTransports_ = async ()=>{
        // 1. Take a sample from each Transport.
        const sample = await Promise.all(transports.map(async (transport)=>{
            const transport_ = transport({
                chain: chain,
                retryCount: 0,
                timeout: timeout
            });
            const start = Date.now();
            let end;
            let success;
            try {
                await transport_.request({
                    method: "net_listening"
                });
                success = 1;
            } catch  {
                success = 0;
            } finally{
                end = Date.now();
            }
            const latency = end - start;
            return {
                latency: latency,
                success: success
            };
        }));
        // 2. Store the sample. If we have more than `sampleCount` samples, remove
        // the oldest sample.
        samples.push(sample);
        if (samples.length > sampleCount) samples.shift();
        // 3. Calculate the max latency from samples.
        const maxLatency = Math.max(...samples.map((sample)=>Math.max(...sample.map(({ latency: latency })=>latency))));
        // 4. Calculate the score for each Transport.
        const scores = transports.map((_, i)=>{
            const latencies = samples.map((sample)=>sample[i].latency);
            const meanLatency = latencies.reduce((acc, latency)=>acc + latency, 0) / latencies.length;
            const latencyScore = 1 - meanLatency / maxLatency;
            const successes = samples.map((sample)=>sample[i].success);
            const stabilityScore = successes.reduce((acc, success)=>acc + success, 0) / successes.length;
            if (stabilityScore === 0) return [
                0,
                i
            ];
            return [
                latencyWeight * latencyScore + stabilityWeight * stabilityScore,
                i
            ];
        }).sort((a, b)=>b[0] - a[0]);
        // 5. Sort the Transports by score.
        onTransports(scores.map(([, i])=>transports[i]));
        // 6. Wait, and then rank again.
        await (0, $82df4c442695b4bf$export$5c069c93d2b7493f)(interval);
        rankTransports_();
    };
    rankTransports_();
}


var $aMZh2 = parcelRequire("aMZh2");

var $gzjWc = parcelRequire("gzjWc");
class $7611ab01c5b41e94$export$d0a48bf953f3c239 extends (0, $gzjWc.BaseError) {
    constructor(){
        super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
            docsPath: "/docs/clients/intro",
            name: "UrlRequiredError"
        });
    }
}



var $fNXI0 = parcelRequire("fNXI0");

var $aMZh2 = parcelRequire("aMZh2");
function $3ed1f8a9ac62a2b7$export$e86e19342bc4850e(fn, { errorInstance: errorInstance = new Error("timed out"), timeout: timeout, signal: signal }) {
    return new Promise((resolve, reject)=>{
        (async ()=>{
            let timeoutId;
            try {
                const controller = new AbortController();
                if (timeout > 0) timeoutId = setTimeout(()=>{
                    if (signal) controller.abort();
                    else reject(errorInstance);
                }, timeout); // need to cast because bun globals.d.ts overrides @types/node
                resolve(await fn({
                    signal: controller?.signal || null
                }));
            } catch (err) {
                if (err?.name === "AbortError") reject(errorInstance);
                reject(err);
            } finally{
                clearTimeout(timeoutId);
            }
        })();
    });
}



var $6nOtb = parcelRequire("6nOtb");
function $f158ea882eb57924$var$createIdStore() {
    return {
        current: 0,
        take () {
            return this.current++;
        },
        reset () {
            this.current = 0;
        }
    };
}
const $f158ea882eb57924$export$94f79fd1fae0679e = /*#__PURE__*/ $f158ea882eb57924$var$createIdStore();


function $fd15b9c89b56a0ff$export$290dc69d3612792(url, options = {}) {
    return {
        async request (params) {
            const { body: body, onRequest: onRequest = options.onRequest, onResponse: onResponse = options.onResponse, timeout: timeout = options.timeout ?? 10000 } = params;
            const fetchOptions = {
                ...options.fetchOptions ?? {},
                ...params.fetchOptions ?? {}
            };
            const { headers: headers, method: method, signal: signal_ } = fetchOptions;
            try {
                const response = await (0, $3ed1f8a9ac62a2b7$export$e86e19342bc4850e)(async ({ signal: signal })=>{
                    const init = {
                        ...fetchOptions,
                        body: Array.isArray(body) ? (0, $6nOtb.stringify)(body.map((body)=>({
                                jsonrpc: "2.0",
                                id: body.id ?? (0, $f158ea882eb57924$export$94f79fd1fae0679e).take(),
                                ...body
                            }))) : (0, $6nOtb.stringify)({
                            jsonrpc: "2.0",
                            id: body.id ?? (0, $f158ea882eb57924$export$94f79fd1fae0679e).take(),
                            ...body
                        }),
                        headers: {
                            "Content-Type": "application/json",
                            ...headers
                        },
                        method: method || "POST",
                        signal: signal_ || (timeout > 0 ? signal : null)
                    };
                    const request = new Request(url, init);
                    if (onRequest) await onRequest(request);
                    const response = await fetch(url, init);
                    return response;
                }, {
                    errorInstance: new (0, $aMZh2.TimeoutError)({
                        body: body,
                        url: url
                    }),
                    timeout: timeout,
                    signal: true
                });
                if (onResponse) await onResponse(response);
                let data;
                if (response.headers.get("Content-Type")?.startsWith("application/json")) data = await response.json();
                else {
                    data = await response.text();
                    data = JSON.parse(data || "{}");
                }
                if (!response.ok) throw new (0, $aMZh2.HttpRequestError)({
                    body: body,
                    details: (0, $6nOtb.stringify)(data.error) || response.statusText,
                    headers: response.headers,
                    status: response.status,
                    url: url
                });
                return data;
            } catch (err) {
                if (err instanceof (0, $aMZh2.HttpRequestError)) throw err;
                if (err instanceof (0, $aMZh2.TimeoutError)) throw err;
                throw new (0, $aMZh2.HttpRequestError)({
                    body: body,
                    cause: err,
                    url: url
                });
            }
        }
    };
}



function $b130bbeefe4d10ed$export$7d6f1c8842f9f527(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { batch: batch, fetchOptions: fetchOptions, key: key = "http", name: name = "HTTP JSON-RPC", onFetchRequest: onFetchRequest, onFetchResponse: onFetchResponse, retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const { batchSize: batchSize = 1000, wait: wait = 0 } = typeof batch === "object" ? batch : {};
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.http[0];
        if (!url_) throw new (0, $7611ab01c5b41e94$export$d0a48bf953f3c239)();
        const rpcClient = (0, $fd15b9c89b56a0ff$export$290dc69d3612792)(url_, {
            fetchOptions: fetchOptions,
            onRequest: onFetchRequest,
            onResponse: onFetchResponse,
            timeout: timeout
        });
        return (0, $d48cdafdaf09bb70$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const { schedule: schedule } = (0, $fNXI0.createBatchScheduler)({
                    id: url_,
                    wait: wait,
                    shouldSplitBatch (requests) {
                        return requests.length > batchSize;
                    },
                    fn: (body)=>rpcClient.request({
                            body: body
                        }),
                    sort: (a, b)=>a.id - b.id
                });
                const fn = async (body)=>batch ? schedule(body) : [
                        await rpcClient.request({
                            body: body
                        })
                    ];
                const [{ error: error, result: result }] = await fn(body);
                if (error) throw new (0, $aMZh2.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "http"
        }, {
            fetchOptions: fetchOptions,
            url: url_
        });
    };
}


parcelRequire("eNJDH");
var $c4rfq = parcelRequire("c4rfq");
function $cea68b5dc8f74603$export$1ee567fcdafbf4d8(chain) {
    if (!chain) return undefined;
    return {
        id: `${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
        name: chain.name,
        imageId: (0, $aa7460a2eaf4ba4c$export$fd35d6514357600).EIP155NetworkImageIds[chain.id],
        chain: (0, $1VCt9.ConstantsUtil).CHAIN.EVM
    };
}
async function $cea68b5dc8f74603$export$24a8d1cae47a6f(connector) {
    if (!connector) throw new Error("networkControllerClient:getApprovedCaipNetworks - connector is undefined");
    const provider = await connector?.getProvider();
    const ns = provider?.signer?.session?.namespaces;
    const nsMethods = ns?.[(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155]?.methods;
    const nsChains = (0, $23d8f6d1574ae23f$export$d5ee58c6b13696e9)(ns?.[(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155]?.accounts || []);
    return {
        supportsAllNetworks: Boolean(nsMethods?.includes((0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).ADD_CHAIN_METHOD)),
        approvedCaipNetworkIds: nsChains
    };
}
function $cea68b5dc8f74603$export$94f91666d3e5b28f() {
    return {
        supportsAllNetworks: false,
        approvedCaipNetworkIds: (0, $aa7460a2eaf4ba4c$export$fd35d6514357600).WalletConnectRpcChainIds.map((id)=>`${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155}:${id}`)
    };
}
function $cea68b5dc8f74603$export$867d8b939ab7f43e({ chain: chain, projectId: projectId }) {
    const RPC_URL = (0, $c4rfq.CoreHelperUtil).getBlockchainApiUrl();
    const chainDefaultUrl = chain.rpcUrls[0]?.http?.[0];
    if (!(0, $aa7460a2eaf4ba4c$export$fd35d6514357600).WalletConnectRpcChainIds.includes(chain.id)) return (0, $b130bbeefe4d10ed$export$7d6f1c8842f9f527)(chainDefaultUrl);
    return (0, $babd30084af4d4ba$export$bcd1dd1f397bba12)([
        (0, $b130bbeefe4d10ed$export$7d6f1c8842f9f527)(`${RPC_URL}/v1/?chainId=${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155}:${chain.id}&projectId=${projectId}`, {
            fetchOptions: {
                headers: {
                    "Content-Type": "text/plain"
                }
            }
        }),
        (0, $b130bbeefe4d10ed$export$7d6f1c8842f9f527)(chainDefaultUrl)
    ]);
}
function $cea68b5dc8f74603$export$c1398e40f52e8b4a(caipAddress) {
    if (!caipAddress) throw new Error("No CAIP address provided");
    const account = caipAddress.split(":")[2];
    if (!account) throw new Error("Invalid CAIP address");
    return account;
}


parcelRequire("dUH6N");
var $l0IQQ = parcelRequire("l0IQQ");
var $lr7C8 = parcelRequire("lr7C8");
// created 2023-09-12T22:05:14.211Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $48d5c3170aa0f8d7$var$COMPRESSED$1 = "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";
const $48d5c3170aa0f8d7$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $48d5c3170aa0f8d7$var$NSM_MAX = 4;
function $48d5c3170aa0f8d7$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $48d5c3170aa0f8d7$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $48d5c3170aa0f8d7$var$read_compressed_payload(s) {
    return $48d5c3170aa0f8d7$var$read_payload($48d5c3170aa0f8d7$var$decode_arithmetic($48d5c3170aa0f8d7$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $48d5c3170aa0f8d7$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $48d5c3170aa0f8d7$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $48d5c3170aa0f8d7$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $48d5c3170aa0f8d7$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $48d5c3170aa0f8d7$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $48d5c3170aa0f8d7$var$read_sorted_arrays(next) {
    return $48d5c3170aa0f8d7$var$read_array_while(()=>{
        let v = $48d5c3170aa0f8d7$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $48d5c3170aa0f8d7$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($48d5c3170aa0f8d7$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($48d5c3170aa0f8d7$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $48d5c3170aa0f8d7$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $48d5c3170aa0f8d7$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$48d5c3170aa0f8d7$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $48d5c3170aa0f8d7$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $48d5c3170aa0f8d7$var$read_array_while(next);
    let m = $48d5c3170aa0f8d7$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $48d5c3170aa0f8d7$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $48d5c3170aa0f8d7$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $48d5c3170aa0f8d7$var$read_trie(next) {
    let ret = [];
    let sorted = $48d5c3170aa0f8d7$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $48d5c3170aa0f8d7$var$read_array_while(()=>{
            let cps = $48d5c3170aa0f8d7$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $48d5c3170aa0f8d7$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $48d5c3170aa0f8d7$var$quote_cp(cp) {
    return `{${$48d5c3170aa0f8d7$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $48d5c3170aa0f8d7$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $48d5c3170aa0f8d7$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $48d5c3170aa0f8d7$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-12T22:05:14.211Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $48d5c3170aa0f8d7$var$COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $48d5c3170aa0f8d7$var$S0 = 0xAC00;
const $48d5c3170aa0f8d7$var$L0 = 0x1100;
const $48d5c3170aa0f8d7$var$V0 = 0x1161;
const $48d5c3170aa0f8d7$var$T0 = 0x11A7;
const $48d5c3170aa0f8d7$var$L_COUNT = 19;
const $48d5c3170aa0f8d7$var$V_COUNT = 21;
const $48d5c3170aa0f8d7$var$T_COUNT = 28;
const $48d5c3170aa0f8d7$var$N_COUNT = $48d5c3170aa0f8d7$var$V_COUNT * $48d5c3170aa0f8d7$var$T_COUNT;
const $48d5c3170aa0f8d7$var$S_COUNT = $48d5c3170aa0f8d7$var$L_COUNT * $48d5c3170aa0f8d7$var$N_COUNT;
const $48d5c3170aa0f8d7$var$S1 = $48d5c3170aa0f8d7$var$S0 + $48d5c3170aa0f8d7$var$S_COUNT;
const $48d5c3170aa0f8d7$var$L1 = $48d5c3170aa0f8d7$var$L0 + $48d5c3170aa0f8d7$var$L_COUNT;
const $48d5c3170aa0f8d7$var$V1 = $48d5c3170aa0f8d7$var$V0 + $48d5c3170aa0f8d7$var$V_COUNT;
const $48d5c3170aa0f8d7$var$T1 = $48d5c3170aa0f8d7$var$T0 + $48d5c3170aa0f8d7$var$T_COUNT;
function $48d5c3170aa0f8d7$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $48d5c3170aa0f8d7$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $48d5c3170aa0f8d7$var$SHIFTED_RANK, $48d5c3170aa0f8d7$var$EXCLUSIONS, $48d5c3170aa0f8d7$var$DECOMP, $48d5c3170aa0f8d7$var$RECOMP;
function $48d5c3170aa0f8d7$var$init$1() {
    //console.time('nf');
    let r = $48d5c3170aa0f8d7$var$read_compressed_payload($48d5c3170aa0f8d7$var$COMPRESSED);
    $48d5c3170aa0f8d7$var$SHIFTED_RANK = new Map($48d5c3170aa0f8d7$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $48d5c3170aa0f8d7$var$EXCLUSIONS = new Set($48d5c3170aa0f8d7$var$read_sorted(r));
    $48d5c3170aa0f8d7$var$DECOMP = new Map();
    $48d5c3170aa0f8d7$var$RECOMP = new Map();
    for (let [cp, cps] of $48d5c3170aa0f8d7$var$read_mapped(r)){
        if (!$48d5c3170aa0f8d7$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $48d5c3170aa0f8d7$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $48d5c3170aa0f8d7$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $48d5c3170aa0f8d7$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $48d5c3170aa0f8d7$var$is_hangul(cp) {
    return cp >= $48d5c3170aa0f8d7$var$S0 && cp < $48d5c3170aa0f8d7$var$S1;
}
function $48d5c3170aa0f8d7$var$compose_pair(a, b) {
    if (a >= $48d5c3170aa0f8d7$var$L0 && a < $48d5c3170aa0f8d7$var$L1 && b >= $48d5c3170aa0f8d7$var$V0 && b < $48d5c3170aa0f8d7$var$V1) return $48d5c3170aa0f8d7$var$S0 + (a - $48d5c3170aa0f8d7$var$L0) * $48d5c3170aa0f8d7$var$N_COUNT + (b - $48d5c3170aa0f8d7$var$V0) * $48d5c3170aa0f8d7$var$T_COUNT;
    else if ($48d5c3170aa0f8d7$var$is_hangul(a) && b > $48d5c3170aa0f8d7$var$T0 && b < $48d5c3170aa0f8d7$var$T1 && (a - $48d5c3170aa0f8d7$var$S0) % $48d5c3170aa0f8d7$var$T_COUNT == 0) return a + (b - $48d5c3170aa0f8d7$var$T0);
    else {
        let recomp = $48d5c3170aa0f8d7$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $48d5c3170aa0f8d7$var$decomposed(cps) {
    if (!$48d5c3170aa0f8d7$var$SHIFTED_RANK) $48d5c3170aa0f8d7$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $48d5c3170aa0f8d7$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($48d5c3170aa0f8d7$var$is_hangul(cp)) {
            let s_index = cp - $48d5c3170aa0f8d7$var$S0;
            let l_index = s_index / $48d5c3170aa0f8d7$var$N_COUNT | 0;
            let v_index = s_index % $48d5c3170aa0f8d7$var$N_COUNT / $48d5c3170aa0f8d7$var$T_COUNT | 0;
            let t_index = s_index % $48d5c3170aa0f8d7$var$T_COUNT;
            add($48d5c3170aa0f8d7$var$L0 + l_index);
            add($48d5c3170aa0f8d7$var$V0 + v_index);
            if (t_index > 0) add($48d5c3170aa0f8d7$var$T0 + t_index);
        } else {
            let mapped = $48d5c3170aa0f8d7$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $48d5c3170aa0f8d7$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $48d5c3170aa0f8d7$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $48d5c3170aa0f8d7$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $48d5c3170aa0f8d7$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $48d5c3170aa0f8d7$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $48d5c3170aa0f8d7$var$unpack_cc(packed);
        let cp = $48d5c3170aa0f8d7$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $48d5c3170aa0f8d7$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $48d5c3170aa0f8d7$export$9d0d896b286a3dba(cps) {
    return $48d5c3170aa0f8d7$var$decomposed(cps).map($48d5c3170aa0f8d7$var$unpack_cp);
}
function $48d5c3170aa0f8d7$export$f42252642e08449(cps) {
    return $48d5c3170aa0f8d7$var$composed_from_decomposed($48d5c3170aa0f8d7$var$decomposed(cps));
}
const $48d5c3170aa0f8d7$var$HYPHEN = 0x2D;
const $48d5c3170aa0f8d7$var$STOP = 0x2E;
const $48d5c3170aa0f8d7$var$STOP_CH = ".";
const $48d5c3170aa0f8d7$var$FE0F = 0xFE0F;
const $48d5c3170aa0f8d7$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $48d5c3170aa0f8d7$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $48d5c3170aa0f8d7$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $48d5c3170aa0f8d7$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $48d5c3170aa0f8d7$var$MAPPED, $48d5c3170aa0f8d7$var$IGNORED, $48d5c3170aa0f8d7$var$CM, $48d5c3170aa0f8d7$var$NSM, $48d5c3170aa0f8d7$var$ESCAPE, $48d5c3170aa0f8d7$var$NFC_CHECK, $48d5c3170aa0f8d7$var$GROUPS, $48d5c3170aa0f8d7$var$WHOLE_VALID, $48d5c3170aa0f8d7$var$WHOLE_MAP, $48d5c3170aa0f8d7$var$VALID, $48d5c3170aa0f8d7$var$EMOJI_LIST, $48d5c3170aa0f8d7$var$EMOJI_ROOT;
function $48d5c3170aa0f8d7$var$init() {
    if ($48d5c3170aa0f8d7$var$MAPPED) return;
    let r = $48d5c3170aa0f8d7$var$read_compressed_payload($48d5c3170aa0f8d7$var$COMPRESSED$1);
    const read_sorted_array = ()=>$48d5c3170aa0f8d7$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    $48d5c3170aa0f8d7$var$MAPPED = new Map($48d5c3170aa0f8d7$var$read_mapped(r));
    $48d5c3170aa0f8d7$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $48d5c3170aa0f8d7$var$CM = read_sorted_array();
    $48d5c3170aa0f8d7$var$NSM = new Set(read_sorted_array().map((i)=>$48d5c3170aa0f8d7$var$CM[i]));
    $48d5c3170aa0f8d7$var$CM = new Set($48d5c3170aa0f8d7$var$CM);
    $48d5c3170aa0f8d7$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $48d5c3170aa0f8d7$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $48d5c3170aa0f8d7$var$read_sorted_arrays(r);
    let unrestricted = r();
    const read_chunked = ()=>new Set(read_sorted_array().flatMap((i)=>chunks[i]).concat(read_sorted_array()));
    $48d5c3170aa0f8d7$var$GROUPS = $48d5c3170aa0f8d7$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $48d5c3170aa0f8d7$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // first arent restricted
            N[0] -= 32; // capitalize
            N = $48d5c3170aa0f8d7$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $48d5c3170aa0f8d7$var$WHOLE_VALID = read_sorted_set();
    $48d5c3170aa0f8d7$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($48d5c3170aa0f8d7$var$Array_from($48d5c3170aa0f8d7$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$48d5c3170aa0f8d7$var$WHOLE_VALID.has(cp)) $48d5c3170aa0f8d7$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    for (let { V: V, M: M } of new Set($48d5c3170aa0f8d7$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $48d5c3170aa0f8d7$var$GROUPS.filter((g)=>$48d5c3170aa0f8d7$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            gs.forEach((g)=>rec.G.add(g));
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$48d5c3170aa0f8d7$var$Array_from(x.G));
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g)));
            for (let cp of V)M.set(cp, complement);
        }
    }
    // compute valid set
    let union = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>union.has(cp) ? multi.add(cp) : union.add(cp);
    for (let g of $48d5c3170aa0f8d7$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of union)if (!$48d5c3170aa0f8d7$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $48d5c3170aa0f8d7$var$WHOLE_MAP.set(cp, $48d5c3170aa0f8d7$var$UNIQUE_PH);
    $48d5c3170aa0f8d7$var$VALID = new Set($48d5c3170aa0f8d7$var$Array_from(union).concat($48d5c3170aa0f8d7$var$Array_from($48d5c3170aa0f8d7$export$9d0d896b286a3dba(union)))); // possibly valid
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $48d5c3170aa0f8d7$var$EMOJI_LIST = $48d5c3170aa0f8d7$var$read_trie(r).map((v)=>$48d5c3170aa0f8d7$var$Emoji.from(v)).sort($48d5c3170aa0f8d7$var$compare_arrays);
    $48d5c3170aa0f8d7$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $48d5c3170aa0f8d7$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $48d5c3170aa0f8d7$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $48d5c3170aa0f8d7$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $48d5c3170aa0f8d7$var$quoted_cp(cp) {
    return ($48d5c3170aa0f8d7$export$4b1c9c18c687e5e9(cp) ? "" : `${$48d5c3170aa0f8d7$var$bidi_qq($48d5c3170aa0f8d7$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $48d5c3170aa0f8d7$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $48d5c3170aa0f8d7$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $48d5c3170aa0f8d7$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $48d5c3170aa0f8d7$var$HYPHEN && cps[3] == $48d5c3170aa0f8d7$var$HYPHEN) throw new Error(`invalid label extension: "${$48d5c3170aa0f8d7$var$str_from_cps(cps.slice(0, 4))}"`);
}
function $48d5c3170aa0f8d7$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $48d5c3170aa0f8d7$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $48d5c3170aa0f8d7$var$FENCED.get(cp);
    if (prev) throw $48d5c3170aa0f8d7$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $48d5c3170aa0f8d7$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $48d5c3170aa0f8d7$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $48d5c3170aa0f8d7$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $48d5c3170aa0f8d7$export$6ec6f9a7f89f00db(cps, quoter = $48d5c3170aa0f8d7$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($48d5c3170aa0f8d7$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($48d5c3170aa0f8d7$export$4b1c9c18c687e5e9(cp)) {
            buf.push($48d5c3170aa0f8d7$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($48d5c3170aa0f8d7$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $48d5c3170aa0f8d7$export$e29a9e4d2573411c(cp) {
    $48d5c3170aa0f8d7$var$init();
    return $48d5c3170aa0f8d7$var$CM.has(cp);
}
function $48d5c3170aa0f8d7$export$4b1c9c18c687e5e9(cp) {
    $48d5c3170aa0f8d7$var$init();
    return $48d5c3170aa0f8d7$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $48d5c3170aa0f8d7$export$95d5ea4de7964366() {
    $48d5c3170aa0f8d7$var$init();
    return $48d5c3170aa0f8d7$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $48d5c3170aa0f8d7$export$f4e6b2721065fb3d(frag, decompose) {
    $48d5c3170aa0f8d7$var$init();
    let nf = decompose ? $48d5c3170aa0f8d7$export$9d0d896b286a3dba : $48d5c3170aa0f8d7$export$f42252642e08449;
    return frag.split($48d5c3170aa0f8d7$var$STOP_CH).map((label)=>$48d5c3170aa0f8d7$var$str_from_cps($48d5c3170aa0f8d7$var$tokens_from_str($48d5c3170aa0f8d7$var$explode_cp(label), nf, $48d5c3170aa0f8d7$var$filter_fe0f).flat())).join($48d5c3170aa0f8d7$var$STOP_CH);
}
function $48d5c3170aa0f8d7$export$499f715881831a51(name) {
    return $48d5c3170aa0f8d7$var$flatten($48d5c3170aa0f8d7$var$split(name, $48d5c3170aa0f8d7$export$f42252642e08449, $48d5c3170aa0f8d7$var$filter_fe0f));
}
function $48d5c3170aa0f8d7$export$d2ee080f6ab2341d(name) {
    let labels = $48d5c3170aa0f8d7$var$split(name, $48d5c3170aa0f8d7$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") {
            let prev = 0;
            while(true){
                let next = output.indexOf(0x3BE, prev);
                if (next < 0) break;
                output[next] = 0x39E;
                prev = next + 1;
            }
        }
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $48d5c3170aa0f8d7$var$flatten(labels);
}
function $48d5c3170aa0f8d7$export$d2ba335951b08421(name, preserve_emoji) {
    return $48d5c3170aa0f8d7$var$split(name, $48d5c3170aa0f8d7$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $48d5c3170aa0f8d7$var$filter_fe0f); // emoji are exposed so copy
}
function $48d5c3170aa0f8d7$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $48d5c3170aa0f8d7$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($48d5c3170aa0f8d7$var$STOP_CH).map((label)=>{
        let input = $48d5c3170aa0f8d7$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $48d5c3170aa0f8d7$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $48d5c3170aa0f8d7$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $48d5c3170aa0f8d7$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($48d5c3170aa0f8d7$var$CM.has(norm[0])) throw $48d5c3170aa0f8d7$var$error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $48d5c3170aa0f8d7$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $48d5c3170aa0f8d7$var$error_placement(`emoji + combining mark: "${$48d5c3170aa0f8d7$var$str_from_cps(tokens[i - 1])} + ${$48d5c3170aa0f8d7$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $48d5c3170aa0f8d7$var$check_fenced(norm);
                    let unique = $48d5c3170aa0f8d7$var$Array_from(new Set(chars));
                    let [g] = $48d5c3170aa0f8d7$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $48d5c3170aa0f8d7$var$check_group(g, chars); // need text in order
                    $48d5c3170aa0f8d7$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $48d5c3170aa0f8d7$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $48d5c3170aa0f8d7$var$WHOLE_MAP.get(cp);
        if (whole === $48d5c3170aa0f8d7$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $48d5c3170aa0f8d7$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$48d5c3170aa0f8d7$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $48d5c3170aa0f8d7$var$determine_group(unique) {
    let groups = $48d5c3170aa0f8d7$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$48d5c3170aa0f8d7$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$48d5c3170aa0f8d7$var$GROUPS.some((g)=>$48d5c3170aa0f8d7$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $48d5c3170aa0f8d7$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $48d5c3170aa0f8d7$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $48d5c3170aa0f8d7$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$48d5c3170aa0f8d7$var$bidi_qq($48d5c3170aa0f8d7$export$6ec6f9a7f89f00db(input))}: ${msg}`);
        }
        return $48d5c3170aa0f8d7$var$str_from_cps(output);
    }).join($48d5c3170aa0f8d7$var$STOP_CH);
}
function $48d5c3170aa0f8d7$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$48d5c3170aa0f8d7$var$quoted_cp(cp)}`);
}
function $48d5c3170aa0f8d7$var$error_group_member(g, cp) {
    let quoted = $48d5c3170aa0f8d7$var$quoted_cp(cp);
    let gg = $48d5c3170aa0f8d7$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $48d5c3170aa0f8d7$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $48d5c3170aa0f8d7$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$48d5c3170aa0f8d7$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $48d5c3170aa0f8d7$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $48d5c3170aa0f8d7$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($48d5c3170aa0f8d7$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $48d5c3170aa0f8d7$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$48d5c3170aa0f8d7$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $48d5c3170aa0f8d7$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$48d5c3170aa0f8d7$var$bidi_qq($48d5c3170aa0f8d7$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$48d5c3170aa0f8d7$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $48d5c3170aa0f8d7$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $48d5c3170aa0f8d7$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($48d5c3170aa0f8d7$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $48d5c3170aa0f8d7$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$48d5c3170aa0f8d7$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $48d5c3170aa0f8d7$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $48d5c3170aa0f8d7$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $48d5c3170aa0f8d7$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $48d5c3170aa0f8d7$var$consume_emoji_reversed(cps, eaten) {
    let node = $48d5c3170aa0f8d7$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $48d5c3170aa0f8d7$var$TY_VALID = "valid";
const $48d5c3170aa0f8d7$var$TY_MAPPED = "mapped";
const $48d5c3170aa0f8d7$var$TY_IGNORED = "ignored";
const $48d5c3170aa0f8d7$var$TY_DISALLOWED = "disallowed";
const $48d5c3170aa0f8d7$var$TY_EMOJI = "emoji";
const $48d5c3170aa0f8d7$var$TY_NFC = "nfc";
const $48d5c3170aa0f8d7$var$TY_STOP = "stop";
function $48d5c3170aa0f8d7$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $48d5c3170aa0f8d7$var$init();
    let input = $48d5c3170aa0f8d7$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $48d5c3170aa0f8d7$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $48d5c3170aa0f8d7$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $48d5c3170aa0f8d7$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $48d5c3170aa0f8d7$var$STOP) tokens.push({
                type: $48d5c3170aa0f8d7$var$TY_STOP,
                cp: cp
            });
            else if ($48d5c3170aa0f8d7$var$VALID.has(cp)) tokens.push({
                type: $48d5c3170aa0f8d7$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($48d5c3170aa0f8d7$var$IGNORED.has(cp)) tokens.push({
                type: $48d5c3170aa0f8d7$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $48d5c3170aa0f8d7$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $48d5c3170aa0f8d7$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $48d5c3170aa0f8d7$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($48d5c3170aa0f8d7$var$is_valid_or_mapped(token.type)) {
            if ($48d5c3170aa0f8d7$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($48d5c3170aa0f8d7$var$is_valid_or_mapped(type)) {
                        if (!$48d5c3170aa0f8d7$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $48d5c3170aa0f8d7$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$48d5c3170aa0f8d7$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $48d5c3170aa0f8d7$export$f42252642e08449(cps0);
                if ($48d5c3170aa0f8d7$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $48d5c3170aa0f8d7$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $48d5c3170aa0f8d7$var$collapse_valid_tokens(slice),
                        tokens: $48d5c3170aa0f8d7$export$bac129d8210aa825($48d5c3170aa0f8d7$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $48d5c3170aa0f8d7$var$TY_IGNORED) start = -1; // reset
    }
    return $48d5c3170aa0f8d7$var$collapse_valid_tokens(tokens);
}
function $48d5c3170aa0f8d7$var$is_valid_or_mapped(type) {
    return type == $48d5c3170aa0f8d7$var$TY_VALID || type == $48d5c3170aa0f8d7$var$TY_MAPPED;
}
function $48d5c3170aa0f8d7$var$requires_check(cps) {
    return cps.some((cp)=>$48d5c3170aa0f8d7$var$NFC_CHECK.has(cp));
}
function $48d5c3170aa0f8d7$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $48d5c3170aa0f8d7$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $48d5c3170aa0f8d7$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $48d5c3170aa0f8d7$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}


function $44d317a521aeef63$export$a3295358bff77e(name) {
    return (0, $48d5c3170aa0f8d7$export$499f715881831a51)(name);
}




class $38f64816f97caf9e$export$ba6a4843bec5d2a8 {
    constructor(options){
        this.appKit = undefined;
        this.options = undefined;
        this.chain = (0, $1VCt9.ConstantsUtil).CHAIN.EVM;
        this.defaultChain = undefined;
        this.tokens = (0, $642418818623159c$export$518f198897991e39).getCaipTokens(this.options?.tokens);
        this.getCaipDefaultChain = this.options?.defaultChain;
        this.siweControllerClient = this.options?.siweConfig;
        const { wagmiConfig: wagmiConfig, defaultChain: defaultChain } = options;
        if (!wagmiConfig) throw new Error("wagmiConfig is undefined");
        this.wagmiConfig = wagmiConfig;
        this.defaultChain = (0, $cea68b5dc8f74603$export$1ee567fcdafbf4d8)(defaultChain);
        this.siweControllerClient = options.siweConfig;
        this.networkControllerClient = {
            switchCaipNetwork: async (caipNetwork)=>{
                const chainId = (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(caipNetwork?.id);
                if (chainId) await (0, $84fcda712a4e8b11$export$15599da40e72d2f)(this.wagmiConfig, {
                    chainId: chainId
                });
            },
            getApprovedCaipNetworksData: async ()=>new Promise((resolve)=>{
                    const connections = new Map(this.wagmiConfig.state.connections);
                    const connection = connections.get(this.wagmiConfig.state.current || "");
                    if (connection?.connector?.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID) resolve((0, $cea68b5dc8f74603$export$94f91666d3e5b28f)());
                    else if (connection?.connector?.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID) {
                        const connector = this.wagmiConfig.connectors.find((c)=>c.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID);
                        resolve((0, $cea68b5dc8f74603$export$24a8d1cae47a6f)(connector));
                    }
                    resolve({
                        approvedCaipNetworkIds: undefined,
                        supportsAllNetworks: true
                    });
                })
        };
        this.connectionControllerClient = {
            connectWalletConnect: async (onUri)=>{
                const siweConfig = this.options?.siweConfig;
                const connector = this.wagmiConfig.connectors.find((c)=>c.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID);
                if (!connector) throw new Error("connectionControllerClient:getWalletConnectUri - connector is undefined");
                const provider = await connector.getProvider();
                provider.on("display_uri", (data)=>{
                    onUri(data);
                });
                const clientId = await provider.signer?.client?.core?.crypto?.getClientId();
                if (clientId) this.appKit?.setClientId(clientId);
                const chainId = (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(this.appKit?.getCaipNetwork()?.id);
                const siweParams = await siweConfig?.getMessageParams?.();
                if (siweConfig?.options?.enabled && typeof provider?.authenticate === "function" && siweParams && Object.keys(siweParams || {}).length > 0) {
                    const { SIWEController: SIWEController, getDidChainId: getDidChainId, getDidAddress: getDidAddress } = await (parcelRequire("XE6yD"));
                    await connector.setRequestedChainsIds(siweParams.chains);
                    let reorderedChains = siweParams.chains;
                    if (chainId) reorderedChains = [
                        chainId,
                        ...siweParams.chains.filter((c)=>c !== chainId)
                    ];
                    const result = await provider.authenticate({
                        nonce: await siweConfig.getNonce(),
                        methods: [
                            ...(0, $43P4H.OPTIONAL_METHODS)
                        ],
                        ...siweParams,
                        chains: reorderedChains
                    });
                    const signedCacao = result?.auths?.[0];
                    if (signedCacao) {
                        const { p: p, s: s } = signedCacao;
                        const cacaoChainId = getDidChainId(p.iss) || "";
                        const address = getDidAddress(p.iss);
                        if (address && cacaoChainId) SIWEController.setSession({
                            address: address,
                            chainId: parseInt(cacaoChainId, 10)
                        });
                        try {
                            const message = provider.signer.client.formatAuthMessage({
                                request: p,
                                iss: p.iss
                            });
                            await SIWEController.verifyMessage({
                                message: message,
                                signature: s.s,
                                cacao: signedCacao
                            });
                        } catch (error) {
                            console.error("Error verifying message", error);
                            await provider.disconnect().catch(console.error);
                            await SIWEController.signOut().catch(console.error);
                            throw error;
                        }
                    }
                    this.wagmiConfig.state.current = "";
                }
                await (0, $89ee8b8d60d2586c$export$64605811ab45167f)(this.wagmiConfig, {
                    connector: connector,
                    chainId: chainId
                });
            },
            connectExternal: async ({ id: id, provider: provider, info: info })=>{
                const connector = this.wagmiConfig.connectors.find((c)=>c.id === id);
                if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
                this.appKit?.setClientId(null);
                if (provider && info && connector.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID) connector.setEip6963Wallet?.({
                    provider: provider,
                    info: info
                });
                const chainId = (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(this.appKit?.getCaipNetwork()?.id);
                await (0, $89ee8b8d60d2586c$export$64605811ab45167f)(this.wagmiConfig, {
                    connector: connector,
                    chainId: chainId
                });
            },
            reconnectExternal: async ({ id: id })=>{
                const connector = this.wagmiConfig.connectors.find((c)=>c.id === id);
                if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
                await (0, $2bf13ff4fdf3cd7b$export$f0e7018a430fa792)(this.wagmiConfig, {
                    connectors: [
                        connector
                    ]
                });
            },
            checkInstalled: (ids)=>{
                const injectedConnector = this.appKit?.getConnectors().find((c)=>c.type === "INJECTED");
                if (!ids) return Boolean(window.ethereum);
                if (injectedConnector) {
                    if (!window?.ethereum) return false;
                    return ids.some((id)=>Boolean(window.ethereum?.[String(id)]));
                }
                return false;
            },
            disconnect: async ()=>{
                await (0, $cb43e43868f8b57f$export$37dfea93db2e14ed)(this.wagmiConfig);
                this.appKit?.setClientId(null);
                if (this.options?.siweConfig?.options?.signOutOnDisconnect) {
                    const { SIWEController: SIWEController } = await (parcelRequire("XE6yD"));
                    await SIWEController.signOut();
                }
            },
            signMessage: async (message)=>{
                const caipAddress = this.appKit?.getCaipAddress() || "";
                const account = (0, $cea68b5dc8f74603$export$c1398e40f52e8b4a)(caipAddress);
                return (0, $2a16e70d89d1c4fa$export$1d9a7a8a40780de)(this.wagmiConfig, {
                    message: message,
                    account: account
                });
            },
            estimateGas: async (args)=>{
                try {
                    return await (0, $fe361212e10136a0$export$e0580ae1f48db848)(this.wagmiConfig, {
                        account: args.address,
                        to: args.to,
                        data: args.data,
                        type: "legacy"
                    });
                } catch (error) {
                    return 0n;
                }
            },
            sendTransaction: async (data)=>{
                const { chainId: chainId } = (0, $9bf87c5242498f44$export$4f9234baf34abd0)(this.wagmiConfig);
                const txParams = {
                    account: data.address,
                    to: data.to,
                    value: data.value,
                    gas: data.gas,
                    gasPrice: data.gasPrice,
                    data: data.data,
                    chainId: chainId,
                    type: "legacy"
                };
                await (0, $ffe308c3010df2e8$export$2e8a9232fb815d77)(this.wagmiConfig, txParams);
                const tx = await (0, $84e4d6648ba6b0db$export$8e0e7ffc78696d30)(this.wagmiConfig, txParams);
                await (0, $e62af31518118c60$export$694ec9bdf0bb55cf)(this.wagmiConfig, {
                    hash: tx,
                    timeout: 25000
                });
                return tx;
            },
            writeContract: async (data)=>{
                const caipAddress = this.appKit?.getCaipAddress() || "";
                const account = (0, $cea68b5dc8f74603$export$c1398e40f52e8b4a)(caipAddress);
                const chainId = (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(this.appKit?.getCaipNetwork()?.id);
                const tx = await (0, $db550b2f04051292$export$4c0f201bc17cbf23)(this.wagmiConfig, {
                    chainId: chainId,
                    address: data.tokenAddress,
                    account: account,
                    abi: data.abi,
                    functionName: data.method,
                    args: [
                        data.receiverAddress,
                        data.tokenAmount
                    ]
                });
                return tx;
            },
            getEnsAddress: async (value)=>{
                try {
                    const chainId = (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(this.appKit?.getCaipNetwork()?.id);
                    let ensName = false;
                    let wcName = false;
                    if (value?.endsWith((0, $1VCt9.ConstantsUtil).WC_NAME_SUFFIX)) wcName = await this.appKit?.resolveWalletConnectName(value) || false;
                    if (chainId === (0, $943f0ea18d6af5d7$export$536d3e0d2c7baf54).id) ensName = await (0, $17ec56585491986a$export$24b77c7e87f05b8d)(this.wagmiConfig, {
                        name: (0, $44d317a521aeef63$export$a3295358bff77e)(value),
                        chainId: chainId
                    });
                    return ensName || wcName || false;
                } catch  {
                    return false;
                }
            },
            getEnsAvatar: async (value)=>{
                const chainId = (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(this.appKit?.getCaipNetwork()?.id);
                if (chainId !== (0, $943f0ea18d6af5d7$export$536d3e0d2c7baf54).id) return false;
                const avatar = await (0, $a2a6f7ca5f0b7074$export$65f1d2b9649a54e5)(this.wagmiConfig, {
                    name: (0, $44d317a521aeef63$export$a3295358bff77e)(value),
                    chainId: chainId
                });
                return avatar || false;
            },
            parseUnits: $e484fe21942c6e42$export$203ae30b4f6490b3,
            formatUnits: $94Fzw.formatUnits
        };
    }
    construct(appKit, options) {
        if (!options.projectId) throw new Error("projectId is undefined");
        this.appKit = appKit;
        this.options = options;
        this.tokens = (0, $642418818623159c$export$518f198897991e39).getCaipTokens(options.tokens);
        this.syncRequestedNetworks([
            ...this.wagmiConfig.chains
        ]);
        this.syncConnectors(this.wagmiConfig.connectors);
        this.initAuthConnectorListeners([
            ...this.wagmiConfig.connectors
        ]);
        (0, $caf5e1a20ce94acd$export$9c8eec0a0da048a0)(this.wagmiConfig, {
            onChange: (connectors)=>this.syncConnectors(connectors)
        });
        (0, $c030347180c4f64f$export$30c94aeff2da2ac6)(this.wagmiConfig, {
            onChange: (accountData)=>this.syncAccount({
                    ...accountData
                })
        });
        this.appKit?.setEIP6963Enabled(options.enableEIP6963 !== false);
        this.appKit?.subscribeShouldUpdateToAddress((newAddress)=>{
            if (newAddress) {
                const connections = (0, $b59b87c5f0c25de5$export$82b9f8f75cc709b4)(this.wagmiConfig);
                const connector = connections[0]?.connector;
                if (connector) (0, $3b67507949adfeec$export$9ccfa7718cb7f8b1)(this.wagmiConfig, {
                    connector: connector
                }).then((response)=>this.syncAccount({
                        address: newAddress,
                        isConnected: true,
                        addresses: response.accounts,
                        connector: connector,
                        chainId: response.chainId
                    }));
            }
        });
    }
    subscribeState(callback) {
        return this.appKit?.subscribeState((state)=>callback({
                ...state,
                selectedNetworkId: (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(state.selectedNetworkId)
            }));
    }
    syncRequestedNetworks(chains) {
        const requestedCaipNetworks = chains?.map((chain)=>({
                id: `${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
                name: chain.name,
                imageId: (0, $aa7460a2eaf4ba4c$export$fd35d6514357600).EIP155NetworkImageIds[chain.id],
                imageUrl: this.options?.chainImages?.[chain.id],
                chain: this.chain
            }));
        this.appKit?.setRequestedCaipNetworks(requestedCaipNetworks ?? [], this.chain);
    }
    async syncAccount({ address: address, chainId: chainId, connector: connector, addresses: addresses, status: status }) {
        const caipAddress = `${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155}:${chainId}:${address}`;
        if (this.appKit?.getCaipAddress() === caipAddress) return;
        if (status === "connected" && address && chainId) {
            this.syncNetwork(address, chainId, true);
            this.appKit?.setIsConnected(true, this.chain);
            this.appKit?.setCaipAddress(caipAddress, this.chain);
            await Promise.all([
                this.syncProfile(address, chainId),
                this.syncBalance(address, chainId),
                this.syncConnectedWalletInfo(connector),
                this.appKit?.setApprovedCaipNetworksData(this.chain)
            ]);
            if (connector) this.syncConnectedWalletInfo(connector);
            const isAuthConnector = connector?.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID;
            if (!isAuthConnector && addresses?.length) this.appKit?.setAllAccounts(addresses.map((addr)=>({
                    address: addr,
                    type: "eoa"
                })), this.chain);
        } else if (status === "disconnected") {
            this.appKit?.resetAccount(this.chain);
            this.appKit?.resetWcConnection();
            this.appKit?.resetNetwork();
            this.appKit?.setAllAccounts([], this.chain);
            this.appKit?.setIsConnected(false, this.chain);
        }
    }
    async syncNetwork(address, chainId, isConnected) {
        const chain = this.wagmiConfig.chains.find((c)=>c.id === chainId);
        if (chain || chainId) {
            const name = chain?.name ?? chainId?.toString();
            const id = Number(chain?.id ?? chainId);
            const caipChainId = `${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155}:${id}`;
            this.appKit?.setCaipNetwork({
                id: caipChainId,
                name: name,
                imageId: (0, $aa7460a2eaf4ba4c$export$fd35d6514357600).EIP155NetworkImageIds[id],
                imageUrl: this.options?.chainImages?.[id],
                chain: this.chain
            });
            if (isConnected && address && chainId) {
                const caipAddress = `${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).EIP155}:${id}:${address}`;
                this.appKit?.setCaipAddress(caipAddress, this.chain);
                if (chain?.blockExplorers?.default?.url) {
                    const url = `${chain.blockExplorers.default.url}/address/${address}`;
                    this.appKit?.setAddressExplorerUrl(url, this.chain);
                } else this.appKit?.setAddressExplorerUrl(undefined, this.chain);
                await this.syncBalance(address, chainId);
            }
        }
    }
    async syncWalletConnectName(address) {
        if (!this.appKit) throw new Error("syncWalletConnectName - appKit is undefined");
        try {
            const registeredWcNames = await this.appKit.getWalletConnectName(address);
            if (registeredWcNames[0]) {
                const wcName = registeredWcNames[0];
                this.appKit?.setProfileName(wcName.name, this.chain);
            } else this.appKit?.setProfileName(null, this.chain);
        } catch  {
            this.appKit?.setProfileName(null, this.chain);
        }
    }
    async syncProfile(address, chainId) {
        if (!this.appKit) throw new Error("syncProfile - appKit is undefined");
        try {
            const { name: name, avatar: avatar } = await this.appKit.fetchIdentity({
                address: address
            });
            this.appKit?.setProfileName(name, this.chain);
            this.appKit?.setProfileImage(avatar, this.chain);
            if (!name) await this.syncWalletConnectName(address);
        } catch  {
            if (chainId === (0, $943f0ea18d6af5d7$export$536d3e0d2c7baf54).id) {
                const profileName = await (0, $76f301218461e2ef$export$e1b98d9bc05a9fc2)(this.wagmiConfig, {
                    address: address,
                    chainId: chainId
                });
                if (profileName) {
                    this.appKit?.setProfileName(profileName, this.chain);
                    const profileImage = await (0, $a2a6f7ca5f0b7074$export$65f1d2b9649a54e5)(this.wagmiConfig, {
                        name: profileName,
                        chainId: chainId
                    });
                    if (profileImage) this.appKit?.setProfileImage(profileImage, this.chain);
                } else {
                    await this.syncWalletConnectName(address);
                    this.appKit?.setProfileImage(null, this.chain);
                }
            } else {
                await this.syncWalletConnectName(address);
                this.appKit?.setProfileImage(null, this.chain);
            }
        }
    }
    async syncBalance(address, chainId) {
        const chain = this.wagmiConfig.chains.find((c)=>c.id === chainId);
        if (chain) {
            const balance = await (0, $966d78e7c24e2cc9$export$df96cd8d56be0ab1)(this.wagmiConfig, {
                address: address,
                chainId: chain.id,
                token: this.options?.tokens?.[chain.id]?.address
            });
            this.appKit?.setBalance(balance.formatted, balance.symbol, this.chain);
            return;
        }
        this.appKit?.setBalance(undefined, undefined, this.chain);
    }
    async syncConnectedWalletInfo(connector) {
        if (!connector) throw Error("syncConnectedWalletInfo - connector is undefined");
        if (connector.id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID && connector.getProvider) {
            const walletConnectProvider = await connector.getProvider();
            if (walletConnectProvider.session) this.appKit?.setConnectedWalletInfo({
                ...walletConnectProvider.session.peer.metadata,
                name: walletConnectProvider.session.peer.metadata.name,
                icon: walletConnectProvider.session.peer.metadata.icons?.[0]
            }, this.chain);
        } else {
            const wagmiConnector = this.appKit?.getConnectors().find((c)=>c.id === connector.id);
            this.appKit?.setConnectedWalletInfo({
                name: connector.name,
                icon: connector.icon || this.appKit.getConnectorImage(wagmiConnector)
            }, this.chain);
        }
    }
    syncConnectors(connectors) {
        const uniqueIds = new Set();
        const filteredConnectors = connectors.filter((item)=>!uniqueIds.has(item.id) && uniqueIds.add(item.id));
        const w3mConnectors = [];
        const coinbaseSDKId = (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID;
        const coinbaseConnector = filteredConnectors.find((c)=>c.id === coinbaseSDKId);
        filteredConnectors.forEach(({ id: id, name: name, type: type, icon: icon })=>{
            const isCoinbaseRepeated = coinbaseConnector && id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).CONNECTOR_RDNS_MAP[(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID];
            const shouldSkip = isCoinbaseRepeated || (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID === id;
            if (!shouldSkip) w3mConnectors.push({
                id: id,
                explorerId: (0, $aa7460a2eaf4ba4c$export$fd35d6514357600).ConnectorExplorerIds[id],
                imageUrl: this.options?.connectorImages?.[id] ?? icon,
                name: (0, $aa7460a2eaf4ba4c$export$fd35d6514357600).ConnectorNamesMap[id] ?? name,
                imageId: (0, $aa7460a2eaf4ba4c$export$fd35d6514357600).ConnectorImageIds[id],
                type: (0, $aa7460a2eaf4ba4c$export$fd35d6514357600).ConnectorTypesMap[type] ?? "EXTERNAL",
                info: {
                    rdns: id
                },
                chain: this.chain
            });
        });
        this.appKit?.setConnectors(w3mConnectors);
        this.syncAuthConnector(filteredConnectors);
    }
    async syncAuthConnector(connectors) {
        const authConnector = connectors.find(({ id: id })=>id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID);
        if (authConnector) {
            const provider = await authConnector.getProvider();
            this.appKit?.addConnector({
                id: (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID,
                type: "AUTH",
                name: "Auth",
                provider: provider,
                email: authConnector.email,
                socials: authConnector.socials,
                showWallets: authConnector.showWallets,
                chain: this.chain,
                walletFeatures: authConnector.walletFeatures
            });
        }
    }
    async initAuthConnectorListeners(connectors) {
        const authConnector = connectors.find(({ id: id })=>id === (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID);
        if (authConnector) {
            await this.listenAuthConnector(authConnector);
            await this.listenModal(authConnector);
        }
    }
    async listenAuthConnector(connector) {
        if (typeof window !== "undefined" && connector) {
            this.appKit?.setLoading(true);
            const provider = await connector.getProvider();
            const isLoginEmailUsed = provider.getLoginEmailUsed();
            this.appKit?.setLoading(isLoginEmailUsed);
            if (isLoginEmailUsed) this.appKit?.setIsConnected(false, this.chain);
            provider.onRpcRequest((request)=>{
                if ((0, $l0IQQ.W3mFrameHelpers).checkIfRequestExists(request)) {
                    if (!(0, $l0IQQ.W3mFrameHelpers).checkIfRequestIsAllowed(request)) {
                        if (this.appKit?.isOpen()) {
                            if (this.appKit?.isTransactionStackEmpty()) return;
                            if (this.appKit?.isTransactionShouldReplaceView()) this.appKit?.replace("ApproveTransaction");
                            else this.appKit?.redirect("ApproveTransaction");
                        } else this.appKit?.open({
                            view: "ApproveTransaction"
                        });
                    }
                } else {
                    this.appKit?.open();
                    console.error((0, $lr7C8.W3mFrameRpcConstants).RPC_METHOD_NOT_ALLOWED_MESSAGE, {
                        method: request.method
                    });
                    setTimeout(()=>{
                        this.appKit?.showErrorMessage((0, $lr7C8.W3mFrameRpcConstants).RPC_METHOD_NOT_ALLOWED_UI_MESSAGE);
                    }, 300);
                    provider.rejectRpcRequests();
                }
            });
            provider.onRpcError(()=>{
                const isModalOpen = this.appKit?.isOpen();
                if (isModalOpen) {
                    if (this.appKit?.isTransactionStackEmpty()) this.appKit?.close();
                    else this.appKit?.popTransactionStack(true);
                }
            });
            provider.onRpcSuccess(()=>{
                if (this.appKit?.isTransactionStackEmpty()) this.appKit?.close();
                else this.appKit?.popTransactionStack();
            });
            provider.onNotConnected(()=>{
                const isConnected = this.appKit?.getIsConnectedState();
                if (!isConnected) {
                    this.appKit?.setIsConnected(false, this.chain);
                    this.appKit?.setLoading(false);
                }
            });
            provider.onIsConnected((req)=>{
                this.appKit?.setIsConnected(true, this.chain);
                this.appKit?.setSmartAccountDeployed(Boolean(req.smartAccountDeployed), this.chain);
                this.appKit?.setPreferredAccountType(req.preferredAccountType, this.chain);
                this.appKit?.setLoading(false);
                this.appKit?.setAllAccounts(req.accounts || [
                    {
                        address: req.address,
                        type: req.preferredAccountType || "eoa"
                    }
                ], this.chain);
            });
            provider.onGetSmartAccountEnabledNetworks((networks)=>{
                this.appKit?.setSmartAccountEnabledNetworks(networks, this.chain);
            });
            provider.onSetPreferredAccount(({ address: address, type: type })=>{
                if (!address) return;
                this.appKit?.setPreferredAccountType(type, this.chain);
                this.syncAccount({
                    address: address,
                    isConnected: true,
                    chainId: (0, $1yWTt.NetworkUtil).caipNetworkIdToNumber(this.appKit?.getCaipNetwork()?.id),
                    connector: connector
                });
            });
        }
    }
    async listenModal(connector) {
        const provider = await connector.getProvider();
        this.subscribeState((val)=>{
            if (!val.open) provider.rejectRpcRequests();
        });
    }
}


parcelRequire("3UUkO");
/**
 * Announces an EIP-1193 Provider.
 */ function $9fcc8dbefba99d35$export$60dbeacb3287962a(detail) {
    const event = new CustomEvent("eip6963:announceProvider", {
        detail: Object.freeze(detail)
    });
    window.dispatchEvent(event);
    const handler = ()=>window.dispatchEvent(event);
    window.addEventListener("eip6963:requestProvider", handler);
    return ()=>window.removeEventListener("eip6963:requestProvider", handler);
}
function $9fcc8dbefba99d35$export$f262fc9233ecbc18(listener) {
    if (typeof window === "undefined") return;
    const handler = (event)=>listener(event.detail);
    window.addEventListener("eip6963:announceProvider", handler);
    window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
    return ()=>window.removeEventListener("eip6963:announceProvider", handler);
}


function $bd8d89270fdec732$export$f51a9068ac82ea43() {
    const listeners = new Set();
    let providerDetails = [];
    const request = ()=>(0, $9fcc8dbefba99d35$export$f262fc9233ecbc18)((providerDetail)=>{
            if (providerDetails.some(({ info: info })=>info.uuid === providerDetail.info.uuid)) return;
            providerDetails = [
                ...providerDetails,
                providerDetail
            ];
            listeners.forEach((listener)=>listener(providerDetails, {
                    added: [
                        providerDetail
                    ]
                }));
        });
    let unwatch = request();
    return {
        _listeners () {
            return listeners;
        },
        clear () {
            listeners.forEach((listener)=>listener([], {
                    removed: [
                        ...providerDetails
                    ]
                }));
            providerDetails = [];
        },
        destroy () {
            this.clear();
            listeners.clear();
            unwatch?.();
        },
        findProvider ({ rdns: rdns }) {
            return providerDetails.find((providerDetail)=>providerDetail.info.rdns === rdns);
        },
        getProviders () {
            return providerDetails;
        },
        reset () {
            this.clear();
            unwatch?.();
            unwatch = request();
        },
        subscribe (listener, { emitImmediately: emitImmediately } = {}) {
            listeners.add(listener);
            if (emitImmediately) listener(providerDetails, {
                added: providerDetails
            });
            return ()=>listeners.delete(listener);
        }
    };
}



var $336216731108e79c$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $336216731108e79c$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $336216731108e79c$export$4feba8a1bc8e9afd = $336216731108e79c$var$reduxImpl;
const $336216731108e79c$var$trackedConnections = /* @__PURE__ */ new Map();
const $336216731108e79c$var$getTrackedConnectionState = (name)=>{
    const api = $336216731108e79c$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $336216731108e79c$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $336216731108e79c$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $336216731108e79c$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $336216731108e79c$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($336216731108e79c$import_meta.env ? $336216731108e79c$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($336216731108e79c$import_meta.env ? $336216731108e79c$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $336216731108e79c$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$336216731108e79c$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($336216731108e79c$import_meta.env ? $336216731108e79c$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $336216731108e79c$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($336216731108e79c$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($336216731108e79c$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $336216731108e79c$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($336216731108e79c$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $336216731108e79c$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $336216731108e79c$export$6922d3b3a607469e = $336216731108e79c$var$devtoolsImpl;
const $336216731108e79c$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $336216731108e79c$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $336216731108e79c$export$5c593627aef9f076 = $336216731108e79c$var$subscribeWithSelectorImpl;
const $336216731108e79c$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $336216731108e79c$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $336216731108e79c$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $336216731108e79c$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $336216731108e79c$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $336216731108e79c$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $336216731108e79c$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $336216731108e79c$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $336216731108e79c$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $336216731108e79c$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $336216731108e79c$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $336216731108e79c$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($336216731108e79c$import_meta.env ? $336216731108e79c$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $336216731108e79c$var$oldImpl(config, baseOptions);
    }
    return $336216731108e79c$var$newImpl(config, baseOptions);
};
const $336216731108e79c$export$9a6132153fba2e0 = $336216731108e79c$var$persistImpl;


var $5dd4bbd5972f5b4c$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $5dd4bbd5972f5b4c$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($5dd4bbd5972f5b4c$import_meta.env ? $5dd4bbd5972f5b4c$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
const $5dd4bbd5972f5b4c$export$f51a9068ac82ea43 = (createState)=>createState ? $5dd4bbd5972f5b4c$var$createStoreImpl(createState) : $5dd4bbd5972f5b4c$var$createStoreImpl;
var $5dd4bbd5972f5b4c$export$2e2bcd8739ae039 = (createState)=>{
    if (($5dd4bbd5972f5b4c$import_meta.env ? $5dd4bbd5972f5b4c$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $5dd4bbd5972f5b4c$export$f51a9068ac82ea43(createState);
};



var $9vguw = parcelRequire("9vguw");
var $8syAN = parcelRequire("8syAN");
var $b9XBB = parcelRequire("b9XBB");


function $4674aba9bc5f0149$export$36e7227504c841ea(createConnectorFn) {
    return createConnectorFn;
}


// Regex of wallets/providers that can accurately simulate contract calls & display contract revert reasons.
const $d6278d5335646a0b$var$supportsSimulationIdRegex = /(rabby|trustwallet)/;
const $d6278d5335646a0b$var$targetMap = {
    coinbaseWallet: {
        id: "coinbaseWallet",
        name: "Coinbase Wallet",
        provider (window1) {
            if (window1?.coinbaseWalletExtension) return window1.coinbaseWalletExtension;
            return $d6278d5335646a0b$var$findProvider(window1, "isCoinbaseWallet");
        }
    },
    metaMask: {
        id: "metaMask",
        name: "MetaMask",
        provider (window1) {
            return $d6278d5335646a0b$var$findProvider(window1, (provider)=>{
                if (!provider.isMetaMask) return false;
                // Brave tries to make itself look like MetaMask
                // Could also try RPC `web3_clientVersion` if following is unreliable
                if (provider.isBraveWallet && !provider._events && !provider._state) return false;
                // Other wallets that try to look like MetaMask
                const flags = [
                    "isApexWallet",
                    "isAvalanche",
                    "isBitKeep",
                    "isBlockWallet",
                    "isKuCoinWallet",
                    "isMathWallet",
                    "isOkxWallet",
                    "isOKExWallet",
                    "isOneInchIOSWallet",
                    "isOneInchAndroidWallet",
                    "isOpera",
                    "isPortal",
                    "isRabby",
                    "isTokenPocket",
                    "isTokenary",
                    "isZerion"
                ];
                for (const flag of flags)if (provider[flag]) return false;
                return true;
            });
        }
    },
    phantom: {
        id: "phantom",
        name: "Phantom",
        provider (window1) {
            if (window1?.phantom?.ethereum) return window1.phantom?.ethereum;
            return $d6278d5335646a0b$var$findProvider(window1, "isPhantom");
        }
    }
};
$d6278d5335646a0b$export$a7a34dad4983656f.type = "injected";
function $d6278d5335646a0b$export$a7a34dad4983656f(parameters = {}) {
    const { shimDisconnect: shimDisconnect = true, unstable_shimAsyncInject: unstable_shimAsyncInject } = parameters;
    function getTarget() {
        const target = parameters.target;
        if (typeof target === "function") {
            const result = target();
            if (result) return result;
        }
        if (typeof target === "object") return target;
        if (typeof target === "string") return {
            ...$d6278d5335646a0b$var$targetMap[target] ?? {
                id: target,
                name: `${target[0].toUpperCase()}${target.slice(1)}`,
                provider: `is${target[0].toUpperCase()}${target.slice(1)}`
            }
        };
        return {
            id: "injected",
            name: "Injected",
            provider (window1) {
                return window1?.ethereum;
            }
        };
    }
    let accountsChanged;
    let chainChanged;
    let connect;
    let disconnect;
    return (0, $4674aba9bc5f0149$export$36e7227504c841ea)((config)=>({
            get icon () {
                return getTarget().icon;
            },
            get id () {
                return getTarget().id;
            },
            get name () {
                return getTarget().name;
            },
            get supportsSimulation () {
                return $d6278d5335646a0b$var$supportsSimulationIdRegex.test(this.id.toLowerCase());
            },
            type: $d6278d5335646a0b$export$a7a34dad4983656f.type,
            async setup () {
                const provider = await this.getProvider();
                // Only start listening for events if `target` is set, otherwise `injected()` will also receive events
                if (provider && parameters.target) {
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider.on("connect", connect);
                    }
                    // We shouldn't need to listen for `'accountsChanged'` here since the `'connect'` event should suffice (and wallet shouldn't be connected yet).
                    // Some wallets, like MetaMask, do not implement the `'connect'` event and overload `'accountsChanged'` instead.
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                }
            },
            async connect ({ chainId: chainId, isReconnecting: isReconnecting } = {}) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $b99ad54a290b4e60$export$43839b3ff6336f15)();
                let accounts = [];
                if (isReconnecting) accounts = await this.getAccounts().catch(()=>[]);
                else if (shimDisconnect) // Attempt to show another prompt for selecting account if `shimDisconnect` flag is enabled
                try {
                    const permissions = await provider.request({
                        method: "wallet_requestPermissions",
                        params: [
                            {
                                eth_accounts: {}
                            }
                        ]
                    });
                    accounts = permissions[0]?.caveats?.[0]?.value?.map((x)=>(0, $9vguw.getAddress)(x));
                    // `'wallet_requestPermissions'` can return a different order of accounts than `'eth_accounts'`
                    // switch to `'eth_accounts'` ordering if more than one account is connected
                    // https://github.com/wevm/wagmi/issues/4140
                    if (accounts.length > 0) {
                        const sortedAccounts = await this.getAccounts();
                        accounts = sortedAccounts;
                    }
                } catch (err) {
                    const error = err;
                    // Not all injected providers support `wallet_requestPermissions` (e.g. MetaMask iOS).
                    // Only bubble up error if user rejects request
                    if (error.code === (0, $b9XBB.UserRejectedRequestError).code) throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    // Or prompt is already open
                    if (error.code === (0, $b9XBB.ResourceUnavailableRpcError).code) throw error;
                }
                try {
                    if (!accounts?.length && !isReconnecting) {
                        const requestedAccounts = await provider.request({
                            method: "eth_requestAccounts"
                        });
                        accounts = requestedAccounts.map((x)=>(0, $9vguw.getAddress)(x));
                    }
                    // Manage EIP-1193 event listeners
                    // https://eips.ethereum.org/EIPS/eip-1193#events
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $b9XBB.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    // Remove disconnected shim if it exists
                    if (shimDisconnect) await config.storage?.removeItem(`${this.id}.disconnected`);
                    // Add connected shim if no target exists
                    if (!parameters.target) await config.storage?.setItem("injected.connected", true);
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (err) {
                    const error = err;
                    if (error.code === (0, $b9XBB.UserRejectedRequestError).code) throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    if (error.code === (0, $b9XBB.ResourceUnavailableRpcError).code) throw new (0, $b9XBB.ResourceUnavailableRpcError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $b99ad54a290b4e60$export$43839b3ff6336f15)();
                // Manage EIP-1193 event listeners
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
                // Experimental support for MetaMask disconnect
                // https://github.com/MetaMask/metamask-improvement-proposals/blob/main/MIPs/mip-2.md
                try {
                    // Adding timeout as not all wallets support this method and can hang
                    // https://github.com/wevm/wagmi/issues/4064
                    await (0, $3ed1f8a9ac62a2b7$export$e86e19342bc4850e)(()=>// TODO: Remove explicit type for viem@3
                        provider.request({
                            // `'wallet_revokePermissions'` added in `viem@2.10.3`
                            method: "wallet_revokePermissions",
                            params: [
                                {
                                    eth_accounts: {}
                                }
                            ]
                        }), {
                        timeout: 100
                    });
                } catch  {}
                // Add shim signalling connector is disconnected
                if (shimDisconnect) await config.storage?.setItem(`${this.id}.disconnected`, true);
                if (!parameters.target) await config.storage?.removeItem("injected.connected");
            },
            async getAccounts () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $b99ad54a290b4e60$export$43839b3ff6336f15)();
                const accounts = await provider.request({
                    method: "eth_accounts"
                });
                return accounts.map((x)=>(0, $9vguw.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $b99ad54a290b4e60$export$43839b3ff6336f15)();
                const hexChainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(hexChainId);
            },
            async getProvider () {
                if (typeof window === "undefined") return undefined;
                let provider;
                const target = getTarget();
                if (typeof target.provider === "function") provider = target.provider(window);
                else if (typeof target.provider === "string") provider = $d6278d5335646a0b$var$findProvider(window, target.provider);
                else provider = target.provider;
                // Some wallets do not conform to EIP-1193 (e.g. Trust Wallet)
                // https://github.com/wevm/wagmi/issues/3526#issuecomment-1912683002
                if (provider && !provider.removeListener) {
                    // Try using `off` handler if it exists, otherwise noop
                    if ("off" in provider && typeof provider.off === "function") provider.removeListener = provider.off;
                    else provider.removeListener = ()=>{};
                }
                return provider;
            },
            async isAuthorized () {
                try {
                    const isDisconnected = shimDisconnect && // If shim exists in storage, connector is disconnected
                    await config.storage?.getItem(`${this.id}.disconnected`);
                    if (isDisconnected) return false;
                    // Don't allow injected connector to connect if no target is set and it hasn't already connected
                    // (e.g. flag in storage is not set). This prevents a targetless injected connector from connecting
                    // automatically whenever there is a targeted connector configured.
                    if (!parameters.target) {
                        const connected = await config.storage?.getItem("injected.connected");
                        if (!connected) return false;
                    }
                    const provider = await this.getProvider();
                    if (!provider) {
                        if (unstable_shimAsyncInject !== undefined && unstable_shimAsyncInject !== false) {
                            // If no provider is found, check for async injection
                            // https://github.com/wevm/references/issues/167
                            // https://github.com/MetaMask/detect-provider
                            const handleEthereum = async ()=>{
                                if (typeof window !== "undefined") window.removeEventListener("ethereum#initialized", handleEthereum);
                                const provider = await this.getProvider();
                                return !!provider;
                            };
                            const timeout = typeof unstable_shimAsyncInject === "number" ? unstable_shimAsyncInject : 1000;
                            const res = await Promise.race([
                                ...typeof window !== "undefined" ? [
                                    new Promise((resolve)=>window.addEventListener("ethereum#initialized", ()=>resolve(handleEthereum()), {
                                            once: true
                                        }))
                                ] : [],
                                new Promise((resolve)=>setTimeout(()=>resolve(handleEthereum()), timeout))
                            ]);
                            if (res) return true;
                        }
                        throw new (0, $b99ad54a290b4e60$export$43839b3ff6336f15)();
                    }
                    // Use retry strategy as some injected wallets (e.g. MetaMask) fail to
                    // immediately resolve JSON-RPC requests on page load.
                    const accounts = await (0, $ed552b6d0c3a055e$export$188df5ecf8e7961a)(()=>this.getAccounts());
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $b99ad54a290b4e60$export$43839b3ff6336f15)();
                const chain = config.chains.find((x)=>x.id === chainId);
                if (!chain) throw new (0, $b9XBB.SwitchChainError)(new (0, $115d9c96b0e3a6b5$export$688e5fda4b4631ed)());
                try {
                    await Promise.all([
                        provider.request({
                            method: "wallet_switchEthereumChain",
                            params: [
                                {
                                    chainId: (0, $8syAN.numberToHex)(chainId)
                                }
                            ]
                        })// During `'wallet_switchEthereumChain'`, MetaMask makes a `'net_version'` RPC call to the target chain.
                        // If this request fails, MetaMask does not emit the `'chainChanged'` event, but will still switch the chain.
                        // To counter this behavior, we request and emit the current chain ID to confirm the chain switch either via
                        // this callback or an externally emitted `'chainChanged'` event.
                        // https://github.com/MetaMask/metamask-extension/issues/24247
                        .then(async ()=>{
                            const currentChainId = await this.getChainId();
                            if (currentChainId === chainId) config.emitter.emit("change", {
                                chainId: chainId
                            });
                        }),
                        new Promise((resolve)=>config.emitter.once("change", ({ chainId: currentChainId })=>{
                                if (currentChainId === chainId) resolve();
                            }))
                    ]);
                    return chain;
                } catch (err) {
                    const error = err;
                    // Indicates chain is not added to provider
                    if (error.code === 4902 || // Unwrapping for MetaMask Mobile
                    // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
                    error?.data?.originalError?.code === 4902) try {
                        const { default: blockExplorer, ...blockExplorers } = chain.blockExplorers ?? {};
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else if (blockExplorer) blockExplorerUrls = [
                            blockExplorer.url,
                            ...Object.values(blockExplorers).map((x)=>x.url)
                        ];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $8syAN.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        const currentChainId = await this.getChainId();
                        if (currentChainId !== chainId) throw new (0, $b9XBB.UserRejectedRequestError)(new Error("User rejected switch after adding network."));
                        return chain;
                    } catch (error) {
                        throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    }
                    if (error.code === (0, $b9XBB.UserRejectedRequestError).code) throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    throw new (0, $b9XBB.SwitchChainError)(error);
                }
            },
            async onAccountsChanged (accounts) {
                // Disconnect if there are no accounts
                if (accounts.length === 0) this.onDisconnect();
                else if (config.emitter.listenerCount("connect")) {
                    const chainId = (await this.getChainId()).toString();
                    this.onConnect({
                        chainId: chainId
                    });
                    // Remove disconnected shim if it exists
                    if (shimDisconnect) await config.storage?.removeItem(`${this.id}.disconnected`);
                } else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $9vguw.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const accounts = await this.getAccounts();
                if (accounts.length === 0) return;
                const chainId = Number(connectInfo.chainId);
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
                // Manage EIP-1193 event listeners
                const provider = await this.getProvider();
                if (provider) {
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                }
            },
            async onDisconnect (error) {
                const provider = await this.getProvider();
                // If MetaMask emits a `code: 1013` error, wait for reconnection before disconnecting
                // https://github.com/MetaMask/providers/pull/120
                if (error && error.code === 1013) {
                    if (provider && !!(await this.getAccounts()).length) return;
                }
                // No need to remove `${this.id}.disconnected` from storage because `onDisconnect` is typically
                // only called when the wallet is disconnected through the wallet's interface, meaning the wallet
                // actually disconnected and we don't need to simulate it.
                config.emitter.emit("disconnect");
                // Manage EIP-1193 event listeners
                if (provider) {
                    if (chainChanged) {
                        provider.removeListener("chainChanged", chainChanged);
                        chainChanged = undefined;
                    }
                    if (disconnect) {
                        provider.removeListener("disconnect", disconnect);
                        disconnect = undefined;
                    }
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider.on("connect", connect);
                    }
                }
            }
        }));
}
function $d6278d5335646a0b$var$findProvider(window1, select) {
    function isProvider(provider) {
        if (typeof select === "function") return select(provider);
        if (typeof select === "string") return provider[select];
        return true;
    }
    const ethereum = window1.ethereum;
    if (ethereum?.providers) return ethereum.providers.find((provider)=>isProvider(provider));
    if (ethereum && isProvider(ethereum)) return ethereum;
    return undefined;
}



var $8fINO = parcelRequire("8fINO");
var $b8a987837d483120$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8fINO)));


var $8fINO = parcelRequire("8fINO");
class $3f600830eff0a3ba$export$4293555f241ae35a {
    constructor(uid){
        Object.defineProperty(this, "uid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: uid
        });
        Object.defineProperty(this, "_emitter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, (/*@__PURE__*/$parcel$interopDefault($8fINO)))()
        });
    }
    on(eventName, fn) {
        this._emitter.on(eventName, fn);
    }
    once(eventName, fn) {
        this._emitter.once(eventName, fn);
    }
    off(eventName, fn) {
        this._emitter.off(eventName, fn);
    }
    emit(eventName, ...params) {
        const data = params[0];
        this._emitter.emit(eventName, {
            uid: this.uid,
            ...data
        });
    }
    listenerCount(eventName) {
        return this._emitter.listenerCount(eventName);
    }
}
function $3f600830eff0a3ba$export$6f5e8f34570e3ad1(uid) {
    return new $3f600830eff0a3ba$export$4293555f241ae35a(uid);
}


function $057cb186ebe9e911$export$efcd34ab6248d3cd(value, reviver) {
    return JSON.parse(value, (key, value_)=>{
        let value = value_;
        if (value?.__type === "bigint") value = BigInt(value.value);
        if (value?.__type === "Map") value = new Map(value.value);
        return reviver?.(key, value) ?? value;
    });
}


/**
 * Get the reference key for the circular value
 *
 * @param keys the keys to build the reference key from
 * @param cutoff the maximum number of keys to include
 * @returns the reference key
 */ function $dd555b8eb5c820c3$var$getReferenceKey(keys, cutoff) {
    return keys.slice(0, cutoff).join(".") || ".";
}
/**
 * Faster `Array.prototype.indexOf` implementation build for slicing / splicing
 *
 * @param array the array to match the value in
 * @param value the value to match
 * @returns the matching index, or -1
 */ function $dd555b8eb5c820c3$var$getCutoff(array, value) {
    const { length: length } = array;
    for(let index = 0; index < length; ++index){
        if (array[index] === value) return index + 1;
    }
    return 0;
}
/**
 * Create a replacer method that handles circular values
 *
 * @param [replacer] a custom replacer to use for non-circular values
 * @param [circularReplacer] a custom replacer to use for circular methods
 * @returns the value to stringify
 */ function $dd555b8eb5c820c3$var$createReplacer(replacer, circularReplacer) {
    const hasReplacer = typeof replacer === "function";
    const hasCircularReplacer = typeof circularReplacer === "function";
    const cache = [];
    const keys = [];
    return function replace(key, value) {
        if (typeof value === "object") {
            if (cache.length) {
                const thisCutoff = $dd555b8eb5c820c3$var$getCutoff(cache, this);
                if (thisCutoff === 0) cache[cache.length] = this;
                else {
                    cache.splice(thisCutoff);
                    keys.splice(thisCutoff);
                }
                keys[keys.length] = key;
                const valueCutoff = $dd555b8eb5c820c3$var$getCutoff(cache, value);
                if (valueCutoff !== 0) return hasCircularReplacer ? circularReplacer.call(this, key, value, $dd555b8eb5c820c3$var$getReferenceKey(keys, valueCutoff)) : `[ref=${$dd555b8eb5c820c3$var$getReferenceKey(keys, valueCutoff)}]`;
            } else {
                cache[0] = value;
                keys[0] = key;
            }
        }
        return hasReplacer ? replacer.call(this, key, value) : value;
    };
}
function $dd555b8eb5c820c3$export$dfdc1655ccc5b9cb(value, replacer, indent, circularReplacer) {
    return JSON.stringify(value, $dd555b8eb5c820c3$var$createReplacer((key, value_)=>{
        let value = value_;
        if (typeof value === "bigint") value = {
            __type: "bigint",
            value: value_.toString()
        };
        if (value instanceof Map) value = {
            __type: "Map",
            value: Array.from(value_.entries())
        };
        return replacer?.(key, value) ?? value;
    }, circularReplacer), indent ?? undefined);
}


function $2f876d4ef05facb4$export$d184a47a971dd4b9(parameters) {
    const { deserialize: deserialize = (0, $057cb186ebe9e911$export$efcd34ab6248d3cd), key: prefix = "wagmi", serialize: serialize = (0, $dd555b8eb5c820c3$export$dfdc1655ccc5b9cb), storage: storage = $2f876d4ef05facb4$export$e2ef6c4b988c05b } = parameters;
    function unwrap(value) {
        if (value instanceof Promise) return value.then((x)=>x).catch(()=>null);
        return value;
    }
    return {
        ...storage,
        key: prefix,
        async getItem (key, defaultValue) {
            const value = storage.getItem(`${prefix}.${key}`);
            const unwrapped = await unwrap(value);
            if (unwrapped) return deserialize(unwrapped) ?? null;
            return defaultValue ?? null;
        },
        async setItem (key, value) {
            const storageKey = `${prefix}.${key}`;
            if (value === null) await unwrap(storage.removeItem(storageKey));
            else await unwrap(storage.setItem(storageKey, serialize(value)));
        },
        async removeItem (key) {
            await unwrap(storage.removeItem(`${prefix}.${key}`));
        }
    };
}
const $2f876d4ef05facb4$export$e2ef6c4b988c05b = {
    getItem: ()=>null,
    setItem: ()=>{},
    removeItem: ()=>{}
};



const $ddadecc1d84c9068$var$size = 256;
let $ddadecc1d84c9068$var$index = $ddadecc1d84c9068$var$size;
let $ddadecc1d84c9068$var$buffer;
function $ddadecc1d84c9068$export$e2a22331486dcca0(length = 11) {
    if (!$ddadecc1d84c9068$var$buffer || $ddadecc1d84c9068$var$index + length > $ddadecc1d84c9068$var$size * 2) {
        $ddadecc1d84c9068$var$buffer = "";
        $ddadecc1d84c9068$var$index = 0;
        for(let i = 0; i < $ddadecc1d84c9068$var$size; i++)$ddadecc1d84c9068$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $ddadecc1d84c9068$var$buffer.substring($ddadecc1d84c9068$var$index, $ddadecc1d84c9068$var$index++ + length);
}



function $9d68d08b5a6f0504$export$45a69314cf48a3eb(parameters) {
    const { multiInjectedProviderDiscovery: multiInjectedProviderDiscovery = true, storage: storage = (0, $2f876d4ef05facb4$export$d184a47a971dd4b9)({
        storage: typeof window !== "undefined" && window.localStorage ? window.localStorage : (0, $2f876d4ef05facb4$export$e2ef6c4b988c05b)
    }), syncConnectedChain: syncConnectedChain = true, ssr: ssr = false, ...rest } = parameters;
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Set up connectors, clients, etc.
    /////////////////////////////////////////////////////////////////////////////////////////////////
    const mipd = typeof window !== "undefined" && multiInjectedProviderDiscovery ? (0, $bd8d89270fdec732$export$f51a9068ac82ea43)() : undefined;
    const chains = (0, $5dd4bbd5972f5b4c$export$f51a9068ac82ea43)(()=>rest.chains);
    const connectors = (0, $5dd4bbd5972f5b4c$export$f51a9068ac82ea43)(()=>[
            ...rest.connectors ?? [],
            ...!ssr ? mipd?.getProviders().map(providerDetailToConnector) ?? [] : []
        ].map(setup));
    function setup(connectorFn) {
        // Set up emitter with uid and add to connector so they are "linked" together.
        const emitter = (0, $3f600830eff0a3ba$export$6f5e8f34570e3ad1)((0, $ddadecc1d84c9068$export$e2a22331486dcca0)());
        const connector = {
            ...connectorFn({
                emitter: emitter,
                chains: chains.getState(),
                storage: storage,
                transports: rest.transports
            }),
            emitter: emitter,
            uid: emitter.uid
        };
        // Start listening for `connect` events on connector setup
        // This allows connectors to "connect" themselves without user interaction (e.g. MetaMask's "Manually connect to current site")
        emitter.on("connect", connect);
        connector.setup?.();
        return connector;
    }
    function providerDetailToConnector(providerDetail) {
        const { info: info } = providerDetail;
        const provider = providerDetail.provider;
        return (0, $d6278d5335646a0b$export$a7a34dad4983656f)({
            target: {
                ...info,
                id: info.rdns,
                provider: provider
            }
        });
    }
    const clients = new Map();
    function getClient(config = {}) {
        const chainId = config.chainId ?? store.getState().chainId;
        const chain = chains.getState().find((x)=>x.id === chainId);
        // chainId specified and not configured
        if (config.chainId && !chain) throw new (0, $115d9c96b0e3a6b5$export$688e5fda4b4631ed)();
        {
            const client = clients.get(store.getState().chainId);
            if (client && !chain) return client;
            if (!chain) throw new (0, $115d9c96b0e3a6b5$export$688e5fda4b4631ed)();
        }
        // If a memoized client exists for a chain id, use that.
        {
            const client = clients.get(chainId);
            if (client) return client;
        }
        let client;
        if (rest.client) client = rest.client({
            chain: chain
        });
        else {
            const chainId = chain.id;
            const chainIds = chains.getState().map((x)=>x.id);
            // Grab all properties off `rest` and resolve for use in `createClient`
            const properties = {};
            const entries = Object.entries(rest);
            for (const [key, value] of entries){
                if (key === "chains" || key === "client" || key === "connectors" || key === "transports") continue;
                if (typeof value === "object") {
                    // check if value is chainId-specific since some values can be objects
                    // e.g. { batch: { multicall: { batchSize: 1024 } } }
                    if (chainId in value) properties[key] = value[chainId];
                    else {
                        // check if value is chainId-specific, but does not have value for current chainId
                        const hasChainSpecificValue = chainIds.some((x)=>x in value);
                        if (hasChainSpecificValue) continue;
                        properties[key] = value;
                    }
                } else properties[key] = value;
            }
            client = (0, $81f5f2ddf42262a4$export$5d730b7aed1a3eb0)({
                ...properties,
                chain: chain,
                batch: properties.batch ?? {
                    multicall: true
                },
                transport: (parameters)=>rest.transports[chainId]({
                        ...parameters,
                        connectors: connectors
                    })
            });
        }
        clients.set(chainId, client);
        return client;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Create store
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function getInitialState() {
        return {
            chainId: chains.getState()[0].id,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
    }
    let currentVersion;
    const prefix = "0.0.0-canary-";
    if ((0, $b2ca896600a7a3fa$export$83d89fbfd8236492).startsWith(prefix)) currentVersion = Number.parseInt((0, $b2ca896600a7a3fa$export$83d89fbfd8236492).replace(prefix, ""));
    else currentVersion = Number.parseInt((0, $b2ca896600a7a3fa$export$83d89fbfd8236492).split(".")[0] ?? "0");
    const store = (0, $5dd4bbd5972f5b4c$export$f51a9068ac82ea43)((0, $336216731108e79c$export$5c593627aef9f076)(// only use persist middleware if storage exists
    storage ? (0, $336216731108e79c$export$9a6132153fba2e0)(getInitialState, {
        migrate (persistedState, version) {
            if (version === currentVersion) return persistedState;
            const initialState = getInitialState();
            const chainId = validatePersistedChainId(persistedState, initialState.chainId);
            return {
                ...initialState,
                chainId: chainId
            };
        },
        name: "store",
        partialize (state) {
            // Only persist "critical" store properties to preserve storage size.
            return {
                connections: {
                    __type: "Map",
                    value: Array.from(state.connections.entries()).map(([key, connection])=>{
                        const { id: id, name: name, type: type, uid: uid } = connection.connector;
                        const connector = {
                            id: id,
                            name: name,
                            type: type,
                            uid: uid
                        };
                        return [
                            key,
                            {
                                ...connection,
                                connector: connector
                            }
                        ];
                    })
                },
                chainId: state.chainId,
                current: state.current
            };
        },
        merge (persistedState, currentState) {
            // `status` should not be persisted as it messes with reconnection
            if (typeof persistedState === "object" && persistedState && "status" in persistedState) delete persistedState.status;
            // Make sure persisted `chainId` is valid
            const chainId = validatePersistedChainId(persistedState, currentState.chainId);
            return {
                ...currentState,
                ...persistedState,
                chainId: chainId
            };
        },
        skipHydration: ssr,
        storage: storage,
        version: currentVersion
    }) : getInitialState));
    function validatePersistedChainId(persistedState, defaultChainId) {
        return persistedState && typeof persistedState === "object" && "chainId" in persistedState && typeof persistedState.chainId === "number" && chains.getState().some((x)=>x.id === persistedState.chainId) ? persistedState.chainId : defaultChainId;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Subscribe to changes
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Update default chain when connector chain changes
    if (syncConnectedChain) store.subscribe(({ connections: connections, current: current })=>current ? connections.get(current)?.chainId : undefined, (chainId)=>{
        // If chain is not configured, then don't switch over to it.
        const isChainConfigured = chains.getState().some((x)=>x.id === chainId);
        if (!isChainConfigured) return;
        return store.setState((x)=>({
                ...x,
                chainId: chainId ?? x.chainId
            }));
    });
    // EIP-6963 subscribe for new wallet providers
    mipd?.subscribe((providerDetails)=>{
        const currentConnectorIds = new Map();
        for (const connector of connectors.getState())currentConnectorIds.set(connector.id, true);
        const newConnectors = [];
        for (const providerDetail of providerDetails){
            const connector = setup(providerDetailToConnector(providerDetail));
            if (currentConnectorIds.has(connector.id)) continue;
            newConnectors.push(connector);
        }
        if (storage && !store.persist.hasHydrated()) return;
        connectors.setState((x)=>[
                ...x,
                ...newConnectors
            ], true);
    });
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Emitter listeners
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function change(data) {
        store.setState((x)=>{
            const connection = x.connections.get(data.uid);
            if (!connection) return x;
            return {
                ...x,
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts ?? connection.accounts,
                    chainId: data.chainId ?? connection.chainId,
                    connector: connection.connector
                })
            };
        });
    }
    function connect(data) {
        // Disable handling if reconnecting/connecting
        if (store.getState().status === "connecting" || store.getState().status === "reconnecting") return;
        store.setState((x)=>{
            const connector = connectors.getState().find((x)=>x.uid === data.uid);
            if (!connector) return x;
            if (connector.emitter.listenerCount("connect")) connector.emitter.off("connect", change);
            if (!connector.emitter.listenerCount("change")) connector.emitter.on("change", change);
            if (!connector.emitter.listenerCount("disconnect")) connector.emitter.on("disconnect", disconnect);
            return {
                ...x,
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: data.uid,
                status: "connected"
            };
        });
    }
    function disconnect(data) {
        store.setState((x)=>{
            const connection = x.connections.get(data.uid);
            if (connection) {
                const connector = connection.connector;
                if (connector.emitter.listenerCount("change")) connection.connector.emitter.off("change", change);
                if (connector.emitter.listenerCount("disconnect")) connection.connector.emitter.off("disconnect", disconnect);
                if (!connector.emitter.listenerCount("connect")) connection.connector.emitter.on("connect", connect);
            }
            x.connections.delete(data.uid);
            if (x.connections.size === 0) return {
                ...x,
                connections: new Map(),
                current: null,
                status: "disconnected"
            };
            const nextConnection = x.connections.values().next().value;
            return {
                ...x,
                connections: new Map(x.connections),
                current: nextConnection.connector.uid
            };
        });
    }
    return {
        get chains () {
            return chains.getState();
        },
        get connectors () {
            return connectors.getState();
        },
        storage: storage,
        getClient: getClient,
        get state () {
            return store.getState();
        },
        setState (value) {
            let newState;
            if (typeof value === "function") newState = value(store.getState());
            else newState = value;
            // Reset state if it got set to something not matching the base state
            const initialState = getInitialState();
            if (typeof newState !== "object") newState = initialState;
            const isCorrupt = Object.keys(initialState).some((x)=>!(x in newState));
            if (isCorrupt) newState = initialState;
            store.setState(newState, true);
        },
        subscribe (selector, listener, options) {
            return store.subscribe(selector, listener, options ? {
                ...options,
                fireImmediately: options.emitImmediately
            } : undefined);
        },
        _internal: {
            mipd: mipd,
            store: store,
            ssr: Boolean(ssr),
            syncConnectedChain: syncConnectedChain,
            transports: rest.transports,
            chains: {
                setState (value) {
                    const nextChains = typeof value === "function" ? value(chains.getState()) : value;
                    if (nextChains.length === 0) return;
                    return chains.setState(nextChains, true);
                },
                subscribe (listener) {
                    return chains.subscribe(listener);
                }
            },
            connectors: {
                providerDetailToConnector: providerDetailToConnector,
                setup: setup,
                setState (value) {
                    return connectors.setState(typeof value === "function" ? value(connectors.getState()) : value, true);
                },
                subscribe (listener) {
                    return connectors.subscribe(listener);
                }
            },
            events: {
                change: change,
                connect: connect,
                disconnect: disconnect
            }
        }
    };
}




var $9vguw = parcelRequire("9vguw");
var $8syAN = parcelRequire("8syAN");
var $b9XBB = parcelRequire("b9XBB");
$097816f280f0dbb2$export$40dfb463b44d19b.type = "coinbaseWallet";
function $097816f280f0dbb2$export$40dfb463b44d19b(parameters = {}) {
    if (parameters.version === "3" || parameters.headlessMode) return $097816f280f0dbb2$var$version3(parameters);
    return $097816f280f0dbb2$var$version4(parameters);
}

function $097816f280f0dbb2$var$version4(parameters) {
    let sdk;
    let walletProvider;
    let accountsChanged;
    let chainChanged;
    let disconnect;
    return (0, $4674aba9bc5f0149$export$36e7227504c841ea)((config)=>({
            id: "coinbaseWalletSDK",
            name: "Coinbase Wallet",
            supportsSimulation: true,
            type: $097816f280f0dbb2$export$40dfb463b44d19b.type,
            async connect ({ chainId: chainId } = {}) {
                try {
                    const provider = await this.getProvider();
                    const accounts = (await provider.request({
                        method: "eth_requestAccounts"
                    })).map((x)=>(0, $9vguw.getAddress)(x));
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $b9XBB.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user closed modal|accounts received is empty|user denied account|request rejected)/i.test(error.message)) throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                provider.disconnect();
                provider.close?.();
            },
            async getAccounts () {
                const provider = await this.getProvider();
                return (await provider.request({
                    method: "eth_accounts"
                })).map((x)=>(0, $9vguw.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                const chainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(chainId);
            },
            async getProvider () {
                if (!walletProvider) {
                    // Unwrapping import for Vite compatibility.
                    // See: https://github.com/vitejs/vite/issues/9703
                    const CoinbaseWalletSDK = await (async ()=>{
                        const { default: SDK } = await (parcelRequire("5AWy6"));
                        if (typeof SDK !== "function" && typeof SDK.default === "function") return SDK.default;
                        return SDK;
                    })();
                    sdk = new CoinbaseWalletSDK({
                        ...parameters,
                        appChainIds: config.chains.map((x)=>x.id)
                    });
                    walletProvider = sdk.makeWeb3Provider({
                        ...parameters,
                        options: parameters.preference ?? "all"
                    });
                }
                return walletProvider;
            },
            async isAuthorized () {
                try {
                    const accounts = await this.getAccounts();
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const chain = config.chains.find((chain)=>chain.id === chainId);
                if (!chain) throw new (0, $b9XBB.SwitchChainError)(new (0, $115d9c96b0e3a6b5$export$688e5fda4b4631ed)());
                const provider = await this.getProvider();
                try {
                    await provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: (0, $8syAN.numberToHex)(chain.id)
                            }
                        ]
                    });
                    return chain;
                } catch (error) {
                    // Indicates chain is not added to provider
                    if (error.code === 4902) try {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chain.blockExplorers?.default.url ? [
                            chain.blockExplorers?.default.url
                        ] : [];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $8syAN.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        return chain;
                    } catch (error) {
                        throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    }
                    throw new (0, $b9XBB.SwitchChainError)(error);
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $9vguw.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
            }
        }));
}

function $097816f280f0dbb2$var$version3(parameters) {
    const reloadOnDisconnect = false;
    let sdk;
    let walletProvider;
    let accountsChanged;
    let chainChanged;
    let disconnect;
    return (0, $4674aba9bc5f0149$export$36e7227504c841ea)((config)=>({
            id: "coinbaseWalletSDK",
            name: "Coinbase Wallet",
            supportsSimulation: true,
            type: $097816f280f0dbb2$export$40dfb463b44d19b.type,
            async connect ({ chainId: chainId } = {}) {
                try {
                    const provider = await this.getProvider();
                    const accounts = (await provider.request({
                        method: "eth_requestAccounts"
                    })).map((x)=>(0, $9vguw.getAddress)(x));
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $b9XBB.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user closed modal|accounts received is empty|user denied account)/i.test(error.message)) throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                provider.disconnect();
                provider.close();
            },
            async getAccounts () {
                const provider = await this.getProvider();
                return (await provider.request({
                    method: "eth_accounts"
                })).map((x)=>(0, $9vguw.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                const chainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(chainId);
            },
            async getProvider () {
                if (!walletProvider) {
                    // Unwrapping import for Vite compatibility.
                    // See: https://github.com/vitejs/vite/issues/9703
                    const CoinbaseWalletSDK = await (async ()=>{
                        const { default: SDK } = await (parcelRequire("4dD0Q"));
                        if (typeof SDK !== "function" && typeof SDK.default === "function") return SDK.default;
                        return SDK;
                    })();
                    sdk = new CoinbaseWalletSDK({
                        ...parameters,
                        reloadOnDisconnect: reloadOnDisconnect
                    });
                    // Force types to retrieve private `walletExtension` method from the Coinbase Wallet SDK.
                    const walletExtensionChainId = sdk.walletExtension?.getChainId();
                    const chain = config.chains.find((chain)=>parameters.chainId ? chain.id === parameters.chainId : chain.id === walletExtensionChainId) || config.chains[0];
                    const chainId = parameters.chainId || chain?.id;
                    const jsonRpcUrl = parameters.jsonRpcUrl || chain?.rpcUrls.default.http[0];
                    walletProvider = sdk.makeWeb3Provider(jsonRpcUrl, chainId);
                }
                return walletProvider;
            },
            async isAuthorized () {
                try {
                    const accounts = await this.getAccounts();
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const chain = config.chains.find((chain)=>chain.id === chainId);
                if (!chain) throw new (0, $b9XBB.SwitchChainError)(new (0, $115d9c96b0e3a6b5$export$688e5fda4b4631ed)());
                const provider = await this.getProvider();
                try {
                    await provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: (0, $8syAN.numberToHex)(chain.id)
                            }
                        ]
                    });
                    return chain;
                } catch (error) {
                    // Indicates chain is not added to provider
                    if (error.code === 4902) try {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chain.blockExplorers?.default.url ? [
                            chain.blockExplorers?.default.url
                        ] : [];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $8syAN.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        return chain;
                    } catch (error) {
                        throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    }
                    throw new (0, $b9XBB.SwitchChainError)(error);
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $9vguw.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
            }
        }));
}

function $3edc96eb73c6af98$export$c04fcecb1d6d70c7(parameters) {
    const { chain: chain } = parameters;
    const fallbackUrl = chain.rpcUrls.default.http[0];
    if (!parameters.transports) return [
        fallbackUrl
    ];
    const transport = parameters.transports?.[chain.id]?.({
        chain: chain
    });
    const transports = transport?.value?.transports || [
        transport
    ];
    return transports.map(({ value: value })=>value?.url || fallbackUrl);
}



var $9vguw = parcelRequire("9vguw");
var $8syAN = parcelRequire("8syAN");
var $b9XBB = parcelRequire("b9XBB");
$784f2e5735c3e08b$export$340cc50ae9d9f255.type = "walletConnect";

function $784f2e5735c3e08b$export$340cc50ae9d9f255(parameters) {
    const isNewChainsStale = parameters.isNewChainsStale ?? true;
    let provider_;
    let providerPromise;
    const NAMESPACE = "eip155";
    let accountsChanged;
    let chainChanged;
    let connect;
    let displayUri;
    let sessionDelete;
    let disconnect;
    return (0, $4674aba9bc5f0149$export$36e7227504c841ea)((config)=>({
            id: "walletConnect",
            name: "WalletConnect",
            type: $784f2e5735c3e08b$export$340cc50ae9d9f255.type,
            async setup () {
                const provider = await this.getProvider().catch(()=>null);
                if (!provider) return;
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
                if (!sessionDelete) {
                    sessionDelete = this.onSessionDelete.bind(this);
                    provider.on("session_delete", sessionDelete);
                }
            },
            async connect ({ chainId: chainId, ...rest } = {}) {
                try {
                    const provider = await this.getProvider();
                    if (!provider) throw new (0, $b99ad54a290b4e60$export$43839b3ff6336f15)();
                    if (!displayUri) {
                        displayUri = this.onDisplayUri;
                        provider.on("display_uri", displayUri);
                    }
                    let targetChainId = chainId;
                    if (!targetChainId) {
                        const state = await config.storage?.getItem("state") ?? {};
                        const isChainSupported = config.chains.some((x)=>x.id === state.chainId);
                        if (isChainSupported) targetChainId = state.chainId;
                        else targetChainId = config.chains[0]?.id;
                    }
                    if (!targetChainId) throw new Error("No chains found on connector.");
                    const isChainsStale = await this.isChainsStale();
                    // If there is an active session with stale chains, disconnect current session.
                    if (provider.session && isChainsStale) await provider.disconnect();
                    // If there isn't an active session or chains are stale, connect.
                    if (!provider.session || isChainsStale) {
                        const optionalChains = config.chains.filter((chain)=>chain.id !== targetChainId).map((optionalChain)=>optionalChain.id);
                        await provider.connect({
                            optionalChains: [
                                targetChainId,
                                ...optionalChains
                            ],
                            ..."pairingTopic" in rest ? {
                                pairingTopic: rest.pairingTopic
                            } : {}
                        });
                        this.setRequestedChainsIds(config.chains.map((x)=>x.id));
                    }
                    // If session exists and chains are authorized, enable provider for required chain
                    const accounts = (await provider.enable()).map((x)=>(0, $9vguw.getAddress)(x));
                    const currentChainId = await this.getChainId();
                    if (displayUri) {
                        provider.removeListener("display_uri", displayUri);
                        displayUri = undefined;
                    }
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    if (!sessionDelete) {
                        sessionDelete = this.onSessionDelete.bind(this);
                        provider.on("session_delete", sessionDelete);
                    }
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user rejected|connection request reset)/i.test(error?.message)) throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                try {
                    await provider?.disconnect();
                } catch (error) {
                    if (!/No matching key/i.test(error.message)) throw error;
                } finally{
                    if (chainChanged) {
                        provider?.removeListener("chainChanged", chainChanged);
                        chainChanged = undefined;
                    }
                    if (disconnect) {
                        provider?.removeListener("disconnect", disconnect);
                        disconnect = undefined;
                    }
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider?.on("connect", connect);
                    }
                    if (accountsChanged) {
                        provider?.removeListener("accountsChanged", accountsChanged);
                        accountsChanged = undefined;
                    }
                    if (sessionDelete) {
                        provider?.removeListener("session_delete", sessionDelete);
                        sessionDelete = undefined;
                    }
                    this.setRequestedChainsIds([]);
                }
            },
            async getAccounts () {
                const provider = await this.getProvider();
                return provider.accounts.map((x)=>(0, $9vguw.getAddress)(x));
            },
            async getProvider ({ chainId: chainId } = {}) {
                async function initProvider() {
                    const optionalChains = config.chains.map((x)=>x.id);
                    if (!optionalChains.length) return;
                    const { EthereumProvider: EthereumProvider } = await Promise.resolve((parcelRequire("43P4H")));
                    return await EthereumProvider.init({
                        ...parameters,
                        disableProviderPing: true,
                        optionalChains: optionalChains,
                        projectId: parameters.projectId,
                        rpcMap: Object.fromEntries(config.chains.map((chain)=>{
                            const [url] = (0, $3edc96eb73c6af98$export$c04fcecb1d6d70c7)({
                                chain: chain,
                                transports: config.transports
                            });
                            return [
                                chain.id,
                                url
                            ];
                        })),
                        showQrModal: parameters.showQrModal ?? true
                    });
                }
                if (!provider_) {
                    if (!providerPromise) providerPromise = initProvider();
                    provider_ = await providerPromise;
                    provider_?.events.setMaxListeners(Number.POSITIVE_INFINITY);
                }
                if (chainId) await this.switchChain?.({
                    chainId: chainId
                });
                return provider_;
            },
            async getChainId () {
                const provider = await this.getProvider();
                return provider.chainId;
            },
            async isAuthorized () {
                try {
                    const [accounts, provider] = await Promise.all([
                        this.getAccounts(),
                        this.getProvider()
                    ]);
                    // If an account does not exist on the session, then the connector is unauthorized.
                    if (!accounts.length) return false;
                    // If the chains are stale on the session, then the connector is unauthorized.
                    const isChainsStale = await this.isChainsStale();
                    if (isChainsStale && provider.session) {
                        await provider.disconnect().catch(()=>{});
                        return false;
                    }
                    return true;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $b99ad54a290b4e60$export$43839b3ff6336f15)();
                const chain = config.chains.find((x)=>x.id === chainId);
                if (!chain) throw new (0, $b9XBB.SwitchChainError)(new (0, $115d9c96b0e3a6b5$export$688e5fda4b4631ed)());
                try {
                    await Promise.all([
                        new Promise((resolve)=>{
                            const listener = ({ chainId: currentChainId })=>{
                                if (currentChainId === chainId) {
                                    config.emitter.off("change", listener);
                                    resolve();
                                }
                            };
                            config.emitter.on("change", listener);
                        }),
                        provider.request({
                            method: "wallet_switchEthereumChain",
                            params: [
                                {
                                    chainId: (0, $8syAN.numberToHex)(chainId)
                                }
                            ]
                        })
                    ]);
                    const requestedChains = await this.getRequestedChainsIds();
                    this.setRequestedChainsIds([
                        ...requestedChains,
                        chainId
                    ]);
                    return chain;
                } catch (err) {
                    const error = err;
                    if (/(user rejected)/i.test(error.message)) throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    // Indicates chain is not added to provider
                    try {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chain.blockExplorers?.default.url ? [
                            chain.blockExplorers?.default.url
                        ] : [];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            ...chain.rpcUrls.default.http
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $8syAN.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        const requestedChains = await this.getRequestedChainsIds();
                        this.setRequestedChainsIds([
                            ...requestedChains,
                            chainId
                        ]);
                        return chain;
                    } catch (error) {
                        throw new (0, $b9XBB.UserRejectedRequestError)(error);
                    }
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $9vguw.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const chainId = Number(connectInfo.chainId);
                const accounts = await this.getAccounts();
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                this.setRequestedChainsIds([]);
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                if (sessionDelete) {
                    provider.removeListener("session_delete", sessionDelete);
                    sessionDelete = undefined;
                }
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
            },
            onDisplayUri (uri) {
                config.emitter.emit("message", {
                    type: "display_uri",
                    data: uri
                });
            },
            onSessionDelete () {
                this.onDisconnect();
            },
            getNamespaceChainsIds () {
                if (!provider_) return [];
                const chainIds = provider_.session?.namespaces[NAMESPACE]?.accounts?.map((account)=>Number.parseInt(account.split(":")[1] || ""));
                return chainIds ?? [];
            },
            async getRequestedChainsIds () {
                return await config.storage?.getItem(this.requestedChainsStorageKey) ?? [];
            },
            /**
         * Checks if the target chains match the chains that were
         * initially requested by the connector for the WalletConnect session.
         * If there is a mismatch, this means that the chains on the connector
         * are considered stale, and need to be revalidated at a later point (via
         * connection).
         *
         * There may be a scenario where a dapp adds a chain to the
         * connector later on, however, this chain will not have been approved or rejected
         * by the wallet. In this case, the chain is considered stale.
         */ async isChainsStale () {
                if (!isNewChainsStale) return false;
                const connectorChains = config.chains.map((x)=>x.id);
                const namespaceChains = this.getNamespaceChainsIds();
                if (namespaceChains.length && !namespaceChains.some((id)=>connectorChains.includes(id))) return false;
                const requestedChains = await this.getRequestedChainsIds();
                return !connectorChains.every((id)=>requestedChains.includes(id));
            },
            async setRequestedChainsIds (chains) {
                await config.storage?.setItem(this.requestedChainsStorageKey, chains);
            },
            get requestedChainsStorageKey () {
                return `${this.id}.requestedChains`;
            }
        }));
}



parcelRequire("dUH6N");
var $2xFCG = parcelRequire("2xFCG");
parcelRequire("ikDNi");
var $1VCt9 = parcelRequire("1VCt9");
var $1yWTt = parcelRequire("1yWTt");

var $9vguw = parcelRequire("9vguw");
var $b9XBB = parcelRequire("b9XBB");

function $c6a83357ca5bf642$export$f3a67f9bdc78b494(parameters) {
    function parseChainId(chainId) {
        return (0, $1yWTt.NetworkUtil).parseEvmChainId(chainId) || 1;
    }
    return (0, $4674aba9bc5f0149$export$36e7227504c841ea)((config)=>({
            id: (0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID,
            name: "Web3Modal Auth",
            type: "w3mAuth",
            socials: parameters.socials,
            email: parameters.email,
            showWallets: parameters.showWallets,
            walletFeatures: parameters.walletFeatures,
            chain: (0, $1VCt9.ConstantsUtil).CHAIN.EVM,
            async connect (options = {}) {
                const provider = await this.getProvider();
                const { address: address, chainId: chainId } = await provider.connect({
                    chainId: options.chainId
                });
                await provider.getSmartAccountEnabledNetworks();
                const parsedChainId = parseChainId(chainId);
                return {
                    accounts: [
                        address
                    ],
                    account: address,
                    chainId: parsedChainId,
                    chain: {
                        id: parsedChainId,
                        unsuported: false
                    }
                };
            },
            async disconnect () {
                const provider = await this.getProvider();
                await provider.disconnect();
            },
            async getAccounts () {
                const provider = await this.getProvider();
                const { address: address } = await provider.connect();
                config.emitter.emit("change", {
                    accounts: [
                        address
                    ]
                });
                return [
                    address
                ];
            },
            async getProvider () {
                if (!this.provider) this.provider = new (0, $2xFCG.W3mFrameProvider)(parameters.options.projectId);
                return Promise.resolve(this.provider);
            },
            async getChainId () {
                const provider = await this.getProvider();
                const { chainId: chainId } = await provider.getChainId();
                return parseChainId(chainId);
            },
            async isAuthorized () {
                const provider = await this.getProvider();
                const { isConnected: isConnected } = await provider.isConnected();
                return isConnected;
            },
            async switchChain ({ chainId: chainId }) {
                try {
                    const chain = config.chains.find((c)=>c.id === chainId);
                    if (!chain) throw new (0, $b9XBB.SwitchChainError)(new Error("chain not found on connector."));
                    const provider = await this.getProvider();
                    await provider.switchNetwork(chainId);
                    config.emitter.emit("change", {
                        chainId: Number(chainId)
                    });
                    return chain;
                } catch (error) {
                    if (error instanceof Error) throw new (0, $b9XBB.SwitchChainError)(error);
                    throw error;
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((0, $9vguw.getAddress))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const chainId = Number(connectInfo.chainId);
                const accounts = await this.getAccounts();
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                const provider = await this.getProvider();
                await provider.disconnect();
            }
        }));
}



function $29c52379fb31a0f0$export$f84bd70098573c5c({ projectId: projectId, chains: chains, metadata: metadata, enableCoinbase: enableCoinbase, enableInjected: enableInjected, auth: auth = {}, enableWalletConnect: enableWalletConnect, enableEIP6963: enableEIP6963, ...wagmiConfig }) {
    const connectors = wagmiConfig?.connectors ?? [];
    const transportsArr = chains.map((chain)=>[
            chain.id,
            (0, $cea68b5dc8f74603$export$867d8b939ab7f43e)({
                chain: chain,
                projectId: projectId
            })
        ]);
    const transports = Object.fromEntries(transportsArr);
    const defaultAuth = {
        email: true,
        showWallets: true,
        walletFeatures: true,
        socials: [
            "google",
            "x",
            "discord",
            "farcaster",
            "github",
            "apple",
            "facebook"
        ]
    };
    if (enableWalletConnect !== false) connectors.push((0, $784f2e5735c3e08b$export$340cc50ae9d9f255)({
        projectId: projectId,
        metadata: metadata,
        showQrModal: false
    }));
    if (enableInjected !== false) connectors.push((0, $d6278d5335646a0b$export$a7a34dad4983656f)({
        shimDisconnect: true
    }));
    if (enableCoinbase !== false) connectors.push((0, $097816f280f0dbb2$export$40dfb463b44d19b)({
        version: "4",
        appName: metadata?.name ?? "Unknown",
        appLogoUrl: metadata?.icons[0] ?? "Unknown",
        preference: wagmiConfig.coinbasePreference || "all"
    }));
    const mergedAuth = {
        ...defaultAuth,
        ...auth
    };
    if (mergedAuth.email || mergedAuth.socials?.length) connectors.push((0, $c6a83357ca5bf642$export$f3a67f9bdc78b494)({
        chains: [
            ...chains
        ],
        options: {
            projectId: projectId
        },
        socials: mergedAuth.socials,
        email: mergedAuth.email,
        showWallets: mergedAuth.showWallets,
        walletFeatures: mergedAuth.walletFeatures
    }));
    return (0, $9d68d08b5a6f0504$export$45a69314cf48a3eb)({
        chains: chains,
        multiInjectedProviderDiscovery: enableEIP6963 !== false,
        transports: transports,
        ...wagmiConfig,
        connectors: connectors
    });
}






function $33aa9f7ba80515f1$export$14650d4efb17e382(options) {
    const wagmiAdapter = new (0, $38f64816f97caf9e$export$ba6a4843bec5d2a8)({
        wagmiConfig: options.wagmiConfig,
        siweConfig: options.siweConfig,
        defaultChain: options.defaultChain
    });
    return new (0, $edee1d43f6d87414$export$fc94c40ea502fa4c)({
        ...options,
        defaultChain: wagmiAdapter.defaultChain,
        adapters: [
            wagmiAdapter
        ],
        sdkType: "w3m",
        sdkVersion: `html-wagmi-${(0, $7acb69a91c2b4ceb$export$aafe1f751f1bc52a).VERSION}`
    });
}




const $c523d3e6cdc2b362$export$b7b19aa0ee06c73 = /*#__PURE__*/ (0, $57ffd000782ab8bb$export$b6380ff64616a4fb)({
    id: 137,
    name: "Polygon",
    nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://polygon-rpc.com"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "PolygonScan",
            url: "https://polygonscan.com",
            apiUrl: "https://api.polygonscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    }
});



var $ceSUN = parcelRequire("ceSUN");

function $49eddce0aba3e555$export$642c4e67bbdc0bc7(ether, unit = "wei") {
    return (0, $e484fe21942c6e42$export$203ae30b4f6490b3)(ether, (0, $ceSUN.etherUnits)[unit]);
}


const $7fe1f7edde6e3026$var$chains = [
    (0, $943f0ea18d6af5d7$export$536d3e0d2c7baf54),
    (0, $c523d3e6cdc2b362$export$b7b19aa0ee06c73)
];
const $7fe1f7edde6e3026$var$projectId = "8cb9d988c38d5dafd5fbe1f639fd6ff7";
const $7fe1f7edde6e3026$var$path = window.location.href.split("?")[0];
const $7fe1f7edde6e3026$var$metadata = {
    name: "Yunipal Islands",
    description: "Login to Yunipal Islands",
    url: $7fe1f7edde6e3026$var$path,
    icons: [
        $7fe1f7edde6e3026$var$path + "logo.png"
    ]
};
const $7fe1f7edde6e3026$export$e506a1d27d1eaa20 = (0, $29c52379fb31a0f0$export$f84bd70098573c5c)({
    chains: $7fe1f7edde6e3026$var$chains,
    projectId: $7fe1f7edde6e3026$var$projectId,
    metadata: $7fe1f7edde6e3026$var$metadata
});
//reconnect(config)
// 3. Create modal
const $7fe1f7edde6e3026$var$web3modal = (0, $33aa9f7ba80515f1$export$14650d4efb17e382)({
    wagmiConfig: $7fe1f7edde6e3026$export$e506a1d27d1eaa20,
    projectId: $7fe1f7edde6e3026$var$projectId,
    themeMode: "dark"
});
document.addEventListener("DOMContentLoaded", $7fe1f7edde6e3026$var$loadApp());
async function $7fe1f7edde6e3026$var$loadApp() {
    await (0, $2bf13ff4fdf3cd7b$export$f0e7018a430fa792)($7fe1f7edde6e3026$export$e506a1d27d1eaa20);
    const account = await (0, $9bf87c5242498f44$export$4f9234baf34abd0)($7fe1f7edde6e3026$export$e506a1d27d1eaa20);
    //web3modal.subscribeModal(() => processAction())
    $7fe1f7edde6e3026$var$web3modal.subscribeEvents((modalEvent)=>$7fe1f7edde6e3026$var$handleEvents(modalEvent.data.event));
    //This is not working to catch account already connected
    if (account.isConnected) $7fe1f7edde6e3026$var$processAction();
    else await $7fe1f7edde6e3026$var$web3modal.open();
}
async function $7fe1f7edde6e3026$var$handleEvents(modalEvent) {
    const CONNECTED = "CONNECT_SUCCESS";
    const DISCONNECTED = "DISCONNECT_SUCCESS";
    console.log("HandleEvent: " + modalEvent);
    if (modalEvent == CONNECTED) $7fe1f7edde6e3026$var$processAction();
    else if (modalEvent == DISCONNECTED) {
        const responseText = document.getElementById("response-text");
        responseText.innerHTML = "";
        responseText.className = "";
        const responseButton = document.getElementById("response-button");
        responseButton.className = "";
        responseButton.innerHTML = "Copy";
    }
}
async function $7fe1f7edde6e3026$var$processAction() {
    const account = (0, $9bf87c5242498f44$export$4f9234baf34abd0)($7fe1f7edde6e3026$export$e506a1d27d1eaa20);
    //Don't process if no account is connected
    if (!account.isConnected || account.isConnecting) return;
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get("action");
    const message = urlParams.get("message");
    const chainId = urlParams.get("chainId") || 1;
    const to = urlParams.get("to");
    const value = urlParams.get("value");
    const data = urlParams.get("data") || "";
    const gasLimit = urlParams.get("gasLimit") || undefined;
    const gasPrice = urlParams.get("gasPrice") || undefined;
    if (action === "sign" && message) return $7fe1f7edde6e3026$var$signWagmiMessage(message);
    if (action === "send" && to && value) return $7fe1f7edde6e3026$var$sendWagmiTransaction(chainId, to, value, gasLimit, gasPrice, data);
    if (action === "auth" && message) {
        let account = (0, $9bf87c5242498f44$export$4f9234baf34abd0)($7fe1f7edde6e3026$export$e506a1d27d1eaa20);
        //get the signing message using the message
        let response = await fetch(message + "/functions/requestMessage?address=" + account.address + "&chain=001", {
            method: "POST"
        });
        let jsonData = await response.json();
        console.log(jsonData.result.message);
        return $7fe1f7edde6e3026$var$authSignMessage(jsonData.result.message);
    }
    $7fe1f7edde6e3026$var$displayResponse("Invalid URL");
}
async function $7fe1f7edde6e3026$var$sendWagmiTransaction(chainId, to, value, gasLimit, gasPrice, data) {
    try {
        await new Promise((resolve)=>setTimeout(resolve, 1000));
        const account = (0, $9bf87c5242498f44$export$4f9234baf34abd0)($7fe1f7edde6e3026$export$e506a1d27d1eaa20);
        if (account.chainId !== chainId) await (0, $84fcda712a4e8b11$export$15599da40e72d2f)($7fe1f7edde6e3026$export$e506a1d27d1eaa20, {
            chainId: `0x${parseInt(chainId, 10).toString(16)}`
        });
        const from = (0, $9bf87c5242498f44$export$4f9234baf34abd0)($7fe1f7edde6e3026$export$e506a1d27d1eaa20);
        const tx = await (0, $84e4d6648ba6b0db$export$8e0e7ffc78696d30)($7fe1f7edde6e3026$export$e506a1d27d1eaa20, {
            account: from,
            to: to,
            value: (0, $49eddce0aba3e555$export$642c4e67bbdc0bc7)(value)
        });
        console.log({
            tx: tx
        });
        $7fe1f7edde6e3026$var$displayResponse("Transaction sent.<br><br>Copy to clipboard then continue to App", tx.hash);
    } catch (error) {
        $7fe1f7edde6e3026$var$copyToClipboard("error");
        $7fe1f7edde6e3026$var$displayResponse("Transaction Denied");
    }
}
async function $7fe1f7edde6e3026$var$authSignMessage(message) {
    try {
        await new Promise((resolve)=>setTimeout(resolve, 3000));
        const signature = await (0, $2a16e70d89d1c4fa$export$1d9a7a8a40780de)($7fe1f7edde6e3026$export$e506a1d27d1eaa20, {
            message: message
        });
        console.log({
            signature: signature
        });
        const response = {
            signature: signature,
            message: message
        };
        $7fe1f7edde6e3026$var$displayResponse("Signature complete.<br><br>Copy to clipboard then continue to App", JSON.stringify(response));
    } catch (error) {
        $7fe1f7edde6e3026$var$copyToClipboard("error");
        $7fe1f7edde6e3026$var$displayResponse("Signature Denied");
    }
}
async function $7fe1f7edde6e3026$var$signWagmiMessage(message) {
    try {
        await new Promise((resolve)=>setTimeout(resolve, 3000));
        const signature = await (0, $2a16e70d89d1c4fa$export$1d9a7a8a40780de)($7fe1f7edde6e3026$export$e506a1d27d1eaa20, {
            message: message
        });
        console.log({
            signature: signature
        });
        $7fe1f7edde6e3026$var$displayResponse("Signature complete.<br><br>Copy to clipboard then continue to App", signature);
    } catch (error) {
        $7fe1f7edde6e3026$var$copyToClipboard("error");
        $7fe1f7edde6e3026$var$displayResponse("Signature Denied");
    }
}
async function $7fe1f7edde6e3026$var$copyToClipboard(response) {
    try {
        // focus from metamask back to browser
        window.focus(); // wait to finish focus
        await new Promise((resolve)=>setTimeout(resolve, 500)); // copy tx hash to clipboard
        await navigator.clipboard.writeText(response);
        document.getElementById("response-button").innerHTML = "Copied";
    } catch  {
        // for metamask mobile android
        const input = document.createElement("input");
        input.type = "text";
        input.value = response;
        document.body.appendChild(input);
        input.select();
        document.execCommand("Copy");
        input.style = "visibility: hidden";
        document.getElementById("response-button").innerHTML = "Copied";
    }
}
function $7fe1f7edde6e3026$var$displayResponse(text, response) {
    // display error or response
    const responseText = document.getElementById("response-text");
    responseText.innerHTML = text;
    responseText.className = "active";
    if (response) {
        // display button to copy tx.hash or signature
        const responseButton = document.getElementById("response-button");
        responseButton.className = "active";
        responseButton.onclick = ()=>$7fe1f7edde6e3026$var$copyToClipboard(response);
    }
}

})();
//# sourceMappingURL=index.fbe3f492.js.map
